(function () {
	'use strict';

	angular.module('sitegen.site', ['thatisuday.ng-image-gallery', 'infinite-scroll'])
		.provider('$currentSite', function () {
			this.$get = function ($injector, STORAGE_PREFIX) {

				var rScope = $injector.get('$rootScope');
				var $translate = $injector.get('$translate');

				var provider = {};
				var site = {};
				var menu = {};
				var page = {};

				provider.getSite = function () {
					return site;
				};

				provider.setSite = function (_site) {

					site = _site;

					/*if (localStorage.getItem(STORAGE_PREFIX + 'site_lang') == null){
						localStorage.setItem(STORAGE_PREFIX + 'site_lang', angular.toJson(site.defaultLanguage));
					}*/

					localStorage.setItem(STORAGE_PREFIX + 'site_lang', angular.toJson(site.languageFound));
					$translate.use(site.languageFound.key);
					$translate.preferredLanguage(site.languageFound.key);

					if (site.page) {
						page = site.page;
					} else {
						page = {};
					}

					if (site.menu) {
						menu = site.menu;
					} else {
						menu = {};
					}

					if (rScope != null) {
						rScope.$broadcast('siteUpdated');
						rScope.$broadcast('pageReady');
					}

				};

				provider.setMenu = function (_menu) {
					menu = _menu;
					site.menu = menu;
				};

				provider.getMenu = function () {
					return menu;
				};

				provider.setPage = function (_page) {
					page = _page;
					site.page = page;
				};

				provider.getPage = function () {
					return page;
				};

				return provider;
			};
		})
		.config(config).run(function ($rootScope, $location) {
			$rootScope.$on('$locationChangeSuccess', function () {
				$rootScope.actualLocation = $location.path();
			});

			$rootScope.$watch(function () {
				return $location.path();
			}, function (newLocation, oldLocation) {
				if ($rootScope.actualLocation === newLocation) {
					$rootScope._useProviderFilter = true;
				}
			});
		});


	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

		var siteGenNavigation = {
			main: 'app/main/sitegen/navigation/horizontal-navigation.html',
			toolbar: 'app/main/sitegen/toolbar/layouts/horizontal-navigation/toolbar.html',
			navigation: 'app/main/sitegen/navigation/layouts/horizontal-navigation/navigation.html'
		};

		// State
		$stateProvider
			.state('sitegen.site', {
				url: '/:site',
				views: {
					'content@sitegen': {
						templateUrl: 'app/main/sitegen/site/site.html',
						controller: 'SiteGenController as vm'
					}
				},
				resolve: {
					site: function ($filter, $stateParams, toastr, SiteGenService, $currentSite, SitesManagementService, $rootScope, $translate, STORAGE_PREFIX) {
						//var lang = $translate.preferredLanguage();
						var lang;
						var langKey = null;

						if (localStorage.getItem(STORAGE_PREFIX + 'site_lang') && localStorage.getItem(STORAGE_PREFIX + 'site_lang') !== 'undefined') {
							lang = angular.fromJson(localStorage.getItem(STORAGE_PREFIX + 'site_lang'));
							if (lang != null) {
								langKey = lang.key;
							}
						}

						SiteGenService.find($stateParams.site, null, langKey).then(function (resp) {
							$currentSite.setSite(resp);
						}).catch(function (error) {
							toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
						});
					}
				}
			})
			.state('sitegen.page', {
				url: '/:site/:page?param1',
				views: {
					'content@sitegen': {
						templateUrl: 'app/main/sitegen/site/site.html',
						controller: 'SiteGenController as vm'
					}
				},
				resolve: {
					page: ['$filter', '$state', '$stateParams', '$timeout', 'toastr', 'SiteGenService', '$currentSite', '$rootScope', 'STORAGE_PREFIX',
						function ($filter, $state, $stateParams, $timeout, toastr, SiteGenService, $currentSite, $rootScope, STORAGE_PREFIX) {
							// Mise en forme le paramètre page
							/*$state.transitionTo('sitegen.page', { site: $stateParams.site, page: $stateParams.page.trim().replace(/\s/g, "-") }, {
								location: true,
								inherit: true,
								relative: $state.$current,
								notify: false
							});*/
							//var lang = $translate.preferredLanguage();
							var lang = angular.fromJson(localStorage.getItem(STORAGE_PREFIX + 'site_lang'));
							var langKey = null;
							if (lang != null) {
								langKey = lang.key;
							}
							SiteGenService.find($stateParams.site, $stateParams.page, langKey).then(function (resp) {
								$currentSite.setSite(resp);
							}).catch(function (error) {
								toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
							});

						}]
				},
			})
			.state('sitegen.site.my_selection_of_providers', {
				url: '/my-selection',
				views: {
					'content@sitegen': {
						templateUrl: 'app/main/sitegen/my_selection_of_providers/my_selection_of_providers.html',
						controller: 'MySelectionOfProvidersController as vm'
					}
				}
			})
			.state('sitegen.site.login', {
				url: '/login?fromAction?fromActivation',
				views: {
					'content@sitegen': {
						templateUrl: 'app/main/sitegen/account/login.html',
						controller: 'SiteGenLoginController as vm'
					}
				}
			})
			.state('sitegen.site.workbook', {
				url: '/requestforproposal',
				views: {
					'content@sitegen': {
						templateUrl: 'app/main/sitegen/workbook/workbook.html',
						controller: 'WorkbookController as vm'
					}
				}
			})
			.state('sitegen.site.account_activation', {
				url: '/account_activation',
				views: {
					'content@sitegen': {
						templateUrl: 'app/main/sitegen/account/account_activation.html',
						controller: 'SiteGenAccountActivationController as vm'
					}
				}
			})
			.state('sitegen.site.my_profile', {
				url: '/my_profile',
				views: {
					'content@sitegen': {
						templateUrl: 'app/main/sitegen/account/my_profile.html',
						controller: 'SiteGenMyProfileController as vm'
					}
				}
			})
			.state('sitegen.site.account_home', {
				url: '/account_home?rfp',
				views: {
					'content@sitegen': {
						templateUrl: 'app/main/sitegen/account/account_home/account_home.html',
						controller: 'AccountHomeController as vm'
					}
				}
			})
			.state('sitegen.site.update_password', {
				url: '/update_password',
				views: {
					'content@sitegen': {
						templateUrl: 'app/main/sitegen/account/update_password.html',
						controller: 'SiteGenUpdateMyPasswordController as vm'
					}
				}
			})
			.state('sitegen.site.forgot_login', {
				url: '/forgot_login?fromAction',
				views: {
					'content@sitegen': {
						templateUrl: 'app/main/sitegen/account/forgot_login.html',
						controller: 'SiteGenForgotLoginController as vm'
					}
				}
			})
			.state('sitegen.site.forgot_password', {
				url: '/forgot_password?fromAction',
				views: {
					'content@sitegen': {
						templateUrl: 'app/main/sitegen/account/forgot_password.html',
						controller: 'SiteGenForgotPasswordController as vm'
					}
				}
			})
			.state('sitegen.site.request_for_proposal', {
				url: '/request_for_proposal',
				views: {
					'content@sitegen': {
						templateUrl: 'app/main/sitegen/request_for_proposal/request_for_proposal.html',
						controller: 'SiteGenRequestForProposalController as vm'
					}
				}
			})
			.state('sitegen.site.request_for_proposal.send', {
				url: '/send?id',
				views: {
					'content@sitegen': {
						templateUrl: 'app/main/sitegen/request_for_proposal/send_request_for_proposal.html',
						controller: 'SiteGenSendRequestForProposalController as vm'
					}
				}
			})
			.state('sitegen.site.request_for_proposal.details', {
				url: '/details?id',
				views: {
					'content@sitegen': {
						templateUrl: 'app/main/sitegen/request_for_proposal/details_request_for_proposal.html',
						controller: 'SiteGenDetailsRequestForProposalController as vm'
					}
				}
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/sitegen');

	}
})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('AddToFolderController', AddToFolderController);

	function AddToFolderController($scope, $mdDialog, $filter, toastr, entity, type, folderService) {

		$scope.folders = [];
		$scope.mode = null;
		$scope.existantFolder = {};
		$scope.folder = {};
		$scope.type = type;

		var PROVIDER_SESSION_STORAGE_KEY_PREFIX = "PROVIDER_";
		var ARTICLE_SESSION_STORAGE_KEY_PREFIX = "ARTICLE_";

		$scope.hidePopup = function () {
			$mdDialog.cancel();
		};

		folderService.findAllExcludeEntityById(entity.id, type).then((res) => {
			$scope.folders = res.data.folders;
			if ($scope.folders.length == 0) {
				if (res.data.lengthWhitoutExclude > 0) {
					$scope.alreadyOnFolder = true;
				}
			}
		}).catch(() => {

		});

		$scope.removeFromLocalStorage = function (entityId, type) {
			if (type === 'article') {
				localStorage.removeItem(ARTICLE_SESSION_STORAGE_KEY_PREFIX + entityId);
			} else if (type === 'company') {
				localStorage.removeItem(PROVIDER_SESSION_STORAGE_KEY_PREFIX + entityId);
				$scope.$broadcast('checkSelection');
			}
		};

		$scope.save = function () {
			if ($scope.mode === 'ADD_TO_EXISTANT_FOLDER') {
				folderService.addToFolder($scope.existantFolder.folder.id, entity.id, type).then(() => {
					toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE'));
					$mdDialog.hide();
				}).catch(() => {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			} else if ($scope.mode === 'CREATE_FOLDER') {
				folderService.createFolderAndAddEntity($scope.folder, entity.id, type).then(() => {
					toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_SAVE'));
					$mdDialog.hide();
				}).catch(() => {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}
		};
	}
})();

(function () {
    'use strict';

    angular.module('sitegen.site').controller('detailsFolderController', detailsFolderController);

    function detailsFolderController($scope, $mdDialog, $filter, $translate, $timeout, id, toastr, folderService, SiteGenService) {

        $scope.folder = {};
        $scope.rfpLoaded = false;
        $scope.ccLoaded = false;
        folderService.findById(id, $translate.use()).then((res) => {
            SiteGenService.getPersonnalCC($translate.preferredLanguage()).then(function (res) {
                $scope.ccs = res.data;
                $timeout(() => {
                    $scope.ccLoaded = true;
                });
            }).catch(function (err) {
                toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });

            SiteGenService.getPersonnalRfp($translate.preferredLanguage()).then(function (res) {
                $scope.rfps = res.data;
                $timeout(() => {
                    $scope.rfpLoaded = true;
                });
            }).catch(function (err) {
                toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
            $scope.folder = res.data;
            $timeout(() => {
                $scope.$watch('folder.rfp', () => {
                    if (!!$scope.folder && $scope.folder.rfp != null && $scope.rfpLoaded) {
                        $scope.addEntityToFolder($scope.folder.rfp.id, 'rfp');
                    }
                });
                $scope.$watch('folder.cc', () => {
                    if (!!$scope.folder && $scope.folder.cc != null && $scope.ccLoaded) {
                        $scope.addEntityToFolder($scope.folder.cc.id, 'cc');
                    }
                });
            })
        }).catch(() => {
            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });



        $scope.hidePopup = function () {
            $mdDialog.hide();
        };

        $scope.addEntityToFolder = function (entityId, type) {
            folderService.addToFolder($scope.folder.id, entityId, type).then(() => {
                toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE'));
            }).catch(() => {
                toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
        };

        $scope.delete = function (entityId, type) {
            folderService.removeFromFolder($scope.folder.id, entityId, type).then(() => {
                if (type === 'article') {
                    for (let i = $scope.folder.articles.length - 1; i >= 0; i--) {
                        if ($scope.folder.articles[i].id === entityId) {
                            $scope.folder.articles.splice(i, 1);
                        }
                    }
                } else if (type === 'company') {
                    for (let i = $scope.folder.companies.length - 1; i >= 0; i--) {
                        if ($scope.folder.companies[i].id === entityId) {
                            $scope.folder.companies.splice(i, 1);
                        }
                    }
                } else if (type === 'rfp') {
                    $scope.folder.rfp = null;
                } else if (type === 'cc') {
                    $scope.folder.cc = null;
                }
                toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_DELETE'));
            }).catch(() => {
                toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.front', ['ui.utils.masks','ui.calendar', 'slickCarousel'])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
    
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/home');
        
      // moment.defineLocale('fr', {
      //   months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
      //   monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
      //   monthsParseExact : true,
      //   weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
      //   weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
      //   weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
      //   weekdaysParseExact : true,
      //   longDateFormat : {
      //     LT : 'HH:mm',
      //     LTS : 'HH:mm:ss',
      //     L : 'DD/MM/YYYY',
      //     LL : 'D MMMM YYYY',
      //     LLL : 'D MMMM YYYY HH:mm',
      //     LLLL : 'dddd D MMMM YYYY HH:mm'
      //   },
      //   calendar : {
      //     sameDay: '[Aujourd\'hui à] LT',
      //     nextDay: '[Demain à] LT',
      //     nextWeek: 'dddd [à] LT',
      //     lastDay: '[Hier à] LT',
      //     lastWeek: 'dddd [dernier à] LT',
      //     sameElse: 'L'
      //   },
      //   relativeTime : {
      //     future : 'dans %s',
      //     past : 'il y a %s',
      //     s : 'quelques secondes',
      //     m : 'une minute',
      //     mm : '%d minutes',
      //     h : 'une heure',
      //     hh : '%d heures',
      //     d : 'un jour',
      //     dd : '%d jours',
      //     M : 'un mois',
      //     MM : '%d mois',
      //     y : 'un an',
      //     yy : '%d ans'
      //   },
      //   ordinalParse: /\d{1,2}(er|)/,
      //   ordinal : function (number) {
      //     return number + (number === 1 ? 'er' : '');
      //   },
      //   week : {
      //     dow : 1, // Monday is the first day of the week.
      //     doy : 4  // The week that contains Jan 4th is the first week of the year.
      //   }
      // });

    }
})();

(function () {
  'use strict';

  angular.module('app.front').controller('addContactCtrl', addContactCtrl);

  function addContactCtrl($scope, $translate, $mdDialog, companyId, contactService) {

    $scope.newContact = {};
    $scope.addContactMode = true;

    contactService.getCategories($translate.preferredLanguage()).then(function (data) {
      $scope.categories = data;
    }).catch(function (response) {

    });

    $scope.saveContact = function () {
      contactService.addModel($scope.categories, $scope.newContact, companyId).then(function (response) {
        $mdDialog.hide();
      }).catch(function () {

      });
    };

    $scope.hidePopup = function () {
      $mdDialog.cancel();
    };
  }
})();

(function(){
	'use strict';

	angular.module('app.front').controller('addInscriptionFormController', addInscriptionFormController);

	function addInscriptionFormController($scope, $mdDialog, $translate, $filter, eventId, form, toastr, modelService, inscriptionFormService, inscriptionSubCategoryService){
		var modelType = 'COMPANY_MODEL';
		var baseUrl = './api/rest/model/' + modelType;
		if (form != null){
			$scope.newForm = angular.copy(form);
		}else{
			$scope.newForm = {
				eventId: eventId
			};
		}

		inscriptionSubCategoryService.list($translate.preferredLanguage()).then(function(response){
			$scope.subcategories = response.data;
		}).catch(function(){

		});

		modelService.getSubTypes(baseUrl, $translate.preferredLanguage(), true).then(function (response) {
			$scope.subtypes = response.data;
		}).catch(function(response){

		});

		$scope.save = function(){
			inscriptionFormService.save($scope.newForm).then(function(response){
				$mdDialog.hide(response);
			}).catch(function(){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};
	}
})();
(function () {
  'use strict';

  angular.module('app.front').controller('PageController', PageController);

  function PageController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, $stateParams, SitesManagementService) {
   
    $scope.sites = [];
    $scope.blocs = [];
    $scope.languages = [];

    $scope.page = {
      pageBlocs: []
    };


    // UTILS

    $scope._pagesListFn = function () {
      $state.go('app.pages');
    };

    $scope._getCleanKey = function (key) {
      var _cleanKey = angular.copy(key);
      return _cleanKey.replace(/[{()}]/g, '');
    };

    $scope._siteLanguagesBuilderFn = function (itemSite) {
      if (itemSite) {
        for (var i = 0; i < itemSite.languages.length; i++) {
          var lang = itemSite.languages[i];
          delete lang.activated;
          delete lang.preferred;

          var alreadyHere = false;

          for (var j = 0; j < $scope.languages.length; j++) {
            if ($scope.languages[j].key === lang.key) {
              alreadyHere = true;
            }
          }

          if (!alreadyHere) {
            lang.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + lang.key);
            $scope.languages.push(lang);
          }
        }
      }

    };


    // BLOCKS

    SitesManagementService.findAll('blocs').then(function (response) {
      $scope.blocs = response.data;
    }).catch(function (error) {
      toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
    });


    // ENTRY POINT       

    $scope.initPage = function () {
      if ($stateParams.id) { // Get page if MAJ

        SitesManagementService.find('page', $stateParams.id).then(function (response) {
          $scope.page = response.data;
          if ($scope.page && $scope.page.targetLanguage) {
            $scope.page.targetLanguage.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + angular.copy($scope.page.targetLanguage.key));
          }
          angular.forEach($scope.page.sites, function (site) {
            $scope._siteLanguagesBuilderFn(site)
          });

          angular.forEach($scope.page.pageBlocs, function (item, index) {
            $scope.$watch("page.pageBlocs[" + index + "].bloc", function(newValue, oldValue, scope){
              if(newValue && newValue.id && oldValue && oldValue.id && newValue.id != oldValue.id) {
                $scope.page.pageBlocs[index].html = angular.copy($scope.page.pageBlocs[index].bloc.html);
                $scope.page.pageBlocs[index].pageBlocTranslations = [];
                angular.forEach($scope.page.pageBlocs[index].bloc.keys, function (_item, _index) {
                  $scope.page.pageBlocs[index].pageBlocTranslations.push({
                    key: _item,
                    value: null
                  });
                });
              }
            });
          });

        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });

        SitesManagementService.findAll('sites').then(function (response) {
          $scope.sites = response.data;
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });

      } else {

        SitesManagementService.findAll('sites').then(function (response) {
          $scope.sites = response.data;
          angular.forEach($scope.sites, function (itemSite, indexSite) {
            $scope._siteLanguagesBuilderFn(itemSite);
          });
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });

      }
    };

    $scope.initPage();


    // PAGE

    // Change site
    $scope._changeSiteFn = function () {
      $scope.languages = [];
      angular.forEach($scope.page.sites, function (site) {
        $scope._siteLanguagesBuilderFn(site)
      });
    };

    // Change language
    $scope._changeLanguageFn = function () {
      if ($scope.page.id && $scope.page.targetLanguage) {
        SitesManagementService.findPage($scope.page.id, $scope.page.targetLanguage.key).then(function (response) {
          var page = response.data;
          if (page && page.targetLanguage) {
            page.targetLanguage.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + angular.copy($scope.page.targetLanguage.key));
          }
          $scope._siteLanguagesBuilderFn(page.site);
          $scope.page.targetLanguage = angular.copy(page.targetLanguage);
          if (page.pageBlocs != null) {
            $scope.page.pageBlocs = angular.copy(page.pageBlocs);
          }
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }
    };

    // Add new block
    $scope._addPageBlocFn = function () {

      if ($scope.blocs && $scope.blocs.length > 0) {

        var newPageBlock = {
          index: $scope.page.pageBlocs.length + 1,
          bloc: angular.copy($scope.blocs[0]),
          pageBlocTranslations: [],
          html: angular.copy($scope.blocs[0].html)
        };

        angular.forEach(newPageBlock.bloc.keys, function (item, index) {
          newPageBlock.pageBlocTranslations.push({
            key: item,
            value: null
          });
        });

        var _pageBlocsLength =  $scope.page.pageBlocs.push(newPageBlock);
        $scope.$watch("page.pageBlocs[" + (_pageBlocsLength - 1) + "].bloc", function(newValue, oldValue, scope){
          if(newValue && newValue.id && oldValue && oldValue.id && newValue.id != oldValue.id) {
            $scope.page.pageBlocs[_pageBlocsLength - 1].html = angular.copy($scope.page.pageBlocs[_pageBlocsLength - 1].bloc.html);
            $scope.page.pageBlocs[_pageBlocsLength - 1].pageBlocTranslations = [];
            angular.forEach($scope.page.pageBlocs[_pageBlocsLength - 1].bloc.keys, function (_item, _index) {
              $scope.page.pageBlocs[_pageBlocsLength - 1].pageBlocTranslations.push({
                key: _item,
                value: null
              });
            });
          }
        });

      }

    };

    // Remove a block
    $scope._removePageBlocFn = function (id) {
      for (var i = 0; i < $scope.page.pageBlocs.length; i++) {
        if ($scope.page.pageBlocs[i].id === id) {
          $scope.page.pageBlocs.splice(i, 1);
          break;
        }

      }
    };

    // Change block
    $scope._changePageBlocFn = function (pageBloc) {
      console.log("change");
      // TODO - Correct block chang : Get page blocks from server by page, block and language
      pageBloc.html = angular.copy(pageBloc.bloc.html);
      pageBloc.pageBlocTranslations = [];
      console.log(pageBloc);
      angular.forEach(pageBloc.bloc.keys, function (item, index) {
        pageBloc.pageBlocTranslations.push({
          key: item,
          value: null
        });
      });
    };

    // Save page
    $scope._save = function (pageForm) {
      pageForm.$setSubmitted();
      if (pageForm.$valid) {
        SitesManagementService.save('page', $scope.page).then(function (response) {
          pageForm.$setPristine();
          //$scope._pagesListFn();
          if ($stateParams.id) {
            $scope.initPage();
          } else {
            $state.go("app.pages.page", {
              id: response.data.id
            });
          }
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      } else {
        toastr.error("Vous devez renseigner tous les champs requis avant de valider.");
      }
    };

    // Delete page
    $scope._delete = function () {
      SitesManagementService.delete('page', $scope.page.id).then(function (response) {
        $scope._pagesListFn();
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.showHtml = function (bloc) {
      bloc.showHtml = !bloc.showHtml;
    };

    $scope.moveBloc = function (bloc, up) {
      if (bloc.index != null && $scope.page.id != null) {
        SitesManagementService.moveBloc($scope.page.id, bloc.index, up).then(function (res) {
          $scope.page = res.data;
        }).catch(function (err) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
          console.log(err);
        });
      } else {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      }
    };

  }

})();

(function () {
    'use strict';

    angular.module('app.front').controller('BlocController', BlocController);

    function BlocController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, $stateParams, $templateRequest, $sce, SitesManagementService) {

        $scope.bloc = {};

        $scope.types = SitesManagementService.getBlocTypes();

        if($stateParams.id) {

            SitesManagementService.find('bloc', $stateParams.id).then(function(response){
                $scope.bloc = response.data;
			}).catch(function(error){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });

        }

        $scope._blocsListFn = function() {
            $state.go('app.blocs');
        };

        $scope.getBloc = function(){
            if ($scope.bloc && $scope.bloc.type) {

              // Carousel type process
              var templateUrl = null;
              if ($scope.bloc.type === 'CAROUSEL') {
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/carousel.template.type.html');
              } if ($scope.bloc.type === 'CAROUSEL_PURE') {
					templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/carousel_pure.template.type.html');
				 } else if ($scope.bloc.type === 'BLOG') {
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/blog.template.type.html');
              } else if ($scope.bloc.type === 'BLOG_PURE') {
					templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/blog_pure.template.type.html');
				 }else if ($scope.bloc.type === 'ARTICLE'){
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/article.template.type.html');
              } else if ($scope.bloc.type === 'ARTICLE_PURE'){
					templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/article_pure.template.type.html');
				 }else if ($scope.bloc.type === 'SEARCH_COMPANY'){
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/search_companies.template.type.html');
              } else if ($scope.bloc.type === 'COMPANY'){
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/company.template.type.html');
              } else if ($scope.bloc.type === 'SEARCH_PACKAGE'){
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/search_packages.template.type.html');
              } else if ($scope.bloc.type === 'PACKAGE'){
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/package.template.type.html');
              } else if ($scope.bloc.type === 'SEARCH_TOURIST_ATTRACTIONS'){
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/search_tourist_attractions.template.type.html');
              } else if ($scope.bloc.type === 'TOURIST_ATTRACTION') {
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/tourist_attraction.template.type.html');
              } else if ($scope.bloc.type === 'FESTIVALS'){
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/festivals.template.type.html');
              } else if ($scope.bloc.type === 'FESTIVAL'){
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/festival.template.type.html');
              } else if ($scope.bloc.type === 'EVENT_INSCRIPTION'){
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/event/event_inscription.template.type.html');
              } else if ($scope.bloc.type === 'GALLERIES'){
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/galleries.template.type.html');
              } else if ($scope.bloc.type === 'GALLERY'){
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/gallery.template.type.html');
              } else if ($scope.bloc.type === 'CONTACT'){
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/contact.template.type.html');
              } else if ($scope.bloc.type === 'TABLE'){
                templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/table.template.type.html');
              } else if ($scope.bloc.type === 'FAVORITE'){
					 templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/favorite.template.type.html');
				  }

              if (templateUrl != null) {

                $templateRequest(templateUrl).then(function (template) {
                  $scope.bloc.html = template;
                }, function () {
                  console.log('Error template type reading !!');
                });
              }else{
                  $scope.bloc.html = '';
              }

            }

        };

        $scope._save = function(blocForm) {
            blocForm.$setSubmitted();
  			if (blocForm.$valid) {
                SitesManagementService.save('bloc', $scope.bloc).then(function(response){
                    blocForm.$setPristine();
                    $scope._blocsListFn();
                }).catch(function(error){
                    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                });
            }
        };

        $scope._delete = function() {
            SitesManagementService.delete('bloc', $scope.bloc.id).then(function(response){
				$scope._blocsListFn();
			}).catch(function(error){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
        };


    }

})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('NewDemandeDevisController', NewDemandeDevisController);

	function NewDemandeDevisController($scope, $translate, $q, $location,$mdDialog,WorkbookService,$filter,modelService,SiteGenRequestForProposalService, $rootScope,$state, toastr,URL, $window, STORAGE_PREFIX, $timeout, $accountProvider,companyService,BlogService, $currentSite) {


		if($scope.requestForProposalTemp && $scope.requestForProposalTemp.selectedCC) {
			$scope.requestForProposal = {};
			$scope.requestForProposal.selectedCC = $scope.requestForProposalTemp.selectedCC;
			$scope.requestForProposal.siteId = $currentSite.getSite().id;
			$scope.requestForProposal.typeCC = 'EXISTANT';
			$scope.stepTwoOk = true;
		}else{
			$scope.stepTwoOk = false;
			$scope.requestForProposal = {};

		}

		if($scope.user){

			$scope.requestForProposal.applicantAddress1 = $scope.user.applicantAddress1;
			$scope.requestForProposal.applicantAddress2 = $scope.user.applicantAddress2;
			$scope.requestForProposal.applicantAddress3 = $scope.user.applicantAddress3;
			$scope.requestForProposal.applicantCity =  $scope.user.applicantCity;
			$scope.requestForProposal.applicantCivility = $scope.user.applicantCivility;
			$scope.requestForProposal.applicantCompany = $scope.user.applicantCompany;
			$scope.requestForProposal.applicantCompanyType = $scope.user.applicantCompanyType;
			$scope.requestForProposal.applicantCountry = $scope.user.applicantCountry;
			$scope.requestForProposal.applicantDirectPhone = $scope.user.applicantDirectPhone;
			$scope.requestForProposal.applicantFirstName = $scope.user.applicantFirstName;
			$scope.requestForProposal.applicantFunction = $scope.user.applicantFunction;
			$scope.requestForProposal.applicantLastName = $scope.user.applicantLastName;
			$scope.requestForProposal.applicantMobilePhone = $scope.user.applicantMobilePhone;
			$scope.requestForProposal.applicantWebSite = $scope.user.applicantWebSite;
			$scope.requestForProposal.applicantEmail =  $scope.user.applicantEmail;
			$scope.requestForProposal.applicantPostCode =  $scope.user.applicantPostCode;
		}
		$scope.squareUnits = [
			"SQUARE_METER",
			"SQUARE_FEET"
		];
		$scope.listCCExistant = [];

		$translate(['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MR', 'SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MRS']).then((translation) => {

			$scope.civilities = [
				translation['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MR'],
				translation['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MRS']
			];

		});
		$scope.desiredConfigurations = [
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.THEATER'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.CLASS_ROOM'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.BOARD_ROOM'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.U_STYLE'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.BANQUET'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.COCKTAIL'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.CONFERENCE'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.CABARET'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.AUDITORIUM')
		];

		$scope.getCC = function () {
			$scope.listCCExistant = [];
			WorkbookService.getCC().then(function (res) {
				$scope.listCCExistant = res;
			}).catch(function (err) {
				console.log(err)
				toastr.error($filter("translate")("GENERAL.TOASTR.ERROR"));
			})
		}
		$scope.getCC();


		/**
		 * Validate Step Two
		 */
		$scope.validateStepTwo = function(type,wizard,valid){
			if(type=='FORMULAIRE' && !valid){ //focus first required
				toastr.error($filter('translate')('GENERAL.TOASTR.FIELDS_REQUIRED'));
				setTimeout(function(){
					wizard.forms[0].$error.required[0].$$element[0].focus();
				});
				return;
			}
				$scope.stepTwoOk = true;
				wizard.selectedIndex = 1;
				$scope.requestForProposal.siteId = $currentSite.getSite().id;
				$scope.requestForProposal.typeCC = type;
				if(document.getElementById('logoRfp')){
					var logo = document.getElementById('logoRfp').files[0];
					if(logo){
						$scope.requestForProposal.logo = logo;
					}
				}

		}

		/**
		 * Send at step 3
		 */
		$scope.sendRFP = function () {

			var _targetProviders = [];
			$scope.mySelectionOfProviders.forEach(function (element) {
				if (element.toSend) {
					_targetProviders.push(element);
				}
			});

			if(_targetProviders.length==0){
				toastr.error($filter('translate')('SITE_GEN.WORKBOOK.ERROR_PROVIDERS'));
				return;
			}

			var fmData = new FormData();

			var dto = angular.copy($scope.requestForProposal);
			if (dto.dateStart != null) {
				dto.dateStart = $filter('date')($scope.requestForProposal.dateStart, 'dd/MM/yyyy');
			}
			if (dto.dateEnd != null) {
				dto.dateEnd = $filter('date')($scope.requestForProposal.dateEnd, 'dd/MM/yyyy');
			}
			fmData.append('dto', angular.toJson(dto));
			fmData.append('typeCC', $scope.requestForProposal.typeCC);
			fmData.append('lang', $translate.preferredLanguage());
			if($scope.requestForProposal.typeCC=='EXISTANT') {
				fmData.append('id_CC_Existant', $scope.requestForProposal.selectedCC);
			}
			var input = document.getElementById('file');
			if (input != null && input.files != null && input.files.length > 0) {
				fmData.append('file', input.files[0]);
			}

			if($scope.requestForProposal.file) {
				fmData.append("file", $scope.requestForProposal.file);
			}

			if($scope.requestForProposal.logo){
				fmData.append("logo",$scope.requestForProposal.logo);
			}



			fmData.append('providers', JSON.stringify(_targetProviders));
			fmData.append('baseUrl', $scope.contextUrl + "/" + $currentSite.getSite().url);
			SiteGenRequestForProposalService.sendRequestForProposalPure(fmData).then(function (response) {

				if($scope.requestForProposal.typeCC=='EXISTANT') {
					$rootScope.ccSend = true;
				}
				$scope.$emit('rfpcreated');
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});

		}

		BlogService.findAllTags($translate.preferredLanguage()).then(function (tags) {
			$scope.desiredActivities = tags.data;

		}).catch(function (data) {
			 console.log(data)
		});

		//used by file.js (save file locally)
		$scope.saveFile = function (file) {

			$scope.requestForProposal.file = file;
			$scope.validateStepTwo('PDF',$scope.wizardForm);
		}

		$scope.getCompanies = function () {
			var _ids = [];
			for (var i = 0; i < localStorage.length; i++) {
				if (localStorage.key(i).substring(0, 9) === 'PROVIDER_') {
					try {
						var _item = JSON.parse(localStorage.getItem(localStorage.key(i)));
						if (_item.id && localStorage.key(i) === 'PROVIDER_' + _item.id) {
							_ids.push(_item);
						}
					} catch (error) {
						console.log(error);
					}
				}
			}
			if (_ids.length > 0) {
				companyService.listMySelection($translate.preferredLanguage(), _ids).then(function (response) {
					$scope.mySelectionOfProviders = response.data;
				}).catch(function (error) {
					console.log(error);
				});
			}
		}
		$scope.getCompanies();

		/**
		 * Set wizard at ng-init
		 */
		$scope.setWizard = function(wizard){
			$scope.wizardForm = wizard;

			if($scope.requestForProposal.selectedCC){
				$scope.wizardForm.selectedIndex = 1;
			}
		}

		$scope.resizeImage = function(base_image) {
			var maxWidth = 150; // Max width for the image
			var maxHeight = 150;    // Max height for the image
			var ratio = 0;  // Used for aspect ratio
			var width = base_image.width;    // Current image width
			var height = base_image.height;  // Current image height

			if(width > maxWidth){
				ratio = maxWidth / width;   // get ratio for scaling image

            height = height * ratio;    // Reset height to match scaled image
            width = width * ratio;    // Reset width to match scaled image
        }
        // Check if current height is larger than max
        if(height > maxHeight){
				ratio = maxHeight / height; // get ratio for scaling image

             width = width * ratio;    // Reset width to match scaled image
            height = height * ratio;    // Reset height to match scaled image
		  }

		  return {width:width,height:height};
		}

		$scope.writePDF = function(base_image,pdf){
			$scope.dimensions = {width:100,height:100};
			if(base_image){
				$scope.dimensions = $scope.resizeImage(base_image);
				pdf.addImage(base_image, 'JPEG', pdf.internal.pageSize.width/2-75, 20,$scope.dimensions.width,$scope.dimensions.height);
			}
			var y = 40 + $scope.dimensions.height;
			//------!!!!!!!!-----Contact------!!!!!!!!!---------
			pdf.setFontSize(16);
			pdf.setFontType("bold");
			pdf.text(15,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.APPLICANT_INFORMATIONS"))
			pdf.setFontType("normal");
			pdf.setFontSize(12);

			//applicant company
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY")+':  ')
			pdf.setFontType("normal");
			pdf.text(120,y,($scope.requestForProposal.applicantCompany ? $scope.requestForProposal.applicantCompany : ''))

			//applicant company type
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY_TYPE")+':  ')
			pdf.setFontType("normal");
			pdf.text(160,y,($scope.requestForProposal.applicantCompanyType ? $scope.requestForProposal.applicantCompanyType : ''))

			//website
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_WEB_SITE")+':  ')
			pdf.setFontType("normal");
			pdf.text(80,y,($scope.requestForProposal.applicantWebSite ? $scope.requestForProposal.applicantWebSite : ''))

			//title/civility
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CIVILITY")+':  ')
			pdf.setFontType("normal");
			pdf.text(60,y,($scope.requestForProposal.applicantCivility ? $scope.requestForProposal.applicantCivility : '' ))

			//First Name
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FIRST_NAME")+':  ')
			pdf.setFontType("normal");
			pdf.text(100,y,($scope.requestForProposal.applicantFirstName ? $scope.requestForProposal.applicantFirstName : '' ))

			//Last Name
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_LAST_NAME")+':  ')
			pdf.setFontType("normal");
			pdf.text(100,y,($scope.requestForProposal.applicantLastName ? $scope.requestForProposal.applicantLastName : '' ))

			//position
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FUNCTION")+':  ')
			pdf.setFontType("normal");
			pdf.text(85,y,($scope.requestForProposal.applicantFunction ? $scope.requestForProposal.applicantFunction : '' ))

			//address 1
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS1")+':  ')
			pdf.setFontType("normal");
			pdf.text(100,y,($scope.requestForProposal.applicantAddress1 ? $scope.requestForProposal.applicantAddress1 : '' ))

			//address2
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS2")+':  ')
			pdf.setFontType("normal");
			pdf.text(100,y,($scope.requestForProposal.applicantAddress2 ? $scope.requestForProposal.applicantAddress2 : '' ))

			//address3
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS3")+':  ')
			pdf.setFontType("normal");
			pdf.text(100,y,($scope.requestForProposal.applicantAddress3 ? $scope.requestForProposal.applicantAddress3 : ''))

			//post code
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_POST_CODE")+':  ')
			pdf.setFontType("normal");
			pdf.text(100,y,($scope.requestForProposal.applicantPostCode ? $scope.requestForProposal.applicantPostCode : ''))

			//city
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CITY")+':  ')
			pdf.setFontType("normal");
			pdf.text(60,y,($scope.requestForProposal.applicantCity ? $scope.requestForProposal.applicantCity : ''))

			//country
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COUNTRY")+':  ')
			pdf.setFontType("normal");
			pdf.text(80,y,($scope.requestForProposal.applicantCountry ? $scope.requestForProposal.applicantCountry : ''))

			//direct phone
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_DIRECT_PHONE")+':  ')
			pdf.setFontType("normal");
			pdf.text(120,y,($scope.requestForProposal.applicantDirectPhone ? $scope.requestForProposal.applicantDirectPhone : ''))

			//mobile phone
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_MOBILE_PHONE")+':  ')
			pdf.setFontType("normal");
			pdf.text(120,y,($scope.requestForProposal.applicantMobilePhone ? $scope.requestForProposal.applicantMobilePhone : ''))

			//email
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_EMAIL")+':  ')
			pdf.setFontType("normal");
			pdf.text(60,y,($scope.requestForProposal.applicantEmail ? $scope.requestForProposal.applicantEmail : ($scope.user.mail ? $scope.user.mail : '')))


			pdf.setFontSize(10);
			pdf.text(pdf.internal.pageSize.width-40,pdf.internal.pageSize.height-20,'1/3')


			//------!!!!!!!!-----Request for proposal details------!!!!!!!!!---------
			pdf.addPage();
			pdf.setFontSize(16);
			if(base_image){
				$scope.dimensions = $scope.resizeImage(base_image);
				pdf.addImage(base_image, 'JPEG', pdf.internal.pageSize.width/2-75, 20,$scope.dimensions.width,$scope.dimensions.height);
			}
			y = 40 + $scope.dimensions.height;
			pdf.setFontType("bold");
			pdf.text(15,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.EVENT_INFORMATIONS"))
			pdf.setFontType("normal");
			pdf.setFontSize(12);

			//event title
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TITLE")+':  ')
			pdf.setFontType("normal");
			pdf.text(150,y,($scope.requestForProposal.eventTitle ? $scope.requestForProposal.eventTitle : ''))


			//event type
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TYPE")+':  ')
			pdf.setFontType("normal");
			pdf.text(140,y,($scope.requestForProposal.eventType ? $scope.requestForProposal.eventType : ''))

			//number participants
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.NUMBER_OF_PARTICIPANTS")+':  ')
			pdf.setFontType("normal");
			pdf.text(160,y,($scope.requestForProposal.numberOfParticipants ? $scope.requestForProposal.numberOfParticipants +'' : ''))

			//start date
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.START_DATE")+':  ')
			pdf.setFontType("normal");
			pdf.text(110,y,($scope.requestForProposal.dateStart ? $filter('date')($scope.requestForProposal.dateStart, 'dd/MM/yyyy') : '' ))


			//end date
			pdf.setFontType("bolditalic");
			pdf.text(280,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.END_DATE")+':  ')
			pdf.setFontType("normal");
			pdf.text(360,y,($scope.requestForProposal.dateEnd ? $filter('date')($scope.requestForProposal.dateEnd, 'dd/MM/yyyy') : '' ))


			//desired activities
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.DESIRED_ACTIVITIES"))
			pdf.setFontType("normal");
			y += 20;
			var activities = angular.copy($scope.requestForProposal.desiredActivities);
			if(activities){
				if(activities.length<=4){
					var str = '';
					str = angular.copy($scope.addValuesToStr(str,activities));
					pdf.text(30,y,str);

				}else{
					while(activities.length>4){
						var str = '';

						str = angular.copy($scope.addValuesToStr(str,activities.splice(0,4)));
						pdf.text(30,y,str+',');
						y+=20
					}
					if(activities.length>0){
						var str = '';
						str = angular.copy($scope.addValuesToStr(str,activities));
						pdf.text(30,y,str);

					}
				}
			}
			y+=30;

			//Number bedrooms
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_NUMBER")+':  ')
			pdf.setFontType("normal");
			pdf.text(160,y,($scope.requestForProposal.roomNumber ? $scope.requestForProposal.roomNumber+'' : '' ))

			y+=30;

			//number participants
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_CAPACITY_MAX")+':  ')
			pdf.setFontType("normal");
			pdf.text(510,y,($scope.requestForProposal.roomCapacityMax ? $scope.requestForProposal.roomCapacityMax+'' : '' ))

			y+=30;

			//setup
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.CONFIGURATION")+':  ')
			pdf.setFontType("normal");
			pdf.text(180,y,($scope.requestForProposal.desiredConfiguration ? $scope.requestForProposal.desiredConfiguration : ''))

			y+=30;


			//square
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE")+':  ')
			pdf.setFontType("normal");
			pdf.text(520,y,($scope.requestForProposal.square ? $scope.requestForProposal.square+'' : ''))
			y+=30;


			//square unit
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE_UNIT")+':  ')
			pdf.setFontType("normal");
			var str = 'SITE_GEN.REQUEST_FOR_PROPOSALS.SQUARE_UNITS.';
			if($scope.requestForProposal.squareUnit && $scope.requestForProposal.squareUnit=='SQUARE_METER'){
				str+='SQUARE_METER';
			}else if($scope.requestForProposal.squareUnit && $scope.requestForProposal.squareUnit=='SQUARE_FEET'){
				str+='SQUARE_FEET';
			}
			pdf.text(120,y,($scope.requestForProposal.squareUnit ? $filter('translate')(str) : ''))
			y+=30;

			//technical equipement
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.TECHNICAL_EQUIPMENT"))
			pdf.setFontType("normal");
			y+=20;
			pdf.text(20,y,($scope.requestForProposal.technicalEquipment ? $scope.requestForProposal.technicalEquipment : ''))
			y+=30;


			//precision hotel
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_HOTEL"))
			pdf.setFontType("normal");
			y+=20;
			pdf.text(20,y,($scope.requestForProposal.precisiontoTheHotel ? $scope.requestForProposal.precisiontoTheHotel : ''))
			y+=30;


			//precision event place
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_EVENT_PLACE"))
			pdf.setFontType("normal");
			y+=20;
			pdf.text(20,y,($scope.requestForProposal.precisiontoTheEventPlace ? $scope.requestForProposal.precisiontoTheEventPlace : ''))
			y+=30;


			pdf.setFontSize(10);
			pdf.text(pdf.internal.pageSize.width-40,pdf.internal.pageSize.height-20,'2/3')

			pdf.addPage();
			if(base_image){
				$scope.dimensions = $scope.resizeImage(base_image);
				pdf.addImage(base_image, 'JPEG', pdf.internal.pageSize.width/2-75, 20,$scope.dimensions.width,$scope.dimensions.height);
			}

			y = 40 + $scope.dimensions.height;
			pdf.setFontSize(12);

			//precision receptive
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_RECEPTIVE"))
			pdf.setFontType("normal");
			y+=20;
			pdf.text(20,y,($scope.requestForProposal.precisionForTheReceptive ? $scope.requestForProposal.precisionForTheReceptive : ''))


			//precision carrier
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_CARRIER"))
			pdf.setFontType("normal");
			y+=20;
			pdf.text(20,y,($scope.requestForProposal.precisionForTheCarrier ? $scope.requestForProposal.precisionForTheCarrier : ''))


			//other precision
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.OTHER_PRECISION"))
			pdf.setFontType("normal");
			y+=20;
			pdf.text(20,y,($scope.requestForProposal.otherPrecision ? $scope.requestForProposal.otherPrecision : ''))

			pdf.setFontSize(10);
			pdf.text(pdf.internal.pageSize.width-40,pdf.internal.pageSize.height-20,'3/3')

			pdf.save($scope.requestForProposal.name+".pdf");
		}
		$scope.addValuesToStr = function(str,activities){
			activities.forEach(element => {
				str += ''+(str!='' ? ', ' : '')+element;
			});
			return str;
		}
		$scope.exportForm = function(wizard,valid){
			if(!valid) { //focus first required
				toastr.error($filter('translate')('GENERAL.TOASTR.FIELDS_REQUIRED'));
				setTimeout(function(){
					wizard.forms[0].$error.required[0].$$element[0].focus();
				});

				return;
			}

			var pdf = new jsPDF('p', 'pt', 'a4');

			var newCanvas = document.createElement('canvas');
			var file = null;
			if(document.getElementById('logoRfp')){
			 file = document.getElementById('logoRfp').files[0];
			}

			if(file){
				var context = newCanvas.getContext('2d');

				var reader = new FileReader();

				var base_image = new Image();

				reader.readAsDataURL(file);

				reader.onload = ()=>{
					base_image.src = reader.result;
				}

				base_image.onload = () => {
					context.drawImage(base_image, 0, 0);

					$scope.writePDF(base_image,pdf,file)
				}
			}else{
				$scope.writePDF(null,pdf,null)
			}
		}


	}
})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('MyDemandeDevisController', MyDemandeDevisController);

	function MyDemandeDevisController($scope, $translate, $q, $location,
		$filter, $rootScope, $state, $stateParams, toastr, $window, STORAGE_PREFIX, $timeout, $accountProvider, userService, $currentSite, SiteGenService) {


		$scope.requestForProposals = [];
		$scope.loaded = false;

		$scope.refresh = function () {
			SiteGenService.getPersonnalRfp($translate.preferredLanguage()).then(function (res) {
				$scope.requestForProposals = res.data;

				$scope.loaded = true;
			}).catch(function (err) {
				$scope.loaded = true;
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}

		$scope.refresh();

		$scope.$on('refreshRFP', () => {
			$scope.loaded = false;
			$scope.refresh();
		});


	}
}
)();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('MyCahiersChargesController', MyCahiersChargesController);

	function MyCahiersChargesController($scope, $translate, $q, $location,
		$filter, $rootScope, $state, toastr, $window, $mdDialog, BlogService, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $accountProvider, userService, $currentSite, WorkbookService, SiteGenService, modelService, SiteGenRequestForProposalService) {
		$scope.dtOptions = null;
		$translate(['SITE_GEN.TABLE.EMPTY', 'SITE_GEN.TABLE.INFO_CC', 'SITE_GEN.TABLE.INFO_EMPTY_CC',
			'SITE_GEN.TABLE.INFO_FILTERED_CC', 'SITE_GEN.TABLE.LENGTH_MENU_CC', 'SITE_GEN.TABLE.LOADING',
			'SITE_GEN.TABLE.PROCESSING', 'SITE_GEN.TABLE.SEARCH', 'SITE_GEN.TABLE.ZERO_RECORDS_CC',
			'SITE_GEN.TABLE.FIRST', 'SITE_GEN.TABLE.LAST', 'SITE_GEN.TABLE.NEXT', 'SITE_GEN.TABLE.PREVIOUS']).then((translation) => {

				$scope.dtOptions = DTOptionsBuilder.newOptions()
					.withLanguage({
						"sEmptyTable": translation['SITE_GEN.TABLE.EMPTY'], //"Aucune donnée disponible"
						"sInfo": translation['SITE_GEN.TABLE.INFO_CC'],//" _START_ sur _END_ d'un total de _TOTAL_ données"
						"sInfoEmpty": translation['SITE_GEN.TABLE.INFO_EMPTY_CC'],//" 0 sur 0 of 0 entries",
						"sInfoFiltered": translation['SITE_GEN.TABLE.INFO_FILTERED_CC'],//"(filtered from _MAX_ total entries)",
						"sInfoPostFix": "",
						"sInfoThousands": ",",
						"sLengthMenu": translation['SITE_GEN.TABLE.LENGTH_MENU_CC'],//"Show _MENU_ entries"
						"sLoadingRecords": translation['SITE_GEN.TABLE.LOADING'],//"Loading...",
						"sProcessing": translation['SITE_GEN.TABLE.PROCESSING'],//"Processing...",
						"sSearch": translation['SITE_GEN.TABLE.SEARCH'],//"Search:",
						"sZeroRecords": translation['SITE_GEN.TABLE.ZERO_RECORDS_CC'],//"No matching records found",
						"oPaginate": {
							"sFirst": translation['SITE_GEN.TABLE.FIRST'],//"First",
							"sLast": translation['SITE_GEN.TABLE.LAST'],//"Last",
							"sNext": translation['SITE_GEN.TABLE.NEXT'], //"Next",
							"sPrevious": translation['SITE_GEN.TABLE.PREVIOUS'],//"Previous"
						},
						"oAria": {
							"sSortAscending": ": activate to sort column ascending",
							"sSortDescending": ": activate to sort column descending"
						}

					});

			});

		$scope.dtColumnDefs = [
			DTColumnDefBuilder.newColumnDef(0),
			DTColumnDefBuilder.newColumnDef(1),
			DTColumnDefBuilder.newColumnDef(2).notSortable(),
			DTColumnDefBuilder.newColumnDef(3).notSortable(),
			DTColumnDefBuilder.newColumnDef(4).notSortable()

		];

		$scope.cahier = {};
		if ($scope.user) {

			$scope.cahier.applicantAddress1 = $scope.user.applicantAddress1;
			$scope.cahier.applicantAddress2 = $scope.user.applicantAddress2;
			$scope.cahier.applicantAddress3 = $scope.user.applicantAddress3;
			$scope.cahier.applicantCity = $scope.user.applicantCity;
			$scope.cahier.applicantCivility = $scope.user.applicantCivility;
			$scope.cahier.applicantCompany = $scope.user.applicantCompany;
			$scope.cahier.applicantCompanyType = $scope.user.applicantCompanyType;
			$scope.cahier.applicantCountry = $scope.user.applicantCountry;
			$scope.cahier.applicantDirectPhone = $scope.user.applicantDirectPhone;
			$scope.cahier.applicantFirstName = $scope.user.applicantFirstName;
			$scope.cahier.applicantFunction = $scope.user.applicantFunction;
			$scope.cahier.applicantLastName = $scope.user.applicantLastName;
			$scope.cahier.applicantMobilePhone = $scope.user.applicantMobilePhone;
			$scope.cahier.applicantWebSite = $scope.user.applicantWebSite;
			$scope.cahier.applicantEmail = $scope.user.applicantEmail;
			$scope.cahier.applicantPostCode = $scope.user.applicantPostCode;
		}

		$scope.cahiersCharges = [];

		$scope.loaded = false;


		$translate(['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MR', 'SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MRS']).then((translation) => {

			$scope.civilities = [
				translation['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MR'],
				translation['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MRS']
			];

		})
		BlogService.findAllTags($translate.preferredLanguage()).then(function (tags) {
			$scope.desiredActivities = tags.data;

		}).catch(function (data) {
			console.log(data)
		});
		$scope.desiredConfigurations = [
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.THEATER'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.CLASS_ROOM'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.BOARD_ROOM'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.U_STYLE'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.BANQUET'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.COCKTAIL'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.CONFERENCE'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.CABARET'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.AUDITORIUM')
		];
		$scope.squareUnits = [
			"SQUARE_METER",
			"SQUARE_FEET"
		];
		$scope.refresh = function () {
			SiteGenService.getPersonnalCC($translate.preferredLanguage()).then(function (res) {
				$scope.cahiersCharges = angular.copy(res.data);

				$scope.loaded = true;
			}).catch(function (err) {
				$scope.loaded = true;
				if (err.status == 401) {
					toastr.error($filter('translate')('GENERAL.TOASTR.UNAUTHORIZED'))
					$state.go('sitegen.site.login');
				} else {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}
			});
		}

		$scope.refresh();

		$scope.$on('refreshCC', () => {
			$scope.loaded = false;
			$scope.refresh();
		});
		$scope.download = function (id) {
			$window.open(SiteGenService.downloadCC(id));
		}

		$scope.saveInfosPDF = function () {
			var dto = angular.copy($scope.cahier);
			if (dto.dateStart != null) {
				dto.dateStart = $filter('date')($scope.cahier.dateStart, 'dd/MM/yyyy');
			}
			if (dto.dateEnd != null) {
				dto.dateEnd = $filter('date')($scope.cahier.dateEnd, 'dd/MM/yyyy');
			}

			SiteGenRequestForProposalService.editCC_WithoutFile(dto).then(function (response) {

				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_SAVE'));
				$mdDialog.hide();

				$scope.cahiersCharges.forEach(function (cc) {
					if (cc.id == response.id) {
						cc.dateStart = response.dateStart;
						cc.dateEnd = response.dateEnd;
						cc.name = response.name;
					}
				});



			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}
		$scope.saveFile = function (file) {

			var fmData = new FormData();
			fmData.append('file', file);

			var dto = angular.copy($scope.cahier);
			if (dto.dateStart != null) {
				dto.dateStart = $filter('date')($scope.cahier.dateStart, 'dd/MM/yyyy');
			}
			if (dto.dateEnd != null) {
				dto.dateEnd = $filter('date')($scope.cahier.dateEnd, 'dd/MM/yyyy');
			}
			fmData.append('dto', angular.toJson(dto));
			SiteGenRequestForProposalService.saveCC_PDF(fmData).then(function (response) {

				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_SAVE'));
				$mdDialog.hide();
				if (!$scope.cahier.id) {
					$scope.$emit('cahiercreated');
				} else {
					$scope.cahiersCharges.forEach(function (cc) {
						if (cc.id == response.id) {
							cc.dateStart = response.dateStart;
							cc.dateEnd = response.dateEnd;
							cc.name = response.name;
						}
					});
				}


			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});

		}


		$scope.generateFromForm = function (form, valid) {

			if (!valid) { //focus first required
				toastr.error($filter('translate')('GENERAL.TOASTR.FIELDS_REQUIRED'));
				setTimeout(function () {
					form.$error.required[0].$$element[0].focus();
				});
				return;
			}
			var fmData = new FormData();


			var dto = angular.copy($scope.cahier);
			if (dto.dateStart != null) {
				dto.dateStart = $filter('date')($scope.cahier.dateStart, 'dd/MM/yyyy');
			}
			if (dto.dateEnd != null) {
				dto.dateEnd = $filter('date')($scope.cahier.dateEnd, 'dd/MM/yyyy');
			}
			fmData.append('dto', angular.toJson(dto));
			var logo = document.getElementById('logoRfp') ? document.getElementById('logoRfp').files[0] : null;
			if (logo) {
				$scope.cahier.logo = logo;
				fmData.append("logo", $scope.cahier.logo);
			}

			SiteGenRequestForProposalService.saveCC_Formulaire(fmData).then(function (response) {
				try {

					$mdDialog.hide();
				} catch (error) {

				}
				$scope.$emit('cahiercreated');
				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_SAVE'));
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});

		}

		$scope.hidePopup = function () {
			$mdDialog.hide();
		}
		$scope.editCC = function (cc) {
			SiteGenRequestForProposalService.getCCById(cc.id).then(function (res) {
				$scope.cahier = angular.copy(res);

				if ($scope.cahier.dateStart != null) {
					var parts = $scope.cahier.dateStart.split('/');

					$scope.cahier.dateStart = new Date(parts[2], parts[1] - 1, parts[0]);
				}
				if ($scope.cahier.dateEnd != null) {
					var parts = $scope.cahier.dateEnd.split('/');
					$scope.cahier.dateEnd = new Date(parts[2], parts[1] - 1, parts[0]);
				}
				if (cc.type == "FORM") {
					$mdDialog.show({
						templateUrl: 'app/main/sitegen/account/my_cahiers_charges/popup/edit_cc_form.html',
						preserveScope: true,
						clickOutsideToClose: true,
						scope: $scope,
					}).then(function () {
					}).catch(function () {
					});

				} else if (cc.type == 'PDF') {
					$mdDialog.show({
						templateUrl: 'app/main/sitegen/account/my_cahiers_charges/popup/edit_cc_pdf.html',
						preserveScope: true,
						clickOutsideToClose: true,
						scope: $scope,
					}).then(function () {
						$mdDialog.hide();

					}).catch(function () {

					});
				}
			}).catch(function (err) {
				console.log(err)
			})

		}

		$scope.duplicate = function (cc) {
			$scope.cahier.id = angular.copy(cc.id);
			$scope.cahier.name = angular.copy(cc.name);

			$mdDialog.show({
				templateUrl: 'app/main/sitegen/account/my_cahiers_charges/popup/duplicate_cc.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {
			}).catch(function () {
			});
		}

		$scope.duplicateConfirm = function () {
			$scope.loaded = false;
			SiteGenRequestForProposalService.duplicateCC($scope.cahier.id, $scope.cahier.name).then(function (response) {
				$scope.refresh();
				$mdDialog.hide();

				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_SAVE'));


			}).catch(function (error) {
				console.log(error)
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}


		$scope.resizeImage = function (base_image) {
			var maxWidth = 150; // Max width for the image
			var maxHeight = 150;    // Max height for the image
			var ratio = 0;  // Used for aspect ratio
			var width = base_image.width;    // Current image width
			var height = base_image.height;  // Current image height

			if (width > maxWidth) {
				ratio = maxWidth / width;   // get ratio for scaling image

				height = height * ratio;    // Reset height to match scaled image
				width = width * ratio;    // Reset width to match scaled image
			}
			// Check if current height is larger than max
			if (height > maxHeight) {
				ratio = maxHeight / height; // get ratio for scaling image

				width = width * ratio;    // Reset width to match scaled image
				height = height * ratio;    // Reset height to match scaled image
			}

			return { width: width, height: height };
		}
		$scope.writePDF = function (cahier, base_image, pdf) {
			$scope.dimensions = { width: 100, height: 100 };

			if (base_image) {
				$scope.dimensions = $scope.resizeImage(base_image)
				pdf.addImage(base_image, 'JPEG', pdf.internal.pageSize.width / 2 - 75, 20, $scope.dimensions.width, $scope.dimensions.height);
			}
			//------!!!!!!!!-----Contact------!!!!!!!!!---------

			var y = 40 + $scope.dimensions.height;

			pdf.setFontSize(16);
			pdf.setFontType("bold");
			pdf.text(15, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.APPLICANT_INFORMATIONS"))
			pdf.setFontType("normal");
			pdf.setFontSize(12);

			//applicant company
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY") + ':  ')
			pdf.setFontType("normal");
			pdf.text(120, y, (cahier.applicantCompany ? cahier.applicantCompany : ''))

			//applicant company type
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY_TYPE") + ':  ')
			pdf.setFontType("normal");
			pdf.text(160, y, (cahier.applicantCompanyType ? cahier.applicantCompanyType : ''))

			//website
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_WEB_SITE") + ':  ')
			pdf.setFontType("normal");
			pdf.text(80, y, (cahier.applicantWebSite ? cahier.applicantWebSite : ''))

			//title/civility
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CIVILITY") + ':  ')
			pdf.setFontType("normal");
			pdf.text(60, y, (cahier.applicantCivility ? cahier.applicantCivility : ''))

			//First Name
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FIRST_NAME") + ':  ')
			pdf.setFontType("normal");
			pdf.text(100, y, (cahier.applicantFirstName ? cahier.applicantFirstName : ''))

			//Last Name
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_LAST_NAME") + ':  ')
			pdf.setFontType("normal");
			pdf.text(100, y, (cahier.applicantLastName ? cahier.applicantLastName : ''))

			//position
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FUNCTION") + ':  ')
			pdf.setFontType("normal");
			pdf.text(85, y, (cahier.applicantFunction ? cahier.applicantFunction : ''))

			//address 1
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS1") + ':  ')
			pdf.setFontType("normal");
			pdf.text(100, y, (cahier.applicantAddress1 ? cahier.applicantAddress1 : ''))

			//address2
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS2") + ':  ')
			pdf.setFontType("normal");
			pdf.text(100, y, (cahier.applicantAddress2 ? cahier.applicantAddress2 : ''))

			//address3
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS3") + ':  ')
			pdf.setFontType("normal");
			pdf.text(100, y, (cahier.applicantAddress3 ? cahier.applicantAddress3 : ''))

			//post code
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_POST_CODE") + ':  ')
			pdf.setFontType("normal");
			pdf.text(100, y, (cahier.applicantPostCode ? cahier.applicantPostCode : ''))

			//city
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CITY") + ':  ')
			pdf.setFontType("normal");
			pdf.text(60, y, (cahier.applicantCity ? cahier.applicantCity : ''))

			//country
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COUNTRY") + ':  ')
			pdf.setFontType("normal");
			pdf.text(80, y, (cahier.applicantCountry ? cahier.applicantCountry : ''))

			//direct phone
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_DIRECT_PHONE") + ':  ')
			pdf.setFontType("normal");
			pdf.text(120, y, (cahier.applicantDirectPhone ? cahier.applicantDirectPhone : ''))

			//mobile phone
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_MOBILE_PHONE") + ':  ')
			pdf.setFontType("normal");
			pdf.text(120, y, (cahier.applicantMobilePhone ? cahier.applicantMobilePhone : ''))

			//email
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_EMAIL") + ':  ')
			pdf.setFontType("normal");
			pdf.text(60, y, (cahier.applicantEmail ? cahier.applicantEmail : ($scope.user.mail ? $scope.user.mail : '')))


			pdf.setFontSize(10);
			pdf.text(pdf.internal.pageSize.width - 40, pdf.internal.pageSize.height - 20, '1/3')


			//------!!!!!!!!-----Request for proposal details------!!!!!!!!!---------
			pdf.addPage();
			pdf.setFontSize(16);
			if (base_image) {
				$scope.dimensions = $scope.resizeImage(base_image)
				pdf.addImage(base_image, 'JPEG', pdf.internal.pageSize.width / 2 - 75, 20, $scope.dimensions.width, $scope.dimensions.height);
			}

			y = 40 + $scope.dimensions.height;


			pdf.setFontType("bold");
			pdf.text(15, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.EVENT_INFORMATIONS"))
			pdf.setFontType("normal");
			pdf.setFontSize(12);

			//event title
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TITLE") + ':  ')
			pdf.setFontType("normal");
			pdf.text(150, y, (cahier.eventTitle ? cahier.eventTitle : ''))


			//event type
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TYPE") + ':  ')
			pdf.setFontType("normal");
			pdf.text(140, y, (cahier.eventType ? cahier.eventType : ''))

			//number participants
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.NUMBER_OF_PARTICIPANTS") + ':  ')
			pdf.setFontType("normal");
			pdf.text(160, y, (cahier.numberOfParticipants ? cahier.numberOfParticipants + '' : ''))

			//start date
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.START_DATE") + ':  ')
			pdf.setFontType("normal");
			pdf.text(110, y, (cahier.dateStart ? $filter('date')(cahier.dateStart, 'dd/MM/yyyy') : ''))


			//end date

			pdf.setFontType("bolditalic");
			pdf.text(280, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.END_DATE") + ':  ')
			pdf.setFontType("normal");
			pdf.text(360, y, (cahier.dateEnd ? $filter('date')(cahier.dateEnd, 'dd/MM/yyyy') : ''))


			//desired activities
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.DESIRED_ACTIVITIES"))
			pdf.setFontType("normal");
			y += 30;

			var activities = angular.copy(cahier.desiredActivities);
			if (activities) {
				if (activities.length <= 4) {
					var str = '';
					str = angular.copy($scope.addValuesToStr(str, activities));
					pdf.text(30, y, str);

				} else {
					while (activities.length > 4) {
						var str = '';

						str = angular.copy($scope.addValuesToStr(str, activities.splice(0, 4)));
						pdf.text(30, y, str + ',');
						y += 20
					}
					if (activities.length > 0) {
						var str = '';
						str = angular.copy($scope.addValuesToStr(str, activities));
						pdf.text(30, y, str);

					}
				}
			}
			y += 30;

			//Number bedrooms
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_NUMBER") + ':  ')
			pdf.setFontType("normal");
			pdf.text(160, y, (cahier.roomNumber ? cahier.roomNumber + '' : ''))

			y += 30;

			//number participants
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_CAPACITY_MAX") + ':  ')
			pdf.setFontType("normal");
			pdf.text(510, y, (cahier.roomCapacityMax ? cahier.roomCapacityMax + '' : ''))

			y += 30;

			//setup
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.CONFIGURATION") + ':  ')
			pdf.setFontType("normal");
			pdf.text(180, y, (cahier.desiredConfiguration ? cahier.desiredConfiguration : ''))

			y += 30;


			//square
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE") + ':  ')
			pdf.setFontType("normal");
			pdf.text(520, y, (cahier.square ? cahier.square + '' : ''))
			y += 30;


			//square unit
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE_UNIT") + ':  ')
			pdf.setFontType("normal");
			var str = 'SITE_GEN.REQUEST_FOR_PROPOSALS.SQUARE_UNITS.';
			if (cahier.squareUnit && cahier.squareUnit == 'SQUARE_METER') {
				str += 'SQUARE_METER';
			} else if (cahier.squareUnit && cahier.squareUnit == 'SQUARE_FEET') {
				str += 'SQUARE_FEET';
			}
			pdf.text(120, y, (cahier.squareUnit ? $filter('translate')(str) : ''))
			y += 30;

			//technical equipement
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.TECHNICAL_EQUIPMENT"))
			pdf.setFontType("normal");
			y += 20;
			pdf.text(20, y, (cahier.technicalEquipment ? cahier.technicalEquipment : ''))
			y += 30;


			//precision hotel
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_HOTEL"))
			pdf.setFontType("normal");
			y += 20;
			pdf.text(20, y, (cahier.precisiontoTheHotel ? cahier.precisiontoTheHotel : ''))
			y += 30;


			//precision event place
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_EVENT_PLACE"))
			pdf.setFontType("normal");
			y += 20;
			pdf.text(20, y, (cahier.precisiontoTheEventPlace ? cahier.precisiontoTheEventPlace : ''))
			y += 30;


			pdf.setFontSize(10);
			pdf.text(pdf.internal.pageSize.width - 40, pdf.internal.pageSize.height - 20, '2/3')

			pdf.addPage();
			if (base_image) {
				$scope.dimensions = $scope.resizeImage(base_image)
				pdf.addImage(base_image, 'JPEG', pdf.internal.pageSize.width / 2 - 75, 20, $scope.dimensions.width, $scope.dimensions.height);
			}
			pdf.setFontSize(12);

			y = 40 + $scope.dimensions.height;
			//precision receptive
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_RECEPTIVE"))
			pdf.setFontType("normal");
			y += 20;
			pdf.text(20, y, (cahier.precisionForTheReceptive ? cahier.precisionForTheReceptive : ''))


			//precision carrier
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_CARRIER"))
			pdf.setFontType("normal");
			y += 20;
			pdf.text(20, y, (cahier.precisionForTheCarrier ? cahier.precisionForTheCarrier : ''))


			//other precision
			y += 30;
			pdf.setFontType("bolditalic");
			pdf.text(20, y, $filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.OTHER_PRECISION"))
			pdf.setFontType("normal");
			y += 20;
			pdf.text(20, y, (cahier.otherPrecision ? cahier.otherPrecision : ''))

			pdf.setFontSize(10);
			pdf.text(pdf.internal.pageSize.width - 40, pdf.internal.pageSize.height - 20, '3/3')

			pdf.save(cahier.name + ".pdf");
		}
		$scope.addValuesToStr = function (str, activities) {
			activities.forEach(element => {
				str += '' + (str != '' ? ', ' : '') + element;
			});
			return str;
		}
		$scope.exportForm = function (form, cc, valid) {
			if (!valid) { //focus first required
				toastr.error($filter('translate')('GENERAL.TOASTR.FIELDS_REQUIRED'));
				setTimeout(function () {
					form.$error.required[0].$$element[0].focus();
				});

				return;
			}
			var cahier = cc ? angular.copy(cc) : angular.copy($scope.cahier);


			var pdf = new jsPDF('p', 'pt', 'a4');

			var newCanvas = document.createElement('canvas');
			var file = null;

			if (document.getElementById('logoRfp') && document.getElementById('logoRfp').files && document.getElementById('logoRfp').files[0]) {

				file = document.getElementById('logoRfp').files[0];
				var context = newCanvas.getContext('2d');

				var reader = new FileReader();

				var base_image = new Image();

				reader.readAsDataURL(file);

				reader.onload = () => {
					base_image.src = reader.result;
				}

				base_image.onload = () => {
					context.drawImage(base_image, 0, 0);

					$scope.writePDF(cahier, base_image, pdf, file)
				}
			} else if (cahier.locationLogo) {
				//imgLogoSrc = 'alternatedocroots/'+$scope.cahier.locationLogo;

				WorkbookService.getLogo(cahier).then(function (res) {
					var blob = new Blob([res.data], {
						type: res.headers('Content-Type')
					})
					console.log(blob)
					var context = newCanvas.getContext('2d');

					var reader = new FileReader();

					var base_image = new Image();

					reader.readAsDataURL(blob);

					reader.onload = () => {
						base_image.src = reader.result;
					}

					base_image.onload = () => {
						context.drawImage(base_image, 0, 0);

						$scope.writePDF(cahier, base_image, pdf)
					}
				}).catch(function (err) {
					console.log(err);
				})
			} else {
				$scope.writePDF(cahier, null, pdf, null)
			}
		}


		$scope.deleteConfirm = function (id) {
			var content = {
				title: $filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.DELETE_POPUP'),
				message: $filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.DELETE_POPUP_CONFIRM')
			};
			$scope.openConfirmPopup(content).then(function () {
				SiteGenRequestForProposalService.deleteCC(id).then((res) => {
					if (res.data === 'INCORRECT_USER') {
						toastr.error($filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.INCORRECT_USER'));
					} else if (res.data === 'RFP_EXIST') {
						toastr.error($filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.RFP_EXIST'));
					} else {
						toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_DELETE'));
						$scope.refresh();
					}
				}).catch(function () {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}).catch(function () {

			});
		};

		$scope.sendRFP = function (cc) {
			$rootScope.$broadcast('sendCC', { id: cc.id })
		}
	}
}
)();

(function () {
    'use strict';

    angular.module('sitegen.site').controller('maSelectionPureController', maSelectionPureController);

    function maSelectionPureController($scope,$state,$rootScope,$currentSite, $filter, $mdDialog, folderService) {

        var PROVIDER_SESSION_STORAGE_KEY_PREFIX = "PROVIDER_";
        var ARTICLE_SESSION_STORAGE_KEY_PREFIX = "ARTICLE_";
        $scope.mySelectionOfProviders = [];
        $scope.mySelectionOfArticles = [];

        $scope.refresh = function () {
            $scope.mySelectionOfProviders = [];
            $scope.mySelectionOfArticles = [];

            for (var i = 0; i < localStorage.length; i++) {
                if (localStorage.key(i).substring(0, 9) === PROVIDER_SESSION_STORAGE_KEY_PREFIX) {
                    try {
                        var _item = JSON.parse(localStorage.getItem(localStorage.key(i)));
                        if (_item.id && localStorage.key(i) === PROVIDER_SESSION_STORAGE_KEY_PREFIX + _item.id) {
                            $scope.mySelectionOfProviders.push(_item);
                        }
                    } catch (error) {
                        console.log(error);
                    }
                } else if (localStorage.key(i).substring(0, 8) === ARTICLE_SESSION_STORAGE_KEY_PREFIX) {
                    try {
                        var _item = JSON.parse(localStorage.getItem(localStorage.key(i)));
                        if (_item.id && localStorage.key(i) === ARTICLE_SESSION_STORAGE_KEY_PREFIX + _item.id) {
                            $scope.mySelectionOfArticles.push(_item);
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            }
        };

        $scope.refresh();


        $scope.removeFromLocalStorage = function (entityId, type) {
            if (type === 'article') {
                localStorage.removeItem(ARTICLE_SESSION_STORAGE_KEY_PREFIX + entityId);
            } else if (type === 'company') {
					 localStorage.removeItem(PROVIDER_SESSION_STORAGE_KEY_PREFIX + entityId);
					 $scope.$broadcast('checkSelection');
            }
            $scope.refresh();
        };



        $scope.addToFolder = function (entity, type) {
            $mdDialog.show({
                templateUrl: 'app/main/sitegen/account/ma_selection/popup/add_to_folder.html',
                controller: 'AddToFolderController',
                clickOutsideToClose: true,
                locals: {
                    entity: entity,
                    type: type
                }
            }).then(() => {
                $scope.refresh();
            }).catch(() => { });
		  };


		  $scope.goToCompany = function(comp){
			$state.go('sitegen.page', {
				site: $currentSite.getSite().url,
				page: $rootScope.site.companyUrl,
				param1: comp.id
			})
		  }

		  $scope.goToArticle = function(art){
			$state.go('sitegen.page', {
				site: $currentSite.getSite().url,
				page: $rootScope.site.articleUrl,
				param1: art.id
			})
		  }

    }

})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('MySelectionController', MySelectionController);

	function MySelectionController($scope, $translate, $q, $location,
		$filter, $rootScope, $state, toastr, URL, $window, STORAGE_PREFIX, $mdDialog, $timeout, $accountProvider, userService, companyService, $currentSite, SiteGenService) {
		var PROVIDER_SESSION_STORAGE_KEY_PREFIX = "PROVIDER_";
		$scope.URL = URL;
		$scope.mySelectonOfProviders = [];
		/*if($cookies.get("SESSION_TOKEN") !== undefined) {
			var _ids = [];
			for (var i = 0; i < localStorage.length; i++) {
					 if(localStorage.key(i).substring(0, 9) === 'PROVIDER_') {
						  try {
								var _item = JSON.parse(localStorage.getItem(localStorage.key(i)));
								if(_item.id && localStorage.key(i) === 'PROVIDER_' + _item.id && _item.session && _item.session === $cookies.get("SESSION_TOKEN")) {
									 _ids.push(_item);
								}
						  } catch(error) {
								console.log(error);
						  }
					 }
			}
			if(_ids.length > 0) {
				companyService.listMySelection($translate.preferredLanguage(), _ids).then(function (response) {
					$scope.mySelectonOfProviders = response.data;
				}).catch(function (error) {
					console.log(error);
				});
			}
		}*/
		var _ids = [];
		for (var i = 0; i < localStorage.length; i++) {
			if (localStorage.key(i).substring(0, 9) === 'PROVIDER_') {
				try {
					var _item = JSON.parse(localStorage.getItem(localStorage.key(i)));
					if (_item.id && localStorage.key(i) === 'PROVIDER_' + _item.id) {
						_ids.push(_item);
					}
				} catch (error) {
					console.log(error);
				}
			}
		}
		if (_ids.length > 0) {
			companyService.listMySelection($translate.preferredLanguage(), _ids).then(function (response) {
				$scope.mySelectonOfProviders = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		}
		/*companyService.listMySelection($translate.preferredLanguage(), localStorage).then(function (response) {
			$scope.mySelectonOfProviders = response.data;
		}).catch(function (error) {
			console.log(error);
		});*/

		$scope.filterModel = function (model, index) {
			return $filter('showColumn')(model, index);
		};

		$scope.details = function (company) {
			SiteGenService.find($currentSite.getSite().url, company.pageDetailName, $translate.preferredLanguage()).then(function (resp) {
				$currentSite.setSite(resp);
				$rootScope.$broadcast('menuReady');
				$rootScope.$broadcast('pageReady');
				$state.go('sitegen.page', {
					site: $currentSite.getSite().url,
					page: company.pageDetailName,
					param1: company.id
				}, {
					reload: true
				});
			}).catch(function (error) {
				$scope.toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.deleteFromSelection = function (company) {
			localStorage.removeItem(PROVIDER_SESSION_STORAGE_KEY_PREFIX + company.id);
			$scope.$broadcast('checkSelection');
			var index = $scope.mySelectonOfProviders.map(function (item) {
				return item.id;
			}).indexOf(company.id);
			if (index != -1) {
				$scope.mySelectonOfProviders.splice(index, 1);
			}
		}

		$scope.openAddToAFolder = function (id) {
			$mdDialog.show({
				templateUrl: 'app/main/sitegen/account/ma_selection/popup/add_to_folder.html',
				controller: 'AddToFolderController',
				clickOutsideToClose: true,
				locals: {
					id: id
				}
			}).then(function () {

			}).catch(function () {

			});
		}
	}
})();

(function () {
    'use strict';

    angular.module('sitegen.site').controller('FoldersController', FoldersController);

    function FoldersController($scope, DTOptionsBuilder, DTColumnDefBuilder, $filter, $mdDialog, $translate, toastr, folderService) {

        $scope.loaded = false;

        $translate(['SITE_GEN.TABLE.EMPTY', 'SITE_GEN.TABLE.INFO_FOLDER', 'SITE_GEN.TABLE.INFO_EMPTY_FOLDER',
            'SITE_GEN.TABLE.INFO_FILTERED_FOLDER', 'SITE_GEN.TABLE.LENGTH_MENU_FOLDER', 'SITE_GEN.TABLE.LOADING',
            'SITE_GEN.TABLE.PROCESSING', 'SITE_GEN.TABLE.SEARCH', 'SITE_GEN.TABLE.ZERO_RECORDS_FOLDER',
            'SITE_GEN.TABLE.FIRST', 'SITE_GEN.TABLE.LAST', 'SITE_GEN.TABLE.NEXT', 'SITE_GEN.TABLE.PREVIOUS']).then((translation) => {

                $scope.dtOptions = DTOptionsBuilder.newOptions()
                    .withLanguage({
                        "sEmptyTable": translation['SITE_GEN.TABLE.EMPTY'], //"Aucune donnée disponible"
                        "sInfo": translation['SITE_GEN.TABLE.INFO_FOLDER'],//" _START_ sur _END_ d'un total de _TOTAL_ données"
                        "sInfoEmpty": translation['SITE_GEN.TABLE.INFO_EMPTY_FOLDER'],//" 0 sur 0 of 0 entries",
                        "sInfoFiltered": translation['SITE_GEN.TABLE.INFO_FILTERED_FOLDER'],//"(filtered from _MAX_ total entries)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ",",
                        "sLengthMenu": translation['SITE_GEN.TABLE.LENGTH_MENU_FOLDER'],//"Show _MENU_ entries",
                        "sLoadingRecords": translation['SITE_GEN.TABLE.LOADING'],//"Loading...",
                        "sProcessing": translation['SITE_GEN.TABLE.PROCESSING'],//"Processing...",
                        "sSearch": translation['SITE_GEN.TABLE.SEARCH'],//"Search:",
                        "sZeroRecords": translation['SITE_GEN.TABLE.ZERO_RECORDS_FOLDER'],//"No matching records found",
                        "oPaginate": {
                            "sFirst": translation['SITE_GEN.TABLE.FIRST'],//"First",
                            "sLast": translation['SITE_GEN.TABLE.LAST'],//"Last",
                            "sNext": translation['SITE_GEN.TABLE.NEXT'], //"Next",
                            "sPrevious": translation['SITE_GEN.TABLE.PREVIOUS'],//"Previous"
                        },
                        "oAria": {
                            "sSortAscending": ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }

                    });

            });
        $scope.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(5).notSortable(),
        ];

        $scope.folders = [];


        $scope.refresh = function () {
            folderService.findByCurrentUser().then((res) => {
                $scope.folders = angular.copy(res.data);
                $scope.loaded = true;
            }).catch(() => {
                toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                $scope.loaded = true;
            });
        };

        $scope.refresh();

        $scope.$on('refreshfolders', () => {
            $scope.loaded = false;
            $scope.refresh();
        });

        $scope.details = function (id) {
            $mdDialog.show({
                templateUrl: 'app/main/sitegen/account/folder/popup/details_folder.html',
                controller: 'detailsFolderController',
                clickOutsideToClose: true,
                locals: {
                    id: id
                }
            }).then(() => { $scope.refresh(); }).catch(() => { });
        };

        $scope.deleteConfirm = function (id) {
            var content = {
                title: $filter('translate')('SITE_GEN.FOLDER.DELETE_POPUP'),
                message: $filter('translate')('SITE_GEN.FOLDER.DELETE_POPUP_CONFIRM')
            };
            $scope.openConfirmPopup(content).then(function () {
                folderService.deleteFolder(id).then((res) => {
                    if (res.data === 'INCORRECT_USER') {
                        toastr.error($filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.INCORRECT_USER'));
                    } else {
                        toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_DELETE'));
                        $scope.refresh();
                    }
                }).catch(function () {
                    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                });
            }).catch(function () {

            });
        };

    }

})();

(function () {
    'use strict';

    angular.module('sitegen.site').service('folderService', folderService);

    function folderService($http, $q) {

        var service = {};
        var BASE_URL_FOLDER = './api/rest/foldersite';

        service.save = function (folder) {
            return $q((resolve, reject) => {
                $http({
                    url: BASE_URL_FOLDER,
                    method: 'POST',
                    params: {
                        '_v': new Date().getTime(),
                    },
                    data: folder
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.findByCurrentUser = function () {
            return $q((resolve, reject) => {
                $http({
                    url: BASE_URL_FOLDER,
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                    },
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.findById = function (id, lang) {
            return $q((resolve, reject) => {
                $http({
                    url: BASE_URL_FOLDER + '/' + id,
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                        lang: lang
                    },
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.findAllExcludeEntityById = function (entityId, type) {
            return $q((resolve, reject) => {
                $http({
                    url: BASE_URL_FOLDER + '/exclude',
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                        entityId: entityId,
                        type: type
                    },
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.addToFolder = function (id, entityId, type) {
            return $q((resolve, reject) => {
                $http({
                    url: BASE_URL_FOLDER + '/add-to-folder',
                    method: 'PUT',
                    params: {
                        '_v': new Date().getTime(),
                        id: id,
                        entityId: entityId,
                        type: type
                    },
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.removeFromFolder = function (id, entityId, type) {
            return $q((resolve, reject) => {
                $http({
                    url: BASE_URL_FOLDER + '/remove-from-folder',
                    method: 'DELETE',
                    params: {
                        '_v': new Date().getTime(),
                        id: id,
                        entityId: entityId,
                        type: type
                    },
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.createFolderAndAddEntity = function (dto, entityId, type) {
            return $q((resolve, reject) => {
                $http({
                    url: BASE_URL_FOLDER + '/create-folder',
                    method: 'POST',
                    params: {
                        '_v': new Date().getTime(),
                        entityId: entityId,
                        type: type
                    },
                    data: dto
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.deleteFolder = function (entityId) {
            return $q((resolve, reject) => {
                $http({
                    url: BASE_URL_FOLDER + '/delete-folder',
                    method: 'DELETE',
                    params: {
                        '_v': new Date().getTime(),
                        id: entityId,
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        return service;

    }
})();
(function () {
    'use strict';

    angular.module('sitegen.site').controller('AddFolderController', AddFolderController);

    function AddFolderController($scope, $filter, toastr, folderService) {
        $scope.folder = {};
        $scope.save = function () {
            folderService.save($scope.folder).then((res) => {
                $scope.folder = {};
                toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_SAVE'));
                $scope.$emit('foldercreated');
            }).catch(() => {
                toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
        };
    }

})();
(function () {
	'use strict';

	angular.module('sitegen.site').controller('AccountHomeController', AccountHomeController);

	function AccountHomeController($scope, $state, $translate, $q, $location,
		$filter, $stateParams, $rootScope, toastr, $window, STORAGE_PREFIX, $timeout, $accountProvider, userService, $currentSite, SiteGenService) {


		$scope.$watch('menuType', () => {

			if ($scope.menuType != 'CREATE_DEMANDE_DEVIS') {
				$scope.requestForProposalTemp = null;
			}
			if ($scope.menuType !== 'MY_RFPS') {
				$rootScope.ccSend = null;
			}
		})


		if ($stateParams && $stateParams.rfp) {
			$scope.menuType = 'MY_RFPS';
		} else {
			$scope.menuType = 'MY_CC';
		}
		userService.getCurrent($translate.preferredLanguage(), false).then(function (response) {
			$scope.user = response.data;
		}).catch(function () {
			toastr.error($filter('translate')('GENERAL.TOASTR.UNAUTHORIZED'))
			$state.go('sitegen.site.login');
		});

		$scope.$watch('menuType', (newValue, oldValue) => {
			if (newValue === 'MY_FOLDERS') {
				$scope.$broadcast('refreshfolders');
			}
		});

		$scope.$on('foldercreated', () => {
			$scope.menuType = 'MY_FOLDERS';
			// $scope.$broadcast('refreshfolders');
		});

		$scope.$on('cahiercreated', () => {
			$scope.menuType = 'MY_CC';
			$scope.$broadcast('refreshCC');
		});

		$scope.$on('rfpcreated', () => {
			$scope.menuType = 'MY_RFPS';
			$scope.$broadcast('refreshRFP');
		});

		$scope.$on('sendCC', (event, data) => {

			$scope.requestForProposalTemp = {
				'selectedCC': data.id
			}
			$scope.menuType = 'CREATE_DEMANDE_DEVIS';


		})
	}
}
)();

(function () {
    'use strict';
  
    angular.module('app.front').controller('MailingTriggerController', MailingTriggerController);
  
    function MailingTriggerController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, $stateParams, MailingService, languageService, 
      modelService, InscriptionsAdminService, eventService, inscriptionFormService) {
          
      $scope.MODELS_TYPES = {
        COMPANY_MODEL: 'COMPANY_MODEL',
        CONTACT_MODEL: 'CONTACT_MODEL',
        INSCRIPTION_MODEL : 'INSCRIPTION_MODEL',
        LOGISTIC_MODEL : 'LOGISTIC_MODEL',
      };
      $scope.pages = [];
      $scope.languages = [];
      $scope.types = [
        { value : "DROPDOWN_TRIGGER" },
        { value : "REGISTRATION_VALIDATED_TRIGGER" }  
      ];

      $scope.fields = {
        contact : [],
        company : [],
        inscription : [],
        logistic : []
      };
  
      $scope.trigger = {};
  
      // UTILS

      // md-select input search
      window.mdSelectOnKeyDownOverride = function (event) {
        event.stopPropagation();
      };
  
      $scope._triggersListFn = function () {
        $state.go('app.mailing_triggers');
      };
  
      // LANGUAGES
      languageService.getLanguages().then(function (response) {
        $scope.languages = response.data;
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });

      // FIELDS
      modelService.listFieldsByType(
        $scope.MODELS_TYPES.CONTACT_MODEL, 
        $translate.preferredLanguage()
      ).then(function (resp) {
        $scope.fields.contact = $filter('filter')(resp.data, function (item) {
          return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
        });     
      }).catch(function (err) {
        console.log(err);
      });

      modelService.listFieldsByType(
        $scope.MODELS_TYPES.COMPANY_MODEL, 
        $translate.preferredLanguage()
      ).then(function (resp) {
        $scope.fields.company = $filter('filter')(resp.data, function (item) {
            return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
        });
      }).catch(function (err) {
        console.log(err);
      });

      modelService.listFieldsByType(
        $scope.MODELS_TYPES.INSCRIPTION_MODEL, 
        $translate.preferredLanguage()
      ).then(function (resp) {
        $scope.fields.inscription = $filter('filter')(resp.data, function (item) {
            return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
        });
      }).catch(function (err) {
        console.log(err);
      });

      modelService.listFieldsByType(
        'LOGISTIC_MODEL', 
        $translate.preferredLanguage()
      ).then(function (resp) {
        $scope.fields.logistic = $filter('filter')(resp.data, function (item) {
            return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
        });
      }).catch(function (err) {
        console.log(err);
      });

      // EVENTS
      eventService.findAll().then(function(response){
				$scope.events = response.data;
			}).catch(function(err){
        console.log(err);
      });

      // TEMPLATES
      MailingService.findAll('pages', null).then(function(response){
        $scope.pages = response.data;
      }).catch(function(error){
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
  
      // ENTRY POINT       
      $scope.initTrigger = function (id, lang) {
        MailingService.find('trigger', id, lang).then(function (response) {
          $scope.trigger = response.data;
          if($scope.trigger && $scope.trigger.type && $scope.trigger.type == 'REGISTRATION_VALIDATED_TRIGGER' 
              && $scope.trigger.event && $scope.trigger.event.id) {
            inscriptionFormService.listByEvent($scope.trigger.event.id, $translate.preferredLanguage()).then(function(response){
              $scope.registrationForms = response.data;
            }).catch(function(err){
              console.log(err);
            });
          }
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      };
  
      // MAJ
      if ($stateParams.id) {    
        $scope.initTrigger($stateParams.id, null);
      }

      // Model type handle
      $scope._modelTypeChangeFn = function() {
        delete $scope.trigger.field;
        delete $scope.trigger.fieldValue;
      };

      // Field handle
      $scope._fieldChangeFn = function() {
        delete $scope.trigger.fieldValue;
      };

      // Trigger type handle
      $scope._triggerTypeChangeFn = function() {
      };

      // Event handle
      $scope.listRegistrationFormsByEvent = function(event) {
        delete $scope.trigger.registrationForm;
        inscriptionFormService.listByEvent(event.id, $translate.preferredLanguage()).then(function(response){
          $scope.registrationForms = response.data;
        }).catch(function(err){
          console.log(err);
        });
      };
  
      // Save
      $scope._save = function (triggerForm) {
        triggerForm.$setSubmitted();
        if (triggerForm.$valid) {
          MailingService.save('trigger', $scope.trigger, null).then(function (response) {
            triggerForm.$setPristine();
            if ($stateParams.id) {
              $scope.initTrigger($stateParams.id, null);
            } else {
              $state.transitionTo('app.mailing_triggers.trigger', { id:response.data.id }, {
                    location: true,
                    inherit: true,
                    relative: $state.$current,
                    notify: false
              });
              $scope.trigger.id = response.data.id;
            }
            toastr.success($filter('translate')('MAILING.DO_MAILING.SUCCESS'));
          }).catch(function (error) {
            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
          });
        } else {
          toastr.error("Vous devez renseigner tous les champs requis avant de valider.");
        }
      };
  
      // Delete
      $scope._delete = function () {
        MailingService.delete('trigger', $scope.trigger.id).then(function (response) {
          $scope._triggersListFn();
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      };
  
    }
  
  })();
  
(function () {
  'use strict';

  angular.module('app.front').controller('MailingPageController', MailingPageController).filter('inscriptionGroupBy', function(){
    return function(items, group){
       return items.filter(function(element, index, array) {
        return element.insriptionFormId==group.insriptionFormId;
       });
    }
  });

  function MailingPageController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, $stateParams, MailingService, languageService,
      MODELS_TYPES, modelService, InscriptionsAdminService, inscriptionFormService) {

    $scope.blocs = [];
    $scope.languages = [];

    $scope.page = {
      htmlHeader : "<head>\n\n</head>",
      pageBlocs: []
    };

    $scope.fields = {
      contact : [],
      company : [],
      inscription : []
    };


    // UTILS

    // md-select input search
    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
    };

    $scope._pagesListFn = function () {
      $state.go('app.mailing_pages');
    };

    $scope._getCleanKey = function (key) {
      var _cleanKey = angular.copy(key);
      return _cleanKey.replace(/[{()}]/g, '');
    };

     $scope.getInscriptionFormGroups = function () {
      var groupArray = [];
      angular.forEach($scope.fields.inscription, function (item, index) {
        var _thisGroupIndex = groupArray.map(function(mapper) {
          return mapper.insriptionFormId;
        }).indexOf(item.insriptionFormId);
        if(_thisGroupIndex == -1) {
          groupArray.push(item);
        };
      });
      return groupArray;
    };


    // LANGUAGES

    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
    }).catch(function (error) {
      toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
    });

    // BLOCKS

    MailingService.findAll('blocs', null).then(function (response) {
      $scope.blocs = response.data;
    }).catch(function (error) {
      toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
    });

    // All model fields : Contact, Company & Inscription

    modelService.listFieldsByType(
      "CONTACT_MODEL",
      $translate.preferredLanguage()
    ).then(function (resp) {
      $scope.fields.contact = $filter('filter')(resp.data, function (item) {
          return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT';
      });
    }).catch(function (err) {
      $scope.initDataInProgress = false;
      console.log(err);
    });

    modelService.listFieldsByType(
      "COMPANY_MODEL",
      $translate.preferredLanguage()
    ).then(function (resp) {
      $scope.fields.company = $filter('filter')(resp.data, function (item) {
          return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT';
      });
    }).catch(function (err) {
      $scope.initDataInProgress = false;
      console.log(err);
    });

    modelService.listFieldsByType(
      "INSCRIPTION_MODEL",
      $translate.preferredLanguage()
    ).then(function (resp) {
      $scope.fields.inscription = $filter('filter')(resp.data, function (item) {
          return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT';
      });
    }).catch(function (err) {
      $scope.initDataInProgress = false;
      console.log(err);
    });

    /*inscriptionFormService.listAllFields(
      $translate.preferredLanguage(), false
    ).then(function (resp) {
      $scope.fields.inscription = $filter('filter')(resp.data, function (item) {
          return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT';
      });
    }).catch(function (err) {
      $scope.initDataInProgress = false;
      console.log(err);
    });*/


    // ENTRY POINT

    $scope.initPage = function (pageId, lang) {
      MailingService.find('page', pageId, lang).then(function (response) {
        $scope.page = response.data;
        angular.forEach($scope.page.pageBlocs, function (item, index) {
          $scope.$watch("page.pageBlocs[" + index + "].bloc", function(newValue, oldValue, scope){
            if(newValue && newValue.id && oldValue && oldValue.id && newValue.id != oldValue.id) {
              $scope.page.pageBlocs[index].html = angular.copy($scope.page.pageBlocs[index].bloc.html);
              $scope.page.pageBlocs[index].pageBlocTranslations = [];
              angular.forEach($scope.page.pageBlocs[index].bloc.keys, function (_item, _index) {
                $scope.page.pageBlocs[index].pageBlocTranslations.push({
                  simpleField: true,
                  key: _item,
                  value: null
                });
              });
              angular.forEach($scope.page.pageBlocs[index].bloc.keys2, function (_item, _index) {
                $scope.page.pageBlocs[index].pageBlocTranslations.push({
                  simpleField: false,
                  key: _item,
                  value: null
                });
              });
            }
          });
        });
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    // MAJ Page
    if ($stateParams.id) {
      $scope.initPage($stateParams.id, $translate.preferredLanguage());
    }

    // Change language
    $scope._changeLanguageFn = function () {
      if ($scope.page.id && $scope.page.language) {
        MailingService.find('page', $scope.page.id, $scope.page.language.key).then(function (response) {
          $scope.page = response.data;
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }
    };

    // Add new block
    $scope._addPageBlocFn = function () {
      if ($scope.blocs && $scope.blocs.length > 0) {

        var newPageBlock = {
          index: $scope.page.pageBlocs.length + 1,
          bloc: angular.copy($scope.blocs[0]),
          pageBlocTranslations: [],
          html: angular.copy($scope.blocs[0].html)
        };

        angular.forEach(newPageBlock.bloc.keys, function (item, index) {
          newPageBlock.pageBlocTranslations.push({
            simpleField: true,
            key: item,
            value: null
          });
        });

        angular.forEach(newPageBlock.bloc.keys2, function (item, index) {
          newPageBlock.pageBlocTranslations.push({
            simpleField: false,
            key: item,
            value: null
          });
        });

        var _pageBlocsLength =  $scope.page.pageBlocs.push(newPageBlock);
        $scope.$watch("page.pageBlocs[" + (_pageBlocsLength - 1) + "].bloc", function(newValue, oldValue, scope){
          if(newValue && newValue.id && oldValue && oldValue.id && newValue.id != oldValue.id) {
            $scope.page.pageBlocs[_pageBlocsLength - 1].html = angular.copy($scope.page.pageBlocs[_pageBlocsLength - 1].bloc.html);
            $scope.page.pageBlocs[_pageBlocsLength - 1].pageBlocTranslations = [];
            angular.forEach($scope.page.pageBlocs[_pageBlocsLength - 1].bloc.keys, function (_item, _index) {
              $scope.page.pageBlocs[_pageBlocsLength - 1].pageBlocTranslations.push({
                simpleField: true,
                key: _item,
                value: null
              });
            });
            angular.forEach($scope.page.pageBlocs[_pageBlocsLength - 1].bloc.keys2, function (_item, _index) {
              $scope.page.pageBlocs[_pageBlocsLength - 1].pageBlocTranslations.push({
                simpleField: false,
                key: _item,
                value: null
              });
            });
          }
        });

      }
    };

    // Remove a block
    $scope._removePageBlocFn = function (id) {
      for (var i = 0; i < $scope.page.pageBlocs.length; i++) {
        if ($scope.page.pageBlocs[i].id === id) {
          $scope.page.pageBlocs.splice(i, 1);
          break;
        }
      }
    };

    // Change block
    $scope._changePageBlocFn = function (pageBloc) {
      console.log("change");
      // TODO - Correct block chang : Get page blocks from server by page, block and language
      pageBloc.html = angular.copy(pageBloc.bloc.html);
      pageBloc.pageBlocTranslations = [];
      console.log(pageBloc);
      angular.forEach(pageBloc.bloc.keys, function (item, index) {
        pageBloc.pageBlocTranslations.push({
          simpleField: true,
          key: item,
          value: null
        });
      });
      angular.forEach(pageBloc.bloc.keys2, function (item, index) {
        pageBloc.pageBlocTranslations.push({
          simpleField: false,
          key: item,
          value: null
        });
      });
    };

    // Save page
    $scope._save = function (pageForm) {
      pageForm.$setSubmitted();
      if (pageForm.$valid) {
        MailingService.save('page', $scope.page, null).then(function (response) {
          pageForm.$setPristine();
          if ($stateParams.id) {
            $scope.initPage($stateParams.id, $scope.page.language.key);
          } else {
            $state.transitionTo('app.mailing_pages.page', { id:response.data.id }, {
							location: true,
							inherit: true,
							relative: $state.$current,
							notify: false
            });
            $scope.page = response.data
            angular.forEach($scope.page.pageBlocs, function (item, index) {
              $scope.$watch("page.pageBlocs[" + index + "].bloc", function(newValue, oldValue, scope){
                if(newValue && newValue.id && oldValue && oldValue.id && newValue.id != oldValue.id) {
                  $scope.page.pageBlocs[index].html = angular.copy($scope.page.pageBlocs[index].bloc.html);
                  $scope.page.pageBlocs[index].pageBlocTranslations = [];
                  angular.forEach($scope.page.pageBlocs[index].bloc.keys, function (_item, _index) {
                    $scope.page.pageBlocs[index].pageBlocTranslations.push({
                      simpleField: true,
                      key: _item,
                      value: null
                    });
                  });
                  angular.forEach($scope.page.pageBlocs[index].bloc.keys2, function (_item, _index) {
                    $scope.page.pageBlocs[index].pageBlocTranslations.push({
                      simpleField: false,
                      key: _item,
                      value: null
                    });
                  });
                }
              });
            });
          }
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      } else {
        toastr.error("Vous devez renseigner tous les champs requis avant de valider.");
      }
    };

    // Delete page
    $scope._delete = function () {
      MailingService.delete('page', $scope.page.id).then(function (response) {
        $scope._pagesListFn();
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.showHtml = function (bloc) {
      bloc.showHtml = !bloc.showHtml;
    };

    $scope.moveBloc = function (bloc, up) {
      if (bloc.index != null && $scope.page.id != null) {
        MailingService.moveBloc($scope.page.id, bloc.index, up, $scope.page.language.key).then(function (res) {
          $scope.page = res.data;
        }).catch(function (err) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
          console.log(err);
        });
      } else {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      }
    };

  }

})();

(function () {
    'use strict';

    angular.module('app.front').controller('MailingBlocController', MailingBlocController);

    function MailingBlocController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, $stateParams, $templateRequest, $sce, MailingService) {

        $scope.bloc = {};

        $scope.types = MailingService.getBlocTypes();

        if($stateParams.id) {
          MailingService.find('bloc', $stateParams.id, null).then(function(response){
            $scope.bloc = response.data;
			    }).catch(function(error){
				    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
          });   
        }

        $scope._blocsListFn = function() {
          $state.go('app.mailing_blocs');
        };

        $scope.getBloc = function(){
          if ($scope.bloc && $scope.bloc.type) {
            
            var templateUrl = null;
            if ($scope.bloc.type === 'TEST') {
              templateUrl = $sce.getTrustedResourceUrl('app/main/mailing/blocs/bloc/templates/test.template.type.html');
            }

            if (templateUrl != null) {
              $templateRequest(templateUrl).then(function (template) {
                $scope.bloc.html = template;
              }, function () {
                console.log('Error template type reading !!');
              });
            } else {
              $scope.bloc.html = '';
            }

          }
        };

        $scope._save = function(blocForm) {
          blocForm.$setSubmitted();
  			  if (blocForm.$valid) {
            MailingService.save('bloc', $scope.bloc, null).then(function(response){
              blocForm.$setPristine();
              $scope._blocsListFn();
            }).catch(function(error){
              toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
          }
        };

        $scope._delete = function() {
          MailingService.delete('bloc', $scope.bloc.id).then(function(response){
				    $scope._blocsListFn();
			    }).catch(function(error){
				    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			    });
        };

    }
    
})();
(function () {
    'use strict';

    angular.module('app.front').controller('InscriptionsAdminSettingsController', InscriptionsAdminSettingsController);

    function InscriptionsAdminSettingsController($rootScope, $scope, $timeout, $filter, $state, $translate, $mdDialog, $element, toastr, MODELS_TYPES, modelService, 
        InscriptionsAdminService) {

    }
    
})();
(function () {
  'use strict';

  angular.module('app.front').controller('statsClicksController', statsClicksController);

  function statsClicksController($rootScope, $scope, $filter, $translate, $mdSelect, toastr, $state, companyService) {
    var now = new Date();
    $scope.filter = {
      date: angular.copy(now),
      dateCustom: angular.copy(now),
      month: null,
      year: null
    };
    $scope.periodModes = [];
    $scope.periodMode = {
      value: null
    };
    $scope.monthNames = [];
    $scope.yearValues = [];
    $scope.customYear = {
      value: null
    };
    $scope.statistics = {};
    var companyID = $state.params.id;

    initPeriodModes();
    initMonthAndYears();

    $scope.searchStatisticsCustomYear = function () {
      var customYear;
      var period;

      if (validateYearFormat($scope.customYear.value)) {
        $scope.filter.year = 'custom';
        $mdSelect.hide();
      } else {
        toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
      }
    };

    $scope.getStatistics = function () {
      var begin = null;
      var end = null;
      var momentVar = null;

      switch ($scope.periodMode.value) {
        case 'day':
          {
            momentVar = moment($scope.filter.date);

            momentVar.set({
              'hour': 0,
              'minute': 0,
              'second': 0,
              'millisecond': 0
            });
            begin = momentVar.valueOf();

            momentVar.add(1, 'days');
            end = momentVar.valueOf();

            break;
          }
        case 'month':
          {
            momentVar = moment(now);

            momentVar.set({
              'date': 1,
              'hour': 0,
              'minute': 0,
              'second': 0,
              'millisecond': 0
            });

            momentVar.month($scope.filter.month);
            if ($scope.filter.year === 'custom') {
              momentVar.year($scope.customYear);
            } else {
              momentVar.year($scope.filter.year);
            }

            begin = momentVar.valueOf();

            momentVar.add(1, 'months');
            end = momentVar.valueOf();

            break;
          }
        case 'year':
          {
            momentVar = moment(now);

            momentVar.set({
              'month': 0,
              'date': 1,
              'hour': 0,
              'minute': 0,
              'second': 0,
              'millisecond': 0
            });

            if ($scope.filter.year === 'custom') {
              momentVar.year($scope.customYear);
            } else {
              momentVar.year($scope.filter.year);
            }

            begin = momentVar.valueOf();

            momentVar.add(1, 'years');
            end = momentVar.valueOf();

            break;
          }
        case 'custom':
          {
            momentVar = moment($scope.filter.date);

            momentVar.set({
              'hour': 0,
              'minute': 0,
              'second': 0,
              'millisecond': 0
            });
            begin = momentVar.valueOf();

            momentVar = moment($scope.filter.dateCustom);
            momentVar.add(1, 'days');

            momentVar.set({
              'hour': 0,
              'minute': 0,
              'second': 0,
              'millisecond': 0
            });

            end = momentVar.valueOf();

            if (end < begin) {
              toastr.error($filter('translate')('STATS_CLICKS.TOAST_INVALD_DATES'));
            }

            break;
          }
      }

      var postDTO;

      if (begin && end) {
        postDTO = {
          beginDate: begin,
          endDate: end,
          companyID: companyID
        };
      } else {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        return;
      }

      companyService.findStatsClickByCompanyIDAndDates(postDTO).then(function (res) {
        if (res.data) {
          $scope.statistics = res.data;
        }

        console.log(res.data);
      }).catch(function (err) {
        console.log(err);
      });
    };

    //Init range years and months
    function initMonthAndYears() {
      for (var i = 0; i < 12; i++) {
        $scope.monthNames.push({
          value: i,
          name: $filter('translate')('GENERAL.MONTH_NAMES.' + i)
        });
      }

      var yearNow = now.getFullYear();

      for (var i = -3; i <= 3; i++) {
        $scope.yearValues.push(yearNow + i);
      }
    }

    function initPeriodModes() {
      $scope.periodModes = [{
          name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.DAY'),
          value: 'day'
        },
        {
          name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.MONTH'),
          value: 'month'
        },
        {
          name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.YEAR'),
          value: 'year'
        },
        {
          name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.CUSTOM'),
          value: 'custom'
        }
      ];
      $scope.periodMode.value = 'day';

      $rootScope.$on('$translateChangeSuccess', function () {
        console.log('tra,slaye');
        $scope.periodModes = [{
            name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.DAY'),
            value: 'day'
          },
          {
            name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.MONTH'),
            value: 'month'
          },
          {
            name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.YEAR'),
            value: 'year'
          },
          {
            name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.CUSTOM'),
            value: 'custom'
          }
        ];
        $scope.periodMode.value = $filter('translate')('STATS_CLICKS.PERIOD_MODES.DAY');
      });
    }

    function validateYearFormat(year) {
      if (year >= (now.getFullYear() - 100) && year <= (now.getFullYear() + 100)) {
        return true;
      }

      return false;
    }

    //For iput select year
    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
    };
  }
})();

(function () {
    'use strict';
 
    angular.module('app.front').service('researchEngineSortService', researchEngineSortService);
 
    function researchEngineSortService($http, $q, $filter) {
 
        var service = {};
        
        // Fixe fields
        var fieldSorts = [{
                fieldSortIndex: 999,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'ASC',
                fixeFieldSqlKey: 'creationdate',
                fixeFieldSortKeyLang: 'CREATION_DATE',
                libelle: 'COMPANIES.COMPANY_SORT.CREATION_DATE',
            },
            {
                fieldSortIndex: 1000,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'DESC',
                fixeFieldSqlKey: 'creationdate',
                fixeFieldSortKeyLang: 'CREATION_DATE',
                libelle: 'COMPANIES.COMPANY_SORT.CREATION_DATE',
            },
            {
                fieldSortIndex: 1001,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'ASC',
                fixeFieldSqlKey: 'updatedate',
                fixeFieldSortKeyLang: 'MODIFICATION_DATE',
                libelle: 'COMPANIES.COMPANY_SORT.MODIFICATION_DATE',
            },
            {
                fieldSortIndex: 1002,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'DESC',
                fixeFieldSqlKey: 'updatedate',
                fixeFieldSortKeyLang: 'MODIFICATION_DATE',
                libelle: 'COMPANIES.COMPANY_SORT.MODIFICATION_DATE',
            },
            {
                fieldSortIndex: 1003,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'ASC',
                fixeFieldSqlKey: 'activated',
                fixeFieldSortKeyLang: 'ENABLE',
                libelle: 'COMPANIES.COMPANY_SORT.ENABLE',
                searchEngineOwner : 'COMPANY_MODEL'
            },
            {
                fieldSortIndex: 1004,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'DESC',
                fixeFieldSqlKey: 'activated',
                fixeFieldSortKeyLang: 'ENABLE',
                libelle: 'COMPANIES.COMPANY_SORT.ENABLE',
                searchEngineOwner : 'COMPANY_MODEL'
            },
            {
                fieldSortIndex: 1005,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'ASC',
                fixeFieldSqlKey: 'activated',
                fixeFieldSortKeyLang: 'DISABLE',
                libelle: 'COMPANIES.COMPANY_SORT.DISABLE',
                searchEngineOwner : 'COMPANY_MODEL'
            },
            {
                fieldSortIndex: 1006,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'DESC',
                fixeFieldSqlKey: 'activated',
                fixeFieldSortKeyLang: 'DISABLE',
                libelle: 'COMPANIES.COMPANY_SORT.DISABLE',
                searchEngineOwner : 'COMPANY_MODEL'
            }
        ];

        var modelSorts = {
            sorts: []
        };

        service.init = function(modelType) {
            modelSorts = { sorts: [] };
            var _thisFieldSorts = $filter('filter')(fieldSorts, function (_sort) {
                return !_sort.searchEngineOwner || (_sort.searchEngineOwner && _sort.searchEngineOwner == modelType)
            });
            var modelSort = {
                fieldSorts: _thisFieldSorts,
                fieldSortSelected: null
            };
            modelSorts.sorts.push(angular.copy(modelSort));
            modelSorts.sorts.push(angular.copy(modelSort));
            return modelSorts;
        };

        service.setSort = function(_modelSorts) {
            modelSorts = _modelSorts;
        };
   
        service.getSort = function() {
            return modelSorts;
        };
 
        return service;
 
    }
 
 })(); 
(function() {

    'use strict';

    angular.module('app.front').directive('researchEngineSort', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {

        return {
            restrict: 'E',
            controller: 'researchEngineSortController',
            controllerAs: 'researchEngineSortController',
            templateUrl: 'app/main/globe_network/companies/sort/sort.html',
            scope: {
                modelType: '@',
                subTypeId: '=',
                onSort: '&'
            }
        };

    }]);

})();

(function(){
    'use strict';

    angular.module('app.front').controller('researchEngineSortController', researchEngineSortController);

    function researchEngineSortController($rootScope, $scope, $state, $translate, $mdDialog, $timeout, $filter, toastr, 
        companyService, modelService, ResearchPageCreationService, researchEngineSortService) {
        
        // Init sort list

        $scope.modelSortsDto = angular.copy(researchEngineSortService.init($scope.modelType));

        ResearchPageCreationService.findSort($scope.modelType, $scope.subTypeId, $translate.preferredLanguage()).then(function (resp) {
            angular.forEach($scope.modelSortsDto.sorts, function(_sort) {
                _sort.fieldSorts = _sort.fieldSorts.concat(resp.data.fieldSorts);
            });
        }).catch(function (error) {
            console.log(error);
        });

        // Sort function

        $scope.sortModelFn = function() {
            $scope.onSort({ sort : $scope.modelSortsDto } );
        };
       
    }

})();
(function () {
  'use strict';

  angular.module('app.front').controller('companyLogsController', companyLogsController);

  function companyLogsController($rootScope, $scope, LOGS_ACTIONS, adminService, $state, $translate, $mdDialog, $timeout, $filter, toastr, companyService, modelService, researchEngineFilterService, researchEngineSortService, MODELS_TYPES) {
    $scope.logs = [];
    $scope.ACTIONS = LOGS_ACTIONS;
    $scope.allLoaded = false;

    var companyID = $state.params.id;
    var filter = {
      page: 0,
      output: 100
    };

    $scope.getLogs = function () {
      adminService.getByCompanyID(companyID, filter).then(function (res) {
        if (res.data) {
          $scope.logs = $scope.logs.concat(res.data);
        }
        if (res.data.length < 100) {
          $scope.allLoaded = true;
        } else {
          filter.page++;
        }
        console.log(res.data);
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.getLogs();

  }
})();

(function () {
  'use strict';

  angular.module('app.front').service('researchEngineFilterService', researchEngineFilterService);

  function researchEngineFilterService($http, $q, $filter) {

     var service = {};

     var modelFilters = { filters : [] };

     // Custom model field filter
     var customModelFieldFilter = [
       {
         customModelFieldFilter : true,
         fieldFilterBaseType: "MODEL_FIELD",
         fieldFilterIndex : -5, 
         fieldFilterSize: 25,
         modelFieldFilterKeyLang : 'MODEL_FIELD_KEYWORD',
         modelFieldFilterKeyLangForTanslate : 'MODEL_FIELD_KEYWORD',
         includeInFilter : true,
         typeChamps : 'STRING',
         fixedFieldFilter : {}
       }
     ];

     // Custom fixe field filter
     var customFixeFieldFilter = [
       {
         customFixeFieldFilter : true,
         fieldFilterBaseType: "FIXE_FIELD",
         fieldFilterIndex : -4, 
         fieldFilterSize: 25,
         fixeFieldFilterKeyLang : 'FIXE_FIELD_CREATION_DATE', 
         fixeFieldFilterKeyLangForTranslate : 'FIXE_FIELD_CREATION_DATE_COMPANY', 
         includeInFilter : true,
         typeChamps : 'DATE',
         fixedFieldFilter : {},
         searchEngineOwner : 'COMPANY_MODEL'
       },{
         customFixeFieldFilter : true,
         fieldFilterBaseType: "FIXE_FIELD",
         fieldFilterIndex : -3, 
         fieldFilterSize: 25,
         fixeFieldFilterKeyLang : 'FIXE_FIELD_MODIFICATION_DATE', 
         fixeFieldFilterKeyLangForTranslate : 'FIXE_FIELD_MODIFICATION_DATE_COMPANY', 
         includeInFilter : true,
         typeChamps : 'DATE',
         fixedFieldFilter : {},
         searchEngineOwner : 'COMPANY_MODEL'
       },{
         customFixeFieldFilter : true,
         fieldFilterBaseType: "FIXE_FIELD",
         fieldFilterIndex : -2, 
         fieldFilterSize: 25,
         fixeFieldFilterKeyLang : 'FIXE_FIELD_CREATION_DATE_CONTACT', 
         fixeFieldFilterKeyLangForTranslate : 'FIXE_FIELD_CREATION_DATE_CONTACT', 
         includeInFilter : true,
         typeChamps : 'DATE',
         fixedFieldFilter : {},
         searchEngineOwner : 'COMPANY_MODEL'
       },{
         customFixeFieldFilter : true,
         fieldFilterBaseType: "FIXE_FIELD",
         fieldFilterIndex : -1, 
         fieldFilterSize: 25,
         fixeFieldFilterKeyLang : 'FIXE_FIELD_MODIFICATION_DATE_CONTACT', 
         fixeFieldFilterKeyLangForTranslate : 'FIXE_FIELD_MODIFICATION_DATE_CONTACT', 
         includeInFilter : true,
         typeChamps : 'DATE',
         fixedFieldFilter : {},
         searchEngineOwner : 'COMPANY_MODEL'
       },{
         customFixeFieldFilter : true,
         fieldFilterBaseType: "FIXE_FIELD",
         fieldFilterIndex : -4, 
         fieldFilterSize: 25,
         fixeFieldFilterKeyLang : 'FIXE_FIELD_CREATION_DATE', 
         fixeFieldFilterKeyLangForTranslate : 'FIXE_FIELD_CREATION_DATE_INSCRIPTION', 
         includeInFilter : true,
         typeChamps : 'DATE',
         fixedFieldFilter : {},
         searchEngineOwner : 'INSCRIPTION_MODEL'
       },{
         customFixeFieldFilter : true,
         fieldFilterBaseType: "FIXE_FIELD",
         fieldFilterIndex : -3, 
         fieldFilterSize: 25,
         fixeFieldFilterKeyLang : 'FIXE_FIELD_MODIFICATION_DATE', 
         fixeFieldFilterKeyLangForTranslate : 'FIXE_FIELD_MODIFICATION_DATE_INSCRIPTION', 
         includeInFilter : true,
         typeChamps : 'DATE',
         fixedFieldFilter : {},
         searchEngineOwner : 'INSCRIPTION_MODEL'
       }
     ];

     service.init = function() {
        modelFilters = { filters : [] };
     };

     service.getCustomModelFieldFilterFn = function(modelType) {
        return $filter('filter')(customModelFieldFilter, function (_filter) {
          return !_filter.searchEngineOwner || (_filter.searchEngineOwner && _filter.searchEngineOwner == modelType)
        });
     };

     service.getCustomFixeFieldFilterFn = function(modelType) {
        return $filter('filter')(customFixeFieldFilter, function (_filter) {
          return !_filter.searchEngineOwner || (_filter.searchEngineOwner && _filter.searchEngineOwner == modelType)
        });
     };

     service.setFilter = function(_filters) {
        modelFilters.filters = _filters;
     };

     service.getFilter = function() {
        return modelFilters;
     };

     return service;

  }

})();

(function() {

    'use strict';

    angular.module('app.front').directive('researchEngineFilter', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {

        return {
            restrict: 'E',
            controller: 'researchEngineFilterController',
            controllerAs: 'researchEngineFilterController',
            templateUrl: 'app/main/globe_network/companies/filter/filter.html',
            scope: {
                modelType: '@',
                subTypeId: '=',
                onFilter: '&'
            }
        };

    }]);

})();

(function(){
    'use strict';

    angular.module('app.front').controller('researchEngineFilterController', researchEngineFilterController);

    function researchEngineFilterController($rootScope, $scope, $state, $translate, $mdDialog, $timeout, $filter, toastr, 
        companyService, modelService, ResearchPageCreationService, researchEngineFilterService) {
            
        window.mdSelectOnKeyDownOverride = function (event) {
            event.stopPropagation();
        };

        researchEngineFilterService.init();
        $scope.arrayFilters = [];
        $scope.actualFilter = {};

        ResearchPageCreationService.findFilter($scope.modelType, $scope.subTypeId, $translate.preferredLanguage()).then(function (resp) {

            $scope.actualFilter = resp.data;

            // Custom model field for filter
            angular.forEach(researchEngineFilterService.getCustomModelFieldFilterFn($scope.modelType), function(item, index) {
                $scope.actualFilter.fieldFilters.push(angular.copy(item));
            });
            
            // Custom fixe field for filter
            angular.forEach(researchEngineFilterService.getCustomFixeFieldFilterFn($scope.modelType), function(item, index) {
                $scope.actualFilter.fieldFilters.push(angular.copy(item));
            });

            // Fixe field libelle translation
            angular.forEach($scope.actualFilter.fieldFilters, function(item, index) {
                var _fixeFieldLibelle = null;
                if(item.fixeFieldFilterClazz == 'CompanyDisposition') {
                    _fixeFieldLibelle = 'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.' + item.fixeFieldFilterKeyLang;
                } else if(item.fieldFilterBaseType == "FIXE_FIELD" && !item.customFixeFieldFilter) {
                    _fixeFieldLibelle = 'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.' + item.fixeFieldFilterKeyLang;
                } else if(item.fieldFilterBaseType == "FIXE_FIELD" && item.customFixeFieldFilter) {
                    _fixeFieldLibelle = 'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.' + item.fixeFieldFilterKeyLangForTranslate;
                    item.fieldFilterIndex += 1000;
                } else if(item.fieldFilterBaseType == "MODEL_FIELD" && item.customModelFieldFilter) {
                    _fixeFieldLibelle = 'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.' + item.modelFieldFilterKeyLangForTanslate;
                } else if(item.fieldFilterBaseType == "MODEL_FIELD") {
                    item.libellePrefix = 'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.INPUT_PLACEHOLDER_PREFIX.' + item.modelType
                }
                if(_fixeFieldLibelle != null) {
                    item.libelle = angular.copy($filter('translate')(_fixeFieldLibelle));
                }
            });

            $scope.arrayFilters.push(angular.copy($scope.actualFilter));
            researchEngineFilterService.setFilter(angular.copy($scope.arrayFilters));

        }).catch(function (error) {
            console.log(error);
        });


        // Expand search
        $scope.expandSearchFn = function() {
            $scope.arrayFilters.push(angular.copy($scope.actualFilter));  
        };

        // Remove filter
        $scope.removeFilterFn = function($index) {
            $scope.arrayFilters.splice($index, 1);
        };

        // Filtre functions

        $scope.filterModelFn = function() {
            var modelFilters = { filters : [] };
            modelFilters.filters = angular.copy($scope.arrayFilters);
            $scope.onFilter({ filter : modelFilters } );
        };

        $scope.changeDate = function(filter) {
            if (filter != null && filter.dateTime != null){
                filter.criteria = $filter('date')(filter.dateTime, 'dd/MM/yyyy');
            }
        };

        $scope.changeDateRangeMin = function(filter, format) {
            if (filter != null && filter.fixedFieldFilter != null) {
                var _date = angular.copy(filter.minValue);
                _date.setHours(0, 1, 0, 0);
                if(format) {
                    filter.fixedFieldFilter.minValue = $filter('date')(_date, format);
                } else {
                    filter.fixedFieldFilter.minValue = angular.copy(_date.getTime());
                }
            }
        };

        $scope.changeDateRangeMax = function(filter, format) {
            if (filter != null && filter.fixedFieldFilter != null) {
                var _date = angular.copy(filter.maxValue);
                _date.setHours(23, 59, 0, 0);
                if(format) {
                    filter.fixedFieldFilter.maxValue = $filter('date')(_date, 'dd/MM/yyyy');
                } else {
                    filter.fixedFieldFilter.maxValue = angular.copy(_date.getTime());
                }
            }
        };
       
    }

})();
(function(){
	'use strict';

	angular.module('app.front').controller('DuplicationToolModalController', DuplicationToolModalController);

	function DuplicationToolModalController($rootScope, $scope, $mdDialog, $state, $filter, $translate, dtToolData, toastr, modelService, MODELS_TYPES){
        
        $scope.MODELS_TYPES = MODELS_TYPES;
        $scope.initDataInProgress = false;

        if (dtToolData != null && dtToolData._modelType != null){
			$scope._dtToolData = angular.copy(dtToolData);
            $scope._dtToolData._fields = [{}, {}];
            $scope.initDataInProgress = true;
            if($scope._dtToolData._modelType == MODELS_TYPES.COMPANY_MODEL && $scope._dtToolData._modelSubTypeId != null) {
                modelService.listFieldsBySubType(
                    MODELS_TYPES.COMPANY_MODEL, 
                    $scope._dtToolData._modelSubTypeId,
                    $translate.preferredLanguage()
                ).then(function (resp) {
                    $scope.fields = $filter('filter')(resp.data, function (item) {
                        return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
                    });
                    $scope.initDataInProgress = false;
                }).catch(function (err) {
                    $scope.initDataInProgress = false;
                    console.log(err)
                });
            } else if ($scope._dtToolData._modelType == MODELS_TYPES.CONTACT_MODEL) {
                modelService.listFieldsByType(
                    MODELS_TYPES.CONTACT_MODEL, 
                    $translate.preferredLanguage()
                ).then(function (resp) {
                    $scope.fields = $filter('filter')(resp.data, function (item) {
                        return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
                    });
                    $scope.initDataInProgress = false;
                }).catch(function (err) {
                    $scope.initDataInProgress = false;
                    console.log(err);
                });
            }
		}

        // md-select input search
        window.mdSelectOnKeyDownOverride = function (event) {
            event.stopPropagation();
        };

        $scope.hidePopup = function(){
			$mdDialog.cancel();
		};

        $scope._lookForDuplicates = function (_form) {
            _form.$setSubmitted();
            if (_form.$valid) {
                var _fields = $scope._dtToolData._fields.filter(function(_field){
                    return _field.id != null
                });
                $state.go('app.duplication_tool', { 
                    _modelType: $scope._dtToolData._modelType,
                    _modelSubTypeId: $scope._dtToolData._modelSubTypeId,
                    _companyId: $scope._dtToolData._companyId,
                    _fields : _fields
                });
                 $scope.hidePopup();
            }
        };
		
	}

})();
(function(){
	'use strict';

	angular.module('app.front').controller('logisticController', logisticController);

	function logisticController($rootScope, $scope, $state, $filter, $translate, $window, toastr, logisticService, inscriptionStatusService, inscriptionService, inscriptionSubCategoryService, logisticalStatusService, URL, DISPLAY_MODELS_ICONS){

		$scope.generalInfosShowed = true;
		$scope.transportPlansShowed = true;
		$scope.alternatedocroots = URL.alternatedocroots;
		$scope.logistic = {};

		$scope.iconsDisplay = {};
		angular.forEach(DISPLAY_MODELS_ICONS, function (elt) {
			$scope.iconsDisplay[elt.name] = elt.value;
		});


		logisticService.get($state.params.logisticId).then(function(response){
			$scope.categories = angular.copy(response.data.categories);
			$scope.logistic = response.data;
			angular.forEach($scope.logistic.transportPlans, function(item, key){
				$scope.logistic.transportPlans[key] = buildTransportPlan(item);
			});
		}).catch(function(){

		});

		$scope.modelType = 'LOGISTIC_MODEL';

		inscriptionStatusService.list($translate.preferredLanguage()).then(function(response){
			$scope.inscriptionStatuses = response.data;
		}).catch(function(){

		});

		logisticalStatusService.list($translate.preferredLanguage()).then(function(response){
			$scope.logisticStatus = response.data;
		}).catch(function(){

		});

		inscriptionSubCategoryService.list($translate.preferredLanguage()).then(function(response){
			$scope.subCategories = response.data;
		}).catch(function(){

		});

		$scope.addTransportPlan = function(){
			$scope.transportPlansShowed = true;
			logisticService.addTransport($scope.logistic.id).then(function(response){
				$scope.logistic.transportPlans.push(response.data);
			}).catch(function(){

			});
		};

		$scope.updateTransportPlan = function(plan){
			var dto = angular.copy(plan);
			if (plan._arrivalDate != null){
				dto.arrivalDate = $filter('date')(plan._arrivalDate, 'yyyy-MM-dd');
			}
			if (plan._arrivalTime != null){
				dto.arrivalTime = $filter('date')(plan._arrivalTime, 'HH:mm');
			}
			if (plan._departureDate != null){
				dto.departureDate = $filter('date')(plan._departureDate, 'yyyy-MM-dd');
			}
			if (plan._departureTime != null){
				dto.departureTime = $filter('date')(plan._departureTime, 'HH:mm');
			}
			logisticService.updateTransport($scope.logistic.id, dto).then(function(response){

			}).catch(function(){

			});
		};


		$scope.uploadTicket = function(plan){
			var fmData = new FormData();
			var input = document.getElementById('ticket_' + plan.id);
			if (input != null && input.files != null){
				fmData.append('file', input.files[0]);
				logisticService.uploadTicket($scope.logistic.id, plan.id, fmData).then(function(response){
					for (var i = 0; i < $scope.logistic.transportPlans.length; i++){
						if ($scope.logistic.transportPlans[i].id === plan.id){
							$scope.logistic.transportPlans[i] = buildTransportPlan(response.data);
							break;
						}
					}
				}).catch(function(){

				});
			}
		};

		$scope.downloadTicket = function(planId){
			$window.open(logisticService.downloadTicket($scope.logistic.id, planId));
		};

		$scope.deleteTransportPlan = function(planId){
			logisticService.removeTransport($scope.logistic.id, planId).then(function(response){
				for (var i = 0; i < $scope.logistic.transportPlans.length; i++){
					if ($scope.logistic.transportPlans[i].id === planId){
						$scope.logistic.transportPlans.splice(i, 1);
						break;
					}
				}
			}).catch(function(){

			});
		};

		$scope.openDeleteTransportPlan = function(planId){
			var content = {
				title: $filter('translate')('LOGISTIC.DELETE_PLAN'),
				message: $filter('translate')('LOGISTIC.DELETE_PLAN_MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				$scope.deleteTransportPlan(planId);
			}).catch(function(){

			});
		};

		$scope.deleteTicket = function(planId){
			logisticService.removeTicket($scope.logistic.id, planId).then(function(response){
				for (var i = 0; i < $scope.logistic.transportPlans.length; i++){
					if ($scope.logistic.transportPlans[i].id === planId){
						$scope.logistic.transportPlans[i].ticketLocation = null;
						$scope.logistic.transportPlans[i].ticketOriginalName = null;
						break;
					}
				}
			}).catch(function(){

			});
		};

		$scope.openDeleteTicket = function(planId){
			var content = {
				title: $filter('translate')('LOGISTIC.DELETE_TICKET'),
				message: $filter('translate')('LOGISTIC.DELETE_TICKET_MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				$scope.deleteTicket(planId);
			}).catch(function(){

			});
		};

		
		

		/* LIVE UPDATE */
		$scope.$on('modelUpdated', function (event, args) {
			if (args != null && args.model != null){
				logisticService.updateField($scope.logistic.id, args.model).then(function (response) {
					// $scope.listSubscriptions();
					//refreshModelContact();
				}).catch(function (error) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					console.log(error);
				});
			}
		});
		$scope.changeInscriptionStatus = function(){
			inscriptionService.updateInscriptionStatus($scope.logistic.inscription.id, $scope.logistic.inscription.inscriptionStatus.id).then(function(response){

			}).catch(function(){

			});
		};
		$scope.changeSubCategory = function(){
			inscriptionService.updateSubCategory($scope.logistic.inscription.id, $scope.logistic.inscription.subCategory.id).then(function(response){

			}).catch(function(){

			});
		};

		$scope.changeLogisticStatus = function(){
			if ($scope.logistic.status != null){
				logisticService.updateStatus($scope.logistic.id, $scope.logistic.status.id).then(function(){
	
				}).catch(function(){
	
				});
			}
		};

		function buildTransportPlan(plan){
			var item = angular.copy(plan);
			if (item.departureDate != null){
				item._departureDate = new Date(item.departureDate.year, item.departureDate.month - 1, item.departureDate.day);
			}
			if (item.arrivalDate != null){
				item._arrivalDate = new Date(item.departureDate.year, item.departureDate.month - 1, item.departureDate.day);
			}
			if (item.departureTime != null){
				item._departureTime = new Date(1970, 0, 1, item.departureTime.hour, item.departureTime.minute);
			}
			if (item.arrivalTime != null){
				item._arrivalTime = new Date(1970, 0, 1, item.arrivalTime.hour, item.arrivalTime.minute);
			}
			return item;
		}
	}
})();
(function () {
	'use strict';

	angular.module('app.front').service('contactService', contactService);

	function contactService($q, $http, $filter, $rootScope) {

		var BASE_URL_CONTACT = './api/rest/contact/';
		var FIRST_CATEGORY_INDEX = 1;

		var categories = null;
		var selectedModel = null;

		var service = {};

		service.buildModel = function (categories, contact) {
			$rootScope.buildingModel = true;
			var firstCategory = findFirstCategory(categories);
			for (var i = 0; i < firstCategory.values.length; i++) {
				var field = firstCategory.values[i];
				if (field.fixField) {
					if ((field.selectableObject == null || field.selectableObject.length < 1)) {
						field.value = contact[field.keyJava];
					} else {
						if (field.typeChamps === 'OBJECT') {
							field.value = setSelectedObject(field, contact);
						} else {
							field.value = setSelectedMultipleObject(field, contact);
						}
					}
				}
			}
			angular.forEach(categories, function (category, key) {
				for (var i = 0; i < category.values.length; i++) {
					var field = category.values[i];
					if (field.typeChamps === 'LIST_SELECT') {
						field.value = setSelectedList(field);
					} else if (field.typeChamps === 'DATE'){
						if (field.value != null && field.value !== ''){
							field.dateTime = $filter('stringToDate')(field.value);
						}
					} else if (field.typeChamps === 'BOOLEAN') {
						field.value = 'true' === field.value;
					}
				}
				angular.forEach(category.subCategories, function (category, key) {
					for (var i = 0; i < category.values.length; i++) {
						var field = category.values[i];
						if (field.typeChamps === 'LIST_SELECT') {
							field.value = setSelectedList(field);
						} else if (field.typeChamps === 'DATE') {
							if (field.value != null && field.value !== '') {
								field.dateTime = $filter('stringToDate')(field.value);
							}
						} else if (field.typeChamps === 'BOOLEAN') {
							field.value = 'true' === field.value;
						}
					}
				});
			});
			$rootScope.buildingModel = false;
			return categories;
		};

		/** Details */

		service.getSelectedModel = function (modelId, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + modelId,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					}
				}).then(function (response) {
					categories = null;
					selectedModel = response.data;
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.listContacts = function (companyId, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + 'company/' + companyId,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.listContactsDisplay = function (companyId, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + 'company/display/' + companyId,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.listContactsHidden = function (companyId, subTypeId, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: BASE_URL_CONTACT + 'company/display/' + companyId,
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang': lang,
            'showHidden' : true
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

		service.getCategories = function (lang, modelId) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + 'categories/',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'id': modelId,
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					}
				}).then(function (response) {
					if (modelId != null) {
						categories = service.buildModel(response.data, selectedModel);
						resolve(categories);
					} else {
						resolve(response.data);
					}
				}).catch(function (response) {
					reject(response);
				});
			});
		};



		service.addModel = function (categories, newModel, companyId) {
			return $q(function (resolve, reject) {
				var fmData = new FormData();
				var internalSaveModel = function (_category) {
					if (angular.isArray(_category.subCategories) && _category.subCategories.length > 0) {
						angular.forEach(_category.subCategories, function (_subCategories) {
							internalSaveModel(_subCategories);
						});
					}
					angular.forEach(_category.values, function (item) {
						if (!item.fixField) {
							var valuedField = {
								idBaseField: item.id,
								id: item.idValue
							};
							if (item.typeChamps === 'BOOLEAN') {
								valuedField.value = '' + item.value;
							} else if (item.typeChamps === 'DATE'){
								if (item.dateTime != null){
									valuedField.value = $filter('date')(item.dateTime, 'dd/MM/yyyy');
								}
							} else if (item.typeChamps === 'LIST_SELECT') {
								valuedField.listFieldId = item.value.id;
							} else if (item.typeChamps === 'MULTIPLE_SELECT') {
								valuedField.values = [];
								angular.forEach(item.values, function (objectSelected) {
									valuedField.values.push({
										id: objectSelected.id,
										libelle: objectSelected.libelle
									});
								});
							} else if (item.typeChamps === 'FILE' || item.typeChamps === 'IMAGE') {
								var input = document.getElementById('genericField_file_' + item.id + '_' + item.index);
								var file = null;
								if (input != null) {
									file = input.files[0];
								}
								fmData.append('file_' + valuedField.idBaseField, file);
							} else if (item.typeChamps === 'NUMBER' || item.typeChamps === 'INTEGER') {
								if ('null' === item.value) {
									valuedField.value = '';
								} else {
									valuedField.value = item.value;
								}
							} else {
								valuedField.value = item.value;
							}
							newModel.valuedFields.push(valuedField);
						} else {
							newModel[item.keyJava] = item.value;
						}
					});
				};
				newModel.valuedFields = [];

				angular.forEach(categories, function (_category) {
					internalSaveModel(_category);
				});

				fmData.append('modelDTO', angular.toJson(newModel));
				$http({
					url: BASE_URL_CONTACT + companyId,
					method: 'POST',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': undefined,
						'authorization': []
					},
					transformRequest: angular.identity,
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.updateField = function (id, dto) {
			return $q(function (resolve, reject) {
				if (!dto.fixField) {
					var fmData = new FormData();
					var valuedField = {
						idBaseField: dto.id,
						id: dto.idValue
					};
					if (dto.typeChamps === 'BOOLEAN') {
						valuedField.value = '' + dto.value;
					} else if (dto.typeChamps === 'DATE') {
						if (dto.dateTime != null) {
							valuedField.value = $filter('date')(dto.dateTime, 'dd/MM/yyyy');
						}
					} else if (dto.typeChamps === 'LIST_SELECT') {
						if (!!dto.value) {
							valuedField.listFieldId = dto.value.id;
						}
					} else if (dto.typeChamps === 'MULTIPLE_SELECT') {
						valuedField.values = [];
						angular.forEach(dto.values, function (objectSelected) {
							valuedField.values.push({
								id: objectSelected.id,
								libelle: objectSelected.libelle
							});
						});
					} else if (dto.typeChamps === 'FILE' || dto.typeChamps === 'IMAGE') {
						var input = document.getElementById('genericField_file_' + dto.id + '_' + dto.index);
						var file = null;
						if (input != null) {
							file = input.files[0];
						}
						fmData.append('file', file);
					} else if (dto.typeChamps === 'NUMBER' || dto.typeChamps === 'INTEGER') {
						if ('null' === dto.value) {
							valuedField.value = '';
						} else {
							valuedField.value = dto.value;
						}
					} else {
						valuedField.value = dto.value;
					}
					fmData.append('modelDTO', angular.toJson(valuedField));
					$http({
						url: BASE_URL_CONTACT + id + '/field',
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': undefined,
							'authorization': []
						},
						data: fmData
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				}
			});
		};

		service.downloadValuedFile = function (fieldId) {
			var url = BASE_URL_CONTACT + 'download/' + fieldId + '/' + selectedModel.id;
			return url;
		};

		service.setActivated = function (id, activated) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + id + '/activate',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'active': activated
					},
					headers: {
						'Content-Type': 'application/json; charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.setChecked = function (id, checked) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + id + '/checked',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'checked': checked
					},
					headers: {
						'Content-Type': 'application/json; charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.deleteModel = function (id, toDelete) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + id,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime(),
						'delete': toDelete
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.move = function(id, companyId){
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + id + '/move/' + companyId,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.copy = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + id + '/copy',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		function findFirstCategory(categories) {
			var found = false;
			var index = 0;
			while (!found && index < categories.length) {
				var category = categories[index];
				if (category.index === FIRST_CATEGORY_INDEX) {
					return category;
				}
				index++;
			}
		}

		function setSelectedList(field) {
			var valueReturned = null;
			if (field.listFieldId) {
				for (var k = 0; k < field.listFieldsDTO.length; k++) {
					if (field.listFieldId === field.listFieldsDTO[k].id) {
						valueReturned = field.listFieldsDTO[k];
					}
				}
			}
			return valueReturned;
		}

		function setSelectedObject(field, data) {
			var valueReturned = null;
			if (data[field.keyJava]) {
				for (var k = 0; k < field.selectableObject.length; k++) {
					if (data[field.keyJava].id === field.selectableObject[k].id) {
						valueReturned = field.selectableObject[k];
					}
				}
			}
			return valueReturned;
		}

		function setSelectedMultipleObject(field, data) {
			var values = [];
			if (data[field.keyJava]) {
				for (var l = 0; l < data[field.keyJava].length; l++) {
					for (var k = 0; k < field.selectableObject.length; k++) {
						if (data[field.keyJava][l].id === field.selectableObject[k].id) {
							values.push(field.selectableObject[k]);
						}
					}
				}
			}
			return values;
		}

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('contactController', contactController);

	function contactController($rootScope, DISPLAY_MODELS_ICONS, $scope, $filter, $state, $translate, $mdDialog, toastr, contactService, companyService, userService, eventService, inscriptionService, inscriptionStatusService,
		SettingsMessageService, STORAGE_PREFIX, MessageService, MODELS_TYPES, DuplicationToolService) {
		$scope.userService = userService;
		$scope.companyId = $state.params.id;
		$scope.id = $state.params.contactId;
		$scope.subTypeId = $state.params.subType;
		$scope.modelType = 'CONTACT_MODEL';
		$scope.logsShowed = false;

		$scope.iconsDisplay = {};
		angular.forEach(DISPLAY_MODELS_ICONS, function (elt) {
			$scope.iconsDisplay[elt.name] = elt.value;
		});

		$scope.users = [];
		$scope.actions = [];
		$scope.contacts = [];
		$scope.message = {
			actionForm: null,
			receiverForm: null
		};
		$scope.filter = {
			sender: null,
			action: null
		};
		$scope.messages = [];
		$scope.typeAction = {
			ALL: 'ALL',
			TO_DO: 'TO_DO',
			DONE: 'DONE'
		};
		$scope.searchText = '';
		$scope.showForm = false;

		// $scope.searchCompany = function () {
		//   companyService.filterByString('BON').then(function (res) {
		//     console.log(res.data);
		//   }).catch(function (err) {
		//     toastr.error('Erreur lors de la récupération des résultats de la recherche');
		//     console.log(err);
		//   });
		// };
		// $scope.searchCompany();


		if ($scope.id != null && $scope.companyId != null && $scope.subTypeId != null) {
			companyService.getSelectedModelDisplay($scope.companyId, $scope.subTypeId).then(function (response) {
				$scope.company = response.data;
				putContactFavFirst();
			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(response);
			});

			refreshModelContact();

			$scope.refreshContacts = function () {
				contactService.listContactsDisplay($scope.companyId, $translate.preferredLanguage()).then(function (response) {
					$scope.contacts = response.data;
					putContactFavFirst();
				}).catch(function (response) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					console.log(response);
				});
			};
			$scope.refreshContacts();

		} else if ($scope.companyId != null && $scope.subTypeId != null) {
			$state.go('app.companies.details', {
				subType: $scope.subTypeId,
				id: $scope.companyId
			});
		} else {
			$state.go('app.home');
		}

		// companyService.findAll($translate.preferredLanguage()).then(function (response) {
		// 	$scope.companies = response.data;
		// }).catch(function (response) {
		// 	toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		// 	console.log(response);
		// });

		$scope.showDeleteContact = function (toDelete) {
			var content = null;
			if (toDelete) {
				content = {
					title: $filter('translate')('CONTACTS.DELETE'),
					message: $filter('translate')('CONTACTS.CONFIRM_DELETE')
				};
			} else {
				content = {
					title: $filter('translate')('CONTACTS.CANCEL_DELETE'),
					message: $filter('translate')('CONTACTS.CONFIRM_CANCEL_DELETE')
				};
			}
			$rootScope.openConfirmPopup(content).then(function () {
				contactService.deleteModel($scope.selectedContact.id, toDelete).then(function (response) {
					if (toDelete) {
						$state.go('app.companies.details', {
							subType: $scope.subTypeId,
							id: $scope.companyId
						});
					} else {
						for (var i = 0; i < $scope.contacts.length; i++) {
							if ($scope.contacts[i].id === $scope.selectedContact.id) {
								$scope.contacts[i].deleted = toDelete;
								break;
							}
						}
						$scope.selectedContact.deleted = toDelete;
					}
				}).catch(function (response) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					console.log(response);
				});
			}).catch(function () {

			});
		};

		$scope.detailsContact = function (id) {
			$state.go('app.companies.details.contact', {
				contactId: id
			});
		};

		$scope.setPrincipal = function () {
			companyService.setPrincipal($scope.id).then(function (response) {
				$scope.company.favouriteId = angular.copy(parseInt($scope.id));
				for (var i = 0; $scope.contacts.length; i++) {
					if ($scope.contacts[i].id === parseInt($scope.id)) {
						var contact = angular.copy($scope.contacts[i]);
						$scope.contacts.splice(i, 1);
						$scope.contacts.unshift(contact);
						break;
					}
				}
			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(response);
			});
		};

		/* DEPLACER SOCIETE */

		$scope.openMove = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/contacts/popup/move_contact.html',
				preserveScope: true,
				scope: $scope,
				clickOutsideToClose: true
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.printCompany = function (item) {
			var result = item.modelPattern;
			if (item.subTypes != null && item.subTypes.length > 0) {
				result += ' (';
				for (var i = 0; i < item.subTypes.length; i++) {
					result += item.subTypes[i].name;
					if (i < item.subTypes.length - 1) {
						result += ' ';
					}
				}
				result += ')';
			}
			return result;
		};

		$scope.searchCompany = function (text) {
			return companyService.filterByString(text, $translate.preferredLanguage()).then(function (res) {
				return res.data;
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(err);
				return [];
			});
		};

		$scope.moveContact = function () {
			contactService.move($scope.selectedContact.id, $scope.contact.company.id).then(function (response) {
				$mdDialog.hide();
				$state.go('app.companies.details', {
					id: $scope.companyId,
					subType: $scope.subTypeId
				});
			}).catch(function (response) {
				console.log(response);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		/* DEPLACER SOCIETE */

		/* COPIE SOCIETE */
		$scope.openCopy = function () {
			var content = {
				title: $filter('translate')('CONTACTS.COPY'),
				message: $filter('translate')('CONTACTS.COPY_CONFIRM')
			};

			$rootScope.openConfirmPopup(content).then(function () {
				contactService.copy($scope.id).then(function () {
					toastr.success($filter('translate')('CONTACTS.COPY_SUCCESS'));
					$scope.refreshContacts();
				}).catch(function (err) {
					console.log(err);
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					console.log(response);
				});
			}).catch(function () {

			});
		};


		/* LIVE UPDATE */
		$scope.$on('modelUpdated', function (event, args) {
			contactService.updateField($scope.id, args.model).then(function (response) {
				$scope.refreshContacts();
				//refreshModelContact();
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(error);
			});
		});

		$scope.setActivated = function (id, activate) {
			contactService.setActivated(id, activate).then(function () {
				for (var i = 0; i < $scope.contacts.length; i++) {
					if ($scope.contacts[i].id === parseInt(id)) {
						$scope.contacts[i].activate = activate;
						break;
					}
				}
				if ($scope.selectedContact.id === parseInt(id)) {
					$scope.selectedContact.activate = activate;
				}
			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(response);
			});
		};

		$scope.$on('activatedUpdated', function (event, args) {
			$scope.setActivated($scope.id, args.model.activate);
		});

		$scope.$on('checkedUpdated', function (event, args) {
			contactService.setChecked($scope.id, args.model.checked).then(function () {}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(response);
			});
		});
		/* LIVE UPDATE */

		/* Company */

		$scope.backToCompany = function () {
			$state.go('app.companies.details', {
				id: $scope.companyId,
				subType: $scope.subTypeId
			});
		};

		$scope.setCompanyActivated = function (id, activate) {
			companyService.setActivated(id, activate).then(function (response) {

			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(response);
			});
		};



		//MESSAGES
		$scope.findAllUsers = function () {
			userService.findAllUsers().then(function (users) {
				$scope.users = users.data;
			}).catch(function (data) {

			});
		};

		$scope.findAllUsers();

		$scope.findAllActions = function () {
			SettingsMessageService.findAllAction(localStorage[STORAGE_PREFIX + 'language']).then(function (actions) {
				$scope.actions = actions.data;
			}).catch(function (data) {

			});
		};

		$scope.findAllActions();

		$scope.cancelFormMessage = function () {
			$scope.message = {
				actionForm: null,
				receiverForm: null
			};
			$mdDialog.hide();
		};

		$scope.saveMessage = function () {
			if ($scope.message.actionForm != null) {
				$scope.message.dateAction = moment($scope.message.startDateForm).set('hours', $scope.message.startTime.split(':')[0]).set('minutes', $scope.message.startTime.split(':')[1]).toDate().getTime();
				if (!$scope.message.actionDone) {
					$scope.message.actionDone = false;
				}
				$scope.message.action = angular.fromJson($scope.message.actionForm);
			}

			if ($scope.message.receiverForm != null && $scope.message.receiverForm != "null") {
				$scope.message.receiver = angular.fromJson($scope.message.receiverForm);
				$scope.message.receiverID = angular.fromJson($scope.message.receiverForm).id;
			} else {
				$scope.message.receiverID = null;
			}
			$scope.message.contactId = $scope.id;
			MessageService.saveMessage($scope.message).then(function (data) {
				$scope.findAllMessages();
				$scope.cancelFormMessage();
				$mdDialog.hide();
			}).catch(function (data) {

			});
		};

		$scope.findAllMessages = function () {
			switch ($scope.filter.action) {
				case null:
					delete $scope.filter.actionToDo;
					$scope.filter.actionExist = false;
					break;
				case $scope.typeAction.ALL:
					delete $scope.filter.actionToDo;
					$scope.filter.actionExist = true;
					break;
				case $scope.typeAction.DONE:
					$scope.filter.actionToDo = false;
					break;
				case $scope.typeAction.TO_DO:
					$scope.filter.actionToDo = true;
					break;
				default:
					break;
			}
			$scope.filter.addressee = [];
			angular.forEach($scope.filter.receiverForm, function (item, key) {
				$scope.filter.addressee.push(angular.fromJson(item));
			});
			$scope.filter.contactId = $scope.id;
			MessageService.findAllMessage($scope.filter, localStorage[STORAGE_PREFIX + 'language']).then(function (messages) {
				$scope.messages = messages.data;
			}).catch(function (data) {

			});
		};
		$scope.findAllMessages();

		$scope.getDate = function (date) {
			return moment(date).toDate();
		};


		$scope.confirmAction = function (action) {
			var content = {
				title: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL_TITLE') : $filter('translate')('MESSAGE.ACTION_CONFIRM_TITLE'),
				message: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL') : $filter('translate')('MESSAGE.ACTION_CONFIRM')
			};
			$rootScope.openConfirmPopup(content).then(function () {
				action.actionDone = !action.actionDone;
				MessageService.confirmAction(action).then(function (data) {}).catch(function (data) {});
			}).catch(function () {

			});
		};

		$scope.showPopUpMessage = function () {
			$scope.message = {
				actionForm: null,
				receiverForm: null
			};

			for (var i = 0; i < $scope.users.length; i++) {
				if ($scope.users[i].id === $rootScope.user.id) {
					$scope.message.receiverForm = angular.toJson($scope.users[i]);
					break;
				}
			}

			$mdDialog.show({
				templateUrl: 'app/main/message/popup/update_message.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.openAddContact = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/contacts/popup/add_contact.html',
				clickOutsideToClose: true,
				controller: 'addContactCtrl',
				locals: {
					companyId: parseInt($scope.companyId)
				}
			}).then(function () {
				$scope.refreshContacts();
			}).catch(function () {


			});
		};

		function refreshModelContact() {
			contactService.getSelectedModel($scope.id, $translate.preferredLanguage()).then(function (response) {
				$scope.selectedContact = response.data;
				$scope.selectedContact.companyId = parseInt(angular.copy($scope.companyId));
				contactService.getCategories($translate.preferredLanguage(), $scope.id).then(function (data) {
					$scope.categories = data;
				}).catch(function () {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					console.log(response);
				});
			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(response);
			});
		}

		$scope.setContactActivated = function (id, activate) {
			contactService.setActivated(id, activate).then(function (response) {
				$scope.refreshContacts();
				$scope.hiddenContact = false;
			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(response);
			});
		};

		$scope.showMoreContacts = function () {
			contactService.listContactsHidden($scope.companyId, $translate.preferredLanguage()).then(function (response) {
				$scope.hiddenContact = true;
				$scope.contacts = $scope.contacts.concat(response.data);
			}).catch(function (response) {

			});
		};


		$scope.hideMoreContacts = function () {
			contactService.listContactsHidden($scope.companyId, $translate.preferredLanguage()).then(function (response) {
				$scope.hiddenContact = false;
				$scope.contacts = $scope.contacts.filter(function (el) {
					return $filter("filter")(response.data, {
						id: el.id
					}).length == 0;
				})
			}).catch(function (response) {

			});
		};

		$scope.updateMessage = function (message) {
			$scope.message = angular.copy(message);
			// $scope.message.receiverForm = angular.copy(angular.toJson(msg.receiver).toString());
			// console.log($scope.message);
			if (message.action != null) {
				var actionID = angular.copy(message.action.actionID);
				angular.forEach($scope.actions, function (action) {
					if (action.id === actionID) {
						$scope.message.actionForm = angular.toJson(action);
					}
				});
			} else {
				$scope.message.actionForm = null;
			}

			if (message.receiver != null) {
				var receiverID = angular.copy(message.receiver.id);
				angular.forEach($scope.users, function (user) {
					if (user.id === receiverID) {
						$scope.message.receiverForm = angular.toJson(user);
					}
				});
			} else {
				$scope.message.receiverForm = 'null';
			}

			if (message.action != null && message.action.dateAction != null) {
				var date = new Date(message.action.dateAction);

				$scope.message.startDateForm = date;
				$scope.message.startTime = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
			} else {
				var now = new Date();
				$scope.message.startDateForm = now;
				$scope.message.startTime = (now.getHours() < 10 ? '0' + now.getHours() : now.getHours()) + ':' + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes());
			}

			$mdDialog.show({
				templateUrl: 'app/main/message/popup/update_message.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.showLogs = function () {
			$scope.logsShowed = !$scope.logsShowed;
		};

		function putContactFavFirst() {
			if ($scope.contacts.length > 0 && $scope.company && $scope.company.favouriteId) {
				for (var i = 0; i < $scope.contacts.length; i++) {
					var contact = angular.copy($scope.contacts[i]);
					if (contact.id === $scope.company.favouriteId) {
						$scope.contacts.splice(i, 1);
						$scope.contacts.unshift(contact);
					}
				}
			}
		}

		// Outils de duplication
		$scope._lookForContactDuplicates = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/duplication_tool/duplication_tool_modal.html',
				clickOutsideToClose: true,
				controller: 'DuplicationToolModalController',
				locals: {
					dtToolData: {
						_modelType: MODELS_TYPES.CONTACT_MODEL,
						_companyId: $scope.companyId
					}
				}
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope._contactDuplicatesAutoMergeFn = function() {
			$scope._mdProgressLinear = true;
			DuplicationToolService._autoMergeDuplicatesModel(MODELS_TYPES.CONTACT_MODEL, null, $scope.companyId).then(function (response) {
				if(!JSON.parse(response.data)) {
					toastr.error($filter('translate')('DUPLICATION_TOOL.ANY_OCCURENCE_FOUND'));
				} else {
					$scope.backToCompany();
					toastr.success($filter('translate')('DUPLICATION_TOOL.MERGE.MERGE_ACTION_SUCCESS'));
				}
				$scope._mdProgressLinear = false;
			}).catch(function (error) {
			  	console.log(error);
			  	toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			  	$scope._mdProgressLinear = false;
			});
		};

		/* Subscription */

		$scope.setStatusStyle = function(status){
			if (status != null && status.color != null){
				return {'background-color': status.color, 'color': 'white', 'font-weight':600};
			}else{
				return {'font-weight':600};
			}
		};

		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};
		$scope.event = {};
		$scope.openSubscribe = function(){
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/contacts/popup/subscribe.html',
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true
			}).then(function(){
				
			}).catch(function(){

			});
		};

		$scope.listSubscriptions = function(){
			inscriptionService.list($scope.id, $translate.preferredLanguage()).then(function(response){
				$scope.inscriptions = response.data;
				var _inscriptionFound = false;
				angular.forEach($scope.inscriptions, function(item, key){
					$scope.inscriptions[key].categories = inscriptionService.buildModel(angular.copy(item.categories));

					// Target inscription from isncriptions list
					if(!_inscriptionFound && $state.params.inscriptionId && item.id === $state.params.inscriptionId) {
						item._showDetails = true;
						_inscriptionFound = true;
					}
				});
			}).catch(function(){

			});
		};

		$scope.subscribe = function(){
			if ($scope.event != null){
				inscriptionService.save($scope.id, $scope.event.id).then(function(response){
					$mdDialog.hide();
					toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_CREATE'));
					$scope.refreshEvents();
					$scope.listSubscriptions();
				}).catch(function(response){
					if (response.status === 409){
						toastr.error($filter('translate')('INSCRIPTION.ERROR_SAVE_409'));
					}else if (response.status === 404){
						toastr.error($filter('translate')('INSCRIPTION.ERROR_SAVE_404'));
					}else {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					}
				});
			}
		};

		$scope.refreshEvents = function(){
			eventService.listNotSubscribed($scope.id).then(function(response){
				$scope.events = response.data;
			}).catch(function(){
	
			});
		};
		$scope.listSubscriptions();
		$scope.refreshEvents();

		/* LIVE UPDATE */
		$scope.$on('inscriptionUpdated', function (event, args) {
			inscriptionService.updateField(args.inscription.id, args.model).then(function (response) {
				// $scope.listSubscriptions();
				//refreshModelContact();
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(error);
			});
		});
		$scope.$on('inscriptionStatusUpdated', function(event, args){
			inscriptionService.updateInscriptionStatus(args.model.id, args.model.inscriptionStatus.id).then(function(response){

			}).catch(function(){

			});
		});
		$scope.$on('subCategoryUpdated', function(event, args){
			inscriptionService.updateSubCategory(args.model.id, args.model.subCategory.id).then(function(response){

			}).catch(function(){

			});
		});

		$scope.goToLogistics = function(logisticId){
			$state.go('app.companies.details.contact.logistic', {logisticId: logisticId});
		};
		/*
		* Mailing
		*/
		$scope._mailingDialogOpenFn = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/mailing/mailing_modal.html',
				clickOutsideToClose: false,
				controller: 'MailingModalController',
				locals: {
					data : {
						modelType: MODELS_TYPES.CONTACT_MODEL,
						modelSubTypeId: $scope.subTypeId,
						contactId: $scope.id,
						filter: null
					}
				}
			}).then(function () {
			}).catch(function () {
			});
		};

	}

})();


(function(){
	'use strict';

	angular.module('app.front').controller('inscriptionFormsController', inscriptionFormsController);

	function inscriptionFormsController($rootScope, $scope, $state, $translate, $mdDialog, $filter, toastr, inscriptionFormService){

		$scope.refresh = function(){
			inscriptionFormService.list($translate.preferredLanguage()).then(function(response){
				$scope.forms = response.data;
			}).catch(function(){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.refresh();

		$scope.showPopUpDelete = function(form){
			var content = {
				title: $filter('translate')('INSCRIPTION_FORMS.DELETE_TITLE'),
				message: $filter('translate')('INSCRIPTION_FORMS.DELETE_MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				inscriptionFormService.remove(form.id, $state.params.id).then(function(){
					$scope.refresh();
				}).catch(function(){
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}).catch(function(){

			});
		};

		$scope.update = function(form){
			$mdDialog.show({
				templateUrl: 'app/main/events/inscriptions/forms/popup/add_form.html',
				controller: 'addInscriptionFormController',
				clickOutsideToClose : true,
				locals: {
					eventId: $state.params.id,
					form: form
				}
			}).then(function(response){
				$scope.refresh();
			}).catch(function(){

			});
		};

		$scope.details = function(form){
			$state.go('app.events.inscriptionFields', {id: $state.params.id, formId: form.id});
		};

		$scope.openAdd = function(){
			$mdDialog.show({
				templateUrl: 'app/main/events/inscriptions/forms/popup/add_form.html',
				controller: 'addInscriptionFormController',
				clickOutsideToClose : true,
				locals: {
					eventId: $state.params.id,
					form: null
				}
			}).then(function(response){
				$state.go('app.events.inscriptionFields', {id: $state.params.id, formId : response.data});
			}).catch(function(){

			});
		};
	}
})();
(function(){
	'use strict';

	angular.module('app.front').service('inscriptionFormService', inscriptionFormService);

	function inscriptionFormService($http, $q){
		var service = {};

		service.save = function(dto){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form',
					method: 'POST',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					data: dto,
					params: {'_v': new Date().getTime()}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.remove = function(id, eventId){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/'+id,
					method: 'DELETE',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'eventId': eventId}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.list = function(lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form',
					method: 'GET',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'lang': lang}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.listByEvent = function(eventId, lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/event/' + eventId,
					method: 'GET',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'lang': lang}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.findById = function(id, lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/' + id,
					method: 'GET',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'lang': lang}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.addField = function(id, page, dto, lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/'+id+'/field',
					method: 'POST',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					data: dto,
					params: {'_v': new Date().getTime(), 'lang': lang, 'page': page}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.updateField = function(id, dto, lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/'+id+'/field',
					method: 'PUT',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					data: dto,
					params: {'_v': new Date().getTime(), 'lang': lang}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.removeField = function(id, fieldId){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/'+id+'/field/'+fieldId,
					method: 'DELETE',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime()}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.upField = function(id, fieldId){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/'+id+'/field/up/'+fieldId,
					method: 'PUT',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime()}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.downField = function(id, fieldId){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/'+id+'/field/down/'+fieldId,
					method: 'PUT',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime()}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.listFields = function(id, page, lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/'+id+'/field',
					method: 'GET',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'lang': lang, 'page': page}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.listAllFields = function(lang, removeDuplicatesField){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/field/all',
					method: 'GET',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'lang': lang, 'removeDuplicatesField': removeDuplicatesField}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		/* PUBLIC SITES */

		service.publicFindById = function(id, contactNumber, lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/public/sitegen/inscription-form/' + id,
					method: 'GET',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'lang': lang, 'contactNumber': contactNumber}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		return service;
	}
})();
(function () {
	'use strict';

	angular.module('app.front').controller('inscriptionFieldsController', inscriptionFieldsController);

	function inscriptionFieldsController($rootScope, $scope, $state, $filter, $translate, $mdDialog, toastr, languageService, inscriptionFormService, modelService, TYPES_INSCRIPTION_FIELD, MODEL_TYPES) {
		var companyFields = null;
		var contactFields = null;
		var eventFields = null;
		var logisticFields = null;
		$scope.language = {};
		$scope.typeFields = TYPES_INSCRIPTION_FIELD;
		$scope.newField1 = {
			typeField: 'FIELD',
			column: 1
		};
		$scope.newField2 = {
			typeField: 'FIELD',
			column: 2
		};
		
		$scope.modelTypes = MODEL_TYPES;
		$scope.pagination = {page: 1};

		$scope.refreshFields = function(){
			$scope.loaded = false;
			inscriptionFormService.listFields($state.params.formId, $scope.pagination.page, $scope.language.key).then(function(response){
				$scope.inscriptionFields = response.data;
				$scope.copyInscriptionFields = angular.copy(response.data);
				$scope.conditionalFields = [];
				angular.forEach($scope.inscriptionFields, function(item, key){
					if (item.typeField === 'FIELD'){
						$scope.getFields($scope.inscriptionFields[key]);
						if (item.field != null && item.field.typeChamps === 'LIST_SELECT'){
							$scope.conditionalFields.push(angular.copy(item));
						}
					}
				});
			}).catch(function(){
				
			});
		};
		
		$scope.refresh = function(){
			if ($state.params.formId != null){
				inscriptionFormService.findById($state.params.formId, $scope.language.key).then(function(response){
					$scope.form = response.data;
				}).catch(function(response){
					
				});
			}
			$scope.refreshFields();
		};
		$scope.refresh();

		$scope.addItem = function(column, form){
			inscriptionFormService.addField($state.params.formId, $scope.pagination.page, $scope['newField'+column], $scope.language.key).then(function(response){
				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_CREATE'));
				$scope.refresh($scope.language.key);
				$scope['newField'+column] = {
					typeField: 'FIELD',
					column: column
				};
				$scope.getFields($scope['newField'+column]);
				form.$setPristine();
				form.$setUntouched();
			}).catch(function(response){

			});
		};

		$scope.getFields = function(newField){
			if (newField.modelType === 'COMPANY_MODEL'){
				if (companyFields != null){
					newField.fields = angular.copy(companyFields);
				}else{
					modelService.listFieldsBySubType(newField.modelType, $scope.form.subtype.id, $translate.preferredLanguage()).then(function(response){
						companyFields = angular.copy(response.data);
						newField.fields = response.data;
					}).catch(function(response){
	
					});
				}
			}else if (newField.modelType === 'CONTACT_MODEL'){
				if (contactFields != null){
					newField.fields = angular.copy(contactFields);
				}else{
					modelService.listFieldsByType(newField.modelType, $translate.preferredLanguage()).then(function(response){
						contactFields = angular.copy(response.data);
						newField.fields = response.data;
					}).catch(function(response){
	
					});
				}

			}else if (newField.modelType === 'INSCRIPTION_MODEL'){
				if (eventFields != null){
					newField.fields = angular.copy(eventFields);
				}else{
					modelService.listFieldsByType(newField.modelType, $translate.preferredLanguage(), $state.params.id).then(function(response){
						eventFields = angular.copy(response.data);
						newField.fields = response.data;
					}).catch(function(response){
						
					});
				}
			}else if (newField.modelType === 'LOGISTIC_MODEL'){
				if (logisticFields != null){
					newField.fields = angular.copy(logisticFields);
				}else{
					modelService.listFieldsByType(newField.modelType, $translate.preferredLanguage(), $state.params.id).then(function(response){
						logisticFields = angular.copy(response.data);
						newField.fields = response.data;
					}).catch(function(response){
						
					});
				}
			}
		};
		$scope.getFields($scope.newField1);
		$scope.getFields($scope.newField2);
		
		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.refresh();
			});
		}).catch(function (error) {

		});

		$scope.updateField = function(field){
			inscriptionFormService.updateField($state.params.formId, field, $scope.language.key).then(function(response){
				for (var i = 0; i < $scope.inscriptionFields.length; i++){
					if ($scope.inscriptionFields[i].id === response.data.id){
						$scope.inscriptionFields[i] = response.data;
						$scope.getFields($scope.inscriptionFields[i]);
						break;
					}
				}
			}).catch(function(){

			});
		};

		$scope.removeField = function(field, index){
			var content = {
				title: $filter('translate')('INSCRIPTION_FORMS.FIELDS.DELETE_TITLE'),
				message: $filter('translate')('INSCRIPTION_FORMS.FIELDS.DELETE_MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				inscriptionFormService.removeField($state.params.formId, field.id).then(function(){
					$scope.refresh($scope.language.key);
					toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_DELETE'));
				}).catch(function(){
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}).catch(function(){});
		};

		$scope.up =function(field){
			inscriptionFormService.upField($state.params.formId, field.id).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.down =function(field){
			inscriptionFormService.downField($state.params.formId, field.id).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.enabledFieldUpdating = function(field){
			field.active = true;
		};

		$scope.cancelFieldUpdating = function(field, index, form){
			for (var i = 0; i < $scope.copyInscriptionFields.length; i++){
				if (field.id === $scope.copyInscriptionFields[i].id){

					$scope.inscriptionFields[i] = angular.copy($scope.copyInscriptionFields[i]);
					$scope.getFields($scope.inscriptionFields[i]);
					break;
				}
			}
		};

		$scope.openConditional = function(field){
			$scope.field = angular.copy(field);
			$mdDialog.show({
				templateUrl: 'app/main/events/inscriptions/forms/popup/condition.html',
				preserveScope: true,
				scope: $scope,
				clickOutsideToClose: true
			}).then(function(){
			
			}).catch(function(){

			});
		};

		$scope.saveCondition = function(){
			inscriptionFormService.updateField($state.params.formId, $scope.field, $scope.language.key).then(function(response){
				for (var i = 0; i < $scope.inscriptionFields.length; i++){
					if ($scope.inscriptionFields[i].id === response.data.id){
						$scope.inscriptionFields[i] = response.data;
						$scope.getFields($scope.inscriptionFields[i]);
						$mdDialog.hide();
						break;
					}
				}
			}).catch(function(){

			});
		};

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};
	}
})();

(function () {
  'use strict';

  angular.module('app.front').controller('editUserController', editUserController);

  function editUserController($rootScope, $scope, $filter, $mdDialog, user, URL, toastr, userService, groupService) {
    $scope.user = angular.copy(user);
    if (!$scope.user.seeInactiveContact) {
      $scope.user.seeInactiveContact = false;
    }
    if (user.pictureLocation != null) {
      $scope.user.src = URL.alternatedocroots + '/' + user.pictureLocation;
    }

    groupService.findGroups().then(function (response) {
      $scope.groups = response.data;
    }).catch(function () {
      toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
    });

    $scope.update = function () {
      var fmData = new FormData();
      fmData.append('dto', angular.toJson($scope.user));
      var input = document.getElementById('edit_user_dropify');
      if (input != null && input.files != null && input.files.length > 0) {
        fmData.append('file', input.files[0]);
      }
      userService.updateUser(fmData).then(function (response) {
        if ($rootScope.user != null && $rootScope.user.id === $scope.user.id){
          $rootScope.$broadcast('getCurrentUser');
        }
        $mdDialog.hide();
      }).catch(function (err) {
        if(err.status === 409) {
					if(err.data === 'ALREADY_EXIST_MAIL') {
						toastr.error($filter('translate')('USERS.ALREADY_EXIST_MAIL'));
					} else if(err.data === 'ALREADY_EXIST_LOGIN') {
						toastr.error($filter('translate')('USERS.ALREADY_EXIST_LOGIN'));
					} else {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					}
				} else {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}
      });
    };

    $scope.hidePopup = function () {
      $mdDialog.cancel();
    };
  }
})();

(function(){
	'use strict';

	angular.module('app.front').controller('addUserController', addUserController);

	function addUserController($rootScope, $scope, $filter, $mdDialog, toastr, company, userService, groupService){

		$scope.groups = [];
		$scope.newUser = {};
		$scope.company = company;

		if (!company){
			groupService.findGroups().then(function(response){
				$scope.groups = response.data;
			}).catch(function(){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}

		$scope.saveUser = function(){
			var fmData = new FormData();
			if (company != null){
				$scope.newUser.activated = true;
				$scope.newUser.companyId = company.id;
			}
			fmData.append('dto', angular.toJson($scope.newUser));
			var input = document.getElementById('add_user_dropify');
			if (input != null && input.files != null && input.files.length > 0){
				fmData.append('file', input.files[0]);
			}
			userService.addUser(fmData, company != null).then(function(){
				$mdDialog.hide();
			}).catch(function(err){
				if(err.status === 409) {
					if(err.data == 'ALREADY_EXIST_MAIL') {
						toastr.error($filter('translate')('USERS.ALREADY_EXIST_MAIL'));
					} else if(err.data == 'ALREADY_EXIST_LOGIN') {
						toastr.error($filter('translate')('USERS.ALREADY_EXIST_LOGIN'));
					} else {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					}
				} else {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}
				console.log(err);
			});
		};

		$scope.addManager = function(){
			$mdDialog.show({
				templateUrl: 'app/main/access_rights/users/popup/add_user.html',
				controller: 'addUserController',
				clickOutsideToClose: true,
				locals: {
					fromAssociation : true
				}
			}).then(function(){

			}).catch(function(){

			});
		};

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};
	}
})();

(function(){
	'use strict';

	angular.module('app.front').controller('editGroupController', editGroupController);

	function editGroupController($scope, $mdDialog, $filter, group, toastr, groupService){
		$scope.group = angular.copy(group);

		$scope.update = function(){
			groupService.updateGroup($scope.group).then(function(){
				$mdDialog.hide();
			}).catch(function(){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};
	}
})();

(function(){
	'use strict';

	angular.module('app.front').controller('addGroupController', addGroupController);


	function addGroupController($scope, $mdDialog, $filter, toastr, groupService){
		$scope.newGroup = {
			index: 0
		};

		$scope.save = function(){
			groupService.addGroup($scope.newGroup).then(function(response){
				$mdDialog.hide();
			}).catch(function(response){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};
	}
})();

(function(){
	'use strict';

	angular.module('app.front').controller('editAssociationController', editAssociationController);

	function editAssociationController($scope, $mdDialog, $filter, toastr, association, URL, associationService, userService){
		$scope.association = angular.copy(association);
		if ($scope.association.logo != null){
			$scope.association.src = URL.alternatedocroots + '/' + $scope.association.logo;
		}

		userService.findActive().then(function (response) {
			$scope.users = response.data;
		}).catch(function () {
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		$scope.hidePopup = function () {
			$mdDialog.cancel();
		};

		$scope.update = function () {
			var fmData = new FormData();
			fmData.append('dto', angular.toJson($scope.association));
			var input = document.getElementById('edit_association_dropify');
			if (input != null && input.files != null && input.files.length > 0) {
				fmData.append('file', input.files[0]);
			}
			associationService.update(fmData).then(function (response) {
				$mdDialog.hide();
			}).catch(function () {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};
	}
})();

(function(){
	'use strict';

	angular.module('app.front').controller('addAssociationController', addAssociationController);

	function addAssociationController($scope, $mdDialog, $filter, $translate, toastr, associationService, userService){

		$scope.newAssociation = {};

		userService.findActive().then(function(response){
			$scope.users = response.data;
		}).catch(function(){
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};

		$scope.save = function(){
			var fmData = new FormData();
			fmData.append('dto', angular.toJson($scope.newAssociation));
			var input = document.getElementById('add_association_dropify');
			if (input != null && input.files != null && input.files.length > 0){
				$scope.missingFile = false;
				fmData.append('file', input.files[0]);
				associationService.save(fmData, $translate.preferredLanguage()).then(function(response){
					$mdDialog.hide();
				}).catch(function(){
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}else{
				$scope.missingFile = true;
			}
		};

	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function(){
	'use strict';

	angular.module('app.front').controller('addTouristAttractionController', addTouristAttractionController);

	function addTouristAttractionController($scope, $translate, $state, $filter, $mdDialog, toastr, modelService, touristAttractionService, languageService, DocumentService){
		$scope.modelType = 'COMPANY_MODEL';
		var baseUrl = './api/rest/model/' + $scope.modelType;
		$scope.updateMode = false;
		$scope.tourist = {};
		$scope.language = {};
		$scope.photos = [];

		modelService.findSpecificByType(baseUrl, $translate.preferredLanguage(), 'REGION').then(function (response) {
			$scope.regions = response.data.listFieldsDTO;
		}).catch(function () {

		});

		modelService.findSpecificByType(baseUrl, $translate.preferredLanguage(), 'TOURISM').then(function (response) {
			$scope.tourisms = response.data.listFieldsDTO;
		}).catch(function () {

		});

		modelService.findSpecificByType(baseUrl, $translate.preferredLanguage(), 'CITY').then(function (response) {
			$scope.cities = response.data.listFieldsDTO;
		}).catch(function () {

		});

		$scope.findTourist = function(id){
			touristAttractionService.findById(id, $scope.language.key).then(function(res){
				$scope.tourist = res.data;
				$scope.updateMode = true;
			}).catch(function(){

			});
		};

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}

			if ($state.params.id) {
				$scope.findTourist($state.params.id);
			}
		}).catch(function (error) {

		});

		$scope.add = function(){
			var fmData = new FormData();
			fmData.append('dto', angular.toJson($scope.tourist));
			var maxIndex = 0;
			for (var i = 0; i < $scope.photos.length; i++){
				var input = document.getElementById('tourist_photo_' + i);
				var file = null;
				if (input != null) {
					file = input.files[0];
				}
				if (file != null){
					fmData.append('file_' + maxIndex, file);
					maxIndex++;
				}
			}
			fmData.append('maxIndex', maxIndex);
			touristAttractionService.save(fmData, $scope.language.key).then(function(){
				$state.go('app.touristAttractions');
			}).catch(function(){

			});
		};

		$scope.displayPopUpDeletePhoto = function (photo, index) {
			$scope.photoToDelete = angular.copy(photo);
			$scope.indexToDelete = index;
			$mdDialog.show({
				templateUrl: 'app/main/tourist_attractions/popup/delete_photo.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.hidePopup = function () {
			$mdDialog.hide();
		};

		$scope.deletePhotoPermanentely = function () {
			touristAttractionService.deletePhoto($state.params.id, $scope.photoToDelete.id).then(function (res) {
				$scope.tourist.photos.splice($scope.indexToDelete, 1);
				toastr.success($filter('translate')('PACKAGES.ADD.TOAST.SUCCESS_DELETE_PHOTO'));
				$scope.hidePopup();
			}).catch(function (err) {
				toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_DELETE_PHOTO'));
			});
		};

		$scope.langageChanged = function () {
			if ($scope.updateMode) {
				if ($state.params.id != null) {
					$scope.findTourist($state.params.id);
				}
			}
		};
	}
})();
(function () {
	'use strict';

	angular
		.module('app.front')
		.controller('reportingStatisticsController', reportingStatisticsController);

	/** @ngInject */
	function reportingStatisticsController($scope, groupService, userService, SettingsMessageService, MessageService, languageService, statisticsService, companyService, STORAGE_PREFIX, STATISTICS_NATIONALITIES, $filter, $rootScope, toastr, $mdDialog, $mdSelect, $window) {
		$scope.language = {};
		$scope.groups = [];
		$scope.actions = [];
		$scope.filter = {
			groupIDs: [],
			actionIDs: [],
			begin: {},
			end: {}
		};
		$scope.stats = [];
		$scope.monthNames = [];
		$scope.yearValues = [];
		$scope.year = {
			value: null
		};
		$scope.customPeriod = false;
		$scope.customFilter = {
			begin: {},
			end: {}
		};
		$scope.customPeriods = {
			filter: null,
			period: {
				begin: {
					year: null
				},
				end: {
					year: null
				}
			}
		};
		$scope.displayCustomPeriod = false;
		$scope.messagesArray = [];

		var now = new Date();

		//For iput select year
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		$scope.getStatisticsReporting = function () {
			var year;

			if (!$scope.customPeriod) {
				if ($scope.year.value === 'custom') {
					year = angular.copy($scope.customPeriods.filter);
				} else if ($scope.year.value === 'all') {
					year = null;
				} else {
					year = angular.copy($scope.year.value);
				}

				statisticsService.getStatisticReporting($scope.filter, $scope.language.key, year).then(function (res) {
					$scope.displayCustomPeriod = false;
					$scope.stats = res.data;
					iniStatsMonthValues();
					initStatsAccrued();
					initStatsMessages();
				}).catch(function (err) {
					console.log(err);
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			} else {
				if ($scope.customFilter.begin.year == null || $scope.customFilter.end.year == null || $scope.customFilter.begin.month == null || $scope.customFilter.end.month == null) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					return;
				}

				var filter = angular.copy($scope.filter);
				filter.begin = {
					month: $scope.customFilter.begin.month
				};
				filter.end = {
					month: $scope.customFilter.end.month
				};

				if ($scope.customFilter.begin.year === 'custom') {
					filter.begin.year = $scope.customPeriods.period.begin.year;
				} else {
					filter.begin.year = $scope.customFilter.begin.year;
				}

				if ($scope.customFilter.end.year === 'custom') {
					filter.end.year = $scope.customPeriods.period.end.year;
				} else {
					filter.end.year = $scope.customFilter.end.year;
				}

				if (new Date(filter.begin.year, filter.begin.month, 1) > new Date(filter.end.year, filter.end.month, 1)) {
					toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INVALID_PERIOD'));
					return;
				}

				console.log(filter);

				statisticsService.getStatisticReporting(filter, $scope.language.key, null).then(function (res) {
					$scope.displayCustomPeriod = true;
					$scope.stats = res.data;
					iniStatsCustomPeriod();
					initStatsMessages();
				}).catch(function (err) {
					console.log(err);
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}
		};

		$scope.getUsersByGroups = function() {
			$scope.users = [];
			userService.findByGroups($scope.filter.groupIDs).then(function(res) {
				$scope.users = res.data;
			}).catch(function(err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.confirmAction = function (action) {
			var content = {
				title: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL_TITLE') : $filter('translate')('MESSAGE.ACTION_CONFIRM_TITLE'),
				message: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL') : $filter('translate')('MESSAGE.ACTION_CONFIRM')
			};
			$rootScope.openConfirmPopup(content).then(function () {
				action.actionDone = !action.actionDone;
				MessageService.confirmAction(action).then(function (data) {}).catch(function (data) {});
			}).catch(function () {

			});
		};

		$scope.downloadStatisticsReporting = function () {
			if (!$scope.customPeriod) {
				var year;

				if ($scope.year.value === 'custom') {
					year = angular.copy($scope.customPeriods.filter);
				} else if ($scope.year.value === 'all') {
					year = null;
				} else {
					year = angular.copy($scope.year.value);
				}

				statisticsService.generateReporting($scope.filter, $scope.language.key, year).then(function (res) {

				}).catch(function (err) {
					console.log(err);
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			} else {
				if ($scope.customFilter.begin.year == null || $scope.customFilter.end.year == null || $scope.customFilter.begin.month == null || $scope.customFilter.end.month == null) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					return;
				}

				var filter = angular.copy($scope.filter);
				filter.begin = {
					month: $scope.customFilter.begin.month
				};
				filter.end = {
					month: $scope.customFilter.end.month
				};

				if ($scope.customFilter.begin.year === 'custom') {
					filter.begin.year = $scope.customPeriods.period.begin.year;
				} else {
					filter.begin.year = $scope.customFilter.begin.year;
				}

				if ($scope.customFilter.end.year === 'custom') {
					filter.end.year = $scope.customPeriods.period.end.year;
				} else {
					filter.end.year = $scope.customFilter.end.year;
				}

				if (new Date(filter.begin.year, filter.begin.month, 1) > new Date(filter.end.year, filter.end.month, 1)) {
					toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INVALID_PERIOD'));
					return;
				}

				statisticsService.generateReporting(filter, $scope.language.key, null).then(function (res) {}).catch(function (err) {
					console.log(err);
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}

		};

		$scope.searchStatisticsCustomYear = function () {
			if (validateYearFormat($scope.customPeriods.filter)) {
				$scope.year.value = 'custom';
				$mdSelect.hide();
			} else {
				$scope.year.value = now.getFullYear();
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}
		};

		$scope.searchStatisticsCustomYearBetween = function (begin) {
			if (begin && validateYearFormat($scope.customPeriods.period.begin.year)) {
				$scope.customFilter.begin.year = 'custom';
				$mdSelect.hide();
			} else if (!begin && validateYearFormat($scope.customPeriods.period.end.year)) {
				$scope.customFilter.end.year = 'custom';
				$mdSelect.hide();
			} else {
				if (begin) {
					$scope.customFilter.begin.year = now.getFullYear();
				} else {
					$scope.customFilter.end.year = now.getFullYear();
				}
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}
		};

		$scope.groupContainsActionsDone = function (group) {
			for (var i = 0; i < group.msgs.length; i++) {
				if (group.msgs[i].action && group.msgs[i].action.actionDone) {
					return true;
				}
			}

			return false;
		};

		function validateYearFormat(year) {
			if (year >= (now.getFullYear() - 100) && year <= (now.getFullYear() + 100)) {
				return true;
			}

			return false;
		}

		function init() {
			languageService.getLanguages().then(function (response) {
				$scope.languages = response.data;
				for (var i = 0; i < $scope.languages.length; i++) {
					var language = $scope.languages[i];
					if (language.preferred) {
						$scope.language.key = language.key;
						break;
					}
				}

				findActions();
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});

			$scope.getUsersByGroups();

			findGroups();
			initMonthAndYears();
		}

		function findActions() {
			//get all actions
			SettingsMessageService.findAllAction($scope.language.key).then(function (actions) {
				$scope.actions = actions.data;
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}

		function findGroups() {
			//get all groups
			groupService.findGroups().then(function (response) {
				$scope.groups = response.data;
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}

		//Init range years and months
		function initMonthAndYears() {
			for (var i = 0; i < 12; i++) {
				$scope.monthNames.push({
					value: i,
					name: $filter('translate')('GENERAL.MONTH_NAMES.' + i)
				});
			}
		}

		function iniStatsMonthValues() {
			for (var i = 0; i < $scope.stats.length; i++) {
				for (var j = 0; j < $scope.stats[i].users.length; j++) {
					var actionsIndexex = {};
					if ($scope.stats[i].statsJSON == undefined) {
						$scope.stats[i].statsJSON = [];
					}
					for (var k = 0; k < $scope.stats[i].users[j].statistics.length; k++) {
						for (var l = 0; l < $scope.stats[i].users[j].statistics[k].nbrByMonth.length; l++) {
							if (actionsIndexex[$scope.stats[i].users[j].statistics[k].action.id] != undefined) {
								$scope.stats[i].statsJSON[actionsIndexex[$scope.stats[i].users[j].statistics[k].action.id]].months[$scope.stats[i].users[j].statistics[k].nbrByMonth[l].month] = $scope.stats[i].users[j].statistics[k].nbrByMonth[l].number;
							} else {
								var action = $scope.stats[i].users[j].statistics[k].action;
								var statJSON = {
									actionName: $scope.stats[i].users[j].user.fullName + ' - ' + action.libelle,
									months: {}
								};

								statJSON.months[$scope.stats[i].users[j].statistics[k].nbrByMonth[l].month] = $scope.stats[i].users[j].statistics[k].nbrByMonth[l].number;
								$scope.stats[i].statsJSON.push(statJSON);
								actionsIndexex[action.id] = $scope.stats[i].statsJSON.length - 1;
							}
						}
					}
				}
			}
		}

		function iniStatsCustomPeriod() {
			for (var i = 0; i < $scope.stats.length; i++) {
				for (var j = 0; j < $scope.stats[i].users.length; j++) {
					if ($scope.stats[i].statsJSON == undefined) {
						$scope.stats[i].statsJSON = [];
					}
					for (var k = 0; k < $scope.stats[i].users[j].statistics.length; k++) {
						var action = $scope.stats[i].users[j].statistics[k].action;
						var statJSON = {
							actionName: $scope.stats[i].users[j].user.fullName + ' - ' + action.libelle,
							value: $scope.stats[i].users[j].statistics[k].nbrAverage
						};

						$scope.stats[i].statsJSON.push(statJSON);
					}
				}
			}

			console.log($scope.stats);
		}

		function initStatsAccrued() {
			for (var i = 0; i < $scope.stats.length; i++) {
				for (var j = 0; j < $scope.stats[i].statsJSON.length; j++) {
					$scope.stats[i].statsJSON[j].monthsAccrued = {};
					var previous = null;
					for (var k = 0; k < 12; k++) {
						if ($scope.stats[i].statsJSON[j].months[k] != undefined) {
							if (previous == null) {
								$scope.stats[i].statsJSON[j].monthsAccrued[k] = $scope.stats[i].statsJSON[j].months[k];
							} else {
								$scope.stats[i].statsJSON[j].monthsAccrued[k] = previous + $scope.stats[i].statsJSON[j].months[k];
							}

							previous = $scope.stats[i].statsJSON[j].monthsAccrued[k];
						} else {
							if (previous != null) {
								$scope.stats[i].statsJSON[j].monthsAccrued[k] = previous;
							}
						}
					}
				}
			}
		}

		function initStatsMessages() {
			$scope.messagesArray = [];
			for (var i = 0; i < $scope.stats.length; i++) {
				for (var j = 0; j < $scope.stats[i].users.length; j++) {
					var msgElt = {
						user: $scope.stats[i].users[j].user.fullName,
						msgs: []
					};
					for (var k = 0; k < $scope.stats[i].users[j].messages.length; k++) {
						msgElt.msgs.push($scope.stats[i].users[j].messages[k]);
					}
					$scope.messagesArray.push(msgElt);
				}
			}

			console.log($scope.messagesArray);
		}

		function initYears() {
			$scope.year.value = now.getFullYear();

			for (var i = -3; i <= 3; i++) {
				$scope.yearValues.push($scope.year.value + i);
			}
		}

		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		init();
		initYears();
	}
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('repartitionStatisticsController', repartitionStatisticsController);

  /** @ngInject */
  function repartitionStatisticsController($scope, $translate, modelService, statisticsService, companyService, STORAGE_PREFIX, STATISTICS_NATIONALITIES, $filter, $rootScope, toastr, $mdDialog, $mdSelect, $window) {
    $scope.typesRepartition = [{
        value: 'CONTACT_MODEL',
        name: $filter('translate')('STATISTICS.REPARTITION.TYPES_REPARTITION.USER')
      },
      {
        value: 'COMPANY_MODEL',
        name: $filter('translate')('STATISTICS.REPARTITION.TYPES_REPARTITION.COMPANY')
      }
    ];

    //Si les trads sont chargées après le controller: les trads n'apparaissent pas
    $rootScope.$on('$translateChangeSuccess', function () {
      $scope.typesRepartition[0].name = $translate.instant('STATISTICS.REPARTITION.TYPES_REPARTITION.USER');
      $scope.typesRepartition[1].name = $translate.instant('STATISTICS.REPARTITION.TYPES_REPARTITION.COMPANY');
    });

    $scope.userValues = {
      typeRepartition: null,
      typeCompany: null,
      field: null,
      typeCompanyContact: null
    };

    $scope.data = {
      typesCompany: [],
      fields: [],
      statistics: [],
      statisticsSubTypes: []
    };

    $scope.chart = {
      data: [],
      labels: [],
      dataSubTypes: {
        companies: [],
        contacts: []
      },
      labelsSubTypes: [],
      options: {
        legend: {
          display: true,
          position: 'right',
          labels: {
            generateLabels: function (chart) {
              var data = chart.data;
              if (data.labels.length && data.datasets.length) {
                return data.labels.map(function (label, i) {
                  var meta = chart.getDatasetMeta(0);
                  var ds = data.datasets[0];
                  var arc = meta.data[i];
                  var custom = arc && arc.custom || {};
                  var getValueAtIndexOrDefault = Chart.helpers.getValueAtIndexOrDefault;
                  var arcOpts = chart.options.elements.arc;
                  var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
                  var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
                  var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

                  // We get the value of the current label
                  var value = chart.config.data.datasets[arc._datasetIndex].data[arc._index];

                  return {
                    // Instead of `text: label,`
                    // We add the value to the string
                    text: label + " : " + value,
                    fillStyle: fill,
                    strokeStyle: stroke,
                    lineWidth: bw,
                    hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                    index: i
                  };
                });
              } else {
                return [];
              }
            }
          }
        }
      }
    };

    $scope.displayChartSubTypes = false;
    var lang;

    if (localStorage.getItem(STORAGE_PREFIX + 'language')) {
      lang = localStorage.getItem(STORAGE_PREFIX + 'language');

      if (!lang) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      }
    } else {
      toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
    }

    $scope.checkTypeRepartition = function () {
      $scope.userValues.typeCompany = null;
      $scope.userValues.field = null;
      emptyChart();
      getCompanyTypes();

      switch ($scope.userValues.typeRepartition) {
        case 'CONTACT_MODEL':
          {
            $scope.displayChartSubTypes = false;
            getFields($scope.userValues.typeRepartition);
            break;
          }

        case 'COMPANY_MODEL':
          {
            $scope.displayChartSubTypes = true;
            getStatisticsSubTypes();
            initTitlesSubTypesCharts();
            break;
          }

      }
    };

    $scope.checkTypeCompany = function () {
      $scope.userValues.field = null;
      $scope.displayChartSubTypes = false;
      emptyChart();

      getFields($scope.userValues.typeRepartition);
    };

    $scope.checkField = function () {
      getStatistics($scope.userValues.typeRepartition);
    };

    function getCompanyTypes() {
      if ($scope.data.typesCompany.length > 0) {
        return;
      } else if ($rootScope.companiesMenus && $rootScope.companiesMenus.length > 0) {
        $scope.data.typesCompany = $rootScope.companiesMenus;
      } else {
        modelService.getSubTypes('./api/rest/model/COMPANY_MODEL', lang, null).then(function (response) {
          //TYPE DE SOCIETE
          $scope.data.typesCompany = response.data;
        }).catch(function (err) {
          console.log(err);
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }
    }

    function getFields(type) {
      switch (type) {
        case 'COMPANY_MODEL':
          {
            modelService.listSelectFieldsFromSubType($scope.userValues.typeCompany, lang).then(function (res) {
              if (res.data) {
                if (res.data.length === 0) {
                  toastr.error($filter('translate')('STATISTICS.REPARTITION.TOAST.NO_SELECT_FIELD_COMPANY'));
                }
                $scope.data.fields = res.data;
              }
            }).catch(function (err) {
              console.log(err);
              toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
            break;
          }
        case 'CONTACT_MODEL':
          {
            modelService.listSelectFieldsFromType($scope.userValues.typeRepartition, lang).then(function (res) {
              if (res.data) {
                if (res.data.length === 0) {
                  toastr.error($filter('translate')('STATISTICS.REPARTITION.TOAST.NO_SELECT_FIELD_CONTACT'));
                }

                $scope.data.fields = res.data;
              }
            }).catch(function (err) {
              console.log(err);
              toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
            break;
          }
      }
    }

    function getStatistics(type) {
      switch (type) {
        case 'COMPANY_MODEL':
          {
            statisticsService.getStatisticRepartitionCompany($scope.userValues.typeCompany, $scope.userValues.field, lang).then(function (res) {
              if (res.data) {
                $scope.data.statistics = res.data;
                if (res.data.length === 0) {
                  toastr.error($filter('translate')('STATISTICS.REPARTITION.TOAST.NO_DATA_TO_DISPLAY'));
                }
              } else {
                $scope.data.statistics = [];
                toastr.error($filter('translate')('STATISTICS.REPARTITION.TOAST.NO_DATA_TO_DISPLAY'));
              }
              initChart();
            }).catch(function (err) {
              console.log(err);
              toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
            break;
          }
        case 'CONTACT_MODEL':
          {
            if($scope.userValues.field == null) {
              return;
            }

            statisticsService.getStatisticRepartitionContact($scope.userValues.field, lang, $scope.userValues.typeCompanyContact).then(function (res) {
              if (res.data) {
                $scope.data.statistics = res.data;
                if (res.data.length === 0) {
                  toastr.error($filter('translate')('STATISTICS.REPARTITION.TOAST.NO_DATA_TO_DISPLAY'));
                }
              } else {
                $scope.data.statistics = [];
                toastr.error($filter('translate')('STATISTICS.REPARTITION.TOAST.NO_DATA_TO_DISPLAY'));
              }
              initChart();
            }).catch(function (err) {
              console.log(err);
              toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
            break;
          }
      }
    }

    function getStatisticsSubTypes() {
      if ($scope.data.statisticsSubTypes.length === 0) {
        statisticsService.getStatisticsByCompanyTypes(lang).then(function (res) {
          console.log(res.data);
          if (res.data) {
            $scope.data.statisticsSubTypes = res.data;
            iniChartSubTypes();
          }
        }).catch(function (err) {
          console.log(err);
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }
    }

    function initChart() {
      emptyChart();

      if ($scope.data.statistics && $scope.data.statistics.length > 0) {
        for (var i = 0; i < $scope.data.statistics.length; i++) {
          $scope.chart.labels.push($scope.data.statistics[i].value);
          $scope.chart.data.push($scope.data.statistics[i].number);
        }
      }
    }

    function iniChartSubTypes() {
      for (var i = 0; i < $scope.data.statisticsSubTypes.length; i++) {
        $scope.chart.labelsSubTypes.push($scope.data.statisticsSubTypes[i].companyType);
        $scope.chart.dataSubTypes.companies.push($scope.data.statisticsSubTypes[i].nbrCompanies);
        $scope.chart.dataSubTypes.contacts.push($scope.data.statisticsSubTypes[i].nbrContacts);
      }

      console.log($scope.chart.dataSubTypes);
    }

    function emptyChart() {
      $scope.chart.data = [];
      $scope.chart.labels = [];
    }

    function initTitlesSubTypesCharts() {
      $scope.chart.optionsContacts = angular.copy($scope.chart.options);
      $scope.chart.optionsContacts.title = {
        display: true,
        text: $filter('translate')('STATISTICS.REPARTITION.TITLE_CONTACTS_CHART'),
        fontSize: 22
      };
      $scope.chart.optionsCompanies = angular.copy($scope.chart.options);
      $scope.chart.optionsCompanies.title = {
        display: true,
        text: $filter('translate')('STATISTICS.REPARTITION.TITLE_COMPANIES_CHART'),
        fontSize: 22
      };
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.controller('displayStatisticsController', displayStatisticsController);

	/** @ngInject */
	function displayStatisticsController($scope, userService, $translate, statisticsService, modelService, companyService, STORAGE_PREFIX, STATISTICS_NATIONALITIES, $filter, $rootScope, toastr, $mdDialog, $mdSelect, $window) {
		//Useful variables
		var now = new Date();
		var langage = localStorage[STORAGE_PREFIX + 'language'];

		$scope.filter = {
			begin: {
				year: now.getFullYear(),
				month: now.getMonth()
			},
			end: {
				year: now.getFullYear(),
				month: now.getMonth()
			},
			category: null,
			region: null,
			companyID: null,
			nationality: null,
			order: {
				name: null,
				inverse: false
			},
			onlyAverage: false,
			specificFieldsArray: [],
			associationsIDs: null
		};
		$scope.filterFirstPeriod = angular.copy($scope.filter);
		$scope.filterFirstPeriod.onlyAverage = true;
		$scope.filterSecondPeriod = angular.copy($scope.filterFirstPeriod);
		$scope.nationalities = {};
		$scope.companies = [];
		$scope.specificFieldsValue = {};
		$scope.loaded = false;
		$scope.loading = {
			filter: false,
			compare: false
		};

		//order name = 's.company.customer.name'
		$scope.monthNames = [];
		$scope.yearValues = [];
		$scope.customYear = {
			filter: {
				begin: null,
				end: null
			},
			compare: {
				firstPeriod: {
					begin: null,
					end: null
				},
				secondPeriod: {
					begin: null,
					end: null
				}
			}
		};
		$scope.statisticsArray = [];
		$scope.statisticsNatArray = [];
		$scope.statisticsCompare = [];
		$scope.specificFields = [];
		$scope.filterMode = true;
		var filedTypes = [
			'CATEGORY',
			'REGION'
		];

		companyService.findForStatistics($translate.preferredLanguage()).then(function (res) {
			if (res.data) {
				$scope.companies = res.data;
			}
		}).catch(function (err) {
			console.log(err);
			toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_COMPANIES'));
		});

		modelService.findSpecificsByMultipleTypes('./api/rest/model/COMPANY_MODEL', $translate.preferredLanguage(), filedTypes).then(function (res) {
			console.log(res.data);
			$scope.specificFields = res.data;
		}).catch(function (err) {
			console.log(err);
		});

		//Helper
		var validateYearFormat = function (year) {
			if (year >= (now.getFullYear() - 100) && year <= (now.getFullYear() + 100)) {
				return true;
			}

			return false;
		};

		//Init range years and months
		var initMonthAndYears = function () {
			for (var i = 0; i < 12; i++) {
				$scope.monthNames.push({
					value: i,
					name: $filter('translate')('GENERAL.MONTH_NAMES.' + i)
				});
			}

			var yearNow = now.getFullYear();

			for (var j = -3; j <= 3; j++) {
				$scope.yearValues.push(yearNow + j);
			}
		};

		initMonthAndYears();

		//For iput select year
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		$scope.searchStatisticsCustomYear = function (begin) {
			var customYear;
			var period;

			if (begin) {
				customYear = $scope.customYear.filter.begin;
				period = $scope.filter.begin;
			} else {
				customYear = $scope.customYear.filter.end;
				period = $scope.filter.end;
			}
			if (validateYearFormat(customYear)) {
				period.year = 'custom';
				$mdSelect.hide();
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}

		};

		$scope.searchStatisticsCompareCustomYear = function (firstPeriod, begin) {
			var customYear;
			var period;

			if (firstPeriod) {
				if (begin) {
					customYear = $scope.customYear.compare.firstPeriod.begin;
					period = $scope.filterFirstPeriod.begin;
				} else {
					customYear = $scope.customYear.compare.firstPeriod.end;
					period = $scope.filterFirstPeriod.end;
				}
			} else {
				if (begin) {
					customYear = $scope.customYear.compare.secondPeriod.begin;
					period = $scope.filterSecondPeriod.begin;
				} else {
					customYear = $scope.customYear.compare.secondPeriod.end;
					period = $scope.filterSecondPeriod.end;
				}
			}

			if (validateYearFormat(customYear)) {
				period.year = 'custom';
				$mdSelect.hide();
			} else {
				period.year = now.getFullYear();
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}

		};

		var getFilter = function (filter) {
			if ($scope.filter.begin.year === 'custom') {
				filter.begin.year = angular.copy($scope.customYearBegin);
			}

			if ($scope.filter.end.year === 'custom') {
				filter.end.year = angular.copy($scope.customYearEnd);
			}

			if (new Date(filter.begin.year, filter.begin.month, 1) > new Date(filter.end.year, filter.end.month, 1)) {
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INVALID_PERIOD'));
				return null;
			}

			filter.specificFieldsArray = [];
			console.log($scope.specificFieldsValue);
			angular.forEach($scope.specificFieldsValue, function (value, key) {
				if (value) {
					filter.specificFieldsArray.push({
						id: key,
						idValue: value
					});
				}
			});

			return filter;
		};

		$scope.switchMode = function () {
			$scope.filterMode = !$scope.filterMode;
		};

		$scope.getStatsCompanies = function () {

			var filter = getFilter($scope.filter);

			if (filter === null) {
				return;
			}
			$scope.loaded = false;
			$scope.loading.filter = true;
			statisticsService.filter(filter, $translate.preferredLanguage()).then(function (res) {
				if (res.data) {
					$scope.statisticsArray = res.data;
					$scope.loaded = true;
				}
				$scope.loading.filter = false;
			}).catch(function (err) {
				$scope.loaded = true;
				$scope.loading.filter = false;
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_RESULTS'));
				console.log(err);
			});
		};

		$scope.downloadCompanies = function () {
			var filter = getFilter($scope.filter);

			if (filter === null) {
				return;
			}

			statisticsService.generateCompanies(filter, $translate.preferredLanguage()).then(function (res) {
				console.log(res);
			}).catch(function (err) {
				console.log(err);
			});
		};

		$scope.downloadNationalities = function () {
			var filter = getFilter($scope.filter);

			if (filter === null) {
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INCORRECT_CRITERIAS_SEARCH'));
				return;
			}

			// statisticsService.download(filter).then(function (res) {

			// }).catch(function (err) {
			//   toastr.error('Erreur lors de la génération du document');
			//   console.log(err);
			// });
			statisticsService.generateNationalities(filter).then(function (res) {
				console.log(res);
			}).catch(function (err) {
				console.log(err);
			});
		};

		$scope.getStatsNationalities = function () {
			var filter = getFilter($scope.filter);

			if (filter === null) {
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INCORRECT_CRITERIAS_SEARCH'));
				return;
			}

			$scope.loading.filter = true;

			statisticsService.getStatsNationalities(filter).then(function (res) {
				if (res.data != null) {
					$scope.statisticsNatArray = res.data;
				}
				$scope.loading.filter = false;
			}).catch(function (err) {
				console.log(err);
				$scope.loading.filter = false;
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_STATS_NATIONALITIES'));
			});
		};

		initRights();
		$scope.getStatsCompanies();
		$scope.getStatsNationalities();

		$scope.getStatsCompareCompanies = function () {
			var filterFirstPeriod = getFilter($scope.filterFirstPeriod);
			var filterSecondPeriod = getFilter($scope.filterSecondPeriod);

			if (filterFirstPeriod === null || filterSecondPeriod === null) {
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INCORRECT_CRITERIAS_SEARCH'));
				return;
			}

			$scope.loading.compare = true;

			statisticsService.compare([filterFirstPeriod, filterSecondPeriod], $translate.preferredLanguage()).then(function (res) {
				if (res.data != null) {
					$scope.statisticsCompare = res.data;
					initStatsCompare();
					//$scope.statisticsCompare[0] = $filter('orderBy')($scope.statisticsCompare[0], 'companyID');
					//$scope.statisticsCompare[1] = $filter('orderBy')($scope.statisticsCompare[1], 'companyID');
				}
				$scope.loading.compare = false;
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_RESULTS'));
			});
		};

		function initStatsCompare() {
			for (var i = 0; i < $scope.statisticsCompare[0].length; i++) {
				var stat1 = $scope.statisticsCompare[0][i].statistics[0];
				var stat2 = $scope.statisticsCompare[1][i].statistics[0];

				stat1.evoNbrArrivals = Math.round((stat2.nbrArrivals != null && stat1.nbrArrivals != null && stat1.nbrArrivals !== 0) ? ((stat2.nbrArrivals - stat1.nbrArrivals) * 100 / stat1.nbrArrivals) : 0);
				stat1.evoNbrDepartures = Math.round((stat2.nbrDepartures != null && stat1.nbrDepartures != null && stat1.nbrDepartures !== 0) ? ((stat2.nbrDepartures - stat1.nbrDepartures) * 100 / stat1.nbrDepartures) : 0);
				stat1.evoNbrRooms = Math.round((stat2.nbrRooms != null && stat1.nbrRooms != null && stat1.nbrRooms !== 0) ? ((stat2.nbrRooms - stat1.nbrRooms) * 100 / stat1.nbrRooms) : 0);
				stat1.evoIncomeOnMonth = Math.round((stat2.incomeOnMonth != null && stat1.incomeOnMonth != null && stat1.incomeOnMonth !== 0) ? ((stat2.incomeOnMonth - stat1.incomeOnMonth) * 100 / stat1.incomeOnMonth) : 0);
				stat1.evoAverageDurationStay = Math.round((stat2.averageDurationStay != null && stat1.averageDurationStay != null && stat1.averageDurationStay !== 0) ? ((stat2.averageDurationStay - stat1.averageDurationStay) * 100 / stat1.averageDurationStay) : 0);
				stat1.occupationRate = Math.round((stat1.nbrOccupedRooms != null && stat1.nbrRooms != null && stat1.nbrRooms !== 0) ? ((stat1.nbrOccupedRooms / stat1.nbrRooms) * 100) : 0);
				stat2.occupationRate = Math.round((stat2.nbrOccupedRooms != null && stat2.nbrRooms != null && stat2.nbrRooms !== 0) ? ((stat2.nbrOccupedRooms / stat2.nbrRooms) * 100) : 0);
				stat1.evoOccupationRate = Math.round((stat2.occupationRate != null && stat1.occupationRate != null && stat1.occupationRate !== 0) ? ((stat2.occupationRate - stat1.occupationRate) * 100 / stat1.occupationRate) : 0);
				stat1.evoNbrEmployeesFullTime = Math.round((stat2.nbrEmployeesFullTime != null && stat1.nbrEmployeesFullTime != null && stat1.nbrEmployeesFullTime !== 0) ? ((stat2.nbrEmployeesFullTime - stat1.nbrEmployeesFullTime) * 100 / stat1.nbrEmployeesFullTime) : 0);
				stat1.evoNbrEmployeesPartTime = Math.round((stat2.nbrEmployeesPartTime != null && stat1.nbrEmployeesPartTime != null && stat1.nbrEmployeesPartTime !== 0) ? ((stat2.nbrEmployeesPartTime - stat1.nbrEmployeesPartTime) * 100 / stat1.nbrEmployeesPartTime) : 0);
			}

			$scope.statisticsCompare[0] = $filter('orderBy')($scope.statisticsCompare[0], 'company');
			$scope.statisticsCompare[1] = $filter('orderBy')($scope.statisticsCompare[1], 'company');
		}

		function initRights() {
			console.log('initRights');
			console.log(userService.isUserAdmin());
			console.log($rootScope.user.associationIds);
			if (userService.isUserAdmin()) {

			} else if (userService.isUserLinkedToAssociations()) {
				$scope.filter.associationsIDs = angular.copy($rootScope.user.associationIds);
			} else {
				console.log('noooo');
			}
		}

		// window.mdSelectOnKeyDownOverride = function (event) {
		// 	event.stopPropagation();
		// };
	}
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.controller('editStatisticsController', editStatisticsController);

	/** @ngInject */
	function editStatisticsController($scope, $translate, statisticsService, companyService, $filter, $state, $rootScope, toastr, $mdDialog, $mdSelect, userService) {
		//Constants
		var now = new Date();

    var emptystatNationality = {
      nationality: null,
      nbrLeavings: null,
      nbrArrivals: null,
      nbrNights: null
    };
    var emptyStats = {
      companyID: null,
      statsNationality: [
        emptystatNationality
      ]
    };
    $scope.nationalities = [];
    $scope.monthNames = [];
    $scope.yearValues = [];
    $scope.customYear = null;
    $scope.overwriteMode = false;
		$scope.selectedCompanyID = null;
		$scope.selectCompany = {
			id: null
		};
		$scope.isAdmin = false;
    $scope.companies = [];
    $scope.statistics = angular.copy(emptyStats);
    $scope.selectedPeriod = {
      month: now.getMonth(),
      year: now.getFullYear(),
      companyID: null
    };

		var getCompanies = function () {
			companyService.findForStatistics($translate.preferredLanguage()).then(function (res) {
				if (res.data) {
					$scope.companies = res.data;
				}
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('STATISTICS.DISPLAY.ERROR_GET_COMPANIES'));
			});
		};

		var validateYearFormat = function (year) {
			if (year >= 1900 && year <= 2100) {
				return true;
			}
			return false;
		};

		var checkCorrectNbrRooms = function () {
			if ($scope.statistics.nbrOccupedRooms != null && $scope.statistics.nbrRooms != null) {
				if ($scope.statistics.nbrOccupedRooms > $scope.statistics.nbrRooms) {
					return false;
				}
			}

			return true;
		};

    $scope.removeNationalityAlreadyUsed = function() {
      $scope.nationalities = angular.copy($scope.nationalitiesCopy);

      for (var i = 0; i < $scope.statistics.statsNationality.length; i++) {
        for (var y = 0; y < $scope.nationalities.length; y++) {
          if ($scope.statistics.statsNationality[i].nationality != null && $scope.nationalities[y].id === $scope.statistics.statsNationality[i].nationality.id) {
            $scope.nationalities[y].alreadyHere = true;
            break;
          }
        }
      }
    };

		var initMonthAndYears = function () {
			for (var i = 0; i < 12; i++) {
				$scope.monthNames.push({
					value: i,
					name: $filter('translate')('GENERAL.MONTH_NAMES.' + i)
				});
			}

			var yearNow = now.getFullYear();

      for (var j = -3; j <= 3; j++) {
        $scope.yearValues.push(yearNow + j);
      }
    };

		$scope.getStatistics = function () {
			var period = angular.copy($scope.selectedPeriod);

			if (period.year === 'custom') {
				if (validateYearFormat($scope.customYear)) {
					period.year = angular.copy($scope.customYear);
				} else {
					toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_DATE'));
					return;
				}
			}

			if ($scope.selectedCompanyID != null) {
				period.companyID = $scope.selectedCompanyID;
			} else if ($scope.selectCompany.id != null) {
				period.companyID = $scope.selectCompany.id;
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.ERROR_SELECT_COMPANY'));
				return;
			}

      statisticsService.getNationalities($translate.preferredLanguage()).then(function(response){
        $scope.nationalities = response.data;
        $scope.nationalitiesCopy = angular.copy($scope.nationalities);
        statisticsService.get(period).then(function (res) {
          if (res.data) {
            $scope.statistics = res.data;
            if ($scope.statistics.statsNationality == null || $scope.statistics.statsNationality.length === 0) {
              $scope.addNationality();
            }
            $scope.removeNationalityAlreadyUsed();
            $scope.overwriteMode = true;
          } else {
            $scope.statistics = angular.copy(emptyStats);
            $scope.removeNationalityAlreadyUsed();
            $scope.overwriteMode = false;
          }
        }).catch(function (err) {
          toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.ERROR_STATISTICS'));
          console.log(err);
        });
      }).catch(function(){
  
      });
     
    };

		initMonthAndYears();
		//$scope.getStatistics();

		//For iput select year
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		$scope.searchStatisticsCustomYear = function () {
			if (validateYearFormat($scope.customYear)) {
				$scope.selectedPeriod.year = 'custom';
				$mdSelect.hide();
				$scope.getStatistics();
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}

		};

		$scope.save = function () {
			if (!checkCorrectNbrRooms()) {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.ERROR_NBR_ROOMS'));
				return;
			}

			if (!!$scope.overwriteMode) {
				$scope.content = {
					message: $filter('translate')('STATISTICS.EDIT.POP_UP.MESSAGE'),
					title: $filter('translate')('STATISTICS.EDIT.POP_UP.TITLE')
				};
				$mdDialog.show({
					templateUrl: 'app/main/popup/confirm.html',
					clickOutsideToClose: true,
					scope: $scope,
					preserveScope: true
				}).then(function () {}).catch(function () {});
			} else {
				$scope.confirmAction();
			}
		};

		$scope.confirmAction = function () {
			var dto = angular.copy($scope.statistics);

			if (!$scope.overwriteMode) {
				if ($scope.selectedPeriod.year === 'custom') {
					if (validateYearFormat($scope.customYear)) {
						dto.year = angular.copy($scope.customYear);
					} else {
						toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_DATE'));
						return;
					}
				} else {
					dto.year = angular.copy($scope.selectedPeriod.year);
				}
				dto.month = angular.copy($scope.selectedPeriod.month);
			}

			if ($scope.selectedCompanyID != null) {
				dto.companyID = $scope.selectedCompanyID;
			} else if ($scope.selectCompany.id != null) {
				dto.companyID = $scope.selectCompany.id;
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.ERROR_SELECT_COMPANY'));
				return;
			}

			for (var i = 0; i < dto.statsNationality.length; i++) {
				if (!dto.statsNationality[i].nationality) {
					dto.statsNationality.splice(i, 1);
				}
			}

      statisticsService.save(dto, $translate.preferredLanguage()).then(function (res) {
        if (res.data) {
          $scope.statistics = res.data;
          if ($scope.statistics.statsNationality == null || $scope.statistics.statsNationality.length === 0) {
            $scope.addNationality();
          }
          toastr.success($filter('translate')('STATISTICS.EDIT.TOAST.SUCCESS_UPDATE'));
          if ($scope.overwriteMode) {
            $scope.hidePopup();
          }
        } else {
          toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.ERROR_RELOAD'));
        }
      }).catch(function (err) {
        toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.ERROR_UPDATE'));
      });
    };

		$scope.hidePopup = function () {
			$mdDialog.hide();
		};

    $scope.addNationality = function() {
      $scope.removeNationalityAlreadyUsed();
      $scope.statistics.statsNationality.push(angular.copy(emptystatNationality));
    };

		$scope.removeNationality = function (index) {
			$scope.statistics.statsNationality.splice(index, 1);
			$scope.removeNationalityAlreadyUsed();
		};

		//On check ici car on a besoin de fonctions définies ci-dessus
		if (!$rootScope.user) {
			var wait = $scope.$on('rooScopeUser:ready', function () {
				if (userService.canUserEditStats()) {
					if ($rootScope.user.company && $rootScope.user.company.id) {
						$scope.selectedCompanyID = $rootScope.user.company.id;
						$scope.getStatistics();
						wait();
					} else {
						$scope.selectedCompanyID = null;
						$scope.isAdmin = true;
						getCompanies();
					}
				} else {
					$state.go('app.statistics.display');
				}
			});
		} else {
			if (userService.canUserEditStats()) {
				if ($rootScope.user.company && $rootScope.user.company.id) {
					$scope.selectedCompanyID = $rootScope.user.company.id;
					$scope.getStatistics();
				} else {
					$scope.selectedCompanyID = null;
					$scope.isAdmin = true;
					getCompanies();
				}
			} else {
				$state.go('app.statistics.display');
			}
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.controller('automaticStatisticsController', automaticStatisticsController);

	/** @ngInject */
	function automaticStatisticsController($scope, statisticsService, modelService, companyService, STORAGE_PREFIX, STATISTICS_NATIONALITIES, $filter, $rootScope, toastr, $mdDialog, $mdSelect, $window) {
		$scope.statistics = [];
		$scope.yearValues = [];
		$scope.typesCompany = [];
		$scope.customYear = null;
		$scope.chart = null;
		$scope.year = null;
		$scope.filter = {
			typeID: null,
			year: null
		};
		var now = new Date();
		var lang;

		//For iput select year
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		var validateYearFormat = function (year) {
			if (year >= (now.getFullYear() - 100) && year <= (now.getFullYear() + 100)) {
				return true;
			}

			return false;
		};

		function initYears() {
			$scope.year = now.getFullYear();

			for (var i = -3; i <= 3; i++) {
				$scope.yearValues.push($scope.year + i);
			}
		}

		function initChartData() {
			initEmptyChart();
			for (var i = 0; i < $scope.statistics.length; i++) {
				$scope.chart.labels.push($filter('translate')('GENERAL.MONTH_NAMES.' + ($scope.statistics[i].month - 1)));
				$scope.chart.data[0].push($scope.statistics[i].nbrCompanies);
				$scope.chart.data[1].push($scope.statistics[i].nbrUsers);
			}
		}

		$scope.searchStatisticsCustomYear = function () {
			if (validateYearFormat($scope.customYear)) {
				$scope.year = 'custom';
				$scope.getStatistics();
				$mdSelect.hide();
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}
		};

		$scope.getStatistics = function () {
			var year;

			if ($scope.year === 'custom') {
				year = angular.copy($scope.customYear);
			} else if ($scope.year === 'all') {
				year = null;
			} else {
				year = angular.copy($scope.year);
			}

			$scope.filter.year = year;

			$scope.statistics = [];

			statisticsService.getStatisticsAutomatic($scope.filter).then(function (res) {
				if (res.data) {
					$scope.statistics = res.data;
					initChartData();
				} else {
					toastr.error($filter('translate')('STATISTICS.AUTOMATIC.TOAST.NO_GET'));
				}
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('STATISTICS.AUTOMATIC.TOAST.ERROR_GET'));
			});
		};

		function getCompanyTypes() {
			if ($rootScope.companiesMenus && $rootScope.companiesMenus.length > 0) {
				$scope.typesCompany = $rootScope.companiesMenus;
			} else {
				modelService.getSubTypes('./api/rest/model/COMPANY_MODEL', lang, null).then(function (response) {
					//TYPE DE SOCIETE
					$scope.typesCompany = response.data;
				}).catch(function (err) {
					console.log(err);
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}
		}

		function initEmptyChart() {
			$scope.chart = {
				data: [
					[],
					[]
				],
				labels: [],
				series: [$filter('translate')('STATISTICS.AUTOMATIC.TABLE.NBR_COMPANIES'), $filter('translate')('STATISTICS.AUTOMATIC.TABLE.NBR_USERS')],
				options: {
					scales: {
						yAxes: [{
								id: 'y-axis-1',
								type: 'linear',
								display: true,
								position: 'left'
							},
							{
								id: 'y-axis-2',
								type: 'linear',
								display: true,
								position: 'right'
							}
						]
					}
				},
				datasetOverride: [{
					yAxisID: 'y-axis-1'
				}, {
					yAxisID: 'y-axis-2'
				}]
			};
		}

		function init() {
			initEmptyChart();

			if (localStorage.getItem(STORAGE_PREFIX + 'language')) {
				lang = localStorage.getItem(STORAGE_PREFIX + 'language');

				if (!lang) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}
			} else {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			}

			initYears();
			$scope.getStatistics();
			getCompanyTypes();
		}

		init();
	}
})();

(function () {
    'use strict';

    angular.module('app.front').controller('SitesController', SitesController);

    function SitesController($rootScope, $scope, $timeout, $filter, $state, $translate, $mdDialog, toastr, SitesManagementService, languageService, URL) {

        $scope.$mdDialog = $mdDialog;

        $scope.sites = [];
        $scope.site = {};

        $scope.languages = [];

        $scope.search = {};

        languageService.getLanguages().then(function (response) {
            $scope.languages = response.data;
        }).catch(function (error) {
            console.log(error);
		});
		
		SitesManagementService.findAll('sites').then(function (response) {
            $scope.sites = response.data;

            angular.forEach($scope.sites, function(itemSite, indexSite) {

                itemSite.languagesTmp = angular.copy(itemSite.languages);

                var _defaultLanguageFound = false;

                angular.forEach(itemSite.languagesTmp, function(itemLang, indexLang) {
                    if(itemSite.defaultLanguage && !_defaultLanguageFound && itemLang.key == itemSite.defaultLanguage.key) {
                        _defaultLanguageFound = true;
                        itemLang.defaultLanguage = true;
                    }
                    itemLang.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + itemLang.key);
                });

                if(itemSite.defaultLanguage && !_defaultLanguageFound) {
                    itemSite.defaultLanguage.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + itemSite.defaultLanguage.key);
                    itemSite.defaultLanguage.defaultLanguage = true;
                    itemSite.languagesTmp.push(angular.copy(itemSite.defaultLanguage));
                }

            });

        }).catch(function (error) {
            console.log(error);
        });

        $scope._dialogFn = function(site){

            $scope.site = {};
            if(site) {
                $scope.site = angular.copy(site);
                SitesManagementService.findById($scope.site.id).then(function(response){
                    $scope.site.css = response.data.css;
                }).catch(function(){

                });

                // Logo
                if ($scope.site.logo != null){
                    $scope.site.src = URL.alternatedocroots + '/' + $scope.site.logo;
                }

                SitesManagementService.findPagesBySiteID($scope.site.id).then(function (response) {
                    $scope.pages = response.data;
                }).catch(function (error) {
                    console.log(error);
                });

            }

            $timeout(function(){
                $scope.$mdDialog.show({
                    templateUrl: 'app/main/sites_management/sites/site.dialog.html',
                    preserveScope: true,
                    clickOutsideToClose: true,
                    scope: $scope,
                }).then(function(resp){
                }).catch(function(err){
                });
            });
            
		};

        $scope._save = function(_form) {

            _form.$setSubmitted();
            if (_form.$valid){

                var fmData = new FormData();
                fmData.append('dto', angular.toJson($scope.site));
                var input = document.getElementById('site_logo');
                if (input != null && input.files != null && input.files.length > 0){
                    fmData.append('file', input.files[0]);
                } 

                SitesManagementService.saveFd('site', fmData).then(function(response){

                    response.data.languagesTmp = angular.copy(response.data.languages);

                    var _defaultLanguageFound = false;

                    angular.forEach(response.data.languagesTmp, function(itemLang, indexLang) {
                        if(response.data.defaultLanguage && !_defaultLanguageFound && itemLang.key == response.data.defaultLanguage.key) {
                            _defaultLanguageFound = true;
                            itemLang.defaultLanguage = true;
                        }
                        itemLang.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + itemLang.key);
                    });

                    if(response.data.defaultLanguage && !_defaultLanguageFound) {
                        response.data.defaultLanguage.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + response.data.defaultLanguage.key);
                        response.data.defaultLanguage.defaultLanguage = true;
                        response.data.languagesTmp.push(angular.copy(response.data.defaultLanguage));
                    }


                    if($scope.site.id) {
                        var index = $scope.sites.map(function(mapper) { return mapper.id; }).indexOf($scope.site.id);
                        if(index > -1) {
                            $scope.sites[index] = response.data;
                        }
                    } else {
                        $scope.sites.push(response.data);
                    }

                    _form.$setPristine();
                    _form.$setUntouched();
                    $mdDialog.cancel();
                }).catch(function(error){
                    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                });
            
            }
        };

        $scope._delete = function() {
            SitesManagementService.delete('site', $scope.site.id).then(function(response){
				var index = $scope.sites.map(function(mapper) { return mapper.id; }).indexOf($scope.site.id);
				if(index > -1) {
					$scope.sites.splice(index, 1);
				}
				$mdDialog.cancel();
			}).catch(function(error){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
        };

    }
    
})();
(function () {
  'use strict';

  angular.module('app.front').controller('SiteMenuController', SiteMenuController);

  function SiteMenuController($scope, $rootScope, SitesManagementService, toastr, languageService, $filter) {
    $scope.sites = [];
    $scope.siteID = null;
    $scope.siteMenu = {};
    $scope.languages = [];
    $scope.language = {};
    $scope.pages = [];
    var emptyItem = {
      sideMenuID: null,
      level: 0,
      title: null,
      pageID: null,
      subItems: [],
      menuItemParentID: null
    };

    init();

    function init() {
      SitesManagementService.findAll('sites').then(function (res) {
        if (res.data) {
          $scope.sites = res.data;
        }
      }).catch(function (err) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });

      languageService.getLanguages().then(function (response) {
        $scope.languages = response.data;
        for (var i = 0; i < $scope.languages.length; i++) {
          var language = $scope.languages[i];
          if (language.preferred) {
            $scope.language.key = language.key;
            break;
          }
        }
      }).catch(function (error) {

      });
    }

    $scope.getSiteMenu = function () {
      SitesManagementService.findSiteMenuBySiteID($scope.siteID, $scope.language.key).then(function (res) {
        if (res.data) {
          $scope.siteMenu = res.data;
        }
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.getSitePages = function () {
      SitesManagementService.findPagesBySiteID($scope.siteID).then(function (res) {
        if (res.data) {
          $scope.pages = res.data;
        }
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.addItem = function (level, menuItemParentID) {
      var newItem = angular.copy(emptyItem);

      newItem.sideMenuID = $scope.siteMenu.id;
      newItem.level = level;
      newItem.menuItemParentID = menuItemParentID;

      SitesManagementService.saveSiteMenuItem(newItem, $scope.language.key).then(function (res) {
        if (level === 0) {
          $scope.siteMenu.items.push(res.data);
        } else if (level === 1) {
          for (var i = 0; i < $scope.siteMenu.items.length; i++) {
            if ($scope.siteMenu.items[i].id === menuItemParentID) {
              if (!$scope.siteMenu.items[i].subItems) {
                $scope.siteMenu.items[i].subItems = [];
              }

              $scope.siteMenu.items[i].subItems.push(res.data);
              break;
            }
          }
        } else if (level === 2) {
          for (var i = 0; i < $scope.siteMenu.items.length; i++) {
            for (var y = 0; y < $scope.siteMenu.items[i].subItems.length; y++) {
              if ($scope.siteMenu.items[i].subItems[y].id === menuItemParentID) {
                if (!$scope.siteMenu.items[i].subItems[y].subItems) {
                  $scope.siteMenu.items[i].subItems[y].subItems = [];
                }

                $scope.siteMenu.items[i].subItems[y].subItems.push(res.data);
              }
            }
          }
        }
        //$scope.getSiteMenu();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.saveItem = function (item) {
      SitesManagementService.saveSiteMenuItem(item, $scope.language.key).then(function (res) {}).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.deleteItem = function (item) {
      if (item.id == null) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      }
      SitesManagementService.deleteSiteMenuItem(item.id).then(function (res) {
        $scope.getSiteMenu();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.downItem = function (item, indexItem, indexSubItem, indexSubSubItem) {
      var dto = angular.copy(item);
      dto.sideMenuID = $scope.siteMenu.id;
      SitesManagementService.downSiteMenuItem(dto).then(function (res) {
        reOrder(false, indexItem, indexSubItem, indexSubSubItem);
      }).catch(function (err) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        console.log(err);
      });
    };

    $scope.upItem = function (item, indexItem, indexSubItem, indexSubSubItem) {
      var dto = angular.copy(item);
      dto.sideMenuID = $scope.siteMenu.id;
      SitesManagementService.upSiteMenuItem(dto).then(function (res) {
        reOrder(true, indexItem, indexSubItem, indexSubSubItem);
      }).catch(function (err) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        console.log(err);
      });
    };

    function reOrder(up, indexItem, indexSubItem, indexSubSubItem) {
      var toMove;
      var toExchange;
      var indexAdd;

      if (up) {
        indexAdd = -1;
      } else {
        indexAdd = 1;
      }

      toMove = $filter('filter')($scope.siteMenu.items, {
        index: indexItem
      })[0];

      if (indexSubItem == null && indexSubSubItem == null) {
        toExchange = $filter('filter')($scope.siteMenu.items, {
          index: indexItem + indexAdd
        })[0];
      }

      if (indexSubItem != null) {
        if (indexSubSubItem == null) {
          toExchange = $filter('filter')(toMove.subItems, {
            index: indexSubItem + indexAdd
          })[0];
        }
        toMove = $filter('filter')(toMove.subItems, {
          index: indexSubItem
        })[0];
      }

      if (indexSubSubItem != null) {
        toExchange = $filter('filter')(toMove.subItems, {
          index: indexSubSubItem + indexAdd
        })[0];
        toMove = $filter('filter')(toMove.subItems, {
          index: indexSubSubItem
        })[0];
      }

      if (up) {
        toMove.index -= 1;
        toExchange.index += 1;
      } else {
        toExchange.index -= 1;
        toMove.index += 1;
      }

    }
  }
})();

(function () {
    'use strict';

    angular.module('app.front').controller('PagesController', PagesController);

    function PagesController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, SitesManagementService) {

        $scope.pages = [];

        $scope.sites = [];
        $scope.blocs = [];

        $scope.search = {};

        // Sites
        SitesManagementService.findAll('sites').then(function(response){
            $scope.sites = response.data;
        }).catch(function(error){
            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });

        // Blocs
        SitesManagementService.findAll('blocs').then(function(response){
            $scope.blocs = response.data;
        }).catch(function(error){
            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });

        //Pages
        SitesManagementService.findAll('pages').then(function (response) {
            $scope.pages = response.data;
        }).catch(function (error) {
            console.log(error);
        });

        $scope._pageDetailsFn = function(id) {
            $state.go("app.pages.page", { id : id });
        };

    }
    
})();
(function () {
	'use strict';

	angular.module('app.front').controller('BlocsController', BlocsController);

	function BlocsController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, SitesManagementService) {

		$scope.blocs = [];

		$scope.types = SitesManagementService.getBlocTypes();

		$scope.search = {};

		SitesManagementService.findAll('blocs').then(function (response) {
			$scope.blocs = response.data;
		}).catch(function (error) {
			console.log(error);
		});

		$scope._blocDetailsFn = function (id) {
			$state.go("app.blocs.bloc", {
				id: id
			});
		};

	}

})();

(function () {
	'use strict';

	angular.module('sitegen.site').service('WorkbookService', WorkbookService);

	function WorkbookService($q, $http, $filter, $location, toastr) {

		var service = {};


		service.getCC = function(){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/getCCFromConnectedUser',
					method: 'GET',
					params: { '_v': new Date().getTime()},
					headers: { 'Content-Type': undefined }
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (error) {
					reject(error);
				});
			});
		}

		service.getLogo = function (cahier) {

			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/logo/'+cahier.id,
					method: 'GET',
					params: { '_v': new Date().getTime()},
					responseType: 'arraybuffer',
					headers: { 'Content-Type': undefined,'accept': 'image/*;q=0.8' }
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					console.log(error)
					reject(error);
				});
			});
	  };
		return service;
	}
})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('WorkbookController', WorkbookController);

	function WorkbookController($scope, $translate, $q, $location,
		$filter, $rootScope, toastr, $window,$state, STORAGE_PREFIX, $timeout, $accountProvider, userService, SiteGenRequestForProposalService, $currentSite, companyService,BlogService, modelService,WorkbookService) {
		$scope.alreadyConnect = false;
		$scope.showConnect = false;
		$scope.showSignIn = false;
		$scope.stepTwoOk = false;
		$scope.rfpSent = false;
		$scope.squareUnits = [
			"SQUARE_METER",
			"SQUARE_FEET"
		];
		$scope.listCCExistant = [];


		$translate(['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MR', 'SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MRS']).then((translation) => {

			$scope.civilities = [
				translation['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MR'],
				translation['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MRS']
			];

		});
		$scope.desiredConfigurations = [
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.THEATER'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.CLASS_ROOM'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.BOARD_ROOM'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.U_STYLE'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.BANQUET'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.COCKTAIL'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.CONFERENCE'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.CABARET'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.AUDITORIUM')
		];
		$scope.requestForProposal = {};
		userService.getCurrent($translate.preferredLanguage(), false).then(function (response) {
			$scope.user = response.data;

		if($scope.user){

			$scope.requestForProposal.applicantAddress1 = $scope.user.applicantAddress1;
			$scope.requestForProposal.applicantAddress2 = $scope.user.applicantAddress2;
			$scope.requestForProposal.applicantAddress3 = $scope.user.applicantAddress3;
			$scope.requestForProposal.applicantCity =  $scope.user.applicantCity;
			$scope.requestForProposal.applicantCivility = $scope.user.applicantCivility;
			$scope.requestForProposal.applicantCompany = $scope.user.applicantCompany;
			$scope.requestForProposal.applicantCompanyType = $scope.user.applicantCompanyType;
			$scope.requestForProposal.applicantCountry = $scope.user.applicantCountry;
			$scope.requestForProposal.applicantDirectPhone = $scope.user.applicantDirectPhone;
			$scope.requestForProposal.applicantFirstName = $scope.user.applicantFirstName;
			$scope.requestForProposal.applicantFunction = $scope.user.applicantFunction;
			$scope.requestForProposal.applicantLastName = $scope.user.applicantLastName;
			$scope.requestForProposal.applicantMobilePhone = $scope.user.applicantMobilePhone;
			$scope.requestForProposal.applicantWebSite = $scope.user.applicantWebSite;
			$scope.requestForProposal.applicantEmail =  $scope.user.applicantEmail;
			$scope.requestForProposal.applicantPostCode =  $scope.user.applicantPostCode;
		}
			$scope.alreadyConnect = true;
			$scope.getCC();
		}).catch(function () {

		});
		$scope.login = function (user, form) {

			$accountProvider.login(user).then(function (response) {
				$scope.user = response.data;
				$rootScope.$emit('OnAccountReady');
				$scope.alreadyConnect = true;
				form.selectedIndex = 1;
				$scope.getCC();

			}).catch(function (response) {
				console.log(response)
				toastr.error($filter("translate")("SITE_GEN.ACCOUNT.INCORRECT_IDENTIFIER"));
			});
		};

		$scope.getCC = function () {
			$scope.listCCExistant = [];
			WorkbookService.getCC().then(function (res) {
				$scope.listCCExistant = res;
			}).catch(function (err) {
				console.log(err)
				toastr.error($filter("translate")("GENERAL.TOASTR.ERROR"));
			})
		}

		/**
		 * Validate Step Two
		 */
		$scope.validateStepTwo = function(type,wizard,valid){
			if(type=='FORMULAIRE' && !valid){ //focus first required
				toastr.error($filter('translate')('GENERAL.TOASTR.FIELDS_REQUIRED'));
				setTimeout(function(){
					wizard.forms[1].$error.required[0].$$element[0].focus();
				});
				return;
			}
			if(document.getElementById('logoRfp')){
				var logo = document.getElementById('logoRfp').files[0];
				if(logo){
					$scope.requestForProposal.logo =logo;
				}
			}

				$scope.stepTwoOk = true;
				wizard.selectedIndex = 2;
				$scope.requestForProposal.siteId = $currentSite.getSite().id;
				$scope.requestForProposal.typeCC = type;
		}

		/**
		 * Send at step 3
		 */
		$scope.sendRFP = function () {

			var _targetProviders = [];
			$scope.mySelectionOfProviders.forEach(function (element) {
				if (element.toSend) {
					_targetProviders.push(element);
				}
			});

			if(_targetProviders.length==0){
				toastr.error($filter('translate')('SITE_GEN.WORKBOOK.ERROR_PROVIDERS'));
				return;
			}

			var fmData = new FormData();
			var dto = angular.copy($scope.requestForProposal);
			if (dto.dateStart != null) {
				dto.dateStart = $filter('date')($scope.requestForProposal.dateStart, 'dd/MM/yyyy');
			}
			if (dto.dateEnd != null) {
				dto.dateEnd = $filter('date')($scope.requestForProposal.dateEnd, 'dd/MM/yyyy');
			}
			fmData.append('dto', angular.toJson(dto));
			fmData.append('typeCC', $scope.requestForProposal.typeCC);
			fmData.append('lang', $translate.preferredLanguage());
			if($scope.requestForProposal.typeCC=='EXISTANT') {
				fmData.append('id_CC_Existant', $scope.requestForProposal.selectedCC);
			}
			var input = document.getElementById('file');
			if (input != null && input.files != null && input.files.length > 0) {
				fmData.append('file', input.files[0]);
			}

			if($scope.requestForProposal.file) {
				fmData.append("file", $scope.requestForProposal.file);
			}

			if($scope.requestForProposal.logo){
				fmData.append("logo",$scope.requestForProposal.logo);
			}

			fmData.append('providers', JSON.stringify(_targetProviders));
			fmData.append('baseUrl', $scope.contextUrl + "/" + $currentSite.getSite().url);
			SiteGenRequestForProposalService.sendRequestForProposalPure(fmData).then(function (response) {
				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_SAVE'));
				$scope.rfpSent = true;
				$scope.requestForProposal.id = response.id;
				$state.go('sitegen.site.account_home',{site: $currentSite.getSite().url,rfp:true});
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});

		}

		BlogService.findAllTags($translate.preferredLanguage()).then(function (tags) {
			$scope.desiredActivities = tags.data;

		}).catch(function (data) {
			 console.log(data)
		});



		/**
		 * Set wizard at ng-init
		 */
		$scope.setWizard = function(wizard){
			$scope.wizardForm = wizard;
		}

		//used by file.js (save file locally)
		$scope.saveFile = function (file) {

			$scope.requestForProposal.file = file;
			$scope.validateStepTwo('PDF',$scope.wizardForm);
		}

		$scope.getCompanies = function () {
			var _ids = [];
			for (var i = 0; i < localStorage.length; i++) {
				if (localStorage.key(i).substring(0, 9) === 'PROVIDER_') {
					try {
						var _item = JSON.parse(localStorage.getItem(localStorage.key(i)));
						if (_item.id && localStorage.key(i) === 'PROVIDER_' + _item.id) {
							_ids.push(_item);
						}
					} catch (error) {
						console.log(error);
					}
				}
			}
			if (_ids.length > 0) {
				companyService.listMySelection($translate.preferredLanguage(), _ids).then(function (response) {
					$scope.mySelectionOfProviders = response.data;
				}).catch(function (error) {
					console.log(error);
				});
			}
		}
		$scope.getCompanies();

		$scope.register = function (user, form) {
			var fmData = new FormData();
			fmData.append('dto', angular.toJson(user));
			$accountProvider.registerWithoutConfirm(fmData, $translate.preferredLanguage(), "/" + $currentSite.getSite().url).then(function (response) {
				toastr.success($filter('translate')('SITE_GEN.ACCOUNT.NEW_ACCOUNT_ACTIVATION_ASK_MSG'));
				var dto = {
					usermail: user.login,
					password: user.password
				}
				user = {};
				$scope.login(dto, form);
			}).catch(function (error) {
				if (error.status === 409) {
					if (error.data == 'ALREADY_EXIST_MAIL') {
						toastr.error($filter('translate')('USERS.ALREADY_EXIST_MAIL'));
					} else if (error.data == 'ALREADY_EXIST_LOGIN') {
						toastr.error($filter('translate')('USERS.ALREADY_EXIST_LOGIN'));
					} else {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					}
				} else {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}
			});
		};

		$scope.resizeImage = function(base_image) {
			var maxWidth = 150; // Max width for the image
			var maxHeight = 150;    // Max height for the image
			var ratio = 0;  // Used for aspect ratio
			var width = base_image.width;    // Current image width
			var height = base_image.height;  // Current image height

			if(width > maxWidth){
				ratio = maxWidth / width;   // get ratio for scaling image

            height = height * ratio;    // Reset height to match scaled image
            width = width * ratio;    // Reset width to match scaled image
        }
        // Check if current height is larger than max
        if(height > maxHeight){
				ratio = maxHeight / height; // get ratio for scaling image

             width = width * ratio;    // Reset width to match scaled image
            height = height * ratio;    // Reset height to match scaled image
		  }

		  return {width:width,height:height};
		}

		$scope.writePDF = function(base_image,pdf){
			$scope.dimensions = {width:100,height:100};
			if(base_image){
				$scope.dimensions = $scope.resizeImage(base_image);
				pdf.addImage(base_image, 'JPEG', pdf.internal.pageSize.width/2-75, 20,$scope.dimensions.width,$scope.dimensions.height);
			}
			var y = 40 + $scope.dimensions.height;
			//------!!!!!!!!-----Contact------!!!!!!!!!---------
			pdf.setFontSize(16);
			pdf.setFontType("bold");
			pdf.text(15,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.APPLICANT_INFORMATIONS"))
			pdf.setFontType("normal");
			pdf.setFontSize(12);

			//applicant company
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY")+':  ')
			pdf.setFontType("normal");
			pdf.text(120,y,($scope.requestForProposal.applicantCompany ? $scope.requestForProposal.applicantCompany : ''))

			//applicant company type
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY_TYPE")+':  ')
			pdf.setFontType("normal");
			pdf.text(160,y,($scope.requestForProposal.applicantCompanyType ? $scope.requestForProposal.applicantCompanyType : ''))

			//website
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_WEB_SITE")+':  ')
			pdf.setFontType("normal");
			pdf.text(80,y,($scope.requestForProposal.applicantWebSite ? $scope.requestForProposal.applicantWebSite : ''))

			//title/civility
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CIVILITY")+':  ')
			pdf.setFontType("normal");
			pdf.text(60,y,($scope.requestForProposal.applicantCivility ? $scope.requestForProposal.applicantCivility : '' ))

			//First Name
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FIRST_NAME")+':  ')
			pdf.setFontType("normal");
			pdf.text(100,y,($scope.requestForProposal.applicantFirstName ? $scope.requestForProposal.applicantFirstName : '' ))

			//Last Name
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_LAST_NAME")+':  ')
			pdf.setFontType("normal");
			pdf.text(100,y,($scope.requestForProposal.applicantLastName ? $scope.requestForProposal.applicantLastName : '' ))

			//position
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FUNCTION")+':  ')
			pdf.setFontType("normal");
			pdf.text(85,y,($scope.requestForProposal.applicantFunction ? $scope.requestForProposal.applicantFunction : '' ))

			//address 1
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS1")+':  ')
			pdf.setFontType("normal");
			pdf.text(100,y,($scope.requestForProposal.applicantAddress1 ? $scope.requestForProposal.applicantAddress1 : '' ))

			//address2
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS2")+':  ')
			pdf.setFontType("normal");
			pdf.text(100,y,($scope.requestForProposal.applicantAddress2 ? $scope.requestForProposal.applicantAddress2 : '' ))

			//address3
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS3")+':  ')
			pdf.setFontType("normal");
			pdf.text(100,y,($scope.requestForProposal.applicantAddress3 ? $scope.requestForProposal.applicantAddress3 : ''))

			//post code
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_POST_CODE")+':  ')
			pdf.setFontType("normal");
			pdf.text(100,y,($scope.requestForProposal.applicantPostCode ? $scope.requestForProposal.applicantPostCode : ''))

			//city
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CITY")+':  ')
			pdf.setFontType("normal");
			pdf.text(60,y,($scope.requestForProposal.applicantCity ? $scope.requestForProposal.applicantCity : ''))

			//country
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COUNTRY")+':  ')
			pdf.setFontType("normal");
			pdf.text(80,y,($scope.requestForProposal.applicantCountry ? $scope.requestForProposal.applicantCountry : ''))

			//direct phone
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_DIRECT_PHONE")+':  ')
			pdf.setFontType("normal");
			pdf.text(120,y,($scope.requestForProposal.applicantDirectPhone ? $scope.requestForProposal.applicantDirectPhone : ''))

			//mobile phone
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_MOBILE_PHONE")+':  ')
			pdf.setFontType("normal");
			pdf.text(120,y,($scope.requestForProposal.applicantMobilePhone ? $scope.requestForProposal.applicantMobilePhone : ''))

			//email
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_EMAIL")+':  ')
			pdf.setFontType("normal");
			pdf.text(60,y,($scope.requestForProposal.applicantEmail ? $scope.requestForProposal.applicantEmail : ($scope.user.mail ? $scope.user.mail : '')))


			pdf.setFontSize(10);
			pdf.text(pdf.internal.pageSize.width-40,pdf.internal.pageSize.height-20,'1/3')


			//------!!!!!!!!-----Request for proposal details------!!!!!!!!!---------
			pdf.addPage();
			pdf.setFontSize(16);
			if(base_image){
				$scope.dimensions = $scope.resizeImage(base_image);
				pdf.addImage(base_image, 'JPEG', pdf.internal.pageSize.width/2-75, 20,$scope.dimensions.width,$scope.dimensions.height);
			}
			y = 40 + $scope.dimensions.height;

			pdf.setFontType("bold");
			pdf.text(15,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.EVENT_INFORMATIONS"))
			pdf.setFontType("normal");
			pdf.setFontSize(12);

			//event title
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TITLE")+':  ')
			pdf.setFontType("normal");
			pdf.text(150,y,($scope.requestForProposal.eventTitle ? $scope.requestForProposal.eventTitle : ''))


			//event type
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TYPE")+':  ')
			pdf.setFontType("normal");
			pdf.text(140,y,($scope.requestForProposal.eventType ? $scope.requestForProposal.eventType : ''))

			//number participants
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.NUMBER_OF_PARTICIPANTS")+':  ')
			pdf.setFontType("normal");
			pdf.text(160,y,($scope.requestForProposal.numberOfParticipants ? $scope.requestForProposal.numberOfParticipants +'' : ''))

			//start date
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.START_DATE")+':  ')
			pdf.setFontType("normal");
			pdf.text(110,y,($scope.requestForProposal.dateStart ? $filter('date')($scope.requestForProposal.dateStart, 'dd/MM/yyyy') : '' ))


			//end date
			pdf.setFontType("bolditalic");
			pdf.text(280,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.END_DATE")+':  ')
			pdf.setFontType("normal");
			pdf.text(360,y,($scope.requestForProposal.dateEnd ? $filter('date')($scope.requestForProposal.dateEnd, 'dd/MM/yyyy') : '' ))


			//desired activities
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.DESIRED_ACTIVITIES"))
			pdf.setFontType("normal");
			y+=30;
			var activities = angular.copy($scope.requestForProposal.desiredActivities);
			if(activities){
				if(activities.length<=4){
					var str = '';
					str = angular.copy($scope.addValuesToStr(str,activities));
					pdf.text(30,y,str);

				}else{
					while(activities.length>4){
						var str = '';

						str = angular.copy($scope.addValuesToStr(str,activities.splice(0,4)));
						pdf.text(30,y,str+',');
						y+=20
					}
					if(activities.length>0){
						var str = '';
						str = angular.copy($scope.addValuesToStr(str,activities));
						pdf.text(30,y,str);

					}
				}
			}
			y+=30;

			//Number bedrooms
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_NUMBER")+':  ')
			pdf.setFontType("normal");
			pdf.text(160,y,($scope.requestForProposal.roomNumber ? $scope.requestForProposal.roomNumber+'' : '' ))

			y+=30;

			//number participants
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_CAPACITY_MAX")+':  ')
			pdf.setFontType("normal");
			pdf.text(510,y,($scope.requestForProposal.roomCapacityMax ? $scope.requestForProposal.roomCapacityMax+'' : '' ))

			y+=30;

			//setup
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.CONFIGURATION")+':  ')
			pdf.setFontType("normal");
			pdf.text(180,y,($scope.requestForProposal.desiredConfiguration ? $scope.requestForProposal.desiredConfiguration : ''))

			y+=30;


			//square
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE")+':  ')
			pdf.setFontType("normal");
			pdf.text(520,y,($scope.requestForProposal.square ? $scope.requestForProposal.square+'' : ''))
			y+=30;


			//square unit
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE_UNIT")+':  ')
			pdf.setFontType("normal");
			var str = 'SITE_GEN.REQUEST_FOR_PROPOSALS.SQUARE_UNITS.';
			if($scope.requestForProposal.squareUnit && $scope.requestForProposal.squareUnit=='SQUARE_METER'){
				str+='SQUARE_METER';
			}else if($scope.requestForProposal.squareUnit && $scope.requestForProposal.squareUnit=='SQUARE_FEET'){
				str+='SQUARE_FEET';
			}
			pdf.text(120,y,($scope.requestForProposal.squareUnit ? $filter('translate')(str) : ''))
			y+=30;

			//technical equipement
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.TECHNICAL_EQUIPMENT"))
			pdf.setFontType("normal");
			y+=20;
			pdf.text(20,y,($scope.requestForProposal.technicalEquipment ? $scope.requestForProposal.technicalEquipment : ''))
			y+=30;


			//precision hotel
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_HOTEL"))
			pdf.setFontType("normal");
			y+=20;
			pdf.text(20,y,($scope.requestForProposal.precisiontoTheHotel ? $scope.requestForProposal.precisiontoTheHotel : ''))
			y+=30;


			//precision event place
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_EVENT_PLACE"))
			pdf.setFontType("normal");
			y+=20;
			pdf.text(20,y,($scope.requestForProposal.precisiontoTheEventPlace ? $scope.requestForProposal.precisiontoTheEventPlace : ''))
			y+=30;


			pdf.setFontSize(10);
			pdf.text(pdf.internal.pageSize.width-40,pdf.internal.pageSize.height-20,'2/3')

			pdf.addPage();
			if(base_image){
				$scope.dimensions = $scope.resizeImage(base_image);
				pdf.addImage(base_image, 'JPEG', pdf.internal.pageSize.width/2-75, 20,$scope.dimensions.width,$scope.dimensions.height);
			}
			y = 40 + $scope.dimensions.height;
			pdf.setFontSize(12);

			//precision receptive
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_RECEPTIVE"))
			pdf.setFontType("normal");
			y+=20;
			pdf.text(20,y,($scope.requestForProposal.precisionForTheReceptive ? $scope.requestForProposal.precisionForTheReceptive : ''))


			//precision carrier
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_CARRIER"))
			pdf.setFontType("normal");
			y+=20;
			pdf.text(20,y,($scope.requestForProposal.precisionForTheCarrier ? $scope.requestForProposal.precisionForTheCarrier : ''))


			//other precision
			y+=30;
			pdf.setFontType("bolditalic");
			pdf.text(20,y,$filter('translate')("SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.OTHER_PRECISION"))
			pdf.setFontType("normal");
			y+=20;
			pdf.text(20,y,($scope.requestForProposal.otherPrecision ? $scope.requestForProposal.otherPrecision : ''))

			pdf.setFontSize(10);
			pdf.text(pdf.internal.pageSize.width-40,pdf.internal.pageSize.height-20,'3/3')

			pdf.save($scope.requestForProposal.name+".pdf");
		}
		$scope.addValuesToStr = function(str,activities){
			activities.forEach(element => {
				str += ''+(str!='' ? ', ' : '')+element;
			});
			return str;
		}
		$scope.exportForm = function(wizard,valid){
			if(!valid) { //focus first required
				toastr.error($filter('translate')('GENERAL.TOASTR.FIELDS_REQUIRED'));
				setTimeout(function(){
					console.log(wizard)
					wizard.forms[1].$error.required[0].$$element[0].focus();
				});

				return;
			}

			var pdf = new jsPDF('p', 'pt', 'a4');

			var newCanvas = document.createElement('canvas');
			var file = null;
			if(document.getElementById('logoRfp')){
				file = document.getElementById('logoRfp').files[0];
			}
			if(file){
				var context = newCanvas.getContext('2d');

				var reader = new FileReader();

				var base_image = new Image();

				reader.readAsDataURL(file);

				reader.onload = ()=>{
					base_image.src = reader.result;
				}

				base_image.onload = () => {
					context.drawImage(base_image, 0, 0);

					$scope.writePDF(base_image,pdf,file)
				}
			}else{
				$scope.writePDF(null,pdf,null)
			}
		}

	}
}
)();

(function () {
	'use strict';

	angular
		.module('sitegen.site')
		.controller('SiteGenToolbarController', SiteGenToolbarController);

	/** @ngInject */
	function SiteGenToolbarController($mdMenu, $rootScope, $scope, $state, $window, $timeout, $mdSidenav, $mdDialog, $cookies, msNavigationService,
		$filter, $interval, $element, $translate, $currentSite, SitesManagementService, toastr, $stateParams, SiteGenService, STORAGE_PREFIX, URL,
		$accountProvider) {

		var vm = this;

		vm.bodyEl = angular.element('body');


		vm.URL = URL;

		// Methods
		vm.toggleSidenav = toggleSidenav;
		vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
		vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
		vm.changeLanguage = changeLanguage;


		var originatorEv;
		vm.openMenu = function ($mdMenu, ev) {
			originatorEv = ev;
			$mdMenu.open(ev);
		};

		/**
		 * Toggle sidenav
		 *
		 * @param sidenavId
		 */
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		};

		/**
		 * Toggle horizontal mobile menu
		 */
		function toggleHorizontalMobileMenu() {
			vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
		};

		/**
		 * Toggle msNavigation folded
		 */
		function toggleMsNavigationFolded() {
			msNavigationService.toggleFolded();
		}

		/**
		 * Change Language
		 */
		function changeLanguage(lang) {

			$scope.selectedLanguage = lang;

			// Change the language
			if ($scope.selectedLanguage != null) {
				localStorage.setItem(STORAGE_PREFIX + 'site_lang', angular.toJson(lang));
				$translate.use($scope.selectedLanguage.key);
				$translate.preferredLanguage($scope.selectedLanguage.key);
			}

			$rootScope.$broadcast('siteLanguageRefreshed');
			//$state.reload();
			$scope.goToPage($currentSite.getPage().name);

		}

		/**
		 * Go to target site
		 */
		$scope.goToSite = function (siteUrl) {
			if (siteUrl) {
				$state.go('sitegen.site', {
					'site': siteUrl
				});
			}
		};

		/**
		 * Go to target page
		 */
		$scope.goToPage = function (item) {

			if (item.directUrl) {
				if (item.url) {
					window.open(item.url, '_blank');
				}
			} else {
				if (item.pageName) {
					SiteGenService.find($currentSite.getSite().url, item.pageName, $translate.preferredLanguage()).then(function (resp) {
						$currentSite.setSite(resp);
						$rootScope.$broadcast('menuReady');
						$rootScope.$broadcast('pageReady');
						$state.transitionTo('sitegen.page', {
							site: $currentSite.getSite().url,
							page: item.pageName,
							param1: null
						}, {
							location: true,
							inherit: true,
							relative: $state.$current,
							notify: true
						});

					}).catch(function (error) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}
			}
		};

		/*
		 * Current site
		 */

		// Site
		$scope.site = $currentSite.getSite();
		checkCurrentSite();
		// Menu
		$scope.menu = $currentSite.getMenu();
		// Language
		try {
			var lang = angular.fromJson(localStorage.getItem(STORAGE_PREFIX + 'site_lang'));
			if (lang != null) {
				$scope.selectedLanguage = lang;
			}
		} catch (e) {
			console.log(e);
		}

		$scope.$on('siteUpdated', function () {
			$scope.site = $currentSite.getSite();
			checkCurrentSite();
			$scope.menu = $currentSite.getMenu();
			try {
				var lang = angular.fromJson(localStorage.getItem(STORAGE_PREFIX + 'site_lang'));
				if (lang != null) {
					$scope.selectedLanguage = lang;
				}
			} catch (e) {
				console.log(e);
			}
		});

		/*
		 * Current menu associated with current site
		 */
		$rootScope.$on('menuReady', function () {
			$scope.menu = $currentSite.getMenu();
		});

		/*
		 * Sites list
		 */
		SiteGenService.findAll('sites').then(function (response) {
			if (response && response.data) {
				$scope.sites = response.data;

				checkCurrentSite();
			}
		}).catch(function (error) {
			console.log(error);
		});

		$scope.isMobile = function (nbrItems) {
			return nbrItems >= 3 || window.innerWidth <= 960;
		};

		$scope.toggleLvl1 = function (elId) {
			$timeout(function () {
				var tempEl = document.getElementById('nl_js--' + elId); // ul list
				var tempWrapper = document.getElementById('nl_js--wrapper-' + elId); // li wrapper
				tempEl.classList.toggle('nl__active');
				tempWrapper.classList.toggle('nl__active');
			}, 0);
		}
		$scope.toggleLvl2 = function (elId) {
			$timeout(function () {
				var tempEl = document.getElementById('nl_js--lvl2-' + elId); // ul list
				var tempWrapper = document.getElementById('nl_js--lvl2-wrapper-' + elId); // li wrapper
				tempEl.classList.toggle('nl__active');
				tempWrapper.classList.toggle('nl__active');
			}, 0);
		}
		$scope.toggleMobileMenu = function () {
			var bodyEl = angular.element('body');
			bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
		}

		function checkCurrentSite() {
			if ($scope.sites && $scope.sites.length > 0 && $scope.site) {
				$scope.nextSite = null;
				for (var i = 0; i < $scope.sites.length; i++) {
					if ($scope.sites[i].id === $scope.site.id) {
						$scope.sites[i].current = true;
					} else {
						$scope.sites[i].current = false;
						if (!$scope.nextSite) {
							$scope.nextSite = $scope.sites[i];
						}
					}
				}
			}
		}

		$scope.goToLogin = function () {
			$state.go('sitegen.site.login', {
				site: $currentSite.getSite().url
			});
		};

		$scope.goToMyProfile = function () {
			$state.go('sitegen.site.my_profile', {
				site: $currentSite.getSite().url
			});
		};

		$scope.goToMySelectionOfProviders = function () {
			$state.go('sitegen.site.my_selection_of_providers', {
				site: $currentSite.getSite().url
			});
		};

		$scope.logout = function () {
			$accountProvider.logout().then(function (response) {
				$rootScope.$emit('OnAccountReady');
				$state.go('sitegen.site', {
					site: $currentSite.getSite().url
				});
			}).catch(function (error) {
				console.log(error);
			});
		};

		$scope.goToMyAccount = function () {
			$state.go('sitegen.site.account_home', { site: $currentSite.getSite().url });
		};

	}

})();

(function () {
	'use strict';

	angular.module('sitegen.site').service('SiteGenService', SiteGenService);

	function SiteGenService($q, $http, $filter, $location, toastr) {

		var service = {};

		service.find = function (siteUrl, pageName, lang) {

			var params = {
				'_v': new Date().getTime(),
				'siteUrl': siteUrl
			};

			if (pageName) {
				params.pageName = pageName;
			};

			if (lang) {
				params.lang = lang;
			};

			return $q(function (resolve, reject) {
				$http({
					url: './api/public/sitegen/site',
					method: 'GET',
					params: params
				}).then(function (response) {

					var site = response.data;

					if (pageName && !site.page) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					}

					if (site.defaultLanguage) {
						site.defaultLanguage.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + site.defaultLanguage.key);
						site.defaultLanguage.defaultLanguage = true;
					}

					site.languagesTmp = angular.copy(site.languages);

					var _defaultLanguageFound = false;
					angular.forEach(site.languagesTmp, function (itemLang, indexLang) {
						if (site.defaultLanguage && !_defaultLanguageFound && itemLang.key == site.defaultLanguage.key) {
							_defaultLanguageFound = true;
							itemLang.defaultLanguage = true;
						}
						itemLang.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + itemLang.key);
					});
					if (site.defaultLanguage && !_defaultLanguageFound) {
						site.languagesTmp.push(angular.copy(site.defaultLanguage));
					}

					resolve(site);

				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findCss = function (siteUrl) {
			// return $location.protocol() + '://' + location.host() + '/Summeet/public/sitegen/site/css?siteUrl='+siteUrl;
			return $q(function (resolve, reject) {
				$http({
					url: './api/public/sitegen/site/css',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'siteUrl': siteUrl
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findFooter = function (siteUrl) {
			// return $location.protocol() + '://' + location.host() + '/Summeet/public/sitegen/site/css?siteUrl='+siteUrl;
			return $q(function (resolve, reject) {
				$http({
					url: './api/public/sitegen/site/footer',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'siteUrl': siteUrl
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findAll = function () {
			return $q(function (resolve, reject) {
				$http({
					url: './api/public/sitegen/sites',
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.sendContact = function (contact) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/public/sitegen/contact',
					method: 'POST',
					params: {
						'_v': new Date().getTime()
					},
					data: contact
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.getMailContact = function () {
			return $q(function (resolve, reject) {
				$http({
					url: './api/public/sitegen/contact/getMailSender',
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.getBlogs = function (blogs, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/public/sitegen/blogs/favorite',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang,
					},
					data: blogs
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.sendNewsletter = function (mail) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/public/sitegen/newsletter',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'mail': mail
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.getRelatedArticles = function (id, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/public/sitegen/article/findRelated/' + id,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.listMySelection = function (lang, ids) {
			var _ids = ids;
			return $q(function (resolve, reject) {
				$http({
					url: './api/public/sitegen/companies/selections',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					data: _ids
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.listArticlesByCompany = function (id, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/public/sitegen/article/company/' + id,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};



		service.addStatisticRead = function (id,from,lang) {

			return $q(function(resolve, reject){
				$http({
					url: './api/public/sitegen/article/addStatisticRead/'+id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'lang': lang,
						'from': from
					}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		}

		service.addStatisticShown = function (id,from,lang) {
			return $q(function(resolve, reject){
				$http({
					url: './api/public/sitegen/article/addStatisticShown/'+id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'lang': lang,
						'from': from
					}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		}

		service.findBannerById = function (id, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/public/sitegen/banner/'+id,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		}

		service.addStatisticBanner = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/public/sitegen/banner/addStatistic/'+id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'type': 'READ'
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		}
		service.getPersonnalRfp = function(lang){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/getPersonnalRfp',
					method: 'GET',
					params: { '_v': new Date().getTime(),
					'lang': lang},
					headers: { 'Content-Type': 'application/json;charset=UTF-8' }
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		}
		service.getPersonnalCC= function(lang){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/getPersonnalCC',
					method: 'GET',
					params: { '_v': new Date().getTime(),
					'lang': lang},
					headers: { 'Content-Type': 'application/json;charset=UTF-8' }
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		}

		service.downloadCC= function(id){
			return '/api/public/sitegen/downloadCC/'+id;
		}

		service.getNotationForCompany = function(id){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/notations/'+id,
					method: 'GET',
					params: { '_v': new Date().getTime()},
					headers: { 'Content-Type': 'application/json;charset=UTF-8' }
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		}
		service.addNotationForCompany = function(dto,id){

			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/notation/'+id,
					method: 'POST',
					params: { '_v': new Date().getTime()},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		}

		service.getCompaniesRelated = function(id,lang){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/companies/findRelated/'+id,
					method: 'GET',
					params: { '_v': new Date().getTime(),'lang':lang},
					headers: { 'Content-Type': 'application/json;charset=UTF-8' }
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		}

		service.findBannerCarouselByIds = function(ids,lang){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/banners/findBannerCarouselByIds/',
					method: 'POST',
					params: { '_v': new Date().getTime(),'lang':lang},
					headers: { 'Content-Type': 'application/json;charset=UTF-8' },
					data: ids
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		}

		service.getAllTags = function(lang){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/tags/getAll/',
					method: 'GET',
					params: { '_v': new Date().getTime(),'lang':lang},
					headers: { 'Content-Type': 'application/json;charset=UTF-8' }
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		}

		return service;

	}

})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('SiteGenController', SiteGenController);

	function SiteGenController($rootScope, $stateParams, $scope, $state, SiteGenService, $currentSite, $sce, $interpolate, $compile, URL, $addthis, $document) {
		$addthis.add();
		$addthis.loaded().then(function () {

			$addthis.layersRefresh();
		});
		$scope.$sce = $sce;
		$scope.$interpolate = $interpolate;
		$scope.$compile = $compile;
		$scope.$scope = $scope;
		$scope.banner = {};
		$rootScope.siteUrl = angular.copy($stateParams.site);


		$addthis.layersRefresh();
		$scope.page = $currentSite.getPage();

		$rootScope.$on('pageReady', function () {
			$scope.page = $currentSite.getPage();
		});

		$scope.$on('siteUpdated', function () {
			if ($rootScope.siteUrl == 'leisure') {
				$rootScope.siteTitle = "Visit Lebanon - Leisure Website";
				$rootScope.siteDescription = 'All the touristic information for the Leisure professionals including itineraries ideas, practical information, etc. in Lebanon.';
			} else if ($rootScope.siteUrl == 'mice') {
				$rootScope.siteTitle = "Visit Lebanon - MICE Website";
				$rootScope.siteDescription = 'All the information needed to help you with the organization of your Meetings, Incentives, Congress and Events in Lebanon.';
			} else {
				if ($rootScope.site) {
					$rootScope.siteTitle = $rootScope.site.name;
				} else {
					$rootScope.siteTitle = "";
					$document.title = '';
				}

			}
		});

		SiteGenService.findCss($state.params.site).then(function (response) {
			$rootScope.css = URL.alternatedocroots + '/' + response.data;
		}).catch(function () {
			$rootScope.css = '';
		});

		SiteGenService.findFooter($state.params.site).then(function (response) {
			$rootScope.footer = URL.alternatedocroots + '/' + response.data;
		}).catch(function () {
			$rootScope.footer = '';
		});

		$scope.resizeImage = function (size, filename) {
			var filenamewithoutextension = filename.substring(0, filename.lastIndexOf('.'));
			var extension = filename.substring(filename.lastIndexOf('.'));
			switch (size) {
				case 'mini':
					return filenamewithoutextension + '-320' + extension;
				case 'small':
					return filenamewithoutextension + '-720' + extension;
				case 'medium':
					return filenamewithoutextension + '-1280' + extension;
				case 'big':
					return filenamewithoutextension + '-1920' + extension;
				case 'original':
					return filename;
			}
		};



		$scope.getBlocTypeController = function (bloc) {
			var el = document.getElementById('content-container');
			el.scrollTop = 0;

			if (bloc.type === 'BLOG') {
				return 'BlogBlocController';
			} if (bloc.type === 'BLOG_PURE') {
				return 'blogPureBlocController';
			} else if (bloc.type === 'ARTICLE') {
				return 'articleBlocController';
			} else if (bloc.type === 'ARTICLE_PURE') {
				return 'articlePureBlocController';
			} else if (bloc.type === 'PACKAGE') {
				return 'PackageBlocController';
			} else if (bloc.type === 'CAROUSEL' || bloc.type === 'CAROUSEL_PURE') {
				return 'CarouselBlocController';
			} else if (bloc.type === 'SEARCH_COMPANY') {
				return 'searchCompaniesController';
			} else if (bloc.type === 'SEARCH_PACKAGE') {
				return 'searchPackagesController';
			} else if (bloc.type === 'SEARCH_TOURIST_ATTRACTIONS') {
				return 'searchTouristAttractionsController';
			} else if (bloc.type === 'COMPANY') {
				return 'companyBlocController';
			} else if (bloc.type === 'TOURIST_ATTRACTION') {
				return 'TouristAttractionBlocController';
			} else if (bloc.type === 'FESTIVALS') {
				return 'festivalsBlocController';
			} else if (bloc.type === 'FESTIVAL') {
				return 'festivalBlocController';
			} else if (bloc.type === 'EVENT_INSCRIPTION') {
				return 'eventInscriptionBlocController';
			} else if (bloc.type === 'GALLERIES') {
				return 'galleriesBlocController';
			} else if (bloc.type === 'GALLERY') {
				return 'galleryBlocController';
			} else if (bloc.type === 'CONTACT') {
				return 'contactBlocController';
			} else if (bloc.type === 'FAVORITE') {
				return 'favoriteBlocController';
			} else if (bloc.type === 'ARTICLE_100' || bloc.type === 'ARTICLE_50' || bloc.type === 'ARTICLE_33' || bloc.type === 'ARTICLE_25') {
				return 'articleXBlocController';
			} else if (bloc.type === 'SEARCH_COMPANY_WITH_STATUS') {
				return 'searchCompaniesWithStatusController';
			} else if (bloc.type === 'COMPANY_WITH_STATUS') {
				return 'companyWithStatusBlocController';
			} else if (bloc.type === 'COMPANY_SELECTION') {
				return 'companySelectionBlocController';
			} else if (bloc.type === 'BANNER') {
				return 'bannerBlocController';
			} else if (bloc.type === 'BANNER_CAROUSEL') {
				return 'bannerCarouselBlocController';
			} else if (bloc.type === 'NEWSLETTER') {
				return 'newsletterBlocController';
			}
			else {
				return 'HTMLBlocController';
			}

		};

		$scope.$on('$destroy', function () {
			$rootScope.css = '';
		});

		$scope.$on('$destroy', function () {
			$rootScope.footer = '';
		});

		$scope.convertAndTrustYoutube = function (string) {
			var youtubeUrl = string.replace('watch?v=', 'embed/');
			return $sce.trustAsResourceUrl(youtubeUrl);
		};

		$scope.isConnected = function () {
			return !!$rootScope.user && $rootScope.user.id != null;
		};


	}

})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('SiteGenSendRequestForProposalController', SiteGenSendRequestForProposalController);

	function SiteGenSendRequestForProposalController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, SiteGenService,
		$currentSite, $sce, $interpolate, $compile, URL, SiteGenRequestForProposalService, $location,BlogService, $accountProvider, modelService, $cookies) {

		$scope.eventTypes = [
			"TYPE_1",
			"TYPE_2"
		];

		$scope.squareUnits = [
			"SQUARE_METER",
			"SQUARE_FEET"
		];

		$scope.providers = [
			"VISIT_LEBANON"
		];

		$scope.targetProvider = {
			value: null
		};

		$scope.formSend = false;

		if (localStorage.getItem("SELECTED_PROVIDER")) {
			var _targetProvider = localStorage.getItem("SELECTED_PROVIDER");
			if (_targetProvider) {
				$scope.targetProvider.value = JSON.parse(_targetProvider);
				$scope.providers.push("SELECTED_PROVIDER");
			}
		}
		/*if($cookies.get("SESSION_TOKEN") !== undefined && localStorage.getItem("SELECTED_PROVIDER")) {
			var _targetProvider = JSON.parse(localStorage.getItem("SELECTED_PROVIDER"));
			if (_targetProvider && _targetProvider.session && _targetProvider.session === $cookies.get("SESSION_TOKEN")) {
				$scope.targetProvider.value = _targetProvider;
				$scope.providers.push("SELECTED_PROVIDER");
			}
		}*/

		$scope.mySelectionOfProviders = [];
		/*angular.forEach(sessionStorage, function (item, index) {
			var _item = JSON.parse(item);
			if (_item.id && index.indexOf("PROVIDER_" + _item.id) > -1) {
				$scope.mySelectionOfProviders.push(_item);
			}
		});*/
		for (var i = 0; i < localStorage.length; i++) {
			if(localStorage.key(i).substring(0, 9) === 'PROVIDER_') {
				try {
					var _item = JSON.parse(localStorage.getItem(localStorage.key(i)));
					if(_item.id && localStorage.key(i) === 'PROVIDER_' + _item.id) {
						$scope.mySelectionOfProviders.push(_item);
					}
				} catch(error) {
					console.log(error);
				}
			}
		}
		/*for (var i = 0; i < localStorage.length; i++) {
			if(localStorage.key(i).substring(0, 9) === 'PROVIDER_') {
				try {
					var _item = JSON.parse(localStorage.getItem(localStorage.key(i)));
					if(_item.id && localStorage.key(i) === 'PROVIDER_' + _item.id && _item.session && _item.session === $cookies.get("SESSION_TOKEN")) {
						$scope.mySelectionOfProviders.push(_item);
					}
				} catch(error) {
					console.log(error);
				}
			}
		}*/
		if ($scope.mySelectionOfProviders.length > 0) {
			$scope.providers.push("MY_SELECTION_OF_PROVIDERS");
		}

		$scope.targetRequestForProposalId = $location.search().id;
		if ($scope.targetRequestForProposalId) {
			SiteGenRequestForProposalService.findMyRequestForProposalById(parseInt($scope.targetRequestForProposalId),
				$translate.preferredLanguage()).then(function (response) {
				var dateStartArray = response.data.dateStart.split("/");
				var dateStart = new Date(parseInt(dateStartArray[2]), parseInt(dateStartArray[1]) - 1, parseInt(dateStartArray[0]));
				response.data.dateStart = dateStart;
				var dateEndArray = response.data.dateEnd.split("/");
				var dateEnd = new Date(parseInt(dateEndArray[2]), parseInt(dateEndArray[1]) - 1, parseInt(dateEndArray[0]));
				response.data.dateEnd = dateEnd;
				$scope.requestForProposal = response.data;
				$scope.requestForProposal.targetProvider = $scope.targetProvider.value != null ? "SELECTED_PROVIDER" :
					$scope.mySelectionOfProviders.length > 0 ? "MY_SELECTION_OF_PROVIDERS" : "VISIT_LEBANON";
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				$state.go('sitegen.site.login', {
					site: $currentSite.getSite().url
				});
			});
		} else {
			$scope.count = 0;
			if($scope.targetProvider.value[1] != null){
				$scope.targetProvider.value.forEach(function(item, index){
					if(item != null){
						$scope.count +=1;
					}
				});
			}
			$scope.requestForProposal = {
				targetProvider: $scope.count == 0 ? "SELECTED_PROVIDER" : "MY_SELECTION_OF_PROVIDERS"
				//targetProvider: $scope.targetProvider.value != null ? "SELECTED_PROVIDER" : $scope.mySelectionOfProviders.length > 0 ? "MY_SELECTION_OF_PROVIDERS" : "VISIT_LEBANON"
			};
		}

		BlogService.findAllTags($translate.preferredLanguage()).then(function (tags) {
			$scope.desiredActivities = tags.data;

		}).catch(function (data) {
			 console.log(data)
		});

		$scope.desiredConfigurations = [
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.THEATER'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.CLASS_ROOM'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.BOARD_ROOM'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.U_STYLE'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.BANQUET'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.COCKTAIL'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.CONFERENCE'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.CABARET'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.AUDITORIUM')
		];

		$accountProvider.getAccount().then(function (response) {
            $scope.user = response;
            console.log($scope.user);
            $scope.requestForProposal=$scope.user;
		}).catch(function (error) {
			$scope.user = null;
			console.log(error);
		});


		$translate(['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MR', 'SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MRS']).then((translation) => {

			$scope.civilities = [
				translation['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MR'],
				translation['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MRS']
			];

		});

		$scope.sendNewRequestForProposal = function (_form) {
			if(_form.$valid){
				var fmData = new FormData();
				$scope.requestForProposal.siteId = $currentSite.getSite().id;
				var dto = angular.copy($scope.requestForProposal);
				if (dto.dateStart != null) {
					dto.dateStart = $filter('date')($scope.requestForProposal.dateStart, 'dd/MM/yyyy');
				}
				if (dto.dateEnd != null) {
					dto.dateEnd = $filter('date')($scope.requestForProposal.dateEnd, 'dd/MM/yyyy');
				}
				fmData.append('dto', angular.toJson(dto));
				fmData.append('lang', $translate.preferredLanguage());
				var input = document.getElementById('file');
				if (input != null && input.files != null && input.files.length > 0) {
					fmData.append('file', input.files[0]);
				}
				var _targetProviders = [];
				if ($scope.requestForProposal.targetProvider === "SELECTED_PROVIDER") {
					if ($scope.targetProvider.value) {
						_targetProviders.push(angular.copy($scope.targetProvider.value.id));
					}
				} else if ($scope.requestForProposal.targetProvider === "MY_SELECTION_OF_PROVIDERS") {
					angular.forEach($scope.mySelectionOfProviders, function (item, index) {
						_targetProviders.push(angular.copy(item.id));
					});
				}

				fmData.append('providers', JSON.stringify(_targetProviders));
				fmData.append('baseUrl', $scope.contextUrl + "/" + $currentSite.getSite().url);
				SiteGenRequestForProposalService.sendRequestForProposal(fmData, _targetProviders).then(function (response) {
					$scope.toastr.success($filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.REQUEST_SENT'));
					$scope.formSend = true;
					$scope.requestForProposal = {
						targetProvider: $scope.targetProvider.value != null ? "SELECTED_PROVIDER" : $scope.mySelectionOfProviders.length > 0 ? "MY_SELECTION_OF_PROVIDERS" : "VISIT_LEBANON"
					};
					_form.$setPristine();
					_form.$setUntouched();
					/*$accountProvider.getAccount().then(function (response) {
						$state.go('sitegen.site.request_for_proposal', {
							site: $currentSite.getSite().url
						});
					}).catch(function (error) {
						$scope.formSend = true;
						$scope.requestForProposal = {
							targetProvider: $scope.targetProvider.value != null ? "SELECTED_PROVIDER" : $scope.mySelectionOfProviders.length > 0 ? "MY_SELECTION_OF_PROVIDERS" : "VISIT_LEBANON"
						};
						_form.$setPristine();
						_form.$setUntouched();
					});*/
				}).catch(function (error) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}else{
				$scope.toastr.error($filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.FILL_REQUIRED_FIELD'));
			}
		};

	}

})();

(function () {
	'use strict';

	angular.module('sitegen.site').service('SiteGenRequestForProposalService', SiteGenRequestForProposalService);

	function SiteGenRequestForProposalService($q, $http, $filter, $location, toastr) {

		var service = {};

		service.sendRequestForProposal = function (fmData) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/sendRequestForProposal',
					method: 'POST',
					params: { '_v': new Date().getTime() },
					headers: { 'Content-Type': undefined },
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		};

		service.sendRequestForProposalPure = function (fmData) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/sendRequestForProposalPure',
					method: 'POST',
					params: { '_v': new Date().getTime() },
					headers: { 'Content-Type': undefined },
					data: fmData
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (error) {
					reject(error);
				});
			});
		};

		service.findMyRequestForProposal = function (lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/requestForProposal/findMyRequestForProposal',
					method: 'GET',
					params: { '_v': new Date().getTime(), 'lang': lang }
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		};

		service.findMyRequestForProposalById = function (id, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/requestForProposal/findMyRequestForProposalById/' + id,
					method: 'GET',
					params: { '_v': new Date().getTime(), 'lang': lang }
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		};
		service.saveCC_PDF = function (fmData) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/saveCC_PDF',
					method: 'POST',
					params: { '_v': new Date().getTime() },
					headers: { 'Content-Type': undefined },
					data: fmData
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (error) {
					reject(error);
				});
			});
		}
		service.editCC_WithoutFile = function(dto) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/editCC_WithoutFile',
					method: 'POST',
					params: { '_v': new Date().getTime() },
					data: dto
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (error) {
					reject(error);
				});
			});
		}
		service.saveCC_Formulaire = function (fmData) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/saveCC_Formulaire',
					method: 'POST',
					params: { '_v': new Date().getTime() },
					headers: { 'Content-Type': undefined },
					data: fmData
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (error) {
					reject(error);
				});
			});
		}

		service.duplicateCC = function (id, name) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/duplicateCC',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'id': id,
						'name': name
					},
					headers: { 'Content-Type': 'application/json;charset=UTF-8' }
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		}

		service.deleteCC = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/deleteCC',
					method: 'DELETE',
					params: {
						'_v': new Date().getTime(),
						'id': id,
					},
					headers: { 'Content-Type': 'application/json;charset=UTF-8' }
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		}
		service.getCCById = function(id){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/getCC/'+id,
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					},
					headers: { 'Content-Type': 'application/json;charset=UTF-8' }
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (error) {
					reject(error);
				});
			});
		}
		return service;

	}

})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('SiteGenRequestForProposalController', SiteGenRequestForProposalController);

	function SiteGenRequestForProposalController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, SiteGenService, 
		$currentSite, $sce, $interpolate, $compile, URL, SiteGenRequestForProposalService) {

		SiteGenRequestForProposalService.findMyRequestForProposal($translate.preferredLanguage()).then(function (response) {
			$scope.requestForProposals = response.data;
		}).catch(function (error) {
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		$scope.detailsRequestForProposal = function(rfp) {
			$state.go('sitegen.site.request_for_proposal.details', {site: $currentSite.getSite().url, id : rfp.id});
		};

		$scope.duplicateRequestForProposal = function(rfp) {
			$state.go('sitegen.site.request_for_proposal.send', {site: $currentSite.getSite().url, id : rfp.id});
		};
		
	}

})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('SiteGenDetailsRequestForProposalController', SiteGenDetailsRequestForProposalController);

	function SiteGenDetailsRequestForProposalController($rootScope, $scope,BlogService, $timeout, $filter, $state, $translate, toastr, SiteGenService,
		$currentSite, $sce, $interpolate, $compile, URL, SiteGenRequestForProposalService, $location, $accountProvider, modelService) {

		$scope.squareUnits = [
			"SQUARE_METER",
			"SQUARE_FEET"
		];

		$scope.providers = [
			"VISIT_LEBANON"
		];

		$scope.targetRequestForProposalId = $location.search().id;
		if ($scope.targetRequestForProposalId) {
			SiteGenRequestForProposalService.findMyRequestForProposalById(parseInt($scope.targetRequestForProposalId),
				$translate.preferredLanguage()).then(function (response) {
				$scope.requestForProposal = response.data;
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				$state.go('sitegen.site.login', {
					site: $currentSite.getSite().url
				});
			});
		} else {
			$state.go('sitegen.site.login', {
                site: $currentSite.getSite().url
            });
		}

		BlogService.findAllTags($translate.preferredLanguage()).then(function (tags) {
			$scope.desiredActivities = tags.data;

		}).catch(function (data) {
			 console.log(data)
		});

		$scope.desiredConfigurations = [
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.THEATER'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.CLASS_ROOM'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.BOARD_ROOM'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.U_STYLE'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.BANQUET'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.COCKTAIL'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.CONFERENCE'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.CABARET'),
			$filter('translate')('SITE_GEN.REQUEST_FOR_PROPOSALS.CONFIGURATIONS.AUDITORIUM')
		];


		$translate(['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MR', 'SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MRS']).then((translation) => {

			$scope.civilities = [
				translation['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MR'],
				translation['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MRS']
			];

		});

	}

})();

(function ()
{
    'use strict';

    angular
        .module('sitegen.site')
        .controller('SiteGenNavigationController', SiteGenNavigationController);

    /** @ngInject */
    function SiteGenNavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function(){
	'use strict';

	angular.module('sitegen.site').controller('MySelectionOfProvidersController', MySelectionOfProvidersController);

	function MySelectionOfProvidersController($scope, $state, $translate, URL, $filter, companyService, SiteGenService, $currentSite, $rootScope, toastr, $cookies){
		var PROVIDER_SESSION_STORAGE_KEY_PREFIX = "PROVIDER_";
		$scope.URL = URL;
		$scope.mySelectonOfProviders = [];
		/*if($cookies.get("SESSION_TOKEN") !== undefined) {
			var _ids = [];
			for (var i = 0; i < localStorage.length; i++) {
                if(localStorage.key(i).substring(0, 9) === 'PROVIDER_') {
                    try {
                        var _item = JSON.parse(localStorage.getItem(localStorage.key(i)));
                        if(_item.id && localStorage.key(i) === 'PROVIDER_' + _item.id && _item.session && _item.session === $cookies.get("SESSION_TOKEN")) {
                            _ids.push(_item);
                        }
                    } catch(error) {
                        console.log(error);
                    }
                }
			}
			if(_ids.length > 0) {
				companyService.listMySelection($translate.preferredLanguage(), _ids).then(function (response) {
					$scope.mySelectonOfProviders = response.data;
				}).catch(function (error) {
					console.log(error);
				});
			}
		}*/
		var _ids = [];
		for (var i = 0; i < localStorage.length; i++) {
			if(localStorage.key(i).substring(0, 9) === 'PROVIDER_') {
				try {
					var _item = JSON.parse(localStorage.getItem(localStorage.key(i)));
					if(_item.id && localStorage.key(i) === 'PROVIDER_' + _item.id) {
						_ids.push(_item);
					}
				} catch(error) {
					console.log(error);
				}
			}
		}
		if(_ids.length > 0) {
			companyService.listMySelection($translate.preferredLanguage(), _ids).then(function (response) {
				$scope.mySelectonOfProviders = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		}
		/*companyService.listMySelection($translate.preferredLanguage(), localStorage).then(function (response) {
			$scope.mySelectonOfProviders = response.data;
		}).catch(function (error) {
			console.log(error);
		});*/

		$scope.filterModel = function (model, index) {
			return $filter('showColumn')(model, index);
		};

		$scope.details = function (company) {
			SiteGenService.find($currentSite.getSite().url, $rootScope.site.companyUrl, $translate.preferredLanguage()).then(function (resp) {
				$currentSite.setSite(resp);
				$rootScope.$broadcast('menuReady');
				$rootScope.$broadcast('pageReady');
				$state.go('sitegen.page', {
					site: $currentSite.getSite().url,
					page: $rootScope.site.companyUrl,
					param1: company.id
				}, {
					reload: true
				});
			}).catch(function (error) {
				$scope.toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.deleteFromSelection = function(company) {

			localStorage.removeItem(PROVIDER_SESSION_STORAGE_KEY_PREFIX + company.id);
			$rootScope.$broadcast('checkSelection');
			var index = $scope.mySelectonOfProviders.map(function(item) {
				return item.id;
			}).indexOf(company.id);
			if(index != -1) {
				$scope.mySelectonOfProviders.splice(index, 1);
			}

 		}
	}
})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('TouristAttractionBlocController', TouristAttractionBlocController);

	function TouristAttractionBlocController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, SiteGenService, touristAttractionService, $currentSite, $sce, $interpolate, URL) {
		$scope.URL = URL;

		$scope._touristSlickConfig = {
			enabled: true,
			autoplay: true,
			draggable: true,
			autoplaySpeed: 3500,
			arrows: false,
			dots: true,
			dotsClass: 'slick-dots nl-slick--dots',
			method: {} // required for .prev() + .next()
	  };

		$scope.trustSrc = function (src) {
			var url = src.replace('watch?v=', 'embed/');
			return $sce.trustAsResourceUrl(url);
		};

		$scope.findTourist = function(){
			if ($state.params.param1 != null) {
				touristAttractionService.findByIdPublic($state.params.param1, $translate.preferredLanguage()).then(function (response) {
					$scope.tourist = response.data;
					getURLTouristPhotos();
				}).catch(function () {
		
				});
			}
		};

		$scope.findTourist();

		$scope.$on('siteLanguageRefreshed', function(){
			$scope.findTourist();
		});

		$scope.conf = {
			thumbnails: true,
			thumbSize: 130,
			inline: false,
			bubbles: true,
			bubbleSize: 8,
			imgBubbles: false,
			bgClose: false,
			piracy: false,
			imgAnim: 'fadeup',
		};

		// so you will bind openGallery method to a button on page
		// to open this gallery like ng-click="openGallery();"
		$scope.openGallery = function () {
			$scope.methods.open();

			// You can also open gallery model with visible image index
			// Image at that index will be shown when gallery modal opens
			//scope.methods.open(index);
		};

		$scope.closeGallery = function () {
			$scope.methods.close();
		};

		$scope.nextImg = function () {
			$scope.methods.next();
		};

		$scope.prevImg = function () {
			$scope.methods.prev();
		};

		function getURLTouristPhotos() {
			if ($scope.tourist.photos && $scope.tourist.photos.length > 0) {
				$scope.tourist.photos = $filter('orderBy')($scope.tourist.photos, 'docNumber');
				for (var i = 0; i < $scope.tourist.photos.length; i++) {
					$scope.tourist.photos[i].url = $scope.URL.alternatedocroots + '/' + $scope.tourist.photos[i].location;
					$scope.tourist.photos[i].id = i;
				}
			}
		}
	}

})();
(function () {
	'use strict';

	angular.module('sitegen.site').controller('searchTouristAttractionsController', searchTouristAttractionsController);

	function searchTouristAttractionsController($rootScope, $scope, $translate, $timeout, $state, $filter, toastr, modelService, touristAttractionService, SiteGenService, $currentSite, URL) {
		$scope.modelType = 'COMPANY_MODEL';
		var baseUrl = './api/rest/model/' + $scope.modelType;
		var max = 20;
		$scope.tourists = [];
		$scope.filter = {
			regions: {},
			tourisms: {}
		};
		$scope.loaded = true;
		$scope.URL = URL;
		$scope.infiniteScrollPrevent = false;
		$scope.page = 0;

		$scope.loadFields = function () {
			modelService.findSpecificByTypePublic($translate.preferredLanguage(), 'REGION').then(function (response) {
				$scope.filter.regions = response.data;
			}).catch(function () {

			});

			modelService.findSpecificByTypePublic($translate.preferredLanguage(), 'TOURISM').then(function (response) {
				$scope.filter.tourisms = response.data;
			}).catch(function () {

			});
		};
		$scope.loadFields();

		$scope.loadMoreTourists = function () {
			if (!$scope.infiniteScrollPrevent) {
				$scope.loaded = false;
				$scope.infiniteScrollPrevent = true;
				touristAttractionService.publicGet($scope.page, max, $scope.filter, $translate.preferredLanguage()).then(function (response) {
					if (response.data.length > 0) {
						$scope.tourists = $scope.tourists.concat(response.data);
						orderPhotos();
						$scope.infiniteScrollPrevent = false;
					} else {
						$scope.infiniteScrollPrevent = true;
					}
					$scope.loaded = true;
					$scope.page++;
				}).catch(function () {

				});
			}
		};

		$scope.filterTourists = function () {
			$scope.tourists = [];
			$scope.page = 0;
			$scope.infiniteScrollPrevent = false;
			$scope.loadMoreTourists();
		};
		$scope.filterTourists();

		$scope.details = function (pageName, packageId) {
			SiteGenService.find($currentSite.getSite().url, pageName, $translate.preferredLanguage()).then(function (resp) {

				$currentSite.setSite(resp);
				$rootScope.$broadcast('menuReady');
				$rootScope.$broadcast('pageReady');
				$state.go('sitegen.page', {
					site: $currentSite.getSite().url,
					page: pageName,
					param1: packageId
				}, {
						reload: true
					});

			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.$on('siteLanguageRefreshed', function () {
			$scope.page = 0;
			$scope.infiniteScrollPrevent = false;
			$scope.tourists = [];
			$scope.loadMoreTourists();
			$scope.loadFields();
		});

		function orderPhotos() {
			for (var i = 0; i < $scope.tourists.length; i++) {
				if (!$scope.tourists[i].ordered) {
					$scope.tourists[i].photos = $filter('orderBy')($scope.tourists[i].photos, 'docNumber');
					$scope.tourists[i].ordered = true;
				}
			}
			
		}
	}

})();
(function(){
	'use strict';

	angular.module('sitegen.site').controller('searchPackagesController', searchPackagesController);
	
	function searchPackagesController($rootScope, $scope, $translate, $state, $filter, toastr, modelService, packagesService, SiteGenService, $currentSite, URL){
		$scope.modelType = 'COMPANY_MODEL';
		var baseUrl = './api/rest/model/' + $scope.modelType;
		var max = 20;
		$scope.packages = [];
		$scope.filter = {
			regions: {},
			tourisms: {},
			publish: true
		};
		$scope.loaded = true;
		$scope.URL = URL;
		$scope.infiniteScrollPrevent = false;
		$scope.page = 0;
		
		$scope.loadFields = function(){
			modelService.findSpecificByTypePublic($translate.preferredLanguage(), 'REGION').then(function (response) {
				$scope.filter.regions = response.data;
			}).catch(function () {
	
			});
	
			modelService.findSpecificByTypePublic($translate.preferredLanguage(), 'TOURISM').then(function (response) {
				$scope.filter.tourisms = response.data;
			}).catch(function () {
	
			});
		};
		$scope.loadFields();

		$scope.loadMorePackages = function () {
			if (!$scope.infiniteScrollPrevent) {
				$scope.loaded = false;
				$scope.infiniteScrollPrevent = true;
				packagesService.publicGet($scope.page, max, $scope.filter, $currentSite.getSite().id,$translate.preferredLanguage()).then(function (response) {
					if (response.data.length > 0) {
						$scope.packages = $scope.packages.concat(response.data);
						$scope.infiniteScrollPrevent = false;
					} else {
						$scope.infiniteScrollPrevent = true;
					}
					$scope.loaded = true;
					$scope.page++;
				}).catch(function () {

				});
			}
		};

		$scope.filterPackages = function () {
			$scope.packages = [];
			$scope.page = 0;
			$scope.infiniteScrollPrevent = false;
			$scope.loadMorePackages();
		};
		$scope.filterPackages();

		$scope.details = function (pageName, packageId) {
			SiteGenService.find($currentSite.getSite().url, pageName, $translate.preferredLanguage()).then(function (resp) {

				$currentSite.setSite(resp);
				$rootScope.$broadcast('menuReady');
				$rootScope.$broadcast('pageReady');
				$state.go('sitegen.page', {
					site: $currentSite.getSite().url,
					page: pageName,
					param1: packageId
				}, {
						reload: true
					});

			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.$on('siteLanguageRefreshed', function(){
			$scope.page = 0;
			$scope.infiniteScrollPrevent = false;
			$scope.packages = [];
			$scope.loadMorePackages();
			$scope.loadFields();
		});
	}

})();
(function () {
    'use strict';

    angular.module('sitegen.site').controller('searchCompaniesWithStatusController', searchCompaniesWithStatusController);

    function searchCompaniesWithStatusController($rootScope, $scope, $q, $filter, $state, $translate, toastr, SiteGenService, $currentSite, $sce, statisticsService, modelService, companyService, URL, BlogService) {

        var MAX_COMPANIES = 20;
        var MIN_VALUE = 0;
        var MAX_VALUE = 10000;
        var PROVIDER_SESSION_STORAGE_KEY_PREFIX = "PROVIDER_";
        $scope.companySlicks = [];

        function getValueById(id, valuedField) {
            if (valuedField.idBaseField === id) {
                if (valuedField.typeChamps === 'MULTIPLE_SELECT') {
                    var result = '';
                    angular.forEach(valuedField.values, function (value, key) {
                        result += value.libelle;
                        if (key < valuedField.values.length - 1) {
                            result += ', ';
                        }
                    });
                    return result;
                } else if (valuedField.typeChamps === 'IMAGE') {
                    return valuedField.fileLocation;
                } else {
                    return valuedField.value;
                }
            }
            return null;
        }

        $scope.URL = URL;
        $scope.companies = [];
        $scope.fields = [];
        $scope.page = 0;
        $scope.infiniteScrollPrevent = false;
        $scope.loaded = true;



        $scope._initPreselectFilterObj = {
            _state: false,
            _typeId: null,
            _sortId: null
        };

        $scope._initPreselectFilterFn = function (_state, _typeId, _sortId) {
            $scope._initPreselectFilterObj._state = _state;
            $scope._initPreselectFilterObj._typeId = _typeId;
            $scope._initPreselectFilterObj._sortId = _sortId;
        };


        $scope.companyTypes = {
            values: [],
            fieldModel: {
                listFieldsDTO: [],
                type: 'TAGS'
            }
        };
        $scope.categories = {
            value: null,
            fieldModel: {
                listFieldsDTO: [],
            }
        };
        $scope.countries = {
            values: [],
            fieldModel: {
                listFieldsDTO: [],
                type: 'COUNTRIES'
            }
        };
        $scope.regions = {
            values: [],
            fieldModel: {
                listFieldsDTO: [],
                type: 'REGIONS'
            }
        };

        BlogService.findAllTags($translate.preferredLanguage()).then((res) => {
            $scope.companyTypes.fieldModel.listFieldsDTO = res.data;
        }).catch(() => { });

        statisticsService.getNationalities($translate.preferredLanguage()).then(function (countries) {
            $scope.countries.fieldModel.listFieldsDTO = countries.data;

        }).catch(function (data) {
            console.log(data)
        });

        statisticsService.getRegions($translate.preferredLanguage()).then(function (regions) {
            $scope.regions.fieldModel.listFieldsDTO = regions.data;

        }).catch(function (data) {
            console.log(data)
        });

        modelService.listLinkedField($translate.preferredLanguage()).then(function (response) {
            $scope.fields = [];
            $scope.fields.push($scope.countries);
            $scope.fields.push($scope.regions);
            $scope.fields.push($scope.companyTypes);
            if ($rootScope._useProviderFilter && $rootScope._providerFilter != null) {
                response.data = angular.copy($rootScope._providerFilter.fields);
                $scope.keyword = angular.copy($rootScope._providerFilter.keyword);
            }
            for (var i = 0; i < response.data.length; i++) {
                var field = response.data[i];
                switch (field.type) {
                    case 'CATEGORY':
                        $scope.categories.fieldModel = angular.copy(field.fieldModel);
                        $scope.categories.id = angular.copy(field.id);
                        $scope.categories.type = angular.copy(field.type);
                        $scope.fields.push($scope.categories);
                        break;
                    default:
                        break;
                }
            }
            $rootScope._providerFilter = null;
            $rootScope._useProviderFilter = false;
            if ($scope._initPreselectFilterObj) {
                $scope.filter($scope._initPreselectFilterObj._typeId, $scope._initPreselectFilterObj._sortId);
            }
        }).catch(function () {

        });

        $scope.loadMoreCompanies = function (typeId, sortId) {
            if (!$scope.infiniteScrollPrevent) {
                $scope.loaded = false;
                $scope.infiniteScrollPrevent = true;

                companyService.filters($scope.keyword, $scope.fields, $scope.page, MAX_COMPANIES, $currentSite.getSite().id, typeId, $translate.preferredLanguage(), sortId, true).then(function (response) {
                    if (response.data.length > 0) {
                        response.data.forEach(function (item, index) {
                            response.data[index]._companySlickConfig = {
                                enabled: true,
                                autoplay: true,
                                draggable: true,
                                autoplaySpeed: 3500,
                                arrows: false,
                                dots: true,
                                dotsClass: 'slick-dots nl-slick--dots',
                                method: {} // required for .prev() + .next()
                            };
                        });
                        $scope.companies = $scope.companies.concat(response.data);
                        $scope.infiniteScrollPrevent = false;
                    } else {
                        $scope.infiniteScrollPrevent = true;
                    }
                    $scope.loaded = true;
                    $scope.page++;
                }).catch(function () {
                    // $scope.loaded = true;
                });
            }
        };

        $scope.details = function (pageName, companyId) {
            SiteGenService.find($currentSite.getSite().url, pageName, $translate.preferredLanguage()).then(function (resp) {
				/*companyService.setStatisticView(companyId).then(function(response){
				}).catch(function(error){
					console.log(error);
				});*/
                $rootScope._providerFilter = {
                    keyword: angular.copy($scope.keyword),
                    fields: angular.copy($scope.fields)
                };
                $currentSite.setSite(resp);
                $rootScope.$broadcast('menuReady');
                $rootScope.$broadcast('pageReady');
                $state.go('sitegen.page', {
                    site: $currentSite.getSite().url,
                    page: pageName,
                    param1: companyId
                }, {
                    reload: true
                });
            }).catch(function (error) {
                toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
        };

        $scope.filter = function (typeId, sortId) {
            $scope.companies = [];
            $scope.page = 0;
            $scope.infiniteScrollPrevent = false;
            $scope.loadMoreCompanies(typeId, sortId);
        };

        $scope.preselectTypes = function (ids) {
            for (var i = 0; i < ids.length; i++) {
                $scope.companyTypes.values.push({
                    id: ids[i]
                });
            }
        };

        $scope.preselectCat = function (id) {
            if (id != null) {
                $scope.categories.value = {
                    id: id
                };
            }
        };

        $scope.preselectCountries = function (ids) {
            for (var i = 0; i < ids.length; i++) {
                $scope.countries.values.push({
                    id: ids[i]
                });
            }
        };

        $scope.preselectRegions = function (ids) {
            for (var i = 0; i < ids.length; i++) {
                $scope.regions.values.push({
                    id: ids[i]
                });
            }
        };

        $scope.searchValueById = function (id, company) {
            if (company != null && company.valuedFields != null) {
                for (var i = 0; i < company.valuedFields.length; i++) {
                    var valuedField = company.valuedFields[i];
                    var res = getValueById(id, valuedField);
                    if (res != null) {
                        return res;
                    }
                }
            }
            return null;
        };


    }

})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('searchCompaniesController', searchCompaniesController);

	function searchCompaniesController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, SiteGenService, $currentSite, $sce, $interpolate, modelService, companyService, URL, $cookies) {

		var MAX_COMPANIES = 20;
		var MIN_VALUE = 0;
		var MAX_VALUE = 10000;
		var PROVIDER_SESSION_STORAGE_KEY_PREFIX = "PROVIDER_";

		function getValueById(id, valuedField) {
			if (valuedField.idBaseField === id) {
				if (valuedField.typeChamps === 'MULTIPLE_SELECT') {
					var result = '';
					angular.forEach(valuedField.values, function (value, key) {
						result += value.libelle;
						if (key < valuedField.values.length - 1) {
							result += ', ';
						}
					});
					return result;
				} else if (valuedField.typeChamps === 'IMAGE') {
					return valuedField.fileLocation;
				} else {
					return valuedField.value;
				}
			}
			return null;
		}

		$scope.URL = URL;
		$scope.companies = [];
		$scope.fields = [];
		$scope.page = 0;
		$scope.infiniteScrollPrevent = false;
		$scope.loaded = true;

		$scope._initPreselectFilterObj = {
			_state: false,
			_typeId: null,
			_sortId: null
		};

		$scope._initPreselectFilterFn = function (_state, _typeId, _sortId) {
			$scope._initPreselectFilterObj._state = _state;
			$scope._initPreselectFilterObj._typeId = _typeId;
			$scope._initPreselectFilterObj._sortId = _sortId;
		};

		$scope.keyword = {
			value: null
		};

		$scope.companyTypes = {
			values: [],
			fieldModel: {
				listFieldsDTO: []
			}
		};
		$scope.categories = {
			values: [],
			fieldModel: {
				listFieldsDTO: []
			}
		};
		$scope.tourismTypes = {
			fieldModel: {
				listFieldsDTO: []
			}
		};
		$scope.regions = {
			fieldModel: {
				listFieldsDTO: []
			}
		};
		$scope.cities = {
			fieldModel: {
				listFieldsDTO: []
			}
		};
		$scope.rooms = {
			fieldModel: {
				listFieldsDTO: []
			},
			minValue: null,
			maxValue: null
		};
		$scope.meetingRooms = {
			fieldModel: {
				listFieldsDTO: []
			},
			minValue: null,
			maxValue: null
		};
		$scope.capacities = {
			fieldModel: {
				listFieldsDTO: []
			},
			minValue: null,
			maxValue: null
		};
		$scope.peoples = {
			fieldModel: {
				listFieldsDTO: []
			},
			minValue: null,
			maxValue: null,
			value: {
				value: null
			}
		};

		modelService.listLinkedField($translate.preferredLanguage()).then(function (response) {
			$scope.fields = [];
			$scope.fields.push($scope.peoples);
			if ($rootScope._useProviderFilter && $rootScope._providerFilter != null) {
				response.data = angular.copy($rootScope._providerFilter.fields);
				$scope.keyword = angular.copy($rootScope._providerFilter.keyword);
			}
			for (var i = 0; i < response.data.length; i++) {
				var field = response.data[i];
				switch (field.type) {
					case 'COMPANY_TYPE':
						$scope.companyTypes.fieldModel = angular.copy(field.fieldModel);
						$scope.companyTypes.id = angular.copy(field.id);
						$scope.companyTypes.type = angular.copy(field.type);
						if ($rootScope._useProviderFilter && $rootScope._providerFilter != null) {
							$scope.companyTypes.values = angular.copy(field.values);
						}
						$scope.fields.push($scope.companyTypes);
						break;
					case 'CATEGORY':
						$scope.categories = field;
						$scope.fields.push(field);
						break;
					case 'TOURISM':
						$scope.tourismTypes = field;
						$scope.fields.push(field);
						break;
					case 'REGION':
						$scope.regions = field;
						$scope.fields.push(field);
						break;
					case 'CITY':
						$scope.cities = field;
						$scope.fields.push(field);
						break;
					case 'BEDROOMS':
						$scope.rooms = field;
						$scope.fields.push(field);
						break;
					case 'ROOMS':
						$scope.meetingRooms = field;
						$scope.fields.push(field);
						break;
					case 'CAPACITY':
						$scope.capacities = field;
						$scope.fields.push(field);
						break;
					default:
						break;
				}
			}
			$rootScope._providerFilter = null;
			$rootScope._useProviderFilter = false;
			if ($scope._initPreselectFilterObj && $scope._initPreselectFilterObj._state) {
				$scope.filter($scope._initPreselectFilterObj._typeId, $scope._initPreselectFilterObj._sortId);
			}
		}).catch(function () {

		});

		$scope.loadMoreCompanies = function (typeId, sortId) {
			if (!$scope.infiniteScrollPrevent) {
				$scope.loaded = false;
				$scope.infiniteScrollPrevent = true;

				companyService.filters($scope.keyword, $scope.fields, $scope.page, MAX_COMPANIES, $currentSite.getSite().id, typeId, $translate.preferredLanguage(), sortId, false).then(function (response) {
					if (response.data.length > 0) {
						$scope.companies = $scope.companies.concat(response.data);
						$scope.infiniteScrollPrevent = false;
					} else {
						$scope.infiniteScrollPrevent = true;
					}
					$scope.loaded = true;
					$scope.page++;
				}).catch(function () {
					// $scope.loaded = true;
				});
			}
		};

		$scope.details = function (pageName, companyId) {
			SiteGenService.find($currentSite.getSite().url, pageName, $translate.preferredLanguage()).then(function (resp) {
				/*companyService.setStatisticView(companyId).then(function(response){
				}).catch(function(error){
					console.log(error);
				});*/
				$rootScope._providerFilter = {
					keyword: angular.copy($scope.keyword),
					fields: angular.copy($scope.fields)
				};
				$currentSite.setSite(resp);
				$rootScope.$broadcast('menuReady');
				$rootScope.$broadcast('pageReady');
				$state.go('sitegen.page', {
					site: $currentSite.getSite().url,
					page: pageName,
					param1: companyId
				}, {
						reload: true
					});
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.filter = function (typeId, sortId) {
			$scope.companies = [];
			$scope.page = 0;
			$scope.infiniteScrollPrevent = false;
			$scope.loadMoreCompanies(typeId, sortId);
		};

		$scope.preselectTypes = function (ids) {
			for (var i = 0; i < ids.length; i++) {
				$scope.companyTypes.values.push({
					id: ids[i]
				});
			}
		};

		$scope.searchValueById = function (id, company) {
			if (company != null && company.valuedFields != null) {
				for (var i = 0; i < company.valuedFields.length; i++) {
					var valuedField = company.valuedFields[i];
					var res = getValueById(id, valuedField);
					if (res != null) {
						return res;
					}
				}
			}
			return null;
		};



	}

})();

(function () {
    'use strict';

    angular.module('sitegen.site').controller('PackageBlocController',PackageBlocController);

    function PackageBlocController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, SiteGenService, packagesService, $currentSite, $sce, $interpolate, URL) {
        $scope.URL = URL;

        $scope._packageSlickConfig = {
            enabled: true,
            autoplay: true,
            draggable: true,
            autoplaySpeed: 3500,
            arrows: false,
            dots: true,
            dotsClass: 'slick-dots nl-slick--dots',
            method: {} // required for .prev() + .next()
        };

        $scope.trustSrc = function (src) {
            var url = src.replace('watch?v=', 'embed/');
            return $sce.trustAsResourceUrl(url);
        };

        $scope.package = {};
        packagesService.findByIdPublic($state.params.param1, $translate.preferredLanguage()).then(function(response){
            $scope.package = response.data;
            getURLPackagePhotos();
        }).catch(function(){

        });

        $scope.conf = {
            thumbnails: true,
            thumbSize: 130,
            inline: false,
            bubbles: true,
            bubbleSize: 8,
            imgBubbles: false,
            bgClose: false,
            piracy: false,
            imgAnim: 'fadeup',
        };

        // so you will bind openGallery method to a button on page
        // to open this gallery like ng-click="openGallery();"
        $scope.openGallery = function () {
            $scope.methods.open();

            // You can also open gallery model with visible image index
            // Image at that index will be shown when gallery modal opens
            //scope.methods.open(index);
        };

        $scope.closeGallery = function () {
            $scope.methods.close();
        };

        $scope.nextImg = function () {
            $scope.methods.next();
        };

        $scope.prevImg = function () {
            $scope.methods.prev();
        };

        function getURLPackagePhotos() {
            if ($scope.package.documents && $scope.package.documents.length > 0) {
                for (var i = 0; i < $scope.package.documents.length; i++) {
                    $scope.package.documents[i].url = $scope.URL.alternatedocroots + '/' + $scope.package.documents[i].location;
                    $scope.package.documents[i].id = i;
                }
            }
        }
    }
    
})();
(function () {
    'use strict';
    angular.module('sitegen.site').controller('newsletterBlocController', newsletterBlocController);

    function newsletterBlocController($scope, $filter, toastr, SiteGenService) {
        $scope.mailsended = false;
        $scope.newsletterMail = {};
        $scope.sendNewsletter = function () {

            SiteGenService.sendNewsletter($scope.newsletterMail.mail).then(function (res) {
                $scope.mailsended = true;
            }).catch(function (err) {
                console.log(err)
                if (err.status === 406) {
                    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR_EMAIL_ALREADY'));
                } else {
                    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                }

            })
        }
    }
})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('HTMLBlocController', HTMLBlocController);

	function HTMLBlocController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, SiteGenService, $currentSite, $sce, $interpolate) {

	}

})();
(function () {
	'use strict';

	angular.module('sitegen.site').controller('galleryBlocController', galleryBlocController);

	function galleryBlocController($scope, URL, $state, GalleryService, $translate, SiteGenService, $currentSite, $rootScope, $window, toastr, $filter) {
		$scope.URL = URL;
		$scope.gallery = {};
		$scope.showSlick = false;
		$scope.gallerySlickConfig = {
			enabled: true,
			autoplay: false,
			draggable: true,
			autoplaySpeed: 3500,
			arrows: false,
			dots: false,
			initialSlide: 0,
			method: {},
			event: {
				afterChange: function (event, slick, currentSlide, nextSlide) {
				  $scope.myIndex = currentSlide; // save current index each time
				},
				init: function (event, slick) {
				  slick.slickGoTo($scope.currentIndex); // slide to correct index when init
				}
			}
		};

		$scope.conf = {
			thumbnails: true,
			thumbSize: 130,
			inline: false,
			bubbles: true,
			bubbleSize: 8,
			imgBubbles: false,
			bgClose: false,
			piracy: false,
			imgAnim: 'fadeup',
		};

		$scope.methods = {};

		$scope.goBack = function (pageName) {
			SiteGenService.find($currentSite.getSite().url, pageName, $translate.preferredLanguage()).then(function (resp) {
				$currentSite.setSite(resp);
				$rootScope.$broadcast('menuReady');
				$rootScope.$broadcast('pageReady');
				$state.go('sitegen.page', {
					site: $currentSite.getSite().url,
					page: pageName
				}, {
					reload: true
				});

			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.findGallery = function () {
			if ($state.params.param1 != null) {
				GalleryService.getPublic($state.params.param1, $translate.preferredLanguage()).then(function (response) {
					$scope.gallery = response.data;
				}).catch(function () {

				});
			}
		};

		$scope.$on('siteLanguageRefreshed', function () {
			$scope.findGallery();
		});

		$scope.showSlider = function (index) {
			$scope.currentIndex = index;
			$scope.showSlick = true;
		};

		$scope.hideSlider = function () {
			$scope.showSlick = false;
		};

		$scope.nextImg = function () {
			$scope.methods.next();
		};

		$scope.prevImg = function () {
			$scope.methods.prev();
		};

		$scope.findGallery();

		$scope.downloadFromFileName = function(fileName) {
			$window.open(GalleryService.getDownloadLink(fileName));
		};
	}
})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('galleriesBlocController', galleriesBlocController);

	function galleriesBlocController($scope, GalleryService, $translate, URL, SiteGenService, $currentSite, $rootScope, $state, toastr, $filter) {
		$scope.galleries = [];
		$scope.URL = URL;
		$scope.arrayUUIDs = [];

		$scope.getGalleries = function (arrayUUIDs) {
			if (arrayUUIDs) {
				$scope.arrayUUIDs = arrayUUIDs;
			}

			GalleryService.getMutliplePublic($scope.arrayUUIDs, $translate.preferredLanguage()).then(function (res) {

				$scope.galleries = res.data;

			}).catch(function (err) {
				console.log(err);
			});
		};

		$scope.$on('siteLanguageRefreshed', function () {
			$scope.findGalleries();
		});

		$scope.goSubGallery = function (pageName, uuid) {
			SiteGenService.find($currentSite.getSite().url, pageName, $translate.preferredLanguage()).then(function (resp) {

				$currentSite.setSite(resp);
				$rootScope.$broadcast('menuReady');
				$rootScope.$broadcast('pageReady');
				$state.go('sitegen.page', {
					site: $currentSite.getSite().url,
					page: pageName,
					param1: uuid
				}, {
					reload: true
				});

			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};
	}
})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('festivalsBlocController', festivalsBlocController);

	function festivalsBlocController($rootScope, $scope, $translate, $timeout, $state, $filter, toastr, modelService, FestivalService, SiteGenService, $currentSite, URL) {
		var max = 20;
		$scope.festivals = [];
		$scope.URL = URL;
		$scope.infiniteScrollPrevent = false;
		$scope.page = 0;
		$scope.loaded = true;

		$scope.loadMoreFestivals = function () {
			if (!$scope.infiniteScrollPrevent) {
				$scope.loaded = false;
				$scope.infiniteScrollPrevent = true;
				FestivalService.publicGet($scope.page, max, $translate.preferredLanguage()).then(function (response) {
					if (response.data.length > 0) {
						$scope.festivals = $scope.festivals.concat(response.data);
						orderPhotos();
						$scope.infiniteScrollPrevent = false;
					} else {
						$scope.infiniteScrollPrevent = true;
					}
					$scope.loaded = true;
					$scope.page++;
				}).catch(function () {

				});
			}
		};
		$scope.loadMoreFestivals();

		$scope.details = function (pageName, packageId) {
			SiteGenService.find($currentSite.getSite().url, pageName, $translate.preferredLanguage()).then(function (resp) {

				$currentSite.setSite(resp);
				$rootScope.$broadcast('menuReady');
				$rootScope.$broadcast('pageReady');
				$state.go('sitegen.page', {
					site: $currentSite.getSite().url,
					page: pageName,
					param1: packageId
				}, {
						reload: true
					});

			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.$on('siteLanguageRefreshed', function () {
			$scope.page = 0;
			$scope.infiniteScrollPrevent = false;
			$scope.festivals = [];
			$scope.loadMoreFestivals();
		});

		function orderPhotos() {
			for (var i = 0; i < $scope.festivals.length; i++) {
				if (!$scope.festivals[i].ordered) {
					$scope.festivals[i].photos = $filter('orderBy')($scope.festivals[i].photos, 'docNumber');
					$scope.festivals[i].ordered = true;
				}
			}
			
		}
	}

})();
(function () {
	'use strict';

	angular.module('sitegen.site').controller('festivalBlocController', festivalBlocController);

	function festivalBlocController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, SiteGenService, FestivalService, $currentSite, $sce, $interpolate, URL) {
		$scope.URL = URL;

		$scope._festivalSlickConfig = {
			enabled: true,
			autoplay: true,
			draggable: true,
			autoplaySpeed: 3500,
			arrows: false,
			dots: true,
			dotsClass: 'slick-dots nl-slick--dots',
			method: {} // required for .prev() + .next()
	  };


		$scope.findFestival = function () {
			if ($state.params.param1 != null) {
				FestivalService.findByIdPublic($state.params.param1, $translate.preferredLanguage()).then(function (response) {
					$scope.festival = response.data;
					getPhotos();
				}).catch(function () {

				});
			}
		};

		$scope.findFestival();

		$scope.$on('siteLanguageRefreshed', function () {
			$scope.findFestival();
		});

		$scope.conf = {
			thumbnails: true,
			thumbSize: 130,
			inline: false,
			bubbles: true,
			bubbleSize: 8,
			imgBubbles: false,
			bgClose: false,
			piracy: false,
			imgAnim: 'fadeup',
		};

		// so you will bind openGallery method to a button on page
		// to open this gallery like ng-click="openGallery();"
		$scope.openGallery = function () {
			$scope.methods.open();

			// You can also open gallery model with visible image index
			// Image at that index will be shown when gallery modal opens
			//scope.methods.open(index);
		};

		$scope.closeGallery = function () {
			$scope.methods.close();
		};

		$scope.nextImg = function () {
			$scope.methods.next();
		};

		$scope.prevImg = function () {
			$scope.methods.prev();
		};

		function getPhotos() {
			if ($scope.festival.photos && $scope.festival.photos.length > 0) {
				$scope.festival.photos = $filter('orderBy')($scope.festival.photos, 'docNumber');
				for (var i = 0; i < $scope.festival.photos.length; i++) {
					$scope.festival.photos[i].url = $scope.URL.alternatedocroots + '/' + $scope.festival.photos[i].location;
					$scope.festival.photos[i].id = i;
				}
			}
		}
	}

})();
(function () {
	'use strict';

	angular.module('sitegen.site').controller('favoriteBlocController', favoriteBlocController);

	function favoriteBlocController($rootScope, $scope, SiteGenService, $translate, URL, toastr, $currentSite, $state, $filter) {
		$scope.blogs = [];
		$scope.URL = URL;
		$scope.articlePageName = null;

		$scope.getBlogs = function (blogs, articlePageName) {

			$scope.articlePageName = articlePageName;
			SiteGenService.getBlogs(blogs, $translate.preferredLanguage()).then(function (res) {
				$scope.blogs = res.data;
				$scope.slickConfig = {
					enabled: true,
					autoplay: true,
					draggable: true,
					autoplaySpeed: 3000,
					arrows: false,
					dots: false,
					slidesToShow: $scope.blogs.length > 3 ? 4 : $scope.blogs.length,
					responsive: true,
					slidesToScroll: 1,
					method: {} // required for .prev() + .next()
				};
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(error);
			})
		};

		$scope.details = function (articleId) {
			SiteGenService.find($currentSite.getSite().url, $scope.articlePageName, $translate.preferredLanguage()).then(function (resp) {

				SiteGenService.addStatisticRead(articleId, "FAVORITE", $translate.preferredLanguage()).then(function () {
					$currentSite.setSite(resp);
					$rootScope.$broadcast('menuReady');
					$rootScope.$broadcast('pageReady');
					$state.go('sitegen.page', {
						site: $currentSite.getSite().url,
						page: $scope.articlePageName,
						param1: articleId
					}, {
						reload: true
					});
				}).catch(function () {

				})





			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};
	};
})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('eventInscriptionBlocController', eventInscriptionBlocController);

	function eventInscriptionBlocController($scope, $state, $translate, $filter, toastr, inscriptionFormService, inscriptionService) {
		var contactNumber = null;
		$scope.subscribed = false;
		$scope.loading;

		if ($state.params.param1 != null) {
			contactNumber = angular.copy($state.params.param1);
		}
		$scope.checkCondition = function (field) {
			/*if (field.condition != null && field.fieldCondition != null){
				for (var i = 0; i < $scope.form.fields.length; i++) {
					var item = $scope.form.fields[i];
					if (item.id === field.fieldCondition.id) {
						field._show = (item.genericField.value != null && item.genericField.value.id === field.condition.id);
					}
				}
			}else{
				field._show = true;
			}*/
			if (field.conditions != null && field.conditions.length > 0 && field.fieldCondition != null) {
				for (var i = 0; i < $scope.form.fields.length; i++) {
					var item = $scope.form.fields[i];
					if (item.id === field.fieldCondition.id) {
						/*if (item.genericField.value == null) {
							field._show = false;
						} else {
							var _index = field.conditions.map(function (_item) {
								return _item.id;
							}).indexOf(item.genericField.value.id);
							field._show = _index > -1;
						}*/
						if (item.genericField.typeChamps === 'MULTIPLE_SELECT') {
							if (item.genericField.values && item.genericField.values.length > 0) {
								var _match = false;
								for (var j = 0; j < item.genericField.values.length; j++) {
									var _index = field.conditions.map(function (_item) {
										return _item.id;
									}).indexOf(item.genericField.values[j].id);
									if (_index > -1) {
										_match = true;
										break;
									}
								}
								field._show = _match;
							} else {
								field._show = false;
							}
						} else {
							if (item.genericField.value == null) {
								field._show = false;
							} else {
								var _index = field.conditions.map(function (_item) {
									return _item.id;
								}).indexOf(item.genericField.value.id);
								field._show = _index > -1;
							}
						}
					}
				}
			} else {
				field._show = true;
			}
		};
		$scope.init = function (idForm) {

			inscriptionFormService.publicFindById(idForm, contactNumber, $translate.preferredLanguage()).then(function (response) {
				$scope.form = response.data;
				if ($scope.form.validated) {
					$scope.formValidated = true;
				}

				$scope.originalForm = angular.copy($scope.form);
				if (!$scope.form.tracked) {
					contactNumber = null;
				}
				if (contactNumber != null) {
					angular.forEach($scope.form.fields, function (item, key) {
						if (item.genericField != null) {
							var field = item.genericField;
							if (field.typeChamps === 'LIST_SELECT') {
								field.value = setSelectedList(field);
							} else if (field.typeChamps === 'DATE') {
								field.dateTime = null;
								if (field.value != null && field.value !== '') {
									field.dateTime = $filter('stringToDate')(field.value);
								}
							} else if (field.typeChamps === 'BOOLEAN') {
								field.value = 'true' === field.value;
							}
							$scope.form.fields[key].genericField = field;
						}
					});
				}
				angular.forEach($scope.form.fields, function (item, key) {
					$scope.checkCondition($scope.form.fields[key]);
				});

			}).catch(function (err) {
				if (err.status === 404) {

				}
			});

		};


		$scope.checkConditionAfterUpdate = function (field) {
			/*for (var i = 0; i < $scope.form.fields.length; i++) {
				var item = $scope.form.fields[i];
				if (item.fieldCondition != null && item.condition != null && item.fieldCondition.id === field.id) {
					item._show = (field.genericField.value != null && field.genericField.value.id === item.condition.id);
				}
			}*/
			for (var i = 0; i < $scope.form.fields.length; i++) {
				var item = $scope.form.fields[i];
				if (item.fieldCondition != null && item.conditions != null && item.fieldCondition.id === field.id) {
					if (field.genericField.typeChamps === 'MULTIPLE_SELECT') {
						if (field.genericField.values && field.genericField.values.length > 0) {
							var _match = false;
							for (var j = 0; j < field.genericField.values.length; j++) {
								var _index = item.conditions.map(function (_item) {
									return _item.id;
								}).indexOf(field.genericField.values[j].id);
								if (_index > -1) {
									_match = true;
									break;
								}
							}
							item._show = _match;
						} else {
							item._show = false;
						}
					} else {
						if (field.genericField.value == null) {
							item._show = false;
						} else {
							var _index = item.conditions.map(function (_item) {
								return _item.id;
							}).indexOf(field.genericField.value.id);
							item._show = _index > -1;
						}
					}
				}
			}
		};

		$scope.setSubmittedWizardNestedForm = function () {
			$scope.$broadcast('$submittedNestedForm');
			return true;
		};

		$scope.saveStep = function (step) {
			$scope.$broadcast('$submittedNestedForm');
			if (step.currentStepInvalid()) {
				toastr.error($filter('translate')('SITE_GEN.TOASTR_ERROR_FIELDS_REQUIRED'));
			} else {
				$scope.save($scope['wizardStep' + (step.selectedIndex + 1)], step.selectedIndex + 1);
				step.nextStep();
				$scope.$broadcast('$resetNestedForm');
			}
		};

		$scope.save = function (angularForm, page) {
			$scope.loading = true;
			if ($scope.form.validated) {
				toastr.error($filter('translate')('SITE_GEN.SUBSCRIPTION_ALREADY_DONE'));
				return;
			}

			var pageNumber = null;
			if (page != null) {
				pageNumber = angular.copy(page);
			}
			var fmData = new FormData();
			var form = {
				number: $scope.form.number,
				valuedFields: []
			};
			angular.forEach($scope.form.fields, function (field) {
				if (page == null || page != null && field.page === field.page) {
					if (field.typeField === 'FIELD') {
						var newField = angular.copy(field);
						var item = angular.copy(field.genericField);
						if (!item.fixField) {
							var valuedField = angular.copy(item);
							if (item.typeChamps === 'BOOLEAN') {
								valuedField.value = '' + item.value;
							} else if (item.typeChamps === 'DATE') {
								if (item.dateTime != null) {
									valuedField.value = $filter('date')(item.dateTime, 'dd/MM/yyyy');
								}
							} else if (item.typeChamps === 'LIST_SELECT') {
								valuedField.value = '';
								if (item.value != null) {
									valuedField.listFieldId = item.value.id;
								} else {
									valuedField.listFieldId = null;
								}
							} else if (item.typeChamps === 'MULTIPLE_SELECT') {
								valuedField.values = [];
								angular.forEach(item.values, function (objectSelected) {
									valuedField.values.push({
										id: objectSelected.id,
										libelle: objectSelected.libelle
									});
								});
							} else if (item.typeChamps === 'FILE' || item.typeChamps === 'IMAGE') {
								var input = document.getElementById('genericField_file_' + item.id + '_' + item.index);
								var file = null;
								if (input != null) {
									file = input.files[0];
									fmData.append('file_' + item.id, file);
								}
							} else if (item.typeChamps === 'NUMBER' || item.typeChamps === 'INTEGER') {
								if ('null' === item.value) {
									valuedField.value = '';
								} else {
									valuedField.value = item.value;
								}
							} else {
								valuedField.value = item.value;
							}
							newField.genericField = valuedField;
							form.valuedFields.push(newField);
						}
					}
				}
			});
			fmData.append('dto', angular.toJson(form));
			inscriptionService.savePublic($scope.form.id, contactNumber, pageNumber, fmData, $translate.preferredLanguage()).then(function (response) {
				if (response.data != null) {
					$scope.form.number = response.data;
				}
				if (angularForm != null) {
					angularForm.$setPristine();
					angularForm.$setUntouched();
				}
				if ($scope.form.nbPages === pageNumber || pageNumber == null) {
					$scope.form = angular.copy($scope.originalForm);
					$scope.subscribed = true;
					toastr.success($filter('translate')('SITE_GEN.SUCCESS_SUBSCRIPTION'));
				}
				$scope.loading = false;
			}).catch(function (response) {
				if (response.status === 409) {
					toastr.error($filter('translate')('SITE_GEN.SUBSCRIPTION_ALREADY_DONE'));
				} else {
					console.log(response);
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}
				$scope.loading = false;
			});
		};


		function setSelectedList(field) {
			var valueReturned = null;
			if (field.idValue != null) {
				for (var k = 0; k < field.listFieldsDTO.length; k++) {
					if (field.idValue === field.listFieldsDTO[k].id) {
						valueReturned = field.listFieldsDTO[k];
					}
				}
			}
			return valueReturned;
		}

	}

})();

(function(){
	'use strict';

	angular.module('sitegen.site').controller('contactBlocController', contactBlocController);

	function contactBlocController($scope, $state, $translate, $sce, companyService, statisticsService, URL, $currentSite, SiteGenService, toastr, $filter){
        $scope.senderMail = null;
        $scope.contact = {
        };
        $scope.recaptchaResponse = null;
        $scope.formSent = false;

        init();
        
        $scope.sendContact = function() {
            SiteGenService.sendContact($scope.contact).then(function(res) {
                //toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_SEND'));
                $scope.formSent = true;
            }).catch(function(err) {
                console.log(err);
            });
        };

        function init() {
            SiteGenService.getMailContact().then(function(res) {
                $scope.senderMail = res.data;
            }).catch(function(err) {
                console.log(err);
            });
        }
	}
})();
(function () {
    'use strict';

    angular.module('sitegen.site').controller('companyWithStatusBlocController', companyWithStatusBlocController);

    function companyWithStatusBlocController($rootScope, $scope, $mdDialog, $state, $location, $translate, $sce, userService, companyService, toastr, $filter, $currentSite, statisticsService, SiteGenService, URL) {
        $scope.URL = URL;
        $scope.blogs = [];
        $scope.showElt = {
            PHONE: false,
            EMAIL: false
        };
        $scope.notation = {};
        $scope.newNotation = {};
        $scope.loaderExport = false;
        $location.search().fromAction = null;
        $scope.showWebsite = false;
        userService.getCurrent($translate.preferredLanguage(), false).then(function (response) {
            $scope.user = response.data;
            SiteGenService.getNotationForCompany($state.params.param1).then(function (res) {
                $scope.notation = res.data;
            }).catch(function (err) {
                console.log(err)
            })
        }).catch(function () {
            //toastr.error($filter('translate')('GENERAL.TOASTR.UNAUTHORIZED'))
            //$state.go('sitegen.site.login');
        });

        $scope.setShowWebsite = function (state) {
            $scope.showWebsite = state;
        }
        $scope.goToLogin = function () {
            $state.go('sitegen.site.login', {
                site: $currentSite.getSite().url,
                fromAction: 'COMPANY_' + $scope.company.id
            });
        }
        function getValueById(id, valuedField) {
            if (valuedField.idBaseField === id) {
                if (valuedField.typeChamps === 'MULTIPLE_SELECT') {
                    var result = '';
                    angular.forEach(valuedField.values, function (value, key) {
                        result += value.libelle;
                        if (key < valuedField.values.length - 1) {
                            result += ', ';
                        }
                    });
                    return result;
                } else if (valuedField.typeChamps === 'IMAGE') {
                    return valuedField.fileLocation;
                } else {
                    return valuedField.value;
                }
            }
            return null;
        }

        $scope.currentIndex = 0;
        $scope._companySlickConfig = {
            enabled: true,
            autoplay: true,
            draggable: true,
            autoplaySpeed: 3500,
            arrows: false,
            dots: true,
            dotsClass: 'slick-dots nl-slick--dots',
            method: {}, // required for .prev() + .next(),
            event: {
                init: function (event, slick) {
                    slick.slickGoTo($scope.currentIndex); // slide to correct index when init
                }
            }
        };

        $scope._companyPopUpSlickConfig = {
            enabled: true,
            autoplay: true,
            draggable: true,
            autoplaySpeed: 3500,
            arrows: false,
            dots: true,
            dotsClass: 'slick-dots nl-slick--dots',
            method: {}, // required for .prev() + .next(),
            event: {
                afterChange: function (event, slick, currentSlide, nextSlide) {
                    $scope.currentIndex = currentSlide; // save current index each time
                },
                init: function (event, slick) {
                    slick.slickGoTo($scope.currentIndex); // slide to correct index when init
                }
            }
        };

        $scope.trustSrc = function (src) {
            var url = src.replace('watch?v=', 'embed/');
            return $sce.trustAsResourceUrl(url);
        };

        $scope.showMoreComments = function () {
            $scope.notation.visibleComments = $scope.notation.comments;
        }

        $scope.showDesc = function (company) {
            if (company.countries != null && company.countries.length > 0) {
                return (company.category != null ? '' + company.category + ' - ' : '') + (company.tags != null && company.tags.length > 0 ? company.tags.map(function (tag) {
                    return tag.name;
                }).join(', ') + ' - ' : '') + ' ' + company.countries.map(function (country) {
                    return country.libelle;
                }).join(', ') + '';
            } else {
                return (company.category != null ? '' + company.category + '' : '') + (company.tags != null && company.tags.length > 0 ? (company.category != null ? ' - ' : '') + ' ' + (company.tags != null && company.tags.length > 0 ? company.tags.map(function (tag) {
                    return tag.name;
                }).join(', ') : '') : '');
            }
        };

        $scope.showDescNoCategory = function (company) {
            if (company.countries != null && company.countries.length > 0) {
                return (company.tags != null && company.tags.length > 0 ? company.tags.map(function (tag) {
                    return tag.name;
                }).join(', ') + ' - ' : '') + ' ' + company.countries.map(function (country) {
                    return country.libelle;
                }).join(', ') + '';
            } else {
                return (company.activity ? (company.category != null ? ' - ' : '') + ' ' + (company.tags != null && company.tags.length > 0 ? company.tags.map(function (tag) {
                    return tag.name;
                }).join(', ') + ' - ' : '') : '');
            }
        };
        $scope.findCompany = function () {
            if ($state.params.param1 != null) {
                companyService.findByIdPublic($state.params.param1, $translate.preferredLanguage()).then(function (response) {
                    $scope.company = response.data;
                    $rootScope.siteDescription = $scope.company.modelPattern;
                    $rootScope.siteType = 'article';
                    $scope.searchValueById = function (id) {
                        if ($scope.company != null && $scope.company.valuedFields != null) {
                            for (var i = 0; i < $scope.company.valuedFields.length; i++) {
                                var valuedField = $scope.company.valuedFields[i];
                                var res = getValueById(id, valuedField);
                                if (res != null) {
                                    return res;
                                }
                            }
                        }
                        return null;
                    };
                    $scope.searchContactValueById = function (id) {
                        if ($scope.company != null && $scope.company.contactFavourite != null && $scope.company.contactFavourite.valuedFields != null) {
                            for (var i = 0; i < $scope.company.contactFavourite.valuedFields.length; i++) {
                                var valuedField = $scope.company.contactFavourite.valuedFields[i];
                                var res = getValueById(id, valuedField);
                                if (res != null) {
                                    return res;
                                }
                            }
                        }
                        return null;
                    };
                    getURLCompanyPhotos();
                }).catch(function () {

                });
            }
        };

        $scope.findArticles = function () {
            SiteGenService.listArticlesByCompany($state.params.param1, $translate.preferredLanguage()).then(function (res) {
                $scope.blogs = res.data;
                $scope.slickConfig = {
                    enabled: true,
                    autoplay: true,
                    draggable: true,
                    autoplaySpeed: 3000,
                    arrows: false,
                    dots: false,
                    slidesToShow: $scope.blogs.length > 4 ? 4 : $scope.blogs.length,
                    slidesToScroll: 1,
                    method: {} // required for .prev() + .next()
                };
            }).catch(function () {

            });
        };

        $scope.findCompany();
        $scope.findArticles();
        $scope.$on('siteLanguageRefreshed', function () {
            $scope.findCompany();
            $scope.findArticles();
        });

        companyService.findDispositionsById($state.params.param1).then(function (response) {
            $scope.dispositions = response.data;
        }).catch(function () {

        });
        $scope.show = function (type) {
            var postDTO = {
                companyID: $state.params.param1,
                type: type
            };

            statisticsService.addStatClick(postDTO).then(function (res) {

            }).catch(function (err) {
                console.log(err);
            });
            $scope.showElt[type] = true;
        };

        // Lightbox
        $scope.images = [
            {
                id: 1,
                url: 'http://www.canalvie.com/polopoly_fs/1.1805932.1468181566!/image/chien-cocker.jpg_gen/derivatives/cvlandscape_670_377/chien-cocker.jpg',
            },
            {
                id: 2,
                url: 'http://www.canalvie.com/polopoly_fs/1.1805932.1468181566!/image/chien-cocker.jpg_gen/derivatives/cvlandscape_670_377/chien-cocker.jpg',
            },
            {
                id: 3,
                url: 'http://www.canalvie.com/polopoly_fs/1.1805932.1468181566!/image/chien-cocker.jpg_gen/derivatives/cvlandscape_670_377/chien-cocker.jpg'
            }
        ];

        $scope.methods = {};

        $scope.conf = {
            thumbnails: true,
            thumbSize: 130,
            inline: false,
            bubbles: true,
            bubbleSize: 8,
            imgBubbles: false,
            bgClose: false,
            piracy: false,
            imgAnim: 'fadeup',
        };

        // so you will bind openGallery method to a button on page
        // to open this gallery like ng-click="openGallery();"
        $scope.openGallery = function () {
            $scope.methods.open();

            // You can also open gallery model with visible image index
            // Image at that index will be shown when gallery modal opens
            //scope.methods.open(index);
        };

        $scope.closeGallery = function () {
            $scope.methods.close();
        };

        $scope.nextImg = function () {
            $scope.methods.next();
        };

        $scope.prevImg = function () {
            $scope.methods.prev();
        };

        $scope.showSlider = function (index) {
            $scope.currentIndex = index;
            $scope.showSlick = true;
        };

        $scope.hideSlider = function () {
            $scope.showSlick = false;
        };


        function getURLCompanyPhotos() {
            if ($scope.company.photos && $scope.company.photos.length > 0) {
                for (var i = 0; i < $scope.company.photos.length; i++) {
                    $scope.company.photos[i].url = $scope.URL.alternatedocroots + '/' + $scope.company.photos[i].location;
                    if (i === 0) {
                        var full = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
                        var imgUrl = full + $scope.URL.alternatedocrootsWithoutDot + '/' + angular.copy($scope.company.photos[i].location);
                        $rootScope.siteImage = imgUrl;
                        var img = new Image();
                        img.onload = function () {
                            document.querySelector('meta[property="og:image:width"]').setAttribute('content', '' + this.width);
                            document.querySelector('meta[property="og:image:height"]').setAttribute('content', '' + this.height);
                        }
                        img.src = imgUrl;
                    }
                    $scope.company.photos[i].id = i;
                }
            }
        }

        $scope.details = function (pageName, id) {
            // SiteGenService.find($currentSite.getSite().url, pageName, $translate.preferredLanguage()).then(function (resp) {

            //     $currentSite.setSite(resp);
            //     $rootScope.$broadcast('menuReady');
            //     $rootScope.$broadcast('pageReady');
            SiteGenService.addStatisticRead(id, "", $translate.preferredLanguage()).then(function (res) {
            }).catch(function (err) {
                console.log(err)
            })
            $state.go('sitegen.page', {
                site: $currentSite.getSite().url,
                page: pageName,
                param1: id
            });

            // }).catch(function (error) {
            //     toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            // });
        };

        $scope.addNotation = function () {
            $scope.newNotation = {};
            $mdDialog.show({
                templateUrl: 'app/main/sitegen/popup/addNotation.popup.html',
                preserveScope: true,
                clickOutsideToClose: true,
                scope: $scope
            }).then(function () {

            }).catch(function () {

            });
        }

        $scope.onChangeRating = function (event) {
            $scope.newNotation.value = event.rating;
        }

        $scope.nbWords = function (word) {
            return word.match(/\S+/g).length;
        };

        $scope.confirmAddNotation = function () {
            if ($scope.newNotation.comment && $scope.nbWords($scope.newNotation.comment) > 200) {
                toastr.error($filter('translate')('SITE_GEN.NOTATION.TOO_LONG'));
                return;
            }
            var dto = angular.copy($scope.newNotation);
            SiteGenService.addNotationForCompany(dto, $scope.company.id).then(function (res) {
                SiteGenService.getNotationForCompany($scope.company.id).then(function (res) {
                    $scope.notation = res.data;
                    $mdDialog.hide();
                    toastr.success($filter('translate')('SITE_GEN.NOTATION.CONFIRM_ADD'))
                }).catch(function (err) {
                    console.log(err)
                })
            }).catch(function (err) {
                console.log(err);
            })
        }

        $scope.hidePopup = function () {
            $mdDialog.hide();
        }

        $scope.getCompaniesRelated = function () {
            SiteGenService.getCompaniesRelated($state.params.param1, $translate.preferredLanguage()).then(function (res) {
                $scope.companiesRelated = res.data;
            }).catch(function (err) {
                //toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'))
            })
        }

        $scope.getCompaniesRelated();

        $scope.exportCompany = function () {
            $scope.loaderExport = true;

            var pdf = new jsPDF('p', 'pt', ['900', '1300']);

            setTimeout(() => {
                html2canvas(document.getElementById('DetailsCompany'), { logging: false }).then(canvas1 => {

                    var img1 = canvas1.toDataURL('image/png', 1.0);

                    pdf.addImage(img1, 'PNG', 2, 2)

                    html2canvas(document.getElementById('BlocLeft'), { logging: false }).then(canvas2 => {

                        var img2 = canvas2.toDataURL('image/png', 1.0);

                        pdf.addImage(img2, 'PNG', 2, 150);

                        if ($scope.company.photos && $scope.company.photos.length > 0) {
                            companyService.getFirstPhoto($scope.company.id, $translate.preferredLanguage()).then(function (res) {
                                var blob = new Blob([res.data], {
                                    type: res.headers('Content-Type')
                                })


                                var reader = new FileReader();

                                var base_image = new Image();

                                reader.readAsDataURL(blob);

                                reader.onload = () => {
                                    base_image.src = reader.result;
                                }

                                base_image.onload = () => {

                                    pdf.addImage(base_image, 'JPEG', 450, 157, 400, 250);
                                }

                                html2canvas(document.getElementById('FirstBloc'), { logging: false }).then(canvas3 => {

                                    var img3 = canvas3.toDataURL('image/png', 1.0);
                                    pdf.addImage(img3, 'PNG', 6, 600);

                                    html2canvas(document.getElementById('SecondBloc'), { logging: false }).then(canvas4 => {

                                        var img4 = canvas4.toDataURL('image/png', 1.0);
                                        pdf.addPage();
                                        pdf.addImage(img4, 'PNG', 6, 10);

                                        pdf.save($scope.company.modelPattern + ".pdf", { returnPromise: true }).then(function (res) {
                                            $scope.loaderExport = false;
                                            $scope.$apply();
                                        }).catch(err => {
                                        })
                                    })
                                })
                            }).catch(function (err) {
                                console.log(err);
                            })
                        } else {
                            html2canvas(document.getElementById('FirstBloc'), { logging: false }).then(canvas3 => {

                                var img3 = canvas3.toDataURL('image/png', 1.0);
                                pdf.addImage(img3, 'PNG', 6, 600);

                                html2canvas(document.getElementById('SecondBloc'), { logging: false }).then(canvas4 => {

                                    var img4 = canvas4.toDataURL('image/png', 1.0);
                                    pdf.addPage();
                                    pdf.addImage(img4, 'PNG', 6, 10);

                                    pdf.save($scope.company.modelPattern + ".pdf", { returnPromise: true }).then(function (res) {
                                        $scope.loaderExport = false;
                                        $scope.$apply();
                                    }).catch(err => {
                                    })
                                })
                            })
                        }
                    })
                })
            });


        }
    }
})();

(function () {
    'use strict';

    angular.module('sitegen.site').controller('companySelectionBlocController', companySelectionBlocController);

    function companySelectionBlocController($rootScope, $scope, SiteGenService, $translate, URL, toastr, $currentSite, $state) {
        $scope.companies = [];
        $scope.URL = URL;
        $scope.getCompanies = function (companies) {
            var _ids = [];
            for (var i = 0; i < companies.length; i++) {
                _ids.push({ id: companies[i] });
            }
            SiteGenService.listMySelection($translate.preferredLanguage(), _ids).then(function (response) {
                $scope.companies = response.data;
                $scope.slickConfig = {
                    enabled: true,
                    autoplay: true,
                    draggable: true,
                    autoplaySpeed: 3000,
                    arrows: false,
                    dots: false,
                    slidesToShow: $scope.companies.length > 4 ? 4 : $scope.companies.length,
                    slidesToScroll: 1,
                    method: {} // required for .prev() + .next()
                };
            }).catch(function (error) {
                console.log(error);
            });
        };



        $scope.details = function (pageName, companyId) {
            SiteGenService.find($currentSite.getSite().url, pageName, $translate.preferredLanguage()).then(function (resp) {

                $currentSite.setSite(resp);
                $rootScope.$broadcast('menuReady');
                $rootScope.$broadcast('pageReady');
                $state.go('sitegen.page', {
                    site: $currentSite.getSite().url,
                    page: pageName,
                    param1: companyId
                }, {
                    reload: true
                });

            }).catch(function (error) {
                toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
        };


        $scope.showDesc = function (company) {
            if (company.countries != null && company.countries.length > 0) {
                return (company.category != null ? '' + company.category + ' - ' : '') + (company.tags != null && company.tags.length > 0 ? company.tags.map(function (tag) {
                    return tag.name;
                }).join(', ') + ' - ' : '') + ' ' + company.countries.map(function (country) {
                    return country.libelle;
                }).join(', ') + '';
            } else {
                return (company.category != null ? '' + company.category + '' : '') + (company.tags != null && company.tags.length > 0 ? (company.category != null ? ' - ' : '') + ' ' + (company.tags != null && company.tags.length > 0 ? company.tags.map(function (tag) {
                    return tag.name;
                }).join(', ') : '') : '');
            }
        };

    };
})();

(function () {
    'use strict';

    angular.module('sitegen.site').controller('companyBlocController', companyBlocController);

    function companyBlocController($scope, $state, $translate, $sce, companyService, statisticsService, URL) {
        $scope.URL = URL;
        $scope.showElt = {
            PHONE: false,
            EMAIL: false
        };

        function getValueById(id, valuedField) {
            if (valuedField.idBaseField === id) {
                if (valuedField.typeChamps === 'MULTIPLE_SELECT') {
                    var result = '';
                    angular.forEach(valuedField.values, function (value, key) {
                        result += value.libelle;
                        if (key < valuedField.values.length - 1) {
                            result += ', ';
                        }
                    });
                    return result;
                } else if (valuedField.typeChamps === 'IMAGE') {
                    return valuedField.fileLocation;
                } else {
                    return valuedField.value;
                }
            }
            return null;
        }

        $scope._companySlickConfig = {
            enabled: true,
            autoplay: true,
            draggable: true,
            autoplaySpeed: 3500,
            arrows: false,
            dots: true,
            dotsClass: 'slick-dots nl-slick--dots',
            method: {} // required for .prev() + .next()
        };

        $scope.trustSrc = function (src) {
            var url = src.replace('watch?v=', 'embed/');
            return $sce.trustAsResourceUrl(url);
        };

        $scope.findCompany = function () {
            if ($state.params.param1 != null) {
                companyService.findByIdPublic($state.params.param1, $translate.preferredLanguage()).then(function (response) {
                    $scope.company = response.data;
                    $scope.searchValueById = function (id) {
                        if ($scope.company != null && $scope.company.valuedFields != null) {
                            for (var i = 0; i < $scope.company.valuedFields.length; i++) {
                                var valuedField = $scope.company.valuedFields[i];
                                var res = getValueById(id, valuedField);
                                if (res != null) {
                                    return res;
                                }
                            }
                        }
                        return null;
                    };
                    $scope.searchContactValueById = function (id) {
                        if ($scope.company != null && $scope.company.contactFavourite != null && $scope.company.contactFavourite.valuedFields != null) {
                            for (var i = 0; i < $scope.company.contactFavourite.valuedFields.length; i++) {
                                var valuedField = $scope.company.contactFavourite.valuedFields[i];
                                var res = getValueById(id, valuedField);
                                if (res != null) {
                                    return res;
                                }
                            }
                        }
                        return null;
                    };
                    getURLCompanyPhotos();
                }).catch(function () {

                });
            }
        };

        $scope.findCompany();
        $scope.$on('siteLanguageRefreshed', function () {
            $scope.findCompany();
        });

        companyService.findDispositionsById($state.params.param1).then(function (response) {
            $scope.dispositions = response.data;
        }).catch(function () {

        });

        $scope.show = function (type) {
            var postDTO = {
                companyID: $state.params.param1,
                type: type
            };

            statisticsService.addStatClick(postDTO).then(function (res) {

            }).catch(function (err) {
                console.log(err);
            });
            $scope.showElt[type] = true;
        };

        // Lightbox
        $scope.images = [
            {
                id: 1,
                url: 'http://www.canalvie.com/polopoly_fs/1.1805932.1468181566!/image/chien-cocker.jpg_gen/derivatives/cvlandscape_670_377/chien-cocker.jpg',
            },
            {
                id: 2,
                url: 'http://www.canalvie.com/polopoly_fs/1.1805932.1468181566!/image/chien-cocker.jpg_gen/derivatives/cvlandscape_670_377/chien-cocker.jpg',
            },
            {
                id: 3,
                url: 'http://www.canalvie.com/polopoly_fs/1.1805932.1468181566!/image/chien-cocker.jpg_gen/derivatives/cvlandscape_670_377/chien-cocker.jpg'
            }
        ];

        $scope.methods = {};

        $scope.conf = {
            thumbnails: true,
            thumbSize: 130,
            inline: false,
            bubbles: true,
            bubbleSize: 8,
            imgBubbles: false,
            bgClose: false,
            piracy: false,
            imgAnim: 'fadeup',
        };

        // so you will bind openGallery method to a button on page
        // to open this gallery like ng-click="openGallery();"
        $scope.openGallery = function () {
            $scope.methods.open();

            // You can also open gallery model with visible image index
            // Image at that index will be shown when gallery modal opens
            //scope.methods.open(index);
        };

        $scope.closeGallery = function () {
            $scope.methods.close();
        };

        $scope.nextImg = function () {
            $scope.methods.next();
        };

        $scope.prevImg = function () {
            $scope.methods.prev();
        };



        function getURLCompanyPhotos() {
            if ($scope.company.photos && $scope.company.photos.length > 0) {
                for (var i = 0; i < $scope.company.photos.length; i++) {
                    $scope.company.photos[i].url = $scope.URL.alternatedocroots + '/' + $scope.company.photos[i].location;
                    $scope.company.photos[i].id = i;
                }
            }
        }

    }
})();

(function () {
  'use strict';

  angular.module('sitegen.site').controller('CarouselBlocController', CarouselBlocController);

  function CarouselBlocController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, SiteGenService, $currentSite, $sce, $interpolate, $templateRequest, $compile) {
    var el = document.querySelector("#versionPure");

    $scope.slickConfig = {
      enabled: true,
      autoplay: true,
      draggable: true,
      autoplaySpeed: 3500,
      arrows: false,
      dots: true,
      dotsClass: el ? 'slick-dots nl-slick--dots--v2' : 'slick-dots nl-slick--dots',
      method: {} // required for .prev() + .next()
    };

    $timeout(() => {
      var el = document.querySelector("#versionPure");
      var firstImg = el.querySelector('.nl_slick--slide--img');
      if (firstImg != null) {
        $rootScope.siteImage = firstImg.getAttribute('src');
        firstImg.addEventListener('load', function () {
          document.querySelector('meta[property="og:image:width"]').setAttribute('content', '' + this.width);
          document.querySelector('meta[property="og:image:height"]').setAttribute('content', '' + this.height);
        })
      }
    });


    $scope.goToUrlCarousel = function (url) {
      if (!url || url == '') {
        return;
      }
      if (url.includes('http')) {
        window.open(url, '_blank');
      } else {
        window.open('//' + url, '_blank');
      }
    }

  }

})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('blogPureBlocController', blogPureBlocController);

	function blogPureBlocController($scope, $currentSite, $rootScope, $state, $filter, $translate, BlogService, statisticsService, SiteGenService, toastr, URL) {
		$scope.URL = URL;
		$scope.pagination = {
			page: 1,
			max: 20,
			total: 0,
			allCharged: false
		}
		$scope.blogs = [];
		$scope.blogsList = [];
		$scope.mailsended = false;
		$scope.newsletterMail = {};


		$scope.filter = {
			"tags": [],
			"countries": [],
			"regions": []
		}

		$scope.pageChanged = function (newPage) {
			$scope.loadMoreArticles(newPage);
		};

		$scope.init = function (tags, countries, regions, pageName) {
			$scope.articlePageName = pageName;
			if ($state.params.param1) {
				var split = $state.params.param1.split(':');
				var type = split[0];
				var id = split[1];
				if (type == "TAGS") {
					$scope.filter.tags.push(id);
				} else if (type == 'COUNTRIES') {
					$scope.filter.countries.push(id);
				} else {
					$scope.filter.regions.push(id);
				}
			} else {
				if (tags && tags != []) {
					$scope.filter.tags = tags;
				}
				if (countries && countries != []) {
					$scope.filter.countries = countries;
				}
				if (regions && regions != []) {
					$scope.filter.regions = regions;
				}
			}

			$scope.getBlogsFive();
			$scope.getBlogsList();
			$scope.findAllTags($translate.preferredLanguage());
			$scope.findAllCountries($translate.preferredLanguage());
			$scope.findAllRegions($translate.preferredLanguage());
		}

		$scope.details = function (articleId) {
			SiteGenService.find($currentSite.getSite().url, $scope.articlePageName, $translate.preferredLanguage()).then(function (resp) {

				SiteGenService.addStatisticRead(articleId, "", $translate.preferredLanguage()).then(function (res) {
					$currentSite.setSite(resp);
					$rootScope.$broadcast('menuReady');
					$rootScope.$broadcast('pageReady');
					$state.go('sitegen.page', {
						site: $currentSite.getSite().url,
						page: $scope.articlePageName,
						param1: articleId
					}, {
						reload: true
					});
				}).catch(function (err) {
					console.log(err)
				})

			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.getBlogsFive = function () {//recupere les 5 premiers
			var fmData = new FormData();
			var tags = $scope.filter.tags.toString();
			var countries = $scope.filter.countries.toString();
			var regions = $scope.filter.regions.toString();
			fmData.append('tags', tags);
			fmData.append('countries', countries);
			fmData.append('regions', regions);
			BlogService.findAllByRecent(fmData, $translate.preferredLanguage()).then(function (res) {

				$scope.blogs = [];
				if (res.data && res.data.articles && res.data.articles.length > 0) {
					$scope.blogs = res.data.articles;

				}

			}).catch(function (error) {
				console.log(error);
			})
		}

		$scope.getBlogsList = function () {//recupere la liste compacte
			var fmData = new FormData();
			var tags = $scope.filter.tags.toString();
			var countries = $scope.filter.countries.toString();
			var regions = $scope.filter.regions.toString();
			fmData.append('tags', tags);
			fmData.append('countries', countries);
			fmData.append('regions', regions);
			BlogService.findAllByRecent(fmData, $translate.preferredLanguage(), $scope.pagination.max, $scope.pagination.page - 1).then(function (res) {
				$scope.blogsList = [];
				if (res.data && res.data.articles && res.data.articles.length > 0) {
					$scope.blogsList = res.data.articles;
					$scope.pagination.total = res.data.total;
				}

			}).catch(function (error) {
				console.log(error);
			})
		}

		$scope.findAllTags = function (lang) {

			BlogService.findAllTags(lang).then(function (tags) {
				$scope.tags = tags.data;

			}).catch(function (data) {
				console.log(data)
			});
		};



		$scope.findAllCountries = function (lang) {

			statisticsService.getNationalities(lang).then(function (countries) {
				$scope.countries = countries.data;

			}).catch(function (data) {
				console.log(data)
			});
		};

		$scope.findAllRegions = function (lang) {

			statisticsService.getRegions(lang).then(function (regions) {
				$scope.regions = regions.data;

			}).catch(function (data) {
				console.log(data)
			});
		};

		$scope.filtrer = function () {
			$scope.pagination.page = 1;
			$scope.pagination.allCharged = false;
			$scope.pagination.total = 0;
			$scope.getBlogsFive();
			$scope.getBlogsList();
		}


		$scope.loadMoreArticles = function (page) {
			$scope.pagination.page = page;

			var fmData = new FormData();
			var tags = $scope.filter.tags.toString();
			var countries = $scope.filter.countries.toString();
			fmData.append('tags', tags);
			fmData.append('countries', countries);
			BlogService.findAllByRecent(fmData, $translate.preferredLanguage(), $scope.pagination.max, $scope.pagination.page - 1).then(function (res) {

				if (res.data && res.data.articles && res.data.articles.length > 0) {
					$scope.blogsList = res.data.articles;
				}


			}).catch(function (error) {
				console.log(error);
			})


		}

		$scope.sendNewsletter = function () {

			SiteGenService.sendNewsletter($scope.newsletterMail.mail).then(function (res) {
				$scope.mailsended = true;
			}).catch(function (err) {
				console.log(err)
				if (err.status === 406) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR_EMAIL_ALREADY'));
				} else {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}

			})
		}

	}
}
)();

(function () {
    'use strict';

    angular.module('sitegen.site').controller('BlogBlocController',BlogBlocController);

    function BlogBlocController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, SiteGenService, URL, $currentSite, $sce, $interpolate, BlogService) {
        var LAST_ARTICLES = 5;
        var MAX = 20;
        $scope.URL = URL;
        $scope.page = 0;
        $scope.infiniteScrollPrevent = false;
		  $scope.newsArray = [];
		  $scope.mailsended = false;
		  $scope.newsletterMail = {};


        BlogService.findXLast(LAST_ARTICLES, $translate.preferredLanguage()).then(function(response){
            $scope.lastNews = response.data;
        }).catch(function(){

        });

        $scope.loadMoreArticles = function(){
            $scope.infiniteScrollPrevent = true;
            BlogService.findRemains(LAST_ARTICLES, $scope.page, MAX, $translate.preferredLanguage()).then(function(response){
                if (response.data.length > 0){
                    $scope.newsArray = $scope.newsArray.concat(response.data);
                    $scope.infiniteScrollPrevent = false;
                }else{
                    $scope.infiniteScrollPrevent = true;
                }
                $scope.page++;
            }).catch(function(response){

            });
        };
        $scope.loadMoreArticles();


        $scope.details = function (pageName, articleId) {

            SiteGenService.find($currentSite.getSite().url, pageName, $translate.preferredLanguage()).then(function (resp) {


					 SiteGenService.addStatisticRead(articleId,"",$translate.preferredLanguage()).then(function(res){
						$currentSite.setSite(resp);
						$rootScope.$broadcast('menuReady');
                $rootScope.$broadcast('pageReady');
                $state.go('sitegen.page', {
                    site: $currentSite.getSite().url,
                    page: pageName,
                    param1: articleId
                }, {
                        reload: true
                    });
					}).catch(function(err){
							console.log(err)
					})


            }).catch(function (error) {
                toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
		  };

		  $scope.sendNewsletter = function() {

			SiteGenService.sendNewsletter($scope.newsletterMail.mail).then(function(res){
				$scope.mailsended = true;
			}).catch(function(err){
				console.log(err)
				if(err.status === 406){
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR_EMAIL_ALREADY'));
				}else{
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}

			})
	   }
    }

})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('bannerCarouselBlocController', bannerCarouselBlocController);

	function bannerCarouselBlocController($scope, $rootScope, $state, $translate, URL, SiteGenService, $currentSite, toastr, $filter) {
		$scope.URL = URL;
		$scope.banners = {};

		$scope._bannerSlickConfig = {
			enabled: true,
			autoplay: true,
			draggable: false,
			autoplaySpeed: 3500,
			arrows: false,
			dots: false,
			method: {} // required for .prev() + .next()
	  };

		$scope.getBanners = function (ids) {

			SiteGenService.findBannerCarouselByIds(ids, $translate.preferredLanguage()).then(function (res) {
				if (res.data != null) {
					$scope.banners = res.data;
				}
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			})
		}

		$scope.goToBanner = function (banner) {
			if (banner && banner.url) {
				SiteGenService.addStatisticBanner(banner.id).then(function (res) {
				}).catch(function (err) {
					//console.log(err);
				})
				if (banner.url.includes('http')) {
					window.open(banner.url, '_blank');
				} else {
					window.open('//' +banner.url, '_blank');
				}
			}
		}
	}
})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('bannerBlocController', bannerBlocController);

	function bannerBlocController($scope, $rootScope, $state, $translate, URL, SiteGenService, $currentSite, toastr, $filter) {
		$scope.URL = URL;
		$scope.banner = {};

		$scope.getBanner = function (id) {

			SiteGenService.findBannerById(id, $translate.preferredLanguage()).then(function (res) {
				if (res.data != null) {
					$scope.banner = res.data;
				}
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			})
		}

		$scope.goToBanner = function () {
			if ($scope.banner && $scope.banner.url) {
				SiteGenService.addStatisticBanner($scope.banner.id).then(function (res) {
				}).catch(function (err) {
					//console.log(err);
				})
				if ($scope.banner.url.includes('http')) {
					window.open($scope.banner.url, '_blank');
				} else {
					window.open('//' + $scope.banner.url, '_blank');
				}
			}
		}
	}
})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('articlePureBlocController', articlePureBlocController);

	function articlePureBlocController($scope, $rootScope, $state, $translate, BlogService, URL, SiteGenService, $currentSite, toastr, $filter, $cookies) {
		$scope.URL = URL;
		$scope.mailsended = false;
		$scope.newsletterMail = {};
		$scope._articleSlickConfig = {
			enabled: true,
			autoplay: true,
			draggable: true,
			autoplaySpeed: 3500,
			arrows: false,
			dots: true,
			dotsClass: 'slick-dots nl-slick--dots',
			method: {} // required for .prev() + .next()
		};
		$scope.articlesRelated = [];
		var ARTICLE_SESSION_STORAGE_KEY_PREFIX = "ARTICLE_";

		$scope.findArticle = function () {
			if ($state.params.param1 != null) {
				BlogService.findById($state.params.param1, $translate.preferredLanguage()).then(function (response) {

					$scope.article = response.data;
					$rootScope.siteDescription = $scope.article.name;
					$rootScope.siteType = 'article';

					getURLArticlePhotos();
					$scope.getRelatedArticles();
				}).catch(function () {

				});
			}
		};

		$scope.findArticle();

		$scope.$on('siteLanguageRefreshed', function () {
			$scope.findArticle();
		});

		$scope.setPageNames = function (nameGeneral, nameDetailsCompany) {
			$scope.pageGeneralName = nameGeneral;
			$scope.pageDetailsCompanyName = nameDetailsCompany;
		}
		$scope.methods = {};

		$scope.conf = {
			thumbnails: true,
			thumbSize: 130,
			inline: false,
			bubbles: true,
			bubbleSize: 8,
			imgBubbles: false,
			bgClose: false,
			piracy: false,
			imgAnim: 'fadeup',
		};

		// so you will bind openGallery method to a button on page
		// to open this gallery like ng-click="openGallery();"
		$scope.openGallery = function () {
			$scope.methods.open();

			// You can also open gallery model with visible image index
			// Image at that index will be shown when gallery modal opens
			//scope.methods.open(index);
		};

		$scope.closeGallery = function () {
			$scope.methods.close();
		};

		$scope.nextImg = function () {
			$scope.methods.next();
		};

		$scope.prevImg = function () {
			$scope.methods.prev();
		};



		function getURLArticlePhotos() {
			if ($scope.article.photos && $scope.article.photos.length > 0) {
				for (var i = 0; i < $scope.article.photos.length; i++) {
					$scope.article.photos[i].url = $scope.URL.alternatedocroots + '/' + $scope.article.photos[i].location;
					if (i === 0) {
						var full = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
						var imgUrl = full + $scope.URL.alternatedocrootsWithoutDot + '/' + angular.copy($scope.article.photos[i].location)
						$rootScope.siteImage = imgUrl;
						var img = new Image();
						img.onload = function () {
							document.querySelector('meta[property="og:image:width"]').setAttribute('content', '' + this.width);
							document.querySelector('meta[property="og:image:height"]').setAttribute('content', '' + this.height);
						}
						img.src = imgUrl;
					}
					$scope.article.photos[i].id = i;
				}
			}
		}

		$scope.sendNewsletter = function () {

			SiteGenService.sendNewsletter($scope.newsletterMail.mail).then(function (res) {
				$scope.mailsended = true;
			}).catch(function (err) {
				console.log(err)
				if (err.status === 406) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR_EMAIL_ALREADY'));
				} else {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}

			})
		}

		$scope.goToFilterPage = function (tag, type) {
			$state.go('sitegen.page', {
				site: $currentSite.getSite().url,
				page: $scope.pageGeneralName,
				param1: "" + type + ":" + tag.id
			})
		}

		$scope.goToDetailsCompany = function (company) {
			$state.go('sitegen.page', {
				site: $currentSite.getSite().url,
				page: $scope.pageDetailsCompanyName,
				param1: company.id
			})
		}

		$scope.getRelatedArticles = function () {
			SiteGenService.getRelatedArticles($scope.article.id, $translate.preferredLanguage()).then(function (res) {
				$scope.articlesRelated = res.data;
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}

		$scope.details = function (pageName, articleId) {
			SiteGenService.addStatisticRead(articleId, "", $translate.preferredLanguage()).then(function (res) {
			}).catch(function (err) {
				console.log(err)
			})
			SiteGenService.find($currentSite.getSite().url, pageName, $translate.preferredLanguage()).then(function (resp) {

				$currentSite.setSite(resp);
				$rootScope.$broadcast('menuReady');
				$rootScope.$broadcast('pageReady');
				$state.go('sitegen.page', {
					site: $currentSite.getSite().url,
					page: pageName,
					param1: articleId
				}, {
					reload: true
				});

			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.isOnSelection = function (article) {
			if (article != null) {
				return localStorage.getItem(ARTICLE_SESSION_STORAGE_KEY_PREFIX + article.id);
			} else {
				return null;
			}
		};

		$scope.deleteFromSelection = function (article) {
			localStorage.removeItem(ARTICLE_SESSION_STORAGE_KEY_PREFIX + article.id);
		};

		$scope.addToSelection = function (article) {
			$scope.nbSelections = 0;
			for (var i = 0; i < localStorage.length; i++) {
				if (localStorage.key(i).substring(0, 9) === ARTICLE_SESSION_STORAGE_KEY_PREFIX) {
					try {
						var _item = JSON.parse(localStorage.getItem(localStorage.key(i)));
						if (_item.id && localStorage.key(i) === ARTICLE_SESSION_STORAGE_KEY_PREFIX + _item.id) {
							$scope.nbSelections++;
						}
					} catch (error) {
						console.log(error);
					}
				}
			}
			if ($scope.nbSelections > 4) {
				toastr.error($filter('translate')('SITE_GEN.NB_SELECTIONS_ERROR'));
			} else {
				localStorage.setItem(ARTICLE_SESSION_STORAGE_KEY_PREFIX + article.id, JSON.stringify({
					id: article.id,
					modelPattern: article.name,
					session: $cookies.get("SESSION_TOKEN")
				}));
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('articleXBlocController', articleXBlocController);

	function articleXBlocController($scope, $currentSite, $rootScope, $state, $translate, BlogService, SiteGenService, URL, toastr, $filter) {
		$scope.URL = URL;

		$scope.news = {};
		$scope.list = [];

		$scope.getArticle = function (pageName, id) {
			$scope.articlePageName = pageName;
			BlogService.findById(id, $translate.preferredLanguage()).then(function (res) {
				$scope.news = res.data;
				$scope.addStatisticShown($scope.news)
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			})
		}

		$scope.getArticlesForSpecial = function (pageName, id1, id2, id3, id4) {
			$scope.articlePageName = pageName;

			BlogService.findForSpecialById(id1, id2, id3, id4, $translate.preferredLanguage()).then(function (res) {
				$scope.folderDTO = res.data;

				if($scope.folderDTO.article1){
					$scope.addStatisticShown($scope.folderDTO.article1)
				}
				if($scope.folderDTO.article2){
					$scope.addStatisticShown($scope.folderDTO.article2)
				}
				if($scope.folderDTO.article3){
					$scope.addStatisticShown($scope.folderDTO.article3)
				}
				if($scope.folderDTO.article4){
					$scope.addStatisticShown($scope.folderDTO.article4)
				}



			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			})
		}

		$scope.addStatisticShown = function(article){
			SiteGenService.addStatisticShown(article.id, "SPECIAL", $translate.preferredLanguage()).then(function () {

			}).catch(function () {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			})
		}


		$scope.details = function (article) {
			if(!article){
				return;
			}
			SiteGenService.find($currentSite.getSite().url, $scope.articlePageName, $translate.preferredLanguage()).then(function (resp) {

				SiteGenService.addStatisticRead(article.id, "SPECIAL", $translate.preferredLanguage()).then(function () {
					$currentSite.setSite(resp);
					$rootScope.$broadcast('menuReady');
					$rootScope.$broadcast('pageReady');
					$state.go('sitegen.page', {
						site: $currentSite.getSite().url,
						page: $scope.articlePageName,
						param1: article.id
					}, {
						reload: true
					});
				}).catch(function () {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				})


			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

	}
}
)();

(function(){
	'use strict';

	angular.module('sitegen.site').controller('articleBlocController', articleBlocController);

	function articleBlocController($scope,$rootScope, $state, $translate, BlogService, URL,SiteGenService,$currentSite,toastr,$filter){
		$scope.URL = URL;
		$scope.mailsended = false;
		$scope.newsletterMail = {};
		$scope._articleSlickConfig = {
			enabled: true,
			autoplay: true,
			draggable: true,
			autoplaySpeed: 3500,
			arrows: false,
			dots: true,
			dotsClass: 'slick-dots nl-slick--dots',
			method: {} // required for .prev() + .next()
	  };


		$scope.findArticle = function () {
			if ($state.params.param1 != null){
				BlogService.findById($state.params.param1, $translate.preferredLanguage()).then(function (response) {

					$scope.article = response.data;
					SiteGenService.addStatisticRead($scope.article.id,"",$translate.preferredLanguage()).then(function(res){
					}).catch(function(err){
							console.log(err)
					})
					getURLArticlePhotos();

				}).catch(function () {

				});
			}
		};

		$scope.findArticle();

		$scope.$on('siteLanguageRefreshed', function () {
			$scope.findArticle();
		});


		$scope.methods = {};

		$scope.conf = {
			thumbnails: true,
			thumbSize: 130,
			inline: false,
			bubbles: true,
			bubbleSize: 8,
			imgBubbles: false,
			bgClose: false,
			piracy: false,
			imgAnim: 'fadeup',
		};

		// so you will bind openGallery method to a button on page
		// to open this gallery like ng-click="openGallery();"
		$scope.openGallery = function () {
			$scope.methods.open();

			// You can also open gallery model with visible image index
			// Image at that index will be shown when gallery modal opens
			//scope.methods.open(index);
		};

		$scope.closeGallery = function () {
			$scope.methods.close();
		};

		$scope.nextImg = function () {
			$scope.methods.next();
		};

		$scope.prevImg = function () {
			$scope.methods.prev();
		};



		function getURLArticlePhotos() {
			if ($scope.article.photos && $scope.article.photos.length > 0) {
				for (var i = 0; i < $scope.article.photos.length; i++) {
					$scope.article.photos[i].url = $scope.URL.alternatedocroots + '/' + $scope.article.photos[i].location;
					$scope.article.photos[i].id = i;
				}
			}
		}

		$scope.goToFilterPage = function(tag,type) {
			$state.go('sitegen.page', {
				site: $currentSite.getSite().url,
				page: $scope.pageGeneralName,
				param1: ""+type+":"+tag.id
			})
		}



	}
})();

(function(){
	'use strict';

	angular.module('sitegen.site').controller('SiteGenUpdateMyPasswordController', SiteGenUpdateMyPasswordController);

    function SiteGenUpdateMyPasswordController($scope, $state, $translate, URL, $filter, companyService, SiteGenService, $currentSite, $rootScope, toastr, 
        $accountProvider, userService, $location){

            $scope.password = {};

			$scope.updateMyPassword = function(_form) {
				$accountProvider.updateMyPassword($scope.account.id, $scope.password.actualPassword, $scope.password.newPassword).then(function(response){
                    $scope.toastr.success($filter('translate')('SITE_GEN.ACCOUNT.PASSWORD_UPDATED'));
                    $scope.password = {};
					_form.$setPristine();
					_form.$setUntouched();
				}).catch(function(error){
					if(error.status === 400 && error.data == 'WRONG_ACTUAL_PASSWORD') {
						$scope.toastr.error($filter('translate')('SITE_GEN.ACCOUNT.WRONG_ACTUAL_PASSWORD'));
					} else {
						$scope.toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					}
					console.log(error);
				});
            };
            
            $scope.goToMyProfil = function() {
                $state.go('sitegen.site.my_profile', {site: $currentSite.getSite().url});
            };

	}
})();
(function(){
	'use strict';

	angular.module('sitegen.site').controller('SiteGenMyProfileController', SiteGenMyProfileController);

    function SiteGenMyProfileController($scope, $state, $translate, URL, $filter, companyService, SiteGenService, $currentSite, $rootScope, toastr,
        $accountProvider, userService, $location){


			$translate(['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MR', 'SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MRS']).then((translation) => {

				$scope.civilities = [
					translation['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MR'],
					translation['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MRS']
				];

			});

		$accountProvider.getAccount(true).then(function (response) {
            $scope.account = response;
        }).catch(function (error) {
			$rootScope.$emit('OnAccountReady');
			$state.go('sitegen.site', {site: $currentSite.getSite().url});
            console.log(error);
        });

		$scope.updateMyProfile = function(_form) {
			var fmData = new FormData();
			fmData.append('dto', angular.toJson($scope.account));
			$accountProvider.updateMyProfile(fmData).then(function(response){
				$rootScope.$emit('OnAccountReady');
				$scope.toastr.success($filter('translate')('SITE_GEN.ACCOUNT.PROFILE_UPDATED'));
				_form.$setPristine();
				_form.$setUntouched();
				$state.go('sitegen.site.account_home',{site: $currentSite.getSite().url});
			}).catch(function(error){
				if(error.status === 409) {
					if(error.data == 'ALREADY_EXIST_MAIL') {
						$scope.toastr.error($filter('translate')('USERS.ALREADY_EXIST_MAIL'));
					} else if(error.data == 'ALREADY_EXIST_LOGIN') {
						$scope.toastr.error($filter('translate')('USERS.ALREADY_EXIST_LOGIN'));
					} else {
						$scope.toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					}
				} else {
					$scope.toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}
				console.log(error);
			});
		};

		$scope.onUpdateMyPassword = function() {
			$state.go('sitegen.site.update_password', {site: $currentSite.getSite().url});
		};

	}
})();

(function () {
	'use strict';

	angular.module('sitegen.site').controller('SiteGenLoginController', SiteGenLoginController);

	function SiteGenLoginController($scope, $state, $translate, URL, $filter, companyService, SiteGenService, $currentSite, $rootScope, toastr,
		$accountProvider, userService, $location) {

		$scope.loginDTO = {};
		$scope.newUser = {};
		$scope.registerSuccess = false;
		$scope.fromAction = $location.search().fromAction;
		$scope.textActivation = null;

		if ($location.search().fromActivation) {
			$scope.textActivation = $filter('translate')('SITE_GEN.ACCOUNT.NEW_ACCOUNT_ACTIVATED_MSG');
		}

		$translate(['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MR', 'SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MRS']).then((translation) => {

			$scope.civilities = [
				translation['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MR'],
				translation['SITE_GEN.REQUEST_FOR_PROPOSALS.CIVILITY.MRS']
			];

		});


		$scope.login = function (_form) {
			$accountProvider.login($scope.loginDTO).then(function (response) {
				$rootScope.$emit('OnAccountReady');
				$scope.loginDTO = {};
				_form.$setPristine();
				_form.$setUntouched();
				if ($scope.fromAction && $scope.fromAction === 'FROM_ON_ASK_FOR_A_QUOTE_ACTION') {
					$state.go('sitegen.site.request_for_proposal.send', { site: $currentSite.getSite().url });
				} else if($scope.fromAction && $scope.fromAction.indexOf('COMPANY_')>-1){
					$state.go('sitegen.page', {
						site: $currentSite.getSite().url,
						page: $rootScope.site.companyUrl,
						param1: $scope.fromAction.split("_")[1]
					})
				} else {
					if (response.anyRequired == true) {
						$state.go('sitegen.site.my_profile', { site: $currentSite.getSite().url });
					} else {
						$state.go('sitegen.site.account_home', { site: $currentSite.getSite().url });
					}
				}
			}).catch(function (response) {
				$scope.toastr.error($filter("translate")("SITE_GEN.ACCOUNT.INCORRECT_IDENTIFIER"));
			});
		};

		$scope.register = function (_form) {
			var fmData = new FormData();
			fmData.append('dto', angular.toJson($scope.newUser));
			$accountProvider.register(fmData, $translate.preferredLanguage(), $location.search().fromAction, $scope.contextUrl + "/" + $currentSite.getSite().url).then(function (response) {
				$scope.toastr.success($filter('translate')('SITE_GEN.ACCOUNT.NEW_ACCOUNT_ACTIVATION_ASK_MSG'));
				$scope.newUser = {};
				_form.$setPristine();
				_form.$setUntouched();
				$scope.registerSuccess = true;
			}).catch(function (error) {
				if (error.status === 409) {
					if (error.data == 'ALREADY_EXIST_MAIL') {
						$scope.toastr.error($filter('translate')('USERS.ALREADY_EXIST_MAIL'));
					} else if (error.data == 'ALREADY_EXIST_LOGIN') {
						$scope.toastr.error($filter('translate')('USERS.ALREADY_EXIST_LOGIN'));
					} else {
						$scope.toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					}
				} else {
					$scope.toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}
				console.log(error);
			});
		};

		$scope.onForgotLogin = function () {
			$state.go('sitegen.site.forgot_login', { site: $currentSite.getSite().url, fromAction: $location.search().fromAction });
		};

		$scope.onForgotPassword = function () {
			$state.go('sitegen.site.forgot_password', { site: $currentSite.getSite().url, fromAction: $location.search().fromAction });
		};
	}
})();

(function(){
	'use strict';

	angular.module('sitegen.site').controller('SiteGenForgotPasswordController', SiteGenForgotPasswordController);

    function SiteGenForgotPasswordController($scope, $state, $translate, URL, $filter, companyService, SiteGenService, $currentSite, $rootScope, toastr, 
        $accountProvider, userService, $location){

		$scope.token = $location.search().key;
		$scope.fromAction = $location.search().fromAction;
		$scope.usermail = {};
		$scope.password = {};

		$scope.forgotPasswordRequest = function(_form) {
			$accountProvider.forgotPasswordRequest($scope.usermail.value, $translate.preferredLanguage(), 
				$location.search().fromAction, $scope.contextUrl + "/" + $currentSite.getSite().url).then(function (response) {
				$scope.toastr.success($filter('translate')('SITE_GEN.ACCOUNT.FORGOT_PASSWORD_SUBMIT_MSG'));
				$scope.usermail = {};
				_form.$setPristine();
				_form.$setUntouched();
			}).catch(function (error) {
				$scope.toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.updateForgotPassword = function(_form) {
			$accountProvider.updateForgotPassword($scope.token, $scope.password.newPassword).then(function (response) {					
				$scope.toastr.success($filter('translate')('SITE_GEN.ACCOUNT.FORGOT_PASSWORD_UPDATED_SUCCESS'));
				$state.go('sitegen.site.login', {site: $currentSite.getSite().url, fromAction : $location.search().fromAction});
				$scope.password = {};
				_form.$setPristine();
				_form.$setUntouched();
			}).catch(function (error) {
				if(error.status === 400) {
					$scope.toastr.error($filter("translate")("SITE_GEN.ACCOUNT.TOKEN_VALIDATION.BAD_REQUEST_EXEPTION"));
					$scope.loading = false;
				} else if(error.status === 408) {
					$scope.toastr.error($filter("translate")("SITE_GEN.ACCOUNT.TOKEN_VALIDATION.TIMEOUT_EXCEPTION"));
					$scope.loading = false;
				} else {
					$scope.toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					$state.go('sitegen.site.login', {site: $currentSite.getSite().url});
				}
			});
		};

	}
})();
(function(){
	'use strict';

	angular.module('sitegen.site').controller('SiteGenForgotLoginController', SiteGenForgotLoginController);

    function SiteGenForgotLoginController($scope, $state, $translate, URL, $filter, companyService, SiteGenService, $currentSite, $rootScope, toastr, 
        $accountProvider, userService, $location){

		$scope.usermail = {};

		$scope.forgotLoginRequest = function(_form) {
			$accountProvider.forgotLoginRequest($scope.usermail.value, $translate.preferredLanguage(), 
				$location.search().fromAction, $scope.contextUrl + "/" + $currentSite.getSite().url).then(function (response) {
				$scope.toastr.success($filter('translate')('SITE_GEN.ACCOUNT.FORGOT_LOGIN_SUBMIT_MSG'));
				$scope.usermail = {};
				_form.$setPristine();
                _form.$setUntouched();
                $state.go('sitegen.site.login', {site: $currentSite.getSite().url, fromAction : $location.search().fromAction});
			}).catch(function (error) {
				$scope.toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};
	}
})();
(function () {
	'use strict';

	angular.module('sitegen.site').controller('SiteGenAccountActivationController', SiteGenAccountActivationController);

	function SiteGenAccountActivationController($scope, $state, $translate, URL, $filter, companyService, SiteGenService, $currentSite, $rootScope, toastr,
		$accountProvider, userService, $location) {

		$scope.loading = true;
		$scope.usermail = {};

		if ($location.search().key) {
			$accountProvider.activateAccountTokenValidation($location.search().key).then(function (response) {
				$scope.toastr.success($filter('translate')('SITE_GEN.ACCOUNT.NEW_ACCOUNT_ACTIVATED_MSG'));

				if ($location.search().fromAction && $location.search().fromAction === "FROM_ON_ASK_FOR_A_QUOTE_ACTION") {
					$state.go('sitegen.site.login', {
						site: $currentSite.getSite().url,
						fromAction: 'FROM_ON_ASK_FOR_A_QUOTE_ACTION',
						fromActivation: true
					});
				} else {
					$state.go('sitegen.site.login', {
						site: $currentSite.getSite().url,
						fromActivation: true
					});
				}
			}).catch(function (error) {
				if (error.status === 400) {
					$scope.toastr.error($filter("translate")("SITE_GEN.ACCOUNT.TOKEN_VALIDATION.BAD_REQUEST_EXEPTION"));
					$scope.loading = false;
				} else if (error.status === 408) {
					$scope.toastr.error($filter("translate")("SITE_GEN.ACCOUNT.TOKEN_VALIDATION.TIMEOUT_EXCEPTION"));
					$scope.loading = false;
				} else {
					$scope.toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					$state.go('sitegen.site.login', {
						site: $currentSite.getSite().url
					});
				}
			});
		}

		$scope.activateAccountRequest = function (_form) {
			$accountProvider.activateAccountRequest($scope.usermail.value, $translate.preferredLanguage(),
				$location.search().fromAction, $scope.contextUrl + "/" + $currentSite.getSite().url).then(function (response) {
				$scope.toastr.success($filter('translate')('SITE_GEN.ACCOUNT.NEW_ACCOUNT_ACTIVATION_ASK_MSG'));
				$scope.usermail = {};
				_form.$setPristine();
				_form.$setUntouched();
				$state.go('sitegen.site.login', {
					site: $currentSite.getSite().url
				});
			}).catch(function (error) {
				$scope.toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};
	}
})();

(function () {
	'use strict';
	angular.module('sitegen.site').provider('$accountProvider', accountProvider);
	function accountProvider() {
		this.$get = function ($injector, STORAGE_PREFIX) {
            var $http = $injector.get('$http');
            var $q = $injector.get('$q');
            var $rootScope = $injector.get('$rootScope');
            var provider = {};
            var account = null;
            provider.getAccount = function(refresh) {
                return $q(function (resolve, reject) {
                    if(!account || refresh) {
                        $http({
                            url: '/api/rest/user',
                            method: 'GET',
                            params: { '_v': new Date().getTime() },
                            headers: { 'Content-Type': 'application/json;charset=UTF-8' }
                        }).then(function (response) {
                            account = response.data;
                            resolve(account);
                        }).catch(function (error) {
                            reject(error);
                        });
                    } else {
                        resolve(account);
                    }
                });
            };
            provider.setAccount = function(_account) {
                account = _account;
                return account;
            };
            provider.login = function (loginDto) {
                return $q(function (resolve, reject) {
                    $http({
                        url: './api/public/sitegen/login',
                        method: 'POST',
                        params: { '_v': new Date().getTime() },
                        data : loginDto
                    }).then(function (response) {
                        account = response.data;
                        resolve(account);
                    }).catch(function (error) {
                        reject(error);
                    });
                });
            };
            provider.logout = function () {
                return $q(function (resolve, reject) {
                    $http({
                        url: '/api/public/sitegen/logout',
                        method: 'GET',
                        params: { '_v': new Date().getTime() },
                    }).then(function (response) {
                        account = null;
                        resolve(account);
                    }).catch(function (error) {
                        reject(error);
                    });
                });
            };
            provider.register = function (fmData, lang, fromAction, baseUrl) {
                return $q(function (resolve, reject) {
                    $http({
                        url: '/api/public/sitegen/register',
                        method: 'POST',
                        params: { '_v': new Date().getTime(), 'lang' : lang, 'fromAction': fromAction,
                            'baseUrl' : baseUrl },
                        headers: { 'Content-Type': undefined },
                        data: fmData
                    }).then(function (response) {
                        account = response.data;
                        resolve(account);
                    }).catch(function (error) {
                        reject(error);
                    });
                });
				};
				provider.registerWithoutConfirm = function (fmData, lang, baseUrl) {
					return $q(function (resolve, reject) {
						 $http({
							  url: '/api/public/sitegen/registerWithoutConfirm',
							  method: 'POST',
							  params: { '_v': new Date().getTime(), 'lang' : lang,
									'baseUrl' : baseUrl },
							  headers: { 'Content-Type': undefined },
							  data: fmData
						 }).then(function (response) {
							  account = response.data;
							  resolve(account);
						 }).catch(function (error) {
							  reject(error);
						 });
					});
			  };
            provider.activateAccountTokenValidation = function (token, fromAction) {
                return $q(function (resolve, reject) {
                    $http({
                        url: '/api/public/sitegen/activateAccountTokenValidation',
                        method: 'PUT',
                        params: { '_v': new Date().getTime(), 'token': token }
                    }).then(function (response) {
                        resolve(response);
                    }).catch(function (error) {
                        reject(error);
                    });
                });
            };
            provider.activateAccountRequest = function (mail, lang, fromAction, baseUrl) {
                return $q(function (resolve, reject) {
                    $http({
                        url: '/api/public/sitegen/activateAccountRequest',
                        method: 'PUT',
                        params: { '_v': new Date().getTime(), 'mail' : mail, 'lang' : lang, 'fromAction': fromAction,
                            'baseUrl' : baseUrl }
                    }).then(function (response) {
                        resolve(response);
                    }).catch(function (error) {
                        reject(error);
                    });
                });
            };
            provider.updateMyProfile = function (fmData) {
                return $q(function (resolve, reject) {
                    $http({
                        url: '/api/rest/sitegen/updateMyProfile',
                        method: 'PUT',
                        params: { '_v': new Date().getTime()},
                        headers: { 'Content-Type': undefined },
                        data: fmData
                    }).then(function (response) {
                        account = response.data;
                        resolve(account);
                    }).catch(function (error) {
                        reject(error);
                    });
                });
            };
            provider.updateMyPassword = function (userId, actualPassword, newPassword) {
                return $q(function (resolve, reject) {
                    $http({
                        url: '/api/rest/sitegen/updateMyPassword/' + userId,
                        method: 'PUT',
                        params: { '_v': new Date().getTime(), 'actualPassword': actualPassword, 'newPassword' : newPassword}
                    }).then(function (response) {
                        resolve(response);
                    }).catch(function (error) {
                        reject(error);
                    });
                });
            };
            provider.forgotLoginRequest =  function (mail, lang) {
                return $q(function (resolve, reject) {
                    $http({
                        url: '/api/public/sitegen/forgotLoginRequest/',
                        method: 'PUT',
                        params: { '_v': new Date().getTime(), 'mail' : mail, 'lang' : lang }
                    }).then(function (response) {
                        resolve(response);
                    }).catch(function (error) {
                        reject(error);
                    });
                });
            };
            provider.forgotPasswordRequest =  function (mail, lang, fromAction, baseUrl) {
                return $q(function (resolve, reject) {
                    $http({
                        url: '/api/public/sitegen/forgotPasswordRequest/',
                        method: 'PUT',
                        params: { '_v': new Date().getTime(), 'mail' : mail, 'lang' : lang, 'fromAction': fromAction,
                            'baseUrl' : baseUrl }
                    }).then(function (response) {
                        resolve(response);
                    }).catch(function (error) {
                        reject(error);
                    });
                });
            };
            provider.updateForgotPassword =  function (token, newPassword) {
                return $q(function (resolve, reject) {
                    $http({
                        url: '/api/public/sitegen/updateForgotPassword/',
                        method: 'PUT',
                        params: { '_v': new Date().getTime(), 'token' : token, 'newPassword' : newPassword }
                    }).then(function (response) {
                        resolve(response);
                    }).catch(function (error) {
                        reject(error);
                    });
                });
            };
            return provider;
        };
	}
})();

(function () {
    'use strict';
  
    angular.module('app.front').service('ResearchPageCreationService', ResearchPageCreationService);
  
      function ResearchPageCreationService($q, $http){

        var service = {};
        
        service.fixeFields = function(){
            return $q(function(resolve, reject){
                $http({
                   url: './api/rest/ResearchPageCreationResources/fixeFields',
                    method: 'GET',
                    params: { '_v': new Date().getTime() }
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            });
        };

        service.findFilter = function(modelType, subTypeId, lang){
            return $q(function(resolve, reject){
                $http({
                    url: './api/rest/ResearchPageCreationResources/findFilter/',
                    method: 'GET',
                    params: { 
                        '_v': new Date().getTime(),
                        'modelType' : modelType, 
                        'subTypeId' : subTypeId, 
                        'lang': lang
                    }
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            });
        };

        service.findSort = function(modelType, subTypeId, lang){
            return $q(function(resolve, reject){
                $http({
                    url: './api/rest/ResearchPageCreationResources/findSort/',
                    method: 'GET',
                    params: { 
                        '_v': new Date().getTime(),
                        'modelType' : modelType, 
                        'subTypeId' : subTypeId, 
                        'lang': lang
                    }
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            });
        };

        service.find = function(modelType, subTypeId, config, lang){
            return $q(function(resolve, reject){
                $http({
                    url: './api/rest/ResearchPageCreationResources/',
                    method: 'GET',
                    params: { 
                        '_v': new Date().getTime(),  
                        'modelType' : modelType, 
                        'subTypeId' : subTypeId, 
                        'config' : config, 
                        'lang': lang 
                    }
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            });
        };

        service.save = function(resConfig){
            return $q(function(resolve, reject){
                $http({
                    url: './api/rest/ResearchPageCreationResources',
                    method: 'POST',
                    params: { '_v': new Date().getTime()},
                    data : resConfig
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            });
        };

        service.delete = function(resConfig){
            return $q(function(resolve, reject){
                $http({
                    url: './api/rest/ResearchPageCreationResources/' + resConfig.data.id,
                    method: 'DELETE',
                    params: { '_v': new Date().getTime(), 'config' : resConfig.config },
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            });
        };

        service.upField = function(resConfig) {
            return $q(function(resolve, reject) {
                $http({
                    url : './api/rest/ResearchPageCreationResources/upField/' + resConfig.data.id,
                    method: 'POST',
                    params: { '_v': new Date().getTime(), 'config' : resConfig.config }
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            })
        };

        service.downField = function(resConfig) {
            return $q(function(resolve, reject) {
                $http({
                    url : './api/rest/ResearchPageCreationResources/downField/' + resConfig.data.id,
                    method: 'POST',
                    params: { '_v': new Date().getTime(), 'config' : resConfig.config }
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            })
        };
    
        return service;

    }
  
})();
  
(function () {
  'use strict';

  angular.module('app.front').controller('ResearchPageCreationController', ResearchPageCreationController);

  function ResearchPageCreationController($rootScope, DISPLAY_MODELS_ICONS, STORAGE_PREFIX, $scope, $timeout, $filter, $state, $translate, toastr, modelService,
     ResearchPageCreationService, inscriptionFormService) {
    
    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
    };

    $scope.fields = [];
    $scope.filters = [];
    $scope.sorts = [];

    $scope.category = {};
    $scope.fieldsAvalaible = [];
    $scope.displaysModels = [];
    $scope.fieldToAdd = null;
    $scope.DISPLAY_MODELS_ICONS = DISPLAY_MODELS_ICONS;
    var dataReady = false;

    $scope.companyModelType = 'COMPANY_MODEL';
    $scope.contactModelType = 'CONTACT_MODEL';
    $scope.registrationModelType = 'INSCRIPTION_MODEL';
    $scope.logisticModelType = 'LOGISTIC_MODEL';

    $scope.modelType = $state.params.modelType;

    $scope.baseUrl = './api/rest/model/' + $state.params.modelType;

    $scope.newFieldToFilter = {};
    $scope.newFieldToSort = {};

    $scope.fieldsAndFiltersReady = {
      filters : false,
      sorts   : false,
      fields  : false
    };

    // Utils

    function removeUsedFields(_fields, _fieldsConf) {
      var _fieldsResult = [];
      if (_fields !== [] && _fieldsConf !== []) {
        var deleteIndex = [];
        _fieldsResult = angular.copy(_fields);
        angular.forEach(_fieldsResult, function (field, index) {
          angular.forEach(_fieldsConf, function (fieldConf) {
            if (field.id && fieldConf.fieldModelDto && fieldConf.fieldModelDto.id) {
              if (field.id === fieldConf.fieldModelDto.id) {
                deleteIndex.push(angular.copy(index));
              }
            }
            if (field.data && field.data.name && fieldConf.fixeFieldDto && fieldConf.fixeFieldDto.data && fieldConf.fixeFieldDto.data.name) {
              if (field.data.name === fieldConf.fixeFieldDto.data.name) {
                deleteIndex.push(angular.copy(index));
              }
            }
          });
        });
        var i = deleteIndex.length;
        while (i--) {
          _fieldsResult.splice(deleteIndex[i], 1);
        }
      }
      return _fieldsResult;
    };

    // Liste des champs    

    if($state.params.modelType == "COMPANY_MODEL") {
      modelService.listFieldsBySubType($state.params.modelType, $state.params.subTypeId, $translate.preferredLanguage()).then(function (resp) {
        // Liste des champs de modèle de company
        $scope.fields = $filter('filter')(resp.data, function (item) {
          return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT';
        });
        // For filter
        $scope.filterFields = angular.copy($scope.fields);
        // For sort
        $scope.sortFields = $filter('filter')(resp.data, function (item) {
          return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' 
            && item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT';
        });
        // For wiew
        $scope.columnFields = $filter('filter')(resp.data, function (item) {
          return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' 
            && item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT' && item.typeChamps !== 'LONG_TEXT';
        });
        // Ajout champ fixe actif/inactif
        $scope.columnFields.push({
          index: $scope.columnFields.lenght + 1,
          libelle: angular.copy($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_STATUS')),
          data: 'FIXE_FIELD_STATUS',
        });
        // Liste des champs fixe (Activé/Désactivé, List de contact, champs de l'entité disposition, etc ...) pour le filtre sur les companies
        ResearchPageCreationService.fixeFields().then(function (resp) {
          angular.forEach(resp.data, function (item, index) {
            if(item.name != 'FIXE_FIELD_CREATION_DATE' && item.name != 'FIXE_FIELD_MODIFICATION_DATE' 
                && item.name != 'FIXE_FIELD_CREATION_DATE_CONTACT' && item.name != 'FIXE_FIELD_MODIFICATION_DATE_CONTACT' 
                && item.name != 'FIXE_FIELD_REGISTRATION_SUBCATEGORY' 
                && item.name !='FIXE_FIELD_LOGISTIC_STATUS' 
                && item.name != 'FIXE_FIELD_REGISTRATION_STATUS') {
              var _fixeFieldLibelle = 'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.' + item.name;
              var _fixeField = {
                index: $scope.fields.length + 1,
                libelle: angular.copy($filter('translate')(_fixeFieldLibelle)),
                data: angular.copy(item),
              };
              $scope.filterFields.push(_fixeField);
            }
          });
          // Liste des champs de modèle de contact     
          modelService.listFieldsByType($scope.contactModelType, $translate.preferredLanguage()).then(function (resp) {
            $scope.contactFields = $filter('filter')(resp.data, function (item) {
              return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
            });
            angular.forEach($scope.contactFields, function (item, index) {
              $scope.filterFields.push(angular.copy(item));
            });
            // All xhr async process end
            $scope.fieldsAndFiltersReady.fields = true;
            if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.filters) {
              $scope.fieldsForFiltersFiltered = removeUsedFields($scope.filterFields, $scope.filters);
            }
            if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.sorts) {
              $scope.fieldsForSortsFiltered = removeUsedFields($scope.sortFields, $scope.sorts);
            }
            if (dataReady) {
              filterFieldsFn();
            } else {
              dataReady = true;
            }
          }).catch(function (error) {
            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            console.log(error);
          });
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
          console.log(error);
        });
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        console.log(error);
      });
    } else if($state.params.modelType == "INSCRIPTION_MODEL") {
      modelService.listFieldsByType($scope.registrationModelType, $translate.preferredLanguage()).then(function (resp) {
        $scope.fields = $filter('filter')(resp.data, function (item) {
          return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT';
        });
        $scope.filterFields = angular.copy($scope.fields);
        $scope.sortFields = $filter('filter')(resp.data, function (item) {
          return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' 
            && item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT';
        });
        $scope.columnFields = $filter('filter')(resp.data, function (item) {
          return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' 
            && item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT' && item.typeChamps !== 'LONG_TEXT';
        });
        modelService.listFieldsByType($scope.logisticModelType, $translate.preferredLanguage()).then(function (resp) {
          angular.forEach(resp.data, function (item, index) {
            if(item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT') {
              $scope.filterFields.push(angular.copy(item));
            }
            if(item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' 
                && item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT') {
              $scope.sortFields.push(angular.copy(item));
            }
            if(item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' 
                && item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT' && item.typeChamps !== 'LONG_TEXT') {
              $scope.columnFields.push(angular.copy(item));
            }
          });
          modelService.listFieldsByType($scope.companyModelType, $translate.preferredLanguage()).then(function (resp) {
            angular.forEach(resp.data, function (item, index) {
              if(item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT') {
                $scope.filterFields.push(angular.copy(item));
              }
              if(item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' 
                  && item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT') {
                $scope.sortFields.push(angular.copy(item));
              }
              if(item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' 
                  && item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT' && item.typeChamps !== 'LONG_TEXT') {
                $scope.columnFields.push(angular.copy(item));
              }
            });
            modelService.listFieldsByType($scope.contactModelType, $translate.preferredLanguage()).then(function (resp) {
              angular.forEach(resp.data, function (item, index) {
                if(item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT') {
                  $scope.filterFields.push(angular.copy(item));
                }
                if(item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' 
                    && item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT') {
                  $scope.sortFields.push(angular.copy(item));
                }
                if(item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' 
                    && item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT' && item.typeChamps !== 'LONG_TEXT') {
                  $scope.columnFields.push(angular.copy(item));
                }
              });
              // Registration Form Sub-Category
              var _fixeFieldRegistrationSubCat = {
                id: -1,
                index: $scope.fields.length + 1,
                libelle: $filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_REGISTRATION_SUBCATEGORY'),
                data: { name : "FIXE_FIELD_REGISTRATION_SUBCATEGORY", type : "LIST_SELECT", clazz : "InscriptionSubCategory" },
                fixField : true,
                fixFieldKey: "FIXE_FIELD_REGISTRATION_SUBCATEGORY"
              };
              $scope.filterFields.push(_fixeFieldRegistrationSubCat);
              $scope.sortFields.push(_fixeFieldRegistrationSubCat);
              $scope.columnFields.push(_fixeFieldRegistrationSubCat);
              // Logistic status
              var _fixeFieldLogistiqueStatus = {
                id: -2,
                index: $scope.fields.length + 2,
                libelle: $filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_LOGISTIC_STATUS'),
                data: { name : "FIXE_FIELD_LOGISTIC_STATUS", type : "LIST_SELECT", clazz : "LogisticalStatus" },
                fixField : true,
                fixFieldKey: "FIXE_FIELD_LOGISTIC_STATUS"
              };
              $scope.filterFields.push(_fixeFieldLogistiqueStatus);
              $scope.sortFields.push(_fixeFieldLogistiqueStatus);
              $scope.columnFields.push(_fixeFieldLogistiqueStatus);
              // Registration Status
              var _fixeFieldRegistrationStatus = {
                id: -3,
                index: $scope.fields.length + 3,
                libelle: $filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_REGISTRATION_STATUS'),
                data: { name : "FIXE_FIELD_REGISTRATION_STATUS", type : "LIST_SELECT", clazz : "InscriptionStatus" },
                fixField : true,
                fixFieldKey: "FIXE_FIELD_REGISTRATION_STATUS"
              };
              $scope.filterFields.push(_fixeFieldRegistrationStatus);
              $scope.sortFields.push(_fixeFieldRegistrationStatus);
              $scope.columnFields.push(_fixeFieldRegistrationStatus);
              // All xhr async process end
              $scope.fieldsAndFiltersReady.fields = true;
              if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.filters) {
                $scope.fieldsForFiltersFiltered = removeUsedFields($scope.filterFields, $scope.filters);
              }
              if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.sorts) {
                $scope.fieldsForSortsFiltered = removeUsedFields($scope.sortFields, $scope.sorts);
              }
              if (dataReady) {
                filterFieldsFn();
              } else {
                dataReady = true;
              }
            }).catch(function (error) {
              toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
              console.log(error);
            });
          }).catch(function (error) {
            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            console.log(error);
          });
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
          console.log(error);
        });
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        console.log(error);
      });
      /*inscriptionFormService.listAllFields($translate.preferredLanguage(), true).then(function (resp) {
      //modelService.listFieldsByType($state.params.modelType, $translate.preferredLanguage()).then(function (resp) {
        $scope.fields = $filter('filter')(resp.data, function (item) {
            return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
        });
        // for filter
        $scope.filterFields = angular.copy($scope.fields);
        // For sort
        $scope.sortFields = $filter('filter')(resp.data, function (item) {
          return item.typeChamps !== 'MULTIPLE_SELECT';
        });
        // For wiew
        $scope.columnFields = $filter('filter')(resp.data, function (item) {
          return item.typeChamps !== 'LONG_TEXT' && item.typeChamps !== 'MULTIPLE_SELECT';
        });
        $scope.fieldsAndFiltersReady.fields = true;
        if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.filters) {
          $scope.fieldsForFiltersFiltered = removeUsedFields($scope.filterFields, $scope.filters);
        }
        if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.sorts) {
          $scope.fieldsForSortsFiltered = removeUsedFields($scope.sortFields, $scope.sorts);
        }
        if (dataReady) {
          filterFieldsFn(); 
        } else {
          dataReady = true;
        }
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        console.log(error);
      });*/
    }

    // List des filtres
    $scope.listFilters = function () {
      ResearchPageCreationService.find($state.params.modelType, $state.params.subTypeId, 'FILTER', $translate.preferredLanguage()).then(function (resp) {
        $scope.filters = resp.data;
        angular.forEach($scope.filters, function (item, index) {
          if (item.baseType == "FIXE_FIELD") {
            var _fixeFieldLibelle = 'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.' + item.fixeFieldDto.data.name;
            item.fixeFieldDto.libelle = angular.copy(_fixeFieldLibelle);
          }
        });
        $scope.newFieldToFilter = {};
        $scope.fieldsAndFiltersReady.filters = true;
        if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.filters) {
          $scope.fieldsForFiltersFiltered = removeUsedFields($scope.filterFields, $scope.filters);
        }
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };
    $scope.listFilters();

    // List des tris
    $scope.listSorting = function () {
      ResearchPageCreationService.find($state.params.modelType, $state.params.subTypeId, 'SORT', $translate.preferredLanguage()).then(function (resp) {
        $scope.sorts = resp.data;
        $scope.newFieldToSort = {};
        $scope.fieldsAndFiltersReady.sorts = true;
        if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.sorts) {
          $scope.fieldsForSortsFiltered = removeUsedFields($scope.sortFields, $scope.sorts);
        }
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };
    $scope.listSorting();

    // Ajouter un champs aux filtres/tris
    $scope.save = function (resConfig) {
      resConfig.data = {};
      resConfig.data.modelType = $scope.modelType;

      // Sub type
      if($scope.modelType == 'COMPANY_MODEL') {
        resConfig.data.modelSubTypeDto = {
          id: $state.params.subTypeId
        };
      }

      if (resConfig.config == 'FILTER') {
        // Field type
        if ($scope.newFieldToFilter.data.modelType) {
          resConfig.data.baseType = 'MODEL_FIELD';
          resConfig.data.fieldModelDto = $scope.newFieldToFilter.data;
        } else {
          resConfig.data.baseType = 'FIXE_FIELD';
          resConfig.data.fixeFieldDto = $scope.newFieldToFilter.data;
        }
        // Index
        resConfig.data.index = $scope.filters.length + 1;
        // Default size : 25%
        resConfig.data.size = 25;

      } else  if (resConfig.config == 'SORT') {
        // Field type
        if ($scope.newFieldToSort.data.modelType) {
          resConfig.data.baseType = 'MODEL_FIELD';
          resConfig.data.fieldModelDto = $scope.newFieldToSort.data;
        } else {
          resConfig.data.baseType = 'FIXE_FIELD';
          resConfig.data.fixeFieldDto = $scope.newFieldToSort.data;
        }
        // Index
        resConfig.data.index = $scope.sorts.length + 1;
      }

      ResearchPageCreationService.save(resConfig).then(function (resp) {
        if (resConfig.config == 'FILTER') {
          $scope.listFilters();
        } else if (resConfig.config == 'SORT') {
          $scope.listSorting();
        }
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    // Supprimer un config
    $scope.delete = function (resConfig) {
      ResearchPageCreationService.delete(resConfig).then(function (resp) {
        if (resConfig.config == 'FILTER') {
          $scope.listFilters();
          $scope.fieldsForFiltersFiltered = removeUsedFields($scope.fields, $scope.filters);
        } else if (resConfig.config == 'SORT') {
          $scope.listSorting();
          $scope.fieldsForSortsFiltered = removeUsedFields($scope.sortFields, $scope.sorts);
        }
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    // Monter un champ
    $scope.upFieldFilterOrSort = function (resConfig) {
      ResearchPageCreationService.upField(resConfig).then(function (resp) {
        if (resConfig.config == 'FILTER') {
          $scope.listFilters();
        } else if (resConfig.config == 'SORT') {
          $scope.listSorting();
        }
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    // Descendre un champ
    $scope.downFieldFilterOrSort = function (resConfig) {
      ResearchPageCreationService.downField(resConfig).then(function (resp) {
        if (resConfig.config == 'FILTER') {
          $scope.listFilters();
        } else if (resConfig.config == 'SORT') {
          $scope.listSorting();
        }
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    /* COLUMNS CONFIGURATION */
    $scope.refreshColumnsDrawTokens = function () {
      modelService.listColumnsDrawTokens($scope.baseUrl, $state.params.subTypeId, $translate.preferredLanguage()).then(function (response) {
        $scope.columns = response.data;
      }).catch(function (response) {

      });
    };
    $scope.refreshColumnsDrawTokens();

    $scope.addToColumn = function (column) {
      if (column.selectedField != null) {
        var dto = {};
        if(column.selectedField.fixField) {
          dto = {
            columnIndex: column.columnIndex,
            fixField : true,
            fixFieldKey : column.selectedField.fixFieldKey
          };
        } else {
          dto = {
            columnIndex: column.columnIndex,
            fixField : false,
            field: angular.copy(column.selectedField),
          };
        }
        modelService.addFieldToColumnDrawToken($scope.baseUrl, $state.params.subTypeId, dto).then(function (response) {
          column.selectedField = {};
          $scope.refreshColumnsDrawTokens();
        }).catch(function (response) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }
    };

    $scope.removeFromColumn = function (id) {
      modelService.deleteColumnDrawToken($scope.baseUrl, id).then(function () {
        $scope.refreshColumnsDrawTokens();
      }).catch(function () {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.upField = function (data) {
      modelService.upFieldColumnDrawToken($scope.baseUrl, data).then(function () {
        $scope.refreshColumnsDrawTokens();
      }).catch(function () {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.downField = function (data) {
      modelService.downFieldColumnDrawToken($scope.baseUrl, data).then(function () {
        $scope.refreshColumnsDrawTokens();
      }).catch(function () {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    init();

    $scope.addField = function () {
      if (!$scope.fieldToAdd) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_SELECT_FIELD'));
        return;
      }
      var dto = {
        subTypeID: $state.params.subTypeId,
        fieldModel: angular.copy($scope.fieldToAdd)
      };
      $scope.fieldToAdd = null;
      modelService.postDisplay(dto, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
        init();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_ADD'));
        init();
      });
    };

    $scope.removeField = function (field) {
      if (!field || !field.id || !field.subTypeID) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
        return;
      }
      modelService.removeDisplay(field.subTypeID, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
        console.log($scope.category.fields);
        if (res.data) {
          $scope.displaysModels = res.data;
        }
        filterFieldsFn();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_DELETE'));
      });
    };

    $scope.goUp = function (field) {
      if (!field || !field.id || !field.subTypeID) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
        return;
      }
      modelService.upDisplay(field.subTypeID, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
        console.log($scope.category.fields);
        if (res.data) {
          $scope.displaysModels = res.data;
        }
        filterFieldsFn();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_MOVE'));
      });
    };

    $scope.goDown = function (field) {
      if (!field || !field.id || !field.subTypeID) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
        return;
      }
      modelService.downDisplay(field.subTypeID, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
        console.log($scope.category.fields);
        if (res.data) {
          $scope.displaysModels = res.data;
        }
        filterFieldsFn();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_MOVE'));
      });
    };

    $scope.setIcon = function (field) {
      if (!field || !field.id) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
        return;
      }
      modelService.setIconDisplay(field).then(function (res) {
      }).catch(function (err) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_ICON'));
      });
    };

    function getDisplays() {
      modelService.getDisplays($state.params.subTypeId, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
        if (res.data) {
          $scope.displaysModels = res.data;
        }
        if (dataReady) {
          filterFieldsFn();
        } else {
          dataReady = true;
        }
        console.log(res.data);
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_GET'));
      });
    }

    function filterFieldsFn() {
      $scope.fieldsAvalaible = [];
      console.log($scope.fields);
      if ($scope.fields) {
        for (var i = 0; i < $scope.fields.length; i++) {
          if (!$scope.fields[i].data || $scope.fields[i].data.substring(0, 4) !== 'FIXE') {
            $scope.fields[i].alreadyHere = false;
            for (var j = 0; j < $scope.displaysModels.length; j++) {
              if ($scope.fields[i].id === $scope.displaysModels[j].fieldModel.id) {
                $scope.fields[i].alreadyHere = true;
              }
            }
            if (!$scope.fields[i].alreadyHere) {
              $scope.fieldsAvalaible.push(angular.copy($scope.fields[i]));
            }
          }
        }
      } else {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_NO_FIELD'));
      }
      dataReady = false;
    }

    function init() {
      getDisplays();
    }

  }

})();

(function () {
  'use strict';

  angular.module('app.front').service('SettingsMessageService', ['$q', '$http', function ($q, $http) {
    var baseUrl = './api/rest/message';
    return {
      saveAction: function (action, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+'/action',
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: action
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findAllAction: function (lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+'/action/findAll',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      deleteAction: function (actionId) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+'/action/'+actionId,
            method: 'DELETE',
            params: {
              '_v': new Date().getTime(),
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      upAction: function (id, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/action/up/'+id,
            method: 'PUT',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      downAction: function (id, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/action/down/' + id,
            method: 'PUT',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
    };
  }]);

})();

(function () {
  'use strict';

  angular.module('app.front').controller('MessageSettingsController', MessageSettingsController);

  function MessageSettingsController($rootScope, $scope, $timeout, toastr, SettingsMessageService, languageService, $filter) {
    $scope.language = {};
    $scope.languages = [];
    $scope.action = {};
    $scope.actions = [];
    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
      for (var i = 0; i < $scope.languages.length; i++) {
        var language = $scope.languages[i];
        if (language.preferred) {
          $scope.language.key = language.key;
          break;
        }
      }
      $scope.$watch('language.key', function () {
        $scope.showForm = false;
        // $scope.findAllArticles($scope.language.key);
        $scope.findAllAction();
      });
    }).catch(function (error) {

    });

    $scope.findAllAction = function () {
      SettingsMessageService.findAllAction($scope.language.key).then(function (actions) {
        $scope.actions = actions.data;
      }).catch(function (data) {

      });
    };

    $scope.saveAction = function (action, form) {
      SettingsMessageService.saveAction(action, $scope.language.key).then(function (data) {
        $scope.findAllAction();
        $scope.action = {};
        if (form) {
          form.$setUntouched();
          form.$setPristine();
        }
      }).catch(function (data) {

      });
    };

    $scope.upAction = function(id){
      SettingsMessageService.upAction(id, $scope.language.key).then(function(response){
        $scope.actions = response.data;
      }).catch(function(){

      });
    };

    $scope.downAction = function(id){
      SettingsMessageService.downAction(id, $scope.language.key).then(function (response) {
        $scope.actions = response.data;
      }).catch(function () {

      });
    };


    $scope.removeAction = function (action) {
      var content = {
        title: $filter('translate')('SETTINGS.MESSAGE.CREATION_ACTION.DELETE_ACTION'),
        message: $filter('translate')('SETTINGS.MESSAGE.CREATION_ACTION.CONFIRM_DELETE_ACTION')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        // $rootScope.$broadcast('HandDrawTokenList');
        SettingsMessageService.deleteAction(action.id).then(function (response) {
          $scope.findAllAction();
        }).catch(function (response) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }).catch(function () {

      });

    };
  }
})();

(function () {
  'use strict';

	angular.module('app.front').service('languageService', languageService);

	function languageService($q, $http){
		var service = {};

		service.getLanguages = function(){
			return $q(function(resolve, reject){
				$http({
					url: './api/rest/language/all',
					method: 'GET',
					params: {'_v': new Date().getTime(), 'activated': true}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('app.front').controller('databaseContactsController', databaseContactsController);

	function databaseContactsController($rootScope, $scope, $timeout, toastr, modelService, languageService) {
		$scope.modelType = 'CONTACT_MODEL';
		$scope.baseUrl = './api/rest/model/' + $scope.modelType;

		$scope.helpModelTitle = 'Aide sur la gestion des champs des modèles de contact';
		$scope.helpModelContent = 'Dans cette partie il faut renseigner les champs qui seront demandés lors de la création d\'un nouveau modèle de dossier.' + ' L\'objectif est de définir un modèle représentant au mieux les contacts et leurs attributs.';
		$scope.drawTokenTitle = 'Affichage des contacts de dossier (à traduire)';
		$scope.helpDrawTokenTitle = 'Aide sur la gestion de l\'affichage des modèles de dossier';
		$scope.helpDrawTokenContent = 'Cette partie permet de gérer l\'affichage d\'un modèle de contact dans les listes de selection des contacts.';
		$scope.language = {};
		$scope.categories = [];

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.initCategories();
			});
		}).catch(function (error) {

		});
		
		$scope.$on('refreshCategories', function () {
			$scope.initCategories();
		});

		$scope.initCategories = function () {
			modelService.getCategories($scope.baseUrl, $scope.language.key).then(function (response) {
				$scope.categories = response.data;
				$scope.$broadcast('categoriesLoaded');
			}).catch(function (response) {
				toastr.error('Impossible de lister les catégories !');
			});
		};




	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('databaseCompaniesTypesController', databaseCompaniesTypesController);

	function databaseCompaniesTypesController($scope, toastr, languageService, modelService){
		$scope.language = {};
		$scope.types = [];
		$scope.modelType = 'COMPANY_MODEL';
		$scope.baseUrl = './api/rest/model/' + $scope.modelType;

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function(){
				$scope.initSubTypes();
			});
		}).catch(function (error) {

		});

		$scope.initSubTypes = function(){
			modelService.getSubTypes($scope.baseUrl, $scope.language.key, null).then(function(response){
				$scope.types = response.data;
			}).catch(function(){
				toastr.error('Impossible de lister les types !');
			});
		};
	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('databaseCompaniesController', databaseCompaniesController);

	function databaseCompaniesController($rootScope, $scope, $timeout, $filter, toastr, modelService, languageService){
		$scope.modelType = 'COMPANY_MODEL';
		$scope.baseUrl = './api/rest/model/' + $scope.modelType;

		$scope.modelTitle = 'Gestion des modèles de dossier';
		$scope.helpModelTitle = 'Aide sur la gestion des champs des modèles de dossier';
		$scope.helpModelContent = 'Dans cette partie il faut renseigner les champs qui seront demandés lors de la création d\'un nouveau modèle de dossier.'+ ' L\'objectif est de définir un modèle représentant au mieux les dossiers et leurs attributs.';
		$scope.drawTokenTitle = 'Affichage des modèles de dossier  (à traduire)';
		$scope.helpDrawTokenTitle = 'Aide sur la gestion de l\'affichage des modèles de dossier';
		$scope.helpDrawTokenContent = 'Cette partie permet de gérer l\'affichage d\'un modèle de dossier dans les listes de selection des dossiers.';
		$scope.language = {};
		$scope.categories = [];

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.initCategories();
			});
		}).catch(function (error) {

		});

		$scope.$on('refreshCategories', function(){
			$scope.initCategories();
		});


		$scope.initCategories = function(){
			modelService.getCategories($scope.baseUrl, $scope.language.key).then(function(response){
				$scope.categories = response.data;
				$scope.$broadcast('categoriesLoaded');
			}).catch(function(response){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};




	}
})();

(function(){
	'use strict';

	angular.module('app.front').controller('databaseController', databaseController);

	function databaseController($rootScope, $scope, languageService){
		
	}
})();
(function () {
  'use strict';
  angular.module('app.front').controller('databaseContactsSettingsController', databaseContactsSettingsController);

  function databaseContactsSettingsController($scope, $translate, $filter, toastr, STORAGE_PREFIX, DISPLAY_MODELS_ICONS, modelService, ResearchPageCreationService) {
    $scope.modelType = 'CONTACT_MODEL';
    $scope.baseUrl = './api/rest/model/' + $scope.modelType;

    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
    };

    // Liste des champs       
    modelService.listFieldsByType($scope.modelType, $translate.preferredLanguage()).then(function (resp) {
      $scope.fields = $filter('filter')(resp.data, function (item) {
        return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
      });
      $scope.columnFields = angular.copy($scope.fields);
      
      // Ajout champ fixe actif/inactif
      $scope.columnFields.push({
        index: $scope.columnFields.lenght + 1,
        libelle: angular.copy($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_STATUS')),
        data: 'FIXE_FIELD_STATUS',
      });

      if (dataReady) {
        filterFields();
      } else {
        dataReady = true;
      }

    }).catch(function (error) {
      toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      console.log(error);
    });

    /* COLUMNS CONFIGURATION */
    $scope.refreshColumnsDrawTokens = function () {
      modelService.listColumnsDrawTokens($scope.baseUrl, null, $translate.preferredLanguage()).then(function (response) {
        $scope.columns = response.data;
      }).catch(function (response) {

      });
    };
    $scope.refreshColumnsDrawTokens();

    $scope.addToColumn = function (column) {
      if (column.selectedField != null) {
        var dto = {
          columnIndex: column.columnIndex,
          field: angular.copy(column.selectedField),
        };
        modelService.addFieldToColumnDrawToken($scope.baseUrl, null, dto).then(function (response) {
          column.selectedField = {};
          $scope.refreshColumnsDrawTokens();
        }).catch(function (response) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }
    };

    $scope.removeFromColumn = function (id) {
      modelService.deleteColumnDrawToken($scope.baseUrl, id).then(function () {
        $scope.refreshColumnsDrawTokens();
      }).catch(function () {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.upField = function (id) {
      modelService.upFieldColumnDrawToken($scope.baseUrl, id).then(function () {
        $scope.refreshColumnsDrawTokens();
      }).catch(function () {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.downField = function (id) {
      modelService.downFieldColumnDrawToken($scope.baseUrl, id).then(function () {
        $scope.refreshColumnsDrawTokens();
      }).catch(function () {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.category = {};
    $scope.fieldsAvalaible = [];
    $scope.fields = [];
    $scope.displaysModels = [];
    $scope.fieldToAdd = null;
    $scope.DISPLAY_MODELS_ICONS = DISPLAY_MODELS_ICONS;
    var dataReady = false;

    init();

    $scope.addField = function () {
      if (!$scope.fieldToAdd) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_SELECT_FIELD'));
        return;
      }
      var dto = {
        subTypeID: null,
        fieldModel: angular.copy($scope.fieldToAdd)
      };
      $scope.fieldToAdd = null;
      modelService.postDisplay(dto, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
        init();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_ADD'));
        init();
      });
    };

    $scope.removeField = function (field) {
      if (!field || !field.id) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
        return;
      }

      modelService.removeDisplay(field.subTypeID, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
        console.log($scope.category.fields);
        if (res.data) {
          $scope.displaysModels = res.data;
        }

        filterFields();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_DELETE'));
      });
    };

    $scope.goUp = function (field) {
      if (!field || !field.id) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
        return;
      }

      modelService.upDisplay(null, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
        console.log($scope.category.fields);
        if (res.data) {
          $scope.displaysModels = res.data;
        }

        filterFields();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_MOVE'));
      });
    };

    $scope.goDown = function (field) {
      if (!field || !field.id) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
        return;
      }

      modelService.downDisplay(null, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
        console.log($scope.category.fields);
        if (res.data) {
          $scope.displaysModels = res.data;
        }

        filterFields();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_MOVE'));
      });
    };

    $scope.setIcon = function (field) {
      if (!field || !field.id) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
        return;
      }

      modelService.setIconDisplay(field).then(function (res) {

      }).catch(function (err) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_ICON'));
      });
    };

    function getDisplays() {
      modelService.getDisplays(null, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
        if (res.data) {
          $scope.displaysModels = res.data;
        }

        if (dataReady) {
          filterFields();
        } else {
          dataReady = true;
        }
        console.log(res.data);
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_GET'));
      });
    }

    function filterFields() {
      $scope.fieldsAvalaible = [];
      console.log($scope.fields);
      if ($scope.fields) {
        for (var i = 0; i < $scope.fields.length; i++) {
          if (!$scope.fields[i].data || $scope.fields[i].data.substring(0, 4) !== 'FIXE') {
            $scope.fields[i].alreadyHere = false;
            for (var j = 0; j < $scope.displaysModels.length; j++) {
              if ($scope.fields[i].id === $scope.displaysModels[j].fieldModel.id) {
                $scope.fields[i].alreadyHere = true;
              }
            }
            if (!$scope.fields[i].alreadyHere) {
              $scope.fieldsAvalaible.push(angular.copy($scope.fields[i]));
            }
          }
        }
      } else {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_NO_FIELD'));
      }

      dataReady = false;
    }

    function init() {
      getDisplays();
    }

  }
})();

(function(){
	'use strict';

	angular.module('app.front').controller('companiesSettingsController', companiesSettingsController);

	function companiesSettingsController($rootScope, $scope, $translate, $stateParams, $filter, toastr, modelService){
		$scope.modelType = 'COMPANY_MODEL';
		$scope.baseUrl = './api/rest/model/' + $scope.modelType;

		modelService.listFieldsByType($scope.modelType, $translate.preferredLanguage()).then(function(response){
			$scope.fields = response.data;
		}).catch(function(response){
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		modelService.getCategoriesOnly($scope.baseUrl, $translate.preferredLanguage()).then(function (response) {
			$scope.categories = response.data;
		}).catch(function (response) {
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		modelService.listSpecifics($scope.baseUrl, $translate.preferredLanguage()).then(function(response){
			$scope.specifics = response.data;
		}).catch(function(){
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		$scope.translate = function(specific){
			return $filter('translate')('SETTINGS.DATABASE.COMPANIES.' + specific.type);
		};

		$scope.saveLink = function(){
			modelService.saveSpecifics($scope.baseUrl, $scope.specifics).then(function(response){
				toastr.success($filter('translate')('SETTINGS.DATABASE.COMPANIES.SUCCESS_SAVE_SETTINGS'));
			}).catch(function(response){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};
	}
})();

(function () {
  'use strict';

  angular.module('app.front').controller('addPackagesController', addPackagesController);

  function addPackagesController($scope, $rootScope, $translate, companyService, $filter, $state, $stateParams, $q, packagesService, languageService, DocumentService, 
      modelService, $mdDialog, toastr, userService) {
    $scope.userService = userService;
    $scope.language = {};
    $scope.languages = [];
    $scope.companies = [];
    $scope.updateMode = false;
    $scope.modelType = 'COMPANY_MODEL';
    var baseUrl = './api/rest/model/' + $scope.modelType;

    modelService.findSpecificByType(baseUrl, $translate.preferredLanguage(), 'REGION').then(function(response){
      $scope.regions = response.data.listFieldsDTO;
    }).catch(function(){

    });

    modelService.findSpecificByType(baseUrl, $translate.preferredLanguage(), 'TOURISM').then(function (response) {
      $scope.tourisms = response.data.listFieldsDTO;
    }).catch(function () {

    });

    var getPackage = function (id) {
      packagesService.findById(id, $scope.language.key).then(function (res) {
        if (res.data) {
          $scope.package = res.data;
          $scope.updateMode = true;
        } else {
          toastr.error($filter('translate')('PACKAGES.ADD.TOAST.PACKAGE_NOT_FOUND'));
          $state.go('app.packages');
        }
      }).catch(function (err) {
        toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_GET_PACKAGE'));
      });
    };
    $scope.photos = [];

    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
      for (var i = 0; i < $scope.languages.length; i++) {
        var language = $scope.languages[i];
        if (language.preferred) {
          $scope.language.key = language.key;
          break;
        }
      }

      if ($stateParams.id) {
        getPackage($stateParams.id);
      }
    }).catch(function (error) {

    });

    $scope._companyPage = 0;
    $scope.findCompanies = function() {
      companyService.findPage($translate.preferredLanguage(), $scope._companyPage).then(function(res) {
        console.log(res);
        if (res.data) {
          $scope.companies = res.data;
        }
        $scope._companyPage = $scope._companyPage + 1;
      }).catch(function(err) {
        console.log(err);
        toastr.error($filter('translate')('PACKAGES.ADD.ERROR_GET_COMPANIES'));
      });
    };
    $scope.findCompanies();

    var addPhoto = function (fd, i, last) {
      var index = angular.copy(i);
      DocumentService.save(fd).then(function (res) {
        $scope.$emit('photoUploaded' + (index + 1));
        if (last) {
          $state.go('app.packages');
        }
        
      }).catch(function (err) {
        toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_ADD_PHOTO'));
        $scope.$emit('photoUploaded' + (index + 1));
      });
    };

    $scope.add = function () {
      var photos = [];

      for (var i = 0; i < $scope.photos.length; i++) {
        if ($scope.photos[i] != null && $scope.photos[i].uploadFile != null) {
          var photo = $scope.photos[i].uploadFile;
          photos.push(photo);
        }
      }

      packagesService.save($scope.package, $scope.language.key).then(function (res) {
        if (res.data && res.data.id) {
          //On upload les photos l'une après l'autre car le faire en parallèle cause une erreur côté back
          var fds = [];

          for (var i = 0; i < photos.length; i++) {
            var formData = new FormData();
            formData.append('file', photos[i], photos[i].name);
            formData.append('dto', angular.toJson({
              packagesID: res.data.id
            }));

            fds.push(formData);
          }

          var index = 0;

          if (fds.length > 0) {
            for (var i = 0; i < fds.length; i++) {
              if (i === 0) {
                if (fds.length === 1) {
                  addPhoto(fds[i], i, true);
                } else {
                  addPhoto(fds[i], i, false);
                }
                
                index++;
              } else {
                $scope.$on('photoUploaded' + i, function () {
                  if (index === fds.length - 1) {
                    addPhoto(fds[index], index, true);
                  } else {
                    addPhoto(fds[index], index, false);
                  }

                  index++;
                });
              }
            }
          } else {
            $state.go('app.packages');
          }
        } else {
          toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_ADD_PHOTOS'));
        }

      }).catch(function (err) {
        toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_SAVE_PACKAGE'));
        console.log(err);
      });
    };

    $scope.deletePhoto = function (index) {
      $scope.photos.splice(parseInt(index), 1);
    };

    $scope.displayPopUpDeletePhoto = function (photo, index) {
      $scope.photoToDelete = angular.copy(photo);
      $scope.indexToDelete = index;
      $mdDialog.show({
        templateUrl: 'app/main/packages/popup/deletePhoto.popup.html',
        preserveScope: true,
        clickOutsideToClose: true,
        scope: $scope,
      }).then(function () {

      }).catch(function () {

      });
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.deletePhotoPermanentely = function () {
      DocumentService.deleteFile($scope.photoToDelete.id).then(function (res) {
        $scope.package.documents.splice($scope.indexToDelete, 1);
        toastr.success($filter('translate')('PACKAGES.ADD.TOAST.SUCCESS_DELETE_PHOTO'));
        $scope.hidePopup();
      }).catch(function (err) {
        toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_DELETE_PHOTO'));
      });
    };

    $scope.langageChanged = function () {
      if ($scope.updateMode) {
        if ($stateParams.id) {
          getPackage($stateParams.id);
        }
      }
    };
  }
})();

(function(){
	'use strict';

	angular.module('app.front').controller('updateMessageController', updateMessageController);

	function updateMessageController($rootScope, $scope, $mdDialog, $state, $filter, message, companyId, contactId, from, toastr, userService, SettingsMessageService, MessageService, STORAGE_PREFIX, MODELS_TYPES){
		$scope.message = {
			actionForm: null,
			receiverForm: null
		};
		$scope.filter = {
			sender: null,
			action: null
		};
		$scope.modelTypes = MODELS_TYPES;
		if (message != null){
			$scope.message = angular.copy(message);
		}
		
		//	MESSAGES
		$scope.findAllUsers = function (init) {
			userService.findAllUsers().then(function (users) {
				$scope.users = users.data;
				if (init){
					if ($scope.message.id != null) {
						if ($scope.message.receiver != null) {
							var receiverID = angular.copy($scope.message.receiver.id);
							angular.forEach($scope.users, function (user) {
								if (user.id === receiverID) {
									$scope.message.receiverForm = angular.toJson(user);
								}
							});
						} else {
							$scope.message.receiverForm = 'null';
						}
					} else {
						for (var i = 0; i < $scope.users.length; i++) {
							if ($scope.users[i].id === $rootScope.user.id) {
								$scope.message.receiverForm = angular.toJson($scope.users[i]);
								break;
							}
						}

					}
				}
			}).catch(function (data) {

			});
		};

		$scope.findAllUsers(true);

		$scope.findAllActions = function () {
			SettingsMessageService.findAllAction(localStorage[STORAGE_PREFIX + 'language']).then(function (actions) {
				$scope.actions = actions.data;
			}).catch(function (data) {

			});
		};

		$scope.findAllActions();

		$scope.cancelFormMessage = function () {
			$scope.message = {
				actionForm: null,
				receiverForm: null
			};
			$mdDialog.hide();
		};
		$scope.saveMessage = function () {
			if ($scope.message.actionForm != null) {
				$scope.message.dateAction = moment($scope.message.startDateForm).set('hours', $scope.message.startTime.split(':')[0]).set('minutes', $scope.message.startTime.split(':')[1]).toDate().getTime();
				if (!$scope.message.actionDone) {
					$scope.message.actionDone = false;
				}
				$scope.message.action = angular.fromJson($scope.message.actionForm);
			}

			if ($scope.message.receiverForm != null && $scope.message.receiverForm != 'null') {
				$scope.message.receiver = angular.fromJson($scope.message.receiverForm);
				$scope.message.receiverID = angular.fromJson($scope.message.receiverForm).id;
			} else {
				$scope.message.receiverID = null;
			}
			$scope.message.companyId = companyId;
			$scope.message.contactId = contactId;
			if (from != null && from.searchCompanies && from.pagination != null){
				var dto = {
					message: $scope.message,
					modelPaginationDto: from.pagination
				};
				MessageService.bulk(dto, $scope.message.modelType, $state.params.subType).then(function (data) {
					$mdDialog.hide();
					toastr.success($filter('translate')('MESSAGE.BULK.SUCCESS'));
				}).catch(function (data) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}else{
				MessageService.saveMessage($scope.message).then(function (data) {
					$mdDialog.hide();
					toastr.success($filter('translate')('MESSAGE.CREATION.SUCCESS'));
				}).catch(function (data) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}
		};


		$scope.getDate = function (date) {
			return moment(date).toDate();
		};

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};

		
	}

})();
(function () {
    'use strict';

    angular.module('app.front').controller('MailingTriggersController', MailingTriggersController);

    function MailingTriggersController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, MailingService) {

        $scope.triggers = [];
        $scope.pages = [];

        $scope.search = {};

        // Pages
        /*MailingService.findAll('pages', null).then(function(response){
            $scope.pages = response.data;
        }).catch(function(error){
            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });*/

        //Triggers
        MailingService.findAll('triggers', $translate.preferredLanguage()).then(function (response) {
            $scope.triggers = response.data;
        }).catch(function (error) {
            console.log(error);
        });

        $scope._triggerDetailsFn = function(id) {
            $state.go("app.mailing_triggers.trigger", { id : id });
        };

    }
    
})();
(function () {
    'use strict';

    angular.module('app.front').controller('MailingPagesController', MailingPagesController);

    function MailingPagesController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, MailingService) {

        $scope.pages = [];
        $scope.blocs = [];

        $scope.search = {};

        // Blocs
        /*MailingService.findAll('blocs', null).then(function(response){
            $scope.blocs = response.data;
        }).catch(function(error){
            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });*/

        //Pages
        MailingService.findAll('pages', $translate.preferredLanguage()).then(function (response) {
            $scope.pages = response.data;
        }).catch(function (error) {
            console.log(error);
        });

        $scope._pageDetailsFn = function(id) {
            $state.go("app.mailing_pages.page", { id : id });
        };

    }
    
})();
(function () {
    'use strict';

    angular.module('app.front').controller('MailingBlocsController', MailingBlocsController);

    function MailingBlocsController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, MailingService) {

        $scope.blocs = [];

        $scope.types = MailingService.getBlocTypes();

        $scope.search = {};

        MailingService.findAll('blocs', null).then(function (response) {
            $scope.blocs = response.data;
        }).catch(function (error) {
            console.log(error);
        });

        $scope._blocDetailsFn = function(id) {
            $state.go("app.mailing_blocs.bloc", { id : id });
        };

    }
    
})();
(function(){
	'use strict';

	angular.module('app.front').controller('MailingModalController', MailingModalController);

    function MailingModalController($rootScope, $scope, $mdDialog, $state, $filter, $translate, data, toastr, modelService, 
        MailingService, languageService, MODELS_TYPES){
        
        $scope.MODELS_TYPES = MODELS_TYPES;
        $scope.initDataInProgress = false;

        if (data != null && data.modelType != null){

            $scope.initDataInProgress = true;

            $scope.dto = {};
            $scope.dto.modelType = angular.copy(data.modelType);
            $scope.dto.filter = angular.copy(data.filter);
            $scope.dto.mailingType = angular.copy(data.mailingType);

            if(data.modelSubTypeId) {
                 $scope.dto.modelSubTypeId = angular.copy(data.modelSubTypeId);
            };

            if(data.contactId) {
                $scope.dto.contactId = angular.copy(data.contactId);
            };

            MailingService.findAllPageLite($translate.preferredLanguage()).then(function (resp) {
                $scope.pages = resp.data;
                languageService.getLanguages().then(function (resp) {
                    $scope.languages = resp.data;                 
                    modelService.listFieldsByType(
                        MODELS_TYPES.CONTACT_MODEL, 
                        $translate.preferredLanguage()
                    ).then(function (resp) {
                        /*$scope.fields = $filter('filter')(resp.data, function (item) {
                            return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
                        });*/
                        $scope.emailFields = $filter('filter')(resp.data, function (item) {
                            return item.typeChamps == 'EMAIL';
                        });

                        if($scope.dto.modelSubTypeId) {
                            modelService.listFieldsBySubType(
                                MODELS_TYPES.COMPANY_MODEL,
                                $scope.dto.modelSubTypeId,
                                $translate.preferredLanguage()
                            ).then(function (resp) {
                                /*$scope.fields =  $scope.fields.concat($filter('filter')(resp.data, function (item) {
                                    return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
                                }));*/
                                $scope.emailFields = $scope.emailFields.concat($filter('filter')(resp.data, function (item) {
                                    return item.typeChamps == 'EMAIL';
                                }));
                                $scope.initDataInProgress = false;
                            }).catch(function (err) {
                                $scope.initDataInProgress = false;
                                console.log(err)
                            });
                        } else {
                             $scope.initDataInProgress = false;
                        }
                    }).catch(function (err) {
                        $scope.initDataInProgress = false;
                        console.log(err);
                    });
                }).catch(function (error) {
                    $scope.initDataInProgress = false;
                    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                });
            }).catch(function (error) {
                $scope.initDataInProgress = false;
                console.log(error);
            });
		}

        // md-select input search
        window.mdSelectOnKeyDownOverride = function (event) {
            event.stopPropagation();
        };

        $scope.hidePopup = function(){
			$mdDialog.cancel();
        };
        
        $scope._getCleanKey = function (key) {
            var _cleanKey = angular.copy(key);
            return _cleanKey.replace(/[{()}]/g, '');
        };

        $scope.$watch("dto.page.language", function(newValue, oldValue, scope){
            if($scope.dto.page && newValue && newValue.id && oldValue && oldValue.id && newValue.id != oldValue.id) {
                $scope.dto.page.language = angular.copy(newValue);
            };
        });

        $scope.doAMailing = function (_form) {
            _form.$setSubmitted();
            if (_form.$valid) {
                $scope.inProgress = true;
                MailingService.doAMailing( $scope.dto).then(function (response) {
                    $scope.inProgress = false;
                    toastr.success($filter('translate')('MAILING.DO_MAILING.SUCCESS'));
                    $scope.hidePopup();
                }).catch(function (error) {
                    $scope.inProgress = false;
                    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                    console.log(error);
                });
            }
        };
		
	}

})();
(function () {
    'use strict';
  
    angular.module('app.front').service('InscriptionsAdminService', InscriptionsAdminService);
  
    function InscriptionsAdminService($q, $http, $filter) {
        
        var BASE_URL_INSCRIPTION = './api/rest/inscription';
        var service = {};

        service.findInscriptions = function (pagination, lang) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_INSCRIPTION + '/list',
                    method: 'POST',
                    params: {
                        '_v': new Date().getTime(),
                        'lang': lang
                    },
                    data: pagination
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        // EXPORT
        service.export = function(dto, password, lang){
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_INSCRIPTION  +'/export-excel',
                    method: 'POST',
                    params: {
                        '_v': new Date().getTime(),
                        'lang': lang,
                        'password': password
                    },
                    responseType: 'arraybuffer',
                    data: dto
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.deleteExport = function(id){
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_INSCRIPTION + '/export/'+id,
                    method: 'DELETE',
                    params: {
                        '_v': new Date().getTime(),
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.saveExport = function(dto){
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_INSCRIPTION + '/export',
                    method: 'POST',
                    params: {
                        '_v': new Date().getTime(),
                    },
                    data: dto
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.findExports = function(lang){
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_INSCRIPTION + '/export',
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                        'lang': lang
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };
  
        return service;
  
    }
  
  })();
  
(function () {
    'use strict';

    angular.module('app.front').controller('InscriptionsAdminController', InscriptionsAdminController);

    function InscriptionsAdminController($rootScope, $scope, $timeout, $filter, $state, $translate, $mdDialog, $element, toastr, MODELS_TYPES, 
        modelService, InscriptionsAdminService, researchEngineFilterService, researchEngineSortService, logisticService) {

        $scope.modelType = 'INSCRIPTION_MODEL';
        
        $scope.allLoaded = false;
        $scope.loaded = true;
        $scope._inscriptions = [];
            
        $scope.pagination = {
            modelFiltersDto: researchEngineFilterService.getFilter(),
            modelSortsDto: researchEngineSortService.getSort(),
            start: 0,
            outputs: 100
        };
        
        function _onInitFn() {           
            $scope.loaded = false;
            InscriptionsAdminService.findInscriptions($scope.pagination, $translate.preferredLanguage()).then(function (response) {
                $scope._inscriptions = $scope._inscriptions.concat(response.data);
                if (response.data.length < $scope.pagination.outputs) {
                    $scope.allLoaded = true;
                } else {
                    $scope.pagination.start += 1;
                }
                $scope.loaded = true;
            }).catch(function (err) {
                console.log(err);
            });
        }
        _onInitFn();
        
        $scope._findInscriptionsFn = function () {
            $scope.loaded = false;
            InscriptionsAdminService.findInscriptions($scope.pagination, $translate.preferredLanguage()).then(function (response) {
                $scope._inscriptions = $scope._inscriptions.concat(response.data);
                if (response.data.length < $scope.pagination.outputs) {
                    $scope.allLoaded = true;
                } else {
                    $scope.pagination.start += 1;
                }
                $scope.loaded = true;
            }).catch(function (response) {
                console.log(response);
            });
        };
        
        $scope._filterInscritpionFn = function (filter) {
            $scope.pagination.modelFiltersDto = filter;
            $scope.pagination.start = 0;
            $scope.allLoaded = false;
            $scope._inscriptions = [];
            $scope._findInscriptionsFn();
        };
        
        $scope._sortInscriptionFn = function (sort) {
            $scope.pagination.modelSortsDto = sort;
            $scope.pagination.start = 0;
            $scope.allLoaded = false;
            $scope._inscriptions = [];
            $scope._findInscriptionsFn();
        };
        
        $scope.filterModel = function (model, index) {
            return $filter('showColumn')(model, index);
        };
        
        $scope._goToInscriptionsAdminSettings = function() {
            $state.go('app.inscriptions_admin.settings', { modelType : 'INSCRIPTION_MODEL' });
        };

        $scope._inscriptionDetails = function(_inscription) {
            $state.go('app.companies.details.contact', {
                subType: _inscription.subTypeId,
                id: _inscription.companyId,
                contactId: _inscription.contactId,
                inscriptionId: _inscription.id
            });
        };

        $scope.logisticDetails = function(inscription){
            $state.go('app.companies.details.contact.logistic', {
                subType: inscription.subTypeId,
                id: inscription.companyId,
                contactId: inscription.contactId,
                logisticId: inscription.logisticId
            });
        };

        /*
        * Mailing
        */
        $scope._mailingDialogOpenFn = function () {
            $mdDialog.show({
                templateUrl: 'app/main/globe_network/mailing/mailing_modal.html',
                clickOutsideToClose: false,
                controller: 'MailingModalController',
                locals: {
                    data : {
                        modelType: 'INSCRIPTION_MODEL',
                        modelSubTypeId: null,
                        filter: $scope.pagination.modelFiltersDto
                    }
                }
            }).then(function () {

            }).catch(function () {

            });
        };

        /* EXPORT */
		$scope._exportParams = {
            companyFields: [],
            inscriptionFields: [],
            transportFields: [],
            contactFields: [],
            logisticFields: [],
			option: ''
		};
		$scope.search = {
            company: '',
            contact: '',
            inscription: '',
            transport: '',
            logistic: ''
        };

		InscriptionsAdminService.findExports($translate.preferredLanguage()).then(function (response) {
			$scope.exports = response.data;
		}).catch(function () {

		});

		$scope.saveExport = function () {

			var dto = {
				name: $scope._exportParams._name,
				option: $scope._exportParams._option,
                fields: [],
                transportFields: []
			};
			if ($scope._exportParams.id != null) {
				dto.id = $scope._exportParams.id;
            }
            angular.forEach($scope._exportParams.transportFields, function(item){
                dto.transportFields.push(item.key);
            });
            dto.fields = dto.fields.concat($scope._exportParams.inscriptionFields);
            dto.fields = dto.fields.concat($scope._exportParams.logisticFields);
			dto.fields = dto.fields.concat($scope._exportParams.companyFields);
			dto.fields = dto.fields.concat($scope._exportParams.contactFields);
			if ((dto.fields.length > 0 || dto.transportFields.length > 0) && dto.name != null && dto.name.trim().length > 0){
				InscriptionsAdminService.saveExport(dto).then(function (response) {
					if (response.data != null){
						$scope._exportParams.id = parseInt(response.data);
					}
					var found = false;
					for (var i = 0; i < $scope.exports.length; i++){
						if ($scope.exports[i].id === $scope._exportParams.id){
							found = true;
							break;
						}
					}
					if (!found){
                        $scope._exportParams.name = dto.name;
						$scope.exports.push($scope._exportParams);
					}
					toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_SAVE'));
				}).catch(function () {
	
				});
			}else{
				if (dto.fields.length === 0 && dto.transportFields.length === 0){
					toastr.error($filter('translate')('COMPANIES.EXPORT.ERROR_FIELDS'));
				}else if (dto.name == null || dto.name.trim().length === 0){
					toastr.error($filter('translate')('COMPANIES.EXPORT.ERROR_NAME'));
				}
			}
		};

		$scope.openDeleteExport = function(){
			var content = {
				title: $filter('translate')('COMPANIES.EXPORT.DELETE_TITLE'),
				message: $filter('translate')('COMPANIES.EXPORT.DELETE_MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				$scope.deleteExport();
			}).catch(function(){

			});
		};

		$scope.deleteExport = function () {
			if ($scope._exportParams.id != null) {
				InscriptionsAdminService.deleteExport($scope._exportParams.id).then(function (response) {
					for (var i = 0; i < $scope.exports.length; i++) {
						if ($scope.exports[i].id === $scope._exportParams.id) {
							$scope.exports.splice(i, 1);
							$scope._exportParams = {
								companyFields: [],
                                contactFields: [],
                                inscriptionFields: [],
                                transportFields: [],
                                logisticFields: [],
								option: null
							};
							break;
						}
					}
				}).catch(function () {

				});
			}
		};

		$scope.addField = function (chip, fields) {
			if (chip == null || chip.id == null) {
				fields.splice(fields.length - 1, 1);
			}
        };
        
        $scope.addTransportField = function(chip, fields){
            if (chip == null || chip.key == null) {
				fields.splice(fields.length - 1, 1);
			}
        };

		$scope.launchExport = function () {
			var dto = {
                fields: [],
                transportFields: [],
                modelPagination: $scope.pagination,
                option: $scope._exportParams._option
			};
			angular.forEach($scope._exportParams.transportFields, function(item){
                dto.transportFields.push(item.key);
            });
            dto.fields = dto.fields.concat($scope._exportParams.inscriptionFields);
            dto.fields = dto.fields.concat($scope._exportParams.logisticFields);
			dto.fields = dto.fields.concat($scope._exportParams.companyFields);
			dto.fields = dto.fields.concat($scope._exportParams.contactFields);
			InscriptionsAdminService.export(dto, $scope._exportParams.password, $translate.preferredLanguage()).then(function (response) {
				var byteArray = new Uint8Array(response.data);
				var a = window.document.createElement('a');
				a.href = window.URL.createObjectURL(new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
				a.download = 'export.xls';
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			}).catch(function (error) {
                if (error.status === 403){
                    toastr.error($filter('translate')('COMPANIES.EXPORT.BAD_PASSWORD'));
                }
			});
        };
        
        function findTransportField(field){
            for (var i = 0; i < $scope.transportFields.length; i++){
                if ($scope.transportFields[i].key === field){
                    return angular.copy($scope.transportFields[i]);
                }
            }
            return null;
        }

		$scope.exportChanged = function(){
            if ($scope._exportParams != null){
                $scope._exportParams.companyFields = [];
                $scope._exportParams.contactFields = [];
                $scope._exportParams.inscriptionFields = [];
                $scope._exportParams.logisticFields = [];
                var transportFields = angular.copy($scope._exportParams.transportFields);
                $scope._exportParams.transportFields = [];
				for (var i = 0; i < $scope._exportParams.fields.length; i++){
					var field = angular.copy($scope._exportParams.fields[i]);
					$scope._exportParams._name = angular.copy($scope._exportParams.name);
					$scope._exportParams._option = angular.copy($scope._exportParams.option);
					if (field.modelType === 'COMPANY_MODEL'){
						$scope._exportParams.companyFields.push(field);
					}else if (field.modelType === 'CONTACT_MODEL'){
						$scope._exportParams.contactFields.push(field);
					}else if (field.modelType === 'INSCRIPTION_MODEL'){
                        $scope._exportParams.inscriptionFields.push(field);
                    }else if (field.modelType === 'LOGISTIC_MODEL'){
                        $scope._exportParams.logisticFields.push(field);
                    }
                }
                for (var j = 0; j < transportFields.length; j++){
                    var transportField = transportFields[j];
                    $scope._exportParams.transportFields.push(findTransportField(transportField));
                }
			}else{
				$scope._exportParams = {
					companyFields: [],
                    contactFields: [],
                    inscriptionFields: [],
                    transportFields: [],
                    logisticFields: [],
					option: ''
				};
			}
        };

        $scope.fieldsSelected = function(fields, selectedFields, isTransport){
			var res = [];
			if (angular.isArray(selectedFields)){
                if (!isTransport){
                    var fieldIds = selectedFields.map(function(item){
                        return item.id;
                    });
                    angular.forEach(fields, function(item){
                        if (fieldIds.lastIndexOf(item.id) === -1){
                            res.push(item);
                        }
                    });
                }else{
                    var fieldKeys = selectedFields.map(function(item){
                        return item.key;
                    });
                    angular.forEach(fields, function(item){
                        if (fieldKeys.lastIndexOf(item.key) === -1){
                            res.push(item);
                        }
                    });
                }
				return res;
			}else{
				return fields;
			} 
		};
        
        modelService.listExportableField('./api/rest/model/COMPANY_MODEL', null, $translate.preferredLanguage()).then(function (response) {
            $scope.companyFields = response.data;
        }).catch(function () {

        });

        modelService.listExportableField('./api/rest/model/CONTACT_MODEL', null, $translate.preferredLanguage()).then(function (response) {
            $scope.contactFields = response.data;
        }).catch(function () {

        });

        modelService.listExportableField('./api/rest/model/INSCRIPTION_MODEL', null, $translate.preferredLanguage()).then(function (response) {
            $scope.inscriptionFields = response.data;
        }).catch(function () {

        });

        modelService.listExportableField('./api/rest/model/LOGISTIC_MODEL', null, $translate.preferredLanguage()).then(function (response) {
            $scope.logisticFields = response.data;
        }).catch(function () {

        });

        logisticService.getTransportFields().then(function(response){
            $scope.transportFields = response.data;
        }).catch(function(){

        });

        $scope.translate = function(key){
            return $filter('translate')(key);
        };

    }


    
})();
(function () {
    'use strict';

    angular.module('app.front').service('companyService', companyService);

    function companyService($http, $q, $filter, $cookies) {

        /** Constantes */

        var BASE_URL_COMPANY = './api/rest/company/';
        var PUBLIC_URL_COMPANY = './api/public/sitegen/companies/';
        var BASE_URL_STATS = './api/rest/statistics/';
        var FIRST_CATEGORY_INDEX = 1;

        /** Variables */
        var service = {};

        var selectedModel = null;
        var selectedModelId = null;
        var categories = null;
        var listFields = null;
        var modelFilters = null;
        var actualFilter = null;

        // GET ALL

        service.findByTypeId = function (subtypeId, filter, lang) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + 'list/' + subtypeId,
                    method: 'POST',
                    params: {
                        '_v': new Date().getTime(),
                        'lang': lang
                    },
                    data: filter
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.findPage = function (lang, page) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + 'findPage',
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                        'lang': lang,
                        'page': page
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.findAll = function () {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + 'findAll',
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.filterByString = function (string, lang) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + 'search',
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                        'q': string,
                        'lang': lang
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };



        /** Details */

        service.getSelectedModel = function (modelId, subTypeId, lang) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + modelId,
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                        'subTypeId': subTypeId,
                        'lang': lang
                    },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'authorization': []
                    }
                }).then(function (response) {
                    categories = null;
                    selectedModel = response.data;
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.getSelectedModelDisplay = function (modelId, subTypeId, lang) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + 'display/' + modelId,
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                        'subTypeId': subTypeId,
                        'lang': lang
                    },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'authorization': []
                    }
                }).then(function (response) {
                    categories = null;
                    selectedModel = response.data;
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.getCategories = function (lang, modelId) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + 'categories/',
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                        'id': modelId,
                        'lang': lang
                    },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'authorization': []
                    }
                }).then(function (response) {
                    if (modelId != null) {
                        categories = service.buildModel(response.data, selectedModel);
                        resolve(categories);
                    } else {
                        resolve(response.data);
                    }
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.getCategoriesBySubType = function (lang, modelId, subTypeId) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + 'categoriesBySubType/',
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                        'id': modelId,
                        'subTypeId': subTypeId,
                        'lang': lang
                    },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'authorization': []
                    }
                }).then(function (response) {
                    if (modelId != null) {
                        categories = service.buildModel(response.data, selectedModel);
                        resolve(categories);
                    } else {
                        resolve(response.data);
                    }
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.buildModel = function (categories, contact) {
            var firstCategory = findFirstCategory(categories);
            if (firstCategory) {
                for (var i = 0; i < firstCategory.values.length; i++) {
                    var field = firstCategory.values[i];
                    if (field.fixField) {
                        if ((field.selectableObject == null || field.selectableObject.length < 1)) {
                            field.value = contact[field.keyJava];
                        } else {
                            if (field.typeChamps === 'OBJECT') {
                                field.value = setSelectedObject(field, contact);
                            } else {
                                field.value = setSelectedMultipleObject(field, contact);
                            }
                        }
                    }
                }
            }
            angular.forEach(categories, function (category, key) {
                for (var i = 0; i < category.values.length; i++) {
                    var field = category.values[i];
                    if (field.typeChamps === 'LIST_SELECT') {
                        field.value = setSelectedList(field);
                    } else if (field.typeChamps === 'DATE') {
                        field.dateTime = null;
                        if (field.value != null && field.value !== '') {
                            field.dateTime = $filter('stringToDate')(field.value);
                        }
                    } else if (field.typeChamps === 'BOOLEAN') {
                        field.value = 'true' === field.value;
                    }
                }
                angular.forEach(category.subCategories, function (category, key) {
                    for (var i = 0; i < category.values.length; i++) {
                        var field = category.values[i];
                        if (field.typeChamps === 'LIST_SELECT') {
                            field.value = setSelectedList(field);
                        } else if (field.typeChamps === 'DATE') {
                            field.dateTime = null;
                            if (field.value != null && field.value !== '') {
                                field.dateTime = $filter('stringToDate')(field.value);
                            }
                        } else if (field.typeChamps === 'BOOLEAN') {
                            field.value = 'true' === field.value;
                        }
                    }
                });
            });
            return categories;
        };

        service.addModel = function (categories, newModel, subTypes, lang) {
            return $q(function (resolve, reject) {
                var fmData = new FormData();
                var internalSaveModel = function (_category) {
                    if (angular.isArray(_category.subCategories) && _category.subCategories.length > 0) {
                        angular.forEach(_category.subCategories, function (_subCategories) {
                            internalSaveModel(_subCategories);
                        });
                    }
                    angular.forEach(_category.values, function (item) {
                        if (!item.fixField) {
                            var valuedField = {
                                idBaseField: item.id,
                                id: item.idValue
                            };
                            if (item.typeChamps === 'BOOLEAN') {
                                valuedField.value = '' + item.value;
                            } else if (item.typeChamps === 'DATE') {
                                if (item.dateTime != null) {
                                    valuedField.value = $filter('date')(item.dateTime, 'dd/MM/yyyy');
                                }
                            } else if (item.typeChamps === 'LIST_SELECT') {
                                valuedField.listFieldId = item.value.id;
                            } else if (item.typeChamps === 'MULTIPLE_SELECT') {
                                valuedField.values = [];
                                angular.forEach(item.values, function (objectSelected) {
                                    valuedField.values.push({
                                        id: objectSelected.id,
                                        libelle: objectSelected.libelle
                                    });
                                });
                            } else if (item.typeChamps === 'FILE' || item.typeChamps === 'IMAGE') {
                                var input = document.getElementById('genericField_file_' + item.id + '_' + item.index);
                                var file = null;
                                if (input != null) {
                                    file = input.files[0];
                                }
                                fmData.append('file_' + valuedField.idBaseField, file);
                            } else if (item.typeChamps === 'NUMBER' || item.typeChamps === 'INTEGER') {
                                if ('null' === item.value) {
                                    valuedField.value = '';
                                } else {
                                    valuedField.value = item.value;
                                }
                            } else {
                                valuedField.value = item.value;
                            }
                            newModel.valuedFields.push(valuedField);
                        } else {
                            newModel[item.keyJava] = item.value;
                        }
                    });
                };
                newModel.valuedFields = [];

                angular.forEach(categories, function (_category) {
                    internalSaveModel(_category);
                });

                fmData.append('modelDTO', angular.toJson(newModel));
                $http({
                    url: BASE_URL_COMPANY,
                    method: 'POST',
                    params: {
                        '_v': new Date().getTime(),
                        'lang': lang
                    },
                    headers: {
                        'Content-Type': undefined,
                        'authorization': []
                    },
                    transformRequest: angular.identity,
                    data: fmData
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.deleteModel = function (id) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + id,
                    method: 'DELETE',
                    params: {
                        '_v': new Date().getTime()
                    },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'authorization': []
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.updateTypes = function (dto) {
            return $q(function (resolve, reject) {

                $http({
                    url: BASE_URL_COMPANY + 'types',
                    method: 'PUT',
                    params: {
                        '_v': new Date().getTime()
                    },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'authorization': []
                    },
                    data: dto
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.updateAssociations = function (dto) {
            return $q(function (resolve, reject) {

                $http({
                    url: BASE_URL_COMPANY + 'associations',
                    method: 'PUT',
                    params: {
                        '_v': new Date().getTime()
                    },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'authorization': []
                    },
                    data: dto
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.updateSites = function (dto) {
            return $q(function (resolve, reject) {

                $http({
                    url: BASE_URL_COMPANY + 'sites',
                    method: 'PUT',
                    params: {
                        '_v': new Date().getTime()
                    },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'authorization': []
                    },
                    data: dto
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.updateField = function (id, dto) {
            return $q(function (resolve, reject) {
                if (!dto.fixField) {
                    var fmData = new FormData();
                    var valuedField = {
                        idBaseField: dto.id,
                        id: dto.idValue
                    };
                    if (dto.typeChamps === 'BOOLEAN') {
                        valuedField.value = '' + dto.value;
                    } else if (dto.typeChamps === 'DATE') {
                        if (dto.dateTime != null) {
                            valuedField.value = $filter('date')(dto.dateTime, 'dd/MM/yyyy');
                        }
                    } else if (dto.typeChamps === 'LIST_SELECT') {
                        if (!!dto.value) {
                            valuedField.listFieldId = dto.value.id;
                        }
                    } else if (dto.typeChamps === 'MULTIPLE_SELECT') {
                        valuedField.values = [];
                        angular.forEach(dto.values, function (objectSelected) {
                            valuedField.values.push({
                                id: objectSelected.id,
                                libelle: objectSelected.libelle
                            });
                        });
                    } else if (dto.typeChamps === 'FILE' || dto.typeChamps === 'IMAGE') {
                        var input = document.getElementById('genericField_file_' + dto.id + '_' + dto.index);
                        var file = null;
                        if (input != null) {
                            file = input.files[0];
                        }
                        fmData.append('file', file);
                    } else if (dto.typeChamps === 'NUMBER' || dto.typeChamps === 'INTEGER') {
                        if ('null' === dto.value) {
                            valuedField.value = '';
                        } else {
                            valuedField.value = dto.value;
                        }
                    } else {
                        valuedField.value = dto.value;
                    }
                    fmData.append('modelDTO', angular.toJson(valuedField));
                    $http({
                        url: BASE_URL_COMPANY + id + '/field',
                        method: 'PUT',
                        params: {
                            '_v': new Date().getTime()
                        },
                        headers: {
                            'Content-Type': undefined,
                            'authorization': []
                        },
                        data: fmData
                    }).then(function (response) {
                        resolve(response);
                    }).catch(function (response) {
                        reject(response);
                    });
                }
            });
        };

        service.bulkUpdate = function (fmData, typeId) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + 'field/' + typeId,
                    method: 'PUT',
                    params: {
                        '_v': new Date().getTime()
                    },
                    headers: {
                        'Content-Type': undefined,
                        'authorization': []
                    },
                    data: fmData
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.downloadValuedFile = function (fieldId) {
            var url = BASE_URL_COMPANY + 'download/' + fieldId + '/' + selectedModel.id;
            return url;
        };

        service.setActivated = function (id, activated) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + id + '/activate',
                    method: 'PUT',
                    params: {
                        '_v': new Date().getTime(),
                        'active': activated
                    },
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'authorization': []
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.setChecked = function (id, checked) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + id + '/checked',
                    method: 'PUT',
                    params: {
                        '_v': new Date().getTime(),
                        'checked': checked
                    },
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'authorization': []
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.setPrincipal = function (contactId) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + 'principal/' + contactId,
                    method: 'PUT',
                    params: {
                        '_v': new Date().getTime()
                    },
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'authorization': []
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.findAll = function (lang) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + 'findAll',
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                        'lang': lang
                    },
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'authorization': []
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.findForStatistics = function (lang) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + 'statistics',
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                        'lang': lang
                    },
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'authorization': []
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        function findFirstCategory(categories) {
            var found = false;
            var index = 0;
            while (!found && index < categories.length) {
                var category = categories[index];
                if (category.index === FIRST_CATEGORY_INDEX) {
                    return category;
                }
                index++;
            }
        }

        function setSelectedList(field) {
            var valueReturned = null;
            if (field.listFieldId != null) {
                for (var k = 0; k < field.listFieldsDTO.length; k++) {
                    if (field.listFieldId === field.listFieldsDTO[k].id) {
                        valueReturned = field.listFieldsDTO[k];
                    }
                }
            }
            return valueReturned;
        }

        function setSelectedObject(field, data) {
            var valueReturned = null;
            if (data[field.keyJava]) {
                for (var k = 0; k < field.selectableObject.length; k++) {
                    if (data[field.keyJava].id == field.selectableObject[k].id) {
                        valueReturned = field.selectableObject[k];
                    }
                }
            }
            return valueReturned;
        }

        function setSelectedMultipleObject(field, data) {
            var values = [];
            if (data[field.keyJava]) {
                for (var l = 0; l < data[field.keyJava].length; l++) {
                    for (var k = 0; k < field.selectableObject.length; k++) {
                        if (data[field.keyJava][l].id === field.selectableObject[k].id) {
                            values.push(field.selectableObject[k]);
                        }
                    }
                }
            }
            return values;
        }

        // Company Disposition

        service.saveCompanyDisposition = function (companyId, dispositionDto) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + companyId + '/disposition/save/',
                    method: 'POST',
                    params: { '_v': new Date().getTime() },
                    data: dispositionDto
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.deleteCompanyDisposition = function (dispositionId) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + 'disposition/delete/' + dispositionId,
                    method: 'DELETE',
                    params: { '_v': new Date().getTime() },
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        // EXPORT
        service.export = function (dto, typeId, password, lang) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + typeId + '/export',
                    method: 'POST',
                    responseType: 'arraybuffer',
                    params: {
                        '_v': new Date().getTime(),
                        'lang': lang,
                        'password': password
                    },
                    data: dto
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.deleteExport = function (id) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + 'export/' + id,
                    method: 'DELETE',
                    params: {
                        '_v': new Date().getTime(),
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.saveExport = function (dto) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + 'export',
                    method: 'POST',
                    params: {
                        '_v': new Date().getTime(),
                    },
                    data: dto
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.findExports = function (lang) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_COMPANY + 'export',
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                        'lang': lang
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };


        /* PUBLIC METHODS */
        service.filters = function (keyword, filters, page, max, siteId, typeId, lang, sortId, withStatus) {
            return $q(function (resolve, reject) {
                $http({
                    url: PUBLIC_URL_COMPANY + 'filter',
                    method: 'POST',
                    params: {
                        '_v': new Date().getTime(),
                        'keyword': keyword != null ? keyword.value : null,
                        'page': page,
                        'max': max,
                        'siteId': siteId,
                        'lang': lang,
                        'typeId': typeId,
                        'fieldSortId': sortId,
                        'withStatus': !!withStatus
                    },
                    data: filters
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.listMySelection = function (lang, ids) {
            /*var _ids = [];
            angular.forEach(ids, function(item, index){
                var _item = JSON.parse(item);
                if(_item.id && index.indexOf("PROVIDER_" + _item.id)>-1) {
                    _ids.push(JSON.parse(item));
                }
            });*/
            /*for (var i = 0; i < localStorage.length; i++) {
                if(localStorage.key(i).substring(0, 9) === 'PROVIDER_') {
                    try {
                        var _item = JSON.parse(localStorage.getItem(localStorage.key(i)));
                        if(_item.id && localStorage.key(i) === 'PROVIDER_' + _item.id) {
                            _ids.push(_item);
                        }
                    } catch(error) {
                        console.log(error);
                    }
                }
            }*/
            var _ids = ids;
            return $q(function (resolve, reject) {
                $http({
                    url: PUBLIC_URL_COMPANY + 'selections',
                    method: 'POST',
                    params: {
                        '_v': new Date().getTime(),
                        'lang': lang
                    },
                    data: _ids
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.findByIdPublic = function (id, lang) {
            return $q(function (resolve, reject) {
                $http({
                    url: PUBLIC_URL_COMPANY + id,
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                        'lang': lang
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.setStatisticView = function (id) {
            return $q(function (resolve, reject) {
                $http({
                    url: PUBLIC_URL_COMPANY + id + '/setStatisticView',
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime()
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.setStatisticShown = function (id) {
            return $q(function (resolve, reject) {
                $http({
                    url: PUBLIC_URL_COMPANY + id + '/setStatisticShown',
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime()
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.findDispositionsById = function (id) {
            return $q(function (resolve, reject) {
                $http({
                    url: PUBLIC_URL_COMPANY + id + '/dispositions',
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime()
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.findStatsClickByCompanyIDAndDates = function (postDTO) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_STATS + 'clicks',
                    method: 'POST',
                    params: {
                        '_v': new Date().getTime()
                    },
                    data: postDTO
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

		  service.getFirstPhoto = function(id,lang) {
			return $q(function (resolve, reject) {
				$http({
					url:PUBLIC_URL_COMPANY+'logo/'+id,
					method: 'GET',
					params: { '_v': new Date().getTime(),'lang':lang},
					responseType: 'arraybuffer',
					headers: { 'Content-Type': undefined,'accept': 'image/*;q=0.8' }
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					console.log(error)
					reject(error);
				});
			});
		  }


        return service;

    }
})();

(function () {
  'use strict';

  angular.module('app.front').controller('companyController', companyController);

  function companyController($rootScope, DISPLAY_MODELS_ICONS, $scope, $state, $translate, $filter, $mdDialog, toastr, companyService, modelService, contactService, 
      userService, SettingsMessageService, STORAGE_PREFIX, MessageService, MODELS_TYPES, DuplicationToolService) {
    $scope.iconsDisplay = {};
    angular.forEach(DISPLAY_MODELS_ICONS, function (elt) {
      $scope.iconsDisplay[elt.name] = elt.value;
    });

    $scope.$mdDialog = $mdDialog;
    $scope.logsShowed = false;
    $scope.statsClicksShowed = false;

    $scope.newDisposition = {};
    $scope.users = [];
    $scope.actions = [];
    $scope.message = {
      actionForm: null,
      receiverForm: null
    };
    $scope.filter = {
      sender: null,
      action: null
    };
    $scope.messages = [];
    $scope.typeAction = {
      ALL: 'ALL',
      TO_DO: 'TO_DO',
      DONE: 'DONE'
    };
    $scope.showForm = false;
    var subTypeId = $state.params.subType;
    var id = $state.params.id;

    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
    };

    if (subTypeId != null && id != null) {
      $scope.subTypeId = parseInt(subTypeId);
      $scope.modelType = 'COMPANY_MODEL';
      var baseUrl = './api/rest/model/' + $scope.modelType;

      companyService.getSelectedModelDisplay(id, subTypeId, $translate.preferredLanguage()).then(function (response) {
        $scope.company = response.data;
        $scope.refreshContacts();
        companyService.getCategoriesBySubType($translate.preferredLanguage(), $state.params.id, $scope.subTypeId).then(function (data) {
          $scope.categories = data;
        }).catch(function (err) {
          console.log(err);
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });

      }).catch(function (response) {

      });

      $scope.refreshContacts = function () {
        contactService.listContactsDisplay(id, $translate.preferredLanguage()).then(function (response) {
          $scope.contacts = response.data;
          putContactFavFirst();
        }).catch(function (response) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      };

      $scope.showMoreContacts = function () {
        contactService.listContactsHidden(id, $translate.preferredLanguage()).then(function (response) {
          $scope.hiddenContact = true;
          $scope.contacts = $scope.contacts.concat(response.data);
        }).catch(function (response) {

        });
      };


      $scope.hideMoreContacts = function () {
        contactService.listContactsHidden(id, $translate.preferredLanguage()).then(function (response) {
          $scope.hiddenContact = false;
          $scope.contacts = $scope.contacts.filter(function (el) {
            return $filter("filter")(response.data, {
              id: el.id
            }).length == 0;
          })
        }).catch(function (response) {

        });
      };

      modelService.getSubTypes(baseUrl, $translate.preferredLanguage(), true).then(function (response) {
        $scope.subTypes = response.data;
      }).catch(function () {

      });
    } else {
      $state.go('app.home');
    }



    /* LIVE UPDATE */
    $scope.$on('modelUpdated', function (event, args) {
      companyService.updateField(id, args.model).then(function (response) {
        companyService.getSelectedModelDisplay(id, subTypeId, $translate.preferredLanguage()).then(function (response) {
          $scope.company = response.data;
          putContactFavFirst();
        }).catch(function (response) {

        });
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    });

    $scope.$on('subTypeUpdated', function (event, args) {
      companyService.updateTypes($scope.company).then(function (response) {

      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    });

    $scope.$on('associationUpdated', function (event, args) {
      companyService.updateAssociations($scope.company).then(function (response) {

      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    });

    $scope.$on('siteUpdated', function (event, args) {
      companyService.updateSites($scope.company).then(function (response) {

      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    });

    $scope.setActivated = function (id, activate) {
      companyService.setActivated(id, activate).then(function () {}).catch(function (response) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.$on('activatedUpdated', function (event, args) {
      $scope.setActivated(id, args.model.activate);
    });

    $scope.$on('checkedUpdated', function (event, args) {
      companyService.setChecked(id, args.model.checked).then(function () {}).catch(function (response) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    });
    /* LIVE UPDATE */

    $scope.showDeleteCompany = function () {
      var content = {
        title: $filter('translate')('COMPANIES.DELETE'),
        message: $filter('translate')('COMPANIES.CONFIRM_DELETE')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        companyService.deleteModel($scope.company.id).then(function (response) {
          $state.go('app.companies', {
            subType: subTypeId
          });
        }).catch(function () {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }).catch(function () {

      });
    };

    /* DISPOSITION */

    $scope.openDispositionDialogFn = function (_disposition) {

      $scope.newDisposition = {};

      if (_disposition) {
        $scope.newDisposition = angular.copy(_disposition);
      }

      $scope.$mdDialog.show({
        templateUrl: 'app/main/globe_network/companies/popup/disposition.html',
        preserveScope: true,
        clickOutsideToClose: true,
        scope: $scope,
      }).then(function () {

      }).catch(function () {

      });

    };

    $scope.saveCompanyDisposition = function () {
      companyService.saveCompanyDisposition($scope.company.id, $scope.newDisposition).then(function (response) {
        if ($scope.newDisposition.id) {
          var index = $scope.company.dispositions.map(function (_disposition) {
            return _disposition.id;
          }).indexOf($scope.newDisposition.id);
          if (index > -1) {
            $scope.company.dispositions[index] = response.data;
          }
        } else {
          $scope.company.dispositions.push(response.data);
        }
        $mdDialog.cancel();
      }).catch(function (error) {
        console.log(error);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.deleteCompanyDisposition = function (_dispositionId) {
      companyService.deleteCompanyDisposition(_dispositionId).then(function (response) {
        var index = $scope.company.dispositions.map(function (_disposition) {
          return _disposition.id;
        }).indexOf(_dispositionId);
        if (index > -1) {
          $scope.company.dispositions.splice(index, 1);
        }
        $mdDialog.cancel();
      }).catch(function (error) {
        console.log(error);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    /* CONTACTS */

    $scope.$on('refreshContacts', function () {
      $scope.refreshContacts();
    });

    $scope.openAddContact = function () {
      $mdDialog.show({
        templateUrl: 'app/main/globe_network/companies/contacts/popup/add_contact.html',
        clickOutsideToClose: true,
        controller: 'addContactCtrl',
        locals: {
          companyId: id
        }
      }).then(function () {
        $scope.refreshContacts();
      }).catch(function () {

      });
    };

    $scope.detailsContact = function (id) {
      $state.go('app.companies.details.contact', {
        contactId: id
      });
    };

    $scope.setContactActivated = function (id, activate) {
      contactService.setActivated(id, activate).then(function (response) {

      }).catch(function (response) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };


    //	MESSAGES

    $scope.findAllMessages = function () {
      switch ($scope.filter.action) {
        case null:
          delete $scope.filter.actionToDo;
          $scope.filter.actionExist = false;
          break;
        case $scope.typeAction.ALL:
          delete $scope.filter.actionToDo;
          $scope.filter.actionExist = true;
          break;
        case $scope.typeAction.DONE:
          $scope.filter.actionToDo = false;
          break;
        case $scope.typeAction.TO_DO:
          $scope.filter.actionToDo = true;
          break;
        default:
          break;
      }
      $scope.filter.addressee = [];
      angular.forEach($scope.filter.receiverForm, function (item, key) {
        $scope.filter.addressee.push(angular.fromJson(item));
      });
      $scope.filter.companyId = id;
      MessageService.findAllMessage($scope.filter, localStorage[STORAGE_PREFIX + 'language']).then(function (messages) {
        $scope.messages = messages.data;
      }).catch(function (data) {

      });
    };
    $scope.findAllMessages();

    $scope.getDate = function (date) {
      return moment(date).toDate();
    };


    $scope.confirmAction = function (action) {
      var content = {
        title: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL_TITLE') : $filter('translate')('MESSAGE.ACTION_CONFIRM_TITLE'),
        message: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL') : $filter('translate')('MESSAGE.ACTION_CONFIRM')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        action.actionDone = !action.actionDone;
        MessageService.confirmAction(action).then(function (data) {}).catch(function (data) {});
      }).catch(function () {

      });
    };

    $scope.showPopUpMessage = function () {
      var message = {
        actionForm: null,
        receiverForm: null
      };


      $mdDialog.show({
        templateUrl: 'app/main/message/popup/update_message.html',
        clickOutsideToClose: true,
        controller: 'updateMessageController',
        locals: {
          companyId: id,
          contactId: null, 
          message: message,
          from: null
        }
      }).then(function () {
        $scope.findAllMessages();
      }).catch(function () {

      });
    };

    $scope.updateMessage = function (message) {
      var messageToUpdate = angular.copy(message);
      // $scope.message.receiverForm = angular.copy(angular.toJson(msg.receiver).toString());
      // console.log($scope.message);
      if (message.action != null) {
        var actionID = angular.copy(message.action.actionID);
        angular.forEach($scope.actions, function (action) {
          if (action.id === actionID) {
            messageToUpdate.actionForm = angular.toJson(action);
          }
        });
      } else {
        messageToUpdate.actionForm = null;
      }


      if (message.action != null && message.action.dateAction != null) {
        var date = new Date(message.action.dateAction);

        messageToUpdate.startDateForm = date;
        messageToUpdate.startTime = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      } else {
        var now = new Date();
        messageToUpdate.startDateForm = now;
        messageToUpdate.startTime = (now.getHours() < 10 ? '0' + now.getHours() : now.getHours()) + ':' + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes());
      }
      $mdDialog.show({
        templateUrl: 'app/main/message/popup/update_message.html',
        clickOutsideToClose: true,
        controller: 'updateMessageController',
        locals: {
          companyId: id,
          contactId: null,
          message: messageToUpdate,
          from: null
        }
        
      }).then(function () {
        $scope.findAllMessages();
      }).catch(function () {

      });
    };


    $scope.showLogs = function() {
      $scope.statsClicksShowed = false;
      $scope.logsShowed = !$scope.logsShowed;
    };

    $scope.showStatsClicks = function() {
      $scope.logsShowed = false;
      $scope.statsClicksShowed = !$scope.statsClicksShowed;
    };

    function putContactFavFirst() {
      if ($scope.contacts.length > 0 && $scope.company && $scope.company.favouriteId) {
        for (var i = 0; i < $scope.contacts.length; i++) {
          var contact = angular.copy($scope.contacts[i]);
          if (contact.id === $scope.company.favouriteId) {
            $scope.contacts.splice(i, 1);
            $scope.contacts.unshift(contact);
          }
        }
      }
    }

    // Outils de duplication
    $scope._lookForDuplicates = function () {
      $mdDialog.show({
        templateUrl: 'app/main/globe_network/companies/duplication_tool/duplication_tool_modal.html',
        clickOutsideToClose: true,
        controller: 'DuplicationToolModalController',
        locals: {
          dtToolData : {
            _modelType: MODELS_TYPES.COMPANY_MODEL,
            _modelSubTypeId: subTypeId
          }
        }
      }).then(function () {

      }).catch(function () {

      });
    };

    $scope._lookForContactDuplicates = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/duplication_tool/duplication_tool_modal.html',
				clickOutsideToClose: true,
				controller: 'DuplicationToolModalController',
				locals: {
					dtToolData: {
						_modelType: MODELS_TYPES.CONTACT_MODEL,
						_companyId: id
					}
				}
			}).then(function () {

			}).catch(function () {

			});
    };
    
    $scope._contactDuplicatesAutoMergeFn = function() {
			$scope._mdProgressLinear = true;
			DuplicationToolService._autoMergeDuplicatesModel(MODELS_TYPES.CONTACT_MODEL, null, id).then(function (response) {
				if(!response.data) {
					toastr.error($filter('translate')('DUPLICATION_TOOL.ANY_OCCURENCE_FOUND'));
				} else {
					$scope.refreshContacts();
					toastr.success($filter('translate')('DUPLICATION_TOOL.MERGE.MERGE_ACTION_SUCCESS'));
        }
        $scope._mdProgressLinear = false;
			}).catch(function (error) {
			  	console.log(error);
			  	toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			  	$scope._mdProgressLinear = false;
			});
		};

  }
})();

(function () {
	'use strict';

	angular.module('app.front').controller('companiesController', companiesController);

	function companiesController($rootScope, statisticsService, $scope, $state, $translate, $mdDialog, $timeout, $filter, toastr, companyService, modelService, researchEngineFilterService, researchEngineSortService, MODELS_TYPES) {

		$scope.newCompany = {
			subTypesIds: []
		};

		$scope.modelTypes = MODELS_TYPES;

		$scope.allLoaded = false;
		$scope.loaded = true;
		$scope.companies = [];
		$scope.categories = [];
		$scope.fieldsStats = [];
		//show inactives or not
		$scope.hideAll = true;

		$scope.pagination = {
			modelFiltersDto: researchEngineFilterService.getFilter(),
			modelSortsDto: researchEngineSortService.getSort(),
			start: 0,
			outputs: 100
		};

		var subTypeId = $state.params.subType;

		function init() {
			if (subTypeId != null) {
				$scope.subTypeId = parseInt(subTypeId);
				$scope.modelType = 'COMPANY_MODEL';
				var baseUrl = './api/rest/model/' + $scope.modelType;

				modelService.getSubType(baseUrl, $translate.preferredLanguage(), $scope.subTypeId).then(function (response) {
					$scope.subTypeObj = response.data;
				}).catch(function (err) {
					console.log(err);
				});

				if ($rootScope.user) {
					$scope.hideAll = !$rootScope.user.seeInactiveContact;
				}

				//changeActiveFilter();
				$scope.pagination.modelFiltersDto.hideInactivated = $scope.hideAll;

				$scope.loaded = false;
				companyService.findByTypeId($scope.subTypeId, $scope.pagination, $translate.preferredLanguage()).then(function (response) {
					$scope.companies = $scope.companies.concat(response.data);
					if ($scope.subTypes) {
						getSubTypesNames();
					}
					if (response.data.length < $scope.pagination.outputs) {
						$scope.allLoaded = true;
					} else {
						$scope.pagination.start += 1;
					}
					$scope.loaded = true;
				}).catch(function (err) {
					console.log(err);
				});

				modelService.getSubTypes(baseUrl, $translate.preferredLanguage(), true).then(function (response) {
					$scope.subTypes = response.data;
					if ($scope.companies) {
						getSubTypesNames();
					}
				}).catch(function (err) {
					console.log(err);
				});

				modelService.listExportableField(baseUrl, $scope.subTypeId, $translate.preferredLanguage()).then(function (response) {
					$scope.companyFields = response.data;
				}).catch(function () {

				});

				modelService.listExportableField('./api/rest/model/CONTACT_MODEL', null, $translate.preferredLanguage()).then(function (response) {
					$scope.contactFields = response.data;
				}).catch(function () {

				});

			} else {
				$state.go('app.home');
			}
		}

		init();

		companyService.getCategories($translate.preferredLanguage()).then(function (data) {
			$scope.categories = data;
		}).catch(function (err) {
			console.log(err);
		});

		$scope.showCompanyDialog = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/popup/add_company.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.showBulkUpdateDialog = function () {
			$scope.bulkUpdateDTO = {};
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/popup/bulk_update.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.showBulkMessageDialog = function () {
			var message = {
				actionForm: null,
				receiverForm: null
			};
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/popup/bulk_message.html',
				clickOutsideToClose: true,
				controller: 'updateMessageController',
				locals: {
					companyId: null,
					contactId: null,
					message: message,
					from: {
						searchCompanies: true,
						pagination: $scope.pagination
					}
				}
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.refreshFields = function () {
			var baseUrl = './api/rest/model/' + $scope.bulkUpdateDTO.modelType;
			modelService.listModifiableField(baseUrl, $scope.subTypeId, $translate.preferredLanguage()).then(function (response) {
				$scope.fields = response.data;
			}).catch(function () {

			});
		};

		$scope.bulkUpdate = function () {
			if ($scope.bulkUpdateDTO.field != null) {
				var fmData = new FormData();
				var valuedFieldsModel = angular.copy($scope.bulkUpdateDTO.field);
				valuedFieldsModel.idBaseField = valuedFieldsModel.id;

				fmData.append('paginationDTO', angular.toJson($scope.pagination));
				if (valuedFieldsModel.typeChamps === 'BOOLEAN') {
					valuedFieldsModel.value = '' + valuedFieldsModel.value;
				} else if (valuedFieldsModel.typeChamps === 'DATE') {
					if (valuedFieldsModel.dateTime != null) {
						valuedFieldsModel.value = $filter('date')(valuedFieldsModel.dateTime, 'dd/MM/yyyy');
					}
				} else if (valuedFieldsModel.typeChamps === 'LIST_SELECT') {
					if (valuedFieldsModel.fixedFieldSqlKey != null) {
						valuedFieldsModel.value = valuedFieldsModel.value.id;
					} else {
						if (!!valuedFieldsModel.value) {
							valuedFieldsModel.value = '' + valuedFieldsModel.value.id;
						}
					}
				} else if (valuedFieldsModel.typeChamps === 'MULTIPLE_SELECT') {
					valuedFieldsModel.values = [];
					angular.forEach($scope.bulkUpdateDTO.field.values, function (objectSelected) {
						valuedFieldsModel.values.push({
							id: objectSelected.id,
							libelle: objectSelected.libelle
						});
					});
				} else if (valuedFieldsModel.typeChamps === 'FILE' || valuedFieldsModel.typeChamps === 'IMAGE') {
					var input = document.getElementById('genericField_file_' + valuedFieldsModel.id + '_' + valuedFieldsModel.index);
					var file = null;
					if (input != null) {
						file = input.files[0];
					}
					if ($scope.companies.length > 0) {
						if (valuedFieldsModel.modelType === 'CONTACT_MODEL') {
							valuedFieldsModel.value = '' + $scope.companies[0].nbContacts;
						} else {
							valuedFieldsModel.value = '' + $scope.companies[0].nbrResults;
						}
					} else {
						valuedFieldsModel.value = '0';
					}
					if(file!=null){
						fmData.append('file', file);
					}

				} else if (valuedFieldsModel.typeChamps === 'NUMBER' || valuedFieldsModel.typeChamps === 'INTEGER') {
					if ('null' === valuedFieldsModel.value) {
						valuedFieldsModel.value = '';
					}
				}
				fmData.append('modelDTO', angular.toJson(valuedFieldsModel));
				companyService.bulkUpdate(fmData, $scope.subTypeId).then(function () {
					$scope.filterCompanies($scope.pagination.modelFiltersDto);
					toastr.success($filter('translate')('COMPANIES.BULK_UPDATE_SUCCESS'));
					$mdDialog.hide();
				}).catch(function (error) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}
		};

		$scope.getCompanies = function () {
			//changeActiveFilter();
			$scope.loaded = false;
			$scope.pagination.modelFiltersDto.hideInactivated = $scope.hideAll;
			companyService.findByTypeId($scope.subTypeId, $scope.pagination, $translate.preferredLanguage()).then(function (response) {
				$scope.companies = $scope.companies.concat(response.data);
				getSubTypesNames();
				if (response.data.length < $scope.pagination.outputs) {
					$scope.allLoaded = true;
				} else {
					$scope.pagination.start += 1;
				}
				$scope.loaded = true;
			}).catch(function (response) {
				console.log(response);
			});
		};

		$scope.filterCompanies = function (filter) {
			$scope.pagination.modelFiltersDto = filter;
			$scope.pagination.start = 0;
			$scope.allLoaded = false;
			$scope.companies = [];
			$scope.getCompanies();
			$scope.getStatisticsBySubTypeID();
		};

		$scope.sortCompanies = function (sort) {
			$scope.pagination.modelSortsDto = sort;
			$scope.pagination.start = 0;
			$scope.allLoaded = false;
			$scope.companies = [];
			$scope.getCompanies();
		};

		$scope.saveCompany = function () {
			companyService.addModel($scope.categories, $scope.newCompany, $scope.subTypes, $translate.preferredLanguage()).then(function (response) {
				$scope.hidePopup();
				$timeout(function () {
					$state.go('app.companies.details', {
						id: response.data
					});
				});
			}).catch(function (response) {
				if (response.error === 'notype') {
					toastr.error($filter('translate')('COMPANIES.TYPE_REQUIRED'));
				}
			});
		};

		$scope.details = function (company) {
			$state.go('app.companies.details', {
				id: company.id
			});
		};

		$scope.hidePopup = function () {
			$mdDialog.cancel();
		};

		$scope.detailsContact = function (companyId, contactId) {
			$state.go('app.companies.details.contact', {
				id: companyId,
				contactId: contactId
			});
		};

		$scope.filterModel = function (model, index) {
			return $filter('showColumn')(model, index);
		};

		function getSubTypesNames() {
			if ($scope.companies.length > 0) {
				for (var i = 0; i < $scope.companies.length; i++) {
					if (!$scope.companies[i].subTypesNames) {
						$scope.companies[i].subTypesNames = [];
						for (var j = 0; j < $scope.companies[i].subTypesIds.length; j++) {
							for (var k = 0; k < $scope.subTypes.length; k++) {
								if ($scope.companies[i].subTypesIds[j] === $scope.subTypes[k].id) {
									$scope.companies[i].subTypesNames.push($scope.subTypes[k].name);
								}
							}
						}
					}
				}
			}
		}

		$scope.switchActives = function () {
			$scope.hideAll = !$scope.hideAll;

			$scope.companies = [];
			$scope.pagination.start = 0;

			$scope.getCompanies();
		};

		$scope.getStatisticsBySubTypeID = function () {
			statisticsService.getStratisticsFilteredBySubTypeId(subTypeId, $translate.preferredLanguage(), $scope.pagination).then(function (res) {
				if (res.data) {
					$scope.fieldsStats = res.data;
				}
			}).catch(function (err) {
				console.log(err);
			});
		};

		function changeActiveFilter() {
			if ($scope.hideAll) {
				if ($scope.pagination.modelFiltersDto.filters.length > 0) {
					if (!$scope.pagination.modelFiltersDto.filters[0].fieldFilters) {
						$scope.pagination.modelFiltersDto.filters[0].fieldFilters = [];
					}
					$scope.pagination.modelFiltersDto.filters[0].fieldFilters.push({
						fieldFilterBaseType: 'FIXE_FIELD',
						modelType: 'COMPANY_MODEL',
						activated: true,
						fixeFieldFilterKeyLang: "FIXE_FIELD_STATUS",
						typeChamps: "BOOLEAN",
						criteria: true,
						notDisplayed: true
					});
				} else {
					$scope.pagination.modelFiltersDto.filters.push({
						fieldFilters: []
					});
					$scope.pagination.modelFiltersDto.filters[0].fieldFilters.push({
						fieldFilterBaseType: 'FIXE_FIELD',
						modelType: 'COMPANY_MODEL',
						activated: true,
						fixeFieldFilterKeyLang: "FIXE_FIELD_STATUS",
						typeChamps: "BOOLEAN",
						criteria: true,
						notDisplayed: true
					});
				}
			} else {
				for (var i = 0; i < $scope.pagination.modelFiltersDto.filters.length; i++) {
					if ($scope.pagination.modelFiltersDto.filters[i].fieldFilters) {
						for (var j = 0; j < $scope.pagination.modelFiltersDto.filters[i].fieldFilters.length; j++) {
							if ($scope.pagination.modelFiltersDto.filters[i].fieldFilters[j].notDisplayed) {
								$scope.pagination.modelFiltersDto.filters[i].fieldFilters.splice(j, 1);
							}
						}
					}
				}
			}
		}

		/*
		 * Mailing
		 */
		$scope._mailingDialogOpenFn = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/mailing/mailing_modal.html',
				clickOutsideToClose: false,
				controller: 'MailingModalController',
				locals: {
					data: {
						modelType: MODELS_TYPES.COMPANY_MODEL,
						modelSubTypeId: subTypeId,
						filter: $scope.pagination.modelFiltersDto
					}
				}
			}).then(function () {

			}).catch(function () {

			});
		};


		/* EXPORT */
		$scope._exportParams = {
			companyFields: [],
			contactFields: [],
			option: ''
		};
		$scope.search = {
			company: '',
			contact: ''
		};


		companyService.findExports($translate.preferredLanguage()).then(function (response) {
			$scope.exports = response.data;
		}).catch(function () {

		});

		$scope.saveExport = function () {

			var dto = {
				name: $scope._exportParams._name,
				option: $scope._exportParams._option,
				fields: []
			};
			if ($scope._exportParams.id != null) {
				dto.id = $scope._exportParams.id;
			}
			dto.fields = dto.fields.concat($scope._exportParams.companyFields);
			dto.fields = dto.fields.concat($scope._exportParams.contactFields);
			if (dto.fields.length > 0 && dto.name != null && dto.name.trim().length > 0) {
				companyService.saveExport(dto).then(function (response) {
					if (response.data != null) {
						$scope._exportParams.id = parseInt(response.data);
					}
					var found = false;
					for (var i = 0; i < $scope.exports.length; i++) {
						if ($scope.exports[i].id === $scope._exportParams.id) {
							found = true;
							break;
						}
					}
					if (!found) {
						$scope._exportParams.name = dto.name;
						$scope.exports.push($scope._exportParams);
					}
					toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_SAVE'));
				}).catch(function () {

				});
			} else {
				if (dto.fields.length === 0) {
					toastr.error($filter('translate')('COMPANIES.EXPORT.ERROR_FIELDS'));
				} else if (dto.name == null || dto.name.trim().length === 0) {
					toastr.error($filter('translate')('COMPANIES.EXPORT.ERROR_NAME'));
				}
			}
		};

		$scope.openDeleteExport = function () {
			var content = {
				title: $filter('translate')('COMPANIES.EXPORT.DELETE_TITLE'),
				message: $filter('translate')('COMPANIES.EXPORT.DELETE_MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function () {
				$scope.deleteExport();
			}).catch(function () {

			});
		};

		$scope.deleteExport = function () {
			if ($scope._exportParams.id != null) {
				companyService.deleteExport($scope._exportParams.id).then(function (response) {
					for (var i = 0; i < $scope.exports.length; i++) {
						if ($scope.exports[i].id === $scope._exportParams.id) {
							$scope.exports.splice(i, 1);
							$scope._exportParams = {
								companyFields: [],
								contactFields: [],
								option: ''
							};
							break;
						}
					}
				}).catch(function () {

				});
			}
		};

		$scope.addField = function (chip, fields) {
			// $scope.companyFields = $filter('fieldsSelected', fields)
			if (chip == null || chip.id == null) {
				fields.splice(fields.length - 1, 1);
			}
		};

		$scope.launchExport = function () {
			var dto = {
				fields: [],
				modelPagination: $scope.pagination,
				option: $scope._exportParams._option
			};
			dto.fields = dto.fields.concat($scope._exportParams.companyFields);
			dto.fields = dto.fields.concat($scope._exportParams.contactFields);
			companyService.export(dto, $scope.subTypeId, $scope._exportParams.password, $translate.preferredLanguage()).then(function (response) {
				var byteArray = new Uint8Array(response.data);
				var a = window.document.createElement('a');
				a.href = window.URL.createObjectURL(new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
				a.download = 'export.xls';
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			}).catch(function (error) {
				if (error.status === 403) {
					toastr.error($filter('translate')('COMPANIES.EXPORT.BAD_PASSWORD'));
				}
			});
		};

		$scope.exportChanged = function () {
			if ($scope._exportParams != null) {
				$scope._exportParams.companyFields = [];
				$scope._exportParams.contactFields = [];
				for (var i = 0; i < $scope._exportParams.fields.length; i++) {
					var field = angular.copy($scope._exportParams.fields[i]);
					$scope._exportParams._name = angular.copy($scope._exportParams.name);
					$scope._exportParams._option = angular.copy($scope._exportParams.option);
					if (field.modelType === 'COMPANY_MODEL') {
						$scope._exportParams.companyFields.push(field);
					} else if (field.modelType === 'CONTACT_MODEL') {
						$scope._exportParams.contactFields.push(field);
					}
				}
			} else {
				$scope._exportParams = {
					companyFields: [],
					contactFields: [],
					option: ''
				};
			}
		};

		$scope.fieldsSelected = function(fields, selectedFields){
			var res = [];
			if (angular.isArray(selectedFields)){
				var fieldIds = selectedFields.map(function(item){
					return item.id;
				});
				angular.forEach(fields, function(item){
					if (fieldIds.lastIndexOf(item.id) === -1){
						res.push(item);
					}
				});
				return res;
			}else{
				return fields;
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('SubGalleryController', SubGalleryController);

	function SubGalleryController($rootScope, GalleryService, $scope, $translate, $timeout, $location, toastr, FestivalService, languageService, $filter, $mdDialog, DocumentService, $sce, $state, userService) {
		$scope.subGallery = {};
		$scope.languages = [];
		$scope.language = {};
		$scope.loaded = false;
		$scope.updateMode = false;
		$scope.updatingPhotos = false;
		$scope.photos = [];
		var uuidGallery;
		var uuid;

		$scope.getSubGallery = function (uuid, lang) {
			GalleryService.getSub(uuid, lang).then(function (res) {
				$scope.subGallery = res.data;
				$scope.loaded = true;
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.deletePhoto = function (index) {
			$scope.photos.splice(parseInt(index), 1);
		};

		$scope.displayPopUpDeletePhoto = function (photo, index, sub) {
			$scope.photoToDelete = angular.copy(photo);
			$scope.indexToDelete = index;
			$scope.subGalleryEdit = sub;
			$mdDialog.show({
				templateUrl: 'app/main/packages/popup/deletePhoto.popup.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.deletePhotoPermanentely = function () {
			DocumentService.deleteFile($scope.photoToDelete.id).then(function (res) {
				$scope.subGalleryEdit.pictures.splice($scope.indexToDelete, 1);
				toastr.success($filter('translate')('PACKAGES.ADD.TOAST.SUCCESS_DELETE_PHOTO'));
				$scope.hidePopup();
			}).catch(function (err) {
				toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_DELETE_PHOTO'));
			});
		};

		$scope.update = function () {
			$scope.updatingPhotos = true;
			var photos = [];

			for (var i = 0; i < $scope.photos.length; i++) {
				console.log($scope.photos[i]);
				if ($scope.photos[i] != null && $scope.photos[i].uploadFile != null && $scope.photos[i].uploadFile.name != null) {
					var photo = $scope.photos[i].uploadFile;
					photos.push(photo);
				}
			}

			GalleryService.saveSub($scope.subGallery, uuidGallery, $scope.language.key).then(function (res) {
				if (res.data && res.data.id) {
					uuid = res.data.uuid;
					//On upload les photos l'une après l'autre car le faire en parallèle cause une erreur côté back
					var fds = [];

					for (var i = 0; i < photos.length; i++) {
						var formData = new FormData();
						formData.append('file', photos[i], photos[i].name);
						formData.append('dto', angular.toJson({
							subGalleryId: res.data.id
						}));

						fds.push(formData);
					}

					console.log(fds);

					var index = 0;

					if (fds.length > 0) {
						for (var i = 0; i < fds.length; i++) {
							if (i === 0) {
								if (fds.length === 1) {
									addPhoto(fds[i], i, true);
								} else {
									addPhoto(fds[i], i, false);
								}

								index++;
							} else {
								$scope.$on('photoUploaded' + i, function () {
									if (index === fds.length - 1) {
										addPhoto(fds[index], index, true);
									} else {
										addPhoto(fds[index], index, false);
									}

									index++;
								});
							}
						}
					} else {
						$scope.updatingPhotos = false;
					}
				} else {
					$scope.updatingPhotos = false;
				}
			});
		};

		$scope.goBack = function () {
			$state.go('app.gallery.details', {
				uuid: uuidGallery
			});
		};

		function addPhoto(fd, i, last) {
			if (fd) {
				var index = angular.copy(i);
				DocumentService.save(fd).then(function (res) {
					$scope.$emit('photoUploaded' + (index + 1));
					if (last) {
						$scope.photos = [];
						$state.go('.', {
							uuidSub: uuid
						}, {
							notify: false
						});
						$scope.getSubGallery(uuid, $scope.language.key);
						$scope.updatingPhotos = false;
					}

				}).catch(function (err) {
					toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_ADD_PHOTO'));
					$scope.$emit('photoUploaded' + (index + 1));
				});
			}
		}

		function init() {
			if (!$state.params.uuid) {
				$state.go('app.gallery');
			}

			uuidGallery = $state.params.uuid;

			if ($state.params.uuidSub) {
				$scope.updateMode = true;
			}

			languageService.getLanguages().then(function (response) {
				$scope.languages = response.data;
				for (var i = 0; i < $scope.languages.length; i++) {
					var language = $scope.languages[i];
					if (language.preferred) {
						$scope.language.key = language.key;
						break;
					}
				}

				if (!$state.params.uuidSub) {
					$scope.loaded = true;
					return;
				}

				$scope.$watch('language.key', function () {
					$scope.getSubGallery($state.params.uuidSub, $scope.language.key);
				});
			}).catch(function (error) {

			});
		}

		init();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('DetailsGalleryController', DetailsGalleryController);

	function DetailsGalleryController($rootScope, GalleryService, $scope, $translate, $timeout, $location, toastr, FestivalService, languageService, $filter, $mdDialog, DocumentService, $sce, $state, userService) {
		$scope.gallery = {};
		$scope.languages = [];
		$scope.language = {};
		$scope.loaded = false;

		$scope.getGallery = function (uuid, lang) {
			GalleryService.get(uuid, lang).then(function (res) {
				$scope.gallery = res.data;
				$scope.loaded = true;
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.upate = function () {
			GalleryService.save($scope.gallery, $scope.language.key).then(function (res) {
				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_CREATE'));
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.deletePhoto = function (index) {
			$scope.photos.splice(parseInt(index), 1);
		};

		$scope.goAddSubGallery = function (sub) {
			if (!sub) {
				$state.go('app.gallery.details.sub');
			} else {
				$state.go('app.gallery.details.sub', {uuidSub: sub.uuid});
			}

			// $mdDialog.show({
			// 	templateUrl: 'app/main/gallery/details/addSubGallery.popup.html',
			// 	preserveScope: true,
			// 	scope: $scope,
			// 	clickOutsideToClose: true
			// }).then(function () {

			// }).catch(function () {

			// });
		};

		$scope.showPopUpRemove = function (subGallery, index) {
			$scope.subGallery = subGallery;
			$scope.index = index;

			$mdDialog.show({
				templateUrl: 'app/main/gallery/details/removeSubGallery.popup.html',
				preserveScope: true,
				scope: $scope,
				clickOutsideToClose: true
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.displayPopUpDeletePhoto = function (photo, index, sub) {
			$scope.photoToDelete = angular.copy(photo);
			$scope.indexToDelete = index;
			$scope.subGalleryEdit = sub;
			$mdDialog.show({
				templateUrl: 'app/main/packages/popup/deletePhoto.popup.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.downSub = function(sub) {
			GalleryService.downSubGallery(sub.uuid).then(function(res) {
				for (var i = 0; i < $scope.gallery.subGalleries.length; i++) {
					if ($scope.gallery.subGalleries[i].index === sub.index + 1) {
						$scope.gallery.subGalleries[i].index += -1;
					}
				}

				sub.index++;
			}).catch(function(err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.upSub = function(sub) {
			GalleryService.upSubGallery(sub.uuid).then(function(res) {
				for (var i = 0; i < $scope.gallery.subGalleries.length; i++) {
					if ($scope.gallery.subGalleries[i].index === sub.index - 1) {

						$scope.gallery.subGalleries[i].index++;
					}
				}

				sub.index += -1;
			}).catch(function(err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.removeSubGallery = function() {
			GalleryService.removeSub($scope.subGallery.id).then(function(res) {
				var index = angular.copy($scope.subGallery.index);
				for (var i = 0; i < $scope.gallery.subGalleries.length; i++) {
					if ($scope.gallery.subGalleries[i].id === $scope.subGallery.id) {
						$scope.gallery.subGalleries.splice(i, 1);
						break;
					}
				}

				for (var i = 0; i < $scope.gallery.subGalleries.length; i++) {
					if ($scope.gallery.subGalleries[i].index > index) {
						$scope.gallery.subGalleries[i].index += -1;
					}
				}

				$scope.hidePopup();
			}).catch(function(err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.deletePhotoPermanentely = function () {
			DocumentService.deleteFile($scope.photoToDelete.id).then(function (res) {
				$scope.subGalleryEdit.pictures.splice($scope.indexToDelete, 1);
				toastr.success($filter('translate')('PACKAGES.ADD.TOAST.SUCCESS_DELETE_PHOTO'));
				$scope.hidePopup();
			}).catch(function (err) {
				toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_DELETE_PHOTO'));
			});
		};

		$scope.addSubGallery = function () {
			var photos = [];

			for (var i = 0; i < $scope.photos.length; i++) {
				console.log($scope.photos[i]);
				if ($scope.photos[i] != null && $scope.photos[i].uploadFile != null) {
					var photo = $scope.photos[i].uploadFile;
					photos.push(photo);
				}
			}

			GalleryService.saveSub($scope.subGallery, $scope.gallery.id, $scope.language.key).then(function (res) {
				if (res.data && res.data.id) {
					//On upload les photos l'une après l'autre car le faire en parallèle cause une erreur côté back
					var fds = [];

					for (var i = 0; i < photos.length; i++) {
						var formData = new FormData();
						formData.append('file', photos[i], photos[i].name);
						formData.append('dto', angular.toJson({
							subGalleryId: res.data.id
						}));

						fds.push(formData);
					}

					var index = 0;

					if (fds.length > 0) {
						for (var i = 0; i < fds.length; i++) {
							if (i === 0) {
								if (fds.length === 1) {
									addPhoto(fds[i], i, true);
								} else {
									addPhoto(fds[i], i, false);
								}

								index++;
							} else {
								$scope.$on('photoUploaded' + i, function () {
									if (index === fds.length - 1) {
										addPhoto(fds[index], index, true);
									} else {
										addPhoto(fds[index], index, false);
									}

									index++;
								});
							}
						}
					}
				}
			});
		};

		$scope.goBack = function() {
			$state.go('app.gallery');
		};

		function addPhoto(fd, i, last) {
			var index = angular.copy(i);
			DocumentService.save(fd).then(function (res) {
				$scope.$emit('photoUploaded' + (index + 1));
				if (last) {
					console.log('finish');
				}

			}).catch(function (err) {
				toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_ADD_PHOTO'));
				$scope.$emit('photoUploaded' + (index + 1));
			});
		}

		function init() {
			if (!$state.params.uuid) {
				$state.go('app.gallery');
			}

			languageService.getLanguages().then(function (response) {
				$scope.languages = response.data;
				for (var i = 0; i < $scope.languages.length; i++) {
					var language = $scope.languages[i];
					if (language.preferred) {
						$scope.language.key = language.key;
						break;
					}
				}
				$scope.$watch('language.key', function () {
					$scope.getGallery($state.params.uuid, $scope.language.key);
				});
			}).catch(function (error) {

			});
		}

		init();
	}
})();

(function(){
	'use strict';

	angular.module('app.front').controller('addEventController', addEventController);

	function addEventController($scope, $filter, $mdDialog, event, toastr, eventService, SitesManagementService) {
		if (event != null){
			if (event.start != null){
				event.start = new Date(event.start);
			}
			if (event.end != null){
				event.end = new Date(event.end);
			}
		}
		$scope.event = angular.copy(event);

		SitesManagementService.findAll('sites').then(function (response) {
			$scope.sites = response.data;
		}).catch(function(){

		});

		$scope.save = function(){
			var event = angular.copy($scope.event);
			event.start = event.start.getTime();
			if (event.end != null){
				event.end = event.end.getTime();
			}
			var fmData = new FormData();
			fmData.append('event', angular.toJson(event));
			var input = document.getElementById('add_event_dropify');
			if (input != null && input.files != null && input.files.length > 0) {
				fmData.append('file', input.files[0]);
			}
			eventService.save(fmData).then(function (response) {
				$mdDialog.hide();
			}).catch(function () {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});

		};

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};

	}
})();

(function(){
	'use strict';

	angular.module('app.front').service('logisticalStatusService', logisticalStatusService);

	function logisticalStatusService($http, $q){
		var service = {};

		service.list = function(lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/logistical-status',
					method: 'GET',
					params: {'_v': new Date().getTime(), 'lang': lang},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.save = function(dto, lang){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistical-status',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.update = function (dto, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistical-status',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};


		service.remove = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistical-status/'+id,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.up = function(id){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistical-status/up/' + id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.down = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistical-status/down/' + id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};




		return service;
	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('logisticalStatusController', logisticalStatusController);

	function logisticalStatusController($rootScope, $scope, $translate, $filter, logisticalStatusService, languageService) {

		$scope.language = {};
		$scope.newStatus = {};

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.refresh($scope.language.key);
			});
		}).catch(function (error) {

		});


		$scope.refresh = function(lang){
			logisticalStatusService.list(lang).then(function(response){
				$scope.statuses = response.data;
			}).catch(function(response){

			});
		};

		$scope.add = function(form){
			logisticalStatusService.save($scope.newStatus, $scope.language.key).then(function(){
				$scope.newStatus = {};
				$scope.refresh($scope.language.key);
				form.$setPristine();
			}).catch(function(){

			});
		};

		$scope.up = function(id){
			logisticalStatusService.up(id).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){

			});
		};

		$scope.down = function(id){
			logisticalStatusService.down(id).then(function () {
				$scope.refresh($scope.language.key);
			}).catch(function () {

			});
		};

		$scope.edit = function(status){
			$scope.statusToEdit = angular.copy(status);
			status.editionMode = true;
		};

		$scope.update = function(status){
			status.editionMode = false;
			logisticalStatusService.update($scope.statusToEdit, $scope.language.key).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){

			});
		};

		$scope.cancel = function(status){
			status.editionMode = false;
		};

		$scope.remove = function(id){
			var content = {
				title: $filter('translate')('LOGISTICAL_STATUS.DELETE.TITLE'),
				message: $filter('translate')('LOGISTICAL_STATUS.DELETE.MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				logisticalStatusService.remove(id).then(function(){
					$scope.refresh($scope.language.key);
				}).catch(function(){

				});
			}).catch(function(){

			});
		};

	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('logisticalModelController', logisticalModelController);

	function logisticalModelController($scope, $filter, $state, toastr, languageService, modelService){
		$scope.modelType = 'LOGISTIC_MODEL';
		$scope.baseUrl = './api/rest/model/' + $scope.modelType;
		$scope.eventId = $state.params.id;

		$scope.modelTitle = 'Gestion des modèles de dossier';
		$scope.helpModelTitle = 'Aide sur la gestion des champs des modèles de dossier';
		$scope.helpModelContent = 'Dans cette partie il faut renseigner les champs qui seront demandés lors de la création d\'un nouveau modèle de dossier.' + ' L\'objectif est de définir un modèle représentant au mieux les dossiers et leurs attributs.';
		$scope.drawTokenTitle = 'Affichage des modèles de dossier  (à traduire)';
		$scope.helpDrawTokenTitle = 'Aide sur la gestion de l\'affichage des modèles de dossier';
		$scope.helpDrawTokenContent = 'Cette partie permet de gérer l\'affichage d\'un modèle de dossier dans les listes de selection des dossiers.';
		$scope.language = {};
		$scope.categories = [];

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.initCategories();
			});
		}).catch(function (error) {

		});

		$scope.$on('refreshCategories', function () {
			$scope.initCategories();
		});


		$scope.initCategories = function () {
			modelService.getCategories($scope.baseUrl, $scope.language.key, $scope.eventId).then(function (response) {
				$scope.$broadcast('categoriesLoaded');
				$scope.categories = response.data;
			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

	}
})();

(function(){
	'use strict';

	angular.module('app.front').service('logisticService', logisticService);

	function logisticService($http, $q, $filter){
		var service = {};

		service.buildModel = function (categories) {
			angular.forEach(categories, function (category, key) {
				for (var i = 0; i < category.values.length; i++) {
					var field = category.values[i];
					if (field.typeChamps === 'LIST_SELECT') {
						field.value = setSelectedList(field);
					} else if (field.typeChamps === 'DATE'){
						if (field.value != null && field.value !== ''){
							field.dateTime = $filter('stringToDate')(field.value);
						}
					} else if (field.typeChamps === 'BOOLEAN') {
						field.value = 'true' === field.value;
					}
				}
				angular.forEach(category.subCategories, function (category, key) {
					for (var i = 0; i < category.values.length; i++) {
						var field = category.values[i];
						if (field.typeChamps === 'LIST_SELECT') {
							field.value = setSelectedList(field);
						} else if (field.typeChamps === 'DATE') {
							if (field.value != null && field.value !== '') {
								field.dateTime = $filter('stringToDate')(field.value);
							}
						} else if (field.typeChamps === 'BOOLEAN') {
							field.value = 'true' === field.value;
						}
					}
				});
			});
			return categories;
		};

		service.get = function(id, lang){
			return $q(function(resolve, reject){
				$http({
					url: './api/rest/logistic/' + id,
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					}
				}).then(function(response){
					response.data.categories = service.buildModel(angular.copy(response.data.categories));
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.updateStatus = function(id, statusId){
			return $q(function(resolve, reject){
				$http({
					url: './api/rest/logistic/' + id + '/status/' + statusId,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.downloadValuedFile = function (fieldId, modelId) {
			var url =  '/api/rest/logistic/download/' + fieldId + '/' + modelId;
			return url;
		};

		service.updateField = function (id, dto) {
			return $q(function (resolve, reject) {
				if (!dto.fixField) {
					var fmData = new FormData();
					var valuedField = {
						idBaseField: dto.id,
						id: dto.idValue
					};
					if (dto.typeChamps === 'BOOLEAN') {
						valuedField.value = '' + dto.value;
					} else if (dto.typeChamps === 'DATE') {
						if (dto.dateTime != null) {
							valuedField.value = $filter('date')(dto.dateTime, 'dd/MM/yyyy');
						}
					} else if (dto.typeChamps === 'LIST_SELECT') {
						if (!!dto.value) {
							valuedField.listFieldId = dto.value.id;
						}
					} else if (dto.typeChamps === 'MULTIPLE_SELECT') {
						valuedField.values = [];
						angular.forEach(dto.values, function (objectSelected) {
							valuedField.values.push({
								id: objectSelected.id,
								libelle: objectSelected.libelle
							});
						});
					} else if (dto.typeChamps === 'FILE' || dto.typeChamps === 'IMAGE') {
						var input = document.getElementById('genericField_file_' + dto.id + '_' + dto.index);
						var file = null;
						if (input != null) {
							file = input.files[0];
						}
						fmData.append('file', file);
					} else if (dto.typeChamps === 'NUMBER' || dto.typeChamps === 'INTEGER') {
						if ('null' === dto.value) {
							valuedField.value = '';
						} else {
							valuedField.value = dto.value;
						}
					} else {
						valuedField.value = dto.value;
					}
					fmData.append('modelDTO', angular.toJson(valuedField));
					$http({
						url: '/api/rest/logistic/' + id + '/field',
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': undefined,
							'authorization': []
						},
						data: fmData
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				}
			});
		};

		service.addTransport = function(id){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/logistic/' + id + '/transport',
					method: 'POST',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8',
						'authorization': []
					},
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.updateTransport = function(id, dto){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/logistic/' + id + '/transport',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8',
						'authorization': []
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.removeTransport = function(id, planId){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/logistic/' + id + '/transport/' + planId, 
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.uploadTicket = function(id, planId, fmData){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/logistic/' + id + '/transport/' + planId + '/ticket', 
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': undefined,
						'authorization': []
					},
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.downloadTicket = function(id, planId){
			return '/api/rest/logistic/' + id + '/transport/' + planId + '/ticket';
		};



		service.removeTicket = function(id, planId){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/logistic/' + id + '/transport/' + planId + '/ticket', 
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.getTransportFields = function(){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/logistic/transport/fields', 
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		/* HELPERS */

		function setSelectedList(field) {
			var valueReturned = null;
			if (field.listFieldId) {
				for (var k = 0; k < field.listFieldsDTO.length; k++) {
					if (field.listFieldId === field.listFieldsDTO[k].id) {
						valueReturned = field.listFieldsDTO[k];
					}
				}
			}
			return valueReturned;
		}

		return service;
	}
})();
(function(){
	'use strict';

	angular.module('app.front').service('inscriptionSubCategoryService', inscriptionSubCategoryService);

	function inscriptionSubCategoryService($http, $q){
		var service = {};

		service.list = function(lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-subcategory',
					method: 'GET',
					params: {'_v': new Date().getTime(), 'lang': lang},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.save = function(dto, lang){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-subcategory',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.update = function (dto, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-subcategory',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};


		service.remove = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-subcategory/'+id,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.up = function(id){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-subcategory/up/' + id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.down = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-subcategory/down/' + id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};




		return service;
	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('inscriptionSubCategoriesController', inscriptionSubCategoriesController);

	function inscriptionSubCategoriesController($rootScope, $scope, $timeout, $translate, $filter, inscriptionSubCategoryService, languageService) {
		$scope.language = {};
		$scope.newSubCategory = {};

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.refresh($scope.language.key);
			});
		}).catch(function (error) {

		});


		$scope.refresh = function(lang){
			inscriptionSubCategoryService.list(lang).then(function(response){
				$scope.subcategories = response.data;
			}).catch(function(response){

			});
		};

		$scope.add = function(form){
			inscriptionSubCategoryService.save($scope.newSubCategory, $scope.language.key).then(function(){
				$scope.newSubCategory = {};
				$scope.refresh($scope.language.key);
				form.$setPristine();
			}).catch(function(){

			});
		};

		$scope.up = function(id){
			inscriptionSubCategoryService.up(id).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){

			});
		};

		$scope.down = function(id){
			inscriptionSubCategoryService.down(id).then(function () {
				$scope.refresh($scope.language.key);
			}).catch(function () {

			});
		};

		$scope.edit = function(status){
			$scope.subCategoryToEdit = angular.copy(status);
			status.editionMode = true;
		};

		$scope.update = function(status){
			status.editionMode = false;
			inscriptionSubCategoryService.update($scope.subCategoryToEdit, $scope.language.key).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){

			});
		};

		$scope.cancel = function(status){
			status.editionMode = false;
		};

		$scope.remove = function(id){
			var content = {
				title: $filter('translate')('INSCRIPTION_SUB_CATEGORY.DELETE.TITLE'),
				message: $filter('translate')('INSCRIPTION_SUB_CATEGORY.DELETE.MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				inscriptionSubCategoryService.remove(id).then(function(){
					$scope.refresh($scope.language.key);
				}).catch(function(){

				});
			}).catch(function(){

			});
		};

	}
})();
(function(){
	'use strict';

	angular.module('app.front').service('inscriptionStatusService', inscriptionStatusService);

	function inscriptionStatusService($http, $q){
		var service = {};

		service.list = function(lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-status',
					method: 'GET',
					params: {'_v': new Date().getTime(), 'lang': lang},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.save = function(dto, lang){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-status',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.update = function (dto, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-status',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};


		service.remove = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-status/'+id,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.up = function(id){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-status/up/' + id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.down = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-status/down/' + id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};




		return service;
	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('inscriptionStatusController', inscriptionStatusController);

	function inscriptionStatusController($rootScope, $scope, $timeout, $translate, $filter, inscriptionStatusService, languageService) {
		$scope.language = {};
		$scope.newStatus = {};

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.refresh($scope.language.key);
			});
		}).catch(function (error) {

		});


		$scope.refresh = function(lang){
			inscriptionStatusService.list(lang).then(function(response){
				$scope.statuses = response.data;
			}).catch(function(response){

			});
		};

		$scope.add = function(form){
			inscriptionStatusService.save($scope.newStatus, $scope.language.key).then(function(){
				$scope.newStatus = {};
				$scope.refresh($scope.language.key);
				form.$setPristine();
			}).catch(function(){

			});
		};

		$scope.up = function(id){
			inscriptionStatusService.up(id).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){

			});
		};

		$scope.down = function(id){
			inscriptionStatusService.down(id).then(function () {
				$scope.refresh($scope.language.key);
			}).catch(function () {

			});
		};

		$scope.edit = function(status){
			$scope.statusToEdit = angular.copy(status);
			status.editionMode = true;
		};

		$scope.update = function(status){
			status.editionMode = false;
			inscriptionStatusService.update($scope.statusToEdit, $scope.language.key).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){

			});
		};

		$scope.cancel = function(status){
			status.editionMode = false;
		};

		$scope.remove = function(id){
			var content = {
				title: $filter('translate')('INSCRIPTION_STATUS.DELETE.TITLE'),
				message: $filter('translate')('INSCRIPTION_STATUS.DELETE.MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				inscriptionStatusService.remove(id).then(function(){
					$scope.refresh($scope.language.key);
				}).catch(function(){

				});
			}).catch(function(){

			});
		};

	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('inscriptionModelController', inscriptionModelController);

	function inscriptionModelController($scope, $filter, $state, toastr, languageService, modelService){
		$scope.modelType = 'INSCRIPTION_MODEL';
		$scope.baseUrl = './api/rest/model/' + $scope.modelType;
		$scope.eventId = $state.params.id;

		$scope.modelTitle = 'Gestion des modèles de dossier';
		$scope.helpModelTitle = 'Aide sur la gestion des champs des modèles de dossier';
		$scope.helpModelContent = 'Dans cette partie il faut renseigner les champs qui seront demandés lors de la création d\'un nouveau modèle de dossier.' + ' L\'objectif est de définir un modèle représentant au mieux les dossiers et leurs attributs.';
		$scope.drawTokenTitle = 'Affichage des modèles de dossier  (à traduire)';
		$scope.helpDrawTokenTitle = 'Aide sur la gestion de l\'affichage des modèles de dossier';
		$scope.helpDrawTokenContent = 'Cette partie permet de gérer l\'affichage d\'un modèle de dossier dans les listes de selection des dossiers.';
		$scope.language = {};
		$scope.categories = [];

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.initCategories();
			});
		}).catch(function (error) {

		});

		$scope.$on('refreshCategories', function () {
			$scope.initCategories();
		});


		$scope.initCategories = function () {
			modelService.getCategories($scope.baseUrl, $scope.language.key, $scope.eventId).then(function (response) {
				$scope.$broadcast('categoriesLoaded');
				$scope.categories = response.data;
			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

	}
})();

(function(){
	'use strict';

	angular.module('app.front').service('inscriptionService', inscriptionService);

	function inscriptionService($http, $q, $rootScope, $filter){
		var service = {};

		service.buildModel = function (categories) {
			angular.forEach(categories, function (category, key) {
				for (var i = 0; i < category.values.length; i++) {
					var field = category.values[i];
					if (field.typeChamps === 'LIST_SELECT') {
						field.value = setSelectedList(field);
					} else if (field.typeChamps === 'DATE'){
						if (field.value != null && field.value !== ''){
							field.dateTime = $filter('stringToDate')(field.value);
						}
					} else if (field.typeChamps === 'BOOLEAN') {
						field.value = 'true' === field.value;
					}
				}
				angular.forEach(category.subCategories, function (category, key) {
					for (var i = 0; i < category.values.length; i++) {
						var field = category.values[i];
						if (field.typeChamps === 'LIST_SELECT') {
							field.value = setSelectedList(field);
						} else if (field.typeChamps === 'DATE') {
							if (field.value != null && field.value !== '') {
								field.dateTime = $filter('stringToDate')(field.value);
							}
						} else if (field.typeChamps === 'BOOLEAN') {
							field.value = 'true' === field.value;
						}
					}
				});
			});
			return categories;
		};


		service.updateField = function (id, dto) {
			return $q(function (resolve, reject) {
				if (!dto.fixField) {
					var fmData = new FormData();
					var valuedField = {
						idBaseField: dto.id,
						id: dto.idValue
					};
					if (dto.typeChamps === 'BOOLEAN') {
						valuedField.value = '' + dto.value;
					} else if (dto.typeChamps === 'DATE') {
						if (dto.dateTime != null) {
							valuedField.value = $filter('date')(dto.dateTime, 'dd/MM/yyyy');
						}
					} else if (dto.typeChamps === 'LIST_SELECT') {
						if (!!dto.value) {
							valuedField.listFieldId = dto.value.id;
						}
					} else if (dto.typeChamps === 'MULTIPLE_SELECT') {
						valuedField.values = [];
						angular.forEach(dto.values, function (objectSelected) {
							valuedField.values.push({
								id: objectSelected.id,
								libelle: objectSelected.libelle
							});
						});
					} else if (dto.typeChamps === 'FILE' || dto.typeChamps === 'IMAGE') {
						var input = document.getElementById('genericField_file_' + dto.id + '_' + dto.index);
						var file = null;
						if (input != null) {
							file = input.files[0];
						}
						fmData.append('file', file);
					} else if (dto.typeChamps === 'NUMBER' || dto.typeChamps === 'INTEGER') {
						if ('null' === dto.value) {
							valuedField.value = '';
						} else {
							valuedField.value = dto.value;
						}
					} else {
						valuedField.value = dto.value;
					}
					fmData.append('modelDTO', angular.toJson(valuedField));
					$http({
						url: '/api/rest/inscription/' + id + '/field',
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': undefined,
							'authorization': []
						},
						data: fmData
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				}
			});
		};

		service.save = function(contactId, eventId){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription',
					method: 'POST',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'contactId': contactId, 'eventId': eventId}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			}); 
		};

		service.list = function(contactId, lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription/contact/'+contactId,
					method: 'GET',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'lang': lang}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			}); 
		};

		service.downloadValuedFile = function (fieldId, modelId) {
			var url =  '/api/rest/inscription/download/' + fieldId + '/' + modelId;
			return url;
		};

		service.updateInscriptionStatus = function(id, statusId){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription/'+id+'/inscription-status/'+statusId,
					method: 'PUT',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime()}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			}); 
		};

		service.updateSubCategory = function(id, subCategoryId){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription/'+id+'/sub-category/'+subCategoryId,
					method: 'PUT',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime()}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			}); 
		};

		/* PUBLIC */
		service.savePublic = function(formId, contactNumber, pageNumber, fmData, lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/public/sitegen/inscription/'+formId,
					method: 'POST',
					headers: {'Content-Type': undefined},
					params: {'_v': new Date().getTime(), 'lang': lang, 'contactNumber': contactNumber, 'page': pageNumber},
					data: fmData
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			}); 
		};


		/* HELPERS */

		function setSelectedList(field) {
			var valueReturned = null;
			if (field.listFieldId) {
				for (var k = 0; k < field.listFieldsDTO.length; k++) {
					if (field.listFieldId === field.listFieldsDTO[k].id) {
						valueReturned = field.listFieldsDTO[k];
					}
				}
			}
			return valueReturned;
		}

		return service;
	}
})();
(function () {
    'use strict';

    angular.module('app.front').controller('MergeToolController', MergeToolController);

    function MergeToolController($rootScope, $scope, $timeout, $filter, $state, $translate, $mdDialog, $element, $sce, toastr, MODELS_TYPES, modelService, DuplicationToolService) {

        $scope.inProgress = false;
        $scope._modelType = null;
        $scope._modelSubTypeId = null;
        $scope._modelsToMerge = null;

        $scope.unsafe = function(content) {
			return $sce.trustAsHtml(content);
		};

        $scope._getDuplicatesModelsInfos = function(_modelType, _modelSubTypeId, _modelsToMergeIds) {
            $scope.inProgress = true;
            DuplicationToolService._getDuplicatesModelsInfos($translate.preferredLanguage(), _modelType, _modelSubTypeId, _modelsToMergeIds).then(function (response) {
                $scope._modelsToMerge = response.data;
                $scope.inProgress = false;
            }).catch(function (response) {
                toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                $scope.inProgress = false;
            });
        };

        if($state.params._modelType && $state.params._modelsToMerge && $state.params._modelsToMerge.length > 0) {
            $scope._modelType = $state.params._modelType;
            $scope._modelSubTypeId = $state.params._modelSubTypeId;
            $scope._getDuplicatesModelsInfos($state.params._modelType, $state.params._modelSubTypeId, $state.params._modelsToMerge);
        } else {
            $state.go('app.duplication_tool');
        }

        $scope._removeFalsePositiveColumnFn = function(_modelToRemove) {

            var content = {
				title: $filter('translate')('DUPLICATION_TOOL.MERGE.FALSE_POSITIVE_COLUMN_TITLE'),
				message: $filter('translate')('DUPLICATION_TOOL.MERGE.FALSE_POSITIVE_COLUMN_DIALOG_CONFIRM')
            };
            
			$rootScope.openConfirmPopup(content).then(function () {

                var _modelToRemoveCopy = angular.copy(_modelToRemove);

                var _modelIndex = $scope._modelsToMerge.models.map(function (_thisModel) {
                    return _thisModel.modelId;
                }).indexOf(_modelToRemove.modelId);

                if (_modelIndex > -1) {
                    $scope._modelsToMerge.models.splice(_modelIndex, 1);
                    angular.forEach($scope._modelsToMerge.categories, function(_thisCatItem, _thisCatIndex) {
                        angular.forEach(_thisCatItem.values, function(_thisFieldItem, _thisFieldIndex) {
                            angular.forEach(_thisFieldItem.values, function(_thisModelItem, _thisModelIndex) {
                                var _found = false;
                                if(!_found && _thisModelItem.modelInfos.modelId == _modelToRemoveCopy.modelId) {
                                    _thisFieldItem.values.splice(_thisModelIndex, 1);
                                    _found = true;
                                }
                            });
                        });
                    });
                }
                
			}).catch(function (error) {
                console.log(error);
			});
           
        };

        $scope._defaultColumnSelectedFn = function(_modelToSelect) {

            angular.forEach($scope._modelsToMerge.categories, function(_thisCatItem, _thisCatIndex) {
                angular.forEach(_thisCatItem.values, function(_thisFieldItem, _thisFieldIndex) {
                    angular.forEach(_thisFieldItem.values, function(_thisValueItem, _thisValueIndex) {
                        if(_thisValueItem.modelInfos.modelId == _modelToSelect.modelId) {
                            _thisValueItem.selected = true;
                            $scope._modelFieldSelectedFn(_thisCatItem, _thisFieldItem, _thisValueItem);
                        }
                    });                   
                });
            });

            angular.forEach($scope._modelsToMerge.models, function(_item, index) {
                if(_item.modelId != _modelToSelect.modelId) {
                    _item._defaultColumnSelected = false;
                }
            });
            _modelToSelect._defaultColumnSelected = true;

        };

        $scope._modelFieldSelectedFn = function(_category, _field, _value) {
            if(_field.fixeField) {
                _field.modelSelectedId = angular.copy(_value.idValue);
            } else {
                _field.modelSelectedId = angular.copy(_value.modelInfos.modelId);
            }
            _field.noModelSelected = false;
            angular.forEach(_field.values, function(_valueItem, _valueIndex) {
                if (_valueItem.modelInfos.modelId != _value.modelInfos.modelId) {
                    _valueItem.selected = false;
                }
            });
        };

        $scope._mergeModelsFn = function() {
            $scope.inProgress = true;
            var _isValidOperation = true;
            angular.forEach($scope._modelsToMerge.categories, function(_thisCatItem, _thisCatIndex) {
                angular.forEach(_thisCatItem.values, function(_thisFieldItem, _thisFieldIndex) {
                    var _found = false;
                    angular.forEach(_thisFieldItem.values, function(_thisModelItem, _thisModelIndex) {                      
                        if(!_found && _thisModelItem.selected) {
                            _found = true;
                        }
                    });
                    if(!_found) {
                        $scope._modelsToMerge.categories[_thisCatIndex].values[_thisFieldIndex].noModelSelected = true;
                        _isValidOperation = false;
                    }
                });
            });
            if(_isValidOperation) {
                DuplicationToolService._mergeDuplicatesModels($translate.preferredLanguage(),  $scope._modelType, $scope._modelSubTypeId, 
                    $scope._modelsToMerge).then(function (response) {

                    toastr.success($filter('translate')('DUPLICATION_TOOL.MERGE.MERGE_ACTION_SUCCESS'));
                    
                    $scope.inProgress = false;

                   if($scope._modelType == MODELS_TYPES.COMPANY_MODEL) {
                        /*$state.go('app.companies.details', {
                            subType: $scope._modelSubTypeId,
                            id: response.data.id
                        });*/
                        $state.go('app.duplication_tool', {
                            _modelType: MODELS_TYPES.CONTACT_MODEL,
                            _companyId: response.data.id
                        });
                    } else if($scope._modelType == MODELS_TYPES.CONTACT_MODEL) {
                        /*$state.go('app.companies.details.contact', {
                            id: response.data.id
                        });*/
                        $state.go('app.companies.details', {
                            subType: response.data.subTypeId,
                            id: response.data.id
                        });
                    }
                    
                }).catch(function (response) {
                    $scope.inProgress = false;
                    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                });
            } else {
                $scope.inProgress = false;
                toastr.error($filter('translate')('DUPLICATION_TOOL.MERGE.MERGE_ACTION_NO_MODEL_SELECTED_ERROR'));
            }
        };

    }
    
})();
(function () {
    'use strict';

    angular.module('app.front').controller('JunkBoxController', JunkBoxController);

    function JunkBoxController($rootScope, $scope, $timeout, $filter, $state, $translate, $mdDialog, $element, toastr, MODELS_TYPES, 
            modelService, DuplicationToolService) {

        $scope.models = [];
        $scope.loaded = false;

        DuplicationToolService._junkBoxFindAll($translate.preferredLanguage()).then(function (response) {
            $scope.models = response.data;
            $scope.loaded = true;
        }).catch(function (response) {
            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            $scope.loaded = true;
        });

        $scope.onDeleteJunkBox= function(model) {
            model.actionInProgress = true;
            var content = {
				title: $filter('translate')('JUNK_BOX.ACTIONS.REMOVE_CONFIRMATION_TITLE'),
				message: $filter('translate')('JUNK_BOX.ACTIONS.REMOVE_CONFIRMATION_MSG')
            };
			$rootScope.openConfirmPopup(content).then(function () {
                DuplicationToolService._junkBoxDelete(model.id).then(function (response) {
                    var index = $scope.models.map(function (item) {
                        return item.id;
                    }).indexOf(model.id);
                    if (index > -1) {
                        $scope.models.splice(index, 1);
                    }
                }).catch(function (response) {
                    model.actionInProgress = false;
                    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                });
			}).catch(function (error) {
                model.actionInProgress = false;
                console.log(error);
			});
        };
        
    }
    
})();
(function () {
  'use strict';

  angular.module('app.front').controller('usersLogsController', usersLogsController);

  function usersLogsController($scope, LOGS_ENTITY_CONCERNED, LOGS_ACTIONS, adminService, $rootScope, $filter, packagesService, languageService, $mdDialog, $state, toastr) {
    var filter = {
      page: 0,
      output: 100
    };
    $scope.logs = [];
    $scope.allLoaded = false;
    $scope.ENTITY_CONCERNED = LOGS_ENTITY_CONCERNED;
    $scope.ACTIONS = LOGS_ACTIONS;

    $scope.getLogs = function () {
      adminService.get(filter).then(function (res) {
        if (res.data) {
          $scope.logs = $scope.logs.concat(res.data);
        }
        if (res.data.length < 100) {
          $scope.allLoaded = true;
        } else {
          filter.page++;
        }
        console.log(res.data);
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.getLogs();


  }
})();

(function(){
	'use strict';

	angular.module('app.front').controller('messagesLogsController', messagesLogsController);

	function messagesLogsController($scope, $translate, $mdDialog, MessageService){
		$scope.page = 0;
		var MAX = 50;
		$scope.infiniteScrollPrevent = false;
		$scope.messages = [];

		$scope.loadMore = function(){
			if (!$scope.infiniteScrollPrevent){
				$scope.infiniteScrollPrevent = true;
				MessageService.findAllPaginated($scope.page, MAX, $translate.preferredLanguage()).then(function(response){
					if (response.data.length > 0){
						$scope.messages = $scope.messages.concat(response.data);
						$scope.infiniteScrollPrevent = false;
					}else{
						$scope.infiniteScrollPrevent = true;
					}
					$scope.page++;
				}).catch(function(){
	
				});
			}
		};
		$scope.loadMore();

		$scope.seeMessage = function(message){
			$scope.message = message;
			$mdDialog.show({
				templateUrl: 'app/main/admin/messagesLogs/message.html',
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true
			}).then(function(){
				
			}).catch(function(){
		
			});
		};

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};
	}
})();
(function () {
    'use strict';
  
    angular.module('app.front').controller('eventsLogsController', eventsLogsController);
  
    function eventsLogsController($scope, adminService, $rootScope, $filter, packagesService, languageService, $mdDialog, $state, toastr) {

    }
  })();
(function () {
  'use strict';

  angular.module('app.front').controller('usersController', usersController);

  function usersController($rootScope, $scope, $filter, $mdDialog, userService) {
    //Fonction init() en bas de la page!!
    $scope.showAllUsers = true;

    $scope.refreshUsers = function () {
      if ($scope.showAllUsers) {
        userService.findAllUsers().then(function (response) {
          $scope.users = response.data;
        }).catch(function (response) {

        });
      } else {
        userService.findActive().then(function (response) {
          $scope.users = response.data;
        }).catch(function (response) {

        });
      }

    };

    $scope.openAddUser = function () {
      $mdDialog.show({
        templateUrl: 'app/main/access_rights/users/popup/add_user.html',
        controller: 'addUserController',
        clickOutsideToClose: true,
        locals: {
          company: null
        }
      }).then(function () {
        $scope.refreshUsers();
      }).catch(function () {

      });
    };

    $scope.details = function (user) {
      $mdDialog.show({
        templateUrl: 'app/main/access_rights/users/popup/edit_user.html',
        controller: 'editUserController',
        clickOutsideToClose: true,
        locals: {
          user: user
        }
      }).then(function () {
        $scope.refreshUsers();
      }).catch(function () {

      });
    };

    $scope.switchActives = function () {
      $scope.showAllUsers = !$scope.showAllUsers;

      $scope.refreshUsers();
    };

    function init() {
      if ($rootScope.user) {
        $scope.showAllUsers = !!$rootScope.user.seeInactiveContact;
      }

      $scope.refreshUsers();
    }

    init();
  }
})();

(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            'app.quick-panel',

            // Front
            'app.front',

            // Site
            'sitegen.site',

            'chart.js',

            'infinite-scroll',

            'ngQuill',

				'vcRecaptcha',

				'addthis',

				'file',

				'star-rating',

				'angularUtils.directives.dirPagination'
        ]);
})();

(function () {
	'use strict';

	angular.module('fuse').service('userService', userService);

	function userService($q, $http, msNavigationService, $rootScope) {
		var USER_PERMISSIONS = null;
		var USER_CONNECTED = null;

		var USER_IS_ADMIN = false;
		var USER_LINKED_TO_ASSOCIATIONS = false;
		var CAN_USER_EDIT_STATS = false;
		var USER_HAS_NON_READ_MSG = false;

		var getUserRoles = function () {
			return $q(function (resolve, reject) {
				if (USER_PERMISSIONS == null) {
					$http({
						url: '/api/rest/permissions/find',
						method: 'GET',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						USER_PERMISSIONS = response;
						resolve(USER_PERMISSIONS);
					}).catch(function (response) {
						reject(response);
					});
				} else {
					resolve(USER_PERMISSIONS);
				}
			});
		};

		var checkPermission = function (permissionsTOcheck) {
			var _found = false;
			var self = this;
			return $q(function (resolve, reject) {
				self.getUserRoles().then(function (response) {
					angular.forEach(permissionsTOcheck, function (item, _index) {
						if (response.data.indexOf(item) > -1) {
							_found = true;
							return;
						}
					});
					resolve(_found);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var isConnected = function () {
			return $q(function (resolve, reject) {
				if (USER_CONNECTED == null) {
					$http({
						url: '/api/public/unsecured/isConnected',
						method: 'GET',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						USER_CONNECTED = response;
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				} else {
					resolve(USER_CONNECTED);
				}
			});
		};

		var login = function (loginDTO, associationId) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/unsecured/login',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'rememberMe': true,
						'associationId': associationId
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					},
					data: loginDTO
				}).then(function (response) {
					USER_CONNECTED = response;
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var logout = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/unsecured/logout',
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					USER_CONNECTED = null;
					USER_PERMISSIONS = null;
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var getCurrent = function (lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					if (response != null && response.data != null) {
						$rootScope.user = response.data;

						console.log($rootScope.user);
						if ($rootScope.user.admin) {
							USER_IS_ADMIN = true;
							CAN_USER_EDIT_STATS = true;
						} else if ($rootScope.user.associationIds && $rootScope.user.associationIds.length > 0) {
							USER_LINKED_TO_ASSOCIATIONS = true;
						}

						if ($rootScope.user.company && $rootScope.user.company.id) {
							CAN_USER_EDIT_STATS = true;
						}

						if ($rootScope.user.msgNonRead) {
							USER_HAS_NON_READ_MSG = true;
						} else {
							USER_HAS_NON_READ_MSG = false;
						}

						$rootScope.$broadcast('rooScopeUser:ready');
						resolve(response);
					} else {
						reject(response);
					}
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var isUserAdmin = function () {
			return USER_IS_ADMIN;
		};

		var isUserLinkedToAssociations = function () {
			return USER_LINKED_TO_ASSOCIATIONS;
		};

		var canUserEditStats = function () {
			return CAN_USER_EDIT_STATS;
		};

		var isUserHasNonReadMsg = function () {
			return USER_HAS_NON_READ_MSG;
		};

		var getAccounts = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user/accounts',
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		// update password after forgot password
		var updatePassword = function (token, password) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/unsecured/updatePassword',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'key': token,
						'password': password
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var updateAccount = function (accountDTO) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user/account',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					},
					data: accountDTO
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var forgotPassword = function (email) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/unsecured/forgotPassword',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'email': email
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var findAllUsers = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user/findall',
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var findByGroups = function (groupIDs) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user/byGroups',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'groupIDs': groupIDs
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var findActive = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user/find/active',
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var addUser = function (fmData, fromAssociation) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'fromAssociation': fromAssociation
					},
					headers: {
						'Content-Type': undefined
					},
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var updateUser = function (fmData) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': undefined
					},
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		return {
			getUserRoles: getUserRoles,
			checkPermission: checkPermission,
			isConnected: isConnected,
			login: login,
			logout: logout,
			getCurrent: getCurrent,
			getAccounts: getAccounts,
			updatePassword: updatePassword,
			updateAccount: updateAccount,
			forgotPassword: forgotPassword,
			findAllUsers: findAllUsers,
			addUser: addUser,
			updateUser: updateUser,
			findActive: findActive,
			isUserAdmin: isUserAdmin,
			isUserLinkedToAssociations: isUserLinkedToAssociations,
			canUserEditStats: canUserEditStats,
			isUserHasNonReadMsg: isUserHasNonReadMsg,
			findByGroups: findByGroups
		};
	}
})();

(function(){
	'use strict';

	angular.module('app.front').controller('groupsController', groupsController);

	function groupsController($rootScope, $scope, $mdDialog, $filter, toastr, groupService){

		$scope.refreshGroups = function(){
			groupService.findGroups().then(function(response){
				$scope.groups = response.data;
			}).catch(function(response){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.refreshGroups();

		$scope.details = function(group){
			$mdDialog.show({
				templateUrl: 'app/main/access_rights/groups/popup/edit_group.html',
				controller: 'editGroupController',
				clickOutsideToClose: true,
				locals: {
					group: group
				}
			}).then(function(){
				$scope.refreshGroups();
			}).catch(function(){

			});
		};

		$scope.openAddGroup = function(){
			$mdDialog.show({
				templateUrl: 'app/main/access_rights/groups/popup/add_group.html',
				controller: 'addGroupController',
				clickOutsideToClose: true
			}).then(function(){
				$scope.refreshGroups();
			}).catch(function(){

			});
		};

		$scope.openRemoveGroup = function(group){
			var content = {
				title: $filter('translate')('GROUPS.DELETE'),
				message: $filter('translate')('GROUPS.CONFIRM_DELETE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				groupService.deleteGroup(group.id).then(function(){
					$scope.refreshGroups();
				}).catch(function(){
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}).catch(function(){

			});
		};
	}
})();

(function(){
	'use strict';

	angular.module('app.front').service('groupService', groupService);

	function groupService($http, $q){

		var service = {};

		service.addGroup = function(dto){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/group',
					method: 'POST',
					params: {
						'_v': new Date().getTime()
					},
					data: dto
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.updateGroup = function (dto) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/group',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};
		service.deleteGroup = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/group/removeGroup/' + id,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findGroups = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/group/find',
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		return service;

	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('associationsController', associationsController);

	function associationsController($rootScope, $scope, $filter, $mdDialog, $state, toastr, URL, associationService){

		$scope.alternatedocroots = URL.alternatedocroots;

		$scope.refreshAssociations = function(){
			associationService.findAll().then(function(response){
				$scope.associations = response.data;
			}).catch(function(){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.refreshAssociations();

		$scope.openAddAssociation = function(){
			$mdDialog.show({
				templateUrl: 'app/main/access_rights/associations/popup/add_association.html',
				controller: 'addAssociationController',
				clickOutsideToClose: true
			}).then(function(){
				$scope.refreshAssociations();
			}).catch(function(){

			});
		};

		$scope.details = function(association){
			$mdDialog.show({
				templateUrl: 'app/main/access_rights/associations/popup/edit_association.html',
				controller: 'editAssociationController',
				clickOutsideToClose: true,
				locals: {
					association: association
				}
			}).then(function(){
				$scope.refreshAssociations();
			}).catch(function(){

			});
		};

		$scope.detailsCompany = function(association){
			$state.go('app.association', {id: association.id});
		};

		$scope.openRemoveAssociation = function (association) {
			var content = {
				title: $filter('translate')('ASSOCIATIONS.DELETE'),
				message: $filter('translate')('ASSOCIATIONS.CONFIRM_DELETE')
			};
			$rootScope.openConfirmPopup(content).then(function () {
				associationService.delete(association.id).then(function () {
					$scope.refreshAssociations();
				}).catch(function () {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}).catch(function () {

			});
		};
	}
})();

(function(){
	'use strict';

	angular.module('app.front').service('associationService', associationService);

	function associationService($q, $http){
		var service = {};

		service.save = function(fmData){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/association',
					method: 'POST',
					headers: {
						'Content-Type': undefined
					},
					params: {
						'_v': new Date().getTime()
					},
					data: fmData
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.update = function (fmData) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/association',
					method: 'PUT',
					headers: {
						'Content-Type': undefined
					},
					params: {
						'_v': new Date().getTime()
					},
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.delete = function(id){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/association/' + id,
					method: 'DELETE',
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findAll = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/association',
					method: 'GET',
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findById = function (id, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/association/' + id,
					method: 'GET',
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findByIdPublic = function (id, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/unsecured/association/' + id,
					method: 'GET',
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					params: {
						'_v': new Date().getTime(), 
						'lang': lang
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		return service;
	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('associationController', associationController);

	function associationController($scope, $state, $filter, $translate, $mdDialog, toastr, associationService){
		$scope.refreshAssociation = function(){
			associationService.findById($state.params.id, $translate.preferredLanguage()).then(function(response){
				$scope.association = response.data;
			}).catch(function(){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.refreshAssociation();

		$scope.addManager = function(company){
			$mdDialog.show({
				templateUrl: 'app/main/access_rights/users/popup/add_user.html',
				controller: 'addUserController',
				clickOutsideToClose: true,
				locals: {
					company: company
				}
			}).then(function(){
				$scope.refreshAssociation();
			}).catch(function(){

			});
		};
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'datatables', 'datatables.columnfilter',
                'toastr',
                'ui-rangeSlider',
                'thatisuday.ng-image-gallery'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function(){
	'use strict';

	angular.module('app.front').service('touristAttractionService', touristAttractionService);

	function touristAttractionService($q, $http){
		var service = {};

		var url = '/api/rest/touristAttraction';
		var publicUrl = '/api/public/sitegen/touristAttraction';

		service.save = function (fmData, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: url + '/save',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': undefined
					},
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.get = function (lang) {
			return $q(function (resolve, reject) {
				$http({
					url: url,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findById = function (id, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: url + '/findById/' + id,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.delete = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: url + '/delete/' + id,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.deletePhoto = function(id, photoId){
			return $q(function (resolve, reject) {
				$http({
					url: url + '/delete/' + id + '/photo/'+photoId,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.publicGet = function (page, max, filter, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: publicUrl + '/filter',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang,
						'page': page,
						'max': max
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					},
					data: filter
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findByIdPublic = function (id, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: publicUrl + '/' + id,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang,
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		return service;
	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('touristAttractionsController', touristAttractionsController);

	function touristAttractionsController($scope, $state, $mdDialog, $filter, toastr, languageService, touristAttractionService){
		$scope.regions = {};
		$scope.typesTourism = {};
		$scope.language = {};
		$scope.languages = [];
		var updateMode = false;
		$scope.loaded = true;

		$scope.tourist = {};
		$scope.tourists = [];

		$scope.limitNbrTypes = 3;

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
		}).catch(function (error) {

		});

		$scope.initTourists = function () {
			$scope.loaded = false;
			touristAttractionService.get($scope.language.key).then(function (res) {
				if (res.data) {
					$scope.tourists = res.data;
				}
				$scope.loaded = true;
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(err);
			});
		};

		$scope.initTourists();

		$scope.goAdd = function (update) {
			$state.go('app.touristAttractions.add');
		};

		$scope.hidePopup = function () {
			$mdDialog.hide();
		};

		$scope.update = function (tourist) {
			if (tourist.id) {
				$state.go('app.touristAttractions.update', {
					id: tourist.id
				});
			} else {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			}
		};

		$scope.showPopUpDelete = function (tourist, index) {
			$scope.touristToDelete = angular.copy(tourist);
			$scope.indexToDelete = index;

			$mdDialog.show({
				templateUrl: 'app/main/popup/confirm.html',
				clickOutsideToClose: true,
				controller: 'confirmPopupController',
				locals: {
					content: {
						title: $filter('translate')('TOURIST.POPUP_DELETE.TITLE'),
						message: $filter('translate')('TOURIST.POPUP_DELETE.MESSAGE')
					}
				}
			}).then(function () {
				$scope.remove();
			}).catch(function () { });
		};

		$scope.remove = function () {
			touristAttractionService.delete($scope.touristToDelete.id).then(function (res) {
				toastr.success($filter('translate')('TOURIST.SUCCESS_DELETE'));
				$scope.tourists.splice($scope.indexToDelete, 1);
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(err);
			});
		};
	}
})();
(function () {
  'use strict';

  angular.module('fuse').service('statisticsService', statisticsService);

  function statisticsService($q, $http, msNavigationService, $rootScope, $window) {
    var service = {};
    var url = '/api/rest/statistics';
    var publicUrl = './api/public/sitegen';

    service.save = function (statisticsDTO, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url,
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: statisticsDTO
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.get = function (periodDTO) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/findByCompanyIdAndPeriod',
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: periodDTO
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.filter = function (filter, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/filter',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filter
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.compare = function (filters, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/compare',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filters
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStatsNationalities = function (filter) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/nationalities',
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filter
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getNationalities = function (lang) {
      return $q(function (resolve, reject) {
        $http({
          url: publicUrl + '/nationalities',
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getRegions = function (lang) {
      return $q(function (resolve, reject) {
        $http({
          url: publicUrl + '/regions',
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.generateCompanies = function (filter, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/generateCompanies',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filter
        }).then(function (response) {
          $window.location.href = url + '/download/?location=' + response.data;
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.generateNationalities = function (filter, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/generateNationalities',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filter
        }).then(function (response) {
          $window.location.href = url + '/download/?location=' + response.data;
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStatisticsAutomatic = function (filter) {
      var urlAuto = url + '/automaticStatistics';

      return $q(function (resolve, reject) {
        $http({
          url: urlAuto,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime()
          },
          data: filter
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStatisticRepartitionCompany = function (subTypeId, fieldId, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/repartition/company/' + subTypeId + '/' + fieldId,
          method: 'GET',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStatisticRepartitionContact = function (fieldId, lang, companyType) {
      var customURL = url + '/repartition/contact/' + fieldId + '/';

      if (companyType) {
        customURL += companyType;
      }

      return $q(function (resolve, reject) {
        $http({
          url: customURL,
          method: 'GET',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStatisticsByCompanyTypes = function (lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/repartition/byCompanyTypes',
          method: 'GET',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStatisticReporting = function (filter, lang, year) {
      var urlPost = url + '/reporting/';

      if (year !== null) {
        urlPost += year;
      }

      return $q(function (resolve, reject) {
        $http({
          url: urlPost,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          data: filter
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.generateReporting = function (filter, lang, year) {
      var urlPost = url + '/generateReporting/';

      if (year !== null) {
        urlPost += year;
      }

      return $q(function (resolve, reject) {
        $http({
          url: urlPost,
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filter
        }).then(function (response) {
          $window.location.href = url + '/download/?location=' + encodeURIComponent(response.data);
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.addStatClick = function (postDTO) {
      return $q(function (resolve, reject) {
        $http({
          url: publicUrl + '/companies/statClick',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime()
          },
          data: postDTO
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStratisticsBySubTypeId = function (subTypeId, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/repartition/' + subTypeId,
          method: 'GET',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStratisticsFilteredBySubTypeId = function (subTypeId, lang, filter) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/repartition/filtered/' + subTypeId,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          data: filter
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('statisticsController', statisticsController);

  /** @ngInject */
  function statisticsController($scope, statisticsService, $filter, $rootScope, toastr, $mdDialog) {
    
  }
})();

(function () {
  'use strict';

  angular.module('app.front').service('SitesManagementService', SitesManagementService);

  function SitesManagementService($q, $http, $filter) {

    var service = {};

    var blocTypes = [
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.BLOG', value: 'BLOG' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.PACKAGE', value: 'PACKAGE' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.HTML', value: 'HTML' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.SEARCH_COMPANY', value: 'SEARCH_COMPANY' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.SEARCH_PACKAGE', value: 'SEARCH_PACKAGE' },
		{ translation: 'SITES_MANAGEMENT.BLOCS.TYPES.CAROUSEL', value: 'CAROUSEL' },
		{ translation: 'SITES_MANAGEMENT.BLOCS.TYPES.CAROUSEL_PURE', value: 'CAROUSEL_PURE' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.COMPANY', value: 'COMPANY' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.SEARCH_TOURIST_ATTRACTIONS', value: 'SEARCH_TOURIST_ATTRACTIONS' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.TOURIST_ATTRACTION', value: 'TOURIST_ATTRACTION' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.ARTICLE', value: 'ARTICLE' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.FESTIVALS', value: 'FESTIVALS'  },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.FESTIVAL', value: 'FESTIVAL' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.GALLERIES', value: 'GALLERIES' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.GALLERY', value: 'GALLERY' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.CONTACT', value: 'CONTACT' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.TABLE', value: 'TABLE' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.EVENT_INSCRIPTION', value: 'EVENT_INSCRIPTION' }
    ];

    service.getBlocTypes = function () {
      return blocTypes;
    };

    service.findAll = function (path) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/' + path,
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.find = function (path, id) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/' + path + '/' + id,
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findById = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/site/' + id,
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.saveFd = function(path, fmData){
			return $q(function(resolve, reject){
				$http({
          url: './api/rest/sites-management/fd/' + path,
					method: 'POST',
					headers: {
						'Content-Type': undefined
					},
					params: {
						'_v': new Date().getTime()
					},
					data: fmData
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

    service.save = function (path, dto) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/' + path,
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.delete = function (path, id) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/' + path + '/' + id,
          method: 'DELETE',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findPage = function (pageId, langKey) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/page/' + pageId + '/' + langKey,
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findPagesBySiteID = function (siteID) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/page/bySiteID/' + siteID,
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findSiteMenuBySiteID = function (siteID, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/siteMenu/' + siteID,
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findSiteMenuBySiteURL = function (url, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/siteMenuByURL/' + url,
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.saveSiteMenuItem = function (dto, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/siteMenuItem',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.deleteSiteMenuItem = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/siteMenuItem/' + id,
          method: 'DELETE',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.upSiteMenuItem = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/siteMenuItem/up',
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.downSiteMenuItem = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/siteMenuItem/down',
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.moveBloc = function(pageID, blocIndex, up) {
      var url = './api/rest/sites-management/page/' + pageID + '/' + blocIndex + '/';

      if (up) {
        url += 'up';
      } else {
        url += 'down';
      }

      return $q(function (resolve, reject) {
        $http({
          url: url,
          method: 'PUT',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    return service;

  }

})();

(function () {
    'use strict';

    angular
        .module('sitegen.site')
        .controller('SiteGenMainController', SiteGenMainController);

    /** @ngInject */
    function SiteGenMainController($scope, $rootScope, $accountProvider, URL, $location, $state, $currentSite, toastr, $filter, $cookies, companyService, $translate, $http) {
        var PROVIDER_SESSION_STORAGE_KEY_PREFIX = "PROVIDER_";
        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
        if ($location.search().param1) {
            $scope.currentCompanyId = +$location.search().param1;

            companyService.setStatisticView($scope.currentCompanyId).then(function (response) {
            }).catch(function (error) {
                console.log(error);
            });
        }
        $rootScope.site = $currentSite.getSite();
        $scope.$on('$viewContentLoaded', () => {
            $rootScope.currentUrl = window.location.href;
            $rootScope.siteDescription = '';
            $rootScope.siteType = 'article';

            $scope.initLogo();
        });
        $scope.$on('siteUpdated', () => {
            $scope.initLogo();
        });

        $scope.initLogo = function () {
            if ($rootScope.site.logoRS) {
                var full = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
                var defaultLogo = full + URL.alternatedocrootsWithoutDot + '/' + $rootScope.site.logoRS;
                $rootScope.siteImage = defaultLogo;
                var img = new Image();
                img.onload = function () {
                    document.querySelector('meta[property="og:image:width"]').setAttribute('content', '' + this.width);
                    document.querySelector('meta[property="og:image:height"]').setAttribute('content', '' + this.height);
                };
                img.src = defaultLogo;
            }
        };

        $scope.$on('checkSelection', function () {
            var _ids = [];
            for (var i = 0; i < localStorage.length; i++) {
                if (localStorage.key(i).substring(0, 9) === 'PROVIDER_') {
                    try {
                        var _item = JSON.parse(localStorage.getItem(localStorage.key(i)));
                        if (_item.id && localStorage.key(i) === 'PROVIDER_' + _item.id) {
                            _ids.push(_item);
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            }
            $scope.selectionLength = _ids.length;
        });

        $scope.$broadcast('checkSelection');


        var toastrOptions = {
            closeButton: true,
            timeOut: 10000,
            extendedTimeOut: 5000,
            progressBar: true
        };

        $scope.toastr = {
            success: function (msg) {
                toastr.clear();
                toastr.success(msg, $filter('translate')('SITE_GEN.INFOS_TOASTR_TITLE'), toastrOptions);
            },
            error: function (msg) {
                toastr.clear();
                toastr.error(msg, $filter('translate')('SITE_GEN.ERROR_TOASTR_TITLE'), toastrOptions);
            }
        };

        var _protocol = $location.$$protocol;
        var _host = $location.$$host;
        var _port = $location.$$port;
        $scope.contextUrl = _protocol + '://' + $location.$$host;
        if (_port) {
            $scope.contextUrl += ":" + _port;
        }

        $accountProvider.getAccount().then(function (response) {
            $scope.account = response;
            console.log($scope.account)
        }).catch(function (error) {

        });

        $rootScope.$on('OnAccountReady', function () {
            $scope.account = null;
            $accountProvider.getAccount().then(function (response) {
                $scope.account = response;
            }).catch(function (error) {
                //console.error(error);
            });
        });

        $scope.goToLoginFn = function () {
            $state.go('sitegen.site.login', { site: $currentSite.getSite().url, fromAction: $location.search().fromAction });
        };

        $scope.onAskForAQuote = function (company) {
            var _companySelected = angular.copy(company);
            _companySelected.session = $cookies.get("SESSION_TOKEN");
            localStorage.setItem("SELECTED_PROVIDER", JSON.stringify(_companySelected));
            $accountProvider.getAccount().then(function (response) {
                $scope.account = response;
                $state.go('sitegen.site.request_for_proposal.send', { site: $currentSite.getSite().url });
            }).catch(function (error) {
                $scope.account = null;
                $state.go('sitegen.site.login', { site: $currentSite.getSite().url, fromAction: 'FROM_ON_ASK_FOR_A_QUOTE_ACTION' });
                //console.log(error);
            });
        };

        $scope.mySelectonOfProviders = [];
        $scope.getCompanies = function () {
            var _ids = [];
            for (var i = 0; i < localStorage.length; i++) {
                if (localStorage.key(i).substring(0, 9) === 'PROVIDER_') {
                    try {
                        var _item = JSON.parse(localStorage.getItem(localStorage.key(i)));
                        if (_item.id && localStorage.key(i) === 'PROVIDER_' + _item.id) {
                            _ids.push(_item);
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            }
            if (_ids.length > 0) {
                companyService.listMySelection($translate.preferredLanguage(), _ids).then(function (response) {
                    $scope.mySelectonOfProviders = response.data;
                }).catch(function (error) {
                    console.log(error);
                });
            }
        }
        $scope.getCompanies();

        $scope.onAskForAllQuote = function () {
            var _companySelected = angular.copy($scope.mySelectonOfProviders);
            _companySelected.session = $cookies.get("SESSION_TOKEN");
            localStorage.setItem("SELECTED_PROVIDER", JSON.stringify(_companySelected));
            $accountProvider.getAccount().then(function (response) {
                $scope.account = response;
                $state.go('sitegen.site.request_for_proposal.send', { site: $currentSite.getSite().url });
            }).catch(function (error) {
                $scope.account = null;
                $state.go('sitegen.site.login', { site: $currentSite.getSite().url, fromAction: 'FROM_ON_ASK_FOR_A_QUOTE_ACTION' });
                console.log(error);
            });
        };

        $scope.onAskForAllQuotePure = function () {
            $state.go('sitegen.site.workbook', { site: $currentSite.getSite().url });
            // $accountProvider.getAccount().then(function (response) {
            //     $scope.account = response;
            // }).catch(function (error) {
            //     $scope.account = null;
            //     $state.go('sitegen.site.login', { site: $currentSite.getSite().url, fromAction: 'FROM_ON_ASK_FOR_A_QUOTE_ACTION' });
            //     console.log(error);
            // });
        };

        $scope.onAskForAQuotePure = function (pageDetailName, company) {
            if (!pageDetailName) {
                pageDetailName = $rootScope.site.companyUrl;
            }
            localStorage.setItem(PROVIDER_SESSION_STORAGE_KEY_PREFIX + company.id, JSON.stringify({
                id: company.id,
                page: pageDetailName,
                modelPattern: company.modelPattern,
                session: $cookies.get("SESSION_TOKEN")
            }));
            $scope.$broadcast('checkSelection');
            $state.go('sitegen.site.workbook', { site: $currentSite.getSite().url });
            // $accountProvider.getAccount().then(function (response) {
            // 	 $scope.account = response;
            // 	 $state.go('sitegen.site.request_for_proposal.send', { site: $currentSite.getSite().url });
            // }).catch(function (error) {
            // 	 $scope.account = null;
            // 	 $state.go('sitegen.site.login', { site: $currentSite.getSite().url, fromAction: 'FROM_ON_ASK_FOR_A_QUOTE_ACTION' });
            // 	 //console.log(error);
            // });
        };

        $scope.onAddToSelection = function (pageDetailName, company) {
            localStorage.setItem(PROVIDER_SESSION_STORAGE_KEY_PREFIX + company.id, JSON.stringify({
                id: company.id,
                page: pageDetailName,
                modelPattern: company.modelPattern,
                session: $cookies.get("SESSION_TOKEN")
            }));
            $scope.$broadcast('checkSelection');
        };

        $scope.onAddToSelectionPure = function (pageDetailName, company) {
            $scope.nbSelections = 0;
            for (var i = 0; i < localStorage.length; i++) {
                if (localStorage.key(i).substring(0, 9) === PROVIDER_SESSION_STORAGE_KEY_PREFIX) {
                    try {
                        var _item = JSON.parse(localStorage.getItem(localStorage.key(i)));
                        if (_item.id && localStorage.key(i) === PROVIDER_SESSION_STORAGE_KEY_PREFIX + _item.id) {
                            $scope.nbSelections++;
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            }
            if ($scope.nbSelections > 4) {
                toastr.error($filter('translate')('SITE_GEN.NB_SELECTIONS_ERROR'));
            } else {
                localStorage.setItem(PROVIDER_SESSION_STORAGE_KEY_PREFIX + company.id, JSON.stringify({
                    id: company.id,
                    page: pageDetailName,
                    modelPattern: company.modelPattern,
                    session: $cookies.get("SESSION_TOKEN")
                }));
                $scope.$broadcast('checkSelection');
            }
        };

        $scope.onGetSessionStorageItem = function (company) {
            if (company != null) {
                return localStorage.getItem(PROVIDER_SESSION_STORAGE_KEY_PREFIX + company.id);
            } else {
                return null;
            }
			/*if($cookies.get("SESSION_TOKEN") !== undefined && localStorage.getItem(PROVIDER_SESSION_STORAGE_KEY_PREFIX + company.id)) {
				var item = JSON.parse(localStorage.getItem(PROVIDER_SESSION_STORAGE_KEY_PREFIX + company.id));
				if(item && item.session && item.session === $cookies.get("SESSION_TOKEN")) {
					return true;
				}
			}
			return false;*/
        }


        $scope.onDeleteFromSelection = function (company) {
            localStorage.removeItem(PROVIDER_SESSION_STORAGE_KEY_PREFIX + company.id);
            $scope.$broadcast('checkSelection');
        }

        $scope.onAskForAQuoteWithoutLogin = function () {
            $state.go('sitegen.site.request_for_proposal.send', { site: $currentSite.getSite().url });
        };

        $scope.goToMySelectionOfProviders = function () {
            $state.go('sitegen.site.my_selection_of_providers', { site: $currentSite.getSite().url });
        };

        $scope.goToUrl = function (url) {
            window.open(url, '_blank');
        };

        // COOKIE TOKEN
        function create_UUID() {
            var dt = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (dt + Math.random() * 16) % 16 | 0;
                dt = Math.floor(dt / 16);
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid;
        }
        if ($cookies.get("SESSION_TOKEN") === undefined) {
            $cookies.put("SESSION_TOKEN", create_UUID());
        }

    }
})();

(function () {
    'use strict';
  
    angular.module('sitegen.site').directive('dynamicCtrl', ['$compile', '$parse',function($compile, $parse) {
        return {
            restrict: 'A',
            terminal: true,
            priority: 10000,
            link: function(scope, elem) {
                var name = $parse(elem.attr('dynamic-ctrl'))(scope);
                elem.removeAttr('dynamic-ctrl');
                elem.attr('ng-controller', name);
                $compile(elem)(scope);
            }
        };
    }]);

    angular.module('sitegen.site').directive('compile', ['$compile', '$parse', function ($compile, $parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(
                    function (scope) {
                        // watch the 'compile' expression for changes
                        return scope.$eval(attrs.compile);
                    },
                    function (value) {
                        // when the 'compile' expression changes
                        // assign it into the current DOM
                        element.html(value);

                        // compile the new DOM and link it to the current
                        // scope.
                        // NOTE: we only compile .childNodes so that
                        // we don't get into infinite loop compiling ourselves
                        $compile(element.contents())(scope);
                    }
                );
            }
        };
    }]);

    angular.module('sitegen.site').directive('passwordConfirmDirective', [function () {
        return {
            restrict: 'A',
            scope: {
                matchTarget: '=',
            },
            require: 'ngModel',
            link: function link(scope, elem, attrs, ctrl) {
                var validator = function (value) {
                    ctrl.$setValidity('match', value === scope.matchTarget);
                    return value;
                }
                ctrl.$parsers.unshift(validator);
                ctrl.$formatters.push(validator);
                // This is to force validator when the original password gets changed
                scope.$watch('matchTarget', function(newval, oldval) {
                    validator(ctrl.$viewValue);
                });
            }
        };
    }]);
  
})();
  
(function(){
	'use strict';

	angular.module('fuse').controller('confirmPopupController', confirmPopupController);

	function confirmPopupController($scope, $mdDialog, content){
		$scope.content = content;

		$scope.confirmAction = function(){
			$mdDialog.hide();
		};
		
		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};
	}

})();
(function () {
  'use strict';

  angular.module('app.front').service('packagesService', packagesService);

  function packagesService($q, $http) {
    var service = {};
    var url = '/api/rest/packages/';
    var publicUrl = '/api/public/sitegen/packages/';

    service.save = function (dto, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + 'save',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.get = function (filter, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + 'get',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filter
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findById = function (id, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + 'findById/' + id,
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.delete = function(id) {
      return $q(function (resolve, reject) {
        $http({
          url: url + 'delete/' + id,
          method: 'DELETE',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.publicGet = function(page, max, filter, siteId, lang){
      return $q(function (resolve, reject) {
        $http({
          url: publicUrl + 'filter',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang,
            'page': page,
            'max': max,
            'siteId': siteId
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filter
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findByIdPublic = function (id, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: publicUrl + id,
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang': lang,
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    return service;
  }
})();

(function () {
  'use strict';

  angular.module('app.front').controller('packagesController', packagesController);

  function packagesController($scope, $rootScope, $filter, packagesService, languageService, $mdDialog, $state, toastr) {
    $scope.regions = {};
    $scope.typesTourism = {};
    $scope.language = {};
    $scope.languages = [];
    var updateMode = false;
    $scope.loaded = true;
    $scope.filter = {
      region: null,
      typeTourisme: null,
      order: {
        name: null,
        inverse: false
      }
    };
    $scope.package = {};
    $scope.packages = [];

    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
      for (var i = 0; i < $scope.languages.length; i++) {
        var language = $scope.languages[i];
        if (language.preferred) {
          $scope.language.key = language.key;
          break;
        }
      }
    }).catch(function (error) {

    });

    $scope.initPackages = function () {
      $scope.loaded = false;
      packagesService.get($scope.filter, $scope.language.key).then(function (res) {
        if (res.data) {
          $scope.packages = res.data;
        }
        $scope.loaded = true;
      }).catch(function (err) {
        toastr.error($filter('translate')('PACKAGES.ERROR_GET_PACKAGES'));
        console.log(err);
      });
    };

    $scope.initPackages();

    $scope.goAdd = function (update) {
      $state.go('app.packages.add');
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.update = function (pack) {
      if (pack.id) {
        $state.go('app.packages.update', {
          id: pack.id
        });
      } else {
        toastr.error($filter('translate')('PACKAGES.ERROR_UPDATE_PACKAGE'));
      }
    };

    $scope.showPopUpDelete = function (pack, index) {
      $scope.packageToDelete = angular.copy(pack);
      $scope.indexToDelete = index;

      $mdDialog.show({
        templateUrl: 'app/main/popup/confirm.html',
        clickOutsideToClose: true,
        controller: 'confirmPopupController',
        locals: {
          content: {
            title: $filter('translate')('PACKAGES.POPUP_DELETE.TITLE'),
            message: $filter('translate')('PACKAGES.POPUP_DELETE.MESSAGE')
          }
        }
      }).then(function () {
        $scope.remove();
      }).catch(function () {});
    };

    $scope.remove = function () {
      packagesService.delete($scope.packageToDelete.id).then(function (res) {
        toastr.success($filter('translate')('PACKAGES.SUCCESS_DELETE'));
        $scope.packages.splice($scope.indexToDelete, 1);
      }).catch(function (err) {
        toastr.error($filter('translate')('PACKAGES.ERROR_DELETE'));
        console.log(err);
      });
    };

  }
})();

(function () {
  'use strict';

  angular.module('app.front').service('modelService', ['$q', '$http', function ($q, $http) {

    var fieldTypes = null;

    return {
      getFieldTypes: function () {
        return $q(function (resolve, reject) {
          if (fieldTypes != null) {
            resolve(fieldTypes);
          } else {
            $http({
              url: './api/rest/model/types',
              method: 'GET',
              params: {
                '_v': new Date().getTime()
              }
            }).then(function (response) {
              fieldTypes = response.data;
              resolve(fieldTypes);
            }).catch(function (error) {
              reject(error);
            });
          }
        });
      },

      getFieldSubTypes: function (_modelType) {
        return $q(function (resolve, reject) {
          $http({
            url: './api/rest/model/subTypes',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'modelType': _modelType
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (error) {
            reject(error);
          });
        });
      },

      listSelectFieldsFromSubType: function (subTypeId, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: './api/rest/model/' + subTypeId + '/selectFieldsSubType',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      listSelectFieldsFromType: function(type, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: './api/rest/model/' + type + '/selectFieldsType',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      getCategories: function (baseUrl, lang, eventId) {
        var event = null;
        if (eventId != null){
          event = eventId;
        }
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/category',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang,
              'eventId': event
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      getCategoriesOnly: function (baseUrl, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/only/category',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      getCategoriesOnlyBySubType: function (baseUrl, subTypeId, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/only/category/subtype/' + subTypeId,
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      saveCategory: function (category, baseUrl, lang, eventId) {
        var event = null;
        if (eventId != null){
          event = eventId;
        }
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/category',
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang': lang,
              'eventId': event
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: category,
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      updateCategory: function (category, baseUrl, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/category',
            method: 'PUT',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: category,
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      removeCategory: function (categoryId, baseUrl, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/category/' + categoryId,
            method: 'DELETE',
            params: {
              '_v': new Date().getTime(),
              lang: lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      listRequiredFields: function (baseUrl, lang, subTypeId) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/field/required',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang,
              'subTypeId': subTypeId
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      listLinkableField: function(baseUrl, lang){
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/field/common',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      listExportableField: function(baseUrl, subTypeId, lang){
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/field/exportable',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang,
              'subTypeId': subTypeId
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      listModifiableField: function (baseUrl, subTypeId, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/field/modifiable',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang,
              'subTypeId': subTypeId
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      listLinkedField: function (lang) {
        return $q(function (resolve, reject) {
          $http({
            url: '/api/public/sitegen/fields/linked',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      listAllFieldsByCategory: function (modelType, categoryId, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: './api/rest/model/' + modelType + '/field/category/' + categoryId,
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      listFieldsByType: function (modelType, lang, eventId) {
        var event = null;
        if (eventId != null){
          event = eventId;
        }
        return $q(function (resolve, reject) {
          $http({
            url: './api/rest/model/' + modelType + '/field/all',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang,
              'eventId': event
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      listFieldsBySubType: function (modelType, subTypeId, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: './api/rest/model/' + modelType + '/field/subtype/' + subTypeId,
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      listAllFields: function (lang) {
        return $q(function (resolve, reject) {
          $http({
            url: './api/rest/model/field/all',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      getPattern: function (baseUrl, lang, subTypeId) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/drawTokens',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              lang: lang,
              'subTypeId': subTypeId
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      savePattern: function (pattern, baseUrl, subTypeId) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/drawTokens',
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'subTypeId': subTypeId
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: pattern
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      getCategory: function (subTypeId, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: 'api/rest/model/category/' + subTypeId,
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      getDisplays: function (subTypeId, lang) {
        var url;
        if (subTypeId == null) {
          url = 'api/rest/model/display/';
        } else {
          url = 'api/rest/model/display/' + subTypeId;
        }
        return $q(function (resolve, reject) {
          $http({
            url: url,
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      getMultipleDisplays: function (subTypeIds, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: 'api/rest/model/display/multiple',
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang': lang,
              'ids': subTypeIds
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },


      postDisplay: function (dto, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: 'api/rest/model/display',
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: dto,
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      removeDisplay: function (subTypeId, id, lang) {
        var url;

        if (subTypeId == null) {
          url = 'api/rest/model/display/contact/' + id;
        } else {
          url = 'api/rest/model/display/' + subTypeId + '/' + id;
        }

        return $q(function (resolve, reject) {
          $http({
            url: url,
            method: 'DELETE',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      upDisplay: function (subTypeId, id, lang) {
        var url;

        if (subTypeId == null) {
          url = 'api/rest/model/display/up/contact/' + id;
        } else {
          url = 'api/rest/model/display/up/' + subTypeId + '/' + id;
        }
        return $q(function (resolve, reject) {
          $http({
            url: url,
            method: 'PUT',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      downDisplay: function (subTypeId, id, lang) {
        var url;

        if (subTypeId == null) {
          url = 'api/rest/model/display/down/contact/' + id;
        } else {
          url = 'api/rest/model/display/down/' + subTypeId + '/' + id;
        }

        return $q(function (resolve, reject) {
          $http({
            url: url,
            method: 'PUT',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      setIconDisplay: function(dto) {
        return $q(function (resolve, reject) {
            $http({
              url: 'api/rest/model/display/updateIcon',
              method: 'POST',
              params: {
                '_v': new Date().getTime()
              },
              headers: {
                'Content-Type': 'application/json;charset=UTF-8'
              },
              data: dto
            }).then(function (response) {
              resolve(response);
            }).catch(function (response) {
              reject(response);
            });
          });
      },

      upCategory: function (categoryId, baseUrl, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/category/up/' + categoryId,
            method: 'PUT',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      downCategory: function (categoryId, baseUrl, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/category/down/' + categoryId,
            method: 'PUT',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      saveField: function (field, baseUrl, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/field',
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: field,
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      updateField: function (field, baseUrl, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/field/' + field.id,
            method: 'PUT',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: field,
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      moveField: function (field, baseUrl, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/field/move',
            method: 'PUT',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: field,
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      activateField: function (fieldId, baseUrl, activated) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/field/activate/' + fieldId,
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'activated': activated
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },


      upField: function (fieldId, baseUrl, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/field/up/' + fieldId,
            method: 'PUT',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      downField: function (fieldId, baseUrl, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/field/down/' + fieldId,
            method: 'PUT',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      removeField: function (fieldId, baseUrl, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/field/' + fieldId,
            method: 'DELETE',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      saveSubType: function (dto, baseUrl, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/subtype',
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: dto
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      updateSubType: function (dto, baseUrl, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/subtype',
            method: 'PUT',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: dto
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      getSubType: function (baseUrl, lang, id) {
        return $q(function (resolve, reject) {
          var params = {
            '_v': new Date().getTime(),
            'lang': lang
          };
          $http({
            url: baseUrl + '/subtype/' + id,
            method: 'GET',
            params: params,
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      getSubTypes: function (baseUrl, lang, isActivated) {
        return $q(function (resolve, reject) {
          var params = {
            '_v': new Date().getTime(),
            'lang': lang
          };
          if (isActivated != null) {
            params.activated = isActivated;
          }
          $http({
            url: baseUrl + '/subtype',
            method: 'GET',
            params: params,
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      upSubType: function (subTypeId, baseUrl) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/subtype/up/' + subTypeId,
            method: 'PUT',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      downSubType: function (subTypeId, baseUrl) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/subtype/down/' + subTypeId,
            method: 'PUT',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      removeSubType: function (subTypeId, baseUrl) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/subtype/' + subTypeId,
            method: 'DELETE',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      listSpecifics: function (baseUrl, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/field/specific',
            method: 'GET',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      findSpecificByType: function(baseUrl, lang, specificType){
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/field/specific/'+specificType,
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      findSpecificsByMultipleTypes: function(baseUrl, lang, specificTypes){
        console.log(specificTypes);
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/field/specific/multiple',
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: specificTypes
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      findSpecificByTypePublic: function (lang, specificType) {
        return $q(function (resolve, reject) {
          $http({
            url: '/api/public/sitegen/fields/specific/' + specificType,
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      saveSpecifics: function (baseUrl, dto) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/field/specific',
            method: 'POST',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: dto
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      listColumnsDrawTokens: function (baseUrl, subTypeId, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/column/drawTokens',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang,
              'subTypeId': subTypeId
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      addFieldToColumnDrawToken: function (baseUrl, subTypeId, dto) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/column/drawTokens',
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'subTypeId': subTypeId
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: dto
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      deleteColumnDrawToken: function (baseUrl, id) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/column/drawTokens/' + id,
            method: 'DELETE',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      upFieldColumnDrawToken: function (baseUrl, id) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/column/drawTokens/up/' + id,
            method: 'PUT',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      downFieldColumnDrawToken: function (baseUrl, id) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/column/drawTokens/down/' + id,
            method: 'PUT',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      }




    };
  }]);

})();

(function(){
	'use strict';

	angular.module('app.front').filter('onlyRequired', function(){
		return function (items, required){
			var filtered = [];
			for (var i = 0; i < items.length; i++){
				if (!!required && items[i].required || !required){
					filtered.push(items[i]);
				}
			}
			return filtered;
		};
	});

	angular.module('app.front').filter('simpleTypeRequiredFilter', function(){
		return function(items){
			var filtered = [];
			angular.forEach(items, function(item){
				if (item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'MULTIPLE_SELECT' &&
				item.typeChamps !== 'BOOLEAN'){
					filtered.push(item);
				}
			});
			return filtered;
		};
	});

	angular.module('app.front').filter('typeFieldLinkFilter', function () {
		return function (items) {
			var filtered = [];
			angular.forEach(items, function (item) {
				if (item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' &&
					item.typeChamps !== 'BOOLEAN') {
					filtered.push(item);
				}
			});
			return filtered;
		};
	});
})();
(function(){
    'use strict';

    angular.module('app.front').directive('modelBuilder', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {
        return {
            restrict: 'E',
            scope: {
                modelType: '=modelType',
                baseUrl: '=baseUrl',
                categories: '=categories',
                parentId: '=parentId',
                level : '=level',
                language: '=language',
                helpModelTitle: '=helpModelTitle',
                helpModelContent: '=helpModelContent',
                eventId: '=eventId'
            },
            templateUrl: 'app/main/models/model.html',
            controller: 'modelCtrl',
            link: function (element, attrs) {
                return function (scope, element, attrs) { 
                    function compile() {
                        var content;
                        content = element.contents().remove();
                        var directive = $compile(content);
                        element.append(directive(scope, function ($compile) {
                            return $compile;
                        }));
                    }
                    scope.$watch('categories', function(){
                        compile();
                    });
                };
            }
        };
    }]);

    angular.module('app.front').directive('modelType', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {
        return {
            restrict: 'E',
            scope: {
                baseUrl: '=baseUrl',
                thisModel: '=thisModel',
                types: '=types',
                language: '=language',
            },
            templateUrl: 'app/main/models/type.html',
            controller: 'modelCtrl',
            link: function (element, attrs) {
                return function (scope, element, attrs) {
                    function compile() {
                        var content;
                        content = element.contents().remove();
                        var directive = $compile(content);
                        element.append(directive(scope, function ($compile) {
                            return $compile;
                        }));
                    }
                    scope.$watch('types', function () {
                        compile();
                    });
                };
            }
        };
    }]);
    
    angular.module('app.front').directive('drawTokenBuilder', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {
        return {
            restrict: 'E',
            scope: {
                baseUrl: '=baseUrl',
                modelType: '=modelType',
                drawTokenTitle: '=drawTokenTitle',
                helpDrawTokenTitle: '=helpDrawTokenTitle',
                helpDrawTokenContent: '=helpDrawTokenContent',
                language: '=language',
                subTypeId: '=subTypeId'
            },
            templateUrl: 'app/main/models/draw_token.html',
            controller: 'drawTokenCtrl',
            link: function (element, attrs) {
                
                return function (scope, element, attrs) {
                    function compile(){
                        var content;
                        content = element.contents().remove();
                        var directive = $compile(content);
                        element.append(directive(scope, function ($compile) {
                            return $compile;
                        }));
                    }
                    compile();
    
                    scope.simpleTypeRequiredFilter = function(field) {
                         return field.typeChamps !== 'USERS' && field.typeChamps !== 'MULTIPLE_SELECTION';
                    };
                    
                };
            }
        };
    }]);
    
    angular.module('app.front').directive('simpleModelBuilder', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {
        return {
            restrict: 'E',
            scope: {
                modelName: '=modelName',
                modelType: '=modelType',
                modelTitle: '=modelTitle',
                baseUrl: '=baseUrl',
                fields: '=fields',
                enumType : '@enumType',
                helpModelTitle: '=helpModelTitle'
            },
            templateUrl: 'app/main/models/simple_model.html',
            controller: 'simpleModelCtrl',
            compile: function (element, attrs) {
                var content, directive;
                content = element.contents().remove();
                return function (scope, element, attrs) {
                    var directive = $compile(content);
                    element.append(directive(scope, function ($compile) {
                        return $compile;
                    }));
                };
            }
        };
    }]);
    
    angular.module('app.front').directive('helpModelBuilder', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {
        return {
            restrict: 'E',
            scope: {
                helpModelTitle: '=helpModelTitle',
                helpModelContent: '=helpModelContent'
            },
            templateUrl: 'app/main/models/help_model.html'
        };
    }]);
    
    angular.module('app.front').directive('helpDrawTokenBuilder', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {
        return {
            restrict: 'E',
            scope: {
                helpDrawTokenTitle: '=helpDrawTokenTitle',
                helpDrawTokenContent: '=helpDrawTokenContent'
            },
            templateUrl: 'app/main/models/help_draw_token.html'
        };
    }]);

    angular.module('app.front').directive('nooInfosCategory', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {
        return {
            restrict: 'E',
            templateUrl: 'app/main/models/infos_category.html',
            scope: {
                category: '=ngModel',
                level: '=level',
                edition: '=edition',
                formName: '=formName',
                subType: '=subType',
                modelType: '=modelType',
                parent: '=?parent',
                abstractModel: '=model'
            },
            compile: function (element, attrs) {
                var content, directive;
                content = element.contents().remove();
                return function (scope, element, attrs) {
                    scope.nextLevel = scope.level + 1;
                    directive || (directive = $compile(content));
                    element.append(directive(scope, function ($compile) {
                        return $compile;
                    }));
                };
            }
        };
    }]);

    angular.module('app.front').directive('nooInput', function ($compile, $timeout, $parse, $filter, $window, URL, companyService, contactService, inscriptionService, logisticService) {

        var linker = function (scope, element, attrs) {
            if (scope.edition && (scope.model.typeChamps === 'FILE' || scope.model.typeChamps === 'IMAGE')){
                $timeout(function(){
                    var input = element[0].querySelector('#genericField_file_'+scope.model.id+'_'+scope.model.index);
                    angular.element(input).on('change', function(){
                        if (input.files != null){
                            if (scope.modelType === 'INSCRIPTION_MODEL'){
                                scope.$emit('inscriptionUpdated', {model: scope.model, inscription: scope.abstractModel});
                            }else{
                                scope.$emit('modelUpdated', {model: scope.model});
                            }
                        }
                    });

                });
            }
            
            if (scope.model.typeChamps === 'IMAGE'){
                if (scope.model.location != null && scope.model.location !== ''){
                    scope.model.src = URL.alternatedocroots + '/' + scope.model.location;
                }else{
                    scope.model.src = '';
                }
            }
            scope.download = function(){
                if (scope.modelType === 'COMPANY_MODEL'){
                    $window.location.href = companyService.downloadValuedFile(scope.model.id);
                }
                if (scope.modelType === 'CONTACT_MODEL'){
                    $window.location.href = contactService.downloadValuedFile(scope.model.id);
                }
                if (scope.modelType === 'INSCRIPTION_MODEL'){
                    $window.location.href = inscriptionService.downloadValuedFile(scope.model.id, scope.abstractModel.id);
                }
                if (scope.modelType === 'LOGISTIC_MODEL'){
                    $window.location.href = logisticService.downloadValuedFile(scope.model.id, scope.abstractModel.id);
                }
            };
            if (scope.edition){
                scope.$watch('model', function(newModel, oldModel){
                    if (newModel.value !== oldModel.value || newModel.values !== oldModel.values || newModel.dateTime != null){
                        /* LIVE UPDATE */
                        if (scope.modelType === 'INSCRIPTION_MODEL'){
                            scope.$emit('inscriptionUpdated', {model: scope.model, inscription: scope.abstractModel});
                        }else{
                            scope.$emit('modelUpdated', {model: scope.model});
                        }
                    }
                }, true);
            }
        };



        return {
            restrict: 'E',
            replace: true,
            link: linker,
            templateUrl: 'app/main/models/input.html',
            scope: {
                content: '@',
                index: '@',
                model: '=ngModel',
                edition: '=edition',
                formName: '=',
                init: '&initFn',
                subType: '=subType',
                bigDisplayArea: '=',
                modelType: '=modelType',
                abstractModel: '=model'
            }
        };
    });

    angular.module('app.front').directive('nooInfosModel', ['$compile', '$filter', 'toastr', function ($compile, $filter, toastr) {
        return {
            restrict: 'E',
            templateUrl: 'app/main/models/infos_model.html',
            scope: {
                categories: '=ngModel',
                edition: '=edition',
                formName: '=formName',
                subType: '=subType',
                modelType: '=modelType',
                subTypes: '=subTypes',
                model: '=model'
            },
            controller: 'infosModelCtrl',
            compile: function (element, attrs) {
                var content, directive;
                content = element.contents().remove();
                return function (scope, element, attrs) {

                    directive || (directive = $compile(content));
                    element.append(directive(scope, function ($compile) {
                        return $compile;
                    }));
                };
            }
        };
    }]);
})();

	(function () {
	  'use strict';

	  angular.module('app.front').controller('modelCtrl',
	    function ($rootScope, $scope, $http, $state, $filter, $timeout, $mdDialog, toastr, modelService) {
				$scope.loaded = false;

				$scope.$on('categoriesLoaded', function(){
					$scope.loaded = true;
				});
	      $scope.newType = {};

	      window.mdSelectOnKeyDownOverride = function (event) {
	        event.stopPropagation();
	      };

	      $scope.newCategory = {
	        size: 100
	      };

	      modelService.getFieldTypes().then(function (data) {
	        $scope.enumTypes = data;
	      }).catch(function (error) {
	        $scope.enumTypes = [];
	        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	      });
	      if ($scope.modelType === 'COMPANY_MODEL') {
	        modelService.getSubTypes($scope.baseUrl, $scope.language.key, null).then(function (response) {
	          //TYPE DE SOCIETE
	          $scope.types = response.data;
	        }).catch(function () {
	          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	        });

	      }

	      $scope.refreshRequiredFields = function (withPattern) {
	        modelService.listRequiredFields($scope.baseUrl, $scope.language.key).then(function (response) {
	          $rootScope.$broadcast('ChampsListRequired', response.data);
	          if (withPattern) {
	            modelService.getPattern($scope.baseUrl, $scope.language.key).then(function (response) {
	              $rootScope.$broadcast('DrawTokenList', response.data);
	            }).catch(function (response) {
	              toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	            });
	          }
	        }).catch(function (response) {
	          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	        });
	      };

	      $scope.saveCategory = function (form) {
	        if (!!$scope.newCategory.name && $scope.newCategory.name !== '') {
	          $scope.newCategory.index = $scope.categories.length + 1;
	          if (!angular.isUndefined($scope.parentId)) {
	            $scope.newCategory.parentId = $scope.parentId;
	          }
	          modelService.saveCategory($scope.newCategory, $scope.baseUrl, $scope.language.key, $scope.eventId).then(function (response) {
	            toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_ADD_CAT'));
	            $scope.newCategory.id = response.data;
	            $scope.newCategory.fields = [];
	            $scope.categories.push(angular.copy($scope.newCategory));
	            $scope.newCategory = {
	              size: 100
	            };
	            form.$setUntouched();
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }
	      };

	      $scope.updateCategory = function (category) {
	        if (!!category.name && category.name !== '') {
	          modelService.updateCategory(category, $scope.baseUrl, $scope.language.key).then(function (response) {
	            toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE_CAT'));
	            category.active = false;
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }
	      };

	      $scope.removeCategory = function (index, category) {
	        var content = {
	          title: $filter('translate')('SETTINGS.DATABASE.MODELS.DELETE_CAT'),
	          message: $filter('translate')('SETTINGS.DATABASE.MODELS.CONFIRM_DELETE_CAT')
	        };
	        $rootScope.openConfirmPopup(content).then(function () {
	          $rootScope.$broadcast('HandDrawTokenList');
	          modelService.removeCategory(category.id, $scope.baseUrl, $scope.language.key).then(function (response) {
	            toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_DELETE_CAT'));
	            $scope.categories = response.data;
	            $scope.refreshRequiredFields(true);
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }).catch(function () {

	        });
	      };

	      $scope.upCategory = function (category) {
	        if (category.index > 1) {
	          modelService.upCategory(category.id, $scope.baseUrl, $scope.language.key).then(function (response) {
	            $scope.categories = response.data;
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }
	      };

	      $scope.downCategory = function (category) {
	        if (category.index !== $scope.categories.length) {
	          modelService.downCategory(category.id, $scope.baseUrl, $scope.language.key).then(function (response) {
	            $scope.categories = response.data;
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }
	      };

	      $scope.addItemToFieldListType = function (item, list) {
	        list.push({
	          value: angular.copy(item.value),
	          index: list.length + 1
	        });
	      };

	      $scope.removeItemFromFieldListType = function (item, list) {
					var initialIndex = 1;
					for (var i = 0; i<list.length; i++){
						if (list[i].index === item.index){
							list.splice(i, 1);
							break;
						}
					}
	        angular.forEach(list, function (item, thisIndex) {
	          item.index = initialIndex;
	          initialIndex++;
	        });
	      };

	      $scope.upFieldListTypeItem = function (item, list) {
	        var isDone;
	        angular.forEach(list, function (_item) {
	          if (!isDone && _item.index === item.index - 1) {
	            item.index = angular.copy(_item.index);
	            _item.index = angular.copy(_item.index + 1);
	            isDone = true;
	          }
	        });
	      };

	      $scope.downFieldListTypeItem = function (item, list) {
	        var isDone;
	        angular.forEach(list, function (_item) {
	          if (!isDone && _item.index === item.index + 1) {
	            _item.index = angular.copy(item.index);
	            item.index = angular.copy(item.index + 1);
	            isDone = true;
	          }
	        });
	      };

	      $scope.saveChamps = function (category, form) {
	        if (category.newChamps.libelle && category.newChamps.libelle !== '') {
	          category.newChamps.index = category.fields.length + 1;
	          modelService.saveField(category.newChamps, $scope.baseUrl, $scope.language.key).then(function (response) {
	            toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_ADD_FIELD'));
	            if (category.newChamps.typeChamps === 'MULTIPLE_SELECT' || category.newChamps.typeChamps === 'LIST_SELECT') {
	              category.newChamps.id = response.data.id;

	              for (var i = 0; i < category.newChamps.listFieldsDTO.length; i++) {
	                for (var j = 0; j < response.data.listFieldsDTO.length; j++) {
	                  if (response.data.listFieldsDTO[j].index === category.newChamps.listFieldsDTO[i].index) {
	                    category.newChamps.listFieldsDTO[i].id = response.data.listFieldsDTO[j].id;
	                    break;
	                  }
	                }
	              }
	            } else {
	              category.newChamps.id = response.data;
	            }

	            category.newChamps.activated = true;
	            category.fields.push(angular.copy(category.newChamps));
	            if (category.newChamps.required) {
	              $scope.refreshRequiredFields(false);
	            }
	            category.newChamps = {
	              idCategory: category.id,
	              typeChamps: 'STRING',
	              listFieldsDTO: [],
	              modelType: $scope.modelType,
	              size: 100
	            };
	            if (!angular.isUndefined($scope.enumSubTypes)) {
	              if ($scope.enumSubTypes.length !== 0) {
	                category.newChamps.fieldSubType = $scope.enumSubTypes[0].type;
	              }
	            }
	            form.$setUntouched();
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }
	      };

	      $scope.enabledFieldUpdating = function (champs) {
	        $scope.champsTmp = angular.copy(champs);
	        champs.active = true;
	      };

	      $scope.cancelFieldUpdating = function (id, champsList) {
	        var _found = false;
	        angular.forEach(champsList, function (item, index) {
	          if (!_found && item.id === id) {
	            champsList[index] = angular.copy($scope.champsTmp);
	            _found = true;
	          }
	        });
	      };

	      $scope.updateChamps = function (champs) {
	        $rootScope.$broadcast('HandDrawTokenList');
	        if (champs.libelle && champs.libelle !== '' && champs.id) {
	          modelService.updateField(champs, $scope.baseUrl, $scope.language.key).then(function (response) {
	            if (champs.typeChamps === 'MULTIPLE_SELECT' || champs.typeChamps === 'LIST_SELECT') {
	              for (var i = 0; i < champs.listFieldsDTO.length; i++) {
	                for (var j = 0; j < response.data.listFieldsDTO.length; j++) {
	                  if (response.data.listFieldsDTO[j].index === champs.listFieldsDTO[i].index) {
	                    champs.listFieldsDTO[i].id = response.data.listFieldsDTO[j].id;
	                    break;
	                  }
	                }
	              }
	            }
	            toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE_FIELD'));
	            champs.active = false;
	            $scope.refreshRequiredFields(true);
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }
	      };

	      $scope.upChamps = function (category, champs) {
	        if (champs.index > 1) {
	          modelService.upField(champs.id, $scope.baseUrl, $scope.language.key).then(function (response) {
	            category.fields = response.data;
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }
	      };

	      $scope.downChamps = function (category, champs) {
	        if (champs.index < category.fields.length) {
	          modelService.downField(champs.id, $scope.baseUrl, $scope.language.key).then(function (response) {
	            category.fields = response.data;
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }
	      };

	      $scope.openMoveChamps = function (category, champs) {
	        $mdDialog.show({
	          templateUrl: 'app/main/models/move_field.html',
	          controller: 'moveFieldController',
	          clickOutsideToClose: true,
	          locals: {
	            category: category,
	            champs: champs,
	            properties: {
	              baseUrl: $scope.baseUrl,
	              lang: $scope.language.key
	            }
	          }
	        }).then(function () {
	          $scope.$emit('refreshCategories');
	        }).catch(function () {

	        });
	      };

	      $scope.removeChamps = function (category, champs) {
	        var content = {
	          title: $filter('translate')('SETTINGS.DATABASE.MODELS.DELETE_FIELD'),
	          message: $filter('translate')('SETTINGS.DATABASE.MODELS.CONFIRM_DELETE_FIELD')
	        };
	        $rootScope.openConfirmPopup(content).then(function () {
	          $rootScope.$broadcast('HandDrawTokenList');
	          modelService.removeField(champs.id, $scope.baseUrl, $scope.language.key).then(function (response) {
	            category.fields = response.data;
	            $scope.refreshRequiredFields(true);
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }).catch(function () {

	        });

	      };

	      $scope.activateChamps = function (champsId, activated) {
	        modelService.activateField(champsId, $scope.baseUrl, activated).then(function (response) {

	        }).catch(function (response) {

	        });
	      };


	      $scope.saveType = function () {
	        $scope.newType.index = $scope.types.length + 1;
	        modelService.saveSubType($scope.newType, $scope.baseUrl, $scope.language.key).then(function (response) {
	          $scope.newType.id = response.data;
	          $scope.types.push(angular.copy($scope.newType));
	          $scope.newType = {};
	          $scope.$emit('refreshCompanyTypes');
	        }).catch(function (response) {

	        });
	      };

	      $scope.updateType = function (type) {
	        modelService.updateSubType(type, $scope.baseUrl, $scope.language.key).then(function (response) {
	          type.active = false;
	          $scope.$emit('refreshCompanyTypes');
	        }).catch(function (response) {

	        });
	      };

	      $scope.upType = function (type) {
	        if (type.index > 1) {
	          modelService.upSubType(type.id, $scope.baseUrl, $scope.language.key).then(function (response) {
	            $scope.types = response.data;
	            $scope.$emit('refreshCompanyTypes');
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }
	      };

	      $scope.downType = function (type) {
	        if (type.index !== $scope.types.length) {
	          modelService.downSubType(type.id, $scope.baseUrl, $scope.language.key).then(function (response) {
	            $scope.types = response.data;
	            $scope.$emit('refreshCompanyTypes');
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }
	      };

	      $scope.removeType = function (index, type) {
	        var content = {
	          title: $filter('translate')('SETTINGS.DATABASE.TYPES.DELETE'),
	          message: $filter('translate')('SETTINGS.DATABASE.TYPES.CONFIRM_DELETE')
	        };
	        $rootScope.openConfirmPopup(content).then(function () {
	          modelService.removeSubType(type.id, $scope.baseUrl).then(function (response) {
	            $scope.types.splice(index, 1);
	            toastr.success($filter('translate')('SETTINGS.DATABASE.TYPES.SUCCESS_DELETE'));
	            $scope.$emit('refreshCompanyTypes');
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }).catch(function () {

	        });
	      };

	      $scope.filterConfig = function (subType) {
	        $state.go("app.database.types.research_page_creation", {
	          modelType: $scope.thisModel,
	          subTypeId: subType.id
	        });
	      };

	    });

	  angular.module('app.front').controller('simpleModelCtrl',
	    function ($rootScope, $scope, $http, $state, $filter, $timeout, toastr, modelService) {

	      $scope.newField = {};
	      $scope.showHelp = false;

	      $scope.saveField = function () {
	        if ($scope.newField.libelle && $scope.newField.libelle !== '') {
	          $scope.newField.index = $scope.fields.length + 1;
	          $scope.newField.fieldSubType = $scope.enumType;
	          modelService.saveField($scope.newField, $scope.baseUrl).then(function (response) {
	            toastr.success($scope.modelName + ' créé!');
	            if ($scope.newField.typeChamps === 'MULTIPLE_SELECT' || $scope.newField.typeChamps === 'LIST_SELECT') {
	              $scope.newField.id = response.data.id;

	              for (var i = 0; i < $scope.newField.listFieldsDTO.length; i++) {
	                for (var j = 0; j < response.data.listFieldsDTO.length; j++) {
	                  if (response.data.listFieldsDTO[j].index === $scope.newField.listFieldsDTO[i].index) {
	                    $scope.newField.listFieldsDTO[i].id = response.data.listFieldsDTO[j].id;
	                    break;
	                  }
	                }
	              }
	            } else {
	              $scope.newField.id = response.data;
	            }
	            $scope.fields.push(angular.copy($scope.newField));
	            $scope.newField = {};
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }
	      };

	      $scope.updateField = function (field) {
	        if (field.libelle && field.libelle !== '' && field.id) {
	          modelService.updateField(field.id, $scope.baseUrl).then(function (response) {
	            toastr.success($scope.modelName + ' modifié!');
	            if (field.typeChamps === 'MULTIPLE_SELECT' || field.typeChamps === 'LIST_SELECT') {
	              for (var i = 0; i < field.listFieldsDTO.length; i++) {
	                for (var j = 0; j < response.data.listFieldsDTO.length; j++) {
	                  if (response.data.listFieldsDTO[j].index === field.listFieldsDTO[i].index) {
	                    field.listFieldsDTO[i].id = response.data.listFieldsDTO[j].id;
	                    break;
	                  }
	                }
	              }
	            }
	            field.active = false;
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }
	      };

	      $scope.upField = function (field) {
	        if (field.index > 1) {
	          modelService.upField(field.id, $scope.baseUrl).then(function (response) {
	            $scope.fields = response.data;
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }
	      };

	      $scope.downField = function (field) {
	        if (field.index < $scope.fields.length) {
	          modelService.downField(field.id, $scope.baseUrl).then(function (response) {
	            $scope.fields = response.data;
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }
	      };

	      $scope.removeField = function (field) {
	        modelService.removeField(field.id, $scope.baseUrl).then(function (response) {
	          $scope.fields = response.data;
	        }).catch(function (response) {
	          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	        });
	      };
	    });

	  angular.module('app.front').controller('drawTokenCtrl',
	    function ($rootScope, $scope, $http, $state, $filter, $timeout, toastr, modelService) {

	      $scope.handUser = true;
	      $scope.updateRequireToken = true;
	      $scope.tokensModified = false;
	      $scope.champsListRequired = [];
	      $scope.drawTokenList = [];

	      $rootScope.$on('HandDrawTokenList', function (event, data) {
	        $scope.handUser = false;
	        $scope.updateRequireToken = false;
	      });

	      $rootScope.$on('ChampsListRequired', function (event, data) {
	        $scope.champsListRequired = data;
	      });

	      $rootScope.$on('DrawTokenList', function (event, data) {
	        $scope.drawTokenList = data;
	      });

	      $scope.initDrawToken = function () {
	        if ($scope.language != null && $scope.language.key != null) {
	          if ($scope.subTypeId != null) {
	            modelService.listFieldsBySubType($scope.modelType, $scope.subTypeId, $scope.language.key).then(function (response) {
	              $scope.champsListRequired = response.data;
	            }).catch(function (response) {
	              toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	            });
	          } else {
	            modelService.listRequiredFields($scope.baseUrl, $scope.language.key).then(function (response) {
	              $scope.champsListRequired = response.data;
	            }).catch(function (response) {
	              toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	            });
	          }


	          modelService.getPattern($scope.baseUrl, $scope.language.key, $scope.subTypeId).then(function (response) {
	            $scope.drawTokenList = response.data;
	          }).catch(function (response) {
	            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	          });
	        }
	      };
	      $scope.$watch('language.key', function () {
	        $scope.initDrawToken();
	      });


	      $scope.addPatternToken = function () {
	        $scope.tokensModified = true;
	        $scope.drawTokenList.push({
	          prefix: '',
	          suffix: '',
	          index: $scope.drawTokenList.length
	        });
	      };

	      $scope.calculatedPattern = function () {
	        if (!$scope.drawTokenList || $scope.drawTokenList.length < 1) {
	          return 'AUCUN';
	        }
	        var pattern = '';
	        var sortedList = $filter('orderBy')($scope.drawTokenList, 'index', false);
	        for (var i = 0; i < sortedList.length; i++) {
	          var field = sortedList[i].field != null && sortedList[i].field ? sortedList[i].field.libelle : '';
	          pattern = pattern + sortedList[i].prefix + field + sortedList[i].suffix;
	        }
	        return pattern;
	      };

	      $scope.changeElement = function () {
	        if ($scope.handUser && $scope.updateRequireToken) {
	          $scope.tokensModified = true;
	        }
	        $scope.updateRequireToken = true;
	        $scope.handUser = true;
	      };

	      $scope.saveDrawTokens = function () {
	        modelService.savePattern($scope.drawTokenList, $scope.baseUrl, $scope.subTypeId).then(function (response) {
	          toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_ADD_PATTERN'));
	          $scope.tokensModified = false;
	        }).catch(function (response) {
	          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	        });
	      };

	      $scope.cancelModifTokens = function () {
	        modelService.getPattern($scope.baseUrl, $scope.language.key, $scope.subTypeId).then(function (response) {
	          $scope.drawTokenList = response.data;
	          $scope.tokensModified = false;
	        }).catch(function (response) {
	          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	        });
	      };

	      $scope.deleteToken = function (index) {
	        $scope.tokensModified = true;
	        $scope.drawTokenList = $filter('orderBy')($scope.drawTokenList, 'index');
	        $scope.drawTokenList.splice(index, 1);
	        angular.forEach($scope.drawTokenList, function (drawToken, key) {
	          if (drawToken.index > index) {
	            drawToken.index--;
	          }
	        });
	      };

	    });

	  angular.module('app.front').controller('infosModelCtrl',
	    function ($rootScope, $scope, $http, $state, $filter, $timeout, $translate, $mdDialog, toastr, modelService, associationService, inscriptionStatusService, inscriptionSubCategoryService, SitesManagementService) {
	      var initSubTypes = function () {
	        //Présélectionner le type de société dans lequel on est (création d'une société)
	        if ($scope.model != null && angular.isArray($scope.subTypes) && !$scope.edition) {
	          for (var i = 0; i < $scope.subTypes.length; i++) {
	            if ($scope.subTypes[i].id === $scope.subType) {
	              $scope.model['type_' + $scope.subTypes[i].id] = true;
	              $scope.model.subTypesIds.push($scope.subTypes[i].id);
	              break;
	            }
	          }
	        }

	        //Présélectionner les types d'une société (modification d'une société)
	        if ($scope.edition && $scope.model != null && angular.isArray($scope.model.subTypesIds) && angular.isArray($scope.subTypes)) {
	          for (var j = 0; j < $scope.subTypes.length; j++) {
	            if ($scope.model.subTypesIds.lastIndexOf($scope.subTypes[j].id) > -1) {
	              $scope.model['type_' + $scope.subTypes[j].id] = true;
	            }
	          }
	        }
	      };

	      var checkRequired = function (categories) {
	        if (categories) {
	          for (var i = 0; i < categories.length; i++) {
	            if (!categories[i].required) {
	              var required = false;

	              for (var j = 0; j < categories[i].subCategories.length; j++) {
	                if (categories[i].subCategories[j].required) {
	                  required = true;
	                }
	              }

	              if (required) {
	                categories[i].required = true;
	              }
	            }
	          }
	        }
	      };

	      $scope.firstLevel = 0;
	      var categoriesUnfiltered = null;

	      var hideFields = function (categories) {
	        if (categories != null && $scope.model != null) {
	          for (var i = 0; i < categories.length; i++) {
	            var category = categories[i];
	            if (angular.isArray(category.subCategories)) {
	              hideFields(category.subCategories);
	            }
	            var required = false;

	            for (var j = 0; j < category.values.length; j++) {
	              var hide = true;

	              if (category.values[j].required) {
	                required = true;
	              }

	              if (category.values[j].subTypesIds == null || category.values[j].subTypesIds.length < 1) {
	                hide = false;
	              } else {
	                for (var k = 0; k < category.values[j].subTypesIds.length; k++) {
	                  if ($scope.model.subTypesIds.lastIndexOf(category.values[j].subTypesIds[k]) > -1) {
	                    hide = false;
	                    break;
	                  }
	                }
	              }
	              category.values[j].hide = hide;
	            }

	            if (required) {
	              category.required = true;
	            } else {
	              category.required = false;
	            }
	          }
	        }

	        checkRequired(categories);
	      };

	      var filterCategory = function (category) {
	        if (!angular.isUndefined(category.subCategories)) {
	          angular.forEach(category.subCategories, function (subCategory) {
	            filterCategory(subCategory);
	          });
	        }
	        if (category.values.length === 0) {
	          if (angular.isArray(category.subCategories) && category.subCategories.length > 0) {
	            var allIsEmpty = true;
	            angular.forEach(category.subCategories, function (subCategory) {
	              if (allIsEmpty && subCategory.values.length !== 0) {
	                allIsEmpty = false;
	              }
	            });
	            if (allIsEmpty) {
	              category.isEmpty = true;
	            }
	          } else {
	            category.isEmpty = true;
	          }
	        } else {
	          var allIsHided = true;
	          for (var i = 0; i < category.values.length; i++) {
	            if (!category.values[i].hide) {
	              allIsHided = false;
	            }
	          }
	          category.isEmpty = allIsHided;
	        }
	      };
	      $scope.updateSubTypes = function (type, fromInput) {
	        if ($scope.model['type_' + type.id]) {
	          $scope.model.subTypesIds.push(type.id);
	          if (fromInput && $scope.edition) {
	            /* LIVE UPDATE */
	            $scope.$emit('subTypeUpdated', {
	              model: $scope.model
	            });
	          }
	        } else {
	          if ($scope.model.subTypesIds.length === 1) {
							$scope.model['type_' + type.id] = true;
							if (fromInput){
								toastr.error($filter('translate')('COMPANIES.TYPE_REQUIRED'));
							}
	          } else {
	            var index = $scope.model.subTypesIds.lastIndexOf(type.id);
	            if (index > -1) {
	              $scope.model.subTypesIds.splice(index, 1);
	              if (fromInput && $scope.edition) {
	                /* LIVE UPDATE */
	                $scope.$emit('subTypeUpdated', {
	                  model: $scope.model
	                });
	              }
	            }
	          }
	        }
	      };

	      $scope.updateAssociation = function () {
	        $scope.$emit('associationUpdated', {
	          model: $scope.model
	        });
	      };

	      $scope.updateSite = function () {
	        $scope.$emit('siteUpdated', {
	          model: $scope.model
	        });
	      };

	      $scope.updateActive = function () {
	        /* LIVE UPDATE */
	        $scope.$emit('activatedUpdated', {
	          model: $scope.model
	        });
	      };

	      $scope.updateChecked = function () {
	        /* LIVE UPDATE */
	        $scope.$emit('checkedUpdated', {
	          model: $scope.model
	        });
				};
				
				$scope.updateSubCategory = function(){
					 /* LIVE UPDATE */
					 $scope.$emit('subCategoryUpdated', {
	          model: $scope.model
	        });
				};

				$scope.updateInscriptionStatus = function(){
					/* LIVE UPDATE */
					$scope.$emit('inscriptionStatusUpdated', {
					 model: $scope.model
				 });
			 };

	      if ($scope.subType != null && $scope.model != null) {
	        $scope.updateSubTypes({
	          id: $scope.subType
	        });
	      }

	      $scope.$watch('categories', function (newCategories) {
	        if (!angular.isUndefined(newCategories)) {
	          hideFields(newCategories);
	          if (!angular.isUndefined($scope.categories.subCategories)) {
	            angular.forEach($scope.categories.subCategories, function (subCategory) {
	              filterCategory(subCategory);
	            });
	          }
	          angular.forEach($scope.categories, function (category) {
	            filterCategory(category);
	          });
	        }
	      });

	      $scope.$on('refreshCategoriesDirective', function (event, data) {
	        $scope.categories = angular.copy(data);
	        hideFields($scope.categories);
	        if (!angular.isUndefined($scope.categories.subCategories)) {
	          angular.forEach($scope.categories.subCategories, function (subCategory) {
	            filterCategory(subCategory);
	          });
	        }
	        angular.forEach($scope.categories, function (category) {
	          filterCategory(category);
	        });
	      });

	      $scope.$watchGroup(['model', 'subTypes'], function () {
	        initSubTypes();
	        hideFields($scope.categories);
	      });

	      $scope.$watchCollection('model.subTypesIds', function () {
	        hideFields($scope.categories);
	      });

	      if ($scope.modelType === 'COMPANY_MODEL') {
	        associationService.findAll().then(function (response) {
	          $scope.associations = response.data;
	        }).catch(function () {

	        });
	        SitesManagementService.findAll('sites').then(function (response) {
	          $scope.sites = response.data;
	        }).catch(function () {

	        });
				}
				
				if ($scope.modelType === 'INSCRIPTION_MODEL'){
					inscriptionStatusService.list($translate.preferredLanguage()).then(function(response){
						$scope.inscriptionStatuses = response.data;
					}).catch(function(){
			
					});

					inscriptionSubCategoryService.list($translate.preferredLanguage()).then(function(response){
						$scope.subCategories = response.data;
					}).catch(function(){

					});
				}
	    });

	  angular.module('app.front').controller('moveFieldController', function ($rootScope, $scope, $mdDialog, $filter, category, champs, properties, toastr, modelService) {

	    $scope.currentCategory = angular.copy(category);
	    $scope.champs = angular.copy(champs);

	    modelService.getCategoriesOnly(properties.baseUrl, properties.lang).then(function (response) {
	      $scope.categories = response.data;
	    }).catch(function (response) {

	    });

	    $scope.update = function () {
	      modelService.moveField($scope.champs, properties.baseUrl, properties.lang).then(function (response) {
	        toastr.success($filter('translate')('SETTINGS.DATABASE.MODELS.MOVE_FIELD_SUCCESS'));
	        var update = {
	          oldCategoryId: champs.categoryId,
	          newCategoryId: $scope.champs.categoryId
	        };
	        $mdDialog.hide(update);
	      }).catch(function () {

	      });
	    };

	    $scope.hidePopup = function () {
	      $mdDialog.cancel();
	    };

	  });
	})();

(function () {
  'use strict';

  angular.module('app.front').controller('fieldsModelsController',
    function ($rootScope, $scope, $http, $state, $filter, $timeout, $mdDialog, toastr, modelService, STORAGE_PREFIX, DISPLAY_MODELS_ICONS) {
      $scope.category = {};
      $scope.fieldsAvalaible = [];
      $scope.fields = [];
      $scope.displaysModels = [];
      $scope.fieldToAdd = null;
      $scope.DISPLAY_MODELS_ICONS = DISPLAY_MODELS_ICONS;
      var dataReady = false;

      init();

      $scope.addField = function () {
        if (!$scope.fieldToAdd) {
          toastr.error('Vous devez sélectionner un champ à ajouter');
          return;
        }
        var dto = {
          categoryID: $state.params.categoryId,
          fieldModel: angular.copy($scope.fieldToAdd)
        };
        $scope.fieldToAdd = null;
        modelService.postDisplay(dto, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
          init();
        }).catch(function (err) {
          console.log(err);
          toastr.error('Erreur lors de l\'ajout du champs d\'affichage');
        });
      };

      $scope.removeField = function(field) {
        if (!field || !field.id || !field.categoryID) {
          toastr.error('Erreur avec ce champ, veuillez recharger la page SVP');
          return;
        }

        modelService.removeDisplay(field.categoryID, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function(res) {
          console.log($scope.category.fields);
          if (res.data) {
            $scope.displaysModels = res.data;
          }

          filterFields();
        }).catch(function(err) {
          console.log(err);
          toastr.error('Erreur lors de la suppression du champs d\'affichage');
        });
      };

      $scope.goUp = function (field) {
        if (!field || !field.id || !field.categoryID) {
          toastr.error('Erreur avec ce champ, veuillez recharger la page SVP');
          return;
        }

        modelService.upDisplay(field.categoryID, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function(res) {
          console.log($scope.category.fields);
          if (res.data) {
            $scope.displaysModels = res.data;
          }

          filterFields();
        }).catch(function(err) {
          console.log(err);
          toastr.error('Erreur lors de la suppression du champs d\'affichage');
        });
      };

      $scope.goDown = function (field) {
        if (!field || !field.id || !field.categoryID) {
          toastr.error('Erreur avec ce champ, veuillez recharger la page SVP');
          return;
        }

        modelService.downDisplay(field.categoryID, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function(res) {
          console.log($scope.category.fields);
          if (res.data) {
            $scope.displaysModels = res.data;
          }

          filterFields();
        }).catch(function(err) {
          console.log(err);
          toastr.error('Erreur lors de la suppression du champs d\'affichage');
        });
      };

      $scope.setIcon = function(field) {
        if (!field || !field.id) {
          toastr.error('Erreur avec ce champ, veuillez recharger la page SVP');
          return;
        }

        modelService.setIconDisplay(field).then(function(res) {

        }).catch(function(err) {
          toastr.error('Erreur lors du changement de l\'icône associée');
        });
      };

      function getCategory() {
        if ($state.params.categoryId) {
          modelService.getCategory($state.params.categoryId, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
            if (res.data) {
              $scope.category = res.data;
              $scope.fields = [];

              for (var i = 0; i < $scope.category.fields.length; i++) {
                $scope.fields.push($scope.category.fields[i]);
              }

              for (var i = 0; i < $scope.category.subCategories.length; i++) {
                for (var y = 0; y < $scope.category.subCategories[i].fields.length; y++) {
                  $scope.fields.push($scope.category.subCategories[i].fields[y]);
                }
              }
            }

            if (dataReady) {
              filterFields();
            } else {
              dataReady = true;
            }
            console.log(res.data);
          }).catch(function (err) {
            console.log(err);
            toastr.error('Erreur lors de la récupération de la catgorie');
          });
        } else {
          $state.go('app.database.contactsSettings');
        }

      }

      function getDisplays() {
        modelService.getDisplays($state.params.categoryId, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
          if (res.data) {
            $scope.displaysModels = res.data;
          }

          if (dataReady) {
            filterFields();
          } else {
            dataReady = true;
          }
          console.log(res.data);
        }).catch(function (err) {
          console.log(err);
          toastr.error('Erreur lors de la récupération de la catgorie');
        });
      }

      function filterFields() {
        $scope.fieldsAvalaible = [];
        if ($scope.fields) {
          for (var i = 0; i < $scope.fields.length; i++) {
            $scope.fields[i].alreadyHere = false;
            for (var j = 0; j < $scope.displaysModels.length; j++) {
              if ($scope.fields[i].id === $scope.displaysModels[j].fieldModel.id) {
                $scope.fields[i].alreadyHere = true;
              }
            }
            if (!$scope.fields[i].alreadyHere) {
              $scope.fieldsAvalaible.push(angular.copy($scope.fields[i]));
            }
          }

          console.log($scope.fieldsAvalaible);
        } else {
          toastr.error('Aucun champ n\'est disponible sur ce modèle');
        }

        dataReady = false;
      }

      function init() {
        getCategory();
        getDisplays();
      }
    });
})();

(function () {
  'use strict';

  angular.module('app.front').service('MessageService', ['$q', '$http', function ($q, $http) {
    var baseUrl = './api/rest/message';
    return {
      saveMessage: function (message) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl,
            method: 'POST',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: message
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findAllMessage: function (messageFilter,lang, page, max) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+"/findAll",
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang' : lang,
              'page': page,
              'max': max
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: messageFilter
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      confirmAction: function (action) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + "/confirm",
            method: 'POST',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: action
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findMessageByDay : function (dateStart, dateEnd, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + "/day",
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang' : lang,
              'dateStart' : dateStart,
              'dateEnd' : dateEnd
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findMessageNotDone : function (sorting, lang, actionPast) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + "/notDone",
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang,
              'sorting': sorting,
              'output': 10,
              'actionPast': actionPast
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      notificationAction : function (listOlderMessages,lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + "/poll",
            method: "POST",
            params: {'_v': new Date().getTime(), 'lang': lang},
            data : listOlderMessages
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            console.log("#### RESPONSE #####");
            console.log(response);
            if(response.data != null){
              reject(response);
            }
          });
        });
      },
      notifySenderActionsDone : function (lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + "/notifySenderActionsDone",
            method: "GET",
            params: {'_v': new Date().getTime(), 'lang': lang}
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            if(response.data != null){
              reject(response);
            }
          });
        });
      },
      findAllPaginated : function (page, max, lang){
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl ,
            method: 'GET',
            params: { '_v': new Date().getTime(), 'lang': lang, 'page': page, 'max': max },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            if (response.data != null) {
              reject(response);
            }
          });
        });
      },
      bulk : function (dto, modelType, subTypeId){
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/bulk',
            method: 'POST',
            params: { '_v': new Date().getTime(), 'modelType': modelType, 'subTypeId': subTypeId },
            data: dto
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            if (response.data != null) {
              reject(response);
            }
          });
        });
      }
    };
  }]);

})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('MessageController', MessageController);

  /** @ngInject */
  function MessageController($scope, $translate, userService, DISPLAY_MODELS_ICONS, SettingsMessageService, msNavigationService, STORAGE_PREFIX, MessageService, $filter, $rootScope, $mdDialog) {
    $scope.users = [];
    $scope.actions = [];
    $scope.page = 0;
    $scope.max = 20;
    $scope.message = {
      actionForm: null,
      receiverForm: null
    };
    $scope.filter = {
      sender: null,
      action: null
    };
    $scope.infiniteScrollPrevent = false;
    $scope.messages = [];

    $scope.typeAction = {
      ALL: "ALL",
      TO_DO: "TO_DO",
      DONE: "DONE"
    };
    $scope.showForm = false;

    $scope.iconsDisplay = {};
    angular.forEach(DISPLAY_MODELS_ICONS, function (elt) {
      $scope.iconsDisplay[elt.name] = elt.value;
    });

    $scope.findAllUsers = function () {
      userService.findAllUsers().then(function (users) {
        $scope.users = users.data;
      }).catch(function (data) {

      });
    };

    $scope.findAllUsers();


    $scope.findAllActions = function () {
      SettingsMessageService.findAllAction(localStorage[STORAGE_PREFIX + 'language']).then(function (actions) {
        $scope.actions = actions.data;
      }).catch(function (data) {

      });
    };

    $scope.findAllActions();


    $scope.saveMessage = function () {
      if ($scope.message.actionForm != null) {
        $scope.message.dateAction = moment($scope.message.startDateForm).set('hours', $scope.message.startTime.split(':')[0]).set('minutes', $scope.message.startTime.split(':')[1]).toDate().getTime();
        if (!$scope.message.actionDone) {
          $scope.message.actionDone = false;
        }
        $scope.message.action = angular.fromJson($scope.message.actionForm);
      }

      if ($scope.message.receiverForm != null && $scope.message.receiverForm != "null") {
        $scope.message.receiver = angular.fromJson($scope.message.receiverForm);
        $scope.message.receiverID = angular.fromJson($scope.message.receiverForm).id;
      } else {
        $scope.message.receiverID = null;
      }

      MessageService.saveMessage($scope.message).then(function (data) {
        $scope.findAllMessages(true);
        $scope.cancelFormMessage();
        $mdDialog.hide();
      }).catch(function (data) {

      });
    };

    $scope.findAllMessages = function (reset) {
      if (!$scope.infiniteScrollPrevent){
        
        $scope.infiniteScrollPrevent = true;
        if (reset){
          $scope.messages = [];
          $scope.page = 0;
        }
        switch ($scope.filter.action) {
          case null:
            delete $scope.filter.actionToDo;
            $scope.filter.actionExist = false;
            break;
          case $scope.typeAction.ALL:
            delete $scope.filter.actionToDo;
            $scope.filter.actionExist = true;
            break;
          case $scope.typeAction.DONE:
            $scope.filter.actionToDo = false;
            break;
          case $scope.typeAction.TO_DO:
            $scope.filter.actionToDo = true;
            break;
          default:
            break;
        }
        $scope.filter.addressee = [];
        angular.forEach($scope.filter.receiverForm, function (item, key) {
          $scope.filter.addressee.push(angular.fromJson(item));
        });
        
        MessageService.findAllMessage($scope.filter, $translate.preferredLanguage(), $scope.page, $scope.max).then(function (messages) {
          if (messages.data != null && messages.data.length > 0){
            $scope.messages = $scope.messages.concat(messages.data);
            $scope.infiniteScrollPrevent = false;
          }
          $scope.page++;
          //Delete badge
          if (userService.isUserHasNonReadMsg()) {
            msNavigationService.saveItem('message', {
              title: 'Message',
              state: 'app.message',
              translate: 'MESSAGE.TITLE',
              weight: 2,
              badge: null,
              hidden : function() {
                  return !userService.isUserAdmin();
              }
            });
          }
        }).catch(function (data) {
  
        });
      }
    };
    $scope.findAllMessages(true);

    $scope.cancelFormMessage = function () {
      $scope.message = {
        actionForm: null,
        receiverForm: null
      };
      $mdDialog.hide();
    };

    $scope.confirmAction = function (action) {
      var content = {
        title: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL_TITLE') : $filter('translate')('MESSAGE.ACTION_CONFIRM_TITLE'),
        message: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL') : $filter('translate')('MESSAGE.ACTION_CONFIRM')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        action.actionDone = !action.actionDone;
        MessageService.confirmAction(action).then(function (data) {}).catch(function (data) {});
      }).catch(function () {

      });
    };

    $scope.showPopUpMessage = function () {
      $scope.message = {
        actionForm: null,
        receiverForm: null
      };

      for (var i = 0; i < $scope.users.length; i++) {
        if ($scope.users[i].id === $rootScope.user.id) {
          $scope.message.receiverForm = angular.toJson($scope.users[i]);
          break;
        }
      }

      var now = new Date();
      $scope.message.startDateForm = now;
      $scope.message.startTime = (now.getHours() < 10 ? '0' + now.getHours() : now.getHours()) + ':' + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes());

      $mdDialog.show({
        templateUrl: 'app/main/message/popup/update_message.html',
        preserveScope: true,
        clickOutsideToClose: true,
        scope: $scope,
      }).then(function () {

      }).catch(function () {

      });
    };

    $scope.updateMessage = function (message) {
      $scope.message = angular.copy(message);
      if (message.action != null) {
        var actionID = angular.copy(message.action.actionID);
        angular.forEach($scope.actions, function (action) {
          if (action.id === actionID) {
            $scope.message.actionForm = angular.toJson(action);
          }
        });
      } else {
        $scope.message.actionForm = null;
      }

      if (message.receiver != null) {
        var receiverID = angular.copy(message.receiver.id);
        angular.forEach($scope.users, function (user) {
          if (user.id === receiverID) {
            $scope.message.receiverForm = angular.toJson(user);
          }
        });
      } else {
        $scope.message.receiverForm = 'null';
      }

      if (message.action != null && message.action.dateAction != null) {
        var date = new Date(message.action.dateAction);

        $scope.message.startDateForm = date;
        console.log(date);
        $scope.message.startTime = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      } else {
        var now = new Date();
        $scope.message.startDateForm = now;
        $scope.message.startTime = (now.getHours() < 10 ? '0' + now.getHours() : now.getHours()) + ':' + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes());
      }

      $mdDialog.show({
        templateUrl: 'app/main/message/popup/update_message.html',
        preserveScope: true,
        clickOutsideToClose: true,
        scope: $scope,
      }).then(function () {

      }).catch(function () {

      });
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.front').service('DocumentService', DocumentService);

  function DocumentService($q, $http) {
    var baseUrl = "/api/rest/document/";
    var save = function (fd) {
      return $q(function (resolve, reject) {
        $http({
          url: baseUrl+"save",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": undefined
          },
          transformRequest: angular.identity,
          data: fd
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var deleteFile = function (fileId) {
      return $q(function (resolve, reject) {
        $http({
          url: baseUrl+"delete/"+fileId,
          method: "DELETE",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });

    };

    var remove = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: baseUrl+"disable/" + id,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var getDownloadLink = function (documentId) {
      return baseUrl+'download/' + documentId;
    };


    return {
      save: save,
      remove: remove,
      deleteFile: deleteFile,
      getDownloadLink: getDownloadLink
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.front').service('databaseFoldersService', ['$q', '$http', function ($q, $http) {
    var baseUrl = './api/rest/folder';
    return {
      saveFolder: function (folder, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl,
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: folder
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      findRoots : function (lang, parentFolderId) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl,
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang,
              'idParent' : parentFolderId
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findById : function (lang, idFolder) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+'/'+idFolder,
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      deleteFolder : function (idFolder) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+'/'+idFolder,
            method: 'DELETE',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findDocumentsFolder : function (idFolder) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+'/documents',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'folderId' : idFolder
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });

      }
    };
  }]);

})();

(function () {
	'use strict';

	angular.module('app.front').controller('databaseFoldersController', databaseFoldersController);

	function databaseFoldersController($rootScope, $scope, $timeout,$location, toastr, databaseFoldersService, languageService,$filter,$mdDialog,DocumentService) {
		$scope.language = {};
		$scope.folders = [];
		$scope.files = [];
		$scope.newFolder = {};
		$scope.selectedFolder = null;
    $scope.showForm = false;
    $scope.document = {};
    $scope.error = {};
    $scope.folderUpdate = false;
    $scope.thread = [];

    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
      for (var i = 0; i < $scope.languages.length; i++) {
        var language = $scope.languages[i];
        if (language.preferred) {
          $scope.language.key = language.key;
          $scope.findFolders($scope.language.key);
          $scope.findDocuments($scope.newFolder.idParent);
          break;
        }
      }
      $scope.$watch('language.key', function () {
        $scope.findFolders($scope.language.key, $scope.newFolder.idParent);
      });
    }).catch(function (error) {

    });

    $scope.showFolderForm = function () {
      $scope.showForm = !$scope.showForm;
    };

    $scope.createFolder = function () {
      databaseFoldersService.saveFolder($scope.newFolder,$scope.language.key).then(function (data) {
        $scope.showForm = !$scope.showForm;
        delete $scope.newFolder.name;
        $scope.findFolders($scope.language.key,$scope.newFolder.idParent);
        $scope.findDocuments($scope.newFolder.idParent);
      }).catch(function (data) {

      });
    };


    $scope.goToFolder = function (folder,fromThread) {
      if(!$scope.thread.includes(folder)){
        $scope.thread.push(folder);
      }
      var lengthThread = angular.copy($scope.thread).length-1;
      if(fromThread){
        for (var i = lengthThread; i > 0; i--) {
          if ($scope.thread[i] != folder) {
            $scope.thread.pop();
          }
        }
      }
      $scope.newFolder.idParent = folder.id;
      $scope.document.folderId = $scope.newFolder.idParent;
      $scope.findFolders($scope.language.key,folder.id);
      $scope.findDocuments($scope.newFolder.idParent);
    };


    $scope.returnParent = function () {
      databaseFoldersService.findById($scope.language.key, $scope.newFolder.idParent).then(function (folder) {
        $scope.thread.pop();
        $scope.newFolder.idParent = folder.data != null ? folder.data.idParent : null;
        $scope.document.folderId = $scope.newFolder.idParent;
        $scope.findFolders($scope.language.key, $scope.newFolder.idParent);
        $scope.findDocuments($scope.newFolder.idParent);
      }).catch(function (data) {
        delete $scope.newFolder.idParent;
      });
    };



    $scope.openAddFile = function () {
      $scope.documentPopup = $mdDialog.show({
        templateUrl: 'app/main/media/popup/document_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
      }).catch(function () {
      });
    };

    $scope.saveDocument = function () {
      var input = document.getElementById('document_input_file');
      var file = null;
      $scope.error.file = false;
      if (input != null) {
        file = input.files[0];
        if (file == null) {
          $scope.error.file = true;
        }
      } else {
        $scope.error.file = true;
      }

      if (!$scope.error.file) {
        var fd = new FormData();
        fd.append('file', file);
        fd.append('dto', angular.toJson($scope.document));
        DocumentService.save(fd).then(function (response) {
          $scope.findFolders($scope.language.key, $scope.newFolder.idParent);
          $scope.findDocuments($scope.newFolder.idParent);
          $scope.hidePopup();
        }).catch(function (response) {
          if (response.status === 404) {
            toastr.error('Dossier parent introuvable, veuillez actualiser la page');
          }
        });
      }
    };


    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.isPicture = function (filename) {
      return (/\.(gif|jpg|jpeg|tiff|png)$/i).test(filename);
    };

    $scope.getUrl = function () {
      return $location.protocol()+"://"+$location.host()+($location.port() ? ':'+$location.port(): '');
    };

    // FIND ALL
    $scope.findFolders = function (lang, parentFolderId) {
      if(!parentFolderId){
        $scope.thread = [];
        $scope.newFolder = {};
      }
      databaseFoldersService.findRoots(lang, parentFolderId).then(function (folders) {
        $scope.folders = folders.data;
      }).catch(function (data) {

      })
    };

    $scope.findDocuments = function (folderId) {
      databaseFoldersService.findDocumentsFolder(folderId).then(function (documents) {
        $scope.files = documents.data;
      }).catch(function (data) {
      });
    };


    //DELETE

    $scope.deleteFile = function (file) {
      var content = {
        title: $filter('translate')('FOLDERS.DELETE_FILE'),
        message: $filter('translate')('FOLDERS.CONFIRM_DELETE_FILE')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        DocumentService.deleteFile(file.id).then(function (data) {
          $scope.findFolders($scope.language.key, $scope.newFolder.idParent);
          $scope.findDocuments($scope.newFolder.idParent);
        }).catch(function (data) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }).catch(function () {

      });
    };


    $scope.deleteFolder = function (folder) {
      var content = {
        title: $filter('translate')('FOLDERS.DELETE'),
        message: $filter('translate')('FOLDERS.CONFIRM_DELETE')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        databaseFoldersService.deleteFolder(folder.id).then(function (data) {
          $scope.findFolders($scope.language.key, $scope.newFolder.idParent);
          $scope.findDocuments($scope.newFolder.idParent);
        }).catch(function (data) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }).catch(function () {

      });
    };



    //UPDATE FOLDER
    $scope.updateFolder = function (folder) {
      $scope.folderNameCopy = {name: folder.name};
      $scope.folderUpdate = !$scope.folderUpdate;
      folder.update = $scope.folderUpdate;
    };

    $scope.saveUpdateFolder = function (folder) {
      var updateFolder = {
        id : folder.id,
        name : angular.copy($scope.folderNameCopy.name),
        idParent: folder.idParent
      };
      databaseFoldersService.saveFolder(updateFolder,$scope.language.key).then(function (data) {
        $scope.folderUpdate = !$scope.folderUpdate;
        $scope.findFolders($scope.language.key,updateFolder.idParent);
        $scope.findDocuments(updateFolder.idParent);
      }).catch(function (data) {

      });
    };

	}
})();

(function () {
  'use strict';

  angular.module('app.front').service('MailingService', MailingService);

  function MailingService($q, $http, $filter) {

    var service = {};

    var blocTypes = [
      { translation: 'MAILING.BLOCS.TYPES.HTML', value: 'HTML' },
      { translation: 'MAILING.BLOCS.TYPES.TEST', value: 'TEST' }
    ];

    service.getBlocTypes = function () {
      return blocTypes;
    };

    service.findAll = function (path, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/' + path,
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang' : lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.find = function (path, id, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/' + path + '/' + id,
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang' : lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.save = function (path, dto, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/' + path,
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang' : lang
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.delete = function (path, id) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/' + path + '/' + id,
          method: 'DELETE',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.moveBloc = function(pageID, blocIndex, up, lang) {
      var url = './api/rest/mailing/page/' + pageID + '/' + blocIndex + '/';
      if (up) {
        url += 'up';
      } else {
        url += 'down';
      }
      return $q(function (resolve, reject) {
        $http({
          url: url,
          method: 'PUT',
          params: {
            '_v': new Date().getTime(),
            'lang' : lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findAllPageLite = function () {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/pages/lite',
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.doAMailing = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/doAMailing',
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    return service;

  }

})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController($scope, STORAGE_PREFIX, DISPLAY_MODELS_ICONS, MessageService, $rootScope, $filter) {
    $scope.iconsDisplay = {};
    angular.forEach(DISPLAY_MODELS_ICONS, function (elt) {
      $scope.iconsDisplay[elt.name] = elt.value;
    });

    $scope.months = [];
    $scope.date = {
      year: moment().get('y'),
      month: moment().format("MMM"),
      day: moment().date()
    };
    $scope.daysInMonth = 0;
    $scope.getYear = function (n) {
      return moment().get('year') + n;
    };
    $scope.hoursInDay = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];
    $scope.actions = [];
    moment().locale(localStorage[STORAGE_PREFIX + 'language']);
    $scope.monthBeginSunday = false;
    $scope.getMonth = function () {
      $scope.months = moment.localeData().monthsShort();
    };

    $scope.getMonth();


    $scope.findMessageByDay = function (startDate, endDate) {
      MessageService.findMessageByDay(startDate, endDate, localStorage[STORAGE_PREFIX + 'language']).then(function (messages) {
        $scope.actions = messages.data;
      }).catch(function (err) {
        console.log(err);
      });
    };

    $scope.displayDays = function (typeDay) {
      $scope.daysWeek = [];
      if (typeDay == 'year') {
        var startDate = moment("01/01/" + $scope.date.year, "DD/MM/YYYY").set({
          'h': 0,
          "m": 0,
          "ms": 0
        }).toDate().getTime();
        var endDate = moment("31/12/" + $scope.date.year, "DD/MM/YYYY").set({
          'h': 23,
          "m": 59
        }).toDate().getTime();
        $scope.findMessageByDay(startDate, endDate);
        delete $scope.date.month;
        delete $scope.date.day;
        delete $scope.date.sort;
      } else if (typeDay == 'month') {
        $scope.daysInMonth = moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").daysInMonth();
        var startDate = moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").startOf('month').set({
          'h': 0,
          "m": 0,
          "ms": 0
        }).toDate().getTime();
        var endDate = moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").endOf('month').set({
          'h': 23,
          "m": 59,
          "ms": 0
        }).toDate().getTime();
        $scope.findMessageByDay(startDate, endDate);
        delete $scope.date.day;
        delete $scope.date.sort;
      } else {
        if ($scope.date.year && $scope.date.month) {
          delete $scope.date.sort;
          $scope.daysInMonth = moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").daysInMonth();
          if ($scope.date.day && $scope.date.day > $scope.daysInMonth) {
            $scope.actions = [];
            delete $scope.date.day;
          } else {
            if ($scope.date.year && $scope.date.month && $scope.date.day) {
              var currentDate = moment($scope.date.year + '-' + $scope.date.month + "-" + $scope.date.day, "YYYY-MMM-DD");
              var startDate = currentDate.set({
                'h': 0,
                "m": 0,
                "ms": 0
              }).toDate().getTime();
              var endDate = currentDate.set({
                'h': 23,
                "m": 59
              }).toDate().getTime();
              $scope.findMessageByDay(startDate, endDate);
            }
          }
        }
      }

    };
    $scope.displayDays();

    $scope.displayCircle = function (day) {
      if ($scope.date.year && $scope.date.month) {
        if (moment($scope.date.year + '-' + $scope.date.month + '-' + day, "YYYY-MMM-DD").day() == 0) {
          return true;
        }
      }
      return false;
    };



    $scope.filterMessageByHour = function (hour) {
      return function (message) {
        return moment(message.action.dateAction).get('h') == hour;
      }
    };

    $scope.filterMessageUnder = function (hour) {
      return function (message) {
        return moment(message.action.dateAction).get('h') < hour;
      }
    };

    $scope.filterMessageOver = function (hour) {
      return function (message) {
        return moment(message.action.dateAction).get('h') > hour;
      }
    };


    $scope.filterMessageByMonth = function (month) {
      return function (message) {
        return moment(message.action.dateAction).format("MMM") == month;
      }
    };


    $scope.filterMessageByDaysInMonth = function (date) {
      return function (message) {
        return moment(message.action.dateAction).date() == date;
      }
    };





    $scope.confirmAction = function (action) {
      var content = {
        title: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL_TITLE') : $filter('translate')('MESSAGE.ACTION_CONFIRM_TITLE'),
        message: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL') : $filter('translate')('MESSAGE.ACTION_CONFIRM')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        action.actionDone = !action.actionDone;
        MessageService.confirmAction(action).then(function (data) {}).catch(function (data) {});
      }).catch(function () {

      });
    };

    $scope.getDateMonthCalendar = function (indexWeek, indexDay) {
      var date = moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").startOf('month').add(indexWeek * 7, 'days');
      date = date.day(indexDay);
      if (indexWeek == 0) {
        if (date.date() > 7 && beginWithSunday == '') {
          return "";
        }
      } else if (indexWeek == 4) {
        if (date.date() < 7) {
          return "";
        }
      }

      return date.date();
    };
    var beginWithSunday = $scope.getDateMonthCalendar(0,0);



    $scope.startOfMonthSunday = function () {
      if ($scope.date.year && $scope.date.month) {
        var date = moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").startOf('month').day();
        if (date == 0) {
          return true;
        }
      }
      return false;
    };

    $scope.selectWeek = function (day) {
      delete $scope.date.day;
      var date = moment($scope.date.year + '-' + $scope.date.month + '-' + day, "YYYY-MMM-DD").startOf('week');
      var startDate = moment($scope.date.year + '-' + $scope.date.month + '-' + day, "YYYY-MMM-DD").startOf('week').set({
        'h': 0,
        "m": 0,
        "ms": 0
      }).toDate().getTime();
      var endDate = moment($scope.date.year + '-' + $scope.date.month + '-' + day, "YYYY-MMM-DD").endOf('week').set({
        'h': 23,
        "m": 59,
        "ms": 0
      }).toDate().getTime();
      $scope.findMessageByDay(startDate, endDate);
      $scope.daysWeek = [];
      for (var i = 0; i < 7; i++) {
        var dateWeek = date.add(1, 'days').date();
        $scope.daysWeek.push({
          date: dateWeek,
          inCurrentMonth: date.month() == moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").month()
        });
      }
    };

    $scope.setDate = function (date) {
      if (date.inCurrentMonth) {
        $scope.date.day = date.date;
      } else {
        var nextDate = moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").add(1, 'month').format("MMM");
        $scope.date.month = nextDate;
        $scope.date.day = date.date;
      }
    };

    $scope.sortMessage = function (sorting) {
      delete $scope.date.year;
      delete $scope.date.month;
      delete $scope.date.day;
      $scope.date.sort = sorting;
      MessageService.findMessageNotDone(sorting, localStorage[STORAGE_PREFIX + 'language'], false).then(function (messages) {
        $scope.actions = messages.data;
      }).catch(function (err) {
        console.log(err);
      });
    };

  }
})();

(function () {
	'use strict';

	angular.module('app.front').service('GalleryService', ['$q', '$http', function ($q, $http) {
		var baseUrl = './api/rest/gallery';
		var publicUrl = './api/public/sitegen';

		return {
			save: function (gallery, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl,
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: gallery
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			saveSub: function (subGallery, galleryID, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/' + galleryID + '/sub',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: subGallery
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getAll: function (lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/all',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			get: function (uuid, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/' + uuid,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			upSubGallery: function (uuid) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/upSubGallery/' + uuid,
						method: 'GET',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			downSubGallery: function (uuid) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/downSubGallery/' + uuid,
						method: 'GET',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getSub: function (uuid, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/sub/' + uuid,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getMutliplePublic: function (uuids, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: publicUrl + '/gallery',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: uuids
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getPublic: function (uuid, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: publicUrl + '/gallery/' + uuid,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			remove: function (id) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/' + id,
						method: 'DELETE',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			removeSub: function (id) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/sub/' + id,
						method: 'DELETE',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getDownloadLink: function (documentName) {
				return publicUrl + '/download/' + documentName;
			}
		};
	}]);

})();

(function () {
	'use strict';

	angular.module('app.front').controller('GalleryController', GalleryController);

	function GalleryController($rootScope, GalleryService, $scope, $translate, $timeout, $location, toastr, FestivalService, languageService, $filter, $mdDialog, DocumentService, $sce, $state, userService) {
		$scope.galleries = [];
		$scope.gallery = {};
		$scope.languages = [];
		$scope.language = {};
		$scope.loaded = false;
		$scope.updateMode = false;

		$scope.showPopUAdd = function (gallery, index) {
			if (!gallery) {
				$scope.gallery = {};
				$scope.updateMode = false;
			} else {
				$scope.gallery = angular.copy(gallery);
				$scope.index = index;
				$scope.updateMode = true;
			}

			$mdDialog.show({
				templateUrl: 'app/main/gallery/addGallery.popup.html',
				preserveScope: true,
				scope: $scope,
				clickOutsideToClose: true
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.showPopUpRemove = function (gallery, index) {
			$scope.gallery = gallery;
			$scope.index = index;

			$mdDialog.show({
				templateUrl: 'app/main/gallery/removeGallery.popup.html',
				preserveScope: true,
				scope: $scope,
				clickOutsideToClose: true
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.hidePopup = function () {
			$mdDialog.hide();
		};

		$scope.addGallery = function () {
			GalleryService.save($scope.gallery, $scope.language.key).then(function (res) {
				if (!$scope.updateMode) {
					$scope.galleries.unshift(angular.copy(res.data));
				} else {
					$scope.galleries[$scope.index] = angular.copy(res.data);
				}

				$scope.hidePopup();
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.removeGallery = function () {
			GalleryService.remove($scope.gallery.id).then(function (res) {
				$scope.galleries.splice($scope.index, 1);
				$scope.hidePopup();
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.getGalleries = function (lang) {
			$scope.galleries = [];
			GalleryService.getAll(lang).then(function (res) {
				$scope.galleries = res.data;
				$scope.loaded = true;
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.goDetails = function (gallery) {
			console.log(gallery);
			$state.go('app.gallery.details', {
				uuid: gallery.uuid
			});
		};

		function init() {
			//$scope.getGalleries();

			languageService.getLanguages().then(function (response) {
				$scope.languages = response.data;
				for (var i = 0; i < $scope.languages.length; i++) {
					var language = $scope.languages[i];
					if (language.preferred) {
						$scope.language.key = language.key;
						break;
					}
				}
				$scope.$watch('language.key', function () {
					$scope.getGalleries($scope.language.key);
				});
			}).catch(function (error) {

			});
		}

		init();
	}
})();

(function () {
  'use strict';

  angular.module('app.front').service('FestivalService', ['$q', '$http', function ($q, $http) {
    var baseUrl = './api/rest/festival';
    var publicUrl = './api/public/sitegen';
    return {
      saveFestival: function (festival, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl,
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: festival
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findFestivals: function (lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl,
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      removeFestival: function (id) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+"/"+id,
            method: 'DELETE',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      publicGet: function(page, max, lang){
        return $q(function (resolve, reject) {
          $http({
            url: publicUrl + '/festivals',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'page': page,
              'max': max, 
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findByIdPublic : function(id, lang){
        return $q(function (resolve, reject) {
          $http({
            url: publicUrl + '/festivals/' + id,
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      }
    };
  }]);

})();

(function () {
	'use strict';

	angular.module('app.front').controller('FestivalController', FestivalController);

	function FestivalController($rootScope, $scope, $timeout,$location, toastr, FestivalService, languageService,$filter,$mdDialog,DocumentService,$sce,$state, userService) {
    $scope.userService = userService;
		$scope.language = {};
    $scope.festival = {
      publish : false
    };
    $scope.festivals = [];
    $scope.showForm = false;
    $scope.timeNotMatch = false;
    $scope.loaded = true;
    $scope.photos = [];
    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
      for (var i = 0; i < $scope.languages.length; i++) {
        var language = $scope.languages[i];
        if (language.preferred) {
          $scope.language.key = language.key;
          break;
        }
      }
      $scope.$watch('language.key', function () {
        $scope.findFestivals($scope.language.key);
      });
    }).catch(function (error) {

    });

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.unsafe = function(content) {
      return $sce.trustAsHtml(content);
    };

    $scope.showFormFestival = function () {
      $scope.showForm = true;
    };

    $scope.cancelFestivalForm = function () {
      $scope.festival = {
        publish: false
      };
      $scope.showForm = false;
      $scope.photos = [];
    };


    // FIND ALL


    $scope.findFestivals = function (lang) {
      $scope.loaded = false;
      FestivalService.findFestivals(lang).then(function (festivals) {
        $scope.festivals = festivals.data;
        if($scope.festival.id){
          for(var i = 0; i < festivals.data.length; i++){
            if($scope.festival.id == festivals.data[i].id){
              $scope.festival = angular.copy(festivals.data[i]);
            }
          }
          $scope.festival.startDateForm = moment($scope.festival.dateStart).toDate();
          $scope.festival.endDateForm = moment($scope.festival.dateEnd).toDate();
          $scope.festival.startTime = moment($scope.festival.dateStart).format('HH:mm');
          $scope.festival.endTime = moment($scope.festival.dateEnd).format('HH:mm');
        }
        $scope.loaded = true;
      }).catch(function (data) {

      });
    };


    // SAVE FESTIVAL

    $scope.saveFestival = function () {


      var photos = [];

      for (var i = 0; i < $scope.photos.length; i++) {
        if ($scope.photos[i] != null && $scope.photos[i].uploadFile != null) {
          var photo = $scope.photos[i].uploadFile;
          photos.push(photo);
        }
      }

      if ($scope.festival.startDateForm != null && $scope.festival.startTime != null){
        $scope.festival.dateStart = moment($scope.festival.startDateForm).set('hours', $scope.festival.startTime.split(':')[0]).set('minutes', $scope.festival.startTime.split(':')[1]).toDate().getTime();
      }else if ($scope.festival.startDateForm != null){
        $scope.festival.dateStart = moment($scope.festival.startDateForm).toDate().getTime();
      }
      if ($scope.festival.endDateForm != null && $scope.festival.endTime != null){
        $scope.festival.dateEnd = moment($scope.festival.endDateForm).set('hours', $scope.festival.endTime.split(':')[0]).set('minutes', $scope.festival.endTime.split(':')[1]).toDate().getTime();
      }else if ($scope.festival.endDateForm != null){
        $scope.festival.dateEnd = moment($scope.festival.endDateForm).toDate().getTime();
      }
      if ($scope.festival.dateStart > $scope.festival.dateEnd) {
        $scope.timeNotMatch = true;
      } else {
        FestivalService.saveFestival($scope.festival, $scope.language.key).then(function (data) {



          //On upload les photos l'une après l'autre car le faire en parallèle cause une erreur côté back
          var fds = [];

          for (var i = 0; i < photos.length; i++) {
            var formData = new FormData();
            formData.append('file', photos[i]);
            formData.append('dto', angular.toJson({
              festivalId: data.data
            }));

            fds.push(formData);
          }

          var index = 0;

          if (fds.length > 0) {
            for (var i = 0; i < fds.length; i++) {
              if (i === 0) {
                if(i === fds.length - 1){
                  $scope.addPhoto(fds[i], i, true);
                }else{
                  $scope.addPhoto(fds[i], i);
                }
                index++;
              } else {
                $scope.$on('photoUploaded' + i, function () {
                  if (index === fds.length - 1) {
                    $scope.addPhoto(fds[index], index, true);
                  } else {
                    $scope.addPhoto(fds[index], index, false);
                  }

                  index++;
                });
              }
            }
          } else {
            $state.go('app.festival');
          }

          $scope.cancelFestivalForm();
          $scope.findFestivals($scope.language.key);
        }).catch(function (data) {
          console.log(data);
        });
      }
    };

    $scope.addPhoto = function (fd, i, last) {
      var index = angular.copy(i);
      DocumentService.save(fd).then(function (res) {
        $scope.$emit('photoUploaded' + (index + 1));
        if (last) {
          $scope.findFestivals($scope.language.key);
          $state.go('app.festival');
        }
      }).catch(function (err) {
        toastr.error($filter('translate')('FESTIVAL.ERROR_ADD_PHOTO'));
        $scope.$emit('photoUploaded' + (index + 1));
        if (last) {
          $state.go('app.festival');
        }
      });
    };


  //  UPDATE FESTIVAL

    $scope.updateFestival = function (festival) {
      $scope.showForm = true;
      $scope.festival = angular.copy(festival);
      if ($scope.festival.dateStart != null){
        $scope.festival.startDateForm = moment($scope.festival.dateStart).toDate();
        $scope.festival.startTime = moment($scope.festival.dateStart).format('HH:mm');
      }
      if ($scope.festival.dateEnd != null){
        $scope.festival.endDateForm = moment($scope.festival.dateEnd).toDate();
        $scope.festival.endTime = moment($scope.festival.dateEnd).format('HH:mm');
      }
    };



    //  REMOVE FESTIVAL
    $scope.removeFestival = function (festival) {
      var content = {
        title: $filter('translate')('FESTIVAL.DELETE'),
        message: $filter('translate')('FESTIVAL.CONFIRM_DELETE')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        FestivalService.removeFestival(festival.id).then(function (data) {
          $scope.findFestivals($scope.language.key);
          $scope.cancelFestivalForm();
        }).catch(function (data) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }).catch(function () {

      });
    };




    //  DELETE PHOTO

    $scope.deletePhoto = function (index) {
      $scope.photos.splice(index, 1);
    };


    $scope.displayPopUpDeletePhoto = function (photo, index) {
      $scope.photoToDelete = angular.copy(photo);
      $scope.indexToDelete = index;
      $mdDialog.show({
        templateUrl: 'app/main/festival/popup/deletePhoto.popup.html',
        preserveScope: true,
        clickOutsideToClose: true,
        scope: $scope
      }).then(function () {

      }).catch(function () {

      });
    };


    $scope.deletePhotoPermanentely = function () {
      DocumentService.deleteFile($scope.photoToDelete.id).then(function (res) {
        $scope.festival.photos.splice($scope.indexToDelete, 1);
        toastr.success($filter('translate')('FESTIVAL.CONFIRM_MESSAGE_PHOTO'));
        $scope.findFestivals($scope.language.key);
        $scope.hidePopup();
      }).catch(function (err) {
        toastr.error($filter('translate')('FESTIVAL.ERROR_MESSAGE_PHOTO'));
      });
    };


  }
})();

(function(){
	'use strict';

	angular.module('app.front').controller('eventsController', eventsController);

	function eventsController($scope, $mdDialog, $filter, $state, toastr, eventService, URL){

		$scope.URL = URL;

		$scope.refresh = function(){
			eventService.findAll().then(function(response){
				$scope.events = response.data;
			}).catch(function(){
	
			});
		};
		$scope.refresh();

		$scope.goAdd = function(){
			$mdDialog.show({
				templateUrl: 'app/main/events/popup/add_event.html',
				controller: 'addEventController',
				clickOutsideToClose: true,
				locals: {
					event : {}
				}
			}).then(function(){
				$scope.refresh();
			}).catch(function(){

			});
		};

		$scope.update = function(event){
			$mdDialog.show({
				templateUrl: 'app/main/events/popup/add_event.html',
				controller: 'addEventController',
				clickOutsideToClose: true,
				locals: {
					event: event
				}
			}).then(function () {
				$scope.refresh();
			}).catch(function () {

			});

		};

		$scope.showPopUpDelete = function (event, index) {
			$scope.eventToDelete = angular.copy(event);
			$scope.indexToDelete = index;

			$mdDialog.show({
				templateUrl: 'app/main/popup/confirm.html',
				clickOutsideToClose: true,
				controller: 'confirmPopupController',
				locals: {
					content: {
						title: $filter('translate')('EVENT.POPUP_DELETE.TITLE'),
						message: $filter('translate')('EVENT.POPUP_DELETE.MESSAGE')
					}
				}
			}).then(function () {
				$scope.remove();
			}).catch(function () {});
		};

		$scope.remove = function () {
			eventService.delete($scope.eventToDelete.id).then(function (res) {
				toastr.success($filter('translate')('EVENT.SUCCESS_DELETE'));
				$scope.events.splice($scope.indexToDelete, 1);
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(err);
			});
		};

		$scope.goToInscriptionStatus = function () {
			$state.go('app.events.inscriptionStatus');
		};

		$scope.goToLogisticalStatus = function(){
			$state.go('app.events.logisticalStatus');
		};

		$scope.seeInscriptionForms = function(event){
			$state.go('app.events.inscriptionForms', {id: event.id});
		};

		$scope.goToSubCategories = function(){
			$state.go('app.events.inscriptionSubCategories');
		};

		$scope.seeInscriptionFields = function(event){
			$state.go('app.events.inscriptionModel', {id: event.id});
		};

		$scope.seeLogisticalFields = function(event){
			$state.go('app.events.logisticalModel', {id: event.id});
		};
	}
})();
(function(){
	'use strict';

	angular.module('app.front').service('eventService', eventService);

	function eventService($http, $q){
		var service = {};

		

		service.save = function(fmData){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/event',
					method: 'POST',
					headers: {'Content-Type': undefined},
					data: fmData,
					params: {'_v': new Date().getTime()}
				}).then(function(response){
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.delete = function(id){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/event/' + id,
					method: 'DELETE',
					headers: {
						'Content-Type': undefined
					},
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};


		service.findAll = function(){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/event',
					method: 'GET',
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});

		};

		service.listNotSubscribed = function(contactId){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/event/contact/'+contactId,
					method: 'GET',
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		return service;
	}
})();
(function () {
    'use strict';
  
    angular.module('app.front').service('DuplicationToolService', DuplicationToolService);
  
    function DuplicationToolService($q, $http, $filter) {
  
      var service = {};

      service.lookForDuplicates = function(dToolDto, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: './api/rest/duplication-tool/lookForDuplicates',
            method: 'POST',
            params: { '_v': new Date().getTime(), 'lang' : lang },
            data : dToolDto
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      };

      service._getDuplicatesModelsInfos = function(_lang, _modelType, _modelSubTypeId, _modelsToMergeIds) {
        return $q(function (resolve, reject) {
          $http({
            url: './api/rest/duplication-tool/getDuplicatesModelsInfos',
            method: 'POST',
            params: { '_v': new Date().getTime(), 'lang' : _lang, 'modelType' : _modelType, 'modelSubTypeId' : _modelSubTypeId },
            data : { duplicateIds : _modelsToMergeIds }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      };

      service._mergeDuplicatesModels = function(_lang, _modelType, _modelSubTypeId, _modelsToMerge) {
        return $q(function (resolve, reject) {
          $http({
            url: './api/rest/duplication-tool/mergeDuplicatesModels',
            method: 'POST',
            params: { '_v': new Date().getTime(), 'lang' : _lang, 'modelType' : _modelType, 'modelSubTypeId' : _modelSubTypeId },
            data : _modelsToMerge
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      };

      service._autoMergeDuplicatesModel = function(_modelType, _modelSubTypeId, _companyId) {
        return $q(function (resolve, reject) {
          $http({
            url: './api/rest/duplication-tool/autoMergeDuplicatesModel',
            method: 'POST',
            params: { '_v': new Date().getTime(), 'modelType' : _modelType, 
              'modelSubTypeId' : _modelSubTypeId, "companyId" : _companyId }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      };

      service._junkBoxFindAll = function (_lang) {
        return $q(function (resolve, reject) {
          $http({
            url: './api/rest/duplication-tool/junkBox',
            method: "GET",
            params: { '_v': new Date().getTime(), 'lang' : _lang }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      };

      service._junkBoxDelete = function (id) {
        return $q(function (resolve, reject) {
          $http({
            url: './api/rest/duplication-tool/junkBox/' + id,
            method: "DELETE",
            params: { '_v': new Date().getTime() }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      };
  
      return service;
  
    }
  
  })();
  
(function () {
    'use strict';

    angular.module('app.front').controller('DuplicationToolController', DuplicationToolController);

    function DuplicationToolController($rootScope, $scope, $timeout, $filter, $state, $translate, $mdDialog, $element, toastr, MODELS_TYPES, modelService, 
        DuplicationToolService, companyService) {

        // Constantes

        $scope.MODEL_BASE_URL = './api/rest/model/';
        $scope.MODELS_TYPES = MODELS_TYPES;    

        
        // Variables

        $scope.inProgress = false;
        $scope.initDataInProgress = false;
        $scope.fieldsListInProgress = false;

        $scope.duplicationToolDto = {};
        $scope.duplicationToolForm = {};
        $scope.duplicatesEntityDto = {};

        // Handle params
        var  _modelType = $state.params._modelType;
        var _modelSubTypeId = $state.params._modelSubTypeId;
        var _companyId = $state.params._companyId;
        var _fields = $state.params._fields;

        if(_modelType) {
            $scope.initDataInProgress = true;
        }

        /**
         * 
         */       

        // md-select input search

        window.mdSelectOnKeyDownOverride = function (event) {
            event.stopPropagation();
        };

        /**
         * 
         */

        // Init company model subtype

        modelService.getSubTypes(
            $scope.MODEL_BASE_URL + $scope.MODELS_TYPES.COMPANY_MODEL, 
            $translate.preferredLanguage(), 
            true
        ).then(function (resp) {
            $scope.modelSubTypes = resp.data;
            if(_modelType && _modelType == $scope.MODELS_TYPES.COMPANY_MODEL) {
                $scope.duplicationToolDto.modelType = MODELS_TYPES.COMPANY_MODEL;
                $scope.duplicationToolDto.modelSubTypeId = $state.params._modelSubTypeId;
                $scope.duplicationToolDto.fields = $state.params._fields;
                $scope.initDataInProgress = false;
            }
        }).catch(function (err) {
            $scope.initDataInProgress = false;
            console.log(err)
        });  

        // Init companies list for contact duplicates search
        $scope._companyPage = 0;
        $scope.findCompanies = function() {
            companyService.findPage($translate.preferredLanguage(), $scope._companyPage).then(function(res) {
                if (res.data) {
                    $scope._companies = res.data;
                }
                $scope._companyPage = $scope._companyPage + 1;

                if(_modelType && _modelType == $scope.MODELS_TYPES.CONTACT_MODEL) {
                    modelService.listFieldsByType(
                        $scope.MODELS_TYPES.CONTACT_MODEL, 
                        $translate.preferredLanguage()
                    ).then(function (resp) {
                        $scope.fields = $filter('filter')(resp.data, function (item) {
                            return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
                        });
                        $scope.duplicationToolDto.modelType = MODELS_TYPES.CONTACT_MODEL;
                        $scope.duplicationToolDto.companyId = parseInt($state.params._companyId, 10);
                        $scope.duplicationToolDto.fields = $state.params._fields;
                        $scope.initDataInProgress = false;
                    }).catch(function (err) {
                        $scope.initDataInProgress = false;
                        console.log(err);
                    });
                }
            }).catch(function(err) {
                console.log(err);
                $scope.initDataInProgress = false;
            });
        };
        $scope.findCompanies();

        /**
         * 
         */

        // Model type select handle

        $scope.modelTypeSelectedFn = function() {

            if($scope.duplicationToolDto && $scope.duplicationToolDto.modelType) {

                delete $scope.duplicationToolDto.modelSubTypeId;
                delete $scope.duplicationToolDto.contactId;
                delete $scope.duplicationToolDto.fieldCategoryId;
                delete $scope.duplicationToolDto.fields;
                delete $scope.duplicatesEntityDto.dto;

                if($scope.duplicationToolDto.modelType === $scope.MODELS_TYPES.CONTACT_MODEL) {

                    $scope.fieldsListInProgress = true;

                    // Field categories if contact model selected
                    /*modelService.getCategoriesOnly(
                        $scope.MODEL_BASE_URL + $scope.MODELS_TYPES.CONTACT_MODEL, 
                        $translate.preferredLanguage(), 
                        true
                    ).then(function (resp) {
                        $scope.fieldCategories = resp.data;
                    }).catch(function (err) {
                        console.log(err)
                    });*/
                    modelService.listFieldsByType(
                        $scope.MODELS_TYPES.CONTACT_MODEL, 
                        $translate.preferredLanguage()
                    ).then(function (resp) {
                        $scope.fields = $filter('filter')(resp.data, function (item) {
                            return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
                        });
                        $scope.fieldsListInProgress = false;
                    }).catch(function (err) {
                        $scope.fieldsListInProgress = false;
                        console.log(err);
                    });

                } else if($scope.duplicationToolDto.modelType === $scope.MODELS_TYPES.COMPANY_MODEL) {
                    // No process
                    // Company model subtypes are loaded in the beginnilookForDuplicatesFnng
                } else {
                    // No process
                }

            }     

        };


        // Model subtype select handle

        $scope.modelSubTypeSelectedFn = function() {

            if($scope.duplicationToolDto && $scope.duplicationToolDto.modelSubTypeId) {

                /*modelService.getCategoriesOnlyBySubType(
                    $scope.MODEL_BASE_URL + $scope.MODELS_TYPES.COMPANY_MODEL, 
                    $scope.duplicationToolDto.modelSubTypeId, 
                    $translate.preferredLanguage(), true
                ).then(function (resp) {
                    $scope.fieldCategories = resp.data;
                }).catch(function (err) {
                    console.log(err)
                });*/

                $scope.fieldsListInProgress = true;

                modelService.listFieldsBySubType(
                    $scope.MODELS_TYPES.COMPANY_MODEL, 
                    $scope.duplicationToolDto.modelSubTypeId,
                    $translate.preferredLanguage()
                ).then(function (resp) {
                    $scope.fields = $filter('filter')(resp.data, function (item) {
                        return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
                    });
                    $scope.fieldsListInProgress = false;
                }).catch(function (err) {
                    $scope.fieldsListInProgress = false;
                    console.log(err)
                });

            }

        };


        // Field category select handle

        $scope.fieldCategorySelectedFn = function() { 

            if($scope.duplicationToolDto && $scope.duplicationToolDto.modelType && $scope.duplicationToolDto.fieldCategoryId) {

                modelService.listAllFieldsByCategory(
                    $scope.duplicationToolDto.modelType, 
                    $scope.duplicationToolDto.fieldCategoryId, 
                    $translate.preferredLanguage()
                ).then(function (resp) {
                    $scope.fields = $filter('filter')(resp.data, function (item) {
                        return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
                    });
                }).catch(function (err) {
                    console.log(err)
                });

            }

        };


        // Submit 

        $scope.lookForDuplicatesFn = function() {
            $scope.duplicationToolForm.form.$setSubmitted();
            if ($scope.duplicationToolForm.form.$valid) {

                $scope.inProgress = true;

                DuplicationToolService.lookForDuplicates(
                    $scope.duplicationToolDto, 
                    $translate.preferredLanguage()
                ).then(function (resp) {
                    $scope.duplicatesEntityDto.dto = resp.data;
                    $scope.inProgress = false;
                }).catch(function (err) {
                    $scope.inProgress = false;
                    console.log(err)
                });

            }
        };

        // Remove duplicat
        
        $scope.removeDuplicatesFn = function(_modelsToMerge) {
            $state.go("app.merge_tool", {  
                '_modelType' :  $scope.duplicationToolDto.modelType, 
                '_modelSubTypeId' : $scope.duplicationToolDto.modelSubTypeId,
                '_modelsToMerge' : _modelsToMerge 
            });
        };


    }
    
})();
(function () {
    'use strict';
  
    angular.module('app.front').service('DataImportService', DataImportService);
  
    function DataImportService($q, $http, $filter) {
  
      var service = {};

      service.columnsMatching = function (fd) {
          return $q(function (resolve, reject) {
            $http({
                url: "/api/rest/dataimport/columnsMatching",
                method: "POST",
                params: {
                    '_v': new Date().getTime()
                },
                headers: {
                    "Content-Type": undefined
                },
                transformRequest: angular.identity,
                data: fd
            }).then(function (response) {
                resolve(response);
            }).catch(function (response) {
                reject(response);
            });
          });
      };

      service.importData = function (fd) {
        return $q(function (resolve, reject) {
          $http({
              url: "/api/rest/dataimport/importData",
              method: "POST",
              params: {
                  '_v': new Date().getTime()
              },
              headers: {
                  "Content-Type": undefined
              },
              transformRequest: angular.identity,
              data: fd
          }).then(function (response) {
              resolve(response);
          }).catch(function (response) {
              reject(response);
          });
        });
      };

      service.importResultData = function (data, lang) {
        return $q(function (resolve, reject) {
          $http({
              url: "/api/rest/dataimport/importResultData",
              method: "POST",
              params: {
                '_v': new Date().getTime(),
                'lang' : lang
              },
              data: JSON.stringify(data)
          }).then(function (response) {
              resolve(response);
          }).catch(function (response) {
              reject(response);
          });
        });
      };
  
      return service;
  
    }
  
  })();
  
(function () {
    'use strict';

    angular.module('app.front').controller('DataImportController', DataImportController);

    function DataImportController($rootScope, $scope, $timeout, $filter, $state, $translate, $mdDialog, $element, toastr, MODELS_TYPES, 
            modelService, DataImportService) {

        $scope.MODEL_BASE_URL = './api/rest/model/';
        $scope.MODELS_TYPES = MODELS_TYPES
        $scope.error = {};
        $scope.inProgress = false;
        $scope._sheets = [];
        $scope.dataImportForm = {};
        $scope.dataImportSubmitForm = {};
        $scope._dataImportResults = [];
        
        // Utils

        // md-select input search
        window.mdSelectOnKeyDownOverride = function (event) {
            event.stopPropagation();
        };

        // Reset all forms
        $scope._resetFormsFn = function() {
            if($scope.dataImportForm && $scope.dataImportForm.form) {
                try {
                    $scope.dataImportForm.form.$setPristine();
                    $scope.dataImportForm.form.$setUntouched();
                } catch(error) {
                    console.error(error);
                }
            };
            if($scope.dataImportSubmitForm && $scope.dataImportSubmitForm.form) {
                try {
                    $scope.dataImportSubmitForm.form.$setPristine();
                    $scope.dataImportSubmitForm.form.$setUntouched();
                } catch(error) {
                    console.error(error);
                }
            };
        };

        // Init company model subtype
        modelService.getSubTypes(
            $scope.MODEL_BASE_URL + $scope.MODELS_TYPES.COMPANY_MODEL, 
            $translate.preferredLanguage(), 
            true
        ).then(function (resp) {
            $scope.modelSubTypes = resp.data;
        }).catch(function (err) {
            console.log(err)
        });  

        // Collect file column
        $scope.columnsMatching = function() {
            $scope.inProgress = true;
            $scope._dataImportResults = [];
            var input = document.getElementById('data_import_input_file');
            var file = null;
            $scope.error.file = false;
            if (input != null) {
                file = input.files[0];
                if (file == null) {
                    $scope.error.file = true;
                }
            } else {
                $scope.error.file = true;
            }
            if (!$scope.error.file) {
                var fd = new FormData();
                fd.append('file', file);
                fd.append('lang', $translate.preferredLanguage());
                DataImportService.columnsMatching(fd).then(function (response) {
                    $scope._sheets = response.data;
                    $scope.inProgress = false;
                    $scope._resetFormsFn();
                }).catch(function (response) {
                    toastr.error('An error occured during processing the application');
                    $scope.inProgress = false;
                });
            } else {
                $scope.inProgress = false;
            }
        };

        // Model type select handle
        $scope.modelTypeSelectedFn = function(_column) {
            delete _column.fieldId;
            delete _column.modelSubTypeId;
            if(_column.modelType === $scope.MODELS_TYPES.CONTACT_MODEL) {
                $scope.inProgress = true;
                modelService.listFieldsByType(
                    $scope.MODELS_TYPES.CONTACT_MODEL, 
                    $translate.preferredLanguage()
                ).then(function (resp) {
                    _column.fields = $filter('filter')(resp.data, function (item) {
                        return item.typeChamps !== 'RICH_TEXT' 
                            //&& item.typeChamps !== 'LIST_SELECT'
                            && item.typeChamps !== 'MULTIPLE_SELECT' 
                            && item.typeChamps !== 'OBJECT' 
                            && item.typeChamps !== 'IMAGE' 
                            && item.typeChamps !== 'FILE';
                    });
                    $scope.inProgress = false;
                }).catch(function (err) {
                    $scope.inProgress = false;
                    console.log(err);
                });
            }
        };

        // Model subtype select handle
        $scope.modelSubTypeSelectedFn = function(_column) {
            $scope.inProgress = true;
            delete _column.fieldId;
            modelService.listFieldsBySubType(
                $scope.MODELS_TYPES.COMPANY_MODEL,
                _column.modelSubTypeId,
                $translate.preferredLanguage()
            ).then(function (resp) {
                _column.fields = $filter('filter')(resp.data, function (item) {
                    return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
                });
                $scope.inProgress = false;
            }).catch(function (err) {
                $scope.inProgress = false;
                console.log(err)
            });
        };

        // Import data
        $scope.importDataFn = function() {
            $scope.inProgress = true;
            var _atLeastOneFieldHasBeenSelected = false;
            for(var i = 0; i < $scope._sheets.length; i++) {    
                for(var j = 0; j < $scope._sheets[i].columns.length;j++) {
                    if($scope._sheets[i].columns[j].modelType) {
                        _atLeastOneFieldHasBeenSelected = true;
                        break;
                    }
                }
                if(_atLeastOneFieldHasBeenSelected == true) {
                    break;
                }
            }
            if(!_atLeastOneFieldHasBeenSelected) {
                toastr.error('At least one field is required !!!');
            }
            var input = document.getElementById('data_import_input_file');
            var file = null;
            $scope.error.file = false;
            if (input != null) {
                file = input.files[0];
                if (file == null) {
                    $scope.error.file = true;
                }
            } else {
                $scope.error.file = true;
            }
            if (!$scope.error.file && _atLeastOneFieldHasBeenSelected) {
                var fd = new FormData();
                fd.append('file', file);
                fd.append('dto', angular.toJson($scope._sheets));
                fd.append('lang', $translate.preferredLanguage());
                DataImportService.importData(fd).then(function (response) {
                    $scope._sheets = [];
                    $scope._dataImportResults = response.data;
                    $scope.inProgress = false;
                    toastr.success($filter('translate')('DATA_IMPORT.IMPORT_SUCCESS'));
                    $scope._resetFormsFn();
                }).catch(function (response) {
                    toastr.error('An error occured during processing the application');
                    $scope.inProgress = false;
                });
            } else {
                $scope.inProgress = false;
            }
        };

        // Checked row is a duplicate

        $scope._rowIsADuplicateFn = function(_row, _rows) {
            if(_row.modelType === 'COMPANY_MODEL') {
                angular.forEach(_rows, function(item, index) {
                    if(item.modelType === 'CONTACT_MODEL') {
                        if(_row.isADuplicate) {
                            item.companyIsADuplicate = true;
                        } else {
                            item.isADuplicate = false;
                            item.companyIsADuplicate = false;
                        }
                    }
                });
            }
        };

        // Select field to update if duplicate
        $scope._modelFieldSelectedFn = function(_sheet, _row, _field, _handelValue, _unhandleValue) {
            if(_handelValue.selected) {
                _unhandleValue.selected = false;
                _field.noModelSelected = false;
            } else {
                _field.noModelSelected = true;
            }
        };

        // New model from file OR Maj 
        $scope.submitImportDataResult = function() {
            $scope.inProgress = true;
            var _isValidOperation = true;
            for(var i = 0; i < $scope._dataImportResults.length; i++) {
                for(var j = 0; j < $scope._dataImportResults[i].rows.length; j++) {
                    for(var k = 0; k < $scope._dataImportResults[i].rows[j].length; k++) { 
                        if($scope._dataImportResults[i].rows[j][k].isADuplicate) {
                            for(var l = 0; l < $scope._dataImportResults[i].rows[j][k].valuedFields.length; l++) {
                                if($scope._dataImportResults[i].rows[j][k].isADuplicate)
                                if($scope._dataImportResults[i].rows[j][k].valuedFields[l].noModelSelected) {
                                    _isValidOperation = false;
                                    break;
                                }
                            }
                        }
                        if(!_isValidOperation) break;
                    }
                    if(!_isValidOperation) break;
                }
                if(!_isValidOperation) break;
            }
            if(_isValidOperation) {
                DataImportService.importResultData($scope._dataImportResults, $translate.preferredLanguage()).then(function (response) {
                    $scope._sheets = [];
                    $scope._dataImportResults = [];
                    $scope.inProgress = false;
                    toastr.success($filter('translate')('DATA_IMPORT.IMPORT_SUCCESS'));
                    $scope._resetFormsFn();
                }).catch(function (response) {
                    toastr.error('An error occured during processing the application');
                    $scope.inProgress = false;
                });
            } else {
                $scope.inProgress = false;
                toastr.error($filter('translate')('DATA_IMPORT.DUPLICATE_NO_FIELD_VALUE_SELECTED_ERROR'));
            }
        };
        
    }
    
})();
(function () {
  'use strict';

  angular.module('app.front').service('CalendarExternService', ['$q', '$http', function ($q, $http) {
    var baseUrl = './api/rest/eventExtern';
    return {
      saveEvent: function (event, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl,
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: event
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      }
    };
  }]);

})();

(function () {
	'use strict';

	angular.module('app.front').controller('CalendarExternController', CalendarExternController);

	function CalendarExternController($rootScope, $scope, $timeout,$location, toastr, CalendarExternService, languageService,$filter,$mdDialog,DocumentService,$sce, uiCalendarConfig) {
    $scope.languages = [];
    $scope.language = {};
    $scope.events = [];
  $scope.event = {};
	  $scope.calendarUiConfig = {
      calendar: {
        lang: 'fr',
        eventLimit: true,
        header: '',
        handleWindowResize: false,
        aspectRatio: 1,
        dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
        dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        slotLabelFormat:'HH:mm',
        allDaySlot:false,
        viewRender: function (view) {
          $scope.calendarView = view;
          $scope.calendar = $scope.calendarView.calendar;
          $scope.currentMonthShort = $scope.calendar.getDate().format('MMM');
          $scope.currentMonthKey = "month-" + $scope.calendar.getDate().format('M');
        },
        columnFormat: {
          month: 'ddd',
          week: 'ddd D',
          day: 'ddd M'
        },
        timeFormat: 'H:mm',
        // eventClick: eventDetail,
        selectable: false,
        selectHelper: true,
        // select: select,
        eventRender: function (event, element, view) {
          return (!event.ranges) || ((event.ranges[0].week === 1) || (event.ranges[0].week === "1") || (moment(event.start).week() % 2 === moment().week() % 2));
        },
        defaultView: 'agendaWeek'
      }
    };

    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
      for (var i = 0; i < $scope.languages.length; i++) {
        var language = $scope.languages[i];
        if (language.preferred) {
          $scope.language.key = language.key;
          break;
        }
      }
      $scope.$watch('language.key', function () {
        // $scope.findFolders($scope.language.key, $scope.newFolder.idParent);
      });
    }).catch(function (error) {

    });

    $scope.changeView = function (view) {
      if (view == 'today') {
        $scope.calendar.today();
      } else {
        $scope.calendar.changeView(view);
      }
      var viewType = uiCalendarConfig.calendars.myCalendar.fullCalendar('getView');
    };


    /**
     * Go to next on current view (week, month etc.)
     */
    $scope.next = function() {
      $scope.calendarView.calendar.next();
      uiCalendarConfig.calendars.myCalendar.fullCalendar('removeEvents');
      var viewType = uiCalendarConfig.calendars.myCalendar.fullCalendar('getView');
      // vm.findAllDisponibilities(viewType);
    };

    /**
     * Go to previous on current view (week, month etc.)
     */
    $scope.prev = function() {
      $scope.calendarView.calendar.prev();
      uiCalendarConfig.calendars.myCalendar.fullCalendar('removeEvents');
      var viewType = uiCalendarConfig.calendars.myCalendar.fullCalendar('getView');
      // vm.findAllDisponibilities(viewType);
    };

    $scope.addEvent = function () {
      $scope.eventPopup = $mdDialog.show({
        templateUrl: 'app/main/calendarExtern/popup/addEvent.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
      }).catch(function () {
      });
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.saveEvent = function () {
      console.log($scope.event);
      $scope.event.dateStart = moment($scope.event.startDateForm).set('hours', $scope.event.startTime.split(":")[0]).set('minutes', $scope.event.startTime.split(":")[1]).toDate().getTime();
      $scope.event.dateEnd = moment($scope.event.endDateForm).set('hours', $scope.event.endTime.split(":")[0]).set('minutes', $scope.event.endTime.split(":")[1]).toDate().getTime();

      CalendarExternService.saveEvent($scope.event,$scope.language.key).then(function (data) {
        $scope.hidePopup();
      }).catch(function (data) {

      });
    };
  }
})();

(function () {
	'use strict';

	angular.module('app.front').service('BlogService', ['$q', '$http', function ($q, $http) {
		var baseUrl = './api/rest/blog';
		var publicBaseUrl = './api/public/sitegen';
		return {
			saveArticle: function (article, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/article',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: article
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			findAllArticles: function (lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/article/findAll',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			findAllByRecent: function (fmData,lang,max,page) {
				var params = max ? {
					'_v': new Date().getTime(),
					'lang': lang,
					'max':max,
					'page': page
				} : {
					'_v': new Date().getTime(),
					'lang': lang
				}

				var url = max ? '/article/findAllRecent/condensed-list' : '/article/findAllRecent';
				return $q(function (resolve, reject) {
					$http({
						url: publicBaseUrl + url,
						method: 'POST',
						params: params,
						headers: {
							'Content-Type': undefined
						},
						transformRequest: angular.identity,
						data: fmData
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			removeArticle: function (articleId) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/' + articleId,
						method: 'DELETE',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			findXLast : function(x, lang){
				return $q(function (resolve, reject) {
					$http({
						url: publicBaseUrl + '/articles/last',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang,
							'last': x
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			findRemains : function(x, page, max, lang){
				return $q(function (resolve, reject) {
					$http({
						url: publicBaseUrl + '/articles',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang,
							'last': x,
							'page': page,
							'max': max
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			findById: function (id, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: publicBaseUrl + '/articles/'+id,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			findForSpecialById:function (id1,id2,id3,id4,lang) {
				return $q(function (resolve, reject) {
					$http({
						url: publicBaseUrl + '/articlesSpecial/',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang,
							'id1':id1,
							'id2':id2,
							'id3':id3,
							'id4':id4
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			findAllTags: function (lang) {
				return $q(function (resolve, reject) {
					$http({
						url: publicBaseUrl + '/tags/findAllTags',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
		};
	}]);

})();

(function () {
	'use strict';

	angular.module('app.front').controller('BlogController', BlogController);

  function BlogController($rootScope, $scope, $timeout, $location, $window, $anchorScroll, toastr, BlogService, languageService,$filter,$mdDialog,DocumentService,$sce,$state) {
		$scope.language = {};
    $scope.showForm = false;
    $scope.article = {};
    $scope.articles = [];
    $scope.photos = [];
    $scope.loaded = true;

    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
      for (var i = 0; i < $scope.languages.length; i++) {
        var language = $scope.languages[i];
        if (language.preferred) {
          $scope.language.key = language.key;
          break;
        }
      }
      $scope.$watch('language.key', function () {
        $scope.findAllArticles($scope.language.key);
      });
    }).catch(function (error) {

    });


    $scope.hidePopup = function () {
      $mdDialog.hide();
    };


    $scope.showFormBlog = function () {
      $location.hash('top_blog');
      $anchorScroll();
      $scope.showForm = true;
    };


    $scope.cancelArticleForm = function () {
      $scope.article = {};
      $scope.photos = [];
      $scope.showForm = false;
    };

    $scope.unsafe = function(content) {
      return $sce.trustAsHtml(content);
    };


    // FIND ALL
    $scope.findAllArticles = function (lang) {
      $scope.loaded = false;
      BlogService.findAllArticles(lang).then(function (articles) {
        $scope.articles = articles.data;
        if($scope.article.id){
            for(var i = 0; i < articles.data.length; i++){
              if(articles.data[i].id == $scope.article.id){
                $scope.article = angular.copy(articles.data[i]);
                $scope.article.startDateForm = moment($scope.article.dateStart).toDate();
              }
            }
        }
        $scope.loaded = true;
      }).catch(function (data) {

      });
    };


    // SAVE ARTICLE
    $scope.saveArticle = function () {
      var photos = [];

      for (var i = 0; i < $scope.photos.length; i++) {
        if ($scope.photos[i] != null && $scope.photos[i].uploadFile != null) {
          var photo = $scope.photos[i].uploadFile;
          photos.push(photo);
        }
      }

      $scope.article.dateStart = $scope.article.startDateForm.getTime();
      BlogService.saveArticle($scope.article, $scope.language.key).then(function (data) {
        $scope.findAllArticles($scope.language.key);
        //On upload les photos l'une après l'autre car le faire en parallèle cause une erreur côté back
        var fds = [];

        for (var i = 0; i < photos.length; i++) {
          var formData = new FormData();
          formData.append('file', photos[i]);
          formData.append('dto', angular.toJson({
            articleId: data.data
          }));

          fds.push(formData);
        }

        var index = 0;

        if (fds.length > 0) {
          for (var i = 0; i < fds.length; i++) {
            if (i === 0) {
              if(i === fds.length - 1){
                $scope.addPhoto(fds[i], i, true);
              }else{
                $scope.addPhoto(fds[i], i);
              }
              index++;
            } else {
              $scope.$on('photoUploaded' + i, function () {
                if (index === fds.length - 1) {
                  $scope.addPhoto(fds[index], index, true);
                } else {
                  $scope.addPhoto(fds[index], index, false);
                }

                index++;
              });
            }
          }
        } else {
          $state.go('app.blog');
        }

        $scope.cancelArticleForm();
      }).catch(function (data) {

      });
    };

    $scope.addPhoto = function (fd, i, last) {
      var index = angular.copy(i);
      DocumentService.save(fd).then(function (res) {
        $scope.$emit('photoUploaded' + (index + 1));
        if (last) {
          $scope.findAllArticles($scope.language.key);
          $state.go('app.blog');
        }
      }).catch(function (err) {
        toastr.error($filter("translate")("BLOG.ERROR_ADD_PHOTO"));
        $scope.$emit('photoUploaded' + (index + 1));
        if (last) {
          $state.go('app.blog');
        }
      });
    };



    //UPDATE ARTICLE
    $scope.updateArticle = function (article) {
      
      $scope.showForm = true;
      $scope.article = angular.copy(article);
      $scope.article.startDateForm = moment($scope.article.dateStart).toDate();
      $location.hash('top_blog');
      $anchorScroll();
    };


    //DELETE ARTICLE
    $scope.removeArticle = function (article) {
      var content = {
        title: $filter('translate')('BLOG.DELETE'),
        message: $filter('translate')('BLOG.CONFIRM_DELETE')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        BlogService.removeArticle(article.id).then(function (data) {
          $scope.cancelArticleForm();
          $scope.findAllArticles($scope.language.key);
        }).catch(function (data) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }).catch(function () {

      });
    };



    // DELETE PHOTO
    $scope.deletePhoto = function (index) {
      $scope.photos.splice(index, 1);
    };


    $scope.displayPopUpDeletePhoto = function (photo, index) {
      $scope.photoToDelete = angular.copy(photo);
      $scope.indexToDelete = index;
      $mdDialog.show({
        templateUrl: 'app/main/blog/popup/deletePhoto.popup.html',
        preserveScope: true,
        clickOutsideToClose: true,
        scope: $scope
      }).then(function () {

      }).catch(function () {

      });
    };


    $scope.deletePhotoPermanentely = function () {
      DocumentService.deleteFile($scope.photoToDelete.id).then(function (res) {
        $scope.article.photos.splice($scope.indexToDelete, 1);
        toastr.success($filter("translate")("BLOG.CONFIRM_MESSAGE_PHOTO"));
        $scope.findAllArticles($scope.language.key);
        $scope.hidePopup();
      }).catch(function (err) {
        toastr.error($filter("translate")("BLOG.ERROR_MESSAGE_PHOTO"));
      });
    };

  }
})();

(function () {
    'use strict';
  
    angular.module('app.front').service('adminService', adminService);
  
    function adminService($q, $http) {
      var service = {};
      var url = '/api/rest/logs/';
  
      service.get = function (filter) {
        return $q(function (resolve, reject) {
          $http({
            url: url,
            method: 'POST',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: filter
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      };

      service.getByCompanyID = function(companyID, filter) {
        return $q(function (resolve, reject) {
          $http({
            url: url + companyID,
            method: 'POST',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: filter
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      };
  
      return service;
    }
  })();
  
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
angular.module('file', [])

.factory('readFile', function ($window, $q) {
    'use strict';

    var readFile = function (file) {
        var deferred = $q.defer(),
            reader = new $window.FileReader();

        reader.onload = function (ev) {
            var content = ev.target.result;
            deferred.resolve(content);
        };

        reader.readAsText(file);
        return deferred.promise;
    };

    return readFile;
})

// does not capture input change event
.directive('fileHandler', function (readFile) {
    'use strict';

    return {
        link: function (scope, element) {
            element.on('change', function (event) {
                var file = event.target.files[0];
                readFile(file).then(function (content) {
                    console.log(content);
                });
            });
        }
    };
})

.directive('fileBrowser', function (readFile) {
    'use strict';

    return {
        template: '<input id="file_cc" type="file" style="display: none;" />' +
            '<ng-transclude></ng-transclude>',
        transclude: true,
        link: function (scope, element) {
			setTimeout(function() {
				console.log({element:element[0].children})
				//var fileInput = element[0].getElementsByTagName('input')[0];
				var fileInput = element[0].children.item(0);
            fileInput.addEventListener('change', function (event) {
                var file = event.target.files[0];
                readFile(file).then(function (content) {
					 });


					 scope.saveFile(file);
            });

            element.on('click', function () {
                fileInput.click();
            });
			});

        }
    };
});

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $scope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, STORAGE_PREFIX, msNavigationService)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            fr: {
                'title'      : 'French',
                'translation': 'TOOLBAR.FRENCH',
                'code'       : 'fr',
                'flag'       : 'fr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];
            // vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

            if (localStorage[STORAGE_PREFIX + 'language'] == null){
                localStorage[STORAGE_PREFIX + 'language'] = $translate.preferredLanguage();
                vm.selectedLanguage = vm.languages[localStorage[STORAGE_PREFIX + 'language']];
            }else{
                vm.selectedLanguage = vm.languages[localStorage[STORAGE_PREFIX + 'language']];
            }
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            // Do logout here..
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            $scope.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */

            // Change the language
            localStorage[STORAGE_PREFIX + 'language'] = lang.code;
            $translate.preferredLanguage(lang.code);
            $scope.$emit('refreshCompanyTypes', { langKey: lang.code});
            $state.reload();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/main/home');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, STORAGE_PREFIX, $translate, $state)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            fr: {
                'title'      : 'French',
                'translation': 'TOOLBAR.FRENCH',
                'code'       : 'fr',
                'flag'       : 'fr'
            }
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        // Methods
        vm.changeLanguage = changeLanguage;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });

        init();

        /**
         * Initialize
         */
        function init()
        {
            // vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
            vm.userStatus = vm.userStatusOptions[0];

            if (localStorage[STORAGE_PREFIX + 'language'] == null){
                localStorage[STORAGE_PREFIX + 'language'] = $translate.preferredLanguage();
                vm.selectedLanguage = vm.languages[localStorage[STORAGE_PREFIX + 'language']];
            }else{
                vm.selectedLanguage = vm.languages[localStorage[STORAGE_PREFIX + 'language']];
                $translate.use(vm.selectedLanguage.code).catch(function(){
                    console.log('error');
                });
            }
        }

        function changeLanguage(lang)
        {
            $scope.selectedLanguage = lang;
            localStorage[STORAGE_PREFIX + 'language'] = lang.code;
            $translate.preferredLanguage(lang.code);
            $translate.use(lang.code);
            $scope.$emit('refreshCompanyTypes', { langKey: lang.code});
            $state.reload();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController)
        .config(function($mdThemingProvider) {

            // Green
            $mdThemingProvider.definePalette('lebanonPalette', {
                '50': '0DA4B4',
                '100': '0DA4B4',
                '200': '0DA4B4',
                '300': '0DA4B4',
                '400': '0DA4B4',
                '500': '0DA4B4',
                '600': '0DA4B4',
                '700': '0DA4B4',
                '800': '0DA4B4',
                '900': '0DA4B4',
                'A100': '0DA4B4',
                'A200': '0DA4B4',
                'A400': '0DA4B4',
                'A700': '0DA4B4',
                'contrastDefaultColor': 'light',
            });

            $mdThemingProvider.theme('default')
              .primaryPalette('lebanonPalette', {
                'default': '500',
                'hue-1': '500',
                'hue-2': '600',
                'hue-3': '800'
              })
              .accentPalette('grey', {
                'default': '400',
                'hue-1': '300',
                'hue-2': '600',
                'hue-3': '800'
              })
              .warnPalette('red');

          });

    /** @ngInject */
    function MainController($scope, $rootScope, msNavigationService, userService)
    {
        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

        /* MENU */

        // EX MENU
        /*msNavigationService.saveItem('menu1', {
			group: true,
			title: 'Menu1',
			icon: 'icon-cog',
			state: 'app.home',
			stateParams: {
			    'param1': 1
			},
			translate: 'MENU.TITLE',
			weight: 8
        });*/

       
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig, fuseTheming)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider, $compileProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        $compileProvider.debugInfoEnabled(false);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
/* globals define, angular */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['quill'], factory)
  } else if (typeof module !== 'undefined' && typeof exports === 'object') {
    module.exports = factory(require('quill'))
  } else {
    root.Requester = factory(root.Quill)
  }
}(this, function (Quill) {
  'use strict'

  var app
  // declare ngQuill module
  app = angular.module('ngQuill', [])

  app.provider('ngQuillConfig', function () {
    var config = {
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          ['blockquote', 'code-block'],

          [{ 'header': 1 }, { 'header': 2 }],               // custom button values
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
          [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
          [{ 'direction': 'rtl' }],                         // text direction

          [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

          [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          [{ 'font': [] }],
          [{ 'align': [] }],

          ['clean'],                                         // remove formatting button

          ['link', 'image', 'video']                         // link and image, video
        ]
      },
      theme: 'snow',
      placeholder: 'Insert text here ...',
      readOnly: false,
      bounds: document.body
    }

    this.set = function (customConf) {
      customConf = customConf || {}

      if (customConf.modules) {
        config.modules = customConf.modules
      }
      if (customConf.theme) {
        config.theme = customConf.theme
      }
      if (customConf.placeholder !== null && customConf.placeholder !== undefined) {
        config.placeholder = customConf.placeholder.trim()
      }
      if (customConf.bounds) {
        config.bounds = customConf.bounds
      }
      if (customConf.readOnly) {
        config.readOnly = customConf.readOnly
      }
      if (customConf.formats) {
        config.formats = customConf.formats
      }
    }

    this.$get = function () {
      return config
    }
  })

  app.component('ngQuillEditor', {
    bindings: {
      'modules': '<modules',
      'theme': '@?',
      'readOnly': '<?',
      'formats': '<?',
      'placeholder': '@?',
      'bounds': '<?',
      'scrollingContainer': '<?',
      'strict': '<?',
      'onEditorCreated': '&?',
      'onContentChanged': '&?',
      'onSelectionChanged': '&?',
      'ngModel': '<',
      'maxLength': '<',
      'minLength': '<',
      'customOptions': '<?'
    },
    require: {
      ngModelCtrl: 'ngModel'
    },
    transclude: {
      'toolbar': '?ngQuillToolbar'
    },
    template: '<div class="ng-hide" ng-show="$ctrl.ready"><ng-transclude ng-transclude-slot="toolbar"></ng-transclude></div>',
    controller: ['$scope', '$element', '$timeout', '$transclude', 'ngQuillConfig', function ($scope, $element, $timeout, $transclude, ngQuillConfig) {
      var config = {}
      var content
      var editorElem
      var modelChanged = false
      var editorChanged = false
      var editor
      var placeholder = ngQuillConfig.placeholder

      this.validate = function (text) {
        if (this.maxLength) {
          if (text.length > this.maxLength + 1) {
            this.ngModelCtrl.$setValidity('maxlength', false)
          } else {
            this.ngModelCtrl.$setValidity('maxlength', true)
          }
        }

        if (this.minLength > 1) {
          // validate only if text.length > 1
          if (text.length <= this.minLength && text.length > 1) {
            this.ngModelCtrl.$setValidity('minlength', false)
          } else {
            this.ngModelCtrl.$setValidity('minlength', true)
          }
        }
      }

      this.$onChanges = function (changes) {
        if (changes.ngModel && changes.ngModel.currentValue !== changes.ngModel.previousValue) {
          content = changes.ngModel.currentValue

          if (editor && !editorChanged) {
            modelChanged = true
            if (content) {
              editor.setContents(editor.clipboard.convert(content))
            } else {
              editor.setText('')
            }
          }
          editorChanged = false
        }

        if (editor && changes.readOnly) {
          editor.enable(!changes.readOnly.currentValue)
        }
      }

      this.$onInit = function () {
        if (this.placeholder !== null && this.placeholder !== undefined) {
          placeholder = this.placeholder.trim()
        }

        config = {
          theme: this.theme || ngQuillConfig.theme,
          readOnly: this.readOnly || ngQuillConfig.readOnly,
          modules: this.modules || ngQuillConfig.modules,
          formats: this.formats || ngQuillConfig.formats,
          placeholder: placeholder,
          bounds: this.bounds || ngQuillConfig.bounds,
          strict: this.strict,
          scrollingContainer: this.scrollingContainer
        }
      }

      this.$postLink = function () {
        // create quill instance after dom is rendered
        $timeout(function () {
          this._initEditor(editorElem)
        }.bind(this), 0)
      }

      this._initEditor = function (editorElem) {
        var $editorElem = angular.element('<div></div>')
        var container = $element.children()

        editorElem = $editorElem[0]

        if (config.bounds === 'self') {
          config.bounds = editorElem
        }

        // set toolbar to custom one
        if ($transclude.isSlotFilled('toolbar')) {
          config.modules.toolbar = container.find('ng-quill-toolbar').children()[0]
        }

        container.append($editorElem);

        if (this.customOptions) {
          this.customOptions.forEach(function (customOption) {
            var newCustomOption = Quill.import(customOption.import);
            newCustomOption.whitelist = customOption.whitelist;
            if (customOption.toRegister) {
              newCustomOption[customOption.toRegister.key] = customOption.toRegister.value;
            }
            Quill.register(newCustomOption, true);
          })
        }

        editor = new Quill(editorElem, config)

        this.ready = true

        // mark model as touched if editor lost focus
        editor.on('selection-change', function (range, oldRange, source) {
          if (this.onSelectionChanged) {
            this.onSelectionChanged({
              editor: editor,
              oldRange: oldRange,
              range: range,
              source: source
            })
          }

          if (range) {
            return
          }
          $scope.$applyAsync(function () {
            this.ngModelCtrl.$setTouched()
          }.bind(this))
        }.bind(this))

        // update model if text changes
        editor.on('text-change', function (delta, oldDelta, source) {
          var html = editorElem.children[0].innerHTML
          var text = editor.getText()
          var emptyModelTag = ['<' + editor.root.firstChild.localName + '>', '</' + editor.root.firstChild.localName + '>']

          if (html === emptyModelTag[0] + '<br>' + emptyModelTag[1]) {
              html = null
          }
          this.validate(text)

          if (!modelChanged) {
            $scope.$applyAsync(function () {
              editorChanged = true

              this.ngModelCtrl.$setViewValue(html)

              if (this.onContentChanged) {
                this.onContentChanged({
                  editor: editor,
                  html: html,
                  text: text,
                  delta: delta,
                  oldDelta: oldDelta,
                  source: source
                })
              }
            }.bind(this))
          }
          modelChanged = false
        }.bind(this))

        // set initial content
        if (content) {
          modelChanged = true

          var contents = editor.clipboard.convert(content)
          editor.setContents(contents)
          editor.history.clear()
        }

        // provide event to get informed when editor is created -> pass editor object.
        if (this.onEditorCreated) {
          this.onEditorCreated({editor: editor})
        }
      }
    }]
  })

  return app.name;
}));

!function(t){"function"==typeof define&&define.amd?define(t):t()}(function(){"use strict";
/** @license
   *
   * jsPDF - PDF Document creation from JavaScript
   * Version 2.1.1 Built on 2019-10-11T08:56:17.234Z
   *                      CommitID 0dd01f177e
   *
   * Copyright (c) 2010-2018 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
   *               2015-2018 yWorks GmbH, http://www.yworks.com
   *               2015-2018 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
   *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
   *               2010 Aaron Spike, https://github.com/acspike
   *               2012 Willow Systems Corporation, willow-systems.com
   *               2012 Pablo Hess, https://github.com/pablohess
   *               2012 Florian Jenett, https://github.com/fjenett
   *               2013 Warren Weckesser, https://github.com/warrenweckesser
   *               2013 Youssef Beddad, https://github.com/lifof
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2013 Stefan Slonevskiy, https://github.com/stefslon
   *               2013 Jeremy Morel, https://github.com/jmorel
   *               2013 Christoph Hartmann, https://github.com/chris-rock
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Makes, https://github.com/dollaruw
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Steven Spungin, https://github.com/Flamenco
   *               2014 Kenneth Glassey, https://github.com/Gavvers
   *
   * Licensed under the MIT License
   *
   * Contributor(s):
   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
   *    kim3er, mfo, alnorth, Flamenco
   */function on(t){return(on="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(t){if("object"!==on(t.console)){t.console={};for(var e,n,r=t.console,i=function(){},a=["memory"],o="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=a.pop();)r[e]||(r[e]={});for(;n=o.pop();)r[n]||(r[n]=i)}var s,u,l,c,h="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";function f(){}void 0===t.btoa&&(t.btoa=function(t){var e,n,r,i,a,o=0,s=0,u="",l=[];if(!t)return t;for(;e=(a=t.charCodeAt(o++)<<16|t.charCodeAt(o++)<<8|t.charCodeAt(o++))>>18&63,n=a>>12&63,r=a>>6&63,i=63&a,l[s++]=h.charAt(e)+h.charAt(n)+h.charAt(r)+h.charAt(i),o<t.length;);u=l.join("");var c=t.length%3;return(c?u.slice(0,c-3):u)+"===".slice(c||3)}),void 0===t.atob&&(t.atob=function(t){var e,n,r,i,a,o,s=0,u=0,l=[];if(!t)return t;for(t+="";e=(o=h.indexOf(t.charAt(s++))<<18|h.indexOf(t.charAt(s++))<<12|(i=h.indexOf(t.charAt(s++)))<<6|(a=h.indexOf(t.charAt(s++))))>>16&255,n=o>>8&255,r=255&o,l[u++]=64==i?String.fromCharCode(e):64==a?String.fromCharCode(e,n):String.fromCharCode(e,n,r),s<t.length;);return l.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(null==this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=1<arguments.length?arguments[1]:void 0,a=0;a<n;a++)a in e&&(r[a]=t.call(i,e[a],a,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.reduce||Object.defineProperty(Array.prototype,"reduce",{value:function(t){if(null===this)throw new TypeError("Array.prototype.reduce called on null or undefined");if("function"!=typeof t)throw new TypeError(t+" is not a function");var e,n=Object(this),r=n.length>>>0,i=0;if(2<=arguments.length)e=arguments[1];else{for(;i<r&&!(i in n);)i++;if(r<=i)throw new TypeError("Reduce of empty array with no initial value");e=n[i++]}for(;i<r;)i in n&&(e=t(e,n[i],i,n)),i++;return e}}),Uint8Array.prototype.reduce||Object.defineProperty(Uint8Array.prototype,"reduce",{value:function(t){if(null===this)throw new TypeError("Array.prototype.reduce called on null or undefined");if("function"!=typeof t)throw new TypeError(t+" is not a function");var e,n=Object(this),r=n.length>>>0,i=0;if(2<=arguments.length)e=arguments[1];else{for(;i<r&&!(i in n);)i++;if(r<=i)throw new TypeError("Reduce of empty array with no initial value");e=n[i++]}for(;i<r;)i in n&&(e=t(e,n[i],i,n)),i++;return e}}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(null==this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(t){if(null==this)throw new TypeError('"this" is null or not defined');var e=Object(this),n=e.length>>>0;if("function"!=typeof t)throw new TypeError("predicate must be a function");for(var r=arguments[1],i=0;i<n;){var a=e[i];if(t.call(r,a,i,e))return a;i++}},configurable:!0,writable:!0}),"function"!=typeof Object.create&&(Object.create=function(t,e){if(t!==Object(t)&&null!==t)throw TypeError("Argument must be an object, or null");f.prototype=t||{},void 0!==e&&Object.defineProperties(f.prototype,e);var n=new f;return(f.prototype=null)===t&&(n.__proto__=null),n}),Object.keys||(Object.keys=(s=Object.prototype.hasOwnProperty,u=!{toString:null}.propertyIsEnumerable("toString"),c=(l=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"]).length,function(t){if("object"!==on(t)&&("function"!=typeof t||null===t))throw new TypeError;var e,n,r=[];for(e in t)s.call(t,e)&&r.push(e);if(u)for(n=0;n<c;n++)s.call(t,l[n])&&r.push(l[n]);return r})),Object.values||(Object.values=function(t){var e=[];for(var n in t)t.hasOwnProperty(n)&&t.propertyIsEnumerable(n)&&e.push(t[n]);return e}),"function"!=typeof Object.assign&&(Object.assign=function(t){var e=arguments;if(null==t)throw new TypeError("Cannot convert undefined or null to object");t=Object(t);for(var n=1;n<arguments.length;n++){var r=e[n];if(null!=r)for(var i in r)Object.prototype.hasOwnProperty.call(r,i)&&(t[i]=r[i])}return t}),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")}),Number.isInteger=Number.isInteger||function(t){return"number"==typeof t&&isFinite(t)&&Math.floor(t)===t}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());var sn,t,e,a,n,r,i,o,s,f,u,l,P,k,F,d,p,g,m,b,v,c,y,w,h,x,N,L,A,_,S,C,I,j,B,O,E,M,T,q,R,D,U=(sn="undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")(),ln.API={events:[]},ln.version="2.1.1","function"==typeof define&&define.amd?define(function(){return ln}):"undefined"!=typeof module&&module.exports?(module.exports=ln,module.exports.jsPDF=ln):sn.jsPDF=ln,ln);
/**
   * @license
   * Copyright (c) 2016 Alexander Weidt,
   * https://github.com/BiggA94
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */function un(a){if("object"!==on(a))throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");var o={};this.subscribe=function(t,e,n){if(n=n||!1,"string"!=typeof t||"function"!=typeof e||"boolean"!=typeof n)throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");o.hasOwnProperty(t)||(o[t]={});var r=Math.random().toString(35);return o[t][r]=[e,!!n],r},this.unsubscribe=function(t){for(var e in o)if(o[e][t])return delete o[e][t],0===Object.keys(o[e]).length&&delete o[e],!0;return!1},this.publish=function(t){if(o.hasOwnProperty(t)){var e=Array.prototype.slice.call(arguments,1),n=[];for(var r in o[t]){var i=o[t][r];try{i[0].apply(a,e)}catch(t){sn.console&&console.error("jsPDF PubSub Error",t.message,t)}i[1]&&n.push(r)}n.length&&n.forEach(this.unsubscribe)}},this.getTopics=function(){return o}}function ln(t){var r,a="string"==typeof arguments[0]?arguments[0]:"p",e=arguments[1],o=arguments[2],n=arguments[3],i=[],s=1,u=16,l="S";"object"===on(t=t||{})&&(a=t.orientation,e=t.unit||e,o=t.format||o,n=t.compress||t.compressPdf||n,s="number"==typeof t.userUnit?Math.abs(t.userUnit):1,void 0!==t.precision&&(r=t.precision),void 0!==t.floatPrecision&&(u=t.floatPrecision),l=t.defaultPathOperation||"S"),i=t.filters||(!0===n?["FlateEncode"]:i),e=e||"mm",a=(""+(a||"P")).toLowerCase();var c=t.putOnlyUsedFonts||!1,et={},h={internal:{},__private__:{}};h.__private__.PubSub=un;var f="1.3",d=h.__private__.getPdfVersion=function(){return f};h.__private__.setPdfVersion=function(t){f=t};var p={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};h.__private__.getPageFormats=function(){return p};var g=h.__private__.getPageFormat=function(t){return p[t]};o=o||"a4";var m="compat",nt="advanced",rt=m;function b(){this.saveGraphicsState(),st(new Ft(tt,0,0,-tt,0,rn()*tt).toString()+" cm"),this.setFontSize(this.getFontSize()/tt),l="n",rt=nt}function v(){this.restoreGraphicsState(),l="S",rt=m}h.advancedAPI=function(t){var e=rt===m;return e&&b.call(this),"function"!=typeof t||(t(this),e&&v.call(this)),this},h.compatAPI=function(t){var e=rt===nt;return e&&v.call(this),"function"!=typeof t||(t(this),e&&b.call(this)),this},h.isAdvancedAPI=function(){return rt===nt};function it(t){if(rt!==nt)throw new Error(t+" is only available in 'advanced' API mode. You need to call advancedAPI() first.")}var at,y=h.roundToPrecision=h.__private__.roundToPrecision=function(t,e){var n=r||e;if(isNaN(t)||isNaN(n))throw new Error("Invalid argument passed to jsPDF.roundToPrecision");return t.toFixed(n).replace(/0+$/,"")};at=h.hpf=h.__private__.hpf="number"==typeof u?function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return y(t,u)}:"smart"===u?function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return y(t,-1<t&&t<1?16:5)}:function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return y(t,16)};function w(t){return ot(function(t){return rt===m?rn()-t:rt===nt?t:void 0}(t))}var x=h.f2=h.__private__.f2=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return y(t,2)},N=h.__private__.f3=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f3");return y(t,3)},ot=h.scale=h.__private__.scale=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.scale");return rt===m?t*tt:rt===nt?t:void 0};h.__private__.setPrecision=h.setPrecision=function(t){"number"==typeof parseInt(t,10)&&(r=parseInt(t,10))};var L,A="00000000000000000000000000000000",_=h.__private__.getFileId=function(){return A},S=h.__private__.setFileId=function(t){return A=void 0!==t&&/^[a-fA-F0-9]{32}$/.test(t)?t.toUpperCase():A.split("").map(function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))}).join("")};h.setFileId=function(t){return S(t),this},h.getFileId=function(){return _()};var P=h.__private__.convertDateToPDFDate=function(t){var e=t.getTimezoneOffset(),n=e<0?"+":"-",r=Math.floor(Math.abs(e/60)),i=Math.abs(e%60),a=[n,j(r),"'",j(i),"'"].join("");return["D:",t.getFullYear(),j(t.getMonth()+1),j(t.getDate()),j(t.getHours()),j(t.getMinutes()),j(t.getSeconds()),a].join("")},k=h.__private__.convertPDFDateToDate=function(t){var e=parseInt(t.substr(2,4),10),n=parseInt(t.substr(6,2),10)-1,r=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),a=parseInt(t.substr(12,2),10),o=parseInt(t.substr(14,2),10);return new Date(e,n,r,i,a,o,0)},F=h.__private__.setCreationDate=function(t){var e;if(void 0===t&&(t=new Date),t instanceof Date)e=P(t);else{if(!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t))throw new Error("Invalid argument passed to jsPDF.setCreationDate");e=t}return L=e},C=h.__private__.getCreationDate=function(t){var e=L;return"jsDate"===t&&(e=k(L)),e};h.setCreationDate=function(t){return F(t),this},h.getCreationDate=function(t){return C(t)};var I,j=h.__private__.padd2=function(t){return("0"+parseInt(t)).slice(-2)},B=h.__private__.padd2Hex=function(t){return("00"+(t=t.toString())).substr(t.length)},O=0,E=[],M=[],T=0,q=[],R=[],D=!1,U=M;h.__private__.setCustomOutputDestination=function(t){D=!0,U=t};function z(t){D||(U=t)}h.__private__.resetCustomOutputDestination=function(){D=!1,U=M};var st=h.__private__.out=function(t){return t=t.toString(),T+=t.length+1,U.push(t),U},H=h.__private__.write=function(t){return st(1===arguments.length?t.toString():Array.prototype.join.call(arguments," "))},W=h.__private__.getArrayBuffer=function(t){for(var e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},V=[["Helvetica","helvetica","normal","WinAnsiEncoding"],["Helvetica-Bold","helvetica","bold","WinAnsiEncoding"],["Helvetica-Oblique","helvetica","italic","WinAnsiEncoding"],["Helvetica-BoldOblique","helvetica","bolditalic","WinAnsiEncoding"],["Courier","courier","normal","WinAnsiEncoding"],["Courier-Bold","courier","bold","WinAnsiEncoding"],["Courier-Oblique","courier","italic","WinAnsiEncoding"],["Courier-BoldOblique","courier","bolditalic","WinAnsiEncoding"],["Times-Roman","times","normal","WinAnsiEncoding"],["Times-Bold","times","bold","WinAnsiEncoding"],["Times-Italic","times","italic","WinAnsiEncoding"],["Times-BoldItalic","times","bolditalic","WinAnsiEncoding"],["ZapfDingbats","zapfdingbats","normal",null],["Symbol","symbol","normal",null]];h.__private__.getStandardFonts=function(){return V};var ut=t.fontSize||16;h.__private__.setFontSize=h.setFontSize=function(t){return ut=rt===nt?t/tt:t,this};var G,Y=h.__private__.getFontSize=h.getFontSize=function(){return rt===m?ut:ut*tt},lt=t.R2L||!1;h.__private__.setR2L=h.setR2L=function(t){return lt=t,this},h.__private__.getR2L=h.getR2L=function(){return lt};var J,X=h.__private__.setZoomMode=function(t){var e=[void 0,null,"fullwidth","fullheight","fullpage","original"];if(/^\d*\.?\d*%$/.test(t))G=t;else if(isNaN(t)){if(-1===e.indexOf(t))throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "'+t+'" is not recognized.');G=t}else G=parseInt(t,10)};h.__private__.getZoomMode=function(){return G};var K,Z=h.__private__.setPageMode=function(t){if(-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(t))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+t+'" is not recognized.');J=t};h.__private__.getPageMode=function(){return J};var $=h.__private__.setLayoutMode=function(t){if(-1==[void 0,null,"continuous","single","twoleft","tworight","two"].indexOf(t))throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "'+t+'" is not recognized.');K=t};h.__private__.getLayoutMode=function(){return K},h.__private__.setDisplayMode=h.setDisplayMode=function(t,e,n){return X(t),$(e),Z(n),this};var Q={title:"",subject:"",author:"",keywords:"",creator:""};h.__private__.getDocumentProperty=function(t){if(-1===Object.keys(Q).indexOf(t))throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");return Q[t]},h.__private__.getDocumentProperties=function(){return Q},h.__private__.setDocumentProperties=h.setProperties=h.setDocumentProperties=function(t){for(var e in Q)Q.hasOwnProperty(e)&&t[e]&&(Q[e]=t[e]);return this},h.__private__.setDocumentProperty=function(t,e){if(-1===Object.keys(Q).indexOf(t))throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");return Q[t]=e};var ct,tt,ht,ft,dt,pt={},gt={},mt=[],bt={},vt={},yt={},wt={},xt=null,Nt=0,Lt=[],At=new un(h),_t=t.hotfixes||[],St={},Pt={},kt=[],Ft=function(t,e,n,r,i,a){var o=[];return Object.defineProperty(this,"sx",{get:function(){return o[0]},set:function(t){o[0]=t}}),Object.defineProperty(this,"shy",{get:function(){return o[1]},set:function(t){o[1]=t}}),Object.defineProperty(this,"shx",{get:function(){return o[2]},set:function(t){o[2]=t}}),Object.defineProperty(this,"sy",{get:function(){return o[3]},set:function(t){o[3]=t}}),Object.defineProperty(this,"tx",{get:function(){return o[4]},set:function(t){o[4]=t}}),Object.defineProperty(this,"ty",{get:function(){return o[5]},set:function(t){o[5]=t}}),Object.defineProperty(this,"a",{get:function(){return o[0]},set:function(t){o[0]=t}}),Object.defineProperty(this,"b",{get:function(){return o[1]},set:function(t){o[1]=t}}),Object.defineProperty(this,"c",{get:function(){return o[2]},set:function(t){o[2]=t}}),Object.defineProperty(this,"d",{get:function(){return o[3]},set:function(t){o[3]=t}}),Object.defineProperty(this,"e",{get:function(){return o[4]},set:function(t){o[4]=t}}),Object.defineProperty(this,"f",{get:function(){return o[5]},set:function(t){o[5]=t}}),Object.defineProperty(this,"rotation",{get:function(){return Math.atan2(this.shx,this.sx)}}),Object.defineProperty(this,"scaleX",{get:function(){return this.decompose().scale.sx}}),Object.defineProperty(this,"scaleY",{get:function(){return this.decompose().scale.sy}}),Object.defineProperty(this,"isIdentity",{get:function(){return 1===this.sx&&(0===this.shy&&(0===this.shx&&(1===this.sy&&(0===this.tx&&0===this.ty))))}}),this.sx=isNaN(t)?1:t,this.shy=isNaN(e)?0:e,this.shx=isNaN(n)?0:n,this.sy=isNaN(r)?1:r,this.tx=isNaN(i)?0:i,this.ty=isNaN(a)?0:a,this};Ft.prototype.join=function(t){return[this.sx,this.shy,this.shx,this.sy,this.tx,this.ty].map(at).join(t)},Ft.prototype.multiply=function(t){var e=t.sx*this.sx+t.shy*this.shx,n=t.sx*this.shy+t.shy*this.sy,r=t.shx*this.sx+t.sy*this.shx,i=t.shx*this.shy+t.sy*this.sy,a=t.tx*this.sx+t.ty*this.shx+this.tx,o=t.tx*this.shy+t.ty*this.sy+this.ty;return new Ft(e,n,r,i,a,o)},Ft.prototype.decompose=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,a=this.ty,o=Math.sqrt(t*t+e*e),s=(t/=o)*n+(e/=o)*r;n-=t*s,r-=e*s;var u=Math.sqrt(n*n+r*r);return s/=u,t*(r/=u)<e*(n/=u)&&(t=-t,e=-e,s=-s,o=-o),{scale:new Ft(o,0,0,u,0,0),translate:new Ft(1,0,0,1,i,a),rotate:new Ft(t,e,-e,t,0,0),skew:new Ft(1,0,s,1,0,0)}},Ft.prototype.toString=function(t){return this.join(" ")},Ft.prototype.inversed=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,a=this.ty,o=1/(t*r-e*n),s=r*o,u=-e*o,l=-n*o,c=t*o;return new Ft(s,u,l,c,-s*i-l*a,-u*i-c*a)},Ft.prototype.applyToPoint=function(t){var e=t.x*this.sx+t.y*this.shx+this.tx,n=t.x*this.shy+t.y*this.sy+this.ty;return new Ze(e,n)},Ft.prototype.applyToRectangle=function(t){var e=this.applyToPoint(t),n=this.applyToPoint(new Ze(t.x+t.w,t.y+t.h));return new $e(e.x,e.y,n.x-e.x,n.y-e.y)},Ft.prototype.clone=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,a=this.ty;return new Ft(t,e,n,r,i,a)},h.Matrix=Ft;var Ct=h.matrixMult=function(t,e){return e.multiply(t)},It=new Ft(1,0,0,1,0,0);h.unitMatrix=h.identityMatrix=It;function jt(t,e){this.gState=t,this.matrix=e,this.id="",this.objectNumber=-1}function Bt(t,e){if(!vt[t]){var n=(e instanceof h.ShadingPattern?"Sh":"P")+(Object.keys(bt).length+1).toString(10);e.id=n,vt[t]=n,bt[n]=e,At.publish("addPattern",e)}}h.ShadingPattern=function(t,e,n,r,i){it("ShadingPattern"),this.type="axial"===t?2:3,this.coords=e,this.colors=n,jt.call(this,r,i)},h.TilingPattern=function(t,e,n,r,i){it("TilingPattern"),this.boundingBox=t,this.xStep=e,this.yStep=n,this.stream="",this.cloneIndex=0,jt.call(this,r,i)},h.TilingPattern.prototype={createClone:function(t,e,n,r,i){var a=new h.TilingPattern(e||this.boundingBox,n||this.xStep,r||this.yStep,this.gState,i||this.matrix);a.stream=this.stream;var o=t+"$$"+this.cloneIndex+++"$$";return Bt(o,a),a}},h.addShadingPattern=function(t,e){return it("addShadingPattern()"),Bt(t,e),this},h.beginTilingPattern=function(t){it("beginTilingPattern()"),Qe(t.boundingBox[0],t.boundingBox[1],t.boundingBox[2]-t.boundingBox[0],t.boundingBox[3]-t.boundingBox[1],t.matrix)},h.endTilingPattern=function(t,e){it("endTilingPattern()"),e.stream=R[I].join("\n"),Bt(t,e),At.publish("endTilingPattern",e),kt.pop().restore()};function Ot(t){t.objectNumber=Gt();var e=[];e.push({key:"Type",value:"/XObject"}),e.push({key:"Subtype",value:"/Form"}),e.push({key:"BBox",value:"["+[at(t.x),at(t.y),at(t.x+t.width),at(t.y+t.height)].join(" ")+"]"}),e.push({key:"Matrix",value:"["+t.matrix.toString()+"]"});var n=t.pages[1].join("\n");ee({data:n,additionalKeyValues:e}),st("endobj")}function Et(t,e){e||(e=21);var n=Gt(),r=function(t,e){var n,r=[],i=1/(e-1);for(n=0;n<1;n+=i)r.push(n);if(r.push(1),0!=t[0].offset){var a={offset:0,color:t[0].color};t.unshift(a)}if(1!=t[t.length-1].offset){var o={offset:1,color:t[t.length-1].color};t.push(o)}for(var s="",u=0,l=0;l<r.length;l++){for(n=r[l];n>t[u+1].offset;)u++;var c=t[u].offset,h=(n-c)/(t[u+1].offset-c),f=t[u].color,d=t[u+1].color;s+=B(Math.round((1-h)*f[0]+h*d[0]).toString(16))+B(Math.round((1-h)*f[1]+h*d[1]).toString(16))+B(Math.round((1-h)*f[2]+h*d[2]).toString(16))}return s.trim()}(t.colors,e),i=[];i.push({key:"FunctionType",value:"0"}),i.push({key:"Domain",value:"[0.0 1.0]"}),i.push({key:"Size",value:"["+e+"]"}),i.push({key:"BitsPerSample",value:"8"}),i.push({key:"Range",value:"[0.0 1.0 0.0 1.0 0.0 1.0]"}),i.push({key:"Decode",value:"[0.0 1.0 0.0 1.0 0.0 1.0]"}),ee({data:r,additionalKeyValues:i,alreadyAppliedFilters:["/ASCIIHexDecode"]}),st("endobj"),t.objectNumber=Gt(),st("<< /ShadingType "+t.type),st("/ColorSpace /DeviceRGB");var a="/Coords ["+at(parseFloat(t.coords[0]))+" "+at(parseFloat(t.coords[1]))+" ";2===t.type?a+=at(parseFloat(t.coords[2]))+" "+at(parseFloat(t.coords[3])):a+=at(parseFloat(t.coords[2]))+" "+at(parseFloat(t.coords[3]))+" "+at(parseFloat(t.coords[4]))+" "+at(parseFloat(t.coords[5])),st(a+="]"),t.matrix&&st("/Matrix ["+t.matrix.toString()+"]"),st("/Function "+n+" 0 R"),st("/Extend [true true]"),st(">>"),st("endobj")}function Mt(t,e){var n=Yt(),r=Gt();e.push({resourcesOid:n,objectOid:r}),t.objectNumber=r;var i=[];i.push({key:"Type",value:"/Pattern"}),i.push({key:"PatternType",value:"1"}),i.push({key:"PaintType",value:"1"}),i.push({key:"TilingType",value:"1"}),i.push({key:"BBox",value:"["+t.boundingBox.map(at).join(" ")+"]"}),i.push({key:"XStep",value:at(t.xStep)}),i.push({key:"YStep",value:at(t.yStep)}),i.push({key:"Resources",value:n+" 0 R"}),t.matrix&&i.push({key:"Matrix",value:"["+t.matrix.toString()+"]"}),ee({data:t.stream,additionalKeyValues:i}),st("endobj")}function Tt(t){for(var e in t.objectNumber=Gt(),st("<<"),t)switch(e){case"opacity":st("/ca "+x(t[e]));break;case"stroke-opacity":st("/CA "+x(t[e]))}st(">>"),st("endobj")}function qt(t){Jt(t.resourcesOid,!0),st("<<"),st("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),function(){for(var t in st("/Font <<"),pt)!pt.hasOwnProperty(t)||(!1===c||!0===c&&et.hasOwnProperty(t))&&st("/"+t+" "+pt[t].objectNumber+" 0 R");st(">>")}(),function(){if(0<Object.keys(bt).length){for(var t in st("/Shading <<"),bt)bt.hasOwnProperty(t)&&bt[t]instanceof h.ShadingPattern&&0<=bt[t].objectNumber&&st("/"+t+" "+bt[t].objectNumber+" 0 R");At.publish("putShadingPatternDict"),st(">>")}}(),function(t){if(0<Object.keys(bt).length){for(var e in st("/Pattern <<"),bt)bt.hasOwnProperty(e)&&bt[e]instanceof h.TilingPattern&&0<=bt[e].objectNumber&&bt[e].objectNumber<t&&st("/"+e+" "+bt[e].objectNumber+" 0 R");At.publish("putTilingPatternDict"),st(">>")}}(t.objectOid),function(){if(0<Object.keys(yt).length){var t;for(t in st("/ExtGState <<"),yt)yt.hasOwnProperty(t)&&0<=yt[t].objectNumber&&st("/"+t+" "+yt[t].objectNumber+" 0 R");At.publish("putGStateDict"),st(">>")}}(),function(){for(var t in st("/XObject <<"),St)St.hasOwnProperty(t)&&0<=St[t].objectNumber&&st("/"+t+" "+St[t].objectNumber+" 0 R");At.publish("putXobjectDict"),st(">>")}(),st(">>"),st("endobj")}function Rt(){var t=[];!function(){for(var t in pt)!pt.hasOwnProperty(t)||(!1===c||!0===c&&et.hasOwnProperty(t))&&(n=pt[t],At.publish("putFont",{font:n,out:st,newObject:Gt,putStream:ee,pdfEscapeWithNeededParanthesis:e}),!0!==n.isAlreadyPutted&&(n.objectNumber=Gt(),st("<<"),st("/Type /Font"),st("/BaseFont /"+e(n.postScriptName)),st("/Subtype /Type1"),"string"==typeof n.encoding&&st("/Encoding /"+n.encoding),st("/FirstChar 32"),st("/LastChar 255"),st(">>"),st("endobj")));function e(t,e){return-1!==t.indexOf(" ")?"("+ie(t,e)+")":ie(t,e)}var n}(),function(){var t;for(t in yt)yt.hasOwnProperty(t)&&Tt(yt[t])}(),function(){for(var t in St)St.hasOwnProperty(t)&&Ot(St[t])}(),function(t){var e;for(e in bt)bt.hasOwnProperty(e)&&(bt[e]instanceof h.ShadingPattern?Et(bt[e]):bt[e]instanceof h.TilingPattern&&Mt(bt[e],t))}(t),At.publish("putResources"),t.forEach(qt),qt({resourcesOid:Zt,objectOid:Number.MAX_SAFE_INTEGER}),At.publish("postPutResources")}function Dt(t){gt[t.fontName]=gt[t.fontName]||{},gt[t.fontName][t.fontStyle]=t.id}function Ut(t,e,n,r,i){var a={id:"F"+(Object.keys(pt).length+1).toString(10),postScriptName:t,fontName:e,fontStyle:n,encoding:r,isStandardFont:i||!1,metadata:{}};return At.publish("addFont",{font:a,instance:this}),pt[a.id]=a,Dt(a),a.id}function zt(t,e){var n,r,i;switch(a=e||a,"string"==typeof t&&(n=g(t.toLowerCase()),Array.isArray(n)&&(r=n[0],i=n[1])),Array.isArray(t)&&(r=t[0]*tt,i=t[1]*tt),isNaN(r)&&(r=o[0],i=o[1]),(14400<r||14400<i)&&(console.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"),r=Math.min(14400,r),i=Math.min(14400,i)),o=[r,i],a.substr(0,1)){case"l":r<i&&(o=[i,r]);break;case"p":i<r&&(o=[i,r])}ae(o),Be(je),st(Ue),0!==Ye&&st(Ye+" J"),0!==Je&&st(Je+" j"),At.publish("addPage",{pageNumber:Nt})}function Ht(t,e,n){var r,i=void 0;return n=n||{},t=void 0!==t?t:pt[ct].fontName,e=void 0!==e?e:pt[ct].fontStyle,r=t.toLowerCase(),void 0!==gt[r]&&void 0!==gt[r][e]?i=gt[r][e]:void 0!==gt[t]&&void 0!==gt[t][e]?i=gt[t][e]:!1===n.disableWarning&&console.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),i||n.noFallback||null==(i=gt.times[e])&&(i=gt.times.normal),i}function Wt(t){return!0===Array.isArray(_t)&&-1<_t.indexOf(t)}var Vt,Gt=h.__private__.newObject=function(){var t=Yt();return Jt(t,!0),t},Yt=h.__private__.newObjectDeferred=function(){return E[++O]=function(){return T},O},Jt=function(t,e){return e="boolean"==typeof e&&e,E[t]=T,e&&st(t+" 0 obj"),t},Xt=h.__private__.newAdditionalObject=function(){var t={objId:Yt(),content:""};return q.push(t),t},Kt=Yt(),Zt=Yt(),$t=h.__private__.decodeColorString=function(t){var e=t.split(" ");if(2!==e.length||"g"!==e[1]&&"G"!==e[1]){if(5===e.length&&("k"===e[4]||"K"===e[4])){e=[(1-e[0])*(1-e[3]),(1-e[1])*(1-e[3]),(1-e[2])*(1-e[3]),"r"]}}else{var n=parseFloat(e[0]);e=[n,n,n,"r"]}for(var r="#",i=0;i<3;i++)r+=("0"+Math.floor(255*parseFloat(e[i])).toString(16)).slice(-2);return r},Qt=h.__private__.encodeColorString=function(t){var e;"string"==typeof t&&(t={ch1:t});var n=t.ch1,r=t.ch2,i=t.ch3,a=t.ch4,o="draw"===t.pdfColorType?["G","RG","K"]:["g","rg","k"];if("string"==typeof n&&"#"!==n.charAt(0)){var s=new RGBColor(n);if(s.ok)n=s.toHex();else if(!/^\d*\.?\d*$/.test(n))throw new Error('Invalid color "'+n+'" passed to jsPDF.encodeColorString.')}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var u=parseInt(n.substr(1),16);n=u>>16&255,r=u>>8&255,i=255&u}if(void 0===r||void 0===a&&n===r&&r===i)if("string"==typeof n)e=n+" "+o[0];else switch(t.precision){case 2:e=x(n/255)+" "+o[0];break;case 3:default:e=N(n/255)+" "+o[0]}else if(void 0===a||"object"===on(a)){if(a&&!isNaN(a.a)&&0===a.a)return e=["1.","1.","1.",o[1]].join(" ");if("string"==typeof n)e=[n,r,i,o[1]].join(" ");else switch(t.precision){case 2:e=[x(n/255),x(r/255),x(i/255),o[1]].join(" ");break;default:case 3:e=[N(n/255),N(r/255),N(i/255),o[1]].join(" ")}}else if("string"==typeof n)e=[n,r,i,a,o[2]].join(" ");else switch(t.precision){case 2:e=[x(n),x(r),x(i),x(a),o[2]].join(" ");break;case 3:default:e=[N(n),N(r),N(i),N(a),o[2]].join(" ")}return e},te=h.__private__.getFilters=function(){return i},ee=h.__private__.putStream=function(t){var e=(t=t||{}).data||"",n=t.filters||te(),r=t.alreadyAppliedFilters||[],i=t.addLength1||!1,a=e.length,o={};!0===n&&(n=["FlateEncode"]);var s=t.additionalKeyValues||[],u=(o=void 0!==ln.API.processDataByFilters?ln.API.processDataByFilters(e,n):{data:e,reverseChain:[]}).reverseChain+(Array.isArray(r)?r.join(" "):r.toString());if(0!==o.data.length&&(s.push({key:"Length",value:o.data.length}),!0===i&&s.push({key:"Length1",value:a})),0!=u.length)if(u.split("/").length-1==1)s.push({key:"Filter",value:u});else{s.push({key:"Filter",value:"["+u+"]"});for(var l=0;l<s.length;l+=1)if("DecodeParms"===s[l].key){for(var c=[],h=0;h<o.reverseChain.split("/").length-1;h+=1)c.push("null");c.push(s[l].value),s[l].value="["+c.join(" ")+"]"}}st("<<");for(var f=0;f<s.length;f++)st("/"+s[f].key+" "+s[f].value);st(">>"),0!==o.data.length&&(st("stream"),st(o.data),st("endstream"))},ne=h.__private__.putPage=function(t){var e=t.number,n=t.data,r=t.objId,i=t.contentsObjId;Jt(r,!0),st("<</Type /Page"),st("/Parent "+t.rootDictionaryObjId+" 0 R"),st("/Resources "+t.resourceDictionaryObjId+" 0 R"),st("/MediaBox ["+parseFloat(at(t.mediaBox.bottomLeftX))+" "+parseFloat(at(t.mediaBox.bottomLeftY))+" "+at(t.mediaBox.topRightX)+" "+at(t.mediaBox.topRightY)+"]"),null!==t.cropBox&&st("/CropBox ["+at(t.cropBox.bottomLeftX)+" "+at(t.cropBox.bottomLeftY)+" "+at(t.cropBox.topRightX)+" "+at(t.cropBox.topRightY)+"]"),null!==t.bleedBox&&st("/BleedBox ["+at(t.bleedBox.bottomLeftX)+" "+at(t.bleedBox.bottomLeftY)+" "+at(t.bleedBox.topRightX)+" "+at(t.bleedBox.topRightY)+"]"),null!==t.trimBox&&st("/TrimBox ["+at(t.trimBox.bottomLeftX)+" "+at(t.trimBox.bottomLeftY)+" "+at(t.trimBox.topRightX)+" "+at(t.trimBox.topRightY)+"]"),null!==t.artBox&&st("/ArtBox ["+at(t.artBox.bottomLeftX)+" "+at(t.artBox.bottomLeftY)+" "+at(t.artBox.topRightX)+" "+at(t.artBox.topRightY)+"]"),"number"==typeof t.userUnit&&1!==t.userUnit&&st("/UserUnit "+t.userUnit),At.publish("putPage",{objId:r,pageContext:Lt[e],pageNumber:e,page:n}),st("/Contents "+i+" 0 R"),st(">>"),st("endobj");var a=n.join("\n");return rt===nt&&(a+="\nQ"),Jt(i,!0),ee({data:a,filters:te()}),st("endobj"),r},re=h.__private__.putPages=function(){var t,e,n=[];for(t=1;t<=Nt;t++)Lt[t].objId=Yt(),Lt[t].contentsObjId=Yt();for(t=1;t<=Nt;t++)n.push(ne({number:t,data:R[t],objId:Lt[t].objId,contentsObjId:Lt[t].contentsObjId,mediaBox:Lt[t].mediaBox,cropBox:Lt[t].cropBox,bleedBox:Lt[t].bleedBox,trimBox:Lt[t].trimBox,artBox:Lt[t].artBox,userUnit:Lt[t].userUnit,rootDictionaryObjId:Kt,resourceDictionaryObjId:Zt}));Jt(Kt,!0),st("<</Type /Pages");var r="/Kids [";for(e=0;e<Nt;e++)r+=n[e]+" 0 R ";st(r+"]"),st("/Count "+Nt),st(">>"),st("endobj"),At.publish("postPutPages")},ie=h.__private__.pdfEscape=h.pdfEscape=function(t,e){return function(t,e){var n,r,i,a,o,s,u,l,c;if(i=(e=e||{}).sourceEncoding||"Unicode",o=e.outputEncoding,(e.autoencode||o)&&pt[ct].metadata&&pt[ct].metadata[i]&&pt[ct].metadata[i].encoding&&(a=pt[ct].metadata[i].encoding,!o&&pt[ct].encoding&&(o=pt[ct].encoding),!o&&a.codePages&&(o=a.codePages[0]),"string"==typeof o&&(o=a[o]),o)){for(u=!1,s=[],n=0,r=t.length;n<r;n++)(l=o[t.charCodeAt(n)])?s.push(String.fromCharCode(l)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(u=!0);t=s.join("")}for(n=t.length;void 0===u&&0!==n;)t.charCodeAt(n-1)>>8&&(u=!0),n--;if(!u)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if((c=(l=t.charCodeAt(n))>>8)>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(c),s.push(l-(c<<8))}return String.fromCharCode.apply(void 0,s)}(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},ae=h.__private__.beginPage=function(t){R[++Nt]=[],Lt[Nt]={objId:0,contentsObjId:0,userUnit:Number(s),artBox:null,bleedBox:null,cropBox:null,trimBox:null,mediaBox:{bottomLeftX:0,bottomLeftY:0,topRightX:Number(t[0]),topRightY:Number(t[1])}},oe(Nt),z(R[I])},oe=function(t){0<t&&t<=Nt&&(I=t)},se=h.__private__.getNumberOfPages=h.getNumberOfPages=function(){return R.length-1},ue=h.__private__.putInfo=function(){for(var t in Gt(),st("<<"),st("/Producer (jsPDF "+ln.version+")"),Q)Q.hasOwnProperty(t)&&Q[t]&&st("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+ie(Q[t])+")");st("/CreationDate ("+L+")"),st(">>"),st("endobj")},le=h.__private__.putCatalog=function(t){var e=(t=t||{}).rootDictionaryObjId||Kt;switch(Gt(),st("<<"),st("/Type /Catalog"),st("/Pages "+e+" 0 R"),G||(G="fullwidth"),G){case"fullwidth":st("/OpenAction [3 0 R /FitH null]");break;case"fullheight":st("/OpenAction [3 0 R /FitV null]");break;case"fullpage":st("/OpenAction [3 0 R /Fit]");break;case"original":st("/OpenAction [3 0 R /XYZ null null 1]");break;default:var n=""+G;"%"===n.substr(n.length-1)&&(G=parseInt(G)/100),"number"==typeof G&&st("/OpenAction [3 0 R /XYZ null null "+x(G)+"]")}switch(K||(K="continuous"),K){case"continuous":st("/PageLayout /OneColumn");break;case"single":st("/PageLayout /SinglePage");break;case"two":case"twoleft":st("/PageLayout /TwoColumnLeft");break;case"tworight":st("/PageLayout /TwoColumnRight")}J&&st("/PageMode /"+J),At.publish("putCatalog"),st(">>"),st("endobj")},ce=h.__private__.putTrailer=function(){st("trailer"),st("<<"),st("/Size "+(O+1)),st("/Root "+O+" 0 R"),st("/Info "+(O-1)+" 0 R"),st("/ID [ <"+A+"> <"+A+"> ]"),st(">>")},he=h.__private__.putHeader=function(){st("%PDF-"+f),st("%ºß¬à")},fe=h.__private__.putXRef=function(){var t="0000000000";st("xref"),st("0 "+(O+1)),st("0000000000 65535 f");for(var e=1;e<=O;e++){"function"==typeof E[e]?st((t+E[e]()).slice(-10)+" 00000 n"):void 0!==E[e]?st((t+E[e]).slice(-10)+" 00000 n"):st("0000000000 00000 n")}},de=h.__private__.buildDocument=function(){T=O=0,M=[],E=[],q=[],Kt=Yt(),Zt=Yt(),z(M),At.publish("buildDocument"),he(),re(),function(){At.publish("putAdditionalObjects");for(var t=0;t<q.length;t++){var e=q[t];Jt(e.objId,!0),st(e.content),st("endobj")}At.publish("postPutAdditionalObjects")}(),Rt(),ue(),le();var t=T;return fe(),ce(),st("startxref"),st(""+t),st("%%EOF"),z(R[I]),M.join("\n")},pe=h.__private__.getBlob=function(t){return new Blob([W(t)],{type:"application/pdf"})},ge=h.output=h.__private__.output=((Vt=function(t,e){switch("string"==typeof(e=e||{})?e={filename:e}:e.filename=e.filename||"generated.pdf",t){case void 0:return de();case"save":h.save(e.filename);break;case"arraybuffer":return W(de());case"blob":return pe(de());case"bloburi":case"bloburl":if(void 0!==sn.URL&&"function"==typeof sn.URL.createObjectURL)return sn.URL&&sn.URL.createObjectURL(pe(de()))||void 0;console.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");break;case"datauristring":case"dataurlstring":var n="",r=de();try{n=btoa(r)}catch(t){n=btoa(unescape(encodeURIComponent(r)))}return"data:application/pdf;filename="+e.filename+";base64,"+n;case"pdfobjectnewwindow":if("[object Window]"!==Object.prototype.toString.call(sn))throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");var i='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="'+(e.pdfObjectUrl||"https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js")+'"><\/script><script >PDFObject.embed("'+this.output("dataurlstring")+'", '+JSON.stringify(e)+");<\/script></body></html>",a=sn.open();return null!==a&&a.document.write(i),a;case"pdfjsnewwindow":if("[object Window]"!==Object.prototype.toString.call(sn))throw new Error("The option pdfjsnewwindow just works in a browser-environment.");var o='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="'+(e.pdfJsUrl||"examples/PDF.js/web/viewer.html")+'?file=" width="500px" height="400px" /></body></html>',s=sn.open();if(null!==s){s.document.write(o);var u=this;s.document.documentElement.querySelector("#pdfViewer").onload=function(){s.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(u.output("bloburl"))}}return s;case"dataurlnewwindow":if("[object Window]"!==Object.prototype.toString.call(sn))throw new Error("The option dataurlnewwindow just works in a browser-environment.");var l='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="'+this.output("datauristring",e)+'"></iframe></body></html>',c=sn.open();if(null!==c&&c.document.write(l),c||"undefined"==typeof safari)return c;break;case"datauri":case"dataurl":return sn.document.location.href=this.output("datauristring",e);default:return null}}).foo=function(){try{return Vt.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var n="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!sn.console)throw new Error(n);sn.console.error(n,t),sn.alert&&alert(n)}},(Vt.foo.bar=Vt).foo);switch(e){case"pt":tt=1;break;case"mm":tt=72/25.4;break;case"cm":tt=72/2.54;break;case"in":tt=72;break;case"px":tt=1==Wt("px_scaling")?.75:96/72;break;case"pc":case"em":tt=12;break;case"ex":tt=6;break;default:throw new Error("Invalid unit: "+e)}F(),S();var me=h.__private__.getPageInfo=h.getPageInfo=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfo");return{objId:Lt[t].objId,pageNumber:t,pageContext:Lt[t]}},be=h.__private__.getPageInfoByObjId=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");for(var e in Lt)if(Lt[e].objId===t)break;return me(e)},ve=h.__private__.getCurrentPageInfo=h.getCurrentPageInfo=function(){return{objId:Lt[I].objId,pageNumber:I,pageContext:Lt[I]}};h.addPage=function(){return zt.apply(this,arguments),this},h.setPage=function(){return oe.apply(this,arguments),z.call(this,R[I]),this},h.insertPage=function(t){return this.addPage(),this.movePage(I,t),this},h.movePage=function(t,e){var n,r;if(e<t){n=R[t],r=Lt[t];for(var i=t;e<i;i--)R[i]=R[i-1],Lt[i]=Lt[i-1];R[e]=n,Lt[e]=r,this.setPage(e)}else if(t<e){n=R[t],r=Lt[t];for(var a=t;a<e;a++)R[a]=R[a+1],Lt[a]=Lt[a+1];R[e]=n,Lt[e]=r,this.setPage(e)}return this},h.deletePage=function(){return function(t){0<t&&t<=Nt&&(R.splice(t,1),Lt.splice(t,1),--Nt<I&&(I=Nt),this.setPage(I))}.apply(this,arguments),this},h.__private__.text=h.text=function(t,e,n,r,i){var a,o,s,u,l,c,h,f,d=(r=r||{}).scope||this;if("number"==typeof t&&"number"==typeof e&&("string"==typeof n||Array.isArray(n))){var p=n;n=e,e=t,t=p}if(arguments[3]instanceof Ft==!1?(h=arguments[3],s=i,u=arguments[5],"object"===on(h)&&null!==h||("string"==typeof s&&(u=s,s=null),"string"==typeof h&&(u=h,h=null),"number"==typeof h&&(s=h,h=null),r={flags:h,angle:s,align:u})):(it("The transform parameter of text() with a Matrix value"),f=i),isNaN(e)||isNaN(n)||null==t)throw new Error("Invalid arguments passed to jsPDF.text");if(0===t.length)return d;var g,m="",b="number"==typeof r.lineHeightFactor?r.lineHeightFactor:Ie,v=d.internal.scaleFactor;function y(t){for(var e,n=t.concat(),r=[],i=n.length;i--;)"string"==typeof(e=n.shift())?r.push(e):Array.isArray(t)&&(1===e.length||void 0===e[1]&&void 0===e[2])?r.push(e[0]):r.push([e[0],e[1],e[2]]);return r}function w(t,e){var n;if("string"==typeof t)n=e(t)[0];else if(Array.isArray(t)){for(var r,i,a=t.concat(),o=[],s=a.length;s--;)"string"==typeof(r=a.shift())?o.push(e(r)[0]):Array.isArray(r)&&"string"==typeof r[0]&&(i=e(r[0],r[1],r[2]),o.push([i[0],i[1],i[2]]));n=o}return n}var x=!1,N=!0;if("string"==typeof t)x=!0;else if(Array.isArray(t)){var L=t.concat();o=[];for(var A,_=L.length;_--;)("string"!=typeof(A=L.shift())||Array.isArray(A)&&"string"!=typeof A[0])&&(N=!1);x=N}if(!1===x)throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');"string"==typeof t&&(t=t.match(/[\r?\n]/)?t.split(/\r\n|\r|\n/g):[t]);var S=ut/d.internal.scaleFactor,P=S*(Ie-1);switch(r.baseline){case"bottom":n-=P;break;case"top":n+=S-P;break;case"hanging":n+=S-2*P;break;case"middle":n+=S/2-P}if(0<(c=r.maxWidth||0)&&("string"==typeof t?t=d.splitTextToSize(t,c):"[object Array]"===Object.prototype.toString.call(t)&&(t=d.splitTextToSize(t.join(" "),c))),a={text:t,x:e,y:n,options:r,mutex:{pdfEscape:ie,activeFontKey:ct,fonts:pt,activeFontSize:ut}},At.publish("preProcessText",a),t=a.text,s=(r=a.options).angle,f instanceof Ft==!1&&s&&"number"==typeof s){s*=Math.PI/180,0===r.rotationDirection&&(s=-s),rt===nt&&(s=-s);var k=Math.cos(s),F=Math.sin(s);f=new Ft(k,F,-F,k,0,0)}else s&&s instanceof Ft&&(f=s);rt!==nt||f||(f=It),void 0!==(l=r.charSpace||Ve)&&(m+=at(ot(l))+" Tc\n",this.setCharSpace(this.getCharSpace()||0));r.lang;var C=-1,I=void 0!==r.renderingMode?r.renderingMode:r.stroke,j=d.internal.getCurrentPageInfo().pageContext;switch(I){case 0:case!1:case"fill":C=0;break;case 1:case!0:case"stroke":C=1;break;case 2:case"fillThenStroke":C=2;break;case 3:case"invisible":C=3;break;case 4:case"fillAndAddForClipping":C=4;break;case 5:case"strokeAndAddPathForClipping":C=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":C=6;break;case 7:case"addToPathForClipping":C=7}var B=void 0!==j.usedRenderingMode?j.usedRenderingMode:-1;-1!==C?m+=C+" Tr\n":-1!==B&&(m+="0 Tr\n"),-1!==C&&(j.usedRenderingMode=C),u=r.align||"left";var O,E=ut*b,M=d.internal.pageSize.getWidth(),T=pt[ct];l=r.charSpace||Ve,c=r.maxWidth||0,h={};var q=[];if("[object Array]"===Object.prototype.toString.call(t)){var R;o=y(t),"left"!==u&&(O=o.map(function(t){return d.getStringUnitWidth(t,{font:T,charSpace:l,fontSize:ut,doKerning:!1})*ut/v}));var D,U=0;if("right"===u){e-=O[0],t=[],_=o.length;for(var z=0;z<_;z++)R=0===z?(D=Te(e),qe(n)):(D=ot(U-O[z]),-E),t.push([o[z],D,R]),U=O[z]}else if("center"===u){e-=O[0]/2,t=[],_=o.length;for(var H=0;H<_;H++)R=0===H?(D=Te(e),qe(n)):(D=ot((U-O[H])/2),-E),t.push([o[H],D,R]),U=O[H]}else if("left"===u){t=[],_=o.length;for(var W=0;W<_;W++)t.push(o[W])}else{if("justify"!==u)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');t=[],_=o.length,c=0!==c?c:M;for(var V=0;V<_;V++)R=0===V?qe(n):-E,D=0===V?Te(e):0,V<_-1&&q.push(at(ot((c-O[V])/(o[V].split(" ").length-1)))),t.push([o[V],D,R])}}!0===("boolean"==typeof r.R2L?r.R2L:lt)&&(t=w(t,function(t,e,n){return[t.split("").reverse().join(""),e,n]})),a={text:t,x:e,y:n,options:r,mutex:{pdfEscape:ie,activeFontKey:ct,fonts:pt,activeFontSize:ut}},At.publish("postProcessText",a),t=a.text,g=a.mutex.isHex||!1;var G=pt[ct].encoding;"WinAnsiEncoding"!==G&&"StandardEncoding"!==G||(t=w(t,function(t,e,n){return[function(t){return t=t.split("\t").join(Array(r.TabLen||9).join(" ")),ie(t,h)}(t),e,n]})),o=y(t),t=[];for(var Y,J,X,K=Array.isArray(o[0])?1:0,Z="",$=function(t,e,n){return n instanceof Ft?(n="number"==typeof r.angle?Ct(n,new Ft(1,0,0,1,t,e)):Ct(new Ft(1,0,0,1,t,e),n),rt===nt&&(n=Ct(new Ft(1,0,0,-1,0,0),n)),n.join(" ")+" Tm\n"):at(t)+" "+at(e)+" Td\n"},Q=0;Q<o.length;Q++){switch(Z="",K){case 1:X=(g?"<":"(")+o[Q][0]+(g?">":")"),Y=parseFloat(o[Q][1]),J=parseFloat(o[Q][2]);break;case 0:X=(g?"<":"(")+o[Q]+(g?">":")"),Y=Te(e),J=qe(n)}void 0!==q&&void 0!==q[Q]&&(Z=q[Q]+" Tw\n"),0===Q?t.push(Z+$(Y,J,f)+X):0==K?t.push(Z+X):1==K&&t.push(Z+$(Y,J,f)+X)}t=0==K?t.join(" Tj\nT* "):t.join(" Tj\n"),t+=" Tj\n";var tt="BT\n/";return tt+=ct+" "+ut+" Tf\n",tt+=at(ut*b)+" TL\n",tt+=He+"\n",tt+=m,tt+=t,st(tt+="ET"),et[ct]=!0,d},h.__private__.lstext=h.lstext=function(t,e,n,r){return this.text(t,e,n,{charSpace:r})};var ye=h.__private__.clip=h.clip=function(t){return st("evenodd"===t?"W*":"W"),this};h.clipEvenOdd=function(){return ye("evenodd")},h.__private__.clip_fixed=h.clip_fixed=function(t){return h.clip(t)},h.__private__.discardPath=h.discardPath=function(){return st("n"),this};var we=h.__private__.isValidStyle=function(t){var e=!1;return-1!==[void 0,null,"S","D","F","DF","FD","f","f*","B","B*","n"].indexOf(t)&&(e=!0),e};h.__private__.setDefaultPathOperation=h.setDefaultPathOperation=function(t){return we(t)&&(l=t),this};var xe=h.__private__.getStyle=h.getStyle=function(t){var e=l;switch(t){case"D":case"S":e="S";break;case"F":e="f";break;case"FD":case"DF":e="B";break;case"f":case"f*":case"B":case"B*":e=t}return e},Ne=h.close=function(){return st("h"),this};h.stroke=function(){return st("S"),this},h.fill=function(t){return Ae("f",t),this},h.fillEvenOdd=function(t){return Ae("f*",t),this},h.fillStroke=function(t){return Ae("B",t),this},h.fillStrokeEvenOdd=function(t){return Ae("B*",t),this};function Le(t,e,n){null===t||rt===nt&&void 0===t||(t=xe(t),e?(n||(n={matrix:It}),n instanceof Ft&&(n={matrix:n}),n.key=e,n||(n=It),_e(n,t)):st(t))}var Ae=function(t,e){"object"===on(e)?_e(e,t):st(t)},_e=function(t,e){var n=vt[t.key],r=bt[n];if(r instanceof h.ShadingPattern)st("q"),st(Se(e)),r.gState&&h.setGState(r.gState),st(t.matrix.toString()+" cm"),st("/"+n+" sh"),st("Q");else if(r instanceof h.TilingPattern){var i=new Ft(1,0,0,-1,0,rn());t.matrix&&(i=i.multiply(t.matrix||It),n=r.createClone(t.key,t.boundingBox,t.xStep,t.yStep,i).id),st("q"),st("/Pattern cs"),st("/"+n+" scn"),r.gState&&h.setGState(r.gState),st(e),st("Q")}},Se=function(t){switch(t){case"f":case"F":return"W n";case"f*":return"W* n";case"B":return"W S";case"B*":return"W* S";case"S":return"W S";case"n":return"W n"}},Pe=h.moveTo=function(t,e){return st(at(ot(t))+" "+at(w(e))+" m"),this},ke=h.lineTo=function(t,e){return st(at(ot(t))+" "+at(w(e))+" l"),this},Fe=h.curveTo=function(t,e,n,r,i,a){return st([at(ot(t)),at(w(e)),at(ot(n)),at(w(r)),at(ot(i)),at(w(a)),"c"].join(" ")),this};h.__private__.line=h.line=function(t,e,n,r,i){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!we(i))throw new Error("Invalid arguments passed to jsPDF.line");return rt===m?this.lines([[n-t,r-e]],t,e,[1,1],i||"S"):this.lines([[n-t,r-e]],t,e,[1,1]).stroke()},h.__private__.lines=h.lines=function(t,e,n,r,i,a,o,s){var u,l,c,h,f,d,p,g,m,b,v,y;if("number"==typeof t&&(y=n,n=e,e=t,t=y),r=r||[1,1],a=a||!1,isNaN(e)||isNaN(n)||!Array.isArray(t)||!Array.isArray(r)||!we(i)||"boolean"!=typeof a)throw new Error("Invalid arguments passed to jsPDF.lines");for(Pe(e,n),u=r[0],l=r[1],h=t.length,b=e,v=n,c=0;c<h;c++)2===(f=t[c]).length?(b=f[0]*u+b,v=f[1]*l+v,ke(b,v)):(d=f[0]*u+b,p=f[1]*l+v,g=f[2]*u+b,m=f[3]*l+v,b=f[4]*u+b,v=f[5]*l+v,Fe(d,p,g,m,b,v));return a&&Ne(),Le(i,o,s),this},h.path=function(t,e,n,r){for(var i=0;i<t.length;i++){var a=t[i],o=a.c;switch(a.op){case"m":Pe(o[0],o[1]);break;case"l":ke(o[0],o[1]);break;case"c":Fe.apply(this,o);break;case"h":Ne()}}return Le(e,n,r),this},h.__private__.rect=h.rect=function(t,e,n,r,i,a,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!we(i))throw new Error("Invalid arguments passed to jsPDF.rect");return rt===m&&(r=-r),st([at(ot(t)),at(w(e)),at(ot(n)),at(ot(r)),"re"].join(" ")),Le(i,a,o),this},h.__private__.triangle=h.triangle=function(t,e,n,r,i,a,o,s,u){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(a)||!we(o))throw new Error("Invalid arguments passed to jsPDF.triangle");return this.lines([[n-t,r-e],[i-n,a-r],[t-i,e-a]],t,e,[1,1],o,!0,s,u),this},h.__private__.roundedRect=h.roundedRect=function(t,e,n,r,i,a,o,s,u){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(a)||!we(o))throw new Error("Invalid arguments passed to jsPDF.roundedRect");var l=4/3*(Math.SQRT2-1);return i=Math.min(i,.5*n),a=Math.min(a,.5*r),this.lines([[n-2*i,0],[i*l,0,i,a-a*l,i,a],[0,r-2*a],[0,a*l,-i*l,a,-i,a],[2*i-n,0],[-i*l,0,-i,-a*l,-i,-a],[0,2*a-r],[0,-a*l,i*l,-a,i,-a]],t+i,e,[1,1],o,!0,s,u),this},h.__private__.ellipse=h.ellipse=function(t,e,n,r,i,a,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!we(i))throw new Error("Invalid arguments passed to jsPDF.ellipse");var s=4/3*(Math.SQRT2-1)*n,u=4/3*(Math.SQRT2-1)*r;return Pe(t+n,e),Fe(t+n,e-u,t+s,e-r,t,e-r),Fe(t-s,e-r,t-n,e-u,t-n,e),Fe(t-n,e+u,t-s,e+r,t,e+r),Fe(t+s,e+r,t+n,e+u,t+n,e),Le(i,a,o),this},h.__private__.circle=h.circle=function(t,e,n,r,i,a){if(isNaN(t)||isNaN(e)||isNaN(n)||!we(r))throw new Error("Invalid arguments passed to jsPDF.circle");return this.ellipse(t,e,n,n,r,i,a)},h.setFont=function(t,e){return ct=Ht(t,e,{disableWarning:!1}),this};var Ce=h.__private__.getFont=h.getFont=function(){return pt[Ht.apply(h,arguments)]};h.setFontStyle=h.setFontType=function(t){return ct=Ht(void 0,t),this},h.__private__.getFontList=h.getFontList=function(){var t,e,n={};for(t in gt)if(gt.hasOwnProperty(t))for(e in n[t]=[],gt[t])gt[t].hasOwnProperty(e)&&n[t].push(e);return n},h.addFont=function(t,e,n,r){return Ut.call(this,t,e,n,r=r||"Identity-H")};var Ie,je=t.lineWidth||.200025,Be=h.__private__.setLineWidth=h.setLineWidth=function(t){return st(at(ot(t))+" w"),this};h.__private__.setLineDash=ln.API.setLineDash=ln.API.setLineDashPattern=function(t,e){if(t=t||[],e=e||0,isNaN(e)||!Array.isArray(t))throw new Error("Invalid arguments passed to jsPDF.setLineDash");return t=t.map(function(t){return at(ot(t))}).join(" "),e=at(ot(e)),st("["+t+"] "+e+" d"),this};var Oe=h.__private__.getLineHeight=h.getLineHeight=function(){return ut*Ie};h.__private__.getLineHeight=h.getLineHeight=function(){return ut*Ie};var Ee=h.__private__.setLineHeightFactor=h.setLineHeightFactor=function(t){return"number"==typeof(t=t||1.15)&&(Ie=t),this},Me=h.__private__.getLineHeightFactor=h.getLineHeightFactor=function(){return Ie};Ee(t.lineHeight);var Te=h.__private__.getHorizontalCoordinate=function(t){return ot(t)},qe=h.__private__.getVerticalCoordinate=function(t){return rt===nt?t:Lt[I].mediaBox.topRightY-Lt[I].mediaBox.bottomLeftY-ot(t)},Re=h.__private__.getHorizontalCoordinateString=h.getHorizontalCoordinateString=function(t){return at(Te(t))},De=h.__private__.getVerticalCoordinateString=h.getVerticalCoordinateString=function(t){return at(qe(t))},Ue=t.strokeColor||"0 G";h.__private__.getStrokeColor=h.getDrawColor=function(){return $t(Ue)},h.__private__.setStrokeColor=h.setDrawColor=function(t,e,n,r){return Ue=Qt({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"draw",precision:2}),st(Ue),this};var ze=t.fillColor||"0 g";h.__private__.getFillColor=h.getFillColor=function(){return $t(ze)},h.__private__.setFillColor=h.setFillColor=function(t,e,n,r){return ze=Qt({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"fill",precision:2}),st(ze),this};var He=t.textColor||"0 g",We=h.__private__.getTextColor=h.getTextColor=function(){return $t(He)};h.__private__.setTextColor=h.setTextColor=function(t,e,n,r){return He=Qt({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"text",precision:3}),this};var Ve=t.charSpace,Ge=h.__private__.getCharSpace=h.getCharSpace=function(){return parseFloat(Ve||0)};h.__private__.setCharSpace=h.setCharSpace=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.setCharSpace");return Ve=t,this};var Ye=0;h.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2},h.__private__.setLineCap=h.setLineCap=function(t){var e=h.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return st((Ye=e)+" J"),this};var Je=0;h.__private__.setLineJoin=h.setLineJoin=function(t){var e=h.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return st((Je=e)+" j"),this},h.__private__.setLineMiterLimit=h.__private__.setMiterLimit=h.setLineMiterLimit=h.setMiterLimit=function(t){if(t=t||0,isNaN(t))throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");return st(at(ot(t))+" M"),this},h.GState=function(t){var e="opacity,stroke-opacity".split(",");for(var n in t)t.hasOwnProperty(n)&&0<=e.indexOf(n)&&(this[n]=t[n]);this.id="",this.objectNumber=-1},h.GState.prototype.equals=function(t){var e,n="id,objectNumber,equals";if(!t||on(t)!==on(this))return!1;var r=0;for(e in this)if(!(0<=n.indexOf(e))){if(this.hasOwnProperty(e)&&!t.hasOwnProperty(e))return!1;if(this[e]!==t[e])return!1;r++}for(e in t)t.hasOwnProperty(e)&&n.indexOf(e)<0&&r--;return 0===r},h.setGState=function(t){(t="string"==typeof t?yt[wt[t]]:Xe(null,t)).equals(xt)||(st("/"+t.id+" gs"),xt=t)};var Xe=function(t,e){if(!t||!wt[t]){var n=!1;for(var r in yt)if(yt.hasOwnProperty(r)&&yt[r].equals(e)){n=!0;break}if(n)e=yt[r];else{var i="GS"+(Object.keys(yt).length+1).toString(10);(yt[i]=e).id=i}return t&&(wt[t]=e.id),At.publish("addGState",e),e}};h.addGState=function(t,e){return Xe(t,e),this},h.saveGraphicsState=function(){return st("q"),mt.push({key:ct,size:ut,color:He}),this},h.restoreGraphicsState=function(){st("Q");var t=mt.pop();return ct=t.key,ut=t.size,He=t.color,xt=null,this},h.setCurrentTransformationMatrix=function(t){return st(t.toString()+" cm"),this},h.comment=function(t){return st("#"+t),this};function Ke(){this.page=Nt,this.currentPage=I,this.pages=R.slice(0),this.pagesContext=Lt.slice(0),this.x=ht,this.y=ft,this.matrix=dt,this.width=en(I),this.height=rn(I),this.outputDestination=U,this.id="",this.objectNumber=-1}var Ze=function(t,e){var n=t||0;Object.defineProperty(this,"x",{enumerable:!0,get:function(){return n},set:function(t){isNaN(t)||(n=parseFloat(t))}});var r=e||0;Object.defineProperty(this,"y",{enumerable:!0,get:function(){return r},set:function(t){isNaN(t)||(r=parseFloat(t))}});var i="pt";return Object.defineProperty(this,"type",{enumerable:!0,get:function(){return i},set:function(t){i=t.toString()}}),this},$e=function(t,e,n,r){Ze.call(this,t,e),this.type="rect";var i=n||0;Object.defineProperty(this,"w",{enumerable:!0,get:function(){return i},set:function(t){isNaN(t)||(i=parseFloat(t))}});var a=r||0;return Object.defineProperty(this,"h",{enumerable:!0,get:function(){return a},set:function(t){isNaN(t)||(a=parseFloat(t))}}),this};Ke.prototype.restore=function(){Nt=this.page,I=this.currentPage,Lt=this.pagesContext,R=this.pages,ht=this.x,ft=this.y,dt=this.matrix,nn(I,this.width),an(I,this.height),U=this.outputDestination};var Qe=function(t,e,n,r,i){kt.push(new Ke),Nt=I=0,R=[],ht=t,ft=e,dt=i,ae([n,r])};for(var tn in h.beginFormObject=function(t,e,n,r,i){return Qe(t,e,n,r,i),this},h.endFormObject=function(t){return function(t){if(!Pt[t]){var e=new Ke,n="Xo"+(Object.keys(St).length+1).toString(10);e.id=n,Pt[t]=n,St[n]=e,At.publish("addFormObject",e),kt.pop().restore()}}(t),this},h.doFormObject=function(t,e){var n=St[Pt[t]];return st("q"),st(e.toString()+" cm"),st("/"+n.id+" Do"),st("Q"),this},h.getFormObject=function(t){var e=St[Pt[t]];return{x:e.x,y:e.y,width:e.width,height:e.height,matrix:e.matrix}},h.save=function(r,t){if(r=r||"generated.pdf",(t=t||{}).returnPromise=t.returnPromise||!1,!1!==t.returnPromise)return new Promise(function(t,e){try{var n=saveAs(pe(de()),r);"function"!=typeof saveAs.unload||sn.setTimeout&&setTimeout(saveAs.unload,911),t(n)}catch(t){e(t.message)}});saveAs(pe(de()),r),"function"!=typeof saveAs.unload||sn.setTimeout&&setTimeout(saveAs.unload,911)},ln.API)ln.API.hasOwnProperty(tn)&&("events"===tn&&ln.API.events.length?function(t,e){var n,r,i;for(i=e.length-1;-1!==i;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(At,ln.API.events):h[tn]=ln.API[tn]);var en=h.getPageWidth=function(t){return(Lt[t=t||I].mediaBox.topRightX-Lt[t].mediaBox.bottomLeftX)/tt},nn=h.setPageWidth=function(t,e){Lt[t].mediaBox.topRightX=e*tt+Lt[t].mediaBox.bottomLeftX},rn=h.getPageHeight=function(t){return(Lt[t=t||I].mediaBox.topRightY-Lt[t].mediaBox.bottomLeftY)/tt},an=h.setPageHeight=function(t,e){Lt[t].mediaBox.topRightY=e*tt+Lt[t].mediaBox.bottomLeftY};return h.internal={pdfEscape:ie,getStyle:xe,getFont:Ce,getFontSize:Y,getCharSpace:Ge,getTextColor:We,getLineHeight:Oe,getLineHeightFactor:Me,write:H,getHorizontalCoordinate:Te,getVerticalCoordinate:qe,getCoordinateString:Re,getVerticalCoordinateString:De,collections:{},newObject:Gt,newAdditionalObject:Xt,newObjectDeferred:Yt,newObjectDeferredBegin:Jt,getFilters:te,putStream:ee,events:At,scaleFactor:tt,pageSize:{getWidth:function(){return en(I)},setWidth:function(t){nn(I,t)},getHeight:function(){return rn(I)},setHeight:function(t){an(I,t)}},output:ge,getNumberOfPages:se,pages:R,out:st,f2:x,f3:N,getPageInfo:me,getPageInfoByObjId:be,getCurrentPageInfo:ve,getPDFVersion:d,Point:Ze,Rectangle:$e,Matrix:Ft,hasHotfix:Wt},Object.defineProperty(h.internal.pageSize,"width",{get:function(){return en(I)},set:function(t){nn(I,t)},enumerable:!0,configurable:!0}),Object.defineProperty(h.internal.pageSize,"height",{get:function(){return rn(I)},set:function(t){an(I,t)},enumerable:!0,configurable:!0}),function(t){for(var e=0,n=V.length;e<n;e++){var r=Ut(t[e][0],t[e][1],t[e][2],V[e][3],!0);!1===c&&(et[r]=!0);var i=t[e][0].split("-");Dt({id:r,fontName:i[0],fontStyle:i[1]||""})}At.publish("addFonts",{fonts:pt,dictionary:gt})}(V),ct="F1",zt(o,a),At.publish("initialized"),h}function z(t){if(void 0!==t&&""!=t)return!0}function H(){var e=void 0;Object.defineProperty(this,"pdf",{get:function(){return e},set:function(t){e=t}});var n=150;Object.defineProperty(this,"width",{get:function(){return n},set:function(t){n=isNaN(t)||!1===Number.isInteger(t)||t<0?150:t,this.getContext("2d").pageWrapXEnabled&&(this.getContext("2d").pageWrapX=n+1)}});var r=300;Object.defineProperty(this,"height",{get:function(){return r},set:function(t){r=isNaN(t)||!1===Number.isInteger(t)||t<0?300:t,this.getContext("2d").pageWrapYEnabled&&(this.getContext("2d").pageWrapY=r+1)}});var i=[];Object.defineProperty(this,"childNodes",{get:function(){return i},set:function(t){i=t}});var a={};Object.defineProperty(this,"style",{get:function(){return a},set:function(t){a=t}}),Object.defineProperty(this,"parentNode",{})}function W(t){var r,e,n,i,a,o,s,u,l,c;for(/[^\x00-\xFF]/.test(t),e=[],n=0,i=(t+=r="\0\0\0\0".slice(t.length%4||4)).length;n<i;n+=4)0!==(a=(t.charCodeAt(n)<<24)+(t.charCodeAt(n+1)<<16)+(t.charCodeAt(n+2)<<8)+t.charCodeAt(n+3))?(o=(a=((a=((a=((a=(a-(c=a%85))/85)-(l=a%85))/85)-(u=a%85))/85)-(s=a%85))/85)%85,e.push(33+o,33+s,33+u,33+l,33+c)):e.push(122);return function(t,e){for(var n=r.length;0<n;n--)t.pop()}(e),String.fromCharCode.apply(String,e)+"~>"}function V(t){var r,e,n,i,a,o=String,s="length",u="charCodeAt",l="slice",c="replace";for(t[l](-2),t=t[l](0,-2)[c](/\s/g,"")[c]("z","!!!!!"),n=[],i=0,a=(t+=r="uuuuu"[l](t[s]%5||5))[s];i<a;i+=5)e=52200625*(t[u](i)-33)+614125*(t[u](i+1)-33)+7225*(t[u](i+2)-33)+85*(t[u](i+3)-33)+(t[u](i+4)-33),n.push(255&e>>24,255&e>>16,255&e>>8,255&e);return function(t,e){for(var n=r[s];0<n;n--)t.pop()}(n),o.fromCharCode.apply(o,n)}function G(t){var e=new RegExp(/^([0-9A-Fa-f]{2})+$/);if(-1!==(t=t.replace(/\s/g,"")).indexOf(">")&&(t=t.substr(0,t.indexOf(">"))),t.length%2&&(t+="0"),!1===e.test(t))return"";for(var n="",r=0;r<t.length;r+=2)n+=String.fromCharCode("0x"+(t[r]+t[r+1]));return n}function Y(t){for(var e,n,r=[],i=t.length;i--;)r[i]=t.charCodeAt(i);return e=a.adler32cs.from(t),t=function(t,e){var n=new Uint8Array(t.byteLength+e.byteLength);return n.set(new Uint8Array(t),0),n.set(new Uint8Array(e),t.byteLength),n}(t=(n=new Deflater(6)).append(new Uint8Array(r)),n.flush()),(r=new Uint8Array(t.byteLength+6)).set(new Uint8Array([120,156])),r.set(t,2),r.set(new Uint8Array([255&e,e>>8&255,e>>16&255,e>>24&255]),t.byteLength+2),t=r.reduce(function(t,e){return t+String.fromCharCode(e)},"")}function J(t,e,n,r){var i=5,a=m;switch(r){case P.image_compression.FAST:i=3,a=g;break;case P.image_compression.MEDIUM:i=6,a=b;break;case P.image_compression.SLOW:i=9,a=v}t=p(t,e,n,a);var o=new Uint8Array(d(i)),s=U.API.adler32cs.fromBuffer(t.buffer),u=new Deflater(i),l=u.append(t),c=u.flush(),h=o.length+l.length+c.length,f=new Uint8Array(h+4);return f.set(o),f.set(l,o.length),f.set(c,o.length+l.length),f[h++]=s>>>24&255,f[h++]=s>>>16&255,f[h++]=s>>>8&255,f[h++]=255&s,P.__addimage__.arrayBufferToBinaryString(f)}function X(t){var e=Array.apply([],t);return e.unshift(0),e}function K(t,e,n,r){for(var i=[],a=0,o=t.length,s=0;a!==o&&s+e[a]<n;)s+=e[a],a++;i.push(t.slice(0,a));var u=a;for(s=0;a!==o;)s+e[a]>r&&(i.push(t.slice(u,a)),s=0,u=a),s+=e[a],a++;return u!==a&&i.push(t.slice(u,a)),i}function Z(t,e,n){n||(n={});var r,i,a,o,s,u,l,c=[],h=[c],f=n.textIndent||0,d=0,p=0,g=t.split(" "),m=A.apply(this,[" ",n])[0];if(u=-1===n.lineIndent?g[0].length+2:n.lineIndent||0){var b=Array(u).join(" "),v=[];g.map(function(t){1<(t=t.split(/\s*\n/)).length?v=v.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):v.push(t[0])}),g=v,u=_.apply(this,[b,n])}for(a=0,o=g.length;a<o;a++){var y=0;if(r=g[a],u&&"\n"==r[0]&&(r=r.substr(1),y=1),e<f+d+(p=(i=A.apply(this,[r,n])).reduce(function(t,e){return t+e},0))||y){if(e<p){for(s=K.apply(this,[r,i,e-(f+d),e]),c.push(s.shift()),c=[s.pop()];s.length;)h.push([s.shift()]);p=i.slice(r.length-(c[0]?c[0].length:0)).reduce(function(t,e){return t+e},0)}else c=[r];h.push(c),f=p+u,d=m}else c.push(r),f+=d+p,d=m}return l=u?function(t,e){return(e?b:"")+t.join(" ")}:function(t){return t.join(" ")},h.map(l)}function $(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n}function Q(){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+this.internal.__metadata__.namespaceuri+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),n=unescape(encodeURIComponent(t)),r=unescape(encodeURIComponent(this.internal.__metadata__.metadata)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),a=unescape(encodeURIComponent("</x:xmpmeta>")),o=n.length+r.length+i.length+e.length+a.length;this.internal.__metadata__.metadata_object_number=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+o+" >>"),this.internal.write("stream"),this.internal.write(e+n+r+i+a),this.internal.write("endstream"),this.internal.write("endobj")}function tt(){this.internal.__metadata__.metadata_object_number&&this.internal.write("/Metadata "+this.internal.__metadata__.metadata_object_number+" 0 R")}function et(){return void 0===this.internal.vFS&&(this.internal.vFS={}),!0}function nt(x){var t=0;if(71!==x[t++]||73!==x[t++]||70!==x[t++]||56!==x[t++]||56!=(x[t++]+1&253)||97!==x[t++])throw new Error("Invalid GIF 87a/89a header.");var N=x[t++]|x[t++]<<8,e=x[t++]|x[t++]<<8,n=x[t++],r=n>>7,i=1<<1+(7&n);x[t++];x[t++];var a=null,o=null;r&&(a=t,t+=3*(o=i));var s=!0,u=[],l=0,c=null,h=0,f=null;for(this.width=N,this.height=e;s&&t<x.length;)switch(x[t++]){case 33:switch(x[t++]){case 255:if(11!==x[t]||78==x[t+1]&&69==x[t+2]&&84==x[t+3]&&83==x[t+4]&&67==x[t+5]&&65==x[t+6]&&80==x[t+7]&&69==x[t+8]&&50==x[t+9]&&46==x[t+10]&&48==x[t+11]&&3==x[t+12]&&1==x[t+13]&&0==x[t+16])t+=14,f=x[t++]|x[t++]<<8,t++;else for(t+=12;;){if(!(0<=(P=x[t++])))throw Error("Invalid block size");if(0===P)break;t+=P}break;case 249:if(4!==x[t++]||0!==x[t+4])throw new Error("Invalid graphics extension block.");var d=x[t++];l=x[t++]|x[t++]<<8,c=x[t++],0==(1&d)&&(c=null),h=d>>2&7,t++;break;case 254:for(;;){if(!(0<=(P=x[t++])))throw Error("Invalid block size");if(0===P)break;t+=P}break;default:throw new Error("Unknown graphic control label: 0x"+x[t-1].toString(16))}break;case 44:var p=x[t++]|x[t++]<<8,g=x[t++]|x[t++]<<8,m=x[t++]|x[t++]<<8,b=x[t++]|x[t++]<<8,v=x[t++],y=v>>6&1,w=1<<1+(7&v),L=a,A=o,_=!1;if(v>>7){_=!0;L=t,t+=3*(A=w)}var S=t;for(t++;;){var P;if(!(0<=(P=x[t++])))throw Error("Invalid block size");if(0===P)break;t+=P}u.push({x:p,y:g,width:m,height:b,has_local_palette:_,palette_offset:L,palette_size:A,data_offset:S,data_length:t-S,transparent_index:c,interlaced:!!y,delay:l,disposal:h});break;case 59:s=!1;break;default:throw new Error("Unknown gif block: 0x"+x[t-1].toString(16))}this.numFrames=function(){return u.length},this.loopCount=function(){return f},this.frameInfo=function(t){if(t<0||t>=u.length)throw new Error("Frame index out of range.");return u[t]},this.decodeAndBlitFrameBGRA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);rt(x,n.data_offset,i,r);var a=n.palette_offset,o=n.transparent_index;null===o&&(o=256);var s=n.width,u=N-s,l=s,c=4*(n.y*N+n.x),h=4*((n.y+n.height)*N+n.x),f=c,d=4*u;!0===n.interlaced&&(d+=4*N*7);for(var p=8,g=0,m=i.length;g<m;++g){var b=i[g];if(0===l&&(l=s,h<=(f+=d)&&(d=4*u+4*N*(p-1),f=c+(s+u)*(p<<1),p>>=1)),b===o)f+=4;else{var v=x[a+3*b],y=x[a+3*b+1],w=x[a+3*b+2];e[f++]=w,e[f++]=y,e[f++]=v,e[f++]=255}--l}},this.decodeAndBlitFrameRGBA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);rt(x,n.data_offset,i,r);var a=n.palette_offset,o=n.transparent_index;null===o&&(o=256);var s=n.width,u=N-s,l=s,c=4*(n.y*N+n.x),h=4*((n.y+n.height)*N+n.x),f=c,d=4*u;!0===n.interlaced&&(d+=4*N*7);for(var p=8,g=0,m=i.length;g<m;++g){var b=i[g];if(0===l&&(l=s,h<=(f+=d)&&(d=4*u+4*N*(p-1),f=c+(s+u)*(p<<1),p>>=1)),b===o)f+=4;else{var v=x[a+3*b],y=x[a+3*b+1],w=x[a+3*b+2];e[f++]=v,e[f++]=y,e[f++]=w,e[f++]=255}--l}}}function rt(t,e,n,r){for(var i=t[e++],a=1<<i,o=1+a,s=1+o,u=i+1,l=(1<<u)-1,c=0,h=0,f=0,d=t[e++],p=new Int32Array(4096),g=null;;){for(;c<16&&0!==d;)h|=t[e++]<<c,c+=8,1===d?d=t[e++]:--d;if(c<u)break;var m=h&l;if(h>>=u,c-=u,m!=a){if(m==o)break;for(var b=m<s?m:g,v=0,y=b;a<y;)y=p[y]>>8,++v;var w=y;if(r<f+v+(b!==m?1:0))return void console.log("Warning, gif stream longer than expected.");n[f++]=w;var x=f+=v;for(b!==m&&(n[f++]=w),y=b;v--;)y=p[y],n[--x]=255&y,y>>=8;null!==g&&s<4096&&(p[s++]=g<<8|w,l+1<=s&&u<12&&(++u,l=l<<1|1)),g=m}else s=1+o,l=(1<<(u=i+1))-1,g=null}return f!==r&&console.log("Warning, gif stream shorter than expected."),n}
/**
   * @license
   * Copyright (c) 2016 Alexander Weidt,
   * https://github.com/BiggA94
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
!function(t,e){function A(t){return t.replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")}function b(t){return t.replace(/\\\\/g,"\\").replace(/\\\(/g,"(").replace(/\\\)/g,")")}function _(t){return t.toFixed(2)}function s(t){return t.toFixed(5)}var h,n=t.API,r=1;n.__acroform__={};function i(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t}function v(t){return t*r}function y(t){return t/r}function u(t){var e=new O,n=J.internal.getHeight(t)||0,r=J.internal.getWidth(t)||0;return e.BBox=[0,0,Number(_(r)),Number(_(n))],e}function f(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],n=t.V||t.DV,r=L(t,n),i=h.internal.getFont(t.fontName,t.fontStyle).id;e.push("/Tx BMC"),e.push("q"),e.push("BT"),e.push(h.__private__.encodeColorString(t.color)),e.push("/"+i+" "+_(r.fontSize)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push(r.text),e.push("ET"),e.push("Q"),e.push("EMC");var a=new u(t);return a.stream=e.join("\n"),a}}function a(){h.internal.acroformPlugin.acroFormDictionaryRoot.objId=void 0;var t=h.internal.acroformPlugin.acroFormDictionaryRoot.Fields;for(var e in t)if(t.hasOwnProperty(e)){var n=t[e];n.objId=void 0,n.hasAnnotation&&k.call(h,n)}}function o(){if(void 0===h.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("putCatalogCallback: Root missing.");h.internal.write("/AcroForm "+h.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R")}function l(){h.internal.events.unsubscribe(h.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete h.internal.acroformPlugin.acroFormDictionaryRoot._eventID,h.internal.acroformPlugin.printedOut=!0}function c(t){var e=!t;for(var n in t||(h.internal.newObjectDeferredBegin(h.internal.acroformPlugin.acroFormDictionaryRoot.objId,!0),h.internal.acroformPlugin.acroFormDictionaryRoot.putStream()),t=t||h.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if(t.hasOwnProperty(n)){var r=t[n],i=[],a=r.Rect;if(r.Rect&&(r.Rect=m.call(this,r.Rect)),h.internal.newObjectDeferredBegin(r.objId,!0),r.DA=J.createDefaultAppearanceStream(r),"object"===on(r)&&"function"==typeof r.getKeyValueListForStream&&(i=r.getKeyValueListForStream()),r.Rect=a,r.hasAppearanceStream&&!r.appearanceStreamContent){var o=f.call(this,r);i.push({key:"AP",value:"<</N "+o+">>"}),h.internal.acroformPlugin.xForms.push(o)}if(r.appearanceStreamContent){var s="";for(var u in r.appearanceStreamContent)if(r.appearanceStreamContent.hasOwnProperty(u)){var l=r.appearanceStreamContent[u];if(s+="/"+u+" ",s+="<<",1<=Object.keys(l).length||Array.isArray(l)){for(var n in l)if(l.hasOwnProperty(n)){var c=l[n];"function"==typeof c&&(c=c.call(this,r)),s+="/"+n+" "+c+" ",0<=h.internal.acroformPlugin.xForms.indexOf(c)||h.internal.acroformPlugin.xForms.push(c)}}else"function"==typeof(c=l)&&(c=c.call(this,r)),s+="/"+n+" "+c,0<=h.internal.acroformPlugin.xForms.indexOf(c)||h.internal.acroformPlugin.xForms.push(c);s+=">>"}i.push({key:"AP",value:"<<\n"+s+">>"})}h.internal.putStream({additionalKeyValues:i}),h.internal.out("endobj")}e&&F.call(this,h.internal.acroformPlugin.xForms)}var d=n.__acroform__.setBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");return t|=1<<e},p=n.__acroform__.clearBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");return t&=~(1<<e)},g=n.__acroform__.getBit=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");return 0==(t&1<<e)?0:1},w=n.__acroform__.getBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");return g(t,e-1)},x=n.__acroform__.setBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");return d(t,e-1)},N=n.__acroform__.clearBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");return p(t,e-1)},m=n.__acroform__.calculateCoordinates=function(t){var e=this.internal.getHorizontalCoordinate,n=this.internal.getVerticalCoordinate,r=t[0],i=t[1],a=t[2],o=t[3],s={};return s.lowerLeft_X=e(r)||0,s.lowerLeft_Y=n(i+o)||0,s.upperRight_X=e(r+a)||0,s.upperRight_Y=n(i)||0,[Number(_(s.lowerLeft_X)),Number(_(s.lowerLeft_Y)),Number(_(s.upperRight_X)),Number(_(s.upperRight_Y))]},L=function(i,t){var e=0===i.fontSize?i.maxFontSize:i.fontSize,n={text:"",fontSize:""},a=(t=")"==(t="("==t.substr(0,1)?t.substr(1):t).substr(t.length-1)?t.substr(0,t.length-1):t).split(" "),r=e,o=J.internal.getHeight(i)||0;o=o<0?-o:o;var s=J.internal.getWidth(i)||0;s=s<0?-s:s;function u(t,e,n){if(t+1<a.length){var r=e+" "+a[t+1];return S(r,i,n).width<=s-4}return!1}r++;t:for(;0<r;){t="";var l,c,h=S("3",i,--r).height,f=i.multiline?o-r:(o-h)/2,d=f+=2,p=0,g=0;if(r<=0){t="(...) Tj\n",t+="% Width of Text: "+S(t,i,r=12).width+", FieldWidth:"+s+"\n";break}var m="",b=0;for(var v in a)if(a.hasOwnProperty(v)){m=" "==(m+=a[v]+" ").substr(m.length-1)?m.substr(0,m.length-1):m;var y=parseInt(v),w=u(y,m,r),x=v>=a.length-1;if(w&&!x){m+=" ";continue}if(w||x){if(x)g=y;else if(i.multiline&&o<(h+2)*(b+2)+2)continue t}else{if(!i.multiline)continue t;if(o<(h+2)*(b+2)+2)continue t;g=y}for(var N="",L=p;L<=g;L++)N+=a[L]+" ";switch(N=" "==N.substr(N.length-1)?N.substr(0,N.length-1):N,c=S(N,i,r).width,i.textAlign){case"right":l=s-c-2;break;case"center":l=(s-c)/2;break;case"left":default:l=2}t+=_(l)+" "+_(d)+" Td\n",t+="("+A(N)+") Tj\n",t+=-_(l)+" 0 Td\n",d=-(r+2),c=0,p=g+1,b++,m=""}else;break}return n.text=t,n.fontSize=r,n},S=function(t,e,n){var r=h.internal.getFont(e.fontName,e.fontStyle),i=h.getStringUnitWidth(t,{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n);return{height:h.getStringUnitWidth("3",{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n)*1.5,width:i}},P={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},k=function(t){var e={type:"reference",object:t};void 0===h.internal.getPageInfo(t.page).pageContext.annotations.find(function(t){return t.type===e.type&&t.object===e.object})&&h.internal.getPageInfo(t.page).pageContext.annotations.push(e)},F=function(t){for(var e in t)if(t.hasOwnProperty(e)){var n=e,r=t[e];h.internal.newObjectDeferredBegin(r&&r.objId,!0),"object"===on(r)&&"function"==typeof r.putStream&&r.putStream(),delete t[n]}},C=function(){if(void 0!==this.internal&&(void 0===this.internal.acroformPlugin||!1===this.internal.acroformPlugin.isInitialized)){if(h=this,M.FieldNum=0,this.internal.acroformPlugin=JSON.parse(JSON.stringify(P)),this.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");r=h.internal.scaleFactor,h.internal.acroformPlugin.acroFormDictionaryRoot=new E,h.internal.acroformPlugin.acroFormDictionaryRoot._eventID=h.internal.events.subscribe("postPutResources",l),h.internal.events.subscribe("buildDocument",a),h.internal.events.subscribe("putCatalog",o),h.internal.events.subscribe("postPutPages",c),h.internal.acroformPlugin.isInitialized=!0}},I=n.__acroform__.arrayToPdfArray=function(t){if(Array.isArray(t)){for(var e="[",n=0;n<t.length;n++)switch(0!==n&&(e+=" "),on(t[n])){case"boolean":case"number":case"object":e+=t[n].toString();break;case"string":"/"!==t[n].substr(0,1)?e+="("+A(t[n].toString())+")":e+=t[n].toString()}return e+="]"}throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray")};function j(t){return(t=t||"").toString(),t="("+A(t)+")"}function B(){var e;Object.defineProperty(this,"objId",{configurable:!0,get:function(){return e||(e=h.internal.newObjectDeferred()),e},set:function(t){e=t}})}B.prototype.toString=function(){return this.objId+" 0 R"},B.prototype.putStream=function(){var t=this.getKeyValueListForStream();h.internal.putStream({data:this.stream,additionalKeyValues:t}),h.internal.out("endobj")},B.prototype.getKeyValueListForStream=function(){return function(t){var e=[],n=Object.getOwnPropertyNames(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var r in n)if(!1===Object.getOwnPropertyDescriptor(t,n[r]).configurable){var i=n[r],a=t[i];a&&(Array.isArray(a)?e.push({key:i,value:I(a)}):a instanceof B?e.push({key:i,value:a.objId+" 0 R"}):"function"!=typeof a&&e.push({key:i,value:a}))}return e}(this)};var O=function(){B.call(this),Object.defineProperty(this,"Type",{value:"/XObject",configurable:!1,writeable:!0}),Object.defineProperty(this,"Subtype",{value:"/Form",configurable:!1,writeable:!0}),Object.defineProperty(this,"FormType",{value:1,configurable:!1,writeable:!0});var e,n=[];Object.defineProperty(this,"BBox",{configurable:!1,writeable:!0,get:function(){return n},set:function(t){n=t}}),Object.defineProperty(this,"Resources",{value:"2 0 R",configurable:!1,writeable:!0}),Object.defineProperty(this,"stream",{enumerable:!1,configurable:!0,set:function(t){e=t.trim()},get:function(){return e||null}})};i(O,B);var E=function(){B.call(this);var e,t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return 0<t.length?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!1,configurable:!1,get:function(){return t}}),Object.defineProperty(this,"DA",{enumerable:!1,configurable:!1,get:function(){if(e)return"("+e+")"},set:function(t){e=t}})};i(E,B);var M=function t(){B.call(this);var e=4;Object.defineProperty(this,"F",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute F supplied.');e=t}}),Object.defineProperty(this,"showWhenPrinted",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(e,3))},set:function(t){!0===Boolean(t)?this.F=x(e,3):this.F=N(e,3)}});var n=0;Object.defineProperty(this,"Ff",{enumerable:!1,configurable:!1,get:function(){return n},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute Ff supplied.');n=t}});var r=[];Object.defineProperty(this,"Rect",{enumerable:!1,configurable:!1,get:function(){if(0!==r.length)return r},set:function(t){r=void 0!==t?t:[]}}),Object.defineProperty(this,"x",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[0])?0:y(r[0])},set:function(t){r[0]=v(t)}}),Object.defineProperty(this,"y",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[1])?0:y(r[1])},set:function(t){r[1]=v(t)}}),Object.defineProperty(this,"width",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[2])?0:y(r[2])},set:function(t){r[2]=v(t)}}),Object.defineProperty(this,"height",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[3])?0:y(r[3])},set:function(t){r[3]=v(t)}});var i="";Object.defineProperty(this,"FT",{enumerable:!0,configurable:!1,get:function(){return i},set:function(t){switch(t){case"/Btn":case"/Tx":case"/Ch":case"/Sig":i=t;break;default:throw new Error('Invalid value "'+t+'" for attribute FT supplied.')}}});var a=null;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,get:function(){if(!a||a.length<1){if(this instanceof W)return;a="FieldObject"+t.FieldNum++}return"("+A(a)+")"},set:function(t){a=t.toString()}}),Object.defineProperty(this,"fieldName",{configurable:!0,enumerable:!0,get:function(){return a},set:function(t){a=t}});var o="helvetica";Object.defineProperty(this,"fontName",{enumerable:!0,configurable:!0,get:function(){return o},set:function(t){o=t}});var s="normal";Object.defineProperty(this,"fontStyle",{enumerable:!0,configurable:!0,get:function(){return s},set:function(t){s=t}});var u=0;Object.defineProperty(this,"fontSize",{enumerable:!0,configurable:!0,get:function(){return y(u)},set:function(t){u=v(t)}});var l=50;Object.defineProperty(this,"maxFontSize",{enumerable:!0,configurable:!0,get:function(){return y(l)},set:function(t){l=v(t)}});var c="black";Object.defineProperty(this,"color",{enumerable:!0,configurable:!0,get:function(){return c},set:function(t){c=t}});var h="/F1 0 Tf 0 g";Object.defineProperty(this,"DA",{enumerable:!0,configurable:!1,get:function(){if(!(!h||this instanceof W||this instanceof G))return j(h)},set:function(t){t=t.toString(),h=t}});var f=null;Object.defineProperty(this,"DV",{enumerable:!1,configurable:!1,get:function(){if(f)return this instanceof U==!1?j(f):f},set:function(t){t=t.toString(),f=this instanceof U==!1?"("===t.substr(0,1)?b(t.substr(1,t.length-2)):b(t):t}}),Object.defineProperty(this,"defaultValue",{enumerable:!0,configurable:!0,get:function(){return this instanceof U==!0?b(f.substr(1,f.length-1)):f},set:function(t){t=t.toString(),f=this instanceof U==!0?"/"+t:t}});var d=null;Object.defineProperty(this,"V",{enumerable:!1,configurable:!1,get:function(){if(d)return this instanceof U==!1?j(d):d},set:function(t){t=t.toString(),d=this instanceof U==!1?"("===t.substr(0,1)?b(t.substr(1,t.length-2)):b(t):t}}),Object.defineProperty(this,"value",{enumerable:!0,configurable:!0,get:function(){return this instanceof U==!0?b(d.substr(1,d.length-1)):d},set:function(t){t=t.toString(),d=this instanceof U==!0?"/"+t:t}}),Object.defineProperty(this,"hasAnnotation",{enumerable:!0,configurable:!0,get:function(){return this.Rect}}),Object.defineProperty(this,"Type",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Widget":null}});var p,g=!1;Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,writeable:!0,get:function(){return g},set:function(t){t=Boolean(t),g=t}}),Object.defineProperty(this,"page",{enumerable:!0,configurable:!0,writeable:!0,get:function(){if(p)return p},set:function(t){p=t}}),Object.defineProperty(this,"readOnly",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,1))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,1):this.Ff=N(this.Ff,1)}}),Object.defineProperty(this,"required",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,2))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,2):this.Ff=N(this.Ff,2)}}),Object.defineProperty(this,"noExport",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,3))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,3):this.Ff=N(this.Ff,3)}});var m=null;Object.defineProperty(this,"Q",{enumerable:!0,configurable:!1,get:function(){if(null!==m)return m},set:function(t){if(-1===[0,1,2].indexOf(t))throw new Error('Invalid value "'+t+'" for attribute Q supplied.');m=t}}),Object.defineProperty(this,"textAlign",{get:function(){var t;switch(m){case 0:default:t="left";break;case 1:t="center";break;case 2:t="right"}return t},configurable:!0,enumerable:!0,set:function(t){switch(t){case"right":case 2:m=2;break;case"center":case 1:m=1;break;case"left":case 0:default:m=0}}})};i(M,B);function T(){M.call(this),this.FT="/Ch",this.V="()",this.fontName="zapfdingbats";var e=0;Object.defineProperty(this,"TI",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"topIndex",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){e=t}});var n=[];Object.defineProperty(this,"Opt",{enumerable:!0,configurable:!1,get:function(){return I(n)},set:function(t){n=function(t){var e=[];return"string"==typeof t&&(e=function(t,e,n){n||(n=1);for(var r,i=[];r=e.exec(t);)i.push(r[n]);return i}(t,/\((.*?)\)/g)),e}(t)}}),this.getOptions=function(){return n},this.setOptions=function(t){n=t,this.sort&&n.sort()},this.addOption=function(t){t=(t=t||"").toString(),n.push(t),this.sort&&n.sort()},this.removeOption=function(t,e){for(e=e||!1,t=(t=t||"").toString();-1!==n.indexOf(t)&&(n.splice(n.indexOf(t),1),!1!==e););},Object.defineProperty(this,"combo",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,18))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,18):this.Ff=N(this.Ff,18)}}),Object.defineProperty(this,"edit",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,19))},set:function(t){!0===this.combo&&(!0===Boolean(t)?this.Ff=x(this.Ff,19):this.Ff=N(this.Ff,19))}}),Object.defineProperty(this,"sort",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,20))},set:function(t){!0===Boolean(t)?(this.Ff=x(this.Ff,20),n.sort()):this.Ff=N(this.Ff,20)}}),Object.defineProperty(this,"multiSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,22))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,22):this.Ff=N(this.Ff,22)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"commitOnSelChange",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,27))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,27):this.Ff=N(this.Ff,27)}}),this.hasAppearanceStream=!1}i(T,M);function q(){T.call(this),this.fontName="helvetica",this.combo=!1}i(q,T);function R(){q.call(this),this.combo=!0}i(R,q);function D(){R.call(this),this.edit=!0}i(D,R);var U=function(){M.call(this),this.FT="/Btn",Object.defineProperty(this,"noToggleToOff",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,15))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,15):this.Ff=N(this.Ff,15)}}),Object.defineProperty(this,"radio",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,16))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,16):this.Ff=N(this.Ff,16)}}),Object.defineProperty(this,"pushButton",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,17))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,17):this.Ff=N(this.Ff,17)}}),Object.defineProperty(this,"radioIsUnison",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e,n={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){if(0!==Object.keys(n).length){var t,e=[];for(t in e.push("<<"),n)e.push("/"+t+" ("+n[t]+")");return e.push(">>"),e.join("\n")}},set:function(t){"object"===on(t)&&(n=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return n.CA||""},set:function(t){"string"==typeof t&&(n.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return e.substr(1,e.length-1)},set:function(t){e="/"+t}})};i(U,M);function z(){U.call(this),this.pushButton=!0}i(z,U);function H(){U.call(this),this.radio=!0,this.pushButton=!1;var e=[];Object.defineProperty(this,"Kids",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=void 0!==t?t:[]}})}i(H,U);var W=function(){var e,n;M.call(this),Object.defineProperty(this,"Parent",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"optionName",{enumerable:!1,configurable:!0,get:function(){return n},set:function(t){n=t}});var r,i={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t,e=[];for(t in e.push("<<"),i)e.push("/"+t+" ("+i[t]+")");return e.push(">>"),e.join("\n")},set:function(t){"object"===on(t)&&(i=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return i.CA||""},set:function(t){"string"==typeof t&&(i.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return r},set:function(t){r=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return r.substr(1,r.length-1)},set:function(t){r="/"+t}}),this.caption="l",this.appearanceState="Off",this._AppearanceType=J.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(this.optionName)};i(W,M),H.prototype.setAppearance=function(t){if(!("createAppearanceStream"in t&&"getCA"in t))throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");for(var e in this.Kids)if(this.Kids.hasOwnProperty(e)){var n=this.Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n.optionName),n.caption=t.getCA()}},H.prototype.createOption=function(t){var e=new W;return e.Parent=this,e.optionName=t,this.Kids.push(e),X.call(this,e),e};function V(){U.call(this),this.fontName="zapfdingbats",this.caption="3",this.appearanceState="On",this.value="On",this.textAlign="center",this.appearanceStreamContent=J.CheckBox.createAppearanceStream()}i(V,U);var G=function(){M.call(this),this.FT="/Tx",Object.defineProperty(this,"multiline",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,13))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,13):this.Ff=N(this.Ff,13)}}),Object.defineProperty(this,"fileSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,21))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,21):this.Ff=N(this.Ff,21)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"doNotScroll",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,24))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,24):this.Ff=N(this.Ff,24)}}),Object.defineProperty(this,"comb",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,25))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,25):this.Ff=N(this.Ff,25)}}),Object.defineProperty(this,"richText",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e=null;Object.defineProperty(this,"MaxLen",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"maxLength",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){Number.isInteger(t)&&(e=t)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return this.V||this.DV}})};i(G,M);function Y(){G.call(this),Object.defineProperty(this,"password",{enumerable:!0,configurable:!0,get:function(){return Boolean(w(this.Ff,14))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,14):this.Ff=N(this.Ff,14)}}),this.password=!0}i(Y,G);var J={CheckBox:{createAppearanceStream:function(){return{N:{On:J.CheckBox.YesNormal},D:{On:J.CheckBox.YesPushDown,Off:J.CheckBox.OffPushDown}}},YesPushDown:function(t){var e=new u(t),n=[],r=h.internal.getFont(t.fontName,t.fontStyle).id,i=h.__private__.encodeColorString(t.color),a=L(t,t.caption);return n.push("0.749023 g"),n.push("0 0 "+_(J.internal.getWidth(t))+" "+_(J.internal.getHeight(t))+" re"),n.push("f"),n.push("BMC"),n.push("q"),n.push("0 0 1 rg"),n.push("/"+r+" "+_(a.fontSize)+" Tf "+i),n.push("BT"),n.push(a.text),n.push("ET"),n.push("Q"),n.push("EMC"),e.stream=n.join("\n"),e},YesNormal:function(t){var e=new u(t),n=h.internal.getFont(t.fontName,t.fontStyle).id,r=h.__private__.encodeColorString(t.color),i=[],a=J.internal.getHeight(t),o=J.internal.getWidth(t),s=L(t,t.caption);return i.push("1 g"),i.push("0 0 "+_(o)+" "+_(a)+" re"),i.push("f"),i.push("q"),i.push("0 0 1 rg"),i.push("0 0 "+_(o-1)+" "+_(a-1)+" re"),i.push("W"),i.push("n"),i.push("0 g"),i.push("BT"),i.push("/"+n+" "+_(s.fontSize)+" Tf "+r),i.push(s.text),i.push("ET"),i.push("Q"),e.stream=i.join("\n"),e},OffPushDown:function(t){var e=new u(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(J.internal.getWidth(t))+" "+_(J.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:J.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=J.RadioButton.Circle.YesNormal,e.D[t]=J.RadioButton.Circle.YesPushDown,e},getCA:function(){return"l"},YesNormal:function(t){var e=new u(t),n=[],r=J.internal.getWidth(t)<=J.internal.getHeight(t)?J.internal.getWidth(t)/4:J.internal.getHeight(t)/4;r=Number((.9*r).toFixed(5));var i=J.internal.Bezier_C,a=Number((r*i).toFixed(5));return n.push("q"),n.push("1 0 0 1 "+s(J.internal.getWidth(t)/2)+" "+s(J.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+a+" "+a+" "+r+" 0 "+r+" c"),n.push("-"+a+" "+r+" -"+r+" "+a+" -"+r+" 0 c"),n.push("-"+r+" -"+a+" -"+a+" -"+r+" 0 -"+r+" c"),n.push(a+" -"+r+" "+r+" -"+a+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=new u(t),n=[],r=J.internal.getWidth(t)<=J.internal.getHeight(t)?J.internal.getWidth(t)/4:J.internal.getHeight(t)/4,i=(r=Number((.9*r).toFixed(5)),Number((2*r).toFixed(5))),a=Number((i*J.internal.Bezier_C).toFixed(5)),o=Number((r*J.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(J.internal.getWidth(t)/2)+" "+s(J.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+a+" "+a+" "+i+" 0 "+i+" c"),n.push("-"+a+" "+i+" -"+i+" "+a+" -"+i+" 0 c"),n.push("-"+i+" -"+a+" -"+a+" -"+i+" 0 -"+i+" c"),n.push(a+" -"+i+" "+i+" -"+a+" "+i+" 0 c"),n.push("f"),n.push("Q"),n.push("0 g"),n.push("q"),n.push("1 0 0 1 "+s(J.internal.getWidth(t)/2)+" "+s(J.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+o+" "+o+" "+r+" 0 "+r+" c"),n.push("-"+o+" "+r+" -"+r+" "+o+" -"+r+" 0 c"),n.push("-"+r+" -"+o+" -"+o+" -"+r+" 0 -"+r+" c"),n.push(o+" -"+r+" "+r+" -"+o+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=new u(t),n=[],r=J.internal.getWidth(t)<=J.internal.getHeight(t)?J.internal.getWidth(t)/4:J.internal.getHeight(t)/4;r=Number((.9*r).toFixed(5));var i=Number((2*r).toFixed(5)),a=Number((i*J.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(J.internal.getWidth(t)/2)+" "+s(J.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+a+" "+a+" "+i+" 0 "+i+" c"),n.push("-"+a+" "+i+" -"+i+" "+a+" -"+i+" 0 c"),n.push("-"+i+" -"+a+" -"+a+" -"+i+" 0 -"+i+" c"),n.push(a+" -"+i+" "+i+" -"+a+" "+i+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:J.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=J.RadioButton.Cross.YesNormal,e.D[t]=J.RadioButton.Cross.YesPushDown,e},getCA:function(){return"8"},YesNormal:function(t){var e=new u(t),n=[],r=J.internal.calculateCross(t);return n.push("q"),n.push("1 1 "+_(J.internal.getWidth(t)-2)+" "+_(J.internal.getHeight(t)-2)+" re"),n.push("W"),n.push("n"),n.push(_(r.x1.x)+" "+_(r.x1.y)+" m"),n.push(_(r.x2.x)+" "+_(r.x2.y)+" l"),n.push(_(r.x4.x)+" "+_(r.x4.y)+" m"),n.push(_(r.x3.x)+" "+_(r.x3.y)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=new u(t),n=J.internal.calculateCross(t),r=[];return r.push("0.749023 g"),r.push("0 0 "+_(J.internal.getWidth(t))+" "+_(J.internal.getHeight(t))+" re"),r.push("f"),r.push("q"),r.push("1 1 "+_(J.internal.getWidth(t)-2)+" "+_(J.internal.getHeight(t)-2)+" re"),r.push("W"),r.push("n"),r.push(_(n.x1.x)+" "+_(n.x1.y)+" m"),r.push(_(n.x2.x)+" "+_(n.x2.y)+" l"),r.push(_(n.x4.x)+" "+_(n.x4.y)+" m"),r.push(_(n.x3.x)+" "+_(n.x3.y)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=new u(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(J.internal.getWidth(t))+" "+_(J.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}}},createDefaultAppearanceStream:function(t){var e=h.internal.getFont(t.fontName,t.fontStyle).id,n=h.__private__.encodeColorString(t.color);return"/"+e+" "+t.fontSize+" Tf "+n}};J.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=J.internal.getWidth(t),n=J.internal.getHeight(t),r=Math.min(e,n);return{x1:{x:(e-r)/2,y:(n-r)/2+r},x2:{x:(e-r)/2+r,y:(n-r)/2},x3:{x:(e-r)/2,y:(n-r)/2},x4:{x:(e-r)/2+r,y:(n-r)/2+r}}}},J.internal.getWidth=function(t){var e=0;return"object"===on(t)&&(e=v(t.Rect[2])),e},J.internal.getHeight=function(t){var e=0;return"object"===on(t)&&(e=v(t.Rect[3])),e};var X=n.addField=function(t){if(C.call(this),!(t instanceof M))throw new Error("Invalid argument passed to jsPDF.addField.");return function(t){h.internal.acroformPlugin.printedOut&&(h.internal.acroformPlugin.printedOut=!1,h.internal.acroformPlugin.acroFormDictionaryRoot=null),h.internal.acroformPlugin.acroFormDictionaryRoot||C.call(h),h.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)}.call(this,t),t.page=h.internal.getCurrentPageInfo().pageNumber,this};n.addButton=function(t){if(t instanceof U==!1)throw new Error("Invalid argument passed to jsPDF.addButton.");return X.call(this,t)},n.addTextField=function(t){if(t instanceof G==!1)throw new Error("Invalid argument passed to jsPDF.addTextField.");return X.call(this,t)},n.addChoiceField=function(t){if(t instanceof T==!1)throw new Error("Invalid argument passed to jsPDF.addChoiceField.");return X.call(this,t)},"object"==on(e)&&void 0===e.ChoiceField&&void 0===e.ListBox&&void 0===e.ComboBox&&void 0===e.EditBox&&void 0===e.Button&&void 0===e.PushButton&&void 0===e.RadioButton&&void 0===e.CheckBox&&void 0===e.TextField&&void 0===e.PasswordField?(e.ChoiceField=T,e.ListBox=q,e.ComboBox=R,e.EditBox=D,e.Button=U,e.PushButton=z,e.RadioButton=H,e.CheckBox=V,e.TextField=G,e.PasswordField=Y,e.AcroForm={Appearance:J}):console.warn("AcroForm-Classes are not populated into global-namespace, because the class-Names exist already. This avoids conflicts with the already used framework."),n.AcroFormChoiceField=T,n.AcroFormListBox=q,n.AcroFormComboBox=R,n.AcroFormEditBox=D,n.AcroFormButton=U,n.AcroFormPushButton=z,n.AcroFormRadioButton=H,n.AcroFormCheckBox=V,n.AcroFormTextField=G,n.AcroFormPasswordField=Y,n.AcroFormAppearance=J,n.AcroForm={ChoiceField:T,ListBox:q,ComboBox:R,EditBox:D,Button:U,PushButton:z,RadioButton:H,CheckBox:V,TextField:G,PasswordField:Y,Appearance:J},t.AcroForm={ChoiceField:T,ListBox:q,ComboBox:R,EditBox:D,Button:U,PushButton:z,RadioButton:H,CheckBox:V,TextField:G,PasswordField:Y,Appearance:J}}(U,"undefined"!=typeof window&&window||"undefined"!=typeof global&&global),
/** @license
   * jsPDF addImage plugin
   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
   *               2013 Chris Dowling, https://github.com/gingerchris
   *               2013 Trinh Ho, https://github.com/ineedfat
   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
   *               2013 Norah Smith, https://github.com/burnburnrocket
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   */
function(s){var p="addImage_";s.__addimage__={};function h(t){for(var e=this.internal.write,n=this.internal.putStream,r=(0,this.internal.getFilters)();-1!==r.indexOf("FlateEncode");)r.splice(r.indexOf("FlateEncode"),1);t.objectId=this.internal.newObject();var i=[];if(i.push({key:"Type",value:"/XObject"}),i.push({key:"Subtype",value:"/Image"}),i.push({key:"Width",value:t.width}),i.push({key:"Height",value:t.height}),t.colorSpace===v.INDEXED?i.push({key:"ColorSpace",value:"[/Indexed /DeviceRGB "+(t.palette.length/3-1)+" "+("sMask"in t&&void 0!==t.sMask?t.objectId+2:t.objectId+1)+" 0 R]"}):(i.push({key:"ColorSpace",value:"/"+t.colorSpace}),t.colorSpace===v.DEVICE_CMYK&&i.push({key:"Decode",value:"[1 0 1 0 1 0 1 0]"})),i.push({key:"BitsPerComponent",value:t.bitsPerComponent}),"decodeParameters"in t&&void 0!==t.decodeParameters&&i.push({key:"DecodeParms",value:"<<"+t.decodeParameters+">>"}),"transparency"in t&&Array.isArray(t.transparency)){for(var a="",o=0,s=t.transparency.length;o<s;o++)a+=t.transparency[o]+" "+t.transparency[o]+" ";i.push({key:"Mask",value:"["+a+"]"})}void 0!==t.sMask&&i.push({key:"SMask",value:t.objectId+1+" 0 R"});var u=void 0!==t.filter?["/"+t.filter]:void 0;if(n({data:t.data,additionalKeyValues:i,alreadyAppliedFilters:u}),e("endobj"),"sMask"in t&&void 0!==t.sMask){var l="/Predictor "+t.predictor+" /Colors 1 /BitsPerComponent "+t.bitsPerComponent+" /Columns "+t.width,c={width:t.width,height:t.height,colorSpace:"DeviceGray",bitsPerComponent:t.bitsPerComponent,decodeParameters:l,data:t.sMask};"filter"in t&&(c.filter=t.filter),h.call(this,c)}t.colorSpace===v.INDEXED&&(this.internal.newObject(),n({data:A(new Uint8Array(t.palette))}),e("endobj"))}function t(){var t=this.internal.collections[p+"images"];for(var e in t)h.call(this,t[e])}function e(){var t,e=this.internal.collections[p+"images"],n=this.internal.write;for(var r in e)n("/I"+(t=e[r]).index,t.objectId,"0","R")}function g(){this.internal.collections[p+"images"]||(this.internal.collections[p+"images"]={},this.internal.events.subscribe("putResources",t),this.internal.events.subscribe("putXobjectDict",e))}function u(t){return"function"==typeof s["process"+t.toUpperCase()]}function f(t){return"object"===on(t)&&1===t.nodeType}function l(t,e){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return atob(unescape(n).split("base64,").pop());var r=s.loadFile(n,!0);if(void 0!==r)return r}if("CANVAS"===t.nodeName){var i;switch(e){case"PNG":i="image/png";break;case"WEBP":i="image/webp";break;case"JPEG":case"JPG":default:i="image/jpeg"}return atob(t.toDataURL(i,1).split("base64,").pop())}}function d(t,e,n,r,i,a){var o=function(t,e,n){return t||e||(e=t=-96),t<0&&(t=-1*n.width*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.height*72/e/this.internal.scaleFactor),0===t&&(t=e*n.width/n.height),0===e&&(e=t*n.height/n.width),[t,e]}.call(this,n,r,i),s=this.internal.getCoordinateString,u=this.internal.getVerticalCoordinateString,l=function(){var t=this.internal.collections[p+"images"];return g.call(this),t}.call(this);if(n=o[0],r=o[1],l[i.index]=i,a){a*=Math.PI/180;var c=Math.cos(a),h=Math.sin(a),f=function(t){return t.toFixed(4)},d=[f(c),f(h),f(-1*h),f(c),0,0,"cm"]}this.internal.write("q"),a?(this.internal.write([1,"0","0",1,s(t),u(e+r),"cm"].join(" ")),this.internal.write(d.join(" ")),this.internal.write([s(n),"0","0",s(r),"0","0","cm"].join(" "))):this.internal.write([s(n),"0","0",s(r),s(t),u(e+r),"cm"].join(" ")),this.isAdvancedAPI()&&this.internal.write([1,0,0,-1,0,0,"cm"].join(" ")),this.internal.write("/I"+i.index+" Do"),this.internal.write("Q")}var m="UNKNOWN",c={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0],[255,216,255,219],[255,216,255,238]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],WEBP:[[82,73,70,70,void 0,void 0,void 0,void 0,87,69,66,80]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]},b=s.__addimage__.getImageFileTypeByImageData=function(t,e){var n,r;e=e||m;var i,a,o,s=m;if(N(t))for(o in c)for(i=c[o],n=0;n<i.length;n+=1){for(a=!0,r=0;r<i[n].length;r+=1)if(void 0!==i[n][r]&&i[n][r]!==t[r]){a=!1;break}if(!0===a){s=o;break}}else for(o in c)for(i=c[o],n=0;n<i.length;n+=1){for(a=!0,r=0;r<i[n].length;r+=1)if(void 0!==i[n][r]&&i[n][r]!==t.charCodeAt(r)){a=!1;break}if(!0===a){s=o;break}}return s===m&&e!==m&&(s=e),s},v=s.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"};s.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"};var y=s.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},w=s.__addimage__.sHashCode=function(t){var e,n,r=0;if("string"==typeof t)for(n=t.length,e=0;e<n;e++)r=(r<<5)-r+t.charCodeAt(e),r|=0;else if(N(t))for(n=t.byteLength/2,e=0;e<n;e++)r=(r<<5)-r+t[e],r|=0;return r},a=s.__addimage__.validateStringAsBase64=function(t){(t=t||"").toString().trim();var e=!0;return 0===t.length&&(e=!1),t.length%4!=0&&(e=!1),!1===/^[A-Za-z0-9+/]+$/.test(t.substr(0,t.length-2))&&(e=!1),!1===/^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2))&&(e=!1),e},o=s.__addimage__.extractImageFromDataUrl=function(t){var e=(t=t||"").split("base64,"),n=null;if(2===e.length){var r=/^data:(\w*\/\w*);*(charset=[\w=-]*)*;*$/.exec(e[0]);Array.isArray(r)&&(n={mimeType:r[1],charset:r[2],data:e[1]})}return n},x=s.__addimage__.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array};s.__addimage__.isArrayBuffer=function(t){return x()&&t instanceof ArrayBuffer};var N=s.__addimage__.isArrayBufferView=function(t){return x()&&"undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array)},L=s.__addimage__.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},A=s.__addimage__.arrayBufferToBinaryString=function(e){try{return atob(btoa(String.fromCharCode.apply(null,e)))}catch(t){if("undefined"!=typeof Uint8Array&&void 0!==Uint8Array.prototype.reduce)return new Uint8Array(e).reduce(function(t,e){return t.push(String.fromCharCode(e)),t},[]).join("")}};s.addImage=function(){var t,e,n,r,i,a,o,s,u;if(t=arguments[0],u="number"==typeof arguments[1]?(e=m,n=arguments[1],r=arguments[2],i=arguments[3],a=arguments[4],o=arguments[5],s=arguments[6],arguments[7]):(e=arguments[1],n=arguments[2],r=arguments[3],i=arguments[4],a=arguments[5],o=arguments[6],s=arguments[7],arguments[8]),"object"===on(t)&&!f(t)&&"imageData"in t){var l=t;t=l.imageData,e=l.format||e||m,n=l.x||n||0,r=l.y||r||0,i=l.w||l.width||i,a=l.h||l.height||a,o=l.alias||o,s=l.compression||s,u=l.rotation||l.angle||u}var c=this.internal.getFilters();if(void 0===s&&-1!==c.indexOf("FlateEncode")&&(s="SLOW"),isNaN(n)||isNaN(r))throw new Error("Invalid coordinates passed to jsPDF.addImage");g.call(this);var h=_.call(this,t,e,o,s);return d.call(this,n,r,i,a,h,u),this};var _=function(t,e,n,r){var i,a;if("string"==typeof t&&b(t)===m){t=unescape(t);var o=S(t,!1);""!==o?t=o:void 0!==(o=s.loadFile(t,!0))&&(t=o)}if(f(t)&&(t=l(t,e)),e=b(t,e),!u(e))throw new Error("addImage does not support files of type '"+e+"', please ensure that a plugin for '"+e+"' support is added.");if(function(t){return null==t||0===t.length}(n)&&(n=function(t){return"string"==typeof t||N(t)?w(t):null}(t)),(i=function(t){var e=this.internal.collections[p+"images"];if(e)for(var n in e)if(t===e[n].alias)return e[n]}.call(this,n))||(x()&&(t instanceof Uint8Array||(t=L(a=t))),i=this["process"+e.toUpperCase()](t,function(){return Object.keys(this.internal.collections[p+"images"]).length}.call(this),n,function(t){return t&&"string"==typeof t&&(t=t.toUpperCase()),t in s.image_compression?t:y.NONE}(r),a)),!i)throw new Error("An unknown error occurred whilst processing the image.");return i},S=s.__addimage__.convertBase64ToBinaryString=function(t,e){var n;e="boolean"!=typeof e||e;var r,i="";if("string"==typeof t){r=null!==(n=o(t))?n.data:t;try{i=atob(r)}catch(t){if(e)throw a(r)?new Error("atob-Error in jsPDF.convertBase64ToBinaryString "+t.message):new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ")}}return i};s.getImageProperties=function(t){var e,n,r="";if(f(t)&&(t=l(t)),"string"==typeof t&&b(t)===m&&(""===(r=S(t,!1))&&(r=s.loadFile(t)||""),t=r),n=b(t),!u(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if(!x()||t instanceof Uint8Array||(t=L(t)),!(e=this["process"+n.toUpperCase()](t)))throw new Error("An unknown error occurred whilst processing the image");return e.fileType=n,e}}(U.API),
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
t=U.API,U.API.events.push(["addPage",function(t){this.internal.getPageInfo(t.pageNumber).pageContext.annotations=[]}]),t.events.push(["putPage",function(t){for(var e,n,r,i=this.internal.getCoordinateString,a=this.internal.getVerticalCoordinateString,o=this.internal.getPageInfoByObjId(t.objId),s=t.pageContext.annotations,u=!1,l=0;l<s.length&&!u;l++)switch((e=s[l]).type){case"link":(z(e.options.url)||z(e.options.pageNumber))&&(u=!0);break;case"reference":case"text":case"freetext":u=!0}if(0!=u){this.internal.write("/Annots [");for(var c=0;c<s.length;c++)switch((e=s[c]).type){case"reference":this.internal.write(" "+e.object.objId+" 0 R ");break;case"text":var h=this.internal.newAdditionalObject(),f=this.internal.newAdditionalObject(),d=e.title||"Note";r="<</Type /Annot /Subtype /Text "+(n="/Rect ["+i(e.bounds.x)+" "+a(e.bounds.y+e.bounds.h)+" "+i(e.bounds.x+e.bounds.w)+" "+a(e.bounds.y)+"] ")+"/Contents ("+e.contents+")",r+=" /Popup "+f.objId+" 0 R",r+=" /P "+o.objId+" 0 R",r+=" /T ("+d+") >>",h.content=r;var p=h.objId+" 0 R";r="<</Type /Annot /Subtype /Popup "+(n="/Rect ["+i(e.bounds.x+30)+" "+a(e.bounds.y+e.bounds.h)+" "+i(e.bounds.x+e.bounds.w+30)+" "+a(e.bounds.y)+"] ")+" /Parent "+p,e.open&&(r+=" /Open true"),r+=" >>",f.content=r,this.internal.write(h.objId,"0 R",f.objId,"0 R");break;case"freetext":n="/Rect ["+i(e.bounds.x)+" "+a(e.bounds.y)+" "+i(e.bounds.x+e.bounds.w)+" "+a(e.bounds.y+e.bounds.h)+"] ";var g=e.color||"#000000";r="<</Type /Annot /Subtype /FreeText "+n+"/Contents ("+e.contents+")",r+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+g+")",r+=" /Border [0 0 0]",r+=" >>",this.internal.write(r);break;case"link":if(e.options.name){var m=this.annotations._nameMap[e.options.name];e.options.pageNumber=m.page,e.options.top=m.y}else e.options.top||(e.options.top=0);if(n="/Rect ["+i(e.x)+" "+a(e.y)+" "+i(e.x+e.w)+" "+a(e.y+e.h)+"] ",r="",e.options.url)r="<</Type /Annot /Subtype /Link "+n+"/Border [0 0 0] /A <</S /URI /URI ("+e.options.url+") >>";else if(e.options.pageNumber)switch(r="<</Type /Annot /Subtype /Link "+n+"/Border [0 0 0] /Dest ["+this.internal.getPageInfo(e.options.pageNumber).objId+" 0 R",e.options.magFactor=e.options.magFactor||"XYZ",e.options.magFactor){case"Fit":r+=" /Fit]";break;case"FitH":r+=" /FitH "+e.options.top+"]";break;case"FitV":e.options.left=e.options.left||0,r+=" /FitV "+e.options.left+"]";break;case"XYZ":default:var b=a(e.options.top);e.options.left=e.options.left||0,void 0===e.options.zoom&&(e.options.zoom=0),r+=" /XYZ "+e.options.left+" "+b+" "+e.options.zoom+"]"}""!=r&&(r+=" >>",this.internal.write(r))}this.internal.write("]")}}]),t.createAnnotation=function(t){var e=this.internal.getCurrentPageInfo();switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":e.pageContext.annotations.push(t)}},t.link=function(t,e,n,r,i){this.internal.getCurrentPageInfo().pageContext.annotations.push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),a=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,n,r),n+=.2*a,this.link(e,n-a,i,a,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor},
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){var l={1569:[65152],1570:[65153,65154],1571:[65155,65156],1572:[65157,65158],1573:[65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194],1584:[65195,65196],1585:[65197,65198],1586:[65199,65200],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},a={65247:{65154:65269,65156:65271,65160:65273,65166:65275},65248:{65154:65270,65156:65272,65160:65274,65166:65276},65165:{65247:{65248:{65258:65010}}},1617:{1612:64606,1613:64607,1614:64608,1615:64609,1616:64610}},e={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},n=[1570,1571,1573,1575];t.__arabicParser__={};var r=t.__arabicParser__.isInArabicSubstitutionA=function(t){return void 0!==l[t.charCodeAt(0)]},c=t.__arabicParser__.isArabicLetter=function(t){return"string"==typeof t&&/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t)},i=t.__arabicParser__.isArabicEndLetter=function(t){return c(t)&&r(t)&&l[t.charCodeAt(0)].length<=2},o=t.__arabicParser__.isArabicAlfLetter=function(t){return c(t)&&0<=n.indexOf(t.charCodeAt(0))};t.__arabicParser__.arabicLetterHasIsolatedForm=function(t){return c(t)&&r(t)&&1<=l[t.charCodeAt(0)].length};var s=t.__arabicParser__.arabicLetterHasFinalForm=function(t){return c(t)&&r(t)&&2<=l[t.charCodeAt(0)].length};t.__arabicParser__.arabicLetterHasInitialForm=function(t){return c(t)&&r(t)&&3<=l[t.charCodeAt(0)].length};var u=t.__arabicParser__.arabicLetterHasMedialForm=function(t){return c(t)&&r(t)&&4==l[t.charCodeAt(0)].length},h=t.__arabicParser__.resolveLigatures=function(t){var e=0,n=a,r="",i=0;for(e=0;e<t.length;e+=1)void 0!==n[t.charCodeAt(e)]?(i++,"number"==typeof(n=n[t.charCodeAt(e)])&&(r+=String.fromCharCode(n),n=a,i=0),e===t.length-1&&(n=a,r+=t.charAt(e-(i-1)),e-=i-1,i=0)):(n=a,r+=t.charAt(e-i),e-=i,i=0);return r};t.__arabicParser__.isArabicDiacritic=function(t){return void 0!==t&&void 0!==e[t.charCodeAt(0)]};function f(t){var e=0,n=0,r=0,i="",a="",o="",s=(t=t||"").split("\\s+"),u=[];for(e=0;e<s.length;e+=1){for(u.push(""),n=0;n<s[e].length;n+=1)i=s[e][n],a=s[e][n-1],o=s[e][n+1],c(i)?(r=d(i,a,o),u[e]+=-1!==r?String.fromCharCode(l[i.charCodeAt(0)][r]):i):u[e]+=i;u[e]=h(u[e])}return u.join(" ")}var d=t.__arabicParser__.getCorrectForm=function(t,e,n){return c(t)?!1===r(t)?-1:!s(t)||!c(e)&&!c(n)||!c(n)&&i(e)||i(t)&&!c(e)||i(t)&&o(e)||i(t)&&i(e)?0:u(t)&&c(e)&&!i(e)&&c(n)&&s(n)?3:i(t)||!c(n)?1:2:-1},p=t.__arabicParser__.processArabic=t.processArabic=function(){var t,e="string"==typeof arguments[0]?arguments[0]:arguments[0].text,n=[];if(Array.isArray(e)){var r=0;for(n=[],r=0;r<e.length;r+=1)Array.isArray(e[r])?n.push([f(e[r][0]),e[r][1],e[r][2]]):n.push([f(e[r])]);t=n}else t=f(e);return"string"==typeof arguments[0]?t:(arguments[0].text=t,arguments[0])};t.events.push(["preProcessText",p])}(U.API),U.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.out("/OpenAction "+e+" 0 R")})}return this},
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
e=U.API,H.prototype.getContext=function(t,e){var n;if("2d"!==(t=t||"2d"))return null;for(n in e)this.pdf.context2d.hasOwnProperty(n)&&(this.pdf.context2d[n]=e[n]);return(this.pdf.context2d._canvas=this).pdf.context2d},H.prototype.toDataURL=function(){throw new Error("toDataURL is not implemented.")},e.events.push(["initialized",function(){this.canvas=new H,this.canvas.pdf=this}]),
/**
   * @license
   * ====================================================================
   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Hall, james@parall.ax
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
function(t){function S(){void 0===this.internal.__cell__&&(this.internal.__cell__={},this.internal.__cell__.padding=3,this.internal.__cell__.headerFunction=void 0,this.internal.__cell__.margins=Object.assign({},P),this.internal.__cell__.margins.width=this.getPageWidth(),k.call(this))}var P={left:0,top:0,bottom:0,right:0},o=!1,k=function(){this.internal.__cell__.lastCell=new F,this.internal.__cell__.pages=1},F=function(){var e=arguments[0];Object.defineProperty(this,"x",{enumerable:!0,get:function(){return e},set:function(t){e=t}});var n=arguments[1];Object.defineProperty(this,"y",{enumerable:!0,get:function(){return n},set:function(t){n=t}});var r=arguments[2];Object.defineProperty(this,"width",{enumerable:!0,get:function(){return r},set:function(t){r=t}});var i=arguments[3];Object.defineProperty(this,"height",{enumerable:!0,get:function(){return i},set:function(t){i=t}});var a=arguments[4];Object.defineProperty(this,"text",{enumerable:!0,get:function(){return a},set:function(t){a=t}});var o=arguments[5];Object.defineProperty(this,"lineNumber",{enumerable:!0,get:function(){return o},set:function(t){o=t}});var s=arguments[6];return Object.defineProperty(this,"align",{enumerable:!0,get:function(){return s},set:function(t){s=t}}),this};F.prototype.clone=function(){return new F(this.x,this.y,this.width,this.height,this.text,this.lineNumber,this.align)},F.prototype.toArray=function(){return[this.x,this.y,this.width,this.height,this.text,this.lineNumber,this.align]},t.setHeaderFunction=function(t){return S.call(this),this.internal.__cell__.headerFunction="function"==typeof t?t:void 0,this},t.getTextDimensions=function(t,e){S.call(this);var n=(e=e||{}).fontSize||this.getFontSize(),r=e.font||this.getFont(),i=e.scaleFactor||this.internal.scaleFactor,a=0,o=0,s=0;if(!Array.isArray(t)&&"string"!=typeof t)throw new Error("getTextDimensions expects text-parameter to be of type String or an Array of Strings.");t=Array.isArray(t)?t:[t];for(var u=0;u<t.length;u++)a<(s=this.getStringUnitWidth(t[u],{font:r})*n)&&(a=s),0!==a&&(o=t.length);return{w:a/=i,h:Math.max((o*n*this.getLineHeightFactor()-n*(this.getLineHeightFactor()-1))/i,0)}},t.cellAddPage=function(){S.call(this),this.addPage();var t=this.internal.__cell__.margins||P;return this.internal.__cell__.lastCell=new F(t.left,t.top,void 0,void 0),this.internal.__cell__.pages+=1,this},t.cellInitialize=function(){S.call(this),k.call(this)};var C=t.cell=function(){var t;t=arguments[0]instanceof F?arguments[0]:new F(arguments[0],arguments[1],arguments[2],arguments[3],arguments[4],arguments[5]),S.call(this);var e=this.internal.__cell__.lastCell,n=this.internal.__cell__.padding,r=this.internal.__cell__.margins||P,i=this.internal.__cell__.tableHeaderRow,a=this.internal.__cell__.printHeaders;return void 0!==e.lineNumber&&(e.lineNumber===t.lineNumber?(t.x=(e.x||0)+(e.width||0),t.y=e.y||0):e.y+e.height+t.height+r.bottom>this.getPageHeight()?(this.cellAddPage(),t.y=r.top,a&&i&&(this.printHeaderRow(t.lineNumber,!0),t.y+=i[0].height)):t.y=e.y+e.height||t.y),void 0!==t.text[0]&&(this.rect(t.x,t.y,t.width,t.height,!0===o?"FD":void 0),"right"===t.align?this.text(t.text,t.x+t.width-n,t.y+n,{align:"right",baseline:"top"}):"center"===t.align?this.text(t.text,t.x+t.width/2,t.y+n,{align:"center",baseline:"top",maxWidth:t.width-n-n}):this.text(t.text,t.x+n,t.y+n,{align:"left",baseline:"top",maxWidth:t.width-n-n})),this.internal.__cell__.lastCell=t,this};t.table=function(e,n,t,r,i){if(S.call(this),!t)throw new Error("No data for PDF table.");var a,o,s,u,l=[],c=[],h=[],f={},d={},p=[],g=[],m=(i=i||{}).autoSize||!1,b=!1!==i.printHeaders,v=i.css&&void 0!==i.css["font-size"]?16*i.css["font-size"]:i.fontSize||12,y=i.margins||Object.assign({width:this.getPageWidth()},P),w="number"==typeof i.padding?i.padding:3,x=i.headerBackgroundColor||"#c8c8c8";if(k.call(this),this.internal.__cell__.printHeaders=b,this.internal.__cell__.margins=y,this.internal.__cell__.table_font_size=v,this.internal.__cell__.padding=w,this.internal.__cell__.headerBackgroundColor=x,this.setFontSize(v),null==r)h=(c=l=Object.keys(t[0])).map(function(){return"left"});else if(Array.isArray(r)&&"object"===on(r[0]))for(l=r.map(function(t){return t.name}),c=r.map(function(t){return t.prompt||t.name||""}),h=l.map(function(t){return t.align||"left"}),a=0;a<r.length;a+=1)d[r[a].name]=r[a].width*(19.049976/25.4);else Array.isArray(r)&&"string"==typeof r[0]&&(h=(c=l=r).map(function(){return"left"}));if(m)for(a=0;a<l.length;a+=1){for(f[u=l[a]]=t.map(function(t){return t[u]}),this.setFontStyle("bold"),p.push(this.getTextDimensions(c[a],{fontSize:this.internal.__cell__.table_font_size,scaleFactor:this.internal.scaleFactor}).w),o=f[u],this.setFontStyle("normal"),s=0;s<o.length;s+=1)p.push(this.getTextDimensions(o[s],{fontSize:this.internal.__cell__.table_font_size,scaleFactor:this.internal.scaleFactor}).w);d[u]=Math.max.apply(null,p)+w+w,p=[]}if(b){var N={};for(a=0;a<l.length;a+=1)N[l[a]]={},N[l[a]].text=c[a],N[l[a]].align=h[a];var L=I.call(this,N,d);g=l.map(function(t){return new F(e,n,d[t],L,N[t].text,void 0,N[t].align)}),this.setTableHeaderRow(g),this.printHeaderRow(1,!1)}var A=r.reduce(function(t,e){return t[e.name]=e.align,t},{});for(a=0;a<t.length;a+=1){var _=I.call(this,t[a],d);for(s=0;s<l.length;s+=1)C.call(this,new F(e,n,d[l[s]],_,t[a][l[s]],a+2,A[l[s]]))}return this.internal.__cell__.table_x=e,this.internal.__cell__.table_y=n,this};var I=function(t,e){var n=this.internal.__cell__.padding,r=this.internal.__cell__.table_font_size,i=this.internal.scaleFactor;return Object.keys(t).map(function(t){return"object"===on(t)?t.text:t}).map(function(t){return this.splitTextToSize(t,e[t]-n-n)},this).map(function(t){return this.getLineHeightFactor()*t.length*r/i+n+n},this).reduce(function(t,e){return Math.max(t,e)},0)};t.setTableHeaderRow=function(t){S.call(this),this.internal.__cell__.tableHeaderRow=t},t.printHeaderRow=function(t,e){if(S.call(this),!this.internal.__cell__.tableHeaderRow)throw new Error("Property tableHeaderRow does not exist.");var n;if(o=!0,"function"==typeof this.internal.__cell__.headerFunction){var r=this.internal.__cell__.headerFunction(this,this.internal.__cell__.pages);this.internal.__cell__.lastCell=new F(r[0],r[1],r[2],r[3],void 0,-1)}this.setFontStyle("bold");for(var i=[],a=0;a<this.internal.__cell__.tableHeaderRow.length;a+=1)n=this.internal.__cell__.tableHeaderRow[a].clone(),e&&(n.y=this.internal.__cell__.margins.top||0,i.push(n)),n.lineNumber=t,this.setFillColor(this.internal.__cell__.headerBackgroundColor),C.call(this,n);0<i.length&&this.setTableHeaderRow(i),this.setFontStyle("normal"),o=!1}}(U.API),
/**
   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
function(t){function c(t){return t=t||{},this.isStrokeTransparent=t.isStrokeTransparent||!1,this.strokeOpacity=t.strokeOpacity||1,this.strokeStyle=t.strokeStyle||"#000000",this.fillStyle=t.fillStyle||"#000000",this.isFillTransparent=t.isFillTransparent||!1,this.fillOpacity=t.fillOpacity||1,this.font=t.font||"10px sans-serif",this.textBaseline=t.textBaseline||"alphabetic",this.textAlign=t.textAlign||"left",this.lineWidth=t.lineWidth||1,this.lineJoin=t.lineJoin||"miter",this.lineCap=t.lineCap||"butt",this.path=t.path||[],this.transform=void 0!==t.transform?t.transform.clone():new P,this.globalCompositeOperation=t.globalCompositeOperation||"normal",this.globalAlpha=t.globalAlpha||1,this.clip_path=t.clip_path||[],this.currentPoint=t.currentPoint||new v,this.miterLimit=t.miterLimit||10,this.lastPoint=t.lastPoint||new v,this.ignoreClearRect="boolean"!=typeof t.ignoreClearRect||t.ignoreClearRect,this}var u,i,a,l,h,v,k,P,f;t.events.push(["initialized",function(){this.context2d=new e(this),u=this.internal.f2,i=this.internal.getCoordinateString,a=this.internal.getVerticalCoordinateString,l=this.internal.getHorizontalCoordinate,h=this.internal.getVerticalCoordinate,v=this.internal.Point,k=this.internal.Rectangle,P=this.internal.Matrix,f=new c}]);var e=function(t){Object.defineProperty(this,"canvas",{get:function(){return{parentNode:!1,style:!1}}});var e=t;Object.defineProperty(this,"pdf",{get:function(){return e}});var n=!1;Object.defineProperty(this,"pageWrapXEnabled",{get:function(){return n},set:function(t){n=Boolean(t)}});var r=!1;Object.defineProperty(this,"pageWrapYEnabled",{get:function(){return r},set:function(t){r=Boolean(t)}});var i=0;Object.defineProperty(this,"posX",{get:function(){return i},set:function(t){isNaN(t)||(i=t)}});var a=0;Object.defineProperty(this,"posY",{get:function(){return a},set:function(t){isNaN(t)||(a=t)}});var o=!1;Object.defineProperty(this,"autoPaging",{get:function(){return o},set:function(t){o=Boolean(t)}});var s=0;Object.defineProperty(this,"lastBreak",{get:function(){return s},set:function(t){s=t}});var u=[];Object.defineProperty(this,"pageBreaks",{get:function(){return u},set:function(t){u=t}}),Object.defineProperty(this,"ctx",{get:function(){return f},set:function(t){t instanceof c&&(f=t)}}),Object.defineProperty(this,"path",{get:function(){return f.path},set:function(t){f.path=t}});var l=[];Object.defineProperty(this,"ctxStack",{get:function(){return l},set:function(t){l=t}}),Object.defineProperty(this,"fillStyle",{get:function(){return this.ctx.fillStyle},set:function(t){var e;e=d(t),this.ctx.fillStyle=e.style,this.ctx.isFillTransparent=0===e.a,this.ctx.fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})}}),Object.defineProperty(this,"strokeStyle",{get:function(){return this.ctx.strokeStyle},set:function(t){var e=d(t);this.ctx.strokeStyle=e.style,this.ctx.isStrokeTransparent=0===e.a,this.ctx.strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))}}),Object.defineProperty(this,"lineCap",{get:function(){return this.ctx.lineCap},set:function(t){-1!==["butt","round","square"].indexOf(t)&&(this.ctx.lineCap=t,this.pdf.setLineCap(t))}}),Object.defineProperty(this,"lineWidth",{get:function(){return this.ctx.lineWidth},set:function(t){isNaN(t)||(this.ctx.lineWidth=t,this.pdf.setLineWidth(t))}}),Object.defineProperty(this,"lineJoin",{get:function(){return this.ctx.lineJoin},set:function(t){-1!==["bevel","round","miter"].indexOf(t)&&(this.ctx.lineJoin=t,this.pdf.setLineJoin(t))}}),Object.defineProperty(this,"miterLimit",{get:function(){return this.ctx.miterLimit},set:function(t){isNaN(t)||(this.ctx.miterLimit=t,this.pdf.setMiterLimit(t))}}),Object.defineProperty(this,"textBaseline",{get:function(){return this.ctx.textBaseline},set:function(t){this.ctx.textBaseline=t}}),Object.defineProperty(this,"textAlign",{get:function(){return this.ctx.textAlign},set:function(t){-1!==["right","end","center","left","start"].indexOf(t)&&(this.ctx.textAlign=t)}}),Object.defineProperty(this,"font",{get:function(){return this.ctx.font},set:function(t){var e;if(this.ctx.font=t,null!==(e=/^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))){var n=e[1],r=(e[2],e[3]),i=e[4],a=(e[5],e[6]),o=/^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];i="px"===o?Math.floor(parseFloat(i)):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)),this.pdf.setFontSize(i);var s="";("bold"===r||700<=parseInt(r,10)||"bold"===n)&&(s="bold"),"italic"===n&&(s+="italic"),0===s.length&&(s="normal");for(var u="",l=a.toLowerCase().replace(/"|'/g,"").split(/\s*,\s*/),c={arial:"Helvetica",verdana:"Helvetica",helvetica:"Helvetica","sans-serif":"Helvetica",fixed:"Courier",monospace:"Courier",terminal:"Courier",courier:"Courier",times:"Times",cursive:"Times",fantasy:"Times",serif:"Times"},h=0;h<l.length;h++){if(void 0!==this.pdf.internal.getFont(l[h],s,{noFallback:!0,disableWarning:!0})){u=l[h];break}if("bolditalic"===s&&void 0!==this.pdf.internal.getFont(l[h],"bold",{noFallback:!0,disableWarning:!0}))u=l[h],s="bold";else if(void 0!==this.pdf.internal.getFont(l[h],"normal",{noFallback:!0,disableWarning:!0})){u=l[h],s="normal";break}}if(""===u)for(var f=0;f<l.length;f++)if(c[l[f]]){u=c[l[f]];break}u=""===u?"Times":u,this.pdf.setFont(u,s)}}}),Object.defineProperty(this,"globalCompositeOperation",{get:function(){return this.ctx.globalCompositeOperation},set:function(t){this.ctx.globalCompositeOperation=t}}),Object.defineProperty(this,"globalAlpha",{get:function(){return this.ctx.globalAlpha},set:function(t){this.ctx.globalAlpha=t}}),Object.defineProperty(this,"ignoreClearRect",{get:function(){return this.ctx.ignoreClearRect},set:function(t){this.ctx.ignoreClearRect=Boolean(t)}})};e.prototype.fill=function(){n.call(this,"fill",!1)},e.prototype.stroke=function(){n.call(this,"stroke",!1)},e.prototype.beginPath=function(){this.path=[{type:"begin"}]},e.prototype.moveTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.moveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.moveTo");var n=this.ctx.transform.applyToPoint(new v(t,e));this.path.push({type:"mt",x:n.x,y:n.y}),this.ctx.lastPoint=new v(t,e)},e.prototype.closePath=function(){var t=new v(0,0),e=0;for(e=this.path.length-1;-1!==e;e--)if("begin"===this.path[e].type&&"object"===on(this.path[e+1])&&"number"==typeof this.path[e+1].x){t=new v(this.path[e+1].x,this.path[e+1].y),this.path.push({type:"lt",x:t.x,y:t.y});break}"object"===on(this.path[e+2])&&"number"==typeof this.path[e+2].x&&this.path.push(JSON.parse(JSON.stringify(this.path[e+2]))),this.path.push({type:"close"}),this.ctx.lastPoint=new v(t.x,t.y)},e.prototype.lineTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.lineTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.lineTo");var n=this.ctx.transform.applyToPoint(new v(t,e));this.path.push({type:"lt",x:n.x,y:n.y}),this.ctx.lastPoint=new v(n.x,n.y)},e.prototype.clip=function(){this.ctx.clip_path=JSON.parse(JSON.stringify(this.path)),n.call(this,null,!0)},e.prototype.quadraticCurveTo=function(t,e,n,r){if(isNaN(n)||isNaN(r)||isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");var i=this.ctx.transform.applyToPoint(new v(n,r)),a=this.ctx.transform.applyToPoint(new v(t,e));this.path.push({type:"qct",x1:a.x,y1:a.y,x:i.x,y:i.y}),this.ctx.lastPoint=new v(i.x,i.y)},e.prototype.bezierCurveTo=function(t,e,n,r,i,a){if(isNaN(i)||isNaN(a)||isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.bezierCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");var o=this.ctx.transform.applyToPoint(new v(i,a)),s=this.ctx.transform.applyToPoint(new v(t,e)),u=this.ctx.transform.applyToPoint(new v(n,r));this.path.push({type:"bct",x1:s.x,y1:s.y,x2:u.x,y2:u.y,x:o.x,y:o.y}),this.ctx.lastPoint=new v(o.x,o.y)},e.prototype.arc=function(t,e,n,r,i,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i))throw console.error("jsPDF.context2d.arc: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.arc");if(a=Boolean(a),!this.ctx.transform.isIdentity){var o=this.ctx.transform.applyToPoint(new v(t,e));t=o.x,e=o.y;var s=this.ctx.transform.applyToPoint(new v(0,n)),u=this.ctx.transform.applyToPoint(new v(0,0));n=Math.sqrt(Math.pow(s.x-u.x,2)+Math.pow(s.y-u.y,2))}Math.abs(i-r)>=2*Math.PI&&(r=0,i=2*Math.PI),this.path.push({type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,counterclockwise:a})},e.prototype.arcTo=function(t,e,n,r,i){throw new Error("arcTo not implemented.")},e.prototype.rect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.rect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rect");this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.lineTo(t+n,e),this.lineTo(t,e)},e.prototype.fillRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.fillRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillRect");if(!x.call(this)){var i={};"butt"!==this.lineCap&&(i.lineCap=this.lineCap,this.lineCap="butt"),"miter"!==this.lineJoin&&(i.lineJoin=this.lineJoin,this.lineJoin="miter"),this.beginPath(),this.rect(t,e,n,r),this.fill(),i.hasOwnProperty("lineCap")&&(this.lineCap=i.lineCap),i.hasOwnProperty("lineJoin")&&(this.lineJoin=i.lineJoin)}},e.prototype.strokeRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.strokeRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");N.call(this)||(this.beginPath(),this.rect(t,e,n,r),this.stroke())},e.prototype.clearRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.clearRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.clearRect");this.ignoreClearRect||(this.fillStyle="#ffffff",this.fillRect(t,e,n,r))},e.prototype.save=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("q");if(this.pdf.setPage(e),t){this.ctx.fontSize=this.pdf.internal.getFontSize();var r=new c(this.ctx);this.ctxStack.push(this.ctx),this.ctx=r}},e.prototype.restore=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("Q");this.pdf.setPage(e),t&&0!==this.ctxStack.length&&(this.ctx=this.ctxStack.pop(),this.fillStyle=this.ctx.fillStyle,this.strokeStyle=this.ctx.strokeStyle,this.font=this.ctx.font,this.lineCap=this.ctx.lineCap,this.lineWidth=this.ctx.lineWidth,this.lineJoin=this.ctx.lineJoin)},e.prototype.toDataURL=function(){throw new Error("toDataUrl not implemented.")};var d=function(t){var e,n,r,i;if(!0===t.isCanvasGradient&&(t=t.getColor()),!t)return{r:0,g:0,b:0,a:0,style:t};if(/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t))i=r=n=e=0;else{var a=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);if(null!==a)e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),i=1;else if(null!==(a=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t)))e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),i=parseFloat(a[4]);else{if(i=1,"string"==typeof t&&"#"!==t.charAt(0)){var o=new RGBColor(t);t=o.ok?o.toHex():"#000000"}4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16)}}return{r:e,g:n,b:r,a:i,style:t}},x=function(){return this.ctx.isFillTransparent||0==this.globalAlpha},N=function(){return Boolean(this.ctx.isStrokeTransparent||0==this.globalAlpha)};e.prototype.fillText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.fillText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillText");if(r=isNaN(r)?void 0:r,!x.call(this)){n=o.call(this,n);var i=B(this.ctx.transform.rotation),a=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:a,angle:i,align:this.textAlign,maxWidth:r})}},e.prototype.strokeText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.strokeText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeText");if(!N.call(this)){r=isNaN(r)?void 0:r,n=o.call(this,n);var i=B(this.ctx.transform.rotation),a=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:a,renderingMode:"stroke",angle:i,align:this.textAlign,maxWidth:r})}},e.prototype.measureText=function(t){if("string"!=typeof t)throw console.error("jsPDF.context2d.measureText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.measureText");var e=this.pdf,n=this.pdf.internal.scaleFactor,r=e.internal.getFontSize(),i=e.getStringUnitWidth(t)*r/e.internal.scaleFactor;return new function(t){var e=(t=t||{}).width||0;return Object.defineProperty(this,"width",{get:function(){return e}}),this}({width:i*=Math.round(96*n/72*1e4)/1e4})},e.prototype.scale=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.scale: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.scale");var n=new P(t,0,0,e,0,0);this.ctx.transform=this.ctx.transform.multiply(n)},e.prototype.rotate=function(t){if(isNaN(t))throw console.error("jsPDF.context2d.rotate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rotate");var e=new P(Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0);this.ctx.transform=this.ctx.transform.multiply(e)},e.prototype.translate=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.translate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.translate");var n=new P(1,0,0,1,t,e);this.ctx.transform=this.ctx.transform.multiply(n)},e.prototype.transform=function(t,e,n,r,i,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(a))throw console.error("jsPDF.context2d.transform: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.transform");var o=new P(t,e,n,r,i,a);this.ctx.transform=this.ctx.transform.multiply(o)},e.prototype.setTransform=function(t,e,n,r,i,a){t=isNaN(t)?1:t,e=isNaN(e)?0:e,n=isNaN(n)?0:n,r=isNaN(r)?1:r,i=isNaN(i)?0:i,a=isNaN(a)?0:a,this.ctx.transform=new P(t,e,n,r,i,a)},e.prototype.drawImage=function(t,e,n,r,i,a,o,s,u){var l=this.pdf.getImageProperties(t),c=1,h=1,f=1,d=1;void 0!==r&&void 0!==s&&(f=s/r,d=u/i,c=l.width/r*s/r,h=l.height/i*u/i),void 0===a&&(a=e,o=n,n=e=0),void 0!==r&&void 0===s&&(s=r,u=i),void 0===r&&void 0===s&&(s=l.width,u=l.height);for(var p,g=this.ctx.transform.decompose(),m=B(g.rotate.shx),b=new P,v=(b=(b=(b=b.multiply(g.translate)).multiply(g.skew)).multiply(g.scale)).applyToRectangle(new k(a-e*f,o-n*d,r*c,i*h)),y=F.call(this,v),w=[],x=0;x<y.length;x+=1)-1===w.indexOf(y[x])&&w.push(y[x]);if(w.sort(),this.autoPaging)for(var N=w[0],L=w[w.length-1],A=N;A<L+1;A++){if(this.pdf.setPage(A),0!==this.ctx.clip_path.length){var _=this.path;p=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=C(p,this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY),I.call(this,"fill",!0),this.path=_}var S=JSON.parse(JSON.stringify(v));S=C([S],this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY)[0],this.pdf.addImage(t,"JPEG",S.x,S.y,S.w,S.h,null,null,m)}else this.pdf.addImage(t,"JPEG",v.x,v.y,v.w,v.h,null,null,m)};var F=function(t,e,n){var r=[];switch(e=e||this.pdf.internal.pageSize.width,n=n||this.pdf.internal.pageSize.height,t.type){default:case"mt":case"lt":r.push(Math.floor((t.y+this.posY)/n)+1);break;case"arc":r.push(Math.floor((t.y+this.posY-t.radius)/n)+1),r.push(Math.floor((t.y+this.posY+t.radius)/n)+1);break;case"qct":var i=y(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x,t.y);r.push(Math.floor(i.y/n)+1),r.push(Math.floor((i.y+i.h)/n)+1);break;case"bct":var a=O(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x2,t.y2,t.x,t.y);r.push(Math.floor(a.y/n)+1),r.push(Math.floor((a.y+a.h)/n)+1);break;case"rect":r.push(Math.floor((t.y+this.posY)/n)+1),r.push(Math.floor((t.y+t.h+this.posY)/n)+1)}for(var o=0;o<r.length;o+=1)for(;this.pdf.internal.getNumberOfPages()<r[o];)w.call(this);return r},w=function(){var t=this.fillStyle,e=this.strokeStyle,n=this.font,r=this.lineCap,i=this.lineWidth,a=this.lineJoin;this.pdf.addPage(),this.fillStyle=t,this.strokeStyle=e,this.font=n,this.lineCap=r,this.lineWidth=i,this.lineJoin=a},C=function(t,e,n){for(var r=0;r<t.length;r++)switch(t[r].type){case"bct":t[r].x2+=e,t[r].y2+=n;case"qct":t[r].x1+=e,t[r].y1+=n;case"mt":case"lt":case"arc":default:t[r].x+=e,t[r].y+=n}return t},n=function(t,e){for(var n,r,i=this.fillStyle,a=this.strokeStyle,o=this.lineCap,s=this.lineWidth,u=this.lineJoin,l=JSON.parse(JSON.stringify(this.path)),c=JSON.parse(JSON.stringify(this.path)),h=[],f=0;f<c.length;f++)if(void 0!==c[f].x)for(var d=F.call(this,c[f]),p=0;p<d.length;p+=1)-1===h.indexOf(d[p])&&h.push(d[p]);for(var g=0;g<h.length;g++)for(;this.pdf.internal.getNumberOfPages()<h[g];)w.call(this);if(h.sort(),this.autoPaging)for(var m=h[0],b=h[h.length-1],v=m;v<b+1;v++){if(this.pdf.setPage(v),this.fillStyle=i,this.strokeStyle=a,this.lineCap=o,this.lineWidth=s,this.lineJoin=u,0!==this.ctx.clip_path.length){var y=this.path;n=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=C(n,this.posX,-1*this.pdf.internal.pageSize.height*(v-1)+this.posY),I.call(this,t,!0),this.path=y}r=JSON.parse(JSON.stringify(l)),this.path=C(r,this.posX,-1*this.pdf.internal.pageSize.height*(v-1)+this.posY),!1!==e&&0!==v||I.call(this,t,e)}else I.call(this,t,e);this.path=l},I=function(t,e){if(("stroke"!==t||e||!N.call(this))&&("stroke"===t||e||!x.call(this))){for(var n,r,i=[],a=this.path,o=0;o<a.length;o++){var s=a[o];switch(s.type){case"begin":i.push({begin:!0});break;case"close":i.push({close:!0});break;case"mt":i.push({start:s,deltas:[],abs:[]});break;case"lt":var u=i.length;if(!isNaN(a[o-1].x)&&(n=[s.x-a[o-1].x,s.y-a[o-1].y],0<u))for(;0<=u;u--)if(!0!==i[u-1].close&&!0!==i[u-1].begin){i[u-1].deltas.push(n),i[u-1].abs.push(s);break}break;case"bct":n=[s.x1-a[o-1].x,s.y1-a[o-1].y,s.x2-a[o-1].x,s.y2-a[o-1].y,s.x-a[o-1].x,s.y-a[o-1].y],i[i.length-1].deltas.push(n);break;case"qct":var l=a[o-1].x+2/3*(s.x1-a[o-1].x),c=a[o-1].y+2/3*(s.y1-a[o-1].y),h=s.x+2/3*(s.x1-s.x),f=s.y+2/3*(s.y1-s.y),d=s.x,p=s.y;n=[l-a[o-1].x,c-a[o-1].y,h-a[o-1].x,f-a[o-1].y,d-a[o-1].x,p-a[o-1].y],i[i.length-1].deltas.push(n);break;case"arc":i.push({deltas:[],abs:[],arc:!0}),Array.isArray(i[i.length-1].abs)&&i[i.length-1].abs.push(s)}}r=e?null:"stroke"===t?"stroke":"fill";for(var g=0;g<i.length;g++){if(i[g].arc){for(var m=i[g].abs,b=0;b<m.length;b++){var v=m[b];"arc"===v.type?L.call(this,v.x,v.y,v.radius,v.startAngle,v.endAngle,v.counterclockwise,void 0,e):S.call(this,v.x,v.y)}A.call(this,r),this.pdf.internal.out("h")}if(!i[g].arc&&!0!==i[g].close&&!0!==i[g].begin){var y=i[g].start.x,w=i[g].start.y;j.call(this,i[g].deltas,y,w)}}r&&A.call(this,r),e&&_.call(this)}},o=function(t){var e=this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor,n=e*(this.pdf.internal.getLineHeightFactor()-1);switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e-n;case"hanging":return t+e-2*n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}};e.prototype.createLinearGradient=function(){function t(){}return t.colorStops=[],t.addColorStop=function(t,e){this.colorStops.push([t,e])},t.getColor=function(){return 0===this.colorStops.length?"#000000":this.colorStops[0][1]},t.isCanvasGradient=!0,t},e.prototype.createPattern=function(){return this.createLinearGradient()},e.prototype.createRadialGradient=function(){return this.createLinearGradient()};var L=function(t,e,n,r,i,a,o,s){for(var u=m.call(this,n,r,i,a),l=0;l<u.length;l++){var c=u[l];0===l&&p.call(this,c.x1+t,c.y1+e),g.call(this,t,e,c.x2,c.y2,c.x3,c.y3,c.x4,c.y4)}s?_.call(this):A.call(this,o)},A=function(t){switch(t){case"stroke":this.pdf.internal.out("S");break;case"fill":this.pdf.internal.out("f")}},_=function(){this.pdf.clip(),this.pdf.discardPath()},p=function(t,e){this.pdf.internal.out(i(t)+" "+a(e)+" m")},s=function(t){var e;switch(t.align){case"right":case"end":e="right";break;case"center":e="center";break;case"left":case"start":default:e="left"}var n=this.ctx.transform.applyToPoint(new v(t.x,t.y)),r=this.ctx.transform.decompose(),i=new P;i=(i=(i=i.multiply(r.translate)).multiply(r.skew)).multiply(r.scale);for(var a,o,s=this.pdf.getTextDimensions(t.text),u=this.ctx.transform.applyToRectangle(new k(t.x,t.y,s.w,s.h)),l=i.applyToRectangle(new k(t.x,t.y-s.h,s.w,s.h)),c=F.call(this,l),h=[],f=0;f<c.length;f+=1)-1===h.indexOf(c[f])&&h.push(c[f]);if(h.sort(),!0===this.autoPaging)for(var d=h[0],p=h[h.length-1],g=d;g<p+1;g++){if(this.pdf.setPage(g),0!==this.ctx.clip_path.length){var m=this.path;a=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=C(a,this.posX,-1*this.pdf.internal.pageSize.height*(g-1)+this.posY),I.call(this,"fill",!0),this.path=m}var b=JSON.parse(JSON.stringify(u));b=C([b],this.posX,-1*this.pdf.internal.pageSize.height*(g-1)+this.posY)[0],.01<=t.scale&&(o=this.pdf.internal.getFontSize(),this.pdf.setFontSize(o*t.scale)),this.pdf.text(t.text,b.x,b.y,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(o)}else.01<=t.scale&&(o=this.pdf.internal.getFontSize(),this.pdf.setFontSize(o*t.scale)),this.pdf.text(t.text,n.x+this.posX,n.y+this.posY,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(o)},S=function(t,e,n,r){n=n||0,r=r||0,this.pdf.internal.out(i(t+n)+" "+a(e+r)+" l")},j=function(t,e,n){return this.pdf.lines(t,e,n,null,null)},g=function(t,e,n,r,i,a,o,s){this.pdf.internal.out([u(l(n+t)),u(h(r+e)),u(l(i+t)),u(h(a+e)),u(l(o+t)),u(h(s+e)),"c"].join(" "))},m=function(t,e,n,r){for(var i=2*Math.PI,a=Math.PI/2;n<e;)e-=i;var o=Math.abs(n-e);o<i&&r&&(o=i-o);for(var s=[],u=r?-1:1,l=e;1e-5<o;){var c=l+u*Math.min(o,a);s.push(b.call(this,t,l,c)),o-=Math.abs(c-l),l=c}return s},b=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),a=t*Math.sin(r),o=i,s=-a,u=o*o+s*s,l=u+o*i+s*a,c=4/3*(Math.sqrt(2*u*l)-l)/(o*a-s*i),h=o-c*s,f=s+c*o,d=h,p=-f,g=r+e,m=Math.cos(g),b=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:h*m-f*b,y2:h*b+f*m,x3:d*m-p*b,y3:d*b+p*m,x4:t*Math.cos(n),y4:t*Math.sin(n)}},B=function(t){return 180*t/Math.PI},y=function(t,e,n,r,i,a){var o=t+.5*(n-t),s=e+.5*(r-e),u=i+.5*(n-i),l=a+.5*(r-a),c=Math.min(t,i,o,u),h=Math.max(t,i,o,u),f=Math.min(e,a,s,l),d=Math.max(e,a,s,l);return new k(c,f,h-c,d-f)},O=function(t,e,n,r,i,a,o,s){var u,l,c,h,f,d,p,g,m,b,v,y,w,x,N=n-t,L=r-e,A=i-n,_=a-r,S=o-i,P=s-a;for(l=0;l<41;l++)m=(p=(c=t+(u=l/40)*N)+u*((f=n+u*A)-c))+u*(f+u*(i+u*S-f)-p),b=(g=(h=e+u*L)+u*((d=r+u*_)-h))+u*(d+u*(a+u*P-d)-g),x=0==l?(w=v=m,y=b):(v=Math.min(v,m),y=Math.min(y,b),w=Math.max(w,m),Math.max(x,b));return new k(Math.round(v),Math.round(y),Math.round(w-v),Math.round(x-y))}}(U.API),(
/**
   * jsPDF filters PlugIn
   * Copyright (c) 2014 Aras Abbasi
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
a=U.API).processDataByFilters=function(t,e){var n=0,r=t||"",i=[];for("string"==typeof(e=e||[])&&(e=[e]),n=0;n<e.length;n+=1)switch(e[n]){case"ASCII85Decode":case"/ASCII85Decode":r=V(r),i.push("/ASCII85Encode");break;case"ASCII85Encode":case"/ASCII85Encode":r=W(r),i.push("/ASCII85Decode");break;case"ASCIIHexDecode":case"/ASCIIHexDecode":r=G(r),i.push("/ASCIIHexEncode");break;case"ASCIIHexEncode":case"/ASCIIHexEncode":r=r.split("").map(function(t){return("0"+t.charCodeAt().toString(16)).slice(-2)}).join("")+">",i.push("/ASCIIHexDecode");break;case"FlateEncode":case"/FlateEncode":r=Y(r),i.push("/FlateDecode");break;default:throw new Error('The filter: "'+e[n]+'" is not implemented')}return{data:r,reverseChain:i.reverse().join(" ")}},(
/**
   * jsPDF fileloading PlugIn
   * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
n=U.API).loadFile=function(t,e,n){e=!1!==e,n="function"==typeof n?n:function(){};var r=void 0;try{r=function(t,e,n){function r(t){var e=t.length,n=[],r=String.fromCharCode;for(a=0;a<e;a+=1)n.push(r(255&t.charCodeAt(a)));return n.join("")}var i=new XMLHttpRequest,a=0;if(i.open("GET",t,!e),i.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(i.onload=function(){200===i.status?n(r(this.responseText)):n(void 0)}),i.send(null),e&&200===i.status)return r(i.responseText)}(t,e,n)}catch(t){}return r},n.loadImageFile=n.loadFile,
/**
   * Copyright (c) 2018 Erik Koopmans
   * Released under the MIT License.
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t,e){if("undefined"!=typeof Promise){var n=function(t){var e=on(t);return"undefined"===e?"undefined":"string"===e||t instanceof String?"string":"number"===e||t instanceof Number?"number":"function"===e||t instanceof Function?"function":t&&t.constructor===Array?"array":t&&1===t.nodeType?"element":"object"===e?"object":"unknown"},r=function(t,e){var n=document.createElement(t);if(e.className&&(n.className=e.className),e.innerHTML){n.innerHTML=e.innerHTML;for(var r=n.getElementsByTagName("script"),i=r.length;0<i--;)r[i].parentNode.removeChild(r[i])}for(var a in e.style)n.style[a]=e.style[a];return n},o=function t(e){var n=Object.assign(t.convert(Promise.resolve()),JSON.parse(JSON.stringify(t.template))),r=t.convert(Promise.resolve(),n);return r=(r=r.setProgress(1,t,1,[t])).set(e)};((o.prototype=Object.create(Promise.prototype)).constructor=o).convert=function(t,e){return t.__proto__=e||o.prototype,t},o.template={prop:{src:null,container:null,overlay:null,canvas:null,img:null,pdf:null,pageSize:null,callback:function(){}},progress:{val:0,state:null,n:0,stack:[]},opt:{filename:"file.pdf",margin:[0,0,0,0],enableLinks:!0,x:0,y:0,html2canvas:{},jsPDF:{}}},o.prototype.from=function(t,e){return this.then(function(){switch(e=e||function(t){switch(n(t)){case"string":return"string";case"element":return"canvas"===t.nodeName.toLowerCase?"canvas":"element";default:return"unknown"}}(t)){case"string":return this.set({src:r("div",{innerHTML:t})});case"element":return this.set({src:t});case"canvas":return this.set({canvas:t});case"img":return this.set({img:t});default:return this.error("Unknown source type.")}})},o.prototype.to=function(t){switch(t){case"container":return this.toContainer();case"canvas":return this.toCanvas();case"img":return this.toImg();case"pdf":return this.toPdf();default:return this.error("Invalid target.")}},o.prototype.toContainer=function(){return this.thenList([function(){return this.prop.src||this.error("Cannot duplicate - no source HTML.")},function(){return this.prop.pageSize||this.setPageSize()}]).then(function(){var t={position:"relative",display:"inline-block",width:Math.max(this.prop.src.clientWidth,this.prop.src.scrollWidth,this.prop.src.offsetWidth)+"px",left:0,right:0,top:0,margin:"auto",backgroundColor:"white"},e=function t(e,n){for(var r=3===e.nodeType?document.createTextNode(e.nodeValue):e.cloneNode(!1),i=e.firstChild;i;i=i.nextSibling)!0!==n&&1===i.nodeType&&"SCRIPT"===i.nodeName||r.appendChild(t(i,n));return 1===e.nodeType&&("CANVAS"===e.nodeName?(r.width=e.width,r.height=e.height,r.getContext("2d").drawImage(e,0,0)):"TEXTAREA"!==e.nodeName&&"SELECT"!==e.nodeName||(r.value=e.value),r.addEventListener("load",function(){r.scrollTop=e.scrollTop,r.scrollLeft=e.scrollLeft},!0)),r}(this.prop.src,this.opt.html2canvas.javascriptEnabled);"BODY"===e.tagName&&(t.height=Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight)+"px"),this.prop.overlay=r("div",{className:"html2pdf__overlay",style:{position:"fixed",overflow:"hidden",zIndex:1e3,left:"-100000px",right:0,bottom:0,top:0}}),this.prop.container=r("div",{className:"html2pdf__container",style:t}),this.prop.container.appendChild(e),this.prop.container.firstChild.appendChild(r("div",{style:{clear:"both",border:"0 none transparent",margin:0,padding:0,height:0}})),this.prop.container.style.float="none",this.prop.overlay.appendChild(this.prop.container),document.body.appendChild(this.prop.overlay),this.prop.container.firstChild.style.position="relative",this.prop.container.height=Math.max(this.prop.container.firstChild.clientHeight,this.prop.container.firstChild.scrollHeight,this.prop.container.firstChild.offsetHeight)+"px"})},o.prototype.toCanvas=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=Object.assign({},this.opt.html2canvas);if(delete t.onrendered,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,t)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},o.prototype.toContext2d=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=this.opt.jsPDF,e=Object.assign({async:!0,allowTaint:!0,backgroundColor:"#ffffff",imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1},this.opt.html2canvas);if(delete e.onrendered,t.context2d.autoPaging=!0,t.context2d.posX=this.opt.x,t.context2d.posY=this.opt.y,e.windowHeight=e.windowHeight||0,e.windowHeight=0==e.windowHeight?Math.max(this.prop.container.clientHeight,this.prop.container.scrollHeight,this.prop.container.offsetHeight):e.windowHeight,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,e)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},o.prototype.toImg=function(){return this.thenList([function(){return this.prop.canvas||this.toCanvas()}]).then(function(){var t=this.prop.canvas.toDataURL("image/"+this.opt.image.type,this.opt.image.quality);this.prop.img=document.createElement("img"),this.prop.img.src=t})},o.prototype.toPdf=function(){return this.thenList([function(){return this.toContext2d()}]).then(function(){this.prop.pdf=this.prop.pdf||this.opt.jsPDF})},o.prototype.output=function(t,e,n){return"img"===(n=n||"pdf").toLowerCase()||"image"===n.toLowerCase()?this.outputImg(t,e):this.outputPdf(t,e)},o.prototype.outputPdf=function(t,e){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){return this.prop.pdf.output(t,e)})},o.prototype.outputImg=function(t){return this.thenList([function(){return this.prop.img||this.toImg()}]).then(function(){switch(t){case void 0:case"img":return this.prop.img;case"datauristring":case"dataurlstring":return this.prop.img.src;case"datauri":case"dataurl":return document.location.href=this.prop.img.src;default:throw'Image output type "'+t+'" is not supported.'}})},o.prototype.isHtml2CanvasLoaded=function(){var t=void 0!==e.html2canvas;if(!t)throw new Error("html2canvas not loaded.");return t},o.prototype.save=function(t){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).set(t?{filename:t}:null).then(function(){this.prop.pdf.save(this.opt.filename)})},o.prototype.doCallback=function(){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){this.prop.callback(this.prop.pdf)})},o.prototype.set=function(e){if("object"!==n(e))return this;var t=Object.keys(e||{}).map(function(t){if(t in o.template.prop)return function(){this.prop[t]=e[t]};switch(t){case"margin":return this.setMargin.bind(this,e.margin);case"jsPDF":return function(){return this.opt.jsPDF=e.jsPDF,this.setPageSize()};case"pageSize":return this.setPageSize.bind(this,e.pageSize);default:return function(){this.opt[t]=e[t]}}},this);return this.then(function(){return this.thenList(t)})},o.prototype.get=function(e,n){return this.then(function(){var t=e in o.template.prop?this.prop[e]:this.opt[e];return n?n(t):t})},o.prototype.setMargin=function(t){return this.then(function(){switch(n(t)){case"number":t=[t,t,t,t];case"array":if(2===t.length&&(t=[t[0],t[1],t[0],t[1]]),4===t.length)break;default:return this.error("Invalid margin array.")}this.opt.margin=t}).then(this.setPageSize)},o.prototype.setPageSize=function(t){function e(t,e){return Math.floor(t*e/72*96)}return this.then(function(){(t=t||U.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner")||(t.inner={width:t.width-this.opt.margin[1]-this.opt.margin[3],height:t.height-this.opt.margin[0]-this.opt.margin[2]},t.inner.px={width:e(t.inner.width,t.k),height:e(t.inner.height,t.k)},t.inner.ratio=t.inner.height/t.inner.width),this.prop.pageSize=t})},o.prototype.setProgress=function(t,e,n,r){return null!=t&&(this.progress.val=t),null!=e&&(this.progress.state=e),null!=n&&(this.progress.n=n),null!=r&&(this.progress.stack=r),this.progress.ratio=this.progress.val/this.progress.state,this},o.prototype.updateProgress=function(t,e,n,r){return this.setProgress(t?this.progress.val+t:null,e||null,n?this.progress.n+n:null,r?this.progress.stack.concat(r):null)},o.prototype.then=function(t,e){var n=this;return this.thenCore(t,e,function(e,t){return n.updateProgress(null,null,1,[e]),Promise.prototype.then.call(this,function(t){return n.updateProgress(null,e),t}).then(e,t).then(function(t){return n.updateProgress(1),t})})},o.prototype.thenCore=function(t,e,n){n=n||Promise.prototype.then;var r=this;t&&(t=t.bind(r)),e&&(e=e.bind(r));var i=-1!==Promise.toString().indexOf("[native code]")&&"Promise"===Promise.name?r:o.convert(Object.assign({},r),Promise.prototype),a=n.call(i,t,e);return o.convert(a,r.__proto__)},o.prototype.thenExternal=function(t,e){return Promise.prototype.then.call(this,t,e)},o.prototype.thenList=function(t){var e=this;return t.forEach(function(t){e=e.thenCore(t)}),e},o.prototype.catch=function(t){t&&(t=t.bind(this));var e=Promise.prototype.catch.call(this,t);return o.convert(e,this)},o.prototype.catchExternal=function(t){return Promise.prototype.catch.call(this,t)},o.prototype.error=function(t){return this.then(function(){throw new Error(t)})},o.prototype.using=o.prototype.set,o.prototype.saveAs=o.prototype.save,o.prototype.export=o.prototype.output,o.prototype.run=o.prototype.then,U.getPageSize=function(t,e,n){if("object"===on(t)){var r=t;t=r.orientation,e=r.unit||e,n=r.format||n}e=e||"mm",n=n||"a4",t=(""+(t||"P")).toLowerCase();var i,a=(""+n).toLowerCase(),o={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};switch(e){case"pt":i=1;break;case"mm":i=72/25.4;break;case"cm":i=72/2.54;break;case"in":i=72;break;case"px":i=.75;break;case"pc":case"em":i=12;break;case"ex":i=6;break;default:throw"Invalid unit: "+e}var s,u=0,l=0;if(o.hasOwnProperty(a))u=o[a][1]/i,l=o[a][0]/i;else try{u=n[1],l=n[0]}catch(t){throw new Error("Invalid format: "+n)}if("p"===t||"portrait"===t)t="p",u<l&&(s=l,l=u,u=s);else{if("l"!==t&&"landscape"!==t)throw"Invalid orientation: "+t;t="l",l<u&&(s=l,l=u,u=s)}return{width:l,height:u,unit:e,k:i,orientation:t}},t.html=function(t,e){(e=e||{}).callback=e.callback||function(){},e.html2canvas=e.html2canvas||{},e.html2canvas.canvas=e.html2canvas.canvas||this.canvas,e.jsPDF=e.jsPDF||this;var n=new o(e);return e.worker?n:n.from(t).doCallback()}}else console.warn("Promise not found. html-Plugin will not work")}(U.API,"undefined"!=typeof window&&window||"undefined"!=typeof global&&global),U.API.addJS=function(t){return o=t,this.internal.events.subscribe("postPutResources",function(){r=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(r+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),i=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+o+")"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==r&&void 0!==i&&this.internal.out("/Names <</JavaScript "+r+" 0 R>>")}),this},(
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
s=U.API).events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(0<this.outline.root.children.length)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],a=e.exec(i);if(null!=a){var o=a[1];t.internal.newObjectDeferredBegin(o,!1)}t.internal.write(i)}if(this.outline.createNamedDestinations){var s=this.internal.pages.length,u=[];for(r=0;r<s;r++){var l=t.internal.newObject();u.push(l);var c=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+c.objId+" 0 R /XYZ null null null]>> endobj")}var h=t.internal.newObject();for(t.internal.write("<< /Names [ "),r=0;r<u.length;r++)t.internal.write("(page_"+(r+1)+")"+u[r]+" 0 R");t.internal.write(" ] >>","endobj"),f=t.internal.newObject(),t.internal.write("<< /Dests "+h+" 0 R"),t.internal.write(">>","endobj")}}]),s.events.push(["putCatalog",function(){0<this.outline.root.children.length&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+f+" 0 R"))}]),s.events.push(["initialized",function(){var s=this;s.outline={createNamedDestinations:!1,root:{children:[]}},s.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},s.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=s,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},s.outline.genIds_r=function(t){t.id=s.internal.newObjectDeferred();for(var e=0;e<t.children.length;e++)this.genIds_r(t.children[e])},s.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),0<t.children.length&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},s.outline.renderItems=function(t){for(var e=this.ctx.pdf.internal.getVerticalCoordinateString,n=0;n<t.children.length;n++){var r=t.children[n];this.objStart(r),this.line("/Title "+this.makeString(r.title)),this.line("/Parent "+this.makeRef(t)),0<n&&this.line("/Prev "+this.makeRef(t.children[n-1])),n<t.children.length-1&&this.line("/Next "+this.makeRef(t.children[n+1])),0<r.children.length&&(this.line("/First "+this.makeRef(r.children[0])),this.line("/Last "+this.makeRef(r.children[r.children.length-1])));var i=this.count=this.count_r({count:0},r);if(0<i&&this.line("/Count "+i),r.options&&r.options.pageNumber){var a=s.internal.getPageInfo(r.options.pageNumber);this.line("/Dest ["+a.objId+" 0 R /XYZ 0 "+e(0)+" 0]")}this.objEnd()}for(var o=0;o<t.children.length;o++)this.renderItems(t.children[o])},s.outline.line=function(t){this.ctx.val+=t+"\r\n"},s.outline.makeRef=function(t){return t.id+" 0 R"},s.outline.makeString=function(t){return"("+s.internal.pdfEscape(t)+")"},s.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},s.outline.objEnd=function(){this.ctx.val+=">> \r\nendobj\r\n"},s.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}]),
/**
   * @license
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
u=U.API,l=[192,193,194,195,196,197,198,199],u.processJPEG=function(t,e,n,r,i,a){var o,s=this.decode.DCT_DECODE,u=null;if("string"==typeof t||this.__addimage__.isArrayBuffer(t)||this.__addimage__.isArrayBufferView(t)){switch(t=i||t,t=this.__addimage__.isArrayBuffer(t)?new Uint8Array(t):t,(o=function(t){for(var e,n=256*t.charCodeAt(4)+t.charCodeAt(5),r=t.length,i={width:0,height:0,numcomponents:1},a=4;a<r;a+=2){if(a+=n,-1!==l.indexOf(t.charCodeAt(a+1))){e=256*t.charCodeAt(a+5)+t.charCodeAt(a+6),i={width:256*t.charCodeAt(a+7)+t.charCodeAt(a+8),height:e,numcomponents:t.charCodeAt(a+9)};break}n=256*t.charCodeAt(a+2)+t.charCodeAt(a+3)}return i}(t=this.__addimage__.isArrayBufferView(t)?this.__addimage__.arrayBufferToBinaryString(t):t)).numcomponents){case 1:a=this.color_spaces.DEVICE_GRAY;break;case 4:a=this.color_spaces.DEVICE_CMYK;break;case 3:a=this.color_spaces.DEVICE_RGB}u={data:t,width:o.width,height:o.height,colorSpace:a,bitsPerComponent:8,filter:s,index:e,alias:n}}return u},
/**
   * @license
   *
   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   * ====================================================================
   */
P=U.API,k="undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")(),F=function(){return"function"==typeof Deflater},d=function(t){var e=30720;return e|=Math.min(3,(t-1&255)>>1)<<6,e|=0,[120,255&(e+=31-e%31)]},p=function(t,e,n,r){for(var i,a,o,s=t.length/e,u=new Uint8Array(t.length+s),l=y(),c=0;c<s;c+=1){if(o=c*e,i=t.subarray(o,o+e),r)u.set(r(i,n,a),o+c);else{for(var h,f=l.length,d=[];h<f;h+=1)d[h]=l[h](i,n,a);var p=w(d.concat());u.set(d[p],o+c)}a=i}return u},g=function(t,e){var n,r=[],i=t.length;r[0]=1;for(var a=0;a<i;a+=1)n=t[a-e]||0,r[a+1]=t[a]-n+256&255;return r},m=function(t,e,n){var r,i=[],a=t.length;i[0]=2;for(var o=0;o<a;o+=1)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},b=function(t,e,n){var r,i,a=[],o=t.length;a[0]=3;for(var s=0;s<o;s+=1)r=t[s-e]||0,i=n&&n[s]||0,a[s+1]=t[s]+256-(r+i>>>1)&255;return a},v=function(t,e,n){var r,i,a,o,s=[],u=t.length;s[0]=4;for(var l=0;l<u;l+=1)r=t[l-e]||0,i=n&&n[l]||0,a=n&&n[l-e]||0,o=c(r,i,a),s[l+1]=t[l]-o+256&255;return s},c=function(t,e,n){if(t===e&&e===n)return t;var r=Math.abs(e-n),i=Math.abs(t-n),a=Math.abs(t+e-n-n);return r<=i&&r<=a?t:i<=a?e:n},y=function(){return[X,g,m,b,v]},w=function(t){var e=t.map(function(t){return t.reduce(function(t,e){return t+Math.abs(e)},0)});return e.indexOf(Math.min.apply(null,e))},P.processPNG=function(t,e,n,r){var i,a,o,s,u,l,c,h,f,d,p,g,m,b,v,y=this.decode.FLATE_DECODE,w="";if(this.__addimage__.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.__addimage__.isArrayBufferView(t)){if("function"!=typeof k.PNG||"function"!=typeof k.FlateStream)throw new Error("PNG support requires png.js and zlib.js");if(t=(o=new PNG(t)).imgData,a=o.bits,i=o.colorSpace,u=o.colors,-1!==[4,6].indexOf(o.colorType)){if(8===o.bits){f=(h=32==o.pixelBitlength?new Uint32Array(o.decodePixels().buffer):16==o.pixelBitlength?new Uint16Array(o.decodePixels().buffer):new Uint8Array(o.decodePixels().buffer)).length,p=new Uint8Array(f*o.colors),d=new Uint8Array(f);var x,N=o.pixelBitlength-o.bits;for(v=b=0;b<f;b++){for(m=h[b],x=0;x<N;)p[v++]=m>>>x&255,x+=o.bits;d[b]=m>>>x&255}}if(16===o.bits){f=(h=new Uint32Array(o.decodePixels().buffer)).length,p=new Uint8Array(f*(32/o.pixelBitlength)*o.colors),d=new Uint8Array(f*(32/o.pixelBitlength)),g=1<o.colors;for(var L=v=b=0;b<f;)m=h[b++],p[v++]=m>>>0&255,g&&(p[v++]=m>>>16&255,m=h[b++],p[v++]=m>>>0&255),d[L++]=m>>>16&255;a=8}!function(t){return t!==P.image_compression.NONE&&F()}(r)?(t=p,c=d,y=void 0):(t=J(p,o.width*o.colors,o.colors,r),c=J(d,o.width,1,r))}if(3===o.colorType&&(i=this.color_spaces.INDEXED,l=o.palette,o.transparency.indexed)){var A=o.transparency.indexed,_=0;for(b=0,f=A.length;b<f;++b)_+=A[b];if((_/=255)==f-1&&-1!==A.indexOf(0))s=[A.indexOf(0)];else if(_!==f){for(h=o.decodePixels(),d=new Uint8Array(h.length),b=0,f=h.length;b<f;b++)d[b]=A[h[b]];c=J(d,o.width,1)}}var S=function(t){var e;switch(t){case P.image_compression.FAST:e=11;break;case P.image_compression.MEDIUM:e=13;break;case P.image_compression.SLOW:e=14;break;default:e=12}return e}(r);return y===this.decode.FLATE_DECODE&&(w="/Predictor "+S+" "),w+="/Colors "+u+" /BitsPerComponent "+a+" /Columns "+o.width,(this.__addimage__.isArrayBuffer(t)||this.__addimage__.isArrayBufferView(t))&&(t=this.__addimage__.arrayBufferToBinaryString(t)),(c&&this.__addimage__.isArrayBuffer(c)||this.__addimage__.isArrayBufferView(c))&&(c=this.__addimage__.arrayBufferToBinaryString(c)),{alias:n,data:t,index:e,filter:y,decodeParameters:w,transparency:s,palette:l,sMask:c,predictor:S,width:o.width,height:o.height,bitsPerComponent:a,colorSpace:i}}},(
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
h=U.API).processGIF89A=function(t,e,n,r){var i=new nt(t),a=i.width,o=i.height,s=[];i.decodeAndBlitFrameRGBA(0,s);var u={data:s,width:a,height:o},l=new it(100).encode(u,100);return h.processJPEG.call(this,l,e,n,r)},h.processGIF87A=h.processGIF89A,(
/**
   * Copyright (c) 2018 Aras Abbasi
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
x=U.API).processBMP=function(t,e,n,r){var i=new at(t,!1),a=i.width,o=i.height,s={data:i.getData(),width:a,height:o},u=new it(100).encode(s,100);return x.processJPEG.call(this,u,e,n,r)},(
/**
   * @license
   * Copyright (c) 2019 Aras Abbasi
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
N=U.API).processWEBP=function(t,e,n,r){var i=new ot(t,!1),a=i.width,o=i.height,s={data:i.getData(),width:a,height:o},u=new it(100).encode(s,100);return N.processJPEG.call(this,u,e,n,r)},U.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"FYRO Macedonian",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")}),this.internal.languageSettings.isSubscribed=!0)),this},
/** @license
   * MIT license.
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
L=U.API,A=L.getCharWidthsArray=function(t,e){var n,r,i=(e=e||{}).font||this.internal.getFont(),a=e.fontSize||this.internal.getFontSize(),o=e.charSpace||this.internal.getCharSpace(),s=e.widths?e.widths:i.metadata.Unicode.widths,u=s.fof?s.fof:1,l=e.kerning?e.kerning:i.metadata.Unicode.kerning,c=l.fof?l.fof:1,h=!1!==e.doKerning,f=0,d=t.length,p=0,g=s[0]||u,m=[];for(n=0;n<d;n++)r=t.charCodeAt(n),"function"==typeof i.metadata.widthOfString?m.push((i.metadata.widthOfGlyph(i.metadata.characterToGlyph(r))+o*(1e3/a)||0)/1e3):(h&&"object"===on(l[r])&&!isNaN(parseInt(l[r][p],10))&&(f=l[r][p]/c),m.push((s[r]||g)/u+f)),p=r;return m},_=L.getStringUnitWidth=function(t,e){var n=(e=e||{}).fontSize||this.internal.getFontSize(),r=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return L.processArabic&&(t=L.processArabic(t)),"function"==typeof r.metadata.widthOfString?r.metadata.widthOfString(t,n,i)/n:A.apply(this,arguments).reduce(function(t,e){return t+e},0)},L.splitTextToSize=function(t,e,n){var r,i=(n=n||{}).fontSize||this.internal.getFontSize(),a=function(t){if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var e=this.internal.getFont(t.fontName,t.fontStyle),n="Unicode";return e.metadata[n]?{widths:e.metadata[n].widths||{0:1},kerning:e.metadata[n].kerning||{}}:{font:e.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var o=1*this.internal.scaleFactor*e/i;a.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,a.lineIndent=n.lineIndent;var s,u,l=[];for(s=0,u=r.length;s<u;s++)l=l.concat(Z.apply(this,[r[s],o,a]));return l},
/** @license
   jsPDF standard_fonts_metrics plugin
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   * MIT license.
   * 
   * ====================================================================
   */
/**
   * This file adds the standard font metrics to jsPDF.
   *
   * Font metrics data is reprocessed derivative of contents of
   * "Font Metrics for PDF Core 14 Fonts" package, which exhibits the following copyright and license:
   *
   * Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated. All Rights Reserved.
   *
   * This file and the 14 PostScript(R) AFM files it accompanies may be used,
   * copied, and distributed for any purpose and without charge, with or without
   * modification, provided that all copyright notices are retained; that the AFM
   * files are not distributed without this file; that all modifications to this
   * file or any of the AFM files are prominently noted in the modified file(s);
   * and that this paragraph is not modified. Adobe Systems has no responsibility
   * or obligation to support the use of the AFM files.
   *
   * @name standard_fonts_metrics
   * @module
   */
function(t){t.__fontmetrics__=t.__fontmetrics__||{};for(var e="0123456789abcdef",n="klmnopqrstuvwxyz",d={},o={},r=0;r<n.length;r++)d[n[r]]=e[r],o[e[r]]=n[r];function s(t){return"0x"+parseInt(t,10).toString(16)}var u=t.__fontmetrics__.compress=function(t){var e,n,r,i=["{"];for(var a in t){if(e=t[a],n=isNaN(parseInt(a,10))?"'"+a+"'":(a=parseInt(a,10),(n=s(a).slice(2)).slice(0,-1)+o[n.slice(-1)]),"number"==typeof e)r=(e<0?(r=s(e).slice(3),"-"):(r=s(e).slice(2),""))+r.slice(0,-1)+o[r.slice(-1)];else{if("object"!==on(e))throw new Error("Don't know what to do with value type "+on(e)+".");r=u(e)}i.push(n+r)}return i.push("}"),i.join("")},i=t.__fontmetrics__.uncompress=function(t){if("string"!=typeof t)throw new Error("Invalid argument passed to uncompress.");for(var e,n,r,i,a={},o=1,s=a,u=[],l="",c="",h=t.length-1,f=1;f<h;f+=1)"'"==(i=t[f])?e=e?void(r=e.join("")):[]:e?e.push(i):"{"==i?(u.push([s,r]),s={},r=void 0):"}"==i?((n=u.pop())[0][n[1]]=s,r=void 0,s=n[0]):"-"==i?o=-1:void 0===r?d.hasOwnProperty(i)?(l+=d[i],r=parseInt(l,16)*o,o=1,l=""):l+=i:d.hasOwnProperty(i)?(c+=d[i],s[r]=parseInt(c,16)*o,o=1,r=void 0,c=""):c+=i;return a},a={codePages:["WinAnsiEncoding"],WinAnsiEncoding:i("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},l={Unicode:{Courier:a,"Courier-Bold":a,"Courier-BoldOblique":a,"Courier-Oblique":a,Helvetica:a,"Helvetica-Bold":a,"Helvetica-BoldOblique":a,"Helvetica-Oblique":a,"Times-Roman":a,"Times-Bold":a,"Times-BoldItalic":a,"Times-Italic":a}},c={Unicode:{"Courier-Oblique":i("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":i("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":i("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:i("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":i("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":i("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:i("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:i("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":i("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:i("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":i("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":i("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":i("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":i("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}};t.events.push(["addFont",function(t){var e=t.font,n=c.Unicode[e.postScriptName];n&&(e.metadata.Unicode={},e.metadata.Unicode.widths=n.widths,e.metadata.Unicode.kerning=n.kerning);var r=l.Unicode[e.postScriptName];r&&(e.metadata.Unicode.encoding=r,e.encoding=r.codePages[0])}])}(U.API),(
/**
   * @license
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
S=U).API.events.push(["addFont",function(t){var e=void 0,n=t.font,r=t.instance;if(void 0!==r){if("string"!=typeof(e=!1===r.existsFileInVFS(n.postScriptName)?r.loadFile(n.postScriptName):r.getFileFromVFS(n.postScriptName)))throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('"+n.postScriptName+"').");!function(t,e){e=/^\x00\x01\x00\x00/.test(e)?$(e):$(atob(e)),t.metadata=S.API.TTFFont.open(e),t.metadata.Unicode=t.metadata.Unicode||{encoding:{},kerning:{},widths:[]},t.metadata.glyIdsUsed=[0]}(n,e)}else if(!1===n.isStandardFont)throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('"+n.postScriptName+"').")}]),(
/** @license
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *
   * 
   * ====================================================================
   */
C=U.API).addSvg=function(t,e,n,r,i){if(void 0===e||void 0===n)throw new Error("addSVG needs values for 'x' and 'y'");function a(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,a=t.length;i<a;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}var o,s,u,l,c,h,f,d,p=(f=document,d=f.createElement("iframe"),l=".jsPDF_sillysvg_iframe {display:none;position:absolute;}",(h=(c=f).createElement("style")).type="text/css",h.styleSheet?h.styleSheet.cssText=l:h.appendChild(c.createTextNode(l)),c.getElementsByTagName("head")[0].appendChild(h),d.name="childframe",d.setAttribute("width",0),d.setAttribute("height",0),d.setAttribute("frameborder","0"),d.setAttribute("scrolling","no"),d.setAttribute("seamless","seamless"),d.setAttribute("class","jsPDF_sillysvg_iframe"),f.body.appendChild(d),d),g=(o=t,(u=((s=p).contentWindow||s.contentDocument).document).write(o),u.close(),u.getElementsByTagName("svg")[0]),m=[1,1],b=parseFloat(g.getAttribute("width")),v=parseFloat(g.getAttribute("height"));b&&v&&(r&&i?m=[r/b,i/v]:r?m=[r/b,r/b]:i&&(m=[i/v,i/v]));var y,w,x,N,L=g.childNodes;for(y=0,w=L.length;y<w;y++)(x=L[y]).tagName&&"PATH"===x.tagName.toUpperCase()&&((N=a(x.getAttribute("d").split(-1===x.getAttribute("d").indexOf(",")?" ":",")))[0]=N[0]*m[0]+e,N[1]=N[1]*m[1]+n,this.lines.call(this,N[2],N[0],N[1],m));return this},C.addSVG=C.addSvg,C.addSvgAsImage=function(t,e,n,r,i,a,o,s){if(isNaN(e)||isNaN(n))throw console.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(r)||isNaN(i))throw console.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var u=document.createElement("canvas");u.width=r,u.height=i;var l=u.getContext("2d");return l.fillStyle="#fff",l.fillRect(0,0,u.width,u.height),canvg(u,t,{ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0,ignoreClear:!0}),this.addImage(u.toDataURL("image/jpeg",1),e,n,r,i,o,s),this},U.API.putTotalPages=function(t){var e,n=0;n=parseInt(this.internal.getFont().id.substr(1),10)<15?(e=new RegExp(t,"g"),this.internal.getNumberOfPages()):(e=new RegExp(this.pdfEscape16(t,this.internal.getFont()),"g"),this.pdfEscape16(this.internal.getNumberOfPages()+"",this.internal.getFont()));for(var r=1;r<=this.internal.getNumberOfPages();r++)for(var i=0;i<this.internal.pages[r].length;i++)this.internal.pages[r][i]=this.internal.pages[r][i].replace(e,n);return this},U.API.viewerPreferences=function(t,e){var n;t=t||{},e=e||!1;var r,i,a,o={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},s=Object.keys(o),u=[],l=0,c=0,h=0;function f(t,e){var n,r=!1;for(n=0;n<t.length;n+=1)t[n]===e&&(r=!0);return r}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(o)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===t||!0===e){var d=s.length;for(h=0;h<d;h+=1)n[s[h]].value=n[s[h]].defaultValue,n[s[h]].explicitSet=!1}if("object"===on(t))for(i in t)if(a=t[i],f(s,i)&&void 0!==a){if("boolean"===n[i].type&&"boolean"==typeof a)n[i].value=a;else if("name"===n[i].type&&f(n[i].valueSet,a))n[i].value=a;else if("integer"===n[i].type&&Number.isInteger(a))n[i].value=a;else if("array"===n[i].type){for(l=0;l<a.length;l+=1)if(r=!0,1===a[l].length&&"number"==typeof a[l][0])u.push(String(a[l]-1));else if(1<a[l].length){for(c=0;c<a[l].length;c+=1)"number"!=typeof a[l][c]&&(r=!1);!0===r&&u.push([a[l][0]-1,a[l][1]-1].join(" "))}n[i].value="["+u.join(" ")+"]"}else n[i].value=n[i].defaultValue;n[i].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")}),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},U.API.addMetadata=function(t,e){return void 0===this.internal.__metadata__&&(this.internal.__metadata__={metadata:t,namespaceuri:e||"http://jspdf.default.namespaceuri/"},this.internal.events.subscribe("putCatalog",tt),this.internal.events.subscribe("postPutResources",Q)),this},function(p){function g(t){var e,n,r,i,a,o,s;for(a="/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange",r=[],o=0,s=(n=Object.keys(t).sort(function(t,e){return t-e})).length;o<s;o++)e=n[o],100<=r.length&&(a+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar",r=[]),void 0!==t[e]&&null!==t[e]&&"function"==typeof t[e].toString&&(i=("0000"+t[e].toString(16)).slice(-4),e=("0000"+(+e).toString(16)).slice(-4),r.push("<"+e+"><"+i+">"));return r.length&&(a+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar\n"),a+="endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend"}var t=p.API,m=t.pdfEscape16=function(t,e){for(var n,r=e.metadata.Unicode.widths,i=["","0","00","000","0000"],a=[""],o=0,s=t.length;o<s;++o){if(n=e.metadata.characterToGlyph(t.charCodeAt(o)),e.metadata.glyIdsUsed.push(n),e.metadata.toUnicode[n]=t.charCodeAt(o),-1==r.indexOf(n)&&(r.push(n),r.push([parseInt(e.metadata.widthOfGlyph(n),10)])),"0"==n)return a.join("");n=n.toString(16),a.push(i[4-n.length],n)}return a.join("")};t.events.push(["putFont",function(t){!function(t){var e=t.font,n=t.out,r=t.newObject,i=t.putStream,a=t.pdfEscapeWithNeededParanthesis;if(e.metadata instanceof p.API.TTFFont&&"Identity-H"===e.encoding){for(var o=e.metadata.Unicode.widths,s=e.metadata.subset.encode(e.metadata.glyIdsUsed,1),u="",l=0;l<s.length;l++)u+=String.fromCharCode(s[l]);var c=r();i({data:u,addLength1:!0}),n("endobj");var h=r();i({data:g(e.metadata.toUnicode),addLength1:!0}),n("endobj");var f=r();n("<<"),n("/Type /FontDescriptor"),n("/FontName /"+a(e.fontName)),n("/FontFile2 "+c+" 0 R"),n("/FontBBox "+p.API.PDFObject.convert(e.metadata.bbox)),n("/Flags "+e.metadata.flags),n("/StemV "+e.metadata.stemV),n("/ItalicAngle "+e.metadata.italicAngle),n("/Ascent "+e.metadata.ascender),n("/Descent "+e.metadata.decender),n("/CapHeight "+e.metadata.capHeight),n(">>"),n("endobj");var d=r();n("<<"),n("/Type /Font"),n("/BaseFont /"+a(e.fontName)),n("/FontDescriptor "+f+" 0 R"),n("/W "+p.API.PDFObject.convert(o)),n("/CIDToGIDMap /Identity"),n("/DW 1000"),n("/Subtype /CIDFontType2"),n("/CIDSystemInfo"),n("<<"),n("/Supplement 0"),n("/Registry (Adobe)"),n("/Ordering ("+e.encoding+")"),n(">>"),n(">>"),n("endobj"),e.objectNumber=r(),n("<<"),n("/Type /Font"),n("/Subtype /Type0"),n("/ToUnicode "+h+" 0 R"),n("/BaseFont /"+e.fontName),n("/Encoding /"+e.encoding),n("/DescendantFonts ["+d+" 0 R]"),n(">>"),n("endobj"),e.isAlreadyPutted=!0}}(t)}]);t.events.push(["putFont",function(t){!function(t){var e=t.font,n=t.out,r=t.newObject,i=t.putStream,a=t.pdfEscapeWithNeededParanthesis;if(e.metadata instanceof p.API.TTFFont&&"WinAnsiEncoding"===e.encoding){for(var o=e.metadata.rawData,s="",u=0;u<o.length;u++)s+=String.fromCharCode(o[u]);var l=r();i({data:s,addLength1:!0}),n("endobj");var c=r();i({data:g(e.metadata.toUnicode),addLength1:!0}),n("endobj");var h=r();n("<<"),n("/Descent "+e.metadata.decender),n("/CapHeight "+e.metadata.capHeight),n("/StemV "+e.metadata.stemV),n("/Type /FontDescriptor"),n("/FontFile2 "+l+" 0 R"),n("/Flags 96"),n("/FontBBox "+p.API.PDFObject.convert(e.metadata.bbox)),n("/FontName /"+a(e.fontName)),n("/ItalicAngle "+e.metadata.italicAngle),n("/Ascent "+e.metadata.ascender),n(">>"),n("endobj"),e.objectNumber=r();for(var f=0;f<e.metadata.hmtx.widths.length;f++)e.metadata.hmtx.widths[f]=parseInt(e.metadata.hmtx.widths[f]*(1e3/e.metadata.head.unitsPerEm));n("<</Subtype/TrueType/Type/Font/ToUnicode "+c+" 0 R/BaseFont/"+e.fontName+"/FontDescriptor "+h+" 0 R/Encoding/"+e.encoding+" /FirstChar 29 /LastChar 255 /Widths "+p.API.PDFObject.convert(e.metadata.hmtx.widths)+">>"),n("endobj"),e.isAlreadyPutted=!0}}(t)}]);function a(t){var e,n=t.text||"",r=t.x,i=t.y,a=t.options||{},o=t.mutex||{},s=o.pdfEscape,u=o.activeFontKey,l=o.fonts,c=u,h="",f=0,d="",p=l[c].encoding;if("Identity-H"!==l[c].encoding)return{text:n,x:r,y:i,options:a,mutex:o};for(d=n,c=u,Array.isArray(n)&&(d=n[0]),f=0;f<d.length;f+=1)l[c].metadata.hasOwnProperty("cmap")&&(e=l[c].metadata.cmap.unicode.codeMap[d[f].charCodeAt(0)]),e?h+=d[f]:d[f].charCodeAt(0)<256&&l[c].metadata.hasOwnProperty("Unicode")?h+=d[f]:h+="";var g="";return parseInt(c.slice(1))<14||"WinAnsiEncoding"===p?g=s(h,c).split("").map(function(t){return t.charCodeAt(0).toString(16)}).join(""):"Identity-H"===p&&(g=m(h,l[c])),o.isHex=!0,{text:g,x:r,y:i,options:a,mutex:o}}t.events.push(["postProcessText",function(t){var e=t.text||"",n=[],r={text:e,x:t.x,y:t.y,options:t.options,mutex:t.mutex};if(Array.isArray(e)){var i=0;for(i=0;i<e.length;i+=1)Array.isArray(e[i])&&3===e[i].length?n.push([a(Object.assign({},r,{text:e[i][0]})).text,e[i][1],e[i][2]]):n.push(a(Object.assign({},r,{text:e[i]})).text);t.text=n}else t.text=a(Object.assign({},r,{text:e})).text}])}(U),(I=U.API).existsFileInVFS=function(t){return et.call(this),void 0!==this.internal.vFS[t]},I.addFileToVFS=function(t,e){return et.call(this),this.internal.vFS[t]=e,this},I.getFileFromVFS=function(t){return et.call(this),void 0!==this.internal.vFS[t]?this.internal.vFS[t]:null},U.API.addHTML=function(t,p,g,s,m){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof p&&(s=p,m=g),"function"==typeof s&&(m=s,s=null),"function"!=typeof m&&(m=function(){});var e=this.internal,b=e.scaleFactor,v=e.pageSize.getWidth(),y=e.pageSize.getHeight();if((s=s||{}).onrendered=function(u){p=parseInt(p)||0,g=parseInt(g)||0;var t=s.dim||{},l=Object.assign({top:0,right:0,bottom:0,left:0,useFor:"content"},s.margin),e=t.h||Math.min(y,u.height/b),c=t.w||Math.min(v,u.width/b)-p,h=s.format||"JPEG",f=s.imageCompression||"SLOW";if(u.height>y-l.top-l.bottom&&s.pagesplit){var d=function(t,e,n,r,i){var a=document.createElement("canvas");a.height=i,a.width=r;var o=a.getContext("2d");return o.mozImageSmoothingEnabled=!1,o.webkitImageSmoothingEnabled=!1,o.msImageSmoothingEnabled=!1,o.imageSmoothingEnabled=!1,o.fillStyle=s.backgroundColor||"#ffffff",o.fillRect(0,0,r,i),o.drawImage(t,e,n,r,i,0,0,r,i),a},n=function(){for(var t,e,n,r,i=0,a=0,o={},s=!1;;){if(a=0,o.top=0!==i?l.top:g,o.left=0!==i?l.left:p,s=(v-l.left-l.right)*b<u.width,"content"===l.useFor?0===i?(t=Math.min((v-l.left)*b,u.width),e=Math.min((y-l.top)*b,u.height-i)):(t=Math.min(v*b,u.width),e=Math.min(y*b,u.height-i),o.top=0):(t=Math.min((v-l.left-l.right)*b,u.width),e=Math.min((y-l.bottom-l.top)*b,u.height-i)),s)for(;"content"===l.useFor&&(0===a?t=Math.min((v-l.left)*b,u.width):(t=Math.min(v*b,u.width-a),o.left=0)),r=[n=d(u,a,i,t,e),o.left,o.top,n.width/b,n.height/b,h,null,f],this.addImage.apply(this,r),!((a+=t)>=u.width);)this.addPage();else r=[n=d(u,0,i,t,e),o.left,o.top,n.width/b,n.height/b,h,null,f],this.addImage.apply(this,r);if((i+=e)>=u.height)break;this.addPage()}m(c,i,null,r)}.bind(this);if("CANVAS"===u.nodeName){var r=new Image;r.onload=n,r.src=u.toDataURL("image/png"),u=r}else n()}else{var i=Math.random().toString(35),a=[u,p,g,c,e,h,i,f];this.addImage.apply(this,a),m(c,e,i,a)}}.bind(this),"undefined"!=typeof html2canvas&&!s.rstz)return html2canvas(t,s);if("undefined"==typeof rasterizeHTML)return null;var n="drawDocument";return"string"==typeof t&&(n=/^http/.test(t)?"drawURL":"drawHTML"),s.width=s.width||v*b,rasterizeHTML[n](t,void 0,s).then(function(t){s.onrendered(t.image)},function(t){m(null,t)})},
/**
   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Daniel Husar, https://github.com/danielhusar
   *               2014 Wolfgang Gassler, https://github.com/woolfg
   *               2014 Steven Spungin, https://github.com/flamenco
   *
   * @license
   * 
   * ====================================================================
   */
function(t){var k,F,i,o,s,u,l,c,C,y,f,h,d,n,I,j,p,g,m,B;function e(){}k=function(t){return e.prototype=t,new e},y=function(t){var e,n,r,i,a,o,s;for(n=0,r=t.length,e=void 0,o=i=!1;!i&&n!==r;)(e=t[n]=t[n].trimLeft())&&(i=!0),n++;for(n=r-1;r&&!o&&-1!==n;)(e=t[n]=t[n].trimRight())&&(o=!0),n--;for(a=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=a.test(e)),t[n]=e),n++;return t},h=function(t){var e,n,r;for(e=void 0,n=(r=t.split(",")).shift();!e&&n;)e=i[n.trim().toLowerCase()],n=r.shift();return e},d=function(t){var e;return-1<(t="auto"===t?"0px":t).indexOf("em")&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),-1<t.indexOf("pt")&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px"),void 0,16,(e=n[t])?e:void 0!==(e={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[t])?n[t]=e/16:(e=parseFloat(t))?n[t]=e/16:(e=t.match(/([\d\.]+)(px)/),Array.isArray(e)&&3===e.length?n[t]=parseFloat(e[1])/16:n[t]=1)},C=function(t){var e,n,r,i,a;return a=t,i=document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(a,null):a.currentStyle?a.currentStyle:a.style,n=void 0,(e={})["font-family"]=h((r=function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),i[t]})("font-family"))||"times",e["font-style"]=o[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left","bold"===(n=u[r("font-weight")]||"normal")&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=d(r("font-size"))||1,e["line-height"]=d(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&d(r("margin-top"))||0,e["margin-bottom"]=n&&d(r("margin-bottom"))||0,e["padding-top"]=n&&d(r("padding-top"))||0,e["padding-bottom"]=n&&d(r("padding-bottom"))||0,e["margin-left"]=n&&d(r("margin-left"))||0,e["margin-right"]=n&&d(r("margin-right"))||0,e["padding-left"]=n&&d(r("padding-left"))||0,e["padding-right"]=n&&d(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=l[r("cssFloat")]||"none",e.clear=c[r("clear")]||"none",e.color=r("color"),e},I=function(t,e,n){var r,i,a,o,s;if(a=!1,o=i=void 0,r=n["#"+t.id])if("function"==typeof r)a=r(t,e);else for(i=0,o=r.length;!a&&i!==o;)a=r[i](t,e),i++;if(r=n[t.nodeName],!a&&r)if("function"==typeof r)a=r(t,e);else for(i=0,o=r.length;!a&&i!==o;)a=r[i](t,e),i++;for(s="string"==typeof t.className?t.className.split(" "):[],i=0;i<s.length;i++)if(r=n["."+s[i]],!a&&r)if("function"==typeof r)a=r(t,e);else for(i=0,o=r.length;!a&&i!==o;)a=r[i](t,e),i++;return a},B=function(t,e){var n,r,i,a,o,s,u,l,c;for(n=[],r=[],i=0,c=t.rows[0].cells.length,u=t.clientWidth;i<c;)l=t.rows[0].cells[i],r[i]={name:l.textContent.toLowerCase().replace(/\s+/g,""),prompt:l.textContent.replace(/\r?\n/g,""),width:l.clientWidth/u*e.pdf.internal.pageSize.getWidth()},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],o={},a=0;a<s.cells.length;)o[r[a].name]=s.cells[a].textContent.replace(/\r?\n/g,""),a++;n.push(o),i++}return{rows:n,headers:r}};var O={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},E=1;F=function(t,i,e){var n,r,a,o,s,u,l,c;for(r=t.childNodes,n=void 0,(s="block"===(a=C(t)).display)&&(i.setBlockBoundary(),i.setBlockStyle(a)),o=0,u=r.length;o<u;){if("object"===on(n=r[o])){if(i.executeWatchFunctions(n),1===n.nodeType&&"HEADER"===n.nodeName){var h=n,f=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=f,F(h,i,e),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===n.nodeType&&"#comment"===n.nodeName)~n.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==n.nodeType||O[n.nodeName])if(3===n.nodeType){var d=n.nodeValue;if(n.nodeValue&&"LI"===n.parentNode.nodeName)if("OL"===n.parentNode.parentNode.nodeName)d=E+++". "+d;else{var p=a["font-size"],g=(3-.75*p)*i.pdf.internal.scaleFactor,m=.75*p*i.pdf.internal.scaleFactor,b=1.74*p/i.pdf.internal.scaleFactor;c=function(t,e){this.pdf.circle(t+g,e+m,b,"FD")}}16&n.ownerDocument.body.compareDocumentPosition(n)&&i.addText(d,a)}else"string"==typeof n&&i.addText(n,a);else{var v;if("IMG"===n.nodeName){var y=n.getAttribute("src");v=j[i.pdf.API.__addimage__.sHashCode(y)||y]}if(v){i.pdf.internal.pageSize.getHeight()-i.pdf.margins_doc.bottom<i.y+n.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(n));var w=C(n),x=i.x,N=12/i.pdf.internal.scaleFactor,L=(w["margin-left"]+w["padding-left"])*N,A=(w["margin-right"]+w["padding-right"])*N,_=(w["margin-top"]+w["padding-top"])*N,S=(w["margin-bottom"]+w["padding-bottom"])*N;void 0!==w.float&&"right"===w.float?x+=i.settings.width-n.width-A:x+=L,i.pdf.addImage(v,x,i.y+_,n.width,n.height),v=void 0,"right"===w.float||"left"===w.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!O[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===w.float?-n.width-L-A:0,i.y+n.height+_+S,n.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===C(n).clear&&(i.y=t,!0)}.bind(this,i.y+n.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=n.width+L+A,"left"===w.float&&(i.x+=n.width+L+A)):i.y+=n.height+_+S}else if("TABLE"===n.nodeName)l=B(n,i),i.y+=10,i.pdf.table(i.x,i.y,l.rows,l.headers,{autoSize:!1,printHeaders:e.printHeaders,margins:i.pdf.margins_doc,css:C(n)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===n.nodeName||"UL"===n.nodeName)E=1,I(n,i,e)||F(n,i,e),i.y+=10;else if("LI"===n.nodeName){var P=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,I(n,i,e)||F(n,i,e),i.x=P}else"BR"===n.nodeName?(i.y+=a["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",k(a))):I(n,i,e)||F(n,i,e)}}o++}if(e.outY=i.y,s)return i.setBlockBoundary(c)},j={},p=function(t,a,e,n){var o,r=t.getElementsByTagName("img"),i=r.length,s=0;function u(){a.pdf.internal.events.publish("imagesLoaded"),n(o)}function l(e,n,r){if(e){var i=new Image;o=++s,i.crossOrigin="",i.onerror=i.onload=function(){if(i.complete&&(0===i.src.indexOf("data:image/")&&(i.width=n||i.width||0,i.height=r||i.height||0),i.width+i.height)){var t=a.pdf.API.__addimage__.sHashCode(e)||e;j[t]=j[t]||i}--s||u()},i.src=e}}for(;i--;)l(r[i].getAttribute("src"),r[i].width,r[i].height);return s||u()},g=function(t,a,o){var s=t.getElementsByTagName("footer");if(0<s.length){s=s[0];var e=a.pdf.internal.write,n=a.y;a.pdf.internal.write=function(){},F(s,a,o);var u=Math.ceil(a.y-n)+5;a.y=n,a.pdf.internal.write=e,a.pdf.margins_doc.bottom+=u;for(var r=function(t){var e=void 0!==t?t.pageNumber:1,n=a.y;a.y=a.pdf.internal.pageSize.getHeight()-a.pdf.margins_doc.bottom,a.pdf.margins_doc.bottom-=u;for(var r=s.getElementsByTagName("span"),i=0;i<r.length;++i)-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")&&(r[i].innerHTML=e),-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&(r[i].innerHTML="###jsPDFVarTotalPages###");F(s,a,o),a.pdf.margins_doc.bottom+=u,a.y=n},i=s.getElementsByTagName("span"),l=0;l<i.length;++l)-1<(" "+i[l].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&a.pdf.internal.events.subscribe("htmlRenderingFinished",a.pdf.putTotalPages.bind(a.pdf,"###jsPDFVarTotalPages###"),!0);a.pdf.internal.events.subscribe("addPage",r,!1),r(),O.FOOTER=1}},m=function(t,e,n,r,i,a){if(!e)return!1;var o,s,u,l;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(o=e.replace(/<\/?script[^>]*?>/gi,""),l="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),(u=document.createElement("div")).style.cssText="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",u.innerHTML='<iframe style="height:1px;width:1px" name="'+l+'" />',document.body.appendChild(u),(s=window.frames[l]).document.open(),s.document.writeln(o),s.document.close(),e=s.document.body);var c,h=new f(t,n,r,i);return p.call(this,e,h,i.elementHandlers,function(t){g(e,h,i.elementHandlers),F(e,h,i.elementHandlers),h.pdf.internal.events.publish("htmlRenderingFinished"),c=h.dispose(),"function"==typeof a?a(c):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),c||{x:h.x,y:h.y}},(f=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this}).prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},f.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},f.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(0<this.watchFunctions.length){for(var r=0;r<this.watchFunctions.length;++r)!0===this.watchFunctions[r](t)?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},f.prototype.splitFragmentsIntoLines=function(t,e){var n,r,i,a,o,s,u,l,c,h,f,d,p,g;for(12,h=this.pdf.internal.scaleFactor,a={},s=u=l=g=o=i=c=r=void 0,d=[f=[]],n=0,p=this.settings.width;t.length;)if(o=t.shift(),g=e.shift(),o)if((i=a[(r=g["font-family"])+(c=g["font-style"])])||(i=this.pdf.internal.getFont(r,c).metadata.Unicode,a[r+c]=i),l={widths:i.widths,kerning:i.kerning,fontSize:12*g["font-size"],textIndent:n},u=this.pdf.getStringUnitWidth(o,l)*l.fontSize/h,"\u2028"==o)f=[],d.push(f);else if(p<n+u){for(s=this.pdf.splitTextToSize(o,p,l),f.push([s.shift(),g]);s.length;)f=[[s.shift(),g]],d.push(f);n=this.pdf.getStringUnitWidth(f[0][0],l)*l.fontSize/h}else f.push([o,g]),n+=u;if(void 0!==g["text-align"]&&("center"===g["text-align"]||"right"===g["text-align"]||"justify"===g["text-align"]))for(var m=0;m<d.length;++m){var b=this.pdf.getStringUnitWidth(d[m][0][0],l)*l.fontSize/h;0<m&&(d[m][0][1]=k(d[m][0][1]));var v=p-b;if("right"===g["text-align"])d[m][0][1]["margin-left"]=v;else if("center"===g["text-align"])d[m][0][1]["margin-left"]=v/2;else if("justify"===g["text-align"]){var y=d[m][0][0].split(" ").length-1;d[m][0][1]["word-spacing"]=v/y,m===d.length-1&&(d[m][0][1]["word-spacing"]=0)}}return d},f.prototype.RenderTextFragment=function(t,e){var n,r;r=0,this.pdf.internal.pageSize.getHeight()-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT",this.getPdfColor(e.color),this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td"),r=Math.max(r,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-12*r).toFixed(2),"Td")),n=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var i=this.getPdfColor(e.color);i!==this.lastTextColor&&(this.pdf.internal.write(i),this.lastTextColor=i),void 0!==e["word-spacing"]&&0<e["word-spacing"]&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+n.id,(12*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},f.prototype.getPdfColor=function(t){var e,n,r,i=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);if(null!=i)e=parseInt(i[1]),n=parseInt(i[2]),r=parseInt(i[3]);else{if("string"==typeof t&&"#"!=t.charAt(0)){var a=new RGBColor(t);t=a.ok?a.toHex():"#000000"}e=t.substring(1,3),e=parseInt(e,16),n=t.substring(3,5),n=parseInt(n,16),r=t.substring(5,7),r=parseInt(r,16)}if("string"==typeof e&&/^#[0-9A-Fa-f]{6}$/.test(e)){var o=parseInt(e.substr(1),16);e=o>>16&255,n=o>>8&255,r=255&o}var s=this.f3;return 0===e&&0===n&&0===r||void 0===n?s(e/255)+" g":[s(e/255),s(n/255),s(r/255),"rg"].join(" ")},f.prototype.f3=function(t){return t.toFixed(3)},f.prototype.renderParagraph=function(t){var e,n,r,i,a,o,s,u,l,c,h,f,d;if(r=y(this.paragraph.text),f=this.paragraph.style,e=this.paragraph.blockstyle,this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},r.join("").trim()){s=this.splitFragmentsIntoLines(r,f),u=o=void 0,n=12/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,h=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*n,c=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*n,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,h=((e["margin-top"]||0)+(e["padding-top"]||0))*n),l=this.pdf.internal.write,a=i=void 0,this.y+=h,l("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var p=0;s.length;){for(i=u=0,a=(o=s.shift()).length;i!==a;)o[i][0].trim()&&(u=Math.max(u,o[i][1]["line-height"],o[i][1]["font-size"]),d=7*o[i][1]["font-size"]),i++;var g=0,m=0;for(void 0!==o[0][1]["margin-left"]&&0<o[0][1]["margin-left"]&&(g=(m=this.pdf.internal.getCoordinateString(o[0][1]["margin-left"]))-p,p=m),l(g+Math.max(e["margin-left"]||0,0)*n,(-12*u).toFixed(2),"Td"),i=0,a=o.length;i!==a;)o[i][0]&&this.RenderTextFragment(o[i][0],o[i][1]),i++;if(this.y+=u*n,this.executeWatchFunctions(o[0][1])&&0<s.length){var b=[],v=[];s.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(b.push(t[e][0]+" "),v.push(t[e][1])),++e}),s=this.splitFragmentsIntoLines(y(b),v),l("ET","Q"),l("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-d/2),l("ET","Q"),this.y+=c}},f.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},f.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},f.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},i={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},u={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},o={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},l={none:"none",right:"right",left:"left"},c={none:"none",both:"both"},n={normal:1},t.fromHTML=function(t,e,n,r,i,a){return this.margins_doc=a||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),m(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}(U.API),U.API,("undefined"!=typeof window&&window||"undefined"!=typeof global&&global).html2pdf=function(t,o,e){var n=o.canvas;if(n){var r,i;if((n.pdf=o).annotations={_nameMap:[],createAnnotation:function(t,e){var n,r=o.context2d._wrapX(e.left),i=o.context2d._wrapY(e.top),a=t.indexOf("#");n=0<=a?{name:t.substring(a+1)}:{url:t},o.link(r,i,e.right-e.left,e.bottom-e.top,n)},setName:function(t,e){var n=o.context2d._wrapX(e.left),r=o.context2d._wrapY(e.top),i=o.context2d._page(e.top);this._nameMap[t]={page:i,x:n,y:r}}},n.annotations=o.annotations,o.context2d._pageBreakAt=function(t){this.pageBreaks.push(t)},o.context2d._gotoPage=function(t){for(;o.internal.getNumberOfPages()<t;)o.addPage();o.setPage(t)},"string"==typeof t){t=t.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"");var a,s=document.createElement("iframe");document.body.appendChild(s),(a=s.contentDocument||s.contentWindow.document).open(),a.write(t),a.close(),r=a.body}else r=t;var u={async:!0,allowTaint:!0,backgroundColor:"#ffffff",canvas:n,imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1,windowHeight:i=o.internal.pageSize.getHeight(),scrollY:i};return o.context2d.pageWrapYEnabled=!0,o.context2d.pageWrapY=o.internal.pageSize.getHeight(),html2canvas(r,u).then(function(){e&&(s&&s.parentElement.removeChild(s),e(o))})}alert("jsPDF canvas plugin not installed")},function(f){var r=f.BlobBuilder||f.WebKitBlobBuilder||f.MSBlobBuilder||f.MozBlobBuilder;f.URL=f.URL||f.webkitURL||function(t,e){return(e=document.createElement("a")).href=t,e};var n=f.Blob,d=URL.createObjectURL,p=URL.revokeObjectURL,a=f.Symbol&&f.Symbol.toStringTag,t=!1,e=!1,g=!!f.ArrayBuffer,i=r&&r.prototype.append&&r.prototype.getBlob;try{t=2===new Blob(["ä"]).size,e=2===new Blob([new Uint8Array([1,2])]).size}catch(t){}function o(t){return t.map(function(t){if(t.buffer instanceof ArrayBuffer){var e=t.buffer;if(t.byteLength!==e.byteLength){var n=new Uint8Array(t.byteLength);n.set(new Uint8Array(e,t.byteOffset,t.byteLength)),e=n.buffer}return e}return t})}function s(t,e){e=e||{};var n=new r;return o(t).forEach(function(t){n.append(t)}),e.type?n.getBlob(e.type):n.getBlob()}function u(t,e){return new n(o(t),e||{})}if(f.Blob&&(s.prototype=Blob.prototype,u.prototype=Blob.prototype),a)try{File.prototype[a]="File",Blob.prototype[a]="Blob",FileReader.prototype[a]="FileReader"}catch(t){}function l(){var t=!!f.ActiveXObject||"-ms-scroll-limit"in document.documentElement.style&&"-ms-ime-align"in document.documentElement.style,e=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;t&&e&&(XMLHttpRequest.prototype.send=function(t){t instanceof Blob&&this.setRequestHeader("Content-Type",t.type),e.call(this,t)});try{new File([],"")}catch(t){try{var n=new Function('class File extends Blob {constructor(chunks, name, opts) {opts = opts || {};super(chunks, opts || {});this.name = name;this.lastModifiedDate = opts.lastModified ? new Date(opts.lastModified) : new Date;this.lastModified = +this.lastModifiedDate;}};return new File([], ""), File')();f.File=n}catch(t){n=function(t,e,n){var r=new Blob(t,n),i=n&&void 0!==n.lastModified?new Date(n.lastModified):new Date;return r.name=e,r.lastModifiedDate=i,r.lastModified=+i,r.toString=function(){return"[object File]"},a&&(r[a]="File"),r};f.File=n}}}t?(l(),f.Blob=e?f.Blob:u):i?(l(),f.Blob=s):function(){function o(t){for(var e=[],n=0;n<t.length;n++){var r=t.charCodeAt(n);r<128?e.push(r):r<2048?e.push(192|r>>6,128|63&r):r<55296||57344<=r?e.push(224|r>>12,128|r>>6&63,128|63&r):(n++,r=65536+((1023&r)<<10|1023&t.charCodeAt(n)),e.push(240|r>>18,128|r>>12&63,128|r>>6&63,128|63&r))}return e}function e(t){var e,n,r,i,a,o;for(e="",r=t.length,n=0;n<r;)switch((i=t[n++])>>4){case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:e+=String.fromCharCode(i);break;case 12:case 13:a=t[n++],e+=String.fromCharCode((31&i)<<6|63&a);break;case 14:a=t[n++],o=t[n++],e+=String.fromCharCode((15&i)<<12|(63&a)<<6|(63&o)<<0)}return e}function s(t){for(var e=new Array(t.byteLength),n=new Uint8Array(t),r=e.length;r--;)e[r]=n[r];return e}function n(t){for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",n=[],r=0;r<t.length;r+=3){var i=t[r],a=r+1<t.length,o=a?t[r+1]:0,s=r+2<t.length,u=s?t[r+2]:0,l=i>>2,c=(3&i)<<4|o>>4,h=(15&o)<<2|u>>6,f=63&u;s||(f=64,a||(h=64)),n.push(e[l],e[c],e[h],e[f])}return n.join("")}var t=Object.create||function(t){function e(){}return e.prototype=t,new e};if(g)var r=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],u=ArrayBuffer.isView||function(t){return t&&-1<r.indexOf(Object.prototype.toString.call(t))};function l(t,e){for(var n=0,r=(t=t||[]).length;n<r;n++){var i=t[n];i instanceof l?t[n]=i._buffer:"string"==typeof i?t[n]=o(i):g&&(ArrayBuffer.prototype.isPrototypeOf(i)||u(i))?t[n]=s(i):g&&(a=i)&&DataView.prototype.isPrototypeOf(a)?t[n]=s(i.buffer):t[n]=o(String(i))}var a;this._buffer=[].concat.apply([],t),this.size=this._buffer.length,this.type=e&&e.type||""}function i(t,e,n){var r=l.call(this,t,n=n||{})||this;return r.name=e,r.lastModifiedDate=n.lastModified?new Date(n.lastModified):new Date,r.lastModified=+r.lastModifiedDate,r}if(l.prototype.slice=function(t,e,n){return new l([this._buffer.slice(t||0,e||this._buffer.length)],{type:n})},l.prototype.toString=function(){return"[object Blob]"},(i.prototype=t(l.prototype)).constructor=i,Object.setPrototypeOf)Object.setPrototypeOf(i,l);else try{i.__proto__=l}catch(t){}function a(){if(!(this instanceof a))throw new TypeError("Failed to construct 'FileReader': Please use the 'new' operator, this DOM object constructor cannot be called as a function.");var n=document.createDocumentFragment();this.addEventListener=n.addEventListener,this.dispatchEvent=function(t){var e=this["on"+t.type];"function"==typeof e&&e(t),n.dispatchEvent(t)},this.removeEventListener=n.removeEventListener}function c(t,e,n){if(!(e instanceof l))throw new TypeError("Failed to execute '"+n+"' on 'FileReader': parameter 1 is not of type 'Blob'.");t.result="",setTimeout(function(){this.readyState=a.LOADING,t.dispatchEvent(new Event("load")),t.dispatchEvent(new Event("loadend"))})}i.prototype.toString=function(){return"[object File]"},a.EMPTY=0,a.LOADING=1,a.DONE=2,a.prototype.error=null,a.prototype.onabort=null,a.prototype.onerror=null,a.prototype.onload=null,a.prototype.onloadend=null,a.prototype.onloadstart=null,a.prototype.onprogress=null,a.prototype.readAsDataURL=function(t){c(this,t,"readAsDataURL"),this.result="data:"+t.type+";base64,"+n(t._buffer)},a.prototype.readAsText=function(t){c(this,t,"readAsText"),this.result=e(t._buffer)},a.prototype.readAsArrayBuffer=function(t){c(this,t,"readAsText"),this.result=t._buffer.slice()},a.prototype.abort=function(){},URL.createObjectURL=function(t){return t instanceof l?"data:"+t.type+";base64,"+n(t._buffer):d.call(URL,t)},URL.revokeObjectURL=function(t){p&&p.call(URL,t)};var h=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;h&&(XMLHttpRequest.prototype.send=function(t){t instanceof l?(this.setRequestHeader("Content-Type",t.type),h.call(this,e(t._buffer))):h.call(this,t)}),f.FileReader=a,f.File=i,f.Blob=l}()}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());try{exports.GifWriter=function(b,t,e,n){var v=0,r=void 0===(n=void 0===n?{}:n).loop?null:n.loop,y=void 0===n.palette?null:n.palette;if(t<=0||e<=0||65535<t||65535<e)throw new Error("Width/Height invalid.");function w(t){var e=t.length;if(e<2||256<e||e&e-1)throw new Error("Invalid code/color length, must be power of 2 and 2 .. 256.");return e}b[v++]=71,b[v++]=73,b[v++]=70,b[v++]=56,b[v++]=57,b[v++]=97;var i=0,a=0;if(null!==y){for(var o=w(y);o>>=1;)++i;if(o=1<<i,--i,void 0!==n.background){if(o<=(a=n.background))throw new Error("Background index out of range.");if(0===a)throw new Error("Background index explicitly passed as 0.")}}if(b[v++]=255&t,b[v++]=t>>8&255,b[v++]=255&e,b[v++]=e>>8&255,b[v++]=(null!==y?128:0)|i,b[v++]=a,b[v++]=0,null!==y)for(var s=0,u=y.length;s<u;++s){var l=y[s];b[v++]=l>>16&255,b[v++]=l>>8&255,b[v++]=255&l}if(null!==r){if(r<0||65535<r)throw new Error("Loop count invalid.");b[v++]=33,b[v++]=255,b[v++]=11,b[v++]=78,b[v++]=69,b[v++]=84,b[v++]=83,b[v++]=67,b[v++]=65,b[v++]=80,b[v++]=69,b[v++]=50,b[v++]=46,b[v++]=48,b[v++]=3,b[v++]=1,b[v++]=255&r,b[v++]=r>>8&255,b[v++]=0}var x=!1;this.addFrame=function(t,e,n,r,i,a){if(!0===x&&(--v,x=!1),a=void 0===a?{}:a,t<0||e<0||65535<t||65535<e)throw new Error("x/y invalid.");if(n<=0||r<=0||65535<n||65535<r)throw new Error("Width/Height invalid.");if(i.length<n*r)throw new Error("Not enough pixels for the frame size.");var o=!0,s=a.palette;if(null==s&&(o=!1,s=y),null==s)throw new Error("Must supply either a local or global palette.");for(var u=w(s),l=0;u>>=1;)++l;u=1<<l;var c=void 0===a.delay?0:a.delay,h=void 0===a.disposal?0:a.disposal;if(h<0||3<h)throw new Error("Disposal out of range.");var f=!1,d=0;if(void 0!==a.transparent&&null!==a.transparent&&(f=!0,(d=a.transparent)<0||u<=d))throw new Error("Transparent color index.");if(0===h&&!f&&0===c||(b[v++]=33,b[v++]=249,b[v++]=4,b[v++]=h<<2|(!0===f?1:0),b[v++]=255&c,b[v++]=c>>8&255,b[v++]=d,b[v++]=0),b[v++]=44,b[v++]=255&t,b[v++]=t>>8&255,b[v++]=255&e,b[v++]=e>>8&255,b[v++]=255&n,b[v++]=n>>8&255,b[v++]=255&r,b[v++]=r>>8&255,b[v++]=!0===o?128|l-1:0,!0===o)for(var p=0,g=s.length;p<g;++p){var m=s[p];b[v++]=m>>16&255,b[v++]=m>>8&255,b[v++]=255&m}return v=function(e,n,t,r){e[n++]=t;var i=n++,a=1<<t,o=a-1,s=1+a,u=1+s,l=t+1,c=0,h=0;function f(t){for(;t<=c;)e[n++]=255&h,h>>=8,c-=8,n===i+256&&(e[i]=255,i=n++)}function d(t){h|=t<<c,c+=l,f(8)}var p=r[0]&o,g={};d(a);for(var m=1,b=r.length;m<b;++m){var v=r[m]&o,y=p<<8|v,w=g[y];if(void 0===w){for(h|=p<<c,c+=l;8<=c;)e[n++]=255&h,h>>=8,c-=8,n===i+256&&(e[i]=255,i=n++);4096===u?(d(a),u=1+s,l=t+1,g={}):(1<<l<=u&&++l,g[y]=u++),p=v}else p=w}return d(p),d(s),f(1),i+1===n?e[i]=0:(e[i]=n-i-1,e[n++]=0),n}(b,v,l<2?2:l,i)},this.end=function(){return!1===x&&(b[v++]=59,x=!0),v},this.getOutputBuffer=function(){return b},this.setOutputBuffer=function(t){b=t},this.getOutputBufferPosition=function(){return v},this.setOutputBufferPosition=function(t){v=t}},exports.GifReader=nt}catch(t){}
/*
   * Copyright (c) 2012 chick307 <chick307@gmail.com>
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
/*
    Copyright (c) 2008, Adobe Systems Incorporated
    All rights reserved.

    Redistribution and use in source and binary forms, with or without 
    modification, are permitted provided that the following conditions are
    met:

    * Redistributions of source code must retain the above copyright notice, 
      this list of conditions and the following disclaimer.
    
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the 
      documentation and/or other materials provided with the distribution.
    
    * Neither the name of Adobe Systems Incorporated nor the names of its 
      contributors may be used to endorse or promote products derived from 
      this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */
function it(t){var w,x,N,L,e,h=Math.floor,A=new Array(64),_=new Array(64),S=new Array(64),P=new Array(64),b=new Array(65535),v=new Array(65535),Z=new Array(64),y=new Array(64),k=[],F=0,C=7,I=new Array(64),j=new Array(64),B=new Array(64),n=new Array(256),O=new Array(2048),E=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],M=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],T=[0,1,2,3,4,5,6,7,8,9,10,11],q=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],R=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],D=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],U=[0,1,2,3,4,5,6,7,8,9,10,11],z=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],H=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function r(t,e){for(var n=0,r=0,i=new Array,a=1;a<=16;a++){for(var o=1;o<=t[a];o++)i[e[r]]=[],i[e[r]][0]=n,i[e[r]][1]=a,r++,n++;n*=2}return i}function W(t){for(var e=t[0],n=t[1]-1;0<=n;)e&1<<n&&(F|=1<<C),n--,--C<0&&(255==F?(V(255),V(0)):V(F),C=7,F=0)}function V(t){k.push(t)}function G(t){V(t>>8&255),V(255&t)}function Y(t,e,n,r,i){for(var a,o=i[0],s=i[240],u=function(t,e){var n,r,i,a,o,s,u,l,c,h,f=0;for(c=0;c<8;++c){n=t[f],r=t[f+1],i=t[f+2],a=t[f+3],o=t[f+4],s=t[f+5],u=t[f+6];var d=n+(l=t[f+7]),p=n-l,g=r+u,m=r-u,b=i+s,v=i-s,y=a+o,w=a-o,x=d+y,N=d-y,L=g+b,A=g-b;t[f]=x+L,t[f+4]=x-L;var _=.707106781*(A+N);t[f+2]=N+_,t[f+6]=N-_;var S=.382683433*((x=w+v)-(A=m+p)),P=.5411961*x+S,k=1.306562965*A+S,F=.707106781*(L=v+m),C=p+F,I=p-F;t[f+5]=I+P,t[f+3]=I-P,t[f+1]=C+k,t[f+7]=C-k,f+=8}for(c=f=0;c<8;++c){n=t[f],r=t[f+8],i=t[f+16],a=t[f+24],o=t[f+32],s=t[f+40],u=t[f+48];var j=n+(l=t[f+56]),B=n-l,O=r+u,E=r-u,M=i+s,T=i-s,q=a+o,R=a-o,D=j+q,U=j-q,z=O+M,H=O-M;t[f]=D+z,t[f+32]=D-z;var W=.707106781*(H+U);t[f+16]=U+W,t[f+48]=U-W;var V=.382683433*((D=R+T)-(H=E+B)),G=.5411961*D+V,Y=1.306562965*H+V,J=.707106781*(z=T+E),X=B+J,K=B-J;t[f+40]=K+G,t[f+24]=K-G,t[f+8]=X+Y,t[f+56]=X-Y,f++}for(c=0;c<64;++c)h=t[c]*e[c],Z[c]=0<h?.5+h|0:h-.5|0;return Z}(t,e),l=0;l<64;++l)y[E[l]]=u[l];var c=y[0]-n;n=y[0],0==c?W(r[0]):(W(r[v[a=32767+c]]),W(b[a]));for(var h=63;0<h&&0==y[h];)h--;if(0==h)return W(o),n;for(var f,d=1;d<=h;){for(var p=d;0==y[d]&&d<=h;)++d;var g=d-p;if(16<=g){f=g>>4;for(var m=1;m<=f;++m)W(s);g&=15}a=32767+y[d],W(i[(g<<4)+v[a]]),W(b[a]),d++}return 63!=h&&W(o),n}function J(t){(t=Math.min(Math.max(t,1),100),e!=t)&&(function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],n=0;n<64;n++){var r=h((e[n]*t+50)/100);r=Math.min(Math.max(r,1),255),A[E[n]]=r}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],a=0;a<64;a++){var o=h((i[a]*t+50)/100);o=Math.min(Math.max(o,1),255),_[E[a]]=o}for(var s=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],u=0,l=0;l<8;l++)for(var c=0;c<8;c++)S[u]=1/(A[E[u]]*s[l]*s[c]*8),P[u]=1/(_[E[u]]*s[l]*s[c]*8),u++}(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),e=t)}this.encode=function(t,e){e&&J(e),k=new Array,F=0,C=7,G(65496),G(65504),G(16),V(74),V(70),V(73),V(70),V(0),V(1),V(1),V(0),G(1),G(1),V(0),V(0),function(){G(65499),G(132),V(0);for(var t=0;t<64;t++)V(A[t]);V(1);for(var e=0;e<64;e++)V(_[e])}(),function(t,e){G(65472),G(17),V(8),G(e),G(t),V(3),V(1),V(17),V(0),V(2),V(17),V(1),V(3),V(17),V(1)}(t.width,t.height),function(){G(65476),G(418),V(0);for(var t=0;t<16;t++)V(M[t+1]);for(var e=0;e<=11;e++)V(T[e]);V(16);for(var n=0;n<16;n++)V(q[n+1]);for(var r=0;r<=161;r++)V(R[r]);V(1);for(var i=0;i<16;i++)V(D[i+1]);for(var a=0;a<=11;a++)V(U[a]);V(17);for(var o=0;o<16;o++)V(z[o+1]);for(var s=0;s<=161;s++)V(H[s])}(),G(65498),G(12),V(3),V(1),V(0),V(2),V(17),V(3),V(17),V(0),V(63),V(0);var n=0,r=0,i=0;F=0,C=7,this.encode.displayName="_encode_";for(var a,o,s,u,l,c,h,f,d,p=t.data,g=t.width,m=t.height,b=4*g,v=0;v<m;){for(a=0;a<b;){for(l=b*v+a,h=-1,d=f=0;d<64;d++)c=l+(f=d>>3)*b+(h=4*(7&d)),m<=v+f&&(c-=b*(v+1+f-m)),b<=a+h&&(c-=a+h-b+4),o=p[c++],s=p[c++],u=p[c++],I[d]=(O[o]+O[s+256>>0]+O[u+512>>0]>>16)-128,j[d]=(O[o+768>>0]+O[s+1024>>0]+O[u+1280>>0]>>16)-128,B[d]=(O[o+1280>>0]+O[s+1536>>0]+O[u+1792>>0]>>16)-128;n=Y(I,S,n,w,N),r=Y(j,P,r,x,L),i=Y(B,P,i,x,L),a+=32}v+=8}if(0<=C){var y=[];y[1]=C+1,y[0]=(1<<C+1)-1,W(y)}return G(65497),new Uint8Array(k)},t=t||50,function(){for(var t=String.fromCharCode,e=0;e<256;e++)n[e]=t(e)}(),w=r(M,T),x=r(D,U),N=r(q,R),L=r(z,H),function(){for(var t=1,e=2,n=1;n<=15;n++){for(var r=t;r<e;r++)v[32767+r]=n,b[32767+r]=[],b[32767+r][1]=n,b[32767+r][0]=r;for(var i=-(e-1);i<=-t;i++)v[32767+i]=n,b[32767+i]=[],b[32767+i][1]=n,b[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)O[t]=19595*t,O[t+256>>0]=38470*t,O[t+512>>0]=7471*t+32768,O[t+768>>0]=-11059*t,O[t+1024>>0]=-21709*t,O[t+1280>>0]=32768*t+8421375,O[t+1536>>0]=-27439*t,O[t+1792>>0]=-5329*t}(),J(t)}U.API.adler32cs=(j="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,B=null,O=function(){if(!j)return function(){return!1};try{var t={};"function"==typeof t.Buffer&&(B=t.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==B&&t instanceof B}}(),E=null!==B?function(t){return new B(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))},M=function(t,e){for(var n=65535&t,r=t>>>16,i=0,a=e.length;i<a;i++)n=(n+(255&e.charCodeAt(i)))%65521,r=(r+n)%65521;return(r<<16|n)>>>0},T=function(t,e){for(var n=65535&t,r=t>>>16,i=0,a=e.length;i<a;i++)n=(n+e[i])%65521,r=(r+n)%65521;return(r<<16|n)>>>0},R=(q={}).Adler32=function(){var n=function(t){if(!(this instanceof n))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null===t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0},e=n.prototype={};return(e.constructor=n).from=function(t){return t.prototype=e,t}(function(t){if(!(this instanceof n))throw new TypeError("Constructor cannot called be as a function.");if(null===t)throw new Error("First argument needs to be a string.");this.checksum=M(1,t.toString())}),n.fromUtf8=function(t){return t.prototype=e,t}(function(t){if(!(this instanceof n))throw new TypeError("Constructor cannot called be as a function.");if(null===t)throw new Error("First argument needs to be a string.");var e=E(t.toString());this.checksum=M(1,e)}),j&&(n.fromBuffer=function(t){return t.prototype=e,t}(function(t){if(!(this instanceof n))throw new TypeError("Constructor cannot called be as a function.");if(!O(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=T(1,e)})),e.update=function(t){if(null===t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=M(this.checksum,t)},e.updateUtf8=function(t){if(null===t)throw new Error("First argument needs to be a string.");var e=E(t.toString());return this.checksum=M(this.checksum,e)},j&&(e.updateBuffer=function(t){if(!O(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=T(this.checksum,e)}),e.clone=function(){return new R(this.checksum)},n}(),q.from=function(t){if(null===t)throw new Error("First argument needs to be a string.");return M(1,t.toString())},q.fromUtf8=function(t){if(null===t)throw new Error("First argument needs to be a string.");var e=E(t.toString());return M(1,e)},j&&(q.fromBuffer=function(t){if(!O(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return T(1,e)}),q),function(t){t.__bidiEngine__=t.prototype.__bidiEngine__=function(t){var p,g,h,f,i,a,o,s=e,m=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],b=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],v={L:0,R:1,EN:2,AN:3,N:4,B:5,S:6},u={0:0,5:1,6:2,7:3,32:4,251:5,254:6,255:7},l=["(",")","(","<",">","<","[","]","[","{","}","{","«","»","«","‹","›","‹","⁅","⁆","⁅","⁽","⁾","⁽","₍","₎","₍","≤","≥","≤","〈","〉","〈","﹙","﹚","﹙","﹛","﹜","﹛","﹝","﹞","﹝","﹤","﹥","﹤"],c=new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),y=!1,w=0;this.__bidiEngine__={};function x(t){var e=t.charCodeAt(),n=e>>8,r=u[n];return void 0!==r?s[256*r+(255&e)]:252==n||253==n?"AL":c.test(n)?"L":8==n?"R":"N"}function N(t,e,n,r){var i,a,o,s,u=e[r];switch(u){case"L":case"R":y=!1;break;case"N":case"AN":break;case"EN":y&&(u="AN");break;case"AL":y=!0,u="R";break;case"WS":u="N";break;case"CS":r<1||r+1>=e.length||"EN"!==(i=n[r-1])&&"AN"!==i||"EN"!==(a=e[r+1])&&"AN"!==a?u="N":y&&(a="AN"),u=a===i?a:"N";break;case"ES":u="EN"===(i=0<r?n[r-1]:"B")&&r+1<e.length&&"EN"===e[r+1]?"EN":"N";break;case"ET":if(0<r&&"EN"===n[r-1]){u="EN";break}if(y){u="N";break}for(o=r+1,s=e.length;o<s&&"ET"===e[o];)o++;u=o<s&&"EN"===e[o]?"EN":"N";break;case"NSM":if(h&&!f){for(s=e.length,o=r+1;o<s&&"NSM"===e[o];)o++;if(o<s){var l=t[r],c=1425<=l&&l<=2303||64286===l;if(i=e[o],c&&("R"===i||"AL"===i)){u="R";break}}}u=r<1||"B"===(i=e[r-1])?"N":n[r-1];break;case"B":p=!(y=!1),u=w;break;case"S":g=!0,u="N";break;case"LRE":case"RLE":case"LRO":case"RLO":case"PDF":y=!1;break;case"BN":u="N"}return u}function d(t,e,n){var r=t.split("");return n&&S(r,n,{hiLevel:w}),r.reverse(),e&&e.reverse(),r.join("")}function L(t,e,n,r,i){if(!(i.hiLevel<t)){if(1===t&&1===w&&!p)return e.reverse(),void(n&&n.reverse());for(var a,o,s,u,l=e.length,c=0;c<l;){if(r[c]>=t){for(s=c+1;s<l&&r[s]>=t;)s++;for(u=c,o=s-1;u<o;u++,o--)a=e[u],e[u]=e[o],e[o]=a,n&&(a=n[u],n[u]=n[o],n[o]=a);c=s}c++}}}function A(t,e,n){var r=t.split(""),i={hiLevel:w};return n||(n=[]),S(r,n,i),function(t,e,n){if(0!==n.hiLevel&&o)for(var r,i=0;i<t.length;i++)1!==e[i]||0<=(r=l.indexOf(t[i]))&&(t[i]=l[r+1])}(r,n,i),L(2,r,e,n,i),L(1,r,e,n,i),r.join("")}var _=function(t){for(var e,n=0;n<t.length;n++){if("L"===(e=x(t.charAt(n))))return!1;if("R"===e)return!0}return!1},S=function(t,e,n){var r,i,a,o,s,u=-1,l=t.length,c=0,h=[],f=w?b:m,d=[];for(g=p=y=!1,i=0;i<l;i++)d[i]=x(t[i]);for(a=0;a<l;a++){if(s=c,h[a]=N(t,d,h,a),r=240&(c=f[s][v[h[a]]]),c&=15,e[a]=o=f[c][5],0<r)if(16==r){for(i=u;i<a;i++)e[i]=1;u=-1}else u=-1;if(f[c][6])-1===u&&(u=a);else if(-1<u){for(i=u;i<a;i++)e[i]=o;u=-1}"B"===d[a]&&(e[a]=0),n.hiLevel|=o}g&&function(t,e,n){for(var r=0;r<n;r++)if("S"===t[r]){e[r]=w;for(var i=r-1;0<=i&&"WS"===t[i];i--)e[i]=w}}(d,e,l)};return this.__bidiEngine__.doBidiReorder=function(t,e,n){if(function(t,e){if(e)for(var n=0;n<t.length;n++)e[n]=n;void 0===f&&(f=_(t)),void 0===a&&(a=_(t))}(t,e),h||!i||a)if(h&&i&&f^a)w=f?1:0,t=d(t,e,n);else if(!h&&i&&a)w=f?1:0,t=A(t,e,n),t=d(t,e);else if(!h||f||i||a){if(h&&!i&&f^a)t=d(t,e),t=f?(w=0,A(t,e,n)):(w=1,t=A(t,e,n),d(t,e));else if(h&&f&&!i&&a)w=1,t=A(t,e,n),t=d(t,e);else if(!h&&!i&&f^a){var r=o;f?(w=1,t=A(t,e,n),w=0,o=!1,t=A(t,e,n),o=r):(w=0,t=A(t,e,n),t=d(t,e),o=!(w=1),t=A(t,e,n),o=r,t=d(t,e))}}else w=0,t=A(t,e,n);else w=f?1:0,t=A(t,e,n);return t},this.__bidiEngine__.setOptions=function(t){t&&(h=t.isInputVisual,i=t.isOutputVisual,f=t.isInputRtl,a=t.isOutputRtl,o=t.isSymmetricSwapping)},this.__bidiEngine__.setOptions(t),this.__bidiEngine__};var e=["BN","BN","BN","BN","BN","BN","BN","BN","BN","S","B","S","WS","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","B","B","B","S","WS","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","BN","BN","BN","BN","BN","BN","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","CS","N","ET","ET","ET","ET","N","N","N","N","L","N","N","BN","N","N","ET","ET","EN","EN","N","L","N","N","N","EN","L","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","N","N","N","N","N","ET","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","NSM","R","NSM","NSM","R","NSM","NSM","R","NSM","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","N","N","N","N","N","R","R","R","R","R","N","N","N","N","N","N","N","N","N","N","N","AN","AN","AN","AN","AN","AN","N","N","AL","ET","ET","AL","CS","AL","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","AN","AN","AN","AN","AN","AN","AN","AN","AN","ET","AN","AN","AL","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","N","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","NSM","NSM","N","NSM","NSM","NSM","NSM","AL","AL","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","R","N","N","N","N","R","N","N","N","N","N","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","BN","BN","BN","L","R","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","B","LRE","RLE","PDF","LRO","RLO","CS","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","BN","BN","BN","BN","BN","N","LRI","RLI","FSI","PDI","BN","BN","BN","BN","BN","BN","EN","L","N","N","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","L","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","N","N","N","N","N","R","NSM","R","R","R","R","R","R","R","R","R","R","ES","R","R","R","R","R","R","R","R","R","R","R","R","R","N","R","R","R","R","R","N","R","N","R","R","N","R","R","N","R","R","R","R","R","R","R","R","R","R","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","CS","N","N","CS","N","N","N","N","N","N","N","N","N","ET","N","N","ES","ES","N","N","N","N","N","ET","ET","N","N","N","N","N","AL","AL","AL","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","BN","N","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","N","N","N","ET","ET","N","N","N","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N"],a=new t.__bidiEngine__({isInputVisual:!0});t.API.events.push(["postProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang,[]);if(n.isInputVisual="boolean"!=typeof n.isInputVisual||n.isInputVisual,a.setOptions(n),"[object Array]"===Object.prototype.toString.call(e)){var i=0;for(r=[],i=0;i<e.length;i+=1)"[object Array]"===Object.prototype.toString.call(e[i])?r.push([a.doBidiReorder(e[i][0]),e[i][1],e[i][2]]):r.push([a.doBidiReorder(e[i])]);t.text=r}else t.text=a.doBidiReorder(e);a.setOptions({isInputVisual:!0})}])}(U);try{exports.JPEGEncoder=it}catch(t){}function at(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR()}at.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var n=this.datav.getUint8(this.pos++,!0),r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:r,blue:n,quad:a}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},at.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]()}catch(t){console.log("bit decode error:"+t)}},at.prototype.bit1=function(){var t,e=Math.ceil(this.width/8),n=e%4;for(t=this.height-1;0<=t;t--){for(var r=this.bottom_up?t:this.height-1-t,i=0;i<e;i++)for(var a=this.datav.getUint8(this.pos++,!0),o=r*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var u=this.palette[a>>7-s&1];this.data[o+4*s]=u.blue,this.data[o+4*s+1]=u.green,this.data[o+4*s+2]=u.red,this.data[o+4*s+3]=255}0!=n&&(this.pos+=4-n)}},at.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++){var a=this.datav.getUint8(this.pos++,!0),o=r*this.width*4+2*i*4,s=a>>4,u=15&a,l=this.palette[s];if(this.data[o]=l.blue,this.data[1+o]=l.green,this.data[2+o]=l.red,this.data[3+o]=255,2*i+1>=this.width)break;l=this.palette[u],this.data[4+o]=l.blue,this.data[4+o+1]=l.green,this.data[4+o+2]=l.red,this.data[4+o+3]=255}0!=e&&(this.pos+=4-e)}},at.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;0<=e;e--){for(var n=this.bottom_up?e:this.height-1-e,r=0;r<this.width;r++){var i=this.datav.getUint8(this.pos++,!0),a=n*this.width*4+4*r;if(i<this.palette.length){var o=this.palette[i];this.data[a]=o.red,this.data[1+a]=o.green,this.data[2+a]=o.blue,this.data[3+a]=255}else this.data[a]=255,this.data[1+a]=255,this.data[2+a]=255,this.data[3+a]=255}0!=t&&(this.pos+=4-t)}},at.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<this.width;i++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var o=(a&e)/e*255|0,s=(a>>5&e)/e*255|0,u=(a>>10&e)/e*255|0,l=a>>15?255:0,c=r*this.width*4+4*i;this.data[c]=u,this.data[1+c]=s,this.data[2+c]=o,this.data[3+c]=l}this.pos+=t}},at.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),n=parseInt("111111",2),r=this.height-1;0<=r;r--){for(var i=this.bottom_up?r:this.height-1-r,a=0;a<this.width;a++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(o&e)/e*255|0,u=(o>>5&n)/n*255|0,l=(o>>11)/e*255|0,c=i*this.width*4+4*a;this.data[c]=l,this.data[1+c]=u,this.data[2+c]=s,this.data[3+c]=255}this.pos+=t}},at.prototype.bit24=function(){for(var t=this.height-1;0<=t;t--){for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),o=e*this.width*4+4*n;this.data[o]=a,this.data[1+o]=i,this.data[2+o]=r,this.data[3+o]=255}this.pos+=this.width%4}},at.prototype.bit32=function(){for(var t=this.height-1;0<=t;t--)for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*n;this.data[s]=a,this.data[1+s]=i,this.data[2+s]=r,this.data[3+s]=o}},at.prototype.getData=function(){return this.data};try{exports.BmpDecoder=at}catch(t){}function ot(t){function Mi(t){if(!t)throw Error("assert :P")}function Ti(t,e,n){for(var r=0;r<4;r++)if(t[e+r]!=n.charCodeAt(r))return!0;return!1}function qi(t,e,n,r,i){for(var a=0;a<i;a++)t[e+a]=n[r+a]}function Ri(t,e,n,r){for(var i=0;i<r;i++)t[e+i]=n}function Di(t){return new Int32Array(t)}function Ui(t,e){for(var n=[],r=0;r<t;r++)n.push(new e);return n}function zi(t,o){var e=[];return function t(e,n,r){for(var i=r[n],a=0;a<i&&(e.push(r.length>n+1?[]:new o),!(r.length<n+1));a++)t(e[a],n+1,r)}(e,0,t),e}function g(t,e){for(var n="",r=0;r<4;r++)n+=String.fromCharCode(t[e++]);return n}function m(t,e){return(t[e+0]<<0|t[e+1]<<8|t[e+2]<<16)>>>0}function b(t,e){return(t[e+0]<<0|t[e+1]<<8|t[e+2]<<16|t[e+3]<<24)>>>0}new(ot=function(){var m=this;function y(t,e){for(var n=1<<e-1>>>0;t&n;)n>>>=1;return n?(t&n-1)+n:t}function w(t,e,n,r,i){for(Mi(!(r%n));t[e+(r-=n)]=i,0<r;);}function $t(t,e,n,r,i){if(Mi(i<=2328),i<=512)var a=Di(512);else if(null==(a=Di(i)))return 0;return function(t,e,n,r,i,a){var o,s,u=e,l=1<<n,c=Di(16),h=Di(16);for(Mi(0!=i),Mi(null!=r),Mi(null!=t),Mi(0<n),s=0;s<i;++s){if(15<r[s])return 0;++c[r[s]]}if(c[0]==i)return 0;for(h[1]=0,o=1;o<15;++o){if(c[o]>1<<o)return 0;h[o+1]=h[o]+c[o]}for(s=0;s<i;++s)o=r[s],0<r[s]&&(a[h[o]++]=s);if(1==h[15])return(r=new Qt).g=0,r.value=a[0],w(t,u,1,l,r),l;var f,d=-1,p=l-1,g=0,m=1,b=1,v=1<<n;for(s=0,o=1,i=2;o<=n;++o,i<<=1){if(m+=b<<=1,(b-=c[o])<0)return 0;for(;0<c[o];--c[o])(r=new Qt).g=o,r.value=a[s++],w(t,u+g,i,v,r),g=y(g,o)}for(o=n+1,i=2;o<=15;++o,i<<=1){if(m+=b<<=1,(b-=c[o])<0)return 0;for(;0<c[o];--c[o]){if(r=new Qt,(g&p)!=d){for(u+=v,f=1<<(d=o)-n;d<15&&!((f-=c[d])<=0);)++d,f<<=1;l+=v=1<<(f=d-n),t[e+(d=g&p)].g=f+n,t[e+d].value=u-e-d}r.g=o-n,r.value=a[s++],w(t,u+(g>>n),i,v,r),g=y(g,o)}}return m!=2*h[15]-1?0:l}(t,e,n,r,i,a)}function Qt(){this.value=this.g=0}function t(){this.value=this.g=0}function te(){this.G=Ui(5,Qt),this.H=Di(5),this.jc=this.Qb=this.qb=this.nd=0,this.pd=Ui(jn,t)}function p(t,e,n,r){Mi(null!=t),Mi(null!=e),Mi(r<2147483648),t.Ca=254,t.I=0,t.b=-8,t.Ka=0,t.oa=e,t.pa=n,t.Jd=e,t.Yc=n+r,t.Zc=4<=r?n+r-4+1:n,v(t)}function g(t,e){for(var n=0;0<e--;)n|=T(t,128)<<e;return n}function b(t,e){var n=g(t,e);return x(t)?-n:n}function k(t,e,n,r){var i,a=0;for(Mi(null!=t),Mi(null!=e),Mi(r<4294967288),t.Sb=r,t.Ra=0,t.u=0,4<r&&(r=4),i=t.h=0;i<r;++i)a+=e[n+i]<<8*i;t.Ra=a,t.bb=r,t.oa=e,t.pa=n}function r(t){for(;8<=t.u&&t.bb<t.Sb;)t.Ra>>>=8,t.Ra+=t.oa[t.pa+t.bb]<<En-8>>>0,++t.bb,t.u-=8;A(t)&&(t.h=1,t.u=0)}function ee(t,e){if(Mi(0<=e),!t.h&&e<=On){var n=ne(t)&Bn[e];return t.u+=e,r(t),n}return t.h=1,t.u=0}function e(){this.b=this.Ca=this.I=0,this.oa=[],this.pa=0,this.Jd=[],this.Yc=0,this.Zc=[],this.Ka=0}function F(){this.Ra=0,this.oa=[],this.h=this.u=this.bb=this.Sb=this.pa=0}function ne(t){return t.Ra>>>(t.u&En-1)>>>0}function A(t){return Mi(t.bb<=t.Sb),t.h||t.bb==t.Sb&&t.u>En}function re(t,e){t.u=e,t.h=A(t)}function ie(t){t.u>=Mn&&(Mi(t.u>=Mn),r(t))}function v(t){Mi(null!=t&&null!=t.oa),t.pa<t.Zc?(t.I=(t.oa[t.pa++]|t.I<<8)>>>0,t.b+=8):(Mi(null!=t&&null!=t.oa),t.pa<t.Yc?(t.b+=8,t.I=t.oa[t.pa++]|t.I<<8):t.Ka?t.b=0:(t.I<<=8,t.b+=8,t.Ka=1))}function x(t){return g(t,1)}function T(t,e){var n=t.Ca;t.b<0&&v(t);var r=t.b,i=n*e>>>8,a=(t.I>>>r>i)+0;for(a?(n-=i,t.I-=i+1<<r>>>0):n=i+1,r=n,i=0;256<=r;)i+=8,r>>=8;return r=7^i+Tn[r],t.b-=r,t.Ca=(n<<r)-1,a}function o(t,e,n){t[e+0]=n>>24&255,t[e+1]=n>>16&255,t[e+2]=n>>8&255,t[e+3]=n>>0&255}function n(t,e){return t[e+0]<<0|t[e+1]<<8}function C(t,e){return n(t,e)|t[e+2]<<16}function I(t,e){return n(t,e)|n(t,e+2)<<16}function ae(t,e){var n=1<<e;return Mi(null!=t),Mi(0<e),t.X=Di(n),null==t.X?0:(t.Mb=32-e,t.Xa=e,1)}function _(t,e){Mi(null!=t),Mi(null!=e),Mi(t.Xa==e.Xa),qi(e.X,0,t.X,0,1<<e.Xa)}function i(){this.X=[],this.Xa=this.Mb=0}function N(t,e,n,r){Mi(null!=n),Mi(null!=r);var i=n[0],a=r[0];return 0==i&&(i=(t*a+e/2)/e),0==a&&(a=(e*i+t/2)/t),i<=0||a<=0?0:(n[0]=i,r[0]=a,1)}function oe(t,e){return t+(1<<e)-1>>>e}function se(t,e){return((4278255360&t)+(4278255360&e)>>>0&4278255360)+((16711935&t)+(16711935&e)>>>0&16711935)>>>0}function a(l,t){m[t]=function(t,e,n,r,i,a,o){var s;for(s=0;s<i;++s){var u=m[l](a[o+s-1],n,r+s);a[o+s]=se(t[e+s],u)}}}function j(){this.ud=this.hd=this.jd=0}function s(t,e){return((4278124286&(t^e))>>>1)+(t&e)>>>0}function u(t){return 0<=t&&t<256?t:t<0?0:255<t?255:void 0}function l(t,e){return u(t+(t-e+.5>>1))}function c(t,e,n){return Math.abs(e-n)-Math.abs(t-n)}function B(t,e,n,r,i,a,o){for(r=a[o-1],n=0;n<i;++n)a[o+n]=r=se(t[e+n],r)}function h(t,e,n,r,i){var a;for(a=0;a<n;++a){var o=t[e+a],s=o>>8&255,u=16711935&(u=(u=16711935&o)+((s<<16)+s));r[i+a]=(4278255360&o)+u>>>0}}function O(t,e){e.jd=t>>0&255,e.hd=t>>8&255,e.ud=t>>16&255}function f(t,e,n,r,i,a){var o;for(o=0;o<r;++o){var s=e[n+o],u=s>>>8,l=s,c=255&(c=(c=s>>>16)+((t.jd<<24>>24)*(u<<24>>24)>>>5));l=255&(l=(l=l+((t.hd<<24>>24)*(u<<24>>24)>>>5))+((t.ud<<24>>24)*(c<<24>>24)>>>5));i[a+o]=(4278255360&s)+(c<<16)+l}}function d(t,e,d,p,g){m[e]=function(t,e,n,r,i,a,o,s,u){for(r=o;r<s;++r)for(o=0;o<u;++o)i[a++]=g(n[p(t[e++])])},m[t]=function(t,e,n,r,i,a,o){var s=8>>t.b,u=t.Ea,l=t.K[0],c=t.w;if(s<8)for(t=(1<<t.b)-1,c=(1<<s)-1;e<n;++e){var h,f=0;for(h=0;h<u;++h)h&t||(f=p(r[i++])),a[o++]=g(l[f&c]),f>>=s}else m["VP8LMapColor"+d](r,i,l,c,a,o,e,n,u)}}function L(t,e,n,r,i){for(n=e+n;e<n;){var a=t[e++];r[i++]=a>>16&255,r[i++]=a>>8&255,r[i++]=a>>0&255}}function S(t,e,n,r,i){for(n=e+n;e<n;){var a=t[e++];r[i++]=a>>16&255,r[i++]=a>>8&255,r[i++]=a>>0&255,r[i++]=a>>24&255}}function P(t,e,n,r,i){for(n=e+n;e<n;){var a=(o=t[e++])>>16&240|o>>12&15,o=o>>0&240|o>>28&15;r[i++]=a,r[i++]=o}}function E(t,e,n,r,i){for(n=e+n;e<n;){var a=(o=t[e++])>>16&248|o>>13&7,o=o>>5&224|o>>3&31;r[i++]=a,r[i++]=o}}function M(t,e,n,r,i){for(n=e+n;e<n;){var a=t[e++];r[i++]=a>>0&255,r[i++]=a>>8&255,r[i++]=a>>16&255}}function q(t,e,n,r,i,a){if(0==a)for(n=e+n;e<n;)o(r,((a=t[e++])[0]>>24|a[1]>>8&65280|a[2]<<8&16711680|a[3]<<24)>>>0),i+=32;else qi(r,i,t,e,n)}function R(t,e){m[e][0]=m[t+"0"],m[e][1]=m[t+"1"],m[e][2]=m[t+"2"],m[e][3]=m[t+"3"],m[e][4]=m[t+"4"],m[e][5]=m[t+"5"],m[e][6]=m[t+"6"],m[e][7]=m[t+"7"],m[e][8]=m[t+"8"],m[e][9]=m[t+"9"],m[e][10]=m[t+"10"],m[e][11]=m[t+"11"],m[e][12]=m[t+"12"],m[e][13]=m[t+"13"],m[e][14]=m[t+"0"],m[e][15]=m[t+"0"]}function D(t){return t==Mr||t==Tr||t==qr||t==Rr}function U(){this.eb=[],this.size=this.A=this.fb=0}function z(){this.y=[],this.f=[],this.ea=[],this.F=[],this.Tc=this.Ed=this.Cd=this.Fd=this.lb=this.Db=this.Ab=this.fa=this.J=this.W=this.N=this.O=0}function H(){this.Rd=this.height=this.width=this.S=0,this.f={},this.f.RGBA=new U,this.f.kb=new z,this.sd=null}function W(){this.width=[0],this.height=[0],this.Pd=[0],this.Qd=[0],this.format=[0]}function V(){this.Id=this.fd=this.Md=this.hb=this.ib=this.da=this.bd=this.cd=this.j=this.v=this.Da=this.Sd=this.ob=0}function G(t){return alert("todo:WebPSamplerProcessPlane"),t.T}function Y(t,e){var n=t.T,r=e.ba.f.RGBA,i=r.eb,a=r.fb+t.ka*r.A,o=ci[e.ba.S],s=t.y,u=t.O,l=t.f,c=t.N,h=t.ea,f=t.W,d=e.cc,p=e.dc,g=e.Mc,m=e.Nc,b=t.ka,v=t.ka+t.T,y=t.U,w=y+1>>1;for(0==b?o(s,u,null,null,l,c,h,f,l,c,h,f,i,a,null,null,y):(o(e.ec,e.fc,s,u,d,p,g,m,l,c,h,f,i,a-r.A,i,a,y),++n);b+2<v;b+=2)d=l,p=c,g=h,m=f,c+=t.Rc,f+=t.Rc,a+=2*r.A,o(s,(u+=2*t.fa)-t.fa,s,u,d,p,g,m,l,c,h,f,i,a-r.A,i,a,y);return u+=t.fa,t.j+v<t.o?(qi(e.ec,e.fc,s,u,y),qi(e.cc,e.dc,l,c,w),qi(e.Mc,e.Nc,h,f,w),n--):1&v||o(s,u,null,null,l,c,h,f,l,c,h,f,i,a+r.A,null,null,y),n}function J(t,e,n){var r=t.F,i=[t.J];if(null!=r){var a=t.U,o=e.ba.S,s=o==Br||o==qr;e=e.ba.f.RGBA;var u=[0],l=t.ka;u[0]=t.T,t.Kb&&(0==l?--u[0]:(--l,i[0]-=t.width),t.j+t.ka+t.T==t.o&&(u[0]=t.o-t.j-l));var c=e.eb;l=e.fb+l*e.A;t=vr(r,i[0],t.width,a,u,c,l+(s?0:3),e.A),Mi(n==u),t&&D(o)&&mr(c,l,s,a,u,e.A)}return 0}function X(t){var e=t.ma,n=e.ba.S,r=n<11,i=n==Cr||n==jr||n==Br||n==Or||12==n||D(n);if(e.memory=null,e.Ib=null,e.Jb=null,e.Nd=null,!Fn(e.Oa,t,i?11:12))return 0;if(i&&D(n)&&fn(),t.da)alert("todo:use_scaling");else{if(r){if(e.Ib=G,t.Kb){if(n=t.U+1>>1,e.memory=Di(t.U+2*n),null==e.memory)return 0;e.ec=e.memory,e.fc=0,e.cc=e.ec,e.dc=e.fc+t.U,e.Mc=e.cc,e.Nc=e.dc+n,e.Ib=Y,fn()}}else alert("todo:EmitYUV");i&&(e.Jb=J,r&&cn())}if(r&&!Ai){for(t=0;t<256;++t)_i[t]=89858*(t-128)+yi>>vi,ki[t]=-22014*(t-128)+yi,Pi[t]=-45773*(t-128),Si[t]=113618*(t-128)+yi>>vi;for(t=wi;t<xi;++t)e=76283*(t-16)+yi>>vi,Fi[t-wi]=At(e,255),Ci[t-wi]=At(e+8>>4,15);Ai=1}return 1}function K(t){var e=t.ma,n=t.U,r=t.T;return Mi(!(1&t.ka)),n<=0||r<=0?0:(n=e.Ib(t,e),null!=e.Jb&&e.Jb(t,e,n),e.Dc+=n,1)}function Z(t){t.ma.memory=null}function $(t,e,n,r){return 47!=ee(t,8)?0:(e[0]=ee(t,14)+1,n[0]=ee(t,14)+1,r[0]=ee(t,1),0!=ee(t,3)?0:!t.h)}function Q(t,e){if(t<4)return t+1;var n=t-2>>1;return(2+(1&t)<<n)+ee(e,n)+1}function tt(t,e){return 120<e?e-120:1<=(n=((n=Vr[e-1])>>4)*t+(8-(15&n)))?n:1;var n}function et(t,e,n){var r=ne(n),i=t[e+=255&r].g-8;return 0<i&&(re(n,n.u+8),r=ne(n),e+=t[e].value,e+=r&(1<<i)-1),re(n,n.u+t[e].g),t[e].value}function ue(t,e,n){return n.g+=t.g,n.value+=t.value<<e>>>0,Mi(n.g<=8),t.g}function nt(t,e,n){var r=t.xc;return Mi((e=0==r?0:t.vc[t.md*(n>>r)+(e>>r)])<t.Wb),t.Ya[e]}function rt(t,e,n,r){var i=t.ab,a=t.c*e,o=t.C;e=o+e;var s=n,u=r;for(r=t.Ta,n=t.Ua;0<i--;){var l=t.gc[i],c=o,h=e,f=s,d=u,p=(u=r,s=n,l.Ea);switch(Mi(c<h),Mi(h<=l.nc),l.hc){case 2:Dn(f,d,(h-c)*p,u,s);break;case 0:var g=c,m=h,b=u,v=s,y=(A=l).Ea;0==g&&(qn(f,d,null,null,1,b,v),B(f,d+1,0,0,y-1,b,v+1),d+=y,v+=y,++g);for(var w=1<<A.b,x=w-1,N=oe(y,A.b),L=A.K,A=A.w+(g>>A.b)*N;g<m;){var _=L,S=A,P=1;for(Rn(f,d,b,v-y,1,b,v);P<y;){var k=(P&~x)+w;y<k&&(k=y),(0,Vn[_[S++]>>8&15])(f,d+ +P,b,v+P-y,k-P,b,v+P),P=k}d+=y,v+=y,++g&x||(A+=N)}h!=l.nc&&qi(u,s-p,u,s+(h-c-1)*p,p);break;case 1:for(p=f,m=d,y=(f=l.Ea)-(v=f&~(b=(d=1<<l.b)-1)),g=oe(f,l.b),w=l.K,l=l.w+(c>>l.b)*g;c<h;){for(x=w,N=l,L=new j,A=m+v,_=m+f;m<A;)O(x[N++],L),Gn(L,p,m,d,u,s),m+=d,s+=d;m<_&&(O(x[N++],L),Gn(L,p,m,y,u,s),m+=y,s+=y),++c&b||(l+=g)}break;case 3:if(f==u&&d==s&&0<l.b){for(f=p=s+(h-c)*p-(v=(h-c)*oe(l.Ea,l.b)),d=m=u,b=s,g=[],v=(y=v)-1;0<=v;--v)g[v]=d[b+v];for(v=y-1;0<=v;--v)m[f+v]=g[v];Un(l,c,h,u,p,u,s)}else Un(l,c,h,f,d,u,s)}s=r,u=n}u!=n&&qi(r,n,s,u,a)}function it(t,e){var n=t.V,r=t.Ba+t.c*t.C,i=e-t.C;if(Mi(e<=t.l.o),Mi(i<=16),0<i){var a=t.l,o=t.Ta,s=t.Ua,u=a.width;if(rt(t,i,n,r),i=s=[s],Mi((n=t.C)<(r=e)),Mi(a.v<a.va),r>a.o&&(r=a.o),n<a.j){var l=a.j-n;n=a.j;i[0]+=l*u}if(n=r<=n?0:(i[0]+=4*a.v,a.ka=n-a.j,a.U=a.va-a.v,a.T=r-n,1)){if(s=s[0],(n=t.ca).S<11){var c=n.f.RGBA,h=(r=n.S,i=a.U,a=a.T,l=c.eb,c.A),f=a;for(c=c.fb+t.Ma*c.A;0<f--;){var d=o,p=s,g=i,m=l,b=c;switch(r){case Fr:Yn(d,p,g,m,b);break;case Cr:Jn(d,p,g,m,b);break;case Mr:Jn(d,p,g,m,b),mr(m,b,0,g,1,0);break;case Ir:Zn(d,p,g,m,b);break;case jr:q(d,p,g,m,b,1);break;case Tr:q(d,p,g,m,b,1),mr(m,b,0,g,1,0);break;case Br:q(d,p,g,m,b,0);break;case qr:q(d,p,g,m,b,0),mr(m,b,1,g,1,0);break;case Or:Xn(d,p,g,m,b);break;case Rr:Xn(d,p,g,m,b),br(m,b,g,1,0);break;case Er:Kn(d,p,g,m,b);break;default:Mi(0)}s+=u,c+=h}t.Ma+=a}else alert("todo:EmitRescaledRowsYUVA");Mi(t.Ma<=n.height)}}t.C=e,Mi(t.C<=t.i)}function at(t){var e;if(0<t.ua)return 0;for(e=0;e<t.Wb;++e){var n=t.Ya[e].G,r=t.Ya[e].H;if(0<n[1][r[1]+0].g||0<n[2][r[2]+0].g||0<n[3][r[3]+0].g)return 0}return 1}function ot(t,e,n,r,i,a){if(0!=t.Z){var o=t.qd,s=t.rd;for(Mi(null!=li[t.Z]);e<n;++e)li[t.Z](o,s,r,i,r,i,a),o=r,s=i,i+=a;t.qd=o,t.rd=s}}function st(t,e){var n=t.l.ma,r=0==n.Z||1==n.Z?t.l.j:t.C;r=t.C<r?r:t.C;if(Mi(e<=t.l.o),r<e){var i=t.l.width,a=n.ca,o=n.tb+i*r,s=t.V,u=t.Ba+t.c*r,l=t.gc;Mi(1==t.ab),Mi(3==l[0].hc),Hn(l[0],r,e,s,u,a,o),ot(n,r,e,a,o,i)}t.C=t.Ma=e}function le(t,e,n,r,i,a,o){var s=t.$/r,u=t.$%r,l=t.m,c=t.s,h=n+t.$,f=h;i=n+r*i;var d=n+r*a,p=280+c.ua,g=t.Pb?s:16777216,m=0<c.ua?c.Wa:null,b=c.wc,v=h<d?nt(c,u,s):null;Mi(t.C<a),Mi(d<=i);var y=!1;t:for(;;){for(;y||h<d;){var w=0;if(g<=s){var x=h-n;Mi((g=t).Pb),g.wd=g.m,g.xd=x,0<g.s.ua&&_(g.s.Wa,g.s.vb),g=s+Yr}if(u&b||(v=nt(c,u,s)),Mi(null!=v),v.Qb&&(e[h]=v.qb,y=!0),!y)if(ie(l),v.jc){w=l,x=e;var N=h,L=v.pd[ne(w)&jn-1];Mi(v.jc),0==(w=L.g<256?(re(w,w.u+L.g),x[N]=L.value,0):(re(w,w.u+L.g-256),Mi(256<=L.value),L.value))&&(y=!0)}else w=et(v.G[0],v.H[0],l);if(l.h)break;if(y||w<256){if(!y)if(v.nd)e[h]=(v.qb|w<<8)>>>0;else{if(ie(l),y=et(v.G[1],v.H[1],l),ie(l),x=et(v.G[2],v.H[2],l),N=et(v.G[3],v.H[3],l),l.h)break;e[h]=(N<<24|y<<16|w<<8|x)>>>0}if(y=!1,++h,r<=++u&&(u=0,++s,null!=o&&s<=a&&!(s%16)&&o(t,s),null!=m))for(;f<h;)w=e[f++],m.X[(506832829*w&4294967295)>>>m.Mb]=w}else if(w<280){if(w=Q(w-256,l),x=et(v.G[4],v.H[4],l),ie(l),x=tt(r,x=Q(x,l)),l.h)break;if(h-n<x||i-h<w)break t;for(N=0;N<w;++N)e[h+N]=e[h+N-x];for(h+=w,u+=w;r<=u;)u-=r,++s,null!=o&&s<=a&&!(s%16)&&o(t,s);if(Mi(h<=i),u&b&&(v=nt(c,u,s)),null!=m)for(;f<h;)w=e[f++],m.X[(506832829*w&4294967295)>>>m.Mb]=w}else{if(!(w<p))break t;for(y=w-280,Mi(null!=m);f<h;)w=e[f++],m.X[(506832829*w&4294967295)>>>m.Mb]=w;w=h,Mi(!(y>>>(x=m).Xa)),e[w]=x.X[y],y=!0}y||Mi(l.h==A(l))}if(t.Pb&&l.h&&h<i)Mi(t.m.h),t.a=5,t.m=t.wd,t.$=t.xd,0<t.s.ua&&_(t.s.vb,t.s.Wa);else{if(l.h)break t;null!=o&&o(t,a<s?a:s),t.a=0,t.$=h-n}return 1}return t.a=3,0}function ce(t){Mi(null!=t),t.vc=null,t.yc=null,t.Ya=null;var e=t.Wa;null!=e&&(e.X=null),Mi((t.vb=null)!=t)}function ut(){var t=new Qe;return null==t?null:(t.a=0,t.xb=ui,R("Predictor","VP8LPredictors"),R("Predictor","VP8LPredictors_C"),R("PredictorAdd","VP8LPredictorsAdd"),R("PredictorAdd","VP8LPredictorsAdd_C"),Dn=h,Gn=f,Yn=L,Jn=S,Xn=P,Kn=E,Zn=M,m.VP8LMapColor32b=zn,m.VP8LMapColor8b=Wn,t)}function he(t,e,n,r,i){var a=1,o=[t],s=[e],u=r.m,l=r.s,c=null,h=0;t:for(;;){if(n)for(;a&&ee(u,1);){var f=o,d=s,p=r,g=1,m=p.m,b=p.gc[p.ab],v=ee(m,2);if(p.Oc&1<<v)a=0;else{switch(p.Oc|=1<<v,b.hc=v,b.Ea=f[0],b.nc=d[0],b.K=[null],++p.ab,Mi(p.ab<=4),v){case 0:case 1:b.b=ee(m,3)+2,g=he(oe(b.Ea,b.b),oe(b.nc,b.b),0,p,b.K),b.K=b.K[0];break;case 3:var y,w=ee(m,8)+1,x=16<w?0:4<w?1:2<w?2:3;if(f[0]=oe(b.Ea,x),b.b=x,y=g=he(w,1,0,p,b.K)){var N,L=w,A=b,_=1<<(8>>A.b),S=Di(_);if(null==S)y=0;else{var P=A.K[0],k=A.w;for(S[0]=A.K[0][0],N=1;N<1*L;++N)S[N]=se(P[k+N],S[N-1]);for(;N<4*_;++N)S[N]=0;A.K[0]=null,A.K[0]=S,y=1}}g=y;break;case 2:break;default:Mi(0)}a=g}}if(o=o[0],s=s[0],a&&ee(u,1)&&!(a=1<=(h=ee(u,4))&&h<=11)){r.a=3;break t}var F;if(F=a)e:{var C,I,j,B=r,O=o,E=s,M=h,T=n,q=B.m,R=B.s,D=[null],U=1,z=0,H=Gr[M];n:for(;;){if(T&&ee(q,1)){var W=ee(q,3)+2,V=oe(O,W),G=oe(E,W),Y=V*G;if(!he(V,G,0,B,D))break n;for(D=D[0],R.xc=W,C=0;C<Y;++C){var J=D[C]>>8&65535;U<=(D[C]=J)&&(U=1+J)}}if(q.h)break n;for(I=0;I<5;++I){var X=zr[I];!I&&0<M&&(X+=1<<M),z<X&&(z=X)}var K=Ui(U*H,Qt),Z=U,$=Ui(Z,te);if(null==$)var Q=null;else Mi(Z<=65536),Q=$;var tt=Di(z);if(null==Q||null==tt||null==K){B.a=1;break n}var et=K;for(C=j=0;C<U;++C){var nt=Q[C],rt=nt.G,it=nt.H,at=0,ot=1,st=0;for(I=0;I<5;++I){X=zr[I],!I&&0<M&&(X+=1<<M);r:{var ut,lt=X,ct=B,ht=tt,ft=rt[I]=et,dt=it[I]=j,pt=0,gt=ct.m,mt=ee(gt,1);if(Ri(ht,0,0,lt),mt){var bt=ee(gt,1)+1,vt=ee(gt,0==ee(gt,1)?1:8);ht[vt]=1,2==bt&&(ht[vt=ee(gt,8)]=1);var yt=1}else{var wt=Di(19),xt=ee(gt,4)+4;if(19<xt){ct.a=3;var Nt=0;break r}for(ut=0;ut<xt;++ut)wt[Wr[ut]]=ee(gt,3);var Lt=void 0,At=void 0,_t=ct,St=wt,Pt=lt,kt=ht,Ft=0,Ct=_t.m,It=8,jt=Ui(128,Qt);i:for(;$t(jt,0,7,St,19);){if(ee(Ct,1)){if(Pt<(Lt=2+ee(Ct,2+2*ee(Ct,3))))break i}else Lt=Pt;for(At=0;At<Pt&&Lt--;){ie(Ct);var Bt=jt[0+(127&ne(Ct))];re(Ct,Ct.u+Bt.g);var Ot=Bt.value;if(Ot<16)0!=(kt[At++]=Ot)&&(It=Ot);else{var Et=16==Ot,Mt=Ot-16,Tt=Ur[Mt],qt=ee(Ct,Dr[Mt])+Tt;if(Pt<At+qt)break i;for(var Rt=Et?It:0;0<qt--;)kt[At++]=Rt}}Ft=1;break i}Ft||(_t.a=3),yt=Ft}(yt=yt&&!gt.h)&&(pt=$t(ft,dt,8,ht,lt)),Nt=yt&&0!=pt?pt:(ct.a=3,0)}if(0==Nt)break n;if(ot&&1==Hr[I]&&(ot=0==et[j].g),at+=et[j].g,j+=Nt,I<=3){var Dt,Ut=tt[0];for(Dt=1;Dt<X;++Dt)tt[Dt]>Ut&&(Ut=tt[Dt]);st+=Ut}}if(nt.nd=ot,nt.Qb=0,ot&&(nt.qb=(rt[3][it[3]+0].value<<24|rt[1][it[1]+0].value<<16|rt[2][it[2]+0].value)>>>0,0==at&&rt[0][it[0]+0].value<256&&(nt.Qb=1,nt.qb+=rt[0][it[0]+0].value<<8)),nt.jc=!nt.Qb&&st<6,nt.jc){var zt,Ht=nt;for(zt=0;zt<jn;++zt){var Wt=zt,Vt=Ht.pd[Wt],Gt=Ht.G[0][Ht.H[0]+Wt];256<=Gt.value?(Vt.g=Gt.g+256,Vt.value=Gt.value):(Vt.g=0,Vt.value=0,Wt>>=ue(Gt,8,Vt),Wt>>=ue(Ht.G[1][Ht.H[1]+Wt],16,Vt),Wt>>=ue(Ht.G[2][Ht.H[2]+Wt],0,Vt),ue(Ht.G[3][Ht.H[3]+Wt],24,Vt))}}}R.vc=D,R.Wb=U,R.Ya=Q,R.yc=K,F=1;break e}F=0}if(!(a=F)){r.a=3;break t}if(0<h){if(l.ua=1<<h,!ae(l.Wa,h)){r.a=1,a=0;break t}}else l.ua=0;var Yt=r,Jt=o,Xt=s,Kt=Yt.s,Zt=Kt.xc;if(Yt.c=Jt,Yt.i=Xt,Kt.md=oe(Jt,Zt),Kt.wc=0==Zt?-1:(1<<Zt)-1,n){r.xb=si;break t}if(null==(c=Di(o*s))){r.a=1,a=0;break t}a=(a=le(r,c,0,o,s,s,null))&&!u.h;break t}return a?(null!=i?i[0]=c:(Mi(null==c),Mi(n)),r.$=0,n||ce(l)):ce(l),a}function lt(t,e){var n=t.c*t.i,r=n+e+16*e;return Mi(t.c<=e),t.V=Di(r),null==t.V?(t.Ta=null,t.Ua=0,t.a=1,0):(t.Ta=t.V,t.Ua=t.Ba+n+e,1)}function ct(t,e){var n=t.C,r=e-n,i=t.V,a=t.Ba+t.c*n;for(Mi(e<=t.l.o);0<r;){var o=16<r?16:r,s=t.l.ma,u=t.l.width,l=u*o,c=s.ca,h=s.tb+u*n,f=t.Ta,d=t.Ua;rt(t,o,i,a),yr(f,d,c,h,l),ot(s,n,n+o,c,h,u),r-=o,i+=o*t.c,n+=o}Mi(n==e),t.C=t.Ma=e}function ht(){this.ub=this.yd=this.td=this.Rb=0}function ft(){this.Kd=this.Ld=this.Ud=this.Td=this.i=this.c=0}function dt(){this.Fb=this.Bb=this.Cb=0,this.Zb=Di(4),this.Lb=Di(4)}function pt(){this.Yb=function(){var t=[];return function t(e,n,r){for(var i=r[n],a=0;a<i&&(e.push(r.length>n+1?[]:0),!(r.length<n+1));a++)t(e[a],n+1,r)}(t,0,[3,11]),t}()}function gt(){this.jb=Di(3),this.Wc=zi([4,8],pt),this.Xc=zi([4,17],pt)}function mt(){this.Pc=this.wb=this.Tb=this.zd=0,this.vd=new Di(4),this.od=new Di(4)}function bt(){this.ld=this.La=this.dd=this.tc=0}function vt(){this.Na=this.la=0}function yt(){this.Sc=[0,0],this.Eb=[0,0],this.Qc=[0,0],this.ia=this.lc=0}function wt(){this.ad=Di(384),this.Za=0,this.Ob=Di(16),this.$b=this.Ad=this.ia=this.Gc=this.Hc=this.Dd=0}function xt(){this.uc=this.M=this.Nb=0,this.wa=Array(new bt),this.Y=0,this.ya=Array(new wt),this.aa=0,this.l=new _t}function Nt(){this.y=Di(16),this.f=Di(8),this.ea=Di(8)}function Lt(){this.cb=this.a=0,this.sc="",this.m=new e,this.Od=new ht,this.Kc=new ft,this.ed=new mt,this.Qa=new dt,this.Ic=this.$c=this.Aa=0,this.D=new xt,this.Xb=this.Va=this.Hb=this.zb=this.yb=this.Ub=this.za=0,this.Jc=Ui(8,e),this.ia=0,this.pb=Ui(4,yt),this.Pa=new gt,this.Bd=this.kc=0,this.Ac=[],this.Bc=0,this.zc=[0,0,0,0],this.Gd=Array(new Nt),this.Hd=0,this.rb=Array(new vt),this.sb=0,this.wa=Array(new bt),this.Y=0,this.oc=[],this.pc=0,this.sa=[],this.ta=0,this.qa=[],this.ra=0,this.Ha=[],this.B=this.R=this.Ia=0,this.Ec=[],this.M=this.ja=this.Vb=this.Fc=0,this.ya=Array(new wt),this.L=this.aa=0,this.gd=zi([4,2],bt),this.ga=null,this.Fa=[],this.Cc=this.qc=this.P=0,this.Gb=[],this.Uc=0,this.mb=[],this.nb=0,this.rc=[],this.Ga=this.Vc=0}function At(t,e){return t<0?0:e<t?e:t}function _t(){this.T=this.U=this.ka=this.height=this.width=0,this.y=[],this.f=[],this.ea=[],this.Rc=this.fa=this.W=this.N=this.O=0,this.ma="void",this.put="VP8IoPutHook",this.ac="VP8IoSetupHook",this.bc="VP8IoTeardownHook",this.ha=this.Kb=0,this.data=[],this.hb=this.ib=this.da=this.o=this.j=this.va=this.v=this.Da=this.ob=this.w=0,this.F=[],this.J=0}function St(){var t=new Lt;return null!=t&&(t.a=0,t.sc="OK",t.cb=0,t.Xb=0,Kr||(Kr=Ct)),t}function Pt(t,e,n){return 0==t.a&&(t.a=e,t.sc=n,t.cb=0),0}function kt(t,e,n){return 3<=n&&157==t[e+0]&&1==t[e+1]&&42==t[e+2]}function Ft(t,e){if(null==t)return 0;if(t.a=0,t.sc="OK",null==e)return Pt(t,2,"null VP8Io passed to VP8GetHeaders()");var n=e.data,r=e.w,i=e.ha;if(i<4)return Pt(t,7,"Truncated header.");var a=n[r+0]|n[r+1]<<8|n[r+2]<<16,o=t.Od;if(o.Rb=!(1&a),o.td=a>>1&7,o.yd=a>>4&1,o.ub=a>>5,3<o.td)return Pt(t,3,"Incorrect keyframe parameters.");if(!o.yd)return Pt(t,4,"Frame not displayable.");r+=3,i-=3;var s=t.Kc;if(o.Rb){if(i<7)return Pt(t,7,"cannot parse picture header");if(!kt(n,r,i))return Pt(t,3,"Bad code word");s.c=16383&(n[r+4]<<8|n[r+3]),s.Td=n[r+4]>>6,s.i=16383&(n[r+6]<<8|n[r+5]),s.Ud=n[r+6]>>6,r+=7,i-=7,t.za=s.c+15>>4,t.Ub=s.i+15>>4,e.width=s.c,e.height=s.i,e.Da=0,e.j=0,e.v=0,e.va=e.width,e.o=e.height,e.da=0,e.ib=e.width,e.hb=e.height,e.U=e.width,e.T=e.height,Ri((a=t.Pa).jb,0,255,a.jb.length),Mi(null!=(a=t.Qa)),a.Cb=0,a.Bb=0,a.Fb=1,Ri(a.Zb,0,0,a.Zb.length),Ri(a.Lb,0,0,a.Lb)}if(o.ub>i)return Pt(t,7,"bad partition length");p(a=t.m,n,r,o.ub),r+=o.ub,i-=o.ub,o.Rb&&(s.Ld=x(a),s.Kd=x(a)),s=t.Qa;var u,l=t.Pa;if(Mi(null!=a),Mi(null!=s),s.Cb=x(a),s.Cb){if(s.Bb=x(a),x(a)){for(s.Fb=x(a),u=0;u<4;++u)s.Zb[u]=x(a)?b(a,7):0;for(u=0;u<4;++u)s.Lb[u]=x(a)?b(a,6):0}if(s.Bb)for(u=0;u<3;++u)l.jb[u]=x(a)?g(a,8):255}else s.Bb=0;if(a.Ka)return Pt(t,3,"cannot parse segment header");if((s=t.ed).zd=x(a),s.Tb=g(a,6),s.wb=g(a,3),s.Pc=x(a),s.Pc&&x(a)){for(l=0;l<4;++l)x(a)&&(s.vd[l]=b(a,6));for(l=0;l<4;++l)x(a)&&(s.od[l]=b(a,6))}if(t.L=0==s.Tb?0:s.zd?1:2,a.Ka)return Pt(t,3,"cannot parse filter header");var c=i;if(r=(i=u=r)+c,s=c,t.Xb=(1<<g(t.m,2))-1,c<3*(l=t.Xb))n=7;else{for(u+=3*l,s-=3*l,c=0;c<l;++c){var h=n[i+0]|n[i+1]<<8|n[i+2]<<16;s<h&&(h=s),p(t.Jc[+c],n,u,h),u+=h,s-=h,i+=3}p(t.Jc[+l],n,u,s),n=u<r?0:5}if(0!=n)return Pt(t,n,"cannot parse partitions");for(n=g(u=t.m,7),i=x(u)?b(u,4):0,r=x(u)?b(u,4):0,s=x(u)?b(u,4):0,l=x(u)?b(u,4):0,u=x(u)?b(u,4):0,c=t.Qa,h=0;h<4;++h){if(c.Cb){var f=c.Zb[h];c.Fb||(f+=n)}else{if(0<h){t.pb[h]=t.pb[0];continue}f=n}var d=t.pb[h];d.Sc[0]=Jr[At(f+i,127)],d.Sc[1]=Xr[At(f+0,127)],d.Eb[0]=2*Jr[At(f+r,127)],d.Eb[1]=101581*Xr[At(f+s,127)]>>16,d.Eb[1]<8&&(d.Eb[1]=8),d.Qc[0]=Jr[At(f+l,117)],d.Qc[1]=Xr[At(f+u,127)],d.lc=f+u}if(!o.Rb)return Pt(t,4,"Not a key frame.");for(x(a),o=t.Pa,n=0;n<4;++n){for(i=0;i<8;++i)for(r=0;r<3;++r)for(s=0;s<11;++s)l=T(a,ni[n][i][r][s])?g(a,8):ti[n][i][r][s],o.Wc[n][i].Yb[r][s]=l;for(i=0;i<17;++i)o.Xc[n][i]=o.Wc[n][ri[i]]}return t.kc=x(a),t.kc&&(t.Bd=g(a,8)),t.cb=1}function Ct(t,e,n,r,i,a,o){var s=e[i].Yb[n];for(n=0;i<16;++i){if(!T(t,s[n+0]))return i;for(;!T(t,s[n+1]);)if(s=e[++i].Yb[0],n=0,16==i)return 16;var u=e[i+1].Yb;if(T(t,s[n+2])){var l=t,c=0;if(T(l,(f=s)[(h=n)+3]))if(T(l,f[h+6])){for(s=0,h=2*(c=T(l,f[h+8]))+(f=T(l,f[h+9+c])),c=0,f=Zr[h];f[s];++s)c+=c+T(l,f[s]);c+=3+(8<<h)}else T(l,f[h+7])?(c=7+2*T(l,165),c+=T(l,145)):c=5+T(l,159);else c=T(l,f[h+4])?3+T(l,f[h+5]):2;s=u[2]}else s=u[c=1];u=o+$r[i],(l=t).b<0&&v(l);var h,f=l.b,d=(h=l.Ca>>1)-(l.I>>f)>>31;--l.b,l.Ca+=d,l.Ca|=1,l.I-=(h+1&d)<<f,a[u]=((c^d)-d)*r[(0<i)+0]}return 16}function It(t){var e=t.rb[t.sb-1];e.la=0,e.Na=0,Ri(t.zc,0,0,t.zc.length),t.ja=0}function jt(t,e){if(null==t)return 0;if(null==e)return Pt(t,2,"NULL VP8Io parameter in VP8Decode().");if(!t.cb&&!Ft(t,e))return 0;if(Mi(t.cb),null==e.ac||e.ac(e)){e.ob&&(t.L=0);var n=ji[t.L];if(2==t.L?(t.yb=0,t.zb=0):(t.yb=e.v-n>>4,t.zb=e.j-n>>4,t.yb<0&&(t.yb=0),t.zb<0&&(t.zb=0)),t.Va=e.o+15+n>>4,t.Hb=e.va+15+n>>4,t.Hb>t.za&&(t.Hb=t.za),t.Va>t.Ub&&(t.Va=t.Ub),0<t.L){var r=t.ed;for(n=0;n<4;++n){var i;if(t.Qa.Cb){var a=t.Qa.Lb[n];t.Qa.Fb||(a+=r.Tb)}else a=r.Tb;for(i=0;i<=1;++i){var o=t.gd[n][i],s=a;if(r.Pc&&(s+=r.vd[0],i&&(s+=r.od[0])),0<(s=s<0?0:63<s?63:s)){var u=s;0<r.wb&&((u=4<r.wb?u>>2:u>>1)>9-r.wb&&(u=9-r.wb)),u<1&&(u=1),o.dd=u,o.tc=2*s+u,o.ld=40<=s?2:15<=s?1:0}else o.tc=0;o.La=i}}}n=0}else Pt(t,6,"Frame setup failed"),n=t.a;if(n=0==n){if(n){(t.$c=0)<t.Aa||(t.Ic=Oi);t:{n=t.Ic;r=4*(u=t.za);var l=32*u,c=u+1,h=0<t.L?u*(0<t.Aa?2:1):0,f=(2==t.Aa?2:1)*u;if((o=r+832+(i=3*(16*n+ji[t.L])/2*l)+(a=null!=t.Fa&&0<t.Fa.length?t.Kc.c*t.Kc.i:0))!=o)n=0;else{if(o>t.Vb){if(t.Vb=0,t.Ec=Di(o),t.Fc=0,null==t.Ec){n=Pt(t,1,"no memory during frame initialization.");break t}t.Vb=o}o=t.Ec,s=t.Fc,t.Ac=o,t.Bc=s,s+=r,t.Gd=Ui(l,Nt),t.Hd=0,t.rb=Ui(c+1,vt),t.sb=1,t.wa=h?Ui(h,bt):null,t.Y=0,t.D.Nb=0,t.D.wa=t.wa,t.D.Y=t.Y,0<t.Aa&&(t.D.Y+=u),Mi(!0),t.oc=o,t.pc=s,s+=832,t.ya=Ui(f,wt),t.aa=0,t.D.ya=t.ya,t.D.aa=t.aa,2==t.Aa&&(t.D.aa+=u),t.R=16*u,t.B=8*u,u=(l=ji[t.L])*t.R,l=l/2*t.B,t.sa=o,t.ta=s+u,t.qa=t.sa,t.ra=t.ta+16*n*t.R+l,t.Ha=t.qa,t.Ia=t.ra+8*n*t.B+l,t.$c=0,s+=i,t.mb=a?o:null,t.nb=a?s:null,Mi(s+a<=t.Fc+t.Vb),It(t),Ri(t.Ac,t.Bc,0,r),n=1}}if(n){if(e.ka=0,e.y=t.sa,e.O=t.ta,e.f=t.qa,e.N=t.ra,e.ea=t.Ha,e.Vd=t.Ia,e.fa=t.R,e.Rc=t.B,e.F=null,e.J=0,!Ar){for(n=-255;n<=255;++n)wr[255+n]=n<0?-n:n;for(n=-1020;n<=1020;++n)xr[1020+n]=n<-128?-128:127<n?127:n;for(n=-112;n<=112;++n)Nr[112+n]=n<-16?-16:15<n?15:n;for(n=-255;n<=510;++n)Lr[255+n]=n<0?0:255<n?255:n;Ar=1}$n=zt,Qn=qt,er=Rt,nr=Dt,rr=Ut,tr=Tt,ir=Ue,ar=ze,or=Ve,sr=Ge,ur=He,lr=We,cr=Ye,hr=Je,fr=Ee,dr=Me,pr=Te,gr=qe,ai[0]=be,ai[1]=Wt,ai[2]=ge,ai[3]=me,ai[4]=ve,ai[5]=we,ai[6]=ye,ai[7]=xe,ai[8]=Le,ai[9]=Ne,ii[0]=Kt,ii[1]=Gt,ii[2]=Yt,ii[3]=Jt,ii[4]=Zt,ii[5]=fe,ii[6]=de,oi[0]=Pe,oi[1]=Vt,oi[2]=Ae,oi[3]=_e,oi[4]=Fe,oi[5]=ke,oi[6]=Ce,n=1}else n=0}n&&(n=function(t,e){for(t.M=0;t.M<t.Va;++t.M){var n,r=t.Jc[t.M&t.Xb],i=t.m,a=t;for(n=0;n<a.za;++n){var o=i,s=a,u=s.Ac,l=s.Bc+4*n,c=s.zc,h=s.ya[s.aa+n];if(s.Qa.Bb?h.$b=T(o,s.Pa.jb[0])?2+T(o,s.Pa.jb[2]):T(o,s.Pa.jb[1]):h.$b=0,s.kc&&(h.Ad=T(o,s.Bd)),h.Za=!T(o,145)+0,h.Za){var f=h.Ob,d=0;for(s=0;s<4;++s){var p,g=c[0+s];for(p=0;p<4;++p){g=ei[u[l+p]][g];for(var m=Qr[T(o,g[0])];0<m;)m=Qr[2*m+T(o,g[m])];g=-m,u[l+p]=g}qi(f,d,u,l,4),d+=4,c[0+s]=g}}else g=T(o,156)?T(o,128)?1:3:T(o,163)?2:0,Ri(u,l,h.Ob[0]=g,4),Ri(c,0,g,4);h.Dd=T(o,142)?T(o,114)?T(o,183)?1:3:2:0}if(a.m.Ka)return Pt(t,7,"Premature end-of-partition0 encountered.");for(;t.ja<t.za;++t.ja){if(a=r,o=(i=t).rb[i.sb-1],u=i.rb[i.sb+i.ja],n=i.ya[i.aa+i.ja],l=i.kc?n.Ad:0)o.la=u.la=0,n.Za||(o.Na=u.Na=0),n.Hc=0,n.Gc=0,n.ia=0;else{var b,v;if(o=u,u=a,l=i.Pa.Xc,c=i.ya[i.aa+i.ja],h=i.pb[c.$b],s=c.ad,f=0,d=i.rb[i.sb-1],g=p=0,Ri(s,f,0,384),c.Za)var y=0,w=l[3];else{m=Di(16);var x=o.Na+d.Na;if(x=Kr(u,l[1],x,h.Eb,0,m,0),o.Na=d.Na=(0<x)+0,1<x)$n(m,0,s,f);else{var N=m[0]+3>>3;for(m=0;m<256;m+=16)s[f+m]=N}y=1,w=l[0]}var L=15&o.la,A=15&d.la;for(m=0;m<4;++m){var _=1&A;for(N=v=0;N<4;++N)L=L>>1|(_=y<(x=Kr(u,w,x=_+(1&L),h.Sc,y,s,f)))<<7,v=v<<2|(3<x?3:1<x?2:0!=s[f+0]),f+=16;L>>=4,A=A>>1|_<<7,p=(p<<8|v)>>>0}for(w=L,y=A>>4,b=0;b<4;b+=2){for(v=0,L=o.la>>4+b,A=d.la>>4+b,m=0;m<2;++m){for(_=1&A,N=0;N<2;++N)x=_+(1&L),L=L>>1|(_=0<(x=Kr(u,l[2],x,h.Qc,0,s,f)))<<3,v=v<<2|(3<x?3:1<x?2:0!=s[f+0]),f+=16;L>>=2,A=A>>1|_<<5}g|=v<<4*b,w|=L<<4<<b,y|=(240&A)<<b}o.la=w,d.la=y,c.Hc=p,c.Gc=g,c.ia=43690&g?0:h.ia,l=!(p|g)}if(0<i.L&&(i.wa[i.Y+i.ja]=i.gd[n.$b][n.Za],i.wa[i.Y+i.ja].La|=!l),a.Ka)return Pt(t,7,"Premature end-of-file encountered.")}if(It(t),i=e,a=1,n=(r=t).D,o=0<r.L&&r.M>=r.zb&&r.M<=r.Va,0==r.Aa)t:{if(n.M=r.M,n.uc=o,Pn(r,n),a=1,n=(v=r.D).Nb,o=(g=ji[r.L])*r.R,u=g/2*r.B,m=16*n*r.R,N=8*n*r.B,l=r.sa,c=r.ta-o+m,h=r.qa,s=r.ra-u+N,f=r.Ha,d=r.Ia-u+N,A=0==(L=v.M),p=L>=r.Va-1,2==r.Aa&&Pn(r,v),v.uc)for(_=(x=r).D.M,Mi(x.D.uc),v=x.yb;v<x.Hb;++v){y=v,w=_;var S=(P=(M=x).D).Nb;b=M.R;var P=P.wa[P.Y+y],k=M.sa,F=M.ta+16*S*b+16*y,C=P.dd,I=P.tc;if(0!=I)if(Mi(3<=I),1==M.L)0<y&&dr(k,F,b,I+4),P.La&&gr(k,F,b,I),0<w&&fr(k,F,b,I+4),P.La&&pr(k,F,b,I);else{var j=M.B,B=M.qa,O=M.ra+8*S*j+8*y,E=M.Ha,M=M.Ia+8*S*j+8*y;S=P.ld,0<y&&(ar(k,F,b,I+4,C,S),sr(B,O,E,M,j,I+4,C,S)),P.La&&(lr(k,F,b,I,C,S),hr(B,O,E,M,j,I,C,S)),0<w&&(ir(k,F,b,I+4,C,S),or(B,O,E,M,j,I+4,C,S)),P.La&&(ur(k,F,b,I,C,S),cr(B,O,E,M,j,I,C,S))}}if(r.ia&&alert("todo:DitherRow"),null!=i.put){if(v=16*L,L=16*(L+1),A?(i.y=r.sa,i.O=r.ta+m,i.f=r.qa,i.N=r.ra+N,i.ea=r.Ha,i.W=r.Ia+N):(v-=g,i.y=l,i.O=c,i.f=h,i.N=s,i.ea=f,i.W=d),p||(L-=g),L>i.o&&(L=i.o),i.F=null,(i.J=null)!=r.Fa&&0<r.Fa.length&&v<L&&(i.J=an(r,i,v,L-v),i.F=r.mb,null==i.F&&0==i.F.length)){a=Pt(r,3,"Could not decode alpha data.");break t}v<i.j&&(g=i.j-v,v=i.j,Mi(!(1&g)),i.O+=r.R*g,i.N+=r.B*(g>>1),i.W+=r.B*(g>>1),null!=i.F&&(i.J+=i.width*g)),v<L&&(i.O+=i.v,i.N+=i.v>>1,i.W+=i.v>>1,null!=i.F&&(i.J+=i.v),i.ka=v-i.j,i.U=i.va-i.v,i.T=L-v,a=i.put(i))}n+1!=r.Ic||p||(qi(r.sa,r.ta-o,l,c+16*r.R,o),qi(r.qa,r.ra-u,h,s+8*r.B,u),qi(r.Ha,r.Ia-u,f,d+8*r.B,u))}if(!a)return Pt(t,6,"Output aborted.")}return 1}(t,e)),null!=e.bc&&e.bc(e),n&=1}return n?(t.cb=0,n):0}function Bt(t,e,n,r,i){i=t[e+n+32*r]+(i>>3),t[e+n+32*r]=-256&i?i<0?0:255:i}function Ot(t,e,n,r,i,a){Bt(t,e,0,n,r+i),Bt(t,e,1,n,r+a),Bt(t,e,2,n,r-a),Bt(t,e,3,n,r-i)}function Et(t){return(20091*t>>16)+t}function Mt(t,e,n,r){var i,a=0,o=Di(16);for(i=0;i<4;++i){var s=t[e+0]+t[e+8],u=t[e+0]-t[e+8],l=(35468*t[e+4]>>16)-Et(t[e+12]),c=Et(t[e+4])+(35468*t[e+12]>>16);o[a+0]=s+c,o[a+1]=u+l,o[a+2]=u-l,o[a+3]=s-c,a+=4,e++}for(i=a=0;i<4;++i)s=(t=o[a+0]+4)+o[a+8],u=t-o[a+8],l=(35468*o[a+4]>>16)-Et(o[a+12]),Bt(n,r,0,0,s+(c=Et(o[a+4])+(35468*o[a+12]>>16))),Bt(n,r,1,0,u+l),Bt(n,r,2,0,u-l),Bt(n,r,3,0,s-c),a++,r+=32}function Tt(t,e,n,r){var i=t[e+0]+4,a=35468*t[e+4]>>16,o=Et(t[e+4]),s=35468*t[e+1]>>16;Ot(n,r,0,i+o,t=Et(t[e+1]),s),Ot(n,r,1,i+a,t,s),Ot(n,r,2,i-a,t,s),Ot(n,r,3,i-o,t,s)}function qt(t,e,n,r,i){Mt(t,e,n,r),i&&Mt(t,e+16,n,r+4)}function Rt(t,e,n,r){Qn(t,e+0,n,r,1),Qn(t,e+32,n,r+128,1)}function Dt(t,e,n,r){var i;for(t=t[e+0]+4,i=0;i<4;++i)for(e=0;e<4;++e)Bt(n,r,e,i,t)}function Ut(t,e,n,r){t[e+0]&&nr(t,e+0,n,r),t[e+16]&&nr(t,e+16,n,r+4),t[e+32]&&nr(t,e+32,n,r+128),t[e+48]&&nr(t,e+48,n,r+128+4)}function zt(t,e,n,r){var i,a=Di(16);for(i=0;i<4;++i){var o=t[e+0+i]+t[e+12+i],s=t[e+4+i]+t[e+8+i],u=t[e+4+i]-t[e+8+i],l=t[e+0+i]-t[e+12+i];a[0+i]=o+s,a[8+i]=o-s,a[4+i]=l+u,a[12+i]=l-u}for(i=0;i<4;++i)o=(t=a[0+4*i]+3)+a[3+4*i],s=a[1+4*i]+a[2+4*i],u=a[1+4*i]-a[2+4*i],l=t-a[3+4*i],n[r+0]=o+s>>3,n[r+16]=l+u>>3,n[r+32]=o-s>>3,n[r+48]=l-u>>3,r+=64}function Ht(t,e,n){var r,i=e-32,a=Pr,o=255-t[i-1];for(r=0;r<n;++r){var s,u=a,l=o+t[e-1];for(s=0;s<n;++s)t[e+s]=u[l+t[i+s]];e+=32}}function Wt(t,e){Ht(t,e,4)}function Vt(t,e){Ht(t,e,8)}function Gt(t,e){Ht(t,e,16)}function Yt(t,e){var n;for(n=0;n<16;++n)qi(t,e+32*n,t,e-32,16)}function Jt(t,e){var n;for(n=16;0<n;--n)Ri(t,e,t[e-1],16),e+=32}function Xt(t,e,n){var r;for(r=0;r<16;++r)Ri(e,n+32*r,t,16)}function Kt(t,e){var n,r=16;for(n=0;n<16;++n)r+=t[e-1+32*n]+t[e+n-32];Xt(r>>5,t,e)}function Zt(t,e){var n,r=8;for(n=0;n<16;++n)r+=t[e-1+32*n];Xt(r>>4,t,e)}function fe(t,e){var n,r=8;for(n=0;n<16;++n)r+=t[e+n-32];Xt(r>>4,t,e)}function de(t,e){Xt(128,t,e)}function pe(t,e,n){return t+2*e+n+2>>2}function ge(t,e){var n,r=e-32;r=new Uint8Array([pe(t[r-1],t[r+0],t[r+1]),pe(t[r+0],t[r+1],t[r+2]),pe(t[r+1],t[r+2],t[r+3]),pe(t[r+2],t[r+3],t[r+4])]);for(n=0;n<4;++n)qi(t,e+32*n,r,0,r.length)}function me(t,e){var n=t[e-1],r=t[e-1+32],i=t[e-1+64],a=t[e-1+96];o(t,e+0,16843009*pe(t[e-1-32],n,r)),o(t,e+32,16843009*pe(n,r,i)),o(t,e+64,16843009*pe(r,i,a)),o(t,e+96,16843009*pe(i,a,a))}function be(t,e){var n,r=4;for(n=0;n<4;++n)r+=t[e+n-32]+t[e-1+32*n];for(r>>=3,n=0;n<4;++n)Ri(t,e+32*n,r,4)}function ve(t,e){var n=t[e-1+0],r=t[e-1+32],i=t[e-1+64],a=t[e-1-32],o=t[e+0-32],s=t[e+1-32],u=t[e+2-32],l=t[e+3-32];t[e+0+96]=pe(r,i,t[e-1+96]),t[e+1+96]=t[e+0+64]=pe(n,r,i),t[e+2+96]=t[e+1+64]=t[e+0+32]=pe(a,n,r),t[e+3+96]=t[e+2+64]=t[e+1+32]=t[e+0+0]=pe(o,a,n),t[e+3+64]=t[e+2+32]=t[e+1+0]=pe(s,o,a),t[e+3+32]=t[e+2+0]=pe(u,s,o),t[e+3+0]=pe(l,u,s)}function ye(t,e){var n=t[e+1-32],r=t[e+2-32],i=t[e+3-32],a=t[e+4-32],o=t[e+5-32],s=t[e+6-32],u=t[e+7-32];t[e+0+0]=pe(t[e+0-32],n,r),t[e+1+0]=t[e+0+32]=pe(n,r,i),t[e+2+0]=t[e+1+32]=t[e+0+64]=pe(r,i,a),t[e+3+0]=t[e+2+32]=t[e+1+64]=t[e+0+96]=pe(i,a,o),t[e+3+32]=t[e+2+64]=t[e+1+96]=pe(a,o,s),t[e+3+64]=t[e+2+96]=pe(o,s,u),t[e+3+96]=pe(s,u,u)}function we(t,e){var n=t[e-1+0],r=t[e-1+32],i=t[e-1+64],a=t[e-1-32],o=t[e+0-32],s=t[e+1-32],u=t[e+2-32],l=t[e+3-32];t[e+0+0]=t[e+1+64]=a+o+1>>1,t[e+1+0]=t[e+2+64]=o+s+1>>1,t[e+2+0]=t[e+3+64]=s+u+1>>1,t[e+3+0]=u+l+1>>1,t[e+0+96]=pe(i,r,n),t[e+0+64]=pe(r,n,a),t[e+0+32]=t[e+1+96]=pe(n,a,o),t[e+1+32]=t[e+2+96]=pe(a,o,s),t[e+2+32]=t[e+3+96]=pe(o,s,u),t[e+3+32]=pe(s,u,l)}function xe(t,e){var n=t[e+0-32],r=t[e+1-32],i=t[e+2-32],a=t[e+3-32],o=t[e+4-32],s=t[e+5-32],u=t[e+6-32],l=t[e+7-32];t[e+0+0]=n+r+1>>1,t[e+1+0]=t[e+0+64]=r+i+1>>1,t[e+2+0]=t[e+1+64]=i+a+1>>1,t[e+3+0]=t[e+2+64]=a+o+1>>1,t[e+0+32]=pe(n,r,i),t[e+1+32]=t[e+0+96]=pe(r,i,a),t[e+2+32]=t[e+1+96]=pe(i,a,o),t[e+3+32]=t[e+2+96]=pe(a,o,s),t[e+3+64]=pe(o,s,u),t[e+3+96]=pe(s,u,l)}function Ne(t,e){var n=t[e-1+0],r=t[e-1+32],i=t[e-1+64],a=t[e-1+96];t[e+0+0]=n+r+1>>1,t[e+2+0]=t[e+0+32]=r+i+1>>1,t[e+2+32]=t[e+0+64]=i+a+1>>1,t[e+1+0]=pe(n,r,i),t[e+3+0]=t[e+1+32]=pe(r,i,a),t[e+3+32]=t[e+1+64]=pe(i,a,a),t[e+3+64]=t[e+2+64]=t[e+0+96]=t[e+1+96]=t[e+2+96]=t[e+3+96]=a}function Le(t,e){var n=t[e-1+0],r=t[e-1+32],i=t[e-1+64],a=t[e-1+96],o=t[e-1-32],s=t[e+0-32],u=t[e+1-32],l=t[e+2-32];t[e+0+0]=t[e+2+32]=n+o+1>>1,t[e+0+32]=t[e+2+64]=r+n+1>>1,t[e+0+64]=t[e+2+96]=i+r+1>>1,t[e+0+96]=a+i+1>>1,t[e+3+0]=pe(s,u,l),t[e+2+0]=pe(o,s,u),t[e+1+0]=t[e+3+32]=pe(n,o,s),t[e+1+32]=t[e+3+64]=pe(r,n,o),t[e+1+64]=t[e+3+96]=pe(i,r,n),t[e+1+96]=pe(a,i,r)}function Ae(t,e){var n;for(n=0;n<8;++n)qi(t,e+32*n,t,e-32,8)}function _e(t,e){var n;for(n=0;n<8;++n)Ri(t,e,t[e-1],8),e+=32}function Se(t,e,n){var r;for(r=0;r<8;++r)Ri(e,n+32*r,t,8)}function Pe(t,e){var n,r=8;for(n=0;n<8;++n)r+=t[e+n-32]+t[e-1+32*n];Se(r>>4,t,e)}function ke(t,e){var n,r=4;for(n=0;n<8;++n)r+=t[e+n-32];Se(r>>3,t,e)}function Fe(t,e){var n,r=4;for(n=0;n<8;++n)r+=t[e-1+32*n];Se(r>>3,t,e)}function Ce(t,e){Se(128,t,e)}function Ie(t,e,n){var r=t[e-n],i=t[e+0],a=3*(i-r)+_r[1020+t[e-2*n]-t[e+n]],o=Sr[112+(a+4>>3)];t[e-n]=Pr[255+r+Sr[112+(a+3>>3)]],t[e+0]=Pr[255+i-o]}function je(t,e,n,r){var i=t[e+0],a=t[e+n];return kr[255+t[e-2*n]-t[e-n]]>r||kr[255+a-i]>r}function Be(t,e,n,r){return 4*kr[255+t[e-n]-t[e+0]]+kr[255+t[e-2*n]-t[e+n]]<=r}function Oe(t,e,n,r,i){var a=t[e-3*n],o=t[e-2*n],s=t[e-n],u=t[e+0],l=t[e+n],c=t[e+2*n],h=t[e+3*n];return 4*kr[255+s-u]+kr[255+o-l]>r?0:kr[255+t[e-4*n]-a]<=i&&kr[255+a-o]<=i&&kr[255+o-s]<=i&&kr[255+h-c]<=i&&kr[255+c-l]<=i&&kr[255+l-u]<=i}function Ee(t,e,n,r){var i=2*r+1;for(r=0;r<16;++r)Be(t,e+r,n,i)&&Ie(t,e+r,n)}function Me(t,e,n,r){var i=2*r+1;for(r=0;r<16;++r)Be(t,e+r*n,1,i)&&Ie(t,e+r*n,1)}function Te(t,e,n,r){var i;for(i=3;0<i;--i)Ee(t,e+=4*n,n,r)}function qe(t,e,n,r){var i;for(i=3;0<i;--i)Me(t,e+=4,n,r)}function Re(t,e,n,r,i,a,o,s){for(a=2*a+1;0<i--;){if(Oe(t,e,n,a,o))if(je(t,e,n,s))Ie(t,e,n);else{var u=t,l=e,c=n,h=u[l-2*c],f=u[l-c],d=u[l+0],p=u[l+c],g=u[l+2*c],m=27*(v=_r[1020+3*(d-f)+_r[1020+h-p]])+63>>7,b=18*v+63>>7,v=9*v+63>>7;u[l-3*c]=Pr[255+u[l-3*c]+v],u[l-2*c]=Pr[255+h+b],u[l-c]=Pr[255+f+m],u[l+0]=Pr[255+d-m],u[l+c]=Pr[255+p-b],u[l+2*c]=Pr[255+g-v]}e+=r}}function De(t,e,n,r,i,a,o,s){for(a=2*a+1;0<i--;){if(Oe(t,e,n,a,o))if(je(t,e,n,s))Ie(t,e,n);else{var u=t,l=e,c=n,h=u[l-c],f=u[l+0],d=u[l+c],p=Sr[112+((g=3*(f-h))+4>>3)],g=Sr[112+(g+3>>3)],m=p+1>>1;u[l-2*c]=Pr[255+u[l-2*c]+m],u[l-c]=Pr[255+h+g],u[l+0]=Pr[255+f-p],u[l+c]=Pr[255+d-m]}e+=r}}function Ue(t,e,n,r,i,a){Re(t,e,n,1,16,r,i,a)}function ze(t,e,n,r,i,a){Re(t,e,1,n,16,r,i,a)}function He(t,e,n,r,i,a){var o;for(o=3;0<o;--o)De(t,e+=4*n,n,1,16,r,i,a)}function We(t,e,n,r,i,a){var o;for(o=3;0<o;--o)De(t,e+=4,1,n,16,r,i,a)}function Ve(t,e,n,r,i,a,o,s){Re(t,e,i,1,8,a,o,s),Re(n,r,i,1,8,a,o,s)}function Ge(t,e,n,r,i,a,o,s){Re(t,e,1,i,8,a,o,s),Re(n,r,1,i,8,a,o,s)}function Ye(t,e,n,r,i,a,o,s){De(t,e+4*i,i,1,8,a,o,s),De(n,r+4*i,i,1,8,a,o,s)}function Je(t,e,n,r,i,a,o,s){De(t,e+4,1,i,8,a,o,s),De(n,r+4,1,i,8,a,o,s)}function Xe(){this.ba=new H,this.ec=[],this.cc=[],this.Mc=[],this.Dc=this.Nc=this.dc=this.fc=0,this.Oa=new V,this.memory=0,this.Ib="OutputFunc",this.Jb="OutputAlphaFunc",this.Nd="OutputRowFunc"}function Ke(){this.data=[],this.offset=this.kd=this.ha=this.w=0,this.na=[],this.xa=this.gb=this.Ja=this.Sa=this.P=0}function Ze(){this.nc=this.Ea=this.b=this.hc=0,this.K=[],this.w=0}function $e(){this.ua=0,this.Wa=new i,this.vb=new i,this.md=this.xc=this.wc=0,this.vc=[],this.Wb=0,this.Ya=new te,this.yc=new Qt}function Qe(){this.xb=this.a=0,this.l=new _t,this.ca=new H,this.V=[],this.Ba=0,this.Ta=[],this.Ua=0,this.m=new F,this.Pb=0,this.wd=new F,this.Ma=this.$=this.C=this.i=this.c=this.xd=0,this.s=new $e,this.ab=0,this.gc=Ui(4,Ze),this.Oc=0}function tn(){this.Lc=this.Z=this.$a=this.i=this.c=0,this.l=new _t,this.ic=0,this.ca=[],this.tb=0,this.qd=null,this.rd=0}function en(t,e,n,r,i,a,o){for(t=null==t?0:t[e+0],e=0;e<o;++e)i[a+e]=t+n[r+e]&255,t=i[a+e]}function nn(t,e,n,r,i,a,o){var s;if(null==t)en(null,null,n,r,i,a,o);else for(s=0;s<o;++s)i[a+s]=t[e+s]+n[r+s]&255}function rn(t,e,n,r,i,a,o){if(null==t)en(null,null,n,r,i,a,o);else{var s,u=t[e+0],l=u,c=u;for(s=0;s<o;++s)l=c+(u=t[e+s])-l,c=n[r+s]+(-256&l?l<0?0:255:l)&255,l=u,i[a+s]=c}}function an(t,e,n,r){var i=e.width,a=e.o;if(Mi(null!=t&&null!=e),n<0||r<=0||a<n+r)return null;if(!t.Cc){if(null==t.ga){var o;if(t.ga=new tn,(o=null==t.ga)||(o=e.width*e.o,Mi(0==t.Gb.length),t.Gb=Di(o),t.Uc=0,o=!(o=null==t.Gb?0:(t.mb=t.Gb,t.nb=t.Uc,t.rc=null,1))),!o){o=t.ga;var s=t.Fa,u=t.P,l=t.qc,c=t.mb,h=t.nb,f=u+1,d=l-1,p=o.l;if(Mi(null!=s&&null!=c&&null!=e),li[0]=null,li[1]=en,li[2]=nn,li[3]=rn,o.ca=c,o.tb=h,o.c=e.width,o.i=e.height,Mi(0<o.c&&0<o.i),l<=1)e=0;else if(o.$a=s[u+0]>>0&3,o.Z=s[u+0]>>2&3,o.Lc=s[u+0]>>4&3,u=s[u+0]>>6&3,o.$a<0||1<o.$a||4<=o.Z||1<o.Lc||u)e=0;else if(p.put=K,p.ac=X,p.bc=Z,p.ma=o,p.width=e.width,p.height=e.height,p.Da=e.Da,p.v=e.v,p.va=e.va,p.j=e.j,p.o=e.o,o.$a)t:{Mi(1==o.$a),e=ut();e:for(;;){if(null==e){e=0;break t}if(Mi(null!=o),(o.mc=e).c=o.c,e.i=o.i,e.l=o.l,e.l.ma=o,e.l.width=o.c,e.l.height=o.i,e.a=0,k(e.m,s,f,d),!he(o.c,o.i,1,e,null))break e;if(!(e=1==e.ab&&3==e.gc[0].hc&&at(e.s)?(o.ic=1,s=e.c*e.i,e.Ta=null,e.Ua=0,e.V=Di(s),e.Ba=0,null==e.V?(e.a=1,0):1):(o.ic=0,lt(e,o.c))))break e;e=1;break t}o.mc=null,e=0}else e=d>=o.c*o.i;o=!e}if(o)return null;1!=t.ga.Lc?t.Ga=0:r=a-n}Mi(null!=t.ga),Mi(n+r<=a);t:{if(e=(s=t.ga).c,a=s.l.o,0==s.$a){if(f=t.rc,d=t.Vc,p=t.Fa,u=t.P+1+n*e,l=t.mb,c=t.nb+n*e,Mi(u<=t.P+t.qc),0!=s.Z)for(Mi(null!=li[s.Z]),o=0;o<r;++o)li[s.Z](f,d,p,u,l,c,e),f=l,d=c,c+=e,u+=e;else for(o=0;o<r;++o)qi(l,c,p,u,e),f=l,d=c,c+=e,u+=e;t.rc=f,t.Vc=d}else{if(Mi(null!=s.mc),e=n+r,Mi(null!=(o=s.mc)),Mi(e<=o.i),o.C>=e)e=1;else if(s.ic||cn(),s.ic){s=o.V,f=o.Ba,d=o.c;var g=o.i,m=(p=1,u=o.$/d,l=o.$%d,c=o.m,h=o.s,o.$),b=d*g,v=d*e,y=h.wc,w=m<v?nt(h,l,u):null;Mi(m<=b),Mi(e<=g),Mi(at(h));e:for(;;){for(;!c.h&&m<v;){if(l&y||(w=nt(h,l,u)),Mi(null!=w),ie(c),(g=et(w.G[0],w.H[0],c))<256)s[f+m]=g,++m,d<=++l&&(l=0,++u<=e&&!(u%16)&&st(o,u));else{if(!(g<280)){p=0;break e}g=Q(g-256,c);var x,N=et(w.G[4],w.H[4],c);if(ie(c),!((N=tt(d,N=Q(N,c)))<=m&&g<=b-m)){p=0;break e}for(x=0;x<g;++x)s[f+m+x]=s[f+m+x-N];for(m+=g,l+=g;d<=l;)l-=d,++u<=e&&!(u%16)&&st(o,u);m<v&&l&y&&(w=nt(h,l,u))}Mi(c.h==A(c))}st(o,e<u?e:u);break e}!p||c.h&&m<b?(p=0,o.a=c.h?5:3):o.$=m,e=p}else e=le(o,o.V,o.Ba,o.c,o.i,e,ct);if(!e){r=0;break t}}a<=n+r&&(t.Cc=1),r=1}if(!r)return null;if(t.Cc&&(null!=(r=t.ga)&&(r.mc=null),t.ga=null,0<t.Ga))return alert("todo:WebPDequantizeLevels"),null}return t.nb+n*i}function on(t,e,n,r,i,a){for(;0<i--;){var o,s=t,u=e+(n?1:0),l=t,c=e+(n?0:3);for(o=0;o<r;++o){var h=l[c+4*o];255!=h&&(h*=32897,s[u+4*o+0]=s[u+4*o+0]*h>>23,s[u+4*o+1]=s[u+4*o+1]*h>>23,s[u+4*o+2]=s[u+4*o+2]*h>>23)}e+=a}}function sn(t,e,n,r,i){for(;0<r--;){var a;for(a=0;a<n;++a){var o=t[e+2*a+0],s=15&(l=t[e+2*a+1]),u=4369*s,l=(240&l|l>>4)*u>>16;t[e+2*a+0]=(240&o|o>>4)*u>>16&240|(15&o|o<<4)*u>>16>>4&15,t[e+2*a+1]=240&l|s}e+=i}}function un(t,e,n,r,i,a,o,s){var u,l,c=255;for(l=0;l<i;++l){for(u=0;u<r;++u){var h=t[e+u];c&=a[o+4*u]=h}e+=n,o+=s}return 255!=c}function ln(t,e,n,r,i){var a;for(a=0;a<i;++a)n[r+a]=t[e+a]>>8}function cn(){mr=on,br=sn,vr=un,yr=ln}function hn(t,S,P){m[t]=function(t,e,n,r,i,a,o,s,u,l,c,h,f,d,p,g,m){var b,v=m-1>>1,y=i[a+0]|o[s+0]<<16,w=u[l+0]|c[h+0]<<16;Mi(null!=t);var x=3*y+w+131074>>2;for(S(t[e+0],255&x,x>>16,f,d),null!=n&&(x=3*w+y+131074>>2,S(n[r+0],255&x,x>>16,p,g)),b=1;b<=v;++b){var N=i[a+b]|o[s+b]<<16,L=u[l+b]|c[h+b]<<16,A=y+N+w+L+524296,_=A+2*(N+w)>>3;x=_+y>>1,y=(A=A+2*(y+L)>>3)+N>>1,S(t[e+2*b-1],255&x,x>>16,f,d+(2*b-1)*P),S(t[e+2*b-0],255&y,y>>16,f,d+(2*b-0)*P),null!=n&&(x=A+w>>1,y=_+L>>1,S(n[r+2*b-1],255&x,x>>16,p,g+(2*b-1)*P),S(n[r+2*b+0],255&y,y>>16,p,g+(2*b+0)*P)),y=N,w=L}1&m||(x=3*y+w+131074>>2,S(t[e+m-1],255&x,x>>16,f,d+(m-1)*P),null!=n&&(x=3*w+y+131074>>2,S(n[r+m-1],255&x,x>>16,p,g+(m-1)*P)))}}function fn(){ci[Fr]=hi,ci[Cr]=di,ci[Ir]=fi,ci[jr]=pi,ci[Br]=gi,ci[Or]=mi,ci[Er]=bi,ci[Mr]=di,ci[Tr]=pi,ci[qr]=gi,ci[Rr]=mi}function dn(t){return t&~Li?t<0?0:255:t>>Ni}function pn(t,e){return dn((19077*t>>8)+(26149*e>>8)-14234)}function gn(t,e,n){return dn((19077*t>>8)-(6419*e>>8)-(13320*n>>8)+8708)}function mn(t,e){return dn((19077*t>>8)+(33050*e>>8)-17685)}function bn(t,e,n,r,i){r[i+0]=pn(t,n),r[i+1]=gn(t,e,n),r[i+2]=mn(t,e)}function vn(t,e,n,r,i){r[i+0]=mn(t,e),r[i+1]=gn(t,e,n),r[i+2]=pn(t,n)}function yn(t,e,n,r,i){var a=gn(t,e,n);e=a<<3&224|mn(t,e)>>3,r[i+0]=248&pn(t,n)|a>>5,r[i+1]=e}function wn(t,e,n,r,i){var a=240&mn(t,e)|15;r[i+0]=240&pn(t,n)|gn(t,e,n)>>4,r[i+1]=a}function xn(t,e,n,r,i){r[i+0]=255,bn(t,e,n,r,i+1)}function Nn(t,e,n,r,i){vn(t,e,n,r,i),r[i+3]=255}function Ln(t,e,n,r,i){bn(t,e,n,r,i),r[i+3]=255}function At(t,e){return t<0?0:e<t?e:t}function An(t,c,h){m[t]=function(t,e,n,r,i,a,o,s,u){for(var l=s+(-2&u)*h;s!=l;)c(t[e+0],n[r+0],i[a+0],o,s),c(t[e+1],n[r+0],i[a+0],o,s+h),e+=2,++r,++a,s+=2*h;1&u&&c(t[e+0],n[r+0],i[a+0],o,s)}}function _n(t,e,n){return 0==n?0==t?0==e?6:5:0==e?4:0:n}function Sn(t,e,n,r,i){switch(t>>>30){case 3:Qn(e,n,r,i,0);break;case 2:tr(e,n,r,i);break;case 1:nr(e,n,r,i)}}function Pn(t,e){var n,r,i=e.M,a=e.Nb,o=t.oc,s=t.pc+40,u=t.oc,l=t.pc+584,c=t.oc,h=t.pc+600;for(n=0;n<16;++n)o[s+32*n-1]=129;for(n=0;n<8;++n)u[l+32*n-1]=129,c[h+32*n-1]=129;for(0<i?o[s-1-32]=u[l-1-32]=c[h-1-32]=129:(Ri(o,s-32-1,127,21),Ri(u,l-32-1,127,9),Ri(c,h-32-1,127,9)),r=0;r<t.za;++r){var f=e.ya[e.aa+r];if(0<r){for(n=-1;n<16;++n)qi(o,s+32*n-4,o,s+32*n+12,4);for(n=-1;n<8;++n)qi(u,l+32*n-4,u,l+32*n+4,4),qi(c,h+32*n-4,c,h+32*n+4,4)}var d=t.Gd,p=t.Hd+r,g=f.ad,m=f.Hc;if(0<i&&(qi(o,s-32,d[p].y,0,16),qi(u,l-32,d[p].f,0,8),qi(c,h-32,d[p].ea,0,8)),f.Za){var b=o,v=s-32+16;for(0<i&&(r>=t.za-1?Ri(b,v,d[p].y[15],4):qi(b,v,d[p+1].y,0,4)),n=0;n<4;n++)b[v+128+n]=b[v+256+n]=b[v+384+n]=b[v+0+n];for(n=0;n<16;++n,m<<=2)b=o,v=s+Ii[n],ai[f.Ob[n]](b,v),Sn(m,g,16*+n,b,v)}else if(b=_n(r,i,f.Ob[0]),ii[b](o,s),0!=m)for(n=0;n<16;++n,m<<=2)Sn(m,g,16*+n,o,s+Ii[n]);for(n=f.Gc,b=_n(r,i,f.Dd),oi[b](u,l),oi[b](c,h),m=g,b=u,v=l,255&(f=n>>0)&&(170&f?er(m,256,b,v):rr(m,256,b,v)),f=c,m=h,255&(n>>=8)&&(170&n?er(g,320,f,m):rr(g,320,f,m)),i<t.Ub-1&&(qi(d[p].y,0,o,s+480,16),qi(d[p].f,0,u,l+224,8),qi(d[p].ea,0,c,h+224,8)),n=8*a*t.B,d=t.sa,p=t.ta+16*r+16*a*t.R,g=t.qa,f=t.ra+8*r+n,m=t.Ha,b=t.Ia+8*r+n,n=0;n<16;++n)qi(d,p+n*t.R,o,s+32*n,16);for(n=0;n<8;++n)qi(g,f+n*t.B,u,l+32*n,8),qi(m,b+n*t.B,c,h+32*n,8)}}function kn(t,e,n,r,i,a,o,s,u){var l=[0],c=[0],h=0,f=null!=u?u.kd:0,d=null!=u?u:new Ke;if(null==t||n<12)return 7;d.data=t,e=[d.w=e],n=[d.ha=n],d.gb=[d.gb];t:{var p=e,g=n,m=d.gb;if(Mi(null!=t),Mi(null!=g),Mi(null!=m),12<=g[m[0]=0]&&!Ti(t,p[0],"RIFF")){if(Ti(t,p[0]+8,"WEBP")){m=3;break t}var b=I(t,p[0]+4);if(b<12||4294967286<b){m=3;break t}if(f&&b>g[0]-8){m=7;break t}m[0]=b,p[0]+=12,g[0]-=12}m=0}if(0!=m)return m;for(b=0<d.gb[0],n=n[0];;){t:{var v=t;g=e;var y=l,w=c,x=p=[0];if((m=n)[(A=h=[h])[0]=0]<8)m=7;else{if(!Ti(v,g[0],"VP8X")){if(10!=I(v,g[0]+4)){m=3;break t}if(m[0]<18){m=7;break t}var N=I(v,g[0]+8),L=1+C(v,g[0]+12);if(2147483648<=L*(v=1+C(v,g[0]+15))){m=3;break t}null!=x&&(x[0]=N),null!=y&&(y[0]=L),null!=w&&(w[0]=v),g[0]+=18,m[0]-=18,A[0]=1}m=0}}if(h=h[0],p=p[0],0!=m)return m;if(g=!!(2&p),!b&&h)return 3;if(null!=a&&(a[0]=!!(16&p)),null!=o&&(o[0]=g),null!=s&&(s[0]=0),o=l[0],p=c[0],h&&g&&null==u){m=0;break}if(n<4){m=7;break}if(b&&h||!b&&!h&&!Ti(t,e[0],"ALPH")){n=[n],d.na=[d.na],d.P=[d.P],d.Sa=[d.Sa];t:{N=t,m=e,b=n;var A=d.gb;y=d.na,w=d.P,x=d.Sa;L=22,Mi(null!=N),Mi(null!=b),v=m[0];var _=b[0];for(Mi(null!=y),Mi(null!=x),y[0]=null,w[0]=null,x[0]=0;;){if(m[0]=v,(b[0]=_)<8){m=7;break t}var S=I(N,v+4);if(4294967286<S){m=3;break t}var P=8+S+1&-2;if(L+=P,0<A&&A<L){m=3;break t}if(!Ti(N,v,"VP8 ")||!Ti(N,v,"VP8L")){m=0;break t}if(_[0]<P){m=7;break t}Ti(N,v,"ALPH")||(y[0]=N,w[0]=v+8,x[0]=S),v+=P,_-=P}}if(n=n[0],d.na=d.na[0],d.P=d.P[0],d.Sa=d.Sa[0],0!=m)break}n=[n],d.Ja=[d.Ja],d.xa=[d.xa];t:if(A=t,m=e,b=n,y=d.gb[0],w=d.Ja,x=d.xa,N=m[0],v=!Ti(A,N,"VP8 "),L=!Ti(A,N,"VP8L"),Mi(null!=A),Mi(null!=b),Mi(null!=w),Mi(null!=x),b[0]<8)m=7;else{if(v||L){if(A=I(A,N+4),12<=y&&y-12<A){m=3;break t}if(f&&A>b[0]-8){m=7;break t}w[0]=A,m[0]+=8,b[0]-=8,x[0]=L}else x[0]=5<=b[0]&&47==A[N+0]&&!(A[N+4]>>5),w[0]=b[0];m=0}if(n=n[0],d.Ja=d.Ja[0],d.xa=d.xa[0],e=e[0],0!=m)break;if(4294967286<d.Ja)return 3;if(null==s||g||(s[0]=d.xa?2:1),o=[o],p=[p],d.xa){if(n<5){m=7;break}s=o,f=p,g=a,t=null==t||n<5?0:5<=n&&47==t[e+0]&&!(t[e+4]>>5)?(b=[0],A=[0],y=[0],k(w=new F,t,e,n),$(w,b,A,y)?(null!=s&&(s[0]=b[0]),null!=f&&(f[0]=A[0]),null!=g&&(g[0]=y[0]),1):0):0}else{if(n<10){m=7;break}s=p,t=null==t||n<10||!kt(t,e+3,n-3)?0:(f=t[e+0]|t[e+1]<<8|t[e+2]<<16,g=16383&(t[e+7]<<8|t[e+6]),t=16383&(t[e+9]<<8|t[e+8]),1&f||3<(f>>1&7)||!(f>>4&1)||f>>5>=d.Ja||!g||!t?0:(o&&(o[0]=g),s&&(s[0]=t),1))}if(!t)return 3;if(o=o[0],p=p[0],h&&(l[0]!=o||c[0]!=p))return 3;null!=u&&(u[0]=d,u.offset=e-u.w,Mi(e-u.w<4294967286),Mi(u.offset==u.ha-n));break}return 0==m||7==m&&h&&null==u?(null!=a&&(a[0]|=null!=d.na&&0<d.na.length),null!=r&&(r[0]=o),null!=i&&(i[0]=p),0):m}function Fn(t,e,n){var r=e.width,i=e.height,a=0,o=0,s=r,u=i;if(e.Da=null!=t&&0<t.Da,e.Da&&(s=t.cd,u=t.bd,a=t.v,o=t.j,n<11||(a&=-2,o&=-2),a<0||o<0||s<=0||u<=0||r<a+s||i<o+u))return 0;if(e.v=a,e.j=o,e.va=a+s,e.o=o+u,e.U=s,e.T=u,e.da=null!=t&&0<t.da,e.da){if(!N(s,u,n=[t.ib],a=[t.hb]))return 0;e.ib=n[0],e.hb=a[0]}return e.ob=null!=t&&t.ob,e.Kb=null==t||!t.Sd,e.da&&(e.ob=e.ib<3*r/4&&e.hb<3*i/4,e.Kb=0),1}function Cn(t){if(null==t)return 2;if(t.S<11){var e=t.f.RGBA;e.fb+=(t.height-1)*e.A,e.A=-e.A}else e=t.f.kb,t=t.height,e.O+=(t-1)*e.fa,e.fa=-e.fa,e.N+=(t-1>>1)*e.Ab,e.Ab=-e.Ab,e.W+=(t-1>>1)*e.Db,e.Db=-e.Db,null!=e.F&&(e.J+=(t-1)*e.lb,e.lb=-e.lb);return 0}function In(t,e,n,r){if(null==r||t<=0||e<=0)return 2;if(null!=n){if(n.Da){var i=n.cd,a=n.bd,o=-2&n.v,s=-2&n.j;if(o<0||s<0||i<=0||a<=0||t<o+i||e<s+a)return 2;t=i,e=a}if(n.da){if(!N(t,e,i=[n.ib],a=[n.hb]))return 2;t=i[0],e=a[0]}}r.width=t,r.height=e;t:{var u=r.width,l=r.height;if(t=r.S,u<=0||l<=0||!(Fr<=t&&t<13))t=2;else{if(r.Rd<=0&&null==r.sd){o=a=i=e=0;var c=(s=u*Ei[t])*l;if(t<11||(a=(l+1)/2*(e=(u+1)/2),12==t&&(o=(i=u)*l)),null==(l=Di(c+2*a+o))){t=1;break t}r.sd=l,t<11?((u=r.f.RGBA).eb=l,u.fb=0,u.A=s,u.size=c):((u=r.f.kb).y=l,u.O=0,u.fa=s,u.Fd=c,u.f=l,u.N=0+c,u.Ab=e,u.Cd=a,u.ea=l,u.W=0+c+a,u.Db=e,u.Ed=a,12==t&&(u.F=l,u.J=0+c+2*a),u.Tc=o,u.lb=i)}if(e=1,i=r.S,a=r.width,o=r.height,Fr<=i&&i<13)if(i<11)t=r.f.RGBA,e&=(s=Math.abs(t.A))*(o-1)+a<=t.size,e&=s>=a*Ei[i],e&=null!=t.eb;else{t=r.f.kb,s=(a+1)/2,c=(o+1)/2,u=Math.abs(t.fa);l=Math.abs(t.Ab);var h=Math.abs(t.Db),f=Math.abs(t.lb),d=f*(o-1)+a;e&=u*(o-1)+a<=t.Fd,e&=l*(c-1)+s<=t.Cd,e=(e&=h*(c-1)+s<=t.Ed)&a<=u&s<=l&s<=h,e&=null!=t.y,e&=null!=t.f,e&=null!=t.ea,12==i&&(e&=a<=f,e&=d<=t.Tc,e&=null!=t.F)}else e=0;t=e?0:2}}return 0!=t||null!=n&&n.fd&&(t=Cn(r)),t}var jn=64,Bn=[0,1,3,7,15,31,63,127,255,511,1023,2047,4095,8191,16383,32767,65535,131071,262143,524287,1048575,2097151,4194303,8388607,16777215],On=24,En=32,Mn=8,Tn=[0,0,1,1,2,2,2,2,3,3,3,3,3,3,3,3,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7];a("Predictor0","PredictorAdd0"),m.Predictor0=function(){return 4278190080},m.Predictor1=function(t){return t},m.Predictor2=function(t,e,n){return e[n+0]},m.Predictor3=function(t,e,n){return e[n+1]},m.Predictor4=function(t,e,n){return e[n-1]},m.Predictor5=function(t,e,n){return s(s(t,e[n+1]),e[n+0])},m.Predictor6=function(t,e,n){return s(t,e[n-1])},m.Predictor7=function(t,e,n){return s(t,e[n+0])},m.Predictor8=function(t,e,n){return s(e[n-1],e[n+0])},m.Predictor9=function(t,e,n){return s(e[n+0],e[n+1])},m.Predictor10=function(t,e,n){return s(s(t,e[n-1]),s(e[n+0],e[n+1]))},m.Predictor11=function(t,e,n){var r=e[n+0];return c(r>>24&255,t>>24&255,(e=e[n-1])>>24&255)+c(r>>16&255,t>>16&255,e>>16&255)+c(r>>8&255,t>>8&255,e>>8&255)+c(255&r,255&t,255&e)<=0?r:t},m.Predictor12=function(t,e,n){var r=e[n+0];return(u((t>>24&255)+(r>>24&255)-((e=e[n-1])>>24&255))<<24|u((t>>16&255)+(r>>16&255)-(e>>16&255))<<16|u((t>>8&255)+(r>>8&255)-(e>>8&255))<<8|u((255&t)+(255&r)-(255&e)))>>>0},m.Predictor13=function(t,e,n){var r=e[n-1];return(l((t=s(t,e[n+0]))>>24&255,r>>24&255)<<24|l(t>>16&255,r>>16&255)<<16|l(t>>8&255,r>>8&255)<<8|l(t>>0&255,r>>0&255))>>>0};var qn=m.PredictorAdd0;m.PredictorAdd1=B,a("Predictor2","PredictorAdd2"),a("Predictor3","PredictorAdd3"),a("Predictor4","PredictorAdd4"),a("Predictor5","PredictorAdd5"),a("Predictor6","PredictorAdd6"),a("Predictor7","PredictorAdd7"),a("Predictor8","PredictorAdd8"),a("Predictor9","PredictorAdd9"),a("Predictor10","PredictorAdd10"),a("Predictor11","PredictorAdd11"),a("Predictor12","PredictorAdd12"),a("Predictor13","PredictorAdd13");var Rn=m.PredictorAdd2;d("ColorIndexInverseTransform","MapARGB","32b",function(t){return t>>8&255},function(t){return t}),d("VP8LColorIndexInverseTransformAlpha","MapAlpha","8b",function(t){return t},function(t){return t>>8&255});var Dn,Un=m.ColorIndexInverseTransform,zn=m.MapARGB,Hn=m.VP8LColorIndexInverseTransformAlpha,Wn=m.MapAlpha,Vn=m.VP8LPredictorsAdd=[];Vn.length=16,(m.VP8LPredictors=[]).length=16,(m.VP8LPredictorsAdd_C=[]).length=16,(m.VP8LPredictors_C=[]).length=16;var Gn,Yn,Jn,Xn,Kn,Zn,$n,Qn,tr,er,nr,rr,ir,ar,or,sr,ur,lr,cr,hr,fr,dr,pr,gr,mr,br,vr,yr,wr=Di(511),xr=Di(2041),Nr=Di(225),Lr=Di(767),Ar=0,_r=xr,Sr=Nr,Pr=Lr,kr=wr,Fr=0,Cr=1,Ir=2,jr=3,Br=4,Or=5,Er=6,Mr=7,Tr=8,qr=9,Rr=10,Dr=[2,3,7],Ur=[3,3,11],zr=[280,256,256,256,40],Hr=[0,1,1,1,0],Wr=[17,18,0,1,2,3,4,5,16,6,7,8,9,10,11,12,13,14,15],Vr=[24,7,23,25,40,6,39,41,22,26,38,42,56,5,55,57,21,27,54,58,37,43,72,4,71,73,20,28,53,59,70,74,36,44,88,69,75,52,60,3,87,89,19,29,86,90,35,45,68,76,85,91,51,61,104,2,103,105,18,30,102,106,34,46,84,92,67,77,101,107,50,62,120,1,119,121,83,93,17,31,100,108,66,78,118,122,33,47,117,123,49,63,99,109,82,94,0,116,124,65,79,16,32,98,110,48,115,125,81,95,64,114,126,97,111,80,113,127,96,112],Gr=[2954,2956,2958,2962,2970,2986,3018,3082,3212,3468,3980,5004],Yr=8,Jr=[4,5,6,7,8,9,10,10,11,12,13,14,15,16,17,17,18,19,20,20,21,21,22,22,23,23,24,25,25,26,27,28,29,30,31,32,33,34,35,36,37,37,38,39,40,41,42,43,44,45,46,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,76,77,78,79,80,81,82,83,84,85,86,87,88,89,91,93,95,96,98,100,101,102,104,106,108,110,112,114,116,118,122,124,126,128,130,132,134,136,138,140,143,145,148,151,154,157],Xr=[4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,119,122,125,128,131,134,137,140,143,146,149,152,155,158,161,164,167,170,173,177,181,185,189,193,197,201,205,209,213,217,221,225,229,234,239,245,249,254,259,264,269,274,279,284],Kr=null,Zr=[[173,148,140,0],[176,155,140,135,0],[180,157,141,134,130,0],[254,254,243,230,196,177,153,140,133,130,129,0]],$r=[0,1,4,8,5,2,3,6,9,12,13,10,7,11,14,15],Qr=[-0,1,-1,2,-2,3,4,6,-3,5,-4,-5,-6,7,-7,8,-8,-9],ti=[[[[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128]],[[253,136,254,255,228,219,128,128,128,128,128],[189,129,242,255,227,213,255,219,128,128,128],[106,126,227,252,214,209,255,255,128,128,128]],[[1,98,248,255,236,226,255,255,128,128,128],[181,133,238,254,221,234,255,154,128,128,128],[78,134,202,247,198,180,255,219,128,128,128]],[[1,185,249,255,243,255,128,128,128,128,128],[184,150,247,255,236,224,128,128,128,128,128],[77,110,216,255,236,230,128,128,128,128,128]],[[1,101,251,255,241,255,128,128,128,128,128],[170,139,241,252,236,209,255,255,128,128,128],[37,116,196,243,228,255,255,255,128,128,128]],[[1,204,254,255,245,255,128,128,128,128,128],[207,160,250,255,238,128,128,128,128,128,128],[102,103,231,255,211,171,128,128,128,128,128]],[[1,152,252,255,240,255,128,128,128,128,128],[177,135,243,255,234,225,128,128,128,128,128],[80,129,211,255,194,224,128,128,128,128,128]],[[1,1,255,128,128,128,128,128,128,128,128],[246,1,255,128,128,128,128,128,128,128,128],[255,128,128,128,128,128,128,128,128,128,128]]],[[[198,35,237,223,193,187,162,160,145,155,62],[131,45,198,221,172,176,220,157,252,221,1],[68,47,146,208,149,167,221,162,255,223,128]],[[1,149,241,255,221,224,255,255,128,128,128],[184,141,234,253,222,220,255,199,128,128,128],[81,99,181,242,176,190,249,202,255,255,128]],[[1,129,232,253,214,197,242,196,255,255,128],[99,121,210,250,201,198,255,202,128,128,128],[23,91,163,242,170,187,247,210,255,255,128]],[[1,200,246,255,234,255,128,128,128,128,128],[109,178,241,255,231,245,255,255,128,128,128],[44,130,201,253,205,192,255,255,128,128,128]],[[1,132,239,251,219,209,255,165,128,128,128],[94,136,225,251,218,190,255,255,128,128,128],[22,100,174,245,186,161,255,199,128,128,128]],[[1,182,249,255,232,235,128,128,128,128,128],[124,143,241,255,227,234,128,128,128,128,128],[35,77,181,251,193,211,255,205,128,128,128]],[[1,157,247,255,236,231,255,255,128,128,128],[121,141,235,255,225,227,255,255,128,128,128],[45,99,188,251,195,217,255,224,128,128,128]],[[1,1,251,255,213,255,128,128,128,128,128],[203,1,248,255,255,128,128,128,128,128,128],[137,1,177,255,224,255,128,128,128,128,128]]],[[[253,9,248,251,207,208,255,192,128,128,128],[175,13,224,243,193,185,249,198,255,255,128],[73,17,171,221,161,179,236,167,255,234,128]],[[1,95,247,253,212,183,255,255,128,128,128],[239,90,244,250,211,209,255,255,128,128,128],[155,77,195,248,188,195,255,255,128,128,128]],[[1,24,239,251,218,219,255,205,128,128,128],[201,51,219,255,196,186,128,128,128,128,128],[69,46,190,239,201,218,255,228,128,128,128]],[[1,191,251,255,255,128,128,128,128,128,128],[223,165,249,255,213,255,128,128,128,128,128],[141,124,248,255,255,128,128,128,128,128,128]],[[1,16,248,255,255,128,128,128,128,128,128],[190,36,230,255,236,255,128,128,128,128,128],[149,1,255,128,128,128,128,128,128,128,128]],[[1,226,255,128,128,128,128,128,128,128,128],[247,192,255,128,128,128,128,128,128,128,128],[240,128,255,128,128,128,128,128,128,128,128]],[[1,134,252,255,255,128,128,128,128,128,128],[213,62,250,255,255,128,128,128,128,128,128],[55,93,255,128,128,128,128,128,128,128,128]],[[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128]]],[[[202,24,213,235,186,191,220,160,240,175,255],[126,38,182,232,169,184,228,174,255,187,128],[61,46,138,219,151,178,240,170,255,216,128]],[[1,112,230,250,199,191,247,159,255,255,128],[166,109,228,252,211,215,255,174,128,128,128],[39,77,162,232,172,180,245,178,255,255,128]],[[1,52,220,246,198,199,249,220,255,255,128],[124,74,191,243,183,193,250,221,255,255,128],[24,71,130,219,154,170,243,182,255,255,128]],[[1,182,225,249,219,240,255,224,128,128,128],[149,150,226,252,216,205,255,171,128,128,128],[28,108,170,242,183,194,254,223,255,255,128]],[[1,81,230,252,204,203,255,192,128,128,128],[123,102,209,247,188,196,255,233,128,128,128],[20,95,153,243,164,173,255,203,128,128,128]],[[1,222,248,255,216,213,128,128,128,128,128],[168,175,246,252,235,205,255,255,128,128,128],[47,116,215,255,211,212,255,255,128,128,128]],[[1,121,236,253,212,214,255,255,128,128,128],[141,84,213,252,201,202,255,219,128,128,128],[42,80,160,240,162,185,255,205,128,128,128]],[[1,1,255,128,128,128,128,128,128,128,128],[244,1,255,128,128,128,128,128,128,128,128],[238,1,255,128,128,128,128,128,128,128,128]]]],ei=[[[231,120,48,89,115,113,120,152,112],[152,179,64,126,170,118,46,70,95],[175,69,143,80,85,82,72,155,103],[56,58,10,171,218,189,17,13,152],[114,26,17,163,44,195,21,10,173],[121,24,80,195,26,62,44,64,85],[144,71,10,38,171,213,144,34,26],[170,46,55,19,136,160,33,206,71],[63,20,8,114,114,208,12,9,226],[81,40,11,96,182,84,29,16,36]],[[134,183,89,137,98,101,106,165,148],[72,187,100,130,157,111,32,75,80],[66,102,167,99,74,62,40,234,128],[41,53,9,178,241,141,26,8,107],[74,43,26,146,73,166,49,23,157],[65,38,105,160,51,52,31,115,128],[104,79,12,27,217,255,87,17,7],[87,68,71,44,114,51,15,186,23],[47,41,14,110,182,183,21,17,194],[66,45,25,102,197,189,23,18,22]],[[88,88,147,150,42,46,45,196,205],[43,97,183,117,85,38,35,179,61],[39,53,200,87,26,21,43,232,171],[56,34,51,104,114,102,29,93,77],[39,28,85,171,58,165,90,98,64],[34,22,116,206,23,34,43,166,73],[107,54,32,26,51,1,81,43,31],[68,25,106,22,64,171,36,225,114],[34,19,21,102,132,188,16,76,124],[62,18,78,95,85,57,50,48,51]],[[193,101,35,159,215,111,89,46,111],[60,148,31,172,219,228,21,18,111],[112,113,77,85,179,255,38,120,114],[40,42,1,196,245,209,10,25,109],[88,43,29,140,166,213,37,43,154],[61,63,30,155,67,45,68,1,209],[100,80,8,43,154,1,51,26,71],[142,78,78,16,255,128,34,197,171],[41,40,5,102,211,183,4,1,221],[51,50,17,168,209,192,23,25,82]],[[138,31,36,171,27,166,38,44,229],[67,87,58,169,82,115,26,59,179],[63,59,90,180,59,166,93,73,154],[40,40,21,116,143,209,34,39,175],[47,15,16,183,34,223,49,45,183],[46,17,33,183,6,98,15,32,183],[57,46,22,24,128,1,54,17,37],[65,32,73,115,28,128,23,128,205],[40,3,9,115,51,192,18,6,223],[87,37,9,115,59,77,64,21,47]],[[104,55,44,218,9,54,53,130,226],[64,90,70,205,40,41,23,26,57],[54,57,112,184,5,41,38,166,213],[30,34,26,133,152,116,10,32,134],[39,19,53,221,26,114,32,73,255],[31,9,65,234,2,15,1,118,73],[75,32,12,51,192,255,160,43,51],[88,31,35,67,102,85,55,186,85],[56,21,23,111,59,205,45,37,192],[55,38,70,124,73,102,1,34,98]],[[125,98,42,88,104,85,117,175,82],[95,84,53,89,128,100,113,101,45],[75,79,123,47,51,128,81,171,1],[57,17,5,71,102,57,53,41,49],[38,33,13,121,57,73,26,1,85],[41,10,67,138,77,110,90,47,114],[115,21,2,10,102,255,166,23,6],[101,29,16,10,85,128,101,196,26],[57,18,10,102,102,213,34,20,43],[117,20,15,36,163,128,68,1,26]],[[102,61,71,37,34,53,31,243,192],[69,60,71,38,73,119,28,222,37],[68,45,128,34,1,47,11,245,171],[62,17,19,70,146,85,55,62,70],[37,43,37,154,100,163,85,160,1],[63,9,92,136,28,64,32,201,85],[75,15,9,9,64,255,184,119,16],[86,6,28,5,64,255,25,248,1],[56,8,17,132,137,255,55,116,128],[58,15,20,82,135,57,26,121,40]],[[164,50,31,137,154,133,25,35,218],[51,103,44,131,131,123,31,6,158],[86,40,64,135,148,224,45,183,128],[22,26,17,131,240,154,14,1,209],[45,16,21,91,64,222,7,1,197],[56,21,39,155,60,138,23,102,213],[83,12,13,54,192,255,68,47,28],[85,26,85,85,128,128,32,146,171],[18,11,7,63,144,171,4,4,246],[35,27,10,146,174,171,12,26,128]],[[190,80,35,99,180,80,126,54,45],[85,126,47,87,176,51,41,20,32],[101,75,128,139,118,146,116,128,85],[56,41,15,176,236,85,37,9,62],[71,30,17,119,118,255,17,18,138],[101,38,60,138,55,70,43,26,142],[146,36,19,30,171,255,97,27,20],[138,45,61,62,219,1,81,188,64],[32,41,20,117,151,142,20,21,163],[112,19,12,61,195,128,48,4,24]]],ni=[[[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[176,246,255,255,255,255,255,255,255,255,255],[223,241,252,255,255,255,255,255,255,255,255],[249,253,253,255,255,255,255,255,255,255,255]],[[255,244,252,255,255,255,255,255,255,255,255],[234,254,254,255,255,255,255,255,255,255,255],[253,255,255,255,255,255,255,255,255,255,255]],[[255,246,254,255,255,255,255,255,255,255,255],[239,253,254,255,255,255,255,255,255,255,255],[254,255,254,255,255,255,255,255,255,255,255]],[[255,248,254,255,255,255,255,255,255,255,255],[251,255,254,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[251,254,254,255,255,255,255,255,255,255,255],[254,255,254,255,255,255,255,255,255,255,255]],[[255,254,253,255,254,255,255,255,255,255,255],[250,255,254,255,254,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[217,255,255,255,255,255,255,255,255,255,255],[225,252,241,253,255,255,254,255,255,255,255],[234,250,241,250,253,255,253,254,255,255,255]],[[255,254,255,255,255,255,255,255,255,255,255],[223,254,254,255,255,255,255,255,255,255,255],[238,253,254,254,255,255,255,255,255,255,255]],[[255,248,254,255,255,255,255,255,255,255,255],[249,254,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,255,255,255,255,255,255,255,255,255],[247,254,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[252,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,254,255,255,255,255,255,255,255,255],[253,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,253,255,255,255,255,255,255,255,255],[250,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[186,251,250,255,255,255,255,255,255,255,255],[234,251,244,254,255,255,255,255,255,255,255],[251,251,243,253,254,255,254,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[236,253,254,255,255,255,255,255,255,255,255],[251,253,253,254,254,255,255,255,255,255,255]],[[255,254,254,255,255,255,255,255,255,255,255],[254,254,254,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,255,255,255,255,255,255,255,255,255],[254,254,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[248,255,255,255,255,255,255,255,255,255,255],[250,254,252,254,255,255,255,255,255,255,255],[248,254,249,253,255,255,255,255,255,255,255]],[[255,253,253,255,255,255,255,255,255,255,255],[246,253,253,255,255,255,255,255,255,255,255],[252,254,251,254,254,255,255,255,255,255,255]],[[255,254,252,255,255,255,255,255,255,255,255],[248,254,253,255,255,255,255,255,255,255,255],[253,255,254,254,255,255,255,255,255,255,255]],[[255,251,254,255,255,255,255,255,255,255,255],[245,251,254,255,255,255,255,255,255,255,255],[253,253,254,255,255,255,255,255,255,255,255]],[[255,251,253,255,255,255,255,255,255,255,255],[252,253,254,255,255,255,255,255,255,255,255],[255,254,255,255,255,255,255,255,255,255,255]],[[255,252,255,255,255,255,255,255,255,255,255],[249,255,254,255,255,255,255,255,255,255,255],[255,255,254,255,255,255,255,255,255,255,255]],[[255,255,253,255,255,255,255,255,255,255,255],[250,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]]],ri=[0,1,2,3,6,4,5,6,6,6,6,6,6,6,6,7,0],ii=[],ai=[],oi=[],si=1,ui=2,li=[],ci=[];hn("UpsampleRgbLinePair",bn,3),hn("UpsampleBgrLinePair",vn,3),hn("UpsampleRgbaLinePair",Ln,4),hn("UpsampleBgraLinePair",Nn,4),hn("UpsampleArgbLinePair",xn,4),hn("UpsampleRgba4444LinePair",wn,2),hn("UpsampleRgb565LinePair",yn,2);var hi=void 0,fi=void 0,di=void 0,pi=void 0,gi=void 0,mi=void 0,bi=void 0,vi=16,yi=1<<vi-1,wi=-227,xi=482,Ni=6,Li=(256<<Ni)-1,Ai=0,_i=Di(256),Si=Di(256),Pi=Di(256),ki=Di(256),Fi=Di(xi-wi),Ci=Di(xi-wi);An("YuvToRgbRow",bn,3),An("YuvToBgrRow",vn,3),An("YuvToRgbaRow",Ln,4),An("YuvToBgraRow",Nn,4),An("YuvToArgbRow",xn,4),An("YuvToRgba4444Row",wn,2),An("YuvToRgb565Row",yn,2);var Ii=[0,4,8,12,128,132,136,140,256,260,264,268,384,388,392,396],ji=[0,2,8],Bi=[8,7,6,4,4,2,2,2,1,1,1,1],Oi=1;this.WebPDecodeRGBA=function(t,e,n,r,i){var a=Cr,o=new Xe,s=new H;(o.ba=s).S=a,s.width=[s.width],s.height=[s.height];var u=s.width,l=s.height,c=new W;if(null==c||null==t)var h=2;else Mi(null!=c),h=kn(t,e,n,c.width,c.height,c.Pd,c.Qd,c.format,null);if(u=0!=h?0:(null!=u&&(u[0]=c.width[0]),null!=l&&(l[0]=c.height[0]),1)){s.width=s.width[0],s.height=s.height[0],null!=r&&(r[0]=s.width),null!=i&&(i[0]=s.height);t:{if(r=new _t,(i=new Ke).data=t,i.w=e,i.ha=n,i.kd=1,e=[0],Mi(null!=i),0!=(t=kn(i.data,i.w,i.ha,null,null,null,e,null,i))&&7!=t||!e[0]||(t=4),0==(e=t)){if(Mi(null!=o),r.data=i.data,r.w=i.w+i.offset,r.ha=i.ha-i.offset,r.put=K,r.ac=X,r.bc=Z,r.ma=o,i.xa){if(null==(t=ut())){o=1;break t}if(function(t,e){var n=[0],r=[0],i=[0];e:for(;;){if(null==t)return 0;if(null==e)return t.a=2,0;if(t.l=e,t.a=0,k(t.m,e.data,e.w,e.ha),!$(t.m,n,r,i)){t.a=3;break e}if(t.xb=ui,e.width=n[0],e.height=r[0],!he(n[0],r[0],1,t,null))break e;return 1}return Mi(0!=t.a),0}(t,r)){if(r=0==(e=In(r.width,r.height,o.Oa,o.ba))){e:{r=t;n:for(;;){if(null==r){r=0;break e}if(Mi(null!=r.s.yc),Mi(null!=r.s.Ya),Mi(0<r.s.Wb),Mi(null!=(n=r.l)),Mi(null!=(i=n.ma)),0!=r.xb){if(r.ca=i.ba,r.tb=i.tb,Mi(null!=r.ca),!Fn(i.Oa,n,jr)){r.a=2;break n}if(!lt(r,n.width))break n;if(n.da)break n;if((n.da||D(r.ca.S))&&cn(),r.ca.S<11||(alert("todo:WebPInitConvertARGBToYUV"),null!=r.ca.f.kb.F&&cn()),r.Pb&&0<r.s.ua&&null==r.s.vb.X&&!ae(r.s.vb,r.s.Wa.Xa)){r.a=1;break n}r.xb=0}if(!le(r,r.V,r.Ba,r.c,r.i,n.o,it))break n;i.Dc=r.Ma,r=1;break e}Mi(0!=r.a),r=0}r=!r}r&&(e=t.a)}else e=t.a}else{if(null==(t=new St)){o=1;break t}if(t.Fa=i.na,t.P=i.P,t.qc=i.Sa,Ft(t,r)){if(0==(e=In(r.width,r.height,o.Oa,o.ba))){if(t.Aa=0,n=o.Oa,Mi(null!=(i=t)),null!=n){if(0<(u=(u=n.Md)<0?0:100<u?255:255*u/100)){for(l=c=0;l<4;++l)(h=i.pb[l]).lc<12&&(h.ia=u*Bi[h.lc<0?0:h.lc]>>3),c|=h.ia;c&&(alert("todo:VP8InitRandom"),i.ia=1)}i.Ga=n.Id,100<i.Ga?i.Ga=100:i.Ga<0&&(i.Ga=0)}jt(t,r)||(e=t.a)}}else e=t.a}0==e&&null!=o.Oa&&o.Oa.fd&&(e=Cn(o.ba))}o=e}a=0!=o?null:a<11?s.f.RGBA.eb:s.f.kb.y}else a=null;return a};var Ei=[3,4,3,4,4,2,2,4,4,4,2,1,1]});var e=[0],n=[0],r=[],i=new ot,a=t,o=function(t,e){var n={},r=0,i=!1,a=0,o=0;if(n.frames=[],!
/*Copyright (c) 2017 Dominik Homberger
    
    https://webpjs.appspot.com
    WebPRiffParser dominikhlbg@gmail.com
    */
function(t,e,n,r){for(var i=0;i<r;i++)if(t[e+i]!=n.charCodeAt(i))return!0;return!1}(t,e,"RIFF",4)){var s,u;for(b(t,e+=4),e+=8;e<t.length;){var l=g(t,e),c=b(t,e+=4);e+=4;var h=c+(1&c);switch(l){case"VP8 ":case"VP8L":void 0===n.frames[r]&&(n.frames[r]={}),(p=n.frames[r]).src_off=i?o:e-8,p.src_size=a+c+8,r++,i&&(i=!1,o=a=0);break;case"VP8X":(p=n.header={}).feature_flags=t[e];var f=e+4;p.canvas_width=1+m(t,f),f+=3,p.canvas_height=1+m(t,f),f+=3;break;case"ALPH":i=!0,a=h+8,o=e-8;break;case"ANIM":(p=n.header).bgcolor=b(t,e),f=e+4,p.loop_count=(s=t)[(u=f)+0]<<0|s[u+1]<<8,f+=2;break;case"ANMF":var d,p;(p=n.frames[r]={}).offset_x=2*m(t,e),e+=3,p.offset_y=2*m(t,e),e+=3,p.width=1+m(t,e),e+=3,p.height=1+m(t,e),e+=3,p.duration=m(t,e),e+=3,d=t[e++],p.dispose=1&d,p.blend=d>>1&1}"ANMF"!=l&&(e+=h)}return n}}(a,0);o.response=a,o.rgbaoutput=!0,o.dataurl=!1;var s=o.header?o.header:null,u=o.frames?o.frames:null;if(s){s.loop_counter=s.loop_count,e=s.canvas_height,n=s.canvas_width;for(var l=0;l<u.length&&0!=u[l].blend;l++);}var c=u[0],h=i.WebPDecodeRGBA(a,c.src_off,c.src_size,n,e);c.rgba=h,c.imgwidth=n[0],c.imgheight=e[0];for(var f=0;f<n[0]*e[0]*4;f++)r[f]=h[f];return this.width=n,this.height=e,this.data=r,this}ot.prototype.getData=function(){return this.data};try{exports.WebPDecoder=ot}catch(t){}
/*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */
/*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */
!function(t){var p=15,g=573,e=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];function ht(){var d=this;function u(t,e){for(var n=0;n|=1&t,t>>>=1,n<<=1,0<--e;);return n>>>1}d.build_tree=function(t){var e,n,r,i=d.dyn_tree,a=d.stat_desc.static_tree,o=d.stat_desc.elems,s=-1;for(t.heap_len=0,t.heap_max=g,e=0;e<o;e++)0!==i[2*e]?(t.heap[++t.heap_len]=s=e,t.depth[e]=0):i[2*e+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=s<2?++s:0)]=1,t.depth[r]=0,t.opt_len--,a&&(t.static_len-=a[2*r+1]);for(d.max_code=s,e=Math.floor(t.heap_len/2);1<=e;e--)t.pqdownheap(i,e);for(r=o;e=t.heap[1],t.heap[1]=t.heap[t.heap_len--],t.pqdownheap(i,1),n=t.heap[1],t.heap[--t.heap_max]=e,t.heap[--t.heap_max]=n,i[2*r]=i[2*e]+i[2*n],t.depth[r]=Math.max(t.depth[e],t.depth[n])+1,i[2*e+1]=i[2*n+1]=r,t.heap[1]=r++,t.pqdownheap(i,1),2<=t.heap_len;);t.heap[--t.heap_max]=t.heap[1],function(t){var e,n,r,i,a,o,s=d.dyn_tree,u=d.stat_desc.static_tree,l=d.stat_desc.extra_bits,c=d.stat_desc.extra_base,h=d.stat_desc.max_length,f=0;for(i=0;i<=p;i++)t.bl_count[i]=0;for(s[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<g;e++)h<(i=s[2*s[2*(n=t.heap[e])+1]+1]+1)&&(i=h,f++),s[2*n+1]=i,n>d.max_code||(t.bl_count[i]++,a=0,c<=n&&(a=l[n-c]),o=s[2*n],t.opt_len+=o*(i+a),u&&(t.static_len+=o*(u[2*n+1]+a)));if(0!==f){do{for(i=h-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[h]--,f-=2}while(0<f);for(i=h;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--e])>d.max_code||(s[2*r+1]!==i&&(t.opt_len+=(i-s[2*r+1])*s[2*r],s[2*r+1]=i),n--)}}(t),function(t,e,n){var r,i,a,o=[],s=0;for(r=1;r<=p;r++)o[r]=s=s+n[r-1]<<1;for(i=0;i<=e;i++)0!==(a=t[2*i+1])&&(t[2*i]=u(o[a]++,a))}(i,d.max_code,t.bl_count)}}function ft(t,e,n,r,i){this.static_tree=t,this.extra_bits=e,this.extra_base=n,this.elems=r,this.max_length=i}ht._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],ht.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],ht.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],ht.d_code=function(t){return t<256?e[t]:e[256+(t>>>7)]},ht.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],ht.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],ht.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],ht.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],ft.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],ft.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],ft.static_l_desc=new ft(ft.static_ltree,ht.extra_lbits,257,286,p),ft.static_d_desc=new ft(ft.static_dtree,ht.extra_dbits,0,30,p),ft.static_bl_desc=new ft(null,ht.extra_blbits,0,19,7);function n(t,e,n,r,i){this.good_length=t,this.max_lazy=e,this.nice_length=n,this.max_chain=r,this.func=i}var dt=[new n(0,0,0,0,0),new n(4,4,8,4,1),new n(4,5,16,8,1),new n(4,6,32,32,1),new n(4,4,16,16,2),new n(8,16,32,32,2),new n(8,16,128,128,2),new n(8,32,128,256,2),new n(32,128,258,1024,2),new n(32,258,258,4096,2)],pt=["need dictionary","stream end","","","stream error","data error","","buffer error","",""];function gt(t,e,n,r){var i=t[2*e],a=t[2*n];return i<a||i===a&&r[e]<=r[n]}function r(){var s,u,l,c,f,h,d,p,i,g,m,b,v,o,y,w,x,N,L,A,_,S,P,k,F,C,I,j,B,O,E,M,T,q,R,D,U,a,z,H,W,V=this,G=new ht,Y=new ht,J=new ht;function X(){var t;for(t=0;t<286;t++)E[2*t]=0;for(t=0;t<30;t++)M[2*t]=0;for(t=0;t<19;t++)T[2*t]=0;E[512]=1,V.opt_len=V.static_len=0,D=a=0}function K(t,e){var n,r,i=-1,a=t[1],o=0,s=7,u=4;for(0===a&&(s=138,u=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=a,a=t[2*(n+1)+1],++o<s&&r===a||(o<u?T[2*r]+=o:0!==r?(r!==i&&T[2*r]++,T[32]++):o<=10?T[34]++:T[36]++,i=r,u=(o=0)===a?(s=138,3):r===a?(s=6,3):(s=7,4))}function Z(t){V.pending_buf[V.pending++]=t}function $(t){Z(255&t),Z(t>>>8&255)}function Q(t,e){var n,r=e;16-r<W?($(H|=(n=t)<<W&65535),H=n>>>16-W,W+=r-16):(H|=t<<W&65535,W+=r)}function tt(t,e){var n=2*t;Q(65535&e[n],65535&e[1+n])}function et(t,e){var n,r,i=-1,a=t[1],o=0,s=7,u=4;for(0===a&&(s=138,u=3),n=0;n<=e;n++)if(r=a,a=t[2*(n+1)+1],!(++o<s&&r===a)){if(o<u)for(;tt(r,T),0!=--o;);else 0!==r?(r!==i&&(tt(r,T),o--),tt(16,T),Q(o-3,2)):o<=10?(tt(17,T),Q(o-3,3)):(tt(18,T),Q(o-11,7));i=r,u=(o=0)===a?(s=138,3):r===a?(s=6,3):(s=7,4)}}function nt(){16===W?($(H),W=H=0):8<=W&&(Z(255&H),H>>>=8,W-=8)}function rt(t,e){var n,r,i;if(V.pending_buf[U+2*D]=t>>>8&255,V.pending_buf[U+2*D+1]=255&t,V.pending_buf[q+D]=255&e,D++,0===t?E[2*e]++:(a++,t--,E[2*(ht._length_code[e]+256+1)]++,M[2*ht.d_code(t)]++),0==(8191&D)&&2<I){for(n=8*D,r=_-x,i=0;i<30;i++)n+=M[2*i]*(5+ht.extra_dbits[i]);if(n>>>=3,a<Math.floor(D/2)&&n<Math.floor(r/2))return!0}return D===R-1}function it(t,e){var n,r,i,a,o=0;if(0!==D)for(;n=V.pending_buf[U+2*o]<<8&65280|255&V.pending_buf[U+2*o+1],r=255&V.pending_buf[q+o],o++,0===n?tt(r,t):(tt((i=ht._length_code[r])+256+1,t),0!==(a=ht.extra_lbits[i])&&Q(r-=ht.base_length[i],a),tt(i=ht.d_code(--n),e),0!==(a=ht.extra_dbits[i])&&Q(n-=ht.base_dist[i],a)),o<D;);tt(256,t),z=t[513]}function at(){8<W?$(H):0<W&&Z(255&H),W=H=0}function ot(t,e,n){Q(0+(n?1:0),3),function(t,e,n){at(),z=8,n&&($(e),$(~e)),V.pending_buf.set(p.subarray(t,t+e),V.pending),V.pending+=e}(t,e,!0)}function e(t,e,n){var r,i,a=0;0<I?(G.build_tree(V),Y.build_tree(V),a=function(){var t;for(K(E,G.max_code),K(M,Y.max_code),J.build_tree(V),t=18;3<=t&&0===T[2*ht.bl_order[t]+1];t--);return V.opt_len+=3*(t+1)+5+5+4,t}(),r=V.opt_len+3+7>>>3,(i=V.static_len+3+7>>>3)<=r&&(r=i)):r=i=e+5,e+4<=r&&-1!==t?ot(t,e,n):i===r?(Q(2+(n?1:0),3),it(ft.static_ltree,ft.static_dtree)):(Q(4+(n?1:0),3),function(t,e,n){var r;for(Q(t-257,5),Q(e-1,5),Q(n-4,4),r=0;r<n;r++)Q(T[2*ht.bl_order[r]+1],3);et(E,t-1),et(M,e-1)}(G.max_code+1,Y.max_code+1,a+1),it(E,M)),X(),n&&at()}function st(t){e(0<=x?x:-1,_-x,t),x=_,s.flush_pending()}function ut(){var t,e,n,r;do{if(0===(r=i-P-_)&&0===_&&0===P)r=f;else if(-1===r)r--;else if(f+f-262<=_){for(p.set(p.subarray(f,f+f),0),S-=f,_-=f,x-=f,n=t=v;e=65535&m[--n],m[n]=f<=e?e-f:0,0!=--t;);for(n=t=f;e=65535&g[--n],g[n]=f<=e?e-f:0,0!=--t;);r+=f}if(0===s.avail_in)return;t=s.read_buf(p,_+P,r),3<=(P+=t)&&(b=((b=255&p[_])<<w^255&p[_+1])&y)}while(P<262&&0!==s.avail_in)}function lt(t){var e,n,r=F,i=_,a=k,o=f-262<_?_-(f-262):0,s=O,u=d,l=_+258,c=p[i+a-1],h=p[i+a];B<=k&&(r>>=2),P<s&&(s=P);do{if(p[(e=t)+a]===h&&p[e+a-1]===c&&p[e]===p[i]&&p[++e]===p[i+1]){i+=2,e++;do{}while(p[++i]===p[++e]&&p[++i]===p[++e]&&p[++i]===p[++e]&&p[++i]===p[++e]&&p[++i]===p[++e]&&p[++i]===p[++e]&&p[++i]===p[++e]&&p[++i]===p[++e]&&i<l);if(n=258-(l-i),i=l-258,a<n){if(S=t,s<=(a=n))break;c=p[i+a-1],h=p[i+a]}}}while((t=65535&g[t&u])>o&&0!=--r);return a<=P?a:P}function ct(t){return t.total_in=t.total_out=0,t.msg=null,V.pending=0,V.pending_out=0,u=113,c=0,G.dyn_tree=E,G.stat_desc=ft.static_l_desc,Y.dyn_tree=M,Y.stat_desc=ft.static_d_desc,J.dyn_tree=T,J.stat_desc=ft.static_bl_desc,W=H=0,z=8,X(),function(){var t;for(i=2*f,t=m[v-1]=0;t<v-1;t++)m[t]=0;C=dt[I].max_lazy,B=dt[I].good_length,O=dt[I].nice_length,F=dt[I].max_chain,N=k=2,b=A=P=x=_=0}(),0}V.depth=[],V.bl_count=[],V.heap=[],E=[],M=[],T=[],V.pqdownheap=function(t,e){for(var n=V.heap,r=n[e],i=e<<1;i<=V.heap_len&&(i<V.heap_len&&gt(t,n[i+1],n[i],V.depth)&&i++,!gt(t,r,n[i],V.depth));)n[e]=n[i],e=i,i<<=1;n[e]=r},V.deflateInit=function(t,e,n,r,i,a){return r||(r=8),i||(i=8),a||(a=0),t.msg=null,-1===e&&(e=6),i<1||9<i||8!==r||n<9||15<n||e<0||9<e||a<0||2<a?-2:(t.dstate=V,d=(f=1<<(h=n))-1,y=(v=1<<(o=i+7))-1,w=Math.floor((o+3-1)/3),p=new Uint8Array(2*f),g=[],m=[],R=1<<i+6,V.pending_buf=new Uint8Array(4*R),l=4*R,U=Math.floor(R/2),q=3*R,I=e,j=a,ct(t))},V.deflateEnd=function(){return 42!==u&&113!==u&&666!==u?-2:(V.pending_buf=null,p=g=m=null,V.dstate=null,113===u?-3:0)},V.deflateParams=function(t,e,n){var r=0;return-1===e&&(e=6),e<0||9<e||n<0||2<n?-2:(dt[I].func!==dt[e].func&&0!==t.total_in&&(r=t.deflate(1)),I!==e&&(C=dt[I=e].max_lazy,B=dt[I].good_length,O=dt[I].nice_length,F=dt[I].max_chain),j=n,r)},V.deflateSetDictionary=function(t,e,n){var r,i=n,a=0;if(!e||42!==u)return-2;if(i<3)return 0;for(f-262<i&&(a=n-(i=f-262)),p.set(e.subarray(a,a+i),0),x=_=i,b=((b=255&p[0])<<w^255&p[1])&y,r=0;r<=i-3;r++)b=(b<<w^255&p[r+2])&y,g[r&d]=m[b],m[b]=r;return 0},V.deflate=function(t,e){var n,r,i,a,o;if(4<e||e<0)return-2;if(!t.next_out||!t.next_in&&0!==t.avail_in||666===u&&4!==e)return t.msg=pt[4],-2;if(0===t.avail_out)return t.msg=pt[7],-5;if(s=t,a=c,c=e,42===u&&(r=8+(h-8<<4)<<8,3<(i=(I-1&255)>>1)&&(i=3),r|=i<<6,0!==_&&(r|=32),u=113,function(t){Z(t>>8&255),Z(255&t)}(r+=31-r%31)),0!==V.pending){if(s.flush_pending(),0===s.avail_out)return c=-1,0}else if(0===s.avail_in&&e<=a&&4!==e)return s.msg=pt[7],-5;if(666===u&&0!==s.avail_in)return t.msg=pt[7],-5;if(0!==s.avail_in||0!==P||0!==e&&666!==u){switch(o=-1,dt[I].func){case 0:o=function(t){var e,n=65535;for(l-5<n&&(n=l-5);;){if(P<=1){if(ut(),0===P&&0===t)return 0;if(0===P)break}if(_+=P,e=x+n,((P=0)===_||e<=_)&&(P=_-e,_=e,st(!1),0===s.avail_out))return 0;if(f-262<=_-x&&(st(!1),0===s.avail_out))return 0}return st(4===t),0===s.avail_out?4===t?2:0:4===t?3:1}(e);break;case 1:o=function(t){for(var e,n=0;;){if(P<262){if(ut(),P<262&&0===t)return 0;if(0===P)break}if(3<=P&&(b=(b<<w^255&p[_+2])&y,n=65535&m[b],g[_&d]=m[b],m[b]=_),0!==n&&(_-n&65535)<=f-262&&2!==j&&(N=lt(n)),3<=N)if(e=rt(_-S,N-3),P-=N,N<=C&&3<=P){for(N--;b=(b<<w^255&p[++_+2])&y,n=65535&m[b],g[_&d]=m[b],m[b]=_,0!=--N;);_++}else _+=N,N=0,b=((b=255&p[_])<<w^255&p[_+1])&y;else e=rt(0,255&p[_]),P--,_++;if(e&&(st(!1),0===s.avail_out))return 0}return st(4===t),0===s.avail_out?4===t?2:0:4===t?3:1}(e);break;case 2:o=function(t){for(var e,n,r=0;;){if(P<262){if(ut(),P<262&&0===t)return 0;if(0===P)break}if(3<=P&&(b=(b<<w^255&p[_+2])&y,r=65535&m[b],g[_&d]=m[b],m[b]=_),k=N,L=S,N=2,0!==r&&k<C&&(_-r&65535)<=f-262&&(2!==j&&(N=lt(r)),N<=5&&(1===j||3===N&&4096<_-S)&&(N=2)),3<=k&&N<=k){for(n=_+P-3,e=rt(_-1-L,k-3),P-=k-1,k-=2;++_<=n&&(b=(b<<w^255&p[_+2])&y,r=65535&m[b],g[_&d]=m[b],m[b]=_),0!=--k;);if(A=0,N=2,_++,e&&(st(!1),0===s.avail_out))return 0}else if(0!==A){if((e=rt(0,255&p[_-1]))&&st(!1),_++,P--,0===s.avail_out)return 0}else A=1,_++,P--}return 0!==A&&(e=rt(0,255&p[_-1]),A=0),st(4===t),0===s.avail_out?4===t?2:0:4===t?3:1}(e)}if(2!==o&&3!==o||(u=666),0===o||2===o)return 0===s.avail_out&&(c=-1),0;if(1===o){if(1===e)Q(2,3),tt(256,ft.static_ltree),nt(),1+z+10-W<9&&(Q(2,3),tt(256,ft.static_ltree),nt()),z=7;else if(ot(0,0,!1),3===e)for(n=0;n<v;n++)m[n]=0;if(s.flush_pending(),0===s.avail_out)return c=-1,0}}return 4!==e?0:1}}function i(){this.next_in_index=0,this.next_out_index=0,this.avail_in=0,this.total_in=0,this.avail_out=0,this.total_out=0}i.prototype={deflateInit:function(t,e){return this.dstate=new r,e||(e=p),this.dstate.deflateInit(this,t,e)},deflate:function(t){return this.dstate?this.dstate.deflate(this,t):-2},deflateEnd:function(){if(!this.dstate)return-2;var t=this.dstate.deflateEnd();return this.dstate=null,t},deflateParams:function(t,e){return this.dstate?this.dstate.deflateParams(this,t,e):-2},deflateSetDictionary:function(t,e){return this.dstate?this.dstate.deflateSetDictionary(this,t,e):-2},read_buf:function(t,e,n){var r=this.avail_in;return n<r&&(r=n),0===r?0:(this.avail_in-=r,t.set(this.next_in.subarray(this.next_in_index,this.next_in_index+r),e),this.next_in_index+=r,this.total_in+=r,r)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}};var a=t.zip||t;a.Deflater=a._jzlib_Deflater=function(t){var s=new i,u=new Uint8Array(512),e=t?t.level:-1;void 0===e&&(e=-1),s.deflateInit(e),s.next_out=u,this.append=function(t,e){var n,r=[],i=0,a=0,o=0;if(t.length){s.next_in_index=0,s.next_in=t,s.avail_in=t.length;do{if(s.next_out_index=0,s.avail_out=512,0!==s.deflate(0))throw new Error("deflating: "+s.msg);s.next_out_index&&(512===s.next_out_index?r.push(new Uint8Array(u)):r.push(new Uint8Array(u.subarray(0,s.next_out_index)))),o+=s.next_out_index,e&&0<s.next_in_index&&s.next_in_index!==i&&(e(s.next_in_index),i=s.next_in_index)}while(0<s.avail_in||0===s.avail_out);return n=new Uint8Array(o),r.forEach(function(t){n.set(t,a),a+=t.length}),n}},this.flush=function(){var t,e,n=[],r=0,i=0;do{if(s.next_out_index=0,s.avail_out=512,1!==(t=s.deflate(4))&&0!==t)throw new Error("deflating: "+s.msg);0<512-s.avail_out&&n.push(new Uint8Array(u.subarray(0,s.next_out_index))),i+=s.next_out_index}while(0<s.avail_in||0===s.avail_out);return s.deflateEnd(),e=new Uint8Array(i),n.forEach(function(t){e.set(t,r),r+=t.length}),e}}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()).RGBColor=function(t){var e;t=t||"",this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6)),t={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"}[t=(t=t.replace(/ /g,"")).toLowerCase()]||t;for(var n=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return[parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],r=0;r<n.length;r++){var i=n[r].re,a=n[r].process,o=i.exec(t);o&&(e=a(o),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0)}this.r=this.r<0||isNaN(this.r)?0:255<this.r?255:this.r,this.g=this.g<0||isNaN(this.g)?0:255<this.g?255:this.g,this.b=this.b<0||isNaN(this.b)?0:255<this.b?255:this.b,this.toRGB=function(){return"rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),n=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==n.length&&(n="0"+n),"#"+t+e+n}},function(t){function e(t){var e;if(this.rawData=t,e=this.contents=new J(t),this.contents.pos=4,"ttcf"===e.readString(4))throw new Error("TTCF not supported.");e.pos=0,this.parse(),this.subset=new R(this),this.registerTTF()}t.API.TTFFont=(e.open=function(t){return new e(t)},e.prototype.parse=function(){return this.directory=new r(this.contents),this.head=new l(this),this.name=new L(this),this.cmap=new b(this),this.toUnicode={},this.hhea=new g(this),this.maxp=new _(this),this.hmtx=new P(this),this.post=new w(this),this.os2=new v(this),this.loca=new M(this),this.glyf=new C(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},e.prototype.registerTTF=function(){var i,t,e,n,r;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.bbox).length;t<e;t++)i=n[t],r.push(Math.round(i*this.scaleFactor));return r}.call(this),this.stemV=0,this.post.exists?(e=255&(n=this.post.italic_angle),0!=(32768&(t=n>>16))&&(t=-(1+(65535^t))),this.italicAngle=+(t+"."+e)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(r=this.familyClass)||2===r||3===r||4===r||5===r||7===r,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},e.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},e.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},e.prototype.widthOfString=function(t,e,n){var r,i,a,o;for(i=a=0,o=(t=""+t).length;0<=o?i<o:o<i;i=0<=o?++i:--i)r=t.charCodeAt(i),a+=this.widthOfGlyph(this.characterToGlyph(r))+n*(1e3/e)||0;return a*(e/1e3)},e.prototype.lineHeight=function(t,e){var n;return null==e&&(e=!1),n=e?this.lineGap:0,(this.ascender+n-this.decender)/1e3*t},e);var J=(n.prototype.readByte=function(){return this.data[this.pos++]},n.prototype.writeByte=function(t){return this.data[this.pos++]=t},n.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},n.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},n.prototype.readInt32=function(){var t;return 2147483648<=(t=this.readUInt32())?t-4294967296:t},n.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},n.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},n.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},n.prototype.readInt16=function(){var t;return 32768<=(t=this.readUInt16())?t-65536:t},n.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},n.prototype.readString=function(t){var e,n;for(n=[],e=0;0<=t?e<t:t<e;e=0<=t?++e:--e)n[e]=String.fromCharCode(this.readByte());return n.join("")},n.prototype.writeString=function(t){var e,n,r;for(r=[],e=0,n=t.length;0<=n?e<n:n<e;e=0<=n?++e:--e)r.push(this.writeByte(t.charCodeAt(e)));return r},n.prototype.readShort=function(){return this.readInt16()},n.prototype.writeShort=function(t){return this.writeInt16(t)},n.prototype.readLongLong=function(){var t,e,n,r,i,a,o,s;return t=this.readByte(),e=this.readByte(),n=this.readByte(),r=this.readByte(),i=this.readByte(),a=this.readByte(),o=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^n)+4294967296*(255^r)+16777216*(255^i)+65536*(255^a)+256*(255^o)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*n+4294967296*r+16777216*i+65536*a+256*o+s},n.prototype.writeLongLong=function(t){var e,n;return e=Math.floor(t/4294967296),n=4294967295&t,this.writeByte(e>>24&255),this.writeByte(e>>16&255),this.writeByte(e>>8&255),this.writeByte(255&e),this.writeByte(n>>24&255),this.writeByte(n>>16&255),this.writeByte(n>>8&255),this.writeByte(255&n)},n.prototype.readInt=function(){return this.readInt32()},n.prototype.writeInt=function(t){return this.writeInt32(t)},n.prototype.read=function(t){var e,n;for(e=[],n=0;0<=t?n<t:t<n;n=0<=t?++n:--n)e.push(this.readByte());return e},n.prototype.write=function(t){var e,n,r,i;for(i=[],n=0,r=t.length;n<r;n++)e=t[n],i.push(this.writeByte(e));return i},n);function n(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}var p,r=(i.prototype.encode=function(t){var e,n,r,i,a,o,s,u,l,c,h,f,d;for(d in h=Object.keys(t).length,o=Math.log(2),l=16*Math.floor(Math.log(h)/o),i=Math.floor(l/o),u=16*h-l,(n=new J).writeInt(this.scalarType),n.writeShort(h),n.writeShort(l),n.writeShort(i),n.writeShort(u),r=16*h,s=n.pos+r,a=null,f=[],t)for(c=t[d],n.writeString(d),n.writeInt(p(c)),n.writeInt(s),n.writeInt(c.length),f=f.concat(c),"head"===d&&(a=s),s+=c.length;s%4;)f.push(0),s++;return n.write(f),e=2981146554-p(n.data),n.pos=a+8,n.writeUInt32(e),n.data},p=function(t){var e,n,r,i;for(t=F.call(t);t.length%4;)t.push(0);for(r=new J(t),e=n=0,i=t.length;e<i;e=e+=4)n+=r.readUInt32();return 4294967295&n},i);function i(t){var e,n,r;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},n=0,r=this.tableCount;0<=r?n<r:r<n;n=0<=r?++n:--n)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}function a(t,e){for(var n in e)s.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}return r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype,t}var o,s={}.hasOwnProperty;function u(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}u.prototype.parse=function(){},u.prototype.encode=function(){},u.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null};var l=(a(c,o=u),c.prototype.tag="head",c.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},c.prototype.encode=function(t){var e;return(e=new J).writeInt(this.version),e.writeInt(this.revision),e.writeInt(this.checkSumAdjustment),e.writeInt(this.magicNumber),e.writeShort(this.flags),e.writeShort(this.unitsPerEm),e.writeLongLong(this.created),e.writeLongLong(this.modified),e.writeShort(this.xMin),e.writeShort(this.yMin),e.writeShort(this.xMax),e.writeShort(this.yMax),e.writeShort(this.macStyle),e.writeShort(this.lowestRecPPEM),e.writeShort(this.fontDirectionHint),e.writeShort(t),e.writeShort(this.glyphDataFormat),e.data},c);function c(){return c.__super__.constructor.apply(this,arguments)}var h=(f.encode=function(t,e){var n,r,i,a,o,s,u,l,c,h,f,d,p,g,m,b,v,y,w,x,N,L,A,_,S,P,k,F,C,I,j,B,O,E,M,T,q,R,D,U,z,H,W,V,G,Y;switch(F=new J,a=Object.keys(t).sort(function(t,e){return t-e}),e){case"macroman":for(p=0,g=function(){var t=[];for(d=0;d<256;++d)t.push(0);return t}(),b={0:0},i={},C=0,O=a.length;C<O;C++)null==b[W=t[r=a[C]]]&&(b[W]=++p),i[r]={old:t[r],new:b[t[r]]},g[r]=b[t[r]];return F.writeUInt16(1),F.writeUInt16(0),F.writeUInt32(12),F.writeUInt16(0),F.writeUInt16(262),F.writeUInt16(0),F.write(g),{charMap:i,subtable:F.data,maxGlyphID:p+1};case"unicode":for(P=[],c=[],b={},n={},m=u=null,I=v=0,E=a.length;I<E;I++)null==b[w=t[r=a[I]]]&&(b[w]=++v),n[r]={old:w,new:b[w]},o=b[w]-r,null!=m&&o===u||(m&&c.push(m),P.push(r),u=o),m=r;for(m&&c.push(m),c.push(65535),P.push(65535),_=2*(A=P.length),L=2*Math.pow(Math.log(A)/Math.LN2,2),h=Math.log(L/2)/Math.LN2,N=2*A-L,s=[],x=[],f=[],d=j=0,M=P.length;j<M;d=++j){if(S=P[d],l=c[d],65535===S){s.push(0),x.push(0);break}if(32768<=S-(k=n[S].new))for(s.push(0),x.push(2*(f.length+A-d)),r=B=S;S<=l?B<=l:l<=B;r=S<=l?++B:--B)f.push(n[r].new);else s.push(k-S),x.push(0)}for(F.writeUInt16(3),F.writeUInt16(1),F.writeUInt32(12),F.writeUInt16(4),F.writeUInt16(16+8*A+2*f.length),F.writeUInt16(0),F.writeUInt16(_),F.writeUInt16(L),F.writeUInt16(h),F.writeUInt16(N),z=0,T=c.length;z<T;z++)r=c[z],F.writeUInt16(r);for(F.writeUInt16(0),H=0,q=P.length;H<q;H++)r=P[H],F.writeUInt16(r);for(V=0,R=s.length;V<R;V++)o=s[V],F.writeUInt16(o);for(G=0,D=x.length;G<D;G++)y=x[G],F.writeUInt16(y);for(Y=0,U=f.length;Y<U;Y++)p=f[Y],F.writeUInt16(p);return{charMap:n,subtable:F.data,maxGlyphID:v+1}}},f);function f(n,t){var e,r,i,a,o,s,u,l,c,h,f,d,p,g,m,b,v;switch(this.platformID=n.readUInt16(),this.encodingID=n.readShort(),this.offset=t+n.readInt(),c=n.pos,n.pos=this.offset,this.format=n.readUInt16(),this.length=n.readUInt16(),this.language=n.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=0;s<256;++s)this.codeMap[s]=n.readByte();break;case 4:for(f=n.readUInt16(),h=f/2,n.pos+=6,i=function(){var t,e;for(e=[],s=t=0;0<=h?t<h:h<t;s=0<=h?++t:--t)e.push(n.readUInt16());return e}(),n.pos+=2,p=function(){var t,e;for(e=[],s=t=0;0<=h?t<h:h<t;s=0<=h?++t:--t)e.push(n.readUInt16());return e}(),u=function(){var t,e;for(e=[],s=t=0;0<=h?t<h:h<t;s=0<=h?++t:--t)e.push(n.readUInt16());return e}(),l=function(){var t,e;for(e=[],s=t=0;0<=h?t<h:h<t;s=0<=h?++t:--t)e.push(n.readUInt16());return e}(),r=(this.length-n.pos+this.offset)/2,o=function(){var t,e;for(e=[],s=t=0;0<=r?t<r:r<t;s=0<=r?++t:--t)e.push(n.readUInt16());return e}(),s=m=0,v=i.length;m<v;s=++m)for(g=i[s],e=b=d=p[s];d<=g?b<=g:g<=b;e=d<=g?++b:--b)0===l[s]?a=e+u[s]:0!==(a=o[l[s]/2+(e-d)-(h-s)]||0)&&(a+=u[s]),this.codeMap[e]=65535&a}n.pos=c}var b=(a(d,o),d.prototype.tag="cmap",d.prototype.parse=function(t){var e,n,r;for(t.pos=this.offset,this.version=t.readUInt16(),r=t.readUInt16(),this.tables=[],this.unicode=null,n=0;0<=r?n<r:r<n;n=0<=r?++n:--n)e=new h(t,this.offset),this.tables.push(e),!e.isUnicode||null==this.unicode&&(this.unicode=e);return!0},d.encode=function(t,e){var n,r;return null==e&&(e="macroman"),n=h.encode(t,e),(r=new J).writeUInt16(0),r.writeUInt16(1),n.table=r.data.concat(n.subtable),n},d);function d(){return d.__super__.constructor.apply(this,arguments)}var g=(a(m,o),m.prototype.tag="hhea",m.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},m);function m(){return m.__super__.constructor.apply(this,arguments)}var v=(a(y,o),y.prototype.tag="OS/2",y.prototype.parse=function(n){if(n.pos=this.offset,this.version=n.readUInt16(),this.averageCharWidth=n.readShort(),this.weightClass=n.readUInt16(),this.widthClass=n.readUInt16(),this.type=n.readShort(),this.ySubscriptXSize=n.readShort(),this.ySubscriptYSize=n.readShort(),this.ySubscriptXOffset=n.readShort(),this.ySubscriptYOffset=n.readShort(),this.ySuperscriptXSize=n.readShort(),this.ySuperscriptYSize=n.readShort(),this.ySuperscriptXOffset=n.readShort(),this.ySuperscriptYOffset=n.readShort(),this.yStrikeoutSize=n.readShort(),this.yStrikeoutPosition=n.readShort(),this.familyClass=n.readShort(),this.panose=function(){var t,e;for(e=[],t=0;t<10;++t)e.push(n.readByte());return e}(),this.charRange=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(n.readInt());return e}(),this.vendorID=n.readString(4),this.selection=n.readShort(),this.firstCharIndex=n.readShort(),this.lastCharIndex=n.readShort(),0<this.version&&(this.ascent=n.readShort(),this.descent=n.readShort(),this.lineGap=n.readShort(),this.winAscent=n.readShort(),this.winDescent=n.readShort(),this.codePageRange=function(){var t,e;for(e=[],t=0;t<2;t=++t)e.push(n.readInt());return e}(),1<this.version))return this.xHeight=n.readShort(),this.capHeight=n.readShort(),this.defaultChar=n.readShort(),this.breakChar=n.readShort(),this.maxContext=n.readShort()},y);function y(){return y.__super__.constructor.apply(this,arguments)}var w=(a(x,o),x.prototype.tag="post",x.prototype.parse=function(r){var t,e,n;switch(r.pos=this.offset,this.format=r.readInt(),this.italicAngle=r.readInt(),this.underlinePosition=r.readShort(),this.underlineThickness=r.readShort(),this.isFixedPitch=r.readInt(),this.minMemType42=r.readInt(),this.maxMemType42=r.readInt(),this.minMemType1=r.readInt(),this.maxMemType1=r.readInt(),this.format){case 65536:break;case 131072:var i;for(e=r.readUInt16(),this.glyphNameIndex=[],i=0;0<=e?i<e:e<i;i=0<=e?++i:--i)this.glyphNameIndex.push(r.readUInt16());for(this.names=[],n=[];r.pos<this.offset+this.length;)t=r.readByte(),n.push(this.names.push(r.readString(t)));return n;case 151552:return e=r.readUInt16(),this.offsets=r.read(e);case 196608:break;case 262144:return this.map=function(){var t,e,n;for(n=[],i=t=0,e=this.file.maxp.numGlyphs;0<=e?t<e:e<t;i=0<=e?++t:--t)n.push(r.readUInt32());return n}.call(this)}},x);
/* comment : Store copyright information, platformID, encodingID, and languageID in the NameEntry object.*/function x(){return x.__super__.constructor.apply(this,arguments)}var N=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},L=(a(A,o),A.prototype.tag="name",A.prototype.parse=function(t){var e,n,r,i,a,o,s,u,l,c,h;for(t.pos=this.offset,t.readShort(),e=t.readShort(),o=t.readShort(),n=[],i=0;0<=e?i<e:e<i;i=0<=e?++i:--i)n.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+o+t.readShort()});for(s={},i=l=0,c=n.length;l<c;i=++l)r=n[i],t.pos=r.offset,u=t.readString(r.length),a=new N(u,r),null==s[h=r.nameID]&&(s[h]=[]),s[r.nameID].push(a);this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5];try{this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}catch(t){this.postscriptName=s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}return this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},A);function A(){return A.__super__.constructor.apply(this,arguments)}var _=(a(S,o),S.prototype.tag="maxp",S.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},S);function S(){return S.__super__.constructor.apply(this,arguments)}var P=(a(k,o),k.prototype.tag="hmtx",k.prototype.parse=function(n){var r,t,i,a,e,o,s;for(n.pos=this.offset,this.metrics=[],r=0,o=this.file.hhea.numberOfMetrics;0<=o?r<o:o<r;r=0<=o?++r:--r)this.metrics.push({advance:n.readUInt16(),lsb:n.readInt16()});for(i=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var t,e;for(e=[],r=t=0;0<=i?t<i:i<t;r=0<=i?++t:--t)e.push(n.readInt16());return e}(),this.widths=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.metrics).length;t<e;t++)a=n[t],r.push(a.advance);return r}.call(this),t=this.widths[this.widths.length-1],s=[],r=e=0;0<=i?e<i:i<e;r=0<=i?++e:--e)s.push(this.widths.push(t));return s},k.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},k);function k(){return k.__super__.constructor.apply(this,arguments)}var F=[].slice,C=(a(I,o),I.prototype.tag="glyf",I.prototype.parse=function(){return this.cache={}},I.prototype.glyphFor=function(t){var e,n,r,i,a,o,s,u,l,c;return t in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,n=i.indexOf(t),0===(r=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+n,a=(o=new J(e.read(r))).readShort(),u=o.readShort(),c=o.readShort(),s=o.readShort(),l=o.readShort(),this.cache[t]=-1===a?new O(o,u,c,s,l):new j(o,a,u,c,s,l),this.cache[t]))},I.prototype.encode=function(t,e,n){var r,i,a,o,s;for(a=[],i=[],o=0,s=e.length;o<s;o++)r=t[e[o]],i.push(a.length),r&&(a=a.concat(r.encode(n)));return i.push(a.length),{table:a,offsets:i}},I);function I(){return I.__super__.constructor.apply(this,arguments)}var j=(B.prototype.encode=function(){return this.raw.data},B);function B(t,e,n,r,i,a){this.raw=t,this.numberOfContours=e,this.xMin=n,this.yMin=r,this.xMax=i,this.yMax=a,this.compound=!1}var O=(E.prototype.encode=function(){var t,e,n;for(e=new J(F.call(this.raw.data)),t=0,n=this.glyphIDs.length;t<n;++t)e.pos=this.glyphOffsets[t];return e.data},E);function E(t,e,n,r,i){var a,o;for(this.raw=t,this.xMin=e,this.yMin=n,this.xMax=r,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],a=this.raw;o=a.readShort(),this.glyphOffsets.push(a.pos),this.glyphIDs.push(a.readShort()),32&o;)a.pos+=1&o?4:2,128&o?a.pos+=8:64&o?a.pos+=4:8&o&&(a.pos+=2)}var M=(a(T,o),T.prototype.tag="loca",T.prototype.parse=function(n){var t,r;return n.pos=this.offset,t=this.file.head.indexToLocFormat,this.offsets=0===t?function(){var t,e;for(e=[],r=0,t=this.length;r<t;r+=2)e.push(2*n.readUInt16());return e}.call(this):function(){var t,e;for(e=[],r=0,t=this.length;r<t;r+=4)e.push(n.readUInt32());return e}.call(this)},T.prototype.indexOf=function(t){return this.offsets[t]},T.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},T.prototype.encode=function(t,e){for(var n=new Uint32Array(this.offsets.length),r=0,i=0,a=0;a<n.length;++a)if(n[a]=r,i<e.length&&e[i]==a){++i,n[a]=r;var o=this.offsets[a],s=this.offsets[a+1]-o;0<s&&(r+=s)}for(var u=new Array(4*n.length),l=0;l<n.length;++l)u[4*l+3]=255&n[l],u[4*l+2]=(65280&n[l])>>8,u[4*l+1]=(16711680&n[l])>>16,u[4*l]=(4278190080&n[l])>>24;return u},T);function T(){return T.__super__.constructor.apply(this,arguments)}var q,R=(D.prototype.generateCmap=function(){var t,e,n,r,i;for(e in r=this.font.cmap.tables[0].codeMap,t={},i=this.subset)n=i[e],t[e]=r[n];return t},D.prototype.glyphsFor=function(t){var e,n,r,i,a,o,s;for(r={},a=0,o=t.length;a<o;a++)r[i=t[a]]=this.font.glyf.glyphFor(i);for(i in e=[],r)(null!=(n=r[i])?n.compound:void 0)&&e.push.apply(e,n.glyphIDs);if(0<e.length)for(i in s=this.glyphsFor(e))n=s[i],r[i]=n;return r},D.prototype.encode=function(t,e){var n,r,i,a,o,s,u,l,c,h,f,d,p,g,m;for(r in n=b.encode(this.generateCmap(),"unicode"),a=this.glyphsFor(t),f={0:0},m=n.charMap)f[(s=m[r]).old]=s.new;for(d in h=n.maxGlyphID,a)d in f||(f[d]=h++);return l=function(t){var e,n;for(e in n={},t)n[t[e]]=e;return n}(f),c=Object.keys(l).sort(function(t,e){return t-e}),p=function(){var t,e,n;for(n=[],t=0,e=c.length;t<e;t++)o=c[t],n.push(l[o]);return n}(),i=this.font.glyf.encode(a,p,f),u=this.font.loca.encode(i.offsets,p),g={cmap:this.font.cmap.raw(),glyf:i.table,loca:u,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.encode(e)},this.font.os2.exists&&(g["OS/2"]=this.font.os2.raw()),this.font.directory.encode(g)},D);function D(t){this.font=t,this.subset={},this.unicodes={},this.next=33}function U(){}t.API.PDFObject=(q=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},U.convert=function(r){var i,t,e,n;if(Array.isArray(r))return"["+function(){var t,e,n;for(n=[],t=0,e=r.length;t<e;t++)i=r[t],n.push(U.convert(i));return n}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+q(r.getUTCFullYear(),4)+q(r.getUTCMonth(),2)+q(r.getUTCDate(),2)+q(r.getUTCHours(),2)+q(r.getUTCMinutes(),2)+q(r.getUTCSeconds(),2)+"Z)";if("[object Object]"!=={}.toString.call(r))return""+r;for(t in e=["<<"],r)n=r[t],e.push("/"+t+" "+U.convert(n));return e.push(">>"),e.join("\n")},U)}(U),(
/*
  # PNG.js
  # Copyright (c) 2011 Devon Govett
  # MIT LICENSE
  # 
  # 
  */
D="undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()).PNG=function(){var l,n,r;function t(t){var e,n,r,i,a,o,s,u,l,c,h,f,d,p;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},o=null;;){switch(e=this.readUInt32(),l=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":o&&this.animation.frames.push(o),this.pos+=4,o={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},a=this.readUInt16(),i=this.readUInt16()||100,o.delay=1e3*a/i,o.disposeOp=this.data[this.pos++],o.blendOp=this.data[this.pos++],o.data=[];break;case"IDAT":case"fdAT":for("fdAT"===l&&(this.pos+=4,e-=4),t=(null!=o?o.data:void 0)||this.imgData,f=0;0<=e?f<e:e<f;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if(0<(c=r-this.transparency.indexed.length))for(d=0;0<=c?d<c:c<d;0<=c?++d:--d)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(h=this.read(e)).indexOf(0),u=String.fromCharCode.apply(String,h.slice(0,s)),this.text[u]=String.fromCharCode.apply(String,h.slice(s+1));break;case"IEND":return o&&this.animation.frames.push(o),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(p=this.colorType)||6===p,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}function i(){if("[object Window]"!==Object.prototype.toString.call(D))return!1;try{n=D.document.createElement("canvas"),r=n.getContext("2d")}catch(t){return!1}return!0}return t.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:t<e;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},t.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},t.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},t.prototype.decodePixels=function(I){var j=this.pixelBitlength/8,B=new Uint8Array(this.width*this.height*j),O=0,E=this;if(null==I&&(I=this.imgData),0===I.length)return new Uint8Array(0);function t(t,e,n,r){var i,a,o,s,u,l,c,h,f,d,p,g,m,b,v,y,w,x,N,L,A,_=Math.ceil((E.width-t)/n),S=Math.ceil((E.height-e)/r),P=E.width==_&&E.height==S;for(b=j*_,g=P?B:new Uint8Array(b*S),l=I.length,a=m=0;m<S&&O<l;){switch(I[O++]){case 0:for(s=w=0;w<b;s=w+=1)g[a++]=I[O++];break;case 1:for(s=x=0;x<b;s=x+=1)i=I[O++],u=s<j?0:g[a-j],g[a++]=(i+u)%256;break;case 2:for(s=N=0;N<b;s=N+=1)i=I[O++],o=(s-s%j)/j,v=m&&g[(m-1)*b+o*j+s%j],g[a++]=(v+i)%256;break;case 3:for(s=L=0;L<b;s=L+=1)i=I[O++],o=(s-s%j)/j,u=s<j?0:g[a-j],v=m&&g[(m-1)*b+o*j+s%j],g[a++]=(i+Math.floor((u+v)/2))%256;break;case 4:for(s=A=0;A<b;s=A+=1)i=I[O++],o=(s-s%j)/j,u=s<j?0:g[a-j],0===m?v=y=0:(v=g[(m-1)*b+o*j+s%j],y=o&&g[(m-1)*b+(o-1)*j+s%j]),c=u+v-y,h=Math.abs(c-u),d=Math.abs(c-v),p=Math.abs(c-y),f=h<=d&&h<=p?u:d<=p?v:y,g[a++]=(i+f)%256;break;default:throw new Error("Invalid filter algorithm: "+I[O-1])}if(!P){var k=((e+m*r)*E.width+t)*j,F=m*b;for(s=0;s<_;s+=1){for(var C=0;C<j;C+=1)B[k++]=g[F++];k+=(n-1)*j}}m++}}return I=(I=new lt(I)).getBytes(),1==E.interlaceMethod?(t(0,0,8,8),t(4,0,8,8),t(0,4,4,8),t(2,0,4,4),t(0,2,2,4),t(1,0,2,2),t(0,1,1,2)):t(0,0,1,1),B},t.prototype.decodePalette=function(){var t,e,n,r,i,a,o,s,u;for(n=this.palette,a=this.transparency.indexed||[],i=new Uint8Array((a.length||0)+n.length),e=o=t=r=0,s=n.length;o<s;e=o+=3)i[r++]=n[e],i[r++]=n[e+1],i[r++]=n[e+2],i[r++]=null!=(u=a[t++])?u:255;return i},t.prototype.copyToImageData=function(t,e){var n,r,i,a,o,s,u,l,c,h,f;if(r=this.colors,c=null,n=this.hasAlphaChannel,this.palette.length&&(c=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),l=(i=t.data||t).length,o=c||e,a=s=0,1===r)for(;a<l;)u=c?4*e[a/4]:s,h=o[u++],i[a++]=h,i[a++]=h,i[a++]=h,i[a++]=n?o[u++]:255,s=u;else for(;a<l;)u=c?4*e[a/4]:s,i[a++]=o[u++],i[a++]=o[u++],i[a++]=o[u++],i[a++]=n?o[u++]:255,s=u},t.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t},i(),l=function(t){if(!0!==i())throw new Error("This method requires a Browser with Canvas-capability.");var e;return r.width=t.width,r.height=t.height,r.clearRect(0,0,t.width,t.height),r.putImageData(t,0,0),(e=new Image).src=n.toDataURL(),e},t.prototype.decodeFrames=function(t){var e,n,r,i,a,o,s,u;if(this.animation){for(u=[],n=a=0,o=(s=this.animation.frames).length;a<o;n=++a)e=s[n],r=t.createImageData(e.width,e.height),i=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(r,i),e.imageData=r,u.push(e.image=l(r));return u}},t.prototype.renderFrame=function(t,e){var n,r,i;return n=(r=this.animation.frames)[e],i=r[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===n.blendOp&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},t.prototype.animate=function(n){var r,i,a,o,s,t,u=this;return i=0,t=this.animation,o=t.numFrames,a=t.frames,s=t.numPlays,(r=function(){var t,e;if(t=i++%o,e=a[t],u.renderFrame(n,t),1<o&&i/o<s)return u.animation._timeout=setTimeout(r,e.delay)})()},t.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},t.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},t}();
/*
   * Extracted from pdf.js
   * https://github.com/andreasgal/pdf.js
   *
   * Copyright (c) 2011 Mozilla Foundation
   *
   * Contributors: Andreas Gal <gal@mozilla.com>
   *               Chris G Jones <cjones@mozilla.com>
   *               Shaon Barman <shaon.barman@gmail.com>
   *               Vivien Nicolas <21@vingtetun.org>
   *               Justin D'Arcangelo <justindarc@gmail.com>
   *               Yury Delendik
   *
   * 
   */
var st=(ut.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),a=0;a<n;++a)i[a]=e[a];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(var n=e+t;!this.eof&&this.bufferLength<n;)this.readBlock();var r=this.bufferLength;r<n&&(n=r)}else{for(;!this.eof;)this.readBlock();n=this.bufferLength}return this.pos=n,this.buffer.subarray(e,n)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},ut);function ut(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}var lt=("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()).FlateStream=function(){if("undefined"!=typeof Uint32Array){var F=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),C=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),I=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),j=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],B=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return(t.prototype=Object.create(st.prototype)).getBits=function(t){for(var e,n=this.codeSize,r=this.codeBuf,i=this.bytes,a=this.bytesPos;n<t;)void 0===(e=i[a++])&&O("Bad encoding in flate stream"),r|=e<<n,n+=8;return e=r&(1<<t)-1,this.codeBuf=r>>t,this.codeSize=n-=t,this.bytesPos=a,e},t.prototype.getCode=function(t){for(var e=t[0],n=t[1],r=this.codeSize,i=this.codeBuf,a=this.bytes,o=this.bytesPos;r<n;){var s;void 0===(s=a[o++])&&O("Bad encoding in flate stream"),i|=s<<r,r+=8}var u=e[i&(1<<n)-1],l=u>>16,c=65535&u;return(0==r||r<l||0==l)&&O("Bad encoding in flate stream"),this.codeBuf=i>>l,this.codeSize=r-l,this.bytesPos=o,c},t.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,a=new Uint32Array(i),o=1,s=0,u=2;o<=n;++o,s<<=1,u<<=1)for(var l=0;l<e;++l)if(t[l]==o){var c=0,h=s;for(r=0;r<o;++r)c=c<<1|1&h,h>>=1;for(r=c;r<i;r+=u)a[r]=o<<16|l;++s}return[a,n]},t.prototype.readBlock=function(){function t(t,e,n,r,i){for(var a=t.getBits(n)+r;0<a--;)e[u++]=i}var e=this.getBits(3);if(1&e&&(this.eof=!0),0!=(e>>=1)){var n,r;if(1==e)n=j,r=B;else if(2==e){for(var i=this.getBits(5)+257,a=this.getBits(5)+1,o=this.getBits(4)+4,s=Array(F.length),u=0;u<o;)s[F[u++]]=this.getBits(3);for(var l=this.generateHuffmanTable(s),c=0,h=(u=0,i+a),f=new Array(h);u<h;){var d=this.getCode(l);16==d?t(this,f,2,3,c):17==d?t(this,f,3,3,c=0):18==d?t(this,f,7,11,c=0):f[u++]=c=d}n=this.generateHuffmanTable(f.slice(0,i)),r=this.generateHuffmanTable(f.slice(i,h))}else O("Unknown block type in flate stream");for(var p=(S=this.buffer)?S.length:0,g=this.bufferLength;;){var m=this.getCode(n);if(m<256)p<=g+1&&(p=(S=this.ensureBuffer(g+1)).length),S[g++]=m;else{if(256==m)return void(this.bufferLength=g);var b=(m=C[m-=257])>>16;0<b&&(b=this.getBits(b));c=(65535&m)+b;m=this.getCode(r),0<(b=(m=I[m])>>16)&&(b=this.getBits(b));var v=(65535&m)+b;p<=g+c&&(p=(S=this.ensureBuffer(g+c)).length);for(var y=0;y<c;++y,++g)S[g]=S[g-v]}}}else{var w,x=this.bytes,N=this.bytesPos;void 0===(w=x[N++])&&O("Bad block header in flate stream");var L=w;void 0===(w=x[N++])&&O("Bad block header in flate stream"),L|=w<<8,void 0===(w=x[N++])&&O("Bad block header in flate stream");var A=w;void 0===(w=x[N++])&&O("Bad block header in flate stream"),(A|=w<<8)!=(65535&~L)&&O("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var _=this.bufferLength,S=this.ensureBuffer(_+L),P=_+L;this.bufferLength=P;for(var k=_;k<P;++k){if(void 0===(w=x[N++])){this.eof=!0;break}S[k]=w}this.bytesPos=N}},t}function O(t){throw new Error(t)}function t(t){var e=0,n=t[e++],r=t[e++];-1!=n&&-1!=r||O("Invalid header in flate stream"),8!=(15&n)&&O("Unknown compression method in flate stream"),((n<<8)+r)%31!=0&&O("Bad FCHECK in flate stream"),32&r&&O("FDICT bit set in flate stream"),this.bytes=t,this.bytesPos=2,this.codeSize=0,this.codeBuf=0,st.call(this)}}();return function(t,e){if("function"==typeof define&&define.amd)define([],e);else if("undefined"!=typeof exports)e();else{e(),t.FileSaver={}}}(window,function(){var c="object"===("undefined"==typeof window?"undefined":on(window))&&window.window===window?window:"object"===("undefined"==typeof self?"undefined":on(self))&&self.self===self?self:"object"===("undefined"==typeof global?"undefined":on(global))&&global.global===global?global:void 0;function h(t,e,n){var r=new XMLHttpRequest;r.open("GET",t),r.responseType="blob",r.onload=function(){i(r.response,e,n)},r.onerror=function(){console.error("could not download file")},r.send()}function a(t){var e=new XMLHttpRequest;return e.open("HEAD",t,!1),e.send(),200<=e.status&&e.status<=299}function o(e){try{e.dispatchEvent(new MouseEvent("click"))}catch(t){var n=document.createEvent("MouseEvents");n.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),e.dispatchEvent(n)}}var i=c.saveAs||("object"!==("undefined"==typeof window?"undefined":on(window))||window!==c?function(){}:"download"in HTMLAnchorElement.prototype?function(t,e,n){var r=c.URL||c.webkitURL,i=document.createElement("a");e=e||t.name||"download",i.download=e,i.rel="noopener","string"==typeof t?(i.href=t,i.origin!==location.origin?a(i.href)?h(t,e,n):o(i,i.target="_blank"):o(i)):(i.href=r.createObjectURL(t),setTimeout(function(){r.revokeObjectURL(i.href)},4e4),setTimeout(function(){o(i)},0))}:"msSaveOrOpenBlob"in navigator?function(t,e,n){if(e=e||t.name||"download","string"==typeof t)if(a(t))h(t,e,n);else{var r=document.createElement("a");r.href=t,r.target="_blank",setTimeout(function(){o(r)})}else navigator.msSaveOrOpenBlob(function(t,e){return void 0===e?e={autoBom:!1}:"object"!==on(e)&&(console.warn("Deprecated: Expected third argument to be a object"),e={autoBom:!e}),e.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t}(t,n),e)}:function(t,e,n,r){if((r=r||open("","_blank"))&&(r.document.title=r.document.body.innerText="downloading..."),"string"==typeof t)return h(t,e,n);var i="application/octet-stream"===t.type,a=/constructor/i.test(c.HTMLElement)||c.safari,o=/CriOS\/[\d]+/.test(navigator.userAgent);if((o||i&&a)&&"object"===("undefined"==typeof FileReader?"undefined":on(FileReader))){var s=new FileReader;s.onloadend=function(){var t=s.result;t=o?t:t.replace(/^data:[^;]*;/,"data:attachment/file;"),r?r.location.href=t:location=t,r=null},s.readAsDataURL(t)}else{var u=c.URL||c.webkitURL,l=u.createObjectURL(t);r?r.location=l:location.href=l,r=null,setTimeout(function(){u.revokeObjectURL(l)},4e4)}});c.saveAs=i.saveAs=i,"undefined"!=typeof module&&(module.exports=i)}),U});try{module.exports=jsPDF}catch(t){}
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $translate, $timeout, $state)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

        $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
            $translate.refresh();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise(function ($injector, $scope) {
            var state = $injector.get('$state');
            var $currentSite = $injector.get('$currentSite');
            /*var userService = $injector.get('userService');
            var window_ = $injector.get('$window');
            userService.getCurrent().then(function (response) {
                if (response.data != null){
                    state.go('app.home');
                }
            }).catch(function(error){
                if (angular.isUndefined(error) || error == null || error.status === 404 || error.status === 401){
                    state.go('sitegen.site.login');
                }
            });*/
            state.go('sitegen.site.login', { site: $currentSite.getSite().url }); 
        });

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/navigation/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            },
            siteGenNavigation : {
                main      : 'app/main/sitegen/navigation/horizontal-navigation.html',
                toolbar   : 'app/main/sitegen/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/main/sitegen/navigation/layouts/horizontal-navigation/navigation.html'
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            })
            .state('sitegen', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts['siteGenNavigation'].main,
                        controller : 'SiteGenMainController as vm'
                    },
                    'toolbar@sitegen'   : {
                        templateUrl: layouts['siteGenNavigation'].toolbar,
                        controller : 'SiteGenToolbarController as vm'
                    },
                    'navigation@sitegen': {
                        templateUrl: layouts['siteGenNavigation'].navigation,
                        controller : 'SiteGenNavigationController as vm'
                    },
                    'quickPanel@sitegen': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });

        /*$httpProvider.interceptors.push(function ($q, $injector, PUBLIC_PAGES) {
            return {
                'responseError': function (response) {
                    // same as above
                    if (response.status === 401) {
                        var state = $injector.get('$state');
                        if (PUBLIC_PAGES.lastIndexOf(state.current.name) === -1 && !state.current.abstract){
                            state.go('login');
                        }
                    }
                    return $q.reject(response);
                }
            };
        });*/
    }

})();

(function () {
	'use strict';

	angular.module('fuse').filter('showAllUsers', function () {
		return function (items, showAllUsers) {
			var filtered = [];
			if (items != null && angular.isArray(items)) {
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					if (showAllUsers) {
						filtered.push(item);
					} else {
						if (item.activated) {
							filtered.push(item);
						}
					}
				}
			}
			return filtered;
		};
	});

	angular.module('fuse').filter('stringToDate', function () {
		return function (item) {
			if (item != null && item.length > 0) {
				var parts = item.split('/');
				if (parts.length === 3) {
					var day = parseInt(parts[0]);
					var month = parseInt(parts[1]) - 1;
					var year = parseInt(parts[2]);
					return new Date(year, month, day);
				}
			}
			return null;
		};
	});

	//   angular.module('fuse').filter('unique', function ($filter) {
	//     return function (items, property) {
	//       var result = [];

	//       if (items) {
	//         for (var i = 0; i < items.length; i++) {
	//           //console.log($filter('filter')(result, {[property]: items[i][property]}));
	//           if ($filter('filter')(result, {
	//               [property]: items[i][property]
	//             }).length === 0) {
	//             result.push(items[i]);
	//           }
	//         }
	//       }

	//       return result;
	//     };
	//   });

	angular.module('fuse').filter('filterText', function () {
		return function (items, searchString) {
			if (!searchString) {
				return items;
			} else {
				var filtered = [];

				for (var i = 0; i < items.length; i++) {
					if (items[i].name) {
						if (items[i].name.toLocaleLowerCase().includes(searchString.toLocaleLowerCase())) {
							filtered.push(items[i]);
						}
					} else if (items[i].libelle) {
						if (items[i].libelle.toLocaleLowerCase().includes(searchString.toLocaleLowerCase())) {
							filtered.push(items[i]);
						}
					} else if (items[i].value) {
						if (items[i].value.toLocaleLowerCase().includes(searchString.toLocaleLowerCase())) {
							filtered.push(items[i]);
						}
					} else if (items[i].fullName) {
						if (items[i].fullName.toLocaleLowerCase().includes(searchString.toLocaleLowerCase())) {
							filtered.push(items[i]);
						}
					} else {
						filtered = items;
						break;
					}

				}

				return filtered;
			}
		};
	});

	angular.module('fuse').filter('showColumn', function ($filter) {
		return function (item, index) {
			var result = '';
			if (angular.isArray(item.columns)) {
				var columnByIndex = item.columns.filter(function (column) {
					return column.columnIndex === index;
				});
				if (columnByIndex[0].fields.length > 0) {
					angular.forEach(columnByIndex[0].fields, function (field, index) {
						if(!field.fixField) {
							for (var i = 0; i < item.valuedFields.length; i++) {
								if (item.valuedFields[i] != null && item.valuedFields[i].idBaseField === field.field.id) {
									if (item.valuedFields[i].value != null && item.valuedFields[i].value !== '') {
										if (result.length > 0) {
											result += ' - ';
										}
										if (field.field.typeChamps === 'DATE') {
											result += $filter('translate')('GENERAL.DATE_FORMAT', {
												date: $filter('stringToDate')(item.valuedFields[i].value)
											});
										} else if (field.field.typeChamps === 'URL') {
											result += '<a href="' + item.valuedFields[i].value + '" target="_blank">' + item.valuedFields[i].value + '</a>';
										} else if (field.field.typeChamps === 'EMAIL') {
											result += '<a href="mailto:' + item.valuedFields[i].value + '">' + item.valuedFields[i].value + '</a>';
										} else if (field.field.typeChamps === 'LIST_SELECT' && field.field.listFieldsDTO != null && field.field.listFieldsDTO.length > 0) {
											var color = '';
											for (var j = 0; j < field.field.listFieldsDTO.length; j++) {
												if (field.field.listFieldsDTO[j].value === item.valuedFields[i].value && field.field.listFieldsDTO[j].color != null) {
													color = angular.copy(field.field.listFieldsDTO[j].color);

													break;
												}
											}
											result += '<span style="color:' + color + ';">' + item.valuedFields[i].value + '</span>';
										} else {
											result += item.valuedFields[i].value;
										}
									}
									break;
								}
							}
						} else {
							if(field.fixFieldKey) {
								if(field.fixFieldKey === 'FIXE_FIELD_REGISTRATION_SUBCATEGORY') {
									if(item.subCategory && item.subCategory.name) {
										result += item.subCategory.name;
									}
								} else if(field.fixFieldKey === 'FIXE_FIELD_LOGISTIC_STATUS') {
									if(item.logisticStatus && item.logisticStatus.name) {
										result += item.logisticStatus.name;
									}
								} else if(field.fixFieldKey === 'FIXE_FIELD_REGISTRATION_STATUS') {
									if(item.registrationStatus && item.registrationStatus.name) {
										result += item.registrationStatus.name;
									}
								}
							}
						}
					});
				}
			}
			return result;
		};
	});

	angular.module('fuse').filter('nlEllipsis', function () {
		return function (htmlText, limit) {
			if (!htmlText) {
				return htmlText;
			}
			var arrayString = htmlText.split(/<(?:.|\n)*?>/gm);
			var arrayTags = htmlText.match(/<(?:.|\n)*?>/gm);
			var regExpClosing = new RegExp('^<\/');
			var regExpBR = new RegExp('^<br');
			var result = '';

			var charCount = 0;
			var closingTagsCount = 0;
			var openingTagsCount = 0;

			for (var i = 0; i < arrayString.length; i++) {
				for (var j = 0; j < arrayString[i].length; j++) {
					if (charCount < limit) {
						result += arrayString[i][j];
					} else {
						//we don't want to cut a word at the end: we delete "orphant chars"
						var k = result.length;

						while (k--) {
							if (result[k] === ' ') {
								result = result.substring(0, k);
								break;
							}
						}
						result += '...';
						//check if last tag was opening or closing tag
						if (closingTagsCount !== openingTagsCount) {
							var counterTags = 0;

							while (closingTagsCount < openingTagsCount) {
								if (arrayTags.length > i + counterTags) {
									if (!regExpBR.test(arrayTags[i + counterTags]) && arrayTags[i + counterTags] != null) {
										result += arrayTags[i + counterTags];
										if (regExpClosing.test(arrayTags[i + counterTags])) {
											closingTagsCount++;
										} else {
											openingTagsCount++;
										}
									}

									counterTags++;
								} else {
									break;
								}
							}
						}

						return result;
					}

					charCount++;
				}
				if (arrayTags && arrayTags.length > 0 && arrayTags[i] != null) {
					result += arrayTags[i];
				} else {
					if (charCount >= limit){
						result += '...';
					}

					return result;
				}

				if (arrayTags[i] != null && regExpClosing.test(arrayTags[i])) {
					closingTagsCount++;
				} else if (arrayTags[i] != null && !regExpBR.test(arrayTags[i])) {
					openingTagsCount++;
				}
			}

			result += '...';
			return result;
		};
	});

	angular.module('app.front').filter('filterTranslate', function($filter){
		return function(items, text){
			var res = [];
			if (angular.isArray(items) && text != null){
				var regExp = new RegExp('^.*'+text+'.*$', 'i');
				return $filter('filter')(items, function(value, index ,array){
					var translate = $filter('translate')(value.translateKey);
					return regExp.test(translate);
				});
			}else{
				return items;
			}
		};
	});

})();

(function () {
  'use strict';

  angular.module('fuse').directive('dropifyDirective', function ($timeout, $q) {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          filesave: '=',
          filesavename: '=',
          initfile: '=ngModel',
          required: '=?required'
        },
        template: '<input type="file" data-show-remove="false" data-default-file="{{initfile.src}}" ng-required="{{!!required}}"/>',
        link: function (scope, element, attributes) {

          function getBase64(file) {
            return $q(function (resolve, reject) {
              var reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = function () {
                resolve(reader.result);
              };
              reader.onerror = function (error) {
                reject(error);
              };
            });
          }

          $timeout(function () {
            var $this = $(element);
            $this.dropify({
              messages: {
                'default': 'Glisser-déposer une image ici ou cliquer',
                'replace': 'Glisser-déposer une image ici ou cliquer pour remplacer',
                'remove': 'Supprimer',
                'error': 'Oups, une erreur est survenue'
              }
            });
          });

          element.bind('change', function (changeEvent) {
            //$rootScope.$broadcast('changePicture');
            scope.$apply(function () {
              scope.filesave = changeEvent.target.files[0];
            });
          });
          // element.on('$destroy', function () {
          //   $(element).destroy();
          // });
        }
      };
    }).directive('forceSelectFocus', function () {
      return {
        restrict: 'A',
        require: ['^^mdSelect', '^ngModel'],
        link: function (scope, element, controller) {
          scope.$watch(function () {
            var foundElement = element;
            while (!foundElement.hasClass('md-select-menu-container')) {
              foundElement = foundElement.parent();
            }
            return foundElement.hasClass('md-active');
          }, function (newVal) {
            if (newVal) {
              console.log(controller[1]);
              element.focus();
            }
          })
        }
      }
    }).directive('ngEnter', function () {
      return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
          if (event.which === 13) {
            scope.$apply(function () {
              scope.$eval(attrs.ngEnter);
            });

            event.preventDefault();
          }
        });
      };
    }).directive('httpSrc', ['$http', function ($http) {
      return {
        // do not share scope with sibling img tags and parent
        // (prevent show same images on img tag)
        scope: {
          httpSrc: '@',
          hasProfilePicture: '=',
          isArticle: '=',
          isInstitution: '=',
          noCache: '='
        },
        link: function ($scope, elem, attrs) {
          function revokeObjectURL() {
            if ($scope.objectURL) {
              URL.revokeObjectURL($scope.objectURL);
            }
          }

          $scope.$watch('objectURL', function (objectURL) {
            elem.attr('src', objectURL);
          });

          $scope.$on('$destroy', function () {
            revokeObjectURL();
          });

          function refreshPhoto(url) {
            revokeObjectURL();
            if ($scope.hasProfilePicture) {
              if (url && url.indexOf('data:') === 0) {
                $scope.objectURL = url;
              } else if (url) {
                $http.get(url, {
                    responseType: 'arraybuffer',
                    cache: (attrs.noCache ? false : true),
                    headers: {
                      'accept': 'image/webp,image/*,*/*;q=0.8'
                    }
                  })
                  .then(function (response) {
                    var blob = new Blob(
                      [response.data], {
                        type: response.headers('Content-Type')
                      }
                    );
                    $scope.objectURL = URL.createObjectURL(blob);
                  }).catch(function (error) {
                    console.log(error);
                  });
              }
            } else {
              if ($scope.isArticle) {
                $scope.objectURL = 'assets/images/article/noArticlePhoto.png';
              } else if ($scope.isInstitution) {
                $scope.objectURL = 'assets/icons/rendus/profil/clinique.png';
              } else {
                $scope.objectURL = 'assets/icons/rendus/popup/pop-up-avatar-icone@3x.png';
              }
            }
          };

          $scope.$on('refreshPhoto', function () {
            refreshPhoto(attrs.httpSrc);
          });

          attrs.$observe('httpSrc', function (url) {
            refreshPhoto(url);
          });
        }
      };
    }]);


  angular.module("fuse").directive('stringToNumber', function () {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function (value) {
          return '' + value;
        });
        ngModel.$formatters.push(function (value) {
          return parseFloat(value);
        });
      }
    };
  });

  angular.module("fuse").directive('imgDimensionsBindDirective', function () {
    return {
      restrict: 'A',
      scope: {
        img: '=imgDimensionsBindDirective'
      },
      link: function (scope, element, attrs) {
        element.bind('load', function () {
          if (scope.img) {
            // scope.img.width = angular.copy(element[0].naturalWidth);
            // scope.img.height = angular.copy(element[0].naturalHeight);

            if (element[0].naturalWidth >= element[0].naturalHeight) {
              scope.img.landscape = true;
            } else {
              scope.img.landscape = false;
            }
          }

          scope.$apply();
        });
      }
    };
  });


  angular.module("fuse").directive('stringToBoolean', function () {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function (value) {
          return '' + value;
        });
        ngModel.$formatters.push(function (value) {
          return value == "true";
        });
      }
    };
  });

  angular.module('fuse').directive('nooInputEvent', function ($timeout, URL) {

    var linker = function (scope, element, attrs) {
        var initializing = true;
        if (scope.model.typeChamps === 'IMAGE'){
            if (scope.model.location != null && scope.model.location !== ''){
                scope.model.src = URL.alternatedocroots + '/' + scope.model.location;
            }else{
                scope.model.src = '';
            }
        }

        scope.$watch('model', function(newModel, oldModel){
          if (initializing){
            $timeout(function(){
              initializing = false;
            });
          }else {
            scope.watch({field: scope.field});
          }
        }, true);

        scope.$on('$submittedNestedForm', function() {
          scope.formName.$setSubmitted();
        });

        scope.$on('$resetNestedForm', function() {
          scope.formName.$setPristine();
					scope.formName.$setUntouched();
        });
    };



    return {
        restrict: 'E',
        replace: true,
        link: linker,
        templateUrl: 'app/main/sites_management/blocs/bloc/event/input.html',
        scope: {
            watch: '&watch',
            field: '=field',
            content: '@',
            index: '@',
            model: '=ngModel',
            required: '=ngRequired',
            disabled: '=ngDisabled',
            formName: '=',
            init: '&initFn',
            subType: '=subType',
            modelType: '=modelType'
        }
    };
}).directive('fileInputChanged', function() {
  return {
    restrict: 'A',
    scope: {
      plan: '=plan',
      call: '&call'
    },
    link: function (scope, element) {
      element.on('change', function(){
        scope.call({plan: scope.plan});
        element.value = '';
      });
      element.on('$destroy', function() {
        element.off();
      });

    }
  };
});

  angular.module('fuse').directive('nlFooter', function nlFooter() {
    return {
      restrict: 'E',
      templateUrl: 'app/footer.tmpl.html',
    };
  });

})();

(function () {
	'use strict';

	angular
		.module('fuse')
		.controller('IndexController', IndexController);

	/** @ngInject */
	function IndexController($rootScope, $scope, $mdDialog, $sce, $currentSite, $q, URL, DISPLAY_MODELS_ICONS) {
		var poll = null;

		$rootScope.site = {};
		$scope.URL = URL;

		$scope.$on('siteUpdated', function () {
			$rootScope.site = $currentSite.getSite();

		});


		$scope.iconsDisplay = {};
		angular.forEach(DISPLAY_MODELS_ICONS, function (elt) {
			$scope.iconsDisplay[elt.name] = elt.value;
		});
		$rootScope.css = '';
		$rootScope.footer = '';

		$scope.trustAsHtml = function (string) {
			return $sce.trustAsHtml(string);
		};


		$scope.getDate = function (date) {
			if (date != null) {
				return moment(date).toDate();
			} else {
				return null;
			}
		};

		$scope.hidePopup = function () {
			$mdDialog.hide();
		};

		$scope.showBlocByDates = function (begin, end) {
			if (!begin || !end) {
				return true;
			}
			if (begin == null || end == null) {
				return true;
			}
			var beginParts = begin.split('/');
			var endParts = end.split('/');
			if (beginParts.length !== 3 || endParts.length !== 3) {
				return true;
			}
			var beginDate = new Date(beginParts[2], parseInt(beginParts[1]) - 1, beginParts[0]);
			var endDate = new Date(endParts[2], parseInt(endParts[1]) - 1, endParts[0], 23, 59, 59, 999);
			var today = new Date();
			return beginDate.getTime() <= today.getTime() && today.getTime() <= endDate.getTime();
		};

		$scope.openConfirmPopup = function (content) {
			return $q(function (resolve, reject) {
				$mdDialog.show({
					templateUrl: 'app/main/popup/confirm.html',
					clickOutsideToClose: true,
					controller: 'confirmPopupController',
					locals: {
						content: content
					}
				}).then(function () {
					resolve();
				}).catch(function () {
					reject();
				});
			});
		};


	}
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .constant({
      STATISTICS_NATIONALITIES: [{
        name: 'France',
        code: 'FR'
      },
      {
        name: 'Royaume-Uni',
        code: 'EN'
      }
      ],
      STORAGE_PREFIX: 'GlobeNetwork_',
      URL: {
        alternatedocroots: './alternatedocroots',
        alternatedocrootsWithoutDot: '/alternatedocroots'
      },
      PUBLIC_PAGES: ['login', 'forgotPassword', 'activateAccount', 'updatePassword'],
      LOGS_ENTITY_CONCERNED: {
        COMPANY: 'ADMIN.USERSLOGS.ENTITIES.COMPANY',
        CONTACT: 'ADMIN.USERSLOGS.ENTITIES.CONTACT'
      },
      LOGS_ACTIONS: {
        UPDATE: 'ADMIN.USERSLOGS.ACTIONS.UPDATE',
        CREATE: 'ADMIN.USERSLOGS.ACTIONS.CREATE',
        DELETE: 'ADMIN.USERSLOGS.ACTIONS.DELETE',
        COPY: 'ADMIN.USERSLOGS.ACTIONS.COPY',
        ARCHIVE: 'ADMIN.USERSLOGS.ACTIONS.ARCHIVE',
        CHECK: 'ADMIN.USERSLOGS.ACTIONS.CHECK',
        UPDATE_TYPE: 'ADMIN.USERSLOGS.ACTIONS.UPDATE_TYPE',
        UPDATE_ASSOCIATION: 'ADMIN.USERSLOGS.ACTIONS.UPDATE_ASSOCIATION',
        UPDATE_FIELD: 'ADMIN.USERSLOGS.ACTIONS.UPDATE_FIELD',
        ADD_FIELD: 'ADMIN.USERSLOGS.ACTIONS.ADD_FIELD',
        DELETE_DISPOSITION: 'ADMIN.USERSLOGS.ACTIONS.DELETE_DISPOSITION',
        ADD_DISPOSITION: 'ADMIN.USERSLOGS.ACTIONS.ADD_DISPOSITION',
        UPDATE_DISPOSITION: 'ADMIN.USERSLOGS.ACTIONS.UPDATE_DISPOSITION',
        LOGIN: 'ADMIN.USERSLOGS.ACTIONS.LOGIN',
        LOGOUT: 'ADMIN.USERSLOGS.ACTIONS.LOGOUT'
      },
      DISPLAY_MODELS_ICONS: [
        { name: 'PHONE', value: 'icon-phone' },
        { name: 'CELLPHONE', value: 'icon-cellphone' },
        { name: 'MAIL', value: 'icon-email' },
        { name: 'WEB', value: 'icon-web' }
      ],
      MODELS_TYPES: {
        COMPANY_MODEL: 'COMPANY_MODEL',
        CONTACT_MODEL: 'CONTACT_MODEL',

      },
      TYPES_INSCRIPTION_FIELD: [
        'HEADER', 'FIELD', 'EXPLANATION'
      ],
      MODEL_TYPES: [
        'COMPANY_MODEL', 'CONTACT_MODEL', 'INSCRIPTION_MODEL', 'LOGISTIC_MODEL'
      ]

    });


})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider, $translatePartialLoaderProvider, ngQuillConfigProvider, STORAGE_PREFIX, $addthisProvider,$mdDateLocaleProvider)
    {
		  // Put your common app configurations here

		  $addthisProvider.disableAutoAdd();
		  $addthisProvider.config({
			'pubid': 'ra-5d7797ca1a2f8955'
		  });

        // angular-translate configuration

        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json',
            loadFailureHandler: 'ErrorTranslationHandler'
		  });
		  localStorage[STORAGE_PREFIX + 'language'] = 'fr';
        if (localStorage[STORAGE_PREFIX + 'language'] == null){
            $translateProvider.preferredLanguage('fr');
            $translateProvider.use('fr');
        }else{
            $translateProvider.preferredLanguage(localStorage[STORAGE_PREFIX + 'language']);
            $translateProvider.use(localStorage[STORAGE_PREFIX + 'language']);
        }
        $translateProvider.fallbackLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');
        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');

        $translatePartialLoaderProvider.addPart('app/main/home');


        var FontAttributor = Quill.import('attributors/class/font');
        FontAttributor.whitelist = [
        'roboto'
        ];
        Quill.register(FontAttributor, true);
        ngQuillConfigProvider.set({
            bounds: 'self',
            placeholder: '',
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote', 'code-block'],

                    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
                    [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
                    [{ 'direction': 'rtl' }],                         // text direction

                    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'align': [] }],

                    ['clean'],                                         // remove formatting button

                    ['link', 'image']                         // link and image, video
                  ]
            }
		  });


		    // Example of a French localization.
			 $mdDateLocaleProvider.months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre','décembre'];
			 $mdDateLocaleProvider.shortMonths = ['jan', 'fév', 'mar', 'avr', 'mai', 'juin', 'juil', 'août','sep','oct','nov','déc'];
			 $mdDateLocaleProvider.days = ['dimanche', 'lundi', 'mardi', 'mercredi','jeudi','vendredi','samedi'];
			 $mdDateLocaleProvider.shortDays = ['Di', 'Lu', 'Ma', 'Me','Je','Ve','Sa'];

			 // Can change week display to start on Monday.
			 $mdDateLocaleProvider.firstDayOfWeek = 1;

    }

})();

(function () {
	'use strict';

	angular
		.module('fuse')
		.factory('ErrorTranslationHandler', ErrorTranslationHandler);

	/** @ngInject */
	function ErrorTranslationHandler($q) {
		return function (part, lang, response) {
			return $q.when({});
		};
	}

})();

/*!
 * html2canvas 1.0.0-rc.5 <https://html2canvas.hertzen.com>
 * Copyright (c) 2019 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
!function(A,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(A=A||self).html2canvas=e()}(this,function(){"use strict";
/*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */var r=function(A,e){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(A,e){A.__proto__=e}||function(A,e){for(var t in e)e.hasOwnProperty(t)&&(A[t]=e[t])})(A,e)};function A(A,e){function t(){this.constructor=A}r(A,e),A.prototype=null===e?Object.create(e):(t.prototype=e.prototype,new t)}var K=function(){return(K=Object.assign||function(A){for(var e,t=1,r=arguments.length;t<r;t++)for(var n in e=arguments[t])Object.prototype.hasOwnProperty.call(e,n)&&(A[n]=e[n]);return A}).apply(this,arguments)};function a(B,s,o,i){return new(o||(o=Promise))(function(A,e){function t(A){try{n(i.next(A))}catch(A){e(A)}}function r(A){try{n(i.throw(A))}catch(A){e(A)}}function n(e){e.done?A(e.value):new o(function(A){A(e.value)}).then(t,r)}n((i=i.apply(B,s||[])).next())})}function S(t,r){var n,B,s,A,o={label:0,sent:function(){if(1&s[0])throw s[1];return s[1]},trys:[],ops:[]};return A={next:e(0),throw:e(1),return:e(2)},"function"==typeof Symbol&&(A[Symbol.iterator]=function(){return this}),A;function e(e){return function(A){return function(e){if(n)throw new TypeError("Generator is already executing.");for(;o;)try{if(n=1,B&&(s=2&e[0]?B.return:e[0]?B.throw||((s=B.return)&&s.call(B),0):B.next)&&!(s=s.call(B,e[1])).done)return s;switch(B=0,s&&(e=[2&e[0],s.value]),e[0]){case 0:case 1:s=e;break;case 4:return o.label++,{value:e[1],done:!1};case 5:o.label++,B=e[1],e=[0];continue;case 7:e=o.ops.pop(),o.trys.pop();continue;default:if(!(s=0<(s=o.trys).length&&s[s.length-1])&&(6===e[0]||2===e[0])){o=0;continue}if(3===e[0]&&(!s||e[1]>s[0]&&e[1]<s[3])){o.label=e[1];break}if(6===e[0]&&o.label<s[1]){o.label=s[1],s=e;break}if(s&&o.label<s[2]){o.label=s[2],o.ops.push(e);break}s[2]&&o.ops.pop(),o.trys.pop();continue}e=r.call(t,o)}catch(A){e=[6,A],B=0}finally{n=s=0}if(5&e[0])throw e[1];return{value:e[0]?e[1]:void 0,done:!0}}([e,A])}}}var I=(n.prototype.add=function(A,e,t,r){return new n(this.left+A,this.top+e,this.width+t,this.height+r)},n.fromClientRect=function(A){return new n(A.left,A.top,A.width,A.height)},n);function n(A,e,t,r){this.left=A,this.top=e,this.width=t,this.height=r}for(var T=function(A){return I.fromClientRect(A.getBoundingClientRect())},c=function(A){for(var e=[],t=0,r=A.length;t<r;){var n=A.charCodeAt(t++);if(55296<=n&&n<=56319&&t<r){var B=A.charCodeAt(t++);56320==(64512&B)?e.push(((1023&n)<<10)+(1023&B)+65536):(e.push(n),t--)}else e.push(n)}return e},l=function(){for(var A=[],e=0;e<arguments.length;e++)A[e]=arguments[e];if(String.fromCodePoint)return String.fromCodePoint.apply(String,A);var t=A.length;if(!t)return"";for(var r=[],n=-1,B="";++n<t;){var s=A[n];s<=65535?r.push(s):(s-=65536,r.push(55296+(s>>10),s%1024+56320)),(n+1===t||16384<r.length)&&(B+=String.fromCharCode.apply(String,r),r.length=0)}return B},e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",Q="undefined"==typeof Uint8Array?[]:new Uint8Array(256),t=0;t<e.length;t++)Q[e.charCodeAt(t)]=t;function B(A,e,t){return A.slice?A.slice(e,t):new Uint16Array(Array.prototype.slice.call(A,e,t))}var s=(o.prototype.get=function(A){var e;if(0<=A){if(A<55296||56319<A&&A<=65535)return e=((e=this.index[A>>5])<<2)+(31&A),this.data[e];if(A<=65535)return e=((e=this.index[2048+(A-55296>>5)])<<2)+(31&A),this.data[e];if(A<this.highStart)return e=2080+(A>>11),e=this.index[e],e+=A>>5&63,e=((e=this.index[e])<<2)+(31&A),this.data[e];if(A<=1114111)return this.data[this.highValueIndex]}return this.errorValue},o);function o(A,e,t,r,n,B){this.initialValue=A,this.errorValue=e,this.highStart=t,this.highValueIndex=r,this.index=n,this.data=B}function C(A,e,t,r){var n=r[t];if(Array.isArray(A)?-1!==A.indexOf(n):A===n)for(var B=t;B<=r.length;){if((i=r[++B])===e)return!0;if(i!==H)break}if(n===H)for(B=t;0<B;){var s=r[--B];if(Array.isArray(A)?-1!==A.indexOf(s):A===s)for(var o=t;o<=r.length;){var i;if((i=r[++o])===e)return!0;if(i!==H)break}if(s!==H)break}return!1}function g(A,e){for(var t=A;0<=t;){var r=e[t];if(r!==H)return r;t--}return 0}function w(A,e,t,r,n){if(0===t[r])return Y;var B=r-1;if(Array.isArray(n)&&!0===n[B])return Y;var s=B-1,o=1+B,i=e[B],a=0<=s?e[s]:0,c=e[o];if(2===i&&3===c)return Y;if(-1!==j.indexOf(i))return"!";if(-1!==j.indexOf(c))return Y;if(-1!==$.indexOf(c))return Y;if(8===g(B,e))return"÷";if(11===q.get(A[B])&&(c===X||c===P||c===x))return Y;if(7===i||7===c)return Y;if(9===i)return Y;if(-1===[H,d,f].indexOf(i)&&9===c)return Y;if(-1!==[p,N,m,O,y].indexOf(c))return Y;if(g(B,e)===v)return Y;if(C(23,v,B,e))return Y;if(C([p,N],L,B,e))return Y;if(C(12,12,B,e))return Y;if(i===H)return"÷";if(23===i||23===c)return Y;if(16===c||16===i)return"÷";if(-1!==[d,f,L].indexOf(c)||14===i)return Y;if(36===a&&-1!==rA.indexOf(i))return Y;if(i===y&&36===c)return Y;if(c===R&&-1!==Z.concat(R,m,D,X,P,x).indexOf(i))return Y;if(-1!==Z.indexOf(c)&&i===D||-1!==Z.indexOf(i)&&c===D)return Y;if(i===M&&-1!==[X,P,x].indexOf(c)||-1!==[X,P,x].indexOf(i)&&c===b)return Y;if(-1!==Z.indexOf(i)&&-1!==AA.indexOf(c)||-1!==AA.indexOf(i)&&-1!==Z.indexOf(c))return Y;if(-1!==[M,b].indexOf(i)&&(c===D||-1!==[v,f].indexOf(c)&&e[1+o]===D)||-1!==[v,f].indexOf(i)&&c===D||i===D&&-1!==[D,y,O].indexOf(c))return Y;if(-1!==[D,y,O,p,N].indexOf(c))for(var Q=B;0<=Q;){if((w=e[Q])===D)return Y;if(-1===[y,O].indexOf(w))break;Q--}if(-1!==[M,b].indexOf(c))for(Q=-1!==[p,N].indexOf(i)?s:B;0<=Q;){var w;if((w=e[Q])===D)return Y;if(-1===[y,O].indexOf(w))break;Q--}if(J===i&&-1!==[J,G,V,z].indexOf(c)||-1!==[G,V].indexOf(i)&&-1!==[G,k].indexOf(c)||-1!==[k,z].indexOf(i)&&c===k)return Y;if(-1!==tA.indexOf(i)&&-1!==[R,b].indexOf(c)||-1!==tA.indexOf(c)&&i===M)return Y;if(-1!==Z.indexOf(i)&&-1!==Z.indexOf(c))return Y;if(i===O&&-1!==Z.indexOf(c))return Y;if(-1!==Z.concat(D).indexOf(i)&&c===v||-1!==Z.concat(D).indexOf(c)&&i===N)return Y;if(41===i&&41===c){for(var u=t[B],U=1;0<u&&41===e[--u];)U++;if(U%2!=0)return Y}return i===P&&c===x?Y:"÷"}function u(t,A){A||(A={lineBreak:"normal",wordBreak:"normal"});var e=function(A,n){void 0===n&&(n="strict");var B=[],s=[],o=[];return A.forEach(function(A,e){var t=q.get(A);if(50<t?(o.push(!0),t-=50):o.push(!1),-1!==["normal","auto","loose"].indexOf(n)&&-1!==[8208,8211,12316,12448].indexOf(A))return s.push(e),B.push(16);if(4!==t&&11!==t)return s.push(e),31===t?B.push("strict"===n?L:X):t===W?B.push(_):29===t?B.push(_):43===t?131072<=A&&A<=196605||196608<=A&&A<=262141?B.push(X):B.push(_):void B.push(t);if(0===e)return s.push(e),B.push(_);var r=B[e-1];return-1===eA.indexOf(r)?(s.push(s[e-1]),B.push(r)):(s.push(e),B.push(_))}),[s,B,o]}(t,A.lineBreak),r=e[0],n=e[1],B=e[2];return"break-all"!==A.wordBreak&&"break-word"!==A.wordBreak||(n=n.map(function(A){return-1!==[D,_,W].indexOf(A)?X:A})),[r,n,"keep-all"===A.wordBreak?B.map(function(A,e){return A&&19968<=t[e]&&t[e]<=40959}):void 0]}var i,U,E,F,h,H=10,d=13,f=15,p=17,N=18,m=19,R=20,L=21,v=22,O=24,D=25,b=26,M=27,y=28,_=30,P=32,x=33,V=34,z=35,X=37,J=38,G=39,k=40,W=42,Y="×",q=(i=function(A){var e,t,r,n,B,s=.75*A.length,o=A.length,i=0;"="===A[A.length-1]&&(s--,"="===A[A.length-2]&&s--);var a="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array&&void 0!==Uint8Array.prototype.slice?new ArrayBuffer(s):new Array(s),c=Array.isArray(a)?a:new Uint8Array(a);for(e=0;e<o;e+=4)t=Q[A.charCodeAt(e)],r=Q[A.charCodeAt(e+1)],n=Q[A.charCodeAt(e+2)],B=Q[A.charCodeAt(e+3)],c[i++]=t<<2|r>>4,c[i++]=(15&r)<<4|n>>2,c[i++]=(3&n)<<6|63&B;return a}("KwAAAAAAAAAACA4AIDoAAPAfAAACAAAAAAAIABAAGABAAEgAUABYAF4AZgBeAGYAYABoAHAAeABeAGYAfACEAIAAiACQAJgAoACoAK0AtQC9AMUAXgBmAF4AZgBeAGYAzQDVAF4AZgDRANkA3gDmAOwA9AD8AAQBDAEUARoBIgGAAIgAJwEvATcBPwFFAU0BTAFUAVwBZAFsAXMBewGDATAAiwGTAZsBogGkAawBtAG8AcIBygHSAdoB4AHoAfAB+AH+AQYCDgIWAv4BHgImAi4CNgI+AkUCTQJTAlsCYwJrAnECeQKBAk0CiQKRApkCoQKoArACuALAAsQCzAIwANQC3ALkAjAA7AL0AvwCAQMJAxADGAMwACADJgMuAzYDPgOAAEYDSgNSA1IDUgNaA1oDYANiA2IDgACAAGoDgAByA3YDfgOAAIQDgACKA5IDmgOAAIAAogOqA4AAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAK8DtwOAAIAAvwPHA88D1wPfAyAD5wPsA/QD/AOAAIAABAQMBBIEgAAWBB4EJgQuBDMEIAM7BEEEXgBJBCADUQRZBGEEaQQwADAAcQQ+AXkEgQSJBJEEgACYBIAAoASoBK8EtwQwAL8ExQSAAIAAgACAAIAAgACgAM0EXgBeAF4AXgBeAF4AXgBeANUEXgDZBOEEXgDpBPEE+QQBBQkFEQUZBSEFKQUxBTUFPQVFBUwFVAVcBV4AYwVeAGsFcwV7BYMFiwWSBV4AmgWgBacFXgBeAF4AXgBeAKsFXgCyBbEFugW7BcIFwgXIBcIFwgXQBdQF3AXkBesF8wX7BQMGCwYTBhsGIwYrBjMGOwZeAD8GRwZNBl4AVAZbBl4AXgBeAF4AXgBeAF4AXgBeAF4AXgBeAGMGXgBqBnEGXgBeAF4AXgBeAF4AXgBeAF4AXgB5BoAG4wSGBo4GkwaAAIADHgR5AF4AXgBeAJsGgABGA4AAowarBrMGswagALsGwwbLBjAA0wbaBtoG3QbaBtoG2gbaBtoG2gblBusG8wb7BgMHCwcTBxsHCwcjBysHMAc1BzUHOgdCB9oGSgdSB1oHYAfaBloHaAfaBlIH2gbaBtoG2gbaBtoG2gbaBjUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHbQdeAF4ANQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQd1B30HNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1B4MH2gaKB68EgACAAIAAgACAAIAAgACAAI8HlwdeAJ8HpweAAIAArwe3B14AXgC/B8UHygcwANAH2AfgB4AA6AfwBz4B+AcACFwBCAgPCBcIogEYAR8IJwiAAC8INwg/CCADRwhPCFcIXwhnCEoDGgSAAIAAgABvCHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIhAiLCI4IMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlggwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAANQc1BzUHNQc1BzUHNQc1BzUHNQc1B54INQc1B6II2gaqCLIIugiAAIAAvgjGCIAAgACAAIAAgACAAIAAgACAAIAAywiHAYAA0wiAANkI3QjlCO0I9Aj8CIAAgACAAAIJCgkSCRoJIgknCTYHLwk3CZYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiAAIAAAAFAAXgBeAGAAcABeAHwAQACQAKAArQC9AJ4AXgBeAE0A3gBRAN4A7AD8AMwBGgEAAKcBNwEFAUwBXAF4QkhCmEKnArcCgAHHAsABz4LAAcABwAHAAd+C6ABoAG+C/4LAAcABwAHAAc+DF4MAAcAB54M3gweDV4Nng3eDaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAEeDqABVg6WDqABoQ6gAaABoAHXDvcONw/3DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DncPAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcAB7cPPwlGCU4JMACAAIAAgABWCV4JYQmAAGkJcAl4CXwJgAkwADAAMAAwAIgJgACLCZMJgACZCZ8JowmrCYAAswkwAF4AXgB8AIAAuwkABMMJyQmAAM4JgADVCTAAMAAwADAAgACAAIAAgACAAIAAgACAAIAAqwYWBNkIMAAwADAAMADdCeAJ6AnuCR4E9gkwAP4JBQoNCjAAMACAABUK0wiAAB0KJAosCjQKgAAwADwKQwqAAEsKvQmdCVMKWwowADAAgACAALcEMACAAGMKgABrCjAAMAAwADAAMAAwADAAMAAwADAAMAAeBDAAMAAwADAAMAAwADAAMAAwADAAMAAwAIkEPQFzCnoKiQSCCooKkAqJBJgKoAqkCokEGAGsCrQKvArBCjAAMADJCtEKFQHZCuEK/gHpCvEKMAAwADAAMACAAIwE+QowAIAAPwEBCzAAMAAwADAAMACAAAkLEQswAIAAPwEZCyELgAAOCCkLMAAxCzkLMAAwADAAMAAwADAAXgBeAEELMAAwADAAMAAwADAAMAAwAEkLTQtVC4AAXAtkC4AAiQkwADAAMAAwADAAMAAwADAAbAtxC3kLgAuFC4sLMAAwAJMLlwufCzAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAApwswADAAMACAAIAAgACvC4AAgACAAIAAgACAALcLMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAvwuAAMcLgACAAIAAgACAAIAAyguAAIAAgACAAIAA0QswADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAANkLgACAAIAA4AswADAAMAAwADAAMAAwADAAMAAwADAAMAAwAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACJCR4E6AswADAAhwHwC4AA+AsADAgMEAwwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMACAAIAAGAwdDCUMMAAwAC0MNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQw1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHPQwwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADUHNQc1BzUHNQc1BzUHNQc2BzAAMAA5DDUHNQc1BzUHNQc1BzUHNQc1BzUHNQdFDDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAgACAAIAATQxSDFoMMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAF4AXgBeAF4AXgBeAF4AYgxeAGoMXgBxDHkMfwxeAIUMXgBeAI0MMAAwADAAMAAwAF4AXgCVDJ0MMAAwADAAMABeAF4ApQxeAKsMswy7DF4Awgy9DMoMXgBeAF4AXgBeAF4AXgBeAF4AXgDRDNkMeQBqCeAM3Ax8AOYM7Az0DPgMXgBeAF4AXgBeAF4AXgBeAF4AXgBeAF4AXgBeAF4AXgCgAAANoAAHDQ4NFg0wADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAeDSYNMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAIAAgACAAIAAgACAAC4NMABeAF4ANg0wADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAD4NRg1ODVYNXg1mDTAAbQ0wADAAMAAwADAAMAAwADAA2gbaBtoG2gbaBtoG2gbaBnUNeg3CBYANwgWFDdoGjA3aBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gaUDZwNpA2oDdoG2gawDbcNvw3HDdoG2gbPDdYN3A3fDeYN2gbsDfMN2gbaBvoN/g3aBgYODg7aBl4AXgBeABYOXgBeACUG2gYeDl4AJA5eACwO2w3aBtoGMQ45DtoG2gbaBtoGQQ7aBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gZJDjUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1B1EO2gY1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQdZDjUHNQc1BzUHNQc1B2EONQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHaA41BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1B3AO2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gY1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1B2EO2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gZJDtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBkkOeA6gAKAAoAAwADAAMAAwAKAAoACgAKAAoACgAKAAgA4wADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAD//wQABAAEAAQABAAEAAQABAAEAA0AAwABAAEAAgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAKABMAFwAeABsAGgAeABcAFgASAB4AGwAYAA8AGAAcAEsASwBLAEsASwBLAEsASwBLAEsAGAAYAB4AHgAeABMAHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAFgAbABIAHgAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABYADQARAB4ABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAUABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAkAFgAaABsAGwAbAB4AHQAdAB4ATwAXAB4ADQAeAB4AGgAbAE8ATwAOAFAAHQAdAB0ATwBPABcATwBPAE8AFgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAB4AUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAFAATwBAAE8ATwBPAEAATwBQAFAATwBQAB4AHgAeAB4AHgAeAB0AHQAdAB0AHgAdAB4ADgBQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgBQAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAJAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAkACQAJAAkACQAJAAkABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAFAAHgAeAB4AKwArAFAAUABQAFAAGABQACsAKwArACsAHgAeAFAAHgBQAFAAUAArAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUAAeAB4AHgAeAB4AHgArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwAYAA0AKwArAB4AHgAbACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQADQAEAB4ABAAEAB4ABAAEABMABAArACsAKwArACsAKwArACsAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAKwArACsAKwArAFYAVgBWAB4AHgArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AGgAaABoAGAAYAB4AHgAEAAQABAAEAAQABAAEAAQABAAEAAQAEwAEACsAEwATAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABLAEsASwBLAEsASwBLAEsASwBLABoAGQAZAB4AUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABMAUAAEAAQABAAEAAQABAAEAB4AHgAEAAQABAAEAAQABABQAFAABAAEAB4ABAAEAAQABABQAFAASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUAAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAFAABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQAUABQAB4AHgAYABMAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAFAABAAEAAQABAAEAFAABAAEAAQAUAAEAAQABAAEAAQAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAArACsAHgArAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAABAAEAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAAQABAANAA0ASwBLAEsASwBLAEsASwBLAEsASwAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQAKwBQAFAAUABQAFAAUABQAFAAKwArAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAKwArACsAUABQAFAAUAArACsABABQAAQABAAEAAQABAAEAAQAKwArAAQABAArACsABAAEAAQAUAArACsAKwArACsAKwArACsABAArACsAKwArAFAAUAArAFAAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAGgAaAFAAUABQAFAAUABMAB4AGwBQAB4AKwArACsABAAEAAQAKwBQAFAAUABQAFAAUAArACsAKwArAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAUAArAFAAUAArAFAAUAArACsABAArAAQABAAEAAQABAArACsAKwArAAQABAArACsABAAEAAQAKwArACsABAArACsAKwArACsAKwArAFAAUABQAFAAKwBQACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwAEAAQAUABQAFAABAArACsAKwArACsAKwArACsAKwArACsABAAEAAQAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAUAArAFAAUABQAFAAUAArACsABABQAAQABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQAKwArAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwAeABsAKwArACsAKwArACsAKwBQAAQABAAEAAQABAAEACsABAAEAAQAKwBQAFAAUABQAFAAUABQAFAAKwArAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQAKwArAAQABAArACsABAAEAAQAKwArACsAKwArACsAKwArAAQABAArACsAKwArAFAAUAArAFAAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwAeAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwAEAFAAKwBQAFAAUABQAFAAUAArACsAKwBQAFAAUAArAFAAUABQAFAAKwArACsAUABQACsAUAArAFAAUAArACsAKwBQAFAAKwArACsAUABQAFAAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwAEAAQABAAEAAQAKwArACsABAAEAAQAKwAEAAQABAAEACsAKwBQACsAKwArACsAKwArAAQAKwArACsAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAB4AHgAeAB4AHgAeABsAHgArACsAKwArACsABAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQABAArACsAKwArACsAKwArAAQABAArAFAAUABQACsAKwArACsAKwBQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAB4AUAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQACsAKwAEAFAABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQABAArACsAKwArACsAKwArAAQABAArACsAKwArACsAKwArAFAAKwBQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAFAABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQABABQAB4AKwArACsAKwBQAFAAUAAEAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQABoAUABQAFAAUABQAFAAKwArAAQABAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQACsAUAArACsAUABQAFAAUABQAFAAUAArACsAKwAEACsAKwArACsABAAEAAQABAAEAAQAKwAEACsABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArAAQABAAeACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAXAAqACoAKgAqACoAKgAqACsAKwArACsAGwBcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAeAEsASwBLAEsASwBLAEsASwBLAEsADQANACsAKwArACsAKwBcAFwAKwBcACsAKwBcAFwAKwBcACsAKwBcACsAKwArACsAKwArAFwAXABcAFwAKwBcAFwAXABcAFwAXABcACsAXABcAFwAKwBcACsAXAArACsAXABcACsAXABcAFwAXAAqAFwAXAAqACoAKgAqACoAKgArACoAKgBcACsAKwBcAFwAXABcAFwAKwBcACsAKgAqACoAKgAqACoAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArAFwAXABcAFwAUAAOAA4ADgAOAB4ADgAOAAkADgAOAA0ACQATABMAEwATABMACQAeABMAHgAeAB4ABAAEAB4AHgAeAB4AHgAeAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUAANAAQAHgAEAB4ABAAWABEAFgARAAQABABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAANAAQABAAEAAQABAANAAQABABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsADQANAB4AHgAeAB4AHgAeAAQAHgAeAB4AHgAeAB4AKwAeAB4ADgAOAA0ADgAeAB4AHgAeAB4ACQAJACsAKwArACsAKwBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqAFwASwBLAEsASwBLAEsASwBLAEsASwANAA0AHgAeAB4AHgBcAFwAXABcAFwAXAAqACoAKgAqAFwAXABcAFwAKgAqACoAXAAqACoAKgBcAFwAKgAqACoAKgAqACoAKgBcAFwAXAAqACoAKgAqAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAKgAqACoAKgAqACoAKgAqACoAXAAqAEsASwBLAEsASwBLAEsASwBLAEsAKgAqACoAKgAqACoAUABQAFAAUABQAFAAKwBQACsAKwArACsAKwBQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQACsAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwAEAAQABAAeAA0AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQACsAKwANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABYAEQArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAADQANAA0AUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAABAAEAAQAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAA0ADQArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQACsABAAEACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoADQANABUAXAANAB4ADQAbAFwAKgArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArAB4AHgATABMADQANAA4AHgATABMAHgAEAAQABAAJACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAUABQAFAAUABQAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABABQACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwAeACsAKwArABMAEwBLAEsASwBLAEsASwBLAEsASwBLAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAKwBcAFwAXABcAFwAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAKwArACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBcACsAKwArACoAKgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEACsAKwAeAB4AXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAKgAqACoAKgAqACoAKgArACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgArACsABABLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKgAqACoAKgAqACoAKgBcACoAKgAqACoAKgAqACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQAUABQAFAAUABQAFAAUAArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsADQANAB4ADQANAA0ADQAeAB4AHgAeAB4AHgAeAB4AHgAeAAQABAAEAAQABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeACsAKwArAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAUABQAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAHgAeAB4AHgBQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwANAA0ADQANAA0ASwBLAEsASwBLAEsASwBLAEsASwArACsAKwBQAFAAUABLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAANAA0AUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsABAAEAAQAHgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAAUABQAFAABABQAFAAUABQAAQABAAEAFAAUAAEAAQABAArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwAEAAQABAAEAAQAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUAArAFAAKwBQACsAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAHgAeAB4AHgAeAB4AHgAeAFAAHgAeAB4AUABQAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAKwArAB4AHgAeAB4AHgAeACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAUABQAFAAKwAeAB4AHgAeAB4AHgAeAA4AHgArAA0ADQANAA0ADQANAA0ACQANAA0ADQAIAAQACwAEAAQADQAJAA0ADQAMAB0AHQAeABcAFwAWABcAFwAXABYAFwAdAB0AHgAeABQAFAAUAA0AAQABAAQABAAEAAQABAAJABoAGgAaABoAGgAaABoAGgAeABcAFwAdABUAFQAeAB4AHgAeAB4AHgAYABYAEQAVABUAFQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgANAB4ADQANAA0ADQAeAA0ADQANAAcAHgAeAB4AHgArAAQABAAEAAQABAAEAAQABAAEAAQAUABQACsAKwBPAFAAUABQAFAAUAAeAB4AHgAWABEATwBQAE8ATwBPAE8AUABQAFAAUABQAB4AHgAeABYAEQArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAGwAbABsAGwAbABsAGwAaABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAaABsAGwAbABsAGgAbABsAGgAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgBQABoAHgAdAB4AUAAeABoAHgAeAB4AHgAeAB4AHgAeAB4ATwAeAFAAGwAeAB4AUABQAFAAUABQAB4AHgAeAB0AHQAeAFAAHgBQAB4AUAAeAFAATwBQAFAAHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAB4AUABQAFAAUABPAE8AUABQAFAAUABQAE8AUABQAE8AUABPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBQAFAAUABQAE8ATwBPAE8ATwBPAE8ATwBPAE8AUABQAFAAUABQAFAAUABQAFAAHgAeAFAAUABQAFAATwAeAB4AKwArACsAKwAdAB0AHQAdAB0AHQAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAeAB0AHQAeAB4AHgAdAB0AHgAeAB0AHgAeAB4AHQAeAB0AGwAbAB4AHQAeAB4AHgAeAB0AHgAeAB0AHQAdAB0AHgAeAB0AHgAdAB4AHQAdAB0AHQAdAB0AHgAdAB4AHgAeAB4AHgAdAB0AHQAdAB4AHgAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAeAB4AHgAdAB4AHgAeAB4AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB4AHgAdAB0AHQAdAB4AHgAdAB0AHgAeAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAeAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHQAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABQAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAFgARAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAlACUAHgAeAB4AHgAeAB4AHgAeAB4AFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBQAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB4AHgAeAB4AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAdAB0AHQAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAeAB0AHQAeAB4AHgAeAB0AHQAeAB4AHgAeAB0AHQAdAB4AHgAdAB4AHgAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAeAB0AHQAeAB4AHQAeAB4AHgAeAB0AHQAeAB4AHgAeACUAJQAdAB0AJQAeACUAJQAlACAAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAHgAeAB4AHgAdAB4AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB4AHQAdAB0AHgAdACUAHQAdAB4AHQAdAB4AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAHQAdAB0AHQAlAB4AJQAlACUAHQAlACUAHQAdAB0AJQAlAB0AHQAlAB0AHQAlACUAJQAeAB0AHgAeAB4AHgAdAB0AJQAdAB0AHQAdAB0AHQAlACUAJQAlACUAHQAlACUAIAAlAB0AHQAlACUAJQAlACUAJQAlACUAHgAeAB4AJQAlACAAIAAgACAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHgAeABcAFwAXABcAFwAXAB4AEwATACUAHgAeAB4AFgARABYAEQAWABEAFgARABYAEQAWABEAFgARAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARABYAEQAWABEAFgARABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAEAAQABAAeAB4AKwArACsAKwArABMADQANAA0AUAATAA0AUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUAANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAA0ADQANAA0ADQANAA0ADQAeAA0AFgANAB4AHgAXABcAHgAeABcAFwAWABEAFgARABYAEQAWABEADQANAA0ADQATAFAADQANAB4ADQANAB4AHgAeAB4AHgAMAAwADQANAA0AHgANAA0AFgANAA0ADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArAA0AEQARACUAJQBHAFcAVwAWABEAFgARABYAEQAWABEAFgARACUAJQAWABEAFgARABYAEQAWABEAFQAWABEAEQAlAFcAVwBXAFcAVwBXAFcAVwBXAAQABAAEAAQABAAEACUAVwBXAFcAVwA2ACUAJQBXAFcAVwBHAEcAJQAlACUAKwBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBRAFcAUQBXAFEAVwBXAFcAVwBXAFcAUQBXAFcAVwBXAFcAVwBRAFEAKwArAAQABAAVABUARwBHAFcAFQBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBRAFcAVwBXAFcAVwBXAFEAUQBXAFcAVwBXABUAUQBHAEcAVwArACsAKwArACsAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwArACUAJQBXAFcAVwBXACUAJQAlACUAJQAlACUAJQAlACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArACsAKwArACUAJQAlACUAKwArACsAKwArACsAKwArACsAKwArACsAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACsAVwBXAFcAVwBXAFcAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAE8ATwBPAE8ATwBPAE8ATwAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlACUAJQAlACUAJQAlACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADQATAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABLAEsASwBLAEsASwBLAEsASwBLAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAABAAEAAQABAAeAAQABAAEAAQABAAEAAQABAAEAAQAHgBQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUABQAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAeAA0ADQANAA0ADQArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAB4AHgAeAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAAQAUABQAFAABABQAFAAUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAeAB4AHgAeACsAKwArACsAUABQAFAAUABQAFAAHgAeABoAHgArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADgAOABMAEwArACsAKwArACsAKwArACsABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwANAA0ASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUAAeAB4AHgBQAA4AUAArACsAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAA0ADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArAB4AWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYACsAKwArAAQAHgAeAB4AHgAeAB4ADQANAA0AHgAeAB4AHgArAFAASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArAB4AHgBcAFwAXABcAFwAKgBcAFwAXABcAFwAXABcAFwAXABcAEsASwBLAEsASwBLAEsASwBLAEsAXABcAFwAXABcACsAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArAFAAUABQAAQAUABQAFAAUABQAFAAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAHgANAA0ADQBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAXAAqACoAKgBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAKgAqACoAXABcACoAKgBcAFwAXABcAFwAKgAqAFwAKgBcACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcACoAKgBQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAA0ADQBQAFAAUAAEAAQAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQADQAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAVABVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBUAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVACsAKwArACsAKwArACsAKwArACsAKwArAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAKwArACsAKwBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAKwArACsAKwAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAKwArACsAKwArAFYABABWAFYAVgBWAFYAVgBWAFYAVgBWAB4AVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgArAFYAVgBWAFYAVgArAFYAKwBWAFYAKwBWAFYAKwBWAFYAVgBWAFYAVgBWAFYAVgBWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAEQAWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAaAB4AKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAGAARABEAGAAYABMAEwAWABEAFAArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACUAJQAlACUAJQAWABEAFgARABYAEQAWABEAFgARABYAEQAlACUAFgARACUAJQAlACUAJQAlACUAEQAlABEAKwAVABUAEwATACUAFgARABYAEQAWABEAJQAlACUAJQAlACUAJQAlACsAJQAbABoAJQArACsAKwArAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAcAKwATACUAJQAbABoAJQAlABYAEQAlACUAEQAlABEAJQBXAFcAVwBXAFcAVwBXAFcAVwBXABUAFQAlACUAJQATACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXABYAJQARACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAWACUAEQAlABYAEQARABYAEQARABUAVwBRAFEAUQBRAFEAUQBRAFEAUQBRAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcARwArACsAVwBXAFcAVwBXAFcAKwArAFcAVwBXAFcAVwBXACsAKwBXAFcAVwBXAFcAVwArACsAVwBXAFcAKwArACsAGgAbACUAJQAlABsAGwArAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwAEAAQABAAQAB0AKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsADQANAA0AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsADQBQAFAAUABQACsAKwArACsAUABQAFAAUABQAFAAUABQAA0AUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUAArACsAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQACsAKwArAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgBQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwBQAFAAUABQAFAABAAEAAQAKwAEAAQAKwArACsAKwArAAQABAAEAAQAUABQAFAAUAArAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsABAAEAAQAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsADQANAA0ADQANAA0ADQANAB4AKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AUABQAFAAUABQAFAAUABQAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwArACsAUABQAFAAUABQAA0ADQANAA0ADQANABQAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwANAA0ADQANAA0ADQANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwBQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAA0ADQAeAB4AHgAeAB4AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsASwBLAEsASwBLAEsASwBLAEsASwANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAeAA4AUAArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAADQANAB4ADQAeAAQABAAEAB4AKwArAEsASwBLAEsASwBLAEsASwBLAEsAUAAOAFAADQANAA0AKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAANAA0AHgANAA0AHgAEACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAA0AKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsABAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABAArACsAUAArACsAKwArACsAKwAEACsAKwArACsAKwBQAFAAUABQAFAABAAEACsAKwAEAAQABAAEAAQABAAEACsAKwArAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAQABABQAFAAUABQAA0ADQANAA0AHgBLAEsASwBLAEsASwBLAEsASwBLACsADQArAB4AKwArAAQABAAEAAQAUABQAB4AUAArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEACsAKwAEAAQABAAEAAQABAAEAAQABAAOAA0ADQATABMAHgAeAB4ADQANAA0ADQANAA0ADQANAA0ADQANAA0ADQANAA0AUABQAFAAUAAEAAQAKwArAAQADQANAB4AUAArACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAArACsAKwAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAXABcAA0ADQANACoASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAFAABAAEAAQABAAOAB4ADQANAA0ADQAOAB4ABAArACsAKwArACsAKwArACsAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAUABQAFAAUAArACsAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAA0ADQANACsADgAOAA4ADQANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAAQABAAEAFAADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwAOABMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAArACsAKwAEACsABAAEACsABAAEAAQABAAEAAQABABQAAQAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABIAEgAQwBDAEMAUABQAFAAUABDAFAAUABQAEgAQwBIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABDAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwANAA0AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAANACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAA0ADQANAB4AHgAeAB4AHgAeAFAAUABQAFAADQAeACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAEcARwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwArACsAKwArACsAKwArACsAKwArACsAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQACsAKwAeAAQABAANAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAB4AHgAeAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAHgAeAAQABAAEAAQABAAEAAQAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAEAAQABAAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAFAAUAArACsAUAArACsAUABQACsAKwBQAFAAUABQACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwBQACsAUABQAFAAUABQAFAAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAKwAeAB4AUABQAFAAUABQACsAUAArACsAKwBQAFAAUABQAFAAUABQACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AKwArAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAEAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAeAB4ADQANAA0ADQAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsABAAEAAQABAAEAAQABAArAAQABAArAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAEAAQABAAEAAQABAAEACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAFgAWAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUAArAFAAKwArAFAAKwBQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUAArAFAAKwBQACsAKwArACsAKwArAFAAKwArACsAKwBQACsAUAArAFAAKwBQAFAAUAArAFAAUAArAFAAKwArAFAAKwBQACsAUAArAFAAKwBQACsAUABQACsAUAArACsAUABQAFAAUAArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQACsAUABQAFAAUAArAFAAKwBQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwBQAFAAUAArAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwAlACUAJQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAeACUAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeACUAJQAlACUAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQAlACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeACUAJQAlACUAJQAeACUAJQAlACUAJQAgACAAIAAlACUAIAAlACUAIAAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAIQAhACEAIQAhACUAJQAgACAAJQAlACAAIAAgACAAIAAgACAAIAAgACAAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAIAAgACAAIAAlACUAJQAlACAAJQAgACAAIAAgACAAIAAgACAAIAAlACUAJQAgACUAJQAlACUAIAAgACAAJQAgACAAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeACUAHgAlAB4AJQAlACUAJQAlACAAJQAlACUAJQAeACUAHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAIAAgACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAIAAlACUAJQAlACAAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAIAAgACAAJQAlACUAIAAgACAAIAAgAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFwAXABcAFQAVABUAHgAeAB4AHgAlACUAJQAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAIAAgACAAJQAlACUAJQAlACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACAAIAAlACAAIAAlACUAJQAlACUAJQAgACUAJQAlACUAJQAlACUAJQAlACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAIAAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACsAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsA"),U=Array.isArray(i)?function(A){for(var e=A.length,t=[],r=0;r<e;r+=4)t.push(A[r+3]<<24|A[r+2]<<16|A[r+1]<<8|A[r]);return t}(i):new Uint32Array(i),E=Array.isArray(i)?function(A){for(var e=A.length,t=[],r=0;r<e;r+=2)t.push(A[r+1]<<8|A[r]);return t}(i):new Uint16Array(i),F=B(E,12,U[4]/2),h=2===U[5]?B(E,(24+U[4])/2):function(A,e,t){return A.slice?A.slice(e,t):new Uint32Array(Array.prototype.slice.call(A,e,t))}(U,Math.ceil((24+U[4])/4)),new s(U[0],U[1],U[2],U[3],F,h)),Z=[_,36],j=[1,2,3,5],$=[H,8],AA=[M,b],eA=j.concat($),tA=[J,G,k,V,z],rA=[f,d],nA=(BA.prototype.slice=function(){return l.apply(void 0,this.codePoints.slice(this.start,this.end))},BA);function BA(A,e,t,r){this.codePoints=A,this.required="!"===e,this.start=t,this.end=r}var sA,oA;(oA=sA||(sA={}))[oA.STRING_TOKEN=0]="STRING_TOKEN",oA[oA.BAD_STRING_TOKEN=1]="BAD_STRING_TOKEN",oA[oA.LEFT_PARENTHESIS_TOKEN=2]="LEFT_PARENTHESIS_TOKEN",oA[oA.RIGHT_PARENTHESIS_TOKEN=3]="RIGHT_PARENTHESIS_TOKEN",oA[oA.COMMA_TOKEN=4]="COMMA_TOKEN",oA[oA.HASH_TOKEN=5]="HASH_TOKEN",oA[oA.DELIM_TOKEN=6]="DELIM_TOKEN",oA[oA.AT_KEYWORD_TOKEN=7]="AT_KEYWORD_TOKEN",oA[oA.PREFIX_MATCH_TOKEN=8]="PREFIX_MATCH_TOKEN",oA[oA.DASH_MATCH_TOKEN=9]="DASH_MATCH_TOKEN",oA[oA.INCLUDE_MATCH_TOKEN=10]="INCLUDE_MATCH_TOKEN",oA[oA.LEFT_CURLY_BRACKET_TOKEN=11]="LEFT_CURLY_BRACKET_TOKEN",oA[oA.RIGHT_CURLY_BRACKET_TOKEN=12]="RIGHT_CURLY_BRACKET_TOKEN",oA[oA.SUFFIX_MATCH_TOKEN=13]="SUFFIX_MATCH_TOKEN",oA[oA.SUBSTRING_MATCH_TOKEN=14]="SUBSTRING_MATCH_TOKEN",oA[oA.DIMENSION_TOKEN=15]="DIMENSION_TOKEN",oA[oA.PERCENTAGE_TOKEN=16]="PERCENTAGE_TOKEN",oA[oA.NUMBER_TOKEN=17]="NUMBER_TOKEN",oA[oA.FUNCTION=18]="FUNCTION",oA[oA.FUNCTION_TOKEN=19]="FUNCTION_TOKEN",oA[oA.IDENT_TOKEN=20]="IDENT_TOKEN",oA[oA.COLUMN_TOKEN=21]="COLUMN_TOKEN",oA[oA.URL_TOKEN=22]="URL_TOKEN",oA[oA.BAD_URL_TOKEN=23]="BAD_URL_TOKEN",oA[oA.CDC_TOKEN=24]="CDC_TOKEN",oA[oA.CDO_TOKEN=25]="CDO_TOKEN",oA[oA.COLON_TOKEN=26]="COLON_TOKEN",oA[oA.SEMICOLON_TOKEN=27]="SEMICOLON_TOKEN",oA[oA.LEFT_SQUARE_BRACKET_TOKEN=28]="LEFT_SQUARE_BRACKET_TOKEN",oA[oA.RIGHT_SQUARE_BRACKET_TOKEN=29]="RIGHT_SQUARE_BRACKET_TOKEN",oA[oA.UNICODE_RANGE_TOKEN=30]="UNICODE_RANGE_TOKEN",oA[oA.WHITESPACE_TOKEN=31]="WHITESPACE_TOKEN",oA[oA.EOF_TOKEN=32]="EOF_TOKEN";function iA(A){return 48<=A&&A<=57}function aA(A){return iA(A)||65<=A&&A<=70||97<=A&&A<=102}function cA(A){return 10===A||9===A||32===A}function QA(A){return function(A){return function(A){return 97<=A&&A<=122}(A)||function(A){return 65<=A&&A<=90}(A)}(A)||function(A){return 128<=A}(A)||95===A}function wA(A){return QA(A)||iA(A)||45===A}function uA(A,e){return 92===A&&10!==e}function UA(A,e,t){return 45===A?QA(e)||uA(e,t):!!QA(A)||!(92!==A||!uA(A,e))}function lA(A,e,t){return 43===A||45===A?!!iA(e)||46===e&&iA(t):iA(46===A?e:A)}var CA={type:sA.LEFT_PARENTHESIS_TOKEN},gA={type:sA.RIGHT_PARENTHESIS_TOKEN},EA={type:sA.COMMA_TOKEN},FA={type:sA.SUFFIX_MATCH_TOKEN},hA={type:sA.PREFIX_MATCH_TOKEN},HA={type:sA.COLUMN_TOKEN},dA={type:sA.DASH_MATCH_TOKEN},fA={type:sA.INCLUDE_MATCH_TOKEN},pA={type:sA.LEFT_CURLY_BRACKET_TOKEN},NA={type:sA.RIGHT_CURLY_BRACKET_TOKEN},KA={type:sA.SUBSTRING_MATCH_TOKEN},IA={type:sA.BAD_URL_TOKEN},TA={type:sA.BAD_STRING_TOKEN},mA={type:sA.CDO_TOKEN},RA={type:sA.CDC_TOKEN},LA={type:sA.COLON_TOKEN},vA={type:sA.SEMICOLON_TOKEN},OA={type:sA.LEFT_SQUARE_BRACKET_TOKEN},DA={type:sA.RIGHT_SQUARE_BRACKET_TOKEN},bA={type:sA.WHITESPACE_TOKEN},SA={type:sA.EOF_TOKEN},MA=(yA.prototype.write=function(A){this._value=this._value.concat(c(A))},yA.prototype.read=function(){for(var A=[],e=this.consumeToken();e!==SA;)A.push(e),e=this.consumeToken();return A},yA.prototype.consumeToken=function(){var A=this.consumeCodePoint();switch(A){case 34:return this.consumeStringToken(34);case 35:var e=this.peekCodePoint(0),t=this.peekCodePoint(1),r=this.peekCodePoint(2);if(wA(e)||uA(t,r)){var n=UA(e,t,r)?2:1,B=this.consumeName();return{type:sA.HASH_TOKEN,value:B,flags:n}}break;case 36:if(61===this.peekCodePoint(0))return this.consumeCodePoint(),FA;break;case 39:return this.consumeStringToken(39);case 40:return CA;case 41:return gA;case 42:if(61===this.peekCodePoint(0))return this.consumeCodePoint(),KA;break;case 43:if(lA(A,this.peekCodePoint(0),this.peekCodePoint(1)))return this.reconsumeCodePoint(A),this.consumeNumericToken();break;case 44:return EA;case 45:var s=A,o=this.peekCodePoint(0),i=this.peekCodePoint(1);if(lA(s,o,i))return this.reconsumeCodePoint(A),this.consumeNumericToken();if(UA(s,o,i))return this.reconsumeCodePoint(A),this.consumeIdentLikeToken();if(45===o&&62===i)return this.consumeCodePoint(),this.consumeCodePoint(),RA;break;case 46:if(lA(A,this.peekCodePoint(0),this.peekCodePoint(1)))return this.reconsumeCodePoint(A),this.consumeNumericToken();break;case 47:if(42===this.peekCodePoint(0))for(this.consumeCodePoint();;){var a=this.consumeCodePoint();if(42===a&&47===(a=this.consumeCodePoint()))return this.consumeToken();if(-1===a)return this.consumeToken()}break;case 58:return LA;case 59:return vA;case 60:if(33===this.peekCodePoint(0)&&45===this.peekCodePoint(1)&&45===this.peekCodePoint(2))return this.consumeCodePoint(),this.consumeCodePoint(),mA;break;case 64:var c=this.peekCodePoint(0),Q=this.peekCodePoint(1),w=this.peekCodePoint(2);if(UA(c,Q,w))return B=this.consumeName(),{type:sA.AT_KEYWORD_TOKEN,value:B};break;case 91:return OA;case 92:if(uA(A,this.peekCodePoint(0)))return this.reconsumeCodePoint(A),this.consumeIdentLikeToken();break;case 93:return DA;case 61:if(61===this.peekCodePoint(0))return this.consumeCodePoint(),hA;break;case 123:return pA;case 125:return NA;case 117:case 85:var u=this.peekCodePoint(0),U=this.peekCodePoint(1);return 43!==u||!aA(U)&&63!==U||(this.consumeCodePoint(),this.consumeUnicodeRangeToken()),this.reconsumeCodePoint(A),this.consumeIdentLikeToken();case 124:if(61===this.peekCodePoint(0))return this.consumeCodePoint(),dA;if(124===this.peekCodePoint(0))return this.consumeCodePoint(),HA;break;case 126:if(61===this.peekCodePoint(0))return this.consumeCodePoint(),fA;break;case-1:return SA}return cA(A)?(this.consumeWhiteSpace(),bA):iA(A)?(this.reconsumeCodePoint(A),this.consumeNumericToken()):QA(A)?(this.reconsumeCodePoint(A),this.consumeIdentLikeToken()):{type:sA.DELIM_TOKEN,value:l(A)}},yA.prototype.consumeCodePoint=function(){var A=this._value.shift();return void 0===A?-1:A},yA.prototype.reconsumeCodePoint=function(A){this._value.unshift(A)},yA.prototype.peekCodePoint=function(A){return A>=this._value.length?-1:this._value[A]},yA.prototype.consumeUnicodeRangeToken=function(){for(var A=[],e=this.consumeCodePoint();aA(e)&&A.length<6;)A.push(e),e=this.consumeCodePoint();for(var t=!1;63===e&&A.length<6;)A.push(e),e=this.consumeCodePoint(),t=!0;if(t){var r=parseInt(l.apply(void 0,A.map(function(A){return 63===A?48:A})),16),n=parseInt(l.apply(void 0,A.map(function(A){return 63===A?70:A})),16);return{type:sA.UNICODE_RANGE_TOKEN,start:r,end:n}}var B=parseInt(l.apply(void 0,A),16);if(45===this.peekCodePoint(0)&&aA(this.peekCodePoint(1))){this.consumeCodePoint(),e=this.consumeCodePoint();for(var s=[];aA(e)&&s.length<6;)s.push(e),e=this.consumeCodePoint();return n=parseInt(l.apply(void 0,s),16),{type:sA.UNICODE_RANGE_TOKEN,start:B,end:n}}return{type:sA.UNICODE_RANGE_TOKEN,start:B,end:B}},yA.prototype.consumeIdentLikeToken=function(){var A=this.consumeName();return"url"===A.toLowerCase()&&40===this.peekCodePoint(0)?(this.consumeCodePoint(),this.consumeUrlToken()):40===this.peekCodePoint(0)?(this.consumeCodePoint(),{type:sA.FUNCTION_TOKEN,value:A}):{type:sA.IDENT_TOKEN,value:A}},yA.prototype.consumeUrlToken=function(){var A=[];if(this.consumeWhiteSpace(),-1===this.peekCodePoint(0))return{type:sA.URL_TOKEN,value:""};var e,t=this.peekCodePoint(0);if(39===t||34===t){var r=this.consumeStringToken(this.consumeCodePoint());return r.type===sA.STRING_TOKEN&&(this.consumeWhiteSpace(),-1===this.peekCodePoint(0)||41===this.peekCodePoint(0))?(this.consumeCodePoint(),{type:sA.URL_TOKEN,value:r.value}):(this.consumeBadUrlRemnants(),IA)}for(;;){var n=this.consumeCodePoint();if(-1===n||41===n)return{type:sA.URL_TOKEN,value:l.apply(void 0,A)};if(cA(n))return this.consumeWhiteSpace(),-1===this.peekCodePoint(0)||41===this.peekCodePoint(0)?(this.consumeCodePoint(),{type:sA.URL_TOKEN,value:l.apply(void 0,A)}):(this.consumeBadUrlRemnants(),IA);if(34===n||39===n||40===n||0<=(e=n)&&e<=8||11===e||14<=e&&e<=31||127===e)return this.consumeBadUrlRemnants(),IA;if(92===n){if(!uA(n,this.peekCodePoint(0)))return this.consumeBadUrlRemnants(),IA;A.push(this.consumeEscapedCodePoint())}else A.push(n)}},yA.prototype.consumeWhiteSpace=function(){for(;cA(this.peekCodePoint(0));)this.consumeCodePoint()},yA.prototype.consumeBadUrlRemnants=function(){for(;;){var A=this.consumeCodePoint();if(41===A||-1===A)return;uA(A,this.peekCodePoint(0))&&this.consumeEscapedCodePoint()}},yA.prototype.consumeStringSlice=function(A){for(var e="";0<A;){var t=Math.min(6e4,A);e+=l.apply(void 0,this._value.splice(0,t)),A-=t}return this._value.shift(),e},yA.prototype.consumeStringToken=function(A){for(var e="",t=0;;){var r=this._value[t];if(-1===r||void 0===r||r===A)return e+=this.consumeStringSlice(t),{type:sA.STRING_TOKEN,value:e};if(10===r)return this._value.splice(0,t),TA;if(92===r){var n=this._value[t+1];-1!==n&&void 0!==n&&(10===n?(e+=this.consumeStringSlice(t),t=-1,this._value.shift()):uA(r,n)&&(e+=this.consumeStringSlice(t),e+=l(this.consumeEscapedCodePoint()),t=-1))}t++}},yA.prototype.consumeNumber=function(){var A=[],e=4,t=this.peekCodePoint(0);for(43!==t&&45!==t||A.push(this.consumeCodePoint());iA(this.peekCodePoint(0));)A.push(this.consumeCodePoint());t=this.peekCodePoint(0);var r=this.peekCodePoint(1);if(46===t&&iA(r))for(A.push(this.consumeCodePoint(),this.consumeCodePoint()),e=8;iA(this.peekCodePoint(0));)A.push(this.consumeCodePoint());t=this.peekCodePoint(0),r=this.peekCodePoint(1);var n=this.peekCodePoint(2);if((69===t||101===t)&&((43===r||45===r)&&iA(n)||iA(r)))for(A.push(this.consumeCodePoint(),this.consumeCodePoint()),e=8;iA(this.peekCodePoint(0));)A.push(this.consumeCodePoint());return[function(A){var e=0,t=1;43!==A[e]&&45!==A[e]||(45===A[e]&&(t=-1),e++);for(var r=[];iA(A[e]);)r.push(A[e++]);var n=r.length?parseInt(l.apply(void 0,r),10):0;46===A[e]&&e++;for(var B=[];iA(A[e]);)B.push(A[e++]);var s=B.length,o=s?parseInt(l.apply(void 0,B),10):0;69!==A[e]&&101!==A[e]||e++;var i=1;43!==A[e]&&45!==A[e]||(45===A[e]&&(i=-1),e++);for(var a=[];iA(A[e]);)a.push(A[e++]);var c=a.length?parseInt(l.apply(void 0,a),10):0;return t*(n+o*Math.pow(10,-s))*Math.pow(10,i*c)}(A),e]},yA.prototype.consumeNumericToken=function(){var A=this.consumeNumber(),e=A[0],t=A[1],r=this.peekCodePoint(0),n=this.peekCodePoint(1),B=this.peekCodePoint(2);if(UA(r,n,B)){var s=this.consumeName();return{type:sA.DIMENSION_TOKEN,number:e,flags:t,unit:s}}return 37===r?(this.consumeCodePoint(),{type:sA.PERCENTAGE_TOKEN,number:e,flags:t}):{type:sA.NUMBER_TOKEN,number:e,flags:t}},yA.prototype.consumeEscapedCodePoint=function(){var A=this.consumeCodePoint();if(aA(A)){for(var e=l(A);aA(this.peekCodePoint(0))&&e.length<6;)e+=l(this.consumeCodePoint());cA(this.peekCodePoint(0))&&this.consumeCodePoint();var t=parseInt(e,16);return 0===t||function(A){return 55296<=A&&A<=57343}(t)||1114111<t?65533:t}return-1===A?65533:A},yA.prototype.consumeName=function(){for(var A="";;){var e=this.consumeCodePoint();if(wA(e))A+=l(e);else{if(!uA(e,this.peekCodePoint(0)))return this.reconsumeCodePoint(e),A;A+=l(this.consumeEscapedCodePoint())}}},yA);function yA(){this._value=[]}var _A=(PA.create=function(A){var e=new MA;return e.write(A),new PA(e.read())},PA.parseValue=function(A){return PA.create(A).parseComponentValue()},PA.parseValues=function(A){return PA.create(A).parseComponentValues()},PA.prototype.parseComponentValue=function(){for(var A=this.consumeToken();A.type===sA.WHITESPACE_TOKEN;)A=this.consumeToken();if(A.type===sA.EOF_TOKEN)throw new SyntaxError("Error parsing CSS component value, unexpected EOF");this.reconsumeToken(A);for(var e=this.consumeComponentValue();(A=this.consumeToken()).type===sA.WHITESPACE_TOKEN;);if(A.type===sA.EOF_TOKEN)return e;throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one")},PA.prototype.parseComponentValues=function(){for(var A=[];;){var e=this.consumeComponentValue();if(e.type===sA.EOF_TOKEN)return A;A.push(e),A.push()}},PA.prototype.consumeComponentValue=function(){var A=this.consumeToken();switch(A.type){case sA.LEFT_CURLY_BRACKET_TOKEN:case sA.LEFT_SQUARE_BRACKET_TOKEN:case sA.LEFT_PARENTHESIS_TOKEN:return this.consumeSimpleBlock(A.type);case sA.FUNCTION_TOKEN:return this.consumeFunction(A)}return A},PA.prototype.consumeSimpleBlock=function(A){for(var e={type:A,values:[]},t=this.consumeToken();;){if(t.type===sA.EOF_TOKEN||Be(t,A))return e;this.reconsumeToken(t),e.values.push(this.consumeComponentValue()),t=this.consumeToken()}},PA.prototype.consumeFunction=function(A){for(var e={name:A.value,values:[],type:sA.FUNCTION};;){var t=this.consumeToken();if(t.type===sA.EOF_TOKEN||t.type===sA.RIGHT_PARENTHESIS_TOKEN)return e;this.reconsumeToken(t),e.values.push(this.consumeComponentValue())}},PA.prototype.consumeToken=function(){var A=this._tokens.shift();return void 0===A?SA:A},PA.prototype.reconsumeToken=function(A){this._tokens.unshift(A)},PA);function PA(A){this._tokens=A}function xA(A){return A.type===sA.DIMENSION_TOKEN}function VA(A){return A.type===sA.NUMBER_TOKEN}function zA(A){return A.type===sA.IDENT_TOKEN}function XA(A){return A.type===sA.STRING_TOKEN}function JA(A,e){return zA(A)&&A.value===e}function GA(A){return A.type!==sA.WHITESPACE_TOKEN}function kA(A){return A.type!==sA.WHITESPACE_TOKEN&&A.type!==sA.COMMA_TOKEN}function WA(A){var e=[],t=[];return A.forEach(function(A){if(A.type===sA.COMMA_TOKEN){if(0===t.length)throw new Error("Error parsing function args, zero tokens for arg");return e.push(t),void(t=[])}A.type!==sA.WHITESPACE_TOKEN&&t.push(A)}),t.length&&e.push(t),e}function YA(A){return A.type===sA.NUMBER_TOKEN||A.type===sA.DIMENSION_TOKEN}function qA(A){return A.type===sA.PERCENTAGE_TOKEN||YA(A)}function ZA(A){return 1<A.length?[A[0],A[1]]:[A[0]]}function jA(A,e,t){var r=A[0],n=A[1];return[ae(r,e),ae(void 0!==n?n:r,t)]}function $A(A){return A.type===sA.DIMENSION_TOKEN&&("deg"===A.unit||"grad"===A.unit||"rad"===A.unit||"turn"===A.unit)}function Ae(A){switch(A.filter(zA).map(function(A){return A.value}).join(" ")){case"to bottom right":case"to right bottom":case"left top":case"top left":return[se,se];case"to top":case"bottom":return Qe(0);case"to bottom left":case"to left bottom":case"right top":case"top right":return[se,ie];case"to right":case"left":return Qe(90);case"to top left":case"to left top":case"right bottom":case"bottom right":return[ie,ie];case"to bottom":case"top":return Qe(180);case"to top right":case"to right top":case"left bottom":case"bottom left":return[ie,se];case"to left":case"right":return Qe(270)}return 0}function ee(A){return 0==(255&A)}function te(A){var e=255&A,t=255&A>>8,r=255&A>>16,n=255&A>>24;return e<255?"rgba("+n+","+r+","+t+","+e/255+")":"rgb("+n+","+r+","+t+")"}function re(A,e){if(A.type===sA.NUMBER_TOKEN)return A.number;if(A.type!==sA.PERCENTAGE_TOKEN)return 0;var t=3===e?1:255;return 3===e?A.number/100*t:Math.round(A.number/100*t)}function ne(A){var e=A.filter(kA);if(3===e.length){var t=e.map(re),r=t[0],n=t[1],B=t[2];return ue(r,n,B,1)}if(4!==e.length)return 0;var s=e.map(re),o=(r=s[0],n=s[1],B=s[2],s[3]);return ue(r,n,B,o)}var Be=function(A,e){return e===sA.LEFT_CURLY_BRACKET_TOKEN&&A.type===sA.RIGHT_CURLY_BRACKET_TOKEN||(e===sA.LEFT_SQUARE_BRACKET_TOKEN&&A.type===sA.RIGHT_SQUARE_BRACKET_TOKEN||e===sA.LEFT_PARENTHESIS_TOKEN&&A.type===sA.RIGHT_PARENTHESIS_TOKEN)},se={type:sA.NUMBER_TOKEN,number:0,flags:4},oe={type:sA.PERCENTAGE_TOKEN,number:50,flags:4},ie={type:sA.PERCENTAGE_TOKEN,number:100,flags:4},ae=function(A,e){if(A.type===sA.PERCENTAGE_TOKEN)return A.number/100*e;if(xA(A))switch(A.unit){case"rem":case"em":return 16*A.number;case"px":default:return A.number}return A.number},ce=function(A){if(A.type===sA.DIMENSION_TOKEN)switch(A.unit){case"deg":return Math.PI*A.number/180;case"grad":return Math.PI/200*A.number;case"rad":return A.number;case"turn":return 2*Math.PI*A.number}throw new Error("Unsupported angle type")},Qe=function(A){return Math.PI*A/180},we=function(A){if(A.type===sA.FUNCTION){var e=he[A.name];if(void 0===e)throw new Error('Attempting to parse an unsupported color function "'+A.name+'"');return e(A.values)}if(A.type===sA.HASH_TOKEN){if(3===A.value.length){var t=A.value.substring(0,1),r=A.value.substring(1,2),n=A.value.substring(2,3);return ue(parseInt(t+t,16),parseInt(r+r,16),parseInt(n+n,16),1)}if(4===A.value.length){t=A.value.substring(0,1),r=A.value.substring(1,2),n=A.value.substring(2,3);var B=A.value.substring(3,4);return ue(parseInt(t+t,16),parseInt(r+r,16),parseInt(n+n,16),parseInt(B+B,16)/255)}if(6===A.value.length){t=A.value.substring(0,2),r=A.value.substring(2,4),n=A.value.substring(4,6);return ue(parseInt(t,16),parseInt(r,16),parseInt(n,16),1)}if(8===A.value.length){t=A.value.substring(0,2),r=A.value.substring(2,4),n=A.value.substring(4,6),B=A.value.substring(6,8);return ue(parseInt(t,16),parseInt(r,16),parseInt(n,16),parseInt(B,16)/255)}}if(A.type===sA.IDENT_TOKEN){var s=He[A.value.toUpperCase()];if(void 0!==s)return s}return He.TRANSPARENT},ue=function(A,e,t,r){return(A<<24|e<<16|t<<8|Math.round(255*r)<<0)>>>0};function Ue(A,e,t){return t<0&&(t+=1),1<=t&&(t-=1),t<1/6?(e-A)*t*6+A:t<.5?e:t<2/3?6*(e-A)*(2/3-t)+A:A}function le(A){var e=A.filter(kA),t=e[0],r=e[1],n=e[2],B=e[3],s=(t.type===sA.NUMBER_TOKEN?Qe(t.number):ce(t))/(2*Math.PI),o=qA(r)?r.number/100:0,i=qA(n)?n.number/100:0,a=void 0!==B&&qA(B)?ae(B,1):1;if(0==o)return ue(255*i,255*i,255*i,1);var c=i<=.5?i*(1+o):i+o-i*o,Q=2*i-c,w=Ue(Q,c,s+1/3),u=Ue(Q,c,s),U=Ue(Q,c,s-1/3);return ue(255*w,255*u,255*U,a)}var Ce,ge,Ee,Fe,he={hsl:le,hsla:le,rgb:ne,rgba:ne},He={ALICEBLUE:4042850303,ANTIQUEWHITE:4209760255,AQUA:16777215,AQUAMARINE:2147472639,AZURE:4043309055,BEIGE:4126530815,BISQUE:4293182719,BLACK:255,BLANCHEDALMOND:4293643775,BLUE:65535,BLUEVIOLET:2318131967,BROWN:2771004159,BURLYWOOD:3736635391,CADETBLUE:1604231423,CHARTREUSE:2147418367,CHOCOLATE:3530104575,CORAL:4286533887,CORNFLOWERBLUE:1687547391,CORNSILK:4294499583,CRIMSON:3692313855,CYAN:16777215,DARKBLUE:35839,DARKCYAN:9145343,DARKGOLDENROD:3095837695,DARKGRAY:2846468607,DARKGREEN:6553855,DARKGREY:2846468607,DARKKHAKI:3182914559,DARKMAGENTA:2332068863,DARKOLIVEGREEN:1433087999,DARKORANGE:4287365375,DARKORCHID:2570243327,DARKRED:2332033279,DARKSALMON:3918953215,DARKSEAGREEN:2411499519,DARKSLATEBLUE:1211993087,DARKSLATEGRAY:793726975,DARKSLATEGREY:793726975,DARKTURQUOISE:13554175,DARKVIOLET:2483082239,DEEPPINK:4279538687,DEEPSKYBLUE:12582911,DIMGRAY:1768516095,DIMGREY:1768516095,DODGERBLUE:512819199,FIREBRICK:2988581631,FLORALWHITE:4294635775,FORESTGREEN:579543807,FUCHSIA:4278255615,GAINSBORO:3705462015,GHOSTWHITE:4177068031,GOLD:4292280575,GOLDENROD:3668254975,GRAY:2155905279,GREEN:8388863,GREENYELLOW:2919182335,GREY:2155905279,HONEYDEW:4043305215,HOTPINK:4285117695,INDIANRED:3445382399,INDIGO:1258324735,IVORY:4294963455,KHAKI:4041641215,LAVENDER:3873897215,LAVENDERBLUSH:4293981695,LAWNGREEN:2096890111,LEMONCHIFFON:4294626815,LIGHTBLUE:2916673279,LIGHTCORAL:4034953471,LIGHTCYAN:3774873599,LIGHTGOLDENRODYELLOW:4210742015,LIGHTGRAY:3553874943,LIGHTGREEN:2431553791,LIGHTGREY:3553874943,LIGHTPINK:4290167295,LIGHTSALMON:4288707327,LIGHTSEAGREEN:548580095,LIGHTSKYBLUE:2278488831,LIGHTSLATEGRAY:2005441023,LIGHTSLATEGREY:2005441023,LIGHTSTEELBLUE:2965692159,LIGHTYELLOW:4294959359,LIME:16711935,LIMEGREEN:852308735,LINEN:4210091775,MAGENTA:4278255615,MAROON:2147483903,MEDIUMAQUAMARINE:1724754687,MEDIUMBLUE:52735,MEDIUMORCHID:3126187007,MEDIUMPURPLE:2473647103,MEDIUMSEAGREEN:1018393087,MEDIUMSLATEBLUE:2070474495,MEDIUMSPRINGGREEN:16423679,MEDIUMTURQUOISE:1221709055,MEDIUMVIOLETRED:3340076543,MIDNIGHTBLUE:421097727,MINTCREAM:4127193855,MISTYROSE:4293190143,MOCCASIN:4293178879,NAVAJOWHITE:4292783615,NAVY:33023,OLDLACE:4260751103,OLIVE:2155872511,OLIVEDRAB:1804477439,ORANGE:4289003775,ORANGERED:4282712319,ORCHID:3664828159,PALEGOLDENROD:4008225535,PALEGREEN:2566625535,PALETURQUOISE:2951671551,PALEVIOLETRED:3681588223,PAPAYAWHIP:4293907967,PEACHPUFF:4292524543,PERU:3448061951,PINK:4290825215,PLUM:3718307327,POWDERBLUE:2967529215,PURPLE:2147516671,REBECCAPURPLE:1714657791,RED:4278190335,ROSYBROWN:3163525119,ROYALBLUE:1097458175,SADDLEBROWN:2336560127,SALMON:4202722047,SANDYBROWN:4104413439,SEAGREEN:780883967,SEASHELL:4294307583,SIENNA:2689740287,SILVER:3233857791,SKYBLUE:2278484991,SLATEBLUE:1784335871,SLATEGRAY:1887473919,SLATEGREY:1887473919,SNOW:4294638335,SPRINGGREEN:16744447,STEELBLUE:1182971135,TAN:3535047935,TEAL:8421631,THISTLE:3636451583,TOMATO:4284696575,TRANSPARENT:0,TURQUOISE:1088475391,VIOLET:4001558271,WHEAT:4125012991,WHITE:4294967295,WHITESMOKE:4126537215,YELLOW:4294902015,YELLOWGREEN:2597139199};(ge=Ce||(Ce={}))[ge.VALUE=0]="VALUE",ge[ge.LIST=1]="LIST",ge[ge.IDENT_VALUE=2]="IDENT_VALUE",ge[ge.TYPE_VALUE=3]="TYPE_VALUE",ge[ge.TOKEN_VALUE=4]="TOKEN_VALUE",(Fe=Ee||(Ee={}))[Fe.BORDER_BOX=0]="BORDER_BOX",Fe[Fe.PADDING_BOX=1]="PADDING_BOX";function de(A){var e=we(A[0]),t=A[1];return t&&qA(t)?{color:e,stop:t}:{color:e,stop:null}}function fe(A,t){var e=A[0],r=A[A.length-1];null===e.stop&&(e.stop=se),null===r.stop&&(r.stop=ie);for(var n=[],B=0,s=0;s<A.length;s++){var o=A[s].stop;if(null!==o){var i=ae(o,t);B<i?n.push(i):n.push(B),B=i}else n.push(null)}var a=null;for(s=0;s<n.length;s++){var c=n[s];if(null===c)null===a&&(a=s);else if(null!==a){for(var Q=s-a,w=(c-n[a-1])/(1+Q),u=1;u<=Q;u++)n[a+u-1]=w*u;a=null}}return A.map(function(A,e){return{color:A.color,stop:Math.max(Math.min(1,n[e]/t),0)}})}function pe(A,e,t){var r="number"==typeof A?A:function(A,e,t){var r=e/2,n=t/2,B=ae(A[0],e)-r,s=n-ae(A[1],t);return(Math.atan2(s,B)+2*Math.PI)%(2*Math.PI)}(A,e,t),n=Math.abs(e*Math.sin(r))+Math.abs(t*Math.cos(r)),B=e/2,s=t/2,o=n/2,i=Math.sin(r-Math.PI/2)*o,a=Math.cos(r-Math.PI/2)*o;return[n,B-a,B+a,s-i,s+i]}function Ne(A,e){return Math.sqrt(A*A+e*e)}function Ke(A,e,B,s,o){return[[0,0],[0,e],[A,0],[A,e]].reduce(function(A,e){var t=e[0],r=e[1],n=Ne(B-t,s-r);return(o?n<A.optimumDistance:n>A.optimumDistance)?{optimumCorner:e,optimumDistance:n}:A},{optimumDistance:o?1/0:-1/0,optimumCorner:null}).optimumCorner}function Ie(A){var n=Qe(180),B=[];return WA(A).forEach(function(A,e){if(0===e){var t=A[0];if(t.type===sA.IDENT_TOKEN&&-1!==["top","left","right","bottom"].indexOf(t.value))return void(n=Ae(A));if($A(t))return void(n=(ce(t)+Qe(270))%Qe(360))}var r=de(A);B.push(r)}),{angle:n,stops:B,type:xe.LINEAR_GRADIENT}}function Te(A){return 0===A[0]&&255===A[1]&&0===A[2]&&255===A[3]}var me={name:"background-clip",initialValue:"border-box",prefix:!(Fe[Fe.CONTENT_BOX=2]="CONTENT_BOX"),type:Ce.LIST,parse:function(A){return A.map(function(A){if(zA(A))switch(A.value){case"padding-box":return Ee.PADDING_BOX;case"content-box":return Ee.CONTENT_BOX}return Ee.BORDER_BOX})}},Re={name:"background-color",initialValue:"transparent",prefix:!1,type:Ce.TYPE_VALUE,format:"color"},Le=function(A,e,t,r,n){var B="http://www.w3.org/2000/svg",s=document.createElementNS(B,"svg"),o=document.createElementNS(B,"foreignObject");return s.setAttributeNS(null,"width",A.toString()),s.setAttributeNS(null,"height",e.toString()),o.setAttributeNS(null,"width","100%"),o.setAttributeNS(null,"height","100%"),o.setAttributeNS(null,"x",t.toString()),o.setAttributeNS(null,"y",r.toString()),o.setAttributeNS(null,"externalResourcesRequired","true"),s.appendChild(o),o.appendChild(n),s},ve=function(r){return new Promise(function(A,e){var t=new Image;t.onload=function(){return A(t)},t.onerror=e,t.src="data:image/svg+xml;charset=utf-8,"+encodeURIComponent((new XMLSerializer).serializeToString(r))})},Oe={get SUPPORT_RANGE_BOUNDS(){var A=function(A){if(A.createRange){var e=A.createRange();if(e.getBoundingClientRect){var t=A.createElement("boundtest");t.style.height="123px",t.style.display="block",A.body.appendChild(t),e.selectNode(t);var r=e.getBoundingClientRect(),n=Math.round(r.height);if(A.body.removeChild(t),123===n)return!0}}return!1}(document);return Object.defineProperty(Oe,"SUPPORT_RANGE_BOUNDS",{value:A}),A},get SUPPORT_SVG_DRAWING(){var A=function(A){var e=new Image,t=A.createElement("canvas"),r=t.getContext("2d");if(!r)return!1;e.src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";try{r.drawImage(e,0,0),t.toDataURL()}catch(A){return!1}return!0}(document);return Object.defineProperty(Oe,"SUPPORT_SVG_DRAWING",{value:A}),A},get SUPPORT_FOREIGNOBJECT_DRAWING(){var A="function"==typeof Array.from&&"function"==typeof window.fetch?function(r){var A=r.createElement("canvas"),n=100;A.width=n,A.height=n;var B=A.getContext("2d");if(!B)return Promise.reject(!1);B.fillStyle="rgb(0, 255, 0)",B.fillRect(0,0,n,n);var e=new Image,s=A.toDataURL();e.src=s;var t=Le(n,n,0,0,e);return B.fillStyle="red",B.fillRect(0,0,n,n),ve(t).then(function(A){B.drawImage(A,0,0);var e=B.getImageData(0,0,n,n).data;B.fillStyle="red",B.fillRect(0,0,n,n);var t=r.createElement("div");return t.style.backgroundImage="url("+s+")",t.style.height="100px",Te(e)?ve(Le(n,n,0,0,t)):Promise.reject(!1)}).then(function(A){return B.drawImage(A,0,0),Te(B.getImageData(0,0,n,n).data)}).catch(function(){return!1})}(document):Promise.resolve(!1);return Object.defineProperty(Oe,"SUPPORT_FOREIGNOBJECT_DRAWING",{value:A}),A},get SUPPORT_CORS_IMAGES(){var A=void 0!==(new Image).crossOrigin;return Object.defineProperty(Oe,"SUPPORT_CORS_IMAGES",{value:A}),A},get SUPPORT_RESPONSE_TYPE(){var A="string"==typeof(new XMLHttpRequest).responseType;return Object.defineProperty(Oe,"SUPPORT_RESPONSE_TYPE",{value:A}),A},get SUPPORT_CORS_XHR(){var A="withCredentials"in new XMLHttpRequest;return Object.defineProperty(Oe,"SUPPORT_CORS_XHR",{value:A}),A}},De=(be.prototype.debug=function(){for(var A=[],e=0;e<arguments.length;e++)A[e]=arguments[e];this.enabled&&("undefined"!=typeof window&&window.console&&"function"==typeof console.debug?console.debug.apply(console,[this.id,this.getTime()+"ms"].concat(A)):this.info.apply(this,A))},be.prototype.getTime=function(){return Date.now()-this.start},be.create=function(A){be.instances[A.id]=new be(A)},be.destroy=function(A){delete be.instances[A]},be.getInstance=function(A){var e=be.instances[A];if(void 0===e)throw new Error("No logger instance found with id "+A);return e},be.prototype.info=function(){for(var A=[],e=0;e<arguments.length;e++)A[e]=arguments[e];this.enabled&&"undefined"!=typeof window&&window.console&&"function"==typeof console.info&&console.info.apply(console,[this.id,this.getTime()+"ms"].concat(A))},be.prototype.error=function(){for(var A=[],e=0;e<arguments.length;e++)A[e]=arguments[e];this.enabled&&("undefined"!=typeof window&&window.console&&"function"==typeof console.error?console.error.apply(console,[this.id,this.getTime()+"ms"].concat(A)):this.info.apply(this,A))},be.instances={},be);function be(A){var e=A.id,t=A.enabled;this.id=e,this.enabled=t,this.start=Date.now()}var Se=(Me.create=function(A,e){return Me._caches[A]=new ye(A,e)},Me.destroy=function(A){delete Me._caches[A]},Me.open=function(A){var e=Me._caches[A];if(void 0!==e)return e;throw new Error('Cache with key "'+A+'" not found')},Me.getOrigin=function(A){var e=Me._link;return e?(e.href=A,e.href=e.href,e.protocol+e.hostname+e.port):"about:blank"},Me.isSameOrigin=function(A){return Me.getOrigin(A)===Me._origin},Me.setContext=function(A){Me._link=A.document.createElement("a"),Me._origin=Me.getOrigin(A.location.href)},Me.getInstance=function(){var A=Me._current;if(null===A)throw new Error("No cache instance attached");return A},Me.attachInstance=function(A){Me._current=A},Me.detachInstance=function(){Me._current=null},Me._caches={},Me._origin="about:blank",Me._current=null,Me);function Me(){}var ye=(_e.prototype.addImage=function(A){var e=Promise.resolve();return this.has(A)||(Ye(A)||Ge(A))&&(this._cache[A]=this.loadImage(A)),e},_e.prototype.match=function(A){return this._cache[A]},_e.prototype.loadImage=function(s){return a(this,void 0,void 0,function(){var e,r,t,n,B=this;return S(this,function(A){switch(A.label){case 0:return e=Se.isSameOrigin(s),r=!ke(s)&&!0===this._options.useCORS&&Oe.SUPPORT_CORS_IMAGES&&!e,t=!ke(s)&&!e&&"string"==typeof this._options.proxy&&Oe.SUPPORT_CORS_XHR&&!r,e||!1!==this._options.allowTaint||ke(s)||t||r?(n=s,t?[4,this.proxy(n)]:[3,2]):[2];case 1:n=A.sent(),A.label=2;case 2:return De.getInstance(this.id).debug("Added image "+s.substring(0,256)),[4,new Promise(function(A,e){var t=new Image;t.onload=function(){return A(t)},t.onerror=e,(We(n)||r)&&(t.crossOrigin="anonymous"),t.src=n,!0===t.complete&&setTimeout(function(){return A(t)},500),0<B._options.imageTimeout&&setTimeout(function(){return e("Timed out ("+B._options.imageTimeout+"ms) loading image")},B._options.imageTimeout)})];case 3:return[2,A.sent()]}})})},_e.prototype.has=function(A){return void 0!==this._cache[A]},_e.prototype.keys=function(){return Promise.resolve(Object.keys(this._cache))},_e.prototype.proxy=function(B){var s=this,o=this._options.proxy;if(!o)throw new Error("No proxy defined");var i=B.substring(0,256);return new Promise(function(e,t){var r=Oe.SUPPORT_RESPONSE_TYPE?"blob":"text",n=new XMLHttpRequest;if(n.onload=function(){if(200===n.status)if("text"==r)e(n.response);else{var A=new FileReader;A.addEventListener("load",function(){return e(A.result)},!1),A.addEventListener("error",function(A){return t(A)},!1),A.readAsDataURL(n.response)}else t("Failed to proxy resource "+i+" with status code "+n.status)},n.onerror=t,n.open("GET",o+"?url="+encodeURIComponent(B)+"&responseType="+r),"text"!=r&&n instanceof XMLHttpRequest&&(n.responseType=r),s._options.imageTimeout){var A=s._options.imageTimeout;n.timeout=A,n.ontimeout=function(){return t("Timed out ("+A+"ms) proxying "+i)}}n.send()})},_e);function _e(A,e){this.id=A,this._options=e,this._cache={}}function Pe(A){var n=rt.CIRCLE,B=Bt.FARTHEST_CORNER,s=[],o=[];return WA(A).forEach(function(A,e){var t=!0;if(0===e?t=A.reduce(function(A,e){if(zA(e))switch(e.value){case"center":return o.push(oe),!1;case"top":case"left":return o.push(se),!1;case"right":case"bottom":return o.push(ie),!1}else if(qA(e)||YA(e))return o.push(e),!1;return A},t):1===e&&(t=A.reduce(function(A,e){if(zA(e))switch(e.value){case"circle":return n=rt.CIRCLE,!1;case et:return n=rt.ELLIPSE,!1;case tt:case Ze:return B=Bt.CLOSEST_SIDE,!1;case je:return B=Bt.FARTHEST_SIDE,!1;case $e:return B=Bt.CLOSEST_CORNER,!1;case"cover":case At:return B=Bt.FARTHEST_CORNER,!1}else if(YA(e)||qA(e))return Array.isArray(B)||(B=[]),B.push(e),!1;return A},t)),t){var r=de(A);s.push(r)}}),{size:B,shape:n,stops:s,position:o,type:xe.RADIAL_GRADIENT}}var xe,Ve,ze=/^data:image\/svg\+xml/i,Xe=/^data:image\/.*;base64,/i,Je=/^data:image\/.*/i,Ge=function(A){return Oe.SUPPORT_SVG_DRAWING||!qe(A)},ke=function(A){return Je.test(A)},We=function(A){return Xe.test(A)},Ye=function(A){return"blob"===A.substr(0,4)},qe=function(A){return"svg"===A.substr(-3).toLowerCase()||ze.test(A)},Ze="closest-side",je="farthest-side",$e="closest-corner",At="farthest-corner",et="ellipse",tt="contain";(Ve=xe||(xe={}))[Ve.URL=0]="URL",Ve[Ve.LINEAR_GRADIENT=1]="LINEAR_GRADIENT",Ve[Ve.RADIAL_GRADIENT=2]="RADIAL_GRADIENT";var rt,nt,Bt,st;(nt=rt||(rt={}))[nt.CIRCLE=0]="CIRCLE",nt[nt.ELLIPSE=1]="ELLIPSE",(st=Bt||(Bt={}))[st.CLOSEST_SIDE=0]="CLOSEST_SIDE",st[st.FARTHEST_SIDE=1]="FARTHEST_SIDE",st[st.CLOSEST_CORNER=2]="CLOSEST_CORNER",st[st.FARTHEST_CORNER=3]="FARTHEST_CORNER";var ot=function(A){if(A.type===sA.URL_TOKEN){var e={url:A.value,type:xe.URL};return Se.getInstance().addImage(A.value),e}if(A.type!==sA.FUNCTION)throw new Error("Unsupported image type");var t=ct[A.name];if(void 0===t)throw new Error('Attempting to parse an unsupported image function "'+A.name+'"');return t(A.values)};var it,at,ct={"linear-gradient":function(A){var n=Qe(180),B=[];return WA(A).forEach(function(A,e){if(0===e){var t=A[0];if(t.type===sA.IDENT_TOKEN&&"to"===t.value)return void(n=Ae(A));if($A(t))return void(n=ce(t))}var r=de(A);B.push(r)}),{angle:n,stops:B,type:xe.LINEAR_GRADIENT}},"-moz-linear-gradient":Ie,"-ms-linear-gradient":Ie,"-o-linear-gradient":Ie,"-webkit-linear-gradient":Ie,"radial-gradient":function(A){var B=rt.CIRCLE,s=Bt.FARTHEST_CORNER,o=[],i=[];return WA(A).forEach(function(A,e){var t=!0;if(0===e){var r=!1;t=A.reduce(function(A,e){if(r)if(zA(e))switch(e.value){case"center":return i.push(oe),A;case"top":case"left":return i.push(se),A;case"right":case"bottom":return i.push(ie),A}else(qA(e)||YA(e))&&i.push(e);else if(zA(e))switch(e.value){case"circle":return B=rt.CIRCLE,!1;case et:return B=rt.ELLIPSE,!1;case"at":return!(r=!0);case Ze:return s=Bt.CLOSEST_SIDE,!1;case"cover":case je:return s=Bt.FARTHEST_SIDE,!1;case tt:case $e:return s=Bt.CLOSEST_CORNER,!1;case At:return s=Bt.FARTHEST_CORNER,!1}else if(YA(e)||qA(e))return Array.isArray(s)||(s=[]),s.push(e),!1;return A},t)}if(t){var n=de(A);o.push(n)}}),{size:s,shape:B,stops:o,position:i,type:xe.RADIAL_GRADIENT}},"-moz-radial-gradient":Pe,"-ms-radial-gradient":Pe,"-o-radial-gradient":Pe,"-webkit-radial-gradient":Pe,"-webkit-gradient":function(A){var e=Qe(180),s=[],o=xe.LINEAR_GRADIENT,t=rt.CIRCLE,r=Bt.FARTHEST_CORNER;return WA(A).forEach(function(A,e){var t=A[0];if(0===e){if(zA(t)&&"linear"===t.value)return void(o=xe.LINEAR_GRADIENT);if(zA(t)&&"radial"===t.value)return void(o=xe.RADIAL_GRADIENT)}if(t.type===sA.FUNCTION)if("from"===t.name){var r=we(t.values[0]);s.push({stop:se,color:r})}else if("to"===t.name)r=we(t.values[0]),s.push({stop:ie,color:r});else if("color-stop"===t.name){var n=t.values.filter(kA);if(2===n.length){r=we(n[1]);var B=n[0];VA(B)&&s.push({stop:{type:sA.PERCENTAGE_TOKEN,number:100*B.number,flags:B.flags},color:r})}}}),o===xe.LINEAR_GRADIENT?{angle:(e+Qe(180))%Qe(360),stops:s,type:o}:{size:r,shape:t,stops:s,position:[],type:o}}},Qt={name:"background-image",initialValue:"none",type:Ce.LIST,prefix:!1,parse:function(A){if(0===A.length)return[];var e=A[0];return e.type===sA.IDENT_TOKEN&&"none"===e.value?[]:A.filter(function(A){return kA(A)&&function(A){return A.type!==sA.FUNCTION||ct[A.name]}(A)}).map(ot)}},wt={name:"background-origin",initialValue:"border-box",prefix:!1,type:Ce.LIST,parse:function(A){return A.map(function(A){if(zA(A))switch(A.value){case"padding-box":return 1;case"content-box":return 2}return 0})}},ut={name:"background-position",initialValue:"0% 0%",type:Ce.LIST,prefix:!1,parse:function(A){return WA(A).map(function(A){return A.filter(qA)}).map(ZA)}};(at=it||(it={}))[at.REPEAT=0]="REPEAT",at[at.NO_REPEAT=1]="NO_REPEAT",at[at.REPEAT_X=2]="REPEAT_X";var Ut,lt,Ct={name:"background-repeat",initialValue:"repeat",prefix:!(at[at.REPEAT_Y=3]="REPEAT_Y"),type:Ce.LIST,parse:function(A){return WA(A).map(function(A){return A.filter(zA).map(function(A){return A.value}).join(" ")}).map(gt)}},gt=function(A){switch(A){case"no-repeat":return it.NO_REPEAT;case"repeat-x":case"repeat no-repeat":return it.REPEAT_X;case"repeat-y":case"no-repeat repeat":return it.REPEAT_Y;case"repeat":default:return it.REPEAT}};(lt=Ut||(Ut={})).AUTO="auto",lt.CONTAIN="contain";function Et(A){return{name:"border-"+A+"-color",initialValue:"transparent",prefix:!1,type:Ce.TYPE_VALUE,format:"color"}}function Ft(A){return{name:"border-radius-"+A,initialValue:"0 0",prefix:!1,type:Ce.LIST,parse:function(A){return ZA(A.filter(qA))}}}var ht,Ht,dt={name:"background-size",initialValue:"0",prefix:!(lt.COVER="cover"),type:Ce.LIST,parse:function(A){return WA(A).map(function(A){return A.filter(ft)})}},ft=function(A){return zA(A)||qA(A)},pt=Et("top"),Nt=Et("right"),Kt=Et("bottom"),It=Et("left"),Tt=Ft("top-left"),mt=Ft("top-right"),Rt=Ft("bottom-right"),Lt=Ft("bottom-left");(Ht=ht||(ht={}))[Ht.NONE=0]="NONE",Ht[Ht.SOLID=1]="SOLID";function vt(A){return{name:"border-"+A+"-style",initialValue:"solid",prefix:!1,type:Ce.IDENT_VALUE,parse:function(A){switch(A){case"none":return ht.NONE}return ht.SOLID}}}function Ot(A){return{name:"border-"+A+"-width",initialValue:"0",type:Ce.VALUE,prefix:!1,parse:function(A){return xA(A)?A.number:0}}}var Dt,bt,St=vt("top"),Mt=vt("right"),yt=vt("bottom"),_t=vt("left"),Pt=Ot("top"),xt=Ot("right"),Vt=Ot("bottom"),zt=Ot("left"),Xt={name:"color",initialValue:"transparent",prefix:!1,type:Ce.TYPE_VALUE,format:"color"},Jt={name:"display",initialValue:"inline-block",prefix:!1,type:Ce.LIST,parse:function(A){return A.filter(zA).reduce(function(A,e){return A|Gt(e.value)},0)}},Gt=function(A){switch(A){case"block":return 2;case"inline":return 4;case"run-in":return 8;case"flow":return 16;case"flow-root":return 32;case"table":return 64;case"flex":case"-webkit-flex":return 128;case"grid":case"-ms-grid":return 256;case"ruby":return 512;case"subgrid":return 1024;case"list-item":return 2048;case"table-row-group":return 4096;case"table-header-group":return 8192;case"table-footer-group":return 16384;case"table-row":return 32768;case"table-cell":return 65536;case"table-column-group":return 131072;case"table-column":return 262144;case"table-caption":return 524288;case"ruby-base":return 1048576;case"ruby-text":return 2097152;case"ruby-base-container":return 4194304;case"ruby-text-container":return 8388608;case"contents":return 16777216;case"inline-block":return 33554432;case"inline-list-item":return 67108864;case"inline-table":return 134217728;case"inline-flex":return 268435456;case"inline-grid":return 536870912}return 0};(bt=Dt||(Dt={}))[bt.NONE=0]="NONE",bt[bt.LEFT=1]="LEFT",bt[bt.RIGHT=2]="RIGHT",bt[bt.INLINE_START=3]="INLINE_START";var kt,Wt,Yt,qt,Zt={name:"float",initialValue:"none",prefix:!(bt[bt.INLINE_END=4]="INLINE_END"),type:Ce.IDENT_VALUE,parse:function(A){switch(A){case"left":return Dt.LEFT;case"right":return Dt.RIGHT;case"inline-start":return Dt.INLINE_START;case"inline-end":return Dt.INLINE_END}return Dt.NONE}},jt={name:"letter-spacing",initialValue:"0",prefix:!1,type:Ce.VALUE,parse:function(A){return A.type===sA.IDENT_TOKEN&&"normal"===A.value?0:A.type===sA.NUMBER_TOKEN?A.number:A.type===sA.DIMENSION_TOKEN?A.number:0}},$t={name:"line-break",initialValue:(Wt=kt||(kt={})).NORMAL="normal",prefix:!(Wt.STRICT="strict"),type:Ce.IDENT_VALUE,parse:function(A){switch(A){case"strict":return kt.STRICT;case"normal":default:return kt.NORMAL}}},Ar={name:"line-height",initialValue:"normal",prefix:!1,type:Ce.TOKEN_VALUE},er={name:"list-style-image",initialValue:"none",type:Ce.VALUE,prefix:!1,parse:function(A){return A.type===sA.IDENT_TOKEN&&"none"===A.value?null:ot(A)}};(qt=Yt||(Yt={}))[qt.INSIDE=0]="INSIDE";var tr,rr,nr={name:"list-style-position",initialValue:"outside",prefix:!(qt[qt.OUTSIDE=1]="OUTSIDE"),type:Ce.IDENT_VALUE,parse:function(A){switch(A){case"inside":return Yt.INSIDE;case"outside":default:return Yt.OUTSIDE}}};(rr=tr||(tr={}))[rr.NONE=-1]="NONE",rr[rr.DISC=0]="DISC",rr[rr.CIRCLE=1]="CIRCLE",rr[rr.SQUARE=2]="SQUARE",rr[rr.DECIMAL=3]="DECIMAL",rr[rr.CJK_DECIMAL=4]="CJK_DECIMAL",rr[rr.DECIMAL_LEADING_ZERO=5]="DECIMAL_LEADING_ZERO",rr[rr.LOWER_ROMAN=6]="LOWER_ROMAN",rr[rr.UPPER_ROMAN=7]="UPPER_ROMAN",rr[rr.LOWER_GREEK=8]="LOWER_GREEK",rr[rr.LOWER_ALPHA=9]="LOWER_ALPHA",rr[rr.UPPER_ALPHA=10]="UPPER_ALPHA",rr[rr.ARABIC_INDIC=11]="ARABIC_INDIC",rr[rr.ARMENIAN=12]="ARMENIAN",rr[rr.BENGALI=13]="BENGALI",rr[rr.CAMBODIAN=14]="CAMBODIAN",rr[rr.CJK_EARTHLY_BRANCH=15]="CJK_EARTHLY_BRANCH",rr[rr.CJK_HEAVENLY_STEM=16]="CJK_HEAVENLY_STEM",rr[rr.CJK_IDEOGRAPHIC=17]="CJK_IDEOGRAPHIC",rr[rr.DEVANAGARI=18]="DEVANAGARI",rr[rr.ETHIOPIC_NUMERIC=19]="ETHIOPIC_NUMERIC",rr[rr.GEORGIAN=20]="GEORGIAN",rr[rr.GUJARATI=21]="GUJARATI",rr[rr.GURMUKHI=22]="GURMUKHI",rr[rr.HEBREW=22]="HEBREW",rr[rr.HIRAGANA=23]="HIRAGANA",rr[rr.HIRAGANA_IROHA=24]="HIRAGANA_IROHA",rr[rr.JAPANESE_FORMAL=25]="JAPANESE_FORMAL",rr[rr.JAPANESE_INFORMAL=26]="JAPANESE_INFORMAL",rr[rr.KANNADA=27]="KANNADA",rr[rr.KATAKANA=28]="KATAKANA",rr[rr.KATAKANA_IROHA=29]="KATAKANA_IROHA",rr[rr.KHMER=30]="KHMER",rr[rr.KOREAN_HANGUL_FORMAL=31]="KOREAN_HANGUL_FORMAL",rr[rr.KOREAN_HANJA_FORMAL=32]="KOREAN_HANJA_FORMAL",rr[rr.KOREAN_HANJA_INFORMAL=33]="KOREAN_HANJA_INFORMAL",rr[rr.LAO=34]="LAO",rr[rr.LOWER_ARMENIAN=35]="LOWER_ARMENIAN",rr[rr.MALAYALAM=36]="MALAYALAM",rr[rr.MONGOLIAN=37]="MONGOLIAN",rr[rr.MYANMAR=38]="MYANMAR",rr[rr.ORIYA=39]="ORIYA",rr[rr.PERSIAN=40]="PERSIAN",rr[rr.SIMP_CHINESE_FORMAL=41]="SIMP_CHINESE_FORMAL",rr[rr.SIMP_CHINESE_INFORMAL=42]="SIMP_CHINESE_INFORMAL",rr[rr.TAMIL=43]="TAMIL",rr[rr.TELUGU=44]="TELUGU",rr[rr.THAI=45]="THAI",rr[rr.TIBETAN=46]="TIBETAN",rr[rr.TRAD_CHINESE_FORMAL=47]="TRAD_CHINESE_FORMAL",rr[rr.TRAD_CHINESE_INFORMAL=48]="TRAD_CHINESE_INFORMAL",rr[rr.UPPER_ARMENIAN=49]="UPPER_ARMENIAN",rr[rr.DISCLOSURE_OPEN=50]="DISCLOSURE_OPEN";function Br(A){return{name:"margin-"+A,initialValue:"0",prefix:!1,type:Ce.TOKEN_VALUE}}var sr,or,ir={name:"list-style-type",initialValue:"none",prefix:!(rr[rr.DISCLOSURE_CLOSED=51]="DISCLOSURE_CLOSED"),type:Ce.IDENT_VALUE,parse:function(A){switch(A){case"disc":return tr.DISC;case"circle":return tr.CIRCLE;case"square":return tr.SQUARE;case"decimal":return tr.DECIMAL;case"cjk-decimal":return tr.CJK_DECIMAL;case"decimal-leading-zero":return tr.DECIMAL_LEADING_ZERO;case"lower-roman":return tr.LOWER_ROMAN;case"upper-roman":return tr.UPPER_ROMAN;case"lower-greek":return tr.LOWER_GREEK;case"lower-alpha":return tr.LOWER_ALPHA;case"upper-alpha":return tr.UPPER_ALPHA;case"arabic-indic":return tr.ARABIC_INDIC;case"armenian":return tr.ARMENIAN;case"bengali":return tr.BENGALI;case"cambodian":return tr.CAMBODIAN;case"cjk-earthly-branch":return tr.CJK_EARTHLY_BRANCH;case"cjk-heavenly-stem":return tr.CJK_HEAVENLY_STEM;case"cjk-ideographic":return tr.CJK_IDEOGRAPHIC;case"devanagari":return tr.DEVANAGARI;case"ethiopic-numeric":return tr.ETHIOPIC_NUMERIC;case"georgian":return tr.GEORGIAN;case"gujarati":return tr.GUJARATI;case"gurmukhi":return tr.GURMUKHI;case"hebrew":return tr.HEBREW;case"hiragana":return tr.HIRAGANA;case"hiragana-iroha":return tr.HIRAGANA_IROHA;case"japanese-formal":return tr.JAPANESE_FORMAL;case"japanese-informal":return tr.JAPANESE_INFORMAL;case"kannada":return tr.KANNADA;case"katakana":return tr.KATAKANA;case"katakana-iroha":return tr.KATAKANA_IROHA;case"khmer":return tr.KHMER;case"korean-hangul-formal":return tr.KOREAN_HANGUL_FORMAL;case"korean-hanja-formal":return tr.KOREAN_HANJA_FORMAL;case"korean-hanja-informal":return tr.KOREAN_HANJA_INFORMAL;case"lao":return tr.LAO;case"lower-armenian":return tr.LOWER_ARMENIAN;case"malayalam":return tr.MALAYALAM;case"mongolian":return tr.MONGOLIAN;case"myanmar":return tr.MYANMAR;case"oriya":return tr.ORIYA;case"persian":return tr.PERSIAN;case"simp-chinese-formal":return tr.SIMP_CHINESE_FORMAL;case"simp-chinese-informal":return tr.SIMP_CHINESE_INFORMAL;case"tamil":return tr.TAMIL;case"telugu":return tr.TELUGU;case"thai":return tr.THAI;case"tibetan":return tr.TIBETAN;case"trad-chinese-formal":return tr.TRAD_CHINESE_FORMAL;case"trad-chinese-informal":return tr.TRAD_CHINESE_INFORMAL;case"upper-armenian":return tr.UPPER_ARMENIAN;case"disclosure-open":return tr.DISCLOSURE_OPEN;case"disclosure-closed":return tr.DISCLOSURE_CLOSED;case"none":default:return tr.NONE}}},ar=Br("top"),cr=Br("right"),Qr=Br("bottom"),wr=Br("left");(or=sr||(sr={}))[or.VISIBLE=0]="VISIBLE",or[or.HIDDEN=1]="HIDDEN",or[or.SCROLL=2]="SCROLL";function ur(A){return{name:"padding-"+A,initialValue:"0",prefix:!1,type:Ce.TYPE_VALUE,format:"length-percentage"}}var Ur,lr,Cr,gr,Er={name:"overflow",initialValue:"visible",prefix:!(or[or.AUTO=3]="AUTO"),type:Ce.LIST,parse:function(A){return A.filter(zA).map(function(A){switch(A.value){case"hidden":return sr.HIDDEN;case"scroll":return sr.SCROLL;case"auto":return sr.AUTO;case"visible":default:return sr.VISIBLE}})}},Fr={name:"overflow-wrap",initialValue:(lr=Ur||(Ur={})).NORMAL="normal",prefix:!(lr.BREAK_WORD="break-word"),type:Ce.IDENT_VALUE,parse:function(A){switch(A){case"break-word":return Ur.BREAK_WORD;case"normal":default:return Ur.NORMAL}}},hr=ur("top"),Hr=ur("right"),dr=ur("bottom"),fr=ur("left");(gr=Cr||(Cr={}))[gr.LEFT=0]="LEFT",gr[gr.CENTER=1]="CENTER";var pr,Nr,Kr={name:"text-align",initialValue:"left",prefix:!(gr[gr.RIGHT=2]="RIGHT"),type:Ce.IDENT_VALUE,parse:function(A){switch(A){case"right":return Cr.RIGHT;case"center":case"justify":return Cr.CENTER;case"left":default:return Cr.LEFT}}};(Nr=pr||(pr={}))[Nr.STATIC=0]="STATIC",Nr[Nr.RELATIVE=1]="RELATIVE",Nr[Nr.ABSOLUTE=2]="ABSOLUTE",Nr[Nr.FIXED=3]="FIXED";var Ir,Tr,mr={name:"position",initialValue:"static",prefix:!(Nr[Nr.STICKY=4]="STICKY"),type:Ce.IDENT_VALUE,parse:function(A){switch(A){case"relative":return pr.RELATIVE;case"absolute":return pr.ABSOLUTE;case"fixed":return pr.FIXED;case"sticky":return pr.STICKY}return pr.STATIC}},Rr={name:"text-shadow",initialValue:"none",type:Ce.LIST,prefix:!1,parse:function(A){return 1===A.length&&JA(A[0],"none")?[]:WA(A).map(function(A){for(var e={color:He.TRANSPARENT,offsetX:se,offsetY:se,blur:se},t=0,r=0;r<A.length;r++){var n=A[r];YA(n)?(0===t?e.offsetX=n:1===t?e.offsetY=n:e.blur=n,t++):e.color=we(n)}return e})}};(Tr=Ir||(Ir={}))[Tr.NONE=0]="NONE",Tr[Tr.LOWERCASE=1]="LOWERCASE",Tr[Tr.UPPERCASE=2]="UPPERCASE";var Lr,vr,Or={name:"text-transform",initialValue:"none",prefix:!(Tr[Tr.CAPITALIZE=3]="CAPITALIZE"),type:Ce.IDENT_VALUE,parse:function(A){switch(A){case"uppercase":return Ir.UPPERCASE;case"lowercase":return Ir.LOWERCASE;case"capitalize":return Ir.CAPITALIZE}return Ir.NONE}},Dr={name:"transform",initialValue:"none",prefix:!0,type:Ce.VALUE,parse:function(A){if(A.type===sA.IDENT_TOKEN&&"none"===A.value)return null;if(A.type!==sA.FUNCTION)return null;var e=br[A.name];if(void 0===e)throw new Error('Attempting to parse an unsupported transform function "'+A.name+'"');return e(A.values)}},br={matrix:function(A){var e=A.filter(function(A){return A.type===sA.NUMBER_TOKEN}).map(function(A){return A.number});return 6===e.length?e:null},matrix3d:function(A){var e=A.filter(function(A){return A.type===sA.NUMBER_TOKEN}).map(function(A){return A.number}),t=e[0],r=e[1],n=(e[2],e[3],e[4]),B=e[5],s=(e[6],e[7],e[8],e[9],e[10],e[11],e[12]),o=e[13];e[14],e[15];return 16===e.length?[t,r,n,B,s,o]:null}},Sr={type:sA.PERCENTAGE_TOKEN,number:50,flags:4},Mr=[Sr,Sr],yr={name:"transform-origin",initialValue:"50% 50%",prefix:!0,type:Ce.LIST,parse:function(A){var e=A.filter(qA);return 2!==e.length?Mr:[e[0],e[1]]}};(vr=Lr||(Lr={}))[vr.VISIBLE=0]="VISIBLE",vr[vr.HIDDEN=1]="HIDDEN";var _r,Pr,xr={name:"visible",initialValue:"none",prefix:!(vr[vr.COLLAPSE=2]="COLLAPSE"),type:Ce.IDENT_VALUE,parse:function(A){switch(A){case"hidden":return Lr.HIDDEN;case"collapse":return Lr.COLLAPSE;case"visible":default:return Lr.VISIBLE}}};(Pr=_r||(_r={})).NORMAL="normal",Pr.BREAK_ALL="break-all";var Vr,zr,Xr={name:"word-break",initialValue:"normal",prefix:!(Pr.KEEP_ALL="keep-all"),type:Ce.IDENT_VALUE,parse:function(A){switch(A){case"break-all":return _r.BREAK_ALL;case"keep-all":return _r.KEEP_ALL;case"normal":default:return _r.NORMAL}}},Jr={name:"z-index",initialValue:"auto",prefix:!1,type:Ce.VALUE,parse:function(A){if(A.type===sA.IDENT_TOKEN)return{auto:!0,order:0};if(VA(A))return{auto:!1,order:A.number};throw new Error("Invalid z-index number parsed")}},Gr={name:"opacity",initialValue:"1",type:Ce.VALUE,prefix:!1,parse:function(A){return VA(A)?A.number:1}},kr={name:"text-decoration-color",initialValue:"transparent",prefix:!1,type:Ce.TYPE_VALUE,format:"color"},Wr={name:"text-decoration-line",initialValue:"none",prefix:!1,type:Ce.LIST,parse:function(A){return A.filter(zA).map(function(A){switch(A.value){case"underline":return 1;case"overline":return 2;case"line-through":return 3;case"none":return 4}return 0}).filter(function(A){return 0!==A})}},Yr={name:"font-family",initialValue:"",prefix:!1,type:Ce.LIST,parse:function(A){return A.filter(qr).map(function(A){return A.value})}},qr=function(A){return A.type===sA.STRING_TOKEN||A.type===sA.IDENT_TOKEN},Zr={name:"font-size",initialValue:"0",prefix:!1,type:Ce.TYPE_VALUE,format:"length"},jr={name:"font-weight",initialValue:"normal",type:Ce.VALUE,prefix:!1,parse:function(A){if(VA(A))return A.number;if(zA(A))switch(A.value){case"bold":return 700;case"normal":default:return 400}return 400}},$r={name:"font-variant",initialValue:"none",type:Ce.LIST,prefix:!1,parse:function(A){return A.filter(zA).map(function(A){return A.value})}};(zr=Vr||(Vr={})).NORMAL="normal",zr.ITALIC="italic";function An(A,e){return 0!=(A&e)}function en(A,e,t){if(!A)return"";var r=A[Math.min(e,A.length-1)];return r?t?r.open:r.close:""}var tn={name:"font-style",initialValue:"normal",prefix:!(zr.OBLIQUE="oblique"),type:Ce.IDENT_VALUE,parse:function(A){switch(A){case"oblique":return Vr.OBLIQUE;case"italic":return Vr.ITALIC;case"normal":default:return Vr.NORMAL}}},rn={name:"content",initialValue:"none",type:Ce.LIST,prefix:!1,parse:function(A){if(0===A.length)return[];var e=A[0];return e.type===sA.IDENT_TOKEN&&"none"===e.value?[]:A}},nn={name:"counter-increment",initialValue:"none",prefix:!0,type:Ce.LIST,parse:function(A){if(0===A.length)return null;var e=A[0];if(e.type===sA.IDENT_TOKEN&&"none"===e.value)return null;for(var t=[],r=A.filter(GA),n=0;n<r.length;n++){var B=r[n],s=r[n+1];if(B.type===sA.IDENT_TOKEN){var o=s&&VA(s)?s.number:1;t.push({counter:B.value,increment:o})}}return t}},Bn={name:"counter-reset",initialValue:"none",prefix:!0,type:Ce.LIST,parse:function(A){if(0===A.length)return[];for(var e=[],t=A.filter(GA),r=0;r<t.length;r++){var n=t[r],B=t[r+1];if(zA(n)&&"none"!==n.value){var s=B&&VA(B)?B.number:0;e.push({counter:n.value,reset:s})}}return e}},sn={name:"quotes",initialValue:"none",prefix:!0,type:Ce.LIST,parse:function(A){if(0===A.length)return null;var e=A[0];if(e.type===sA.IDENT_TOKEN&&"none"===e.value)return null;var t=[],r=A.filter(XA);if(r.length%2!=0)return null;for(var n=0;n<r.length;n+=2){var B=r[n].value,s=r[n+1].value;t.push({open:B,close:s})}return t}},on={name:"box-shadow",initialValue:"none",type:Ce.LIST,prefix:!1,parse:function(A){return 1===A.length&&JA(A[0],"none")?[]:WA(A).map(function(A){for(var e={color:255,offsetX:se,offsetY:se,blur:se,spread:se,inset:!1},t=0,r=0;r<A.length;r++){var n=A[r];JA(n,"inset")?e.inset=!0:YA(n)?(0===t?e.offsetX=n:1===t?e.offsetY=n:2===t?e.blur=n:e.spread=n,t++):e.color=we(n)}return e})}},an=(cn.prototype.isVisible=function(){return 0<this.display&&0<this.opacity&&this.visibility===Lr.VISIBLE},cn.prototype.isTransparent=function(){return ee(this.backgroundColor)},cn.prototype.isTransformed=function(){return null!==this.transform},cn.prototype.isPositioned=function(){return this.position!==pr.STATIC},cn.prototype.isPositionedWithZIndex=function(){return this.isPositioned()&&!this.zIndex.auto},cn.prototype.isFloating=function(){return this.float!==Dt.NONE},cn.prototype.isInlineLevel=function(){return An(this.display,4)||An(this.display,33554432)||An(this.display,268435456)||An(this.display,536870912)||An(this.display,67108864)||An(this.display,134217728)},cn);function cn(A){this.backgroundClip=Un(me,A.backgroundClip),this.backgroundColor=Un(Re,A.backgroundColor),this.backgroundImage=Un(Qt,A.backgroundImage),this.backgroundOrigin=Un(wt,A.backgroundOrigin),this.backgroundPosition=Un(ut,A.backgroundPosition),this.backgroundRepeat=Un(Ct,A.backgroundRepeat),this.backgroundSize=Un(dt,A.backgroundSize),this.borderTopColor=Un(pt,A.borderTopColor),this.borderRightColor=Un(Nt,A.borderRightColor),this.borderBottomColor=Un(Kt,A.borderBottomColor),this.borderLeftColor=Un(It,A.borderLeftColor),this.borderTopLeftRadius=Un(Tt,A.borderTopLeftRadius),this.borderTopRightRadius=Un(mt,A.borderTopRightRadius),this.borderBottomRightRadius=Un(Rt,A.borderBottomRightRadius),this.borderBottomLeftRadius=Un(Lt,A.borderBottomLeftRadius),this.borderTopStyle=Un(St,A.borderTopStyle),this.borderRightStyle=Un(Mt,A.borderRightStyle),this.borderBottomStyle=Un(yt,A.borderBottomStyle),this.borderLeftStyle=Un(_t,A.borderLeftStyle),this.borderTopWidth=Un(Pt,A.borderTopWidth),this.borderRightWidth=Un(xt,A.borderRightWidth),this.borderBottomWidth=Un(Vt,A.borderBottomWidth),this.borderLeftWidth=Un(zt,A.borderLeftWidth),this.boxShadow=Un(on,A.boxShadow),this.color=Un(Xt,A.color),this.display=Un(Jt,A.display),this.float=Un(Zt,A.cssFloat),this.fontFamily=Un(Yr,A.fontFamily),this.fontSize=Un(Zr,A.fontSize),this.fontStyle=Un(tn,A.fontStyle),this.fontVariant=Un($r,A.fontVariant),this.fontWeight=Un(jr,A.fontWeight),this.letterSpacing=Un(jt,A.letterSpacing),this.lineBreak=Un($t,A.lineBreak),this.lineHeight=Un(Ar,A.lineHeight),this.listStyleImage=Un(er,A.listStyleImage),this.listStylePosition=Un(nr,A.listStylePosition),this.listStyleType=Un(ir,A.listStyleType),this.marginTop=Un(ar,A.marginTop),this.marginRight=Un(cr,A.marginRight),this.marginBottom=Un(Qr,A.marginBottom),this.marginLeft=Un(wr,A.marginLeft),this.opacity=Un(Gr,A.opacity);var e=Un(Er,A.overflow);this.overflowX=e[0],this.overflowY=e[1<e.length?1:0],this.overflowWrap=Un(Fr,A.overflowWrap),this.paddingTop=Un(hr,A.paddingTop),this.paddingRight=Un(Hr,A.paddingRight),this.paddingBottom=Un(dr,A.paddingBottom),this.paddingLeft=Un(fr,A.paddingLeft),this.position=Un(mr,A.position),this.textAlign=Un(Kr,A.textAlign),this.textDecorationColor=Un(kr,A.textDecorationColor||A.color),this.textDecorationLine=Un(Wr,A.textDecorationLine),this.textShadow=Un(Rr,A.textShadow),this.textTransform=Un(Or,A.textTransform),this.transform=Un(Dr,A.transform),this.transformOrigin=Un(yr,A.transformOrigin),this.visibility=Un(xr,A.visibility),this.wordBreak=Un(Xr,A.wordBreak),this.zIndex=Un(Jr,A.zIndex)}var Qn,wn=function(A){this.content=Un(rn,A.content),this.quotes=Un(sn,A.quotes)},un=function(A){this.counterIncrement=Un(nn,A.counterIncrement),this.counterReset=Un(Bn,A.counterReset)},Un=function(A,e){var t=new MA,r=null!=e?e.toString():A.initialValue;t.write(r);var n=new _A(t.read());switch(A.type){case Ce.IDENT_VALUE:var B=n.parseComponentValue();return A.parse(zA(B)?B.value:A.initialValue);case Ce.VALUE:return A.parse(n.parseComponentValue());case Ce.LIST:return A.parse(n.parseComponentValues());case Ce.TOKEN_VALUE:return n.parseComponentValue();case Ce.TYPE_VALUE:switch(A.format){case"angle":return ce(n.parseComponentValue());case"color":return we(n.parseComponentValue());case"image":return ot(n.parseComponentValue());case"length":var s=n.parseComponentValue();return YA(s)?s:se;case"length-percentage":var o=n.parseComponentValue();return qA(o)?o:se}}throw new Error("Attempting to parse unsupported css format type "+A.format)},ln=function(A){this.styles=new an(window.getComputedStyle(A,null)),this.textNodes=[],this.elements=[],null!==this.styles.transform&&uB(A)&&(A.style.transform="none"),this.bounds=T(A),this.flags=0},Cn=function(A,e){this.text=A,this.bounds=e},gn=function(A){var e=A.ownerDocument;if(e){var t=e.createElement("html2canvaswrapper");t.appendChild(A.cloneNode(!0));var r=A.parentNode;if(r){r.replaceChild(t,A);var n=T(t);return t.firstChild&&r.replaceChild(t.firstChild,t),n}}return new I(0,0,0,0)},En=function(A,e,t){var r=A.ownerDocument;if(!r)throw new Error("Node has no owner document");var n=r.createRange();return n.setStart(A,e),n.setEnd(A,e+t),I.fromClientRect(n.getBoundingClientRect())},Fn=function(A,e){return 0!==e.letterSpacing?c(A).map(function(A){return l(A)}):hn(A,e)},hn=function(A,e){for(var t,r=function(A,e){var t=c(A),r=u(t,e),n=r[0],B=r[1],s=r[2],o=t.length,i=0,a=0;return{next:function(){if(o<=a)return{done:!0,value:null};for(var A=Y;a<o&&(A=w(t,B,n,++a,s))===Y;);if(A===Y&&a!==o)return{done:!0,value:null};var e=new nA(t,A,i,a);return i=a,{value:e,done:!1}}}}(A,{lineBreak:e.lineBreak,wordBreak:e.overflowWrap===Ur.BREAK_WORD?"break-word":e.wordBreak}),n=[];!(t=r.next()).done;)t.value&&n.push(t.value.slice());return n},Hn=function(A,e){this.text=dn(A.data,e.textTransform),this.textBounds=function(A,t,r){var e=Fn(A,t),n=[],B=0;return e.forEach(function(A){if(t.textDecorationLine.length||0<A.trim().length)if(Oe.SUPPORT_RANGE_BOUNDS)n.push(new Cn(A,En(r,B,A.length)));else{var e=r.splitText(A.length);n.push(new Cn(A,gn(r))),r=e}else Oe.SUPPORT_RANGE_BOUNDS||(r=r.splitText(A.length));B+=A.length}),n}(this.text,e,A)},dn=function(A,e){switch(e){case Ir.LOWERCASE:return A.toLowerCase();case Ir.CAPITALIZE:return A.replace(fn,pn);case Ir.UPPERCASE:return A.toUpperCase();default:return A}},fn=/(^|\s|:|-|\(|\))([a-z])/g,pn=function(A,e,t){return 0<A.length?e+t.toUpperCase():A},Nn=(A(Kn,Qn=ln),Kn);function Kn(A){var e=Qn.call(this,A)||this;return e.src=A.currentSrc||A.src,e.intrinsicWidth=A.naturalWidth,e.intrinsicHeight=A.naturalHeight,Se.getInstance().addImage(e.src),e}var In,Tn=(A(mn,In=ln),mn);function mn(A){var e=In.call(this,A)||this;return e.canvas=A,e.intrinsicWidth=A.width,e.intrinsicHeight=A.height,e}var Rn,Ln=(A(vn,Rn=ln),vn);function vn(A){var e=Rn.call(this,A)||this,t=new XMLSerializer;return e.svg="data:image/svg+xml,"+encodeURIComponent(t.serializeToString(A)),e.intrinsicWidth=A.width.baseVal.value,e.intrinsicHeight=A.height.baseVal.value,Se.getInstance().addImage(e.svg),e}var On,Dn=(A(bn,On=ln),bn);function bn(A){var e=On.call(this,A)||this;return e.value=A.value,e}var Sn,Mn=(A(yn,Sn=ln),yn);function yn(A){var e=Sn.call(this,A)||this;return e.start=A.start,e.reversed="boolean"==typeof A.reversed&&!0===A.reversed,e}var _n,Pn=[{type:sA.DIMENSION_TOKEN,flags:0,unit:"px",number:3}],xn=[{type:sA.PERCENTAGE_TOKEN,flags:0,number:50}],Vn="checkbox",zn="radio",Xn="password",Jn=707406591,Gn=(A(kn,_n=ln),kn);function kn(A){var e=_n.call(this,A)||this;switch(e.type=A.type.toLowerCase(),e.checked=A.checked,e.value=function(A){var e=A.type===Xn?new Array(A.value.length+1).join("•"):A.value;return 0===e.length?A.placeholder||"":e}(A),e.type!==Vn&&e.type!==zn||(e.styles.backgroundColor=3739148031,e.styles.borderTopColor=e.styles.borderRightColor=e.styles.borderBottomColor=e.styles.borderLeftColor=2779096575,e.styles.borderTopWidth=e.styles.borderRightWidth=e.styles.borderBottomWidth=e.styles.borderLeftWidth=1,e.styles.borderTopStyle=e.styles.borderRightStyle=e.styles.borderBottomStyle=e.styles.borderLeftStyle=ht.SOLID,e.styles.backgroundClip=[Ee.BORDER_BOX],e.styles.backgroundOrigin=[0],e.bounds=function(A){return A.width>A.height?new I(A.left+(A.width-A.height)/2,A.top,A.height,A.height):A.width<A.height?new I(A.left,A.top+(A.height-A.width)/2,A.width,A.width):A}(e.bounds)),e.type){case Vn:e.styles.borderTopRightRadius=e.styles.borderTopLeftRadius=e.styles.borderBottomRightRadius=e.styles.borderBottomLeftRadius=Pn;break;case zn:e.styles.borderTopRightRadius=e.styles.borderTopLeftRadius=e.styles.borderBottomRightRadius=e.styles.borderBottomLeftRadius=xn}return e}var Wn,Yn=(A(qn,Wn=ln),qn);function qn(A){var e=Wn.call(this,A)||this,t=A.options[A.selectedIndex||0];return e.value=t&&t.text||"",e}var Zn,jn=(A($n,Zn=ln),$n);function $n(A){var e=Zn.call(this,A)||this;return e.value=A.value,e}function AB(A){return we(_A.create(A).parseComponentValue())}var eB,tB=(A(rB,eB=ln),rB);function rB(A){var e=eB.call(this,A)||this;e.src=A.src,e.width=parseInt(A.width,10)||0,e.height=parseInt(A.height,10)||0,e.backgroundColor=e.styles.backgroundColor;try{if(A.contentWindow&&A.contentWindow.document&&A.contentWindow.document.documentElement){e.tree=iB(A.contentWindow.document.documentElement);var t=A.contentWindow.document.documentElement?AB(getComputedStyle(A.contentWindow.document.documentElement).backgroundColor):He.TRANSPARENT,r=A.contentWindow.document.body?AB(getComputedStyle(A.contentWindow.document.body).backgroundColor):He.TRANSPARENT;e.backgroundColor=ee(t)?ee(r)?e.styles.backgroundColor:r:t}}catch(A){}return e}function nB(A){return"STYLE"===A.tagName}var BB=["OL","UL","MENU"],sB=function(A,e,t){for(var r=A.firstChild,n=void 0;r;r=n)if(n=r.nextSibling,QB(r)&&0<r.data.trim().length)e.textNodes.push(new Hn(r,e.styles));else if(wB(r)){var B=oB(r);B.styles.isVisible()&&(aB(r,B,t)?B.flags|=4:cB(B.styles)&&(B.flags|=2),-1!==BB.indexOf(r.tagName)&&(B.flags|=8),e.elements.push(B),dB(r)||gB(r)||fB(r)||sB(r,B,t))}},oB=function(A){return hB(A)?new Nn(A):FB(A)?new Tn(A):gB(A)?new Ln(A):UB(A)?new Dn(A):lB(A)?new Mn(A):CB(A)?new Gn(A):fB(A)?new Yn(A):dB(A)?new jn(A):HB(A)?new tB(A):new ln(A)},iB=function(A){var e=oB(A);return e.flags|=4,sB(A,e,e),e},aB=function(A,e,t){return e.styles.isPositionedWithZIndex()||e.styles.opacity<1||e.styles.isTransformed()||EB(A)&&t.styles.isTransparent()},cB=function(A){return A.isPositioned()||A.isFloating()},QB=function(A){return A.nodeType===Node.TEXT_NODE},wB=function(A){return A.nodeType===Node.ELEMENT_NODE},uB=function(A){return void 0!==A.style},UB=function(A){return"LI"===A.tagName},lB=function(A){return"OL"===A.tagName},CB=function(A){return"INPUT"===A.tagName},gB=function(A){return"svg"===A.tagName},EB=function(A){return"BODY"===A.tagName},FB=function(A){return"CANVAS"===A.tagName},hB=function(A){return"IMG"===A.tagName},HB=function(A){return"IFRAME"===A.tagName},dB=function(A){return"TEXTAREA"===A.tagName},fB=function(A){return"SELECT"===A.tagName},pB=(NB.prototype.getCounterValue=function(A){var e=this.counters[A];return e&&e.length?e[e.length-1]:1},NB.prototype.getCounterValues=function(A){var e=this.counters[A];return e||[]},NB.prototype.pop=function(A){var e=this;A.forEach(function(A){return e.counters[A].pop()})},NB.prototype.parse=function(A){var t=this,e=A.counterIncrement,r=A.counterReset,n=!0;null!==e&&e.forEach(function(A){var e=t.counters[A.counter];e&&0!==A.increment&&(n=!1,e[Math.max(0,e.length-1)]+=A.increment)});var B=[];return n&&r.forEach(function(A){var e=t.counters[A.counter];B.push(A.counter),e||(e=t.counters[A.counter]=[]),e.push(A.reset)}),B},NB);function NB(){this.counters={}}function KB(r,A,e,n,t,B){return r<A||e<r?yB(r,t,0<B.length):n.integers.reduce(function(A,e,t){for(;e<=r;)r-=e,A+=n.values[t];return A},"")+B}function IB(A,e,t,r){for(var n="";t||A--,n=r(A)+n,e<=(A/=e)*e;);return n}function TB(A,e,t,r,n){var B=t-e+1;return(A<0?"-":"")+(IB(Math.abs(A),B,r,function(A){return l(Math.floor(A%B)+e)})+n)}function mB(A,e,t){void 0===t&&(t=". ");var r=e.length;return IB(Math.abs(A),r,!1,function(A){return e[Math.floor(A%r)]})+t}function RB(A,e,t,r,n,B){if(A<-9999||9999<A)return yB(A,tr.CJK_DECIMAL,0<n.length);var s=Math.abs(A),o=n;if(0===s)return e[0]+o;for(var i=0;0<s&&i<=4;i++){var a=s%10;0==a&&An(B,1)&&""!==o?o=e[a]+o:1<a||1==a&&0===i||1==a&&1===i&&An(B,2)||1==a&&1===i&&An(B,4)&&100<A||1==a&&1<i&&An(B,8)?o=e[a]+(0<i?t[i-1]:"")+o:1==a&&0<i&&(o=t[i-1]+o),s=Math.floor(s/10)}return(A<0?r:"")+o}var LB,vB,OB={integers:[1e3,900,500,400,100,90,50,40,10,9,5,4,1],values:["M","CM","D","CD","C","XC","L","XL","X","IX","V","IV","I"]},DB={integers:[9e3,8e3,7e3,6e3,5e3,4e3,3e3,2e3,1e3,900,800,700,600,500,400,300,200,100,90,80,70,60,50,40,30,20,10,9,8,7,6,5,4,3,2,1],values:["Ք","Փ","Ւ","Ց","Ր","Տ","Վ","Ս","Ռ","Ջ","Պ","Չ","Ո","Շ","Ն","Յ","Մ","Ճ","Ղ","Ձ","Հ","Կ","Ծ","Խ","Լ","Ի","Ժ","Թ","Ը","Է","Զ","Ե","Դ","Գ","Բ","Ա"]},bB={integers:[1e4,9e3,8e3,7e3,6e3,5e3,4e3,3e3,2e3,1e3,400,300,200,100,90,80,70,60,50,40,30,20,19,18,17,16,15,10,9,8,7,6,5,4,3,2,1],values:["י׳","ט׳","ח׳","ז׳","ו׳","ה׳","ד׳","ג׳","ב׳","א׳","ת","ש","ר","ק","צ","פ","ע","ס","נ","מ","ל","כ","יט","יח","יז","טז","טו","י","ט","ח","ז","ו","ה","ד","ג","ב","א"]},SB={integers:[1e4,9e3,8e3,7e3,6e3,5e3,4e3,3e3,2e3,1e3,900,800,700,600,500,400,300,200,100,90,80,70,60,50,40,30,20,10,9,8,7,6,5,4,3,2,1],values:["ჵ","ჰ","ჯ","ჴ","ხ","ჭ","წ","ძ","ც","ჩ","შ","ყ","ღ","ქ","ფ","ჳ","ტ","ს","რ","ჟ","პ","ო","ჲ","ნ","მ","ლ","კ","ი","თ","ჱ","ზ","ვ","ე","დ","გ","ბ","ა"]},MB="마이너스",yB=function(A,e,t){var r=t?". ":"",n=t?"、":"",B=t?", ":"",s=t?" ":"";switch(e){case tr.DISC:return"•"+s;case tr.CIRCLE:return"◦"+s;case tr.SQUARE:return"◾"+s;case tr.DECIMAL_LEADING_ZERO:var o=TB(A,48,57,!0,r);return o.length<4?"0"+o:o;case tr.CJK_DECIMAL:return mB(A,"〇一二三四五六七八九",n);case tr.LOWER_ROMAN:return KB(A,1,3999,OB,tr.DECIMAL,r).toLowerCase();case tr.UPPER_ROMAN:return KB(A,1,3999,OB,tr.DECIMAL,r);case tr.LOWER_GREEK:return TB(A,945,969,!1,r);case tr.LOWER_ALPHA:return TB(A,97,122,!1,r);case tr.UPPER_ALPHA:return TB(A,65,90,!1,r);case tr.ARABIC_INDIC:return TB(A,1632,1641,!0,r);case tr.ARMENIAN:case tr.UPPER_ARMENIAN:return KB(A,1,9999,DB,tr.DECIMAL,r);case tr.LOWER_ARMENIAN:return KB(A,1,9999,DB,tr.DECIMAL,r).toLowerCase();case tr.BENGALI:return TB(A,2534,2543,!0,r);case tr.CAMBODIAN:case tr.KHMER:return TB(A,6112,6121,!0,r);case tr.CJK_EARTHLY_BRANCH:return mB(A,"子丑寅卯辰巳午未申酉戌亥",n);case tr.CJK_HEAVENLY_STEM:return mB(A,"甲乙丙丁戊己庚辛壬癸",n);case tr.CJK_IDEOGRAPHIC:case tr.TRAD_CHINESE_INFORMAL:return RB(A,"零一二三四五六七八九","十百千萬","負",n,14);case tr.TRAD_CHINESE_FORMAL:return RB(A,"零壹貳參肆伍陸柒捌玖","拾佰仟萬","負",n,15);case tr.SIMP_CHINESE_INFORMAL:return RB(A,"零一二三四五六七八九","十百千萬","负",n,14);case tr.SIMP_CHINESE_FORMAL:return RB(A,"零壹贰叁肆伍陆柒捌玖","拾佰仟萬","负",n,15);case tr.JAPANESE_INFORMAL:return RB(A,"〇一二三四五六七八九","十百千万","マイナス",n,0);case tr.JAPANESE_FORMAL:return RB(A,"零壱弐参四伍六七八九","拾百千万","マイナス",n,7);case tr.KOREAN_HANGUL_FORMAL:return RB(A,"영일이삼사오육칠팔구","십백천만",MB,B,7);case tr.KOREAN_HANJA_INFORMAL:return RB(A,"零一二三四五六七八九","十百千萬",MB,B,0);case tr.KOREAN_HANJA_FORMAL:return RB(A,"零壹貳參四五六七八九","拾百千",MB,B,7);case tr.DEVANAGARI:return TB(A,2406,2415,!0,r);case tr.GEORGIAN:return KB(A,1,19999,SB,tr.DECIMAL,r);case tr.GUJARATI:return TB(A,2790,2799,!0,r);case tr.GURMUKHI:return TB(A,2662,2671,!0,r);case tr.HEBREW:return KB(A,1,10999,bB,tr.DECIMAL,r);case tr.HIRAGANA:return mB(A,"あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");case tr.HIRAGANA_IROHA:return mB(A,"いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");case tr.KANNADA:return TB(A,3302,3311,!0,r);case tr.KATAKANA:return mB(A,"アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン",n);case tr.KATAKANA_IROHA:return mB(A,"イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス",n);case tr.LAO:return TB(A,3792,3801,!0,r);case tr.MONGOLIAN:return TB(A,6160,6169,!0,r);case tr.MYANMAR:return TB(A,4160,4169,!0,r);case tr.ORIYA:return TB(A,2918,2927,!0,r);case tr.PERSIAN:return TB(A,1776,1785,!0,r);case tr.TAMIL:return TB(A,3046,3055,!0,r);case tr.TELUGU:return TB(A,3174,3183,!0,r);case tr.THAI:return TB(A,3664,3673,!0,r);case tr.TIBETAN:return TB(A,3872,3881,!0,r);case tr.DECIMAL:default:return TB(A,48,57,!0,r)}},_B="data-html2canvas-ignore",PB=(xB.prototype.toIFrame=function(A,t){var e=this,r=XB(A,t);if(!r.contentWindow)return Promise.reject("Unable to find iframe window");var n=A.defaultView.pageXOffset,B=A.defaultView.pageYOffset,s=r.contentWindow,o=s.document,i=JB(r).then(function(){return a(e,void 0,void 0,function(){var e;return S(this,function(A){switch(A.label){case 0:return this.scrolledElements.forEach(YB),s&&(s.scrollTo(t.left,t.top),!/(iPad|iPhone|iPod)/g.test(navigator.userAgent)||s.scrollY===t.top&&s.scrollX===t.left||(o.documentElement.style.top=-t.top+"px",o.documentElement.style.left=-t.left+"px",o.documentElement.style.position="absolute")),e=this.options.onclone,void 0===this.clonedReferenceElement?[2,Promise.reject("Error finding the "+this.referenceElement.nodeName+" in the cloned document")]:o.fonts&&o.fonts.ready?[4,o.fonts.ready]:[3,2];case 1:A.sent(),A.label=2;case 2:return"function"==typeof e?[2,Promise.resolve().then(function(){return e(o)}).then(function(){return r})]:[2,r]}})})});return o.open(),o.write(kB(document.doctype)+"<html></html>"),WB(this.referenceElement.ownerDocument,n,B),o.replaceChild(o.adoptNode(this.documentElement),o.documentElement),o.close(),i},xB.prototype.createElementClone=function(A){return FB(A)?this.createCanvasClone(A):nB(A)?this.createStyleClone(A):A.cloneNode(!1)},xB.prototype.createStyleClone=function(A){try{var e=A.sheet;if(e&&e.cssRules){var t=[].slice.call(e.cssRules,0).reduce(function(A,e){return e&&"string"==typeof e.cssText?A+e.cssText:A},""),r=A.cloneNode(!1);return r.textContent=t,r}}catch(A){if(De.getInstance(this.options.id).error("Unable to access cssRules property",A),"SecurityError"!==A.name)throw A}return A.cloneNode(!1)},xB.prototype.createCanvasClone=function(A){if(this.options.inlineImages&&A.ownerDocument){var e=A.ownerDocument.createElement("img");try{return e.src=A.toDataURL(),e}catch(A){De.getInstance(this.options.id).info("Unable to clone canvas contents, canvas is tainted")}}var t=A.cloneNode(!1);try{t.width=A.width,t.height=A.height;var r=A.getContext("2d"),n=t.getContext("2d");return n&&(r?n.putImageData(r.getImageData(0,0,A.width,A.height),0,0):n.drawImage(A,0,0)),t}catch(A){}return t},xB.prototype.cloneNode=function(A){if(QB(A))return document.createTextNode(A.data);if(!A.ownerDocument)return A.cloneNode(!1);var e=A.ownerDocument.defaultView;if(uB(A)&&e){var t=this.createElementClone(A),r=e.getComputedStyle(A),n=e.getComputedStyle(A,":before"),B=e.getComputedStyle(A,":after");this.referenceElement===A&&(this.clonedReferenceElement=t),EB(t)&&$B(t);for(var s=this.counters.parse(new un(r)),o=this.resolvePseudoContent(A,t,n,LB.BEFORE),i=A.firstChild;i;i=i.nextSibling)wB(i)&&("SCRIPT"===i.tagName||i.hasAttribute(_B)||"function"==typeof this.options.ignoreElements&&this.options.ignoreElements(i))||this.options.copyStyles&&wB(i)&&nB(i)||t.appendChild(this.cloneNode(i));o&&t.insertBefore(o,t.firstChild);var a=this.resolvePseudoContent(A,t,B,LB.AFTER);return a&&t.appendChild(a),this.counters.pop(s),r&&this.options.copyStyles&&!HB(A)&&GB(r,t),0===A.scrollTop&&0===A.scrollLeft||this.scrolledElements.push([t,A.scrollLeft,A.scrollTop]),(dB(A)||fB(A))&&(dB(t)||fB(t))&&(t.value=A.value),t}return A.cloneNode(!1)},xB.prototype.resolvePseudoContent=function(U,A,e,t){var l=this;if(e){var r=e.content,C=A.ownerDocument;if(C&&r&&"none"!==r&&"-moz-alt-content"!==r&&"none"!==e.display){this.counters.parse(new un(e));var g=new wn(e),E=C.createElement("html2canvaspseudoelement");return GB(e,E),g.content.forEach(function(A){if(A.type===sA.STRING_TOKEN)E.appendChild(C.createTextNode(A.value));else if(A.type===sA.URL_TOKEN){var e=C.createElement("img");e.src=A.value,e.style.opacity="1",E.appendChild(e)}else if(A.type===sA.FUNCTION){if("attr"===A.name){var t=A.values.filter(zA);t.length&&E.appendChild(C.createTextNode(U.getAttribute(t[0].value)||""))}else if("counter"===A.name){var r=A.values.filter(kA),n=r[0],B=r[1];if(n&&zA(n)){var s=l.counters.getCounterValue(n.value),o=B&&zA(B)?ir.parse(B.value):tr.DECIMAL;E.appendChild(C.createTextNode(yB(s,o,!1)))}}else if("counters"===A.name){var i=A.values.filter(kA),a=(n=i[0],i[1]);if(B=i[2],n&&zA(n)){var c=l.counters.getCounterValues(n.value),Q=B&&zA(B)?ir.parse(B.value):tr.DECIMAL,w=a&&a.type===sA.STRING_TOKEN?a.value:"",u=c.map(function(A){return yB(A,Q,!1)}).join(w);E.appendChild(C.createTextNode(u))}}}else if(A.type===sA.IDENT_TOKEN)switch(A.value){case"open-quote":E.appendChild(C.createTextNode(en(g.quotes,l.quoteDepth++,!0)));break;case"close-quote":E.appendChild(C.createTextNode(en(g.quotes,--l.quoteDepth,!1)));break;default:E.appendChild(C.createTextNode(A.value))}}),E.className=qB+" "+ZB,A.className+=t===LB.BEFORE?" "+qB:" "+ZB,E}}},xB.destroy=function(A){return!!A.parentNode&&(A.parentNode.removeChild(A),!0)},xB);function xB(A,e){if(this.options=e,this.scrolledElements=[],this.referenceElement=A,this.counters=new pB,this.quoteDepth=0,!A.ownerDocument)throw new Error("Cloned element does not have an owner document");this.documentElement=this.cloneNode(A.ownerDocument.documentElement)}(vB=LB||(LB={}))[vB.BEFORE=0]="BEFORE",vB[vB.AFTER=1]="AFTER";var VB,zB,XB=function(A,e){var t=A.createElement("iframe");return t.className="html2canvas-container",t.style.visibility="hidden",t.style.position="fixed",t.style.left="-10000px",t.style.top="0px",t.style.border="0",t.width=e.width.toString(),t.height=e.height.toString(),t.scrolling="no",t.setAttribute(_B,"true"),A.body.appendChild(t),t},JB=function(n){return new Promise(function(e,A){var t=n.contentWindow;if(!t)return A("No window assigned for iframe");var r=t.document;t.onload=n.onload=r.onreadystatechange=function(){t.onload=n.onload=r.onreadystatechange=null;var A=setInterval(function(){0<r.body.childNodes.length&&"complete"===r.readyState&&(clearInterval(A),e(n))},50)}})},GB=function(A,e){for(var t=A.length-1;0<=t;t--){var r=A.item(t);"content"!==r&&e.style.setProperty(r,A.getPropertyValue(r))}return e},kB=function(A){var e="";return A&&(e+="<!DOCTYPE ",A.name&&(e+=A.name),A.internalSubset&&(e+=A.internalSubset),A.publicId&&(e+='"'+A.publicId+'"'),A.systemId&&(e+='"'+A.systemId+'"'),e+=">"),e},WB=function(A,e,t){A&&A.defaultView&&(e!==A.defaultView.pageXOffset||t!==A.defaultView.pageYOffset)&&A.defaultView.scrollTo(e,t)},YB=function(A){var e=A[0],t=A[1],r=A[2];e.scrollLeft=t,e.scrollTop=r},qB="___html2canvas___pseudoelement_before",ZB="___html2canvas___pseudoelement_after",jB='{\n    content: "" !important;\n    display: none !important;\n}',$B=function(A){As(A,"."+qB+":before"+jB+"\n         ."+ZB+":after"+jB)},As=function(A,e){var t=A.ownerDocument;if(t){var r=t.createElement("style");r.textContent=e,A.appendChild(r)}};(zB=VB||(VB={}))[zB.VECTOR=0]="VECTOR",zB[zB.BEZIER_CURVE=1]="BEZIER_CURVE";function es(A,t){return A.length===t.length&&A.some(function(A,e){return A===t[e]})}var ts=(rs.prototype.add=function(A,e){return new rs(this.x+A,this.y+e)},rs);function rs(A,e){this.type=VB.VECTOR,this.x=A,this.y=e}function ns(A,e,t){return new ts(A.x+(e.x-A.x)*t,A.y+(e.y-A.y)*t)}var Bs=(ss.prototype.subdivide=function(A,e){var t=ns(this.start,this.startControl,A),r=ns(this.startControl,this.endControl,A),n=ns(this.endControl,this.end,A),B=ns(t,r,A),s=ns(r,n,A),o=ns(B,s,A);return e?new ss(this.start,t,B,o):new ss(o,s,n,this.end)},ss.prototype.add=function(A,e){return new ss(this.start.add(A,e),this.startControl.add(A,e),this.endControl.add(A,e),this.end.add(A,e))},ss.prototype.reverse=function(){return new ss(this.end,this.endControl,this.startControl,this.start)},ss);function ss(A,e,t,r){this.type=VB.BEZIER_CURVE,this.start=A,this.startControl=e,this.endControl=t,this.end=r}function os(A){return A.type===VB.BEZIER_CURVE}var is,as,cs=function(A){var e=A.styles,t=A.bounds,r=jA(e.borderTopLeftRadius,t.width,t.height),n=r[0],B=r[1],s=jA(e.borderTopRightRadius,t.width,t.height),o=s[0],i=s[1],a=jA(e.borderBottomRightRadius,t.width,t.height),c=a[0],Q=a[1],w=jA(e.borderBottomLeftRadius,t.width,t.height),u=w[0],U=w[1],l=[];l.push((n+o)/t.width),l.push((u+c)/t.width),l.push((B+U)/t.height),l.push((i+Q)/t.height);var C=Math.max.apply(Math,l);1<C&&(n/=C,B/=C,o/=C,i/=C,c/=C,Q/=C,u/=C,U/=C);var g=t.width-o,E=t.height-Q,F=t.width-c,h=t.height-U,H=e.borderTopWidth,d=e.borderRightWidth,f=e.borderBottomWidth,p=e.borderLeftWidth,N=ae(e.paddingTop,A.bounds.width),K=ae(e.paddingRight,A.bounds.width),I=ae(e.paddingBottom,A.bounds.width),T=ae(e.paddingLeft,A.bounds.width);this.topLeftBorderBox=0<n||0<B?us(t.left,t.top,n,B,is.TOP_LEFT):new ts(t.left,t.top),this.topRightBorderBox=0<o||0<i?us(t.left+g,t.top,o,i,is.TOP_RIGHT):new ts(t.left+t.width,t.top),this.bottomRightBorderBox=0<c||0<Q?us(t.left+F,t.top+E,c,Q,is.BOTTOM_RIGHT):new ts(t.left+t.width,t.top+t.height),this.bottomLeftBorderBox=0<u||0<U?us(t.left,t.top+h,u,U,is.BOTTOM_LEFT):new ts(t.left,t.top+t.height),this.topLeftPaddingBox=0<n||0<B?us(t.left+p,t.top+H,Math.max(0,n-p),Math.max(0,B-H),is.TOP_LEFT):new ts(t.left+p,t.top+H),this.topRightPaddingBox=0<o||0<i?us(t.left+Math.min(g,t.width+p),t.top+H,g>t.width+p?0:o-p,i-H,is.TOP_RIGHT):new ts(t.left+t.width-d,t.top+H),this.bottomRightPaddingBox=0<c||0<Q?us(t.left+Math.min(F,t.width-p),t.top+Math.min(E,t.height+H),Math.max(0,c-d),Q-f,is.BOTTOM_RIGHT):new ts(t.left+t.width-d,t.top+t.height-f),this.bottomLeftPaddingBox=0<u||0<U?us(t.left+p,t.top+h,Math.max(0,u-p),U-f,is.BOTTOM_LEFT):new ts(t.left+p,t.top+t.height-f),this.topLeftContentBox=0<n||0<B?us(t.left+p+T,t.top+H+N,Math.max(0,n-(p+T)),Math.max(0,B-(H+N)),is.TOP_LEFT):new ts(t.left+p+T,t.top+H+N),this.topRightContentBox=0<o||0<i?us(t.left+Math.min(g,t.width+p+T),t.top+H+N,g>t.width+p+T?0:o-p+T,i-(H+N),is.TOP_RIGHT):new ts(t.left+t.width-(d+K),t.top+H+N),this.bottomRightContentBox=0<c||0<Q?us(t.left+Math.min(F,t.width-(p+T)),t.top+Math.min(E,t.height+H+N),Math.max(0,c-(d+K)),Q-(f+I),is.BOTTOM_RIGHT):new ts(t.left+t.width-(d+K),t.top+t.height-(f+I)),this.bottomLeftContentBox=0<u||0<U?us(t.left+p+T,t.top+h,Math.max(0,u-(p+T)),U-(f+I),is.BOTTOM_LEFT):new ts(t.left+p+T,t.top+t.height-(f+I))};(as=is||(is={}))[as.TOP_LEFT=0]="TOP_LEFT",as[as.TOP_RIGHT=1]="TOP_RIGHT",as[as.BOTTOM_RIGHT=2]="BOTTOM_RIGHT",as[as.BOTTOM_LEFT=3]="BOTTOM_LEFT";function Qs(A){return[A.topLeftBorderBox,A.topRightBorderBox,A.bottomRightBorderBox,A.bottomLeftBorderBox]}function ws(A){return[A.topLeftPaddingBox,A.topRightPaddingBox,A.bottomRightPaddingBox,A.bottomLeftPaddingBox]}var us=function(A,e,t,r,n){var B=(Math.sqrt(2)-1)/3*4,s=t*B,o=r*B,i=A+t,a=e+r;switch(n){case is.TOP_LEFT:return new Bs(new ts(A,a),new ts(A,a-o),new ts(i-s,e),new ts(i,e));case is.TOP_RIGHT:return new Bs(new ts(A,e),new ts(A+s,e),new ts(i,a-o),new ts(i,a));case is.BOTTOM_RIGHT:return new Bs(new ts(i,e),new ts(i,e+o),new ts(A+s,a),new ts(A,a));case is.BOTTOM_LEFT:default:return new Bs(new ts(i,a),new ts(i-s,a),new ts(A,e+o),new ts(A,e))}},Us=function(A,e,t){this.type=0,this.offsetX=A,this.offsetY=e,this.matrix=t,this.target=6},ls=function(A,e){this.type=1,this.target=e,this.path=A},Cs=function(A){this.element=A,this.inlineLevel=[],this.nonInlineLevel=[],this.negativeZIndex=[],this.zeroOrAutoZIndexOrTransformedOrOpacity=[],this.positiveZIndex=[],this.nonPositionedFloats=[],this.nonPositionedInlineLevel=[]},gs=(Es.prototype.getParentEffects=function(){var A=this.effects.slice(0);if(this.container.styles.overflowX!==sr.VISIBLE){var e=Qs(this.curves),t=ws(this.curves);es(e,t)||A.push(new ls(t,6))}return A},Es);function Es(A,e){if(this.container=A,this.effects=e.slice(0),this.curves=new cs(A),null!==A.styles.transform){var t=A.bounds.left+A.styles.transformOrigin[0].number,r=A.bounds.top+A.styles.transformOrigin[1].number,n=A.styles.transform;this.effects.push(new Us(t,r,n))}if(A.styles.overflowX!==sr.VISIBLE){var B=Qs(this.curves),s=ws(this.curves);es(B,s)?this.effects.push(new ls(B,6)):(this.effects.push(new ls(B,2)),this.effects.push(new ls(s,4)))}}function Fs(A){var e=A.bounds,t=A.styles;return e.add(t.borderLeftWidth,t.borderTopWidth,-(t.borderRightWidth+t.borderLeftWidth),-(t.borderTopWidth+t.borderBottomWidth))}function hs(A){var e=A.styles,t=A.bounds,r=ae(e.paddingLeft,t.width),n=ae(e.paddingRight,t.width),B=ae(e.paddingTop,t.width),s=ae(e.paddingBottom,t.width);return t.add(r+e.borderLeftWidth,B+e.borderTopWidth,-(e.borderRightWidth+e.borderLeftWidth+r+n),-(e.borderTopWidth+e.borderBottomWidth+B+s))}function Hs(A,e,t){var r=function(A,e){return 0===A?e.bounds:2===A?hs(e):Fs(e)}(Ts(A.styles.backgroundOrigin,e),A),n=function(A,e){return A===Ee.BORDER_BOX?e.bounds:A===Ee.CONTENT_BOX?hs(e):Fs(e)}(Ts(A.styles.backgroundClip,e),A),B=Is(Ts(A.styles.backgroundSize,e),t,r),s=B[0],o=B[1],i=jA(Ts(A.styles.backgroundPosition,e),r.width-s,r.height-o);return[ms(Ts(A.styles.backgroundRepeat,e),i,B,r,n),Math.round(r.left+i[0]),Math.round(r.top+i[1]),s,o]}function ds(A){return zA(A)&&A.value===Ut.AUTO}function fs(A){return"number"==typeof A}var ps=function(c,Q,w,u){c.container.elements.forEach(function(A){var e=An(A.flags,4),t=An(A.flags,2),r=new gs(A,c.getParentEffects());An(A.styles.display,2048)&&u.push(r);var n=An(A.flags,8)?[]:u;if(e||t){var B=e||A.styles.isPositioned()?w:Q,s=new Cs(r);if(A.styles.isPositioned()||A.styles.opacity<1||A.styles.isTransformed()){var o=A.styles.zIndex.order;if(o<0){var i=0;B.negativeZIndex.some(function(A,e){return o>A.element.container.styles.zIndex.order?(i=e,!1):0<i}),B.negativeZIndex.splice(i,0,s)}else if(0<o){var a=0;B.positiveZIndex.some(function(A,e){return o>A.element.container.styles.zIndex.order?(a=e+1,!1):0<a}),B.positiveZIndex.splice(a,0,s)}else B.zeroOrAutoZIndexOrTransformedOrOpacity.push(s)}else A.styles.isFloating()?B.nonPositionedFloats.push(s):B.nonPositionedInlineLevel.push(s);ps(r,s,e?s:w,n)}else A.styles.isInlineLevel()?Q.inlineLevel.push(r):Q.nonInlineLevel.push(r),ps(r,Q,w,n);An(A.flags,8)&&Ns(A,n)})},Ns=function(A,e){for(var t=A instanceof Mn?A.start:1,r=A instanceof Mn&&A.reversed,n=0;n<e.length;n++){var B=e[n];B.container instanceof Dn&&"number"==typeof B.container.value&&0!==B.container.value&&(t=B.container.value),B.listValue=yB(t,B.container.styles.listStyleType,!0),t+=r?-1:1}},Ks=function(A,e,t,r){var n=[];return os(A)?n.push(A.subdivide(.5,!1)):n.push(A),os(t)?n.push(t.subdivide(.5,!0)):n.push(t),os(r)?n.push(r.subdivide(.5,!0).reverse()):n.push(r),os(e)?n.push(e.subdivide(.5,!1).reverse()):n.push(e),n},Is=function(A,e,t){var r=e[0],n=e[1],B=e[2],s=A[0],o=A[1];if(qA(s)&&o&&qA(o))return[ae(s,t.width),ae(o,t.height)];var i=fs(B);if(zA(s)&&(s.value===Ut.CONTAIN||s.value===Ut.COVER))return fs(B)?t.width/t.height<B!=(s.value===Ut.COVER)?[t.width,t.width/B]:[t.height*B,t.height]:[t.width,t.height];var a=fs(r),c=fs(n),Q=a||c;if(ds(s)&&(!o||ds(o)))return a&&c?[r,n]:i||Q?Q&&i?[a?r:n*B,c?n:r/B]:[a?r:t.width,c?n:t.height]:[t.width,t.height];if(i){var w=0,u=0;return qA(s)?w=ae(s,t.width):qA(o)&&(u=ae(o,t.height)),ds(s)?w=u*B:o&&!ds(o)||(u=w/B),[w,u]}var U=null,l=null;if(qA(s)?U=ae(s,t.width):o&&qA(o)&&(l=ae(o,t.height)),null===U||o&&!ds(o)||(l=a&&c?U/r*n:t.height),null!==l&&ds(s)&&(U=a&&c?l/n*r:t.width),null!==U&&null!==l)return[U,l];throw new Error("Unable to calculate background-size for element")},Ts=function(A,e){var t=A[e];return void 0===t?A[0]:t},ms=function(A,e,t,r,n){var B=e[0],s=e[1],o=t[0],i=t[1];switch(A){case it.REPEAT_X:return[new ts(Math.round(r.left),Math.round(r.top+s)),new ts(Math.round(r.left+r.width),Math.round(r.top+s)),new ts(Math.round(r.left+r.width),Math.round(i+r.top+s)),new ts(Math.round(r.left),Math.round(i+r.top+s))];case it.REPEAT_Y:return[new ts(Math.round(r.left+B),Math.round(r.top)),new ts(Math.round(r.left+B+o),Math.round(r.top)),new ts(Math.round(r.left+B+o),Math.round(r.height+r.top)),new ts(Math.round(r.left+B),Math.round(r.height+r.top))];case it.NO_REPEAT:return[new ts(Math.round(r.left+B),Math.round(r.top+s)),new ts(Math.round(r.left+B+o),Math.round(r.top+s)),new ts(Math.round(r.left+B+o),Math.round(r.top+s+i)),new ts(Math.round(r.left+B),Math.round(r.top+s+i))];default:return[new ts(Math.round(n.left),Math.round(n.top)),new ts(Math.round(n.left+n.width),Math.round(n.top)),new ts(Math.round(n.left+n.width),Math.round(n.height+n.top)),new ts(Math.round(n.left),Math.round(n.height+n.top))]}},Rs="Hidden Text",Ls=(vs.prototype.parseMetrics=function(A,e){var t=this._document.createElement("div"),r=this._document.createElement("img"),n=this._document.createElement("span"),B=this._document.body;t.style.visibility="hidden",t.style.fontFamily=A,t.style.fontSize=e,t.style.margin="0",t.style.padding="0",B.appendChild(t),r.src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",r.width=1,r.height=1,r.style.margin="0",r.style.padding="0",r.style.verticalAlign="baseline",n.style.fontFamily=A,n.style.fontSize=e,n.style.margin="0",n.style.padding="0",n.appendChild(this._document.createTextNode(Rs)),t.appendChild(n),t.appendChild(r);var s=r.offsetTop-n.offsetTop+2;t.removeChild(n),t.appendChild(this._document.createTextNode(Rs)),t.style.lineHeight="normal",r.style.verticalAlign="super";var o=r.offsetTop-t.offsetTop+2;return B.removeChild(t),{baseline:s,middle:o}},vs.prototype.getMetrics=function(A,e){var t=A+" "+e;return void 0===this._data[t]&&(this._data[t]=this.parseMetrics(A,e)),this._data[t]},vs);function vs(A){this._data={},this._document=A}var Os=(Ds.prototype.applyEffects=function(A,e){for(var t=this;this._activeEffects.length;)this.popEffect();A.filter(function(A){return An(A.target,e)}).forEach(function(A){return t.applyEffect(A)})},Ds.prototype.applyEffect=function(A){this.ctx.save(),function(A){return 0===A.type}(A)&&(this.ctx.translate(A.offsetX,A.offsetY),this.ctx.transform(A.matrix[0],A.matrix[1],A.matrix[2],A.matrix[3],A.matrix[4],A.matrix[5]),this.ctx.translate(-A.offsetX,-A.offsetY)),function(A){return 1===A.type}(A)&&(this.path(A.path),this.ctx.clip()),this._activeEffects.push(A)},Ds.prototype.popEffect=function(){this._activeEffects.pop(),this.ctx.restore()},Ds.prototype.renderStack=function(t){return a(this,void 0,void 0,function(){var e;return S(this,function(A){switch(A.label){case 0:return(e=t.element.container.styles).isVisible()?(this.ctx.globalAlpha=e.opacity,[4,this.renderStackContent(t)]):[3,2];case 1:A.sent(),A.label=2;case 2:return[2]}})})},Ds.prototype.renderNode=function(e){return a(this,void 0,void 0,function(){return S(this,function(A){switch(A.label){case 0:return e.container.styles.isVisible()?[4,this.renderNodeBackgroundAndBorders(e)]:[3,3];case 1:return A.sent(),[4,this.renderNodeContent(e)];case 2:A.sent(),A.label=3;case 3:return[2]}})})},Ds.prototype.renderTextWithLetterSpacing=function(t,A){var r=this;0===A?this.ctx.fillText(t.text,t.bounds.left,t.bounds.top+t.bounds.height):c(t.text).map(function(A){return l(A)}).reduce(function(A,e){return r.ctx.fillText(e,A,t.bounds.top+t.bounds.height),A+r.ctx.measureText(e).width},t.bounds.left)},Ds.prototype.createFontStyle=function(A){var e=A.fontVariant.filter(function(A){return"normal"===A||"small-caps"===A}).join(""),t=A.fontFamily.join(", "),r=xA(A.fontSize)?""+A.fontSize.number+A.fontSize.unit:A.fontSize.number+"px";return[[A.fontStyle,e,A.fontWeight,r,t].join(" "),t,r]},Ds.prototype.renderTextNode=function(r,o){return a(this,void 0,void 0,function(){var e,t,n,B,s=this;return S(this,function(A){return e=this.createFontStyle(o),t=e[0],n=e[1],B=e[2],this.ctx.font=t,r.textBounds.forEach(function(r){s.ctx.fillStyle=te(o.color),s.renderTextWithLetterSpacing(r,o.letterSpacing);var A=o.textShadow;A.length&&r.text.trim().length&&(A.slice(0).reverse().forEach(function(A){s.ctx.shadowColor=te(A.color),s.ctx.shadowOffsetX=A.offsetX.number*s.options.scale,s.ctx.shadowOffsetY=A.offsetY.number*s.options.scale,s.ctx.shadowBlur=A.blur.number,s.ctx.fillText(r.text,r.bounds.left,r.bounds.top+r.bounds.height)}),s.ctx.shadowColor="",s.ctx.shadowOffsetX=0,s.ctx.shadowOffsetY=0,s.ctx.shadowBlur=0),o.textDecorationLine.length&&(s.ctx.fillStyle=te(o.textDecorationColor||o.color),o.textDecorationLine.forEach(function(A){switch(A){case 1:var e=s.fontMetrics.getMetrics(n,B).baseline;s.ctx.fillRect(r.bounds.left,Math.round(r.bounds.top+e),r.bounds.width,1);break;case 2:s.ctx.fillRect(r.bounds.left,Math.round(r.bounds.top),r.bounds.width,1);break;case 3:var t=s.fontMetrics.getMetrics(n,B).middle;s.ctx.fillRect(r.bounds.left,Math.ceil(r.bounds.top+t),r.bounds.width,1)}}))}),[2]})})},Ds.prototype.renderReplacedElement=function(A,e,t){if(t&&0<A.intrinsicWidth&&0<A.intrinsicHeight){var r=hs(A),n=ws(e);this.path(n),this.ctx.save(),this.ctx.clip(),this.ctx.drawImage(t,0,0,A.intrinsicWidth,A.intrinsicHeight,r.left,r.top,r.width,r.height),this.ctx.restore()}},Ds.prototype.renderNodeContent=function(l){return a(this,void 0,void 0,function(){var e,t,r,n,B,s,o,i,a,c,Q,w,u,U;return S(this,function(A){switch(A.label){case 0:this.applyEffects(l.effects,4),e=l.container,t=l.curves,r=e.styles,n=0,B=e.textNodes,A.label=1;case 1:return n<B.length?(s=B[n],[4,this.renderTextNode(s,r)]):[3,4];case 2:A.sent(),A.label=3;case 3:return n++,[3,1];case 4:if(!(e instanceof Nn))return[3,8];A.label=5;case 5:return A.trys.push([5,7,,8]),[4,this.options.cache.match(e.src)];case 6:return w=A.sent(),this.renderReplacedElement(e,t,w),[3,8];case 7:return A.sent(),De.getInstance(this.options.id).error("Error loading image "+e.src),[3,8];case 8:if(e instanceof Tn&&this.renderReplacedElement(e,t,e.canvas),!(e instanceof Ln))return[3,12];A.label=9;case 9:return A.trys.push([9,11,,12]),[4,this.options.cache.match(e.svg)];case 10:return w=A.sent(),this.renderReplacedElement(e,t,w),[3,12];case 11:return A.sent(),De.getInstance(this.options.id).error("Error loading svg "+e.svg.substring(0,255)),[3,12];case 12:return e instanceof tB&&e.tree?[4,new Ds({id:this.options.id,scale:this.options.scale,backgroundColor:e.backgroundColor,x:0,y:0,scrollX:0,scrollY:0,width:e.width,height:e.height,cache:this.options.cache,windowWidth:e.width,windowHeight:e.height}).render(e.tree)]:[3,14];case 13:o=A.sent(),e.width&&e.height&&this.ctx.drawImage(o,0,0,e.width,e.height,e.bounds.left,e.bounds.top,e.bounds.width,e.bounds.height),A.label=14;case 14:if(e instanceof Gn&&(i=Math.min(e.bounds.width,e.bounds.height),e.type===Vn?e.checked&&(this.ctx.save(),this.path([new ts(e.bounds.left+.39363*i,e.bounds.top+.79*i),new ts(e.bounds.left+.16*i,e.bounds.top+.5549*i),new ts(e.bounds.left+.27347*i,e.bounds.top+.44071*i),new ts(e.bounds.left+.39694*i,e.bounds.top+.5649*i),new ts(e.bounds.left+.72983*i,e.bounds.top+.23*i),new ts(e.bounds.left+.84*i,e.bounds.top+.34085*i),new ts(e.bounds.left+.39363*i,e.bounds.top+.79*i)]),this.ctx.fillStyle=te(Jn),this.ctx.fill(),this.ctx.restore()):e.type===zn&&e.checked&&(this.ctx.save(),this.ctx.beginPath(),this.ctx.arc(e.bounds.left+i/2,e.bounds.top+i/2,i/4,0,2*Math.PI,!0),this.ctx.fillStyle=te(Jn),this.ctx.fill(),this.ctx.restore())),bs(e)&&e.value.length){switch(this.ctx.font=this.createFontStyle(r)[0],this.ctx.fillStyle=te(r.color),this.ctx.textBaseline="middle",this.ctx.textAlign=Ms(e.styles.textAlign),U=hs(e),a=0,e.styles.textAlign){case Cr.CENTER:a+=U.width/2;break;case Cr.RIGHT:a+=U.width}c=U.add(a,0,0,-U.height/2+1),this.ctx.save(),this.path([new ts(U.left,U.top),new ts(U.left+U.width,U.top),new ts(U.left+U.width,U.top+U.height),new ts(U.left,U.top+U.height)]),this.ctx.clip(),this.renderTextWithLetterSpacing(new Cn(e.value,c),r.letterSpacing),this.ctx.restore(),this.ctx.textBaseline="bottom",this.ctx.textAlign="left"}if(!An(e.styles.display,2048))return[3,20];if(null===e.styles.listStyleImage)return[3,19];if((Q=e.styles.listStyleImage).type!==xe.URL)return[3,18];w=void 0,u=Q.url,A.label=15;case 15:return A.trys.push([15,17,,18]),[4,this.options.cache.match(u)];case 16:return w=A.sent(),this.ctx.drawImage(w,e.bounds.left-(w.width+10),e.bounds.top),[3,18];case 17:return A.sent(),De.getInstance(this.options.id).error("Error loading list-style-image "+u),[3,18];case 18:return[3,20];case 19:l.listValue&&e.styles.listStyleType!==tr.NONE&&(this.ctx.font=this.createFontStyle(r)[0],this.ctx.fillStyle=te(r.color),this.ctx.textBaseline="middle",this.ctx.textAlign="right",U=new I(e.bounds.left,e.bounds.top+ae(e.styles.paddingTop,e.bounds.width),e.bounds.width,function(A,e){return zA(A)&&"normal"===A.value?1.2*e:A.type===sA.NUMBER_TOKEN?e*A.number:qA(A)?ae(A,e):e}(r.lineHeight,r.fontSize.number)/2+1),this.renderTextWithLetterSpacing(new Cn(l.listValue,U),r.letterSpacing),this.ctx.textBaseline="bottom",this.ctx.textAlign="left"),A.label=20;case 20:return[2]}})})},Ds.prototype.renderStackContent=function(C){return a(this,void 0,void 0,function(){var e,t,r,n,B,s,o,i,a,c,Q,w,u,U,l;return S(this,function(A){switch(A.label){case 0:return[4,this.renderNodeBackgroundAndBorders(C.element)];case 1:A.sent(),e=0,t=C.negativeZIndex,A.label=2;case 2:return e<t.length?(l=t[e],[4,this.renderStack(l)]):[3,5];case 3:A.sent(),A.label=4;case 4:return e++,[3,2];case 5:return[4,this.renderNodeContent(C.element)];case 6:A.sent(),r=0,n=C.nonInlineLevel,A.label=7;case 7:return r<n.length?(l=n[r],[4,this.renderNode(l)]):[3,10];case 8:A.sent(),A.label=9;case 9:return r++,[3,7];case 10:B=0,s=C.nonPositionedFloats,A.label=11;case 11:return B<s.length?(l=s[B],[4,this.renderStack(l)]):[3,14];case 12:A.sent(),A.label=13;case 13:return B++,[3,11];case 14:o=0,i=C.nonPositionedInlineLevel,A.label=15;case 15:return o<i.length?(l=i[o],[4,this.renderStack(l)]):[3,18];case 16:A.sent(),A.label=17;case 17:return o++,[3,15];case 18:a=0,c=C.inlineLevel,A.label=19;case 19:return a<c.length?(l=c[a],[4,this.renderNode(l)]):[3,22];case 20:A.sent(),A.label=21;case 21:return a++,[3,19];case 22:Q=0,w=C.zeroOrAutoZIndexOrTransformedOrOpacity,A.label=23;case 23:return Q<w.length?(l=w[Q],[4,this.renderStack(l)]):[3,26];case 24:A.sent(),A.label=25;case 25:return Q++,[3,23];case 26:u=0,U=C.positiveZIndex,A.label=27;case 27:return u<U.length?(l=U[u],[4,this.renderStack(l)]):[3,30];case 28:A.sent(),A.label=29;case 29:return u++,[3,27];case 30:return[2]}})})},Ds.prototype.mask=function(A){this.ctx.beginPath(),this.ctx.moveTo(0,0),this.ctx.lineTo(this.canvas.width,0),this.ctx.lineTo(this.canvas.width,this.canvas.height),this.ctx.lineTo(0,this.canvas.height),this.ctx.lineTo(0,0),this.formatPath(A.slice(0).reverse()),this.ctx.closePath()},Ds.prototype.path=function(A){this.ctx.beginPath(),this.formatPath(A),this.ctx.closePath()},Ds.prototype.formatPath=function(A){var r=this;A.forEach(function(A,e){var t=os(A)?A.start:A;0===e?r.ctx.moveTo(t.x,t.y):r.ctx.lineTo(t.x,t.y),os(A)&&r.ctx.bezierCurveTo(A.startControl.x,A.startControl.y,A.endControl.x,A.endControl.y,A.end.x,A.end.y)})},Ds.prototype.renderRepeat=function(A,e,t,r){this.path(A),this.ctx.fillStyle=e,this.ctx.translate(t,r),this.ctx.fill(),this.ctx.translate(-t,-r)},Ds.prototype.resizeImage=function(A,e,t){if(A.width===e&&A.height===t)return A;var r=this.canvas.ownerDocument.createElement("canvas");return r.width=e,r.height=t,r.getContext("2d").drawImage(A,0,0,A.width,A.height,0,0,e,t),r},Ds.prototype.renderBackgroundImage=function(b){return a(this,void 0,void 0,function(){var O,e,D,t,r,n;return S(this,function(A){switch(A.label){case 0:O=b.styles.backgroundImage.length-1,e=function(e){var t,r,n,B,s,o,i,a,c,Q,w,u,U,l,C,g,E,F,h,H,d,f,p,N,K,I,T,m,R,L,v;return S(this,function(A){switch(A.label){case 0:if(e.type!==xe.URL)return[3,5];t=void 0,r=e.url,A.label=1;case 1:return A.trys.push([1,3,,4]),[4,D.options.cache.match(r)];case 2:return t=A.sent(),[3,4];case 3:return A.sent(),De.getInstance(D.options.id).error("Error loading background-image "+r),[3,4];case 4:return t&&(n=Hs(b,O,[t.width,t.height,t.width/t.height]),g=n[0],f=n[1],p=n[2],h=n[3],H=n[4],l=D.ctx.createPattern(D.resizeImage(t,h,H),"repeat"),D.renderRepeat(g,l,f,p)),[3,6];case 5:!function(A){return A.type===xe.LINEAR_GRADIENT}(e)?function(A){return A.type===xe.RADIAL_GRADIENT}(e)&&(C=Hs(b,O,[null,null,null]),g=C[0],E=C[1],F=C[2],h=C[3],H=C[4],d=0===e.position.length?[oe]:e.position,f=ae(d[0],h),p=ae(d[d.length-1],H),N=function(A,e,t,r,n){var B=0,s=0;switch(A.size){case Bt.CLOSEST_SIDE:A.shape===rt.CIRCLE?B=s=Math.min(Math.abs(e),Math.abs(e-r),Math.abs(t),Math.abs(t-n)):A.shape===rt.ELLIPSE&&(B=Math.min(Math.abs(e),Math.abs(e-r)),s=Math.min(Math.abs(t),Math.abs(t-n)));break;case Bt.CLOSEST_CORNER:if(A.shape===rt.CIRCLE)B=s=Math.min(Ne(e,t),Ne(e,t-n),Ne(e-r,t),Ne(e-r,t-n));else if(A.shape===rt.ELLIPSE){var o=Math.min(Math.abs(t),Math.abs(t-n))/Math.min(Math.abs(e),Math.abs(e-r)),i=Ke(r,n,e,t,!0),a=i[0],c=i[1];s=o*(B=Ne(a-e,(c-t)/o))}break;case Bt.FARTHEST_SIDE:A.shape===rt.CIRCLE?B=s=Math.max(Math.abs(e),Math.abs(e-r),Math.abs(t),Math.abs(t-n)):A.shape===rt.ELLIPSE&&(B=Math.max(Math.abs(e),Math.abs(e-r)),s=Math.max(Math.abs(t),Math.abs(t-n)));break;case Bt.FARTHEST_CORNER:if(A.shape===rt.CIRCLE)B=s=Math.max(Ne(e,t),Ne(e,t-n),Ne(e-r,t),Ne(e-r,t-n));else if(A.shape===rt.ELLIPSE){o=Math.max(Math.abs(t),Math.abs(t-n))/Math.max(Math.abs(e),Math.abs(e-r));var Q=Ke(r,n,e,t,!1);a=Q[0],c=Q[1],s=o*(B=Ne(a-e,(c-t)/o))}}return Array.isArray(A.size)&&(B=ae(A.size[0],r),s=2===A.size.length?ae(A.size[1],n):B),[B,s]}(e,f,p,h,H),K=N[0],I=N[1],0<K&&0<K&&(T=D.ctx.createRadialGradient(E+f,F+p,0,E+f,F+p,K),fe(e.stops,2*K).forEach(function(A){return T.addColorStop(A.stop,te(A.color))}),D.path(g),D.ctx.fillStyle=T,K!==I?(m=b.bounds.left+.5*b.bounds.width,R=b.bounds.top+.5*b.bounds.height,v=1/(L=I/K),D.ctx.save(),D.ctx.translate(m,R),D.ctx.transform(1,0,0,L,0,0),D.ctx.translate(-m,-R),D.ctx.fillRect(E,v*(F-R)+R,h,H*v),D.ctx.restore()):D.ctx.fill())):(B=Hs(b,O,[null,null,null]),g=B[0],f=B[1],p=B[2],h=B[3],H=B[4],s=pe(e.angle,h,H),o=s[0],i=s[1],a=s[2],c=s[3],Q=s[4],(w=document.createElement("canvas")).width=h,w.height=H,u=w.getContext("2d"),U=u.createLinearGradient(i,c,a,Q),fe(e.stops,o).forEach(function(A){return U.addColorStop(A.stop,te(A.color))}),u.fillStyle=U,u.fillRect(0,0,h,H),0<h&&0<H&&(l=D.ctx.createPattern(w,"repeat"),D.renderRepeat(g,l,f,p))),A.label=6;case 6:return O--,[2]}})},D=this,t=0,r=b.styles.backgroundImage.slice(0).reverse(),A.label=1;case 1:return t<r.length?(n=r[t],[5,e(n)]):[3,4];case 2:A.sent(),A.label=3;case 3:return t++,[3,1];case 4:return[2]}})})},Ds.prototype.renderBorder=function(e,t,r){return a(this,void 0,void 0,function(){return S(this,function(A){return this.path(function(A,e){switch(e){case 0:return Ks(A.topLeftBorderBox,A.topLeftPaddingBox,A.topRightBorderBox,A.topRightPaddingBox);case 1:return Ks(A.topRightBorderBox,A.topRightPaddingBox,A.bottomRightBorderBox,A.bottomRightPaddingBox);case 2:return Ks(A.bottomRightBorderBox,A.bottomRightPaddingBox,A.bottomLeftBorderBox,A.bottomLeftPaddingBox);case 3:default:return Ks(A.bottomLeftBorderBox,A.bottomLeftPaddingBox,A.topLeftBorderBox,A.topLeftPaddingBox)}}(r,t)),this.ctx.fillStyle=te(e),this.ctx.fill(),[2]})})},Ds.prototype.renderNodeBackgroundAndBorders=function(c){return a(this,void 0,void 0,function(){var e,t,r,n,B,s,o,i,a=this;return S(this,function(A){switch(A.label){case 0:return this.applyEffects(c.effects,2),e=c.container.styles,t=!ee(e.backgroundColor)||e.backgroundImage.length,r=[{style:e.borderTopStyle,color:e.borderTopColor},{style:e.borderRightStyle,color:e.borderRightColor},{style:e.borderBottomStyle,color:e.borderBottomColor},{style:e.borderLeftStyle,color:e.borderLeftColor}],n=Ss(Ts(e.backgroundClip,0),c.curves),t||e.boxShadow.length?(this.ctx.save(),this.path(n),this.ctx.clip(),ee(e.backgroundColor)||(this.ctx.fillStyle=te(e.backgroundColor),this.ctx.fill()),[4,this.renderBackgroundImage(c.container)]):[3,2];case 1:A.sent(),this.ctx.restore(),e.boxShadow.slice(0).reverse().forEach(function(A){a.ctx.save();var e=Qs(c.curves),t=A.inset?0:1e4,r=function(A,t,r,n,B){return A.map(function(A,e){switch(e){case 0:return A.add(t,r);case 1:return A.add(t+n,r);case 2:return A.add(t+n,r+B);case 3:return A.add(t,r+B)}return A})}(e,-t+(A.inset?1:-1)*A.spread.number,(A.inset?1:-1)*A.spread.number,A.spread.number*(A.inset?-2:2),A.spread.number*(A.inset?-2:2));A.inset?(a.path(e),a.ctx.clip(),a.mask(r)):(a.mask(e),a.ctx.clip(),a.path(r)),a.ctx.shadowOffsetX=A.offsetX.number+t,a.ctx.shadowOffsetY=A.offsetY.number,a.ctx.shadowColor=te(A.color),a.ctx.shadowBlur=A.blur.number,a.ctx.fillStyle=A.inset?te(A.color):"rgba(0,0,0,1)",a.ctx.fill(),a.ctx.restore()}),A.label=2;case 2:s=B=0,o=r,A.label=3;case 3:return s<o.length?(i=o[s]).style===ht.NONE||ee(i.color)?[3,5]:[4,this.renderBorder(i.color,B,c.curves)]:[3,7];case 4:A.sent(),A.label=5;case 5:B++,A.label=6;case 6:return s++,[3,3];case 7:return[2]}})})},Ds.prototype.render=function(t){return a(this,void 0,void 0,function(){var e;return S(this,function(A){switch(A.label){case 0:return this.options.backgroundColor&&(this.ctx.fillStyle=te(this.options.backgroundColor),this.ctx.fillRect(this.options.x-this.options.scrollX,this.options.y-this.options.scrollY,this.options.width,this.options.height)),e=function(A){var e=new gs(A,[]),t=new Cs(e),r=[];return ps(e,t,t,r),Ns(e.container,r),t}(t),[4,this.renderStack(e)];case 1:return A.sent(),this.applyEffects([],2),[2,this.canvas]}})})},Ds);function Ds(A){this._activeEffects=[],this.canvas=A.canvas?A.canvas:document.createElement("canvas"),this.ctx=this.canvas.getContext("2d"),(this.options=A).canvas||(this.canvas.width=Math.floor(A.width*A.scale),this.canvas.height=Math.floor(A.height*A.scale),this.canvas.style.width=A.width+"px",this.canvas.style.height=A.height+"px"),this.fontMetrics=new Ls(document),this.ctx.scale(this.options.scale,this.options.scale),this.ctx.translate(-A.x+A.scrollX,-A.y+A.scrollY),this.ctx.textBaseline="bottom",this._activeEffects=[],De.getInstance(A.id).debug("Canvas renderer initialized ("+A.width+"x"+A.height+" at "+A.x+","+A.y+") with scale "+A.scale)}var bs=function(A){return A instanceof jn||(A instanceof Yn||A instanceof Gn&&A.type!==zn&&A.type!==Vn)},Ss=function(A,e){switch(A){case Ee.BORDER_BOX:return Qs(e);case Ee.CONTENT_BOX:return function(A){return[A.topLeftContentBox,A.topRightContentBox,A.bottomRightContentBox,A.bottomLeftContentBox]}(e);case Ee.PADDING_BOX:default:return ws(e)}},Ms=function(A){switch(A){case Cr.CENTER:return"center";case Cr.RIGHT:return"right";case Cr.LEFT:default:return"left"}},ys=(_s.prototype.render=function(r){return a(this,void 0,void 0,function(){var e,t;return S(this,function(A){switch(A.label){case 0:return e=Le(Math.max(this.options.windowWidth,this.options.width)*this.options.scale,Math.max(this.options.windowHeight,this.options.height)*this.options.scale,this.options.scrollX*this.options.scale,this.options.scrollY*this.options.scale,r),[4,xs(e)];case 1:return t=A.sent(),this.options.backgroundColor&&(this.ctx.fillStyle=te(this.options.backgroundColor),this.ctx.fillRect(0,0,this.options.width*this.options.scale,this.options.height*this.options.scale)),this.ctx.drawImage(t,-this.options.x*this.options.scale,-this.options.y*this.options.scale),[2,this.canvas]}})})},_s);function _s(A){this.canvas=A.canvas?A.canvas:document.createElement("canvas"),this.ctx=this.canvas.getContext("2d"),this.options=A,this.canvas.width=Math.floor(A.width*A.scale),this.canvas.height=Math.floor(A.height*A.scale),this.canvas.style.width=A.width+"px",this.canvas.style.height=A.height+"px",this.ctx.scale(this.options.scale,this.options.scale),this.ctx.translate(-A.x+A.scrollX,-A.y+A.scrollY),De.getInstance(A.id).debug("EXPERIMENTAL ForeignObject renderer initialized ("+A.width+"x"+A.height+" at "+A.x+","+A.y+") with scale "+A.scale)}function Ps(A){return we(_A.create(A).parseComponentValue())}var xs=function(r){return new Promise(function(A,e){var t=new Image;t.onload=function(){A(t)},t.onerror=e,t.src="data:image/svg+xml;charset=utf-8,"+encodeURIComponent((new XMLSerializer).serializeToString(r))})};Se.setContext(window);var Vs=function(p,N){return a(void 0,void 0,void 0,function(){var e,t,r,n,B,s,o,i,a,c,Q,w,u,U,l,C,g,E,F,h,H,d,f;return S(this,function(A){switch(A.label){case 0:if(!(e=p.ownerDocument))throw new Error("Element is not attached to a Document");if(!(t=e.defaultView))throw new Error("Document is not attached to a Window");return r=(Math.round(1e3*Math.random())+Date.now()).toString(16),n=EB(p)||function(A){return"HTML"===A.tagName}(p)?function(A){var e=A.body,t=A.documentElement;if(!e||!t)throw new Error("Unable to get document size");var r=Math.max(Math.max(e.scrollWidth,t.scrollWidth),Math.max(e.offsetWidth,t.offsetWidth),Math.max(e.clientWidth,t.clientWidth)),n=Math.max(Math.max(e.scrollHeight,t.scrollHeight),Math.max(e.offsetHeight,t.offsetHeight),Math.max(e.clientHeight,t.clientHeight));return new I(0,0,r,n)}(e):T(p),B=n.width,s=n.height,o=n.left,i=n.top,a=K({},{allowTaint:!1,imageTimeout:15e3,proxy:void 0,useCORS:!1},N),c={backgroundColor:"#ffffff",cache:N.cache?N.cache:Se.create(r,a),logging:!0,removeContainer:!0,foreignObjectRendering:!1,scale:t.devicePixelRatio||1,windowWidth:t.innerWidth,windowHeight:t.innerHeight,scrollX:t.pageXOffset,scrollY:t.pageYOffset,x:o,y:i,width:Math.ceil(B),height:Math.ceil(s),id:r},Q=K({},c,a,N),w=new I(Q.scrollX,Q.scrollY,Q.windowWidth,Q.windowHeight),De.create({id:r,enabled:Q.logging}),De.getInstance(r).debug("Starting document clone"),u=new PB(p,{id:r,onclone:Q.onclone,ignoreElements:Q.ignoreElements,inlineImages:Q.foreignObjectRendering,copyStyles:Q.foreignObjectRendering}),(U=u.clonedReferenceElement)?[4,u.toIFrame(e,w)]:[2,Promise.reject("Unable to find element in cloned iframe")];case 1:return l=A.sent(),C=e.documentElement?Ps(getComputedStyle(e.documentElement).backgroundColor):He.TRANSPARENT,g=e.body?Ps(getComputedStyle(e.body).backgroundColor):He.TRANSPARENT,E=N.backgroundColor,F="string"==typeof E?Ps(E):null===E?He.TRANSPARENT:4294967295,h=p===e.documentElement?ee(C)?ee(g)?F:g:C:F,H={id:r,cache:Q.cache,canvas:Q.canvas,backgroundColor:h,scale:Q.scale,x:Q.x,y:Q.y,scrollX:Q.scrollX,scrollY:Q.scrollY,width:Q.width,height:Q.height,windowWidth:Q.windowWidth,windowHeight:Q.windowHeight},Q.foreignObjectRendering?(De.getInstance(r).debug("Document cloned, using foreign object rendering"),[4,new ys(H).render(U)]):[3,3];case 2:return d=A.sent(),[3,5];case 3:return De.getInstance(r).debug("Document cloned, using computed rendering"),Se.attachInstance(Q.cache),De.getInstance(r).debug("Starting DOM parsing"),f=iB(U),Se.detachInstance(),h===f.styles.backgroundColor&&(f.styles.backgroundColor=He.TRANSPARENT),De.getInstance(r).debug("Starting renderer"),[4,new Os(H).render(f)];case 4:d=A.sent(),A.label=5;case 5:return!0===Q.removeContainer&&(PB.destroy(l)||De.getInstance(r).error("Cannot detach cloned iframe as it is not in the DOM anymore")),De.getInstance(r).debug("Finished rendering"),De.destroy(r),Se.destroy(r),[2,d]}})})};return function(A,e){return void 0===e&&(e={}),Vs(A,e)}});
/**
 * dirPagination - AngularJS module for paginating (almost) anything.
 *
 *
 * Credits
 * =======
 *
 * Daniel Tabuenca: https://groups.google.com/d/msg/angular/an9QpzqIYiM/r8v-3W1X5vcJ
 * for the idea on how to dynamically invoke the ng-repeat directive.
 *
 * I borrowed a couple of lines and a few attribute names from the AngularUI Bootstrap project:
 * https://github.com/angular-ui/bootstrap/blob/master/src/pagination/pagination.js
 *
 * Copyright 2014 Michael Bromley <michael@michaelbromley.co.uk>
 */

(function() {

    /**
     * Config
     */
    var moduleName = 'angularUtils.directives.dirPagination';
    var DEFAULT_ID = '__default';

    /**
     * Module
     */
    angular.module(moduleName, [])
        .directive('dirPaginate', ['$compile', '$parse', 'paginationService', dirPaginateDirective])
        .directive('dirPaginateNoCompile', noCompileDirective)
        .directive('dirPaginationControls', ['paginationService', 'paginationTemplate', dirPaginationControlsDirective])
        .filter('itemsPerPage', ['paginationService', itemsPerPageFilter])
        .service('paginationService', paginationService)
        .provider('paginationTemplate', paginationTemplateProvider)
        .run(['$templateCache',dirPaginationControlsTemplateInstaller]);

    function dirPaginateDirective($compile, $parse, paginationService) {

        return  {
            terminal: true,
            multiElement: true,
            priority: 100,
            compile: dirPaginationCompileFn
        };

        function dirPaginationCompileFn(tElement, tAttrs){

            var expression = tAttrs.dirPaginate;
            // regex taken directly from https://github.com/angular/angular.js/blob/v1.4.x/src/ng/directive/ngRepeat.js#L339
            var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

            var filterPattern = /\|\s*itemsPerPage\s*:\s*(.*\(\s*\w*\)|([^\)]*?(?=\s+as\s+))|[^\)]*)/;
            if (match[2].match(filterPattern) === null) {
                throw 'pagination directive: the \'itemsPerPage\' filter must be set.';
            }
            var itemsPerPageFilterRemoved = match[2].replace(filterPattern, '');
            var collectionGetter = $parse(itemsPerPageFilterRemoved);

            addNoCompileAttributes(tElement);

            // If any value is specified for paginationId, we register the un-evaluated expression at this stage for the benefit of any
            // dir-pagination-controls directives that may be looking for this ID.
            var rawId = tAttrs.paginationId || DEFAULT_ID;
            paginationService.registerInstance(rawId);

            return function dirPaginationLinkFn(scope, element, attrs){

                // Now that we have access to the `scope` we can interpolate any expression given in the paginationId attribute and
                // potentially register a new ID if it evaluates to a different value than the rawId.
                var paginationId = $parse(attrs.paginationId)(scope) || attrs.paginationId || DEFAULT_ID;
                
                // (TODO: this seems sound, but I'm reverting as many bug reports followed it's introduction in 0.11.0.
                // Needs more investigation.)
                // In case rawId != paginationId we deregister using rawId for the sake of general cleanliness
                // before registering using paginationId
                // paginationService.deregisterInstance(rawId);
                paginationService.registerInstance(paginationId);

                var repeatExpression = getRepeatExpression(expression, paginationId);
                addNgRepeatToElement(element, attrs, repeatExpression);

                removeTemporaryAttributes(element);
                var compiled =  $compile(element);

                var currentPageGetter = makeCurrentPageGetterFn(scope, attrs, paginationId);
                paginationService.setCurrentPageParser(paginationId, currentPageGetter, scope);

                if (typeof attrs.totalItems !== 'undefined') {
                    paginationService.setAsyncModeTrue(paginationId);
                    scope.$watch(function() {
                        return $parse(attrs.totalItems)(scope);
                    }, function (result) {
                        if (0 <= result) {
                            paginationService.setCollectionLength(paginationId, result);
                        }
                    });
                } else {
                    paginationService.setAsyncModeFalse(paginationId);
                    scope.$watchCollection(function() {
                        return collectionGetter(scope);
                    }, function(collection) {
                        if (collection) {
                            var collectionLength = (collection instanceof Array) ? collection.length : Object.keys(collection).length;
                            paginationService.setCollectionLength(paginationId, collectionLength);
                        }
                    });
                }

                // Delegate to the link function returned by the new compilation of the ng-repeat
                compiled(scope);
                 
                // (TODO: Reverting this due to many bug reports in v 0.11.0. Needs investigation as the
                // principle is sound)
                // When the scope is destroyed, we make sure to remove the reference to it in paginationService
                // so that it can be properly garbage collected
                // scope.$on('$destroy', function destroyDirPagination() {
                //     paginationService.deregisterInstance(paginationId);
                // });
            };
        }

        /**
         * If a pagination id has been specified, we need to check that it is present as the second argument passed to
         * the itemsPerPage filter. If it is not there, we add it and return the modified expression.
         *
         * @param expression
         * @param paginationId
         * @returns {*}
         */
        function getRepeatExpression(expression, paginationId) {
            var repeatExpression,
                idDefinedInFilter = !!expression.match(/(\|\s*itemsPerPage\s*:[^|]*:[^|]*)/);

            if (paginationId !== DEFAULT_ID && !idDefinedInFilter) {
                repeatExpression = expression.replace(/(\|\s*itemsPerPage\s*:\s*[^|\s]*)/, "$1 : '" + paginationId + "'");
            } else {
                repeatExpression = expression;
            }

            return repeatExpression;
        }

        /**
         * Adds the ng-repeat directive to the element. In the case of multi-element (-start, -end) it adds the
         * appropriate multi-element ng-repeat to the first and last element in the range.
         * @param element
         * @param attrs
         * @param repeatExpression
         */
        function addNgRepeatToElement(element, attrs, repeatExpression) {
            if (element[0].hasAttribute('dir-paginate-start') || element[0].hasAttribute('data-dir-paginate-start')) {
                // using multiElement mode (dir-paginate-start, dir-paginate-end)
                attrs.$set('ngRepeatStart', repeatExpression);
                element.eq(element.length - 1).attr('ng-repeat-end', true);
            } else {
                attrs.$set('ngRepeat', repeatExpression);
            }
        }

        /**
         * Adds the dir-paginate-no-compile directive to each element in the tElement range.
         * @param tElement
         */
        function addNoCompileAttributes(tElement) {
            angular.forEach(tElement, function(el) {
                if (el.nodeType === 1) {
                    angular.element(el).attr('dir-paginate-no-compile', true);
                }
            });
        }

        /**
         * Removes the variations on dir-paginate (data-, -start, -end) and the dir-paginate-no-compile directives.
         * @param element
         */
        function removeTemporaryAttributes(element) {
            angular.forEach(element, function(el) {
                if (el.nodeType === 1) {
                    angular.element(el).removeAttr('dir-paginate-no-compile');
                }
            });
            element.eq(0).removeAttr('dir-paginate-start').removeAttr('dir-paginate').removeAttr('data-dir-paginate-start').removeAttr('data-dir-paginate');
            element.eq(element.length - 1).removeAttr('dir-paginate-end').removeAttr('data-dir-paginate-end');
        }

        /**
         * Creates a getter function for the current-page attribute, using the expression provided or a default value if
         * no current-page expression was specified.
         *
         * @param scope
         * @param attrs
         * @param paginationId
         * @returns {*}
         */
        function makeCurrentPageGetterFn(scope, attrs, paginationId) {
            var currentPageGetter;
            if (attrs.currentPage) {
                currentPageGetter = $parse(attrs.currentPage);
            } else {
                // If the current-page attribute was not set, we'll make our own.
                // Replace any non-alphanumeric characters which might confuse
                // the $parse service and give unexpected results.
                // See https://github.com/michaelbromley/angularUtils/issues/233
                var defaultCurrentPage = (paginationId + '__currentPage').replace(/\W/g, '_');
                scope[defaultCurrentPage] = 1;
                currentPageGetter = $parse(defaultCurrentPage);
            }
            return currentPageGetter;
        }
    }

    /**
     * This is a helper directive that allows correct compilation when in multi-element mode (ie dir-paginate-start, dir-paginate-end).
     * It is dynamically added to all elements in the dir-paginate compile function, and it prevents further compilation of
     * any inner directives. It is then removed in the link function, and all inner directives are then manually compiled.
     */
    function noCompileDirective() {
        return {
            priority: 5000,
            terminal: true
        };
    }

    function dirPaginationControlsTemplateInstaller($templateCache) {
        $templateCache.put('angularUtils.directives.dirPagination.template', '<ul class="pagination" ng-if="1 < pages.length || !autoHide"><li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(1)">&laquo;</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(pagination.current - 1)">&lsaquo;</a></li><li ng-repeat="pageNumber in pages track by tracker(pageNumber, $index)" ng-class="{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' || ( ! autoHide && pages.length === 1 ) }"><a href="" ng-click="setCurrent(pageNumber)">{{ pageNumber }}</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.current + 1)">&rsaquo;</a></li><li ng-if="boundaryLinks"  ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.last)">&raquo;</a></li></ul>');
    }

    function dirPaginationControlsDirective(paginationService, paginationTemplate) {

        var numberRegex = /^\d+$/;

        var DDO = {
            restrict: 'AE',
            scope: {
                maxSize: '=?',
                onPageChange: '&?',
                paginationId: '=?',
                autoHide: '=?'
            },
            link: dirPaginationControlsLinkFn
        };

        // We need to check the paginationTemplate service to see whether a template path or
        // string has been specified, and add the `template` or `templateUrl` property to
        // the DDO as appropriate. The order of priority to decide which template to use is
        // (highest priority first):
        // 1. paginationTemplate.getString()
        // 2. attrs.templateUrl
        // 3. paginationTemplate.getPath()
        var templateString = paginationTemplate.getString();
        if (templateString !== undefined) {
            DDO.template = templateString;
        } else {
            DDO.templateUrl = function(elem, attrs) {
                return attrs.templateUrl || paginationTemplate.getPath();
            };
        }
        return DDO;

        function dirPaginationControlsLinkFn(scope, element, attrs) {

            // rawId is the un-interpolated value of the pagination-id attribute. This is only important when the corresponding dir-paginate directive has
            // not yet been linked (e.g. if it is inside an ng-if block), and in that case it prevents this controls directive from assuming that there is
            // no corresponding dir-paginate directive and wrongly throwing an exception.
            var rawId = attrs.paginationId ||  DEFAULT_ID;
            var paginationId = scope.paginationId || attrs.paginationId ||  DEFAULT_ID;

            if (!paginationService.isRegistered(paginationId) && !paginationService.isRegistered(rawId)) {
                var idMessage = (paginationId !== DEFAULT_ID) ? ' (id: ' + paginationId + ') ' : ' ';
                if (window.console) {
                    console.warn('Pagination directive: the pagination controls' + idMessage + 'cannot be used without the corresponding pagination directive, which was not found at link time.');
                }
            }

            if (!scope.maxSize) { scope.maxSize = 9; }
            scope.autoHide = scope.autoHide === undefined ? true : scope.autoHide;
            scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : true;
            scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : false;

            var paginationRange = Math.max(scope.maxSize, 5);
            scope.pages = [];
            scope.pagination = {
                last: 1,
                current: 1
            };
            scope.range = {
                lower: 1,
                upper: 1,
                total: 1
            };

            scope.$watch('maxSize', function(val) {
                if (val) {
                    paginationRange = Math.max(scope.maxSize, 5);
                    generatePagination();
                }
            });

            scope.$watch(function() {
                if (paginationService.isRegistered(paginationId)) {
                    return (paginationService.getCollectionLength(paginationId) + 1) * paginationService.getItemsPerPage(paginationId);
                }
            }, function(length) {
                if (0 < length) {
                    generatePagination();
                }
            });

            scope.$watch(function() {
                if (paginationService.isRegistered(paginationId)) {
                    return (paginationService.getItemsPerPage(paginationId));
                }
            }, function(current, previous) {
                if (current != previous && typeof previous !== 'undefined') {
                    goToPage(scope.pagination.current);
                }
            });

            scope.$watch(function() {
                if (paginationService.isRegistered(paginationId)) {
                    return paginationService.getCurrentPage(paginationId);
                }
            }, function(currentPage, previousPage) {
                if (currentPage != previousPage) {
                    goToPage(currentPage);
                }
            });

            scope.setCurrent = function(num) {
                if (paginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
                    num = parseInt(num, 10);
                    paginationService.setCurrentPage(paginationId, num);
                }
            };

            /**
             * Custom "track by" function which allows for duplicate "..." entries on long lists,
             * yet fixes the problem of wrongly-highlighted links which happens when using
             * "track by $index" - see https://github.com/michaelbromley/angularUtils/issues/153
             * @param id
             * @param index
             * @returns {string}
             */
            scope.tracker = function(id, index) {
                return id + '_' + index;
            };

            function goToPage(num) {
                if (paginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
                    var oldPageNumber = scope.pagination.current;

                    scope.pages = generatePagesArray(num, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
                    scope.pagination.current = num;
                    updateRangeValues();

                    // if a callback has been set, then call it with the page number as the first argument
                    // and the previous page number as a second argument
                    if (scope.onPageChange) {
                        scope.onPageChange({
                            newPageNumber : num,
                            oldPageNumber : oldPageNumber
                        });
                    }
                }
            }

            function generatePagination() {
                if (paginationService.isRegistered(paginationId)) {
                    var page = parseInt(paginationService.getCurrentPage(paginationId)) || 1;
                    scope.pages = generatePagesArray(page, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
                    scope.pagination.current = page;
                    scope.pagination.last = scope.pages[scope.pages.length - 1];
                    if (scope.pagination.last < scope.pagination.current) {
                        scope.setCurrent(scope.pagination.last);
                    } else {
                        updateRangeValues();
                    }
                }
            }

            /**
             * This function updates the values (lower, upper, total) of the `scope.range` object, which can be used in the pagination
             * template to display the current page range, e.g. "showing 21 - 40 of 144 results";
             */
            function updateRangeValues() {
                if (paginationService.isRegistered(paginationId)) {
                    var currentPage = paginationService.getCurrentPage(paginationId),
                        itemsPerPage = paginationService.getItemsPerPage(paginationId),
                        totalItems = paginationService.getCollectionLength(paginationId);

                    scope.range.lower = (currentPage - 1) * itemsPerPage + 1;
                    scope.range.upper = Math.min(currentPage * itemsPerPage, totalItems);
                    scope.range.total = totalItems;
                }
            }
            function isValidPageNumber(num) {
                return (numberRegex.test(num) && (0 < num && num <= scope.pagination.last));
            }
        }

        /**
         * Generate an array of page numbers (or the '...' string) which is used in an ng-repeat to generate the
         * links used in pagination
         *
         * @param currentPage
         * @param rowsPerPage
         * @param paginationRange
         * @param collectionLength
         * @returns {Array}
         */
        function generatePagesArray(currentPage, collectionLength, rowsPerPage, paginationRange) {
            var pages = [];
            var totalPages = Math.ceil(collectionLength / rowsPerPage);
            var halfWay = Math.ceil(paginationRange / 2);
            var position;

            if (currentPage <= halfWay) {
                position = 'start';
            } else if (totalPages - halfWay < currentPage) {
                position = 'end';
            } else {
                position = 'middle';
            }

            var ellipsesNeeded = paginationRange < totalPages;
            var i = 1;
            while (i <= totalPages && i <= paginationRange) {
                var pageNumber = calculatePageNumber(i, currentPage, paginationRange, totalPages);

                var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
                var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));
                if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
                    pages.push('...');
                } else {
                    pages.push(pageNumber);
                }
                i ++;
            }
            return pages;
        }

        /**
         * Given the position in the sequence of pagination links [i], figure out what page number corresponds to that position.
         *
         * @param i
         * @param currentPage
         * @param paginationRange
         * @param totalPages
         * @returns {*}
         */
        function calculatePageNumber(i, currentPage, paginationRange, totalPages) {
            var halfWay = Math.ceil(paginationRange/2);
            if (i === paginationRange) {
                return totalPages;
            } else if (i === 1) {
                return i;
            } else if (paginationRange < totalPages) {
                if (totalPages - halfWay < currentPage) {
                    return totalPages - paginationRange + i;
                } else if (halfWay < currentPage) {
                    return currentPage - halfWay + i;
                } else {
                    return i;
                }
            } else {
                return i;
            }
        }
    }

    /**
     * This filter slices the collection into pages based on the current page number and number of items per page.
     * @param paginationService
     * @returns {Function}
     */
    function itemsPerPageFilter(paginationService) {

        return function(collection, itemsPerPage, paginationId) {
            if (typeof (paginationId) === 'undefined') {
                paginationId = DEFAULT_ID;
            }
            if (!paginationService.isRegistered(paginationId)) {
                throw 'pagination directive: the itemsPerPage id argument (id: ' + paginationId + ') does not match a registered pagination-id.';
            }
            var end;
            var start;
            if (angular.isObject(collection)) {
                itemsPerPage = parseInt(itemsPerPage) || 9999999999;
                if (paginationService.isAsyncMode(paginationId)) {
                    start = 0;
                } else {
                    start = (paginationService.getCurrentPage(paginationId) - 1) * itemsPerPage;
                }
                end = start + itemsPerPage;
                paginationService.setItemsPerPage(paginationId, itemsPerPage);

                if (collection instanceof Array) {
                    // the array just needs to be sliced
                    return collection.slice(start, end);
                } else {
                    // in the case of an object, we need to get an array of keys, slice that, then map back to
                    // the original object.
                    var slicedObject = {};
                    angular.forEach(keys(collection).slice(start, end), function(key) {
                        slicedObject[key] = collection[key];
                    });
                    return slicedObject;
                }
            } else {
                return collection;
            }
        };
    }

    /**
     * Shim for the Object.keys() method which does not exist in IE < 9
     * @param obj
     * @returns {Array}
     */
    function keys(obj) {
        if (!Object.keys) {
            var objKeys = [];
            for (var i in obj) {
                if (obj.hasOwnProperty(i)) {
                    objKeys.push(i);
                }
            }
            return objKeys;
        } else {
            return Object.keys(obj);
        }
    }

    /**
     * This service allows the various parts of the module to communicate and stay in sync.
     */
    function paginationService() {

        var instances = {};
        var lastRegisteredInstance;

        this.registerInstance = function(instanceId) {
            if (typeof instances[instanceId] === 'undefined') {
                instances[instanceId] = {
                    asyncMode: false
                };
                lastRegisteredInstance = instanceId;
            }
        };

        this.deregisterInstance = function(instanceId) {
            delete instances[instanceId];
        };
        
        this.isRegistered = function(instanceId) {
            return (typeof instances[instanceId] !== 'undefined');
        };

        this.getLastInstanceId = function() {
            return lastRegisteredInstance;
        };

        this.setCurrentPageParser = function(instanceId, val, scope) {
            instances[instanceId].currentPageParser = val;
            instances[instanceId].context = scope;
        };
        this.setCurrentPage = function(instanceId, val) {
            instances[instanceId].currentPageParser.assign(instances[instanceId].context, val);
        };
        this.getCurrentPage = function(instanceId) {
            var parser = instances[instanceId].currentPageParser;
            return parser ? parser(instances[instanceId].context) : 1;
        };

        this.setItemsPerPage = function(instanceId, val) {
            instances[instanceId].itemsPerPage = val;
        };
        this.getItemsPerPage = function(instanceId) {
            return instances[instanceId].itemsPerPage;
        };

        this.setCollectionLength = function(instanceId, val) {
            instances[instanceId].collectionLength = val;
        };
        this.getCollectionLength = function(instanceId) {
            return instances[instanceId].collectionLength;
        };

        this.setAsyncModeTrue = function(instanceId) {
            instances[instanceId].asyncMode = true;
        };

        this.setAsyncModeFalse = function(instanceId) {
            instances[instanceId].asyncMode = false;
        };

        this.isAsyncMode = function(instanceId) {
            return instances[instanceId].asyncMode;
        };
    }

    /**
     * This provider allows global configuration of the template path used by the dir-pagination-controls directive.
     */
    function paginationTemplateProvider() {

        var templatePath = 'angularUtils.directives.dirPagination.template';
        var templateString;

        /**
         * Set a templateUrl to be used by all instances of <dir-pagination-controls>
         * @param {String} path
         */
        this.setPath = function(path) {
            templatePath = path;
        };

        /**
         * Set a string of HTML to be used as a template by all instances
         * of <dir-pagination-controls>. If both a path *and* a string have been set,
         * the string takes precedence.
         * @param {String} str
         */
        this.setString = function(str) {
            templateString = str;
        };

        this.$get = function() {
            return {
                getPath: function() {
                    return templatePath;
                },
                getString: function() {
                    return templateString;
                }
            };
        };
    }
})();

/*!
 * angular-translate - v2.18.1 - 2018-05-19
 * 
 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module unless amdModuleId is set
		define([], function () {
			return (factory());
		});
	} else if (typeof module === 'object' && module.exports) {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		factory();
	}
}(this, function () {

	angular.module('pascalprecht.translate')
		/**
		 * @ngdoc object
		 * @name pascalprecht.translate.$translatePartialLoaderProvider
		 *
		 * @description
		 * By using a $translatePartialLoaderProvider you can configure a list of a needed
		 * translation parts directly during the configuration phase of your application's
		 * lifetime. All parts you add by using this provider would be loaded by
		 * angular-translate at the startup as soon as possible.
		 */
		.provider('$translatePartialLoader', $translatePartialLoader);

	function $translatePartialLoader() {

		'use strict';

		/**
		 * @constructor
		 * @name Part
		 *
		 * @description
		 * Represents Part object to add and set parts at runtime.
		 */
		function Part(name, priority, urlTemplate) {
			this.name = name;
			this.isActive = true;
			this.tables = {};
			this.priority = priority || 0;
			this.langPromises = {};
			this.urlTemplate = urlTemplate;
		}

		/**
		 * @name parseUrl
		 * @method
		 *
		 * @description
		 * Returns a parsed url template string and replaces given target lang
		 * and part name it.
		 *
		 * @param {string|function} urlTemplate - Either a string containing an url pattern (with
		 *                                        '{part}' and '{lang}') or a function(part, lang)
		 *                                        returning a string.
		 * @param {string} targetLang - Language key for language to be used.
		 * @return {string} Parsed url template string
		 */
		Part.prototype.parseUrl = function (urlTemplate, targetLang) {
			if (angular.isFunction(urlTemplate)) {
				return urlTemplate(this.name, targetLang);
			}
			return urlTemplate.replace(/\{part\}/g, this.name).replace(/\{lang\}/g, targetLang);
		};

		Part.prototype.getTable = function (lang, $q, $http, $httpOptions, urlTemplate, errorHandler) {

			//locals
			var self = this;
			var lastLangPromise = this.langPromises[lang];
			var deferred = $q.defer();

			//private helper helpers
			var fetchData = function () {
				return $q(function (resolve, reject) {
					if (self.urlTemplate != null || urlTemplate != null) {
						$http({
								method: 'GET',
								url: self.parseUrl(self.urlTemplate || urlTemplate, lang)
							},
							$httpOptions).then(function (response) {
							if (response != null && response.data != null) {
								resolve(response);
							} else {
								reject();
							}
						}).catch(function () {
							reject();
						});
					} else {
						reject();
					}
				});
				// return $http(
				//   angular.extend({
				//       method : 'GET',
				//       url : self.parseUrl(self.urlTemplate || urlTemplate, lang)
				//     },
				//     $httpOptions)
				// );
			};

			//private helper
			var handleNewData = function (data) {
				self.tables[lang] = data;
				deferred.resolve(data);
			};

			//private helper
			var rejectDeferredWithPartName = function () {
				deferred.reject(self.name);
			};

			//private helper
			var tryGettingThisTable = function () {
				//data fetching logic
				fetchData().then(
					function (result) {
						handleNewData(result.data);
					},
					function (errorResponse) {
						if (errorHandler) {
							errorHandler(self.name, lang, errorResponse).then(handleNewData, rejectDeferredWithPartName);
						} else {
							rejectDeferredWithPartName();
						}
					});
			};

			//loading logic
			if (!this.tables[lang]) {
				//let's try loading the data
				if (!lastLangPromise) {
					//this is the first request - just go ahead and hit the server
					tryGettingThisTable();
				} else {
					//this is an additional request after one or more unfinished or failed requests
					//chain the deferred off the previous request's promise so that this request conditionally executes
					//if the previous request succeeds then the result will be passed through, but if it fails then this request will try again and hit the server
					lastLangPromise.then(deferred.resolve, tryGettingThisTable);
				}
				//retain a reference to the last promise so we can continue the chain if another request is made before any succeed
				//you can picture the promise chain as a singly-linked list (formed by the .then handler queues) that's traversed by the execution context
				this.langPromises[lang] = deferred.promise;
			} else {
				//the part has already been loaded - if lastLangPromise is also undefined then the table has been populated using setPart
				//this breaks the promise chain because we're not tying langDeferred's outcome to a previous call's promise handler queues, but we don't care because there's no asynchronous execution context to keep track of anymore
				deferred.resolve(this.tables[lang]);
			}
			return deferred.promise;
		};

		var parts = {};

		function hasPart(name) {
			return Object.prototype.hasOwnProperty.call(parts, name);
		}

		function isStringValid(str) {
			return angular.isString(str) && str !== '';
		}

		function isPartAvailable(name) {
			if (!isStringValid(name)) {
				throw new TypeError('Invalid type of a first argument, a non-empty string expected.');
			}

			return (hasPart(name) && parts[name].isActive);
		}

		function deepExtend(dst, src) {
			for (var property in src) {
				if (src[property] && src[property].constructor &&
					src[property].constructor === Object) {
					dst[property] = dst[property] || {};
					deepExtend(dst[property], src[property]);
				} else {
					dst[property] = src[property];
				}
			}
			return dst;
		}

		function getPrioritizedParts() {
			var prioritizedParts = [];
			for (var part in parts) {
				if (parts[part].isActive) {
					prioritizedParts.push(parts[part]);
				}
			}
			prioritizedParts.sort(function (a, b) {
				return a.priority - b.priority;
			});
			return prioritizedParts;
		}


		/**
		 * @ngdoc function
		 * @name pascalprecht.translate.$translatePartialLoaderProvider#addPart
		 * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
		 *
		 * @description
		 * Registers a new part of the translation table to be loaded once the
		 * `angular-translate` gets into runtime phase. It does not actually load any
		 * translation data, but only registers a part to be loaded in the future.
		 *
		 * @param {string} name A name of the part to add
		 * @param {int} [priority=0] Sets the load priority of this part.
		 *
		 * @returns {object} $translatePartialLoaderProvider, so this method is chainable
		 * @throws {TypeError} The method could throw a **TypeError** if you pass the param
		 * of the wrong type. Please, note that the `name` param has to be a
		 * non-empty **string**.
		 */
		this.addPart = function (name, priority, urlTemplate) {
			if (!isStringValid(name)) {
				throw new TypeError('Couldn\'t add part, part name has to be a string!');
			}

			if (!hasPart(name)) {
				parts[name] = new Part(name, priority, urlTemplate);
			}
			parts[name].isActive = true;

			return this;
		};

		/**
		 * @ngdocs function
		 * @name pascalprecht.translate.$translatePartialLoaderProvider#setPart
		 * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
		 *
		 * @description
		 * Sets a translation table to the specified part. This method does not make the
		 * specified part available, but only avoids loading this part from the server.
		 *
		 * @param {string} lang A language of the given translation table
		 * @param {string} part A name of the target part
		 * @param {object} table A translation table to set to the specified part
		 *
		 * @return {object} $translatePartialLoaderProvider, so this method is chainable
		 * @throws {TypeError} The method could throw a **TypeError** if you pass params
		 * of the wrong type. Please, note that the `lang` and `part` params have to be a
		 * non-empty **string**s and the `table` param has to be an object.
		 */
		this.setPart = function (lang, part, table) {
			if (!isStringValid(lang)) {
				throw new TypeError('Couldn\'t set part.`lang` parameter has to be a string!');
			}
			if (!isStringValid(part)) {
				throw new TypeError('Couldn\'t set part.`part` parameter has to be a string!');
			}
			if (typeof table !== 'object' || table === null) {
				throw new TypeError('Couldn\'t set part. `table` parameter has to be an object!');
			}

			if (!hasPart(part)) {
				parts[part] = new Part(part);
				parts[part].isActive = false;
			}

			parts[part].tables[lang] = table;
			return this;
		};

		/**
		 * @ngdoc function
		 * @name pascalprecht.translate.$translatePartialLoaderProvider#deletePart
		 * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
		 *
		 * @description
		 * Removes the previously added part of the translation data. So, `angular-translate` will not
		 * load it at the startup.
		 *
		 * @param {string} name A name of the part to delete
		 *
		 * @returns {object} $translatePartialLoaderProvider, so this method is chainable
		 *
		 * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
		 * type. Please, note that the `name` param has to be a non-empty **string**.
		 */
		this.deletePart = function (name) {
			if (!isStringValid(name)) {
				throw new TypeError('Couldn\'t delete part, first arg has to be string.');
			}

			if (hasPart(name)) {
				parts[name].isActive = false;
			}

			return this;
		};


		/**
		 * @ngdoc function
		 * @name pascalprecht.translate.$translatePartialLoaderProvider#isPartAvailable
		 * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
		 *
		 * @description
		 * Checks if the specific part is available. A part becomes available after it was added by the
		 * `addPart` method. Available parts would be loaded from the server once the `angular-translate`
		 * asks the loader to that.
		 *
		 * @param {string} name A name of the part to check
		 *
		 * @returns {boolean} Returns **true** if the part is available now and **false** if not.
		 *
		 * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
		 * type. Please, note that the `name` param has to be a non-empty **string**.
		 */
		this.isPartAvailable = isPartAvailable;

		/**
		 * @ngdoc object
		 * @name pascalprecht.translate.$translatePartialLoader
		 *
		 * @requires $q
		 * @requires $http
		 * @requires $injector
		 * @requires $rootScope
		 * @requires $translate
		 *
		 * @description
		 *
		 * @param {object} options Options object
		 *
		 * @throws {TypeError}
		 */
		this.$get = ['$rootScope', '$injector', '$q', '$http', '$log',
			function ($rootScope, $injector, $q, $http, $log) {

				/**
				 * @ngdoc event
				 * @name pascalprecht.translate.$translatePartialLoader#$translatePartialLoaderStructureChanged
				 * @eventOf pascalprecht.translate.$translatePartialLoader
				 * @eventType broadcast on root scope
				 *
				 * @description
				 * A $translatePartialLoaderStructureChanged event is called when a state of the loader was
				 * changed somehow. It could mean either some part is added or some part is deleted. Anyway when
				 * you get this event the translation table is not longer current and has to be updated.
				 *
				 * @param {string} name A name of the part which is a reason why the event was fired
				 */

				var service = function (options) {
					if (!isStringValid(options.key)) {
						throw new TypeError('Unable to load data, a key is not a non-empty string.');
					}

					if (!isStringValid(options.urlTemplate) && !angular.isFunction(options.urlTemplate)) {
						throw new TypeError('Unable to load data, a urlTemplate is not a non-empty string or not a function.');
					}

					var errorHandler = options.loadFailureHandler;
					if (errorHandler !== undefined) {
						if (!angular.isString(errorHandler)) {
							throw new Error('Unable to load data, a loadFailureHandler is not a string.');
						} else {
							errorHandler = $injector.get(errorHandler);
						}
					}

					var loaders = [],
						prioritizedParts = getPrioritizedParts();

					angular.forEach(prioritizedParts, function (part) {
						loaders.push(
							part.getTable(options.key, $q, $http, options.$http, options.urlTemplate, errorHandler)
						);
						part.urlTemplate = part.urlTemplate || options.urlTemplate;
					});

					// workaround for #1781
					var structureHasBeenChangedWhileLoading = false;
					var dirtyCheckEventCloser = $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
						structureHasBeenChangedWhileLoading = true;
					});

					return $q.all(loaders)
						.then(function () {
							dirtyCheckEventCloser();
							if (structureHasBeenChangedWhileLoading) {
								if (!options.__retries) {
									// the part structure has been changed while loading (the origin ones)
									// this can happen if an addPart/removePart has been invoked right after a $translate.use(lang)
									// TODO maybe we can optimize this with the actual list of missing parts
									options.__retries = (options.__retries || 0) + 1;
									return service(options);
								} else {
									// the part structure has been changed again while loading (retried one)
									// because this could an infinite loop, this will not load another one again
									$log.warn('The partial loader has detected a multiple structure change (with addPort/removePart) ' +
										'while loading translations. You should consider using promises of $translate.use(lang) and ' +
										'$translate.refresh(). Also parts should be added/removed right before an explicit refresh ' +
										'if possible.');
								}
							}
							var table = {};
							prioritizedParts = getPrioritizedParts();
							angular.forEach(prioritizedParts, function (part) {
								deepExtend(table, part.tables[options.key]);
							});
							return table;
						}, function () {
							dirtyCheckEventCloser();
							return $q.reject(options.key);
						});
				};

				/**
				 * @ngdoc function
				 * @name pascalprecht.translate.$translatePartialLoader#addPart
				 * @methodOf pascalprecht.translate.$translatePartialLoader
				 *
				 * @description
				 * Registers a new part of the translation table. This method does not actually perform any xhr
				 * requests to get translation data. The new parts will be loaded in order of priority from the server next time
				 * `angular-translate` asks the loader to load translations.
				 *
				 * @param {string} name A name of the part to add
				 * @param {int} [priority=0] Sets the load priority of this part.
				 *
				 * @returns {object} $translatePartialLoader, so this method is chainable
				 *
				 * @fires {$translatePartialLoaderStructureChanged} The $translatePartialLoaderStructureChanged
				 * event would be fired by this method in case the new part affected somehow on the loaders
				 * state. This way it means that there are a new translation data available to be loaded from
				 * the server.
				 *
				 * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
				 * type. Please, note that the `name` param has to be a non-empty **string**.
				 */
				service.addPart = function (name, priority, urlTemplate) {
					if (!isStringValid(name)) {
						throw new TypeError('Couldn\'t add part, first arg has to be a string');
					}

					if (!hasPart(name)) {
						parts[name] = new Part(name, priority, urlTemplate);
						$rootScope.$emit('$translatePartialLoaderStructureChanged', name);
					} else if (!parts[name].isActive) {
						parts[name].isActive = true;
						$rootScope.$emit('$translatePartialLoaderStructureChanged', name);
					}

					return service;
				};

				/**
				 * @ngdoc function
				 * @name pascalprecht.translate.$translatePartialLoader#deletePart
				 * @methodOf pascalprecht.translate.$translatePartialLoader
				 *
				 * @description
				 * Deletes the previously added part of the translation data. The target part could be deleted
				 * either logically or physically. When the data is deleted logically it is not actually deleted
				 * from the browser, but the loader marks it as not active and prevents it from affecting on the
				 * translations. If the deleted in such way part is added again, the loader will use the
				 * previously loaded data rather than loading it from the server once more time. But if the data
				 * is deleted physically, the loader will completely remove all information about it. So in case
				 * of recycling this part will be loaded from the server again.
				 *
				 * @param {string} name A name of the part to delete
				 * @param {boolean=} [removeData=false] An indicator if the loader has to remove a loaded
				 * translation data physically. If the `removeData` if set to **false** the loaded data will not be
				 * deleted physically and might be reused in the future to prevent an additional xhr requests.
				 *
				 * @returns {object} $translatePartialLoader, so this method is chainable
				 *
				 * @fires {$translatePartialLoaderStructureChanged} The $translatePartialLoaderStructureChanged
				 * event would be fired by this method in case a part deletion process affects somehow on the
				 * loaders state. This way it means that some part of the translation data is now deprecated and
				 * the translation table has to be recompiled with the remaining translation parts.
				 *
				 * @throws {TypeError} The method could throw a **TypeError** if you pass some param of the
				 * wrong type. Please, note that the `name` param has to be a non-empty **string** and
				 * the `removeData` param has to be either **undefined** or **boolean**.
				 */
				service.deletePart = function (name, removeData) {
					if (!isStringValid(name)) {
						throw new TypeError('Couldn\'t delete part, first arg has to be string');
					}

					if (removeData === undefined) {
						removeData = false;
					} else if (typeof removeData !== 'boolean') {
						throw new TypeError('Invalid type of a second argument, a boolean expected.');
					}

					if (hasPart(name)) {
						var wasActive = parts[name].isActive;
						if (removeData) {
							var $translate = $injector.get('$translate');
							var cache = $translate.loaderCache();
							if (typeof (cache) === 'string') {
								// getting on-demand instance of loader
								cache = $injector.get(cache);
							}
							// Purging items from cache...
							if (typeof (cache) === 'object') {
								angular.forEach(parts[name].tables, function (value, key) {
									cache.remove(parts[name].parseUrl(parts[name].urlTemplate, key));
								});
							}
							delete parts[name];
						} else {
							parts[name].isActive = false;
						}
						if (wasActive) {
							$rootScope.$emit('$translatePartialLoaderStructureChanged', name);
						}
					}

					return service;
				};

				/**
				 * @ngdoc function
				 * @name pascalprecht.translate.$translatePartialLoader#isPartLoaded
				 * @methodOf pascalprecht.translate.$translatePartialLoader
				 *
				 * @description
				 * Checks if the registered translation part is loaded into the translation table.
				 *
				 * @param {string} name A name of the part
				 * @param {string} lang A key of the language
				 *
				 * @returns {boolean} Returns **true** if the translation of the part is loaded to the translation table and **false** if not.
				 *
				 * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
				 * type. Please, note that the `name` and `lang` params have to be non-empty **string**.
				 */
				service.isPartLoaded = function (name, lang) {
					return angular.isDefined(parts[name]) && angular.isDefined(parts[name].tables[lang]);
				};

				/**
				 * @ngdoc function
				 * @name pascalprecht.translate.$translatePartialLoader#getRegisteredParts
				 * @methodOf pascalprecht.translate.$translatePartialLoader
				 *
				 * @description
				 * Gets names of the parts that were added with the `addPart`.
				 *
				 * @returns {array} Returns array of registered parts, if none were registered then an empty array is returned.
				 */
				service.getRegisteredParts = function () {
					var registeredParts = [];
					angular.forEach(parts, function (p) {
						if (p.isActive) {
							registeredParts.push(p.name);
						}
					});
					return registeredParts;
				};


				/**
				 * @ngdoc function
				 * @name pascalprecht.translate.$translatePartialLoader#isPartAvailable
				 * @methodOf pascalprecht.translate.$translatePartialLoader
				 *
				 * @description
				 * Checks if a target translation part is available. The part becomes available just after it was
				 * added by the `addPart` method. Part's availability does not mean that it was loaded from the
				 * server, but only that it was added to the loader. The available part might be loaded next
				 * time the loader is called.
				 *
				 * @param {string} name A name of the part to delete
				 *
				 * @returns {boolean} Returns **true** if the part is available now and **false** if not.
				 *
				 * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
				 * type. Please, note that the `name` param has to be a non-empty **string**.
				 */
				service.isPartAvailable = isPartAvailable;

				return service;

			}
		];

	}

	$translatePartialLoader.displayName = '$translatePartialLoader';
	return 'pascalprecht.translate';

}));


(function(){
	'use strict';

	angular.module('app.front').config(config);

	function config($translatePartialLoaderProvider) {


		$translatePartialLoaderProvider.addPart('app/main/tourist_attractions');

	}
})();
(function () {
  'use strict';

  angular.module('app.front')
    .config(config);

  function config($translatePartialLoaderProvider) {


    $translatePartialLoaderProvider.addPart('app/main/statistics');

  }
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($translatePartialLoaderProvider) {



		// Translation
		$translatePartialLoaderProvider.addPart('app/main/sites_management');

  }
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($translatePartialLoaderProvider) {

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/settings');

  }
})();

(function() {
    'use strict';

    angular.module('app.front')
    .config(config);

    function config($translatePartialLoaderProvider) {
    

        $translatePartialLoaderProvider.addPart('app/main/packages');

    }
})();

(function () {
  'use strict';

  angular.module('app.front')
    .config(config);

  function config($translatePartialLoaderProvider, $mdDateLocaleProvider) {

    $translatePartialLoaderProvider.addPart('app/main/message');

    $mdDateLocaleProvider.formatDate = function(date) {
      return date ? moment(date).format('DD/MM/YYYY') : "";
    };

  }
})();

(function() {
    'use strict';

    angular.module('app.front')
    .config(config);

    function config($translatePartialLoaderProvider) {


      $translatePartialLoaderProvider.addPart('app/main/media');

    }
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config( $translatePartialLoaderProvider) {

	
		// Translation
		$translatePartialLoaderProvider.addPart('app/main/mailing');

  }
})();

(function () {
  'use strict';

  angular.module('app.front').config(config).run(run);

  function config($translatePartialLoaderProvider) {

  
    // Translation
    $translatePartialLoaderProvider.addPart('app/main/globe_network');

  }

  function run($rootScope, $translate, $location, modelService, msNavigationService, userService) {
    var modelType = 'COMPANY_MODEL';
    var baseUrl = './api/rest/model/' + modelType;

    $rootScope.refreshCompanyTypes = function (langKey) {
      var lang = langKey != null ? langKey : $translate.preferredLanguage();
      msNavigationService.saveItem('database.phantom', {
        title: 'phantom',
        state: 'app.phantom',
        weight: 2,
        hidden: function() {
          return true;
        }
      });
      
      userService.getCurrent($translate.preferredLanguage()).then(function (response) {
				$rootScope.user = response.data;
        modelService.getSubTypes(baseUrl, lang, true).then(function (response) {

          if (angular.isArray($rootScope.companiesMenus)) {
            angular.forEach($rootScope.companiesMenus, function (item) {
              msNavigationService.deleteItem('database.company_' + item.index);
            });
          }

          $rootScope.companiesMenus = response.data;

          // Companies types menus
          if(userService.isUserAdmin() || userService.isUserLinkedToAssociations()){
            for (var i = 0; i < response.data.length; i++) {
              var subtype = response.data[i];
              msNavigationService.saveItem('database.company_' + subtype.index, {
                title: subtype.name,
                state: 'app.companies',
                stateParams: {
                  'subType': subtype.id
                },
                weight: 20 + subtype.index
              });
            }
          } else {
            msNavigationService.saveItem('database.company_' + $rootScope.user.company.subTypes[0].index, {
              title: 'Profile',
              state: 'app.companies.details',
              stateParams: {
                'subType': $rootScope.user.company.subTypes[0].id,
                'id':$rootScope.user.company.id
              },
              weight: 20 + $rootScope.user.company.subTypes[0].index
            });
          }
        }) // end service
        .catch(function () {});
      }).catch(function () {});
    };

    if ($location.path().lastIndexOf('/crm/') === -1) {
      $rootScope.refreshCompanyTypes();
    }

    $rootScope.$on('refreshCompanyTypes', function (event, args) {
      if (args != null && args.langKey != null) {
        $rootScope.refreshCompanyTypes(args.langKey);
      } else {
        $rootScope.refreshCompanyTypes();
      }
    });

  }

})();

(function() {
  'use strict';

  angular.module('app.front')
  .config(config);

  function config($translatePartialLoaderProvider) {


      $translatePartialLoaderProvider.addPart('app/main/gallery');

  }
})();


(function () {
  'use strict';

  angular.module('app.front')
    .config(config);

  function config($translatePartialLoaderProvider,$mdDateLocaleProvider) {
    $translatePartialLoaderProvider.addPart('app/main/festival');

    $mdDateLocaleProvider.formatDate = function(date) {
      return date ? moment(date).format('DD/MM/YYYY') : "";
    };


  }
})();

(function () {
  	'use strict';

  angular.module('app.front').config(config);

  function config($translatePartialLoaderProvider) {



    
		// Translation
		$translatePartialLoaderProvider.addPart('app/main/events');




  }

})();


(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($translatePartialLoaderProvider) {

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/duplication_tool');

        // Menu
        // Voir app/settings/settings.module.js

  }
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($translatePartialLoaderProvider) {

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/data_import');

    }
    
})();

(function () {
  'use strict';

  angular.module('app.front')
    .config(config);

  function config($translatePartialLoaderProvider,$mdDateLocaleProvider) {
    $translatePartialLoaderProvider.addPart('app/main/calendarExtern');


    // msNavigationServiceProvider.saveItem('calendarExtern', {
    //   title: 'Agenda Externe',
    //   state: 'app.calendarExtern',
    //   translate: 'CALENDAR_EXTERN.TITLE',
    //   weight: 2
    // });

    $mdDateLocaleProvider.formatDate = function(date) {
      return date ? moment(date).format('DD/MM/YYYY') : "";
    };


  }
})();

(function () {
  'use strict';

  angular.module('app.front')
    .config(config);

  function config($translatePartialLoaderProvider,$mdDateLocaleProvider) {

    $translatePartialLoaderProvider.addPart('app/main/blog');

    $mdDateLocaleProvider.formatDate = function(date) {
      return date ? moment(date).format('DD/MM/YYYY') : "";
    };


  }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider) {

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/admin');
  }
})();

(function(){
	'use strict';

	angular.module('app.front').config(config);

	function config($translatePartialLoaderProvider){

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/access_rights');

	}
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/dirPagination.tpl.html","<div class=\"pagination\" ng-if=\"1 < pages.length || !autoHide\"><div ng-if=\"boundaryLinks\" \nng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=\"setCurrent(1)\">&laquo;</a></div><div \nng-if=\"directionLinks\" ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" \nng-click=\"setCurrent(pagination.current - 1)\">&lsaquo;</a></div><div \nng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" \nng-class=\"{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }\"><a href=\"\" \nng-click=\"setCurrent(pageNumber)\">{{ pageNumber }}</a></div><div ng-if=\"directionLinks\" \nng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" \nng-click=\"setCurrent(pagination.current + 1)\">&rsaquo;</a></div><div ng-if=\"boundaryLinks\" \nng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=\"setCurrent(pagination.last)\">\n&raquo;</a></div></div>");
$templateCache.put("app/footer.tmpl.html","");
$templateCache.put("app/navigation/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" \nui-view=\"toolbar\" ng-if=\"false\"></md-toolbar><md-content id=\"content\" class=\"animate-fade-in md-hue-2\" \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-fade-in md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-fade-in md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-fade-in md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/blog/blog.html","<div id=\"top_blog\" class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"BLOG.TITLE\"></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-hue-1 mr-15\" type=\"button\" ng-click=\"showFormBlog()\"><md-icon md-font-icon=\"icon-plus\" class=\"s20\">\n</md-icon><span translate=\"BLOG.CREATION.ADD\"></span></md-button><md-input-container flex><md-select \nng-model=\"language.key\" class=\"md-no-underline\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div><div \nclass=\"content\"><div class=\"nl-Block\" ng-if=\"showForm\"><form name=\"formCreateArticle\" novalidate><div layout=\"row\">\n<md-input-container class=\"mb-0\"><label>{{\"BLOG.CREATION.NAME\"|translate}}</label><input ng-model=\"article.name\" \nname=\"articleName\" maxlength=\"255\" required autocomplete=\"name\"><div class=\"pl-20\" \nng-messages=\"formCreateArticle.articleName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"mb-0\">\n<md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-hide-icons=\"calendar\" ng-model=\"article.startDateForm\" \nname=\"articleStartDate\" md-placeholder=\"{{\'BLOG.CREATION.DATE\' | translate}}\" md-open-on-focus required=\"\">\n</md-datepicker><div class=\"pl-20\" ng-messages=\"formCreateArticle.articleStartDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container class=\"ml-20\"><md-checkbox class=\"md-primary md-hue-2\" name=\"\" ng-model=\"article.active\" \naria-label=\"publish\">{{\"BLOG.CREATION.ACTIVE\"|translate}}</md-checkbox></md-input-container></div><md-input-container \nclass=\"mb-0\"><label>{{\"BLOG.CREATION.SHORT_DESCRIPTION\"|translate}}</label><input ng-model=\"article.shortDescription\" \nname=\"shortDescription\" maxlength=\"255\" required autocomplete=\"name\"><div class=\"pl-20\" \nng-messages=\"formCreateArticle.shortDescription.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><div class=\"nl_Trix nl_Trix--block\"><label \nclass=\"nl_Trix-label\" \nstyle=\"{{formCreateArticle.articleContent.$touched && formCreateArticle.articleContent.$invalid ? \'color:#D81313;\' : \'\'}}\">\n{{\"BLOG.CREATION.CONTENT\"|translate}}<label style=\"font-size:13px; vertical-align: top\">*</label></label>\n<ng-quill-editor ng-model=\"article.content\" name=\"articleContent\" required></ng-quill-editor><div \nng-if=\"formCreateArticle.articleContent.$touched && formCreateArticle.articleContent.$invalid\" \nclass=\"ng-scope nl_form-error-input\"><span style=\"color:#D81313\">{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n<div class=\"mv-20\"><div layout=\"row\"><div class=\"m-5 nl-Form-dropify\" flex=\"25\" \nng-repeat=\"photo in article.photos track by $index\" layout=\"column\" layout-align=\"start end\"><div \nclass=\"nl-Form-dropify-wrapper\"><img class=\"nl-Form-dropify has--image\" ng-src=\"alternatedocroots/{{photo.location}}\">\n</div><md-button class=\"md-raised md-warn md-hue-2\" ng-click=\"displayPopUpDeletePhoto(photo, $index)\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\"></md-icon>{{\"GENERAL.DELETE\" | translate}}</md-button></div></div></div><div \nclass=\"mv-20\"><md-button type=\"button\" class=\"md-raised md-primary md-hue-2\" ng-click=\"photos.push({})\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>{{\"BLOG.ADD_PHOTO\" | translate}}</md-button><div layout=\"row\"><div \nclass=\"m-5 nl-Form-dropify\" flex=\"25\" ng-repeat=\"photo in photos\" layout=\"column\" layout-align=\"start end\">\n<dropify-directive class=\"dropify-wrapper has--deleteBtn\" filesave=\"photo.uploadFile\" ng-model=\"photo.model\"><md-button\n class=\"md-raised md-warn md-hue-2\" ng-click=\"deletePhoto($index)\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon>{{\"GENERAL.DELETE\" | translate}}</md-button></div></div></div><div class=\"\"><md-button md-no-ink \nclass=\"md-raised md-primary md-hue-2\" aria-label=\"Enregistrer\" ng-disabled=\"formCreateArticle.$invalid\" \nng-click=\"saveArticle()\">{{\"GENERAL.SAVE\" | translate}}</md-button><md-button md-no-ink class=\"md-accent md-hue-2\" \naria-label=\"Annuler\" ng-click=\"cancelArticleForm()\">{{\"GENERAL.CANCEL\" | translate}}</md-button></div></form></div><div\n class=\"nl-Block\"><div class=\"\"><table class=\"simple list-view\"><thead><th>{{\"BLOG.CREATION.NAME\" | translate}}</th>\n<th>{{\"BLOG.CREATION.DATE\" | translate}}</th><th>{{\"BLOG.CREATION.ACTIVE\" | translate}}</th><th>\n{{\"BLOG.CREATION.SHORT_DESCRIPTION\" | translate}}</th><th>{{\"BLOG.ACTION\" | translate}}</th></thead><tbody><tr \nng-repeat=\"article in articles | orderBy: \'-dateStart\'\"><td>{{article.name}}</td><td>\n{{getDate(article.dateStart) | date:\'dd/MM/yyyy\'}}</td><td><md-checkbox class=\"md-primary md-hue-2\" \nreadonly=\"readonly\" ng-model=\"article.active\" aria-label=\"publish\"></md-checkbox></td><td><div class=\"ql-editor\" \nng-bind-html=\"unsafe(article.shortDescription)\"></div></td><td><md-button md-no-ink ng-click=\"updateArticle(article)\" \nclass=\"md-raised md-primary md-hue-2\" aria-label=\"Supprimer\">{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button \nmd-no-ink ng-click=\"removeArticle(article)\" class=\"md-warn md-hue-2\" aria-label=\"Supprimer\">\n{{\"GENERAL.DELETE\" | translate}}</md-button></td></tr></tbody></table></div><div class=\"nl-loader\" ng-show=\"!loaded\">\n<div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div>\n<div class=\"right\"><div class=\"half-circle\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/calendarExtern/calendarExtern.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h1\"><span><md-icon\n md-font-icon=\"icon-city\" class=\"s24\"></md-icon></span><span translate=\"CALENDAR_EXTERN.TITLE_PAGE\"></span></div></div>\n</div></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><md-input-container \nclass=\"nl-Input-container\"><label></label><md-select ng-model=\"language.key\" class=\"nl-Input-select md-no-underline\" \naria-label=\"language\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div><div \nid=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" ng-class=\"vm.currentMonthKey\">\n<div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button\" ng-click=\"changeView(\'today\')\" aria-label=\"Today\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span>Aujourd\'hui</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"changeView(\'agendaDay\')\" aria-label=\"Day\"><md-icon md-font-icon=\"icon-view-day\">\n</md-icon><md-tooltip><span>Jour</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"changeView(\'agendaWeek\')\" aria-label=\"Week\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip>\n<span>Semaine</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"changeView(\'month\')\" \naria-label=\"Month\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span>Mois</span></md-tooltip>\n</md-button></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button arrow\" ng-click=\"prev()\" aria-label=\"Previous\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><md-button class=\"md-icon-button arrow\" ng-click=\"next()\" aria-label=\"Next\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><md-button class=\"add-event-button md-fab md-warn\" \nng-click=\"addEvent($event)\" aria-label=\"Add event\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content\" id=\"calendar-view-wrapper\" \nstyle=\"max-height: calc(100vh - 325px);\n    min-height: 0;\n    overflow: auto\"><div id=\"calendarView\" \nclass=\"calendar_intervenant\" ui-calendar=\"calendarUiConfig.calendar\" ng-model=\"events\" calendar=\"myCalendar\"></div>\n</div></div></div></div>");
$templateCache.put("app/main/data_import/data_import.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"DATA_IMPORT.TITLE\"></div></div></div>\n<div class=\"content\"><div class=\"white-bg md-whiteframe-4dp p-10\"><form name=\"dataImportForm.form\" \nclass=\"md-inline-form m-20\" novalidate ng-submit=\"dataImportForm.form.$valid && columnsMatching()\"><fieldset \nclass=\"standard mt-20 mb-20\"><div layout=\"row\" layout-wrap class=\"m-10 p-10\"><md-input-container \nclass=\"nl-Input-container m-0 p-0\" flex=\"100\" ng-class=\"{\'md-input-invalid\': error.file}\"><label \nclass=\"nl-Input-label md-no-float md-container-ignore\">{{\"DATA_IMPORT.FILE_FIELD_LABEL\" | translate}}</label><input \ntype=\"file\" name=\"file\" required id=\"data_import_input_file\" placeholder=\"\"><div ng-messages=\"error\" role=\"alert\"><div \nng-message=\"file\"><span>{{\'GENERAL.REQUIRED\' | translate}}</span></div></div></md-input-container><md-button \ntype=\"submit\" flex md-no-ink class=\"\" ng-disabled=\"inProgress\"><md-icon md-font-icon=\"icon-view-column\"></md-icon>\n{{\'DATA_IMPORT.COLUMN_MATCHING_BTN\' | translate}}</md-button></div></fieldset><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" class=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\" \nng-if=\"inProgress\"><md-progress-circular class=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></form><form name=\"dataImportSubmitForm.form\" \nclass=\"md-inline-form\" novalidate ng-submit=\"dataImportSubmitForm.form.$valid && importDataFn()\" \nng-if=\"_sheets.length > 0\"><div layout=\"row\" layout-align=\"start center\" class=\"m-5 p-5\"><md-button type=\"submit\" flex \nmd-no-ink class=\"md-primary\" ng-disabled=\"inProgress\"><md-icon md-font-icon=\"icon-import\"></md-icon>\n{{\'DATA_IMPORT.IMPORT_DATA_BTN\' | translate}}</md-button></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"m-10 p-10\"><table class=\"dataTable row-border hover\" ng-repeat=\"_sheet in _sheets | orderBy : \'sheetIndex\'\">\n<thead><tr><th width=\"25%\">{{\'DATA_IMPORT.COLUMN\' | translate}}</th><th width=\"15%\" \nstyle=\"text-align:center!important\">{{\'DATA_IMPORT.INCLUDE_IN_DUPLICATE_SEARCH\' | translate}}</th><th width=\"25%\">\n{{ \'DATA_IMPORT.MODEL\' | translate }}</th><th width=\"35%\">{{ \'DATA_IMPORT.FIELD\' | translate }}</th></tr></thead><tbody\n ng-repeat=\"_column in _sheet.columns | orderBy : \'columnIndex\'\"><tr><td width=\"25%\">\n{{_column.columnIndex}} - {{_column.columnName}}</td><td width=\"15%\" style=\"text-align:center!important\"><md-checkbox \nng-model=\"_column.lookForDuplicate\"></md-checkbox></td><td width=\"25%\"><md-input-container class=\"\"><md-select \nname=\"modelType{{$index}}\" ng-model=\"_column.modelType\" \nplaceholder=\"{{\'DUPLICATION_TOOL.SELECT_MODEL_TYPE\' | translate}}\" ng-required=\"_column.lookForDuplicate\" \nng-change=\"modelTypeSelectedFn(_column);\"><md-option ng-repeat=\"modelType in MODELS_TYPES track by $index\" \nng-value=\"modelType\">{{\'GENERAL.\' + modelType | translate}}</md-option></md-select><div class=\"\" \nng-messages=\"dataImportForm.form[\'modelType\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"_column.modelType && _column.modelType == MODELS_TYPES.COMPANY_MODEL\"><md-select \nname=\"modelSubTypeId{{$index}}}\" ng-model=\"_column.modelSubTypeId\" \nplaceholder=\"{{\'DUPLICATION_TOOL.SELECT_COMPANY_MODEL_TYPE\' | translate}}\" md-on-close=\"_searchSubType = \'\'\" \nng-change=\"modelSubTypeSelectedFn(_column);\" \nng-required=\"_column.modelType && _column.modelType == MODELS_TYPES.COMPANY_MODEL\"><md-select-header><section><input \nforce-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchSubType\"></section>\n</md-select-header><md-option \nng-repeat=\"modelSubType in modelSubTypes | filter : _searchSubType | orderBy : \'name\' track by $index\" \nng-value=\"modelSubType.id\">{{modelSubType.name}}</md-option></md-select><div class=\"\" \nng-messages=\"dataImportForm.form[\'modelSubTypeId\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></td><td width=\"35%\"><md-input-container \nclass=\"\"><md-select name=\"field{{$index}}\" ng-model=\"_column.fieldId\" \nplaceholder=\"{{\'DATA_IMPORT.SELECT_FIELD\' | translate}}\" md-on-close=\"_searchField = \'\'\" \nng-required=\"_column.modelType\" ng-model-options=\"{trackBy: \'$value\'}\" \nng-disabled=\"!_column.modelType || (_column.modelType && _column.modelType == MODELS_TYPES.COMPANY_MODEL && !_column.modelSubTypeId)\">\n<md-select-header><section><input force-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"_searchField\"></section></md-select-header><md-option \nng-repeat=\"field in _column.fields | filter : _searchField | orderBy : \'libelle\' track by field.id\" \nng-value=\"field.id\">{{field.libelle}}</md-option></md-select><div class=\"\" \nng-messages=\"dataImportForm.form[\'field\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></td></tr></tbody></table></div><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\" ng-if=\"inProgress\">\n<md-progress-circular class=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\" class=\"m-5 p-5\">\n<md-button type=\"submit\" flex md-no-ink class=\"md-primary\" ng-disabled=\"inProgress\"><md-icon \nmd-font-icon=\"icon-import\"></md-icon>{{\'DATA_IMPORT.IMPORT_DATA_BTN\' | translate}}</md-button></div></form><form \nname=\"dataImportResultForm.form\" class=\"md-inline-form m-20\" novalidate \nng-submit=\"dataImportResultForm.form.$valid && submitImportDataResult()\" ng-if=\"_dataImportResults.length>0\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"m-5 p-5 bold\"><span flex class=\"\" style=\"text-align:center!important\">\n<u>{{\'DATA_IMPORT.IMPORT_RESULT_LIBELLE\' | translate}}</u></span></div><div class=\"\" \nng-repeat=\"_sheet in _dataImportResults\"><div layout=\"row\" layout-align=\"start center\" class=\"m-5 p-5\"><table \nclass=\"dataTable hover\"><tbody><tr><td><div>{{\'DATA_IMPORT.TOTAL_ROWS\' | translate}} : {{ _sheet.totalRows }}</div>\n<div>{{\'DATA_IMPORT.ROW_IMPORTED_SUCCESSFULLY\' | translate}} : {{ _sheet.importedRows }}</div><div>\n{{\'DATA_IMPORT.DUPLICATE_ROWS_DB_MATCHING\' | translate}} : {{ _sheet.duplicateFromBdd }}</div></td></tr></tbody>\n</table></div><div class=\"m-5 p-5\" ng-if=\"_sheet.duplicateFromBdd > 0\"><div layout=\"row\" layout-align=\"start center\">\n<table class=\"dataTable hover\" width=\"100%\" style=\"border-top: none!important\"><thead><tr><th width=\"10%\">\n{{\'DATA_IMPORT.ROW\' | translate}}</th><th width=\"15%\">{{\'DATA_IMPORT.MODEL\' | translate}}</th><th width=\"15%\" \nstyle=\"text-align:center!important\">{{\'DATA_IMPORT.IS_A_DUPLICATE_ROW\' | translate}}</th><th width=\"20%\" \nstyle=\"padding-left:12px!important\">{{ \'DATA_IMPORT.FIELD\' | translate }}</th><th width=\"20%\">\n{{ \'DATA_IMPORT.DUPLICATE_ROW_DB_VALUE\' | translate }}</th><th width=\"20%\">\n{{ \'DATA_IMPORT.DUPLICATE_ROW_FILE_VALUE\' | translate }}</th></tr></thead></table></div><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"_rows in _sheet.rows\"><table class=\"dataTable hover\" width=\"100%\"><tbody \nng-repeat=\"_row in _rows | orderBy : \'rowIndex\'\" \nng-if=\"_row.modelType === \'COMPANY_MODEL\' || \n                                        (_row.modelType === \'CONTACT_MODEL\' && _row.duplicateIds.length>0)\">\n<tr><td width=\"10%\">{{\'DATA_IMPORT.ROW\' | translate}} - {{ _row.rowIndex }}</td><td width=\"15%\" \nstyle=\"border-bottom: 1px dotted #dddddd!important\">{{_row.modelType}}</td><td width=\"15%\" \nstyle=\"text-align:center!important;border-bottom: 1px dotted #dddddd!important\"><md-checkbox \nng-model=\"_row.isADuplicate\" ng-change=\"_rowIsADuplicateFn(_row, _rows);\" \nng-disabled=\"_row.modelType === \'CONTACT_MODEL\' && !_row.companyIsADuplicate\"></md-checkbox></td><td width=\"60%\" \nstyle=\"border-bottom: 1px dotted #dddddd!important\"><table width=\"100%\"><tr \nng-repeat=\"_valuedField in _row.valuedFields | orderBy : \'fieldLibelle\'\" style=\"background-color: inherit!important\" \nng-init=\"_valuedField.lookingForDuplicate ? _valuedField.noModelSelected = false :  _valuedField.noModelSelected = true;\">\n<td width=\"30%\" style=\"padding-left:0px!important\">{{ _valuedField.dataFromDb.fieldLibelle }} <span \nng-if=\"_valuedField.noModelSelected && _row.isADuplicate\" style=\"color:red\">*</span></td><td width=\"30%\" \nstyle=\"padding-left:8px!important\"><md-checkbox ng-model=\"_valuedField.dataFromDb.selected\" ng-if=\"_row.isADuplicate\" \nstyle=\"margin-top: 0px!important;margin-bottom: 0px!important\" \nng-change=\"_modelFieldSelectedFn(_sheet, _row, _valuedField, _valuedField.dataFromDb, _valuedField.dataFromFile)\">\n</md-checkbox><span ng-if=\"_valuedField.dataFromDb.fieldType == \'BOOLEAN\'\"><span \nng-if=\"_valuedField.dataFromDb.valuedFieldValue && _valuedField.dataFromDb.valuedFieldValue == \'true\'\"><span \ntranslate=\"DUPLICATION_TOOL.MERGE.FIELD_VALUE.BOOLEAN.YES\"></span> </span><span \nng-if=\"!_valuedField.dataFromDb.value || (_valuedField.dataFromDb.value && _valuedField.dataFromDb.valuedFieldValue != \'true\')\">\n<span translate=\"DUPLICATION_TOOL.MERGE.FIELD_VALUE.BOOLEAN.NO\"></span> </span></span><span \nng-if=\"_valuedField.dataFromDb.fieldType != \'BOOLEAN\'\">{{ _valuedField.dataFromDb.valuedFieldValue }}</span></td><td \nwidth=\"30%\" style=\"padding-left:20px!important\"><md-checkbox ng-model=\"_valuedField.dataFromFile.selected\" \nng-if=\"_row.isADuplicate\" style=\"margin-top: 0px!important;margin-bottom: 0px!important\" \nng-change=\"_modelFieldSelectedFn(_sheet, _row, _valuedField, _valuedField.dataFromFile, _valuedField.dataFromDb)\">\n</md-checkbox><span ng-if=\"_valuedField.dataFromFile.fieldType == \'BOOLEAN\'\"><span \nng-if=\"_valuedField.dataFromFile.valuedFieldValue && _valuedField.dataFromFile.valuedFieldValue == \'true\'\"><span \ntranslate=\"DUPLICATION_TOOL.MERGE.FIELD_VALUE.BOOLEAN.YES\"></span> </span><span \nng-if=\"!_valuedField.dataFromFile.value || (_valuedField.dataFromFile.value && _valuedField.dataFromFile.valuedFieldValue != \'true\')\">\n<span translate=\"DUPLICATION_TOOL.MERGE.FIELD_VALUE.BOOLEAN.NO\"></span> </span></span><span \nng-if=\"_valuedField.dataFromFile.fieldType != \'BOOLEAN\'\">{{ _valuedField.dataFromFile.valuedFieldValue }}</span></td>\n</tr></table></td></tr></tbody></table></div><div layout=\"row\" layout-align=\"start center\" class=\"m-5 p-5\"><md-button \ntype=\"submit\" flex md-no-ink class=\"md-primary\" ng-disabled=\"inProgress\"><md-icon md-font-icon=\"icon-import\"></md-icon>\n{{\'DATA_IMPORT.IMPORT_RESULT_DUPLICATE_BTN\' | translate}}</md-button></div></div></div></form></div></div></div>");
$templateCache.put("app/main/duplication_tool/duplication_tool.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"DUPLICATION_TOOL.TITLE\"></div></div>\n</div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><form name=\"duplicationToolForm.form\" \nclass=\"md-inline-form\" novalidate><div layout=\"row\" layout-wrap class=\"m-20 p-20\" ng-if=\"!initDataInProgress\">\n<md-input-container class=\"\"><md-select name=\"modelType\" ng-model=\"duplicationToolDto.modelType\" \nplaceholder=\"{{\'DUPLICATION_TOOL.SELECT_MODEL_TYPE\' | translate}}\" ng-change=\"modelTypeSelectedFn();\" required>\n<md-option ng-repeat=\"modelType in MODELS_TYPES track by $index\" ng-value=\"modelType\">\n{{\'GENERAL.\' + modelType | translate}}</md-option></md-select><label>{{\'DUPLICATION_TOOL.LABEL_MODEL\' | translate}}\n</label><div class=\"\" ng-messages=\"duplicationToolForm.form.modelType.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"duplicationToolDto.modelType && duplicationToolDto.modelType == MODELS_TYPES.COMPANY_MODEL\"><md-select \nname=\"modelSubTypeId\" ng-model=\"duplicationToolDto.modelSubTypeId\" \nplaceholder=\"{{\'DUPLICATION_TOOL.SELECT_COMPANY_MODEL_TYPE\' | translate}}\" md-on-close=\"_searchSubType = \'\'\" \nng-change=\"modelSubTypeSelectedFn();\" \nng-required=\"duplicationToolDto.modelType && duplicationToolDto.modelType == MODELS_TYPES.COMPANY_MODEL\">\n<md-select-header><section><input force-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"_searchSubType\"></section></md-select-header><md-option \nng-repeat=\"modelSubType in modelSubTypes | filter : _searchSubType | orderBy : \'name\' track by $index\" \nng-value=\"modelSubType.id\">{{modelSubType.name}}</md-option></md-select><label>\n{{\'DUPLICATION_TOOL.LABEL_COMPANY_TYPE\' | translate}}</label><div class=\"\" \nng-messages=\"duplicationToolForm.form.modelSubTypeId.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"duplicationToolDto.modelType && duplicationToolDto.modelType == MODELS_TYPES.CONTACT_MODEL\"><md-select \nname=\"companyId\" ng-model=\"duplicationToolDto.companyId\" \nplaceholder=\"{{\'DUPLICATION_TOOL.SELECT_COMPANY_FOR_CONTACT_DUPLICATES_SEARCH\' | translate}}\" \nmd-on-close=\"_searchCompany = \'\'\" ng-model-options=\"{trackBy: \'$value\'}\"><md-select-header><section><input \nforce-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchCompany\"></section>\n</md-select-header><md-option \nng-repeat=\"_company in _companies | filter : _searchCompany | orderBy : \'modelPattern\' track by $index\" \nng-value=\"_company.id\">{{_company.modelPattern}}</md-option></md-select><label>\n{{\'DUPLICATION_TOOL.LABEL_COMPANY\' | translate}}</label></md-input-container><md-input-container class=\"\" \nng-if=\"(duplicationToolDto.modelType && duplicationToolDto.modelType == MODELS_TYPES.COMPANY_MODEL && duplicationToolDto.modelSubTypeId) || \n                            (duplicationToolDto.modelType && duplicationToolDto.modelType == MODELS_TYPES.CONTACT_MODEL)\" \nng-if=\"!fieldsListInProgress\"><md-select name=\"fields\" multiple=\"multiple\" ng-model=\"duplicationToolDto.fields\" \nplaceholder=\"{{\'DUPLICATION_TOOL.SELECT_FIELD\' | translate}}\" md-on-close=\"_searchField = \'\'\" required \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-select-header><section><input force-select-focus type=\"search\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField\"></section></md-select-header><md-option \nng-repeat=\"field in fields | filter : _searchField | orderBy : \'libelle\' track by field.id\" ng-value=\"field\">\n{{field.libelle}}</md-option></md-select><label>{{\'DUPLICATION_TOOL.LABEL_FIELDS\' | translate}}</label><div class=\"\" \nng-messages=\"duplicationToolForm.form.fields.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" class=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\" \nng-if=\"inProgress || fieldsListInProgress || initDataInProgress\"><md-progress-circular \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" md-mode=\"indeterminate\">\n</md-progress-circular></div><div layout=\"row\" layout-align=\"start center\" class=\"m-20 p-20\"><md-button flex md-no-ink \nclass=\"md-primary\" ng-disabled=\"inProgress || fieldsListInProgress || initDataInProgress\" \nng-click=\"lookForDuplicatesFn();\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon>\n{{\'DUPLICATION_TOOL.FIND_DUPLICACTE_BTN\' | translate}}</md-button></div></form></div></div><div class=\"content\" \nng-if=\"duplicatesEntityDto && duplicatesEntityDto.dto\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" \nlayout-wrap class=\"m-20 p-20\"><table class=\"dataTable row-border hover\" ng-if=\"duplicatesEntityDto.dto.length != 0\">\n<thead><tr><th>{{ \'DUPLICATION_TOOL.FIELD_LIBELLE\' | translate }}</th><th>\n{{ \'DUPLICATION_TOOL.FIELD_VALUE\' | translate }}</th><th></th></tr></thead><tbody \nng-repeat=\"dto in duplicatesEntityDto.dto\"><tr ng-repeat=\"valuedField in dto.valuedFields | orderBy : \'fieldLibelle\'\">\n<td>{{ valuedField.fieldLibelle }}</td><td><span ng-if=\"valuedField.fieldType != \'MULTIPLE_SELECT\'\">\n{{ valuedField.valuedFieldValue }}</span> <span ng-if=\"valuedField.fieldType == \'MULTIPLE_SELECT\'\"><div \nng-repeat=\"_valuedFieldValue in valuedField.valuedFieldValues  | orderBy : \'libelle\'\">- {{_valuedFieldValue.libelle}}\n</div></span></td></tr><tr><td></td><td></td><td><span ng-if=\"dto.duplicateIds.length == 0\" \ntranslate=\"DUPLICATION_TOOL.ANY_OCCURENCE_FOUND\"></span>\n ({{ dto.duplicateIds.length }} {{ \'DUPLICATION_TOOL.OCCURENCES_FOUND\' | translate }})<md-button flex md-no-ink \nclass=\"md-primary\" ng-click=\"removeDuplicatesFn(dto.duplicateIds);\"><md-icon md-font-icon=\"icon-table-column-remove\">\n</md-icon>{{\'DUPLICATION_TOOL.REMOVE_DUPLICACTE_BTN\' | translate}}</md-button></td></tr></tbody></table><table \nclass=\"dataTable row-border hover\" ng-if=\"duplicatesEntityDto.dto.length == 0\"><tbody><tr><td><span \ntranslate=\"DUPLICATION_TOOL.ANY_OCCURENCE_FOUND\"></span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/events/events.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"EVENT.TITLE\"></div></div><div layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"goToSubCategories()\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n{{\'INSCRIPTION_SUB_CATEGORY.TITLE\' | translate}}</md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"goToLogisticalStatus()\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n{{\'LOGISTICAL_STATUS.TITLE\' | translate}}</md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"goToInscriptionStatus()\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n{{\'INSCRIPTION_STATUS.TITLE\' | translate}}</md-button></div></div><div class=\"content\"><md-button \nclass=\"md-primary md-raised md-hue-2 md-teal-theme-theme\" ng-click=\"goAdd()\">{{\"GENERAL.ADD\" | translate}}</md-button>\n<div class=\"nl-Block nl-Block--table\"><div class=\"nl-listing\"><table class=\"simple list-view\"><thead><th>\n{{\"EVENT.COLUMNS.LOGO\" | translate}}</th><th>{{\"EVENT.COLUMNS.NAME\" | translate}}</th><th>\n{{\"EVENT.COLUMNS.START\" | translate}}</th><th>{{\"EVENT.COLUMNS.END\" | translate}}</th><th>\n{{\"EVENT.COLUMNS.SITE\" | translate}}</th><th>{{\"EVENT.COLUMNS.ACTIONS\" | translate}}</th></thead><tbody><tr \nng-repeat=\"event in events | orderBy: \'name\' track by event.id\"><td class=\"type\" show-gt-sm><a \nhref=\"{{URL.alternatedocroots + \'/\' + event.logo}}\" target=\"_blank\" ng-if=\"event.logo != null\"><img \nng-src=\"{{URL.alternatedocroots + \'/\' + event.logo}}\" style=\"max-height: 80px;max-width: 200px\"></a></td><td>\n{{event.name}}</td><td>{{\'GENERAL.DATE_FORMAT\' | translate : {date: getDate(event.start)} }}</td><td>\n{{\'GENERAL.DATE_FORMAT\' | translate : {date: getDate(event.end)} }}</td><td>{{event.site.name}}</td><td><md-button \nmd-no-ink ng-click=\"seeInscriptionForms(event)\" class=\"md-primary md-raised md-hue-2\" \naria-label=\"See inscription forms\">{{\"EVENT.SEE_INSCRIPTION_FORMS\" | translate}}</md-button><md-button md-no-ink \nng-click=\"seeInscriptionFields(event)\" class=\"md-primary md-raised md-hue-2\" aria-label=\"See fields\">\n{{\"EVENT.SEE_INSCRIPTION_FIELDS\" | translate}}</md-button><md-button md-no-ink ng-click=\"seeLogisticalFields(event)\" \nclass=\"md-primary md-raised md-hue-2\" aria-label=\"See fields\">{{\"EVENT.SEE_LOGISTICAL_FIELDS\" | translate}}</md-button>\n<md-button md-no-ink ng-click=\"update(event)\" class=\"md-primary md-raised md-hue-2\" aria-label=\"Supprimer\">\n{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button md-no-ink ng-click=\"showPopUpDelete(event, $index)\" \nclass=\"md-warn md-hue-2\" aria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}</md-button></td></tr></tbody></table>\n</div></div></div></div>");
$templateCache.put("app/main/festival/festival.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"FESTIVAL.TITLE\"></div></div><div layout=\"row\" layout-align=\"end center\"><md-input-container flex>\n<md-select ng-model=\"language.key\" class=\"md-no-underline\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div><div class=\"content\"><div class=\"nl-Block\"><md-button md-no-ink \nclass=\"md-raised md-primary md-hue-2\" type=\"button\" ng-click=\"showFormFestival()\">\n{{\"FESTIVAL.CREATION.ADD\" | translate}}</md-button></div><div class=\"nl-Block mt-30\" ng-if=\"showForm\"><form \nname=\"formCreateFestival\" class=\"nl-Form-xs\" novalidate><md-input-container><label>\n{{\"FESTIVAL.CREATION.NAME\"|translate}}</label><input ng-model=\"festival.name\" name=\"festivalName\" maxlength=\"255\" \nrequired autocomplete=\"name\"><div class=\"pl-5\" ng-messages=\"formCreateFestival.festivalName.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" ng-model=\"festival.startDateForm\" \nname=\"festivalStartDate\" md-placeholder=\"{{\'FESTIVAL.CREATION.DATE_START\' | translate}}\" md-open-on-focus \nmd-hide-icons=\"calendar\"></md-datepicker></md-input-container><md-input-container><label>\n{{\'FESTIVAL.CREATION.TIME_START\' | translate}} hh:mm</label><input type=\"text\" class=\"input-value\" \nname=\"festivalStartTime\" ng-model=\"festival.startTime\" ui-time-mask=\"short\"><div class=\"pl-5\" \nng-messages=\"formCreateFestival.festivalStartTime.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"time\">\n<span>{{\"GENERAL.FORM.INVALID_FORMAT\" | translate}} (hh:mm)</span></div></div><div ng-if=\"timeNotMatch\" \nclass=\"ng-scope nl_form-error-input\"><span>{{\"FESTIVAL.TIME_ERROR\" | translate}}</span></div></md-input-container>\n<md-input-container><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" ng-model=\"festival.endDateForm\" \nname=\"festivalEndDate\" md-placeholder=\"{{\'FESTIVAL.CREATION.DATE_END\' | translate}}\" \nmd-min-date=\"festival.startDateForm\" md-open-on-focus md-hide-icons=\"calendar\"></md-datepicker></md-input-container>\n<md-input-container><label>{{\'FESTIVAL.CREATION.TIME_END\' | translate}} hh:mm</label><input type=\"text\" \nclass=\"input-value\" name=\"festivalEndTime\" ng-model=\"festival.endTime\" ui-time-mask=\"short\"><div class=\"pl-5\" \nng-messages=\"formCreateFestival.festivalEndTime.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"time\"><span>\n{{\"GENERAL.FORM.INVALID_FORMAT\" | translate}} (hh:mm)</span></div></div><div ng-if=\"timeNotMatch\" \nclass=\"ng-scope nl_form-error-input\"><span>{{\"FESTIVAL.TIME_ERROR\" | translate}}</span></div></md-input-container><div \nclass=\"nl_Trix\"><label class=\"nl_Trix-label\">{{\"FESTIVAL.CREATION.DESCRIPTION\"|translate}}</label><ng-quill-editor \nng-model=\"festival.description\" name=\"festivalDescription\"></ng-quill-editor><div \nng-if=\"formCreateFestival.festivalDescription.$touched && formCreateFestival.festivalDescription.$invalid\" \nclass=\"ng-scope nl_form-error-input\"><span style=\"color:#D81313\">{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n<md-input-container><label>{{\"FESTIVAL.CREATION.ADDRESS\"|translate}}</label><input ng-model=\"festival.address\" \nname=\"festivalAddress\" required><div class=\"pl-5\" ng-messages=\"formCreateFestival.festivalAddress.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container><label>{{\"FESTIVAL.CREATION.COUNTRY\"|translate}}</label><input ng-model=\"festival.country\" \nname=\"festivalCountry\" required><div class=\"pl-5\" ng-messages=\"formCreateFestival.festivalCountry.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container><label>{{\"FESTIVAL.CREATION.WEBSITE\"|translate}}</label><input ng-model=\"festival.website\" \nname=\"festivalWebsite\" required><div class=\"pl-5\" ng-messages=\"formCreateFestival.festivalWebsite.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container ng-if=\"userService.isUserAdmin() || userService.isUserLinkedToAssociations()\"><md-checkbox name=\"\" \nclass=\"md-primary\" ng-model=\"festival.publish\" aria-label=\"publish\">{{\"FESTIVAL.CREATION.PUBLISH\"|translate}}\n</md-checkbox></md-input-container><div class=\"mv-20\"><div layout=\"row\" layout-wrap><div class=\"m-5 nl-Form-dropify\" \nflex=\"15\" ng-repeat=\"photo in festival.photos track by $index\" layout=\"column\" layout-align=\"start end\"><div \nclass=\"nl-Form-dropify-wrapper\"><img class=\"nl-Form-dropify has--image\" ng-src=\"alternatedocroots/{{photo.location}}\">\n</div><md-button class=\"md-raised md-warn md-hue-2\" ng-click=\"displayPopUpDeletePhoto(photo, $index)\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\"></md-icon>{{\"GENERAL.DELETE\" | translate}}</md-button></div></div></div><div \nclass=\"mv-20\"><md-button type=\"button\" class=\"md-raised md-primary md-hue-2\" ng-click=\"photos.push({})\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>{{\"FESTIVAL.ADD_PHOTO\" | translate}}</md-button><div layout=\"row\" layout-wrap><div \nclass=\"m-5 nl-Form-dropify\" flex=\"nogrow\" ng-repeat=\"photo in photos\" layout=\"column\" layout-align=\"start end\">\n<dropify-directive class=\"dropify-wrapper has--deleteBtn\" filesave=\"photo.uploadFile\" ng-model=\"photo.model\"><md-button\n class=\"md-raised md-warn md-hue-2\" ng-click=\"deletePhoto($index)\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon>{{\"GENERAL.DELETE\" | translate}}</md-button></div></div></div><div><md-button \nclass=\"md-raised md-primary md-hue-2\" aria-label=\"Enregistrer\" ng-disabled=\"formCreateFestival.$invalid\" \nng-click=\"saveFestival()\">{{\"GENERAL.SAVE\" | translate}}</md-button><md-button class=\"md-warn md-hue-2\" \naria-label=\"Annuler\" ng-click=\"cancelFestivalForm()\">{{\"GENERAL.CANCEL\" | translate}}</md-button></div></form></div>\n<div class=\"nl-Block mt-30\"><div><table class=\"simple list-view\"><thead><th>{{\"FESTIVAL.CREATION.NAME\" | translate}}\n</th><th>{{\"FESTIVAL.CREATION.DATE_START\" | translate}} - {{\"FESTIVAL.CREATION.DATE_END\" | translate}}</th><th>\n{{\"FESTIVAL.CREATION.PLACE\" | translate}}</th><th>{{\"FESTIVAL.CREATION.PUBLISH\" | translate}}</th><th>\n{{\"FESTIVAL.ACTION\" | translate}}</th></thead><tbody><tr ng-repeat=\"festival in festivals | orderBy : \'name\'\"><td>\n{{festival.name}}</td><td>{{getDate(festival.dateStart) | date:\'dd/MM/yyyy HH:mm\'}}<span \nng-if=\"festival.dateStart != null && festival.dateEnd != null\"> - </span>\n{{getDate(festival.dateEnd) | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{festival.address+\' \'+festival.country}}</td><td>\n<md-checkbox readonly=\"readonly\" disabled=\"disabled\" ng-model=\"festival.publish\" aria-label=\"publish\"></md-checkbox>\n</td><td><md-button ng-click=\"updateFestival(festival)\" \nclass=\"nl-listing-item-button md-primary md-raised md-hue-2 md-teal-theme-theme\" aria-label=\"Supprimer\">\n{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button ng-click=\"removeFestival(festival)\" \nclass=\"nl-listing-item-button md-warn\" aria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}</md-button></td></tr>\n</tbody></table></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div \nclass=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\">\n</div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/gallery/addGallery.popup.html","<md-dialog style=\"min-width: 600px\" aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\" ng-if=\"updateMode\">{{\"GALLERY.POPUP.TITLE_UPDATE\" | translate}}</div><div class=\"contact-name\" \nng-if=\"!updateMode\">{{\"GALLERY.POPUP.TITLE_ADD\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"nl-Popup-content-body\"><form name=\"addGalleryForm\"><md-input-container>\n<label>{{\"GALLERY.TITLE\" | translate}}</label><input type=\"text\" class=\"\" ng-model=\"gallery.title\" name=\"title\" \nrequired maxlength=\"255\"></md-input-container><md-button md-no-ink class=\"md-raised md-primary\" \nng-disabled=\"addGalleryForm.$invalid\" ng-click=\"addGallery()\">{{\"GENERAL.SAVE\" | translate }}</md-button><md-button \nmd-no-ink class=\"md-accent md-hue-2\" aria-label=\"Annuler\" ng-click=\"hidePopup()\">{{\"GENERAL.CANCEL\" | translate }}\n</md-button></form></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gallery/gallery.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"GALLERY.TITLE_PAGE\"></div></div><div layout=\"row\" layout-align=\"end center\"><md-input-container \nflex><md-select ng-model=\"language.key\" class=\"md-no-underline\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div><div class=\"content\"><div class=\"nl-Block\"><md-button md-no-ink \nclass=\"md-raised md-primary md-hue-2\" type=\"button\" ng-click=\"showPopUAdd()\">{{\"GALLERY.ADD\" | translate}}</md-button>\n</div><div class=\"nl-Block mt-30\"><div><table class=\"simple list-view\"><thead><th>{{\"GALLERY.TITLE\" | translate}}</th>\n<th>{{\"GALLERY.UUID\" | translate}}</th><th>{{\"GALLERY.ACTION\" | translate}}</th></thead><tbody><tr \nng-repeat=\"gallery in galleries\" ng-if=\"galleries.length > 0\"><td>{{gallery.title}}</td><td>{{gallery.uuid}}</td><td>\n<md-button ng-click=\"showPopUAdd(gallery, $index)\" \nclass=\"nl-listing-item-button md-primary md-raised md-hue-2 md-teal-theme-theme\" aria-label=\"Supprimer\">\n{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button ng-click=\"goDetails(gallery)\" \nclass=\"nl-listing-item-button md-primary md-raised md-hue-2 md-teal-theme-theme\" aria-label=\"Supprimer\">\n{{\"GENERAL.DETAILS\" | translate}}</md-button><md-button ng-click=\"showPopUpRemove(gallery, $index)\" \nclass=\"nl-listing-item-button md-warn\" aria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}</md-button></td></tr><tr\n ng-if=\"galleries.length === 0\"><td colspan=\"3\" layout=\"center center\">{{\"GALLERY.NO_GALLERY\" | translate}}</td></tr>\n</tbody></table></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div \nclass=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\">\n</div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/gallery/removeGallery.popup.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\"GALLERY.POPUP.DELETE_TITLE\" | translate}}\n</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"nl-Popup-content-body\"><div class=\"nl-Popup-content-body-title\">{{\"GALLERY.POPUP.CONFIRM_DELETE\" | translate}}\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-primary md-raised md-hue-2\" \nng-click=\"removeGallery()\" translate=\"GENERAL.YES\"></md-button><md-button class=\"md-primary md-hue-2\" \nng-click=\"hidePopup()\" translate=\"GENERAL.NO\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/home/home.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"AGENDA.TITLE_PAGE\"></div></div><div layout=\"row\" layout-align=\"start center\"></div></div><div \nclass=\"content\"><div class=\"\"><div layout=\"row\" layout-align=\"center center\" class=\"mb-5\"><button \nng-click=\"sortMessage(\'asc\')\" class=\"nl-Table-header-button\" ng-class=\"{\'nl-selected\':date.sort ==\'asc\'}\"><md-icon \nmd-font-icon=\"icon-sort-ascending\" class=\"s14\"></md-icon></button> <button ng-click=\"sortMessage(\'desc\')\" \nclass=\"nl-Table-header-button\" ng-class=\"{\'nl-selected\':date.sort ==\'desc\'}\"><md-icon \nmd-font-icon=\"icon-sort-descending\" class=\"s14\"></md-icon></button> <button \nng-click=\"date.year = getYear(-1);displayDays(\'year\')\" class=\"nl-Table-header-button\" \nng-class=\"{\'nl-selected\' : date.year == getYear(-1)}\">{{getYear(-1)}}</button> <button \nng-click=\"date.year = getYear(0);displayDays(\'year\')\" class=\"nl-Table-header-button\" \nng-class=\"{\'nl-selected\' : date.year == getYear(0)}\">{{getYear(0)}}</button> <button \nng-click=\"date.year = getYear(1);displayDays(\'year\')\" class=\"nl-Table-header-button\" \nng-class=\"{\'nl-selected\' : date.year == getYear(1)}\">{{getYear(1)}}</button></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"date.year\" class=\"mv-5\"><button ng-repeat=\"month in months\" \nng-click=\"date.month = month;displayDays(\'month\')\" class=\"nl-Table-header-button\" \nng-class=\"{\'nl-selected\' : date.month == month}\">{{month}}</button></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"date.month\" class=\"mb-5\"><button \nng-repeat-start=\"n in [].constructor(daysInMonth) track by $index\" ng-click=\"date.day = $index+1;displayDays()\" \nclass=\"nl-Table-header-button\" ng-class=\"{\'nl-selected\' : date.day == $index+1}\">{{$index+1}}</button> <button \nng-repeat-end ng-if=\"$index+1 != daysInMonth && displayCircle($index+1)\" ng-click=\"selectWeek($index+2)\" \nclass=\"nl-Table-header-button button-icon\"><md-icon style=\"cursor: pointer\" md-font-icon=\"icon-brightness-1\" \nclass=\"s8\"></md-icon></button></div></div><div class=\"\" ng-if=\"date.day && daysWeek.length == 0\"><table \nclass=\"nl-Table\"><tbody><tr><td><div class=\"nl-Table-day\" layout=\"row\" layou-align=\"start center\"><div \nclass=\"nl-Table-day-hour\" layout=\"row\" layout-align=\"start top\"><div class=\"nl-Table-day-hour-value\">&lt;8</div><span \nclass=\"nl-Table-day-hour-expo\">h</span></div><div ng-if=\"(actions | filter :filterMessageUnder(8)).length == 0\"><span \nclass=\"nl-Table-header-empty\">Vide</span></div><div ng-if=\"(actions | filter :filterMessageUnder(8)).length > 0\"><div \nclass=\"nl-Table-message\"><table class=\"nl-Table\"><tbody><tr \nng-repeat=\"message in actions | filter:filterMessageUnder(8)\" class=\"nl-Msg\"><td \nng-if=\"message.company || message.contact\"><div class=\"nl-Msg-link-company\" ng-if=\"message.company\"><div \ntranslate=\"GENERAL.COMPANY\"></div>{{message.company.modelPattern}}</div><div class=\"nl-Msg-link-contact\" \nng-if=\"message.contact\"><div translate=\"GENERAL.CONTACT\"></div>{{message.contact.modelPattern}}</div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div></td><td><div class=\"nl-form--receivedMsg--subject\">\n{{message.subject}}</div><div class=\"nl-form--receivedMsg--content\">{{message.content | limitTo: 70}}</div><div \nng-if=\"message.action\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-check\" \nng-class=\"{\'nl-validated\': message.action.actionDone}\" ng-click=\"confirmAction(message.action)\" layout=\"row\" \nlayout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !message.action.actionDone, \'icon-check\' : message.action.actionDone}\"></i></div><div \nclass=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{message.action.libelle}}</div></div></div></td><td><span \nclass=\"nl-Msg-sender-date\">\n{{getDate(message.creationDate) | date:\'dd/MM/yyyy\'}} - {{getDate(message.creationDate) | date:\'HH:mm\'}}</span><div \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-avatar mr-10\"><img class=\"nl-Msg-avatar-img\" \nhttp-src=\"./alternatedocroots/{{message.sender.pictureLocation}}\" \nhas-profile-picture=\"$root.user.pictureLocation != null\"></div><span class=\"nl-Badge\">{{message.sender.fullName}}\n</span></div></td></tr></tbody></table></div></div></div></td></tr><tr ng-repeat=\"hour in hoursInDay\"><td><div \nclass=\"nl-Table-day\" layout=\"row\" layou-align=\"start center\"><div class=\"nl-Table-day-hour\" layout=\"row\" \nlayout-align=\"start top\"><div class=\"nl-Table-day-hour-value\">{{hour}}</div><span class=\"nl-Table-day-hour-expo\">h\n</span></div><div ng-if=\"(actions | filter:filterMessageByHour(hour)).length == 0\"><span class=\"nl-Table-header-empty\">\nVide</span></div><div ng-if=\"(actions | filter:filterMessageByHour(hour)).length > 0\"><div class=\"nl-Table-message\">\n<table class=\"nl-Table\"><tbody><tr ng-repeat=\"message in actions | filter:filterMessageByHour(hour)\" class=\"nl-Msg\"><td\n ng-if=\"message.company || message.contact\"><div class=\"nl-Msg-link-company\" ng-if=\"message.company\"><div \ntranslate=\"GENERAL.COMPANY\"></div>{{message.company.modelPattern}}</div><div class=\"nl-Msg-link-contact\" \nng-if=\"message.contact\"><div translate=\"GENERAL.CONTACT\"></div>{{message.contact.modelPattern}}</div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div></td><td><div class=\"nl-form--receivedMsg--subject\">\n{{message.subject}}</div><div class=\"nl-form--receivedMsg--content\">{{message.content | limitTo: 70}}</div><div \nng-if=\"message.action\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-check\" \nng-class=\"{\'nl-validated\': message.action.actionDone}\" ng-click=\"confirmAction(message.action)\" layout=\"row\" \nlayout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !message.action.actionDone, \'icon-check\' : message.action.actionDone}\"></i></div><div \nclass=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{message.action.libelle}}</div></div></div></td><td><span \nclass=\"nl-Msg-sender-date\">\n{{getDate(message.creationDate) | date:\'dd/MM/yyyy\'}} - {{getDate(message.creationDate) | date:\'HH:mm\'}}</span><div \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-avatar mr-10\"><img class=\"nl-Msg-avatar-img\" \nhttp-src=\"./alternatedocroots/{{message.sender.pictureLocation}}\" \nhas-profile-picture=\"$root.user.pictureLocation != null\"></div><span class=\"nl-Badge\">{{message.sender.fullName}}\n</span></div></td></tr></tbody></table></div></div></div></td></tr><tr><td><div class=\"nl-Table-day\" layout=\"row\" \nlayou-align=\"start center\"><div class=\"nl-Table-day-hour\" layout=\"row\" layout-align=\"start top\"><div \nclass=\"nl-Table-day-hour-value\">>19</div><span class=\"nl-Table-day-hour-expo\">h</span></div><div \nng-if=\"(actions | filter :filterMessageOver(19)).length == 0\"><span class=\"nl-Table-header-empty\">Vide</span></div><div\n ng-if=\"(actions | filter :filterMessageOver(19)).length > 0\"><div class=\"nl-Table-message\"><table class=\"nl-Table\">\n<tbody><tr ng-repeat=\"message in actions | filter:filterMessageOver(19)\" class=\"nl-Msg\"><td \nng-if=\"message.company || message.contact\"><div class=\"nl-Msg-link-company\" ng-if=\"message.company\"><div \ntranslate=\"GENERAL.COMPANY\"></div>{{message.company.modelPattern}}</div><div class=\"nl-Msg-link-contact\" \nng-if=\"message.contact\"><div translate=\"GENERAL.CONTACT\"></div>{{message.contact.modelPattern}}</div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div></td><td><div class=\"nl-form--receivedMsg--subject\">\n{{message.subject}}</div><div class=\"nl-form--receivedMsg--content\">{{message.content | limitTo: 70}}</div><div \nng-if=\"message.action\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-check\" \nng-class=\"{\'nl-validated\': message.action.actionDone}\" ng-click=\"confirmAction(message.action)\" layout=\"row\" \nlayout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !message.action.actionDone, \'icon-check\' : message.action.actionDone}\"></i></div><div \nclass=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{message.action.libelle}}</div></div></div></td><td><span \nclass=\"nl-Msg-sender-date\">\n{{getDate(message.creationDate) | date:\'dd/MM/yyyy\'}} - {{getDate(message.creationDate) | date:\'HH:mm\'}}</span><div \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-avatar mr-10\"><img class=\"nl-Msg-avatar-img\" \nhttp-src=\"./alternatedocroots/{{message.sender.pictureLocation}}\" \nhas-profile-picture=\"$root.user.pictureLocation != null\"></div><span class=\"nl-Badge\">{{message.sender.fullName}}\n</span></div></td></tr></tbody></table></div></div></div></td></tr></tbody></table></div><div class=\"\" \nng-if=\"!date.day && !date.month && date.year\"><table class=\"nl-Table\"><tr><td ng-repeat=\"month in months\" \nclass=\"nl-Table-header-month\"><p><button class=\"nl-Table-button-simple button-title\" ng-click=\"date.month = month\">\n{{month}}</button></p><span class=\"nl-Table-header-empty\" \nng-if=\"(actions |filter:filterMessageByMonth(month)).length == 0\">Vide</span> <span \nng-if=\"(actions |filter:filterMessageByMonth(month)).length > 0\">\n{{(actions |filter:filterMessageByMonth(month)).length}} actions</span></td></tr></table></div><div class=\"\" \nng-if=\"!date.day && date.month && daysWeek.length == 0\"><table class=\"nl-Table\"><tbody><tr><th \nclass=\"text-center pb-10\">{{\"GENERAL.DAYS.0\" | translate}}</th><th class=\"text-center pb-10\">\n{{\"GENERAL.DAYS.1\" | translate}}</th><th class=\"text-center pb-10\">{{\"GENERAL.DAYS.2\" | translate}}</th><th \nclass=\"text-center pb-10\">{{\"GENERAL.DAYS.3\" | translate}}</th><th class=\"text-center pb-10\">\n{{\"GENERAL.DAYS.4\" | translate}}</th><th class=\"text-center pb-10\">{{\"GENERAL.DAYS.5\" | translate}}</th><th \nclass=\"text-center pb-10\">{{\"GENERAL.DAYS.6\" | translate}}</th></tr><tr ng-if=\"startOfMonthSunday()\"><td class=\"\"></td>\n<td class=\"\"></td><td class=\"\"></td><td class=\"\"></td><td class=\"\"></td><td class=\"\"></td><td \nclass=\"nl-Table-month-day-wrapper\"><button class=\"nl-Table-month-day\">{{getDateMonthCalendar(0,0)}}</button><p \nclass=\"text-center\" \nng-if=\"getDateMonthCalendar(0,0) != \'\' && (actions | filter:filterMessageByDaysInMonth(getDateMonthCalendar(0,0))).length==0\">\n<span class=\"nl-Table-header-empty\">Vide</span></p></td></tr><tr ng-repeat=\"n in [].constructor(5) track by $index\"><td\n class=\"nl-Table-month-day-wrapper\"><button class=\"nl-Table-month-day\" \nng-click=\"date.day = getDateMonthCalendar($index,1);displayDays()\" \nng-class=\"{\'nl-empty\': getDateMonthCalendar($index,1) == \'\'}\">{{getDateMonthCalendar($index,1)}}</button><p \nclass=\"text-center\" \nng-if=\"getDateMonthCalendar($index,1) != \'\' && (actions | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,1))).length==0\">\n<span class=\"nl-Table-header-empty\">Vide</span></p><div class=\"nl-Table-month-rdv\" \nng-repeat=\"message in actions | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,1))\"><span \nclass=\"nl-Badge nl-Badge--primary mb-5\">{{message.action.dateAction | date : \'HH:mm\'}}</span><br><span \nclass=\"nl-Badge\">{{message.action.libelle}}</span></div></td><td class=\"nl-Table-month-day-wrapper\"><button \nclass=\"nl-Table-month-day\" ng-click=\"date.day = getDateMonthCalendar($index,2);displayDays()\" \nng-class=\"{\'nl-empty\': getDateMonthCalendar($index,2) == \'\'}\">{{getDateMonthCalendar($index,2)}}</button><p \nclass=\"text-center\" \nng-if=\"getDateMonthCalendar($index,2) != \'\' && (actions | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,2))).length==0\">\n<span class=\"nl-Table-header-empty\">Vide</span></p><div class=\"nl-Table-month-rdv\" \nng-repeat=\"message in actions | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,2))\"><span \nclass=\"nl-Badge nl-Badge--primary mb-5\">{{message.action.dateAction | date : \'HH:mm\'}}</span><br><span \nclass=\"nl-Badge\">{{message.action.libelle}}</span></div></td><td class=\"nl-Table-month-day-wrapper\"><button \nclass=\"nl-Table-month-day\" ng-click=\"date.day = getDateMonthCalendar($index,3);displayDays()\" \nng-class=\"{\'nl-empty\': getDateMonthCalendar($index,3) == \'\'}\">{{getDateMonthCalendar($index,3)}}</button><p \nclass=\"text-center\" \nng-if=\"getDateMonthCalendar($index,3) != \'\' && (actions | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,3))).length==0\">\n<span class=\"nl-Table-header-empty\">Vide</span></p><div class=\"nl-Table-month-rdv\" \nng-repeat=\"message in actions | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,3))\"><span \nclass=\"nl-Badge nl-Badge--primary mb-5\">{{message.action.dateAction | date : \'HH:mm\'}}</span><br><span \nclass=\"nl-Badge\">{{message.action.libelle}}</span></div></td><td class=\"nl-Table-month-day-wrapper\"><button \nclass=\"nl-Table-month-day\" ng-click=\"date.day = getDateMonthCalendar($index,4);displayDays()\" \nng-class=\"{\'nl-empty\': getDateMonthCalendar($index,4) == \'\'}\">{{getDateMonthCalendar($index,4)}}</button><p \nclass=\"text-center\" \nng-if=\"getDateMonthCalendar($index,4) != \'\' && (actions | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,4))).length==0\">\n<span class=\"nl-Table-header-empty\">Vide</span></p><div class=\"nl-Table-month-rdv\" \nng-repeat=\"message in actions | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,4))\"><span \nclass=\"nl-Badge nl-Badge--primary mb-5\">{{message.action.dateAction | date : \'HH:mm\'}}</span><br><span \nclass=\"nl-Badge\">{{message.action.libelle}}</span></div></td><td class=\"nl-Table-month-day-wrapper\"><button \nclass=\"nl-Table-month-day\" ng-click=\"date.day = getDateMonthCalendar($index,5);displayDays()\" \nng-class=\"{\'nl-empty\': getDateMonthCalendar($index,5) == \'\'}\">{{getDateMonthCalendar($index,5)}}</button><p \nclass=\"text-center\" \nng-if=\"getDateMonthCalendar($index,5) != \'\' && (actions | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,5))).length==0\">\n<span class=\"nl-Table-header-empty\">Vide</span></p><div class=\"nl-Table-month-rdv\" \nng-repeat=\"message in actions | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,5))\"><span \nclass=\"nl-Badge nl-Badge--primary mb-5\">{{message.action.dateAction | date : \'HH:mm\'}}</span><br><span \nclass=\"nl-Badge\">{{message.action.libelle}}</span></div></td><td class=\"nl-Table-month-day-wrapper\"><button \nclass=\"nl-Table-month-day\" ng-click=\"date.day = getDateMonthCalendar($index,6);displayDays()\" \nng-class=\"{\'nl-empty\': getDateMonthCalendar($index,6) == \'\'}\">{{getDateMonthCalendar($index,6)}}</button><p \nclass=\"text-center\" \nng-if=\"getDateMonthCalendar($index,6) != \'\' && (actions | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,6))).length==0\">\n<span class=\"nl-Table-header-empty\">Vide</span></p><div class=\"nl-Table-month-rdv\" \nng-repeat=\"message in actions | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,6))\"><span \nclass=\"nl-Badge nl-Badge--primary mb-5\">{{message.action.dateAction | date : \'HH:mm\'}}</span><br><span \nclass=\"nl-Badge\">{{message.action.libelle}}</span></div></td><td class=\"nl-Table-month-day-wrapper\"><button \nclass=\"nl-Table-month-day\" ng-click=\"date.day = getDateMonthCalendar($index,7);displayDays()\" \nng-class=\"{\'nl-empty\': getDateMonthCalendar($index,7) == \'\'}\">{{getDateMonthCalendar($index,7)}}</button><p \nclass=\"text-center\" \nng-if=\"getDateMonthCalendar($index,7) != \'\' && (actions | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,7))).length==0\">\n<span class=\"nl-Table-header-empty\">Vide</span></p><div class=\"nl-Table-month-rdv\" \nng-repeat=\"message in actions | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,7))\"><span \nclass=\"nl-Badge nl-Badge--primary mb-5\">{{message.action.dateAction | date : \'HH:mm\'}}</span><br><span \nclass=\"nl-Badge\">{{message.action.libelle}}</span></div></td></tr></tbody></table></div><div class=\"\" \nng-if=\"daysWeek.length > 0 && !date.sort\"><table class=\"nl-Table\"><tbody><tr><th class=\"text-center\">\n{{\"GENERAL.DAYS.0\" | translate}}</th><th class=\"text-center\">{{\"GENERAL.DAYS.1\" | translate}}</th><th \nclass=\"text-center\">{{\"GENERAL.DAYS.2\" | translate}}</th><th class=\"text-center\">{{\"GENERAL.DAYS.3\" | translate}}</th>\n<th class=\"text-center\">{{\"GENERAL.DAYS.4\" | translate}}</th><th class=\"text-center\">{{\"GENERAL.DAYS.5\" | translate}}\n</th><th class=\"text-center\">{{\"GENERAL.DAYS.6\" | translate}}</th></tr><tr><td ng-repeat=\"day in daysWeek\"><button \nclass=\"nl-Table-month-day\" href=\"agenda.php?date=2018-11-26&amp;mode=day\" ng-click=\"setDate(day);displayDays()\">\n{{day.date}}</button><p class=\"text-center\" \nng-if=\"(actions | filter:filterMessageByDaysInMonth(day.date)).length == 0\"><span class=\"nl-Table-header-empty\">Vide\n</span></p><div class=\"action_block\" ng-repeat=\"message in actions | filter:filterMessageByDaysInMonth(day.date)\"><span\n class=\"label\">{{getDate(message.action.dateAction) | date : \'HH:mm\'}}</span><br><span class=\"label label-default\">\n{{message.action.libelle}}</span><div class=\"action_channel\">-</div></div></td></tr></tbody></table></div><div \nclass=\"\" ng-if=\"!date.day && !date.month && !date.year\"><table class=\"nl-Table\"><tbody><tr \nng-repeat-start=\"message in actions\"><th class=\"nl-Table-header-date\">\n{{getDate(message.action.dateAction) | date:\'dd/MM/yyyy\'}}</th></tr><tr ng-repeat-end=\"\"><td><div \nclass=\"nl-Table-message\"><table class=\"nl-Table\"><tbody><tr class=\"nl-Msg\"><td \nng-if=\"message.company || message.contact\"><div class=\"nl-Msg-link-company\" ng-if=\"message.company\"><div \ntranslate=\"GENERAL.COMPANY\"></div>{{message.company.modelPattern}}</div><div class=\"nl-Msg-link-contact\" \nng-if=\"message.contact\"><div translate=\"GENERAL.CONTACT\"></div>{{message.contact.modelPattern}}</div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div></td><td><div class=\"nl-form--receivedMsg--subject\">\n{{message.subject}}</div><div class=\"nl-form--receivedMsg--content\">{{message.content | limitTo: 70}}</div><div \nng-if=\"message.action\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-check\" \nng-class=\"{\'nl-validated\': message.action.actionDone}\" ng-click=\"confirmAction(message.action)\" layout=\"row\" \nlayout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !message.action.actionDone, \'icon-check\' : message.action.actionDone}\"></i></div><div \nclass=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{message.action.libelle}}</div></div></div></td><td><span \nclass=\"nl-Msg-sender-date\">\n{{getDate(message.creationDate) | date:\'dd/MM/yyyy\'}} - {{getDate(message.creationDate) | date:\'HH:mm\'}}</span><div \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-avatar mr-10\"><img class=\"nl-Msg-avatar-img\" \nhttp-src=\"./alternatedocroots/{{message.sender.pictureLocation}}\" \nhas-profile-picture=\"$root.user.pictureLocation != null\"></div><span class=\"nl-Badge\">{{message.sender.fullName}}\n</span></div></td></tr></tbody></table></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/media/folders.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"FOLDERS.TITLE\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-input-container>\n<md-select ng-model=\"language.key\" class=\"md-no-underline\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div><div class=\"content\"><div class=\"nl-Block\"><a \nng-click=\"findFolders(language.key);findDocuments()\">/</a> <span ng-repeat=\"folder in thread track by $index\"><a \nng-click=\"goToFolder(folder,true)\">{{folder.name}}</a> {{( thread.length-1 > $index) ? \"/\":\"\"}}</span></div><div \nclass=\"nl-Block mt-30\"><div><md-button md-no-ink class=\"md-raised md-primary md-hue-2\" type=\"button\" \nng-click=\"openAddFile()\"><span translate=\"FOLDERS.UPLOAD_FILE\"></span></md-button><md-button md-no-ink \nclass=\"md-raised md-primary md-hue-2\" type=\"button\" ng-click=\"showFolderForm()\"><span \ntranslate=\"FOLDERS.CREATE_FOLDER\"></span></md-button></div><div class=\"panel-body\" ng-show=\"showForm\"><form \nname=\"formFolderCreation\" class=\"form-horizontal\" role=\"form\" novalidate><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"mt-30 mb-0\"><label>{{\'FOLDERS.NAME\' | translate}} :\n</label><input type=\"text\" ng-model=\"newFolder.name\" name=\"folderName\" aria-label=\"newFolderName\" required><div \nng-messages=\"formFolderCreation.folderName.$error\" role=\"alert\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><div><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"formFolderCreation.$valid && createFolder();\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s24\"></md-icon>Ajouter</md-button></div></div></form></div></div><div \nclass=\"nl-Block mt-10\"><div><div ng-if=\"newFolder.idParent\" ng-click=\"returnParent()\"><md-button \nclass=\"md-primary md-hue-2\" aria-label=\"Dossier\"><md-icon md-font-icon=\"icon-reply\" class=\"nl-listing-item-icon\">\n</md-icon>retour</md-button></div><table class=\"simple list-view\"><tbody><tr ng-repeat=\"folder in folders\" \nng-click=\"goToFolder(folder)\"><td class=\"file-icon\" style=\"width:72px\"><i class=\"icon-folder\"></i></td><td \nng-if=\"!folder.update\">{{folder.name}}</td><td ng-if=\"folder.update\" ng-click=\"$event.stopPropagation();\">\n<md-input-container class=\"mt-10 mb-0 nl-Form-input--noError\"><label>{{\"FOLDERS.NAME\" | translate}}</label><input \ntype=\"text\" ng-model=\"folderNameCopy.name\" required maxlength=\"255\"></md-input-container></td><td><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"$event.stopPropagation();deleteFolder(folder)\" md-no-ink \nclass=\"md-raised md-warn md-hue-2\" aria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}</md-button><md-button \nng-hide=\"folder.update\" md-no-ink ng-click=\"$event.stopPropagation();updateFolder(folder)\" class=\"md-accent md-hue-2\" \naria-label=\"Supprimer\">{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button ng-show=\"folder.update\" md-no-ink \nng-click=\"$event.stopPropagation();updateFolder(folder)\" class=\"md-warn md-hue-2\" aria-label=\"Supprimer\">\n{{\"GENERAL.CANCEL\" | translate}}</md-button><md-button ng-show=\"folder.update\" md-no-ink \nng-click=\"$event.stopPropagation();saveUpdateFolder(folder)\" class=\"md-raised md-primary md-hue-2\" \naria-label=\"Supprimer\" ng-disabled=\"!folderNameCopy.name\">{{\"GENERAL.SAVE\" | translate}}</md-button></div></td></tr><tr\n ng-repeat=\"file in files\" ng-class=\"{\'selected\' : vm.selected === file}\"><td class=\"file-icon\"><i \nclass=\"icon-file-document\"></i></td><td class=\"name\">{{file.originalFileName}}</td><td class=\"type\" show-gt-sm><a \nhref=\"alternatedocroots/{{file.location}}\" target=\"_blank\" ng-if=\"isPicture(file.originalFileName)\"><img \nng-src=\"alternatedocroots/{{file.location}}\" style=\"max-height: 80px;max-width: 200px\"></a></td><td class=\"owner\" \nhide-xs>{{getUrl()}}/alternatedocroots/{{file.location}}</td><td class=\"size\" hide-xs>{{file.size}} Ko</td><td \nclass=\"last-modified\" hide show-gt-md><md-button ng-click=\"$event.stopPropagation();deleteFile(file)\" \nclass=\"nl-listing-item-button md-warn\" aria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}</md-button></td></tr>\n</tbody></table><div class=\"p-16\" ng-show=\"folders.length == 0 && files.length == 0\">\n{{\'FOLDERS.NO_FOLDER\' | translate}}</div></div></div></div></div>");
$templateCache.put("app/main/message/message.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"MESSAGE.TITLE\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"showPopUpMessage()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'MESSAGE.CREATION.NEW\' | translate}}</md-button></div></div><div class=\"content\"><div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>{{\"MESSAGE.BOX.TITLE\" | translate}}</label><md-select \nng-model=\"filter.sender\" aria-label=\"language\" name=\"receiver\" ng-change=\"findAllMessages(true)\"><md-option \nng-value=\"false\">{{\"MESSAGE.BOX.RECEPTION\" | translate}}</md-option><md-option ng-value=\"true\">\n{{\"MESSAGE.BOX.SENT\" | translate}}</md-option><md-option ng-value=\"null\">{{\"MESSAGE.BOX.ALL\" | translate}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>\n{{\"MESSAGE.TYPE.TITLE\" | translate}}</label><md-select ng-model=\"filter.action\" aria-label=\"language\" name=\"receiver\" \nng-change=\"findAllMessages(true)\"><md-option ng-value=\"null\">{{\"MESSAGE.TYPE.ALL\" | translate}}</md-option><md-option \nng-value=\"typeAction.TO_DO\">{{\"MESSAGE.TYPE.TO_DO\" | translate}}</md-option><md-option ng-value=\"typeAction.DONE\">\n{{\"MESSAGE.TYPE.DONE\" | translate}}</md-option><md-option ng-value=\"typeAction.ALL\">\n{{\"MESSAGE.TYPE.ALL_ACTION\" | translate}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>{{\"MESSAGE.CORRESPONDANT\" | translate}}</label><md-select \nmd-on-close=\"filterSelectText = \'\'\" ng-model=\"filter.receiverForm\" aria-label=\"language\" name=\"receiver\" \nmultiple=\"multiple\" ng-change=\"findAllMessages(true)\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"user in users | filterText: filterSelectText\" value=\"{{user}}\">{{user.fullName}}</md-option></md-select>\n</md-input-container></div><div class=\"nl-Block nl-Block--table mt-15\" \ninfinite-scroll-disabled=\"infiniteScrollPrevent\" infinite-scroll=\"findAllMessages()\" \ninfinite-scroll-container=\"\'#content\'\"><div class=\"nl-form--receivedMsg\"><table class=\"simple list-view nl-Table\">\n<thead><th>{{\"MESSAGE.DISPLAY.MESSAGE\" | translate}}</th><th>{{\"MESSAGE.DISPLAY.LINK\" | translate}}</th><th>\n{{\"MESSAGE.DISPLAY.SENDER\" | translate}}</th><th>{{\"MESSAGE.DISPLAY.ACTIONS\" | translate}}</th></thead><tbody><tr \nng-repeat=\"message in messages track by message.id\" class=\"nl-Msg\"><td><div class=\"nl-form--receivedMsg--subject\">\n{{message.subject}}</div><div class=\"nl-form--receivedMsg--content\">{{message.content | limitTo: 70}}</div><div \nng-if=\"message.action\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-check\" \nng-class=\"{\'nl-validated\': message.action.actionDone}\" ng-click=\"confirmAction(message.action)\" layout=\"row\" \nlayout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !message.action.actionDone, \'icon-check\' : message.action.actionDone}\"></i></div><div \nclass=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{message.action.libelle}}</div></div></div></td><td><div \nclass=\"nl-Msg-link-company\" ng-if=\"message.company\"><div translate=\"GENERAL.COMPANY\"></div><a \nhref=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\">{{message.company.modelPattern}}</a></div>\n<div class=\"nl-Msg-link-contact\" ng-if=\"message.contact\"><div translate=\"GENERAL.CONTACT\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n{{message.contact.modelPattern}}</a></div><div ng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" \nng-if=\"field.index != null && field.value\" class=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon \nmd-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s22\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div></td><td><span class=\"nl-Msg-sender-date\">\n{{getDate(message.creationDate) | date:\'dd/MM/yyyy\'}} - {{getDate(message.creationDate) | date:\'HH:mm\'}}</span><div \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-avatar mr-10\"><img class=\"nl-Msg-avatar-img\" \nhttp-src=\"./alternatedocroots/{{message.sender.pictureLocation}}\" \nhas-profile-picture=\"message.sender.pictureLocation != null\"></div><span class=\"nl-Badge\">{{message.sender.fullName}}\n</span></div></td><td><md-button ng-click=\"updateMessage(message)\" class=\"nl-listing-item-button md-accent\" \naria-label=\"Update\">{{\"GENERAL.UPDATE\" | translate}}</md-button></td></tr></tbody></table></div></div></div></div>\n</div>");
$templateCache.put("app/main/models/draw_token.html","<div class=\"page-content container-fluid\"><div class=\"panel panel panel-bordered\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"nl_categories-item-title nl_categories-item-title--first\"><div>\n{{\'SETTINGS.DATABASE.MODELS.TITLE_DRAW_TOKEN\' | translate}}</div></div><div class=\"nl-Block\"><div><div><form \nnovalidate class=\"form-horizontal\" name=\"drawPatternForm\"><div class=\"form-body\"><div ng-show=\"showDrawHelp\" \nclass=\"nl-Models-help\"><help-draw-token-builder help-draw-token-title=\"helpDrawTokenTitle\" \nhelp-draw-token-content=\"helpDrawTokenContent\"></help-draw-token-builder></div><blockquote ng-if=\"tokensModified\" \nclass=\"md-yellow-600-bg pr-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" aria-hidden=\"true\"></md-icon><div class=\"ml-15\">\n{{\'GENERAL.NOT_SAVED\' | translate}}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"saveDrawTokens();\" noo-tooltip tooltip-title=\"Sauvegarder\">\n<md-icon md-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"cancelModifTokens();\" noo-tooltip tooltip-title=\"Annuler\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s18\"></md-icon></md-button></div></blockquote><div layout=\"column\"><md-input-container\n class=\"mv-0\" flex=\"100\"><label class=\"md-no-float md-container-ignore\" translate=\"SETTINGS.DATABASE.MODELS.PATTERN\">\n</label><input ng-disabled=\"true\" type=\"text\" ng-value=\"calculatedPattern()\" readonly=\"readonly\"></md-input-container>\n<div ng-repeat=\"drawToken in drawTokenList | orderBy:\'index\'\" layout=\"row\"><md-input-container class=\"mt-18 mb-0\" \nflex=\"33\"><label translate=\"SETTINGS.DATABASE.MODELS.PREFIX\"></label><input type=\"text\" ng-change=\"changeElement();\" \nng-trim=\"false\" ng-model=\"drawToken.prefix\"></md-input-container><md-input-container class=\"mt-18 mb-0\" flex=\"33\">\n<label translate=\"SETTINGS.DATABASE.MODELS.FIELD\"></label><md-select md-on-close=\"filterSelectText = \'\'\" \nng-change=\"changeElement();\" ng-model=\"drawToken.field\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-select-header>\n<section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"field in champsListRequired | filterText: filterSelectText | simpleTypeRequiredFilter | orderBy: \'libelle\' track by field.id\" \nng-value=\"field\">{{field.libelle}}</md-option></md-select></md-input-container><md-input-container class=\"mt-18 mb-0\" \nflex=\"33\"><label class=\"\" translate=\"SETTINGS.DATABASE.MODELS.SUFFIX\"></label><input type=\"text\" class=\"\" \nng-change=\"changeElement();\" ng-trim=\"false\" ng-model=\"drawToken.suffix\"></md-input-container><div class=\"\"><md-button \ntype=\"button\" class=\"md-raised md-warn md-hue-2\" ng-click=\"deleteToken($index);\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s18\"></md-icon>{{\'GENERAL.DELETE\' | translate}}</md-button></div></div><div class=\"form-group row\"><div>\n<md-button md-no-ink type=\"button\" class=\"md-raised md-primary md-hue-2\" ng-click=\"addPatternToken();\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></div></form>\n</div></div></div></div></div>");
$templateCache.put("app/main/models/fields_models.html","<div id=\"researchPageCreation\" class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.TITLE\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"content\"><div class=\"content\"><div class=\"nl-Block\"><div><div><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\"><span \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.ADD_FIELD_TO_FILTER_ENGINE\"></span></div></div><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><form name=\"researchPageCreationFilterForm\" role=\"form\" \nnovalidate><div layout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"\"><md-select \nname=\"newFieldToFilter\" id=\"newFieldToFilter\" ng-model=\"fieldToAdd\" placeholder=\"\"><md-option ng-value=\"field\" \nng-repeat=\"field in fieldsAvalaible\"><span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span \nng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-select><div \nng-messages=\"researchPageCreationFilterForm.newFieldToFilter.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nObligatoire.</span></div></div></md-input-container><div><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"addField();\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></form></div></div></div></div></div><div class=\"nl-Block mt-15\">\n<div ng-repeat=\"display in displaysModels | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><h3 class=\"\">{{display.fieldModel.libelle}}</h3></div><md-input-container \nclass=\"\" flex=\"10\"><md-select ng-change=\"setIcon(display)\" name=\"iconFieldContact\" id=\"iconFieldContact\" \nng-model=\"display.icon\" placeholder=\"\"><md-option ng-value=\"undefined\">Aucune</md-option><md-option \nng-value=\"icon.name\" ng-repeat=\"icon in DISPLAY_MODELS_ICONS\"><md-icon md-font-icon=\"{{icon.value}}\" class=\"s22\">\n</md-icon></md-option></md-select></md-input-container><div class=\"panel-actions panel-actions-keep\" layout=\"row\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"removeField(display);\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div \nclass=\"ml-15\" layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"goUp(display)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"!(display.index > 0 && displaysModels.length > 1)\"><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button ng-click=\"goDown(display)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"(display.index + 1 == displaysModels.length)\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div></div></div>\n</div></div>");
$templateCache.put("app/main/models/help_draw_token.html","<div class=\"row\"><div class=\"example m-t-0 m-x-0\"><div class=\"ribbon\"><span class=\"ribbon-inner\">{{helpDrawTokenTitle}}\n</span></div><h4>But de l\'affichage</h4><p>{{helpDrawTokenContent}}</p><br><h4>Principe de fonctionnement</h4><p>\nPar défault l\'objet est représenté par la liste de toutes ses valeurs séparées par des \",\" (CHAMPS1,CHAMPS2,CHAMPS3)\n</p><p>On peut modifier se comportement en renseignant un pattern d\'affichage. Pour se faire il faut selectionner\n<md-button type=\"button\" class=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-plus\" class=\"s24\"></md-icon></md-button>.\n</p><p>\nUn block en 3 parties apparait permettant de configurer l\'affichage. Pour afficher par exemple un utilisateur de la forme : PRENOM (EMAIL) il faudra configurer le pattern de cette façon :\n</p><br><form class=\"form-horizontal\"><div class=\"form-group row\"><label class=\"col-xs-12 col-md-3 form-control-label\">\nPattern d\'affichage</label><div class=\"col-md-5 col-xs-12\"><input type=\"text\" class=\"form-control form-control-sm\" \nvalue=\"PRENOM (MAIL)\" readonly=\"readonly\"></div></div><div class=\"form-group row\"><label \nclass=\"col-xs-12 col-md-3 form-control-label\">Prefix</label><div class=\"col-md-5 col-xs-12\"><input type=\"text\" \nclass=\"form-control form-control-sm\" readonly=\"readonly\"></div></div><div class=\"form-group row\"><label \nclass=\"col-xs-12 col-md-3 form-control-label\">Champs</label><div class=\"col-md-5 col-xs-12\"><select \nclass=\"form-control form-control-sm\" disabled=\"disabled\"><option>PRENOM</option></select></div></div><div \nclass=\"form-group row\"><label class=\"col-xs-12 col-md-3 form-control-label\">Suffix</label><div \nclass=\"col-md-5 col-xs-12\"><input type=\"text\" class=\"form-control form-control-sm\" readonly=\"readonly\"></div></div><div\n class=\"form-group row\"><label class=\"col-xs-12 col-md-3 form-control-label\">--</label></div><div \nclass=\"form-group row\"><label class=\"col-xs-12 col-md-3 form-control-label\">Prefix</label><div \nclass=\"col-md-5 col-xs-12\"><input type=\"text\" class=\"form-control form-control-sm\" value=\"(\" readonly=\"readonly\"></div>\n</div><div class=\"form-group row\"><label class=\"col-xs-12 col-md-3 form-control-label\">Champs</label><div \nclass=\"col-md-5 col-xs-12\"><select class=\"form-control form-control-sm\" disabled=\"disabled\"><option>MAIL</option>\n</select></div></div><div class=\"form-group row\"><label class=\"col-xs-12 col-md-3 form-control-label\">Suffix</label>\n<div class=\"col-md-5 col-xs-12\"><input type=\"text\" class=\"form-control form-control-sm\" value=\")\" readonly=\"readonly\">\n</div></div></form></div></div>");
$templateCache.put("app/main/models/help_model.html","<div class=\"row\"><div class=\"example m-t-0 m-x-0\"><div class=\"ribbon\"><span class=\"ribbon-inner\">{{helpModelTitle}}\n</span></div><h4>But du modèle</h4><p>{{helpModelContent}}</p><p>\nAfin de préciser au mieux le modèle, vous avez le choix entre 4 types d\'attributs :</p><p></p><blockquote \nclass=\"blockquote custom-blockquote blockquote-info\">\nSTRING - Représente une réponse au format texte de moins de 255 charactères.<br>\nLONG_STRING - Représente une réponse au format texte pouvant dépasser 255 charactères.<br>\nNUMBER - Représente un nombre positif ou négatif.<br>DATE - Représente une date.<br>\nBOOLEAN - Représente un cas oui/non, cela sera affiché comme une case à cocher à l\'utilisateur.</blockquote><p></p><h4>\nPrincipe de fonctionnement</h4><p>\nPour commencer à gérer les champs, vous devez entrer le libellé de votre champs et cliquer sur<md-button type=\"button\" \nclass=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-help\" class=\"s24\"></md-icon></md-button>.</p><p>Les boutons\n<md-button type=\"button\" class=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s24\"></md-icon>\n</md-button>et<md-button type=\"button\" class=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s24\">\n</md-icon></md-button>vous permettrons de réordonner les champs.</p><p>\nPour modifier un champs, commencer par activer la modification avec le bouton<md-button type=\"button\" \nclass=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-pencil\" class=\"s24\"></md-icon></md-button>\n. Il faut ensuite modifier le libellé du champs et/ou son type et valider la modification en cliquant sur<md-button \ntype=\"button\" class=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-content-save\" class=\"s24\"></md-icon></md-button>.</p>\n<p>Pour supprimer un champs, il faut cliquer sur<md-button type=\"button\" class=\"md-fab md-mini\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s24\"></md-icon></md-button>\n. ATTENTION toutes les informations liées à ce champs seront supprimées!</p></div></div>");
$templateCache.put("app/main/models/infos_category.html","<div class=\"nl_categories-thread\" ng-if=\"category.values.length || category.subCategories.length\" layout=\"row\" \nlayout-wrap><div class=\"nl_categories-item item-l{{level+1}} flex-100\" layout-wrap \nng-show=\"(parent == null || parent != null && !parent.defaultClosed)\"><div class=\"\" \nng-class=\"level >0 ? \'nl_categories-item-subtitle\':\'nl_categories-item-title\'\" layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"category.defaultClosed = !category.defaultClosed\"><div>{{category.name}}\n</div><button ng-if=\"edition\" type=\"button\" class=\"ml-10\"><md-icon md-font-icon=\"icon-eye\" \nng-if=\"category.defaultClosed\"></md-icon><md-icon md-font-icon=\"icon-eye-off\" ng-if=\"!category.defaultClosed\">\n</md-icon></button></div><div layout=\"row\" layout-wrap ng-show=\"(!edition || !category.defaultClosed)\"><div \nng-repeat=\"valueField in filtered = (category.values | filter : { fieldDisplayable : \'true\', hide: false } | onlyRequired: !edition | orderBy: \'index\') track by valueField.id\" \nng-class=\"edition ? \'{{\'flex-\'+valueField.size}}\' : \'flex-100\'\"><noo-input model=\"abstractModel\" sub-type=\"subTypeId\" \nform-name=\"formName\" edition=\"edition\" ng-model=\"valueField\" index=\"{{$index}}\" content=\"{{valueField.typeChamps}}\" \nbig-display-area=\"valueField.bigDisplayArea\" model-type=\"modelType\"></noo-input><div class=\"clearfix visible-lg-block\" \nng-if=\"($index+1) % 3 === 0 && $index !== 0\"></div><div class=\"clearfix visible-md-block\" \nng-if=\"($index+1) % 3 === 0 && $index !== 0\"></div><div class=\"clearfix visible-sm-block\" \nng-if=\"($index+1) % 2 === 0 && $index !== 0\"></div></div></div></div><noo-infos-category model=\"abstractModel\" \nng-if=\"edition\" ng-class=\"edition ? \'{{\'flex-\' + subCategory.size}}\' : \'flex-100\'\" model-type=\"modelType\" \nsub-type=\"subTypeId\" edition=\"edition\" form-name=\"formName\" ng-model=\"subCategory\" parent=\"category\" level=\"nextLevel\" \nng-repeat=\"subCategory in category.subCategories | orderBy: \'index\' track by subCategory.id\"></noo-infos-category>\n<noo-infos-category model=\"abstractModel\" ng-if=\"!edition\" \nng-class=\"edition ? \'{{\'flex-\' + subCategory.size}}\' : \'flex-100\'\" model-type=\"modelType\" sub-type=\"subTypeId\" \nedition=\"edition\" form-name=\"formName\" ng-model=\"subCategory\" parent=\"category\" level=\"nextLevel\" \nng-repeat=\"subCategory in category.subCategories | filter : { required: true } | orderBy: \'index\' track by subCategory.id\">\n</noo-infos-category></div>");
$templateCache.put("app/main/models/infos_model.html","<div><div ng-show=\"edition && modelType !== \'LOGISTIC_MODEL\' || (!edition && modelType === \'COMPANY_MODEL\')\" \nclass=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"typesShowed = !typesShowed\"><div>{{\'GENERAL.SETTINGS\' | translate}}</div><button type=\"button\" class=\"ml-10\">\n<md-icon md-font-icon=\"icon-eye\" ng-if=\"!typesShowed\"></md-icon><md-icon md-font-icon=\"icon-eye-off\" \nng-if=\"typesShowed\"></md-icon></button></div><div ng-show=\"typesShowed\"><div layout=\"row\" \nng-if=\"modelType === \'COMPANY_MODEL\'\"><md-input-container class=\"m-0\"><md-select \nmd-on-close=\"filterSiteSelectText = \'\'\" ng-model=\"model.sites\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nmultiple=\"multiple\" ng-change=\"edition && updateSite()\"><md-select-header><section><input force-select-focus \ntype=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSiteSelectText\"></section></md-select-header>\n<md-option ng-repeat=\"site in sites | filterText: filterSiteSelectText | orderBy: \'name\' track by site.id\" \nng-value=\"site\">{{ site.name }}</md-option></md-select><label translate=\"SITES_MANAGEMENT.SITES.TITLES\"></label>\n</md-input-container></div><div layout=\"row\" ng-if=\"modelType === \'COMPANY_MODEL\'\"><md-input-container class=\"m-0\">\n<md-select md-on-close=\"filterSelectText = \'\'\" ng-model=\"model.associations\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nmultiple=\"multiple\" ng-change=\"edition && updateAssociation()\"><md-select-header><section><input force-select-focus \ntype=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText\"></section></md-select-header>\n<md-option \nng-repeat=\"association in associations | filterText: filterSelectText | orderBy: \'name\' track by association.id\" \nng-value=\"association\">{{ association.name }}</md-option></md-select><label translate=\"ASSOCIATIONS.TITLE\"></label>\n</md-input-container></div><div layout=\"row\" ng-if=\"modelType === \'INSCRIPTION_MODEL\'\"><md-input-container class=\"m-0\">\n<md-select ng-model=\"model.subCategory\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"edition && updateSubCategory()\"><md-option \nng-repeat=\"sub in subCategories | orderBy: \'index\' track by sub.id\" ng-value=\"sub\">{{ sub.name }}</md-option>\n</md-select><label translate=\"INSCRIPTION_SUB_CATEGORY.TITLE\"></label></md-input-container><md-input-container \nclass=\"m-0\"><md-select md-on-close=\"filterInscriptionStatus = \'\'\" ng-model=\"model.inscriptionStatus\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"edition && updateInscriptionStatus()\"><md-select-header><section>\n<input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterInscriptionStatus\">\n</section></md-select-header><md-option \nng-repeat=\"status in inscriptionStatuses | filterText: filterInscriptionStatus | orderBy: \'index\' track by status.id\" \nng-value=\"status\">{{ status.name }}</md-option></md-select><label translate=\"INSCRIPTION_STATUS.TITLE\"></label>\n</md-input-container></div><div layout=\"row\"><div style=\"display: flex; flex-direction: row; flex-wrap: wrap\">\n<md-input-container style=\"flex: 1 0 33%\" class=\"m-0\" ng-repeat=\"type in subTypes | orderBy: \'index\' track by $index\">\n<md-switch class=\"md-primary m-0\" ng-model=\"model[\'type_\' + type.id]\" ng-change=\"updateSubTypes(type, true)\">\n{{type.name}}</md-switch></md-input-container></div><md-input-container class=\"m-0\" \nng-if=\"edition && modelType !== \'INSCRIPTION_MODEL\' && modelType !== \'LOGISTIC_MODEL\'\"><md-switch \nclass=\"md-primary m-0\" ng-model=\"model.activate\" ng-change=\"updateActive()\">{{\'GENERAL.ACTIVE\' | translate}}\n</md-switch></md-input-container><md-input-container class=\"m-0\" \nng-if=\"edition && modelType !== \'INSCRIPTION_MODEL\' && modelType !== \'LOGISTIC_MODEL\'\"><md-switch \nclass=\"md-primary m-0\" ng-model=\"model.checked\" ng-change=\"updateChecked()\">{{\'GENERAL.CHECKED\' | translate}}\n</md-switch></md-input-container></div></div><noo-infos-category model=\"model\" ng-if=\"edition\" form-name=\"formName\" \nng-model=\"category\" level=\"firstLevel\" edition=\"edition\" \nng-repeat=\"category in categories | orderBy: \'index\' track by category.id\" sub-type=\"subTypeId\" model-type=\"modelType\">\n</noo-infos-category><noo-infos-category model=\"model\" ng-if=\"!edition\" form-name=\"formName\" ng-model=\"category\" \nlevel=\"firstLevel\" edition=\"edition\" \nng-repeat=\"category in categories | filter : { required: true } | orderBy: \'index\' track by category.id\" \nsub-type=\"subTypeId\" model-type=\"modelType\"></noo-infos-category></div>");
$templateCache.put("app/main/models/input.html","<div ng-form=\"cellForm\" ng-switch=\"content\"><md-input-container class=\"nl-Input-container\" ng-switch-when=\"STRING\" \nng-class=\"\"><label>{{model.libelle}}</label><input ng-required=\"model.required\" ng-model=\"model.value\" \nid=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" type=\"text\" class=\"\" ng-disabled=\"!(model.fieldEditable)\" \nng-model-options=\"{ updateOn: \'blur\' }\"><div ng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" \ntranslate=\"GENERAL.REQUIRED\"></span></div></md-input-container><md-input-container class=\"nl-Input-container\" \nng-switch-when=\"DATE\"><label class=\"floating-label textarea-label\" for=\"genericField_{{model.id+ \'_\'+index}} \">\n{{model.libelle}}</label><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"model.dateTime\" id=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" \nng-disabled=\"!model.fieldEditable\" ng-required=\"model.required\"></md-datepicker></md-input-container>\n<md-input-container class=\"nl-Input-container\" ng-switch-when=\"URL\" ng-class=\"\"><label>{{model.libelle}}</label><input \nng-required=\"model.required\" ng-model=\"model.value\" id=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" \ntype=\"text\" class=\"\" ng-disabled=\"!(model.fieldEditable)\" ng-model-options=\"{ updateOn: \'blur\' }\"><div \nng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span> <span \nng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div></md-input-container><md-input-container \nclass=\"nl-Input-container\" ng-switch-when=\"EMAIL\" ng-class=\"\"><label>{{model.libelle}}</label><input \nng-required=\"model.required\" ng-model=\"model.value\" id=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" \ntype=\"text\" class=\"\" ng-disabled=\"!(model.fieldEditable)\" ng-model-options=\"{ updateOn: \'blur\' }\"><div \nng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span> <span \nng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div></md-input-container><md-input-container \nclass=\"nl-Input-container\" ng-switch-when=\"INTEGER\"><label>{{model.libelle}}</label><input string-to-number \nng-required=\"model.required\" ng-model=\"model.value\" id=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" \ntype=\"number\" class=\"\" ng-disabled=\"!(model.fieldEditable)\" step=\"1\" ng-pattern=\"/^[0-9]\\d*$/\" \nng-model-options=\"{ updateOn: \'blur\' }\"><div ng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" \ntranslate=\"GENERAL.REQUIRED\"></span> <span ng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div>\n</md-input-container><md-input-container ng-switch-when=\"NUMBER\"><label>{{model.libelle}}</label><input \nstring-to-number ng-required=\"model.required\" ng-model=\"model.value\" id=\"genericField_{{model.id+\'_\'+index}}\" \nname=\"genericField\" type=\"number\" class=\"\" ng-disabled=\"!(model.fieldEditable)\" step=\"1\" \nng-model-options=\"{ updateOn: \'blur\' }\"><div ng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" \ntranslate=\"GENERAL.REQUIRED\"></span> <span ng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div>\n</md-input-container><md-input-container ng-switch-when=\"LONG_STRING\"><label class=\"floating-label textarea-label\">\n{{model.libelle}}</label><textarea md-detect-hidden ng-required=\"model.required\" ng-model=\"model.value\" \nid=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" class=\"\" ng-disabled=\"!(model.fieldEditable)\" rows=\"3\" \nng-model-options=\"{ updateOn: \'blur\' }\"></textarea><div ng-messages=\"cellForm.genericField.$error\"><span \nng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span></div></md-input-container><div ng-switch-when=\"RICH_TEXT\" \nclass=\"nl_Trix\"><label class=\"nl_Trix-label\">{{model.libelle}}</label><ng-quill-editor ng-required=\"model.required\" \nng-disabled=\"!(model.fieldEditable)\" angular-trix ng-model=\"model.value\" name=\"genericField\" \nng-model-options=\"{ updateOn: \'blur\' }\"></ng-quill-editor></div><md-input-container ng-switch-when=\"BOOLEAN\"><md-switch\n id=\"genericField_{{model.id+ \'_\'+index}}\" ng-disabled=\"!(model.fieldEditable)\" ng-model=\"model.value\" \naria-label=\"Switch 2\" class=\"md-primary\" name=\"genericField\" ng-model-options=\"{ updateOn: \'blur\' }\">{{model.libelle}}\n</md-switch><div ng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\">\n</span></div></md-input-container><md-input-container ng-switch-when=\"LIST_SELECT\"><md-select md-on-open=\"\" \nmd-on-close=\"filterSelectText = \'\'\" id=\"genericField_{{model.id+ \'_\'+index}} \" name=\"genericField \" \nng-required=\"model.required \" ng-disabled=\"!(model.fieldEditable) \" ng-model=\"model.value\" \nng-model-options=\"{\'trackBy\': \'$value.id\'}\" ng-style=\"model.value.color != null ?{\'color\': model.value.color} : {}\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"event.stopPropagation()\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"option in model.listFieldsDTO | filterText: filterSelectText | orderBy : \'index\' track by option.id\" \nng-value=\"option\" ng-style=\"option.color != null ?{\'color\': option.color} : {}\">{{option.value}}</md-option>\n</md-select><label>{{model.libelle}}</label><div ng-messages=\"cellForm.genericField.$error\"><span \nng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span></div></md-input-container><md-input-container \nng-switch-when=\"MULTIPLE_SELECT\"><md-select md-on-open=\"\" md-on-close=\"filterSelectText = \'\'\" \nid=\"genericField_{{model.id+ \'_\'+index}} \" name=\"genericField \" ng-required=\"model.required \" \nng-disabled=\"!(model.fieldEditable) \" ng-model=\"model.values \" ng-model-options=\"{\'trackBy\': \'$value.id\'}\" \nmultiple=\"multiple\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"event.stopPropagation()\" ng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"option in model.selectableObject | filterText: filterSelectText | orderBy: \'index\' track by option.id\" \nng-value=\"option\">{{option.libelle != null ? option.libelle : option.value}}</md-option></md-select><label>\n{{model.libelle}}</label><div ng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" \ntranslate=\"GENERAL.REQUIRED\"></span></div></md-input-container><div class=\"nl-info-block-list-img animated fadeIn\" \nng-switch-when=\"IMAGE\"><label for=\"genericField_{{model.id+\'_\'+index}}\" style=\"color: rgba(0,0,0,0.38)\">{{field.name}} \n<span ng-if=\"required\" style=\"color:rgb(213,0,0)\">*</span></label><dropify-directive \nid=\"genericField_file_{{model.id+ \'_\'+model.index}}\" filesave=\"photo.uploadFile\" ng-model=\"model\"></div>\n<md-input-container ng-switch-when=\"FILE\"><label>{{model.libelle}}</label><input type=\"file\" class=\"nl_form--file\" \nng-model=\"model.value\" id=\"genericField_file_{{model.id+ \'_\'+model.index}}\" name=\"genericField\"> <button type=\"button\" \nng-click=\"download()\" class=\"md-fab md-mini md-button\" ng-if=\"model.location != null\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon></button></md-input-container><md-input-container ng-switch-default><label>\n{{model.libelle}}</label><input ng-model=\"model.value \" id=\"genericField_{{model.id+ \'_\'+index}} \" \nname=\"genericField \" type=\"text \" class=\"\" ng-disabled=\"!(model.fieldEditable) \" \nng-model-options=\"{ updateOn: \'blur\' }\"></md-input-container></div>");
$templateCache.put("app/main/models/model.html","<div class=\"mb-15\"><form class=\"form-horizontal\" name=\"updateCategoryForm\" role=\"form\" novalidate><div \nng-repeat=\"category in categories | orderBy:\'index\' track by category.id\" class=\"nl-Block\" ng-form=\"categoryForm\"><div \nng-init=\"category.show = false; category.active = false; !!category.subCategories ? \'\' : category.subCategories = [];\">\n<div layout=\"row\" layout-align=\"space-between center\"><div><div layout=\"row\" layout-align=\"start center\">\n<md-input-container class=\"mt-25 mb-0\" flex=\"noshrink\"><input ng-disabled=\"!category.active\" type=\"text\" \nng-model=\"category.name\" name=\"name\" maxlength=\"255\" required><div ng-messages=\"categoryForm.name.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"ml-25 mt-0 mb-0\" ng-if=\"level > 0\" flex=\"noshrink\"><label>\n{{\'SETTINGS.DATABASE.MODELS.CATEGORY_SIZE\' | translate}}</label><md-select ng-disabled=\"!category.active\" \nng-model=\"category.size\"><md-option ng-value=\"10\">10%</md-option><md-option ng-value=\"15\">15%</md-option><md-option \nng-value=\"20\">20%</md-option><md-option ng-value=\"25\">25%</md-option><md-option ng-value=\"33\">33%</md-option><md-option\n ng-value=\"50\">50%</md-option><md-option ng-value=\"66\">66%</md-option><md-option ng-value=\"75\">75%</md-option>\n<md-option ng-value=\"100\">100%</md-option></md-select></md-input-container></div></div><div><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"\" \nng-if=\"types != null\" flex=\"auto\"><label translate=\"SETTINGS.DATABASE.TYPES.TITLE_PAGE\"></label><md-select \nmd-on-close=\"filterSelectText = \'\'\" ng-disabled=\"!category.active\" ng-model=\"category.subTypes\" \nng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"multiple\"><md-select-header><section><input force-select-focus \ntype=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText\"></section></md-select-header>\n<md-option ng-repeat=\"type in types | filterText: filterSelectText\" ng-value=\"type\">{{type.name}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-switch \nng-disabled=\"!category.active\" ng-model=\"category.defaultClosed\" class=\"ml-15 md-primary md-hue-2\" \naria-label=\"default closed\">{{\'SETTINGS.DATABASE.MODELS.DEFAULT_CLOSED\' | translate}}</md-switch></div><div \nclass=\"ml-25\" layout=\"row\" layout-align=\"start center\"><div><md-button type=\"button\" \nclass=\"md-fab md-mini md-accent md-hue-1\" ng-click=\"category.show = !category.show\"><md-icon ng-show=\"category.show\" \nmd-font-icon=\"icon-eye-off\" class=\"s18\"></md-icon><md-icon ng-hide=\"category.show\" md-font-icon=\"icon-eye\" class=\"s18\">\n</md-icon></md-button></div><div ng-if=\"category.active\"><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"updateCategory(category)\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button></div><div ng-if=\"!category.active\"><md-button \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"category.active = true;\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button></div><div><md-button type=\"button\" \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"removeCategory($index, category);\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button></div><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"button\" ng-disabled=\"!(category.index > 1)\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"upCategory(category)\"><md-icon md-font-icon=\"icon-arrow-up\" \nclass=\"s18\"></md-icon></md-button><md-button type=\"button\" ng-disabled=\"!(category.index != categories.length)\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"downCategory(category)\"><md-icon md-font-icon=\"icon-arrow-down\" \nclass=\"s18\"></md-icon></md-button></div></div></div></div></div><form class=\"form-horizontal\" role=\"form\" \nname=\"champsForm\" novalidate><div class=\"nl-Models-details\" ng-show=\"category.show\"><div class=\"row\" \nng-repeat=\"champs in category.fields | orderBy:\'index\'\" \nng-init=\"champs.idCategory = category.id; !!champs.listFieldsDTO ? \'\' : champs.listFieldsDTO = [];\" \nng-form=\"updateChampsForm\"><div class=\"form-group\" layout=\"row\"><md-input-container flex=\"auto\" \nclass=\"nl-Form-container--auto nl-container--input\"><div>#{{champs.id}}</div></md-input-container><md-input-container \nflex=\"auto\" class=\"nl-Form-container--auto nl-container--switch\"><md-switch \nng-change=\"activateChamps(champs.id,champs.activated)\" ng-model=\"champs.activated\" aria-label=\"Switch 2\" \nclass=\"md-primary\" name=\"activated\"></md-switch></md-input-container><md-input-container flex=\"auto\"><label>\n{{\'SETTINGS.DATABASE.MODELS.FIELD\' | translate}} {{champs.index}}</label><input class=\"\" ng-disabled=\"!champs.active\" \nname=\"libelle\" type=\"text\" ng-model=\"champs.libelle\" maxlength=\"255\" required><div \nng-messages=\"updateChampsForm.libelle.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container><md-input-container class=\"ml-15\" flex=\"10\"><label>\n{{\'SETTINGS.DATABASE.MODELS.FIELD_SIZE\' | translate}}</label><md-select ng-disabled=\"!champs.active\" \nng-model=\"champs.size\"><md-option ng-value=\"10\">10%</md-option><md-option ng-value=\"15\">15%</md-option><md-option \nng-value=\"20\">20%</md-option><md-option ng-value=\"25\">25%</md-option><md-option ng-value=\"33\">33%</md-option><md-option\n ng-value=\"50\">50%</md-option><md-option ng-value=\"66\">66%</md-option><md-option ng-value=\"75\">75%</md-option>\n<md-option ng-value=\"100\">100%</md-option></md-select></md-input-container><md-input-container class=\"ml-15\" \nflex=\"auto\"><label translate=\"SETTINGS.DATABASE.MODELS.FIELD_TYPE\"></label><md-select ng-disabled=\"!champs.active\" \nng-model=\"champs.typeChamps\"><md-option ng-repeat=\"enumType in enumTypes\" ng-value=\"enumType.type\">\n{{\'SETTINGS.DATABASE.TYPES.\'+enumType.texte | translate}}</md-option></md-select></md-input-container>\n<md-input-container class=\"ml-15\" ng-if=\"types != null\" flex=\"auto\"><label \ntranslate=\"SETTINGS.DATABASE.TYPES.TITLE_PAGE\"></label><md-select md-on-close=\"filterSelectText = \'\'\" \nng-disabled=\"!champs.active\" ng-model=\"champs.subTypes\" ng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"multiple\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"type in types | filterText: filterSelectText\" ng-value=\"type\">{{type.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"ml-15\" flex=\"10\"><md-checkbox \nid=\"fieldRequiredInputCheckbox-{{$index}}\" class=\"md-primary md-hue-2\" value=\"true\" ng-disabled=\"!champs.active\" \nng-model=\"champs.required\">{{\'GENERAL.REQUIRED\' | translate}}</md-checkbox></md-input-container><md-input-container \nclass=\"ml-15\" flex=\"10\"><md-checkbox id=\"fieldProfilePictureInputCheckbox-{{$index}}\" class=\"md-primary md-hue-2\" \nng-disabled=\"!champs.active\" value=\"true\" ng-if=\"champs.typeChamps === \'IMAGE\'\" ng-model=\"champs.profilePicture\">\n{{\'SETTINGS.DATABASE.MODELS.PRINCIPAL_PICTURE\' | translate}}</md-checkbox></md-input-container><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"cancelFieldUpdating(champs.id, category.fields);\" ng-if=\"champs.active\" \ntype=\"button\" class=\"md-fab md-mini md-accent md-hue-1\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon>\n</md-button><md-button ng-click=\"updateChamps(champs, updateChampsForm)\" ng-if=\"champs.active\" \nclass=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"((champs.typeChamps == \'LIST\' || champs.typeChamps == \'MULTIPLE_SELECTION\') && (!champs.libelle || champs.listFieldsDTO.length<2)) || (champs.typeChamps != \'LIST\' && !champs.libelle)\">\n<md-icon md-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button><md-button ng-if=\"!champs.active\" \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"enabledFieldUpdating(champs);\" noo-tooltip \ntooltip-title=\"Modifier ce champ\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\" class=\"ml-15\"><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"openMoveChamps(category, champs)\"><md-icon \nmd-font-icon=\"icon-cursor-move\" class=\"s18\"></md-icon></md-button><md-button ng-if=\"champs.index > 1\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"upChamps(category, champs)\" noo-tooltip \ntooltip-title=\"Monter d\'un rang\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button \nng-if=\"champs.index != category.fields.length\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"downChamps(category, champs)\" noo-tooltip tooltip-title=\"Descendre d\'un rang\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div><div \nclass=\"form-group offset-md-2 row\" \nng-if=\"(champs.typeChamps == \'LIST_SELECT\' || champs.typeChamps == \'MULTIPLE_SELECT\') && champs.active\"><div \nclass=\"col-xs-12\" ng-class=\"!!enumSubTypes ? \'col-md-7\' : \'col-md-5\'\"><div class=\"panel panel-line\" \nng-class=\"champs.listFieldsDTO.length < 2 ? \'panel-danger\' : \'panel-success\'\"><div class=\"panel-heading\"><h3 \nng-class=\"{\'panel-title\' : champs.listFieldsDTO.length < 2}\"><span ng-if=\"champs.listFieldsDTO.length < 2\">\nAu moins deux valeurs sont requises pour ce type de champs.</span></h3></div><div class=\"panel-body\"><div \nng-repeat=\"listFieldsDTOItem in champs.listFieldsDTO | orderBy:\'index\'\"><div layout=\"row\"><md-input-container \nclass=\"nl-Input-container\" flex=\"20\"><label>Valeur {{listFieldsDTOItem.index}} #{{listFieldsDTOItem.id}}</label><input \nclass=\"\" type=\"text\" ng-model=\"listFieldsDTOItem.value\" name=\"listFieldsDTOItem{{$index}}\" maxlength=\"255\">\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"20\"><label>\n{{\'SETTINGS.DATABASE.MODELS.COLOR\' | translate}} {{listFieldsDTOItem.index}}</label><input class=\"\" \npattern=\"^#+([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$\" type=\"text\" ng-model=\"listFieldsDTOItem.color\" \nname=\"listFieldsDTOColor{{$index}}\"><div ng-messages=\"champsForm[\'listFieldsDTOColor\'+$index].$error\"><div \nng-message=\"pattern\" translate=\"GENERAL.INVALID_HEX\"></div></div></md-input-container><div layout=\"row\" flex=\"60\">\n<md-button type=\"button\" class=\"md-fab md-mini\" \nng-click=\"removeItemFromFieldListType(listFieldsDTOItem, champs.listFieldsDTO)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s18\"></md-icon></md-button><md-button ng-if=\"listFieldsDTOItem.index > 1\" type=\"button\" class=\"md-fab md-mini\" \nng-click=\"upFieldListTypeItem(listFieldsDTOItem, champs.listFieldsDTO)\" noo-tooltip tooltip-title=\"Monter d\'un rang\">\n<md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button \nng-if=\"listFieldsDTOItem.index != champs.listFieldsDTO.length\" type=\"button\" class=\"md-fab md-mini\" \nng-click=\"downFieldListTypeItem(listFieldsDTOItem, champs.listFieldsDTO)\"><md-icon md-font-icon=\"icon-arrow-down\" \nclass=\"s18\"></md-icon></md-button></div></div></div><div layout=\"row\" \nng-init=\'this[\"_newItemForUpdating\"+this.champs.index] = {}\'><md-input-container class=\"nl-Input-container\" flex=\"20\">\n<label>Valeur</label><input class=\"\" type=\"text\" ng-model=\'this[\"_newItemForUpdating\"+this.champs.index].value\' \nmaxlength=\"255\"></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"20\"><label>\n{{\'SETTINGS.DATABASE.MODELS.COLOR\' | translate}} {{listFieldsDTOItem.index}}</label><input class=\"\" type=\"text\" \nng-model=\"listFieldsDTOItem.color\" name=\"listFieldsDTONewColor{{$index}}\" maxlength=\"255\"><div \nng-messages=\"champsForm[\'listFieldsDTONewColor\'+$index].$error\"><div ng-message=\"pattern\" \ntranslate=\"GENERAL.INVALID_HEX\"></div></div></md-input-container><div class=\"col-md-6 col-xs-12\" layout=\"row\">\n<md-button ng-disabled=\'!this[\"_newItemForUpdating\"+this.champs.index].value\' type=\"button\" class=\"md-fab md-mini\" \nng-click=\'addItemToFieldListType(this[\"_newItemForUpdating\"+this.champs.index], champs.listFieldsDTO); this[\"_newItemForUpdating\"+this.champs.index] = {};\'>\n<md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div><div \nlayout=\"column\" \nng-init=\"category.newChamps = {idCategory: category.id, typeChamps:\'STRING\', listFieldsDTO:[], modelType: modelType, size:100};\" \nng-form=\"newChampsForm\"><div class=\"form-group\" layout=\"row\"><md-input-container class=\"mb-0\" flex=\"auto\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.NAME\"></label><input class=\"\" type=\"text\" ng-model=\"category.newChamps.libelle\" \nname=\"libelle\" required maxlength=\"255\"><div ng-messages=\"newChampsForm.libelle.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container class=\"ml-15 mb-0\" flex=\"auto\">\n<label translate=\"SETTINGS.DATABASE.MODELS.FIELD_SIZE\"></label><md-select ng-model=\"category.newChamps.size\"><md-option\n ng-value=\"10\">10%</md-option><md-option ng-value=\"15\">15%</md-option><md-option ng-value=\"20\">20%</md-option>\n<md-option ng-value=\"25\">25%</md-option><md-option ng-value=\"33\">33%</md-option><md-option ng-value=\"50\">50%\n</md-option><md-option ng-value=\"66\">66%</md-option><md-option ng-value=\"75\">75%</md-option><md-option ng-value=\"100\">\n100%</md-option></md-select></md-input-container><md-input-container class=\"ml-15 mb-0\" flex=\"auto\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.FIELD_TYPE\"></label><md-select ng-model=\"category.newChamps.typeChamps\"><md-option \nng-repeat=\"enumType in enumTypes\" ng-value=\"enumType.type\">{{\'SETTINGS.DATABASE.TYPES.\'+enumType.texte | translate}}\n</md-option></md-select></md-input-container><md-input-container class=\"ml-15 mb-0\" ng-if=\"types != null\" flex=\"auto\">\n<label translate=\"SETTINGS.DATABASE.TYPES.TITLE_PAGE\"></label><md-select md-on-close=\"filterSelectTextSub = \'\'\" \nng-model=\"category.newChamps.subTypes\" multiple=\"multiple\"><md-select-header><section><input force-select-focus \ntype=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectTextSub\"></section></md-select-header>\n<md-option ng-repeat=\"type in types | filterText: filterSelectTextSub\" ng-value=\"type\">{{type.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"ml-15 mb-0\"><md-checkbox \nid=\"newFieldRequiredInputCheckbox-{{$index}}\" class=\"md-primary md-hue-2\" value=\"true\" \nng-model=\"category.newChamps.required\">{{\"GENERAL.REQUIRED\" | translate}}</md-checkbox></md-input-container><div \nclass=\"\" layout=\"row\" layout-align=\"end center\"><md-button \nng-disabled=\"((category.newChamps.typeChamps == \'LIST_SELECT\' || category.newChamps.typeChamps == \'MULTIPLE_SELECT\') && (!category.newChamps.libelle || category.newChamps.listFieldsDTO.length<2)) || ((category.newChamps.typeChamps != \'LIST_SELECT\' || category.newChamps.typeChamps == \'MULTIPLE_SELECT\') && !category.newChamps.libelle)\" \ntype=\"button\" class=\"md-raised md-primary md-hue-2\" ng-click=\"saveChamps(category, newChampsForm);\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}</md-button></div></div><div \nclass=\"form-group offset-md-2 row\" \nng-if=\"category.newChamps.typeChamps == \'LIST_SELECT\' || category.newChamps.typeChamps == \'MULTIPLE_SELECT\'\"><div \nclass=\"col-xs-12\" ng-class=\"!!enumSubTypes ? \'col-md-7\' : \'col-md-5\'\"><div class=\"panel panel-line\" \nng-class=\"category.newChamps.listFieldsDTO.length < 2 ? \'panel-danger\' : \'panel-success\'\"><div class=\"panel-heading\">\n<h3 ng-class=\"{\'panel-title\' : category.newChamps.listFieldsDTO.length < 2}\"><span \nng-if=\"category.newChamps.listFieldsDTO.length < 2\">Au moins deux valeurs sont requises pour ce type de champs.</span>\n</h3></div><div class=\"panel-body\"><div \nng-repeat=\"listFieldsDTOItem in category.newChamps.listFieldsDTO | orderBy:\'index\'\"><div layout=\"row\">\n<md-input-container><label>Valeur {{listFieldsDTOItem.index}}</label><input class=\"\" type=\"text\" \nng-model=\"listFieldsDTOItem.value\" name=\"listFieldsDTOItem{{$index}}\" maxlength=\"255\"></md-input-container><div \nclass=\"\"><md-button type=\"button\" class=\"md-fab md-mini\" \nng-click=\"removeItemFromFieldListType($index, category.newChamps.listFieldsDTO)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s18\"></md-icon></md-button><md-button ng-if=\"listFieldsDTOItem.index > 1\" type=\"button\" class=\"md-fab md-mini\" \nng-click=\"upFieldListTypeItem(listFieldsDTOItem, category.newChamps.listFieldsDTO)\"><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button \nng-if=\"listFieldsDTOItem.index != category.newChamps.listFieldsDTO.length\" type=\"button\" class=\"md-fab md-mini\" \nng-click=\"downFieldListTypeItem(listFieldsDTOItem, category.newChamps.listFieldsDTO)\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div><div layout=\"row\" \nng-init=\"_newItemForCreating = {}\"><md-input-container><label>Valeur</label><input type=\"text\" \nng-model=\"_newItemForCreating.value\" maxlength=\"255\"></md-input-container><div class=\"\"><md-button type=\"button\" \nng-disabled=\"!_newItemForCreating.value\" class=\"md-fab md-mini\" \nng-click=\"addItemToFieldListType(_newItemForCreating, category.newChamps.listFieldsDTO); _newItemForCreating = {};\">\n<md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div><div \nng-if=\"level < 1\"><model-builder model-type=\"modelType\" base-url=\"baseUrl\" categories=\"category.subCategories\" \nlanguage=\"language\" level=\"level+1\" event-id=\"eventId\" parent-id=\"category.id\"></model-builder></div></div></form>\n</div></div></form><div class=\"nl-loader\" ng-show=\"!loaded\" ng-if=\"level === 0\"><div class=\"spinner\"><div \nclass=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div \nclass=\"half-circle\"></div></div></div></div></div></div><div class=\"nl-Block\" ng-show=\"level<2\"><div \nng-init=\"showModelHelp = false;\"><div class=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" \nlayout-align=\"space-between center\"><div><span ng-show=\"level === 0\" \ntranslate=\"SETTINGS.DATABASE.MODELS.CREATE_CATEGORY\"></span> <span ng-show=\"level > 0\" \ntranslate=\"SETTINGS.DATABASE.MODELS.CREATE_SUBCATEGORY\"></span></div></div></div><div><div><div><form \nclass=\"form-horizontal\" name=\"newCategoryForm\" role=\"form\" novalidate><div ng-form=\"newCategoryMiniForm\"><div \nng-show=\"showModelHelp\" class=\"nl-Models-help\"><help-model-builder help-model-title=\"helpModelTitle\" \nhelp-model-content=\"helpModelContent\"><help-model-builder></help-model-builder></help-model-builder></div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"mt-10\"><div layout=\"row\" layout-align=\"start center\">\n<md-input-container flex=\"noshrink\" class=\"mt-25 mb-0\"><label>{{\'SETTINGS.DATABASE.MODELS.NAME\' | translate}}</label>\n<input type=\"text\" ng-model=\"newCategory.name\" name=\"name\" maxlength=\"255\" required><div \nng-messages=\"newCategoryMiniForm.name.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container><md-input-container class=\"ml-15 mt-0 mb-0\" flex=\"noshrink\" ng-if=\"level > 0\"><label>\n{{\'SETTINGS.DATABASE.MODELS.CATEGORY_SIZE\' | translate}}</label><md-select ng-model=\"newCategory.size\"><md-option \nng-value=\"10\">10%</md-option><md-option ng-value=\"15\">15%</md-option><md-option ng-value=\"20\">20%</md-option><md-option\n ng-value=\"25\">25%</md-option><md-option ng-value=\"33\">33%</md-option><md-option ng-value=\"50\">50%</md-option>\n<md-option ng-value=\"66\">66%</md-option><md-option ng-value=\"75\">75%</md-option><md-option ng-value=\"100\">100%\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"ml-15\" ng-if=\"types != null\" flex=\"auto\"><label \ntranslate=\"SETTINGS.DATABASE.TYPES.TITLE_PAGE\"></label><md-select md-on-close=\"filterSelectText = \'\'\" \nng-model=\"newCategory.subTypes\" ng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"multiple\"><md-select-header>\n<section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"type in types | filterText: filterSelectText\" ng-value=\"type\">{{type.name}}</md-option></md-select>\n</md-input-container></div><div class=\"mr-20\"><md-switch ng-model=\"newCategory.defaultClosed\" \nclass=\"md-primary md-hue-2\" aria-label=\"default closed\">{{\'SETTINGS.DATABASE.MODELS.DEFAULT_CLOSED\' | translate}}\n</md-switch></div><md-button md-no-ink type=\"button\" class=\"md-raised md-primary md-hue-2\" \nng-click=\"saveCategory(newCategoryMiniForm);\"><md-icon md-font-icon=\"icon-plus pb-\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/main/models/model_types.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"SETTINGS.DATABASE.TYPES.TITLE_COMPANY\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-input-container><md-select ng-model=\"language.key\" class=\"md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div class=\"content\"><div class=\"\"><model-type this-model=\"modelType\" \ntypes=\"types\" base-url=\"baseUrl\" language=\"language\"></model-type></div></div></div>");
$templateCache.put("app/main/models/model_view.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" ng-if=\"modelType === \'COMPANY_MODEL\'\" translate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\"></div><div class=\"\" \nng-if=\"modelType === \'CONTACT_MODEL\'\" translate=\"SETTINGS.DATABASE.MODELS.TITLE_CONTACT\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container><md-select ng-model=\"language.key\" class=\"md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div class=\"content\"><model-builder ng-init=\"firstTreeLevel = 0\" \nmodel-type=\"modelType\" base-url=\"baseUrl\" categories=\"categories\" level=\"firstTreeLevel\" language=\"language\" \nhelp-model-title=\"helpModelTitle\" help-model-content=\"helpModelContent\" event-id=\"eventId\"></model-builder><div \nclass=\"nl-Block mt-15\" \nng-if=\"modelType !== \'COMPANY_MODEL\' && modelType !== \'INSCRIPTION_MODEL\' && modelType !== \'LOGISTIC_MODEL\'\">\n<draw-token-builder base-url=\"baseUrl\" draw-token-title=\"drawTokenTitle\" help-draw-token-title=\"helpDrawTokenTitle\" \nhelp-draw-token-content=\"helpDrawTokenContent\" language=\"language\"></draw-token-builder></div></div></div>");
$templateCache.put("app/main/models/move_field.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">\n{{\'SETTINGS.DATABASE.MODELS.MOVE_FIELD\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form novalidate name=\"moveFieldForm\" ng-submit=\"moveFieldForm.$valid && update()\"><md-dialog-content>\n<md-input-container><md-select ng-model=\"champs.idCategory\" name=\"idCategory\" required><md-option \nng-repeat=\"category in categories track by category.id\" ng-value=\"category.id\" \nng-disabled=\"currentCategory.id === category.id\">{{category.name}}</md-option></md-select><label>\n{{\'SETTINGS.DATABASE.MODELS.CATEGORY\' | translate}}</label><div ng-messages=\"moveFieldForm.idCategory.$error\"><span \nng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span></div></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-primary md-raised md-hue-2\" type=\"submit\" \ntranslate=\"GENERAL.SAVE\"></md-button><md-button type=\"button\" class=\"md-warn md-hue-2\" ng-click=\"hidePopup()\" \ntranslate=\"GENERAL.CANCEL\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/models/simple_model.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"portlet light portlet-fit portlet-datatable bordered\"><div \nclass=\"portlet-title\"><div class=\"caption\"><i class=\"icon-settings font-dark\"></i> <span \nclass=\"caption-subject font-dark sbold uppercase\">{{modelTitle}}</span></div><div class=\"actions\"><a \nng-click=\"showHelp = !showHelp\" class=\"btn btn-circle btn-icon-only btn-default\" href=\"javascript:;\"><i \nclass=\"fa fa-question\"></i></a></div><div class=\"inputs\" style=\"margin-top: 1.2px\"><div \nclass=\"portlet-input input-inline input-medium\" style=\"margin-right: 20px\"><input type=\"text\" \nclass=\"form-control form-control input-circle\" placeholder=\"Rechercher ici ...\" ng-model=\"simpleModelSearch\"></div>\n</div></div><div class=\"portlet-body\"><form novalidate class=\"form-horizontal\" name=\"modelForm\"><div \nng-show=\"showHelp\" class=\"note note-info\"><h3>{{helpModelTitle}}</h3><p>\nPour commencer, vous devez entrer le libellé de votre modèle et cliquer sur <a \nclass=\"btn btn-circle btn-icon-only green\" href=\"javascript:;\"><i class=\"fa fa-plus\"></i></a></p><p>Les boutons <a \nclass=\"btn btn-circle btn-icon-only btn-default\" href=\"javascript:;\"><i class=\"fa fa-arrow-up\"></i> </a>et <a \nclass=\"btn btn-circle btn-icon-only btn-default\" href=\"javascript:;\"><i class=\"fa fa-arrow-down\"></i> </a>\nvous permettrons de réordonner les modèles</p><p>\nPour modifier un champs, commencer par activer la modification avec le bouton <a \nclass=\"btn btn-circle btn-icon-only btn-default\" href=\"javascript:;\"><i class=\"fa fa-pencil-square-o\"></i> </a>.</p><p>\nIl faut ensuite modifier le libellé du champs et valider la modification en cliquant sur <a \nclass=\"btn btn-circle btn-icon-only btn-success\" href=\"javascript:;\"><i class=\"fa fa-save\"></i></a></p><p>\nPour supprimer un champs, il faut cliquer sur <a class=\"btn btn-circle btn-icon-only btn-danger\" href=\"javascript:;\"><i\n class=\"fa fa-trash\"></i></a></p><p>ATTENTION toutes les informations liées à ce champs seront supprimé!</p></div><div \nclass=\"form-body\"><div class=\"row\"><div \nng-repeat=\"field in fields | filter: {libelle : simpleModelSearch} | orderBy:\'index\'\" class=\"form-group\"><label \nclass=\"col-md-3 control-label\">{{modelName}} {{field.index}}</label><div class=\"col-md-4\"><input \nng-disabled=\"!field.active\" type=\"text\" ng-model=\"field.libelle\" class=\"form-control\"></div><div class=\"col-md-4\"><a \nng-if=\"field.active\" ng-click=\"updateField(field)\" class=\"btn btn-circle btn-icon-only btn-success\" \nhref=\"javascript:;\"><i class=\"fa fa-save\"></i> </a><a ng-if=\"!field.active\" ng-click=\"field.active = !field.active\" \nclass=\"btn btn-circle btn-icon-only btn-default\" href=\"javascript:;\"><i class=\"fa fa-pencil-square-o\"></i> </a><button \nclass=\"btn btn-circle btn-icon-only btn-danger\" mwl-confirm title=\"Suppression\" \nmessage=\"Êtes-vous sûr de vouloir supprimer ce champs?\" confirm-text=\"Valider\" cancel-text=\"Annuler\" placement=\"top\" \non-confirm=\"removeField(field)\" on-cancel=\"cancelClicked = true\" confirm-button-type=\"danger\" \ncancel-button-type=\"default\"><i class=\"fa fa-trash\"></i></button> <a ng-if=\"field.index > 1\" ng-click=\"upField(field)\" \nclass=\"btn btn-circle btn-icon-only btn-default\" href=\"javascript:;\"><i class=\"fa fa-arrow-up\"></i> </a><a \nng-if=\"field.index != fields.length\" ng-click=\"downField(field)\" class=\"btn btn-circle btn-icon-only btn-default\" \nhref=\"javascript:;\"><i class=\"fa fa-arrow-down\"></i></a></div></div><div class=\"form-group\"><label \nclass=\"col-md-3 control-label\">Nom</label><div class=\"col-md-4\"><input type=\"text\" ng-model=\"newField.libelle\" \nclass=\"form-control\"></div><div class=\"col-md-4\"><a ng-click=\"saveField();\" class=\"btn btn-circle btn-icon-only green\" \nhref=\"javascript:;\"><i class=\"fa fa-plus\"></i></a></div></div></div></div></form></div></div></div></div>");
$templateCache.put("app/main/models/type.html","<div class=\"nl-Block\"><div><div class=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" \nlayout-align=\"space-between center\"><div><span translate=\"SETTINGS.DATABASE.TYPES.CREATION\"></span></div><div></div>\n</div></div><div><div><div><form class=\"form-horizontal\" role=\"form\" novalidate name=\"addTypeForm\" \nng-submit=\"addTypeForm.$valid && saveType()\"><div><div layout=\"row\"><md-input-container><label>\n{{\'SETTINGS.DATABASE.TYPES.NAME\' | translate}}</label><input type=\"text\" name=\"name\" ng-model=\"newType.name\" required \nmaxlength=\"255\"><div ng-messages=\"addTypeForm.name.$error\" role=\"alert\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><div><md-button type=\"submit\" \nclass=\"md-raised md-primary md-hue-2\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></form></div></div></div></div><div class=\"mt-15\"><div \nng-repeat=\"type in types | orderBy:\'index\'\" class=\"nl-Block\"><form \nng-submit=\"type.active && updateTypeForm.$valid && updateType(type)\" novalidate name=\"updateForm\"><ng-form \nname=\"updateTypeForm\"><div><div class=\"panel panel panel-bordered m-b-0\"><div layout=\"row\" layout-align=\"start center\">\n<div flex=\"5\"><i class=\"icon md-widgets\" aria-hidden=\"true\"></i> &nbsp;#{{type.id}}</div><div><div \nclass=\"input-search inline-block\"><md-input-container class=\"mt-18 mb-0\"><input type=\"text\" ng-disabled=\"!type.active\" \nng-model=\"type.name\" name=\"name_update\" required maxlength=\"255\"><div ng-messages=\"updateTypeForm.name_update.$error\" \nrole=\"alert\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div>\n</div><div class=\"ml-25\" layout=\"row\" layout-align=\"end end\"><div ng-if=\"type.active\"><md-button type=\"submit\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button>\n</div><div ng-if=\"!type.active\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"type.active = true;\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button></div><div>\n<md-button type=\"button\" class=\"md-fab md-mini md-accent\" ng-click=\"filterConfig(type);\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"s18\"></md-icon></md-button></div><div><md-button type=\"button\" \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"removeType($index, type);\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s18\"></md-icon></md-button></div><div class=\"ml-15\" layout=\"row\" layout-align=\"start center\"><md-button \nng-disabled=\"!(type.index > 1)\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"upType(type)\">\n<md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button \nng-disabled=\"!(type.index != types.length)\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"downType(type)\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div>\n</div></div><div class=\"nl-Models-details\"><draw-token-builder base-url=\"baseUrl\" draw-token-title=\"\'to translate\'\" \nhelp-draw-token-title=\"\'to translate\'\" help-draw-token-content=\"\'to translate\'\" language=\"language\" \nsub-type-id=\"type.id\" model-type=\"thisModel\"></draw-token-builder></div></ng-form></form></div></div>");
$templateCache.put("app/main/packages/packages.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"PACKAGES.TITLE\"></div></div><div layout=\"row\" layout-align=\"end center\"><md-input-container flex>\n<md-select ng-change=\"initPackages()\" ng-model=\"language.key\" class=\"md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div class=\"content\"><md-button \nclass=\"md-primary md-raised md-hue-2 md-teal-theme-theme\" ng-click=\"goAdd()\">{{\"GENERAL.ADD\" | translate}}</md-button>\n<div class=\"nl-Block nl-Block--table\"><div class=\"nl-listing\"><table class=\"simple list-view\"><thead><th>\n{{\"PACKAGES.COLUMNS.NAME\" | translate}}</th><th>{{\"PACKAGES.COLUMNS.DURATION\" | translate}}</th><th>\n{{\"PACKAGES.COLUMNS.REGION\" | translate}}</th><th>{{\"PACKAGES.COLUMNS.TYPE\" | translate}}</th><th>\n{{\"PACKAGES.COLUMNS.COMPANY_NAME\" | translate}}</th><th>{{\"FESTIVAL.CREATION.PUBLISH\" | translate}}</th><th>\n{{\"PACKAGES.COLUMNS.ACTIONS\" | translate}}</th></thead><tbody><tr \nng-repeat=\"package in packages | orderBy : \'name\' track by $index\"><td>{{package.name}}</td><td>{{package.duration}}\n</td><td><span ng-if=\"package.regions != null && package.regions.length > 0\" \nng-repeat=\"region in package.regions | limitTo: 3\">{{region.value}}<span ng-if=\"!$last\">{{\', \'}}</span><span \nng-if=\"$last && package.regions.length > 3\">{{\',...\'}}</span></span></td><td><span \nng-if=\"package.typesTourisme != null && package.typesTourisme.length > 0\" \nng-repeat=\"type in package.typesTourisme | limitTo: 3\">{{type.value}}<span ng-if=\"!$last\">{{\', \'}}</span><span \nng-if=\"$last && package.typesTourisme.length > 3\">{{\',...\'}}</span></span></td><td>{{package.company}}</td><td>\n<md-checkbox readonly=\"readonly\" disabled=\"disabled\" ng-model=\"package.publish\" aria-label=\"publish\"></md-checkbox>\n</td><td><md-button md-no-ink ng-click=\"update(package)\" class=\"md-primary md-raised md-hue-2\" aria-label=\"Supprimer\">\n{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button md-no-ink ng-click=\"showPopUpDelete(package, $index)\" \nclass=\"md-warn md-hue-2\" aria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}</md-button></td></tr></tbody></table>\n</div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div \nclass=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/popup/confirm.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{content.title}}</div></div><md-button \nclass=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content>{{content.message}}</md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button md-no-ink class=\"md-raised md-primary md-hue-2\" ng-click=\"confirmAction()\" \ntranslate=\"GENERAL.YES\"></md-button><md-button class=\"md-warn md-hue-2\" ng-click=\"hidePopup()\" translate=\"GENERAL.NO\">\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/statistics/statistics.html","");
$templateCache.put("app/main/tourist_attractions/tourist_attractions.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"TOURIST.TITLE\"></div></div><div layout=\"row\" layout-align=\"end center\"><md-input-container flex>\n<md-select ng-change=\"initTourists()\" ng-model=\"language.key\" class=\"md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div class=\"content\"><md-button \nclass=\"md-primary md-raised md-hue-2 md-teal-theme-theme\" ng-click=\"goAdd()\">{{\"GENERAL.ADD\" | translate}}</md-button>\n<div class=\"nl-Block nl-Block--table\"><div class=\"nl-listing\"><table class=\"simple list-view\"><thead><th>\n{{\"TOURIST.COLUMNS.NAME\" | translate}}</th><th>{{\"TOURIST.COLUMNS.CITY\" | translate}}</th><th>\n{{\"TOURIST.COLUMNS.REGION\" | translate}}</th><th>{{\"TOURIST.COLUMNS.TYPE\" | translate}}</th><th>\n{{\"TOURIST.COLUMNS.ACTIONS\" | translate}}</th></thead><tbody><tr \nng-repeat=\"tourist in tourists | orderBy: \'name\' track by tourist.id\"><td>{{tourist.name}}</td><td>\n{{tourist.city != null ? tourist.city.value : \'\'}}</td><td>{{tourist.region != null ? tourist.region.value : \'\'}}</td>\n<td><span ng-maxlength=\"10\" ng-repeat=\"type in tourist.typeTourisme | limitTo: limitNbrTypes\">\n{{type.value}}{{$last ? (tourist.typeTourisme.length > limitNbrTypes ? \',...\' : \'\'): \', \'}}</span></td><td><md-button \nmd-no-ink ng-click=\"update(tourist)\" class=\"md-primary md-raised md-hue-2\" aria-label=\"Supprimer\">\n{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button md-no-ink ng-click=\"showPopUpDelete(tourist, $index)\" \nclass=\"md-warn md-hue-2\" aria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}</md-button></td></tr></tbody></table>\n</div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div \nclass=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div>\n</div></div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div class=\"\" \nlayout=\"row\" layout-align=\"start center\" style=\"padding:20px 0\"><img src=\"assets/images/logo/logo_lebanon.png\" alt=\"\" \nstyle=\"width: 90%\"></div><br></md-toolbar><a class=\"nl-navigation-item--avatar\"><div layout=\"row\" \nclass=\"ms-navigation-button nl-Nav-item--avatar\"><img class=\"icon nl-Nav-icon--avatar\" \nhttp-src=\"./alternatedocroots/{{$root.user.pictureLocation}}\" has-profile-picture=\"$root.user.pictureLocation != null\">\n<div class=\"title nl-Nav-item-folded\"><span class=\"nl-Nav-item-title nl-Nav-item-title--avatar\" flex>\n{{$root.user.fullName}}</span><div class=\"nl-Nav-item-subTitle\" flex></div><button type=\"button\" \nclass=\"nl-Nav-item--btnLogout\" ng-click=\"$root.logout()\"><md-icon md-font-icon=\"icon-logout\" class=\"s14\" \nstyle=\"margin-bottom: 2px\"></md-icon>{{vm.selectedLanguage.code === \'en\' ? \'Logout\' : \'Se déconnecter\'}}</button></div>\n</div></a><ms-navigation class=\"scrollable override-class\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/access_rights/associations/association.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\">{{\'ASSOCIATIONS.TITLE\' | translate}}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"button\" class=\"md-accent md-hue-1\" ng-click=\"openAddAssociation()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'ASSOCIATIONS.NEW\' | translate}}</md-button></div></div><div class=\"content\"><div class=\"nl-Block nl-Block--table\">\n<div layout=\"row\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\" flex=\"100\"><thead><th\n translate=\"ASSOCIATIONS.COMPANIES.NAME\"></th><th translate=\"ASSOCIATIONS.COMPANIES.MANAGER\"></th></thead><tbody><tr \nng-repeat=\"company in association.companies | orderBy: \'modelPattern\' track by company.id\"><td>{{company.modelPattern}}\n</td><td><md-button class=\"md-fab md-mini md-hue-2\" type=\"md-button\" ng-click=\"addManager(company)\" \nng-if=\"company.manager == null\"><md-icon md-font-icon=\"icon-link\"></md-icon></md-button>\n{{ company.manager != null ? company.manager.fullName : \'\'}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/access_rights/associations/associations.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\">{{\'ASSOCIATIONS.TITLE\' | translate}}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"button\" class=\"md-accent md-hue-1\" ng-click=\"openAddAssociation()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'ASSOCIATIONS.NEW\' | translate}}</md-button></div></div><div class=\"content\"><div class=\"nl-Block nl-Block--table\">\n<div layout=\"row\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\" flex=\"100\"><thead><th\n translate=\"ASSOCIATIONS.ID\"></th><th translate=\"ASSOCIATIONS.LOGO\"></th><th translate=\"ASSOCIATIONS.NAME\"></th><th \ntranslate=\"ASSOCIATIONS.ADMIN\"></th><th translate=\"GENERAL.ACTIONS\"></th></thead><tbody><tr \nng-repeat=\"association in associations | orderBy: \'name\' track by association.id\" \nng-click=\"detailsCompany(association);\"><td>{{association.id}}</td><td><img style=\"width:200px\" \nng-src=\"{{alternatedocroots + \'/\' + association.logo}}\" ng-if=\"association.logo != null\"></td><td>\n{{ association.name }}</td><td>{{ association.admin.fullName }}</td><td><md-button type=\"button\" \nclass=\"md-fab md-mini md-hue-2\" ng-click=\"$event.stopPropagation();details(association)\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"$event.stopPropagation();openRemoveAssociation(association);\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button></td></tr></tbody></table></div></div></div>\n</div>");
$templateCache.put("app/main/access_rights/groups/groups.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\">{{\'GROUPS.TITLE\' | translate}}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"button\" class=\"md-accent md-hue-1\" ng-click=\"openAddGroup()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'GROUPS.NEW\' | translate}}</md-button></div></div><div class=\"content\"><div class=\"nl-Block nl-Block--table\"><div \nlayout=\"row\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\"><thead><th \ntranslate=\"GROUPS.NAME\"></th><th translate=\"GROUPS.RIGHTS\"></th><th translate=\"GENERAL.ACTIONS\"></th></thead><tbody><tr\n ng-repeat=\"group in groups | orderBy: \'name\' track by group.id\"><td ng-click=\"details(group)\">{{ group.name }}</td><td\n ng-click=\"details(group)\"></td><td><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"openRemoveGroup(group);\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/access_rights/users/users.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\">{{\'USERS.TITLE\' | translate}}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"button\" class=\"md-accent md-hue-1\" ng-click=\"switchActives()\"><md-icon md-font-icon=\"icon-auto-fix\"></md-icon>\n<span ng-hide=\"showAllUsers\" translate=\"USERS.SEE_INACTIVES\"></span> <span ng-show=\"showAllUsers\" \ntranslate=\"USERS.HIDE_INACTIVES\"></span></md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"openAddUser()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'USERS.NEW\' | translate}}</md-button></div>\n</div><div class=\"content\"><div class=\"nl-Block nl-Block--table\"><div layout=\"row\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\"><thead><th translate=\"USERS.NAME\"></th><th \ntranslate=\"USERS.ID\"></th><th translate=\"USERS.GROUPS\"></th><th translate=\"USERS.RIGHTS\"></th></thead><tbody><tr \nng-repeat=\"user in users | showAllUsers: showAllUsers | orderBy: \'fullName\' track by user.id\" ng-click=\"details(user)\">\n<td>{{ user.fullName }}</td><td>{{ user.login }}</td><td><span ng-repeat=\"group in user.groups track by group.id\">\n{{group.name}}</span></td><td></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/admin/eventsLogs/eventsLogs.html","");
$templateCache.put("app/main/admin/messagesLogs/message.html","<md-dialog style=\"min-width: 600px\" aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{message.subject}}</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"nl-Popup-content-body\" layout=\"column\"><div flex=\"100\" class=\"ql-editor\" \nng-bind-html=\"message.content\"></div><div flex=\"100\"><md-button md-no-ink class=\"md-accent md-hue-2\" \naria-label=\"Annuler\" ng-click=\"hidePopup()\">{{\"GENERAL.OK\" | translate }}</md-button></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/admin/messagesLogs/messages_logs.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"ADMIN.MESSAGES_LOGS.TITLE\"></div></div>\n</div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table \nclass=\"dataTable row-border hover\"><thead><tr><th><div>{{\'ADMIN.MESSAGES_LOGS.COLUMNS.DATE\' | translate}}</div></th>\n<th><div>{{\'ADMIN.MESSAGES_LOGS.COLUMNS.SENDER\' | translate}}</div></th><th><div>\n{{\'ADMIN.MESSAGES_LOGS.COLUMNS.RECEIVER\' | translate}}</div></th><th><div>\n{{\'ADMIN.MESSAGES_LOGS.COLUMNS.ACTIONS\' | translate}}</div></th></tr></thead><tbody><tr \nng-repeat=\"message in messages track by message.id\" infinite-scroll-disabled=\"infiniteScrollPrevent\" \ninfinite-scroll=\"loadMore()\"><td>{{\'GENERAL.DATE_TIME_FORMAT\' | translate: {date: message.creationDate} }}</td><td>\n{{message.sender.fullName}}</td><td>{{message.receiver.fullName}}</td><td><md-button type=\"button\" \nng-click=\"seeMessage(message)\" translate=\"ADMIN.MESSAGES_LOGS.DETAILS\"></md-button></td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/admin/messagesLogs/usersLogs.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"ADMIN.USERSLOGS.TITLE\"></div></div>\n</div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table \nclass=\"dataTable row-border hover\"><thead><tr><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.DATE\' | translate}}</div></th><th>\n<div>{{\'ADMIN.USERSLOGS.COLUMNS.USER\' | translate}}</div></th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.ENTITY\' | translate}}\n</div></th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.ACTION\' | translate}}</div></th><th><div>\n{{\'ADMIN.USERSLOGS.COLUMNS.OLD_VALUE\' | translate}}</div></th><th><div>\n{{\'ADMIN.USERSLOGS.COLUMNS.NEW_VALUE\' | translate}}</div></th></tr></thead><tbody><tr ng-repeat=\"log in logs\"><td>\n{{log.date | date: \'dd/MM/yyyy à HH:mm\'}}</td><td>{{log.user}} <span ng-if=\"log.userID\">(id: {{log.userID}})</span>\n</td><td>{{ ENTITY_CONCERNED[log.type] | translate }}</td><td>{{ ACTIONS[log.action] | translate }}</td><td>\n{{log.oldValue}}</td><td>{{log.newValue}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/admin/usersLogs/usersLogs.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"ADMIN.EVENTSLOGS.TITLE\"></div></div>\n</div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table \nclass=\"dataTable row-border hover\"><thead><tr><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.DATE\' | translate}}</div></th><th>\n<div>{{\'ADMIN.USERSLOGS.COLUMNS.USER\' | translate}}</div></th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.ENTITY\' | translate}}\n</div></th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.ACTION\' | translate}}</div></th><th><div>\n{{\'ADMIN.USERSLOGS.COLUMNS.OLD_VALUE\' | translate}}</div></th><th><div>\n{{\'ADMIN.USERSLOGS.COLUMNS.NEW_VALUE\' | translate}}</div></th></tr></thead><tbody><tr ng-repeat=\"log in logs\"><td>\n{{log.date | date: \'dd/MM/yyyy à HH:mm\'}}</td><td><div class=\"nl-Msg-avatar mr-10\"><img class=\"nl-Msg-avatar-img\" \nhttp-src=\"./alternatedocroots/{{log.userPic}}\" has-profile-picture=\"log.userPic != null\"></div>{{log.user}}<br><div \nng-if=\"log.userID\">(id: {{log.userID}})</div></td><td><span ng-if=\"log.idContact\">\n{{\'ADMIN.USERSLOGS.ENTITIES.CONTACT\' | translate}}#{{log.idContact}} ({{\'ADMIN.USERSLOGS.ENTITIES.COMPANY\' | translate}}#{{log.idEntity}})\n</span> <span ng-if=\"!log.idContact\">{{\'ADMIN.USERSLOGS.ENTITIES.COMPANY\' | translate}}#{{log.idEntity}}</span></td>\n<td>{{ ACTIONS[log.action] | translate }}</td><td>{{log.oldValue | limitTo: 100}}</td><td>\n{{log.newValue | limitTo: 100}}</td></tr></tbody></table></div></div><md-button ng-disabled=\"allLoaded\" type=\"button\" \nclass=\"md-accent\" ng-click=\"getLogs()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'COMPANIES.LOAD_MORE\' | translate}}</md-button></div></div>");
$templateCache.put("app/main/blog/popup/deletePhoto.popup.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\"BLOG.DELETE_PHOTO\" | translate}}</div></div>\n<md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"nl-Popup-content-body\"><div class=\"nl-Popup-content-body-title\">{{\"BLOG.CONFIRM_DELETE_PHOTO\" | translate}}\n</div><br><img ng-src=\"alternatedocroots/{{photoToDelete.location}}\"></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button class=\"md-primary md-raised md-hue-2\" ng-click=\"deletePhotoPermanentely()\" \ntranslate=\"GENERAL.YES\"></md-button><md-button class=\"md-warn md-hue-2\" ng-click=\"hidePopup()\" translate=\"GENERAL.NO\">\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/calendarExtern/popup/addEvent.html","<md-dialog class=\"document-dialog\" aria-label=\"Document\" flex=\"40\" md-theme=\"teal-theme\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"eventForm.$valid && saveEvent()\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'FOLDERS.UPLOAD_FILE\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-input-container class=\"nl-Input-container\" flex=\"100\"><label>\n{{\"CALENDAR_EXTERN.CREATION.NAME\" | translate}}</label><input ng-model=\"event.name\" name=\"name\" required><div \nng-messages=\"eventForm.name\" role=\"alert\"><div ng-message=\"required\"><span>{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></div></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\"><label>\n{{\"CALENDAR_EXTERN.CREATION.PLACE\" | translate}}</label><input ng-model=\"event.place\" name=\"place\" required><div \nng-messages=\"eventForm.place\" role=\"alert\"><div ng-message=\"required\"><span>{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></div></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\"><label>\n{{\"CALENDAR_EXTERN.CREATION.WEBSITE\" | translate}}</label><input ng-model=\"event.website\" name=\"website\" required><div \nng-messages=\"eventForm.website\" role=\"alert\"><div ng-message=\"required\"><span>{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><md-datepicker ng-model=\"event.startDateForm\" \nname=\"eventStartDate\" md-placeholder=\"{{\'CALENDAR_EXTERN.CREATION.DATE_START\' | translate}}\" md-open-on-focus \nrequired=\"\"></md-datepicker><div class=\"pl-20\" ng-messages=\"eventForm.eventStartDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container class=\"md-block mv-0\"><label>{{\'CALENDAR_EXTERN.CREATION.TIME_START\' | translate}} hh:mm</label>\n<input type=\"text\" class=\"input-value\" name=\"eventStartTime\" ng-model=\"event.startTime\" ui-time-mask=\"short\" required>\n<div class=\"pl-20\" ng-messages=\"eventForm.eventStartTime.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div><div ng-message=\"time\"><span>\n{{\"GENERAL.FORM.INVALID_FORMAT\" | translate}} (hh:mm)</span></div></div><div ng-if=\"timeNotMatch\" \nclass=\"ng-scope nl_form-error-input\"><span>{{\"CALENDAR_EXTERN.TIME_ERROR\" | translate}}</span></div>\n</md-input-container><md-input-container class=\"md-block\"><md-datepicker ng-model=\"event.endDateForm\" \nname=\"eventEndDate\" md-placeholder=\"{{\'CALENDAR_EXTERN.CREATION.DATE_END\' | translate}}\" \nmd-min-date=\"event.startDateForm\" md-open-on-focus required></md-datepicker><div class=\"pl-20\" \nng-messages=\"eventForm.eventEndDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"md-block mv-0\">\n<label>{{\'CALENDAR_EXTERN.CREATION.TIME_END\' | translate}} hh:mm</label><input type=\"text\" class=\"input-value\" \nname=\"eventEndTime\" ng-model=\"event.endTime\" ui-time-mask=\"short\" required><div class=\"pl-20\" \nng-messages=\"eventForm.eventEndTime.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div><div ng-message=\"time\"><span>\n{{\"GENERAL.FORM.INVALID_FORMAT\" | translate}} (hh:mm)</span></div></div><div ng-if=\"timeNotMatch\" \nclass=\"ng-scope nl_form-error-input\"><span>{{\"CALENDAR_EXTERN.TIME_ERROR\" | translate}}</span></div>\n</md-input-container></md-dialog-content><md-dialog-actions class=\"pr-25\"><md-button type=\"submit\" \nclass=\"md-primary md-hue-2 md-raised\" aria-label=\"Ajouter\">{{\"GENERAL.SAVE\" | translate}}</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/duplication_tool/junk_box/junk_box.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\">{{ \'JUNK_BOX.TITLE\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"></div></div><div \nclass=\"content\"><div class=\"nl-Block nl-Block--table\"><div layout=\"row\"><table class=\"dataTable row-border hover\">\n<thead><th width=\"50%\" translate=\"JUNK_BOX.FIELDS.NAME\"></th><th width=\"35%\" translate=\"JUNK_BOX.FIELDS.DELETION_DATE\">\n</th><th width=\"15%\"></th></thead><tbody><tr ng-repeat=\"_model in models | orderBy: order: reverse\"><td><div \nclass=\"nl-Block--table--company\">{{ _model.modelPattern }}</div></td><td>{{_model.updateDate|date:\'dd/MM/yyyy HH:mm\'}}\n</td><td><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row\"><md-button flex type=\"button\" \nclass=\"md-warn md-hue-2 nl-Button--small\" ng-click=\"onDeleteJunkBox(_model)\" ng-if=\"!_model.actionInProgress\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button><md-progress-circular \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" md-mode=\"indeterminate\" md-diameter=\"36\" \nng-if=\"_model.actionInProgress\"></md-progress-circular></div></td></tr></tbody></table></div><div class=\"nl-loader\" \nng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div \nclass=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/duplication_tool/merge_tool/merge_tool.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"DUPLICATION_TOOL.MERGE.TITLE\"></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button type=\"button\" class=\"\" ng-click=\"_mergeModelsFn();\" \nng-disabled=\"inProgress || !_modelsToMerge\"><md-icon md-font-icon=\"icon-arrange-bring-to-front\"></md-icon>\n{{\'DUPLICATION_TOOL.MERGE.MERGE_BTN\' | translate}}</md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" layout-wrap class=\"m-20 p-20\" style=\"overflow-x:auto\" \nng-if=\"_modelsToMerge\"><table class=\"dataTable row-border\"><thead><tr class=\"md-grey-50-bg\"><th \nstyle=\"min-width:150px!important\">{{ \'DUPLICATION_TOOL.MERGE.COLUMNS.CATEGORY\' | translate}}</th><th \nstyle=\"min-width:150px!important\">{{ \'DUPLICATION_TOOL.MERGE.COLUMNS.SUB_CATEGORY\' | translate}}</th><th \nstyle=\"min-width:150px!important\">{{ \'DUPLICATION_TOOL.MERGE.COLUMNS.FIELD\' | translate}}</th><th \nstyle=\"min-width:250px!important\" ng-repeat=\"_model in _modelsToMerge.models | orderBy : \'modelPattern\'\" ng-style=\"\">\n<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row\" style=\"text-align: center!important\">\n{{_model.modelPattern}}</div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row\"><span><md-button type=\"button\" \nclass=\"md-accent md-hue-2 md-teal-theme-theme\" ng-if=\"_modelsToMerge.models.length > 2\" \nng-click=\"_removeFalsePositiveColumnFn(_model);\"><md-icon md-font-icon=\"icon-bookmark-remove\"></md-icon><md-tooltip \nmd-direction=\"bottom\">{{\'DUPLICATION_TOOL.MERGE.FALSE_POSITIVE_COLUMN_TITLE\' | translate}}</md-tooltip></md-button>\n<md-button type=\"button\" class=\"md-accent md-hue-2 md-teal-theme-theme\" ng-click=\"_defaultColumnSelectedFn(_model);\">\n<md-icon md-font-icon=\"icon-check-all\" ng-if=\"!_model._defaultColumnSelected\" style=\"color: #ef9a9a!important\">\n</md-icon><md-icon md-font-icon=\"icon-check-all\" ng-if=\"_model._defaultColumnSelected\" \nstyle=\"color: #81c784!important\"></md-icon><md-tooltip md-direction=\"bottom\" ng-if=\"!_model._defaultColumnSelected\">\n{{\'DUPLICATION_TOOL.MERGE.SELECT_LIKE_DEFAULT_COLUMN\' | translate}}</md-tooltip><md-tooltip md-direction=\"bottom\" \nng-if=\"_model._defaultColumnSelected\">{{\'DUPLICATION_TOOL.MERGE.DEFAULT_COLUMN_SELECTED\' | translate}}</md-tooltip>\n</md-button></span></div></th></tr></thead><tbody \nng-repeat=\"_category in _modelsToMerge.categories | orderBy : \'index\'\"><tr \nng-repeat=\"_field in _category.values | orderBy : [\'subCatIndex\', \'libelle\']\" ng-init=\"\"><td \nrowspan=\"{{_category.values.length}}\" ng-hide=\"$index>0\" style=\"border-bottom: 1px solid #e0e0e0 !important\"><strong \nng-if=\"!_category.fixeFieldCategory\">{{_category.name}}</strong> <strong ng-if=\"_category.fixeFieldCategory\">\n{{ \'DUPLICATION_TOOL.MERGE.FIXE_FIELD_CATEGORY\' | translate}}</strong></td><td><strong>{{_field.subCatName}}</strong>\n</td><td><span ng-if=\"!_field.fixeField\">{{_field.libelle}}</span> <span ng-if=\"_field.fixeField\">\n{{ \'DUPLICATION_TOOL.MERGE.\' + _field.libelle | translate}}</span> <span ng-if=\"_field.noModelSelected\" \nstyle=\"color:red\">*</span></td><td ng-repeat=\"_valuedField in _field.values | orderBy : \'modelInfos.modelPattern\'\">\n<span><md-checkbox ng-model=\"_valuedField.selected\" ng-change=\"_modelFieldSelectedFn(_category, _field, _valuedField)\">\n<span><span ng-if=\"_field.typeChamps != \'MULTIPLE_SELECT\'\"><span \nng-show=\"_field.typeChamps == \'BOOLEAN\' || _field.typeChamps == \'RICH_TEXT\' || _field.typeChamps == \'FILE\' \n                                                    || _field.typeChamps == \'IMAGE\'\">\n<span ng-if=\"_field.typeChamps == \'BOOLEAN\'\"><span ng-if=\"_valuedField.value && _valuedField.value == \'true\'\" \nng-init=\"_valuedField.valueTmp = true\"><span translate=\"DUPLICATION_TOOL.MERGE.FIELD_VALUE.BOOLEAN.YES\"></span> </span>\n<span ng-if=\"!_valuedField.value || (_valuedField.value && _valuedField.value != \'true\')\" \nng-init=\"_valuedField.valueTmp = false\"><span translate=\"DUPLICATION_TOOL.MERGE.FIELD_VALUE.BOOLEAN.NO\"></span> </span>\n</span><span ng-if=\"_field.typeChamps == \'RICH_TEXT\'\"><span ng-bind-html=\"unsafe(_valuedField.value)\"></span> </span>\n<span ng-if=\"_field.typeChamps == \'FILE\' || _field.typeChamps == \'IMAGE\'\"><span ng-if=\"_field.typeChamps == \'FILE\'\">\n{{_valuedField.fileName}}</span> <span ng-if=\"_field.typeChamps == \'IMAGE\' && _valuedField.fileLocation\"><img \nng-src=\"/alternatedocroots/{{_valuedField.fileLocation}}\" alt=\"img\" style=\"max-width: 80px!important\"> </span></span>\n</span><span \nng-hide=\"_field.typeChamps == \'BOOLEAN\' || _field.typeChamps == \'RICH_TEXT\' || _field.typeChamps == \'FILE\' \n                                                    || _field.typeChamps == \'IMAGE\'\">\n{{_valuedField.value}} </span></span><span ng-if=\"_field.typeChamps == \'MULTIPLE_SELECT\'\"><span \nng-repeat=\"_value in _valuedField.values  | orderBy : \'libelle\'\">- {{_value.libelle}} <span ng-if=\"!$last\">|</span>\n</span></span></span></md-checkbox></span></td></tr></tbody></table></div><div \nclass=\"layout-align-space-around-stretch layout-row m-20 p-20\" ng-if=\"inProgress\"><md-progress-circular \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" md-mode=\"indeterminate\">\n</md-progress-circular></div><div layout=\"row\" layout-wrap class=\"m-10 p-10\"><md-button flex md-no-ink \nclass=\"md-primary\" ng-click=\"_mergeModelsFn();\" ng-disabled=\"inProgress || !_modelsToMerge\"><md-icon \nmd-font-icon=\"icon-arrange-bring-to-front\"></md-icon>{{\'DUPLICATION_TOOL.MERGE.MERGE_BTN\' | translate}}</md-button>\n</div></div></div></div>");
$templateCache.put("app/main/events/inscriptions/status.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"INSCRIPTION_STATUS.TITLE\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-input-container flex><md-select ng-model=\"language.key\" class=\"md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div class=\"content\"><div class=\"nl-Block mt-20\"><form \nname=\"newStatusForm\" role=\"form\" novalidate ng-submit=\"newStatusForm.$valid && add(newStatusForm)\"><div \nlayout=\"column\"><h3 translate=\"INSCRIPTION_STATUS.TITLE\"></h3><div layout=\"row\" layout-align=\"space-between center\">\n<md-input-container class=\"\"><label translate=\"INSCRIPTION_STATUS.NAME\"></label><input type=\"text\" maxlength=\"255\" \nrequired ng-model=\"newStatus.name\" required name=\"name\"><div ng-messages=\"newStatusForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Obligatoire.</span></div></div></md-input-container><md-input-container class=\"\"><label \ntranslate=\"INSCRIPTION_STATUS.COLOR\"></label><input type=\"text\" maxlength=\"255\" ng-model=\"newStatus.color\" \nname=\"color\"></md-input-container><div><md-button type=\"submit\" class=\"md-raised md-primary md-hue-2\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></form><div \nng-repeat=\"status in statuses | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" flex><div layout=\"row\" flex ng-if=\"!status.editionMode\"><h3 \nclass=\"\" flex=\"50\">{{status.name}}</h3><h3 class=\"ml-30\" flex>\n{{\'INSCRIPTION_STATUS.COLOR\' | translate }} : {{status.color}}</h3></div><div layout=\"row\" ng-if=\"status.editionMode\" \nflex><md-input-container><label translate=\"INSCRIPTION_STATUS.NAME\"></label><input type=\"text\" maxlength=\"255\" \nrequired ng-model=\"statusToEdit.name\" name=\"name\"><div ng-messages=\"editStatusForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Obligatoire.</span></div></div></md-input-container><md-input-container class=\"\"><label \ntranslate=\"INSCRIPTION_STATUS.COLOR\"></label><input type=\"text\" maxlength=\"255\" ng-model=\"statusToEdit.color\" \nname=\"color\"></md-input-container></div></div><div class=\"panel-actions panel-actions-keep\" layout=\"row\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-if=\"!status.editionMode\" type=\"button\" \nclass=\"md-fab md-mini md-hue-2\" ng-click=\"edit(status);\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon>\n</md-button><div class=\"ml-15\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"status.editionMode\"><md-button \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"update(status);\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-hue-2\" ng-click=\"cancel(status);\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon>\n</md-button></div><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"remove(status.id);\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(status.index > 0)\" ng-click=\"up(status.id);\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\">\n</md-icon></md-button><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"status.index === statuses.length - 1 || statuses.length <= 1\" ng-click=\"down(status.id);\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/events/inscriptions/sub_categories.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"INSCRIPTION_SUB_CATEGORY.TITLE\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-input-container flex><md-select ng-model=\"language.key\" class=\"md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div class=\"content\"><div class=\"nl-Block mt-20\"><form \nname=\"newSubCategoryForm\" role=\"form\" novalidate ng-submit=\"newSubCategoryForm.$valid && add(newSubCategoryForm)\"><div \nlayout=\"column\"><h3 translate=\"INSCRIPTION_SUB_CATEGORY.TITLE\"></h3><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"\"><input type=\"text\" maxlength=\"255\" required \nng-model=\"newSubCategory.name\" required name=\"name\"><div ng-messages=\"newSubCategoryForm.name.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>Obligatoire.</span></div></div></md-input-container><div><md-button type=\"submit\" \nclass=\"md-raised md-primary md-hue-2\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></form><div \nng-repeat=\"category in subcategories | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><h3 class=\"\" ng-if=\"!category.editionMode\">{{category.name}}</h3>\n<md-input-container ng-if=\"category.editionMode\"><input type=\"text\" maxlength=\"255\" required \nng-model=\"subCategoryToEdit.name\" required name=\"name\"><div ng-messages=\"editStatusForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Obligatoire.</span></div></div></md-input-container></div><div \nclass=\"panel-actions panel-actions-keep\" layout=\"row\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-if=\"!category.editionMode\" type=\"button\" class=\"md-fab md-mini md-hue-2\" ng-click=\"edit(category);\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"category.editionMode\"><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"update(category);\"><md-icon md-font-icon=\"icon-content-save\" \nclass=\"s18\"></md-icon></md-button><md-button type=\"button\" class=\"md-fab md-mini md-hue-2\" \nng-click=\"cancel(category);\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></md-button></div><md-button \ntype=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"remove(category.id);\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(category.index > 0)\" ng-click=\"up(category.id);\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\">\n</md-icon></md-button><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"category.index === subcategories.length - 1 || subcategories.length <= 1\" ng-click=\"down(category.id);\">\n<md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/events/logistics/status.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"LOGISTICAL_STATUS.TITLE\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-input-container flex><md-select ng-model=\"language.key\" class=\"md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div class=\"content\"><div class=\"nl-Block mt-20\"><form \nname=\"newStatusForm\" role=\"form\" novalidate ng-submit=\"newStatusForm.$valid && add(newStatusForm)\"><div \nlayout=\"column\"><h3 translate=\"LOGISTICAL_STATUS.TITLE\"></h3><div layout=\"row\" layout-align=\"space-between center\">\n<md-input-container class=\"\"><label translate=\"LOGISTICAL_STATUS.NAME\"></label><input type=\"text\" maxlength=\"255\" \nrequired ng-model=\"newStatus.name\" name=\"name\"><div ng-messages=\"newStatusForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Obligatoire.</span></div></div></md-input-container><md-input-container class=\"\"><label \ntranslate=\"LOGISTICAL_STATUS.COLOR\"></label><input type=\"text\" maxlength=\"255\" ng-model=\"newStatus.color\" name=\"color\">\n</md-input-container><div><md-button type=\"submit\" class=\"md-raised md-primary md-hue-2\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></form><div \nng-repeat=\"status in statuses | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" flex><div layout=\"row\" flex ng-if=\"!status.editionMode\"><h3 \nclass=\"\" flex=\"50\">{{status.name}}</h3><h3 class=\"ml-30\" flex>\n{{\'LOGISTICAL_STATUS.COLOR\' | translate }} : {{status.color}}</h3></div><div layout=\"row\" ng-if=\"status.editionMode\" \nflex><md-input-container><label translate=\"LOGISTICAL_STATUS.NAME\"></label><input type=\"text\" maxlength=\"255\" required \nng-model=\"statusToEdit.name\" name=\"name\"><div ng-messages=\"editStatusForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Obligatoire.</span></div></div></md-input-container><md-input-container class=\"\"><label \ntranslate=\"LOGISTICAL_STATUS.COLOR\"></label><input type=\"text\" maxlength=\"255\" ng-model=\"statusToEdit.color\" \nname=\"color\"></md-input-container></div></div><div class=\"panel-actions panel-actions-keep\" layout=\"row\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-if=\"!status.editionMode\" type=\"button\" \nclass=\"md-fab md-mini md-hue-2\" ng-click=\"edit(status);\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon>\n</md-button><div class=\"ml-15\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"status.editionMode\"><md-button \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"update(status);\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-hue-2\" ng-click=\"cancel(status);\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon>\n</md-button></div><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"remove(status.id);\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(status.index > 0)\" ng-click=\"up(status.id);\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\">\n</md-icon></md-button><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"status.index === statuses.length - 1 || statuses.length <= 1\" ng-click=\"down(status.id);\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/events/popup/add_event.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add event\" flex=\"40\" md-theme=\"teal-theme\"><form name=\"newEventForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"newEventForm.$valid && save(newEventForm)\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'EVENT.NEW\' | translate}}</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"row\" layout-wrap><div class=\"nl-info-block-list-img animated fadeIn\" flex=\"30\">\n<dropify-directive id=\"add_event_dropify\" filesave=\"photo.uploadFile\" name=\"logo\" ng-model=\"event\"></div><div \nflex=\"65\" class=\"\" layout=\"column\"><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nclass=\"\" ng-model=\"event.name\" name=\"name\" required maxlength=\"255\"><label class=\"\" translate=\"EVENT.COLUMNS.NAME\">\n</label><div ng-messages=\"newEventForm.name.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><md-datepicker \nclass=\"nl-Datepicker nl-Datepicker--fw\" ng-model=\"event.start\" name=\"start\" \nmd-placeholder=\"{{\'EVENT.COLUMNS.START\' | translate}}\" md-open-on-focus required=\"\" md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"newEventForm.start.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" \nng-model=\"event.end\" name=\"end\" md-placeholder=\"{{\'EVENT.COLUMNS.END\' | translate}}\" md-open-on-focus \nmd-hide-icons=\"calendar\"></md-datepicker></md-input-container><md-input-container class=\"nl-Input-container ml-15\" \nflex=\"100\"><md-select ng-model=\"event.site\" ng-model-options=\"{trackBy: \'$value.id\'}\" name=\"site\" required><md-option \nng-repeat=\"site in sites | orderBy: \'name\' track by site.id\" ng-value=\"site\">{{site.name}}</md-option></md-select>\n<label class=\"\" translate=\"EVENT.COLUMNS.SITE\"></label><div ng-messages=\"newEventForm.site.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"submit\" \nclass=\"md-primary md-hue-2 md-raised\" ng-disabled=\"newEventForm.$invalid\" aria-label=\"Sauvegarder\" \ntranslate=\"GENERAL.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/festival/popup/deletePhoto.popup.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\"FESTIVAL.DELETE_PHOTO\" | translate}}</div>\n</div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"nl-Popup-content-body\"><div class=\"nl-Popup-content-body-title\">{{\"FESTIVAL.CONFIRM_DELETE_PHOTO\" | translate}}\n</div><br><img ng-src=\"alternatedocroots/{{photoToDelete.location}}\"></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button class=\"md-primary md-raised md-hue-2\" ng-click=\"deletePhotoPermanentely()\" \ntranslate=\"GENERAL.YES\"></md-button><md-button class=\"md-primary md-hue-2\" ng-click=\"hidePopup()\" \ntranslate=\"GENERAL.NO\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/gallery/details/addSubGallery.popup.html","<md-dialog style=\"min-width: 600px\" aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\"GALLERY.POPUP.TITLE_SUB\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"nl-Popup-content-body\"></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gallery/details/details.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"GALLERY.DETAILS.TITLE\"></div></div><div layout=\"row\" layout-align=\"end center\"><md-input-container \nflex><md-select ng-model=\"language.key\" class=\"md-no-underline\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div><div class=\"content\"><md-button ng-click=\"goBack()\" md-no-ink \nclass=\"md-primary md-raised md-hue-2\" translate=\"GALLERY.GO_GALLERIES\"></md-button><div class=\"nl-Block\"><form \nlayout=\"row\" ng-if=\"loaded\" name=\"detailsGalleryForm\" class=\"nl-Form-xs\" \nng-submit=\"detailsGalleryForm.$valid && upate()\"><md-input-container><label>{{\"GALLERY.TITLE\" | translate}}</label>\n<input type=\"text\" ng-model=\"gallery.title\" name=\"title\" required><div ng-messages=\"detailsGalleryForm.title.$error\" \nrole=\"alert\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-button\n type=\"submit\" md-no-ink class=\"md-primary md-raised md-hue-2\" translate=\"GENERAL.SAVE\"></md-button></form><span \nng-if=\"gallery.subGalleries.length > 0\"><div class=\"nl_categories-item-subtitle\">{{\"GALLERY.SUBGALLERIES\" | translate}}\n</div><span ng-repeat=\"sub in gallery.subGalleries | orderBy: \'index\'\"><div class=\"nl_categories-item-subtitle\"><div \nlayout=\"row\" layout-align=\"start center\">{{sub.title}}<md-button ng-click=\"goAddSubGallery(sub)\" md-no-ink \nclass=\"md-primary md-raised md-hue-2\" translate=\"GENERAL.UPDATE\"></md-button><md-button ng-disabled=\"!(sub.index > 0)\" \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"upSub(sub)\"><md-icon md-font-icon=\"icon-arrow-up\" \nclass=\"s18\"></md-icon></md-button><md-button ng-disabled=\"!(sub.index != gallery.subGalleries.length - 1)\" \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"downSub(sub)\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button><md-button class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"showPopUpRemove(sub, $index)\"><md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></div>\n</div>{{\"GALLERY.UUID\" | translate}}: {{sub.uuid}}<div layout=\"row\" layout-wrap><div class=\"m-5 nl-Form-dropify\" \nflex=\"15\" ng-repeat=\"photo in sub.pictures | limitTo: 5 track by $index\" layout=\"column\" layout-align=\"start end\"><div \nclass=\"nl-Form-dropify-wrapper\"><img class=\"nl-Form-dropify has--image\" ng-src=\"alternatedocroots/{{photo.location}}\">\n</div></div></div><span ng-if=\"sub.pictures.length > 5\">{{\"GALLERY.MORE_PICTURES\" | translate}}</span></span></span>\n<md-button ng-click=\"goAddSubGallery()\" md-no-ink class=\"md-primary md-raised md-hue-2\" \ntranslate=\"GALLERY.ADD_SUBGALLERY\"></md-button><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div \nclass=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div \nclass=\"half-circle\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/gallery/details/removeSubGallery.popup.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">\n{{\"GALLERY.DETAILS.POPUP.DELETE_TITLE\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"nl-Popup-content-body\"><div class=\"nl-Popup-content-body-title\">\n{{\"GALLERY.DETAILS.POPUP.CONFIRM_DELETE\" | translate}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button class=\"md-primary md-raised md-hue-2\" ng-click=\"removeSubGallery()\" translate=\"GENERAL.YES\"></md-button>\n<md-button class=\"md-primary md-hue-2\" ng-click=\"hidePopup()\" translate=\"GENERAL.NO\"></md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/gallery/subGallery/subGallery.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nng-if=\"!updateMode\" class=\"\" translate=\"GALLERY.ADD_SUBGALLERY\"></div><div ng-if=\"updateMode\" class=\"\" \ntranslate=\"GALLERY.UPDATE_SUBGALLERY\"></div></div><div layout=\"row\" layout-align=\"end center\"><md-input-container flex>\n<md-select ng-model=\"language.key\" class=\"md-no-underline\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div><div class=\"content\"><md-button ng-click=\"goBack()\" md-no-ink \nclass=\"md-primary md-raised md-hue-2\" translate=\"GALLERY.GO_GALLERY\"></md-button><form name=\"addPSubGalleryForm\" \nclass=\"nl-Form-xs\" ng-submit=\"addPSubGalleryForm.$valid && update()\"><md-input-container><label>\n{{\"GALLERY.TITLE\" | translate}}</label><input type=\"text\" ng-model=\"subGallery.title\" name=\"title\" required><div \nng-messages=\"addPSubGalleryForm.title.$error\" role=\"alert\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><div layout=\"row\" layout-wrap><div \nclass=\"m-5 nl-Form-dropify\" flex=\"15\" ng-repeat=\"photo in subGallery.pictures track by $index\" layout=\"column\" \nlayout-align=\"start end\"><div class=\"nl-Form-dropify-wrapper\"><img class=\"nl-Form-dropify has--image\" \nng-src=\"alternatedocroots/{{photo.location}}\"></div><md-button class=\"md-raised md-warn md-hue-2\" \nng-click=\"displayPopUpDeletePhoto(photo, $index, subGallery)\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon>{{\"GENERAL.DELETE\" | translate}}</md-button></div></div><div class=\"mv-20\"><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"photos.push({})\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\"PACKAGES.ADD.ADD_PHOTO\" | translate}}</md-button><div layout=\"row\" layout-wrap><div class=\"m-5 nl-Form-dropify\" \nflex=\"nogrow\" ng-repeat=\"photo in photos\" layout=\"column\" layout-align=\"start end\"><dropify-directive \nclass=\"dropify-wrapper has--deleteBtn\" filesave=\"photo.uploadFile\" ng-model=\"photo.model\"><md-button type=\"button\" \nclass=\"md-raised md-warn md-hue-2\" ng-click=\"deletePhoto($index)\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon>{{\"PACKAGES.ADD.DELETE_PHOTO\" | translate}}</md-button></div></div></div><md-button type=\"submit\" \nng-disabled=\"updatingPhotos\" md-no-ink class=\"md-primary md-raised md-hue-2\"><span ng-if=\"updatingPhotos\"><div \nclass=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div \nclass=\"right\"><div class=\"half-circle\"></div></div></div></div></span><span ng-if=\"!updatingPhotos\" \ntranslate=\"GENERAL.SAVE\"></span></md-button></form><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div \nclass=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div \nclass=\"half-circle\"></div></div></div></div></div></div></div>");
$templateCache.put("app/main/globe_network/companies/companies.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\">{{subTypeObj.name}}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"_mailingDialogOpenFn()\"><md-icon md-font-icon=\"icon-bullhorn\"></md-icon><span \ntranslate=\"MAILING.DO_MAILING.MAILING_BTN\"></span></md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"showFieldsStats = !showFieldsStats; getStatisticsBySubTypeID(filter);\"><md-icon \nmd-font-icon=\" icon-trending-up\"></md-icon><span translate=\"COMPANIES.GET_STATS_REPART\"></span></md-button><md-button \ntype=\"button\" class=\"md-accent md-hue-1\" ng-click=\"showExport = !showExport\"><md-icon md-font-icon=\"icon-export\">\n</md-icon><span translate=\"COMPANIES.EXPORT.TITLE\"></span></md-button><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"switchActives()\"><md-icon md-font-icon=\"icon-auto-fix\"></md-icon><span \nng-hide=\"!hideAll\" translate=\"USERS.SEE_INACTIVES\"></span> <span ng-show=\"!hideAll\" translate=\"USERS.HIDE_INACTIVES\">\n</span></md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" ng-click=\"showBulkUpdateDialog()\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon>{{\'COMPANIES.BULK_UPDATE\' | translate}}</md-button><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"showBulkMessageDialog()\"><md-icon md-font-icon=\"icon-message\"></md-icon>\n{{\'COMPANIES.BULK_MESSAGE\' | translate}}</md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"showCompanyDialog()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'COMPANIES.ADD\' | translate}}</md-button>\n</div></div><div class=\"content\"><div ng-show=\"showExport\" class=\"nl-Block nl-Block--bordered nl-Block--theme1\" \nstyle=\"margin-bottom: 20px !important\"><form ng-submit=\"exportForm.$valid && launchExport()\" novalidate \nname=\"exportForm\"><div layout=\"row\" layout-wrap><md-input-container flex=\"100\"><label \ntranslate=\"COMPANIES.EXPORT.PRESELECTION_LOADING\"></label><md-select ng-model=\"_exportParams\" name=\"preselection\" \nng-change=\"exportChanged()\"><md-option ng-value=\"null\"></md-option><md-option \nng-repeat=\"export in exports | orderBy: \'name\' track by export.id\" ng-value=\"export\">{{export.name}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"100\"><md-chips class=\"nl-chips nl-chips__floating\" \nng-model=\"_exportParams.companyFields\" name=\"companyFields\" md-on-add=\"addField($chip, _exportParams.companyFields)\">\n<md-autocomplete md-search-text=\"search.company\" md-select-on-match=\"true\" md-autoselect=\"true\" \nmd-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'COMPANIES.EXPORT.COMPANY_FIELDS\' | translate}}\" \nmd-items=\"field in fieldsSelected(companyFields, _exportParams.companyFields) | filter: {libelle: search.company}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container><md-input-container flex=\"100\"><md-chips \nclass=\"nl-chips nl-chips__floating\" ng-model=\"_exportParams.contactFields\" name=\"contactFields\" \nmd-on-add=\"addField($chip, _exportParams.contactFields)\"><md-autocomplete \nmd-floating-label=\"{{\'COMPANIES.EXPORT.CONTACT_FIELDS\' | translate}}\" md-no-cache=\"true\" \nmd-search-text=\"search.contact\" md-select-on-match=\"true\" md-autoselect=\"true\" md-match-case-insensitive=\"true\" \nmd-no-cache=\"true\" \nmd-items=\"field in fieldsSelected(contactFields, _exportParams.contactFields)| filter: {libelle: search.contact}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container><md-input-container flex=\"55\"><label \ntranslate=\"COMPANIES.EXPORT.OPTIONS\"></label><md-select ng-model=\"_exportParams._option\" name=\"option\"><md-option \nng-value=\"\'\'\"></md-option><md-option translate=\"COMPANIES.EXPORT.COMPANY_ONLY\" value=\"COMPANY_ONLY\"></md-option>\n<md-option translate=\"COMPANIES.EXPORT.MEETING_ROOM_CAPACITY\" value=\"MEETING_ROOM_CAPACITY\"></md-option></md-select>\n</md-input-container><md-input-container flex=\"25\"><label translate=\"COMPANIES.EXPORT.ID\"></label><input type=\"text\" \nmaxlength=\"255\" ng-model=\"_exportParams._name\" name=\"name\" autocomplete=\"new-password\"></md-input-container><div \nflex=\"20\"><md-button type=\"button\" class=\"\" ng-click=\"saveExport()\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon>{{\'GENERAL.SAVE\' | translate}}</md-button><md-button type=\"button\" ng-disabled=\"_exportParams.id == null\" \nclass=\"md-warn md-hue-2 md-teal-theme-theme\" ng-click=\"openDeleteExport()\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon>{{\'GENERAL.DELETE\' | translate}}</md-button></div><md-input-container flex=\"100\"><label \ntranslate=\"COMPANIES.EXPORT.SECURITY\"></label><input type=\"password\" ng-model=\"_exportParams.password\" name=\"password\" \nautocomplete=\"new-password\"></md-input-container><div flex=\"100\" layout=\"row\"><md-button type=\"submit\" \nclass=\"md-primary md-hue-2 submit-button md-raised\" flex layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon>{{\'COMPANIES.EXPORT.TITLE\' | translate}}</md-button></div></div></form></div>\n<research-engine-filter model-type=\"COMPANY_MODEL\" sub-type-id=\"subTypeId\" on-filter=\"filterCompanies(filter)\">\n</research-engine-filter><div layout=\"row\"><div ng-if=\"companies.length > 0\" layout=\"row\" layout-align=\"start center\" \nflex=\"50\"><span flex>{{\'COMPANIES.NUMBER_RESULTS\' | translate}}: {{companies[0].nbrResults}}</span> <span flex>\n{{\'COMPANIES.NUMBER_CONTACTS\' | translate}}: {{companies[0].nbContacts}}</span></div><div flex><research-engine-sort \nmodel-type=\"COMPANY_MODEL\" sub-type-id=\"subTypeId\" on-sort=\"sortCompanies(sort)\"></research-engine-sort></div></div>\n<div class=\"nl-Block\" ng-show=\"showFieldsStats\" ng-if=\"fieldsStats.length > 0\"><table \nclass=\"nl-Table nl-Table-doublebody pure-table pure-table-bordered\"><thead><th>\n{{\"STATISTICS.REPARTITION.VALUE\" | translate}}</th><th>{{\"STATISTICS.REPARTITION.NUMBER\" | translate}}</th></thead>\n<tbody ng-repeat=\"field in fieldsStats\"><tr><td colspan=\"2\" style=\"text-align: center; font-weight: bold\">\n{{field.field}}</td></tr><tr ng-repeat=\"stat in field.stats\"><td>{{stat.value}}</td><td>{{stat.number}}</td></tr>\n</tbody></table></div><div class=\"nl-Block nl-Block--table\"><div layout=\"row\"><table \nclass=\"dataTable row-border hover\"><thead><th translate=\"COMPANIES.NAME\"></th><th></th><th></th><th></th><th \ntranslate=\"COMPANIES.SUBTYPES\"></th></thead><tbody><tr ng-repeat=\"company in companies | orderBy: order: reverse\" \nng-click=\"details(company)\"><td><div class=\"nl-Block--table--company\">{{ company.modelPattern }} <span \nng-if=\"!company.activate\" \nstyle=\"background-color: #f44336; color: white;border-radius: 1px;font-size: 10px;font-weight: 500;padding: 2px 4px\" \ntranslate=\"GENERAL.INACTIVE\"></span> <span ng-if=\"!company.checked\" \nstyle=\"background-color: #03a9f4; color: white;border-radius: 1px;font-size: 10px;font-weight: 500;padding: 2px 4px\" \ntranslate=\"GENERAL.NOT_CHECKED\"></span></div><div ng-repeat=\"contact in company.contacts\"><md-icon \nmd-font-icon=\"icon-account\" ng-style=\"{{ !contact.activate ? {\'color\': \'#f44336\'} : {} }}\" class=\"s16\"></md-icon><span \nclass=\"nl-Block--table--newcontact\" ng-click=\"$event.stopPropagation();detailsContact(company.id,contact.id)\">\n{{contact.modelPattern}}</span></div></td><td ng-repeat=\"column in company.columns track by $index\" \nng-click=\"$event.stopPropagation()\"><div class=\"nl-Block--table--company\" \nng-bind-html=\"trustAsHtml(filterModel(company, column.columnIndex))\">{{company | showColumn:column.columnIndex}}</div>\n<div ng-repeat=\"contact in company.contacts\"><div class=\"nl-Block--table--newcontact\" \nng-bind-html=\"trustAsHtml(filterModel(contact, column.columnIndex))\">{{company | showColumn:column.columnIndex}}</div>\n</div></td><td><span ng-repeat=\"subType in company.subTypesNames\">{{subType + ($last ? \'\' : \' / \')}}</span></td></tr>\n</tbody></table></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div \nclass=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\">\n</div></div></div></div></div></div><md-button ng-disabled=\"allLoaded || !loaded\" type=\"button\" class=\"md-accent\" \nng-click=\"getCompanies()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'COMPANIES.LOAD_MORE\' | translate}}</md-button>\n</div></div>");
$templateCache.put("app/main/globe_network/companies/company.html","<div class=\"page-layout simple fullwidth\" md-theme=\"teal-theme\"><md-progress-linear \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" mode=\"indeterminate\" \nng-if=\"_mdProgressLinear\"></md-progress-linear><div class=\"content content-sm nl-Form-xs\" layout=\"row\" \nlayout-align=\"start stretch\" layout-wrap><div flex=\"20\" class=\"nl-Panel\"><div layout=\"column\" layout-wrap><div \nflex=\"100\" layout=\"column\"><div class=\"nl-Block nl-Block--contact nl-Block--customers nl-selected\" layout=\"row\" \nlayout-align=\"center top\" layout-wrap><div flex=\"100\" layout=\"row\" layout-align=\"start center\" \nclass=\"nl-Panel-mainTitle\"><div flex=\"80\" class=\"pl-15\">{{company.modelPattern}}</div><md-input-container flex=\"20\" \nclass=\"nl-Form-SwitchContainer\"><md-switch class=\"md-primary m-0\" ng-model=\"company.activate\" \nng-change=\"setActivated(company.id, company.activate)\"></md-switch></md-input-container></div><div layout=\"row\" \nflex=\"100\"><div class=\"nl-Panel-infos\" flex=\"100\"><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"field in company.valuedFields | orderBy: \'index\'\" \nng-if=\"(field.index != null && field.value) \n				|| (field.index != null && field.values != null && field.values.length > 0)\">\n<div class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s22\"></md-icon></div>\n<div class=\"nl-Panel-infos-text\" ng-if=\"field.index != null && field.value\">{{field.value}}</div><div \nclass=\"nl-Panel-infos-text\" ng-if=\"field.index != null && field.values && field.values.length > 0\"><span \nng-repeat=\"value in field.values  | orderBy: \'libelle\'\">{{ $last ? value.libelle : value.libelle + \' | \' }}</span>\n</div></div></div><div flex=\"20\"><div class=\"nl-Msg-avatar mt-10 mr-10\" ng-if=\"company.profilePictureLocation != null\">\n<img class=\"nl-Msg-avatar-img\" http-src=\"./alternatedocroots/{{company.profilePictureLocation}}\" \nhas-profile-picture=\"true\"></div></div></div></div><div class=\"nl-Block nl-Block--contact nl-Block--customers\" \nng-repeat=\"contact in contacts track by contact.id\" layout=\"row\" layout-align=\"center top\" layout-wrap \nng-click=\"detailsContact(contact.id)\"><div flex=\"100\" layout=\"row\" layout-align=\"start center\" \nclass=\"nl-Panel-mainTitle\"><div flex=\"80\" class=\"pl-15\"><md-icon ng-if=\"company.favouriteId === contact.id\" \nmd-font-icon=\"icon-star\"></md-icon>{{contact.modelPattern}} <span ng-if=\"contact.deleted\">\n({{\'CONTACTS.DELETED\'|translate}})</span></div><md-input-container flex=\"20\" class=\"nl-Form-SwitchContainer\"><md-switch\n class=\"md-primary m-0\" ng-model=\"contact.activate\" ng-change=\"setContactActivated(contact.id, contact.activate)\">\n</md-switch></md-input-container></div><div layout=\"row\" flex=\"100\"><div class=\"nl-Panel-infos\" flex=\"80\" \nng-if=\"contact.valuedFields != null && contact.valuedFields.length > 0\"><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"field in contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\"><div \nclass=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s22\"></md-icon></div><div \nclass=\"nl-Panel-infos-text\">{{field.value}}</div></div></div><div flex=\"20\"><div class=\"nl-Msg-avatar mt-10 mr-10\" \nng-if=\"contact.profilePictureLocation != null\"><img class=\"nl-Msg-avatar-img\" \nhttp-src=\"./alternatedocroots/{{contact.profilePictureLocation}}\" has-profile-picture=\"true\"></div></div></div></div>\n</div></div><div layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" class=\"md-primary\" \nng-click=\"openAddContact()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'CONTACTS.ADD\' | translate}}</md-button>\n</div><div layout=\"row\" layout-align=\"center center\"><md-button ng-hide=\"hiddenContact\" type=\"button\" \nclass=\"md-primary\" ng-click=\"showMoreContacts()\"><md-icon md-font-icon=\"icon-eye\"></md-icon>\n{{\'CONTACTS.SHOW\' | translate}}</md-button><md-button ng-if=\"hiddenContact\" type=\"button\" class=\"md-primary\" \nng-click=\"hideMoreContacts()\"><md-icon md-font-icon=\"icon-eye-off\"></md-icon>{{\'CONTACTS.HIDE\' | translate}}\n</md-button></div><div layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" class=\"md-primary\" \nng-click=\"_lookForContactDuplicates()\" style=\"white-space: normal!important;line-height: 36px!important\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon>{{\'DUPLICATION_TOOL.CONTACT_TITLE\' | translate}}</md-button></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" class=\"md-primary\" \nng-click=\"_contactDuplicatesAutoMergeFn()\" style=\"white-space: normal!important;line-height: 36px!important\"><md-icon \nmd-font-icon=\"icon-flash-auto\"></md-icon>{{\'DUPLICATION_TOOL.CONTACT_AUTO_MERGE_TITLE\' | translate}}</md-button></div>\n<div layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" class=\"md-primary\" ng-click=\"showLogs()\">\n<md-icon md-font-icon=\"icon-timelapse\"></md-icon>{{\'COMPANIES.LOGS\' | translate}}</md-button></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"button\" class=\"md-primary\" ng-click=\"showStatsClicks()\"><md-icon \nmd-font-icon=\"icon-trending-up\"></md-icon>{{\'STATS_CLICKS.TITLE\' | translate}}</md-button></div></div><div flex=\"80\" \nng-if=\"!logsShowed && !statsClicksShowed\"><div class=\"nl-Block\"><div layout=\"row\" class=\"\"><form \nname=\"updateFolderForm\" novalidate=\"\" flex=\"100\"><noo-infos-model ng-model=\"categories\" edition=\"true\" \nform-name=\"updateFolderForm\" sub-type=\"subTypeId\" sub-types=\"subTypes\" model-type=\"modelType\" model=\"company\">\n</noo-infos-model></form></div><div class=\"\"><div class=\"nl_categories-item-title\" layout=\"row\" \nlayout-align=\"space-between center\"><div>{{\"COMPANIES.DISPOSITION.TITLE_CAT\" | translate }}</div><md-button md-no-ink \nclass=\"nl_button--header m-0\" translate=\"COMPANIES.DISPOSITION.ADD\" ng-click=\"openDispositionDialogFn();\"></md-button>\n</div><div layout=\"row\" class=\"nl-Table--wrapper\"><table \nclass=\"dataTable row-border hover nl-Tablegit nl-Table--center\"><thead><tr><th class=\"secondary-text\">\n{{\"COMPANIES.DISPOSITION.NAME\" | translate }}</th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"COMPANIES.DISPOSITION.SQUARE_METTER\"></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"COMPANIES.DISPOSITION.SQUARE_FEET\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"COMPANIES.DISPOSITION.L_W_H\">\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"COMPANIES.DISPOSITION.DAY_LIGHT\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\"><md-tooltip>\n{{\"COMPANIES.DISPOSITION.THEATER\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/theatre.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.CLASS_ROOM\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/classroom.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.BOARD_ROOM\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/boardroom.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.U_STYLE\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/ustyle.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.BANQUET\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/banquet.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.COCKTAIL\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/cocktail.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.CONFERENCE\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/conference.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.CABARET\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/cabaret.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.AUDITORIUM\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/auditorium.svg\"></md-icon></md-button></div></th></tr></thead><tbody><tr \nng-repeat=\"_disposition in company.dispositions track by $index\" ng-click=\"openDispositionDialogFn(_disposition);\"><td>\n{{ _disposition.name }}</td><td>{{ _disposition.squareMeter }}</td><td>{{ _disposition.squareFeet }}</td><td>\n{{ _disposition.length ? _disposition.length : \"xx\" }}/{{ _disposition.width ? _disposition.width : \"xx\" }}/{{ _disposition.height ? _disposition.height : \"xx\" }}\n</td><td>{{ !_disposition.dayLight ? \'COMPANIES.NO\' : \'COMPANIES.YES\' | translate }}</td><td>{{ _disposition.theatre }}\n</td><td>{{ _disposition.classRoom }}</td><td>{{ _disposition.boardRoom }}</td><td>{{ _disposition.uStyle }}</td><td>\n{{ _disposition.banquet }}</td><td>{{ _disposition.cocktail }}</td><td>{{ _disposition.conference }}</td><td>\n{{ _disposition.cabaret }}</td><td>{{ _disposition.auditorium }}</td></tr></tbody></table></div></div></div><div \nclass=\"nl-Block\"><div class=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" \nlayout-align=\"space-between center\"><div>{{\"MESSAGE.TITLE_BLOC\" | translate}}</div><md-button md-no-ink \nclass=\"nl_button--header m-0\" ng-click=\"showPopUpMessage()\" translate=\"MESSAGE.CREATION.NEW\"></md-button></div><div>\n<div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>{{\"MESSAGE.BOX.TITLE\" | translate}}</label>\n<md-select ng-model=\"filter.sender\" aria-label=\"language\" name=\"receiver\" ng-change=\"findAllMessages()\"><md-option \nng-value=\"false\">{{\"MESSAGE.BOX.RECEPTION\" | translate}}</md-option><md-option ng-value=\"true\">\n{{\"MESSAGE.BOX.SENT\" | translate}}</md-option><md-option ng-value=\"null\">{{\"MESSAGE.BOX.ALL\" | translate}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>\n{{\"MESSAGE.TYPE.TITLE\" | translate}}</label><md-select ng-model=\"filter.action\" aria-label=\"language\" name=\"receiver\" \nng-change=\"findAllMessages()\"><md-option ng-value=\"null\">{{\"MESSAGE.TYPE.ALL\" | translate}}</md-option><md-option \nng-value=\"typeAction.TO_DO\">{{\"MESSAGE.TYPE.TO_DO\" | translate}}</md-option><md-option ng-value=\"typeAction.DONE\">\n{{\"MESSAGE.TYPE.DONE\" | translate}}</md-option><md-option ng-value=\"typeAction.ALL\">\n{{\"MESSAGE.TYPE.ALL_ACTION\" | translate}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>{{\"MESSAGE.CORRESPONDANT\" | translate}}</label><md-select md-on-open=\"\" \nmd-on-close=\"filterSelectText = \'\'\" ng-model=\"filter.receiverForm\" aria-label=\"language\" name=\"receiver\" \nmultiple=\"multiple\" ng-change=\"findAllMessages()\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"user in users | filterText: filterSelectText\" value=\"{{user}}\">{{user.fullName}}</md-option></md-select>\n</md-input-container></div><div class=\"nl-form--receivedMsg mt-15\"><table class=\"simple list-view\"><thead><th>\n{{\"MESSAGE.DISPLAY.MESSAGE\" | translate}}</th><th>{{\"MESSAGE.DISPLAY.LINK\" | translate}}</th><th>\n{{\"MESSAGE.DISPLAY.SENDER\" | translate}}</th><th>{{\"MESSAGE.DISPLAY.ACTIONS\" | translate}}</th></thead><tbody><tr \nng-repeat=\"message in messages\" class=\"nl-Msg\"><td><div class=\"nl-form--receivedMsg--subject\">{{message.subject}}</div>\n<div class=\"nl-form--receivedMsg--content\">{{message.content | limitTo: 70}}</div><div ng-if=\"message.action\" \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-check\" \nng-class=\"{\'nl-validated\': message.action.actionDone}\" ng-click=\"confirmAction(message.action)\" layout=\"row\" \nlayout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !message.action.actionDone, \'icon-check\' : message.action.actionDone}\"></i></div><div \nclass=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{message.action.libelle}}</div></div></div></td><td><div \nclass=\"nl-Msg-link-company\">{{message.company.modelPattern}}</div><div class=\"nl-Msg-link-contact\">\n{{message.contact.modelPattern}}</div></td><td><span class=\"nl-Msg-sender-date\">\n{{getDate(message.creationDate) | date:\'dd/MM/yyyy\'}} - {{getDate(message.creationDate) | date:\'HH:mm\'}}</span><div \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-avatar mr-10\"><img class=\"nl-Msg-avatar-img\" \nhttp-src=\"./alternatedocroots/{{message.sender.pictureLocation}}\" \nhas-profile-picture=\"message.sender.pictureLocation != null\"></div><span class=\"nl-Badge\">{{message.sender.fullName}}\n</span></div></td><td><md-button ng-click=\"updateMessage(message)\" class=\"nl-listing-item-button md-accent\" \naria-label=\"Update\">{{\"GENERAL.UPDATE\" | translate}}</md-button></td></tr></tbody></table></div></div></div></div><div \nflex=\"80\" ng-if=\"logsShowed\"><div ng-include=\"\'app/main/globe_network/companies/logs/companyLogs.html\'\" \nng-controller=\"companyLogsController\"></div></div><div flex=\"80\" ng-if=\"statsClicksShowed\"><div \nng-include=\"\'app/main/globe_network/companies/statsClicks/statsClicks.html\'\" ng-controller=\"statsClicksController\">\n</div></div></div></div>");
$templateCache.put("app/main/globe_network/inscriptions/inscriptions_admin.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"INSCRIPTION_ADMIN.PLURAL_TITLE\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"button\" class=\"md-accent md-hue-1\" ng-click=\"_mailingDialogOpenFn()\"><md-icon \nmd-font-icon=\"icon-bullhorn\"></md-icon><span translate=\"MAILING.DO_MAILING.MAILING_BTN\"></span></md-button><md-button \ntype=\"button\" class=\"md-accent md-hue-1\" ng-click=\"showExport = !showExport\"><md-icon md-font-icon=\"icon-export\">\n</md-icon><span translate=\"COMPANIES.EXPORT.TITLE\"></span></md-button><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"_goToInscriptionsAdminSettings();\"><md-icon md-font-icon=\"icon-cog\"></md-icon>\n<span translate=\"INSCRIPTION_ADMIN.SETTINGS.SETTINGS_ACCESS_BUTTON_TITLE\"></span></md-button></div></div><div \nclass=\"content\"><div ng-show=\"showExport\" class=\"nl-Block nl-Block--bordered nl-Block--theme1\" \nstyle=\"margin-bottom: 20px !important\"><form ng-submit=\"exportForm.$valid && launchExport()\" novalidate \nname=\"exportForm\"><div layout=\"row\" layout-wrap><md-input-container flex=\"100\"><label \ntranslate=\"COMPANIES.EXPORT.PRESELECTION_LOADING\"></label><md-select ng-model=\"_exportParams\" name=\"preselection\" \nng-change=\"exportChanged()\"><md-option ng-value=\"null\"></md-option><md-option \nng-repeat=\"export in exports | orderBy: \'name\' track by export.id\" ng-value=\"export\">{{export.name}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"100\"><md-chips class=\"nl-chips nl-chips__floating\" \nng-model=\"_exportParams.inscriptionFields\" name=\"inscriptionFields\" \nmd-on-add=\"addField($chip, _exportParams.inscriptionFields)\"><md-autocomplete md-select-on-match=\"true\" \nmd-autoselect=\"true\" md-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'COMPANIES.EXPORT.INSCRIPTION_FIELDS\' | translate}}\" md-no-cache=\"true\" \nmd-search-text=\"search.inscription\" \nmd-items=\"field in fieldsSelected(inscriptionFields, _exportParams.inscriptionFields) | filter: {libelle: search.inscription}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container><md-input-container flex=\"100\"><md-chips \nclass=\"nl-chips nl-chips__floating\" ng-model=\"_exportParams.logisticFields\" name=\"logisticFields\" \nmd-on-add=\"addField($chip, _exportParams.logisticFields)\"><md-autocomplete md-select-on-match=\"true\" \nmd-autoselect=\"true\" md-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'COMPANIES.EXPORT.LOGISTIC_FIELDS\' | translate}}\" md-no-cache=\"true\" \nmd-search-text=\"search.logistic\" \nmd-items=\"field in fieldsSelected(logisticFields, _exportParams.logisticFields) | filter: {libelle: search.logistic}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container><md-input-container flex=\"100\"><md-chips \nclass=\"nl-chips nl-chips__floating\" ng-model=\"_exportParams.transportFields\" name=\"transportFields\" \nmd-on-add=\"addTransportField($chip, _exportParams.transportFields, _exportParams.transportFields)\"><md-autocomplete \nmd-select-on-match=\"true\" md-autoselect=\"true\" md-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'COMPANIES.EXPORT.TRANSPORT_FIELDS\' | translate}}\" md-no-cache=\"true\" \nmd-search-text=\"search.transport\" \nmd-items=\"field in fieldsSelected(transportFields, _exportParams.transportFields, true) | orderBy: \'translateKey | translate\' | filterTranslate: search.transport\" \nmd-item-text=\"field.key\" md-min-length=\"0\"><span>{{field.translateKey | translate}}</span></md-autocomplete>\n<md-chip-template><span>{{$chip.translateKey | translate}}</span></md-chip-template></md-chips></md-input-container>\n<md-input-container flex=\"100\"><md-chips class=\"nl-chips nl-chips__floating\" ng-model=\"_exportParams.companyFields\" \nname=\"companyFields\" md-on-add=\"addField($chip, _exportParams.companyFields)\"><md-autocomplete \nmd-select-on-match=\"true\" md-autoselect=\"true\" md-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'COMPANIES.EXPORT.COMPANY_FIELDS\' | translate}}\" md-search-text=\"search.company\" \nmd-no-cache=\"true\" \nmd-items=\"field in fieldsSelected(companyFields, _exportParams.companyFields) | filter: {libelle: search.company}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container><md-input-container flex=\"100\"><md-chips \nclass=\"nl-chips nl-chips__floating\" ng-model=\"_exportParams.contactFields\" name=\"contactFields\" \nmd-on-add=\"addField($chip, _exportParams.contactFields)\"><md-autocomplete md-select-on-match=\"true\" \nmd-autoselect=\"true\" md-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'COMPANIES.EXPORT.CONTACT_FIELDS\' | translate}}\" md-search-text=\"search.contact\" \nmd-no-cache=\"true\" \nmd-items=\"field in fieldsSelected(contactFields, _exportParams.contactFields) | filter: {libelle: search.contact}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container><md-input-container flex=\"55\"><label \ntranslate=\"COMPANIES.EXPORT.OPTIONS\"></label><md-select ng-model=\"_exportParams._option\" name=\"option\"><md-option \nng-value=\"\'\'\"></md-option><md-option translate=\"COMPANIES.EXPORT.TRANSPORT_ONLY\" value=\"TRANSPORT_ONLY\"></md-option>\n<md-option translate=\"COMPANIES.EXPORT.DEPARTURE_AND_ARRIVAL\" value=\"DEPARTURE_AND_ARRIVAL\"></md-option></md-select>\n</md-input-container><md-input-container flex=\"25\"><label translate=\"COMPANIES.EXPORT.ID\"></label><input type=\"text\" \nmaxlength=\"255\" ng-model=\"_exportParams._name\" name=\"name\" autocomplete=\"new-password\"></md-input-container><div \nflex=\"20\"><md-button type=\"button\" class=\"\" ng-click=\"saveExport()\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon>{{\'GENERAL.SAVE\' | translate}}</md-button><md-button type=\"button\" ng-disabled=\"_exportParams.id == null\" \nclass=\"md-warn md-hue-2 md-teal-theme-theme\" ng-click=\"openDeleteExport()\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon>{{\'GENERAL.DELETE\' | translate}}</md-button></div><md-input-container flex=\"100\"><label \ntranslate=\"COMPANIES.EXPORT.SECURITY\"></label><input type=\"password\" ng-model=\"_exportParams.password\" name=\"password\" \nautocomplete=\"new-password\"></md-input-container><div flex=\"100\" layout=\"row\"><md-button type=\"submit\" \nclass=\"md-primary md-hue-2 submit-button md-raised\" flex layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon>{{\'COMPANIES.EXPORT.TITLE\' | translate}}</md-button></div></div></form></div>\n<research-engine-filter model-type=\"INSCRIPTION_MODEL\" sub-type-id=\"subTypeId\" \non-filter=\"_filterInscritpionFn(filter)\"></research-engine-filter><div layout=\"row\"><div \nng-if=\"_inscriptions.length > 0\" layout=\"row\" layout-align=\"start center\" flex=\"50\">\n{{\'COMPANIES.NUMBER_RESULTS\' | translate}}: {{_inscriptions[0].nbrResults}}</div><div flex><research-engine-sort \nmodel-type=\"INSCRIPTION_MODEL\" sub-type-id=\"subTypeId\" on-sort=\"_sortInscriptionFn(sort)\"></research-engine-sort></div>\n</div><div class=\"nl-Block nl-Block--table\"><div layout=\"row\"><table class=\"dataTable row-border hover\"><thead><th \ntranslate=\"EVENT.TITLE\"></th><th translate=\"SETTINGS.DATABASE.CONTACT.TITLE\"></th><th \ntranslate=\"SETTINGS.DATABASE.COMPANY.TITLE\"></th><th translate=\"SETTINGS.DATABASE.TYPES.TITLE\"></th><th></th><th></th>\n<th></th><th translate=\"LOGISTIC.COLUMN_TITLE\"></th></thead><tbody><tr \nng-repeat=\"_inscription in _inscriptions | orderBy: order: reverse\" ng-click=\"_inscriptionDetails(_inscription)\"><td>\n<div class=\"nl-Block--table--company\">{{ _inscription.eventName }}</div></td><td><div class=\"nl-Block--table--company\">\n{{ _inscription.contactPattern }}</div></td><td><div class=\"nl-Block--table--company\">{{ _inscription.companyPattern }}\n</div></td><td><span ng-repeat=\"subType in _inscription.subTypesNames\">{{subType + ($last ? \'\' : \' / \')}}</span></td>\n<td ng-repeat=\"_column in _inscription.columns track by $index\"><div class=\"nl-Block--table--company\" \nng-bind-html=\"trustAsHtml(filterModel(_inscription, _column.columnIndex))\">\n{{_inscription | showColumn:_column.columnIndex}}</div></td><td layout=\"row\" ng-click=\"$event.stopPropagation()\">\n<md-button type=\"button\" ng-click=\"_inscriptionDetails(_inscription)\" translate=\"LOGISTIC.CONTACT\"></md-button>\n<md-button type=\"button\" ng-if=\"_inscription.logisticId != null\" ng-click=\"logisticDetails(_inscription)\" \ntranslate=\"LOGISTIC.COLUMN_TITLE\"></md-button></td></tr></tbody></table></div><div class=\"nl-loader\" ng-show=\"!loaded\">\n<div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div>\n<div class=\"right\"><div class=\"half-circle\"></div></div></div></div></div></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" class=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\">\n<md-button ng-disabled=\"allLoaded || !loaded\" type=\"button\" class=\"md-accent\" ng-click=\"_findInscriptionsFn()\"><md-icon\n md-font-icon=\"icon-plus\"></md-icon>{{\'COMPANIES.LOAD_MORE\' | translate}}</md-button></div></div></div>");
$templateCache.put("app/main/globe_network/mailing/mailing_modal.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Look For Duplicates\" flex=\"40\" md-theme=\"teal-theme\" \nstyle=\"max-width: 65%!important;min-width: 50%!important;max-height: 80%!important\"><form name=\"mailingForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">\n{{\'MAILING.DO_MAILING.MAILING_MODAL_TITLE\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\" ng-disabled=\"inProgress\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"!initDataInProgress\" \nstyle=\"min-height: 60%!important\"><fieldset class=\"standard mt-20 mb-20\"><legend>\n{{\"MAILING.DO_MAILING.FIELD_TO_LINK_FOR_EMAIL_ADDRESS_LEGEND\" | translate}}</legend><md-input-container class=\"\">\n<md-select name=\"_fieldForEmailAdr\" ng-model=\"dto.fieldLinkDestAdrEmail\" \nplaceholder=\"{{\'MAILING.DO_MAILING.FIELD_TO_LINK_FOR_EMAIL_ADDRESS_PLACEHOLDER\' | translate}}\" required \nmd-on-close=\"_searchFieldForEmailAdr = \'\'\" multiple=\"multiple\"><md-select-header><section><input force-select-focus \ntype=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchFieldForEmailAdr\"></section>\n</md-select-header><md-option ng-if=\"(emailFields|filter : { modelType : \'COMPANY_MODEL\' }).length==0\" \nng-repeat=\"field in emailFields | filter : { modelType : \'CONTACT_MODEL\' } | filter : _searchFieldForEmailAdr | orderBy : \'libelle\'\" \nng-value=\"field\">{{field.libelle}}</md-option><md-optgroup label=\"\" \nng-if=\"(emailFields|filter : { modelType : \'COMPANY_MODEL\' }).length>0\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_CONTACT\"></label><md-option \nng-repeat=\"field in emailFields | filter : { modelType : \'CONTACT_MODEL\' } | filter : _searchFieldForEmailAdr | orderBy : \'libelle\'\" \nng-value=\"field\">{{field.libelle}}</md-option></md-optgroup><md-optgroup label=\"\" \nng-if=\"(emailFields|filter : { modelType : \'COMPANY_MODEL\' }).length>0\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\"></label><md-option \nng-repeat=\"field in emailFields | filter : { modelType : \'COMPANY_MODEL\' } | filter : _searchFieldForEmailAdr | orderBy : \'libelle\'\" \nng-value=\"field\">{{field.libelle}}</md-option></md-optgroup></md-select><div class=\"\" \nng-messages=\"mailingForm.form._fieldForEmailAdr.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></fieldset><md-input-container class=\"\">\n<md-select name=\"page\" ng-model=\"dto.page\" \nplaceholder=\"{{\'MAILING.DO_MAILING.SELECT_TEMPLATE_PLACEHOLDER\' | translate}}\" md-on-close=\"_searchPage = \'\'\" required>\n<md-select-header><section><input force-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"_searchPage\"></section></md-select-header><md-option \nng-repeat=\"page in pages | filter : _searchPage | orderBy : \'name\' track by page.id\" ng-value=\"page\">{{page.name}}\n</md-option></md-select><label>{{\'MAILING.DO_MAILING.SELECT_TEMPLATE_LABEL\' | translate}}</label><div class=\"\" \nng-messages=\"mailingForm.form.page.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"dto.page\"><md-select name=\"language\" ng-model=\"dto.page.language\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS.SELECT_LANGUAGE_PLACEHOLDER\' | translate}}\" ng-change=\"_changeLanguageFn();\" \nrequired ng-model-options=\"{trackBy: \'$value.key\'}\"><md-option ng-repeat=\"lang in languages | orderBy : \'libelle\'\" \nng-value=\"lang\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select><label>\n{{\'MAILING.DO_MAILING.SELECT_LANGUAGE_LABEL\' | translate}}</label><div class=\"\" \nng-messages=\"mailingForm.form.language.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></md-dialog-content><md-dialog-content \nng-if=\"initDataInProgress || inProgress\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\"><md-progress-circular \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" md-mode=\"indeterminate\">\n</md-progress-circular></div></md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button \ntype=\"submit\" ng-click=\"doAMailing(mailingForm)\" class=\"md-primary md-hue-2 submit-button md-raised\" \nng-disabled=\"mailingForm.$invalid || mailingForm.$pristine || initDataInProgress || inProgress\" aria-label=\"Submit\">\n{{\'MAILING.DO_MAILING.SEND_BTN\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/home/popup/actionsToDo.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\"ACTION_TO_DO\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" ng-repeat=\"message in actionsToDo\" class=\"mb-15\"><div flex=\"50\"><div \nclass=\"nl-form--receivedMsg--subject\">{{message.subject}}</div><div class=\"mt-5 nl-form--receivedMsg--content\">\n{{message.content | limitTo: 70}}</div><div class=\"mt-5\" ng-if=\"message.action\"><div \nclass=\"nl-Table-message-action-title\">{{message.action.libelle}}</div></div><div class=\"action_deadline mute mt-5\">\n{{\"MESSAGE.LIMIT\" | translate}}: {{getDate(message.action.dateAction) | date:\'dd/MM/yyyy\'}} - {{getDate(message.action.dateAction) | date:\'HH:mm\'}}\n</div></div><div flex=\"50\"><div class=\"ml-15\" ng-if=\"message.company != null\"><div translate=\"GENERAL.COMPANY\" \nstyle=\"font-weight: 500\"></div><a href=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\">\n{{message.company.modelPattern}}</a></div><div class=\"ml-15\" ng-if=\"message.contact != null\"><div \ntranslate=\"GENERAL.CONTACT\" style=\"font-weight: 500\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n{{message.contact.modelPattern}}</a></div><div class=\"ml-15\" \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div><div class=\"ml-15\" \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div></div></div></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button ng-click=\"hidePopup()\" class=\"md-primary md-raised md-hue-2\" \naria-label=\"Sauvegarder\">{{\"GENERAL.OK\" | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/home/popup/lateActions.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\"ACTION_NOT_DONE\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" ng-repeat=\"message in actionsNotDone\" class=\"mb-15\"><div flex=\"50\">\n<div class=\"nl-form--receivedMsg--subject\">{{message.subject}}</div><div class=\"mt-5 nl-form--receivedMsg--content\">\n{{message.content | limitTo: 70}}</div><div class=\"mt-5\" ng-if=\"message.action\"><div \nclass=\"nl-Table-message-action-title\">{{message.action.libelle}}</div></div><div class=\"action_deadline mute mt-5\">\n{{\"MESSAGE.LIMIT\" | translate}}: {{getDate(message.action.dateAction) | date:\'dd/MM/yyyy\'}} - {{getDate(message.action.dateAction) | date:\'HH:mm\'}}\n</div></div><div flex=\"50\"><div class=\"ml-15\" ng-if=\"message.company != null\"><div translate=\"GENERAL.COMPANY\" \nstyle=\"font-weight: 500\"></div><a href=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\">\n{{message.company.modelPattern}}</a></div><div class=\"ml-15\" ng-if=\"message.contact != null\"><div \ntranslate=\"GENERAL.CONTACT\" style=\"font-weight: 500\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n{{message.contact.modelPattern}}</a></div><div class=\"ml-15\" \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div><div class=\"ml-15\" \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div></div></div></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button ng-click=\"hidePopup()\" class=\"md-primary md-raised md-hue-2\" \naria-label=\"Sauvegarder\">{{\"GENERAL.OK\" | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/home/popup/senderActionsDone.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\"ACTION_DONE\" | translate}}</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"row\" ng-repeat=\"message in senderActionsDone\" class=\"mb-15\"><div flex=\"50\"><div \nclass=\"nl-form--receivedMsg--subject\">{{message.subject}}</div><div class=\"mt-5 nl-form--receivedMsg--content\">\n{{message.content | limitTo: 70}}</div><div class=\"mt-5\" ng-if=\"message.action\"><div \nclass=\"nl-Table-message-action-title\">{{message.action.libelle}}</div></div><div class=\"action_deadline mute mt-5\">\n{{\"MESSAGE.LIMIT\" | translate}}: {{getDate(message.action.dateAction) | date:\'dd/MM/yyyy\'}} - {{getDate(message.action.dateAction) | date:\'HH:mm\'}}\n</div></div><div flex=\"50\"><div class=\"ml-15\" ng-if=\"message.company != null\"><div translate=\"GENERAL.COMPANY\" \nstyle=\"font-weight: 500\"></div><a href=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\">\n{{message.company.modelPattern}}</a></div><div class=\"ml-15\" ng-if=\"message.contact != null\"><div \ntranslate=\"GENERAL.CONTACT\" style=\"font-weight: 500\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n{{message.contact.modelPattern}}</a></div><div class=\"ml-15\" \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div><div class=\"ml-15\" \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div></div></div></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button ng-click=\"hidePopup()\" class=\"md-primary md-raised md-hue-2\" \naria-label=\"Sauvegarder\">{{\"GENERAL.OK\" | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/mailing/blocs/blocs.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"MAILING.BLOCS.TITLES\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"button\" class=\"\" ng-click=\"_blocDetailsFn()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>{{\'MAILING.BLOCS.ADD\' | translate}}</md-button></div></div><div class=\"content\"><div\n class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table class=\"dataTable row-border hover\"><thead><tr><th><div>\n{{\'MAILING.BLOCS.FIELDS.NAME\' | translate}}</div><div><input type=\"text\" ng-model=\"search.name\" \nplaceholder=\"{{\'MAILING.BLOCS.FIELDS_SEARCH.NAME\' | translate}}\"></div></th><th><div>\n{{\'MAILING.BLOCS.FIELDS.TYPE\' | translate}}</div><div><input type=\"text\" ng-model=\"search.type\" \nplaceholder=\"{{\'MAILING.BLOCS.FIELDS_SEARCH.TYPE\' | translate}}\"></div></th></tr></thead><tbody><tr \nng-repeat=\"_bloc in blocs | filter:search | orderBy : \'name\' track by $index\" ng-click=\"_blocDetailsFn(_bloc.id);\"><td>\n{{ _bloc.name }}</td><td>{{ _bloc.type }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/mailing/pages/pages.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"MAILING.PAGES.TITLES\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"button\" class=\"\" ng-click=\"_pageDetailsFn()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>{{\'MAILING.PAGES.ADD\' | translate}}</md-button></div></div><div class=\"content\"><div\n class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table class=\"dataTable row-border hover\"><thead><tr><th><div>\n{{\'MAILING.PAGES.FIELDS.NAME\' | translate}}</div><div><input type=\"text\" ng-model=\"search.name\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS_SEARCH.NAME\' | translate}}\"></div></th><th><div>\n{{\'MAILING.PAGES.FIELDS.BLOCS\' | translate}}</div><div><input type=\"text\" ng-model=\"search.pageBlocs.bloc.name\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS_SEARCH.BLOCS\' | translate}}\"></div></th></tr></thead><tbody><tr \nng-repeat=\"_page in pages | filter:search  | orderBy: \'name\' track by $index\" ng-click=\"_pageDetailsFn(_page.id);\"><td>\n{{ _page.name }}</td><td><span ng-repeat=\"_pageBloc in _page.pageBlocs | orderBy: \'bloc.name\' track by $index\" \nclass=\"mr-5 md-grey-300-bg p-5\">{{ _pageBloc.bloc.name }}</span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/mailing/triggers/triggers.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"MAILING.TRIGGERS.TITLES\"></div></div>\n<div layout=\"row\" layout-align=\"start center\"><md-button type=\"button\" class=\"\" ng-click=\"_triggerDetailsFn()\"><md-icon\n md-font-icon=\"icon-plus\"></md-icon>{{\'MAILING.TRIGGERS.ADD\' | translate}}</md-button></div></div><div class=\"content\">\n<div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table class=\"dataTable row-border hover\"><thead><tr><th>\n<div>{{\'MAILING.TRIGGERS.FIELDS.NAME\' | translate}}</div><div><input type=\"text\" ng-model=\"search.name\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.NAME\' | translate}}\"></div></th><th><div>\n{{\'MAILING.TRIGGERS.FIELDS.TYPE\' | translate}}</div><div><input type=\"text\" ng-model=\"search.type\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.TYPE\' | translate}}\"></div></th><th><div>\n{{\'MAILING.TRIGGERS.FIELDS.MODEL_TYPE\' | translate}}</div><div><input type=\"text\" ng-model=\"search.modelType\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.MODEL_TYPE\' | translate}}\"></div></th><th><div>\n{{\'MAILING.TRIGGERS.FIELDS.FIELD\' | translate}}</div><div><input type=\"text\" ng-model=\"search.field.libelle\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.FIELD\' | translate}}\"></div></th><th><div>\n{{\'MAILING.TRIGGERS.FIELDS.FIELD_VALUE\' | translate}}</div><div><input type=\"text\" ng-model=\"search.fieldValue.value\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.FIELD_VALUE\' | translate}}\"></div></th><th><div>\n{{\'MAILING.TRIGGERS.FIELDS.EVENT\' | translate}}</div><div><input type=\"text\" ng-model=\"search.event.name\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.EVENT\' | translate}}\"></div></th><th><div>\n{{\'MAILING.TRIGGERS.FIELDS.REGISTRATION_FORM\' | translate}}</div><div><input type=\"text\" \nng-model=\"search.registrationForm.name\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.REGISTRATION_FORM\' | translate}}\"></div></th></tr></thead><tbody><tr \nng-repeat=\"_trigger in triggers | filter:search  | orderBy: \'name\' track by $index\" \nng-click=\"_triggerDetailsFn(_trigger.id);\"><td>{{_trigger.name}}</td><td>{{_trigger.type}}</td><td>\n{{_trigger.modelType}}</td><td>{{_trigger.field.libelle}}</td><td>{{_trigger.fieldValue.value}}</td><td>\n{{_trigger.event.name}}</td><td>{{_trigger.registrationForm.name}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/media/popup/document_popup.html","<md-dialog class=\"document-dialog\" aria-label=\"Document\" flex=\"40\" md-theme=\"teal-theme\"><form name=\"documentForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"documentForm.$valid && saveDocument()\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'FOLDERS.UPLOAD_FILE\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"$mdDialog.cancel();\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><md-input-container class=\"nl-Input-container\" flex=\"100\" \nng-class=\"{\'md-input-invalid\': error.file}\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\n{{\"FOLDERS.FILE\" | translate}}</label><input type=\"file\" name=\"file\" required id=\"document_input_file\" placeholder=\"\">\n<div ng-messages=\"error\" role=\"alert\"><div ng-message=\"file\"><span>{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</div></md-input-container></md-dialog-content><md-dialog-actions class=\"pr-25\"><md-button type=\"submit\" \nclass=\"md-primary md-hue-2 md-raised\" aria-label=\"Ajouter\">{{\"GENERAL.SAVE\" | translate}}</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/message/popup/update_message.html","<md-dialog style=\"min-width: 600px\" aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\"GENERAL.UPDATE\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"nl-Popup-content-body\"><form name=\"formCreateMessage\" novalidate>\n<md-input-container><label>{{\"MESSAGE.CREATION.RECEIVER\" | translate}}</label><md-select \nng-model=\"message.receiverForm\" aria-label=\"language\" name=\"receiver\"><md-option value=\"null\">\n{{\"MESSAGE.CREATION.ALL_USERS\" | translate}}</md-option><md-optgroup label=\"{{\'MESSAGE.CREATION.USERS\' | translate}}\">\n<md-option ng-repeat=\"user in users\" value=\"{{user}}\">{{user.fullName}}</md-option></md-optgroup></md-select>\n</md-input-container><div class=\"nl_categories-item-subtitle mb-15\">{{\"MESSAGE.CREATION.ACTION_REQUEST\" | translate}}\n</div><div layout=\"column\"><md-input-container flex=\"100\" class=\"mb-0\"><label>{{\"MESSAGE.CREATION.ACTION\" | translate}}\n</label><md-select ng-model=\"message.actionForm\" name=\"action\" aria-label=\"language\"><md-option ng-value=\"null\">\n{{\"MESSAGE.CREATION.NO_ACTION\" | translate}}</md-option><md-option ng-repeat=\"action in actions\" value=\"{{action}}\">\n{{action.libelle}}</md-option></md-select></md-input-container><md-input-container ng-if=\"message.actionForm != null\" \nflex=\"100\" class=\"mb-0\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-hide-icons=\"calendar\" \nng-model=\"message.startDateForm\" name=\"actionDate\" md-placeholder=\"{{\'MESSAGE.CREATION.DATE\' | translate}}\" \nmd-open-on-focus ng-required=\"message.actionForm != null\"></md-datepicker><div class=\"pl-20\" \nng-messages=\"formCreateMessage.actionDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"message.actionForm != null\" flex=\"100\" class=\"mb-0\"><label class=\"input-prefix\">\n{{\'MESSAGE.CREATION.HOUR\' | translate}} hh:mm</label><input type=\"text\" class=\"input-value\" name=\"actionTime\" \nng-model=\"message.startTime\" ui-time-mask=\"short\" required><div class=\"pl-20\" \nng-messages=\"formCreateMessage.actionTime.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div><div ng-message=\"time\"><span>\n{{\"GENERAL.FORM.INVALID_FORMAT\" | translate}} (hh:mm)</span></div></div><div ng-if=\"timeNotMatch\" \nclass=\"ng-scope nl_form-error-input\"><span>{{\"FESTIVAL.TIME_ERROR\" | translate}}</span></div></md-input-container>\n<md-input-container ng-if=\"message.actionForm !== null\" class=\"m-0\" flex=\"100\"><md-switch class=\"md-primary\" \nng-model=\"message.actionDone\" aria-label=\"Switch 1\">{{\"MESSAGE.CREATION.DONE\" | translate}}</md-switch>\n</md-input-container></div><div class=\"nl_categories-item-subtitle mb-15\">{{\"MESSAGE.TITLE\" | translate}}</div><div \nlayout=\"column\"><md-input-container class=\"md-block mb-0\" flex-gt-sm><label>{{\"MESSAGE.CREATION.SUBJECT\"|translate}}\n</label><input ng-model=\"message.subject\" name=\"subject\" maxlength=\"255\" required><div class=\"pl-20\" \nng-messages=\"formCreateMessage.subject.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex-gt-sm><label>{{\"MESSAGE.CREATION.CONTENT\"|translate}}</label><textarea rows=\"4\" ng-model=\"message.content\" \nname=\"content\" required></textarea><div class=\"pl-20\" ng-messages=\"formCreateMessage.content.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><md-button \nmd-no-ink class=\"md-raised md-primary\" ng-disabled=\"formCreateMessage.$invalid\" ng-click=\"saveMessage()\">\n{{\"GENERAL.SAVE\" | translate }}</md-button><md-button md-no-ink class=\"md-accent md-hue-2\" aria-label=\"Annuler\" \nng-click=\"cancelFormMessage()\">{{\"GENERAL.CANCEL\" | translate }}</md-button></form></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/packages/add/addPackage.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><span \nng-if=\"package.id == null\" translate=\"PACKAGES.ADD.TITLE\"></span> <span ng-if=\"package.id != null\" \ntranslate=\"PACKAGES.UPDATE.TITLE\"></span></div><div layout=\"row\" layout-align=\"end center\"><md-input-container flex>\n<md-select ng-change=\"langageChanged()\" ng-model=\"language.key\" class=\"md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div class=\"content\"><div class=\"nl-Block\"><form name=\"addPackageForm\" \nclass=\"nl-Form-xs\" ng-submit=\"addPackageForm.$valid && add()\"><md-input-container class=\"nl-Input-container\"><label>\n{{\"GENERAL.COMPANY\" | translate}}</label><md-select ng-model=\"package.companyID\" name=\"company\" required><md-option \nng-value=\"company.id\" ng-repeat=\"company in companies | orderBy: \'modelPattern\'\">{{company.modelPattern}}</md-option>\n</md-select><div ng-messages=\"addPackageForm.company.$error\" role=\"alert\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container><label>\n{{\"PACKAGES.COLUMNS.NAME\" | translate}}</label><input type=\"text\" ng-model=\"package.name\" name=\"name\" required><div \nng-messages=\"addPackageForm.name.$error\" role=\"alert\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container><label>{{\"PACKAGES.COLUMNS.DURATION\" | translate}}</label><input \ntype=\"number\" ng-model=\"package.duration\" name=\"duration\" required><div ng-messages=\"addPackageForm.duration.$error\" \nrole=\"alert\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container>\n<md-input-container class=\"nl-Input-container\"><label>{{\"PACKAGES.COLUMNS.REGION\" | translate}}</label><md-select \nmultiple=\"multiple\" ng-model=\"package.regions\" ng-model-options=\"{trackBy: \'$value.id\'}\" aria-label=\"region\" \nname=\"region\" required><md-option ng-repeat=\"region in regions\" ng-value=\"region\">{{region.value}}</md-option>\n</md-select><div ng-messages=\"addPackageForm.region.$error\" role=\"alert\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><br><md-input-container class=\"nl-Input-container\">\n<label>{{\"PACKAGES.COLUMNS.TYPE\" | translate}}</label><md-select multiple=\"multiple\" ng-model=\"package.typesTourisme\" \nng-model-options=\"{trackBy: \'$value.id\'}\" aria-label=\"tourism\" name=\"tourism\" required><md-option \nng-repeat=\"tourism in tourisms\" ng-value=\"tourism\">{{tourism.value}}</md-option></md-select><div \nng-messages=\"addPackageForm.tourism.$error\" role=\"alert\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><div class=\"nl_Trix\"><label class=\"nl_Trix-label\">Description</label><ng-quill-editor\n ng-model=\"package.description\"></ng-quill-editor></div><md-input-container \nng-if=\"userService.isUserAdmin() || userService.isUserLinkedToAssociations()\"><md-checkbox name=\"\" class=\"md-primary\" \nng-model=\"package.publish\" aria-label=\"publish\">{{\"FESTIVAL.CREATION.PUBLISH\"|translate}}</md-checkbox>\n</md-input-container><div ng-if=\"updateMode\" class=\"mv-20\"><div layout=\"row\" layout-wrap><div \nclass=\"m-5 nl-Form-dropify\" flex=\"15\" ng-repeat=\"photo in package.documents track by $index\" layout=\"column\" \nlayout-align=\"start end\"><div class=\"nl-Form-dropify-wrapper\"><img class=\"nl-Form-dropify has--image\" \nng-src=\"alternatedocroots/{{photo.location}}\"></div><md-button class=\"md-raised md-warn md-hue-2\" \nng-click=\"displayPopUpDeletePhoto(photo, $index)\"><md-icon md-font-icon=\"icon-close-circle-outline\"></md-icon>\n{{\"GENERAL.DELETE\" | translate}}</md-button></div></div></div><div class=\"mv-20\"><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"photos.push({})\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\"PACKAGES.ADD.ADD_PHOTO\" | translate}}</md-button><div layout=\"row\" layout-wrap><div class=\"m-5 nl-Form-dropify\" \nflex=\"nogrow\" ng-repeat=\"photo in photos\" layout=\"column\" layout-align=\"start end\"><dropify-directive \nclass=\"dropify-wrapper has--deleteBtn\" filesave=\"photo.uploadFile\" ng-model=\"photo.model\"><md-button type=\"button\" \nclass=\"md-raised md-warn md-hue-2\" ng-click=\"deletePhoto($index)\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon>{{\"PACKAGES.ADD.DELETE_PHOTO\" | translate}}</md-button></div></div></div><md-button type=\"submit\" md-no-ink \nclass=\"md-primary md-raised md-hue-2\" translate=\"GENERAL.SAVE\"></md-button></form></div></div></div>");
$templateCache.put("app/main/packages/popup/deletePhoto.popup.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">\n{{\"PACKAGES.POPUP_DELETE_PHOTO.TITLE\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"nl-Popup-content-body\"><div class=\"nl-Popup-content-body-title\">\n{{\"PACKAGES.POPUP_DELETE_PHOTO.MESSAGE\" | translate}}</div><br><img \nng-src=\"alternatedocroots/{{photoToDelete.location}}\"></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button md-no-ink class=\"md-primary md-raised md-hue-2\" ng-click=\"deletePhotoPermanentely()\" \ntranslate=\"GENERAL.YES\"></md-button><md-button class=\"md-warn md-hue-2\" ng-click=\"hidePopup()\" translate=\"GENERAL.NO\">\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/settings/database/companies.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h1\"><span><md-icon\n md-font-icon=\"icon-city\" class=\"s24\"></md-icon></span><span translate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\"></span>\n</div></div></div></div><div layout=\"column\" layout-align=\"center end\" flex><md-button \naria-label=\"Ajouter une pharmacie\" class=\"md-fab md-red-600-bg\" ng-click=\"showPharmacyDialog()\"><md-tooltip \nmd-direction=\"bottom\">Ajouter une pharmacie</md-tooltip><md-icon md-font-icon=\"icon-plus\" \nclass=\"md-default-theme md-font material-icons\" role=\"img\" aria-hidden=\"true\"></md-icon></md-button></div></div><div \nclass=\"white-bg md-whiteframe-4dp\"></div></div>");
$templateCache.put("app/main/settings/database/companies_settings.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"SETTINGS.DATABASE.COMPANIES.SETTINGS\"></div></div><div layout=\"row\" layout-align=\"start center\">\n</div></div><div class=\"content\"><div class=\"nl-Block\"><form name=\"fieldLinkForm\" novalidate \nng-submit=\"fieldLinkForm.$valid && saveLink()\"><div layout=\"column\"><md-input-container \nng-repeat=\"specific in specifics | orderBy: translate track by $index\"><label \ntranslate=\"{{\'SETTINGS.DATABASE.COMPANIES.\'+specific.type}}\"></label><md-select ng-model=\"specific.fieldModel\" \nng-model-options=\"{\'trackBy\': \'$value.id\'}\" ng-if=\"specific.type !== \'PHOTOS\'\"><md-option ng-value=\"null\"></md-option>\n<md-option ng-repeat=\"field in fields | orderBy: \'libelle\' track by field.id\" ng-value=\"field\">{{field.libelle}}\n</md-option></md-select><md-select ng-model=\"specific.category\" ng-model-options=\"{\'trackBy\': \'$value.id\'}\" \nng-if=\"specific.type === \'PHOTOS\'\"><md-option ng-value=\"null\"></md-option><md-option \nng-repeat=\"category in categories | orderBy: \'index\' track by category.id\" ng-value=\"category\">{{category.name}}\n</md-option></md-select></md-input-container><md-button type=\"submit\" class=\"md-primary md-hue-2 md-raised\" \ntranslate=\"GENERAL.SAVE\"></md-button></div></form></div></div></div>");
$templateCache.put("app/main/settings/database/contacts_settings.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"SETTINGS.DATABASE.CONTACTS.SETTINGS\"></div></div><div layout=\"row\" layout-align=\"start center\">\n</div></div><div class=\"content\"><div class=\"nl-Block mt-20\"><div><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\"><span \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.COLUMNS\"></span></div></div><form name=\"\" role=\"form\" novalidate>\n<div layout=\"column\" ng-repeat=\"column in columns | orderBy: \'columnIndex\'\" ng-form=\"columnForm\"><h3>\nColumn {{column.columnIndex}}</h3><div layout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"\">\n<md-select md-on-close=\"filterSelectText = \'\'\" name=\"selectedField\" ng-model=\"column.selectedField\" placeholder=\"\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option ng-value=\"field\" \nng-repeat=\"field in columnFields | filterText: filterSelectText | orderBy: \'libelle\' track by field.id\" \nng-disabled=\"column.fieldsIds.lastIndexOf(field.id) > -1\"><span ng-if=\"field.modelType\">{{ field.libelle }}</span> \n<span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-select><div \nng-messages=\"columnForm.selectedField.$error\" role=\"alert\"><div ng-message=\"required\"><span>Obligatoire.</span></div>\n</div></md-input-container><div><md-button type=\"button\" class=\"md-raised md-primary md-hue-2\" \nng-click=\"addToColumn(column);\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}\n</md-button></div></div><div ng-repeat=\"field in column.fields | orderBy:\'fieldIndex\'\" class=\"nl-Models-item\"><div>\n<div><div layout=\"row\" layout-align=\"space-between center\"><div><h3 class=\"\">{{field.field.libelle}}</h3></div><div \nclass=\"panel-actions panel-actions-keep\" layout=\"row\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"removeFromColumn(field.id);\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(field.fieldIndex > 1)\" ng-click=\"upField(field.id);\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\">\n</md-icon></md-button><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(field.fieldIndex !== column.fields.length)\" ng-click=\"downField(field.id);\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div></div>\n</form></div><br><div class=\"nl-Block mt-15\"><div class=\"nl_categories-item-title nl_categories-item-title--first\">\n<span translate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.TITLE\"></span></div><div \nng-repeat=\"display in displaysModels | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><h3 class=\"\">{{display.fieldModel.libelle}}</h3></div><md-input-container \nclass=\"\" flex=\"10\"><md-select ng-change=\"setIcon(display)\" name=\"iconFieldContact\" id=\"iconFieldContact\" \nng-model=\"display.icon\" placeholder=\"\"><md-option ng-value=\"undefined\">\n{{\'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.NOTHING\' | translate}}</md-option><md-option ng-value=\"icon.name\" \nng-repeat=\"icon in DISPLAY_MODELS_ICONS\"><md-icon md-font-icon=\"{{icon.value}}\" class=\"s22\"></md-icon></md-option>\n</md-select></md-input-container><div class=\"panel-actions panel-actions-keep\" layout=\"row\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"removeField(display);\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div \nclass=\"ml-15\" layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"goUp(display)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"!(display.index > 0 && displaysModels.length > 1)\"><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button ng-click=\"goDown(display)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"(display.index + 1 == displaysModels.length)\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div><form \nname=\"researchPageCreationFilterForm\" role=\"form\" novalidate><div layout=\"row\" layout-align=\"space-between center\">\n<md-input-container class=\"\"><md-select md-on-close=\"filterSelectTextSecond = \'\'\" name=\"newFieldToFilter\" \nid=\"newFieldToFilter\" ng-model=\"fieldToAdd\" placeholder=\"\"><md-select-header><section><input force-select-focus \ntype=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectTextSecond\"></section>\n</md-select-header><md-option ng-value=\"field\" \nng-repeat=\"field in fieldsAvalaible | filterText: filterSelectTextSecond\"><span ng-if=\"field.modelType\">\n{{ field.libelle }}</span> <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-select>\n<div ng-messages=\"researchPageCreationFilterForm.newFieldToFilter.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Obligatoire.</span></div></div></md-input-container><div><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"addField();\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></form></div></div></div>");
$templateCache.put("app/main/settings/database/database.html","");
$templateCache.put("app/main/settings/message/message_settings.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"SETTINGS.MESSAGE.TITLE\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-input-container><md-select ng-model=\"language.key\" class=\"md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div class=\"content\"><div class=\"nl-Block\"><div><div><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" layout-align=\"space-between center\"><div>\n<span translate=\"SETTINGS.MESSAGE.CREATION_ACTION.CREATE\"></span></div></div></div><div><div><div><form \nclass=\"form-horizontal\" role=\"form\" novalidate name=\"addActionForm\" \nng-submit=\"addActionForm.$valid && saveAction(action,addActionForm)\"><div><div layout=\"row\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"mt-18 mb-0\"><label>\n{{\'SETTINGS.MESSAGE.CREATION_ACTION.NAME\' | translate}} :</label><input type=\"text\" name=\"libelle\" \nng-model=\"action.libelle\" required><div ng-messages=\"addActionForm.libelle.$error\" role=\"alert\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><div><md-button \ntype=\"submit\" md-no-ink type=\"button\" class=\"md-raised md-primary md-hue-2\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"s18\"></md-icon>Ajouter</md-button></div></div></div></form></div></div></div></div></div><div class=\"mt-15\"><div\n ng-repeat=\"action in actions | orderBy:\'index\'\" class=\"nl-Block\"><form \nng-submit=\"updateActionForm.$valid && saveAction(action)\" novalidate name=\"updateActionForm\"><div \nclass=\"page-content container-fluid p-b-0\"><div class=\"panel panel panel-bordered m-b-0\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"mt-18 mb-0\"><input type=\"text\" ng-disabled=\"!action.active\" ng-model=\"action.libelle\" name=\"name_update\" \nrequired><div ng-messages=\"updateActionForm.name_update.$error\" role=\"alert\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div><div layout=\"row\"><div ng-if=\"action.active\">\n<md-button type=\"submit\" class=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-content-save\" \nclass=\"s18\"></md-icon></md-button></div><div ng-if=\"!action.active\"><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"action.active = true;\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s18\"></md-icon></md-button></div><div><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"removeAction(action);\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button></div><div \nclass=\"ml-15\" layout=\"row\" layout-align=\"space-between center\"><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"(action.index === 1)\" ng-click=\"upAction(action.id);\"><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"(action.index === actions.length)\" \nng-click=\"downAction(action.id);\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div>\n</div></div></div></div></form></div></div></div></div>");
$templateCache.put("app/main/settings/research_page_creation/research_page_creation.html","<div id=\"researchPageCreation\" class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.TITLE\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"content\"><div class=\"content\"><div \nng-include=\"\'app/main/settings/research_page_creation/includes/filters.html\'\"></div></div><div class=\"content mt-20\">\n<md-content ng-include=\"\'app/main/settings/research_page_creation/includes/sorting.html\'\"></md-content></div><div \nclass=\"nl-Block mt-20\"><div><div class=\"nl_categories-item-title nl_categories-item-title--first\"><span \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.COLUMNS\"></span></div></div><form name=\"\" role=\"form\" novalidate>\n<div layout=\"column\" ng-repeat=\"column in columns | orderBy: \'columnIndex\'\" ng-form=\"columnForm\"><h3>\nColumn {{column.columnIndex}}</h3><div ng-repeat=\"field in column.fields | orderBy:\'fieldIndex\'\" \nclass=\"nl-Models-item\"><div><div><div layout=\"row\" layout-align=\"space-between center\"><div><h3 class=\"\"><span \nng-hide=\"field.fixField\">{{ field.field.libelle }}</span> <span ng-show=\"field.fixField\">\n{{ \'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.\' + field.fixFieldKey | translate }}</span></h3></div><div \nclass=\"panel-actions panel-actions-keep\" layout=\"row\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"removeFromColumn(field.id);\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(field.fieldIndex > 1)\" ng-click=\"upField(field.id);\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\">\n</md-icon></md-button><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(field.fieldIndex !== column.fields.length)\" ng-click=\"downField(field.id);\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"\"><md-select \nmd-on-close=\"filterSelectText = \'\'\" name=\"selectedField\" ng-model=\"column.selectedField\" placeholder=\"\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option ng-value=\"field\" \nng-repeat=\"field in columnFields | filterText: filterSelectText | orderBy: \'libelle\' track by field.id\" \nng-disabled=\"column.fieldsIds.lastIndexOf(field.id) > -1\" ng-if=\"modelType == \'COMPANY_MODEL\'\"><span>\n{{ field.libelle }}</span></md-option><md-optgroup label=\"\" ng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\"></label><md-option ng-value=\"field\" \nng-repeat=\"field in columnFields | filterText: filterSelectText | orderBy: \'libelle\' track by field.id\" \nng-if=\"field.modelType == companyModelType\"><span>{{ field.libelle }}</span></md-option></md-optgroup><md-optgroup \nlabel=\"\" ng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_CONTACT\"></label>\n<md-option ng-value=\"field\" \nng-repeat=\"field in columnFields | filterText: filterSelectText | orderBy: \'libelle\' track by field.id\" \nng-if=\"field.modelType == contactModelType\"><span>{{ field.libelle }}</span></md-option></md-optgroup><md-optgroup \nlabel=\"\" ng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_INSCRIPTION\">\n</label><md-option ng-value=\"field\" \nng-repeat=\"field in columnFields | filterText: filterSelectText | orderBy: \'libelle\' track by field.id\" \nng-if=\"field.modelType == registrationModelType || field.fixFieldKey == \'FIXE_FIELD_REGISTRATION_SUBCATEGORY\' \n                        || field.fixFieldKey == \'FIXE_FIELD_REGISTRATION_STATUS\'\">\n<span>{{ field.libelle }}</span></md-option></md-optgroup><md-optgroup label=\"\" \nng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_LOGISTIC\"></label><md-option \nng-value=\"field\" \nng-repeat=\"field in columnFields | filterText: filterSelectText | orderBy: \'libelle\' track by field.id\" \nng-if=\"field.modelType == logisticModelType || field.fixFieldKey == \'FIXE_FIELD_LOGISTIC_STATUS\'\"><span>\n{{ field.libelle }}</span></md-option></md-optgroup></md-select><div ng-messages=\"columnForm.selectedField.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\'GENERAL.REQUIRED\' | translate}}</span></div></div>\n</md-input-container><div><md-button type=\"button\" class=\"md-raised md-primary md-hue-2\" \nng-click=\"addToColumn(column);\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}\n</md-button></div></div></div></form></div><br><div class=\"nl-Block mt-15\" ng-if=\"modelType != \'INSCRIPTION_MODEL\'\">\n<div class=\"nl_categories-item-title nl_categories-item-title--first\"><span \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.TITLE\"></span></div><div \nng-repeat=\"display in displaysModels | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><h3 class=\"\">{{display.fieldModel.libelle}}</h3></div><md-input-container \nclass=\"\" flex=\"10\"><md-select ng-change=\"setIcon(display)\" name=\"iconFieldContact\" id=\"iconFieldContact\" \nng-model=\"display.icon\" placeholder=\"\"><md-option ng-value=\"undefined\">\n{{\'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.NOTHING\' | translate}}</md-option><md-option ng-value=\"icon.name\" \nng-repeat=\"icon in DISPLAY_MODELS_ICONS\"><md-icon md-font-icon=\"{{icon.value}}\" class=\"s22\"></md-icon></md-option>\n</md-select></md-input-container><div class=\"panel-actions panel-actions-keep\" layout=\"row\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"removeField(display);\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div \nclass=\"ml-15\" layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"goUp(display)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"!(display.index > 0 && displaysModels.length > 1)\"><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button ng-click=\"goDown(display)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"(display.index + 1 == displaysModels.length)\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div><form \nname=\"researchPageCreationFilterForm\" role=\"form\" novalidate><div layout=\"row\" layout-align=\"space-between center\">\n<md-input-container class=\"\"><md-select md-on-close=\"filterSelectTextSecond = \'\'\" name=\"newFieldToFilter\" \nid=\"newFieldToFilter\" ng-model=\"fieldToAdd\" placeholder=\"\"><md-select-header><section><input force-select-focus \ntype=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectTextSecond\"></section>\n</md-select-header><md-option ng-value=\"field\" \nng-repeat=\"field in fieldsAvalaible | filterText: filterSelectTextSecond\"><span ng-if=\"field.modelType\">\n{{ field.libelle }}</span> <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-select>\n<div ng-messages=\"researchPageCreationFilterForm.newFieldToFilter.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>{{\'GENERAL.REQUIRED\' | translate}}</span></div></div></md-input-container><div><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"addField();\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></form></div></div></div>");
$templateCache.put("app/main/sitegen/account/account_activation.html","<div ng-if=\"loading\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\">\n{{\'SITE_GEN.ACCOUNT.NEW_ACCOUNT_ACTIVATED_MSG_WAITING\' | translate}}</div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" class=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\">\n<md-progress-circular class=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></div><div ng-if=\"!loading\"><div layout=\"row\" \nclass=\"nl-Form-xs pt-20\"><div flex=\"30\"></div><div flex=\"40\"><form name=\"activateAccountForm\" novalidate \nng-submit=\"activateAccountForm.$valid && activateAccountRequest(activateAccountForm)\" autocomplete=\"off\" class=\"\"><div \nstyle=\"text-align:center!important\">{{\"SITE_GEN.ACCOUNT.ACTIVATE_MY_ACCOUNT\" | translate}}</div><div class=\"pt-40\">\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"email\" class=\"\" ng-model=\"usermail.value\" \nname=\"mail\" required><label class=\"\" translate=\"USERS.EMAIL\"></label><div \nng-messages=\"activateAccountForm.mail.$error\" class=\"nl-fixeDivError\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span> <span ng-message=\"email\">{{\'GENERAL.PATTERN\' | translate}}</span></div>\n</md-input-container><div class=\"remember-forgot-password\" style=\"text-align:center!important\"><md-button \ntype=\"submit\" class=\"nl-Btn nl-Btn-primary md-button md-default-theme md-ink-ripple\">\n{{\'SITE_GEN.ACCOUNT.REACTIVATE_ACCOUNT\' | translate}}</md-button></div></div></form></div><div flex=\"30\"></div></div>\n</div>");
$templateCache.put("app/main/sitegen/account/forgot_login.html","<div class=\"nl_Row-content\"><div class=\"nl--Container\"><div class=\"nl--Steps--contentNoTabs\"><div layout=\"row\" \nclass=\"nl-Form-xs\"><div flex=\"20\"></div><div flex=\"60\"><form name=\"forgotLoginForm\" novalidate \nng-submit=\"forgotLoginForm.$valid && forgotLoginRequest(forgotLoginForm)\" autocomplete=\"off\" class=\"\"><div \nstyle=\"text-align:center!important\">{{\"SITE_GEN.ACCOUNT.LOGIN_FORGOT\" | translate}}</div><div class=\"pt-40\">\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"email\" class=\"\" ng-model=\"usermail.value\" \nname=\"mail\" required><label class=\"\" translate=\"USERS.EMAIL\"></label><div ng-messages=\"forgotLoginForm.mail.$error\" \nclass=\"nl-fixeDivError\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span> <span ng-message=\"email\">\n{{\'GENERAL.PATTERN\' | translate}}</span></div></md-input-container><div class=\"remember-forgot-password\" \nstyle=\"text-align:center!important\"><md-button type=\"submit\" \nclass=\"nl-Btn nl-Btn-primary md-button md-default-theme md-ink-ripple\">\n{{\'SITE_GEN.ACCOUNT.BTN_ACTION_LOGIN_FORGOT_SUBMIT\' | translate}}</md-button></div><div \nclass=\"remember-forgot-password pt-10\" style=\"text-align:center!important\"><a href \nclass=\"forgot-password md-accent-color\" style=\"cursor: pointer\" ng-click=\"goToLoginFn();\">\n{{\'SITE_GEN.ACCOUNT.LOGIN\' | translate}}</a></div></div></form></div><div flex=\"20\"></div></div></div></div></div>");
$templateCache.put("app/main/sitegen/account/forgot_password.html","<div class=\"nl_Row-content\"><div class=\"nl--Container\"><div class=\"nl--Steps--contentNoTabs\"><div layout=\"row\" \nclass=\"nl-Form-xs\"><div flex=\"20\"></div><div flex=\"60\" ng-if=\"!token\"><form name=\"forgotPasswordForm\" novalidate \nng-submit=\"forgotPasswordForm.$valid && forgotPasswordRequest(forgotPasswordForm)\" autocomplete=\"off\" class=\"\"><div \nstyle=\"text-align:center!important\">{{\"SITE_GEN.ACCOUNT.PASSWORD_FORGOT\" | translate}}</div><div class=\"pt-40\">\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"email\" class=\"\" ng-model=\"usermail.value\" \nname=\"mail\" required><label class=\"\" translate=\"USERS.EMAIL\"></label><div ng-messages=\"forgotPasswordForm.mail.$error\" \nclass=\"nl-fixeDivError\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span> <span ng-message=\"email\">\n{{\'GENERAL.PATTERN\' | translate}}</span></div></md-input-container><div class=\"remember-forgot-password\" \nstyle=\"text-align:center!important\"><md-button type=\"submit\" \nclass=\"nl-Btn nl-Btn-primary md-button md-default-theme md-ink-ripple\">\n{{\'SITE_GEN.ACCOUNT.BTN_ACTION_PASSWORD_FORGOT_SUBMIT\' | translate}}</md-button></div><div \nclass=\"remember-forgot-password pt-10\" style=\"text-align:center!important\"><a href \nclass=\"forgot-password md-accent-color\" style=\"cursor: pointer\" ng-click=\"goToLoginFn();\">\n{{\'SITE_GEN.ACCOUNT.LOGIN\' | translate}}</a></div></div></form></div><div flex=\"60\" ng-if=\"token\"><form \nname=\"updateForgotPasswordForm\" novalidate \nng-submit=\"updateForgotPasswordForm.$valid && updateForgotPassword(updateForgotPasswordForm)\" autocomplete=\"off\" \nclass=\"\"><div style=\"text-align:center!important\">{{\"SITE_GEN.ACCOUNT.PASSWORD_FORGOT\" | translate}}</div><div \nclass=\"pt-40\"><md-input-container class=\"md-block ph-80\" md-no-float><input type=\"password\" name=\"newPassword\" \nng-model=\"password.newPassword\" placeholder=\"New password\" required><div \nng-messages=\"updateForgotPasswordForm.newPassword.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'SITE_GEN.ACCOUNT.REQUIRED_FIELD\'| translate}}</span></div></div></md-input-container><md-input-container \nclass=\"md-block ph-80\" md-no-float><input type=\"password\" name=\"confirmNewPassword\" \nng-model=\"password.confirmPassword\" placeholder=\"Confirm new password\" required password-confirm-directive \nmatch-target=\"password.newPassword\"><div ng-messages=\"updateForgotPasswordForm.confirmNewPassword.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\'SITE_GEN.ACCOUNT.REQUIRED_FIELD\'| translate}}</span></div><div ng-message=\"match\">\n<span>{{\'SITE_GEN.ACCOUNT.PASSWORD_CONFIRM_INCORRECT\'| translate}}</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" style=\"text-align:center!important\"><md-button type=\"submit\" \nclass=\"nl-Btn nl-Btn-primary md-button md-default-theme md-ink-ripple\">\n{{\'SITE_GEN.ACCOUNT.BTN_ACTION_PASSWORD_FORGOT_SUBMIT\' | translate}}</md-button></div><div \nclass=\"remember-forgot-password pt-10\" style=\"text-align:center!important\"><a href \nclass=\"forgot-password md-accent-color\" style=\"cursor: pointer\" ng-click=\"goToLoginFn();\">\n{{\'SITE_GEN.ACCOUNT.LOGIN\' | translate}}</a></div></div></form></div><div flex=\"20\"></div></div></div></div></div>");
$templateCache.put("app/main/sitegen/account/login.html","<div class=\"nl-Form-xs pt-20\" style=\"text-align:center;text-transform: uppercase\"><h2>\n{{\"SITE_GEN.ACCOUNT.TITLE\" | translate}}</h2></div><div class=\"nl_Row-content\"><div class=\"nl--Container\"><div \nclass=\"nl--Steps--contentNoTabs\"><div layout=\"row\" class=\"nl-Form-xs pt-20\"><div flex=\"30\"><form name=\"loginForm\" \nnovalidate ng-submit=\"loginForm.$valid && login(loginForm)\" autocomplete=\"off\"><div \nstyle=\"text-align:center!important;font-size:2rem !important\" class=\"nl-titre--main\">\n{{\"SITE_GEN.ACCOUNT.LOGIN\" | translate}}</div><div class=\"nl--Steps--contentNoTabs\" ng-if=\"textActivation\"><div \nlayout=\"row\" layout-align=\"center center\"><h2 class=\"nl--msg-header\">{{textActivation}}</h2></div></div><div \nclass=\"pt-40\"><md-input-container class=\"md-block ph-80\" md-no-float><input type=\"text\" name=\"login\" \nng-model=\"loginDTO.usermail\" placeholder=\"{{\'USERS.ID\' | translate}}\" required><div \nng-messages=\"loginForm.login.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\n{{\'SITE_GEN.ACCOUNT.REQUIRED_FIELD\'| translate}}</span></div></div></md-input-container><md-input-container \nclass=\"md-block ph-80\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"loginDTO.password\" \nplaceholder=\"{{\'USERS.PASSWORD\' | translate}}\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\'SITE_GEN.ACCOUNT.REQUIRED_FIELD\'| translate}}</span></div></div></md-input-container>\n<div class=\"remember-forgot-password pt-10\" style=\"text-align:center!important\"><a \nclass=\"forgot-password md-accent-color\" style=\"cursor: pointer\" ng-click=\"onForgotLogin();\">\n{{\'SITE_GEN.ACCOUNT.LOGIN_FORGOT\' | translate}}</a><br><a class=\"forgot-password md-accent-color\" \nstyle=\"cursor: pointer\" ng-click=\"onForgotPassword();\">{{\'SITE_GEN.ACCOUNT.PASSWORD_FORGOT\' | translate}}</a></div><div\n class=\"remember-forgot-password\" style=\"text-align:center!important\"><md-button type=\"submit\" \nclass=\"nl-Btn nl-Btn-primary md-button md-default-theme md-ink-ripple\">{{\'SITE_GEN.ACCOUNT.LOGIN\' | translate}}\n</md-button></div></div></form></div><div flex=\"10\"><div class=\"nl_navigation--separator\" \nstyle=\"height: 400px!important\"></div></div><div flex=\"60\"><form name=\"newUserForm\" novalidate \nng-submit=\"newUserForm.$valid && register(newUserForm)\" autocomplete=\"off\" class=\"\"><div \nstyle=\"text-align:center!important; font-size: 2rem\" class=\"nl-titre--main\">\n{{\"SITE_GEN.ACCOUNT.CREATE_AN_ACCOUNT\" | translate}}</div><div class=\"nl--Steps--contentNoTabs\" \nng-if=\"registerSuccess\"><div layout=\"row\" layout-align=\"center center\"><h2 class=\"nl--msg-header\">\n{{\'SITE_GEN.ACCOUNT.NEW_ACCOUNT_ACTIVATION_ASK_MSG\' | translate}}</h2></div></div><div class=\"pt-40\"><input \ntype=\"email\" name=\"loginT\" style=\"height: 0; position: absolute; top: -9999px; left: -9999px\"> <input type=\"email\" \nname=\"loginT\" style=\"height: 0; position: absolute; top: -9999px; left: -9999px\"> <input type=\"password\" \nname=\"actualPasswordT\" style=\"height: 0; position: absolute; top: -9999px; left: -9999px\"> <input type=\"password\" \nname=\"actualPasswordT\" style=\"height: 0; position: absolute; top: -9999px; left: -9999px\"><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" ng-model=\"newUser.login\" name=\"login\" required>\n<label>{{\'USERS.ID\' | translate}} *</label><div ng-messages=\"newUserForm.login.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" ng-model=\"newUser.applicantCompany\" \nname=\"applicantCompany\" required><label>{{\"SITE_GEN.ACCOUNT.COMPANY\" | translate}} *</label><div \nng-messages=\"newUserForm.applicantCompany.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container><div layout-sm=\"column\" layout-gt-sm=\"row\"><md-input-container \nclass=\"nl-Input-container ml-15 md-block\" flex=\"100\" flex-gt-xs=\"20\"><md-select md-on-open=\"\" name=\"applicantCivility\" \nng-model=\"newUser.applicantCivility\" ng-model-options=\"{\'trackBy\': \'$value\'}\" required><md-option \nng-repeat=\"civility in civilities | orderBy : \'toString()\' track by $index\" ng-value=\"civility\">{{civility}}\n</md-option></md-select><label class=\"\" translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CIVILITY\"></label>\n<div ng-messages=\"newUserForm.applicantCivility.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15 md-block\" flex=\"100\" \nflex-gt-xs=\"40\"><input type=\"text\" class=\"\" ng-model=\"newUser.applicantFirstName\" name=\"applicantFirstName\" required>\n<label>{{\"USERS.FIRST_NAME\" | translate}} *</label><div ng-messages=\"newUserForm.applicantFirstName.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15 md-block\" flex=\"100\" flex-gt-xs=\"40\"><input type=\"text\" class=\"\" \nng-model=\"newUser.applicantLastName\" name=\"applicantLastName\" required><label>{{\"USERS.LAST_NAME\" | translate}} *\n</label><div ng-messages=\"newUserForm.applicantFirstName.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div><div layout-sm=\"column\" layout-gt-sm=\"row\">\n<md-input-container class=\"nl-Input-container ml-15 md-block\" flex=\"100\" flex-gt-xs=\"50\"><input type=\"email\" class=\"\" \nng-model=\"newUser.mail\" name=\"mail\" required><label>{{\"USERS.EMAIL\" | translate}} *</label><div \nng-messages=\"newUserForm.mail.$error\" class=\"nl-fixeDivError\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span> <span ng-message=\"email\">{{\'GENERAL.PATTERN\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15 md-block\" flex=\"100\" flex-gt-xs=\"50\"><input \ntype=\"text\" class=\"\" ng-model=\"newUser.applicantMobilePhone\" autocomplete=\"off\" name=\"phone\" \nng-pattern=\"/^(?:(?:\\+|00)33|0)\\s*[1-9](?:[\\s.-]*\\d{2}){4}$/\" required><label>{{\"USERS.PHONE\" | translate}} *</label>\n<div ng-messages=\"newUserForm.phone.$error\" class=\"nl-fixeDivError\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span> <span ng-message=\"pattern\">{{\'GENERAL.PATTERN\' | translate}}</span></div>\n</md-input-container></div><md-input-container class=\"nl-Input-container\"><input type=\"password\" autocomplete=\"off\" \nclass=\"\" ng-model=\"newUser.password\" name=\"password\" required><label>{{\"USERS.PASSWORD\" | translate}} *</label><div \nng-messages=\"newUserForm.password.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><div class=\"remember-forgot-password\" style=\"text-align:center!important\"><md-button \ntype=\"submit\" class=\"nl-Btn nl-Btn-primary md-button md-default-theme md-ink-ripple\">\n{{\'SITE_GEN.ACCOUNT.CREATE_AN_ACCOUNT\' | translate}}</md-button></div><div class=\"remember-forgot-password pt-10\" \nstyle=\"text-align:center!important\" ng-if=\"fromAction && fromAction === \'FROM_ON_ASK_FOR_A_QUOTE_ACTION\'\"><a \nclass=\"forgot-password md-accent-color\" style=\"cursor: pointer\" ng-click=\"onAskForAQuoteWithoutLogin();\">\n{{\'SITE_GEN.ACCOUNT.CONTINUE_WITHOUT_ACCOUNT\' | translate}}</a></div></div></form></div></div></div></div></div>");
$templateCache.put("app/main/sitegen/account/my_profile.html","<div class=\"nl_Row-content\"><div class=\"nl--Container\"><div class=\"nl--Steps--contentNoTabs\"><div class=\"nl-Form-xs\">\n<h2 class=\"nl-titre--main nl--center nl-Search__title\">{{\"SITE_GEN.ACCOUNT.MY_PROFIL\" | translate}}</h2></div><div \nlayout=\"row\" class=\"nl-Form-xs\"><div flex=\"15\"></div><div flex=\"70\"><form name=\"myProfilForm\" novalidate \nng-submit=\"myProfilForm.$valid && updateMyProfile(myProfilForm)\" autocomplete=\"off\" class=\"\"><div class=\"\"><fieldset \nclass=\"nl-Fieldset nl-Fieldset--noMarginTop\"><legend>{{\"SITE_GEN.ACCOUNT.MY_PERSONAL_INFORMATION\" | translate}}\n</legend><md-input-container class=\"nl-Input-container pt-10\"><input type=\"text\" class=\"\" ng-model=\"account.login\" \nname=\"login\" required><label class=\"\" translate=\"USERS.ID\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15 pt-10\" flex=\"100\"><input type=\"email\" class=\"\" ng-model=\"account.mail\" name=\"mail\" \nrequired><label class=\"\" translate=\"USERS.EMAIL\"></label></md-input-container></fieldset><fieldset class=\"nl-Fieldset\">\n<legend>{{\"SITE_GEN.ACCOUNT.COMPANY_INFORMATIONS\" | translate}}</legend><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" ng-model=\"account.applicantCompany\" \nname=\"applicantCompany\" required><label class=\"\">{{\"SITE_GEN.ACCOUNT.COMPANY\" | translate}} *</label>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"account.applicantCompanyType\" name=\"applicantCompanyType\" required><label class=\"\">\n{{\"SITE_GEN.ACCOUNT.COMPANY_TYPE\" | translate}} *</label></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" ng-model=\"account.applicantWebSite\" \nname=\"applicantWebSite\"><label class=\"\" translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_WEB_SITE\"></label>\n</md-input-container></fieldset><fieldset class=\"nl-Fieldset\"><legend>\n{{\"SITE_GEN.ACCOUNT.APPLICANT_INFORMATIONS\" | translate}}</legend><md-input-container class=\"nl-Input-container ml-15\" \nflex=\"100\"><md-select md-on-open=\"\" name=\"applicantCivility\" ng-model=\"account.applicantCivility\" \nng-model-options=\"{\'trackBy\': \'$value\'}\" required><md-option \nng-repeat=\"civility in civilities | orderBy : \'toString()\' track by $index\" ng-value=\"civility\">{{civility}}\n</md-option></md-select><label class=\"\" translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CIVILITY\"></label>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"account.applicantFirstName\" name=\"applicantFirstName\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FIRST_NAME\" | translate}} *</label></md-input-container>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"account.applicantLastName\" name=\"applicantLastName\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_LAST_NAME\" | translate}} *</label></md-input-container>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"account.applicantFunction\" name=\"applicantFunction\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FUNCTION\" | translate}} *</label></md-input-container>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"account.applicantAddress1\" name=\"applicantAddress1\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS1\" | translate}} *</label></md-input-container>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"account.applicantAddress2\" name=\"applicantAddress2\"><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS2\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" ng-model=\"account.applicantAddress3\" \nname=\"applicantAddress3\"><label class=\"\" translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS3\"></label>\n</md-input-container><div layout=\"row\" flex><md-input-container class=\"nl-Input-container ml-15\" flex=\"20\"><input \ntype=\"text\" class=\"\" rows=\"3\" ng-model=\"account.applicantPostCode\" name=\"applicantPostCode\"><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_POST_CODE\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"40\"><input type=\"text\" class=\"\" rows=\"3\" ng-model=\"account.applicantCity\" \nname=\"applicantCity\" required><label>{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CITY\" | translate}} *</label>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"40\"><input type=\"text\" class=\"\" \nrows=\"3\" ng-model=\"account.applicantCountry\" name=\"applicantCountry\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COUNTRY\" | translate}} *</label></md-input-container></div>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"account.applicantDirectPhone\" name=\"applicantDirectPhone\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_DIRECT_PHONE\" | translate}} *</label></md-input-container>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"account.applicantMobilePhone\" name=\"applicantMobilePhone\"><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_MOBILE_PHONE\"></label></md-input-container></fieldset><div>\n</div><div class=\"remember-forgot-password pt-10\" style=\"text-align:center!important\"><md-button type=\"submit\" \nclass=\"nl-Btn nl-Btn-primary md-button md-default-theme md-ink-ripple\">\n{{\'SITE_GEN.ACCOUNT.BTN_UPDATE_MY_PROFILE\' | translate}}</md-button></div><div class=\"remember-forgot-password pt-10\" \nstyle=\"text-align:center!important\"><a href class=\"forgot-password md-accent-color\" style=\"cursor: pointer\" \nng-click=\"onUpdateMyPassword();\">{{\'SITE_GEN.ACCOUNT.BTN_ASK_UPDATE_MY_PASSWORD\' | translate}}</a></div></div></form>\n</div><div flex=\"15\"></div></div></div></div></div>");
$templateCache.put("app/main/sitegen/account/update_password.html","<div class=\"nl_Row-content\"><div class=\"nl--Container\"><div class=\"nl--Steps--contentNoTabs\"><div \nclass=\"nl-Form-xs pt-20\" style=\"text-align:center;text-transform: uppercase\"><h2>\n{{\"SITE_GEN.ACCOUNT.UPDATE_MY_PASSWORD_TITLE\" | translate}}</h2></div><div layout=\"row\" class=\"nl-Form-xs\"><div \nflex=\"20\"></div><div flex=\"60\"><form name=\"updatePasswordForm\" novalidate \nng-submit=\"updatePasswordForm.$valid && updateMyPassword(updatePasswordForm)\" autocomplete=\"off\" class=\"\"><div \nclass=\"pt-20\"><md-input-container class=\"md-block ph-80\" md-no-float><input type=\"password\" name=\"actualPassword\" \nng-model=\"password.actualPassword\" placeholder=\"{{\'SITE_GEN.ACCOUNT.ACTUAL_PASSWORD\' | translate}}\" required><div \nng-messages=\"updatePasswordForm.actualPassword.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'SITE_GEN.ACCOUNT.REQUIRED_FIELD\'| translate}}</span></div></div></md-input-container><md-input-container \nclass=\"md-block ph-80\" md-no-float><input type=\"password\" name=\"newPassword\" ng-model=\"password.newPassword\" \nplaceholder=\"{{\'SITE_GEN.ACCOUNT.NEW_PASSWORD\' | translate}}\" required><div \nng-messages=\"updatePasswordForm.newPassword.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'SITE_GEN.ACCOUNT.REQUIRED_FIELD\'| translate}}</span></div></div></md-input-container><md-input-container \nclass=\"md-block ph-80\" md-no-float><input type=\"password\" name=\"confirmNewPassword\" \nng-model=\"password.confirmPassword\" placeholder=\"{{\'SITE_GEN.ACCOUNT.CONFIRM_NEW_PASSWORD\' | translate}}\" required \npassword-confirm-directive match-target=\"password.newPassword\"><div \nng-messages=\"updatePasswordForm.confirmNewPassword.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'SITE_GEN.ACCOUNT.REQUIRED_FIELD\'| translate}}</span></div><div ng-message=\"match\"><span>\n{{\'SITE_GEN.ACCOUNT.PASSWORD_CONFIRM_INCORRECT\'| translate}}</span></div></div></md-input-container><div \nclass=\"remember-forgot-password pt-10\" style=\"text-align:center!important\"><md-button type=\"submit\" \nclass=\"nl-Btn nl-Btn-primary md-button md-default-theme md-ink-ripple\">\n{{\'SITE_GEN.ACCOUNT.BTN_UPDATED_MY_PASSWORD\' | translate}}</md-button></div><div \nclass=\"remember-forgot-password pt-10\" style=\"text-align:center!important\"><a href \nclass=\"forgot-password md-accent-color\" style=\"cursor: pointer\" ng-click=\"goToMyProfil();\">\n{{\'SITE_GEN.ACCOUNT.MY_PROFIL\' | translate}}</a></div></div></form></div><div flex=\"20\"></div></div></div></div></div>");
$templateCache.put("app/main/sitegen/my_selection_of_providers/my_selection_of_providers.html","<div class=\"nl_Row-content\"><div class=\"nl-Form-xs pt-20\"><h2 class=\"nl-titre--main nl--center nl-Search__title\">\n{{\"SITE_GEN.BTN_PROVIDERS_SELECTED_LIST\" | translate}}</h2></div><div \nclass=\"nl-Search__wrapper layout-wrap layout-align-center-stretch layout-row\" ng-if=\"mySelectonOfProviders.length > 0\">\n<div class=\"flex-100 layout-row layout-align-start-end pt-15\"><button type=\"button\" \nclass=\"nl-BtnPure nl-BtnPure--primary nl-BtnPure--centered\" ng-click=\"onAskForAllQuotePure();\"><span>\n{{\'SITE_GEN.BTN_ASK_FOR_ALL_QUOTE\' | translate}} >></span></button></div></div><div class=\"mt-20\"><div \nclass=\"p-15 layout-row layout-wrap\" ng-if=\"mySelectonOfProviders.length > 0\"><div \nclass=\"nl-Article__selection flex-100 flex-gt-sm-50\" \nng-repeat=\"company in mySelectonOfProviders | orderBy: order: reverse track by company.id\"><div \nclass=\"nl-Article__selection__header\"><div class=\"nl-prestataire-search-item-imgWrapper\"><img \nclass=\"nl-prestataire-search-item-img nl-img--logo\" ng-if=\"company.logo != null && company.logo.length > 0\" \nng-src=\"{{URL.alternatedocroots + \'/\' + company.logo}}\" alt=\"\"> <img class=\"nl-prestataire-search-item-img\" \nng-if=\"(!company.logo || company.logo.length == 0 ) && company.photos != null && company.photos.length > 0\" \nng-src=\"{{URL.alternatedocroots + \'/\' + company.photos[0].location}}\" alt=\"\"> <img \nclass=\"nl-prestataire-search-item-img\" \nng-if=\"(!company.logo || company.logo.length == 0 ) && (!company.photos || company.photos.length == 0)\" \nsrc=\"assets/images/logo/pure.png\" alt=\"\"></div><div \nclass=\"nl-Article__selection__titleWrapper layout-row layout-align-space-between-center flex ph-25\"><div \nclass=\"nl-Article__selection__title flex\">\n{{company.modelPattern}}{{ company.category != null ? \' - \' + company.category : \'\'}}{{ company.location != null ? \' - \' + company.location : \'\' }}\n</div><button type=\"button\" class=\"nl-BtnPure nl-BtnPure--fab md-red-900-bg ml-16\" \nng-click=\"deleteFromSelection(company)\"><img src=\"./assets/images/slick/delete.svg\" alt=\"\"></button></div></div><div \nclass=\"nl-Article__selection__content\"><div><div class=\"nl-relArticle__description\" \nng-if=\"company.category\n													  != null || company.bedrooms !=null || company.rooms !=null\">\n{{company.category}} {{company.category != null ? (company.bedrooms ? \' | \' + company.bedrooms + \" bedrooms \": \'\') : (company.bedrooms ? company.bedrooms+ \" bedrooms \":\'\')}} {{company.category != null || company.bedrooms !=null ? (company.rooms ? \' | \' + company.rooms + \" meeting rooms \":\'\') : (company.rooms ? company.rooms+ \" meeting rooms \":\'\')}} {{company.category != null || company.bedrooms !=null || company.rooms !=null ? (company.maxTheatre ? \' | \' + company.maxTheatre + \" max capacity in theatre style \":\'\') : (company.maxTheatre ? company.maxTheatre+ \" max capacity in theatre style \":\'\')}}\n</div><div class=\"nl-relArticle__description mt-25 mb-30\" ng-if=\"company.resume\">{{company.resume | nlEllipsis: 1200}}\n</div></div><div class=\"layout-row\"><button type=\"button\" class=\"flex-50 nl-BtnPure nl-BtnPure--primary mh-5\" \nng-click=\"details(company)\"><span>{{\'SITE_GEN.BTN_PROVIDER_DETAILS\' | translate}}</span></button> <button \ntype=\"button\" class=\"flex-50 nl-BtnPure nl-BtnPure--primary mh-5\" ng-click=\"onAskForAQuotePure(null,company);\"><span>\n{{\'SITE_GEN.BTN_ASK_FOR_A_QUOTE\' | translate}}</span></button></div></div></div></div></div></div>");
$templateCache.put("app/main/sitegen/navigation/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp nl_navigation\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp nl_navigation--toolbar\" ui-view=\"toolbar\">\n</md-toolbar></div><div class=\"nl_FavList layout-row layout-align-center-center\" \nng-class=\"{\'nl-Active\': selectionLength > 0}\" ng-click=\"goToMySelectionOfProviders();\"><i ng-if=\"selectionLength == 0\" \nclass=\"icon-heart-outline\"></i> <i ng-if=\"selectionLength > 0\" class=\"icon-heart\"></i>\n {{\'SITE_GEN.BTN_PROVIDERS_SELECTED_LIST\' | translate }} ({{selectionLength}})</div><div id=\"content-container\" \nclass=\"nl_container nl-Page__siteGen\"><md-content id=\"content-generated\" class=\"animate-fade-in-out\" ui-view=\"content\">\n</md-content><div class=\"nl_subHeader--anchor\" ng-class=\"{\'nl_active\': isSubHeaderActive }\" ng-if=\"isShopPage\"><div \nclass=\"nl_bs_container\"><div flex=\"45\" flex-sm=\"100\" flex--offset=\"25\" class=\"nl_tab--wrapper\"><div \nclass=\"nl_tab--header\" layout=\"row\" layout-align=\"start center\"><div class=\"nl_tab--header--item nl-active\" \nng-click=\"scrollToEl(\'js--informations\')\">L\'agence</div><div class=\"nl_tab--header--item\" \nng-click=\"scrollToEl(\'js--services\')\">Présentation du service</div><div class=\"nl_tab--header--item\" \nng-click=\"scrollToEl(\'js--avis\')\">Avis</div></div></div></div></div><div ng-include=\"footer\"></div></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/main/sitegen/popup/addNotation.popup.html","<md-dialog class=\"nl-PopupPure\" aria-label=\"Ajout Notation\" md-theme=\"teal-theme\"><md-toolbar \nclass=\"nl-PopupPure__header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"nl-PopupPure__header__title\">{{\'SITE_GEN.NOTATION.ADD_NOTATION\' | translate}}</div></div></div></md-toolbar>\n<md-dialog-content class=\"nl-PopupPure__content\"><form name=\"addNotationForm\"><star-rating-comp \nclass=\"nl-PopupPure__comp\" num-of-stars=\"5\" size=\"\'large\'\" star-type=\"\'svg\'\" on-rating-change=\"onChangeRating($event)\">\n</star-rating-comp><md-input-container class=\"nl-Article__Input\" md-no-float><textarea rows=\"3\" \nplaceholder=\"{{\'SITE_GEN.NOTATION.COMMENT\'|translate}}\" ng-model=\"newNotation.comment\" name=\"comment\" required>\n</textarea><div ng-if=\"newNotation.comment\" style=\"float: right\"><span>\n{{newNotation.comment ? nbWords(newNotation.comment) : 0}}</span> <span>/ 200</span></div><div class=\"pl-20\" \nng-messages=\"addNotationForm.comment.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></form></md-dialog-content><md-dialog-actions\n layout=\"row\"><button class=\"nl-BtnPure nl-BtnPure--danger mr-8\" ng-click=\"hidePopup()\"><span>\n{{\"SITE_GEN.NOTATION.CANCEL\" | translate}}</span></button> <button class=\"nl-BtnPure nl-BtnPure--primary\" \nng-disabled=\"!addNotationForm.$valid || !newNotation.value\" ng-click=\"confirmAddNotation()\"><span>\n{{\"SITE_GEN.NOTATION.ADD\" | translate}}</span></button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sitegen/request_for_proposal/details_request_for_proposal.html","<div class=\"nl-Form-xs pt-20\" style=\"text-align:center;text-transform: uppercase\"><h2>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.DETAILS_REQUEST_FOR_PROPOSAL\" | translate}}</h2></div><div class=\"nl_Row-content\">\n<div class=\"nl--Container\"><div layout=\"row\" class=\"nl-Form-xs\"><div flex=\"100\"><form \nname=\"detailsRequestForProposalForm\" novalidate><div class=\"nl--Steps--contentNoTabs\"><div class=\"\"><div class=\"pt-20\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.TARGET_PROVIDER\"></div><div class=\"nl-RadioBox--item mt-10\" \nstyle=\"border-color: #16a2b4!important\"><span \nng-show=\"requestForProposal.companies && requestForProposal.companies.length > 0\" \nng-repeat=\"company in requestForProposal.companies | orderBy : \'pattern\'\">{{company.pattern + (!$last ? \' | \' : \'\')}} \n</span><span ng-hide=\"requestForProposal.companies && requestForProposal.companies.length > 0\">\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.REQUEST_FOR_PROPOSALS_DEST.VISIT_LEBANON\' | translate}}</span></div><div \nclass=\"pt-20\" translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TITLE\"></div><div class=\"nl-details-div mt-10\" \nclass=\"nl-details-div\">{{requestForProposal.eventTitle}}</div><div class=\"pt-20\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TITLE\"></div><div class=\"nl-details-div mt-10\" \nclass=\"nl-details-div\">{{requestForProposal.eventType}}</div><div class=\"pt-20\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.NUMBER_OF_PARTICIPANTS\"></div><div class=\"nl-details-div mt-10\">\n{{requestForProposal.numberOfParticipants}}</div><div class=\"pt-20\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.START_DATE\"></div><div class=\"nl-details-div mt-10\">\n{{requestForProposal.dateStart}}</div><div class=\"pt-20\" translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.END_DATE\">\n</div><div class=\"nl-details-div mt-10\">{{requestForProposal.dateEnd}}</div><div class=\"pt-20\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.DESIRED_ACTIVITIES\"></div><div class=\"mt-10 nl-details-div\"><span \nng-repeat=\"activity in requestForProposal.desiredActivities\"><span>{{activity}}</span> <span ng-if=\"!$last\">|</span>\n</span></div><div class=\"pt-20\" translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_NUMBER\"></div><div \nclass=\"nl-details-div mt-10\">{{requestForProposal.roomNumber}}</div><div class=\"pt-20\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_CAPACITY_MAX\"></div><div class=\"nl-details-div mt-10\">\n{{requestForProposal.roomCapacityMax}}</div><div class=\"pt-20\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.CONFIGURATION\"></div><div class=\"nl-details-div mt-10\">\n{{requestForProposal.desiredConfiguration}}</div><div class=\"pt-20\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE\"></div><div class=\"nl-details-div mt-10\">\n{{requestForProposal.square}} <span ng-if=\"requestForProposal.squareUnit\">\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.SQUARE_UNITS.\' + requestForProposal.squareUnit | translate}}</span></div><div \nclass=\"pt-20\" translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.TECHNICAL_EQUIPMENT\"></div><div \nclass=\"nl-details-div mt-10\">{{requestForProposal.technicalEquipment}}</div><div class=\"pt-20\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_HOTEL\"></div><div class=\"nl-details-div mt-10\">\n{{requestForProposal.precisiontoTheHotel}}</div><div class=\"pt-20\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_EVENT_PLACE\"></div><div class=\"nl-details-div mt-10\">\n{{requestForProposal.precisiontoTheEventPlace}}</div><div class=\"pt-20\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_RECEPTIVE\"></div><div class=\"nl-details-div mt-10\">\n{{requestForProposal.precisionForTheReceptive}}</div><div class=\"pt-20\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_CARRIER\"></div><div class=\"nl-details-div mt-10\">\n{{requestForProposal.precisionForTheCarrier}}</div><div class=\"pt-20\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.OTHER_PRECISION\"></div><div class=\"nl-details-div mt-10\">\n{{requestForProposal.otherPrecision}}</div><div class=\"mt-10\" ng-if=\"requestForProposal.document\"><a target=\"_self\" \nhref=\"{{requestForProposal.document}}\" style=\"color: rgb(13, 164, 180)!important\" download>\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.DOCUMENT\' | translate}}</a></div></div></div></form></div></div></div></div>");
$templateCache.put("app/main/sitegen/request_for_proposal/request_for_proposal.html","<div class=\"nl-Form-xs pt-20\" style=\"text-align:center;text-transform: uppercase\"><h2>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.MY_REQUEST_FOR_PROPOSALS\" | translate}}</h2></div><div \nclass=\"nl-prestataire--page mt-20\"><div class=\"nl_Row-content\" \nstyle=\"padding-left: 0px!important;padding-right: 0px!important\"><table class=\"dataTable row-border hover\"><thead><th \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TITLE\"></th><th \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.DESIRED_ACTIVITIES\"></th><th></th></thead><tbody><tr \nng-repeat=\"rfp in requestForProposals | orderBy: \'eventTitle\'\" style=\"cursor: pointer!important\" \nng-click=\"detailsRequestForProposal(rfp);\"><td><div class=\"nl-Block--table--company\">{{ rfp.eventTitle }}</div></td>\n<td><span ng-repeat=\"activity in rfp.desiredActivities\">{{activity + ($last ? \'\' : \' | \')}}</span></td><td \nng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"nl-Item-button m-5\" \nng-click=\"detailsRequestForProposal(rfp);\">\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.DETAILS_REQUEST_FOR_PROPOSAL_BTN\' | translate}}</button> <button type=\"button\" \nclass=\"nl-Item-button m-5\" ng-click=\"duplicateRequestForProposal(rfp);\">\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.DUPLICATE_REQUEST_FOR_PROPOSAL\' | translate}}</button></td></tr></tbody></table>\n</div></div>");
$templateCache.put("app/main/sitegen/request_for_proposal/send_request_for_proposal.html","<div class=\"nl-Form-xs pt-20\" style=\"text-align:center;text-transform: uppercase\"><h2 class=\"nl-titre--main\">\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.NEW_REQUEST_FOR_PROPOSAL\" | translate}}</h2></div><div class=\"nl_Row-content\"><div \nclass=\"nl--Container\"><div layout=\"row\" class=\"nl-Form-xs\"><div flex=\"100\"><form ng-if=\"!formSend\" \nname=\"newRequestForProposalForm\" novalidate ng-submit=\"sendNewRequestForProposal(newRequestForProposalForm)\" \nautocomplete=\"off\" class=\"\"><div class=\"nl--Steps--contentNoTabs\"><div class=\"\"><fieldset \nclass=\"nl-Fieldset nl-Fieldset--noMarginTop\"><legend>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.APPLICANT_INFORMATIONS\" | translate}}</legend><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" ng-model=\"requestForProposal.applicantCompany\" \nname=\"applicantCompany\" required><label>{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY\" | translate}} *\n</label><div ng-messages=\"newRequestForProposalForm.applicantCompany.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"requestForProposal.applicantCompanyType\" name=\"applicantCompanyType\" ng-required=\"true\"><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY_TYPE\" | translate}} *</label><div \nng-messages=\"newRequestForProposalForm.applicantCompanyType.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" ng-model=\"requestForProposal.applicantWebSite\" \nname=\"applicantWebSite\"><label class=\"\" translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_WEB_SITE\"></label>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><label>\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CIVILITY\' | translate}}</label><md-select name=\"applicantCivility\" \nrequired ng-model=\"requestForProposal.applicantCivility\" ng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"civility in civilities | orderBy : \'toString()\' track by $index\" ng-value=\"civility\">{{civility}}\n</md-option></md-select><div ng-messages=\"newRequestForProposalForm.applicantCivility.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"requestForProposal.applicantFirstName\" name=\"applicantFirstName\" ng-required=\"true\"><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FIRST_NAME\" | translate}} *</label><div \nng-messages=\"newRequestForProposalForm.applicantFirstName.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"requestForProposal.applicantLastName\" name=\"applicantLastName\" ng-required=\"true\"><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_LAST_NAME\" | translate}} *</label><div \nng-messages=\"newRequestForProposalForm.applicantLastName.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"requestForProposal.applicantFunction\" name=\"applicantFunction\" ng-required=\"true\"><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FUNCTION\" | translate}} *</label><div \nng-messages=\"newRequestForProposalForm.applicantFunction.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"requestForProposal.applicantAddress1\" name=\"applicantAddress1\" ng-required=\"true\"><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS1\" | translate}} *</label><div \nng-messages=\"newRequestForProposalForm.applicantAddress1.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"requestForProposal.applicantAddress2\" name=\"applicantAddress2\"><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS2\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"requestForProposal.applicantAddress3\" name=\"applicantAddress3\"><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS3\"></label></md-input-container><div layout=\"row\" \nflex><md-input-container class=\"nl-Input-container ml-15\" flex=\"20\"><input type=\"text\" class=\"\" rows=\"1\" \nng-model=\"requestForProposal.applicantPostCode\" name=\"applicantPostCode\" ng-required=\"true\"><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_POST_CODE\" | translate}} *</label><div \nng-messages=\"newRequestForProposalForm.applicantPostCode.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"40\"><input type=\"text\" class=\"\" rows=\"1\" \nng-model=\"requestForProposal.applicantCity\" name=\"applicantCity\" ng-required=\"true\"><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CITY\" | translate}} *</label><div \nng-messages=\"newRequestForProposalForm.applicantCity.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"40\"><input type=\"text\" class=\"\" rows=\"1\" \nng-model=\"requestForProposal.applicantCountry\" name=\"applicantCountry\" ng-required=\"true\"><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COUNTRY\" | translate}} *</label><div \nng-messages=\"newRequestForProposalForm.applicantCountry.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"requestForProposal.applicantDirectPhone\" name=\"applicantDirectPhone\" ng-required=\"true\"><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_DIRECT_PHONE\" | translate}} *</label><div \nng-messages=\"newRequestForProposalForm.applicantDirectPhone.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"requestForProposal.applicantMobilePhone\" name=\"applicantMobilePhone\"><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_MOBILE_PHONE\"></label></md-input-container>\n<md-input-container ng-if=\"!user\" class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"email\" class=\"\" \nng-model=\"requestForProposal.applicantEmail\" name=\"applicantEmail\" ng-required=\"!user\"><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_EMAIL\" | translate}} *</label></md-input-container></fieldset></div>\n</div><div><div class=\"flex-100\"><fieldset class=\"nl-Fieldset nl-Fieldset--noMarginTop\"><legend>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.RECIPIENTS\" | translate}}</legend><div class=\"pt-10 nl-text--main\"><div>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.TARGET_PROVIDER\" | translate }} *</div></div><md-input-container \nclass=\"nl-Input-container\" flex=\"100\"><div><md-radio-group ng-model=\"requestForProposal.targetProvider\" layout=\"row\" \nflex ng-required=\"true\"><md-radio-button class=\"nl-RadioBox--item\" flex \nng-repeat=\"provider in providers | orderBy : \'toString()\' track by $index\" ng-value=\"provider\" \naria-label=\"{{provider}}\">{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.REQUEST_FOR_PROPOSALS_DEST.\' + provider | translate}}<div \nng-if=\"mySelectionOfProviders.length === 0 && provider === \'SELECTED_PROVIDER\'\">{{targetProvider.value.modelPattern}}\n</div></md-radio-button></md-radio-group><div layout=\"row\" flex><div flex=\"33\"><div \nclass=\"nl-Block nl-Block-List mt-20\" ng-if=\"requestForProposal.targetProvider == \'MY_SELECTION_OF_PROVIDERS\'\"><div \nclass=\"nl-Block-itemTitle\" \nng-repeat=\"selectionItem in mySelectionOfProviders  | orderBy : \'modelPattern\' track by $index\"><span \nclass=\"nl-Block-List-tilde\">-</span> {{selectionItem.modelPattern}}</div></div></div><div flex=\"33\" \nng-if=\"mySelectionOfProviders.length > 0\"><md-select ng-if=\"requestForProposal.targetProvider == \'SELECTED_PROVIDER\'\" \nname=\"targetProvider\" ng-model=\"targetProvider.value\" ng-model-options=\"{\'trackBy\': \'$value.id\'}\"><md-option \nng-repeat=\"selectionItem in mySelectionOfProviders | orderBy : \'modelPattern\' track by $index\" \nng-value=\"selectionItem\">{{selectionItem.modelPattern}}</md-option></md-select></div><div flex=\"33\"></div></div><div \nng-if=\"!requestForProposal.targetProvider\"><span style=\"color: rgb(213,0,0)\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></div></md-input-container></fieldset><fieldset class=\"nl-Fieldset nl-Fieldset--noMarginTop\"><legend>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.EVENT_INFORMATIONS\" | translate}}</legend><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" ng-model=\"requestForProposal.eventTitle\" \nname=\"eventTitle\" required><label class=\"\">{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TITLE\" | translate}} *\n</label><div ng-messages=\"newRequestForProposalForm.eventTitle.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" ng-model=\"requestForProposal.eventType\" \nname=\"eventType\" required><label class=\"\">{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TYPE\" | translate}} *</label>\n<div ng-messages=\"newRequestForProposalForm.eventType.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><label class=\"md-no-float\">Event Document</label><input type=\"file\" \nclass=\"nl_input--input\" name=\"document\" id=\"file\"></md-input-container><span \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.PRECISIONS_PDF\"></span><md-input-container class=\"nl-Input-container ml-15\" \nflex=\"100\"><input type=\"number\" class=\"\" ng-model=\"requestForProposal.numberOfParticipants\" \nname=\"numberOfParticipants\" required min=\"0\" step=\"1\"><label class=\"\">\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.NUMBER_OF_PARTICIPANTS\" | translate}} *</label><div \nng-messages=\"newRequestForProposalForm.numberOfParticipants.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><div layout=\"row\" flex class=\"mt-10\">\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"50\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" \nmd-open-on-focus md-hide-icons=\"calendar\" ng-model=\"requestForProposal.dateStart\" name=\"dateStart\" required>\n</md-datepicker><label class=\"\">{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.START_DATE\" | translate}} *</label><div \nng-messages=\"newRequestForProposalForm.dateStart.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"50\"><md-datepicker \nclass=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" \nng-model=\"requestForProposal.dateEnd\" name=\"dateEnd\" required></md-datepicker><label class=\"\">\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.END_DATE\" | translate}} *</label><div \nng-messages=\"newRequestForProposalForm.dateEnd.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container></div><md-input-container \nclass=\"nl-Input-container nl-Input-container--wrap nl-Input-container--marged ml-15\" flex=\"100\"><md-select \nmd-on-open=\"\" md-no-asterisk name=\"desiredActivities \" multiple=\"multiple\" required \nng-model=\"requestForProposal.desiredActivities\" ng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"desiredActivitiy in desiredActivities track by $index\" ng-value=\"desiredActivitiy.name\">\n{{desiredActivitiy.name}}</md-option></md-select><label class=\"\">\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.DESIRED_ACTIVITIES\" | translate}} *</label><div \nng-messages=\"newRequestForProposalForm.desiredActivities.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"number\" class=\"\" ng-model=\"requestForProposal.roomNumber\" \nname=\"roomNumber\" min=\"0\" step=\"1\"><label class=\"\">{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_NUMBER\" | translate}}\n</label><div ng-messages=\"newRequestForProposalForm.roomNumber.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"number\" class=\"\" \nng-model=\"requestForProposal.roomCapacityMax\" name=\"roomCapacityMax\" min=\"0\" step=\"1\"><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_CAPACITY_MAX\"></label><div \nng-messages=\"newRequestForProposalForm.roomCapacityMax.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><md-select md-on-open=\"\" name=\"desiredConfiguration \" \nng-model=\"requestForProposal.desiredConfiguration\" ng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"desiredConfiguration in desiredConfigurations | orderBy : \'toString()\' track by $index\" \nng-value=\"desiredConfiguration\">{{desiredConfiguration}}</md-option></md-select><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.CONFIGURATION\"></label><div \nng-messages=\"newRequestForProposalForm.configuration.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIREfsdD\' | translate}}</span></div></md-input-container><div layout=\"row\" flex class=\"mt-10\">\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"60\"><input type=\"number\" class=\"\" \nng-model=\"requestForProposal.square\" name=\"square\"><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE\"></label><div \nng-messages=\"newRequestForProposalForm.square.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"40\"><md-select \nmd-on-open=\"\" name=\"squareUnit\" ng-required=\"requestForProposal.square\" ng-model=\"requestForProposal.squareUnit\" \nng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"squareUnit in squareUnits | orderBy : \'toString()\' track by $index\" ng-value=\"squareUnit\">\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.SQUARE_UNITS.\' + squareUnit | translate}}</md-option></md-select><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE_UNIT\"></label><div \nng-messages=\"newRequestForProposalForm.squareUnit.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><textarea type=\"text\" class=\"\" rows=\"1\" \nng-model=\"requestForProposal.technicalEquipment\" name=\"technicalEquipment\"></textarea><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.TECHNICAL_EQUIPMENT\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><textarea type=\"text\" class=\"\" rows=\"1\" \nng-model=\"requestForProposal.precisiontoTheHotel\" name=\"precisiontoTheHotel\"></textarea><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_HOTEL\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><textarea type=\"text\" class=\"\" rows=\"1\" \nng-model=\"requestForProposal.precisiontoTheEventPlace\" name=\"precisiontoTheEventPlace\"></textarea><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_EVENT_PLACE\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><textarea type=\"text\" class=\"\" rows=\"1\" \nng-model=\"requestForProposal.precisionForTheReceptive\" name=\"precisionForTheReceptive\"></textarea><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_RECEPTIVE\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><textarea type=\"text\" class=\"\" rows=\"1\" \nng-model=\"requestForProposal.precisionForTheCarrier\" name=\"precisionForTheCarrier\"></textarea><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_CARRIER\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><textarea type=\"text\" class=\"\" rows=\"1\" \nng-model=\"requestForProposal.otherPrecision\" name=\"otherPrecision\"></textarea><label class=\"\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.OTHER_PRECISION\"></label></md-input-container></fieldset><div \nclass=\"remember-forgot-password\" style=\"text-align:center!important\"><md-button type=\"submit\" \nclass=\"nl-Btn nl-Btn-primary md-button md-default-theme md-ink-ripple\">\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.SEND_NEW_REQUEST_FOR_PROPOSAL\' | translate}}</md-button></div></div></div></form><div\n layout=\"row\" layout-align=\"center center\" ng-if=\"formSend\" style=\"margin-top: 40px!important\"><h2 \nclass=\"nl--msg-header\" style=\"color: #16a2b4\">{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.REQUEST_SUCCESS\' | translate}}</h2>\n</div></div></div></div></div>");
$templateCache.put("app/main/sitegen/site/site.html","<div id=\"siteGen\"><div ng-show=\"page.pageBlocs && page.pageBlocs.length > 0\"><div \nng-repeat=\"_pageBlock in page.pageBlocs | orderBy : \'index\'\"><div ng-show=\"_pageBlock.bloc && _pageBlock.htmlFill\" \ndynamic-ctrl=\"getBlocTypeController(_pageBlock.bloc)\"><div compile=\"_pageBlock.htmlFill\"></div></div></div></div></div>");
$templateCache.put("app/main/sitegen/workbook/workbook.html","<div class=\"nl_Row-content\"><ms-form-wizard class=\"nl-Stepper\" flex ng-if=\"!rfpSent\"><md-tabs \nclass=\"nl-Stepper__inner\" md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" \nng-init=\"setWizard(msWizard)\"><md-tab ng-disabled=\"alreadyConnect\"><md-tab-label><span \nclass=\"nl-Stepper__header ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">1</span>\n<span class=\"ms-form-wizard-step-text\">{{\"SITE_GEN.WORKBOOK.CONNEXION\" | translate}}</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div class=\"layout-row\">\n<div class=\"p-10 flex-100 flex-gt-xs-50 nl-Stepper__box\" ng-class=\"{\'nl-Selected\': showConnect}\" \nng-click=\"showConnect=true;showSignIn=false\"><div class=\"nl-Stepper__box__title\">\n{{\"SITE_GEN.WORKBOOK.ALREADY_ACCOUNT\" | translate}}</div></div><div \nclass=\"p-10 flex-100 flex-gt-xs-50 nl-Stepper__box\" ng-class=\"{\'nl-Selected\': showSignIn}\" \nng-click=\"showSignIn=true;showConnect=false;\"><div class=\"nl-Stepper__box__title\">\n{{\"SITE_GEN.WORKBOOK.CREATE_ACCOUNT\" | translate}}</div></div></div><div class=\"p-10 flex-100 flex-gt-xs-100\" \nng-if=\"showConnect\"><div layout=\"row\" layout-wrap><md-input-container class=\"nl-Stepper__input\" md-no-float flex=\"100\">\n<input type=\"text\" name=\"usermail\" ng-model=\"vm.formWizard.usermail\" \nplaceholder=\"{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.LOGIN\'|translate}}\" required><div \nng-messages=\"wizardStep1.usermail.$error\" ng-show=\"wizardStep1.usermail.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container class=\"nl-Stepper__input\" md-no-float flex=\"100\"><input type=\"password\" name=\"password\" \nng-model=\"vm.formWizard.password\" placeholder=\"{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PASSWORD\'|translate}}\" \nrequired><div ng-messages=\"wizardStep1.password.$error\" ng-show=\"wizardStep1.password.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><div \nclass=\"nl-Stepper__btn--wrapper\" ng-click=\"login(vm.formWizard,msWizard)\"><button class=\"nl-Stepper__btn\">\n{{\"SITE_GEN.WORKBOOK.CONNECT\" | translate}}</button></div></div><div class=\"p-10 flex-100 flex-gt-xs-100\" \nng-if=\"showSignIn\"><div layout=\"row\" layout-wrap><md-input-container class=\"nl-Stepper__input\" md-no-float flex=\"100\">\n<md-select placeholder=\"{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CIVILITY\'|translate}} *\" md-no-asterisk \nname=\"applicantCivility\" ng-model=\"vm.formWizard.applicantCivility\" ng-model-options=\"{\'trackBy\': \'$value\'}\" required>\n<md-option ng-repeat=\"civility in civilities | orderBy : \'toString()\' track by $index\" ng-value=\"civility\">{{civility}}\n</md-option></md-select><div ng-messages=\"wizardStep1.applicantCivility.$error\" role=\"alert\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Stepper__input\" md-no-float flex=\"100\"><input type=\"text\" name=\"applicantFirstName\" \nng-model=\"vm.formWizard.applicantFirstName\" \nplaceholder=\"{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FIRST_NAME\'|translate}} *\" required><div \nng-messages=\"wizardStep1.applicantFirstName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nclass=\"nl-Stepper__input\" md-no-float flex=\"100\"><input type=\"text\" name=\"applicantLastName\" \nng-model=\"vm.formWizard.applicantLastName\" \nplaceholder=\"{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_LAST_NAME\'|translate}} *\" required><div \nng-messages=\"wizardStep1.applicantLastName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nclass=\"nl-Stepper__input\" md-no-float flex=\"100\"><input type=\"text\" name=\"applicantCompany\" \nng-model=\"vm.formWizard.applicantCompany\" \nplaceholder=\"{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY\'|translate}} *\" required><div \nng-messages=\"wizardStep1.applicantCompany.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nclass=\"nl-Stepper__input\" md-no-float flex=\"100\"><input type=\"text\" name=\"mail\" ng-model=\"vm.formWizard.mail\" \nplaceholder=\"{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_EMAIL\'|translate}} *\" required><div \nng-messages=\"wizardStep1.mail.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"nl-Stepper__input\" md-no-float flex=\"100\"><input \ntype=\"text\" name=\"login\" ng-model=\"vm.formWizard.login\" \nplaceholder=\"{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.LOGIN\'|translate}} *\" required><div \nng-messages=\"wizardStep1.login.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"nl-Stepper__input\" md-no-float flex=\"100\"><input \ntype=\"password\" name=\"password\" ng-model=\"vm.formWizard.password\" \nplaceholder=\"{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PASSWORD\'|translate}} *\" required><div \nng-messages=\"wizardStep1.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><div class=\"nl-Stepper__btn--wrapper\">\n<button class=\"nl-Stepper__btn\" ng-click=\"register(vm.formWizard,msWizard)\">{{\"SITE_GEN.WORKBOOK.SIGN_IN\" | translate}}\n</button></div></div></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid || (!alreadyConnect) || stepTwoOk\"><md-tab-label><span \nclass=\"nl-Stepper__header ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">2</span>\n<span class=\"ms-form-wizard-step-text\">{{\"SITE_GEN.WORKBOOK.WRITE_CC\" | translate}}</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form novalidate><div layout=\"row\"><button class=\"nl-Stepper__box\" \ntype=\"button\" ng-class=\"{\'nl-Selected\': hadFile}\" ng-click=\"hadFile=true;generateCC=false;hadCC=false\"><div \nclass=\"nl-Stepper__box__title\">{{\"SITE_GEN.WORKBOOK.ALREADY_CC_PDF\" | translate}}</div></button> <button \nclass=\"nl-Stepper__box\" type=\"button\" ng-class=\"{\'nl-Selected\': generateCC}\" \nng-click=\"generateCC=true;hadFile=false;hadCC=false\"><div class=\"nl-Stepper__box__title\">\n{{\"SITE_GEN.WORKBOOK.CC_FORM\" | translate}}</div></button> <button class=\"nl-Stepper__box\" type=\"button\" \nng-class=\"{\'nl-Selected\': hadCC}\" ng-click=\"hadCC=true;hadFile=false;generateCC=false;\"><div \nclass=\"nl-Stepper__box__title\">{{\"SITE_GEN.WORKBOOK.ALREADY_CC_EXISTANT\" | translate}}</div></button></div><div \nlayout=\"row\"><div class=\"nl-Stepper__underBox\" ng-if=\"hadFile\"><div class=\"nl-Stepper__underBox__title\">\n{{\"SITE_GEN.WORKBOOK.DOWNLOAD_CC_PDF\" | translate}}</div><div><md-input-container class=\"nl-Input-container ml-15\" \nflex=\"100\"><input type=\"text\" ng-model=\"requestForProposal.name\" name=\"name\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.NAME_CC\" | translate}} *</label><div ng-messages=\"wizardStep2.name.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"requestForProposal.dateStart\" name=\"dateStart\" required></md-datepicker><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.START_DATE\" | translate}} *</label><div \nng-messages=\"wizardStep2.dateStart.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><md-datepicker \nclass=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" \nng-model=\"requestForProposal.dateEnd\" name=\"dateEnd\" required></md-datepicker><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.END_DATE\" | translate}} *</label><div \nng-messages=\"wizardStep2.dateEnd.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"requestForProposal.eventType\" name=\"eventType\" required><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TYPE\" | translate}} *</label><div \nng-messages=\"wizardStep2.eventType.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"number\" class=\"\" \nng-model=\"requestForProposal.numberOfParticipants\" name=\"numberOfParticipants\" required min=\"0\" step=\"1\"><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.NUMBER_OF_PARTICIPANTS\" | translate}} *</label><div \nng-messages=\"wizardStep2.numberOfParticipants.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container></div><button type=\"button\" class=\"nl-Stepper__btn centered\" \nng-disabled=\"!wizardStep2.$valid\" file-browser>{{\"SITE_GEN.WORKBOOK.DOWNLOAD\" | translate}}</button></div><div \nclass=\"nl-Stepper__underBox\" ng-if=\"generateCC\"><div class=\"nl-Stepper__underBox__title\">\n{{\"SITE_GEN.WORKBOOK.FORM\" | translate}}</div><div class=\"nl_Row-content\"><div class=\"nl--Container\"><div layout=\"row\" \nclass=\"nl-Form-xs\"><div flex=\"100\"><div><div class=\"flex-100\"><fieldset class=\"nl-Fieldset nl-Fieldset--noMarginTop\">\n<legend>{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.APPLICANT_INFORMATIONS\" | translate}}</legend><label class=\"ml-5\">\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.LOGO\" | translate}}</label><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"nl-Input-container ml-15\" flex=\"50\"><input type=\"file\" \naccept=\"image/*\" id=\"logoRfp\" name=\"logo\"></md-input-container></div><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"requestForProposal.applicantCompany\" \nname=\"applicantCompany\" required><label>{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY\" | translate}} *\n</label><div ng-messages=\"wizardStep2.applicantCompany.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"requestForProposal.applicantCompanyType\" \nname=\"applicantCompanyType\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY_TYPE\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantCompanyType.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\">\n<input type=\"text\" ng-model=\"requestForProposal.applicantWebSite\" name=\"applicantWebSite\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_WEB_SITE\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><label>\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CIVILITY\' | translate}}</label><md-select name=\"applicantCivility\" \nrequired ng-model=\"requestForProposal.applicantCivility\" ng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"civility in civilities | orderBy : \'toString()\' track by $index\" ng-value=\"civility\">{{civility}}\n</md-option></md-select><div ng-messages=\"wizardStep2.applicantCivility.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"requestForProposal.applicantFirstName\" \nname=\"applicantFirstName\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FIRST_NAME\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantFirstName.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"requestForProposal.applicantLastName\" name=\"applicantLastName\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_LAST_NAME\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantLastName.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"requestForProposal.applicantFunction\" name=\"applicantFunction\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FUNCTION\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantFunction.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"requestForProposal.applicantAddress1\" name=\"applicantAddress1\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS1\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantAddress1.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\">\n<input type=\"text\" ng-model=\"requestForProposal.applicantAddress2\" name=\"applicantAddress2\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS2\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><input type=\"text\" \nng-model=\"requestForProposal.applicantAddress3\" name=\"applicantAddress3\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS3\"></label></md-input-container><div layout=\"row\" \nflex><md-input-container class=\"nl-Input-container ml-15\" flex=\"20\"><input type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.applicantPostCode\" name=\"applicantPostCode\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_POST_CODE\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantPostCode.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"40\"><input type=\"text\" \nrows=\"1\" ng-model=\"requestForProposal.applicantCity\" name=\"applicantCity\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CITY\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantCity.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"40\"><input type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.applicantCountry\" name=\"applicantCountry\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COUNTRY\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantCountry.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container></div><md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\">\n<input type=\"text\" ng-model=\"requestForProposal.applicantDirectPhone\" name=\"applicantDirectPhone\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_DIRECT_PHONE\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantDirectPhone.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\">\n<input type=\"text\" ng-model=\"requestForProposal.applicantMobilePhone\" name=\"applicantMobilePhone\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_MOBILE_PHONE\"></label></md-input-container>\n<md-input-container ng-if=\"!user\" class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><input type=\"email\" \nng-model=\"requestForProposal.applicantEmail\" name=\"applicantEmail\" ng-required=\"!user\"><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_EMAIL\" | translate}} *</label></md-input-container></fieldset></div>\n<div flex=\"100\"><fieldset class=\"nl-Fieldset nl-Fieldset--noMarginTop\"><legend>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.EVENT_INFORMATIONS\" | translate}}</legend><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"requestForProposal.name\" name=\"name\" required>\n<label>{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.NAME_CC\" | translate}} *</label><div ng-messages=\"wizardStep2.name.$error\">\n<span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"requestForProposal.eventTitle\" \nname=\"eventTitle\" required><label>{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TITLE\" | translate}} *</label><div \nng-messages=\"wizardStep2.eventTitle.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"requestForProposal.eventType\" name=\"eventType\" required><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TYPE\" | translate}} *</label><div \nng-messages=\"wizardStep2.eventType.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"number\" class=\"\" \nng-model=\"requestForProposal.numberOfParticipants\" name=\"numberOfParticipants\" required min=\"0\" step=\"1\"><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.NUMBER_OF_PARTICIPANTS\" | translate}} *</label><div \nng-messages=\"wizardStep2.numberOfParticipants.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><div layout=\"row\" flex class=\"mt-10\"><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"50\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"requestForProposal.dateStart\" name=\"dateStart\" required></md-datepicker><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.START_DATE\" | translate}} *</label><div \nng-messages=\"wizardStep2.dateStart.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"50\"><md-datepicker \nclass=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" \nng-model=\"requestForProposal.dateEnd\" name=\"dateEnd\" required></md-datepicker><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.END_DATE\" | translate}} *</label><div \nng-messages=\"wizardStep2.dateEnd.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container></div><md-input-container \nclass=\"nl-Input-container nl-Input-container--wrap nl-Input-container--marged\" flex=\"100\"><md-select md-on-open=\"\" \nmd-no-asterisk name=\"desiredActivities \" multiple=\"multiple\" required ng-model=\"requestForProposal.desiredActivities\" \nng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option ng-repeat=\"desiredActivitiy in desiredActivities track by $index\" \nng-value=\"desiredActivitiy.name\">{{desiredActivitiy.name}}</md-option></md-select><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.DESIRED_ACTIVITIES\" | translate}} *</label><div \nng-messages=\"wizardStep2.desiredActivities.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"number\" \nng-model=\"requestForProposal.roomNumber\" name=\"roomNumber\" min=\"0\" step=\"1\"><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_NUMBER\" | translate}}</label><div \nng-messages=\"wizardStep2.roomNumber.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><input \ntype=\"number\" ng-model=\"requestForProposal.roomCapacityMax\" name=\"roomCapacityMax\" min=\"0\" step=\"1\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_CAPACITY_MAX\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><md-select md-on-open=\"\" name=\"desiredConfiguration \" \nng-model=\"requestForProposal.desiredConfiguration\" ng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"desiredConfiguration in desiredConfigurations | orderBy : \'toString()\' track by $index\" \nng-value=\"desiredConfiguration\">{{desiredConfiguration}}</md-option></md-select><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.CONFIGURATION\"></label></md-input-container><div layout=\"row\" flex>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"60\"><input type=\"number\" \nng-model=\"requestForProposal.square\" name=\"square\"><label translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE\">\n</label></md-input-container><md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"40\">\n<md-select md-on-open=\"\" name=\"squareUnit\" ng-required=\"requestForProposal.square\" \nng-model=\"requestForProposal.squareUnit\" ng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"squareUnit in squareUnits | orderBy : \'toString()\' track by $index\" ng-value=\"squareUnit\">\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.SQUARE_UNITS.\' + squareUnit | translate}}</md-option></md-select><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE_UNIT\"></label><div ng-messages=\"wizardStep2.squareUnit.$error\">\n<span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.technicalEquipment\" name=\"technicalEquipment\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.TECHNICAL_EQUIPMENT\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.precisiontoTheHotel\" name=\"precisiontoTheHotel\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_HOTEL\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.precisiontoTheEventPlace\" name=\"precisiontoTheEventPlace\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_EVENT_PLACE\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.precisionForTheReceptive\" name=\"precisionForTheReceptive\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_RECEPTIVE\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.precisionForTheCarrier\" name=\"precisionForTheCarrier\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_CARRIER\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.otherPrecision\" name=\"otherPrecision\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.OTHER_PRECISION\"></label></md-input-container></fieldset></div><div \nlayout=\"row\" layout-align=\"space-between center\"><button class=\"nl-Stepper__btn flex-45\" \nng-click=\"exportForm(msWizard,wizardStep2.$valid)\">{{\"SITE_GEN.WORKBOOK.EXPORT\" | translate}}</button> <button \nclass=\"nl-Stepper__btn flex-45\" ng-click=\" validateStepTwo(\'FORMULAIRE\',msWizard,wizardStep2.$valid)\">\n{{\"SITE_GEN.WORKBOOK.VALIDATE_CC\" | translate}}</button></div></div></div></div></div></div></div><div \nclass=\"nl-Stepper__underBox\" ng-if=\"hadCC\"><div class=\"nl-Stepper__underBox__title\">\n{{\"SITE_GEN.WORKBOOK.SELECT_CC_TO_SEND\" | translate}}</div><md-input-container class=\"nl-Input-container ml-15\" \nflex=\"100\" ng-if=\"listCCExistant && listCCExistant.length>0\"><md-select required name=\"selectedCC\" \nng-model=\"requestForProposal.selectedCC\" ng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"cc in listCCExistant | orderBy:\'name\'\" ng-value=\"cc.id\">{{cc.name}}</md-option></md-select><div \nng-messages=\"wizardStep2.selectedCC.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><div style=\"text-align: center\" ng-if=\"!listCCExistant || listCCExistant.length==0\">\n{{\"SITE_GEN.WORKBOOK.NO_CC\" | translate}}</div><button ng-if=\"listCCExistant && listCCExistant.length>0\" \nclass=\"nl-Stepper__btn centered\" ng-disabled=\"!wizardStep2.$valid\" ng-click=\"validateStepTwo(\'EXISTANT\',msWizard)\">\n{{\"SITE_GEN.WORKBOOK.NEXT\" | translate}}</button></div></div></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || (msWizard.isFirstStep() && !alreadyConnect) || (!stepTwoOk)\">\n<md-tab-label><span class=\"nl-Stepper__header ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\">3</span><span class=\"ms-form-wizard-step-text\">\n{{\"SITE_GEN.WORKBOOK.SELECT_PROVIDERS\" | translate}}</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" \nms-form-wizard-form novalidate><div class=\"nl-Stepper__underBox\"><div class=\"nl-Stepper__underBox__title\">\n{{\"SITE_GEN.WORKBOOK.CHOOSE_PROVIDERS\" | translate}}</div><div layout=\"column\"><md-checkbox class=\"nl-Form__checkbox\" \nng-repeat=\"comp in mySelectionOfProviders\" ng-model=\"comp.toSend\">{{comp.modelPattern}}</md-checkbox></div><div \nclass=\"mt-15\"><button ng-if=\"mySelectionOfProviders && mySelectionOfProviders.length>0\" \nclass=\"nl-Stepper__btn centered\" ng-click=\"sendRFP()\">{{\"SITE_GEN.WORKBOOK.SEND\" | translate}}</button></div></div>\n</form></md-tab-body></md-tab></md-tabs></ms-form-wizard><div layout=\"row\" layout-align=\"center center\" \nng-if=\"rfpSent\" style=\"margin-top: 40px!important\"><h2 class=\"nl--msg-header\" style=\"color: #16a2b4\">\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.REQUEST_SUCCESS\' | translate}}</h2></div></div>");
$templateCache.put("app/main/sites_management/blocs/blocs.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"SITES_MANAGEMENT.BLOCS.TITLES\"></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button type=\"button\" class=\"\" ng-click=\"_blocDetailsFn()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'SITES_MANAGEMENT.BLOCS.ADD\' | translate}}</md-button></div></div><div \nclass=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table class=\"dataTable row-border hover\">\n<thead><tr><th><div>{{\'SITES_MANAGEMENT.BLOCS.FIELDS.NAME\' | translate}}</div><div><input type=\"text\" \nng-model=\"search.name\" placeholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS_SEARCH.NAME\' | translate}}\"></div></th><th><div>\n{{\'SITES_MANAGEMENT.BLOCS.FIELDS.TYPE\' | translate}}</div><div><md-select ng-model=\"search.type\" \nplaceholder=\"{{\'SITES_MANAGEMENT.BLOCS.FIELDS_SEARCH.TYPE\' | translate}}\"><md-option \nng-repeat=\"_thisType in types | orderBy : \'translation\' track by $index\" ng-value=\"_thisType.value\">\n{{_thisType.translation | translate}}</md-option></md-select></div></th></tr></thead><tbody><tr \nng-repeat=\"_bloc in blocs | filter:search | orderBy : \'name\' track by $index\" ng-click=\"_blocDetailsFn(_bloc.id);\"><td>\n{{ _bloc.name }}</td><td>{{ _bloc.type }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/sites_management/pages/pages.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"SITES_MANAGEMENT.PAGES.TITLES\"></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button type=\"button\" class=\"\" ng-click=\"_pageDetailsFn()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'SITES_MANAGEMENT.PAGES.ADD\' | translate}}</md-button></div></div><div \nclass=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table class=\"dataTable row-border hover\">\n<thead><tr><th><div>{{\'SITES_MANAGEMENT.PAGES.FIELDS.NAME\' | translate}}</div><div><input type=\"text\" \nng-model=\"search.name\" placeholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS_SEARCH.NAME\' | translate}}\"></div></th><th><div>\n{{\'SITES_MANAGEMENT.PAGES.FIELDS.SITE\' | translate}}</div><div><input type=\"text\" ng-model=\"search.site.name\" \nplaceholder=\"{{\'SITES_MANAGEMENT.PAGES.FIELDS_SEARCH.SITE\' | translate}}\"></div></th><th><div>\n{{\'SITES_MANAGEMENT.PAGES.FIELDS.BLOCS\' | translate}}</div><div><input type=\"text\" \nng-model=\"search.pageBlocs.bloc.name\" placeholder=\"{{\'SITES_MANAGEMENT.PAGES.FIELDS_SEARCH.BLOCS\' | translate}}\"></div>\n</th></tr></thead><tbody><tr ng-repeat=\"_page in pages | filter:search  | orderBy: \'name\' track by $index\" \nng-click=\"_pageDetailsFn(_page.id);\"><td>{{ _page.name }}</td><td><span ng-repeat=\"site in _page.sites | limitTo: 4\">\n{{site.name}} <span ng-if=\"!$last\">,</span></span></td><td><span \nng-repeat=\"_pageBloc in _page.pageBlocs | orderBy: \'bloc.name\' track by $index\" class=\"mr-5 md-grey-300-bg\">\n{{ _pageBloc.bloc.name }}</span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/sites_management/siteMenu/siteMenu.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"SITES_MANAGEMENT.MENUS.TITLES\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-input-container><md-select ng-change=\"getSiteMenu(); getSitePages();\" ng-model=\"language.key\" \nclass=\"md-no-underline\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div><div \nclass=\"content\"><md-input-container><label>{{\'SITES_MANAGEMENT.MENUS.SITE\' | translate}}</label><md-select \nng-model=\"siteID\" ng-change=\"getSiteMenu(); getSitePages();\"><md-option ng-value=\"site.id\" ng-repeat=\"site in sites\">\n{{site.name}}</md-option></md-select></md-input-container><md-button class=\"md-raised md-primary md-hue-2 mv-15\" \nng-click=\"addItem(0, null)\" ng-if=\"siteID != null\">\n{{\'SITES_MANAGEMENT.MENUS.ADD_MENU\' | translate}}{{\'SITES_MANAGEMENT.MENUS.LEVEL0\' | translate}}</md-button><div \nclass=\"nl-Block\" ng-repeat=\"item in siteMenu.items | orderBy: \'index\'\"><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\">\n{{\'SITES_MANAGEMENT.MENUS.LEVEL\' | translate}} {{item.level + 1}}</div><div layout=\" row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"mt-20 mb-0\"><label>{{\'SITES_MANAGEMENT.MENUS.TITLE\' | translate}}</label><input class=\"\" type=\"text\" \nng-model=\"item.title\"></md-input-container><md-input-container class=\"mb-5 mt-0\"><label \ntranslate=\"SITES_MANAGEMENT.MENUS.LINKED_PAGE\"></label><md-select ng-model=\"item.pageID\"><md-option ng-value=\"page.id\" \nng-repeat=\"page in pages | orderBy : \'name\' track by $index\">{{page.name}}</md-option></md-select></md-input-container>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"!(item.index > 0)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"upItem(item, item.index, null, null)\"><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button \nng-disabled=\"!(item.index != siteMenu.items.length - 1)\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"downItem(item, item.index, null, null)\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon>\n</md-button><md-button class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"saveItem(item)\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"s20\"></md-icon></md-button><md-button class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"deleteItem(item)\"><md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button><md-button \nclass=\"md-raised md-primary md-hue-2 ml-20\" ng-click=\"addItem(1, item.id)\">\n{{\'SITES_MANAGEMENT.MENUS.ADD_MENU\' | translate}}{{\'SITES_MANAGEMENT.MENUS.LEVEL1\' | translate}}</md-button></div>\n</div><div class=\"nl-block pl-20\" ng-repeat=\"subItem in item.subItems | orderBy: \'index\'\"><div \nclass=\"nl_categories-item-subtitle\">{{\'SITES_MANAGEMENT.MENUS.LEVEL\' | translate}} {{subItem.level + 1}}</div><div \nlayout=\" row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"mt-20 mb-0\"><label>{{\'SITES_MANAGEMENT.MENUS.TITLE\' | translate}}</label><input class=\"\" type=\"text\" \nng-model=\"subItem.title\"></md-input-container><md-input-container class=\"mb-5 mt-0\"><label>\n{{\'SITES_MANAGEMENT.MENUS.LINKED_PAGE\' | translate}}</label><md-select ng-model=\"subItem.pageID\"><md-option \nng-value=\"page.id\" ng-repeat=\"page in pages | orderBy : \'name\' track by $index\">{{page.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"!(subItem.index > 0)\" \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"upItem(subItem, item.index, subItem.index, null)\">\n<md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button \nng-disabled=\"!(subItem.index != item.subItems.length - 1)\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"downItem(subItem, item.index, subItem.index, null)\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\">\n</md-icon></md-button><md-button class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"saveItem(subItem)\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"s20\"></md-icon></md-button><md-button class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"deleteItem(subItem)\"><md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button><md-button \nclass=\"md-raised md-primary md-hue-2 ml-20\" ng-click=\"addItem(2, subItem.id)\">\n{{\'SITES_MANAGEMENT.MENUS.ADD_MENU\' | translate}}{{\'SITES_MANAGEMENT.MENUS.LEVEL2\' | translate}}</md-button></div>\n</div><div class=\"nl-block ml-20\" ng-repeat=\"subSubItem in subItem.subItems | orderBy: \'index\'\"><div \nclass=\"nl_categories-item-subtitle\">{{\'SITES_MANAGEMENT.MENUS.LEVEL\' | translate}} {{subSubItem.level + 1}}</div><div \nlayout=\" row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"mt-20 mb-0\"><label>{{\'SITES_MANAGEMENT.MENUS.TITLE\' | translate}}</label><input type=\"text\" \nng-model=\"subSubItem.title\"></md-input-container><md-input-container class=\"mb-5 mt-0\"><label>\n{{\'SITES_MANAGEMENT.MENUS.LINKED_PAGE\' | translate}}</label><md-select ng-model=\"subSubItem.pageID\"><md-option \nng-value=\"page.id\" ng-repeat=\"page in pages | orderBy : \'name\' track by $index\">{{page.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-button \nng-disabled=\"!(subSubItem.index > 0)\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"upItem(subSubItem, item.index, subItem.index, subSubItem.index)\"><md-icon md-font-icon=\"icon-arrow-up\" \nclass=\"s18\"></md-icon></md-button><md-button ng-disabled=\"!(subSubItem.index != subItem.subItems.length - 1)\" \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"downItem(subSubItem, item.index, subItem.index, subSubItem.index)\"><md-icon md-font-icon=\"icon-arrow-down\" \nclass=\"s18\"></md-icon></md-button><md-button class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"saveItem(subSubItem)\"><md-icon md-font-icon=\"icon-content-save\" class=\"s20\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"deleteItem(subSubItem)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s20\"></md-icon></md-button></div></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/sites/site.dialog.html","<md-dialog class=\"sites-dialog\" aria-label=\"Disposition\" flex style=\"max-height:95%!important\"><form name=\"siteForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name pt-10\" ng-if=\"!site.id\">\n{{\'SITES_MANAGEMENT.SITES.ADD\' | translate}}</div><div class=\"contact-name pt-10\" ng-if=\"site.id\">\n{{\'SITES_MANAGEMENT.SITES.MAJ\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"$mdDialog.cancel();\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content layout=\"column\"><div layout=\"row\" layout-wrap><div \nclass=\"nl-info-block-list-img animated fadeIn\" flex=\"60\"><md-input-container class=\"\"><input type=\"text\" name=\"name\" \nng-model=\"site.name\" placeholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS.NAME\' | translate}}\" required><div class=\"\" \nng-messages=\"siteForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"\"><input type=\"text\" name=\"url\" ng-model=\"site.url\" \nplaceholder=\"URL\" required><div class=\"\" ng-messages=\"siteForm.url.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><div flex=\"10\" class=\"\" \nlayout=\"column\"></div><div flex=\"30\" class=\"\" layout=\"column\"><md-input-container class=\"\"><label>Logo</label>\n<dropify-directive filesave=\"photo.uploadFile\" ng-model=\"site\" placeholder=\"\" id=\"site_logo\"></md-input-container>\n</div></div><div layout=\"row\" layout-wrap class=\"mt-50\"><md-input-container class=\"\"><md-select \nng-model=\"site.languages\" multiple=\"multiple\" placeholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS.LANGUAGES\' | translate}}\" \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"lang in languages | orderBy : \'key\'\" ng-value=\"lang\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container>\n<md-input-container class=\"\"><md-select name=\"defaultLanguage\" ng-model=\"site.defaultLanguage\" \nplaceholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS.DEFAULT_LANGUAGE\' | translate}}\" required><md-option \nng-repeat=\"lang in languages | orderBy : \'key\'\" ng-value=\"lang\" ng-selected=\"lang.id == site.defaultLanguage.id\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select><div class=\"\" \nng-messages=\"siteForm.defaultLanguage.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" ng-if=\"site.id\">\n<md-select name=\"homePage\" ng-model=\"site.homePage\" \nplaceholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS.WELCOME_PAGE\' | translate}}\" ng-model-options=\"{trackBy: \'$value.id\'}\">\n<md-option ng-repeat=\"_page in pages | orderBy : \'name\'\" ng-value=\"_page\">{{_page.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"\"><input type=\"text\" name=\"twitterUrl\" ng-model=\"site.twitterUrl\" \nplaceholder=\"twitter\"></md-input-container><md-input-container class=\"\"><input type=\"text\" name=\"facebookUrl\" \nng-model=\"site.facebookUrl\" placeholder=\"Facebook\"></md-input-container><md-input-container class=\"\"><input \ntype=\"text\" name=\"instagramUrl\" ng-model=\"site.instagramUrl\" placeholder=\"Instagram\"></md-input-container>\n<md-input-container class=\"\"><input type=\"text\" name=\"linkedinUrl\" ng-model=\"site.linkedinUrl\" placeholder=\"Linkedin\">\n</md-input-container><md-input-container class=\"\"><input type=\"text\" name=\"youtubeUrl\" ng-model=\"site.youtubeUrl\" \nplaceholder=\"Youtube\"></md-input-container><md-input-container class=\"\"><textarea name=\"css\" ng-model=\"site.css\" \nplaceholder=\"CSS\" rows=\"5\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button type=\"button\" ng-if=\"site.id\" ng-click=\"_delete()\" \nclass=\"md-red-400-bg submit-button md-raised\" aria-label=\"Delete\">{{\'SITES_MANAGEMENT.ACTIONS.DELETE\' | translate}}\n</md-button><md-button type=\"submit\" ng-click=\"_save(siteForm);\" class=\"md-accent submit-button md-raised\" \naria-label=\"Save\">{{\'SITES_MANAGEMENT.ACTIONS.SAVE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sites_management/sites/sites.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"SITES_MANAGEMENT.SITES.TITLES\"></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button type=\"button\" class=\"\" ng-click=\"_dialogFn()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>{{\'SITES_MANAGEMENT.SITES.ADD\' | translate}}</md-button></div></div><div \nclass=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table class=\"dataTable row-border hover\">\n<thead><tr><th><div>{{\'SITES_MANAGEMENT.SITES.FIELDS.NAME\' | translate}}</div><div><input type=\"text\" \nng-model=\"search.name\" placeholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS_SEARCH.NAME\' | translate}}\"></div></th><th><div>\nURL</div><div><input type=\"text\" ng-model=\"search.url\" \nplaceholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS_SEARCH.URL\' | translate}}\"></div></th><th><div>\n{{\'SITES_MANAGEMENT.SITES.FIELDS.LANGUAGES\' | translate}}</div><div><input type=\"text\" \nng-model=\"search.languagesTmp.libelle\" placeholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS_SEARCH.LANGUAGES\' | translate}}\">\n</div></th></tr></thead><tbody><tr ng-repeat=\"_site in sites | filter:search | orderBy : \'name\' track by $index\" \nng-click=\"_dialogFn(_site)\"><td>{{ _site.name }}</td><td>{{ _site.url }}</td><td><span \nng-repeat=\"lang in _site.languagesTmp | orderBy: \'key\' track by $index\" class=\"mr-5\" \nng-class=\"lang.defaultLanguage ? \'md-green-800-bg\' : \'md-grey-300-bg\'\">{{ lang.libelle }}</span></td></tr></tbody>\n</table></div></div></div></div>");
$templateCache.put("app/main/statistics/automatic/automaticStatistics.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"STATISTICS.AUTOMATIC.TITLE\"></div></div><div layout=\"row\" layout-align=\"start center\"></div></div>\n<div class=\"content\"><div class=\"nl-Block\"><div layout=\"row\"><md-input-container flex><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"year\" ng-change=\"getStatistics()\">\n<md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYear(false)\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option value=\"all\">\n{{\"STATISTICS.AUTOMATIC.ALL\" | translate}}</md-option><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">\n{{year}}</md-option><md-option value=\"custom\" style=\"display: none\">{{customYear}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-change=\"getStatistics()\" \nplaceholder=\"{{\'STATISTICS.REPARTITION.PLACEHOLDER.TYPE\' | translate}}\" ng-model=\"filter.typeID\" name=\"typeID\">\n<md-option ng-value=\"null\" selected=\"selected\">{{\'STATISTICS.AUTOMATIC.ALL\' | translate}}</md-option><md-option \nng-repeat=\"type in typesCompany\" ng-value=\"type.id\">{{type.name}}</md-option></md-select></md-input-container></div>\n<div ng-if=\"statistics.length > 0\"><table class=\"nl-Table pure-table pure-table-bordered\"><thead><th>\n{{\"STATISTICS.AUTOMATIC.TABLE.DATE\" | translate}}</th><th>{{\"STATISTICS.AUTOMATIC.TABLE.NBR_COMPANIES\" | translate}}\n</th><th>{{\"STATISTICS.AUTOMATIC.TABLE.NBR_USERS\" | translate}}</th></thead><tbody><tr ng-repeat=\"stat in statistics\">\n<td>{{(stat.month > 10 ? stat.month : \'0\' + stat.month ) + \'/\' + stat.year}}</td><td>{{stat.nbrCompanies}}</td><td>\n{{stat.nbrUsers}}</td></tr></tbody></table><br><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"chart.data\" \nchart-labels=\"chart.labels\" chart-series=\"chart.series\" chart-options=\"chart.options\" \nchart-dataset-override=\"chart.datasetOverride\"></canvas></div><div class=\"mb-15 mh-10\" ng-if=\"statistics.length === 0\">\n{{\"STATISTICS.AUTOMATIC.NO_RESULT\" | translate}}</div></div></div></div>");
$templateCache.put("app/main/statistics/display/displayStatistics.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"STATISTICS.DISPLAY.TITLE\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"button\" class=\"md-accent md-hue-1\" ng-click=\"switchMode()\"><md-icon md-font-icon=\"icon-swap-horizontal\">\n</md-icon><span ng-if=\"!filterMode\">{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</span> <span ng-if=\"!!filterMode\">\n{{\'STATISTICS.DISPLAY.COMPARE\' | translate}}</span></md-button></div></div><div class=\"content\"><div \nng-if=\"!!filterMode\"><div class=\"nl-Block\"><div class=\"nl_categories-item-title\" layout=\"row\" \nlayout-align=\"space-between center\">{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</div><div \nclass=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.RESULT_BETWEEN\' | translate}}</div><div layout=\"row\"><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filter.begin.month\"><md-option \nng-value=\"month.value\" ng-repeat=\"month in monthNames\">{{month.name}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select \nng-model=\"filter.begin.year\"><md-select-header><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"customYear.filter.begin\" onkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button \nng-click=\"searchStatisticsCustomYear(true)\" class=\"m-0\">{{\'GENERAL.OK\' | translate}}</md-button></md-select-header>\n<md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">{{year}}</md-option><md-option value=\"custom\" \nstyle=\"display: none\">{{customYear.filter.begin}}</md-option></md-select></md-input-container></div><div \nclass=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.AND\' | translate}}</div><div layout=\"row\"><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filter.end.month\"><md-option \nng-value=\"month.value\" ng-repeat=\"month in monthNames\">{{month.name}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select \nng-model=\"filter.end.year\"><md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear.filter.end\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYear(false)\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">\n{{year}}</md-option><md-option value=\"custom\" style=\"display: none\">{{customYear.filter.end}}</md-option></md-select>\n</md-input-container></div><md-input-container><label>{{\'GENERAL.COMPANY\' | translate}}</label><md-select \nng-model=\"filter.companyID\" md-on-open=\"\" md-on-close=\"filterSelectText = \'\'\"><md-option ng-value=\"null\" \nselected=\"selected\">{{\'STATISTICS.DISPLAY.ALL_COMPANIES\' | translate}}</md-option><md-option ng-value=\"company.id\" \nng-repeat=\"company in companies | orderBy: \'modelPattern\'\">{{company.modelPattern}}</md-option></md-select>\n</md-input-container><md-input-container ng-repeat=\"field in specificFields\"><label>{{field.libelle}}</label><md-select\n ng-model=\"specificFieldsValue[field.id]\"><md-option ng-value=\"null\" selected=\"selected\">\n{{\'STATISTICS.AUTOMATIC.ALL\' | translate}}</md-option><md-option ng-value=\"value.id\" \nng-repeat=\"value in field.listFieldsDTO | orderBy: \'value\'\">{{value.value}}</md-option></md-select>\n</md-input-container><md-input-container><label>{{\'STATISTICS.REGROUP_BY\' | translate }}</label><md-select \nng-model=\"filter.regroupment\"><md-option ng-value=\"null\" selected=\"selected\">{{\'STATISTICS.AUTOMATIC.ALL\' | translate}}\n</md-option><md-option ng-value=\"field.id\" ng-repeat=\"field in specificFields | orderBy: \'libelle\'\">{{field.libelle}}\n</md-option></md-select></md-input-container><md-input-container class=\"mt-0 mb-0\"><md-checkbox name=\"\" \nclass=\"md-primary md-hue-2\" ng-model=\"filter.onlyAverage\" aria-label=\"onlyAverage\">\n{{\'STATISTICS.DISPLAY.ONLY_AVERAGE\'|translate}}</md-checkbox></md-input-container><div class=\"mt-5\"><md-button \nclass=\"md-raised md-primary md-hue-2\" md-no-ink ng-click=\"getStatsCompanies()\">\n{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</md-button><md-button class=\"md-raised md-primary md-hue-2\" md-no-ink \nng-click=\"getStatsNationalities()\">{{\'STATISTICS.DISPLAY.BUTTON_GET_STATS_NATIONALITIES\' | translate}}</md-button>\n<md-button class=\"md-primary md-hue-2 ml-30\" ng-click=\"downloadCompanies()\">\n{{\'STATISTICS.DISPLAY.BUTTON_DOWNLOAD_COMPANIES\' | translate}}</md-button><md-button class=\"md-primary md-hue-2\" \nng-click=\"downloadNationalities()\">{{\'STATISTICS.DISPLAY.BUTTON_DOWNLOAD_NATIONALITIES\' | translate}}</md-button></div>\n</div><div class=\"nl-Block mt-25\"><div class=\"nl-loader\" ng-show=\"loading.filter\"><div class=\"spinner\"><div \nclass=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div \nclass=\"half-circle\"></div></div></div></div></div><div><div class=\"nl_categories-item-title\" layout=\"row\" \nlayout-align=\"space-between center\">{{\'STATISTICS.DISPLAY.STATS_BY_COMPANY\' | translate}}</div><table \nclass=\"nl-Table pure-table pure-table-bordered\" ng-if=\"statisticsArray.length > 0\"><thead><tr><th style=\"width:10%\">\n{{\'GENERAL.COMPANY\' | translate}}</th><th>{{\'STATISTICS.EDIT.FIELDS.STAR_RATING\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.REGION\' | translate}}</th><th>{{\'STATISTICS.DISPLAY.MONTH\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.STATS_NATIONALITY.NBR_ARRIVALS\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.STATS_NATIONALITY.NBR_LEAVINGS\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.NBR_ROOMS\' | translate}}</th><th>{{\'STATISTICS.EDIT.FIELDS.NBR_OCCUPED_ROOMS\' | translate}}\n</th><th>{{\'STATISTICS.EDIT.FIELDS.INCOME_ON_MONTH\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.INCOME_BY_DAY\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.AVERAGE_DURATION_STAY\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.OCCUPATION_PERCENTAGE\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.NBR_EMPLOYEES_FULL_TIME\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.NBR_EMPLOYEES_PART_TIME\' | translate}}</th></tr></thead><tbody \nstyle=\"border-bottom: 1px solid #cbcbcb\" ng-repeat=\"elt in statisticsArray | orderBy: \'company\'\"><tr \nng-repeat=\"stat in elt.statistics track by $index\"><td ng-if=\"$index === 0\" rowspan=\"{{elt.statistics.length}}\">\n{{elt.company}}</td><td>{{elt.category}}</td><td>{{elt.region}}</td><td ng-if=\"!stat.average\">\n{{(stat.month > 9 ? (stat.month+1) : \"0\" + (stat.month+1)) + \"/\" + stat.year}}</td><td ng-if=\"stat.average\">\n{{\'STATISTICS.DISPLAY.AVERAGE\' | translate}}</td><td>{{stat.nbrArrivals}}</td><td>{{stat.nbrDepartures}}</td><td>\n{{stat.nbrRooms}}</td><td>{{stat.nbrOccupedRooms}}</td><td>{{stat.incomeOnMonth}}</td><td>{{stat.incomeByDay | number}}\n</td><td>{{stat.averageDurationStay}}</td><td>\n{{(stat.nbrOccupedRooms != null && stat.nbrRooms != null && stat.nbrRooms != 0) ? ((stat.nbrOccupedRooms / stat.nbrRooms) * 100) : \"\" | limitTo: 4}}{{(stat.nbrOccupedRooms != null && stat.nbrRooms != null && stat.nbrRooms != 0) ? \"%\" : \"\"}}\n</td><td>{{stat.nbrEmployeesFullTime}}</td><td>{{stat.nbrEmployeesPartTime}}</td></tr></tbody></table><div \nclass=\"pt-10 pb-15 ph-10\" ng-if=\"statisticsArray.length === 0\">{{\'STATISTICS.DISPLAY.NO_RESULT\' | translate}}</div>\n</div><div class=\"mt-25\"><div class=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.STATS_BY_NATIONALITY\' | translate}}</div><table class=\"nl-Table pure-table pure-table-bordered\" \nng-if=\"statisticsNatArray.length > 0\"><thead><tr><th>\n{{\'STATISTICS.DISPLAY.TABLE_NATIONALITIES.NATIONALITY\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_NATIONALITIES.NBR_ARRIVALS\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_NATIONALITIES.NBR_LEAVINGS\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_NATIONALITIES.NBR_TOTAL_CUSTOMERS\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_NATIONALITIES.NBR_TOTAL_NIGHTS\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_NATIONALITIES.AVERAGE_NBR_NIGHTS_PERSON\' | translate}}</th></tr></thead><tbody><tr \nng-repeat=\"stat in statisticsNatArray\"><td>{{stat.nationality.libelle}}</td><td>{{stat.nbrArrivals}}</td><td>\n{{stat.nbrLeavings}}</td><td>{{stat.nbrArrivals + stat.nbrLeavings}}</td><td>{{stat.nbrNights}}</td><td>\n{{stat.nbrNights / (stat.nbrArrivals + stat.nbrLeavings) | limitTo: 3}}</td></tr></tbody></table><div \nclass=\"pt-10 pb-15 ph-10\" ng-if=\"statisticsNatArray.length === 0\">{{\'STATISTICS.DISPLAY.NO_RESULT\' | translate}}</div>\n</div></div></div><div ng-if=\"!filterMode\" class=\"nl-Block\"><div class=\"nl_categories-item-title\" layout=\"row\" \nlayout-align=\"space-between center\">{{\'STATISTICS.DISPLAY.PERIOD1\' | translate}}</div><div layout=\"row\">\n<md-input-container flex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select \nng-model=\"filterFirstPeriod.begin.month\"><md-option ng-value=\"month.value\" ng-repeat=\"month in monthNames\">\n{{month.name}}</md-option></md-select></md-input-container><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"filterFirstPeriod.begin.year\">\n<md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear.compare.firstPeriod.begin\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCompareCustomYear(true, true)\" \nclass=\"m-0\">{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option ng-value=\"year\" \nng-repeat=\"year in yearValues\">{{year}}</md-option><md-option value=\"custom\" style=\"display: none\">\n{{customYear.compare.firstPeriod.begin}}</md-option></md-select></md-input-container></div><div \nclass=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.AND\' | translate}}</div><div layout=\"row\"><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filterFirstPeriod.end.month\">\n<md-option ng-value=\"month.value\" ng-repeat=\"month in monthNames\">{{month.name}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label>\n<md-select ng-model=\"filterFirstPeriod.end.year\"><md-select-header><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"customYear.compare.firstPeriod.end\" onkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button \nng-click=\"searchStatisticsCompareCustomYear(true, false)\" class=\"m-0\">{{\'GENERAL.OK\' | translate}}</md-button>\n</md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">{{year}}</md-option><md-option \nvalue=\"custom\" style=\"display: none\">{{customYear.compare.firstPeriod.end}}</md-option></md-select>\n</md-input-container></div><div class=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.PERIOD2\' | translate}}</div><div layout=\"row\"><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filterSecondPeriod.begin.month\">\n<md-option ng-value=\"month.value\" ng-repeat=\"month in monthNames\">{{month.name}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label>\n<md-select ng-model=\"filterSecondPeriod.begin.year\"><md-select-header><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"customYear.compare.secondPeriod.begin\" onkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button \nng-click=\"searchStatisticsCompareCustomYear(false, true)\" class=\"m-0\">{{\'GENERAL.OK\' | translate}}</md-button>\n</md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">{{year}}</md-option><md-option \nvalue=\"custom\" style=\"display: none\">{{customYear.compare.secondPeriod.begin}}</md-option></md-select>\n</md-input-container></div><div class=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.AND\' | translate}}</div><div layout=\"row\"><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filterSecondPeriod.end.month\">\n<md-option ng-value=\"month.value\" ng-repeat=\"month in monthNames\">{{month.name}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label>\n<md-select ng-model=\"filterSecondPeriod.end.year\"><md-select-header><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"customYear.compare.secondPeriod.end\" onkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button \nng-click=\"searchStatisticsCompareCustomYear(false, false)\" class=\"m-0\">{{\'GENERAL.OK\' | translate}}</md-button>\n</md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">{{year}}</md-option><md-option \nvalue=\"custom\" style=\"display: none\">{{customYear.compare.secondPeriod.end}}</md-option></md-select>\n</md-input-container></div><md-button md-no-ink class=\"md-raised md-primary md-hue-2\" \nng-click=\"getStatsCompareCompanies()\">Comparer</md-button><div class=\"nl-loader\" ng-show=\"loading.compare\"><div \nclass=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div \nclass=\"right\"><div class=\"half-circle\"></div></div></div></div></div><div class=\"mt-25\" \nng-if=\"statisticsCompare.length > 0\"><table class=\"nl-Table pure-table pure-table-bordered\"><thead><tr><th rowspan=\"2\" \nwidth=\"6%\">{{\'GENERAL.COMPANY\' | translate}}</th><th colspan=\"3\">\n{{\'STATISTICS.EDIT.FIELDS.STATS_NATIONALITY.NBR_ARRIVALS\' | translate}}</th><th colspan=\"3\">\n{{\'STATISTICS.EDIT.FIELDS.STATS_NATIONALITY.NBR_LEAVINGS\' | translate}}</th><th colspan=\"3\">\n{{\'STATISTICS.EDIT.FIELDS.NBR_ROOMS\' | translate}}</th><th colspan=\"3\">\n{{\'STATISTICS.EDIT.FIELDS.INCOME_ON_MONTH\' | translate}}</th><th colspan=\"3\">\n{{\'STATISTICS.EDIT.FIELDS.AVERAGE_DURATION_STAY\' | translate}}</th><th colspan=\"3\">Taux occupation</th><th colspan=\"3\">\n{{\'STATISTICS.EDIT.FIELDS.NBR_EMPLOYEES_FULL_TIME\' | translate}}</th><th colspan=\"3\">\n{{\'STATISTICS.EDIT.FIELDS.NBR_EMPLOYEES_PART_TIME\' | translate}}</th></tr><tr><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th></tr></thead><tbody><tr \nng-repeat=\"stat in statisticsCompare[0] track by $index\"><td>{{stat.company}}</td><td>\n{{stat.statistics[0].nbrArrivals}}</td><td>{{statisticsCompare[1][$index].statistics[0].nbrArrivals}}</td><td \nng-style=\"{ color: (stat.statistics[0].evoNbrArrivals === 0 ? \'\': (stat.statistics[0].evoNbrArrivals >= 0 ? \'green\': \'red\')) }\">\n{{stat.statistics[0].evoNbrArrivals}}%</td><td>{{stat.statistics[0].nbrDepartures}}</td><td>\n{{statisticsCompare[1][$index].statistics[0].nbrDepartures}}</td><td \nng-style=\"{ color: (stat.statistics[0].evoNbrDepartures === 0 ? \'\': (stat.statistics[0].evoNbrDepartures >= 0 ? \'green\': \'red\'))}\">\n{{stat.statistics[0].evoNbrDepartures}}%</td><td>{{stat.statistics[0].nbrRooms}}</td><td>\n{{statisticsCompare[1][$index].statistics[0].nbrRooms}}</td><td \nng-style=\"{ color: (stat.statistics[0].evoNbrRooms === 0 ? \'\': (stat.statistics[0].evoNbrRooms >= 0 ? \'green\': \'red\'))}\">\n{{stat.statistics[0].evoNbrRooms}}%</td><td>{{stat.statistics[0].incomeOnMonth}}</td><td>\n{{statisticsCompare[1][$index].statistics[0].incomeOnMonth}}</td><td \nng-style=\"{ color: (stat.statistics[0].evoIncomeOnMonth === 0 ? \'\': (stat.statistics[0].evoIncomeOnMonth >= 0 ? \'green\': \'red\'))}\">\n{{stat.statistics[0].evoIncomeOnMonth}}%</td><td>{{stat.statistics[0].averageDurationStay}}</td><td>\n{{statisticsCompare[1][$index].statistics[0].averageDurationStay}}</td><td \nng-style=\"{ color: (stat.statistics[0].evoAverageDurationStay === 0 ? \'\': (stat.statistics[0].evoAverageDurationStay >= 0 ? \'green\': \'red\'))}\">\n{{stat.statistics[0].evoAverageDurationStay}}%</td><td>{{stat.statistics[0].occupationRate}}%</td><td>\n{{statisticsCompare[1][$index].statistics[0].occupationRate}}%</td><td \nng-style=\"{ color: (stat.statistics[0].evoOccupationRate === 0 ? \'\': (stat.statistics[0].evoOccupationRate >= 0 ? \'green\': \'red\'))}\">\n{{stat.statistics[0].evoOccupationRate}}%</td><td>{{stat.statistics[0].nbrEmployeesFullTime}}</td><td>\n{{statisticsCompare[1][$index].statistics[0].nbrEmployeesFullTime}}</td><td \nng-style=\"{ color: (stat.statistics[0].evoNbrEmployeesFullTime === 0 ? \'\': (stat.statistics[0].evoNbrEmployeesFullTime >= 0 ? \'green\': \'red\'))}\">\n{{stat.statistics[0].evoNbrEmployeesFullTime}}%</td><td>{{stat.statistics[0].nbrEmployeesPartTime}}</td><td>\n{{statisticsCompare[1][$index].statistics[0].nbrEmployeesPartTime}}</td><td \nng-style=\"{ color: (stat.statistics[0].evoNbrEmployeesPartTime === 0 ? \'\': (stat.statistics[0].evoNbrEmployeesPartTime >= 0 ? \'green\': \'red\'))}\">\n{{stat.statistics[0].evoNbrEmployeesPartTime}}%</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/statistics/edit/editStatistics.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"STATISTICS.EDIT.TITLE\"></div></div><div layout=\"row\" layout-align=\"start center\"></div></div><div \nclass=\"content\"><div layout=\"row\" ng-if=\"isAdmin\"><md-input-container><label>{{\'GENERAL.COMPANY\' | translate}}</label>\n<md-select ng-model=\"selectCompany.id\" ng-change=\"getStatistics()\"><md-option ng-value=\"company.id\" \nng-repeat=\"company in companies | orderBy : \'modelPattern\'\">{{company.modelPattern}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"selectedPeriod.month\" \nng-change=\"getStatistics()\"><md-option ng-value=\"month.value\" ng-repeat=\"month in monthNames\">{{month.name}}\n</md-option></md-select></md-input-container><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"selectedPeriod.year\" \nng-change=\"getStatistics()\"><md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYear()\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">\n{{year}}</md-option><md-option value=\"custom\" style=\"display: none\">{{customYear}}</md-option></md-select>\n</md-input-container></div><md-input-container><label translate=\"STATISTICS.EDIT.FIELDS.NBR_ROOMS\"></label><input \ntype=\"number\" min=\"0\" step=\"1\" ng-model=\"statistics.nbrRooms\"></md-input-container><md-input-container><label \ntranslate=\"STATISTICS.EDIT.FIELDS.NBR_OCCUPED_ROOMS\"></label><input class=\"\" type=\"number\" min=\"0\" step=\"1\" \nng-model=\"statistics.nbrOccupedRooms\"></md-input-container><div layout=\"row\" \nng-repeat=\"statNat in statistics.statsNationality | orderBy: \'nationality.libelle\' track by $index\"><md-input-container\n flex=\"23\"><label>{{\'STATISTICS.EDIT.FIELDS.STATS_NATIONALITY.NATIONALITY\' | translate}}</label><md-select \nng-model=\"statNat.nationality\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"nationality in nationalities | orderBy: \'libelle\'\" ng-value=\"nationality\" \nng-disabled=\"!!nationality.alreadyHere\">{{nationality.libelle}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"23\"><label translate=\"STATISTICS.EDIT.FIELDS.STATS_NATIONALITY.NBR_LEAVINGS\"></label><input \nclass=\"\" type=\"number\" min=\"0\" step=\"1\" ng-model=\"statNat.nbrLeavings\"></md-input-container><md-input-container \nflex=\"23\"><label translate=\"STATISTICS.EDIT.FIELDS.STATS_NATIONALITY.NBR_ARRIVALS\"></label><input class=\"\" \ntype=\"number\" min=\"0\" step=\"1\" ng-model=\"statNat.nbrArrivals\"></md-input-container><md-input-container flex=\"23\"><label\n translate=\"STATISTICS.EDIT.FIELDS.STATS_NATIONALITY.NBR_NIGHTS\"></label><input class=\"\" type=\"number\" min=\"0\" \nstep=\"1\" ng-model=\"statNat.nbrNights\"></md-input-container><md-button class=\"md-icon-button md-warn\" aria-label=\"\" \nng-click=\"removeNationality($index)\">X</md-button></div><md-button class=\"md-primary\" ng-click=\"addNationality()\" \nng-if=\"statistics.statsNationality.length < nationalities.length\">\n{{\'STATISTICS.EDIT.BUTTONS.ADD_NATIONALITY\' | translate}}</md-button><md-input-container><label \ntranslate=\"STATISTICS.EDIT.FIELDS.NBR_CLIENTS\"></label><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"statistics.nbrClients\"></md-input-container><md-input-container><label \ntranslate=\"STATISTICS.EDIT.FIELDS.INCOME_ON_MONTH\"></label><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"statistics.incomeOnMonth\"></md-input-container><md-input-container><label \nclass=\"nl-Input-label md-no-float md-container-ignore\" translate=\"STATISTICS.EDIT.FIELDS.AVERAGE_DURATION_STAY\">\n</label><input type=\"number\" min=\"0\" ng-model=\"statistics.averageDurationStay\"></md-input-container>\n<md-input-container><label class=\"nl-Input-label md-no-float md-container-ignore\" \ntranslate=\"STATISTICS.EDIT.FIELDS.NBR_EMPLOYEES_FULL_TIME\"></label><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"statistics.nbrEmployeesFullTime\"></md-input-container><md-input-container><label \nclass=\"nl-Input-label md-no-float md-container-ignore\" translate=\"STATISTICS.EDIT.FIELDS.NBR_EMPLOYEES_PART_TIME\">\n</label><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"statistics.nbrEmployeesPartTime\"></md-input-container>\n<md-button class=\"md-primary\" ng-click=\"save()\"><span ng-if=\"!!overwriteMode\">\n{{\'STATISTICS.EDIT.BUTTONS.VALIDATE.UPDATE\' | translate}}</span> <span ng-if=\"!overwriteMode\">\n{{\'STATISTICS.EDIT.BUTTONS.VALIDATE.SAVE\' | translate}}</span></md-button></div></div>");
$templateCache.put("app/main/statistics/repartition/repartitionStatistics.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"STATISTICS.REPARTITION.TITLE\"></div></div></div><div class=\"content\"><div layout=\"row\" \nclass=\"nl-Block\"><md-input-container><md-select \nplaceholder=\"{{\'STATISTICS.REPARTITION.PLACEHOLDER.ENTITY\' | translate}}\" ng-model=\"userValues.typeRepartition\" \nname=\"repartition\" ng-change=\"checkTypeRepartition()\" flex=\"33\"><md-option ng-repeat=\"type in typesRepartition\" \nng-value=\"type.value\">{{type.name}}</md-option></md-select></md-input-container><md-input-container \nng-if=\"userValues.typeRepartition === \'COMPANY_MODEL\'\"><md-select \nplaceholder=\"{{\'STATISTICS.REPARTITION.PLACEHOLDER.TYPE\' | translate}}\" ng-model=\"userValues.typeCompany\" \nname=\"typeCompany\" ng-change=\"checkTypeCompany()\" flex=\"33\"><md-option ng-repeat=\"type in data.typesCompany\" \nng-value=\"type.id\">{{type.name}}</md-option></md-select></md-input-container><md-input-container \nng-if=\"userValues.typeRepartition === \'CONTACT_MODEL\'\"><md-select \nplaceholder=\"{{\'STATISTICS.REPARTITION.PLACEHOLDER.TYPE\' | translate}}\" ng-model=\"userValues.typeCompanyContact\" \nname=\"typeCompanyContact\" ng-change=\"checkField()\" flex=\"33\"><md-option ng-value=\"null\">\n{{\"STATISTICS.AUTOMATIC.ALL\" | translate}}</md-option><md-option ng-repeat=\"type in data.typesCompany\" \nng-value=\"type.id\">{{type.name}}</md-option></md-select></md-input-container><md-input-container \nng-if=\"(userValues.typeRepartition === \'CONTACT_MODEL\' || (userValues.typeRepartition === \'COMPANY_MODEL\' && userValues.typeCompany !== null)) && data.fields.length > 0\">\n<md-select placeholder=\"{{\'STATISTICS.REPARTITION.PLACEHOLDER.CRITERIA\' | translate}}\" ng-model=\"userValues.field\" \nname=\"field\" ng-change=\"checkField()\" flex=\"33\"><md-option ng-repeat=\"field in data.fields\" ng-value=\"field.id\">\n{{field.libelle}}</md-option></md-select></md-input-container></div><canvas ng-if=\"!displayChartSubTypes\" id=\"pie\" \nclass=\"chart chart-pie mt-30\" chart-data=\"chart.data\" chart-labels=\"chart.labels\" chart-options=\"chart.options\">\n</canvas><div ng-if=\"displayChartSubTypes\"><canvas id=\"pieCompanies\" class=\"chart chart-pie mt-30\" \nchart-data=\"chart.dataSubTypes.companies\" chart-labels=\"chart.labelsSubTypes\" chart-options=\"chart.optionsCompanies\">\n</canvas><canvas id=\"pieContacts\" class=\"chart chart-pie mt-30\" chart-data=\"chart.dataSubTypes.contacts\" \nchart-labels=\"chart.labelsSubTypes\" chart-options=\"chart.optionsContacts\"></canvas></div></div></div>");
$templateCache.put("app/main/statistics/reporting/reportingStatistics.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"STATISTICS.REPORTING.TITLE\"></div></div></div><div class=\"content\"><div class=\"nl-Block\"><div \nlayout=\"row\"><md-input-container flex><label>{{\'STATISTICS.REPORTING.GROUP\' | translate}}</label><md-select \nmd-on-open=\"\" md-on-close=\"filterSelectText = \'\'\" ng-model=\"filter.groupIDs\" aria-label=\"language\" name=\"receiver\" \nmultiple=\"multiple\" ng-change=\"getUsersByGroups()\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"group in groups | filterText: filterSelectText\" value=\"{{group.id}}\">{{group.name}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>{{\'STATISTICS.REPORTING.USER\' | translate}}</label><md-select \nmd-on-open=\"\" md-on-close=\"filterSelectText3 = \'\'\" ng-model=\"filter.userID\" aria-label=\"language\" name=\"user\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectText3\"></section></md-select-header><md-option ng-value=\"null\">\n{{\'STATISTICS.AUTOMATIC.ALL\' | translate}}</md-option><md-option \nng-repeat=\"user in users | orderBy: \'fullName\' | filterText: filterSelectText3\" value=\"{{user.id}}\">{{user.fullName}}\n</md-option></md-select></md-input-container><md-input-container flex class=\"md-block\"><label>\n{{\'STATISTICS.REPORTING.ACTION\' | translate}}</label><md-select md-on-open=\"\" md-on-close=\"filterSelectText2 = \'\'\" \nng-model=\"filter.actionIDs\" aria-label=\"language\" name=\"receiver\" multiple=\"multiple\"><md-select-header><section><input\n force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText2\"></section>\n</md-select-header><md-option ng-repeat=\"action in actions | filterText: filterSelectText2\" value=\"{{action.id}}\">\n{{action.libelle}}</md-option></md-select></md-input-container><md-select flex ng-model=\"year.value\" \nng-if=\"!customPeriod\"><md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customPeriods.filter\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYear(false)\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option value=\"all\">\n{{\"STATISTICS.AUTOMATIC.ALL\" | translate}}</md-option><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">\n{{year}}</md-option><md-option value=\"custom\" style=\"display: none\">{{customPeriods.filter}}</md-option></md-select>\n</div><md-input-container class=\"ml-20\"><md-checkbox class=\"md-primary md-hue-2\" name=\"\" ng-model=\"customPeriod\" \naria-label=\"custom period\">{{\"STATISTICS.AUTOMATIC.CUSTOM_PERIOD\"|translate}}</md-checkbox></md-input-container><div \nng-if=\"!!customPeriod\" class=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.RESULT_BETWEEN\' | translate}}</div><div layout=\"row\" ng-if=\"!!customPeriod\"><md-input-container \nflex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select \nng-model=\"customFilter.begin.month\"><md-option ng-value=\"month.value\" ng-repeat=\"month in monthNames\">{{month.name}}\n</md-option></md-select></md-input-container><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"customFilter.begin.year\">\n<md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customPeriods.period.begin.year\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYearBetween(true)\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">\n{{year}}</md-option><md-option value=\"custom\" style=\"display: none\">{{customPeriods.period.begin.year}}</md-option>\n</md-select></md-input-container></div><div ng-if=\"!!customPeriod\" class=\"nl_categories-item-subtitle\" layout=\"row\" \nlayout-align=\"space-between center\">{{\'STATISTICS.DISPLAY.AND\' | translate}}</div><div layout=\"row\" \nng-if=\"!!customPeriod\"><md-input-container flex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}\n</label><md-select ng-model=\"customFilter.end.month\"><md-option ng-value=\"month.value\" ng-repeat=\"month in monthNames\">\n{{month.name}}</md-option></md-select></md-input-container><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"customFilter.end.year\">\n<md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customPeriods.period.end.year\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYearBetween(false)\" \nclass=\"m-0\">{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option ng-value=\"year\" \nng-repeat=\"year in yearValues\">{{year}}</md-option><md-option value=\"custom\" style=\"display: none\">\n{{customPeriods.period.end.year}}</md-option></md-select></md-input-container></div></div><div><md-button \ntype=\"button\" ng-click=\"getStatisticsReporting()\" class=\"md-raised md-primary md-hue-2\">\n{{\'COMPANIES.FILTER\' | translate}}</md-button><md-button type=\"button\" ng-click=\"downloadStatisticsReporting()\" \nclass=\"md-raised md-primary md-hue-2\">{{\'GENERAL.DOWNLOAD\' | translate}}</md-button></div><div class=\"nl-Block mt-30\" \nng-if=\"stats.length > 0 && !displayCustomPeriod\"><h3>{{\'STATISTICS.REPORTING.NBR_ACTIONS\' | translate}}</h3><table \nclass=\"nl-Table nl-Table-doublebody pure-table pure-table-bordered\"><thead><tr><th></th><th \nng-repeat=\"month in monthNames\">{{month.name}}</th></tr></thead><tbody ng-repeat=\"group in stats\"><tr><td colspan=\"13\">\n<span layout=\"row\" layout-align=\"center center\">{{group.groupLibelle}}</span></td></tr><tr \nng-repeat-start=\"statJSON in group.statsJSON\"><td>{{statJSON.actionName}}</td><td ng-repeat=\"month in monthNames\">\n{{statJSON.months[$index]}}</td></tr><tr ng-repeat-end><td>\n{{statJSON.actionName}}{{\'STATISTICS.REPORTING.ACCRUED\' | translate}}</td><td ng-repeat=\"month in monthNames\">\n{{statJSON.monthsAccrued[$index]}}</td></tr></tbody></table></div><div class=\"nl-Block mt-30\" \nng-if=\"stats.length > 0 && displayCustomPeriod\"><h3>{{\'STATISTICS.REPORTING.NBR_ACTIONS\' | translate}}</h3><table \nclass=\"nl-Table nl-Table-doublebody pure-table pure-table-bordered\"><thead><tr><th></th><th>\n{{\'STATISTICS.REPORTING.NBR_ACTIONS\' | translate}}</th></tr></thead><tbody ng-repeat=\"group in stats\"><tr><td \ncolspan=\"2\"><span layout=\"row\" layout-align=\"center center\">{{group.groupLibelle}}</span></td></tr><tr \nng-repeat=\"stat in group.statsJSON\"><td>{{stat.actionName}}</td><td>{{stat.value}}</td></tr></tbody></table></div><div \nclass=\"nl-Block mt-30\" ng-if=\"messagesArray.length > 0\"><h3>{{\'STATISTICS.REPORTING.MESSAGES\' | translate}}</h3><table \nclass=\"nl-Table nl-Table-doublebody pure-table pure-table-bordered\"><thead><tr><th>\n{{\'STATISTICS.REPORTING.ROWS.DATE\' | translate}}</th><th>{{\'STATISTICS.REPORTING.ROWS.ACTION\' | translate}}</th><th>\n{{\'STATISTICS.REPORTING.ROWS.SENDER\' | translate}}</th><th>{{\'STATISTICS.REPORTING.ROWS.SUBJECT\' | translate}}</th><th>\n{{\'STATISTICS.REPORTING.ROWS.CONTENT\' | translate}}</th></tr></thead><tbody ng-repeat=\"group in messagesArray\"><tr><td \ncolspan=\"5\"><span layout=\"row\" layout-align=\"center center\">{{group.user}}</span></td></tr><tr \nng-repeat=\"msg in group.msgs | orderBy: \'action.libelle\'\"><td>{{msg.creationDate | date: \'dd/MM/yyyy à HH:mm\'}}</td>\n<td><div ng-if=\"msg.action\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-check\" \nng-class=\"{\'nl-validated\': msg.action.actionDone}\" ng-click=\"confirmAction(msg.action)\" layout=\"row\" \nlayout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !msg.action.actionDone, \'icon-check\' : msg.action.actionDone}\"></i></div><div \nclass=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{msg.action.libelle}}</div></div></div></td><td>\n{{msg.sender.fullName}}</td><td>{{msg.subject}}</td><td>\n{{msg.content | limitTo: 150}}{{ msg.content.length > 150 ? \'...\': \'\'}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/tourist_attractions/add/add_tourist_attraction.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><span \nng-if=\"tourist.id == null\" translate=\"TOURIST.ADD.TITLE\"></span> <span ng-if=\"tourist.id != null\" \ntranslate=\"TOURIST.UPDATE.TITLE\"></span></div><div layout=\"row\" layout-align=\"end center\"><md-input-container flex>\n<md-select ng-change=\"langageChanged()\" ng-model=\"language.key\" class=\"md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div class=\"content\"><div class=\"nl-Block\"><form name=\"addTouristForm\" \nclass=\"nl-Form-xs\" ng-submit=\"addTouristForm.$valid && add()\"><md-input-container><label>\n{{\"TOURIST.COLUMNS.NAME\" | translate}}</label><input type=\"text\" ng-model=\"tourist.name\" name=\"name\" required><div \nng-messages=\"addTouristForm.name.$error\" role=\"alert\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container><label>{{\"TOURIST.COLUMNS.COORDINATES\" | translate}}</label>\n<input type=\"text\" ng-model=\"tourist.coordinates\" name=\"coordinates\"></md-input-container><md-input-container><label>\n{{\"TOURIST.COLUMNS.CITY\" | translate}}</label><md-select ng-model=\"tourist.city\" \nng-model-options=\"{trackBy: \'$value.id\'}\" aria-label=\"region\" name=\"region\" required><md-option \nng-repeat=\"city in cities track by city.id\" ng-value=\"city\">{{city.value}}</md-option></md-select><div \nng-messages=\"addTouristForm.duration.$error\" role=\"alert\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container class=\"nl-Input-container\">\n<label>{{\"TOURIST.COLUMNS.REGION\" | translate}}</label><md-select ng-model=\"tourist.region\" \nng-model-options=\"{trackBy: \'$value.id\'}\" aria-label=\"region\" name=\"region\" required><md-option \nng-repeat=\"region in regions track by region.id\" ng-value=\"region\">{{region.value}}</md-option></md-select><div \nng-messages=\"addTouristForm.region.$error\" role=\"alert\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><br><md-input-container class=\"nl-Input-container\"><label>\n{{\"TOURIST.COLUMNS.TYPE\" | translate}}</label><md-select multiple=\"multiple\" ng-model=\"tourist.typeTourisme\" \nng-model-options=\"{trackBy: \'$value.id\'}\" aria-label=\"tourism\" name=\"tourism\" required><md-option \nng-repeat=\"tourism in tourisms track by tourism.id\" ng-value=\"tourism\">{{tourism.value}}</md-option></md-select><div \nng-messages=\"addTouristForm.tourism.$error\" role=\"alert\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><div class=\"nl_Trix\"><label class=\"nl_Trix-label\">Description</label><ng-quill-editor\n ng-model=\"tourist.description\"></ng-quill-editor></div><div ng-if=\"updateMode\" class=\"mv-20\"><div layout=\"row\" \nlayout-wrap><div class=\"m-5 nl-Form-dropify\" flex=\"15\" \nng-repeat=\"photo in tourist.photos | orderBy: \'docNumber\' track by $index\" layout=\"column\" layout-align=\"start end\">\n<div class=\"nl-Form-dropify-wrapper\"><img class=\"nl-Form-dropify has--image\" \nng-src=\"alternatedocroots/{{photo.location}}\"></div><md-button class=\"md-raised md-warn md-hue-2\" \nng-click=\"displayPopUpDeletePhoto(photo, $index)\"><md-icon md-font-icon=\"icon-close-circle-outline\"></md-icon>\n{{\"GENERAL.DELETE\" | translate}}</md-button></div></div></div><div class=\"mv-20\"><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"photos.push({})\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\"TOURIST.ADD.ADD_PHOTO\" | translate}}</md-button><div layout=\"row\" layout-wrap><div class=\"m-5 nl-Form-dropify\" \nflex=\"nogrow\" ng-repeat=\"photo in photos\" layout=\"column\" layout-align=\"start end\"><dropify-directive \nclass=\"dropify-wrapper has--deleteBtn\" id=\"tourist_photo_{{$index}}\" filesave=\"photo.uploadFile\" \nng-model=\"photo.model\"><md-button type=\"button\" class=\"md-raised md-warn md-hue-2\" ng-click=\"deletePhoto($index)\">\n<md-icon md-font-icon=\"icon-close-circle-outline\"></md-icon>{{\"TOURIST.ADD.DELETE_PHOTO\" | translate}}</md-button>\n</div></div></div><md-button type=\"submit\" md-no-ink class=\"md-primary md-raised md-hue-2\" translate=\"GENERAL.SAVE\">\n</md-button></form></div></div></div>");
$templateCache.put("app/main/tourist_attractions/popup/delete_photo.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">\n{{\"TOURIST.POPUP_DELETE_PHOTO.TITLE\" | translate}}</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"nl-Popup-content-body\"><div class=\"nl-Popup-content-body-title\">\n{{\"TOURIST.POPUP_DELETE_PHOTO.MESSAGE\" | translate}}</div><br><img \nng-src=\"alternatedocroots/{{photoToDelete.location}}\"></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button md-no-ink class=\"md-primary md-hue-2 md-raised\" ng-click=\"deletePhotoPermanentely()\" \ntranslate=\"GENERAL.YES\"></md-button><md-button class=\"md-warn md-hue-2\" ng-click=\"hidePopup()\" translate=\"GENERAL.NO\">\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-primary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-primary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-primary\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>Jhonny Deep</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n    <div class=\"ms-navigation-button nl-Nav-item\" ng-if=\"!node.uisref && node.title\">\n      <i class=\"icon s16 nl-Nav-icon {{node.icon}}\" ng-if=\"node.icon\"></i>\n      <span class=\"title nl-Nav-item-title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n      <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n      <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n    </div>\n\n    <a class=\"ms-navigation-button nl-Nav-item\" ui-sref-opts=\"{reload:true}\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-if=\"node.uisref && node.title\">\n      <i class=\"icon nl-Nav-icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n      <span class=\"title nl-Nav-item-title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n      <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n      <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n    </a>\n\n  </div>\n\n  <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n    <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n      ng-include=\"\'navigation-nested.html\'\"></li>\n  </ul>\n</script>");
$templateCache.put("app/main/access_rights/associations/popup/add_association.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"newAssociationForm\" class=\"md-inline-form\" novalidate \nng-submit=\"newAssociationForm.$valid && save(newAssociationForm)\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div>\n<div layout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'ASSOCIATIONS.NEW\' | translate}}</div>\n</div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-wrap>\n<div class=\"nl-info-block-list-img animated fadeIn\" flex=\"30\"><dropify-directive id=\"add_association_dropify\" \nfilesave=\"photo.uploadFile\" name=\"logo\" ng-model=\"newAssociation\" required><div ng-if=\"missingFile\" \nclass=\"md-input-messages-animation ng-active\" aria-live=\"assertive\"><span \nclass=\"md-input-message-animation ng-binding ng-scope\" \nstyle=\"opacity: 1; margin-top: 0px;color: rgb(213,0,0);font-size: 12px;line-height: 14px\" translate=\"GENERAL.REQUIRED\">\n</span></div></div><div flex=\"70\" class=\"\" layout=\"column\"><md-input-container class=\"nl-Input-container ml-15\" \nflex=\"100\"><input type=\"text\" class=\"\" ng-model=\"newAssociation.name\" name=\"name\" required maxlength=\"255\"><label \nclass=\"\" translate=\"ASSOCIATIONS.NAME\"></label><div ng-messages=\"newAssociationForm.name.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><md-select ng-model=\"newAssociation.admin\" name=\"admin\" required><md-option\n ng-repeat=\"user in users | orderBy: \'fullName\' track by user.id\" ng-value=\"user\">{{user.fullName}}</md-option>\n</md-select><label class=\"\" translate=\"ASSOCIATIONS.ADMIN\"></label><div ng-messages=\"newAssociationForm.admin.$error\">\n<span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"submit\" \nclass=\"md-primary md-hue-2 md-raised\" ng-disabled=\"newAssociationForm.$invalid\" aria-label=\"Sauvegarder\" \ntranslate=\"GENERAL.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/access_rights/associations/popup/edit_association.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"editAssociationForm\" class=\"md-inline-form\" novalidate \nng-submit=\"editAssociationForm.$valid && update(editAssociationForm)\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'ASSOCIATIONS.UPDATE\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-wrap><div class=\"nl-info-block-list-img animated fadeIn\" \nflex=\"30\"><dropify-directive id=\"edit_association_dropify\" filesave=\"photo.uploadFile\" name=\"logo\" \nng-model=\"association\" required></div><div flex=\"70\" class=\"\" layout=\"column\"><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" ng-model=\"association.name\" name=\"name\" \nmaxlength=\"255\" required><label class=\"\" translate=\"ASSOCIATIONS.NAME\"></label><div \nng-messages=\"editAssociationForm.name.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><md-select \nng-model=\"association.admin\" name=\"admin\" ng-model-options=\"{trackBy: \'$value.id\'}\" required><md-option \nng-repeat=\"user in users | orderBy: \'fullName\' track by user.id\" ng-value=\"user\">{{user.fullName}}</md-option>\n</md-select><label class=\"\" translate=\"ASSOCIATIONS.ADMIN\"></label><div ng-messages=\"editAssociationForm.admin.$error\">\n<span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"submit\" \nclass=\"md-primary md-hue-2 submit-button md-raised\" ng-disabled=\"editAssociationForm.$invalid\" \naria-label=\"Sauvegarder\" translate=\"GENERAL.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/access_rights/groups/popup/add_group.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"newGroupForm\" class=\"md-inline-form\" novalidate ng-submit=\"newGroupForm.$valid && save(newGroupForm)\"><md-toolbar\n class=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'GROUPS.NEW\' | translate}}</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"row\" layout-wrap><h3 translate=\"GROUPS.PARAMS\" flex=\"100\"></h3><md-input-container \nclass=\"nl-Input-container\" flex=\"70\"><input type=\"text\" class=\"\" ng-model=\"newGroup.name\" name=\"name\" required><label \nclass=\"\" translate=\"GROUPS.NAME\"></label><div ng-messages=\"newGroupForm.name.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container class=\"nl-Input-container\" \nflex=\"30\"><input type=\"number\" step=\"1\" class=\"\" ng-model=\"newGroup.index\" name=\"index\" required><label class=\"\" \ntranslate=\"GROUPS.INDEX\"></label><div ng-messages=\"newGroupForm.index.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container class=\"nl-Input-container\" \nflex=\"100\"><md-select class=\"\" ng-model=\"newGroup.rights\" name=\"rights\"><md-option \nng-repeat=\"right in rights | orderBy: \'name\' track by right.id\">{{right.name}}</md-option></md-select><label class=\"\" \ntranslate=\"GROUPS.RIGHTS\"></label></md-input-container></div></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button type=\"submit\" class=\"md-primary md-hue-2 submit-button md-raised\" \nng-disabled=\"newGroupForm.$invalid\" aria-label=\"Sauvegarder\" translate=\"GENERAL.SAVE\"></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/access_rights/groups/popup/edit_group.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"editGroupForm\" class=\"md-inline-form\" novalidate ng-submit=\"editGroupForm.$valid && update(editGroupForm)\">\n<md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"row\" layout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'GROUPS.UPDATE\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-wrap><h3 translate=\"GROUPS.PARAMS\" flex=\"100\"></h3>\n<md-input-container class=\"nl-Input-container\" flex=\"70\"><input type=\"text\" class=\"\" ng-model=\"group.name\" name=\"name\" \nrequired><label class=\"\" translate=\"GROUPS.NAME\"></label><div ng-messages=\"editGroupForm.name.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container\" flex=\"30\"><input type=\"number\" step=\"1\" class=\"\" ng-model=\"group.index\" name=\"index\" \nrequired><label class=\"\" translate=\"GROUPS.INDEX\"></label><div ng-messages=\"editGroupForm.index.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container\" flex=\"100\"><md-select class=\"\" ng-model=\"group.rights\" name=\"rights\"><md-option \nng-repeat=\"right in rights | orderBy: \'name\' track by right.id\">{{right.name}}</md-option></md-select><label class=\"\" \ntranslate=\"GROUPS.RIGHTS\"></label></md-input-container></div></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button type=\"submit\" class=\"md-primary md-hue-2 submit-button md-raised\" \nng-disabled=\"editGroupForm.$invalid\" aria-label=\"Sauvegarder\" translate=\"GENERAL.SAVE\"></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/access_rights/users/popup/add_user.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><form name=\"newUserForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"newUserForm.$valid && saveUser(newUserForm)\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'USERS.NEW\' | translate}}</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"row\" layout-wrap><h3 translate=\"USERS.CONNECTION\" flex=\"100\"></h3><md-input-container \nclass=\"nl-Input-container\" flex=\"50\"><input type=\"text\" class=\"\" ng-model=\"newUser.login\" name=\"login\" required><label \nclass=\"\" translate=\"USERS.ID\"></label><div ng-messages=\"newUserForm.login.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container class=\"nl-Input-container\" \nflex=\"50\"><input type=\"password\" class=\"\" ng-model=\"newUser.password\" name=\"password\" required><label class=\"\" \ntranslate=\"USERS.PASSWORD\"></label><div ng-messages=\"newUserForm.login.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div><div layout=\"row\" layout-wrap \nng-if=\"!company\"><md-input-container class=\"nl-Input-container\" flex=\"30\"><md-switch class=\"md-primary\" \nng-model=\"newUser.activated\" name=\"activated\">{{\'USERS.ACTIVE\' | translate}}</md-switch></md-input-container>\n<md-input-container class=\"nl-Input-container\" flex=\"35\"><md-select class=\"\" ng-model=\"newUser.groups\" name=\"groups\" \nng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"multiple\"><md-option \nng-repeat=\"group in groups | orderBy: \'name\' track by group.id\" ng-value=\"group\">{{group.name}}</md-option></md-select>\n<label class=\"\" translate=\"USERS.GROUPS\"></label></md-input-container><md-input-container class=\"nl-Input-container\" \nflex=\"35\"><md-select class=\"\" ng-model=\"newUser.rights\" name=\"rights\"><md-option \nng-repeat=\"right in rights | orderBy: \'name\' track by right.id\">{{right.name}}</md-option></md-select><label class=\"\" \ntranslate=\"USERS.RIGHTS\"></label></md-input-container></div><div layout=\"row\" layout-wrap><h3 \ntranslate=\"USERS.PROFILE\" flex=\"100\"></h3><div class=\"nl-info-block-list-img animated fadeIn\" flex=\"30\">\n<dropify-directive id=\"add_user_dropify\" filesave=\"photo.uploadFile\" ng-model=\"newUser\"></div><div flex=\"70\" class=\"\" \nlayout=\"column\"><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"newUser.fullName\" name=\"fullname\" required><label class=\"\" translate=\"USERS.NAME\"></label><div \nng-messages=\"newUserForm.fullname.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"email\" class=\"\" \nng-model=\"newUser.mail\" name=\"mail\" required><label class=\"\" translate=\"USERS.EMAIL\"></label><div \nng-messages=\"newUserForm.mail.$error\" class=\"nl-fixeDivError\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span> <span ng-message=\"email\">{{\'GENERAL.PATTERN\' | translate}}</span></div>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button\n type=\"submit\" class=\"md-primary md-hue-2 submit-button md-raised\" ng-disabled=\"newUserForm.$invalid\" \naria-label=\"Sauvegarder\" translate=\"GENERAL.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/access_rights/users/popup/edit_user.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"editUserForm\" class=\"md-inline-form\" novalidate ng-submit=\"editUserForm.$valid && update(editUserForm)\">\n<md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"row\" layout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'USERS.UPDATE\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-wrap><h3 translate=\"USERS.CONNECTION\" flex=\"100\"></h3>\n<md-input-container class=\"nl-Input-container\" flex=\"50\"><input type=\"text\" class=\"\" ng-model=\"user.login\" \nname=\"login\" required><label class=\"\" translate=\"USERS.ID\"></label><div ng-messages=\"editUserForm.login.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container\" flex=\"50\"><input type=\"password\" class=\"\" ng-model=\"user.password\" name=\"password\"><label \nclass=\"\" translate=\"USERS.PASSWORD\"></label></md-input-container><md-input-container class=\"nl-Input-container\" \nflex=\"30\"><md-switch class=\"md-primary\" ng-model=\"user.activated\" name=\"activated\">{{\'USERS.ACTIVE\' | translate}}\n</md-switch></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"35\"><md-select class=\"\" \nng-model=\"user.groups\" ng-model-options=\"{trackBy: \'$value.id\'}\" name=\"groups\" multiple=\"multiple\"><md-option \nng-repeat=\"group in groups | orderBy: \'name\' track by group.id\" ng-value=\"group\">{{group.name}}</md-option></md-select>\n<label class=\"\" translate=\"USERS.GROUPS\"></label></md-input-container><md-input-container class=\"nl-Input-container\" \nflex=\"35\"><md-select class=\"\" ng-model=\"user.rights\" name=\"rights\"><md-option \nng-repeat=\"right in rights | orderBy: \'name\' track by right.id\">{{right.name}}</md-option></md-select><label class=\"\" \ntranslate=\"USERS.RIGHTS\"></label></md-input-container></div><div layout=\"row\" layout-wrap><h3 \ntranslate=\"USERS.PROFILE\" flex=\"100\"></h3><div class=\"nl-info-block-list-img animated fadeIn\" flex=\"30\">\n<dropify-directive id=\"edit_user_dropify\" filesave=\"photo.uploadFile\" ng-model=\"user\"></div><div flex=\"70\" class=\"\" \nlayout=\"column\"><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"user.fullName\" name=\"fullname\" required><label class=\"\" translate=\"USERS.NAME\"></label><div \nng-messages=\"editUserForm.fullname.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"email\" class=\"\" \nng-model=\"user.mail\" name=\"mail\" required><label class=\"\" translate=\"USERS.EMAIL\"></label><div \nng-messages=\"editUserForm.mail.$error\" class=\"nl-fixeDivError\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span> <span ng-message=\"email\">{{\'GENERAL.PATTERN\' | translate}}</span></div>\n</md-input-container></div></div><div layout=\"row\" layout-wrap><md-input-container class=\"nl-Input-container\">\n<md-switch class=\"md-primary\" ng-model=\"user.seeInactiveContact\" name=\"activated\">{{\'USERS.SEE_INACTIVES\' | translate}}\n</md-switch></md-input-container></div></md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\">\n<md-button type=\"submit\" class=\"md-primary md-hue-2 submit-button md-raised\" ng-disabled=\"editUserForm.$invalid\" \naria-label=\"Sauvegarder\" translate=\"GENERAL.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/events/inscriptions/forms/fields.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"INSCRIPTION_FORMS.FIELDS.TITLE\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-input-container ng-if=\"form.paginated\"><md-select ng-model=\"pagination.page\" class=\"md-no-underline\" \nng-change=\"refreshFields()\"><md-option ng-value=\"1\">{{\'INSCRIPTION_FORMS.FIELDS.PAGE\'|translate}} 1</md-option>\n<md-option ng-value=\"2\">{{\'INSCRIPTION_FORMS.FIELDS.PAGE\'|translate}} 2</md-option><md-option ng-value=\"3\">\n{{\'INSCRIPTION_FORMS.FIELDS.PAGE\'|translate}} 3</md-option></md-select></md-input-container><md-input-container>\n<md-select ng-model=\"language.key\" class=\"md-no-underline\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div><div class=\"content\"><div class=\"nl-Block\"><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" layout-align=\"space-between center\"><div>\n<span translate=\"INSCRIPTION_FORMS.FIELDS.COLUMN_1\" aria-hidden=\"false\"></span></div></div><form \nname=\"inscriptionFieldsForm1\" novalidate><div><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"field in inscriptionFields | filter: {column: 1} as column1Fields track by field.id\" ng-form=\"fieldForm1\">\n<md-input-container flex=\"10\" class=\"ml-25 mt-0 mb-0\"><label>{{\"INSCRIPTION_FORMS.FIELDS.TYPE\"|translate}}</label>\n<md-select ng-model=\"field.typeField\" name=\"typeField\" required ng-disabled=\"!field.active\"><md-option \nng-repeat=\"typeField in typeFields\" ng-value=\"typeField\">{{typeField}}</md-option></md-select><div class=\"pl-5\" \nng-messages=\"fieldForm1.typeField.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"field.typeField === \'FIELD\'\" class=\"ml-25 mt-25 mb-0\" flex=\"15\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.NAME\"|translate}}</label><input type=\"text\" maxlength=\"255\" ng-model=\"field.name\" \nname=\"name\" required ng-disabled=\"!field.active\"><div class=\"pl-5\" ng-messages=\"fieldForm1.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container ng-if=\"field.typeField === \'FIELD\'\" flex=\"10\" class=\"ml-25 mt-0 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.MODEL_TYPE\"|translate}}</label><md-select ng-model=\"field.modelType\" name=\"modelType\" \nrequired ng-change=\"getFields(field)\" ng-disabled=\"!field.active\"><md-option ng-repeat=\"modelType in modelTypes\" \nng-value=\"modelType\">{{\'GENERAL.\'+modelType | translate}}</md-option></md-select><div class=\"pl-5\" \nng-messages=\"fieldForm1.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"field.typeField === \'FIELD\'\" flex=\"15\" class=\"ml-25 mt-0 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.FIELD\"|translate}}</label><md-select ng-model=\"field.field\" name=\"field\" \nng-model-options=\"{trackBy: \'$value.id\'}\" required ng-disabled=\"!field.active\"><md-option \nng-repeat=\"field in field.fields | orderBy: \'libelle\'\" ng-value=\"field\">{{field.libelle}}</md-option></md-select><div \nclass=\"pl-5\" ng-messages=\"fieldForm1.field.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"field.typeField === \'HEADER\'\" flex=\"20\" class=\"ml-25 mt-25 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.HEADER\"|translate}}</label><input type=\"text\" maxlength=\"255\" ng-model=\"field.header\" \nname=\"header\" required ng-disabled=\"!field.active\"><div class=\"pl-5\" ng-messages=\"fieldForm1.header.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container ng-if=\"field.typeField === \'EXPLANATION\'\" flex=\"20\" class=\"ml-25 mt-25 mb-0\">\n<label>{{\"INSCRIPTION_FORMS.FIELDS.EXPLANATION\"|translate}}</label><textarea ng-model=\"field.text\" rows=\"5\" \nname=\"text\" required ng-disabled=\"!field.active\">\n							</textarea><div class=\"pl-5\" \nng-messages=\"fieldForm1.text.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"5\" \nng-if=\"field.typeField === \'FIELD\'\"><md-checkbox class=\"md-primary md-hue-2\" ng-model=\"field.required\" name=\"required\" \nng-disabled=\"!field.active\">{{\"INSCRIPTION_FORMS.FIELDS.REQUIRED\"|translate}}</md-checkbox></md-input-container>\n<md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"5\" ng-if=\"field.typeField === \'FIELD\'\"><md-checkbox \nclass=\"md-primary md-hue-2\" ng-model=\"field.prefilling\" name=\"prefilling\" ng-disabled=\"!field.active\">\n{{\"INSCRIPTION_FORMS.FIELDS.PREFILLING\"|translate}}</md-checkbox></md-input-container><md-input-container \nclass=\"ml-25 mt-25 mb-0\" flex=\"10\" \nng-show=\"field.typeField === \'FIELD\' && (field.modelType === \'COMPANY_MODEL\' || field.modelType === \'CONTACT_MODEL\')\">\n<md-checkbox class=\"md-primary md-hue-2\" ng-model=\"field.createIfUpdate\" name=\"paginated\" ng-disabled=\"!field.active\">\n{{(field.modelType === \'CONTACT_MODEL\' ? \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_CONTACT\" : \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_COMPANY\")|translate}}\n</md-checkbox></md-input-container><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"button\" \nclass=\"md-fab md-mini md-orange-400-bg md-hue-2\" ng-click=\"openConditional(field);\"><md-icon \nmd-font-icon=\"icon-routes\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"removeField(field, $index);\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s18\"></md-icon></md-button><md-button ng-click=\"cancelFieldUpdating(field, $index);\" ng-if=\"field.active\" \ntype=\"button\" class=\"md-fab md-mini md-accent md-hue-1\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon>\n</md-button><md-button ng-click=\"updateField(field, $index)\" ng-if=\"field.active\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button>\n<md-button ng-if=\"!field.active\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"enabledFieldUpdating(field);\" noo-tooltip tooltip-title=\"Modifier ce champ\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button><div layout=\"row\" layout-align=\"end center\" class=\"ml-15\">\n<md-button ng-if=\"field.index > 0\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"up(field)\" \nnoo-tooltip tooltip-title=\"Monter d\'un rang\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button>\n<md-button ng-if=\"field.index < column1Fields.length -1\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"down(field)\" noo-tooltip tooltip-title=\"Descendre d\'un rang\"><md-icon md-font-icon=\"icon-arrow-down\" \nclass=\"s18\"></md-icon></md-button></div></div></div></div></form><div class=\"nl-Block mt-20\"><form \nname=\"addFieldForm1\" novalidate ng-submit=\"addFieldForm1.$valid && addItem(1, addFieldForm1)\"><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" layout-align=\"space-between center\"><div>\n<span translate=\"INSCRIPTION_FORMS.FIELDS.NEW_FIELD\" aria-hidden=\"false\"></span></div></div><div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"10\" class=\"ml-25 mt-0 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.NAME\"|translate}}</label><md-select ng-model=\"newField1.typeField\" name=\"typeField\" \nrequired><md-option ng-repeat=\"typeField in typeFields\" ng-value=\"typeField\">{{typeField}}</md-option></md-select><div \nclass=\"pl-5\" ng-messages=\"addFieldForm1.typeField.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField1.typeField === \'FIELD\'\" class=\"ml-25 mt-25 mb-0\" flex=\"15\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.NAME\"|translate}}</label><input type=\"text\" maxlength=\"255\" ng-model=\"newField1.name\" \nrequired><div class=\"pl-5\" ng-messages=\"addFieldForm1.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField1.typeField === \'FIELD\'\" flex=\"10\" class=\"ml-25 mt-0 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.MODEL_TYPE\"|translate}}</label><md-select ng-model=\"newField1.modelType\" name=\"modelType\" \nrequired ng-change=\"getFields(newField1)\"><md-option ng-repeat=\"modelType in modelTypes\" ng-value=\"modelType\">\n{{\'GENERAL.\'+modelType | translate}}</md-option></md-select><div class=\"pl-5\" \nng-messages=\"addFieldForm1.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField1.typeField === \'FIELD\'\" flex=\"15\" class=\"ml-25 mt-0 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.FIELD\"|translate}}</label><md-select ng-model=\"newField1.field\" name=\"field\" required>\n<md-option ng-repeat=\"field in newField1.fields  | orderBy: \'libelle\'\" ng-value=\"field\">{{field.libelle}}</md-option>\n</md-select><div class=\"pl-5\" ng-messages=\"addFieldForm1.field.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField1.typeField === \'HEADER\'\" flex=\"30\" class=\"ml-25 mt-25 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.HEADER\"|translate}}</label><input type=\"text\" maxlength=\"255\" ng-model=\"newField1.header\" \nname=\"header\" required><div class=\"pl-5\" ng-messages=\"addFieldForm1.header.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container ng-if=\"newField1.typeField === \'EXPLANATION\'\" flex=\"30\" class=\"ml-25 mt-25 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.EXPLANATION\"|translate}}</label><textarea ng-model=\"newField1.text\" rows=\"5\" name=\"text\" \nrequired>\n								</textarea><div class=\"pl-5\" ng-messages=\"addFieldForm1.text.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"10\" ng-if=\"newField1.typeField === \'FIELD\'\"><md-checkbox \nclass=\"md-primary md-hue-2\" ng-model=\"newField1.required\" name=\"paginated\">\n{{\"INSCRIPTION_FORMS.FIELDS.REQUIRED\"|translate}}</md-checkbox></md-input-container><md-input-container \nclass=\"ml-25 mt-25 mb-0\" flex=\"10\" ng-if=\"newField1.typeField === \'FIELD\'\"><md-checkbox class=\"md-primary md-hue-2\" \nng-model=\"newField1.prefilling\" name=\"prefilling\">{{\"INSCRIPTION_FORMS.FIELDS.PREFILLING\"|translate}}</md-checkbox>\n</md-input-container><md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"15\" \nng-show=\"newField1.typeField === \'FIELD\' && (newField1.modelType === \'COMPANY_MODEL\' || newField1.modelType === \'CONTACT_MODEL\')\">\n<md-checkbox class=\"md-primary md-hue-2\" ng-model=\"newField1.createIfUpdate\" name=\"createIfUpdate\">\n{{(newField1.modelType === \'CONTACT_MODEL\' ? \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_CONTACT\" : \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_COMPANY\")|translate}}\n</md-checkbox></md-input-container><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" \nclass=\"md-raised md-primary md-hue-2\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></form></div></div><div class=\"nl-Block mt-20\"><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" layout-align=\"space-between center\"><div>\n<span translate=\"INSCRIPTION_FORMS.FIELDS.COLUMN_2\" aria-hidden=\"false\"></span></div></div><form \nname=\"inscriptionFieldsForm2\" novalidate><div><div layout=\"row\" layout-align=\"start center\" ng-init=\"getFields(field)\" \nng-repeat=\"field in inscriptionFields | filter: {column: 2} as column2Fields track by field.id\" ng-form=\"fieldForm2\">\n<md-input-container flex=\"10\" class=\"ml-25 mt-0 mb-0\"><label>{{\"INSCRIPTION_FORMS.FIELDS.TYPE\"|translate}}</label>\n<md-select ng-model=\"field.typeField\" name=\"typeField\" required ng-disabled=\"!field.active\"><md-option \nng-repeat=\"typeField in typeFields\" ng-value=\"typeField\">{{typeField}}</md-option></md-select><div class=\"pl-5\" \nng-messages=\"fieldForm2.typeField.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"field.typeField === \'FIELD\'\" class=\"ml-25 mt-25 mb-0\" flex=\"15\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.NAME\"|translate}}</label><input type=\"text\" maxlength=\"255\" ng-model=\"field.name\" \nname=\"name\" required ng-disabled=\"!field.active\"><div class=\"pl-5\" ng-messages=\"fieldForm2.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container ng-if=\"field.typeField === \'FIELD\'\" flex=\"10\" class=\"ml-25 mt-0 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.MODEL_TYPE\"|translate}}</label><md-select ng-model=\"field.modelType\" name=\"modelType\" \nrequired ng-change=\"getFields(field)\" ng-disabled=\"!field.active\"><md-option ng-repeat=\"modelType in modelTypes\" \nng-value=\"modelType\">{{\'GENERAL.\'+modelType | translate}}</md-option></md-select><div class=\"pl-5\" \nng-messages=\"fieldForm2.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"field.typeField === \'FIELD\'\" flex=\"15\" class=\"ml-25 mt-0 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.FIELD\"|translate}}</label><md-select ng-model=\"field.field\" name=\"field\" \nng-model-options=\"{trackBy: \'$value.id\'}\" required ng-disabled=\"!field.active\"><md-option \nng-repeat=\"field in field.fields | orderBy: \'libelle\'\" ng-value=\"field\">{{field.libelle}}</md-option></md-select><div \nclass=\"pl-5\" ng-messages=\"fieldForm2.field.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"field.typeField === \'HEADER\'\" flex=\"20\" class=\"ml-25 mt-25 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.HEADER\"|translate}}</label><input type=\"text\" maxlength=\"255\" ng-model=\"field.header\" \nname=\"header\" required ng-disabled=\"!field.active\"><div class=\"pl-5\" ng-messages=\"fieldForm2.header.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container ng-if=\"field.typeField === \'EXPLANATION\'\" flex=\"20\" class=\"ml-25 mt-25 mb-0\">\n<label>{{\"INSCRIPTION_FORMS.FIELDS.EXPLANATION\"|translate}}</label><textarea ng-model=\"field.text\" rows=\"5\" \nname=\"text\" required ng-disabled=\"!field.active\">\n							</textarea><div class=\"pl-5\" \nng-messages=\"fieldForm2.text.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"5\" \nng-if=\"field.typeField === \'FIELD\'\"><md-checkbox class=\"md-primary md-hue-2\" ng-model=\"field.required\" \nname=\"paginated\" ng-disabled=\"!field.active\">{{\"INSCRIPTION_FORMS.FIELDS.REQUIRED\"|translate}}</md-checkbox>\n</md-input-container><md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"5\" ng-if=\"field.typeField === \'FIELD\'\">\n<md-checkbox class=\"md-primary md-hue-2\" ng-model=\"field.prefilling\" name=\"prefilling\" ng-disabled=\"!field.active\">\n{{\"INSCRIPTION_FORMS.FIELDS.PREFILLING\"|translate}}</md-checkbox></md-input-container><md-input-container \nclass=\"ml-25 mt-25 mb-0\" flex=\"10\" \nng-show=\"field.typeField === \'FIELD\' && (field.modelType === \'COMPANY_MODEL\' || field.modelType === \'CONTACT_MODEL\')\">\n<md-checkbox class=\"md-primary md-hue-2\" ng-model=\"field.createIfUpdate\" name=\"paginated\" ng-disabled=\"!field.active\">\n{{(field.modelType === \'CONTACT_MODEL\' ? \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_CONTACT\" : \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_COMPANY\")|translate}}\n</md-checkbox></md-input-container><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"button\" \nclass=\"md-fab md-mini md-orange-400-bg md-hue-2\" ng-click=\"openConditional(field);\"><md-icon \nmd-font-icon=\"icon-routes\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"removeField(field, $index);\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s18\"></md-icon></md-button><md-button ng-click=\"cancelFieldUpdating(field, $index);\" ng-if=\"field.active\" \ntype=\"button\" class=\"md-fab md-mini md-accent md-hue-1\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon>\n</md-button><md-button ng-click=\"updateField(field, $index)\" ng-if=\"field.active\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button>\n<md-button ng-if=\"!field.active\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"enabledFieldUpdating(field);\" noo-tooltip tooltip-title=\"Modifier ce champ\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button><div layout=\"row\" layout-align=\"end center\" class=\"ml-15\">\n<md-button ng-if=\"field.index > 0\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"up(field)\" \nnoo-tooltip tooltip-title=\"Monter d\'un rang\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button>\n<md-button ng-if=\"field.index < column2Fields.length -1\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"down(field)\" noo-tooltip tooltip-title=\"Descendre d\'un rang\"><md-icon md-font-icon=\"icon-arrow-down\" \nclass=\"s18\"></md-icon></md-button></div></div></div></div></form><div class=\"nl-Block mt-20\"><form \nname=\"addFieldForm2\" novalidate ng-submit=\"addFieldForm2.$valid && addItem(2, addFieldForm2)\"><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" layout-align=\"space-between center\"><div>\n<span translate=\"INSCRIPTION_FORMS.FIELDS.NEW_FIELD\" aria-hidden=\"false\"></span></div></div><div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"10\" class=\"ml-25 mt-0 mb-0\"><label \ntranslate=\"INSCRIPTION_FORMS.FIELDS.NAME\"></label><md-select ng-model=\"newField2.typeField\" name=\"typeField\" required>\n<md-option ng-repeat=\"typeField in typeFields\" ng-value=\"typeField\">{{typeField}}</md-option></md-select><div \nclass=\"pl-5\" ng-messages=\"addFieldForm2.typeField.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField2.typeField === \'FIELD\'\" class=\"ml-25 mt-25 mb-0\" flex=\"15\"><label \ntranslate=\"INSCRIPTION_FORMS.FIELDS.NAME\"></label><input type=\"text\" maxlength=\"255\" ng-model=\"newField2.name\" \nname=\"name\" required><div class=\"pl-5\" ng-messages=\"addFieldForm2.name.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField2.typeField === \'FIELD\'\" flex=\"10\" class=\"ml-25 mt-0 mb-0\"><label \ntranslate=\"INSCRIPTION_FORMS.FIELDS.MODEL_TYPE\"></label><md-select ng-model=\"newField2.modelType\" name=\"modelType\" \nrequired ng-change=\"getFields(newField2)\"><md-option ng-repeat=\"modelType in modelTypes\" ng-value=\"modelType\">\n{{\'GENERAL.\'+modelType | translate}}</md-option></md-select><div class=\"pl-5\" \nng-messages=\"addFieldForm2.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField2.typeField === \'FIELD\'\" flex=\"15\" class=\"ml-25 mt-0 mb-0\"><label \ntranslate=\"INSCRIPTION_FORMS.FIELDS.FIELD\"></label><md-select ng-model=\"newField2.field\" name=\"field\" required>\n<md-option ng-repeat=\"field in newField2.fields | orderBy: \'libelle\'\" ng-value=\"field\">{{field.libelle}}</md-option>\n</md-select><div class=\"pl-5\" ng-messages=\"addFieldForm2.field.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField2.typeField === \'HEADER\'\" flex=\"30\" class=\"ml-25 mt-25 mb-0\"><label \ntranslate=\"INSCRIPTION_FORMS.FIELDS.HEADER\"></label><input type=\"text\" maxlength=\"255\" ng-model=\"newField2.header\" \nname=\"header\" required><div class=\"pl-5\" ng-messages=\"addFieldForm2.header.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container ng-if=\"newField2.typeField === \'EXPLANATION\'\" flex=\"30\" class=\"ml-25 mt-25 mb-0\"><label \ntranslate=\"INSCRIPTION_FORMS.FIELDS.EXPLANATION\"></label><textarea ng-model=\"newField2.text\" rows=\"5\" required \nname=\"text\">\n								</textarea><div class=\"pl-5\" ng-messages=\"addFieldForm2.text.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"10\" ng-if=\"newField2.typeField === \'FIELD\'\"><md-checkbox \nclass=\"md-primary md-hue-2\" ng-model=\"newField2.required\" name=\"required\">\n{{\"INSCRIPTION_FORMS.FIELDS.REQUIRED\"|translate}}</md-checkbox></md-input-container><md-input-container \nclass=\"ml-25 mt-25 mb-0\" flex=\"10\" ng-if=\"newField2.typeField === \'FIELD\'\"><md-checkbox class=\"md-primary md-hue-2\" \nng-model=\"newField2.prefilling\" name=\"prefilling\">{{\"INSCRIPTION_FORMS.FIELDS.PREFILLING\"|translate}}</md-checkbox>\n</md-input-container><md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"15\" \nng-show=\"newField2.typeField === \'FIELD\' && (newField2.modelType === \'COMPANY_MODEL\' || newField2.modelType === \'CONTACT_MODEL\')\">\n<md-checkbox class=\"md-primary md-hue-2\" ng-model=\"newField2.createIfUpdate\" name=\"createIfUpdate\">\n{{(newField2.modelType === \'CONTACT_MODEL\' ? \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_CONTACT\" : \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_COMPANY\")|translate}}\n</md-checkbox></md-input-container><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" \nclass=\"md-raised md-primary md-hue-2\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/main/events/inscriptions/forms/forms.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\" translate=\"INSCRIPTION_FORMS.TITLE\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"button\" class=\"md-accent md-hue-1\" ng-click=\"openAdd()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div><div class=\"content\"><div class=\"nl-Block nl-Block--table\"><div \nclass=\"nl-listing\"><table class=\"simple list-view\"><thead><th>{{\"INSCRIPTION_FORMS.COLUMNS.ID\" | translate}}</th><th>\n{{\"INSCRIPTION_FORMS.COLUMNS.NAME\" | translate}}</th><th>{{\"INSCRIPTION_FORMS.COLUMNS.MODEL_SUBTYPE\" | translate}}</th>\n<th>{{\"INSCRIPTION_FORMS.COLUMNS.SUB_CATEGORY\" | translate}}</th><th>\n{{\"INSCRIPTION_FORMS.COLUMNS.MULTIPLE_PAGES\" | translate}}</th><th>{{\"INSCRIPTION_FORMS.COLUMNS.ACTIONS\" | translate}}\n</th></thead><tbody><tr ng-repeat=\"form in forms track by form.id\"><td>{{form.id}}</td><td>{{form.name}}</td><td>\n{{form.subtype.name}}</td><td>{{form.subCategory != null ? form.subCategory.name : \'\'}}</td><td><md-checkbox \nreadonly=\"readonly\" disabled=\"disabled\" ng-model=\"form.paginated\" aria-label=\"publish\"></md-checkbox></td><td>\n<md-button md-no-ink ng-click=\"details(form)\" class=\"md-primary md-raised md-hue-2\" aria-label=\"Supprimer\">\n{{\"GENERAL.DETAILS\" | translate}}</md-button><md-button md-no-ink ng-click=\"update(form)\" \nclass=\"md-primary md-raised md-hue-2\" aria-label=\"Supprimer\">{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button \nmd-no-ink ng-click=\"showPopUpDelete(form, $index)\" class=\"md-warn md-hue-2\" aria-label=\"Supprimer\">\n{{\"GENERAL.DELETE\" | translate}}</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/globe_network/companies/contacts/contact.html","<div class=\"page-layout simple fullwidth\" md-theme=\"teal-theme\"><md-progress-linear \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" mode=\"indeterminate\" \nng-if=\"_mdProgressLinear\"></md-progress-linear><div class=\"content content-sm nl-Form-xs\" layout=\"row\" \nlayout-align=\"start stretch\" layout-wrap><div flex=\"20\" class=\"nl-Panel\"><div layout=\"column\" layout-wrap><div \nflex=\"100\" layout=\"column\"><div class=\"nl-Block nl-Block--contact nl-Block--customers\" layout=\"row\" \nlayout-align=\"center top\" layout-wrap ng-click=\"backToCompany()\"><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\" class=\"nl-Panel-mainTitle\"><div flex=\"80\" class=\"pl-15\">{{company.modelPattern}}</div>\n<md-input-container flex=\"20\" class=\"nl-Form-SwitchContainer\"><md-switch class=\"md-primary m-0\" \nng-model=\"company.activate\" ng-change=\"setCompanyActivated(company.id, company.activate)\"></md-switch>\n</md-input-container></div><div layout=\"row\" flex=\"100\"><div class=\"nl-Panel-infos\" flex=\"100\"><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"field in company.valuedFields | orderBy: \'index\'\" \nng-if=\"field.index != null && field.value\"><div class=\"mr-5\" ng-if=\"field.icon\"><md-icon \nmd-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s22\"></md-icon></div><div class=\"nl-Panel-infos-text\">\n{{field.value}}</div></div></div><div flex=\"20\"><div class=\"nl-Msg-avatar mt-10 mr-10\" \nng-if=\"company.profilePictureLocation != null\"><img class=\"nl-Msg-avatar-img\" \nhttp-src=\"./alternatedocroots/{{company.profilePictureLocation}}\" has-profile-picture=\"true\"></div></div></div></div>\n<div class=\"nl-Block nl-Block--contact nl-Block--customers\" ng-repeat=\"contact in contacts track by contact.id\" \nng-class=\"{\'nl-selected\': contact.id === selectedContact.id}\" ng-click=\"detailsContact(contact.id)\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div flex=\"100\" layout=\"row\" layout-align=\"start center\" \nclass=\"nl-Panel-mainTitle\"><div flex=\"80\" class=\"pl-15\"><md-icon ng-if=\"company.favouriteId === contact.id\" \nmd-font-icon=\"icon-star\"></md-icon>{{contact.modelPattern}} <span ng-if=\"contact.deleted\">\n({{\'CONTACTS.DELETED\'|translate}})</span></div><md-input-container flex=\"20\" class=\"nl-Form-SwitchContainer\"><md-switch\n class=\"md-primary m-0\" ng-model=\"contact.activate\" ng-change=\"setContactActivated(contact.id, contact.activate)\">\n</md-switch></md-input-container></div><div layout=\"row\" flex=\"100\"><div class=\"nl-Panel-infos\" flex=\"80\" \nng-if=\"contact.valuedFields != null && contact.valuedFields.length > 0\"><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"field in contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\"><div \nclass=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s22\"></md-icon></div><div \nclass=\"nl-Panel-infos-text\">{{field.value}}</div></div></div><div flex=\"20\"><div \nng-if=\"contact.profilePictureLocation != null\" class=\"nl-Msg-avatar mr-10 mt-10\"><img class=\"nl-Msg-avatar-img\" \nhttp-src=\"./alternatedocroots/{{contact.profilePictureLocation}}\" has-profile-picture=\"true\"></div></div></div></div>\n</div></div><div layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" class=\"md-primary\" \nng-click=\"openAddContact()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'CONTACTS.ADD\' | translate}}</md-button>\n</div><div layout=\"row\" layout-align=\"center center\"><md-button ng-hide=\"hiddenContact\" type=\"button\" \nclass=\"md-primary\" ng-click=\"showMoreContacts()\"><md-icon md-font-icon=\"icon-eye\"></md-icon>\n{{\'CONTACTS.SHOW\' | translate}}</md-button><md-button ng-if=\"hiddenContact\" type=\"button\" class=\"md-primary\" \nng-click=\"hideMoreContacts()\"><md-icon md-font-icon=\"icon-eye-off\"></md-icon>{{\'CONTACTS.HIDE\' | translate}}\n</md-button></div><div layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" class=\"md-primary\" \nng-click=\"_lookForContactDuplicates()\" style=\"white-space: normal!important;line-height: 36px!important\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon>{{\'DUPLICATION_TOOL.CONTACT_TITLE\' | translate}}</md-button></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button type=\"button\" class=\"md-primary\" \nng-click=\"_contactDuplicatesAutoMergeFn()\" style=\"white-space: normal!important;line-height: 36px!important\"><md-icon \nmd-font-icon=\"icon-flash-auto\"></md-icon>{{\'DUPLICATION_TOOL.CONTACT_AUTO_MERGE_TITLE\' | translate}}</md-button></div>\n<div layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" class=\"md-primary\" ng-click=\"showLogs()\">\n<md-icon md-font-icon=\"icon-timelapse\"></md-icon>{{\'COMPANIES.LOGS\' | translate}}</md-button></div></div><div \nflex=\"80\" ng-if=\"!logsShowed\"><div class=\"nl-Block\"><div layout=\"row\" layout-align=\"space-between center\"><md-button \nflex type=\"button\" class=\"md-accent md-hue-3 nl-Button--small\" ng-click=\"setPrincipal()\"><md-icon \nmd-font-icon=\"icon-star\"></md-icon>{{\'CONTACTS.PRINCIPAL\' | translate}}</md-button><md-button \nng-if=\"userService.isUserAdmin() || userService.isUserLinkedToAssociations()\" flex type=\"button\" \nclass=\"md-accent md-hue-3 nl-Button--small\" ng-click=\"openSubscribe()\"><md-icon md-font-icon=\"icon-ticket\"></md-icon>\n{{\'CONTACTS.SUBSCRIBE\' | translate}}</md-button><md-button \nng-if=\"userService.isUserAdmin() || userService.isUserLinkedToAssociations()\" flex type=\"button\" \nclass=\"md-accent md-hue-3 nl-Button--small\" ng-click=\"_mailingDialogOpenFn()\"><md-icon md-font-icon=\"icon-bullhorn\">\n</md-icon><span translate=\"MAILING.DO_MAILING.MAILING_BTN\"></span></md-button><md-button \nng-if=\"userService.isUserAdmin() || userService.isUserLinkedToAssociations()\" flex type=\"button\" \nclass=\"md-accent md-hue-3 nl-Button--small\" ng-click=\"openMove()\"><md-icon md-font-icon=\"icon-cursor-move\"></md-icon>\n{{\'CONTACTS.MOVE\' | translate}}</md-button><md-button \nng-if=\"userService.isUserAdmin() || userService.isUserLinkedToAssociations()\" flex type=\"button\" \nclass=\"md-accent md-hue-3 nl-Button--small\" ng-click=\"openCopy()\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon>\n</md-button><md-button ng-if=\"userService.isUserAdmin() || userService.isUserLinkedToAssociations()\" flex \ntype=\"button\" class=\"md-warn md-hue-2 nl-Button--small\" ng-if=\"!selectedContact.deleted\" \nng-click=\"showDeleteContact(true)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button \nng-if=\"userService.isUserAdmin() || userService.isUserLinkedToAssociations()\" flex type=\"button\" \nclass=\"md-accent md-hue-3 nl-Button--small\" ng-if=\"selectedContact.deleted\" ng-click=\"showDeleteContact(false)\">\n<md-icon md-font-icon=\"icon-auto-fix\"></md-icon>{{\'CONTACTS.RESTORE\' | translate}}</md-button></div><div layout=\"row\">\n<form name=\"updateFolderForm\" novalidate=\"\" flex=\"100\"><noo-infos-model ng-model=\"categories\" edition=\"true\" \nform-name=\"updateFolderForm\" model-type=\"modelType\" model=\"selectedContact\"></noo-infos-model></form></div></div><div \nclass=\"nl-Block\" ng-if=\"inscriptions != null && inscriptions.length > 0\"><div class=\"nl_categories-item-title\" \nlayout=\"row\" layout-align=\"space-between center\"><div>{{\"INSCRIPTION.TITLE\" | translate}}</div></div><div \nlayout=\"column\" ng-repeat=\"inscription in inscriptions\"><div class=\"nl_categories-item-subtitle\" layout=\"row\" \nng-click=\"inscription._showDetails = !inscription._showDetails\"><div flex=\"10\" \nstyle=\"font-weight: 600; text-transform: none\">#{{inscription.number}}</div><div flex=\"20\">{{inscription.event.name}}\n</div><div flex=\"10\" ng-if=\"inscription.inscriptionStatus != null\"><span \nng-style=\"setStatusStyle(inscription.inscriptionStatus)\">{{inscription.inscriptionStatus.name}}</span></div><div \nflex=\"20\">{{\'GENERAL.DATE_TIME_FORMAT\' | translate: {date: inscription.creation} }}</div><div flex=\"20\" \ntranslate=\"CONTACTS.LOGISTIC\" ng-click=\"$event.stopPropagation(); goToLogistics(inscription.logisticId)\"></div><div \nflex layout=\"row\" layout-align=\"end center\" ng-if=\"inscription.validated\"><div><md-icon class=\"md-primary\" \nmd-font-icon=\"icon-checkbox-marked-circle\"></md-icon></div></div></div><div layout=\"row\" layout-align=\"center center\" \nclass=\"pl-20 pr-20\" flex=\"100\" ng-show=\"inscription._showDetails\"><div flex=\"100\"><noo-infos-model \nng-model=\"inscription.categories\" edition=\"true\" form-name=\"updateFolderForm\" model-type=\"\'INSCRIPTION_MODEL\'\" \nmodel=\"inscription\"></noo-infos-model></div></div></div></div><div class=\"nl-Block\"><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" layout-align=\"space-between center\"><div>\n{{\"MESSAGE.CREATION.NEW\" | translate}}</div><md-button md-no-ink class=\"nl_button--header m-0\" \nng-click=\"showPopUpMessage()\" translate=\"MESSAGE.CREATION.NEW\"></md-button></div><div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>{{\"MESSAGE.BOX.TITLE\" | translate}}</label><md-select \nng-model=\"filter.sender\" aria-label=\"language\" name=\"receiver\" ng-change=\"findAllMessages()\"><md-option \nng-value=\"false\">{{\"MESSAGE.BOX.RECEPTION\" | translate}}</md-option><md-option ng-value=\"true\">\n{{\"MESSAGE.BOX.SENT\" | translate}}</md-option><md-option ng-value=\"null\">{{\"MESSAGE.BOX.ALL\" | translate}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>\n{{\"MESSAGE.TYPE.TITLE\" | translate}}</label><md-select ng-model=\"filter.action\" aria-label=\"language\" name=\"receiver\" \nng-change=\"findAllMessages()\"><md-option ng-value=\"null\">{{\"MESSAGE.TYPE.ALL\" | translate}}</md-option><md-option \nng-value=\"typeAction.TO_DO\">{{\"MESSAGE.TYPE.TO_DO\" | translate}}</md-option><md-option ng-value=\"typeAction.DONE\">\n{{\"MESSAGE.TYPE.DONE\" | translate}}</md-option><md-option ng-value=\"typeAction.ALL\">\n{{\"MESSAGE.TYPE.ALL_ACTION\" | translate}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>{{\"MESSAGE.CORRESPONDANT\" | translate}}</label><md-select \nmd-on-close=\"filterSelectText = \'\'\" ng-model=\"filter.receiverForm\" aria-label=\"language\" name=\"receiver\" \nmultiple=\"multiple\" ng-change=\"findAllMessages()\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"user in users | filterText: filterSelectText\" value=\"{{user}}\">{{user.fullName}}</md-option></md-select>\n</md-input-container></div><div class=\"nl-form--receivedMsg mt-15\"><table class=\"simple list-view\"><thead><th>\n{{\"MESSAGE.DISPLAY.MESSAGE\" | translate}}</th><th>{{\"MESSAGE.DISPLAY.LINK\" | translate}}</th><th>\n{{\"MESSAGE.DISPLAY.SENDER\" | translate}}</th><th>{{\"MESSAGE.DISPLAY.ACTIONS\" | translate}}</th></thead><tbody><tr \nng-repeat=\"message in messages\" class=\"nl-Msg\"><td><div class=\"nl-form--receivedMsg--subject\">{{message.subject}}</div>\n<div class=\"nl-form--receivedMsg--content\">{{message.content | limitTo: 70}}</div><div ng-if=\"message.action\" \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-check\" \nng-class=\"{\'nl-validated\': message.action.actionDone}\" ng-click=\"confirmAction(message.action)\" layout=\"row\" \nlayout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !message.action.actionDone, \'icon-check\' : message.action.actionDone}\"></i></div><div \nclass=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{message.action.libelle}}</div></div></div></td><td><div \nclass=\"nl-Msg-link-company\" ng-if=\"message.company\"><div translate=\"GENERAL.COMPANY\"></div>\n{{message.company.modelPattern}}</div><div class=\"nl-Msg-link-contact\" ng-if=\"message.contact\"><div \ntranslate=\"GENERAL.CONTACT\"></div>{{message.contact.modelPattern}}</div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div></td><td><span class=\"nl-Msg-sender-date\">\n{{getDate(message.creationDate) | date:\'dd/MM/yyyy\'}} - {{getDate(message.creationDate) | date:\'HH:mm\'}}</span><div \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-avatar mr-10\"><img class=\"nl-Msg-avatar-img\" \nhttp-src=\"./alternatedocroots/{{message.sender.pictureLocation}}\" \nhas-profile-picture=\"message.sender.pictureLocation != null\"></div><span class=\"nl-Badge\">{{message.sender.fullName}}\n</span></div></td><td><md-button ng-click=\"updateMessage(message)\" class=\"nl-listing-item-button md-accent\" \naria-label=\"Update\">{{\"GENERAL.UPDATE\" | translate}}</md-button></td></tr></tbody></table></div></div></div></div><div \nflex=\"80\" ng-if=\"logsShowed\"><div ng-include=\"\'app/main/globe_network/companies/logs/companyLogs.html\'\" \nng-controller=\"companyLogsController\"></div></div></div></div>");
$templateCache.put("app/main/globe_network/companies/contacts/logistic.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div><div \nclass=\"\">{{\'LOGISTIC.TITLE\' | translate}} #{{logistic.inscription.number}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"content content-sm p-5 nl-Form-xs nl-Block\"><div layout=\"column\" \nclass=\"p-15\"><div class=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"generalInfosShowed = !generalInfosShowed\"><div>{{\'LOGISTIC.GENERAL_INFOS\' | translate}}</div><button \ntype=\"button\" class=\"ml-10\"><md-icon md-font-icon=\"icon-eye\" ng-if=\"!generalInfosShowed\"></md-icon><md-icon \nmd-font-icon=\"icon-eye-off\" ng-if=\"generalInfosShowed\"></md-icon></button></div><div ng-show=\"generalInfosShowed\"><div \nlayout=\"row\"><div flex=\"20\" layout=\"column\"><div class=\"nl_categories-item-subtitle\">{{\'LOGISTIC.EVENT\' | translate}}\n</div><div layout-align=\"center center\" layout=\"row\"><img style=\"width:100px\" \nng-src=\"{{alternatedocroots + \'/\' + logistic.inscription.event.logo}}\" ng-if=\"logistic.inscription.event.logo != null\">\n</div></div><div flex=\"20\" layout=\"column\"><div class=\"nl_categories-item-subtitle\">{{\'LOGISTIC.COMPANY\' | translate}}\n</div><div><div style=\"font-weight: 600\">{{logistic.company.modelPattern}}</div><div class=\"nl-Panel-infos\" flex=\"80\" \nng-if=\"logistic.company.valuedFields != null && logistic.company.valuedFields.length > 0\"><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"field in logistic.company.valuedFields | orderBy: \'index\'\" \nng-if=\"field.index != null && field.value\"><div class=\"mr-5\" ng-if=\"field.icon\"><md-icon \nmd-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s22\"></md-icon></div><div class=\"nl-Panel-infos-text\">\n{{field.value}}</div></div></div></div></div><div flex=\"20\" layout=\"column\"><div class=\"nl_categories-item-subtitle\">\n{{\'LOGISTIC.CONTACT\' | translate}}</div><div><div style=\"font-weight: 600\">{{logistic.contact.modelPattern}}</div><div \nclass=\"nl-Panel-infos\" flex=\"80\" \nng-if=\"logistic.contact.valuedFields != null && logistic.contact.valuedFields.length > 0\"><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"field in logistic.contact.valuedFields | orderBy: \'index\'\" \nng-if=\"field.index != null && field.value\"><div class=\"mr-5\" ng-if=\"field.icon\"><md-icon \nmd-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s22\"></md-icon></div><div class=\"nl-Panel-infos-text\">\n{{field.value}}</div></div></div></div></div><div flex layout=\"column\"><div class=\"nl_categories-item-subtitle\">\n{{\'LOGISTIC.STATUS\' | translate}}</div><div layout=\"row\"><md-input-container class=\"m-0\"><md-select \nng-model=\"logistic.inscription.subCategory\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"changeSubCategory()\">\n<md-option ng-repeat=\"sub in subCategories | orderBy: \'index\' track by sub.id\" ng-value=\"sub\">{{ sub.name }}\n</md-option></md-select><label translate=\"INSCRIPTION_SUB_CATEGORY.TITLE\"></label></md-input-container>\n<md-input-container class=\"m-0\"><md-select md-on-close=\"filterInscriptionStatus = \'\'\" \nng-model=\"logistic.inscription.inscriptionStatus\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"changeInscriptionStatus()\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterInscriptionStatus\"></section></md-select-header><md-option\n ng-repeat=\"status in inscriptionStatuses | filterText: filterInscriptionStatus | orderBy: \'index\' track by status.id\" \nng-value=\"status\">{{ status.name }}</md-option></md-select><label translate=\"INSCRIPTION_STATUS.TITLE\"></label>\n</md-input-container><md-input-container class=\"m-0\"><md-select md-on-close=\"filterLogisticStatus = \'\'\" \nng-model=\"logistic.status\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"changeLogisticStatus()\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterLogisticStatus\"></section></md-select-header><md-option \nng-repeat=\"status in logisticStatus | filterText: filterLogisticStatus | orderBy: \'index\' track by status.id\" \nng-value=\"status\">{{ status.name }}</md-option></md-select><label translate=\"LOGISTIC.LOGISTIC_STATUS\"></label>\n</md-input-container></div></div></div></div><form name=\"logisticForm\" novalidate=\"\" flex=\"100\"><noo-infos-model \nng-model=\"categories\" edition=\"true\" form-name=\"logisticForm\" model-type=\"modelType\" model=\"logistic\">\n</noo-infos-model></form><div class=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"transportPlansShowed = !transportPlansShowed\"><div>{{\'LOGISTIC.TRANSPORT_PLAN\' | translate}}</div><div \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"nl_button--header mr-20\" \nng-click=\"$event.stopPropagation(); addTransportPlan()\">{{\'LOGISTIC.ADD_TRANSPORT\' | translate}}</md-button><button \ntype=\"button\" class=\"ml-10\"><md-icon md-font-icon=\"icon-eye\" ng-if=\"!transportPlansShowed\"></md-icon><md-icon \nmd-font-icon=\"icon-eye-off\" ng-if=\"transportPlansShowed\"></md-icon></button></div></div><div \nng-show=\"transportPlansShowed\"><div layout=\"row\" class=\"nl_categories-plan-item\" \nng-repeat=\"plan in logistic.transportPlans | orderBy: [\'_departureDate\', \'_departureTime\'] track by plan.id\" \nlayout-wrap><div layout=\"row\" flex=\"100\"><md-input-container flex=\"20\"><md-select ng-model=\"plan.direction\" \nng-model-options=\"{trackBy: \'$value\'}\" ng-change=\"updateTransportPlan(plan)\"><md-option value=\"Going\" \ntranslate=\"LOGISTIC.GOING\"></md-option><md-option value=\"Return\" translate=\"LOGISTIC.RETURN\"></md-option></md-select>\n<label translate=\"LOGISTIC.DIRECTION\"></label></md-input-container><md-input-container flex=\"20\"><md-select \nng-model=\"plan.type\" ng-model-options=\"{trackBy: \'$value\'}\" ng-change=\"updateTransportPlan(plan)\"><md-option \nvalue=\"Plane\" translate=\"LOGISTIC.PLANE\"></md-option><md-option value=\"Train\" translate=\"LOGISTIC.TRAIN\"></md-option>\n<md-option value=\"Car\" translate=\"LOGISTIC.CAR\"></md-option></md-select><label translate=\"LOGISTIC.TYPE\"></label>\n</md-input-container><md-input-container flex=\"40\"><input type=\"text\" ng-model=\"plan.comment\" name=\"comment\" \nng-change=\"updateTransportPlan(plan)\" ng-model-options=\"{updateOn: \'blur\'}\"><label translate=\"LOGISTIC.COMMENT\">\n</label></md-input-container><div flex layout=\"row\" layout-align=\"end center\"><md-button type=\"button\" \nclass=\"md-accent md-hue-3 nl-Button--small\" ng-click=\"openDeleteTransportPlan(plan.id)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon>{{\'LOGISTIC.DELETE_PLAN\' | translate}}</md-button></div></div><div layout=\"row\" \nflex=\"100\" layout-wrap layout-align=\"start start\"><div flex=\"33\" layout=\"row\" layout-wrap><div \nclass=\"nl_categories-item-subtitle\" translate=\"LOGISTIC.DEPARTURE\" flex=\"100\"></div><md-input-container flex=\"100\">\n<input type=\"text\" ng-model=\"plan.departureLocation\" name=\"departureLocation\" ng-change=\"updateTransportPlan(plan)\" \nng-model-options=\"{updateOn: \'blur\'}\"><label translate=\"LOGISTIC.LOCATION\"></label></md-input-container>\n<md-input-container flex=\"70\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"plan._departureDate\" ng-change=\"updateTransportPlan(plan)\" name=\"departureDate\">\n</md-datepicker><label translate=\"LOGISTIC.DATE\"></label></md-input-container><md-input-container flex=\"30\"><input \ntype=\"time\" ng-model=\"plan._departureTime\" name=\"departureTime\" ng-change=\"updateTransportPlan(plan)\" \nng-model-options=\"{updateOn: \'blur\'}\"><label translate=\"LOGISTIC.TIME\"></label></md-input-container></div><div \nflex=\"33\" layout=\"row\" layout-wrap><div class=\"nl_categories-item-subtitle\" translate=\"LOGISTIC.ARRIVAL\" flex=\"100\">\n</div><md-input-container flex=\"100\"><input type=\"text\" ng-model=\"plan.arrivalLocation\" name=\"arrivalLocation\" \nng-change=\"updateTransportPlan(plan)\" ng-model-options=\"{updateOn: \'blur\'}\"><label translate=\"LOGISTIC.LOCATION\">\n</label></md-input-container><md-input-container flex=\"70\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" \nmd-open-on-focus md-hide-icons=\"calendar\" ng-model=\"plan._arrivalDate\" ng-change=\"updateTransportPlan(plan)\" \nname=\"arrivalDate\"></md-datepicker><label translate=\"LOGISTIC.DATE\"></label></md-input-container><md-input-container \nflex=\"30\"><input type=\"time\" ng-model=\"plan._arrivalTime\" name=\"arrivalTime\" ng-change=\"updateTransportPlan(plan)\" \nng-model-options=\"{updateOn: \'blur\'}\"><label translate=\"LOGISTIC.TIME\"></label></md-input-container></div><div \nflex=\"33\" layout=\"row\" layout-wrap><div class=\"nl_categories-item-subtitle\" translate=\"LOGISTIC.TICKET\" flex=\"100\">\n</div><div flex=\"50\" layout=\"row\" layout-align=\"start start\"><md-button type=\"button\" \nng-click=\"downloadTicket(plan.id)\" class=\"md-accent md-hue-3 nl-Button--small\" \nng-disabled=\"plan.ticketLocation == null\"><md-icon md-font-icon=\"icon-download\"></md-icon>\n{{\'GENERAL.DOWNLOAD\' | translate}}</md-button></div><div flex=\"50\" layout=\"row\" layout-align=\"end start\"><md-button \ntype=\"button\" ng-click=\"openDeleteTicket(plan.id)\" class=\"md-accent md-hue-3 nl-Button--small\" \nng-disabled=\"plan.ticketLocation == null\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{\'LOGISTIC.DELETE_TICKET\' | translate}}</md-button></div><md-input-container flex=\"100\"><input type=\"text\" \nng-model=\"plan.ticketNumber\" name=\"ticketNumber\" ng-change=\"updateTransportPlan(plan.id)\" \nng-model-options=\"{updateOn: \'blur\'}\"><label translate=\"LOGISTIC.TICKET_NUMBER\"></label></md-input-container>\n<md-input-container flex=\"100\"><input type=\"file\" id=\"ticket_{{plan.id}}\" plan=\"plan\" class=\"nl_form--file\" \nname=\"ticket\" file-input-changed call=\"uploadTicket(plan)\"><label translate=\"LOGISTIC.TICKET\"></label>\n</md-input-container></div></div></div></div></div></div></div>");
$templateCache.put("app/main/globe_network/companies/duplication_tool/duplication_tool_modal.html","<md-dialog class=\"admin-user-dialog nl-Modal\" aria-label=\"Look For Duplicates\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"lookForDuplicatesForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div\n class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div\n layout=\"column\" layout-align=\"center center\"><div class=\"contact-name\" \nng-if=\"_dtToolData._modelType == MODELS_TYPES.COMPANY_MODEL\">{{\'DUPLICATION_TOOL.COMPANY_TITLE\' | translate}}</div><div\n class=\"contact-name\" ng-if=\"_dtToolData._modelType == MODELS_TYPES.CONTACT_MODEL\">\n{{\'DUPLICATION_TOOL.CONTACT_TITLE\' | translate}}</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ng-if=\"!initDataInProgress\"><md-input-container class=\"\"><md-select name=\"field1\" \nng-model=\"_dtToolData._fields[0]\" placeholder=\"{{\'DUPLICATION_TOOL.SELECT_FIELD\' | translate}}\" \nmd-on-close=\"_searchField1 = \'\'\" required><md-select-header><section><input force-select-focus type=\"search\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField1\"></section></md-select-header><md-option \nng-repeat=\"field in fields | filter : _searchField1 | orderBy : \'libelle\' track by field.id\" ng-value=\"field\">\n{{field.libelle}}</md-option></md-select><div class=\"\" ng-messages=\"lookForDuplicatesForm.form.field1.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container class=\"\"><md-select name=\"field2\" ng-model=\"_dtToolData._fields[1]\" \nplaceholder=\"{{\'DUPLICATION_TOOL.SELECT_FIELD\' | translate}}\" md-on-close=\"_searchField2 = \'\'\"><md-select-header>\n<section><input force-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField2\">\n</section></md-select-header><md-option \nng-repeat=\"field in fields | filter : _searchField2 | orderBy : \'libelle\' track by field.id\" ng-value=\"field\">\n{{field.libelle}}</md-option></md-select></md-input-container></md-dialog-content><md-dialog-content \nng-if=\"initDataInProgress\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\"><md-progress-circular \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" md-mode=\"indeterminate\">\n</md-progress-circular></div></md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button \ntype=\"submit\" ng-click=\"_lookForDuplicates(lookForDuplicatesForm)\" class=\"md-primary md-hue-2 submit-button md-raised\" \nng-disabled=\"lookForDuplicatesForm.$invalid || lookForDuplicatesForm.$pristine || initDataInProgress\" \naria-label=\"Submit\">{{\'DUPLICATION_TOOL.FIND_DUPLICACTE_BTN\' | translate}}</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/globe_network/companies/filter/filter.html","<div class=\"nl-Block nl-Block--bordered nl-Block--theme1\" ng-repeat=\"arrayFilter in arrayFilters track by $index\"><div \nlayout=\"row\" layout-xs=\"column\" flex layout-wrap layout=\"start center\"><div layout=\"row\" layout-align=\"start center\" \nng-if=\"!filter.notDisplayed\" \nng-repeat=\"filter in arrayFilter.fieldFilters | orderBy: \'fieldFilterIndex\' track by $index\" \nflex=\"{{filter.fieldFilterSize}}\" ng-show=\"$index < 8 || arrayFilter.showAll\"><div ng-switch=\"filter.typeChamps\" \nlayout=\"row\" layout-align=\"space-between center\" class=\"nl-Block-item\"><md-input-container flex \nclass=\"nl-Block--inputContainer\" ng-switch-when=\"STRING\"><label><span \nng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">Disposition &nbsp;-&nbsp;</span> <span \nng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;</span> {{filter.libelle}}</label><input\n type=\"text\" ng-model=\"filter.criteria\" ng-enter=\"filterModelFn();\"></md-input-container><md-input-container flex \nclass=\"nl-Block--inputContainer\" ng-switch-when=\"EMAIL\"><label><span \nng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">Disposition &nbsp;-&nbsp;</span> <span \nng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;</span> {{filter.libelle}}</label><input\n type=\"text\" ng-model=\"filter.criteria\" ng-enter=\"filterModelFn();\"></md-input-container><md-input-container flex \nclass=\"nl-Block--inputContainer\" ng-switch-when=\"URL\"><label><span \nng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">Disposition &nbsp;-&nbsp;</span> <span \nng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;</span> {{filter.libelle}}</label><input\n type=\"text\" ng-enter=\"filterModelFn();\" ng-pattern=\"/^(https?:\\/\\/)?([\\da-z\\.-]+)\\.([a-z\\.]{2,6})([\\/\\w \\.-]*)*\\/?$/\" \nng-model=\"filter.criteria\"></md-input-container><div ng-switch-when=\"DATE\" layout=\"row\" layout-wrap><md-input-container\n flex class=\"nl-Block--inputContainer\" ng-if=\"!filter.customFixeFieldFilter\"><label><span \nng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">Disposition &nbsp;-&nbsp;</span> <span \nng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;</span> {{filter.libelle}}</label>\n<md-datepicker ng-enter=\"filterModelFn();\" class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"filter.dateTime\" ng-change=\"changeDate(filter)\"></md-datepicker>\n</md-input-container><div ng-if=\"filter.customFixeFieldFilter\"><div><label>{{filter.libelle}}</label></div><div \nlayout=\"row\" layout-align=\"start center\"><md-input-container class=\"nl-Block--inputContainer\" flex><label>min</label>\n<md-datepicker ng-enter=\"filterModelFn();\" class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"filter.minValue\" ng-change=\"changeDateRangeMin(filter)\"></md-datepicker>\n</md-input-container><md-input-container class=\"nl-Block--inputContainer\" flex><label>max</label><md-datepicker \nng-enter=\"filterModelFn();\" class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" \nng-model=\"filter.maxValue\" ng-change=\"changeDateRangeMax(filter)\"></md-datepicker></md-input-container></div></div>\n</div><div ng-switch-when=\"INTEGER|NUMBER\" ng-switch-when-separator=\"|\" layout=\"row\" layout-wrap><md-input-container \nclass=\"nl-Block--inputContainer\" flex=\"30\"><label>{{\'COMPANIES.FILTER_COMPARATOR\' | translate}}</label><md-select \nng-enter=\"filterModelFn();\" ng-model=\"filter.comparator\"><md-option value=\"<\">&lt;</md-option><md-option value=\"<=\">\n&lt;=</md-option><md-option value=\"=\" selected=\"selected\">=</md-option><md-option value=\">\">></md-option><md-option \nvalue=\">=\">>=</md-option></md-select></md-input-container><md-input-container class=\"nl-Block--inputContainer\" \nng-if=\"filter.typeChamps === \'INTEGER\'\" flex><label><span ng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">\nDisposition &nbsp;-&nbsp;</span> <span ng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;\n</span> {{filter.libelle}}</label><input ng-enter=\"filterModelFn();\" type=\"number\" ng-model=\"filter.criteria\" step=\"1\" \nng-pattern=\"/^[0-9]\\d*$/\"></md-input-container><md-input-container class=\"nl-Block--inputContainer\" \nng-if=\"filter.typeChamps === \'NUMBER\'\" flex><label><span ng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">\nDisposition &nbsp;-&nbsp;</span> <span ng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;\n</span> {{filter.libelle}}</label><input ng-enter=\"filterModelFn();\" type=\"number\" ng-model=\"filter.criteria\" step=\"1\">\n</md-input-container></div><md-input-container flex class=\"nl-Block--inputContainer\" \nng-switch-when=\"LONG_STRING|RICH_TEXT\" ng-switch-when-separator=\"|\"><label><span \nng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">Disposition &nbsp;-&nbsp;</span> <span \nng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;</span> {{filter.libelle}}</label>\n<textarea ng-enter=\"filterModelFn();\" md-detect-hidden ng-model=\"filter.criteria\" rows=\"3\"></textarea>\n</md-input-container><md-input-container flex class=\"nl-Block--inputContainer\" ng-switch-when=\"BOOLEAN\"><label><span \nng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">Disposition &nbsp;-&nbsp;</span> <span \nng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;</span> {{filter.libelle}}</label>\n<md-switch ng-enter=\"filterModelFn();\" ng-model=\"filter.criteria\" aria-label=\"Switch\" class=\"md-primary\"></md-switch>\n</md-input-container><md-input-container flex class=\"nl-Block--inputContainer\" ng-switch-when=\"LIST_SELECT\"><label>\n<span ng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">Disposition &nbsp;-&nbsp;</span> <span \nng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;</span> {{filter.libelle}}</label>\n<md-select ng-enter=\"filterModelFn();\" md-on-close=\"filterSelectText = \'\'\" ng-model=\"filter.criteriaObj\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"option in filter.listFieldsDTO | filterText: filterSelectText | orderBy : \'index\'\" ng-value=\"option\">\n{{option.value}}</md-option></md-select></md-input-container><md-input-container flex class=\"nl-Block--inputContainer\" \nng-switch-when=\"MULTIPLE_SELECT\"><label><span ng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">\nDisposition &nbsp;-&nbsp;</span> <span ng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;\n</span> {{filter.libelle}}</label><md-select ng-enter=\"filterModelFn();\" ng-model=\"filter.criterias\" \nmultiple=\"multiple\"><md-option ng-repeat=\"option in filter.listFieldsDTO | orderBy : \'index\'\" ng-value=\"option\">\n{{option.value}}</md-option></md-select></md-input-container><md-button \nng-if=\"filter.typeChamps !== \'INTEGER\' && filter.typeChamps !== \'NUMBER\'\" class=\"md-icon-button md-accent\" \naria-label=\"Favorite\" ng-click=\"filter.includeInFilter = !filter.includeInFilter\"><md-icon \nmd-font-icon=\"icon-minus-circle-outline\" class=\"icon s18\" ng-if=\"!filter.includeInFilter\" \nstyle=\"color:#e53935!important\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"icon s18\" \nng-if=\"filter.includeInFilter\" style=\"color:#208abe!important\"></md-icon></md-button></div></div><div layout=\"row\" \nlayout-align=\"center center\" flex=\"100\" ng-if=\"arrayFilter.fieldFilters.length > 8\"><md-button type=\"button\" \nclass=\"md-accent md-hue-2 md-teal-theme-theme\" flex=\"100\" ng-click=\"arrayFilter.showAll = !arrayFilter.showAll\">\n<md-icon ng-if=\"!arrayFilter.showAll\" md-font-icon=\"icon-plus-box\"></md-icon><md-icon ng-if=\"arrayFilter.showAll\" \nmd-font-icon=\"icon-minus-box\"></md-icon>{{\'COMPANIES.FILTERS\' | translate}}</md-button></div></div><div layout=\"row\" \nflex layout-wrap ng-if=\"!$first\"><md-button flex=\"100\" md-no-ink class=\"md-warn\" ng-click=\"removeFilterFn($index);\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon>{{\"COMPANIES.REMOVE_EXPAND_SEARCH_LINE\" | translate}}</md-button></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button flex=\"50\" md-no-ink class=\"md-primary\" \nng-click=\"filterModelFn();\"><md-icon md-font-icon=\"icon-filter-outline\"></md-icon>{{\'COMPANIES.FILTER\' | translate}}\n</md-button><md-button flex=\"50\" md-no-ink class=\"md-accent md-hue-2\" ng-click=\"expandSearchFn();\"><md-icon \nmd-font-icon=\"icon-arrow-expand\"></md-icon>{{\'COMPANIES.EXPAND_SEARCH\' | translate}}</md-button></div>");
$templateCache.put("app/main/globe_network/companies/logs/companyLogs.html","<div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table \nclass=\"dataTable row-border hover\"><thead><tr><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.DATE\' | translate}}</div></th><th>\n<div>{{\'ADMIN.USERSLOGS.COLUMNS.USER\' | translate}}</div></th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.ENTITY\' | translate}}\n</div></th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.ACTION\' | translate}}</div></th><th><div>\n{{\'ADMIN.USERSLOGS.COLUMNS.OLD_VALUE\' | translate}}</div></th><th><div>\n{{\'ADMIN.USERSLOGS.COLUMNS.NEW_VALUE\' | translate}}</div></th></tr></thead><tbody><tr ng-repeat=\"log in logs\"><td>\n{{log.date | date: \'dd/MM/yyyy à HH:mm\'}}</td><td><div class=\"nl-Msg-avatar mr-10\"><img class=\"nl-Msg-avatar-img\" \nhttp-src=\"./alternatedocroots/{{log.userPic}}\" has-profile-picture=\"log.userPic != null\"></div>{{log.user}}<br><div \nng-if=\"log.userID\">(id: {{log.userID}})</div></td><td><span ng-if=\"log.idContact\">\n{{\'ADMIN.USERSLOGS.ENTITIES.CONTACT\' | translate}}#{{log.idContact}}</span> <span ng-if=\"!log.idContact\">\n{{\'ADMIN.USERSLOGS.ENTITIES.COMPANY\' | translate}}</span></td><td>{{ ACTIONS[log.action] | translate }}</td><td>\n{{log.oldValue | limitTo: 100}}</td><td>{{log.newValue | limitTo: 100}}</td></tr></tbody></table></div></div><md-button\n ng-disabled=\"allLoaded\" type=\"button\" class=\"md-accent\" ng-click=\"getLogs()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon>{{\'COMPANIES.LOAD_MORE\' | translate}}</md-button></div>");
$templateCache.put("app/main/globe_network/companies/popup/add_company.html","<md-dialog class=\"admin-user-dialog nl-Modal\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"addCompanyForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'COMPANIES.ADD\' | translate}}</div></div>\n<md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><noo-infos-model \nng-model=\"categories\" edition=\"false\" form-name=\"addCompanyForm\" sub-type=\"subTypeId\" sub-types=\"subTypes\" \nmodel-type=\"modelType\" model=\"newCompany\"></noo-infos-model></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button type=\"submit\" ng-click=\"saveCompany(addCompanyForm)\" \nclass=\"md-primary md-hue-2 submit-button md-raised\" ng-disabled=\"addCompanyForm.$invalid || addCompanyForm.$pristine\" \naria-label=\"Sauvegarder\">Sauvegarder</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/globe_network/companies/popup/bulk_message.html","<md-dialog style=\"min-width: 600px\" aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\"GENERAL.UPDATE\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"nl-Popup-content-body\"><form name=\"formCreateMessage\" novalidate>\n<md-input-container class=\"\"><md-select name=\"modelType\" ng-model=\"message.modelType\" ng-change=\"refreshFields()\" \nplaceholder=\"{{\'COMPANIES.MODEL_TYPE\' | translate}}\" required><md-option ng-repeat=\"modelType in modelTypes\" \nng-value=\"modelType\">{{\'GENERAL.\'+modelType | translate}}</md-option></md-select><div class=\"pl-20\" \nng-messages=\"formCreateMessage.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container><label>\n{{\"MESSAGE.CREATION.RECEIVER\" | translate}}</label><md-select ng-model=\"message.receiverForm\" aria-label=\"language\" \nname=\"receiver\"><md-option value=\"null\">{{\"MESSAGE.CREATION.ALL_USERS\" | translate}}</md-option><md-optgroup \nlabel=\"{{\'MESSAGE.CREATION.USERS\' | translate}}\"><md-option ng-repeat=\"user in users\" value=\"{{user}}\">\n{{user.fullName}}</md-option></md-optgroup></md-select></md-input-container><div \nclass=\"nl_categories-item-subtitle mb-15\">{{\"MESSAGE.CREATION.ACTION_REQUEST\" | translate}}</div><div layout=\"column\">\n<md-input-container flex=\"100\" class=\"mb-0\"><label>{{\"MESSAGE.CREATION.ACTION\" | translate}}</label><md-select \nng-model=\"message.actionForm\" name=\"action\" aria-label=\"language\"><md-option ng-value=\"null\">\n{{\"MESSAGE.CREATION.NO_ACTION\" | translate}}</md-option><md-option ng-repeat=\"action in actions\" value=\"{{action}}\">\n{{action.libelle}}</md-option></md-select></md-input-container><md-input-container ng-if=\"message.actionForm != null\" \nflex=\"100\" class=\"mb-0\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-hide-icons=\"calendar\" \nng-model=\"message.startDateForm\" name=\"actionDate\" md-placeholder=\"{{\'MESSAGE.CREATION.DATE\' | translate}}\" \nmd-open-on-focus ng-required=\"message.actionForm != null\"></md-datepicker><div class=\"pl-20\" \nng-messages=\"formCreateMessage.actionDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"message.actionForm != null\" flex=\"100\" class=\"mb-0\"><label class=\"input-prefix\">\n{{\'MESSAGE.CREATION.HOUR\' | translate}} hh:mm</label><input type=\"text\" class=\"input-value\" name=\"actionTime\" \nng-model=\"message.startTime\" ui-time-mask=\"short\" required><div class=\"pl-20\" \nng-messages=\"formCreateMessage.actionTime.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div><div ng-message=\"time\"><span>\n{{\"GENERAL.FORM.INVALID_FORMAT\" | translate}} (hh:mm)</span></div></div><div ng-if=\"timeNotMatch\" \nclass=\"ng-scope nl_form-error-input\"><span>{{\"FESTIVAL.TIME_ERROR\" | translate}}</span></div></md-input-container>\n<md-input-container ng-if=\"message.actionForm !== null\" class=\"m-0\" flex=\"100\"><md-switch class=\"md-primary\" \nng-model=\"message.actionDone\" aria-label=\"Switch 1\">{{\"MESSAGE.CREATION.DONE\" | translate}}</md-switch>\n</md-input-container></div><div class=\"nl_categories-item-subtitle mb-15\">{{\"MESSAGE.TITLE\" | translate}}</div><div \nlayout=\"column\"><md-input-container class=\"md-block mb-0\" flex-gt-sm><label>{{\"MESSAGE.CREATION.SUBJECT\"|translate}}\n</label><input ng-model=\"message.subject\" name=\"subject\" maxlength=\"255\" required><div class=\"pl-20\" \nng-messages=\"formCreateMessage.subject.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex-gt-sm><label>{{\"MESSAGE.CREATION.CONTENT\"|translate}}</label><textarea rows=\"4\" ng-model=\"message.content\" \nname=\"content\" required></textarea><div class=\"pl-20\" ng-messages=\"formCreateMessage.content.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><md-button \nmd-no-ink class=\"md-raised md-primary\" ng-disabled=\"formCreateMessage.$invalid\" ng-click=\"saveMessage()\">\n{{\"GENERAL.SAVE\" | translate }}</md-button><md-button md-no-ink class=\"md-accent md-hue-2\" aria-label=\"Annuler\" \nng-click=\"cancelFormMessage()\">{{\"GENERAL.CANCEL\" | translate }}</md-button></form></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/globe_network/companies/popup/bulk_update.html","<md-dialog class=\"company-disposition-dialog nl-Modal\" aria-label=\"Disposition\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"bulkUpdateForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'COMPANIES.BULK_UPDATE\' | translate}}</div>\n</div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"\">\n<md-select name=\"modelType\" ng-model=\"bulkUpdateDTO.modelType\" ng-change=\"refreshFields()\" \nplaceholder=\"{{\'COMPANIES.MODEL_TYPE\' | translate}}\" required><md-option ng-repeat=\"modelType in modelTypes\" \nng-value=\"modelType\">{{\'GENERAL.\'+modelType | translate}}</md-option></md-select><div class=\"pl-20\" \nng-messages=\"bulkUpdateForm.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"bulkUpdateDTO.modelType != null\"><md-select name=\"field\" ng-model=\"bulkUpdateDTO.field\" \nng-change=\"bulkUpdateDTO.field.fieldEditable = true; bulkUpdateDTO.field.selectableObject = bulkUpdateDTO.field.listFieldsDTO\" \nplaceholder=\"{{\'COMPANIES.FIELD\' | translate}}\" required><md-option \nng-repeat=\"field in fields | orderBy: \'libelle\' track by $index\" ng-value=\"field\">{{field.libelle}}</md-option>\n</md-select><div class=\"pl-20\" ng-messages=\"bulkUpdateForm.field.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><noo-input form-name=\"bulkUpdateForm\" \nng-if=\"bulkUpdateDTO.field != null\" edition=\"true\" ng-model=\"bulkUpdateDTO.field\" index=\"0\" \ncontent=\"{{bulkUpdateDTO.field.typeChamps}}\" big-display-area=\"valueField.bigDisplayArea\" model-type=\"modelType\">\n</noo-input></md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"button\" \nng-click=\"bulkUpdate();\" md-no-ink class=\"md-primary md-hue-2 md-raised\" \nng-disabled=\"bulkUpdateForm.$invalid || bulkUpdateForm.$pristine\" aria-label=\"Sauvegarder\">Sauvegarder</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/globe_network/companies/popup/disposition.html","<md-dialog class=\"company-disposition-dialog nl-Modal\" aria-label=\"Disposition\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"companyDisposiotionForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div>\n<div layout=\"column\" layout-align=\"center center\"><div class=\"contact-name\" ng-if=\"!newDisposition.id\">\n{{\'COMPANIES.DISPOSITION.ADD\' | translate}}</div><div class=\"contact-name\" ng-if=\"newDisposition.id\">\n{{\'COMPANIES.DISPOSITION.MAJ\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"$mdDialog.cancel();\" aria-label=\"Fermeture modal\"></md-button><md-icon md-font-icon=\"icon-close\"></md-icon>\n</div></md-toolbar><md-dialog-content><md-input-container class=\"\"><input type=\"text\" name=\"name\" \nng-model=\"newDisposition.name\" placeholder=\"{{\'COMPANIES.DISPOSITION.NAME\' | translate}}\" required><div class=\"pl-20\" \nng-messages=\"companyDisposiotionForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\"><input \ntype=\"number\" ng-model=\"newDisposition.squareMeter\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.SQUARE_METTER\' | translate}}\"></md-input-container><md-input-container class=\"\">\n<input type=\"number\" ng-model=\"newDisposition.squareFeet\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.SQUARE_FEET\' | translate}}\"></md-input-container><md-input-container class=\"\">\n<input type=\"number\" ng-model=\"newDisposition.length\" placeholder=\"{{\'COMPANIES.DISPOSITION.LENGTH\' | translate}}\">\n</md-input-container><md-input-container class=\"\"><input type=\"number\" ng-model=\"newDisposition.width\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.WIDTH\' | translate}}\"></md-input-container><md-input-container class=\"\"><input \ntype=\"number\" ng-model=\"newDisposition.height\" placeholder=\"{{\'COMPANIES.DISPOSITION.HEIGHT\' | translate}}\">\n</md-input-container><md-input-container class=\"\"><md-switch ng-model=\"newDisposition.dayLight\" aria-label=\"Switch\" \nclass=\"md-primary\">{{\'COMPANIES.DISPOSITION.DAY_LIGHT\' | translate}}</md-switch></md-input-container>\n<md-input-container class=\"\"><input type=\"number\" ng-model=\"newDisposition.theatre\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.THEATER\' | translate}}\"></md-input-container><md-input-container class=\"\"><input \ntype=\"number\" ng-model=\"newDisposition.classRoom\" placeholder=\"{{\'COMPANIES.DISPOSITION.CLASS_ROOM\' | translate}}\">\n</md-input-container><md-input-container class=\"\"><input type=\"number\" ng-model=\"newDisposition.boardRoom\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.BOARD_ROOM\' | translate}}\"></md-input-container><md-input-container class=\"\">\n<input type=\"number\" ng-model=\"newDisposition.uStyle\" placeholder=\"{{\'COMPANIES.DISPOSITION.U_STYLE\' | translate}}\">\n</md-input-container><md-input-container class=\"\"><input type=\"number\" ng-model=\"newDisposition.banquet\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.BANQUET\' | translate}}\"></md-input-container><md-input-container class=\"\"><input \ntype=\"number\" ng-model=\"newDisposition.cocktail\" placeholder=\"{{\'COMPANIES.DISPOSITION.COCKTAIL\' | translate}}\">\n</md-input-container><md-input-container class=\"\"><input type=\"number\" ng-model=\"newDisposition.conference\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.CONFERENCE\' | translate}}\"></md-input-container><md-input-container class=\"\">\n<input type=\"number\" ng-model=\"newDisposition.cabaret\" placeholder=\"{{\'COMPANIES.DISPOSITION.CABARET\' | translate}}\">\n</md-input-container><md-input-container class=\"\"><input type=\"number\" ng-model=\"newDisposition.auditorium\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.AUDITORIUM\' | translate}}\"></md-input-container></md-dialog-content>\n<md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"button\" ng-if=\"newDisposition.id\" \nng-click=\"deleteCompanyDisposition(newDisposition.id)\" md-no-ink class=\"md-warn md-hue-2\" aria-label=\"Supprimer\">\nSupprimer</md-button><md-button type=\"submit\" ng-click=\"saveCompanyDisposition();\" md-no-ink \nclass=\"md-primary md-hue-2 md-raised\" \nng-disabled=\"companyDisposiotionForm.$invalid || companyDisposiotionForm.$pristine\" aria-label=\"Sauvegarder\">\nSauvegarder</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/globe_network/companies/sort/sort.html","<div layout=\"row\" layout-align=\"end center\"><md-input-container class=\"\" ng-repeat=\"sort in modelSortsDto.sorts\">\n<md-select ng-model=\"sort.fieldSortSelected\" placeholder=\"Trier par\" ng-change=\"sortModelFn();\"><md-option \nng-repeat=\"option in sort.fieldSorts | orderBy : \'fieldSortIndex\'\" ng-value=\"option\"><span \nng-show=\"option.fieldSortBaseType == \'FIXE_FIELD\'\">{{ option.libelle | translate}}</span> <span \nng-hide=\"option.fieldSortBaseType == \'FIXE_FIELD\'\">{{option.libelle}}</span><md-icon ng-if=\"option.sortType == \'ASC\'\" \nmd-font-icon=\"icon-sort-ascending\" class=\"md-default-theme md-font material-icons\" role=\"img\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"option.sortType == \'DESC\'\" md-font-icon=\"icon-sort-descending\" \nclass=\"md-default-theme md-font material-icons\" role=\"img\" aria-hidden=\"true\"></md-icon></md-option></md-select>\n</md-input-container></div>");
$templateCache.put("app/main/globe_network/companies/statsClicks/statsClicks.html","<div class=\"content\"><div class=\"nl-Block\"><div class=\"nl_categories-item-title\" layout=\"row\" \nlayout-align=\"space-between center\">{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</div><md-input-container><label>\n{{\'STATS_CLICKS.PERIOD_MODE\' | translate}}</label><md-select ng-model=\"periodMode.value\" name=\"periodMode\"><md-option \nng-repeat=\"period in periodModes\" ng-value=\"period.value\">{{period.name}}</md-option></md-select></md-input-container>\n<div layout=\"row\"><md-datepicker flex ng-if=\"periodMode.value === \'day\' || periodMode.value === \'custom\'\" \nclass=\"nl-Datepicker nl-Datepicker--fw\" md-hide-icons=\"calendar\" ng-model=\"filter.date\" name=\"date\" \nmd-placeholder=\"{{\'BLOG.CREATION.DATE\' | translate}}\" md-open-on-focus></md-datepicker><md-datepicker flex \nng-if=\"periodMode.value === \'custom\'\" class=\"nl-Datepicker nl-Datepicker--fw\" md-hide-icons=\"calendar\" \nng-model=\"filter.dateCustom\" name=\"date\" md-placeholder=\"{{\'BLOG.CREATION.DATE\' | translate}}\" md-open-on-focus>\n</md-datepicker></div><div layout=\"row\"><md-input-container ng-if=\"periodMode.value === \'month\'\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filter.month\" name=\"filterMonth\">\n<md-option ng-repeat=\"month in monthNames\" ng-value=\"month.value\">{{month.name}}</md-option></md-select>\n</md-input-container><md-input-container ng-if=\"periodMode.value === \'month\' || periodMode.value === \'year\'\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"filter.year\"><md-select-header><input \ntype=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear.value\" onkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button \nng-click=\"searchStatisticsCustomYear()\" class=\"m-0\">{{\'GENERAL.OK\' | translate}}</md-button></md-select-header>\n<md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">{{year}}</md-option><md-option value=\"custom\" \nstyle=\"display: none\">{{customYear.value}}</md-option></md-select></md-input-container></div><md-button \nclass=\"md-raised md-primary md-hue-2\" md-no-ink ng-click=\"getStatistics()\">{{\'STATISTICS.DISPLAY.FILTER\' | translate}}\n</md-button></div><div class=\"nl-Block nl-Block--table\" ng-if=\"statistics.clicks != null\"><div class=\"nl-listing\">\n<table class=\"simple list-view\"><thead><th>{{\"STATS_CLICKS.COLUMNS.TYPE\" | translate}}</th><th>\n{{\"STATS_CLICKS.COLUMNS.NBR\" | translate}}</th></thead><tbody><tr ng-repeat=\"stat in statistics.clicks\"><td>\n{{\"STATS_CLICKS.TYPES.\" + stat.type | translate}}</td><td>{{stat.nbr}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/globe_network/inscriptions/settings/inscriptions_admin_settings.html","");
$templateCache.put("app/main/mailing/blocs/bloc/bloc.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"MAILING.BLOCS.ADD\" ng-if=\"!bloc.id\">\n</div><div class=\"\" translate=\"MAILING.BLOCS.MAJ\" ng-if=\"bloc.id\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"button\" class=\"\" ng-click=\"_blocsListFn()\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon>{{\'MAILING.BLOCS.LIST\' | translate}}</md-button><md-button \ntype=\"button\" class=\"\" ng-click=\"_delete()\" ng-if=\"bloc.id\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>\n{{\'MAILING.ACTIONS.DELETE\' | translate}}</md-button><md-button type=\"button\" class=\"\" ng-click=\"_save(blocForm)\">\n<md-icon md-font-icon=\"icon-content-save\"></md-icon>{{\'MAILING.ACTIONS.SAVE\' | translate}}</md-button></div></div><div \nclass=\"content\"><div class=\"white-bg md-whiteframe-4dp p-40\"><div layout=\"column\"><form name=\"blocForm\" \nclass=\"md-inline-form\" novalidate><md-input-container class=\"\"><input type=\"text\" name=\"name\" ng-model=\"bloc.name\" \nplaceholder=\"{{\'MAILING.BLOCS.FIELDS.NAME\' | translate}}\" required><div class=\"\" ng-messages=\"blocForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container class=\"\"><md-select name=\"type\" ng-model=\"bloc.type\" \nplaceholder=\"{{\'MAILING.BLOCS.FIELDS.TYPE\' | translate}}\" required ng-change=\"getBloc()\"><md-option \nng-repeat=\"_thisType in types | orderBy : \'translation\' track by $index\" ng-value=\"_thisType.value\" \nng-selected=\"_thisType.value == bloc.type\">{{_thisType.translation | translate}}</md-option></md-select><div class=\"\" \nng-messages=\"blocForm.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"\"><textarea name=\"html\" ng-model=\"bloc.html\" \nrows=\"20\" placeholder=\"{{\'MAILING.BLOCS.FIELDS.HTML\' | translate}}\" required>\n                            <div \nclass=\"\" ng-messages=\"blocForm.html.$error\" role=\"alert\">\n                                <div ng-message=\"required\">\n                                    <span>{{\"GENERAL.REQUIRED\" | translate}}</span>\n                                \n</div>\n                            </div>\n                        </md-input-container>\n\n                    </form>\n\n    \n                </div>\n    \n            </div>\n    \n        </div>\n        \n    \n    </div>");
$templateCache.put("app/main/mailing/pages/page/page.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"MAILING.PAGES.ADD\" ng-if=\"!page.id\">\n</div><div class=\"\" translate=\"MAILING.PAGES.MAJ\" ng-if=\"page.id\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"button\" class=\"\" ng-click=\"_pagesListFn()\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon>{{\'MAILING.PAGES.LIST\' | translate}}</md-button><md-button \ntype=\"button\" class=\"\" ng-click=\"_delete()\" ng-if=\"page.id\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>\n{{\'MAILING.ACTIONS.DELETE\' | translate}}</md-button><md-button type=\"button\" class=\"\" ng-click=\"_save(pageForm)\">\n<md-icon md-font-icon=\"icon-content-save\"></md-icon>{{\'MAILING.ACTIONS.SAVE\' | translate}}</md-button></div></div><div \nclass=\"content\"><div class=\"white-bg md-whiteframe-4dp p-40\"><div layout=\"column\"><form name=\"pageForm\" \nclass=\"md-inline-form\" novalidate><md-input-container class=\"\"><input type=\"text\" name=\"name\" ng-model=\"page.name\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS.NAME\' | translate}}\" required><div class=\"\" ng-messages=\"pageForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container class=\"mt-20 mb-20\"><md-select name=\"language\" ng-model=\"page.language\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS.LANGUAGE\' | translate}}\" ng-change=\"_changeLanguageFn();\" required \nng-model-options=\"{trackBy: \'$value.key\'}\"><md-option ng-repeat=\"lang in languages | orderBy : \'libelle\'\" \nng-value=\"lang\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select><label>\n{{\'MAILING.TRIGGERS.FIELDS.LANGUAGE\' | translate}}</label><div class=\"\" ng-messages=\"pageForm.language.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container class=\"mt-40\"><input type=\"text\" name=\"subject\" ng-model=\"page.subject\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS.SUBJECT\' | translate}}\" required><div class=\"\" \nng-messages=\"pageForm.subject.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"mt-40\"><textarea name=\"head\" rows=\"3\" \nng-model=\"page.htmlHeader\" placeholder=\"{{\'MAILING.PAGES.FIELDS.HTML_HEADER\' | translate}}\"></textarea>\n</md-input-container><fieldset class=\"standard mt-20 mb-20\" \nng-repeat=\"_pageBloc in page.pageBlocs | orderBy : \'index\' track by $index\"><div layout=\"row\"><md-input-container \nclass=\"\" flex=\"80\"><md-select name=\"bloc{{$index}}\" ng-model=\"_pageBloc.bloc\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS.BLOC\' | translate}}\" required ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option\n ng-repeat=\"_thisBloc in blocs | orderBy : \'name\' track by _thisBloc.id\" ng-value=\"_thisBloc\">{{_thisBloc.name}}\n</md-option></md-select><div class=\"\" ng-messages=\"pageForm[\'bloc\'+$index].$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><div \nclass=\"ml-15\" layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"moveBloc(_pageBloc, true, pageForm)\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(_pageBloc.index > 1 && page.pageBlocs.length > 1)\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\">\n</md-icon></md-button><md-button ng-click=\"moveBloc(_pageBloc, false, pageForm)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"(_pageBloc.index == page.pageBlocs.length)\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div><md-button md-no-ink \nclass=\"nl-listing-item-button md-accent\" type=\"button\" ng-click=\"showHtml(_pageBloc)\" flex=\"20\">Show html</md-button>\n</div><md-input-container class=\"\" ng-if=\"_pageBloc.showHtml\"><textarea name=\"html{{$index}}\" \nng-model=\"_pageBloc.html\" required></textarea><div class=\"\" ng-messages=\"pageForm[\'html\'+$index].$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><div \nng-repeat=\"_pageBlocTranslation in _pageBloc.pageBlocTranslations  | orderBy : \'key\' track by $index\">\n<md-input-container class=\"\" ng-if=\"!_pageBlocTranslation.simpleField\"><md-select name=\"value{{$index}}\" \nng-model=\"_pageBlocTranslation.field\" placeholder=\"{{_getCleanKey(_pageBlocTranslation.key)}}\" \nng-required=\"!_pageBlocTranslation.simpleField\" md-on-close=\"_searchField = \'\'\" \nng-model-options=\"{trackBy: \'$value.id + $value.libelle + $value.inscriptionFieldFormId\'}\"><md-select-header><section>\n<input force-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField\"></section>\n</md-select-header><md-optgroup label=\"\" ng-if=\"fields.contact.length>0\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_CONTACT\"></label><md-option \nng-repeat=\"field in fields.contact | filter : _searchField | orderBy : \'libelle\'\" ng-value=\"field\">{{field.libelle}}\n</md-option></md-optgroup><md-optgroup label=\"\" ng-if=\"fields.company.length>0\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\"></label><md-option \nng-repeat=\"field in fields.company | filter : _searchField | orderBy : \'libelle\'\" ng-value=\"field\">{{field.libelle}}\n</md-option></md-optgroup><md-optgroup label=\"\" ng-if=\"fields.company.length>0\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_INSCRIPTION\"></label><md-option \nng-repeat=\"field in fields.inscription | filter : _searchField | orderBy : \'libelle\'\" ng-value=\"field\">\n{{field.libelle}}</md-option></md-optgroup></md-select><label>{{_getCleanKey(_pageBlocTranslation.key)}}</label><div \nclass=\"\" ng-messages=\"pageForm[\'value\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"_pageBlocTranslation.simpleField\"><textarea name=\"value{{$index}}\" ng-model=\"_pageBlocTranslation.value\" \nng-required=\"_pageBlocTranslation.simpleField\"></textarea><label>{{_getCleanKey(_pageBlocTranslation.key)}}</label><div\n class=\"\" ng-messages=\"pageForm[\'value\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><md-button type=\"button\" class=\"\" \nng-click=\"_removePageBlocFn(_pageBloc, pageForm)\" ng-if=\"blocs.length > 0\"><md-icon md-font-icon=\"icon-delete-variant\">\n</md-icon>{{\'MAILING.ACTIONS.DELETE\' | translate}}</md-button></fieldset><div layout=\"row\" layout-align=\"start center\" \nclass=\"pt-20\"><md-button type=\"button\" class=\"\" ng-click=\"_addPageBlocFn(pageForm)\" ng-if=\"blocs.length > 0\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>{{\'MAILING.PAGES.ADD_BLOC\' | translate}}</md-button></div></form></div></div></div>\n</div>");
$templateCache.put("app/main/mailing/triggers/trigger/trigger.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"MAILING.TRIGGERS.ADD\" \nng-if=\"!trigger.id\"></div><div class=\"\" translate=\"MAILING.TRIGGERS.MAJ\" ng-if=\"trigger.id\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"button\" class=\"\" ng-click=\"_triggersListFn()\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon>{{\'MAILING.TRIGGERS.LIST\' | translate}}</md-button><md-button \ntype=\"button\" class=\"\" ng-click=\"_delete()\" ng-if=\"trigger.id\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>\n{{\'MAILING.ACTIONS.DELETE\' | translate}}</md-button><md-button type=\"button\" class=\"\" ng-click=\"_save(triggerForm)\">\n<md-icon md-font-icon=\"icon-content-save\"></md-icon>{{\'MAILING.ACTIONS.SAVE\' | translate}}</md-button></div></div><div \nclass=\"content\"><div class=\"white-bg md-whiteframe-4dp p-40\"><div layout=\"column\"><form name=\"triggerForm\" \nclass=\"md-inline-form\" novalidate><md-input-container class=\"\"><input type=\"text\" name=\"name\" ng-model=\"trigger.name\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS.NAME\' | translate}}\" required><div class=\"\" \nng-messages=\"triggerForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"mt-20\"><md-select name=\"type\" \nng-model=\"trigger.type\" placeholder=\"{{\'MAILING.TRIGGERS.FIELDS.TYPE\' | translate}}\" required \nng-change=\"_triggerTypeChangeFn();\"><md-option ng-repeat=\"type in types | orderBy : \'value\'\" ng-value=\"type.value\">\n{{\'MAILING.TRIGGERS.TYPES.\'+ type.value | translate}}</md-option></md-select><label>\n{{\'MAILING.TRIGGERS.FIELDS.TYPE\' | translate}}</label><div class=\"\" ng-messages=\"triggerForm.type.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container class=\"mt-40\" ng-if=\"trigger.type && trigger.type == \'DROPDOWN_TRIGGER\'\"><md-select \nname=\"modelType\" ng-model=\"trigger.modelType\" placeholder=\"{{\'MAILING.TRIGGERS.FIELDS.MODEL_TYPE\' | translate}}\" \nng-required=\"trigger.type && trigger.type ==\'DROPDOWN_TRIGGER\'\" ng-change=\"_modelTypeChangeFn();\"><md-option \nng-repeat=\"modelType in MODELS_TYPES track by $index\" ng-value=\"modelType\">{{\'GENERAL.\' + modelType | translate}}\n</md-option></md-select><label>{{\'MAILING.TRIGGERS.FIELDS.MODEL_TYPE\' | translate}}</label><div class=\"\" \nng-messages=\"triggerForm.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><div layout=\"row\" layout-wrap \nng-if=\"trigger.type && trigger.type == \'DROPDOWN_TRIGGER\'\"><div class=\"nl-info-block-list-img animated fadeIn\" \nflex=\"60\"><md-input-container class=\"mt-40\"><md-select name=\"field\" ng-model=\"trigger.field\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS.FIELD\' | translate}}\" \nng-required=\"trigger.type && trigger.type ==\'DROPDOWN_TRIGGER\'\" md-on-close=\"_searchField = \'\'\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"_fieldChangeFn();\"><md-select-header><section><input \nforce-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField\"></section>\n</md-select-header><md-option ng-if=\"trigger.modelType==\'CONTACT_MODEL\'\" \nng-repeat=\"field in fields.contact | filter : { typeChamps : \'LIST_SELECT\' } | filter : _searchField | orderBy : \'libelle\'\" \nng-value=\"field\">{{field.libelle}}</md-option><md-option ng-if=\"trigger.modelType==\'COMPANY_MODEL\'\" \nng-repeat=\"field in fields.company | filter : { typeChamps : \'LIST_SELECT\' } | filter : _searchField | orderBy : \'libelle\'\" \nng-value=\"field\">{{field.libelle}}</md-option><md-option ng-if=\"trigger.modelType==\'INSCRIPTION_MODEL\'\" \nng-repeat=\"field in fields.inscription | filter : { typeChamps : \'LIST_SELECT\' } | filter : _searchField | orderBy : \'libelle\'\" \nng-value=\"field\">{{field.libelle}}</md-option><md-option ng-if=\"trigger.modelType==\'LOGISTIC_MODEL\'\" \nng-repeat=\"field in fields.logistic | filter : { typeChamps : \'LIST_SELECT\' } | filter : _searchField | orderBy : \'libelle\'\" \nng-value=\"field\">{{field.libelle}}</md-option></md-select><label>{{\'MAILING.TRIGGERS.FIELDS.FIELD\' | translate}}\n</label><div class=\"\" ng-messages=\"triggerForm.field.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><div \nclass=\"nl-info-block-list-img animated fadeIn\" flex=\"40\"><md-input-container class=\"mt-40\"><md-select \nname=\"fieldValue\" ng-model=\"trigger.fieldValue\" placeholder=\"{{\'MAILING.TRIGGERS.FIELDS.FIELD_VALUE\' | translate}}\" \nng-required=\"trigger.type && trigger.type ==\'DROPDOWN_TRIGGER\'\" md-on-close=\"_searchFieldValue = \'\'\" \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-select-header><section><input force-select-focus type=\"search\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchFieldValue\"></section></md-select-header><md-option \nng-repeat=\"fieldValue in trigger.field.listFieldsDTO | filter : _searchFieldValue | orderBy : \'value\'\" \nng-value=\"fieldValue\">{{fieldValue.value}}</md-option></md-select><label>\n{{\'MAILING.TRIGGERS.FIELDS.FIELD_VALUE\' | translate}}</label><div class=\"\" ng-messages=\"triggerForm.fieldValue.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container></div></div><div layout=\"row\" layout-wrap \nng-if=\"trigger.type && trigger.type == \'REGISTRATION_VALIDATED_TRIGGER\'\"><div \nclass=\"nl-info-block-list-img animated fadeIn\" flex=\"60\"><md-input-container class=\"mt-40\"><md-select name=\"event\" \nng-model=\"trigger.event\" placeholder=\"{{\'MAILING.TRIGGERS.FIELDS.EVENT\' | translate}}\" \nng-required=\"trigger.type && trigger.type ==\'REGISTRATION_VALIDATED_TRIGGER\'\" md-on-close=\"_searchEvent = \'\'\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"listRegistrationFormsByEvent(trigger.event);\"><md-select-header>\n<section><input force-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchEvent\">\n</section></md-select-header><md-option ng-repeat=\"_event in events | filter : _searchEvent | orderBy : \'name\'\" \nng-value=\"_event\">{{_event.name}}</md-option></md-select><label>{{\'MAILING.TRIGGERS.FIELDS.EVENT\' | translate}}</label>\n<div class=\"\" ng-messages=\"triggerForm.event.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><div \nclass=\"nl-info-block-list-img animated fadeIn\" flex=\"40\"><md-input-container class=\"mt-40\"><md-select \nname=\"registrationForm\" ng-model=\"trigger.registrationForm\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS.REGISTRATION_FORM\' | translate}}\" \nng-required=\"trigger.type && trigger.type ==\'REGISTRATION_VALIDATED_TRIGGER\'\" \nmd-on-close=\"_searchRegistrationForm = \'\'\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-select-header><section><input \nforce-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchRegistrationForm\">\n</section></md-select-header><md-option \nng-repeat=\"registrationForm in registrationForms | filter : _searchRegistrationForm | orderBy : \'name\'\" \nng-value=\"registrationForm\">{{registrationForm.name}}</md-option></md-select><label>\n{{\'MAILING.TRIGGERS.FIELDS.REGISTRATION_FORM\' | translate}}</label><div class=\"\" \nng-messages=\"triggerForm.registrationForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div></div><md-input-container \nclass=\"mt-40\" ng-if=\"trigger.type\"><md-select name=\"recipients\" ng-model=\"trigger.recipients\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS.RECIPIENTS\' | translate}}\" required multiple=\"multiple\" \nmd-on-close=\"_searchRecipient = \'\'\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-select-header><section><input \nforce-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchRecipient\"></section>\n</md-select-header><md-optgroup label=\"\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_CONTACT\"></label><md-option \nng-repeat=\"recipient in fields.contact | filter : { typeChamps : \'EMAIL\' } | filter : _searchRecipient | orderBy : \'libelle\' track by recipient.id\" \nng-value=\"recipient\">{{recipient.libelle}}</md-option></md-optgroup><md-optgroup label=\"\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\"></label><md-option \nng-repeat=\"recipient in fields.company | filter : { typeChamps : \'EMAIL\' } | filter : _searchRecipient | orderBy : \'libelle\' track by recipient.id\" \nng-value=\"recipient\">{{recipient.libelle}}</md-option></md-optgroup></md-select><label>\n{{\'MAILING.TRIGGERS.FIELDS.RECIPIENTS\' | translate}}</label><div class=\"\" ng-messages=\"triggerForm.recipients.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container class=\"mt-40\" ng-if=\"trigger.type\"><md-select name=\"template\" \nng-model=\"trigger.template\" placeholder=\"{{\'MAILING.TRIGGERS.FIELDS.TEMPLATE\' | translate}}\" required \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"template in pages | orderBy : \'name\'\" \nng-value=\"template\">{{template.name}}</md-option></md-select><label>{{\'MAILING.TRIGGERS.FIELDS.TEMPLATE\' | translate}}\n</label><div class=\"\" ng-messages=\"triggerForm.template.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"mt-40\" \nng-if=\"trigger.type\"><md-select name=\"language\" ng-model=\"trigger.language\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS.LANGUAGE\' | translate}}\" required ng-model-options=\"{trackBy: \'$value.key\'}\">\n<md-option ng-repeat=\"lang in languages | orderBy : \'libelle\'\" ng-value=\"lang\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select><label>\n{{\'MAILING.TRIGGERS.FIELDS.LANGUAGE\' | translate}}</label><div class=\"\" ng-messages=\"triggerForm.language.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container></form></div></div></div></div>");
$templateCache.put("app/main/settings/research_page_creation/includes/filters.html","<div class=\"nl-Block mt-15\"><div><div class=\"nl_categories-item-title nl_categories-item-title--first\"><span \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.ADD_FIELD_TO_FILTER_ENGINE\"></span></div></div><div \nng-repeat=\"filter in filters | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><h3 class=\"\" ng-if=\"filter.baseType == \'MODEL_FIELD\'\"><span \nng-if=\"filter.fieldModelDto && filter.fieldModelDto.modelType == companyModelType\" \ntranslate=\"SETTINGS.DATABASE.COMPANY.TITLE\"></span> <span \nng-if=\"filter.fieldModelDto && filter.fieldModelDto.modelType == contactModelType\" \ntranslate=\"SETTINGS.DATABASE.CONTACT.TITLE\"></span> <span \nng-if=\"filter.fieldModelDto && filter.fieldModelDto.modelType == registrationModelType\" \ntranslate=\"SETTINGS.DATABASE.REGISTRATION.TITLE\"></span> <span \nng-if=\"filter.fieldModelDto && filter.fieldModelDto.modelType == logisticModelType\" \ntranslate=\"SETTINGS.DATABASE.LOGISTIC.TITLE\"></span> &nbsp;-&nbsp; {{filter.fieldModelDto.libelle}}</h3><h3 \nclass=\"panel-title\" ng-if=\"filter.baseType == \'FIXE_FIELD\'\"><span \nng-if=\"filter.fixeFieldDto && filter.fixeFieldDto.data.clazz == \'CompanyDisposition\'\">Disposition</span> <span \nng-if=\"filter.fixeFieldDto && (filter.fixeFieldDto.data.clazz == \'Contact\' || filter.fixeFieldDto.data.clazz == \'Company\')\" \ntranslate=\"SETTINGS.DATABASE.COMPANY.TITLE\"></span> <span \nng-if=\"filter.fixeFieldDto && (filter.fixeFieldDto.data.clazz == \'InscriptionSubCategory\' \n                  || filter.fixeFieldDto.data.clazz == \'InscriptionStatus\')\" \ntranslate=\"SETTINGS.DATABASE.REGISTRATION.TITLE\"></span> <span \nng-if=\"filter.fixeFieldDto && filter.fixeFieldDto.data.clazz == \'LogisticalStatus\'\" \ntranslate=\"SETTINGS.DATABASE.LOGISTIC.TITLE\"></span> &nbsp;-&nbsp; <span translate=\"{{filter.fixeFieldDto.libelle}}\">\n</span></h3></div><div class=\"panel-actions panel-actions-keep\" layout=\"row\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"delete({config : \'FILTER\', data : filter });\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon>\n</md-button><div class=\"ml-15\" layout=\"row\" layout-align=\"space-between center\"><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"!(filter.index > 1)\" \nng-click=\"upFieldFilterOrSort({config : \'FILTER\', data : filter });\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\">\n</md-icon></md-button><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(filter.index != filters.length)\" ng-click=\"downFieldFilterOrSort({config : \'FILTER\', data : filter });\">\n<md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div>\n<form name=\"researchPageCreationFilterForm\" role=\"form\" novalidate><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"\"><md-select md-on-close=\"filterSelectText = \'\'\" \nname=\"newFieldToFilter\" id=\"newFieldToFilter\" ng-model=\"newFieldToFilter.data\" placeholder=\" \" flex><md-select-header>\n<section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectText\"></section></md-select-header><md-optgroup label=\"\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\"></label><md-option ng-value=\"field\" \nng-repeat=\"field in fieldsForFiltersFiltered | filterText: filterSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == companyModelType || (field.data && field.data.clazz == \'AbstractModel\') || (field.data && field.data.clazz == \'Contact\')\">\n<span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\">\n</span></md-option></md-optgroup><md-optgroup label=\"\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_CONTACT\">\n</label><md-option ng-value=\"field\" \nng-repeat=\"field in fieldsForFiltersFiltered | filterText: filterSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == contactModelType\"><span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span \nng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-optgroup><md-optgroup label=\"\" \nng-if=\"modelType == \'COMPANY_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_DISPOSITION\"></label><md-option \nng-value=\"field\" ng-repeat=\"field in fieldsForFiltersFiltered | filterText: filterSelectText | orderBy: \'libelle\'\" \nng-if=\"field.data && field.data.clazz == \'CompanyDisposition\'\"><span ng-if=\"field.modelType\">{{ field.libelle }}</span>\n <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-optgroup><md-optgroup label=\"\" \nng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_INSCRIPTION\"></label>\n<md-option ng-value=\"field\" \nng-repeat=\"field in fieldsForFiltersFiltered | filterText: filterSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == registrationModelType || (field.data && field.data.name == \'FIXE_FIELD_REGISTRATION_SUBCATEGORY\') \n                || (field.data && field.data.name == \'FIXE_FIELD_REGISTRATION_STATUS\')\">\n<span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\">\n</span></md-option></md-optgroup><md-optgroup label=\"\" ng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_LOGISTIC\"></label><md-option ng-value=\"field\" \nng-repeat=\"field in fieldsForFiltersFiltered | filterText: filterSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == logisticModelType || (field.data && field.data.name == \'FIXE_FIELD_LOGISTIC_STATUS\')\"><span \nng-if=\"field.modelType\">{{ field.libelle }}</span> <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span>\n</md-option></md-optgroup></md-select><div ng-messages=\"researchPageCreationFilterForm.newFieldToFilter.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Obligatoire.</span></div></div></md-input-container><div><md-button \ntype=\"button\" class=\"md-raised md-primary md-hue-2\" ng-click=\"save({ config : \'FILTER\' });\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}</md-button></div></div></form></div>");
$templateCache.put("app/main/settings/research_page_creation/includes/sorting.html","<div class=\"nl-Block mt-15\"><div><div class=\"nl_categories-item-title nl_categories-item-title--first\"><span \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.ADD_FIELD_TO_SORT\">{{modelType}}</span></div></div><div \nng-repeat=\"sort in sorts | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><h3 class=\"\" ng-if=\"sort.baseType == \'MODEL_FIELD\'\">\n{{sort.fieldModelDto.libelle}}</h3><h3 class=\"panel-title\" ng-if=\"sort.baseType == \'FIXE_FIELD\'\"><span \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.{{sort.fixeFieldDto.data.name}}\"></span></h3></div><div \nclass=\"panel-actions panel-actions-keep\" layout=\"row\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"delete({config : \'SORT\', data : sort });\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(sort.index > 1)\" ng-click=\"upFieldFilterOrSort({config : \'SORT\', data : sort });\"><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"!(sort.index != sorts.length)\" \nng-click=\"downFieldFilterOrSort({config : \'SORT\', data : sort });\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\">\n</md-icon></md-button></div></div></div></div></div></div></div><form name=\"researchPageCreationSortForm\" role=\"form\" \nnovalidate><div layout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"\"><md-select \nmd-on-close=\"sortSelectText = \'\'\" name=\"newFieldToSort\" id=\"newFieldToSort\" ng-model=\"newFieldToSort.data\" \nplaceholder=\"\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"sortSelectText\"></section></md-select-header><md-option \nng-value=\"field\" ng-repeat=\"field in fieldsForSortsFiltered | filterText: sortSelectText | orderBy: \'libelle\'\" \nng-if=\"modelType == \'COMPANY_MODEL\'\"><span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span \nng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option><md-optgroup label=\"\" \nng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\"></label><md-option \nng-value=\"field\" ng-repeat=\"field in fieldsForSortsFiltered | filterText: sortSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == companyModelType\"><span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span \nng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-optgroup><md-optgroup label=\"\" \nng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_CONTACT\"></label><md-option \nng-value=\"field\" ng-repeat=\"field in fieldsForSortsFiltered | filterText: sortSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == contactModelType\"><span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span \nng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-optgroup><md-optgroup label=\"\" \nng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_INSCRIPTION\"></label>\n<md-option ng-value=\"field\" \nng-repeat=\"field in fieldsForSortsFiltered | filterText: sortSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == registrationModelType || (field.data && field.data.name == \'FIXE_FIELD_REGISTRATION_SUBCATEGORY\') \n                  || (field.data && field.data.name == \'FIXE_FIELD_REGISTRATION_STATUS\')\">\n<span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\">\n</span></md-option></md-optgroup><md-optgroup label=\"\" ng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_LOGISTIC\"></label><md-option ng-value=\"field\" \nng-repeat=\"field in fieldsForSortsFiltered | filterText: sortSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == logisticModelType || (field.data && field.data.name == \'FIXE_FIELD_LOGISTIC_STATUS\')\"><span \nng-if=\"field.modelType\">{{ field.libelle }}</span> <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span>\n</md-option></md-optgroup></md-select><div ng-messages=\"researchPageCreationSortForm.newFieldToSort.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Obligatoire.</span></div></div></md-input-container><div><md-button \ntype=\"button\" class=\"md-raised md-primary md-hue-2\" ng-click=\"save({ config : \'SORT\' });\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}</md-button></div></div></form></div>");
$templateCache.put("app/main/sitegen/account/account_home/account_home.html","<div class=\"nl_Row-content\"><div layout=\"row\"><div class=\"p-10 flex-100 flex-gt-xs-30\"><div class=\"nl-SideMenu\"><div \nclass=\"nl-SideMenu__item\"><h1 class=\"nl-SideMenu__title\">{{\'SITE_GEN.WORKBOOK.CAHIER_CHARGES\' | translate}}</h1><div \nclass=\"nl-SideMenu__inner\"><div class=\"nl-SideMenu__link\" ng-class=\"{\'nl-active\':menuType==\'MY_CC\'}\" \nng-click=\"menuType=\'MY_CC\'\">{{\'SITE_GEN.WORKBOOK.SEE_CAHIER_CHARGES\' | translate}}</div><div class=\"nl-SideMenu__link\" \nng-class=\"{\'nl-active\':menuType==\'CREATE_CC\'}\" ng-click=\"menuType=\'CREATE_CC\'\">\n{{\'SITE_GEN.WORKBOOK.CREATE_CC\' | translate}}</div></div></div><div class=\"nl-SideMenu__item\"><h1 \nclass=\"nl-SideMenu__title\">{{\'SITE_GEN.WORKBOOK.DEMANDE_DEVIS\' | translate}}</h1><div class=\"nl-SideMenu__inner\"><div \nclass=\"nl-SideMenu__link\" ng-class=\"{\'nl-active\':menuType==\'MY_RFPS\'}\" ng-click=\"menuType=\'MY_RFPS\'\">\n{{\'SITE_GEN.WORKBOOK.SEE_DEMANDE_DEVIS\' | translate}}</div><div class=\"nl-SideMenu__link\" \nng-class=\"{\'nl-active\':menuType==\'CREATE_DEMANDE_DEVIS\'}\" ng-click=\"menuType=\'CREATE_DEMANDE_DEVIS\'\">\n{{\'SITE_GEN.WORKBOOK.SEND_RFP\' | translate}}</div></div></div><div class=\"nl-SideMenu__item\"><h1 \nclass=\"nl-SideMenu__title\">{{\'SITE_GEN.WORKBOOK.MY_SELECTION\' | translate}}</h1><div class=\"nl-SideMenu__inner\"><div \nclass=\"nl-SideMenu__link\" ng-class=\"{\'nl-active\':menuType==\'MY_SELECTION\'}\" ng-click=\"menuType=\'MY_SELECTION\'\">\n{{\'SITE_GEN.WORKBOOK.SEE_MY_SELECTION\' | translate}}</div></div></div><div class=\"nl-SideMenu__item\"><h1 \nclass=\"nl-SideMenu__title\">{{\'SITE_GEN.WORKBOOK.MY_FOLDERS\' | translate}}</h1><div class=\"nl-SideMenu__inner\"><div \nclass=\"nl-SideMenu__link\" ng-class=\"{\'nl-active\':menuType==\'MY_FOLDERS\'}\" ng-click=\"menuType=\'MY_FOLDERS\'\">\n{{\'SITE_GEN.WORKBOOK.SEE_MY_FOLDERS\' | translate}}</div><div class=\"nl-SideMenu__link\" \nng-class=\"{\'nl-active\':menuType==\'ADD_FOLDER\'}\" ng-click=\"menuType=\'ADD_FOLDER\'\">\n{{\'SITE_GEN.WORKBOOK.CREATE_FOLDER\' | translate}}</div></div></div></div></div><div \nclass=\"p-10 flex-100 flex-gt-xs-70\" ng-if=\"menuType==\'MY_RFPS\'\" \nng-include=\"\'app/main/sitegen/account/my_demande_devis/my_demande_devis.html\'\" \nng-controller=\"MyDemandeDevisController\"></div><div class=\"p-10 flex-100 flex-gt-xs-70\" ng-if=\"menuType==\'MY_CC\'\" \nng-include=\"\'app/main/sitegen/account/my_cahiers_charges/my_cahiers_charges.html\'\" \nng-controller=\"MyCahiersChargesController\"></div><div class=\"p-10 flex-100 flex-gt-xs-70\" \nng-if=\"menuType==\'CREATE_CC\'\" ng-include=\"\'app/main/sitegen/account/my_cahiers_charges/new_cahier_charges.html\'\" \nng-controller=\"MyCahiersChargesController\"></div><div class=\"p-10 flex-100 flex-gt-xs-70\" \nng-show=\"menuType==\'MY_SELECTION\'\" ng-include=\"\'app/main/sitegen/account/ma_selection/ma_selection_pure.html\'\" \nng-controller=\"maSelectionPureController\"></div><div class=\"p-10 flex-100 flex-gt-xs-70\" \nng-show=\"menuType==\'ADD_FOLDER\'\" ng-include=\"\'app/main/sitegen/account/folder/add_folder.html\'\" \nng-controller=\"AddFolderController\"></div><div class=\"p-10 flex-100 flex-gt-xs-70\" ng-if=\"menuType==\'MY_FOLDERS\'\" \nng-include=\"\'app/main/sitegen/account/folder/folders.html\'\" ng-controller=\"FoldersController\"></div><div \nclass=\"p-10 flex-100 flex-gt-xs-70\" ng-if=\"menuType==\'CREATE_DEMANDE_DEVIS\'\" \nng-include=\"\'app/main/sitegen/account/new_demande_devis/new_demande_devis.html\'\" \nng-controller=\"NewDemandeDevisController\"></div></div></div>");
$templateCache.put("app/main/sitegen/account/folder/add_folder.html","<div class=\"nl_Row-content\"><div class=\"nl--Container\"><div layout=\"row\" class=\"nl-Form-xs\"><form name=\"addFolderForm\" \nnovalidate ng-submit=\"addFolderForm.$valid && save()\" style=\"width:100%\"><fieldset \nclass=\"nl-Fieldset nl-Fieldset--noMarginTop\"><legend>{{\'SITE_GEN.CREATE_FOLDER\' | translate}}</legend>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"folder.name\" name=\"name\" \nrequired><label>{{\"SITE_GEN.FOLDER.NAME\" | translate}} *</label><div ng-messages=\"addFolderForm.name.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><button \nclass=\"nl-Stepper__btn centered\" type=\"submit\" ng-disabled=\"addFolderForm.$invalid\">\n{{\'SITE_GEN.FOLDER.SAVE\' | translate}}</button></fieldset></form></div></div></div>");
$templateCache.put("app/main/sitegen/account/folder/folders.html","<div class=\"content\"><div class=\"nl-Block nl-Block--table\"><div class=\"nl-loader\" ng-show=\"!loaded\"><div \nclass=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div \nclass=\"right\"><div class=\"half-circle\"></div></div></div></div></div><div layout=\"row\" style=\"padding:10px\"><table \ndatatable=\"ng\" dt-options=\"dtOptions\" ng-if=\"loaded\" dt-column-defs=\"dtColumnDefs\" class=\"dataTable row-border hover\">\n<thead><th translate=\"SITE_GEN.FOLDER.NAME\"></th><th translate=\"SITE_GEN.FOLDER.NB_COMPANIES\"></th><th \ntranslate=\"SITE_GEN.FOLDER.NB_ARTICLES\"></th><th translate=\"SITE_GEN.FOLDER.NB_RFP\"></th><th \ntranslate=\"SITE_GEN.FOLDER.NB_CC\"></th><th translate=\"SITE_GEN.FOLDER.ACTIONS\"></th></thead><tbody><tr \nng-repeat=\"cc in folders | orderBy: \'cc.name\' track by cc.id\"><td><div class=\"nl-Block--table--company\">{{cc.name}}\n</div></td><td><div class=\"nl-Block--table--company nl-tac\">{{cc.nbCompanies}}</div></td><td><div \nclass=\"nl-Block--table--company nl-tac\">{{cc.nbArticles}}</div></td><td><div class=\"nl-Block--table--company nl-tac\">\n{{cc.nbRfp}}</div></td><td><div class=\"nl-Block--table--company nl-tac\">{{cc.nbCc}}</div></td><td><md-button \ntype=\"button\" ng-click=\"details(cc.id)\" \nclass=\"nl-Btn nl-Btn-sm nl-Btn-primary nl-Btn--fab md-button md-default-theme md-ink-ripple\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"\"></md-icon></md-button><md-button type=\"button\" ng-click=\"deleteConfirm(cc.id)\" \nclass=\"nl-Btn nl-Btn-grey md-button nl-Btn-sm nl-Btn--fab md-default-theme md-ink-ripple\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/sitegen/account/ma_selection/ma_selection.html","<div class=\"nl-prestataire--page mt-20\"><div class=\"nl_Row-content\" \nstyle=\"padding-left: 0px!important;padding-right: 0px!important\"><div \nclass=\"nl-prestataire-search-item animated fadeIn\" layout=\"row\" layout-align=\"start start\" \nng-repeat=\"company in mySelectonOfProviders | orderBy: order: reverse track by company.id\"><div flex=\"75\" \nlayout=\"column\" class=\"pr-20\"><div><div class=\"nl-prestataire-search-item-title\">\n{{company.modelPattern}}{{ company.category != null ? \' - \' + company.category : \'\'}}{{ company.location != null ? \' - \' + company.location : \'\' }}\n</div><div class=\"nl-prestataire-search-item-subtitle\">\n{{company.category}} {{company.category != null ? (company.bedrooms ? \' | \' + company.bedrooms + \" bedrooms \": \'\') : (company.bedrooms ? company.bedrooms+ \" bedrooms \":\'\')}} {{company.category != null || company.bedrooms !=null ? (company.rooms ? \' | \' + company.rooms + \" meeting rooms \":\'\') : (company.rooms ? company.rooms+ \" meeting rooms \":\'\')}} {{company.category != null || company.bedrooms !=null || company.rooms !=null ? (company.maxTheatre ? \' | \' + company.maxTheatre + \" max capacity in theatre style \":\'\') : (company.maxTheatre ? company.maxTheatre+ \" max capacity in theatre style \":\'\')}}\n</div></div><div><div class=\"nl-prestataire-search-item-description pr-20\">{{company.resume | nlEllipsis: 1200}}</div>\n</div></div><div flex=\"25\" layout=\"column\" class=\"nl-prestataire-search-item-side\"><div \nclass=\"nl-prestataire-search-item-imgWrapper mb-15\" ng-if=\"company.logo != null && company.logo.length > 0\"><img \nclass=\"nl-prestataire-search-item-img nl-img--logo\" ng-src=\"{{URL.alternatedocroots + \'/\' + company.logo}}\" alt=\"\">\n</div><div class=\"nl-prestataire-search-item-imgWrapper mt-16\" \nng-if=\"company.photos != null && company.photos.length > 0\"><img class=\"nl-prestataire-search-item-img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + company.photos[0].location}}\" alt=\"\"></div><div class=\"mt-16\"><button \ntype=\"button\" class=\"nl-Item-button pr-20\" ng-click=\"details(company)\">{{\'SITE_GEN.BTN_PROVIDER_DETAILS\' | translate}}\n</button> <button type=\"button\" class=\"nl-Item-button md-red-200-bg mt-5 pr-20\" \nng-click=\"deleteFromSelection(company)\">{{\'SITE_GEN.BTN_PROVIDER_REMOVE_FROM_LIST\' | translate}}</button> <button \ntype=\"button\" class=\"nl-Item-button-warm mt-5\" ng-click=\"onAskForAQuotePure(company);\">\n{{\'SITE_GEN.BTN_ASK_FOR_A_QUOTE\' | translate}} >></button> <button type=\"button\" class=\"nl-Item-button mt-5\" \nng-click=\"openAddToAFolder(company.id)\">{{\'SITE_GEN.ADD_TO_FOLDER\' | translate}}</button></div></div></div></div></div>");
$templateCache.put("app/main/sitegen/account/ma_selection/ma_selection_pure.html","<div class=\"nl-prestataire--page mt-20\"><div class=\"nl_Row-content\" \nstyle=\"padding-left: 0px!important;padding-right: 0px!important\"><h3 class=\"nl-Title--pure\" \ntranslate=\"SITE_GEN.FOLDER.COMPANIES\"></h3><div ng-if=\"mySelectionOfProviders.length === 0\"><div \nclass=\"nl-prestataire-selection-item animated fadeIn\" layout=\"row\" layout-align=\"start center\"><div flex \nlayout=\"column\" class=\"pr-20\"><div><div class=\"nl-prestataire-search-item-title\">\n{{\'SITE_GEN.SELECTION.NO_COMPANY\' | translate}}</div></div></div></div></div><div \nng-if=\"mySelectionOfProviders.length > 0\" \nng-repeat=\"company in mySelectionOfProviders | orderBy: \'modelPattern\' track by company.id\"><div \nclass=\"nl-prestataire-selection-item animated fadeIn\" layout=\"row\" layout-align=\"start center\" \nng-click=\"goToCompany(company);$event.stopPropagation()\"><div flex layout=\"column\" class=\"pr-20\"><div><div \nclass=\"nl-prestataire-search-item-title\">{{company.modelPattern}}</div></div></div><div flex layout=\"row\" \nlayout-align=\"end center\" class=\"nl-prestataire-search-item-side animated fadeIn\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn-primary\" ng-click=\"addToFolder(company, \'company\');$event.stopPropagation()\">\n{{\'SITE_GEN.SELECTION.ADD\' | translate}}</button> <button type=\"button\" class=\"nl-Btn nl-Btn-grey ml-5\" \nng-click=\"removeFromLocalStorage(company.id, \'company\');$event.stopPropagation()\">\n{{\'SITE_GEN.SELECTION.REMOVE\' | translate}}</button></div></div></div><div class=\"mt-30\"><h3 class=\"nl-Title--pure\" \ntranslate=\"SITE_GEN.FOLDER.ARTICLES\"></h3></div><div ng-if=\"mySelectionOfArticles.length === 0\"><div \nclass=\"nl-prestataire-selection-item animated fadeIn\" layout=\"row\" layout-align=\"start center\"><div flex \nlayout=\"column\" class=\"pr-20\"><div><div class=\"nl-prestataire-search-item-title\">\n{{\'SITE_GEN.SELECTION.NO_ARTICLE\' | translate}}</div></div></div></div></div><div \nng-if=\"mySelectionOfArticles.length > 0\" \nng-repeat=\"article in mySelectionOfArticles | orderBy: \'modelPattern\' track by article.id\"><div \nclass=\"nl-prestataire-selection-item animated fadeIn\" layout=\"row\" layout-align=\"start center\" \nng-click=\"goToArticle(article);$event.stopPropagation()\"><div flex layout=\"column\" class=\"pr-20\"><div><div \nclass=\"nl-prestataire-search-item-title\">{{article.modelPattern}}</div></div></div><div flex layout=\"row\" \nlayout-align=\"end center\" class=\"nl-prestataire-search-item-side animated fadeIn\"><button type=\"button\" \nclass=\"nl-Btn nl-Btn-primary\" ng-click=\"addToFolder(article, \'article\');$event.stopPropagation()\">\n{{\'SITE_GEN.SELECTION.ADD\' | translate}}</button> <button type=\"button\" class=\"nl-Btn nl-Btn-grey ml-5\" \nng-click=\"removeFromLocalStorage(article.id, \'article\');$event.stopPropagation()\">\n{{\'SITE_GEN.SELECTION.REMOVE\' | translate}}</button></div></div></div></div></div>");
$templateCache.put("app/main/sitegen/account/my_cahiers_charges/my_cahiers_charges.html","<div class=\"content\"><div class=\"nl-Block nl-Block--table\"><div class=\"nl-loader\" ng-show=\"!loaded\"><div \nclass=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div \nclass=\"right\"><div class=\"half-circle\"></div></div></div></div></div><div layout=\"row\" style=\"padding:10px\" \nng-if=\"loaded\"><table datatable=\"ng\" dt-options=\"dtOptions\" dt-column-defs=\"dtColumnDefs\" \nclass=\"dataTable row-border hover\"><thead><th translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.NAME_CC\"></th><th width=\"20%\" \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.CREATION_DATE\"></th><th \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.START_DATE\"></th><th \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.END_DATE\"></th><th translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.ACTIONS\" \nstyle=\"text-align: center\"></th></thead><tbody><tr ng-repeat=\"cc in cahiersCharges track by cc.id\"><td><div \nclass=\"nl-Block--table--company\">{{cc.name}}</div></td><td>{{cc.creationDate | date : \'dd/MM/yy HH:mm\'}}</td><td>\n{{cc.dateStart | date : \'dd/MM/yy\'}}</td><td>{{cc.dateEnd | date : \'dd/MM/yy\'}}</td><td style=\"text-align: right\">\n<md-button ng-click=\"download(cc.id)\" ng-if=\"cc.type==\'PDF\'\" \nclass=\"nl-Btn nl-Btn-sm nl-Btn-primary md-button nl-Btn--fab md-default-theme md-ink-ripple\"><md-icon \nmd-font-icon=\"icon-download\" class=\"\"></md-icon></md-button><md-button ng-click=\"exportForm(null,cc,true)\" \nng-if=\"cc.type!=\'PDF\'\" class=\"nl-Btn nl-Btn-sm nl-Btn-primary md-button nl-Btn--fab md-default-theme md-ink-ripple\">\n<md-icon md-font-icon=\"icon-download\" class=\"\"></md-icon></md-button><md-button ng-click=\"editCC(cc)\" \nclass=\"nl-Btn nl-Btn-primary md-button nl-Btn-sm nl-Btn--fab md-default-theme md-ink-ripple\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"\"></md-icon></md-button><md-button ng-click=\"sendRFP(cc)\" \nclass=\"nl-Btn nl-Btn-primary md-button nl-Btn-sm nl-Btn--fab md-default-theme md-ink-ripple\"><md-icon \nmd-font-icon=\"icon-email\" class=\"\"></md-icon></md-button><md-button ng-click=\"duplicate(cc)\" \nclass=\"nl-Btn nl-Btn-primary md-button nl-Btn-sm nl-Btn--fab md-default-theme md-ink-ripple\"><md-icon \nmd-font-icon=\"icon-library-plus\" class=\"\"></md-icon></md-button><md-button ng-click=\"deleteConfirm(cc.id)\" \nclass=\"nl-Btn nl-Btn-grey md-button nl-Btn-sm nl-Btn--fab md-default-theme md-ink-ripple\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"\"></md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/sitegen/account/my_cahiers_charges/new_cahier_charges.html","<div layout=\"row\" class=\"nl-Stepper__inner\"><button class=\"nl-Stepper__box\" type=\"button\" \nng-class=\"{\'nl-Selected\': hadFile}\" ng-click=\"hadFile=true;generateCC=false;\"><div class=\"nl-Stepper__box__title\">\n{{\"SITE_GEN.WORKBOOK.ALREADY_CC_PDF\" | translate}}</div></button> <button class=\"nl-Stepper__box\" type=\"button\" \nng-class=\"{\'nl-Selected\': generateCC}\" ng-click=\"generateCC=true;hadFile=false;\"><div class=\"nl-Stepper__box__title\">\n{{\"SITE_GEN.WORKBOOK.CC_FORM\" | translate}}</div></button></div><div layout=\"row\" class=\"nl-Stepper__inner\"><div \nclass=\"nl-Stepper__underBox\" ng-if=\"hadFile\"><div class=\"nl-Stepper__underBox__title\">\n{{\"SITE_GEN.WORKBOOK.DOWNLOAD_CC_PDF\" | translate}}</div><form name=\"uploadForm\" novalidate><div><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"cahier.name\" name=\"name\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.NAME_CC\" | translate}} *</label><div ng-messages=\"uploadForm.name.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"cahier.dateStart\" name=\"dateStart\" required></md-datepicker><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.START_DATE\" | translate}} *</label><div \nng-messages=\"uploadForm.dateStart.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><md-datepicker \nclass=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" ng-model=\"cahier.dateEnd\" \nname=\"dateEnd\" required></md-datepicker><label>{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.END_DATE\" | translate}} *\n</label><div ng-messages=\"uploadForm.dateEnd.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.eventType\" name=\"eventType\" required><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TYPE\" | translate}} *</label><div \nng-messages=\"uploadForm.eventType.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"number\" class=\"\" \nng-model=\"cahier.numberOfParticipants\" name=\"numberOfParticipants\" required min=\"0\" step=\"1\"><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.NUMBER_OF_PARTICIPANTS\" | translate}} *</label><div \nng-messages=\"uploadForm.numberOfParticipants.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container></div><button type=\"button\" class=\"nl-Stepper__btn centered\" \nng-disabled=\"!uploadForm.$valid\" file-browser>{{\"SITE_GEN.WORKBOOK.DOWNLOAD\" | translate}}</button></form></div><div \nclass=\"nl-Stepper__underBox\" ng-if=\"generateCC\"><div class=\"nl_Row-content\"><div class=\"nl--Container\"><div \nlayout=\"row\" class=\"nl-Form-xs\"><div flex=\"100\"><div class=\"\"><form name=\"wizardStep2\" novalidate><div \nclass=\"flex-100\"><fieldset class=\"nl-Fieldset nl-Fieldset--noMarginTop flex-100\"><legend>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.APPLICANT_INFORMATIONS\" | translate}}</legend><label class=\"ml-5\">\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.LOGO\" | translate}}</label><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"nl-Input-container ml-15\" flex=\"50\"><input type=\"file\" \naccept=\"image/*\" id=\"logoRfp\" name=\"logo\"></md-input-container></div><md-input-container class=\"nl-Input-container\" \nflex=\"100\"><input type=\"text\" ng-model=\"cahier.applicantCompany\" name=\"applicantCompany\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantCompany.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.applicantCompanyType\" name=\"applicantCompanyType\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY_TYPE\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantCompanyType.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\">\n<input type=\"text\" ng-model=\"cahier.applicantWebSite\" name=\"applicantWebSite\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_WEB_SITE\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container\" flex=\"100\"><label>{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CIVILITY\' | translate}}\n</label><md-select palceholder=\"\" name=\"applicantCivility\" required ng-model=\"cahier.applicantCivility\" \nng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"civility in civilities | orderBy : \'toString()\' track by $index\" ng-value=\"civility\">{{civility}}\n</md-option></md-select><div ng-messages=\"wizardStep2.applicantCivility.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container class=\"nl-Input-container\" \nflex=\"100\"><input type=\"text\" ng-model=\"cahier.applicantFirstName\" name=\"applicantFirstName\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FIRST_NAME\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantFirstName.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.applicantLastName\" name=\"applicantLastName\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_LAST_NAME\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantLastName.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.applicantFunction\" name=\"applicantFunction\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FUNCTION\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantFunction.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.applicantAddress1\" name=\"applicantAddress1\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS1\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantAddress1.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\">\n<input type=\"text\" ng-model=\"cahier.applicantAddress2\" name=\"applicantAddress2\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS2\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.applicantAddress3\" name=\"applicantAddress3\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS3\"></label></md-input-container><div layout=\"row\" \nflex><md-input-container class=\"nl-Input-container\" flex=\"20\"><input type=\"text\" rows=\"1\" \nng-model=\"cahier.applicantPostCode\" name=\"applicantPostCode\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_POST_CODE\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantPostCode.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"40\"><input type=\"text\" rows=\"1\" \nng-model=\"cahier.applicantCity\" name=\"applicantCity\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CITY\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantCity.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"40\"><input type=\"text\" rows=\"1\" \nng-model=\"cahier.applicantCountry\" name=\"applicantCountry\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COUNTRY\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantCountry.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container></div><md-input-container class=\"nl-Input-container\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.applicantDirectPhone\" name=\"applicantDirectPhone\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_DIRECT_PHONE\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantDirectPhone.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\">\n<input type=\"text\" ng-model=\"cahier.applicantMobilePhone\" name=\"applicantMobilePhone\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_MOBILE_PHONE\"></label></md-input-container>\n<md-input-container ng-if=\"!user\" class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><input type=\"email\" \nng-model=\"cahier.applicantEmail\" name=\"applicantEmail\" ng-required=\"!user\"><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_EMAIL\" | translate}} *</label></md-input-container></fieldset></div>\n<div class=\"flex-100\"><fieldset class=\"nl-Fieldset nl-Fieldset--noMarginTop\" style=\"min-width: 100%\"><legend>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.EVENT_INFORMATIONS\" | translate}}</legend><md-input-container \nclass=\"nl-Input-container\" flex=\"100\"><input type=\"text\" ng-model=\"cahier.name\" name=\"name\" required><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.NAME_CC\" | translate}} *</label><div ng-messages=\"wizardStep2.name.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container\" flex=\"100\"><input type=\"text\" ng-model=\"cahier.eventTitle\" name=\"eventTitle\" required>\n<label>{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TITLE\" | translate}} *</label><div \nng-messages=\"wizardStep2.eventTitle.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.eventType\" name=\"eventType\" required><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TYPE\" | translate}} *</label><div \nng-messages=\"wizardStep2.eventType.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\"><input type=\"number\" class=\"\" \nng-model=\"cahier.numberOfParticipants\" name=\"numberOfParticipants\" required min=\"0\" step=\"1\"><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.NUMBER_OF_PARTICIPANTS\" | translate}} *</label><div \nng-messages=\"wizardStep2.numberOfParticipants.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><div layout=\"row\" flex class=\"mt-10\"><md-input-container class=\"nl-Input-container\" \nflex=\"50\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" \nng-model=\"cahier.dateStart\" name=\"dateStart\" required></md-datepicker><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.START_DATE\" | translate}} *</label><div \nng-messages=\"wizardStep2.dateStart.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container\" flex=\"50\"><md-datepicker \nclass=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" ng-model=\"cahier.dateEnd\" \nname=\"dateEnd\" required></md-datepicker><label>{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.END_DATE\" | translate}} *\n</label><div ng-messages=\"wizardStep2.dateEnd.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container></div><md-input-container \nclass=\"nl-Input-container nl-Input-container--wrap nl-Input-container--marged\" flex=\"100\" \nstyle=\"margin-top: 4.1rem !important\"><md-select md-on-open=\"\" md-no-asterisk name=\"desiredActivities \" \nmultiple=\"multiple\" required ng-model=\"cahier.desiredActivities\" ng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"desiredActivitiy in desiredActivities track by $index\" ng-value=\"desiredActivitiy.name\">\n{{desiredActivitiy.name}}</md-option></md-select><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.DESIRED_ACTIVITIES\" | translate}} *</label><div \nng-messages=\"wizardStep2.desiredActivities.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\">\n<input type=\"number\" ng-model=\"cahier.roomNumber\" name=\"roomNumber\" min=\"0\" step=\"1\"><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_NUMBER\" | translate}}</label></md-input-container><md-input-container \nclass=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><input type=\"number\" \nng-model=\"cahier.roomCapacityMax\" name=\"roomCapacityMax\" min=\"0\" step=\"1\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_CAPACITY_MAX\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><md-select md-on-open=\"\" name=\"desiredConfiguration \" \nng-model=\"cahier.desiredConfiguration\" ng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"desiredConfiguration in desiredConfigurations | orderBy : \'toString()\' track by $index\" \nng-value=\"desiredConfiguration\">{{desiredConfiguration}}</md-option></md-select><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.CONFIGURATION\"></label></md-input-container><div layout=\"row\" flex \nclass=\"mt-16 mb-16\"><md-input-container class=\"nl-Input-container\" flex=\"60\"><input type=\"number\" \nng-model=\"cahier.square\" name=\"square\"><label translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE\"></label>\n</md-input-container><md-input-container class=\"nl-Input-container\" flex=\"40\"><md-select md-on-open=\"\" \nname=\"squareUnit\" ng-required=\"cahier.square\" ng-model=\"cahier.squareUnit\" ng-model-options=\"{\'trackBy\': \'$value\'}\">\n<md-option ng-repeat=\"squareUnit in squareUnits | orderBy : \'toString()\' track by $index\" ng-value=\"squareUnit\">\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.SQUARE_UNITS.\' + squareUnit | translate}}</md-option></md-select><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE_UNIT\"></label><div ng-messages=\"wizardStep2.squareUnit.$error\">\n<span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"cahier.technicalEquipment\" name=\"technicalEquipment\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.TECHNICAL_EQUIPMENT\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"cahier.precisiontoTheHotel\" name=\"precisiontoTheHotel\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_HOTEL\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"cahier.precisiontoTheEventPlace\" name=\"precisiontoTheEventPlace\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_EVENT_PLACE\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"cahier.precisionForTheReceptive\" name=\"precisionForTheReceptive\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_RECEPTIVE\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"cahier.precisionForTheCarrier\" name=\"precisionForTheCarrier\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_CARRIER\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"cahier.otherPrecision\" name=\"otherPrecision\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.OTHER_PRECISION\"></label></md-input-container></fieldset></div><div \nlayout=\"row\" layout-align=\"space-between center\"><button class=\"nl-Stepper__btn flex-45\" \nng-click=\"exportForm(wizardStep2,null,wizardStep2.$valid)\">{{\"SITE_GEN.WORKBOOK.EXPORT\" | translate}}</button> <button \nclass=\"nl-Stepper__btn flex-45\" ng-click=\"generateFromForm(wizardStep2,wizardStep2.$valid)\">\n{{\"SITE_GEN.WORKBOOK.VALIDATE_CC\" | translate}}</button></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/main/sitegen/account/my_demande_devis/my_demande_devis.html","<div class=\"content\"><div ng-if=\"ccSend\" class=\"nl-note\">{{\'GENERAL.TOASTR.CC_SEND_SUCCESS\'| translate}}</div><div \nclass=\"nl-Block nl-Block--table\"><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div \nclass=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\">\n</div></div></div></div></div><div layout=\"row\"><table nl-responsive-table nl-table-data=\"arrayData\" \nclass=\"dataTable row-border hover\"><thead><th translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.NAME_CC\"></th><th \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.PROVIDERS\"></th><th translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.SEND_ON\"></th>\n</thead><tbody><tr ng-if=\"requestForProposals\" \nng-repeat=\"rfp in requestForProposals | orderBy: \'cahierDeCharges.name\' as arrayData\"><td><div \nclass=\"nl-Block--table--company\">{{ rfp.cahierDeCharges ? rfp.cahierDeCharges.name : \'\' }}</div></td><td><div \nng-repeat=\"comp in rfp.companies\" class=\"nl-Block--table--company\">{{ comp.pattern }}</div></td><td>\n{{rfp.creationDate | date : \'dd/MM/yy HH:mm\'}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/sitegen/account/new_demande_devis/new_demande_devis.html","<div class=\"nl_Row-content\"><ms-form-wizard class=\"nl-Stepper\" flex style=\"margin:0 !important\"><md-tabs \nclass=\"nl-Stepper__inner\" md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" \nng-init=\"setWizard(msWizard)\"><md-tab><md-tab-label><span class=\"nl-Stepper__header ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\">1</span><span class=\"ms-form-wizard-step-text\">\n{{\"SITE_GEN.WORKBOOK.WRITE_CC\" | translate}}</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nms-form-wizard-form novalidate><div layout=\"row\"><button class=\"nl-Stepper__box\" type=\"button\" \nng-class=\"{\'nl-Selected\': hadFile}\" ng-click=\"hadFile=true;generateCC=false;hadCC=false\"><div \nclass=\"nl-Stepper__box__title\">{{\"SITE_GEN.WORKBOOK.ALREADY_CC_PDF\" | translate}}</div></button> <button \nclass=\"nl-Stepper__box\" type=\"button\" ng-class=\"{\'nl-Selected\': generateCC}\" \nng-click=\"generateCC=true;hadFile=false;hadCC=false\"><div class=\"nl-Stepper__box__title\">\n{{\"SITE_GEN.WORKBOOK.CC_FORM\" | translate}}</div></button> <button class=\"nl-Stepper__box\" type=\"button\" \nng-class=\"{\'nl-Selected\': hadCC}\" ng-click=\"hadCC=true;hadFile=false;generateCC=false;\"><div \nclass=\"nl-Stepper__box__title\">{{\"SITE_GEN.WORKBOOK.ALREADY_CC_EXISTANT\" | translate}}</div></button></div><div \nlayout=\"row\"><div class=\"nl-Stepper__underBox\" ng-if=\"hadFile\"><div class=\"nl-Stepper__underBox__title\">\n{{\"SITE_GEN.WORKBOOK.DOWNLOAD_CC_PDF\" | translate}}</div><div><md-input-container class=\"nl-Input-container ml-15\" \nflex=\"100\"><input type=\"text\" ng-model=\"requestForProposal.name\" name=\"name\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.NAME_CC\" | translate}} *</label><div ng-messages=\"wizardStep2.name.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"requestForProposal.dateStart\" name=\"dateStart\" required></md-datepicker><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.START_DATE\" | translate}} *</label><div \nng-messages=\"wizardStep2.dateStart.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><md-datepicker \nclass=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" \nng-model=\"requestForProposal.dateEnd\" name=\"dateEnd\" required></md-datepicker><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.END_DATE\" | translate}} *</label><div \nng-messages=\"wizardStep2.dateEnd.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"requestForProposal.eventType\" name=\"eventType\" required><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TYPE\" | translate}} *</label><div \nng-messages=\"wizardStep2.eventType.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"number\" class=\"\" \nng-model=\"requestForProposal.numberOfParticipants\" name=\"numberOfParticipants\" required min=\"0\" step=\"1\"><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.NUMBER_OF_PARTICIPANTS\" | translate}} *</label><div \nng-messages=\"wizardStep2.numberOfParticipants.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container></div><button type=\"button\" class=\"nl-Stepper__btn centered\" \nng-disabled=\"!wizardStep2.$valid\" file-browser>{{\"SITE_GEN.WORKBOOK.DOWNLOAD\" | translate}}</button></div><div \nclass=\"nl-Stepper__underBox\" ng-if=\"generateCC\"><div class=\"nl-Stepper__underBox__title\">\n{{\"SITE_GEN.WORKBOOK.FORM\" | translate}}</div><div class=\"nl--Container\"><div layout=\"row\" class=\"nl-Form-xs\"><div \nflex=\"100\"><div><div class=\"flex-100\"><fieldset class=\"nl-Fieldset nl-Fieldset--noMarginTop\"><legend>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.APPLICANT_INFORMATIONS\" | translate}}</legend><label class=\"ml-5\">\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.LOGO\" | translate}}</label><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"nl-Input-container ml-15\" flex=\"50\"><input type=\"file\" \naccept=\"image/*\" id=\"logoRfp\" name=\"logo\"></md-input-container></div><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"requestForProposal.applicantCompany\" \nname=\"applicantCompany\" required><label>{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY\" | translate}} *\n</label><div ng-messages=\"wizardStep2.applicantCompany.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"requestForProposal.applicantCompanyType\" \nname=\"applicantCompanyType\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY_TYPE\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantCompanyType.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\">\n<input type=\"text\" ng-model=\"requestForProposal.applicantWebSite\" name=\"applicantWebSite\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_WEB_SITE\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><label>\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CIVILITY\' | translate}}</label><md-select name=\"applicantCivility\" \nrequired ng-model=\"requestForProposal.applicantCivility\" ng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"civility in civilities | orderBy : \'toString()\' track by $index\" ng-value=\"civility\">{{civility}}\n</md-option></md-select><div ng-messages=\"wizardStep2.applicantCivility.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"requestForProposal.applicantFirstName\" \nname=\"applicantFirstName\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FIRST_NAME\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantFirstName.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"requestForProposal.applicantLastName\" name=\"applicantLastName\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_LAST_NAME\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantLastName.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"requestForProposal.applicantFunction\" name=\"applicantFunction\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FUNCTION\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantFunction.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"requestForProposal.applicantAddress1\" name=\"applicantAddress1\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS1\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantAddress1.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\">\n<input type=\"text\" ng-model=\"requestForProposal.applicantAddress2\" name=\"applicantAddress2\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS2\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><input type=\"text\" \nng-model=\"requestForProposal.applicantAddress3\" name=\"applicantAddress3\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS3\"></label></md-input-container><div layout=\"row\" \nflex><md-input-container class=\"nl-Input-container ml-15\" flex=\"20\"><input type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.applicantPostCode\" name=\"applicantPostCode\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_POST_CODE\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantPostCode.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"40\"><input type=\"text\" \nrows=\"1\" ng-model=\"requestForProposal.applicantCity\" name=\"applicantCity\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CITY\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantCity.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"40\"><input type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.applicantCountry\" name=\"applicantCountry\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COUNTRY\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantCountry.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container></div><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"requestForProposal.applicantDirectPhone\" name=\"applicantDirectPhone\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_DIRECT_PHONE\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantDirectPhone.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\">\n<input type=\"text\" ng-model=\"requestForProposal.applicantMobilePhone\" name=\"applicantMobilePhone\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_MOBILE_PHONE\"></label></md-input-container>\n<md-input-container ng-if=\"!user\" class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><input type=\"email\" \nng-model=\"requestForProposal.applicantEmail\" name=\"applicantEmail\" ng-required=\"!user\"><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_EMAIL\" | translate}} *</label></md-input-container></fieldset></div>\n<div class=\"flex-100\"><fieldset class=\"nl-Fieldset nl-Fieldset--noMarginTop\"><legend>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.EVENT_INFORMATIONS\" | translate}}</legend><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"requestForProposal.name\" name=\"name\" required>\n<label>{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.NAME_CC\" | translate}} *</label><div ng-messages=\"wizardStep2.name.$error\">\n<span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"requestForProposal.eventTitle\" \nname=\"eventTitle\" required><label>{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TITLE\" | translate}} *</label><div \nng-messages=\"wizardStep2.eventTitle.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"requestForProposal.eventType\" name=\"eventType\" required><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TYPE\" | translate}} *</label><div \nng-messages=\"wizardStep2.eventType.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"number\" class=\"\" \nng-model=\"requestForProposal.numberOfParticipants\" name=\"numberOfParticipants\" required min=\"0\" step=\"1\"><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.NUMBER_OF_PARTICIPANTS\" | translate}} *</label><div \nng-messages=\"wizardStep2.numberOfParticipants.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><div layout=\"row\" flex class=\"mt-10\"><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"50\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"requestForProposal.dateStart\" name=\"dateStart\" required></md-datepicker><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.START_DATE\" | translate}} *</label><div \nng-messages=\"wizardStep2.dateStart.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"50\"><md-datepicker \nclass=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" \nng-model=\"requestForProposal.dateEnd\" name=\"dateEnd\" required></md-datepicker><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.END_DATE\" | translate}} *</label><div \nng-messages=\"wizardStep2.dateEnd.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container></div><md-input-container \nclass=\"nl-Input-container nl-Input-container--wrap nl-Input-container--marged\" flex=\"100\"><md-select md-on-open=\"\" \nmd-no-asterisk name=\"desiredActivities \" multiple=\"multiple\" required ng-model=\"requestForProposal.desiredActivities\" \nng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option ng-repeat=\"desiredActivitiy in desiredActivities track by $index\" \nng-value=\"desiredActivitiy.name\">{{desiredActivitiy.name}}</md-option></md-select><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.DESIRED_ACTIVITIES\" | translate}} *</label><div \nng-messages=\"wizardStep2.desiredActivities.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"number\" \nng-model=\"requestForProposal.roomNumber\" name=\"roomNumber\" min=\"0\" step=\"1\"><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_NUMBER\" | translate}}</label></md-input-container><md-input-container \nclass=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><input type=\"number\" \nng-model=\"requestForProposal.roomCapacityMax\" name=\"roomCapacityMax\" min=\"0\" step=\"1\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_CAPACITY_MAX\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><md-select md-on-open=\"\" name=\"desiredConfiguration \" \nng-model=\"requestForProposal.desiredConfiguration\" ng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"desiredConfiguration in desiredConfigurations | orderBy : \'toString()\' track by $index\" \nng-value=\"desiredConfiguration\">{{desiredConfiguration}}</md-option></md-select><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.CONFIGURATION\"></label></md-input-container><div layout=\"row\" flex \nclass=\"mt-16 mb-16\"><md-input-container class=\"nl-Input-container ml-15\" flex=\"60\"><input type=\"number\" \nng-model=\"requestForProposal.square\" name=\"square\"><label translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE\">\n</label></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"40\"><md-select md-on-open=\"\" \nname=\"squareUnit\" ng-required=\"requestForProposal.square\" ng-model=\"requestForProposal.squareUnit\" \nng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"squareUnit in squareUnits | orderBy : \'toString()\' track by $index\" ng-value=\"squareUnit\">\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.SQUARE_UNITS.\' + squareUnit | translate}}</md-option></md-select><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE_UNIT\"></label><div ng-messages=\"wizardStep2.squareUnit.$error\">\n<span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.technicalEquipment\" name=\"technicalEquipment\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.TECHNICAL_EQUIPMENT\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.precisiontoTheHotel\" name=\"precisiontoTheHotel\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_HOTEL\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.precisiontoTheEventPlace\" name=\"precisiontoTheEventPlace\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_EVENT_PLACE\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.precisionForTheReceptive\" name=\"precisionForTheReceptive\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_RECEPTIVE\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.precisionForTheCarrier\" name=\"precisionForTheCarrier\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_CARRIER\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container nl-Input-container--marged\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"requestForProposal.otherPrecision\" name=\"otherPrecision\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.OTHER_PRECISION\"></label></md-input-container></fieldset></div><div \nlayout=\"row\" layout-align=\"space-between center\"><button class=\"nl-Stepper__btn flex-45\" \nng-click=\"exportForm(msWizard,wizardStep2.$valid)\">{{\"SITE_GEN.WORKBOOK.EXPORT\" | translate}}</button> <button \nclass=\"nl-Stepper__btn flex-45\" ng-click=\"validateStepTwo(\'FORMULAIRE\',msWizard,wizardStep2.$valid)\">\n{{\"SITE_GEN.WORKBOOK.VALIDATE_CC\" | translate}}</button></div></div></div></div></div></div><div \nclass=\"nl-Stepper__underBox\" ng-if=\"hadCC\"><div class=\"nl-Stepper__underBox__title\">\n{{\"SITE_GEN.WORKBOOK.SELECT_CC_TO_SEND\" | translate}}</div><md-input-container class=\"nl-Input-container ml-15\" \nflex=\"100\" ng-if=\"listCCExistant && listCCExistant.length>0\"><md-select required name=\"selectedCC\" \nng-model=\"requestForProposal.selectedCC\" ng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"cc in listCCExistant | orderBy:\'name\'\" ng-value=\"cc.id\">{{cc.name}}</md-option></md-select><div \nng-messages=\"wizardStep2.selectedCC.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><div style=\"text-align: center\" ng-if=\"!listCCExistant || listCCExistant.length==0\">\n{{\"SITE_GEN.WORKBOOK.NO_CC\" | translate}}</div><button ng-if=\"listCCExistant && listCCExistant.length>0\" \nclass=\"nl-Stepper__btn centered\" ng-disabled=\"!wizardStep2.$valid\" ng-click=\"validateStepTwo(\'EXISTANT\',msWizard)\">\n{{\"SITE_GEN.WORKBOOK.NEXT\" | translate}}</button></div></div></form></md-tab-body></md-tab><md-tab \nng-disabled=\" wizardStep2.$invalid || (!stepTwoOk)\"><md-tab-label><span \nclass=\"nl-Stepper__header ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">2</span>\n<span class=\"ms-form-wizard-step-text\">{{\"SITE_GEN.WORKBOOK.SELECT_PROVIDERS\" | translate}}</span></span>\n</md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form novalidate><div class=\"nl-Stepper__underBox\">\n<div class=\"nl-Stepper__underBox__title\">{{\"SITE_GEN.WORKBOOK.CHOOSE_PROVIDERS\" | translate}}</div><div \nlayout=\"column\"><md-checkbox class=\"nl-Form__checkbox\" ng-repeat=\"comp in mySelectionOfProviders\" \nng-model=\"comp.toSend\">{{comp.modelPattern}}</md-checkbox></div><div class=\"mt-15\"><button \nng-if=\"mySelectionOfProviders && mySelectionOfProviders.length>0\" class=\"nl-Stepper__btn centered\" \nng-click=\"sendRFP()\">{{\"SITE_GEN.WORKBOOK.SEND\" | translate}}</button></div></div></form></md-tab-body></md-tab>\n</md-tabs></ms-form-wizard></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/article.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-prestataire-search--slick\" \nng-if=\"article.photos && article.photos.length > 0\"><div class=\"nl_slick--wrapper\"><button type=\"button\" \nng-click=\"_articleSlickConfig.method.slickPrev()\" class=\"nl_slick--button\"><img \nsrc=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"_articleSlickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button-right\"><img \nsrc=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick settings=\"_articleSlickConfig\" style=\"height: 400px\">\n<div class=\"nl_slick--slide\" ng-repeat=\"_photo in article.photos\"><img class=\"nl_slick--slide--img\" \nng-src=\"{{_photo.url}}\" alt=\"\"></div></slick></div></div><div layout=\"row\" class=\"nl-prestataire-search-item\"><div \nflex=\"70\" class=\"pr-20\"><div layout=\"column\"><div class=\"nl-titre--main nl--item\">{{article.name}}</div><div><div \nclass=\"nl-prestataire-search-item-description ql-editor\" ng-bind-html=\"trustAsHtml(article.content)\"></div></div></div>\n</div><div flex=\"30\" class=\"nl-prestataire-search-item-side\"><div layout=\"column\"><div \nclass=\"nl-prestataire-search-detail-aside\"><div class=\"nl-prestataire-search-item-title title--panel\">Date:</div><div \nclass=\"nl-prestataire-search-item-text mb-10\">{{\'GENERAL.DATE_FORMAT\' | translate: {date:article.dateStart} }}</div>\n</div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/bloc.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"SITES_MANAGEMENT.BLOCS.ADD\" \nng-if=\"!bloc.id\"></div><div class=\"\" translate=\"SITES_MANAGEMENT.BLOCS.MAJ\" ng-if=\"bloc.id\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"button\" class=\"\" ng-click=\"_blocsListFn()\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon>{{\'SITES_MANAGEMENT.BLOCS.LIST\' | translate}}</md-button><md-button \ntype=\"button\" class=\"\" ng-click=\"_delete()\" ng-if=\"bloc.id\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>\n{{\'SITES_MANAGEMENT.ACTIONS.DELETE\' | translate}}</md-button><md-button type=\"button\" class=\"\" \nng-click=\"_save(blocForm)\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n{{\'SITES_MANAGEMENT.ACTIONS.SAVE\' | translate}}</md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp p-40\"><div layout=\"column\"><form name=\"blocForm\" class=\"md-inline-form\" novalidate>\n<md-input-container class=\"\"><input type=\"text\" name=\"name\" ng-model=\"bloc.name\" \nplaceholder=\"{{\'SITES_MANAGEMENT.BLOCS.FIELDS.NAME\' | translate}}\" required><div class=\"\" \nng-messages=\"blocForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"\"><md-select name=\"type\" ng-model=\"bloc.type\" \nplaceholder=\"{{\'SITES_MANAGEMENT.BLOCS.FIELDS.TYPE\' | translate}}\" required ng-change=\"getBloc()\"><md-option \nng-repeat=\"_thisType in types | orderBy : \'translation\' track by $index\" ng-value=\"_thisType.value\" \nng-selected=\"_thisType.value == bloc.type\">{{_thisType.translation | translate}}</md-option></md-select><div class=\"\" \nng-messages=\"blocForm.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"\"><textarea name=\"html\" ng-model=\"bloc.html\" \nrows=\"20\" placeholder=\"{{\'SITES_MANAGEMENT.BLOCS.FIELDS.HTML\' | translate}}\" required>\n                            <div\n class=\"\" ng-messages=\"blocForm.html.$error\" role=\"alert\">\n                                <div ng-message=\"required\">\n                                    <span>{{\"GENERAL.REQUIRED\" | translate}}</span>\n                                \n</div>\n                            </div>\n                        </md-input-container>\n\n                    </form>\n\n    \n                </div>\n    \n            </div>\n    \n        </div>\n        \n    \n    </div>");
$templateCache.put("app/main/sites_management/blocs/bloc/blog.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-Blog\"><div layout=\"row\"><div flex=\"50\"><div class=\"nl-Blog-news\" \nng-repeat=\"news in lastNews track by news.id\" ng-if=\"$index == 0\" \nng-click=\"details(\'{{{PAGE_NAME_ARTICLE}}}\', news.id)\"><div class=\"nl-Blog-news-imgWrapper\"><div \nclass=\"nl-Blog-news-backdrop\"></div><img ng-if=\"news.photos == null || news.photos.length === 0\" \nclass=\"nl-Blog-news-img\" src=\"assets/images/slick/1.jpg\" alt=\"\"> <img \nng-if=\"news.photos != null && news.photos.length > 0\" class=\"nl-Blog-news-img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + news.photos[0].location}}\" alt=\"\"><div class=\"nl-Blog-news-infos\"><div \nclass=\"nl-Blog-news-title\">{{news.name}}</div><div class=\"nl-Blog-news-date\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-calendar-blank\" class=\"s14 mr-5\"></md-icon><div class=\"nl-Blog-news-date-value\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date: news.dateStart} }}</div></div></div></div></div></div><div flex=\"50\"><div \nlayout=\"row\" layout-align=\"start start\" layout-wrap><div flex=\"50\" class=\"nl-Blog-news nl-Blog-news--sm\" \nng-repeat=\"news in lastNews track by news.id\" ng-if=\"$index > 0 && $index <= 4\" \nng-click=\"details(\'{{{PAGE_NAME_ARTICLE}}}\', news.id)\"><div class=\"nl-Blog-news-imgWrapper\"><div \nclass=\"nl-Blog-news-backdrop\"></div><img ng-if=\"news.photos == null || news.photos.length === 0\" \nclass=\"nl-Blog-news-img\" src=\"assets/images/slick/1.jpg\" alt=\"\"> <img \nng-if=\"news.photos != null && news.photos.length > 0\" class=\"nl-Blog-news-img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + news.photos[0].location}}\" alt=\"\"><div class=\"nl-Blog-news-infos\"><div \nclass=\"nl-Blog-news-title\">{{news.name}}</div><div class=\"nl-Blog-news-date\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-calendar-blank\" class=\"s14 mr-5\"></md-icon><div class=\"nl-Blog-news-date-value\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date:news.dateStart} }}</div></div></div></div></div></div></div></div><div \nclass=\"nl-Blog-list\" layout=\"column\" layout-align=\"start start\" infinite-scroll=\"loadMoreArticles()\" \ninfinite-scroll-disabled=\"infiniteScrollPrevent\"><div class=\"nl-Blog-list-item\" layout=\"row\" \nlayout-align=\"start start\" ng-repeat=\"news in newsArray track by news.id\" \nng-click=\"details(\'{{{PAGE_NAME_ARTICLE}}}\', news.id)\"><div class=\"mr-20\"><div class=\"nl-Blog-list-imgWrapper\"><img \nng-if=\"news.photos == null || news.photos.length === 0\" class=\"nl-Blog-news-img\" src=\"assets/images/slick/1.jpg\" \nalt=\"\"> <img ng-if=\"news.photos != null && news.photos.length > 0\" class=\"nl-Blog-news-img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + news.photos[0].location}}\" alt=\"\"></div></div><div flex><div \nclass=\"nl-Blog-list-title\">{{news.name}}</div><div class=\"nl-Blog-list-date\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-calendar-blank\" class=\"s14 mr-5\"></md-icon><div class=\"nl-Blog-news-date-value\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date: news.dateStart} }}</div></div></div><div \nclass=\"nl-Blog-list-description ql-editor\" ng-bind-html=\"trustAsHtml(news.content | nlEllipsis: 400)\"></div></div>\n</div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/carousel.template.type.html","<div class=\"nl_slick--wrapper\"><button type=\"button\" ng-click=\"hideSlider()\" class=\"nl_slick--button--close\"><i \nclass=\"nl_slick--button--icon icon-close\"></i></button> <button type=\"button\" \nng-click=\"slickConfig.method.slickPrev()\" class=\"nl_slick--button nl_slick--button--sm\"><img \nsrc=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"slickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button--sm nl_slick--button-right\"><img \nsrc=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick settings=\"slickConfig\" class=\"nl_slick\"><div \nclass=\"nl_slick--slide\"><iframe width=\"100%\" height=\"100%\" \nsrc=\"https://www.youtube.com/embed/8rjRh4J0VJI?rel=0&amp;controls=0&amp;showinfo=0&amp;start=14&amp;autoplay=1\" \nframeborder=\"0\" allow=\"autoplay; encrypted-media\"></iframe><div class=\"nl_slick-title\">Liban le royaume du soleil</div>\n</div><div class=\"nl_slick--slide\"><img class=\"nl_slick--slide--img\" src=\"assets/images/slick/1.jpg\" alt=\"\"></div><div \nclass=\"nl_slick--slide\"><img class=\"nl_slick--slide--img\" src=\"assets/images/slick/2.jpg\" alt=\"\"></div></slick></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/company.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-prestataire-search--slick\" \nng-if=\"company.photos && company.photos.length > 0\"><div class=\"nl_slick--wrapper\"><button type=\"button\" \nng-click=\"_companySlickConfig.method.slickPrev()\" class=\"nl_slick--button nl_slick--button--sm\"><img \nsrc=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"_companySlickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button--sm nl_slick--button-right\">\n<img src=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick settings=\"_companySlickConfig\" \nstyle=\"height: 400px\"><div class=\"nl_slick--slide\" ng-repeat=\"_photo in company.photos\"><img \nclass=\"nl-relArticle__img\" ng-src=\"{{_photo.url}}\" alt=\"\"></div></slick></div></div><div layout=\"row\" class=\"mt-50\">\n<div flex=\"70\"><div class=\"nl-titre--main nl--item--bigger\">\n{{company.modelPattern}} {{company.category != null ? \' - \' + company.category : \'\'}}</div><div class=\"nl-text--main\" \nng-if=\"searchValueById(3);\">Company Activity - {{searchValueById(3);}}</div></div><div flex=\"30\"><div \nclass=\"nl-prestataire-search-item-logoWrapper\"><img ng-if=\"company.logo == null || company.logo.length === 0\" \nclass=\"nl-prestataire-search-item-img nl-img--logo\" src=\"assets/images/slick/1.jpg\" alt=\"\"> <img \nng-if=\"company.logo != null && company.logo.length > 0\" class=\"nl-prestataire-search-item-img nl-img--logo\" \nng-src=\"{{URL.alternatedocroots + \'/\' + company.logo}}\" alt=\"\"></div></div></div><div id=\"anchor--informations\" \nlayout=\"row\" class=\"nl-prestataire-search-item item-2\"><div \nflex=\"{{ company.contactFavourite != null && company.contactFavourite.valuedFields != null ? \'70\' : \'100\' }}\"><div \nclass=\"nl-prestataire-search-item-maintitle\">Main information</div><div layout=\"column\" class=\"p-20\"><div \nclass=\"mb-25 mt-10\"><div layout=\"row\" layout-align=\"start center\" ng-if=\"company.website != null\"><div \nclass=\"nl-prestataire-search-item-strong\"><b>Website :</b></div><div class=\"nl-prestataire-search-item-text\"><a \nng-href=\"http://{{company.website}}\" target=\"_blank\">{{company.website}}</a></div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">Phone :</div><div \nclass=\"nl-prestataire-search-item-text\">{{searchValueById(4)}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">Email :</div><div \nclass=\"nl-prestataire-search-item-text\">{{searchValueById(6)}}</div></div><div class=\"p-20\" \nng-if=\"company.category || company.bedrooms || company.rooms || company.maxTheatre\"><table \nclass=\"dataTable row-border nl-Tablegit nl-Table--center nl-prestataire-table nl-prestataire-table--common\"><tr><th \nng-if=\"company.category\">Star Rating</th><th ng-if=\"company.bedrooms\">Bedrooms</th><th ng-if=\"company.rooms\">\nMeeting Rooms</th><th ng-if=\"company.maxTheatre\">Max. Theatre</th></tr><tr><td ng-if=\"company.category\">\n{{company.category}}</td><td ng-if=\"company.bedrooms\">{{company.bedrooms}}</td><td ng-if=\"company.rooms\">\n{{company.rooms}}</td><td ng-if=\"company.maxTheatre\">{{company.maxTheatre ? company.maxTheatre + \' pax\' : \'\'}}</td>\n</tr></table></div><div layout=\"row\" layout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\nAddress :</div><div class=\"nl-prestataire-search-item-text\"><span \nng-if=\"searchValueById(8) && searchValueById(8).length>0\">{{searchValueById(8)}}</span> <span \nng-if=\"searchValueById(9) && searchValueById(9).length>0\">,&nbsp;{{searchValueById(9)}}</span> <span \nng-if=\"searchValueById(10) && searchValueById(10).length>0\">,&nbsp;{{searchValueById(10)}}</span> <span \nng-if=\"searchValueById(11) && searchValueById(11).length>0\">,&nbsp;{{searchValueById(11)}}</span> <span \nng-if=\"searchValueById(12) && searchValueById(12).length>0\">,&nbsp;{{searchValueById(12)}}</span> <span \nng-if=\"searchValueById(13) && searchValueById(13).length>0\">,&nbsp;{{searchValueById(13)}}</span> <span \nng-if=\"searchValueById(14) && searchValueById(14).length>0\">,&nbsp;{{searchValueById(14)}}</span></div></div><div \nlayout=\"row\" layout-align=\"start center\" ng-if=\"searchValueById(36) != null && searchValueById(36).length>0\"><div \nclass=\"nl-prestataire-search-item-strong\">Creation :</div><div class=\"nl-prestataire-search-item-text\">\n{{searchValueById(36)}}</div></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"searchValueById(37) != null && searchValueById(37).length>0\"><div class=\"nl-prestataire-search-item-strong\">\nLast refurbishment :</div><div class=\"nl-prestataire-search-item-text\">{{searchValueById(37)}}</div></div><div \nlayout=\"row\" layout-align=\"start center\" ng-if=\"searchValueById(49) != null && searchValueById(49).length>0\"><div \nclass=\"nl-prestataire-search-item-strong\">Spoken Languages by the sales Department :</div><div \nclass=\"nl-prestataire-search-item-text\">{{searchValueById(49)}}</div></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"searchValueById(48) != null && searchValueById(48).length>0\"><div \nclass=\"nl-prestataire-search-item-strong\">Agency specialized in :</div><div class=\"nl-prestataire-search-item-text\">\n{{searchValueById(48)}}</div></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"searchValueById(94) != null && searchValueById(94).length>0\"><div class=\"nl-prestataire-search-item-strong\">\nCan organize :</div><div class=\"nl-prestataire-search-item-text\">{{searchValueById(94)}}</div></div></div></div></div>\n<div flex=\"30\" class=\"nl-prestataire-search-item-side side-contact\" \nng-if=\"company.contactFavourite != null && company.contactFavourite.valuedFields != null\"><div \nclass=\"nl-prestataire-search-item-maintitle\">Main contact</div><div layout=\"column\"><div \nclass=\"nl-prestataire-search-side-avatar\" \nng-if=\"searchContactValueById(22) != null && searchContactValueById(22).length>0\"><img \nng-src=\"{{URL.alternatedocroots + \'/\' + searchContactValueById(22)}}\" alt=\"\" \nclass=\"nl-prestataire-search-side-avatar-img\" alt=\"\"></div><div class=\"nl-prestataire-search-side-text mt-10\"><i \nclass=\"icon-account\"></i> <span class=\"\"><span>{{searchContactValueById(19)}},&nbsp;</span> <span>\n{{searchContactValueById(20)}}&nbsp;</span> <span>{{searchContactValueById(21)}}</span> </span></div><div \nclass=\"nl-prestataire-search-side-text\" \nng-if=\"(searchContactValueById(24) != null && searchContactValueById(24).length>0) || \n                            (searchContactValueById(23) != null && searchContactValueById(23).length>0)\">\n<i class=\"icon-worker\"></i> <span class=\"\"><span \nng-if=\"searchContactValueById(24) != null && searchContactValueById(24).length>0\">{{searchContactValueById(24)}}</span>\n <span ng-if=\"searchContactValueById(23) != null && searchContactValueById(23).length>0\">\n&nbsp;{{searchContactValueById(23)}}</span> </span></div><div class=\"nl-prestataire-search-side-text\" \nng-if=\"searchContactValueById(27) != null && searchContactValueById(27).length>0\"><i class=\"icon-phone-forward\"></i> \n<span class=\"\">{{searchContactValueById(27)}}</span></div><div class=\"nl-prestataire-search-side-text\" \nng-if=\"searchContactValueById(28) != null && searchContactValueById(28).length>0\"><i class=\"icon-cellphone-iphone\"></i>\n <span class=\"\">{{searchContactValueById(28)}}</span></div><div class=\"nl-prestataire-search-side-text\" \nng-if=\"searchContactValueById(29) != null && searchContactValueById(29).length>0\"><i class=\"icon-email\"></i> <span \nclass=\"\">{{searchContactValueById(29)}}</span></div><div class=\"nl-prestataire-search-side-text\" \nng-if=\"searchContactValueById(26) != null && searchContactValueById(26).length>0\"><i \nclass=\"icon-flag-checkered-variant\"></i> <span class=\"\">{{searchContactValueById(26)}}</span></div></div></div></div>\n<div id=\"anchor--meetingrooms\" layout=\"column\" class=\"nl-prestataire-search-item item-2 mt-50\"><div><div \nclass=\"nl-prestataire-search-item-maintitle\">Presentation</div></div><div class=\"ph-20\"><div layout=\"column\" \nlayout-align=\"center start\" ng-if=\"searchValueById(38) != null && searchValueById(38).length>0\" class=\"pv-10\"><div \nclass=\"nl-prestataire-search-item-strong\">Company Profile :</div><div class=\"nl-prestataire-search-item-text\" \nng-bind-html=\"searchValueById(38)\"></div></div><div layout=\"column\" layout-align=\"center start\" \nng-if=\"searchValueById(39) != null && searchValueById(39).length>0\" class=\"pv-10\"><div \nclass=\"nl-prestataire-search-item-strong\">Services :</div><div class=\"nl-prestataire-search-item-text\" \nng-bind-html=\"searchValueById(39)\"></div></div><div layout=\"column\" layout-align=\"center start\" \nng-if=\"searchValueById(40) != null && searchValueById(40).length>0\" class=\"pv-10\"><div \nclass=\"nl-prestataire-search-item-strong\">Main Asset :</div><div class=\"nl-prestataire-search-item-text\" \nng-bind-html=\"searchValueById(40)\"></div></div><div layout=\"column\" layout-align=\"center start\" \nng-if=\"searchValueById(41) != null && searchValueById(41).length>0\" class=\"pv-10\"><div \nclass=\"nl-prestataire-search-item-strong\">Facilities :</div><div class=\"nl-prestataire-search-item-text\" \nng-bind-html=\"searchValueById(41)\"></div></div><div layout=\"column\" layout-align=\"center start\" \nng-if=\"searchValueById(42) != null && searchValueById(42).length>0\" class=\"pv-10\"><div \nclass=\"nl-prestataire-search-item-strong\">Main events organized :</div><div class=\"nl-prestataire-search-item-text\" \nng-bind-html=\"searchValueById(42)\"></div></div><div layout=\"column\" layout-align=\"center start\" \nng-if=\"searchValueById(43) != null && searchValueById(43).length>0\" class=\"pv-10\"><div \nclass=\"nl-prestataire-search-item-strong\">Last events organized :</div><div class=\"nl-prestataire-search-item-text\" \nng-bind-html=\"searchValueById(43)\"></div></div><div layout=\"column\" layout-align=\"center start\" \nng-if=\"searchValueById(44) != null && searchValueById(44).length>0\" class=\"pv-10\"><div \nclass=\"nl-prestataire-search-item-strong\">Highlights of the destination :</div><div \nclass=\"nl-prestataire-search-item-text\" ng-bind-html=\"searchValueById(44)\"></div></div><div layout=\"column\" \nlayout-align=\"center start\" ng-if=\"searchValueById(45) != null && searchValueById(45).length>0\" class=\"pv-10\"><div \nclass=\"nl-prestataire-search-item-strong\">Cultural and leisure assets of the destination :</div><div \nclass=\"nl-prestataire-search-item-text\" ng-bind-html=\"searchValueById(45)\"></div></div><div layout=\"column\" \nlayout-align=\"center start\" ng-if=\"searchValueById(46) != null && searchValueById(46).length>0\" class=\"pv-10\"><div \nclass=\"nl-prestataire-search-item-strong\">MICE asset of the destination :</div><div \nclass=\"nl-prestataire-search-item-text\" ng-bind-html=\"searchValueById(46)\"></div></div></div></div><div \nid=\"anchor--capacities\" layout=\"column\" class=\"nl-prestataire-search-item item-2 mt-50\"><div><div \nclass=\"nl-prestataire-search-item-maintitle\">Capacities</div></div><div class=\"p-20\"><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" class=\"pr-20\"><div \nclass=\"nl-prestataire-search-item-mainsubtitle\">Maximum capacities</div><table \nclass=\"dataTable row-border nl-Tablegit nl-Table--center nl-prestataire-table nl-prestataire-table--common\"><tr><th>\nTheatre</th><th>Conference</th><th>Cocktail</th></tr><tr><td \nng-if=\"searchValueById(51) != null && searchValueById(51).length>0\">{{searchValueById(51)}} pax</td><td \nng-if=\"searchValueById(52) != null && searchValueById(52).length>0\">{{searchValueById(52)}} pax</td><td \nng-if=\"searchValueById(53) != null && searchValueById(53).length>0\">{{searchValueById(53)}} pax</td></tr><tr \nng-if=\"!(searchValueById(51) != null && searchValueById(51).length>0) && !(searchValueById(52) != null && searchValueById(52).length>0) \n                                && !(searchValueById(53) != null && searchValueById(53).length>0)\">\n<td></td><td></td><td></td></tr></table></div><div flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" class=\"pl-20\"><div \nclass=\"nl-prestataire-search-item-mainsubtitle\">Exposition surface</div><table \nclass=\"dataTable row-border nl-Tablegit nl-Table--center nl-prestataire-table nl-prestataire-table--common\"><tr><th>\nLargest Room (m2)</th><th>Indoor (m2)</th><th>Outdoor (m2)</th><th>Total (m2)</th></tr><tr><td \nng-if=\"searchValueById(54) != null && searchValueById(54).length>0\">{{searchValueById(54)}}</td><td \nng-if=\"searchValueById(55) != null && earchValueById(55).length>0\">{{searchValueById(55)}}</td><td \nng-if=\"searchValueById(56) != null && searchValueById(56).length>0\">{{searchValueById(56)}}</td><td \nng-if=\"searchValueById(57) != null && searchValueById(57).length>0\">{{searchValueById(57)}}</td></tr><tr \nng-if=\"!(searchValueById(54) != null && searchValueById(54).length>0) && !(searchValueById(55) != null && earchValueById(55).length>0) \n                                && !(searchValueById(56) != null && searchValueById(56).length>0) && !(searchValueById(57) != null && searchValueById(57).length>0)\">\n<td></td><td></td><td></td><td></td></tr></table></div></div><div class=\"mt-25\" layout=\"row\" \nlayout-align=\"center center\"><div flex=\"100\"><div class=\"nl-prestataire-search-item-mainsubtitle\">Bedrooms</div><table \nclass=\"dataTable row-border nl-Tablegit nl-Table--center nl-prestataire-table nl-prestataire-table--common\"><tr><th>\nRoom Type</th><th>Number</th><th>Size (m2)</th><th>Size (sq.ft)</th></tr><tr><td>Single Room</td><td>\n{{searchValueById(58)}}</td><td>{{searchValueById(59)}}</td><td>{{searchValueById(60)}}</td></tr><tr><td>Double Room\n</td><td>{{searchValueById(61)}}</td><td>{{searchValueById(62)}}</td><td>{{searchValueById(63)}}</td></tr><tr><td>\nTwin Room</td><td>{{searchValueById(64)}}</td><td>{{searchValueById(65)}}</td><td>{{searchValueById(66)}}</td></tr><tr>\n<td>Superior Room</td><td>{{searchValueById(67)}}</td><td>{{searchValueById(68)}}</td><td>{{searchValueById(69)}}</td>\n</tr><tr><td>Suites</td><td>{{searchValueById(70)}}</td><td>{{searchValueById(71)}}</td><td>{{searchValueById(72)}}\n</td></tr></table></div></div></div></div><div id=\"anchor--situation\" layout=\"column\" \nclass=\"nl-prestataire-search-item item-2 mt-50\" \nng-if=\"(searchValueById(84) != null && searchValueById(84).length>0) || \n            (searchValueById(90) != null && searchValueById(90).length>0) || (searchValueById(85) != null && searchValueById(85).length>0) \n            || (searchValueById(86) != null && searchValueById(86).length>0)\">\n<div><div class=\"nl-prestataire-search-item-maintitle\">Situation</div></div><div class=\"p-20\"><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"searchValueById(84) != null && searchValueById(84).length>0\"><div \nclass=\"nl-prestataire-search-item-strong\">Situation :</div><div class=\"nl-prestataire-search-item-text\">\n{{searchValueById(84)}}</div></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"searchValueById(90) != null && searchValueById(90).length>0\"><div class=\"nl-prestataire-search-item-strong\">\nParking :</div><div class=\"nl-prestataire-search-item-text\">{{searchValueById(90)}} places</div></div><div \nlayout=\"row\" layout-align=\"start center\" \nng-if=\"(searchValueById(85) != null && searchValueById(85).length>0) \n                    || (searchValueById(86) != null && searchValueById(86).length>0)\">\n<div class=\"nl-prestataire-search-item-strong\">Closest International Airport :</div><div \nclass=\"nl-prestataire-search-item-text\">{{searchValueById(85)}} <span ng-if=\"searchValueById(86)\">\n({{searchValueById(86)}}km)</span></div></div></div></div><div id=\"anchor--meetingrooms\" layout=\"column\" \nclass=\"nl-Table--wrapper nl-prestataire-search-item nl-prestataire-search-item--table mt-50\" \nng-show=\"dispositions != null && dispositions.length > 0\"><div><div class=\"nl-prestataire-search-item-maintitle\">\nMeeting Rooms</div></div><table \nclass=\"dataTable row-border hover nl-Tablegit nl-Table--center nl-prestataire-table--common\"><thead><tr><th \nclass=\"secondary-text\">{{\"COMPANIES.DISPOSITION.NAME\" | translate }}</th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"COMPANIES.DISPOSITION.SQUARE_METTER\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"COMPANIES.DISPOSITION.SQUARE_FEET\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"COMPANIES.DISPOSITION.L_W_H\"></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"COMPANIES.DISPOSITION.DAY_LIGHT\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" \naria-label=\"square meter\"><md-tooltip>{{\"COMPANIES.DISPOSITION.THEATER\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/theatre.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.CLASS_ROOM\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/classroom.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.BOARD_ROOM\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/boardroom.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.U_STYLE\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/ustyle.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.BANQUET\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/banquet.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.COCKTAIL\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/cocktail.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.CONFERENCE\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/conference.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.CABARET\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/cabaret.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.AUDITORIUM\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/auditorium.svg\"></md-icon></md-button></div></th></tr></thead><tbody><tr \nng-repeat=\"_disposition in dispositions track by $index\"><td>{{ _disposition.name }}</td><td>\n{{ _disposition.squareMeter }}</td><td>{{ _disposition.squareFeet }}</td><td>\n{{ _disposition.length ? _disposition.length : \"xx\" }}/{{ _disposition.width ? _disposition.width : \"xx\" }}/{{ _disposition.height ? _disposition.height : \"xx\" }}\n</td><td>{{ !_disposition.dayLight ? \'COMPANIES.NO\' : \'COMPANIES.YES\' | translate }}</td><td>{{ _disposition.theatre }}\n</td><td>{{ _disposition.classRoom }}</td><td>{{ _disposition.boardRoom }}</td><td>{{ _disposition.uStyle }}</td><td>\n{{ _disposition.banquet }}</td><td>{{ _disposition.cocktail }}</td><td>{{ _disposition.conference }}</td><td>\n{{ _disposition.cabaret }}</td><td>{{ _disposition.auditorium }}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/contact.template.type.html","<div class=\"nl_Row-content\"><h1 class=\"nl-titre--main\">{{\'SITES_MANAGEMENT.BLOCS.CONTACT.TITLE\' | translate}}</h1><div \nng-if=\"senderMail\" class=\"nl-prestataire-search-item\"><div class=\"nl-prestataire-search-item-title\">\n{{\'SITES_MANAGEMENT.BLOCS.CONTACT.CONTACT\' | translate}}</div>{{senderMail}}</div><div \nclass=\"nl-prestataire-search-item\"><div class=\"nl-prestataire-search-item-title\">\n{{\'SITES_MANAGEMENT.BLOCS.CONTACT.CONTACT_FORM\' | translate}}</div>\n{{\'SITES_MANAGEMENT.BLOCS.CONTACT.ALL_FIELDS_REQUIRED\' | translate}}<form name=\"ContactForm\" layout=\"row\" \nng-submit=\"ContactForm.$valid && sendContact()\"><div flex layout=\"column\"><md-input-container flex><label>\n{{\'SITES_MANAGEMENT.BLOCS.CONTACT.MAIL\'|translate}}</label><input type=\"email\" ng-pattern=\"/^.+@.+\\..+$/\" required \nng-model=\"contact.email\" name=\"email\"><div ng-messages=\"ContactForm.email.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container flex><label>{{\'SITES_MANAGEMENT.BLOCS.CONTACT.PHONE\'|translate}}</label><input type=\"text\" \nrequired ng-model=\"contact.phone\" name=\"phone\"><div ng-messages=\"ContactForm.phone.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container flex><label>{{\'SITES_MANAGEMENT.BLOCS.CONTACT.FIRSTNAME\'|translate}}</label><input type=\"text\" \nmaxlength=\"255\" required ng-model=\"contact.firstName\" name=\"firstName\"><div ng-messages=\"ContactForm.firstName.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container flex><label>{{\'SITES_MANAGEMENT.BLOCS.CONTACT.LASTNAME\'|translate}}</label>\n<input type=\"text\" maxlength=\"255\" required ng-model=\"contact.lastName\" name=\"lastName\"><div \nng-messages=\"ContactForm.lastName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container flex><label>\n{{\'SITES_MANAGEMENT.BLOCS.CONTACT.SOCIETY\'|translate}}</label><input type=\"text\" maxlength=\"255\" required \nng-model=\"contact.society\" name=\"society\"><div ng-messages=\"ContactForm.society.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><div flex \nlayout=\"column\"><md-input-container class=\"ml-25 mt-25 mb-0\" flex><label>\n{{\'SITES_MANAGEMENT.BLOCS.CONTACT.YOUR_MESSAGE\'|translate}}</label><textarea ng-model=\"contact.message\" rows=\"8\" \nname=\"message\" required>\n                    </textarea><div ng-messages=\"ContactForm.message.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><div \nlayout=\"row\" align=\"center\"><div ng-model=\"recaptchaResponse\" flex vc-recaptcha \nkey=\"\'6LeiFGAUAAAAABf2un4SgDrdZMpuB-R4UIsi7Dvg\'\"></div><md-button type=\"submit\" flex=\"30\" \nclass=\"md-raised md-primary md-hue-2\">{{\'SITES_MANAGEMENT.BLOCS.CONTACT.SEND_MESSAGE\'|translate}}</md-button></div>\n</div></form></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/decouvrez.template.type.html","<div class=\"nl_Row-content\"><div layout=\"row\" layout-align=\"start stretch\"><div flex=\"33\"><a href=\"\" \nclass=\"nl-discover-wrapper nl-discover-wrapper--md\"><div class=\"nl-discover-title\">Quartiers</div><img \nsrc=\"assets/images/slick/2.jpg\" alt=\"\"> </a><a href=\"\" class=\"nl-discover-wrapper nl-discover-wrapper--sm\"><div \nclass=\"nl-discover-title\">Lieux de culte</div><img src=\"assets/images/slick/2.jpg\" alt=\"\"> </a><a href=\"\" \nclass=\"nl-discover-wrapper nl-discover-wrapper--sm\"><div class=\"nl-discover-title\">Jardins</div><img \nsrc=\"assets/images/slick/2.jpg\" alt=\"\"></a></div><div flex=\"33\"><a href=\"\" \nclass=\"nl-discover-wrapper nl-discover-wrapper--md\"><div class=\"nl-discover-title\">Places</div><img \nsrc=\"assets/images/slick/2.jpg\" alt=\"\"> </a><a href=\"\" class=\"nl-discover-wrapper nl-discover-wrapper--md\"><div \nclass=\"nl-discover-title\">Sites archéologiques</div><img src=\"assets/images/slick/2.jpg\" alt=\"\"></a></div><div \nflex=\"33\"><a href=\"\" class=\"nl-discover-wrapper nl-discover-wrapper--lg\"><div class=\"nl-discover-title\">Restaurants\n</div><img src=\"assets/images/slick/1.jpg\" alt=\"\"></a></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/festival.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-prestataire-search--slick\" \nng-if=\"festival.photos && festival.photos.length > 0\"><div class=\"nl_slick--wrapper\"><button type=\"button\" \nng-click=\"_festivalSlickConfig.method.slickPrev()\" class=\"nl_slick--button\"><img \nsrc=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"_festivalSlickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button-right\"><img \nsrc=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick settings=\"_festivalSlickConfig\" style=\"height: 400px\">\n<div class=\"nl_slick--slide\" ng-repeat=\"_photo in festival.photos\"><img class=\"nl_slick--slide--img\" \nng-src=\"{{_photo.url}}\" alt=\"\"></div></slick></div></div><div layout=\"row\" class=\"nl-prestataire-search-item\"><div \nflex=\"70\" class=\"pr-20\"><div layout=\"column\"><div class=\"nl-titre--main nl--item\">{{festival.name}}</div><div><div \nclass=\"nl-prestataire-search-item-description ql-editor\" ng-bind-html=\"trustAsHtml(festival.description)\"></div></div>\n</div></div><div flex=\"30\" class=\"nl-prestataire-search-item-side\"><div layout=\"column\"><div \nclass=\"nl-prestataire-search-detail-aside\"><div class=\"nl-prestataire-search-item-title title--panel\" \nng-if=\"festival.dateStart != null || festival.dateEnd != null\">Dates:</div><div \nclass=\"nl-prestataire-search-item-text mb-10\">\n{{\'GENERAL.DATE_TIME_FORMAT\' | translate: {date:getDate(festival.dateStart)} }}<span \nng-if=\"festival.dateStart != null && festival.dateEnd != null\"> - </span>\n{{\'GENERAL.DATE_TIME_FORMAT\' | translate:{date:getDate(festival.dateEnd)} }}</div><div \nclass=\"nl-prestataire-search-item-title title--panel\">Adresse:</div><div class=\"nl-prestataire-search-item-text mb-10\">\n{{festival.address+\' \'+festival.country}}</div><div class=\"nl-prestataire-search-item-title title--panel\">Website:\n</div><div class=\"nl-prestataire-search-item-text\"><a ng-href=\"{{festival.website}}\" target=\"_blank\">\n{{festival.website}}</a></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/festivals.template.type.html","<div class=\"nl_Row-content\"><h1 class=\"nl-titre--main nl--center\" translate=\"\">Festivals organized in Lebanon</h1><div \nclass=\"mv-50\" infinite-scroll=\"loadMoreFestivals()\" infinite-scroll-container=\"\'#content-container\'\" \ninfinite-scroll-disabled=\"infiniteScrollPrevent\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"3\">\n<div class=\"nl-prestataire-search-item animated fadeIn\" layout=\"row\" layout-align=\"start start\" \nng-repeat=\"festival in festivals\"><div flex=\"75\" layout=\"column\" class=\"pr-20\"><div><div \nclass=\"nl-prestataire-search-item-title\">{{festival.name}}</div><div class=\"nl-prestataire-search-item-subtitle\" \nng-if=\"festival.dateStart != null || festival.dateEnd != null\"><md-icon md-font-icon=\"icon-calendar\" class=\"s25\">\n</md-icon>{{\'GENERAL.DATE_TIME_FORMAT\' | translate: {date:getDate(festival.dateStart)} }} <span \nng-if=\"festival.dateStart != null && festival.dateEnd != null\">- </span>\n{{\'GENERAL.DATE_TIME_FORMAT\' | translate:{date:getDate(festival.dateEnd)} }}</div><div \nclass=\"nl-prestataire-search-item-subtitle\">{{festival.address+\' \'+festival.country}} | <a \nng-href=\"{{festival.website}}\" target=\"_blank\">{{festival.website}}</a></div></div><div><div \nclass=\"nl-prestataire-search-item-description nl-crop pr-5 ql-editor\" \nng-bind-html=\"trustAsHtml(festival.description | nlEllipsis: 400)\"></div></div></div><div flex=\"25\" layout=\"column\">\n<div class=\"nl-prestataire-search-item-imgWrapper\"><img class=\"nl-prestataire-search-item-img\" \nng-if=\"festival.photos != null && festival.photos.length > 0\" \nng-src=\"{{URL.alternatedocroots + \'/\' + festival.photos[0].location}}\" alt=\"\"></div><div class=\"mt-16\"><button \ntype=\"button\" ng-click=\"details(\'{{{PAGE_NAME_DETAILS_FESTIVAL}}}\', festival.id)\" class=\"nl-Item-button pr-20\">\nRead more</button></div></div></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\">\n<div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div \nclass=\"half-circle\"></div></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/ficheType.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-FicheType\" layout=\"row\" layout-align=\"start stretch\"><div class=\"\" \nlayout=\"row\"></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/galleries.template.type.html","<div class=\"nl_Row-content\" ng-init=\"getGalleries([\'ffa9beb0\', \'c68c90ad\', \'5efa5261\', \'e3278234\'])\"><div \nng-repeat=\"gallery in galleries\"><h1 class=\"nl-titre--main\">{{gallery.title}}</h1><div layout=\"row\" layout-wrap \nlayout-align=\"start\"><div class=\"nl-rowImage p-5\" flex=\"33\" \nng-repeat=\"subGallery in gallery.subGalleries | orderBy: \'index\'\" \nng-click=\"goSubGallery(\'{{{PAGE_NAME_DETAILS_GALLERY}}}\', subGallery.uuid)\"><a href=\"\"><div \nclass=\"nl-rowImage-wrapper m-10\"><div class=\"nl-rowImage-title\">{{subGallery.title}}</div><img class=\"nl-rowImage-img\" \nng-if=\"subGallery.previewPicture\" ng-src=\"{{URL.alternatedocroots + \'/\' + subGallery.previewPicture.location}}\" alt=\"\">\n</div></a></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/gallery.template.type.html","<div class=\"nl_Row-content\" ng-init=\"myIndex = 0;\"><md-button type=\"button\" class=\"md-raised md-primary md-hue-2\" \nng-click=\"goBack(\'{{{PAGE_NAME_GALLERIES}}}\')\">{{\"GALLERY.BACK_TO_GALLERIES\" | translate}}</md-button><br><h1 \nclass=\"nl-titre--main\">{{gallery.title}}</h1><div class=\"nl-rowImage\" layout=\"row\" layout-wrap layout-align=\"start\">\n<div flex=\"33\" flex-xs=\"100\" ng-repeat=\"picture in gallery.pictures\" class=\"nl-rowImage p-5\"><div \nclass=\"nl-rowImage-wrapper\"><img ng-click=\"showSlider($index)\" class=\"nl-rowImage-img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + picture.location}}\" alt=\"\"></div><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"downloadFromFileName(picture.location)\">\n{{\"GALLERY.DOWNLOAD_HIGH\" | translate}}</md-button></div></div><div ng-click=\"hideSlider()\" ng-if=\"showSlick\" \nclass=\"nl_Slick--wrapper\"><div style=\"position: relative; height: 100%; width: 100%\"><button type=\"button\" \nng-click=\"gallerySlickConfig.method.slickPrev(); $event.stopPropagation();\" class=\"nl_slick--button\"><img \nsrc=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"gallerySlickConfig.method.slickNext(); $event.stopPropagation();\" \nclass=\"nl_slick--button nl_slick--button-right\"><img src=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick \ncurrent-index=\"myIndex\" ng-click=\"$event.stopPropagation();\" settings=\"gallerySlickConfig\" class=\"nl_Slick--popup\"><div\n class=\"nl_slick--slide\" ng-repeat=\"picture in gallery.pictures\"><img \nclass=\"nl_slick--slide--img nl_slick--slide--img__contain\" ng-src=\"{{URL.alternatedocroots + \'/\' + picture.location}}\" \nalt=\"\"></div></slick><div class=\"nl_Slick--slideNumber\">{{myIndex + 1}}/{{gallery.pictures.length}}</div></div></div>\n</div>");
$templateCache.put("app/main/sites_management/blocs/bloc/itemMonument.template.type.html","<div class=\"nl_Row-content\"><div layout=\"row\" layout-align=\"start stretch\" class=\"nl-Item\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"nl-Item-title\">Musée National de Beyrouth</div><div class=\"nl-Item-adresse\">\nAdresse National de Beyrouth</div><div class=\"nl-Item-text\">\nLorem, ipsum dolor sit amet consectetur adipisicing elit. Quod, illum cupiditate! Facilis dolor numquam laboriosam, error nobis unde quasi. Quia, voluptatem? Veritatis hic atque facilis repudiandae labore optio minima modi. Molestiae corporis odit incidunt maiores eaque architecto aliquam perferendis aspernatur molestias blanditiis, obcaecati consequatur ut reiciendis cum sed. Soluta dolorem maiores quaerat nam deleniti fuga a ratione voluptatem veniam aliquam? Tempora dolorum, adipisci earum eligendi rem corrupti optio tenetur explicabo, iusto ut nostrum, dolorem hic id.\n<br><br>\nHic magnam facilis fugit laudantium fuga laboriosam voluptates animi fugiat delectus, ipsam architecto nulla. Unde, quis officiis laborum incidunt est iure dolor, ducimus aperiam modi earum necessitatibus? Suscipit aperiam obcaecati, doloribus provident recusandae inventore maiores, harum alias voluptate, in libero quaerat mollitia veniam ex?\n</div></div><div layout=\"column\" layout-align=\"start start\"><div class=\"nl-Item-carte\"><iframe \nsrc=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3312.436393166397!2d35.512889251312686!3d33.878413180558695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151f1705bf01caff%3A0x241292ecea61d223!2sMus%C3%A9e+national+de+Beyrouth!5e0!3m2!1sfr!2sfr!4v1523537000893\" \nwidth=\"100%\" height=\"250\" frameborder=\"0\" style=\"border:0\" allowfullscreen></iframe></div><div \nclass=\"nl-Item-imgwrapper\"><img class=\"nl-Item-img\" src=\"assets/images/etc/early-sunrise.jpg\" alt=\"\"></div><button \ntype=\"button\" class=\"nl-Item-button mt-10\">En savoir plus</button></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/listItem.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-LongList\" layout=\"row\" layout-align=\"start start\"><div><div \nclass=\"nl-LongList-number\">1</div></div><div><div class=\"nl-LongList-text\">\nLorem ipsum, dolor sit amet consectetur adipisicing elit. Nihil odit corporis similique placeat. Distinctio repellat, quisquam iure adipisci soluta suscipit quis a, saepe praesentium ducimus ut, nemo ratione earum molestiae?\n</div></div><div><div class=\"nl-LongList-imageWrapper\"><img class=\"nl-LongList-image\" src=\"assets/images/slick/3.jpg\" \nalt=\"\"></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/mainTitre.template.type.html","<div class=\"nl_Row-content\"><h1 class=\"nl-titre--main nl--center\">10 bonnes raisons d\'organiser un événement au Liban\n</h1></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/package.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-prestataire-search--slick\" \nng-if=\"package.documents && package.documents.length > 0\"><div class=\"nl_slick--wrapper\"><button type=\"button\" \nng-click=\"_packageSlickConfig.method.slickPrev()\" class=\"nl_slick--button\"><img \nsrc=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"_packageSlickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button-right\"><img \nsrc=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick settings=\"_packageSlickConfig\" style=\"height: 400px\">\n<div class=\"nl_slick--slide\" ng-repeat=\"_photo in package.documents\"><img class=\"nl_slick--slide--img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + _photo.location}}\" alt=\"\"></div></slick></div></div><div layout=\"row\" \nclass=\"nl-prestataire-search-item\"><div flex=\"70\" class=\"pr-20\"><div layout=\"column\"><div \nclass=\"nl-titre--main nl--item\">{{package.name}}</div><div><div \nclass=\"nl-prestataire-search-item-description ql-editor\" ng-bind-html=\"trustAsHtml(package.description)\"></div></div>\n</div></div><div flex=\"30\" class=\"nl-prestataire-search-item-side\"><div layout=\"column\"><div \nclass=\"nl-prestataire-search-item-imgWrapper\"><img \nng-if=\"package.companyLogo == null || package.companyLogo.length === 0\" \nclass=\"nl-prestataire-search-item-img nl-img--logo\" src=\"assets/images/slick/1.jpg\" alt=\"\"> <img \nng-if=\"package.companyLogo != null && package.companyLogo.length > 0\" \nclass=\"nl-prestataire-search-item-img nl-img--logo\" ng-src=\"{{URL.alternatedocroots + \'/\' + package.companyLogo}}\" \nalt=\"\"></div><div class=\"mt-16\"><button type=\"button\" class=\"nl-Item-button\">Demander un devis</button></div><div \nclass=\"nl-prestataire-search-detail-aside\"><div class=\"nl-prestataire-search-item-title title--panel\">Durée:</div><div \nclass=\"nl-prestataire-search-item-text mb-10\">{{package.duration}} jours</div><div \nclass=\"nl-prestataire-search-item-title title--panel\">Lieux:</div><div class=\"nl-prestataire-search-item-text mb-10\">\n<span ng-if=\"package.regions != null && package.regions.length > 0\" ng-repeat=\"region in package.regions | limitTo: 3\">\n{{region.value}}<span ng-if=\"!$last\">{{\', \'}}</span><span ng-if=\"$last && package.regions.length > 3\">{{\',...\'}}</span>\n</span></div><div class=\"nl-prestataire-search-item-title title--panel\">Types:</div><div \nclass=\"nl-prestataire-search-item-text\"><span \nng-if=\"package.typesTourisme != null && package.typesTourisme.length > 0\" \nng-repeat=\"type in package.typesTourisme | limitTo: 3\">{{type.value}}<span ng-if=\"!$last\">{{\', \'}}</span><span \nng-if=\"$last && package.typesTourisme.length > 3\">{{\',...\'}}</span></span></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/pageSiteTourist.template.type.html","<div class=\"nl_Row-content\"><div layout=\"row\" class=\"nl-prestataire-search-item\"><div flex=\"70\" class=\"pr-20\"><div \nlayout=\"column\"><div class=\"nl-titre--main nl--item\">Musée National de Beyrouth</div><div><div \nclass=\"nl-prestataire-search-item-description\">\nLorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt fugiat consequuntur nostrum? Vero, sapiente adipisci? Quo nisi placeat, nostrum aspernatur inventore sapiente dolore eveniet, aliquid harum in velit labore. Magni! Ducimus vero, facere eaque aut veniam nulla doloremque iure iste ad. Nulla possimus animi nesciunt non ipsum dolores accusamus, quia harum veritatis molestias, deleniti facilis earum eos et quasi perspiciatis.\n<br><br>\nNesciunt, magnam pariatur? Quidem voluptas accusamus tempora aliquam soluta quas, illo assumenda consequatur consectetur reprehenderit aut sint, hic praesentium molestiae deleniti voluptatibus doloremque eaque nam accusantium saepe! Modi, vitae dolores. Similique magnam natus consectetur atque praesentium iure beatae nemo quae, asperiores reprehenderit est aliquam, sint ipsum ea vitae porro dolorum fuga illum. Explicabo omnis a necessitatibus vel possimus harum hic.\n</div></div><div><a href=\"#\" class=\"nl-download-pdf\"><img src=\"assets/images/slick/2.jpg\" alt=\"\"><div \nclass=\"nl-download-pdf-title\">Cliquez ici pour télécharger notre visite guidée en PDF</div></a></div></div></div><div \nflex=\"30\" class=\"nl-prestataire-search-item-side\"><div layout=\"column\"><div class=\"nl-Paragraphe-aside-img\"><iframe \nwidth=\"100%\" height=\"220px\" src=\"https://www.youtube.com/embed/8DHV0q-qb0o?rel=0\" frameborder=\"0\" \nallow=\"autoplay; encrypted-media\"></iframe></div><div class=\"nl-prestataire-search-detail-aside\"><div \nclass=\"nl-prestataire-search-item-title title--panel\">Adresse:</div><div class=\"nl-prestataire-search-item-text mb-10\">\nValley of the Dog River / Keserwan, Beirut, Liban</div><div class=\"nl-prestataire-search-item-title title--panel\">\nWebsite:</div><div class=\"nl-prestataire-search-item-text mb-10\"><a ng-href=\"\" target=\"_blank\">www.jeitagrotto.com</a>\n</div><div class=\"nl-prestataire-search-item-title title--panel\">Horaires:</div><div \nclass=\"nl-prestataire-search-item-text mb-10\">Lundi au Samedi de 09:00 à 17:00</div></div><div class=\"nl-Item-carte\">\n<iframe \nsrc=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3312.436393166397!2d35.512889251312686!3d33.878413180558695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151f1705bf01caff%3A0x241292ecea61d223!2sMus%C3%A9e+national+de+Beyrouth!5e0!3m2!1sfr!2sfr!4v1523537000893\" \nwidth=\"100%\" height=\"250\" frameborder=\"0\" style=\"border:0\" allowfullscreen></iframe></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/paragraphe.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-Paragraphe mv-25\">\nLorem ipsum dolor sit amet consectetur adipisicing elit. Autem, nam inventore. Dicta sint sed, officiis doloribus, pariatur optio sunt tempore corporis, ad debitis earum consequuntur maxime molestiae explicabo dolor expedita!Voluptate provident facilis porro reprehenderit fugit, explicabo laborum sed praesentium quod aspernatur velit excepturi iure impedit, consectetur fugiat facere accusantium cumque? Autem vitae quibusdam exercitationem ea quas cum, quasi inventore.\n</div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/paragrapheAsideList.html","<div class=\"nl_Row-content\"><div layout=\"row\" layout-align=\"start start\"><div flex=\"66\"><div class=\"nl-Paragraphe\">\nLorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas assumenda, recusandae ipsa aliquam dolor omnis vero nostrum asperiores perspiciatis eaque vel placeat in hic enim ducimus? Cum impedit aliquam eos? Optio, iste iusto? Voluptas ipsum quibusdam quae sint hic explicabo, dignissimos vitae, sed perferendis iste vero! Saepe eaque voluptas nostrum quis id corporis iste eos nulla, reiciendis exercitationem quasi fugit? Error assumenda ipsum doloribus deserunt accusamus voluptas totam aperiam, quidem quo unde dolorum nulla illum corporis neque maiores odit? Assumenda maxime libero magnam minus incidunt, illo expedita distinctio quam eligendi. Voluptatibus ea dolorum animi perspiciatis! Earum doloribus cupiditate voluptate repellendus accusamus corporis, at quas. Tempora atque beatae voluptatum, doloremque reiciendis dolorum consequatur molestias aperiam aut eius voluptatem rerum tempore nisi.\n<br><br>\nLorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt libero, recusandae, quos temporibus exercitationem facere quasi iste, quam voluptatem quaerat sint! Exercitationem quia, beatae velit eius eaque architecto accusamus eos!\n</div></div><div flex=\"33\"><div class=\"nl-Paragraphe-aside-img\"><iframe width=\"100%\" height=\"220px\" \nsrc=\"https://www.youtube.com/embed/8DHV0q-qb0o?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\"></iframe></div>\n<div class=\"nl-Paragraphe-aside-listWrapper\"><div class=\"p-5\"><div class=\"nl-Paragraphe-aside-list-title\">\nJe souhaite découvrir...</div><ul class=\"nl-Paragraphe-aside-list-item\"><li><a href=\"\">Les lieux de culte islamiques\n</a></li><li><a href=\"\">Les lieux de culte chétiens</a></li></ul></div><div class=\"p-5\"><div \nclass=\"nl-Paragraphe-aside-list-title\">Liste des lieux de culte par région :</div><ul \nclass=\"nl-Paragraphe-aside-list-item\"><li><a href=\"\">Beirut</a></li><li><a href=\"\">Mont Liban</a></li><li><a href=\"\">\nVallée de la bekaa</a></li><li><a href=\"\">Nord du Liban</a></li><li><a href=\"\">Sud du Liban</a></li></ul></div></div>\n</div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/rowImage.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-rowImage\" layout=\"row\" layout-align=\"center stretch\"><div flex=\"33\" \nclass=\"p-5\"><div class=\"nl-rowImage-wrapper\"><img class=\"nl-rowImage-img\" src=\"assets/images/slick/1.jpg\" alt=\"\"></div>\n</div><div flex=\"33\" class=\"p-5\"><div class=\"nl-rowImage-wrapper\"><img class=\"nl-rowImage-img\" \nsrc=\"assets/images/slick/2.jpg\" alt=\"\"></div></div><div flex=\"33\" class=\"p-5\"><div class=\"nl-rowImage-wrapper\"><img \nclass=\"nl-rowImage-img\" src=\"assets/images/slick/3.jpg\" alt=\"\"></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/rowImage5Title.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-rowImage nl-rowImage--sm\" layout=\"row\" layout-align=\"center stretch\"><div \nflex=\"20\" class=\"p-5\"><div class=\"nl-rowImage-wrapper\"><div class=\"nl-rowImage-title\">Site 1</div><img \nclass=\"nl-rowImage-img\" src=\"assets/images/slick/1.jpg\" alt=\"\"></div></div><div flex=\"20\" class=\"p-5\"><div \nclass=\"nl-rowImage-wrapper\"><div class=\"nl-rowImage-title\">Site 2</div><img class=\"nl-rowImage-img\" \nsrc=\"assets/images/slick/2.jpg\" alt=\"\"></div></div><div flex=\"20\" class=\"p-5\"><div class=\"nl-rowImage-wrapper\"><div \nclass=\"nl-rowImage-title\">Site 3</div><img class=\"nl-rowImage-img\" src=\"assets/images/slick/3.jpg\" alt=\"\"></div></div>\n<div flex=\"20\" class=\"p-5\"><div class=\"nl-rowImage-wrapper\"><div class=\"nl-rowImage-title\">Site 4</div><img \nclass=\"nl-rowImage-img\" src=\"assets/images/slick/1.jpg\" alt=\"\"></div></div><div flex=\"20\" class=\"p-5\"><div \nclass=\"nl-rowImage-wrapper\"><div class=\"nl-rowImage-title\">Site 5</div><img class=\"nl-rowImage-img\" \nsrc=\"assets/images/slick/2.jpg\" alt=\"\"></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/rowImageTitle.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-rowImage\" layout=\"row\" layout-align=\"center stretch\"><div flex=\"33\" \nclass=\"p-5\"><div class=\"nl-rowImage-wrapper\"><div class=\"nl-rowImage-title\">Site 1</div><img class=\"nl-rowImage-img\" \nsrc=\"assets/images/slick/1.jpg\" alt=\"\"></div></div><div flex=\"33\" class=\"p-5\"><div class=\"nl-rowImage-wrapper\"><div \nclass=\"nl-rowImage-title\">Site 2</div><img class=\"nl-rowImage-img\" src=\"assets/images/slick/2.jpg\" alt=\"\"></div></div>\n<div flex=\"33\" class=\"p-5\"><div class=\"nl-rowImage-wrapper\"><div class=\"nl-rowImage-title\">Site 3</div><img \nclass=\"nl-rowImage-img\" src=\"assets/images/slick/3.jpg\" alt=\"\"></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/search_companies.template.type.html","<div class=\"nl-prestataire--page\" ng-init=\"_initPreselectFilterFn(false, null, null)\"><form name=\"filterCompaniesForm\" \nnovalidate ng-submit=\"filter(null, null)\"><div class=\"nl_Row-content\"><h1 class=\"nl-titre--main nl--center\" \ntranslate=\"\">Rechercher un prestataire</h1><div class=\"nl-prestataire-search-wrapper\" layout=\"row\" \nlayout-align=\"center stretch\" layout-wrap><div flex=\"25\" class=\"nl-prestataire-search-category pl-5 pr-15\"><div \nclass=\"\"><div class=\"nl-prestataire-search-title\">Par activité</div><md-input-container><label \ntranslate=\"SETTINGS.DATABASE.COMPANIES.COMPANY_TYPE\"></label><md-select class=\"\" ng-model=\"companyTypes.values\" \nng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"multiple\" ng-init=\"preselectTypes([])\"><md-option \nng-repeat=\"type in companyTypes.fieldModel.listFieldsDTO | orderBy: \'index\' track by type.id\" ng-value=\"type\">\n{{type.value}}</md-option></md-select></md-input-container><md-input-container><label \ntranslate=\"SETTINGS.DATABASE.COMPANIES.CATEGORY\"></label><md-select ng-model=\"categories.values\" multiple=\"multiple\" \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"category in categories.fieldModel.listFieldsDTO | orderBy: \'index\' track by category.id\" \nng-value=\"category\">{{category.value}}</md-option></md-select></md-input-container><md-input-container><label \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.MODEL_FIELD_KEYWORD\"></label><input type=\"text\" \nng-model=\"keyword.value\"></md-input-container></div></div><div flex=\"25\" \nclass=\"nl-prestataire-search-category pl-15 pr-15\"><div class=\"\"><div class=\"nl-prestataire-search-title\">Par région\n</div><md-input-container><md-select ng-model=\"regions.value\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-value=\"region\" ng-repeat=\"region in regions.fieldModel.listFieldsDTO | orderBy: \'index\' track by region.id\">\n{{region.value}}</md-option></md-select><label translate=\"SETTINGS.DATABASE.COMPANIES.REGION\"></label>\n</md-input-container><md-input-container><md-select ng-model=\"cities.value\" ng-model-options=\"{trackBy: \'$value.id\'}\">\n<md-option ng-value=\"city\" ng-repeat=\"city in cities.fieldModel.listFieldsDTO | orderBy: \'index\' track by city.id\">\n{{city.value}}</md-option></md-select><label translate=\"SETTINGS.DATABASE.COMPANIES.CITY\"></label></md-input-container>\n</div></div><div flex=\"25\" class=\"nl-prestataire-search-category pl-15 pr-15\"><div class=\"\"><div \nclass=\"nl-prestataire-search-title\">Par capacité</div><div layout=\"row\"><md-input-container flex=\"50\" \nclass=\"nl-Form-input--noError\"><label translate=\"SETTINGS.DATABASE.COMPANIES.BEDROOMS\"></label><input type=\"number\" \nmin=\"0\" max=\"10000\" ng-model=\"rooms.minValue\" placeholder=\"min\"></md-input-container><md-input-container flex=\"50\" \nclass=\"nl-Form-input--noError\"><input type=\"number\" min=\"0\" max=\"10000\" ng-model=\"rooms.maxValue\" placeholder=\"max\">\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\" class=\"nl-Form-input--noError\"><label \ntranslate=\"SETTINGS.DATABASE.COMPANIES.CAPACITY\"></label><input type=\"number\" min=\"0\" max=\"10000\" \nng-model=\"capacities.minValue\" placeholder=\"min\"></md-input-container><md-input-container flex=\"50\" \nclass=\"nl-Form-input--noError\"><input type=\"number\" min=\"0\" max=\"10000\" ng-model=\"capacities.maxValue\" \nplaceholder=\"max\"></md-input-container></div></div></div><div flex=\"25\" class=\"pr-5 pl-20\"><div class=\"\"><div \nclass=\"nl-prestataire-search-title\">Par salle</div><md-input-container><md-select ng-model=\"peoples.value.value\">\n<md-option value=\"theatre\" translate=\"COMPANIES.DISPOSITION.THEATER\"></md-option><md-option value=\"classRoom\" \ntranslate=\"COMPANIES.DISPOSITION.CLASS_ROOM\"></md-option><md-option value=\"boardRoom\" \ntranslate=\"COMPANIES.DISPOSITION.BOARD_ROOM\"></md-option><md-option value=\"uStyle\" \ntranslate=\"COMPANIES.DISPOSITION.U_STYLE\"></md-option><md-option value=\"banquet\" \ntranslate=\"COMPANIES.DISPOSITION.BANQUET\"></md-option><md-option value=\"cocktail\" \ntranslate=\"COMPANIES.DISPOSITION.COCKTAIL\"></md-option><md-option value=\"conference\" \ntranslate=\"COMPANIES.DISPOSITION.CONFERENCE\"></md-option><md-option value=\"cabaret\" \ntranslate=\"COMPANIES.DISPOSITION.CABARET\"></md-option><md-option value=\"auditorium\" \ntranslate=\"COMPANIES.DISPOSITION.AUDITORIUM\"></md-option></md-select><label \ntranslate=\"SETTINGS.DATABASE.COMPANIES.CONFIG\"></label></md-input-container><div layout=\"row\"><md-input-container \nflex=\"50\" class=\"nl-Form-input--noError\"><label translate=\"SETTINGS.DATABASE.COMPANIES.PEOPLE\"></label><input \ntype=\"number\" min=\"0\" max=\"10000\" ng-model=\"peoples.minValue\" placeholder=\"min\"></md-input-container>\n<md-input-container flex=\"50\" class=\"nl-Form-input--noError\"><input type=\"number\" min=\"0\" max=\"10000\" \nng-model=\"peoples.maxValue\" placeholder=\"max\"></md-input-container></div><md-input-container><label \ntranslate=\"SETTINGS.DATABASE.COMPANIES.MEETING_ROOMS\"></label><input type=\"number\" step=\"1\" \nng-model=\"meetingRooms.minValue\" min=\"0\" max=\"10000\" placeholder=\"more than\"></md-input-container></div></div><div \nflex=\"25\" flex-offset=\"75\" class=\"pt-20\"><button type=\"submit\" class=\"nl-Item-button\">\n{{\'COMPANIES.FILTER\' | translate}}</button></div></div><div class=\"pv-25\" \ninfinite-scroll=\"loadMoreCompanies(null, null)\" infinite-scroll-disabled=\"infiniteScrollPrevent\" \ninfinite-scroll-container=\"\'#content-container\'\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"3\">\n<div class=\"nl-prestataire-search-item animated fadeIn\" layout=\"row\" layout-align=\"start start\" \nng-repeat=\"company in companies track by company.id\"><div flex=\"75\" layout=\"column\" class=\"pr-20\"><div><div \nclass=\"nl-prestataire-search-item-title\">\n{{company.modelPattern}}{{ company.category != null ? \' - \' + company.category : \'\'}}{{ company.location != null ? \' - \' + company.location : \'\' }}\n</div><div class=\"nl-prestataire-search-item-subtitle\">\n{{company.category}} {{company.category != null ? (company.bedrooms ? \' | \' + company.bedrooms + \" bedrooms \": \'\') : (company.bedrooms ? company.bedrooms+ \" bedrooms \":\'\')}} {{company.category != null || company.bedrooms !=null ? (company.rooms ? \' | \' + company.rooms + \" meeting rooms \":\'\') : (company.rooms ? company.rooms+ \" meeting rooms \":\'\')}} {{company.category != null || company.bedrooms !=null || company.rooms !=null ? (company.maxTheatre ? \' | \' + company.maxTheatre + \" max capacity in theatre style \":\'\') : (company.maxTheatre ? company.maxTheatre+ \" max capacity in theatre style \":\'\')}}\n</div></div><div><div class=\"nl-prestataire-search-item-description pr-20\">{{company.resume | nlEllipsis: 1200}}</div>\n</div></div><div flex=\"25\" layout=\"column\" class=\"nl-prestataire-search-item-side\"><div \nclass=\"nl-prestataire-search-item-imgWrapper mb-15\" ng-if=\"company.logo != null && company.logo.length > 0\"><img \nclass=\"nl-prestataire-search-item-img nl-img--logo\" ng-src=\"{{URL.alternatedocroots + \'/\' + company.logo}}\" alt=\"\">\n</div><div class=\"nl-prestataire-search-item-imgWrapper mt-16\" \nng-if=\"company.photos != null && company.photos.length > 0\"><img class=\"nl-prestataire-search-item-img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + company.photos[0].location}}\" alt=\"\"></div><div class=\"mt-16\"><button \ntype=\"button\" ng-click=\"details(\'{{{PAGE_NAME_DETAILS_COMPANY}}}\', company.id)\" class=\"nl-Item-button pr-20\">\nEn savoir plus</button></div></div></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div \nclass=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div \nclass=\"half-circle\"></div></div></div></div></div></div></div></form></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/search_packages.template.type.html","<div class=\"nl_Row-content\" md-theme=\"teal-theme\"><form name=\"filterPackagesForm\" novalidate \nng-submit=\"filterPackages()\"><h1 class=\"nl-titre--main nl--center\" translate=\"\">Rechercher un package</h1><div \nclass=\"\" layout=\"row\" layout-align=\"center stretch\" layout-wrap><div flex=\"50\" class=\"p-5\"><div class=\"\"><div \nclass=\"nl-prestataire-search-title\">Par région</div><md-input-container><md-select ng-model=\"filter.regions.value\">\n<md-option ng-value=\"region\" ng-repeat=\"region in filter.regions.listFieldsDTO | orderBy: \'index\' track by region.id\">\n{{region.value}}</md-option></md-select><label translate=\"SETTINGS.DATABASE.COMPANIES.REGION\"></label>\n</md-input-container></div></div><div flex=\"50\" class=\"p-5\"><div class=\"\"><div class=\"nl-prestataire-search-title\">\nPar type de tourisme</div><md-input-container><md-select ng-model=\"filter.tourisms.value\"><md-option ng-value=\"type\" \nng-repeat=\"type in filter.tourisms.listFieldsDTO | orderBy: \'index\' track by type.id\">{{type.value}}</md-option>\n</md-select><label translate=\"SETTINGS.DATABASE.COMPANIES.TOURISM\"></label></md-input-container></div></div><div \nflex=\"15\" flex-offset=\"85\"><button type=\"submit\" class=\"nl-Item-button\">{{\'COMPANIES.FILTER\' | translate}}</button>\n</div></div><div class=\"mv-50\" infinite-scroll=\"loadMorePackages()\" infinite-scroll-disabled=\"infiniteScrollPrevent\" \ninfinite-scroll-container=\"\'#content-container\'\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"3\">\n<div class=\"nl-prestataire-search-item animated fadeIn\" layout=\"row\" layout-align=\"start start\" \nng-repeat=\"package in packages track by package.id\"><div flex=\"75\" layout=\"column\" class=\"pr-20\"><div><div \nclass=\"nl-prestataire-search-item-title\">{{package.name}}</div><div class=\"nl-prestataire-search-item-text mb-10\">\n{{package.duration}} {{\'GENERAL.DAYS_WORD\' | translate}} | {{package.region.value}} | {{package.typeTourisme.value}}\n</div></div><div><div class=\"nl-prestataire-search-item-description pr-20 ql-editor\" \nng-bind-html=\"trustAsHtml(package.description | nlEllipsis: 400)\"></div></div></div><div flex=\"25\" layout=\"column\" \nclass=\"nl-prestataire-search-item-side\"><div class=\"nl-prestataire-search-item-imgWrapper mb-15\"><img \nng-if=\"package.companyLogo == null || package.companyLogo.length === 0\" \nclass=\"nl-prestataire-search-item-img nl-img--logo\" src=\"assets/images/slick/1.jpg\" alt=\"\"> <img \nng-if=\"package.companyLogo != null && package.companyLogo.length > 0\" \nclass=\"nl-prestataire-search-item-img nl-img--logo\" ng-src=\"{{URL.alternatedocroots + \'/\' + package.companyLogo}}\" \nalt=\"\"></div><div class=\"nl-prestataire-search-item-imgWrapper\"><img \nng-if=\"package.documents != null && package.documents.length > 0\" class=\"nl-prestataire-search-item-img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + package.documents[0].location}}\" alt=\"\"></div><div class=\"mt-16\"><button \ntype=\"button\" ng-click=\"details(\'{{{PAGE_NAME_DETAILS_PACKAGE}}}\', package.id)\" class=\"nl-Item-button\">En savoir plus\n</button></div></div></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div \nclass=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\">\n</div></div></div></div></div></div></form></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/search_tourist_attractions.template.type.html","<div class=\"nl_Row-content\" md-theme=\"teal-theme\"><form name=\"filterAttractionsForm\" novalidate \nng-submit=\"filterTourists()\"><h1 class=\"nl-titre--main nl--center\" translate=\"\">Rechercher une attraction touristique\n</h1><div class=\"\" layout=\"row\" layout-align=\"center stretch\" layout-wrap><div flex=\"50\" class=\"p-5\"><div class=\"\"><div\n class=\"nl-prestataire-search-title\">Par région</div><md-input-container><md-select ng-model=\"filter.regions.value\">\n<md-option ng-value=\"region\" ng-repeat=\"region in filter.regions.listFieldsDTO | orderBy: \'index\' track by region.id\">\n{{region.value}}</md-option></md-select><label translate=\"SETTINGS.DATABASE.COMPANIES.REGION\"></label>\n</md-input-container></div></div><div flex=\"50\" class=\"p-5\"><div class=\"\"><div class=\"nl-prestataire-search-title\">\nPar type de tourisme</div><md-input-container><md-select ng-model=\"filter.tourisms.value\"><md-option ng-value=\"type\" \nng-repeat=\"type in filter.tourisms.listFieldsDTO | orderBy: \'index\' track by type.id\">{{type.value}}</md-option>\n</md-select><label translate=\"SETTINGS.DATABASE.COMPANIES.TOURISM\"></label></md-input-container></div></div><div \nflex=\"15\" flex-offset=\"85\"><button type=\"submit\" class=\"nl-Item-button\">{{\'COMPANIES.FILTER\' | translate}}</button>\n</div></div><div class=\"mv-50\" infinite-scroll=\"loadMoreTourists()\" infinite-scroll-container=\"\'#content-container\'\" \ninfinite-scroll-disabled=\"infiniteScrollPrevent\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"3\">\n<div class=\"nl-prestataire-search-item animated fadeIn\" layout=\"row\" layout-align=\"start start\" \nng-repeat=\"tourist in tourists\"><div flex=\"75\" layout=\"column\" class=\"pr-20\"><div><div \nclass=\"nl-prestataire-search-item-title\">{{tourist.name}}</div></div><div><div \nclass=\"nl-prestataire-search-item-description nl-crop pr-5 ql-editor\" \nng-bind-html=\"trustAsHtml(tourist.description) | nlEllipsis: 400)\"></div></div></div><div flex=\"25\" layout=\"column\" \nclass=\"\"><div class=\"nl-prestataire-search-item-imgWrapper\"><img class=\"nl-prestataire-search-item-img\" \nng-if=\"tourist.photos != null && tourist.photos.length > 0\" \nng-src=\"{{URL.alternatedocroots + \'/\' + tourist.photos[0].location}}\" alt=\"\"></div><div class=\"mt-16\"><button \ntype=\"button\" ng-click=\"details(\'{{{PAGE_NAME_DETAILS_TOURIST}}}\', tourist.id)\" class=\"nl-Item-button pr-20\">\nEn savoir plus</button></div></div></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div \nclass=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div \nclass=\"half-circle\"></div></div></div></div></div></div></form></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/table.template.type.html","<div class=\"nl_Row-content\"><table \nclass=\"dataTable row-border nl-Tablegit nl-Table--center nl-prestataire-table nl-prestataire-table--common\"><tr><th>\nColumn 1</th><th>Column 2</th><th>Column 3</th><th>Column 4</th></tr><tr><td>Line 1-1</td><td>Line 1-2</td><td>Line 1-3\n</td><td>Line 1-4</td></tr><tr><td>Line 2-1</td><td>Line 2-2</td><td>Line 2-3</td><td>Line 2-4</td></tr></table></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/temoignages.template.type.html","<div class=\"nl_Row-content\"><div layout=\"row\" class=\"nl-Temoignage\"><div><div class=\"nl-Temoignage-avatar\"><img \nclass=\"nl-Temoignage-avatar-img\" src=\"assets/images/avatars/alice.jpg\" alt=\"\"></div></div><div><div \nclass=\"nl-Temoignage-name\">Ine Gerrits<span>, 3vents, Belgique</span></div><div class=\"nl-Temoignage-text\">\nOur first event in Beirut was a big success! And the DMC did a great job; our client was very happy !</div><div \nclass=\"nl-Temoignage-date\">26/01/2018</div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/tourist_attraction.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-prestataire-search--slick\" \nng-if=\"tourist.photos && tourist.photos.length > 0\"><div class=\"nl_slick--wrapper\"><button type=\"button\" \nng-click=\"_touristSlickConfig.method.slickPrev()\" class=\"nl_slick--button\"><img \nsrc=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"_touristSlickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button-right\"><img \nsrc=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick settings=\"_touristSlickConfig\" style=\"height: 400px\">\n<div class=\"nl_slick--slide\" ng-repeat=\"_photo in tourist.photos\"><img class=\"nl_slick--slide--img\" \nng-src=\"{{_photo.url}}\" alt=\"\"></div></slick></div></div><div layout=\"row\" class=\"nl-prestataire-search-item\"><div \nflex=\"70\" class=\"pr-20\"><div layout=\"column\"><div class=\"nl-titre--main nl--item\">{{tourist.name}}</div><div><div \nclass=\"nl-prestataire-search-item-description ql-editor\" ng-bind-html=\"trustAsHtml(tourist.description)\"></div></div>\n</div></div><div flex=\"30\" class=\"nl-prestataire-search-item-side\"><div layout=\"column\"><div \nclass=\"nl-prestataire-search-detail-aside\"><div class=\"layout-row layout-align-space-between-start\"><div \nclass=\"nl-prestataire-search-item-title title--panel\">Ville:</div><div class=\"nl-prestataire-search-item-text mb-10\">\n{{tourist.city.value}}</div></div><div class=\"layout-row layout-align-space-between-start\"><div \nclass=\"nl-prestataire-search-item-title title--panel\">Lieu:</div><div class=\"nl-prestataire-search-item-text mb-10\">\n{{tourist.region.value}}</div></div><div class=\"layout-row layout-align-space-between-start\"><div \nclass=\"nl-prestataire-search-item-title title--panel\">Type:</div><div class=\"nl-prestataire-search-item-text\"><span \nng-repeat=\"type in tourist.typeTourisme | orderBy: \'value\'\">\n{{type.value}}{{!$last && tourist.typeTourisme.length > 1 ? \' - \' : \'\'}}</span></div></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/sites_management/blocs/bloc/video.template.type.html","<div class=\"nl_Row-content\"><div class=\"mv-20\"><iframe width=\"100%\" height=\"350px\" \nsrc=\"https://www.youtube.com/embed/8DHV0q-qb0o?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\"></iframe></div>\n</div>");
$templateCache.put("app/main/sites_management/pages/page/page.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"\" translate=\"SITES_MANAGEMENT.PAGES.ADD\" \nng-if=\"!page.id\"></div><div class=\"\" translate=\"SITES_MANAGEMENT.PAGES.MAJ\" ng-if=\"page.id\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"button\" class=\"\" ng-click=\"_pagesListFn()\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon>{{\'SITES_MANAGEMENT.PAGES.LIST\' | translate}}</md-button><md-button \ntype=\"button\" class=\"\" ng-click=\"_delete()\" ng-if=\"page.id\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>\n{{\'SITES_MANAGEMENT.ACTIONS.DELETE\' | translate}}</md-button><md-button type=\"button\" class=\"\" \nng-click=\"_save(pageForm)\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n{{\'SITES_MANAGEMENT.ACTIONS.SAVE\' | translate}}</md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp p-40\"><div layout=\"column\"><form name=\"pageForm\" class=\"md-inline-form\" novalidate>\n<md-input-container class=\"\"><input type=\"text\" name=\"name\" ng-model=\"page.name\" \nplaceholder=\"{{\'SITES_MANAGEMENT.PAGES.FIELDS.NAME\' | translate}}\" required><div class=\"\" \nng-messages=\"pageForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"\"><md-select ng-model=\"page.sites\" \nmultiple=\"multiple\" placeholder=\"{{\'SITES_MANAGEMENT.PAGES.FIELDS.SITE\' | translate}}\" ng-change=\"_changeSiteFn();\" \nrequired ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"_thisSite in sites | orderBy : \'name\' track by $index\" ng-value=\"_thisSite\">{{_thisSite.name}}</md-option>\n</md-select><div class=\"\" ng-messages=\"pageForm.site.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"mt-40\"><md-select \nname=\"language\" ng-model=\"page.targetLanguage\" placeholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS.LANGUAGE\' | translate}}\" \nng-change=\"_changeLanguageFn($index);\" required ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"lang in languages | orderBy : \'libelle\'\" ng-value=\"lang\">{{lang.libelle}}</md-option></md-select><div \nclass=\"\" ng-messages=\"pageForm.language.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><fieldset class=\"standard mt-20 mb-20\" \nng-repeat=\"_pageBloc in page.pageBlocs | orderBy : \'index\' track by $index\"><div layout=\"row\"><md-input-container \nclass=\"\" flex=\"80\"><md-select name=\"bloc{{$index}}\" ng-model=\"_pageBloc.bloc\" \nplaceholder=\"{{\'SITES_MANAGEMENT.PAGES.FIELDS.BLOC\' | translate}}\" required ng-model-options=\"{trackBy: \'$value.id\'}\">\n<md-option ng-repeat=\"_thisBloc in blocs | orderBy : \'name\' track by _thisBloc.id\" ng-value=\"_thisBloc\">\n{{_thisBloc.name}}</md-option></md-select><div class=\"\" ng-messages=\"pageForm[\'bloc\'+$index].$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><div \nclass=\"ml-15\" layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"moveBloc(_pageBloc, true, pageForm)\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(_pageBloc.index > 1 && page.pageBlocs.length > 1)\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\">\n</md-icon></md-button><md-button ng-click=\"moveBloc(_pageBloc, false, pageForm)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"(_pageBloc.index == page.pageBlocs.length)\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div><md-button md-no-ink \nclass=\"nl-listing-item-button md-accent\" type=\"button\" ng-click=\"showHtml(_pageBloc)\" flex=\"20\">Show html</md-button>\n</div><md-input-container class=\"\" ng-if=\"_pageBloc.showHtml\"><textarea name=\"html{{$index}}\" \nng-model=\"_pageBloc.html\" required></textarea><div class=\"\" ng-messages=\"pageForm[\'html\'+$index].$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><div \nng-repeat=\"_pageBlocTranslation in _pageBloc.pageBlocTranslations  | orderBy : \'key\' track by $index\">\n<md-input-container class=\"\"><textarea name=\"value{{$index}}\" ng-model=\"_pageBlocTranslation.value\" required>\n</textarea><label>{{_getCleanKey(_pageBlocTranslation.key)}}</label><div class=\"\" \nng-messages=\"pageForm[\'value\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><md-button type=\"button\" class=\"\" \nng-click=\"_removePageBlocFn(_pageBloc.id, pageForm)\" ng-if=\"blocs.length > 0\"><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon>{{\'SITES_MANAGEMENT.ACTIONS.DELETE\' | translate}}</md-button></fieldset>\n<div layout=\"row\" layout-align=\"start center\" class=\"pt-20\"><md-button type=\"button\" class=\"\" \nng-click=\"_addPageBlocFn(pageForm)\" ng-if=\"blocs.length > 0\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'SITES_MANAGEMENT.PAGES.ADD_BLOC\' | translate}}</md-button></div></form></div></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/events/inscriptions/forms/popup/add_form.html","<md-dialog class=\"company-disposition-dialog nl-Modal\" aria-label=\"Disposition\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"addForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'INSCRIPTION_FORMS.NEW\' | translate}}</div>\n</div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-input-container><input \ntype=\"text\" maxlength=\"255\" ng-model=\"newForm.name\" name=\"name\" required><label>\n{{\"INSCRIPTION_FORMS.COLUMNS.NAME\"|translate}} *</label><div class=\"pl-5\" ng-messages=\"addForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container><label>{{\"INSCRIPTION_FORMS.COLUMNS.MODEL_SUBTYPE\"|translate}}</label>\n<md-select ng-model=\"newForm.subtype\" ng-model-options=\"{trackBy: \'$value.id\'}\" name=\"subtype\" required><md-option \nng-repeat=\"subtype in subtypes track by subtype.id\" ng-value=\"subtype\">{{subtype.name}}</md-option></md-select><div \nclass=\"pl-5\" ng-messages=\"addForm.subtype.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container><label>\n{{\"INSCRIPTION_FORMS.COLUMNS.SUB_CATEGORY\"|translate}}</label><md-select ng-model=\"newForm.subCategory\" \nng-model-options=\"{trackBy: \'$value.id\'}\" name=\"subCategory\"><md-option \nng-repeat=\"category in subcategories track by category.id\" ng-value=\"category\">{{category.name}}</md-option>\n</md-select></md-input-container><md-input-container><md-checkbox class=\"md-primary md-hue-2\" \nng-model=\"newForm.paginated\" name=\"paginated\">{{\"INSCRIPTION_FORMS.COLUMNS.MULTIPLE_PAGES\"|translate}}</md-checkbox>\n</md-input-container></md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button \ntype=\"button\" ng-click=\"save();\" md-no-ink class=\"md-primary md-hue-2 md-raised\" \nng-disabled=\"addForm.$invalid || addForm.$pristine\" translate=\"GENERAL.SAVE\"></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/events/inscriptions/forms/popup/condition.html","<md-dialog class=\"company-disposition-dialog nl-Modal\" aria-label=\"Disposition\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"conditionForm\" class=\"md-inline-form\" novalidate ng-submit=\"conditionForm.$valid && saveCondition()\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'INSCRIPTION_FORMS.ADD_CONDITION\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div translate=\"INSCRIPTION_FORMS.ADD_CONDITION_HELP\" class=\"mb-10\"></div>\n<md-input-container><label>{{\"INSCRIPTION_FORMS.FORM_FIELD\"|translate}}</label><md-select \nng-model=\"field.fieldCondition\" ng-model-options=\"{trackBy: \'$value.id\'}\" name=\"fieldCondition\" required \nng-change=\"console.log(field.fieldCondition)\"><md-option ng-value=\"null\"></md-option><md-option \nng-repeat=\"field in conditionalFields | orderBy: \'name\' track by field.id\" ng-value=\"field\">{{field.name}}</md-option>\n</md-select></md-input-container><md-input-container><label>{{\"INSCRIPTION_FORMS.CONDITION\"|translate}}</label>\n<md-select ng-model=\"field.condition\" ng-disabled=\"field.fieldCondition == null || field.fieldCondition.field == null\" \nng-model-options=\"{trackBy: \'$value.id\'}\" name=\"condition\" required><md-option ng-value=\"null\"></md-option><md-option \nng-repeat=\"list in field.fieldCondition.field.listFieldsDTO | orderBy: \'index\' track by list.id\" ng-value=\"list\">\n{{list.value}}</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button type=\"submit\" md-no-ink class=\"md-primary md-hue-2 md-raised\" \nng-disabled=\"conditionForm.$invalid || conditionForm.$pristine\" translate=\"GENERAL.SAVE\"></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/globe_network/companies/contacts/popup/add_contact.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add contact\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"addContactForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'CONTACTS.ADD\' | translate}}</div></div>\n<md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><noo-infos-model \nng-model=\"categories\" edition=\"false\" form-name=\"addContactForm\" model-type=\"modelType\" model=\"newContact\">\n</noo-infos-model></md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"submit\" \nng-click=\"saveContact(addContactForm)\" class=\"md-primary md-hue-2 submit-button md-raised\" \nng-disabled=\"addContactForm.$invalid || addContactForm.$pristine\" aria-label=\"Sauvegarder\">Sauvegarder</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/globe_network/companies/contacts/popup/move_contact.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Move contact\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"moveContactForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'CONTACTS.MOVE\' | translate}}</div></div>\n<md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-input-container \nclass=\"nl-Input-container\"><label translate=\"SETTINGS.DATABASE.COMPANIES.TITLE\"></label><md-autocomplete \nmd-selected-item=\"contact.company\" md-item-text=\"printCompany(item)\" md-search-text=\"searchText\" \nmd-items=\"item in searchCompany(searchText)\"><md-item-template><span md-highlight-text=\"searchText\">\n{{printCompany(item)}}</span></md-item-template></md-autocomplete></md-input-container></md-dialog-content>\n<md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"submit\" \nng-click=\"moveContact(moveContactForm)\" class=\"md-primary md-hue-2 submit-button md-raised\" \nng-disabled=\"moveContactForm.$invalid || moveContactForm.$pristine\" aria-label=\"Sauvegarder\" translate=\"GENERAL.SAVE\">\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/globe_network/companies/contacts/popup/subscribe.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Subscribe contact\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"subscribeForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'CONTACTS.SUBSCRIBE\' | translate}}</div></div>\n<md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-input-container \nclass=\"nl-Input-container\"><label translate=\"EVENT.TITLE\"></label><md-select ng-model=\"event\" \nng-model-options=\"{trackBy: \'$value.id\'}\" name=\"event\" required><md-option \nng-repeat=\"event in events | orderBy: \'event.name\' track by event.id\" ng-value=\"event\">{{event.name}}</md-option>\n</md-select><div ng-messages=\"subscribeForm.event.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button type=\"submit\" ng-click=\"subscribe(subscribeForm)\" \nclass=\"md-primary md-hue-2 submit-button md-raised\" ng-disabled=\"subscribeForm.$invalid || subscribeForm.$pristine\" \naria-label=\"Sauvegarder\" translate=\"GENERAL.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mailing/blocs/bloc/templates/test.template.type.html","<div><h1>Bonjour {{{NAME}}} Lorem ipsum dolor sit amet consectetur adipisicing elit.</h1><div>\nLorem ipsum dolor sit amet consectetur adipisicing elit. Autem, nam inventore. Dicta sint sed, officiis doloribus, pariatur optio sunt tempore corporis, ad debitis earum consequuntur maxime molestiae explicabo dolor expedita!Voluptate provident facilis porro reprehenderit fugit, explicabo laborum sed praesentium quod aspernatur velit excepturi iure impedit, consectetur fugiat facere accusantium cumque? Autem vitae quibusdam exercitationem ea quas cum, quasi inventore.\n</div><div layout=\"row\" layout-align=\"center stretch\"><div flex=\"20\" class=\"\"><div class=\"\"><div \nclass=\"nl-rowImage-title\">Img 1</div><img class=\"nl-rowImage-img\" src=\"http://placehold.it/120x120&text=image1\" alt=\"\">\n</div></div><div flex=\"20\" class=\"\"><div class=\"\"><div class=\"nl-rowImage-title\">Img 2</div><img \nclass=\"nl-rowImage-img\" src=\"http://placehold.it/120x120&text=image2\" alt=\"\"></div></div><div flex=\"20\" class=\"\"><div \nclass=\"\"><div class=\"nl-rowImage-title\">Img 3</div><img class=\"nl-rowImage-img\" \nsrc=\"http://placehold.it/120x120&text=image3\" alt=\"\"></div></div><div flex=\"20\" class=\"\"><div class=\"\"><div \nclass=\"nl-rowImage-title\">Img 4</div><img class=\"nl-rowImage-img\" src=\"http://placehold.it/120x120&text=image4\" alt=\"\">\n</div></div><div flex=\"20\" class=\"\"><div class=\"\"><div class=\"nl-rowImage-title\">Img 5</div><img \nclass=\"nl-rowImage-img\" src=\"http://placehold.it/120x120&text=image5\" alt=\"\"></div></div></div></div>");
$templateCache.put("app/main/sitegen/account/folder/popup/details_folder.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add to folder\" flex=\"40\" md-theme=\"teal-theme\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'SITE_GEN.FOLDER.DETAILS\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"flex-100\" layout=\"row\" layout-wrap layout-align=\"space-between center\"><h3 \nclass=\"nl-Popup__title\" ng-if=\"folder.companies.length > 0\" translate=\"SITE_GEN.FOLDER.COMPANIES\"></h3><div \nclass=\"nl-Popup__list__item flex-100 layout-row layout-align-space-between-center\" \nng-repeat=\"company in folder.companies\"><div>{{company.modelPattern}}</div><div layout=\"row\" layout-align=\"end center\">\n<a class=\"nl-Btn nl-Btn-sm nl-Btn-primary\" target=\"_blank\" \nng-href=\"{{$root.site.url + \'/\' + $root.site.companyUrl + \'?param1=\' + company.id}}\">\n{{\'SITE_GEN.FOLDER.SEE\' | translate}}</a><md-button type=\"button\" ng-click=\"delete(company.id, \'company\')\" \nclass=\"nl-Btn nl-Btn-sm nl-Btn-grey md-button md-default-theme md-ink-ripple\">{{\'SITE_GEN.FOLDER.DELETE\' | translate}}\n</md-button></div></div><div class=\"mt-20\"><h3 class=\"nl-Popup__title\" flex=\"100\" ng-if=\"folder.articles.length > 0\" \ntranslate=\"SITE_GEN.FOLDER.ARTICLES\"></h3></div><div \nclass=\"nl-Popup__list__item flex-100 layout-row layout-align-space-between-center\" \nng-repeat=\"article in folder.articles\"><div>{{article.name}}</div><div layout=\"row\" layout-align=\"end center\"><a \nclass=\"nl-Btn nl-Btn-sm nl-Btn-primary\" target=\"_blank\" \nng-href=\"{{$root.site.url + \'/\' + $root.site.articleUrl + \'?param1=\' + article.id}}\">\n{{\'SITE_GEN.FOLDER.SEE\' | translate}}</a><md-button type=\"button\" ng-click=\"delete(article.id, \'article\')\" \nclass=\"nl-Btn nl-Btn-sm nl-Btn-grey md-button md-default-theme md-ink-ripple\">{{\'SITE_GEN.FOLDER.DELETE\' | translate}}\n</md-button></div></div><div class=\"nl-Popup__list__item--2 mt-30\"><div \nclass=\"flex-100 layout-row layout-align-start-center\"><md-input-container class=\"nl-Input-container\" flex=\"100\"><label \ntranslate=\"SITE_GEN.FOLDER.RFP\"></label><md-select name=\"rfp\" ng-model=\"folder.rfp\" \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"rfp in rfps | orderBy : \'cahierDeCharges.name\' track by $index\" ng-value=\"rfp\">\n{{rfp.cahierDeCharges ? rfp.cahierDeCharges.name : \'\'}}</md-option></md-select></md-input-container><md-button \ntype=\"button\" ng-if=\"folder.rfp != null\" ng-click=\"delete(folder.rfp.id, \'rfp\')\" \nclass=\"nl-Btn nl-Btn-sm nl-Btn-primary md-button md-default-theme md-ink-ripple\">\n{{\'SITE_GEN.FOLDER.DELETE\' | translate}}</md-button></div><div class=\"flex-100 layout-row layout-align-start-center\">\n<md-input-container class=\"nl-Input-container\" flex=\"100\"><label translate=\"SITE_GEN.FOLDER.CC\"></label><md-select \nname=\"cc\" ng-model=\"folder.cc\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"cc in ccs | orderBy : \'name\' track by $index\" ng-value=\"cc\">{{cc.name}}</md-option></md-select>\n</md-input-container><md-button type=\"button\" ng-if=\"folder.cc != null\" ng-click=\"delete(folder.cc.id, \'cc\')\" \nclass=\"nl-Btn nl-Btn-sm nl-Btn-primary md-button md-default-theme md-ink-ripple\">\n{{\'SITE_GEN.FOLDER.DELETE\' | translate}}</md-button></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sitegen/account/ma_selection/popup/add_to_folder.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add to folder\" flex=\"60\" md-theme=\"teal-theme\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'SITE_GEN.ADD_TO_FOLDER\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"flex-100\" layout=\"row\" layout-align=\"space-between center\"><button \ntype=\"button\" class=\"nl-Item-button\" ng-click=\"mode = \'ADD_TO_EXISTANT_FOLDER\'\">\n{{\'SITE_GEN.ADD_TO_EXISTANT_FOLDER\' | translate}}</button> <button type=\"button\" class=\"nl-Item-button ml-5\" \nng-click=\"mode = \'CREATE_FOLDER\'\">{{\'SITE_GEN.CREATE_FOLDER\' | translate}}</button></div><div class=\"flex-100\"><div \nclass=\"nl_Row-content\" ng-if=\"mode === \'ADD_TO_EXISTANT_FOLDER\'\"><div class=\"nl--Container\"><div \nng-if=\"!alreadyOnFolder\" layout=\"row\" class=\"nl-Form-xs\"><form name=\"addToFolderForm\" class=\"flex-100 mt-30\" \nnovalidate ng-submit=\"addToFolderForm.$valid && save()\"><h3 ng-if=\"folders.length === 0\">\n{{\'SITE_GEN.NO_FOLDERS_AVAILABLE\' | translate}}</h3><fieldset class=\"nl-Fieldset nl-Fieldset--noMarginTop\" \nng-if=\"folders.length > 0\"><legend translate=\"SITE_GEN.ADD_TO_FOLDER\"></legend><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><label translate=\"SITE_GEN.FOLDER.NAME\"></label><md-select name=\"folder\" \nrequired ng-model=\"existantFolder.folder\"><md-option ng-repeat=\"folder in folders | orderBy : \'name\' track by $index\" \nng-value=\"folder\">{{folder.name}}</md-option></md-select><div ng-messages=\"addToFolderForm.folder.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><button \nclass=\"nl-Stepper__btn centered\" type=\"submit\" ng-disabled=\"addToFolderForm.$invalid\">\n{{\'SITE_GEN.FOLDER.SAVE\' | translate}}</button></fieldset></form></div><div ng-if=\"alreadyOnFolder\" layout=\"row\" \nlayout-align=\"center\" class=\"nl-Form-xs\"><span class=\"nl-Details__subText mt-20\" ng-if=\"type==\'article\'\">\n{{\'SITE_GEN.ARTICLE_ALREADY_ADDED\' | translate}}</span> <span class=\"nl-Details__subText mt-20\" \nng-if=\"type==\'company\'\">{{\'SITE_GEN.COMPANY_ALREADY_ADDED\' | translate}}</span></div></div></div><div \nclass=\"nl_Row-content\" ng-if=\"mode === \'CREATE_FOLDER\'\"><div class=\"nl--Container\"><div layout=\"row\" \nclass=\"nl-Form-xs\"><form name=\"addFolderForm\" class=\"flex-100 mt-30\" novalidate \nng-submit=\"addFolderForm.$valid && save()\"><fieldset class=\"nl-Fieldset nl-Fieldset--noMarginTop\"><legend>\n{{\'SITE_GEN.CREATE_FOLDER\' | translate}}</legend><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input\n type=\"text\" ng-model=\"folder.name\" name=\"name\" required><label>{{\"SITE_GEN.FOLDER.NAME\" | translate}} *</label><div \nng-messages=\"addFolderForm.name.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><button class=\"nl-Stepper__btn centered\" type=\"submit\" ng-disabled=\"addFolderForm.$invalid\">\n{{\'SITE_GEN.FOLDER.SAVE\' | translate}}</button></fieldset></form></div></div></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/sitegen/account/my_cahiers_charges/popup/duplicate_cc.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"editCC\" flex=\"40\" md-theme=\"teal-theme\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.DUPLICATE\' | translate}}</div></div><md-button \nclass=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"nl-Stepper__underBox\"><form \nname=\"duplicateForm\" novalidate><div><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input \ntype=\"text\" ng-model=\"cahier.name\" name=\"name\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.NAME_CC\" | translate}} *</label><div ng-messages=\"duplicateForm.name.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div><button type=\"button\" \nclass=\"nl-Stepper__btn centered\" ng-disabled=\"!duplicateForm.$valid\" ng-click=\"duplicateConfirm()\">\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.DUPLICATE\" | translate}}</button></form></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sitegen/account/my_cahiers_charges/popup/edit_cc_form.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"editCC\" flex=\"60\" md-theme=\"teal-theme\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'SITE_GEN.EDIT_CC\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"flex-100\"><div class=\"nl_Row-content\"><div class=\"nl--Container\"><div \nlayout=\"row\" class=\"nl-Form-xs\"><div flex=\"100\"><div><form name=\"wizardStep2\" novalidate><div class=\"flex-100\">\n<fieldset class=\"nl-Fieldset nl-Fieldset--noMarginTop\"><legend>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.APPLICANT_INFORMATIONS\" | translate}}</legend><label class=\"ml-5\">\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.LOGO\" | translate}}</label><div ng-if=\"!cahier.locationLogo\" layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"nl-Input-container ml-15\" flex=\"50\"><input type=\"file\" \naccept=\"image/*\" id=\"logoRfp\" name=\"logo\"></md-input-container></div><div ng-if=\"cahier.locationLogo\" \nclass=\"layout-row layout-align-start-center\"><img id=\"imageRfp\" class=\"h-150 mr-24\" \nng-src=\"alternatedocroots/{{cahier.locationLogo}}\"><md-button class=\"ml-20 nl-Btn nl-Btn-grey\" \nng-click=\"cahier.locationLogo=null\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><md-input-container\n class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"cahier.applicantCompany\" \nname=\"applicantCompany\" required><label>{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY\" | translate}} *\n</label><div ng-messages=\"wizardStep2.applicantCompany.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"cahier.applicantCompanyType\" \nname=\"applicantCompanyType\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COMPANY_TYPE\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantCompanyType.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.applicantWebSite\" name=\"applicantWebSite\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_WEB_SITE\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><label>\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CIVILITY\' | translate}}</label><md-select name=\"applicantCivility\" \nrequired ng-model=\"cahier.applicantCivility\" ng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"civility in civilities | orderBy : \'toString()\' track by $index\" ng-value=\"civility\">{{civility}}\n</md-option></md-select><div ng-messages=\"wizardStep2.applicantCivility.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"cahier.applicantFirstName\" \nname=\"applicantFirstName\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FIRST_NAME\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantFirstName.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.applicantLastName\" name=\"applicantLastName\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_LAST_NAME\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantLastName.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.applicantFunction\" name=\"applicantFunction\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_FUNCTION\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantFunction.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.applicantAddress1\" name=\"applicantAddress1\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS1\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantAddress1.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.applicantAddress2\" name=\"applicantAddress2\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS2\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"cahier.applicantAddress3\" \nname=\"applicantAddress3\"><label translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_ADDRESS3\"></label>\n</md-input-container><div layout=\"row\" flex><md-input-container class=\"nl-Input-container ml-15\" flex=\"20\"><input \ntype=\"text\" rows=\"1\" ng-model=\"cahier.applicantPostCode\" name=\"applicantPostCode\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_POST_CODE\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantPostCode.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"40\"><input type=\"text\" \nrows=\"1\" ng-model=\"cahier.applicantCity\" name=\"applicantCity\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_CITY\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantCity.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"40\"><input type=\"text\" rows=\"1\" \nng-model=\"cahier.applicantCountry\" name=\"applicantCountry\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_COUNTRY\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantCountry.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container></div><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.applicantDirectPhone\" name=\"applicantDirectPhone\" required><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_DIRECT_PHONE\" | translate}} *</label><div \nng-messages=\"wizardStep2.applicantDirectPhone.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.applicantMobilePhone\" name=\"applicantMobilePhone\"><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_MOBILE_PHONE\"></label></md-input-container>\n<md-input-container ng-if=\"!user\" class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"email\" \nng-model=\"cahier.applicantEmail\" name=\"applicantEmail\" ng-required=\"!user\"><label>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.APPLICANT_EMAIL\" | translate}} *</label></md-input-container></fieldset></div>\n<div class=\"flex-100\"><fieldset class=\"nl-Fieldset nl-Fieldset--noMarginTop\"><legend>\n{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.EVENT_INFORMATIONS\" | translate}}</legend><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"cahier.name\" name=\"name\" required><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.NAME_CC\" | translate}} *</label><div ng-messages=\"wizardStep2.name.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"cahier.eventTitle\" name=\"eventTitle\" required>\n<label>{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TITLE\" | translate}} *</label><div \nng-messages=\"wizardStep2.eventTitle.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.eventType\" name=\"eventType\" required><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TYPE\" | translate}} *</label><div \nng-messages=\"wizardStep2.eventType.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"number\" class=\"\" \nng-model=\"cahier.numberOfParticipants\" name=\"numberOfParticipants\" required min=\"0\" step=\"1\"><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.NUMBER_OF_PARTICIPANTS\" | translate}} *</label><div \nng-messages=\"wizardStep2.numberOfParticipants.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><div layout=\"row\" flex class=\"mt-10\"><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"50\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"cahier.dateStart\" name=\"dateStart\" required></md-datepicker><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.START_DATE\" | translate}} *</label><div \nng-messages=\"wizardStep2.dateStart.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"50\"><md-datepicker \nclass=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" ng-model=\"cahier.dateEnd\" \nname=\"dateEnd\" required></md-datepicker><label>{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.END_DATE\" | translate}} *\n</label><div ng-messages=\"wizardStep2.dateEnd.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container></div><md-input-container \nclass=\"nl-Input-container nl-Input-container--wrap nl-Input-container--marged ml-15\" flex=\"100\"><md-select \nmd-on-open=\"\" md-no-asterisk name=\"desiredActivities \" multiple=\"multiple\" required \nng-model=\"cahier.desiredActivities\" ng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option \nng-repeat=\"desiredActivitiy in desiredActivities track by $index\" ng-value=\"desiredActivitiy.name\">\n{{desiredActivitiy.name}}</md-option></md-select><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.DESIRED_ACTIVITIES\" | translate}} *</label><div \nng-messages=\"wizardStep2.desiredActivities.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"number\" \nng-model=\"cahier.roomNumber\" name=\"roomNumber\" min=\"0\" step=\"1\"><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_NUMBER\" | translate}}</label></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"number\" ng-model=\"cahier.roomCapacityMax\" \nname=\"roomCapacityMax\" min=\"0\" step=\"1\"><label translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.ROOM_CAPACITY_MAX\">\n</label></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><md-select md-on-open=\"\" \nname=\"desiredConfiguration \" ng-model=\"cahier.desiredConfiguration\" ng-model-options=\"{\'trackBy\': \'$value\'}\"><md-option\n ng-repeat=\"desiredConfiguration in desiredConfigurations | orderBy : \'toString()\' track by $index\" \nng-value=\"desiredConfiguration\">{{desiredConfiguration}}</md-option></md-select><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.CONFIGURATION\"></label></md-input-container><div layout=\"row\" flex \nclass=\"mt-10\"><md-input-container class=\"nl-Input-container ml-15\" flex=\"60\"><input type=\"number\" \nng-model=\"cahier.square\" name=\"square\"><label translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE\"></label>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"40\"><md-select md-on-open=\"\" \nname=\"squareUnit\" ng-required=\"cahier.square\" ng-model=\"cahier.squareUnit\" ng-model-options=\"{\'trackBy\': \'$value\'}\">\n<md-option ng-repeat=\"squareUnit in squareUnits | orderBy : \'toString()\' track by $index\" ng-value=\"squareUnit\">\n{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.SQUARE_UNITS.\' + squareUnit | translate}}</md-option></md-select><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.SQUARE_UNIT\"></label><div ng-messages=\"wizardStep2.squareUnit.$error\">\n<span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"cahier.technicalEquipment\" name=\"technicalEquipment\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.TECHNICAL_EQUIPMENT\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><textarea type=\"text\" rows=\"1\" ng-model=\"cahier.precisiontoTheHotel\" \nname=\"precisiontoTheHotel\"></textarea><label translate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_HOTEL\">\n</label></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><textarea type=\"text\" \nrows=\"1\" ng-model=\"cahier.precisiontoTheEventPlace\" name=\"precisiontoTheEventPlace\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_TO_THE_EVENT_PLACE\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"cahier.precisionForTheReceptive\" name=\"precisionForTheReceptive\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_RECEPTIVE\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"cahier.precisionForTheCarrier\" name=\"precisionForTheCarrier\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.PRECISION_FOR_THE_CARRIER\"></label></md-input-container>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><textarea type=\"text\" rows=\"1\" \nng-model=\"cahier.otherPrecision\" name=\"otherPrecision\"></textarea><label \ntranslate=\"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.OTHER_PRECISION\"></label></md-input-container></fieldset></div><div \nlayout=\"row\" layout-align=\"space-between center\"><button class=\"nl-Stepper__btn flex-45\" \nng-click=\"exportForm(wizardStep2,null,wizardStep2.$valid)\">{{\"SITE_GEN.WORKBOOK.EXPORT\" | translate}}</button> <button \nclass=\"nl-Stepper__btn flex-45\" ng-click=\"generateFromForm(wizardStep2,wizardStep2.$valid)\">\n{{\"SITE_GEN.WORKBOOK.VALIDATE_CC\" | translate}}</button></div></form></div></div></div></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/sitegen/account/my_cahiers_charges/popup/edit_cc_pdf.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"editCC\" flex=\"40\" md-theme=\"teal-theme\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'SITE_GEN.EDIT_CC\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"nl-Stepper__underBox\"><div class=\"nl-Stepper__underBox__title\">\n{{\"SITE_GEN.WORKBOOK.DOWNLOAD_NEW_CC_PDF\" | translate}}</div><form name=\"uploadForm\" novalidate><div>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" ng-model=\"cahier.name\" name=\"name\" \nrequired><label>{{\"SITE_GEN.REQUEST_FOR_PROPOSALS.NAME_CC\" | translate}} *</label><div \nng-messages=\"uploadForm.name.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"50\"><md-datepicker \nclass=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" ng-model=\"cahier.dateStart\" \nname=\"dateStart\" required></md-datepicker><label>{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.START_DATE\" | translate}} *\n</label><div ng-messages=\"uploadForm.dateStart.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"50\"><md-datepicker \nclass=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" ng-model=\"cahier.dateEnd\" \nname=\"dateEnd\" required></md-datepicker><label>{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.END_DATE\" | translate}} *\n</label><div ng-messages=\"uploadForm.dateEnd.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nng-model=\"cahier.eventType\" name=\"eventType\" required><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.EVENT_TYPE\" | translate}} *</label><div \nng-messages=\"uploadForm.eventType.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"number\" class=\"\" \nng-model=\"cahier.numberOfParticipants\" name=\"numberOfParticipants\" required min=\"0\" step=\"1\"><label>\n{{ \"SITE_GEN.REQUEST_FOR_PROPOSALS.FIELDS.NUMBER_OF_PARTICIPANTS\" | translate}} *</label><div \nng-messages=\"uploadForm.numberOfParticipants.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><button type=\"button\" \nclass=\"nl-Stepper__btn mr-5\" ng-disabled=\"!uploadForm.$valid\" ng-click=\"saveInfosPDF()\">\n{{\"SITE_GEN.WORKBOOK.SAVE_INFOS_WITHOUT_FILE\" | translate}}</button> <button type=\"button\" \nclass=\"nl-Stepper__btn ml-5\" ng-disabled=\"!uploadForm.$valid\" file-browser>{{\"SITE_GEN.WORKBOOK.DOWNLOAD\" | translate}}\n</button></div></form></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/sitegen/navigation/layouts/horizontal-navigation/navigation.html","");
$templateCache.put("app/main/sitegen/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" \nng-class=\"{\'nl-Leisure\': site.url === \'leisure\', \'nl-Mice\': site.url === \'mice\', \'nl-Pure\': site.url !== \'leisure\' && site.url !== \'mice\'}\" \nlayout=\"column\" layout-align=\"space-between start\"><div class=\"nl_Row-content nl_navigation--logo\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\" layout-align-gt-xs=\"start center\"><div flex=\"20\" flex-sm=\"50\" \nflex-xs=\"100\"><div class=\"logo\" layout=\"row\" layout-align=\"space-between center\" layout-align-gt-xs=\"start center\"><div\n class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><a href \nng-click=\"goToSite(site.url);\" class=\"nl_logo--image--wrapper\"><img ng-if=\"site.logo\" \nng-src=\"{{vm.URL.alternatedocroots}}/{{site.logo}}\" alt=\"\" class=\"nl_logo--image\"></a></div></div><div flex=\"30\" hide \nshow-gt-xs layout=\"column\" layout-align=\"center center\"><div class=\"nl_site-title\">{{site.name}}</div><div \nclass=\"nl_site-slogan\"><span ng-if=\"site.url === \'mice\'\">\nAll the information needed to help you with the organization of your Meetings, Incentives, Congress and Events in Lebanon. \n</span><span ng-if=\"site.url === \'leisure\'\">\nAll the touristic information for the Leisure professionals including itineraries ideas, practical information, etc.\n</span></div></div><div flex=\"50\" hide show-gt-sm layout=\"row\" layout-align=\"end center\"><a ng-href=\"./mice\" \nng-class=\"{\'nl--active\': site.url === \'leisure\'}\" type=\"button\" class=\"nl_button--switch\">Mice Website</a> <a \nng-href=\"./leisure\" ng-class=\"{\'nl--active\': site.url === \'mice\'}\" type=\"button\" class=\"nl_button--switch\">\nLeisure Website</a><md-menu class=\"nl_navigation--header-menu\" ng-if=\"false\"><md-button \nclass=\"nl_navigation--header--btn\" ng-click=\"vm.openMenu($mdMenu, $event)\">Other websites <i \nclass=\"icon-chevron-down s20\"></i></md-button><md-menu-content width=\"4\"><md-menu-item><a \nng-href=\"https://www.visit-lebanon.org/exhibition/en/\" target=\"_blank\">EXHIBITION WEBSITE</a></md-menu-item>\n<md-menu-item ng-repeat=\"_thisSite in sites | orderBy : \'name\' track by $index\" ng-if=\"!_thisSite.current\"><a \ntranslate=\"{{_thisSite.name}}\" ng-href=\"./{{_thisSite.url}}\" target=\"_blank\"></a></md-menu-item></md-menu-content>\n</md-menu><div class=\"nl_navigation--separator\" ng-if=\"sites && sites.length > 1 && site.languagesTmp.length > 1\">\n</div><md-menu class=\"nl_navigation--header-menu\" ng-if=\"site.languagesTmp.length > 1\"><md-button \nclass=\"nl_navigation--header--btn\" ng-click=\"vm.openMenu($mdMenu, $event)\">\n{{\'SITE_GEN.\' + selectedLanguage.key | translate }} <i class=\"icon-chevron-down s20\"></i></md-button><md-menu-content \nwidth=\"4\"><md-menu-item ng-repeat=\"lang in site.languagesTmp | orderBy : \'libelle\' track by $index\" \nng-click=\"vm.changeLanguage(lang);\"><md-button translate=\"{{\'SITE_GEN.\' + lang.key}}\"></md-button></md-menu-item>\n</md-menu-content></md-menu><div class=\"nl_navigation--separator\" ng-if=\"false\"></div><ul class=\"social-nav model-2\">\n<li ng-if=\"site.twitterUrl\"><a href=\"{{site.twitterUrl}}\" target=\"_blank\" class=\"twitter\"><i class=\"fa fa-twitter\"></i>\n</a></li><li ng-if=\"site.facebookUrl\"><a href=\"{{site.facebookUrl}}\" target=\"_blank\" class=\"facebook\"><i \nclass=\"fa fa-facebook\"></i></a></li><li ng-if=\"site.instagramUrl\"><a href=\"{{site.instagramUrl}}\" target=\"_blank\" \nclass=\"instagram\"><i class=\"fa fa-instagram\"></i></a></li><li ng-if=\"site.linkedinUrl\"><a href=\"{{site.linkedinUrl}}\" \ntarget=\"_blank\" class=\"linkedin\"><i class=\"fa fa-linkedin\"></i></a></li><li ng-if=\"site.youtubeUrl\"><a \nhref=\"{{site.youtubeUrl}}\" target=\"_blank\" class=\"pinterest\"><i class=\"fa fa-youtube\"></i></a></li></ul><div \nclass=\"nl_navigation--separator\" \nng-if=\"site.youtubeUrl || site.linkedinUrl || site.instagramUrl || site.facebookUrl || site.twitterUrl\"></div><md-menu \nclass=\"nl_navigation--header-menu\"><md-button class=\"nl_navigation--header--btn\" \nng-click=\"vm.openMenu($mdMenu, $event)\"><span class=\"fa fa-user\"></span><span class=\"ml-5\" \nng-if=\"account && account.applicantFirstName\">{{account.applicantFirstName}}</span> <i class=\"icon-chevron-down s20\">\n</i></md-button><md-menu-content width=\"4\"><md-menu-item ng-click=\"goToLogin();\" ng-if=\"!account\"><md-button \ntranslate=\"{{\'SITE_GEN.ACCOUNT.LOGIN\'}}\"></md-button></md-menu-item><md-menu-item ng-click=\"goToMyProfile();\" \nng-if=\"account\"><md-button translate=\"{{\'SITE_GEN.ACCOUNT.MY_PROFIL\'}}\"></md-button></md-menu-item><md-menu-item \nng-click=\"goToMySelectionOfProviders();\" ng-if=\"account\"><md-button \ntranslate=\"{{\'SITE_GEN.BTN_PROVIDERS_SELECTED_LIST\' | translate}}\"></md-button></md-menu-item><md-menu-item \nng-click=\"goToMyAccount()\" ng-if=\"account\"><md-button translate=\"{{\'SITE_GEN.ACCOUNT.MY_ACCOUNT\'}}\"></md-button>\n</md-menu-item><md-menu-item ng-click=\"logout();\" ng-if=\"account\"><md-button translate=\"{{\'SITE_GEN.ACCOUNT.LOGOUT\'}}\">\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div id=\"horizontal-navigation\" layout=\"row\" \nlayout-align=\"start center\" class=\"nl_navigation nl_Row-content\"><div class=\"nl_navigation--toolbar--wrapper\"><div \nclass=\"ms-navigation-horizontal\"><div class=\"nl_logo-barre-2\" hide-gt-sm layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"navigation-toggle\"><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\">\n</md-icon></md-button></div><a href ng-click=\"goToSite(site.url);\" class=\"nl_logo--image--wrapper\"><img \nng-if=\"site.logo\" ng-src=\"{{vm.URL.alternatedocroots}}/{{site.logo}}\" alt=\"\" class=\"nl_logo--image\"></a></div><ul \nclass=\"horizontal nl_navigation--wrapper\"><li id=\"nl_js--wrapper-{{item.id}}\" \nng-class=\"{\'nl_navigation--parentItem--little\': item.subItems.length <= 2, \'has-children\': item.subItems.length > 0}\" \nclass=\"nl_navigation--parentItem ms-navigation-horizontal-node\" ng-repeat=\"item in menu.items | orderBy: \'index\'\"><div \nclass=\"ms-navigation-horizontal-item nl_navigation--title\" layout=\"row\"><a class=\"ms-navigation-horizontal-button\" \nng-click=\"goToPage(item);toggleMobileMenu()\"><span class=\"title\" flex>{{item.title}}</span> </a><i \nclass=\"nl_icon-lvl1 icon-chevron-right arrow ng-scope\" hide-gt-sm ng-if=\"item.subItems.length > 0\" \nng-click=\"$event.stopPropagation();toggleLvl1(item.title)\"></i></div><ul id=\"nl_js--{{item.title}}\" \nclass=\"nl_navigation--subnav\"><li class=\"ms-navigation-horizontal-node\"><div layout=\"row\" layout-align=\"start stretch\">\n<div layout=\"row\" layout-align=\"start stretch\" ng-class=\"{\'layout-wrap\': isMobile(item.subItems.length) }\" \nstyle=\"width: 100%\"><div ng-class=\"{\'flex-33\': item.subItems.length >= 3 }\" flex-xs=\"100\" \nclass=\"nl_navigation--subnav--item\" ng-repeat=\"subItem in item.subItems | orderBy: \'index\'\" \nid=\"nl_js--lvl2-wrapper-{{subItem.id}}\"><div class=\"nl_navigation--subnav--title\" layout=\"row\" \nlayout-align=\"space-between center\"><div ng-click=\"$event.stopPropagation();goToPage(subItem);toggleMobileMenu()\">\n{{subItem.title}}</div><i class=\"nl_icon-lvl2 icon-chevron-right arrow ng-scope\" hide-gt-sm \nng-hide=\"subItem.subItems.length == 0\" ng-click=\"$event.stopPropagation();toggleLvl2(subItem.id)\"></i></div><div \nlayout=\"column\" id=\"nl_js--lvl2-{{subItem.id}}\" class=\"nl_navigation--subnav--list\"><button type=\"button\" \nng-repeat=\"subSubItem in subItem.subItems | orderBy: \'index\'\" class=\"nl_navigation--subnav--link\" \nng-click=\"$event.stopPropagation();goToPage(subSubItem);toggleMobileMenu()\">{{subSubItem.title}}</button></div></div>\n</div></div></li></ul></li></ul><div class=\"nl_bottomMobile layout-wrap\" layout=\"row\" \nlayout-align=\"space-between center\" hide-gt-sm><div class=\"flex-sm-33 flex-xs-50 mb-5\"><a ng-href=\"./mice\" \nng-class=\"{\'nl--active\': site.url === \'leisure\'}\" type=\"button\" class=\"nl_button--switch\">Mice Website</a> <a \nng-href=\"./leisure\" ng-class=\"{\'nl--active\': site.url === \'mice\'}\" type=\"button\" class=\"nl_button--switch\">\nLeisure Website</a></div><div class=\"flex-sm-33 flex-xs-50 mb-5\"><md-menu \nclass=\"nl_navigation--header-menu flex-sm-50 flex-xs-50\" ng-if=\"sites && sites.length >= 3\"><md-button \nclass=\"nl_navigation--header--btn\" ng-click=\"vm.openMenu($mdMenu, $event)\">Other websites <i \nclass=\"icon-chevron-down s20\"></i></md-button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"_thisSite in sites | orderBy : \'name\' track by $index\" ng-if=\"!_thisSite.current\"><a \ntranslate=\"{{_thisSite.name}}\" ng-href=\"./{{_thisSite.url}}\" target=\"_blank\"></a></md-menu-item></md-menu-content>\n</md-menu></div><div class=\"flex-sm-33 flex-xs-50 mb-5\"><md-menu class=\"nl_navigation--header-menu\" \nstyle=\"margin: 0 8px !important\"><md-button class=\"nl_navigation--header--btn\" ng-click=\"vm.openMenu($mdMenu, $event)\">\nAccount <i class=\"icon-chevron-down s20\"></i></md-button><md-menu-content width=\"4\"><md-menu-item \nng-click=\"goToLogin();\" ng-if=\"!account\"><md-button translate=\"{{\'SITE_GEN.ACCOUNT.LOGIN\'}}\"></md-button>\n</md-menu-item><md-menu-item ng-click=\"goToMyProfile();\" ng-if=\"account\"><md-button \ntranslate=\"{{\'SITE_GEN.ACCOUNT.MY_PROFIL\'}}\"></md-button></md-menu-item><md-menu-item \nng-click=\"goToMyRequestsForProposal();\" ng-if=\"account\"><md-button \ntranslate=\"{{\'SITE_GEN.REQUEST_FOR_PROPOSALS.MY_REQUEST_FOR_PROPOSALS\'}}\"></md-button></md-menu-item><md-menu-item \nng-click=\"logout();\" ng-if=\"account\"><md-button translate=\"{{\'SITE_GEN.ACCOUNT.LOGOUT\'}}\"></md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"flex-sm-50 flex-xs-50 mb-5\" ng-if=\"site.languagesTmp.length > 1\"><md-menu\n class=\"nl_navigation--header-menu\"><md-button class=\"nl_navigation--header--btn\" \nng-click=\"vm.openMenu($mdMenu, $event)\">{{\'SITE_GEN.\' + selectedLanguage.key | translate }} <i \nclass=\"icon-chevron-down s20\"></i></md-button><md-menu-content width=\"4\"><md-menu-item \nng-repeat=\"lang in site.languagesTmp | orderBy : \'libelle\' track by $index\" ng-click=\"vm.changeLanguage(lang);\">\n<md-button translate=\"{{\'SITE_GEN.\' + lang.key}}\"></md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"flex-100\" style=\"text-align: center; margin-top: 24px\"><ul class=\"social-nav model-2\"><li \nng-if=\"site.twitterUrl\"><a href=\"{{site.twitterUrl}}\" target=\"_blank\" class=\"twitter\"><i class=\"fa fa-twitter\"></i></a>\n</li><li ng-if=\"site.facebookUrl\"><a href=\"{{site.facebookUrl}}\" target=\"_blank\" class=\"facebook\"><i \nclass=\"fa fa-facebook\"></i></a></li><li ng-if=\"site.instagramUrl\"><a href=\"{{site.instagramUrl}}\" target=\"_blank\" \nclass=\"instagram\"><i class=\"fa fa-instagram\"></i></a></li><li ng-if=\"site.linkedinUrl\"><a href=\"{{site.linkedinUrl}}\" \ntarget=\"_blank\" class=\"linkedin\"><i class=\"fa fa-linkedin\"></i></a></li><li ng-if=\"site.youtubeUrl\"><a \nhref=\"{{site.youtubeUrl}}\" target=\"_blank\" class=\"pinterest\"><i class=\"fa fa-youtube\"></i></a></li></ul></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/event/event_inscription.template.type.html","<div class=\"nl_Row-content\" ng-init=\"init({{{FORM_ID}}})\"><div class=\"nl--Container\"><div class=\"nl--Steps\" \nng-if=\"!subscribed && form.paginated && form.nbPages > 1\"><ms-form-wizard ng-init=\"msWizard.selectedIndex = 0\"><md-tabs\n md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nng-class=\"{\'etape-0\': msWizard.selectedIndex == 0, \'etape-1\': msWizard.selectedIndex == 1,\'etape-2\': msWizard.selectedIndex == 2,\'etape-3\': msWizard.selectedIndex == 3}\" \nmd-center-tabs=\"true\" class=\"nl--Steps--Tabs\"><md-tab md-on-select=\"updateTitle(msWizard.selectedIndex);\">\n<md-tab-label><span class=\"ms-form-wizard-step-text nl--Steps--Tabs--title\"><span class=\"nl--Steps--Tabs--title-nbr\">1\n</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" ms-form-wizard-form novalidate><div layout=\"row\" \nclass=\"nl-Form-xs nl-Form-xs-registration\"><div flex=\"50\"><div \nng-repeat=\"field in form.fields | filter: {column: 1, page: 1} track by field.id\" ng-form=\"fieldForm\" \nng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" class=\"nl--Steps--mainTitle\">\n{{field.header}}</h1><noo-input-event ng-disabled=\"formValidated\" watch=\"checkConditionAfterUpdate(field)\" \nfield=\"field\" ng-show=\"field._show\" ng-if=\"field.typeField === \'FIELD\'\" ng-required=\"field.required && field._show\" \nsub-type=\"form.subtype.id\" form-name=\"fieldForm\" ng-model=\"field.genericField\" index=\"field.index\" \ncontent=\"{{field.genericField.typeChamps}}\" model-type=\"field.modelType\"></noo-input-event><div \nng-if=\"field.typeField === \'EXPLANATION\' && field._show\" ng-bind-html=\"field.text\"></div></div></div><div flex=\"45\" \nflex-offset=\"5\"><div ng-repeat=\"field in form.fields | filter: {column: 2, page: 1} track by field.id\" \nng-form=\"fieldForm\" ng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" \nclass=\"nl--Steps--mainTitle\">{{field.header}}</h1><noo-input-event ng-disabled=\"formValidated\" \nwatch=\"checkConditionAfterUpdate(field)\" field=\"field\" ng-show=\"field._show\" ng-if=\"field.typeField === \'FIELD\'\" \nng-required=\"field.required && field._show\" sub-type=\"form.subtype.id\" form-name=\"fieldForm\" \nng-model=\"field.genericField\" index=\"field.index\" content=\"{{field.genericField.typeChamps}}\" \nmodel-type=\"field.modelType\"></noo-input-event><div ng-if=\"field.typeField === \'EXPLANATION\'\" \nng-bind-html=\"field.text\"></div></div></div></div></form></md-tab-body></md-tab><md-tab \nmd-on-select=\"updateTitle(msWizard.selectedIndex);\" ng-disabled=\"wizardStep1.$invalid\" ng-show=\"form.nbPages > 1\">\n<md-tab-label><span class=\"ms-form-wizard-step-text nl--Steps--Tabs--title\"><span class=\"nl--Steps--Tabs--title-nbr\">2\n</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form novalidate><div layout=\"row\" \nclass=\"nl-Form-xs nl-Form-xs-registration\"><div flex=\"50\"><div \nng-repeat=\"field in form.fields | filter: {column: 1, page: 2} track by field.id\" ng-form=\"fieldForm\" \nng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" class=\"nl--Steps--mainTitle\">\n{{field.header}}</h1><noo-input-event ng-disabled=\"formValidated\" watch=\"checkConditionAfterUpdate(field)\" \nfield=\"field\" ng-show=\"field._show\" ng-if=\"field.typeField === \'FIELD\'\" ng-required=\"field.required && field._show\" \nsub-type=\"form.subtype.id\" form-name=\"fieldForm\" ng-model=\"field.genericField\" index=\"field.index\" \ncontent=\"{{field.genericField.typeChamps}}\" model-type=\"field.modelType\"></noo-input-event><div \nng-if=\"field.typeField === \'EXPLANATION\' && field._show\" ng-bind-html=\"field.text\"></div></div></div><div flex=\"45\" \nflex-offset=\"5\"><div ng-repeat=\"field in form.fields | filter: {column: 2, page: 2} track by field.id\" \nng-form=\"fieldForm\" ng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" \nclass=\"nl--Steps--mainTitle\">{{field.header}}</h1><noo-input-event ng-disabled=\"formValidated\" \nwatch=\"checkConditionAfterUpdate(field)\" field=\"field\" ng-show=\"field._show\" ng-if=\"field.typeField === \'FIELD\'\" \nng-required=\"field.required && field._show\" sub-type=\"form.subtype.id\" form-name=\"fieldForm\" \nng-model=\"field.genericField\" index=\"field.index\" content=\"{{field.genericField.typeChamps}}\" \nmodel-type=\"field.modelType\"></noo-input-event><div ng-if=\"field.typeField === \'EXPLANATION\' && field._show\" \nng-bind-html=\"field.text\"></div></div></div></div></form></md-tab-body></md-tab><md-tab \nmd-on-select=\"updateTitle(msWizard.selectedIndex);\" ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\" \nng-show=\"form.nbPages > 2\"><md-tab-label><span class=\"ms-form-wizard-step-text nl--Steps--Tabs--title\"><span \nclass=\"nl--Steps--Tabs--title-nbr\">3</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" \nms-form-wizard-form novalidate><div layout=\"row\" class=\"nl-Form-xs nl-Form-xs-registration\"><div flex=\"50\"><div \nng-repeat=\"field in form.fields | filter: {column: 1, page: 3} track by field.id\" ng-form=\"fieldForm\" \nng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" class=\"nl--Steps--mainTitle\">\n{{field.header}}</h1><noo-input-event ng-disabled=\"formValidated\" watch=\"checkConditionAfterUpdate(field)\" \nfield=\"field\" ng-show=\"field._show\" ng-if=\"field.typeField === \'FIELD\'\" ng-required=\"field.required && field._show\" \nsub-type=\"form.subtype.id\" form-name=\"fieldForm\" ng-model=\"field.genericField\" index=\"field.index\" \ncontent=\"{{field.genericField.typeChamps}}\" model-type=\"field.modelType\"></noo-input-event><div \nng-if=\"field.typeField === \'EXPLANATION\' && field._show\" ng-bind-html=\"field.text\"></div></div></div><div flex=\"45\" \nflex-offset=\"5\"><div ng-repeat=\"field in form.fields | filter: {column: 2, page: 3} track by field.id\" \nng-form=\"fieldForm\" ng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" \nclass=\"nl--Steps--mainTitle\">{{field.header}}</h1><noo-input-event ng-disabled=\"formValidated\" \nwatch=\"checkConditionAfterUpdate(field)\" field=\"field\" ng-show=\"field._show\" ng-if=\"field.typeField === \'FIELD\'\" \nng-required=\"field.required && field._show\" sub-type=\"form.subtype.id\" form-name=\"fieldForm\" \nng-model=\"field.genericField\" index=\"field.index\" content=\"{{field.genericField.typeChamps}}\" \nmodel-type=\"field.modelType\"></noo-input-event><div ng-if=\"field.typeField === \'EXPLANATION\' && field._show\" \nng-bind-html=\"field.text\"></div></div></div></div></form></md-tab-body></md-tab></md-tabs><div flex layout=\"row\" \nlayout-align=\"space-between center\" class=\"nl--Steps--footer\"><md-button class=\"nl-Btn nl-Btn-primary nl-Btn-clear\" \ntype=\"button\" ng-if=\"msWizard.isFirstStep()\" ng-click=\"msWizard.previousStep()\">{{\'GENERAL.CANCEL\' | translate }}\n</md-button><md-button class=\"nl-Btn nl-Btn-primary nl-Btn-clear\" type=\"button\" ng-if=\"!msWizard.isFirstStep()\" \nng-click=\"msWizard.previousStep()\">{{\'GENERAL.PREVIOUS\' | translate }}</md-button><md-button \nclass=\"nl-Btn nl-Btn-primary\" type=\"button\" ng-if=\"!msWizard.isLastStep()\" ng-click=\"saveStep(msWizard);\">\n{{\'GENERAL.NEXT\' | translate }}</md-button><md-button class=\"nl-Btn nl-Btn-primary\" type=\"button\" \nng-if=\"msWizard.isLastStep()\" ng-click=\"saveStep(msWizard);\">{{\'GENERAL.SAVE\' | translate }}</md-button></div>\n</ms-form-wizard></div><div class=\"nl--Steps--contentNoTabs\" \nng-if=\"!subscribed && (!form.paginated || form.nbPages <= 1)\"><form name=\"inscriptionForm\" novalidate \nng-submit=\"setSubmittedWizardNestedForm() && inscriptionForm.$valid && save(inscriptionForm)\"><div layout=\"row\" \nclass=\"nl-Form-xs nl-Form-xs-registration\"><div flex=\"50\"><div \nng-repeat=\"field in form.fields | filter: {column: 1} track by field.id\" ng-form=\"fieldForm\" \nng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" class=\"nl--Steps--mainTitle\">\n{{field.header}}</h1><noo-input-event watch=\"checkConditionAfterUpdate(field)\" field=\"field\" ng-show=\"field._show\" \nng-if=\"field.typeField === \'FIELD\'\" ng-required=\"field.required && field._show\" sub-type=\"form.subtype.id\" \nform-name=\"fieldForm\" ng-model=\"field.genericField\" index=\"field.index\" content=\"{{field.genericField.typeChamps}}\" \nmodel-type=\"field.modelType\"></noo-input-event><div ng-if=\"field.typeField === \'EXPLANATION\' && field._show\" \nng-bind-html=\"field.text\"></div></div></div><div flex=\"45\" flex-offset=\"5\"><div \nng-repeat=\"field in form.fields | filter: {column: 2} track by field.id\" ng-form=\"fieldForm\" \nng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" class=\"nl--Steps--mainTitle\">\n{{field.header}}</h1><noo-input-event watch=\"checkConditionAfterUpdate(field)\" field=\"field\" ng-show=\"field._show\" \nng-if=\"field.typeField === \'FIELD\'\" ng-required=\"field.required && field._show\" sub-type=\"form.subtype.id\" \nform-name=\"fieldForm\" ng-model=\"field.genericField\" index=\"field.index\" content=\"{{field.genericField.typeChamps}}\" \nmodel-type=\"field.modelType\"></noo-input-event><div ng-if=\"field.typeField === \'EXPLANATION\' && field._show\" \nng-bind-html=\"field.text\"></div></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"nl-Btn nl-Btn-primary\" type=\"submit\" translate=\"GENERAL.SAVE\"></md-button></div></form></div><div \nclass=\"nl--Steps--contentNoTabs\" ng-if=\"subscribed\"><div layout=\"row\" layout-align=\"center center\"><div><h2 \nclass=\"nl--Steps--mainTitle\">You have been successfully subscribed, thank you !</h2></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/event/input.html","<div ng-form=\"formName\" ng-switch=\"content\"><md-input-container ng-switch-when=\"STRING\"><label \nfor=\"genericField_{{model.id+\'_\'+index}}\">{{field.name}}</label><input ng-disabled=\"disabled\" ng-model=\"model.value\" \nid=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" type=\"text\" class=\"\" ng-required=\"required\"><div \nng-if=\"formName.$submitted\" ng-messages=\"formName.genericField.$error\"><span ng-message=\"required\" \ntranslate=\"GENERAL.REQUIRED\"></span></div></md-input-container><md-input-container ng-switch-when=\"DATE\"><label \nclass=\"floating-label textarea-label\" for=\"genericField_{{model.id+ \'_\'+index}} \">{{field.name}}</label><md-datepicker \nng-disabled=\"disabled\" class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" \nng-model=\"model.dateTime\" id=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" ng-required=\"required\">\n</md-datepicker></md-input-container><md-input-container ng-switch-when=\"URL\" ng-class=\"\"><label \nfor=\"genericField_{{model.id+\'_\'+index}}\">{{field.name}}</label><input ng-disabled=\"disabled\" ng-required=\"required\" \nng-model=\"model.value\" id=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" type=\"text\" class=\"\"><div \nng-if=\"formName.$submitted\" ng-messages=\"formName.genericField.$error\"><span ng-message=\"required\" \ntranslate=\"GENERAL.REQUIRED\"></span> <span ng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div>\n</md-input-container><md-input-container ng-switch-when=\"EMAIL\" ng-class=\"\"><label \nfor=\"genericField_{{model.id+\'_\'+index}}\">{{field.name}}</label><input ng-disabled=\"disabled\" ng-required=\"required\" \nng-model=\"model.value\" id=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" type=\"text\" class=\"\"><div \nng-if=\"formName.$submitted\" ng-messages=\"formName.genericField.$error\"><span ng-message=\"required\" \ntranslate=\"GENERAL.REQUIRED\"></span> <span ng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div>\n</md-input-container><md-input-container ng-switch-when=\"INTEGER\"><label for=\"genericField_{{model.id+\'_\'+index}}\">\n{{field.name}}</label><input ng-disabled=\"disabled\" string-to-number ng-required=\"required\" ng-model=\"model.value\" \nid=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" type=\"number\" class=\"\" step=\"1\" ng-pattern=\"/^[0-9]\\d*$/\">\n<div ng-if=\"formName.$submitted\" ng-messages=\"formName.genericField.$error\"><span ng-message=\"required\" \ntranslate=\"GENERAL.REQUIRED\"></span> <span ng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div>\n</md-input-container><md-input-container ng-switch-when=\"NUMBER\"><label for=\"genericField_{{model.id+\'_\'+index}}\">\n{{field.name}}</label><input ng-disabled=\"disabled\" string-to-number ng-required=\"required\" ng-model=\"model.value\" \nid=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" type=\"number\" class=\"\" step=\"1\"><div \nng-if=\"formName.$submitted\" ng-messages=\"formName.genericField.$error\"><span ng-message=\"required\" \ntranslate=\"GENERAL.REQUIRED\"></span> <span ng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div>\n</md-input-container><md-input-container ng-switch-when=\"LONG_STRING\"><label for=\"genericField_{{model.id+\'_\'+index}}\" \nclass=\"floating-label textarea-label\">{{field.name}}</label><textarea ng-disabled=\"disabled\" md-detect-hidden \nng-required=\"required\" ng-model=\"model.value\" id=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" class=\"\" \nrows=\"3\"></textarea><div ng-if=\"formName.$submitted\" ng-messages=\"formName.genericField.$error\"><span \nng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span></div></md-input-container><div ng-switch-when=\"RICH_TEXT\" \nclass=\"nl_Trix\"><label for=\"genericField_{{model.id+\'_\'+index}}\" class=\"nl_Trix-label\">{{field.name}}</label>\n<ng-quill-editor ng-disabled=\"disabled\" ng-required=\"required\" ng-model=\"model.value\" name=\"genericField\">\n</ng-quill-editor></div><md-input-container ng-switch-when=\"BOOLEAN\"><md-switch ng-disabled=\"disabled\" \nid=\"genericField_{{model.id+ \'_\'+index}}\" ng-model=\"model.value\" aria-label=\"Switch 2\" class=\"md-primary\" \nname=\"genericField\">{{field.name}}</md-switch><div ng-if=\"formName.$submitted\" \nng-messages=\"formName.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span></div>\n</md-input-container><md-input-container ng-switch-when=\"LIST_SELECT\"><md-select ng-disabled=\"disabled\" md-on-open=\"\" \nmd-on-close=\"filterSelectText = \'\'\" id=\"genericField_{{model.id+ \'_\'+index}} \" name=\"genericField \" \nng-required=\"required\" ng-model=\"model.value\" ng-model-options=\"{\'trackBy\': \'$value.id\'}\" \nng-style=\"model.value.color != null ?{\'color\': model.value.color} : {}\"><md-select-header><section><input \nforce-select-focus type=\"text\" onkeydown=\"event.stopPropagation()\" ng-model=\"filterSelectText\"></section>\n</md-select-header><md-option \nng-repeat=\"option in model.listFieldsDTO | filterText: filterSelectText | orderBy : \'index\' track by option.id\" \nng-value=\"option\" ng-style=\"option.color != null ?{\'color\': option.color} : {}\">{{option.value}}</md-option>\n</md-select><label for=\"genericField_{{model.id+\'_\'+index}}\">{{field.name}}</label><div ng-if=\"formName.$submitted\" \nng-messages=\"formName.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span></div>\n</md-input-container><md-input-container ng-switch-when=\"MULTIPLE_SELECT\"><md-select ng-disabled=\"disabled\" \nmd-on-open=\"\" md-on-close=\"filterSelectText = \'\'\" id=\"genericField_{{model.id+ \'_\'+index}} \" name=\"genericField \" \nng-required=\"required\" ng-model=\"model.values \" ng-model-options=\"{\'trackBy\': \'$value.id\'}\" multiple=\"multiple\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"event.stopPropagation()\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"option in model.selectableObject | filterText: filterSelectText | orderBy: \'index\' track by option.id\" \nng-value=\"option\">{{option.libelle != null ? option.libelle : option.value}}</md-option></md-select><label \nfor=\"genericField_{{model.id+\'_\'+index}}\">{{field.name}}</label><div ng-if=\"formName.$submitted\" \nng-messages=\"formName.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span></div>\n</md-input-container><div class=\"nl-info-block-list-img animated fadeIn\" ng-switch-when=\"IMAGE\"><label \nfor=\"genericField_{{model.id+\'_\'+index}}\" style=\"color: rgba(0,0,0,0.38)\">{{field.name}} <span ng-if=\"required\" \nstyle=\"color:rgb(213,0,0)\">*</span></label><dropify-directive ng-disabled=\"disabled\" \nid=\"genericField_file_{{model.id+ \'_\'+model.index}}\" filesave=\"photo.uploadFile\" ng-model=\"model\"></div>\n<md-input-container ng-switch-when=\"FILE\"><label for=\"genericField_{{model.id+\'_\'+index}}\">{{field.name}}</label><input\n ng-disabled=\"disabled\" type=\"file\" class=\"nl_form--file\" ng-model=\"model.value\" \nid=\"genericField_file_{{model.id+ \'_\'+model.index}}\" name=\"genericField\"> <button type=\"button\" ng-click=\"download()\" \nclass=\"md-fab md-mini md-button\" ng-if=\"model.location != null\"><md-icon md-font-icon=\"icon-download\"></md-icon>\n</button></md-input-container><md-input-container ng-switch-default><label for=\"genericField_{{model.id+\'_\'+index}}\">\n{{field.name}}</label><input ng-disabled=\"disabled\" ng-model=\"model.value \" id=\"genericField_{{model.id+ \'_\'+index}} \" \nname=\"genericField \" type=\"text \" class=\"\"></md-input-container></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/event/page.html","");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);